var n3 = Object.defineProperty;
var i3 = (v, y, z) => y in v ? n3(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z;
var Rm = (v, y, z) => (i3(v, typeof y != "symbol" ? y + "" : y, z), z);
import * as a$z from "react";
import a__default, { forwardRef, Children, isValidElement, createElement, cloneElement, Fragment, createContext, useContext, useEffect, useState, useRef, useCallback, useMemo, useLayoutEffect, useReducer, useInsertionEffect, useId, useSyncExternalStore, memo as memo$1 } from "react";
import * as Nu from "react-dom";
import Nu__default, { flushSync, createPortal } from "react-dom";
import useSWR, { unstable_serialize, useSWRConfig } from "swr";
import BigNumber, { BigNumber as BigNumber$1 } from "bignumber.js";
import require$$0$4, { bech32 as bech32$6 } from "bech32";
import Long from "long";
import { CosmWasmClient, createWasmAminoConverters } from "@cosmjs/cosmwasm-stargate";
import require$$1$2 from "libsodium-wrappers-sumo";
import { defaultRegistryTypes, AminoTypes, createDefaultAminoConverters } from "@cosmjs/stargate";
import { useAccount, usePublicClient, erc20ABI as erc20ABI$1, useNetwork, useSwitchNetwork, useWalletClient, configureChains, createConfig, WagmiConfig } from "wagmi";
import { useWallet, ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import * as token$1 from "@solana/spl-token";
import { Connection, PublicKey, Transaction, clusterApiUrl } from "@solana/web3.js";
import { ConnectButton, connectorsForWallets, RainbowKitProvider, darkTheme } from "@rainbow-me/rainbowkit";
import { v4 } from "uuid";
import { txStatusResponseFromJSON } from "@skip-router/core";
import Fuse from "fuse.js";
import { publicActions, maxUint256, getAddress, UserRejectedRequestError, ResourceUnavailableRpcError, createWalletClient, custom, numberToHex as numberToHex$1, SwitchChainError } from "viem";
import ReactCountryFlag from "react-country-flag";
import * as idb from "idb-keyval";
var Tabs = /* @__PURE__ */ ((v) => (v.SWAP = "swap", v.TRANSFER = "transfer", v.FIAT_ON_RAMP = "fiat-on-ramp", v.AGGREGATED = "aggregated", v))(Tabs || {}), Network = /* @__PURE__ */ ((v) => (v.MAINNET = "mainnet", v.TESTNET = "testnet", v))(Network || {}), SessionStorageKeys = /* @__PURE__ */ ((v) => (v.IS_COSMOS_WALLET_CONNECTED = "@leapwallet/elements:is-cosmos-wallet-connected", v.IS_EVM_WALLET_CONNECTED = "@leapwallet/elements:is-evm-wallet-connected", v.LEAP_MODALS_OPEN = "@leapwallet/elements:leap-modals-open", v))(SessionStorageKeys || {}), SWAP_PROVIDER = /* @__PURE__ */ ((v) => (v.SKIP = "skip", v.SQUID = "squid", v))(SWAP_PROVIDER || {});
function getDefaultExportFromCjs$1(v) {
  return v && v.__esModule && Object.prototype.hasOwnProperty.call(v, "default") ? v.default : v;
}
var browser$d = { exports: {} }, process = browser$d.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(v) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(v, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(v, 0);
  try {
    return cachedSetTimeout(v, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, v, 0);
    } catch {
      return cachedSetTimeout.call(this, v, 0);
    }
  }
}
function runClearTimeout(v) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(v);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(v);
  try {
    return cachedClearTimeout(v);
  } catch {
    try {
      return cachedClearTimeout.call(null, v);
    } catch {
      return cachedClearTimeout.call(this, v);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var v = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var y = queue.length; y; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < y; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, y = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(v);
  }
}
process.nextTick = function(v) {
  var y = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var z = 1; z < arguments.length; z++)
      y[z - 1] = arguments[z];
  queue.push(new Item(v, y)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(v, y) {
  this.fun = v, this.array = y;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$3() {
}
process.on = noop$3;
process.addListener = noop$3;
process.once = noop$3;
process.off = noop$3;
process.removeListener = noop$3;
process.removeAllListeners = noop$3;
process.emit = noop$3;
process.prependListener = noop$3;
process.prependOnceListener = noop$3;
process.listeners = function(v) {
  return [];
};
process.binding = function(v) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(v) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$d.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(browserExports);
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(v) {
  return v && v.__esModule && Object.prototype.hasOwnProperty.call(v, "default") ? v.default : v;
}
function getAugmentedNamespace(v) {
  if (v.__esModule)
    return v;
  var y = v.default;
  if (typeof y == "function") {
    var z = function ne() {
      return this instanceof ne ? Reflect.construct(y, arguments, this.constructor) : y.apply(this, arguments);
    };
    z.prototype = y.prototype;
  } else
    z = {};
  return Object.defineProperty(z, "__esModule", { value: !0 }), Object.keys(v).forEach(function(ne) {
    var ue = Object.getOwnPropertyDescriptor(v, ne);
    Object.defineProperty(z, ne, ue.get ? ue : {
      enumerable: !0,
      get: function() {
        return v[ne];
      }
    });
  }), z;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var v = a__default, y = Symbol.for("react.element"), z = Symbol.for("react.fragment"), ne = Object.prototype.hasOwnProperty, ue = v.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, le = { key: !0, ref: !0, __self: !0, __source: !0 };
  function he(ge, we, Ee) {
    var xe, $e = {}, Ne = null, st = null;
    Ee !== void 0 && (Ne = "" + Ee), we.key !== void 0 && (Ne = "" + we.key), we.ref !== void 0 && (st = we.ref);
    for (xe in we)
      ne.call(we, xe) && !le.hasOwnProperty(xe) && ($e[xe] = we[xe]);
    if (ge && ge.defaultProps)
      for (xe in we = ge.defaultProps, we)
        $e[xe] === void 0 && ($e[xe] = we[xe]);
    return { $$typeof: y, type: ge, key: Ne, ref: st, props: $e, _owner: ue.current };
  }
  return reactJsxRuntime_production_min.Fragment = z, reactJsxRuntime_production_min.jsx = he, reactJsxRuntime_production_min.jsxs = he, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process$1.env.NODE_ENV !== "production" && function() {
    var v = a__default, y = Symbol.for("react.element"), z = Symbol.for("react.portal"), ne = Symbol.for("react.fragment"), ue = Symbol.for("react.strict_mode"), le = Symbol.for("react.profiler"), he = Symbol.for("react.provider"), ge = Symbol.for("react.context"), we = Symbol.for("react.forward_ref"), Ee = Symbol.for("react.suspense"), xe = Symbol.for("react.suspense_list"), $e = Symbol.for("react.memo"), Ne = Symbol.for("react.lazy"), st = Symbol.for("react.offscreen"), Nr = Symbol.iterator, br = "@@iterator";
    function $n(Mu) {
      if (Mu === null || typeof Mu != "object")
        return null;
      var Du = Nr && Mu[Nr] || Mu[br];
      return typeof Du == "function" ? Du : null;
    }
    var En = v.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Rn(Mu) {
      {
        for (var Du = arguments.length, eh = new Array(Du > 1 ? Du - 1 : 0), Nc = 1; Nc < Du; Nc++)
          eh[Nc - 1] = arguments[Nc];
        wa("error", Mu, eh);
      }
    }
    function wa(Mu, Du, eh) {
      {
        var Nc = En.ReactDebugCurrentFrame, z1 = Nc.getStackAddendum();
        z1 !== "" && (Du += "%s", eh = eh.concat([z1]));
        var A2 = eh.map(function(b2) {
          return String(b2);
        });
        A2.unshift("Warning: " + Du), Function.prototype.apply.call(console[Mu], console, A2);
      }
    }
    var Aa = !1, _a = !1, Ta = !1, Zn = !1, Ra = !1, Yn;
    Yn = Symbol.for("react.module.reference");
    function $o(Mu) {
      return !!(typeof Mu == "string" || typeof Mu == "function" || Mu === ne || Mu === le || Ra || Mu === ue || Mu === Ee || Mu === xe || Zn || Mu === st || Aa || _a || Ta || typeof Mu == "object" && Mu !== null && (Mu.$$typeof === Ne || Mu.$$typeof === $e || Mu.$$typeof === he || Mu.$$typeof === ge || Mu.$$typeof === we || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Mu.$$typeof === Yn || Mu.getModuleId !== void 0));
    }
    function ct(Mu, Du, eh) {
      var Nc = Mu.displayName;
      if (Nc)
        return Nc;
      var z1 = Du.displayName || Du.name || "";
      return z1 !== "" ? eh + "(" + z1 + ")" : eh;
    }
    function fe(Mu) {
      return Mu.displayName || "Context";
    }
    function be(Mu) {
      if (Mu == null)
        return null;
      if (typeof Mu.tag == "number" && Rn("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Mu == "function")
        return Mu.displayName || Mu.name || null;
      if (typeof Mu == "string")
        return Mu;
      switch (Mu) {
        case ne:
          return "Fragment";
        case z:
          return "Portal";
        case le:
          return "Profiler";
        case ue:
          return "StrictMode";
        case Ee:
          return "Suspense";
        case xe:
          return "SuspenseList";
      }
      if (typeof Mu == "object")
        switch (Mu.$$typeof) {
          case ge:
            var Du = Mu;
            return fe(Du) + ".Consumer";
          case he:
            var eh = Mu;
            return fe(eh._context) + ".Provider";
          case we:
            return ct(Mu, Mu.render, "ForwardRef");
          case $e:
            var Nc = Mu.displayName || null;
            return Nc !== null ? Nc : be(Mu.type) || "Memo";
          case Ne: {
            var z1 = Mu, A2 = z1._payload, b2 = z1._init;
            try {
              return be(b2(A2));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ye = Object.assign, Se = 0, Oe, Fr, zn, Fe, pe, it, xa;
    function wo() {
    }
    wo.__reactDisabledLog = !0;
    function _u() {
      {
        if (Se === 0) {
          Oe = console.log, Fr = console.info, zn = console.warn, Fe = console.error, pe = console.group, it = console.groupCollapsed, xa = console.groupEnd;
          var Mu = {
            configurable: !0,
            enumerable: !0,
            value: wo,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Mu,
            log: Mu,
            warn: Mu,
            error: Mu,
            group: Mu,
            groupCollapsed: Mu,
            groupEnd: Mu
          });
        }
        Se++;
      }
    }
    function Oa() {
      {
        if (Se--, Se === 0) {
          var Mu = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ye({}, Mu, {
              value: Oe
            }),
            info: ye({}, Mu, {
              value: Fr
            }),
            warn: ye({}, Mu, {
              value: zn
            }),
            error: ye({}, Mu, {
              value: Fe
            }),
            group: ye({}, Mu, {
              value: pe
            }),
            groupCollapsed: ye({}, Mu, {
              value: it
            }),
            groupEnd: ye({}, Mu, {
              value: xa
            })
          });
        }
        Se < 0 && Rn("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Os = En.ReactCurrentDispatcher, Pa;
    function Ml(Mu, Du, eh) {
      {
        if (Pa === void 0)
          try {
            throw Error();
          } catch (z1) {
            var Nc = z1.stack.trim().match(/\n( *(at )?)/);
            Pa = Nc && Nc[1] || "";
          }
        return `
` + Pa + Mu;
      }
    }
    var Su = !1, Tu;
    {
      var Au = typeof WeakMap == "function" ? WeakMap : Map;
      Tu = new Au();
    }
    function Zl(Mu, Du) {
      if (!Mu || Su)
        return "";
      {
        var eh = Tu.get(Mu);
        if (eh !== void 0)
          return eh;
      }
      var Nc;
      Su = !0;
      var z1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A2;
      A2 = Os.current, Os.current = null, _u();
      try {
        if (Du) {
          var b2 = function() {
            throw Error();
          };
          if (Object.defineProperty(b2.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b2, []);
            } catch (V2) {
              Nc = V2;
            }
            Reflect.construct(Mu, [], b2);
          } else {
            try {
              b2.call();
            } catch (V2) {
              Nc = V2;
            }
            Mu.call(b2.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (V2) {
            Nc = V2;
          }
          Mu();
        }
      } catch (V2) {
        if (V2 && Nc && typeof V2.stack == "string") {
          for (var R2 = V2.stack.split(`
`), D2 = Nc.stack.split(`
`), I2 = R2.length - 1, N2 = D2.length - 1; I2 >= 1 && N2 >= 0 && R2[I2] !== D2[N2]; )
            N2--;
          for (; I2 >= 1 && N2 >= 0; I2--, N2--)
            if (R2[I2] !== D2[N2]) {
              if (I2 !== 1 || N2 !== 1)
                do
                  if (I2--, N2--, N2 < 0 || R2[I2] !== D2[N2]) {
                    var B2 = `
` + R2[I2].replace(" at new ", " at ");
                    return Mu.displayName && B2.includes("<anonymous>") && (B2 = B2.replace("<anonymous>", Mu.displayName)), typeof Mu == "function" && Tu.set(Mu, B2), B2;
                  }
                while (I2 >= 1 && N2 >= 0);
              break;
            }
        }
      } finally {
        Su = !1, Os.current = A2, Oa(), Error.prepareStackTrace = z1;
      }
      var z2 = Mu ? Mu.displayName || Mu.name : "", W2 = z2 ? Ml(z2) : "";
      return typeof Mu == "function" && Tu.set(Mu, W2), W2;
    }
    function Iu(Mu, Du, eh) {
      return Zl(Mu, !1);
    }
    function Uc(Mu) {
      var Du = Mu.prototype;
      return !!(Du && Du.isReactComponent);
    }
    function Pu(Mu, Du, eh) {
      if (Mu == null)
        return "";
      if (typeof Mu == "function")
        return Zl(Mu, Uc(Mu));
      if (typeof Mu == "string")
        return Ml(Mu);
      switch (Mu) {
        case Ee:
          return Ml("Suspense");
        case xe:
          return Ml("SuspenseList");
      }
      if (typeof Mu == "object")
        switch (Mu.$$typeof) {
          case we:
            return Iu(Mu.render);
          case $e:
            return Pu(Mu.type, Du, eh);
          case Ne: {
            var Nc = Mu, z1 = Nc._payload, A2 = Nc._init;
            try {
              return Pu(A2(z1), Du, eh);
            } catch {
            }
          }
        }
      return "";
    }
    var Lu = Object.prototype.hasOwnProperty, th = {}, Zc = En.ReactDebugCurrentFrame;
    function N1(Mu) {
      if (Mu) {
        var Du = Mu._owner, eh = Pu(Mu.type, Mu._source, Du ? Du.type : null);
        Zc.setExtraStackFrame(eh);
      } else
        Zc.setExtraStackFrame(null);
    }
    function Gh(Mu, Du, eh, Nc, z1) {
      {
        var A2 = Function.call.bind(Lu);
        for (var b2 in Mu)
          if (A2(Mu, b2)) {
            var R2 = void 0;
            try {
              if (typeof Mu[b2] != "function") {
                var D2 = Error((Nc || "React class") + ": " + eh + " type `" + b2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Mu[b2] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D2.name = "Invariant Violation", D2;
              }
              R2 = Mu[b2](Du, b2, Nc, eh, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I2) {
              R2 = I2;
            }
            R2 && !(R2 instanceof Error) && (N1(z1), Rn("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Nc || "React class", eh, b2, typeof R2), N1(null)), R2 instanceof Error && !(R2.message in th) && (th[R2.message] = !0, N1(z1), Rn("Failed %s type: %s", eh, R2.message), N1(null));
          }
      }
    }
    var Mc = Array.isArray;
    function h1(Mu) {
      return Mc(Mu);
    }
    function l2(Mu) {
      {
        var Du = typeof Symbol == "function" && Symbol.toStringTag, eh = Du && Mu[Symbol.toStringTag] || Mu.constructor.name || "Object";
        return eh;
      }
    }
    function Gc(Mu) {
      try {
        return Kc(Mu), !1;
      } catch {
        return !0;
      }
    }
    function Kc(Mu) {
      return "" + Mu;
    }
    function M2(Mu) {
      if (Gc(Mu))
        return Rn("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", l2(Mu)), Kc(Mu);
    }
    var d1 = En.ReactCurrentOwner, K1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, k2, Eu, Zo;
    Zo = {};
    function Fl(Mu) {
      if (Lu.call(Mu, "ref")) {
        var Du = Object.getOwnPropertyDescriptor(Mu, "ref").get;
        if (Du && Du.isReactWarning)
          return !1;
      }
      return Mu.ref !== void 0;
    }
    function Ru(Mu) {
      if (Lu.call(Mu, "key")) {
        var Du = Object.getOwnPropertyDescriptor(Mu, "key").get;
        if (Du && Du.isReactWarning)
          return !1;
      }
      return Mu.key !== void 0;
    }
    function ku(Mu, Du) {
      if (typeof Mu.ref == "string" && d1.current && Du && d1.current.stateNode !== Du) {
        var eh = be(d1.current.type);
        Zo[eh] || (Rn('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', be(d1.current.type), Mu.ref), Zo[eh] = !0);
      }
    }
    function kc(Mu, Du) {
      {
        var eh = function() {
          k2 || (k2 = !0, Rn("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Du));
        };
        eh.isReactWarning = !0, Object.defineProperty(Mu, "key", {
          get: eh,
          configurable: !0
        });
      }
    }
    function Ou(Mu, Du) {
      {
        var eh = function() {
          Eu || (Eu = !0, Rn("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Du));
        };
        eh.isReactWarning = !0, Object.defineProperty(Mu, "ref", {
          get: eh,
          configurable: !0
        });
      }
    }
    var U1 = function(Mu, Du, eh, Nc, z1, A2, b2) {
      var R2 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: y,
        // Built-in properties that belong on the element
        type: Mu,
        key: Du,
        ref: eh,
        props: b2,
        // Record the component responsible for creating this element.
        _owner: A2
      };
      return R2._store = {}, Object.defineProperty(R2._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R2, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Nc
      }), Object.defineProperty(R2, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z1
      }), Object.freeze && (Object.freeze(R2.props), Object.freeze(R2)), R2;
    };
    function g2(Mu, Du, eh, Nc, z1) {
      {
        var A2, b2 = {}, R2 = null, D2 = null;
        eh !== void 0 && (M2(eh), R2 = "" + eh), Ru(Du) && (M2(Du.key), R2 = "" + Du.key), Fl(Du) && (D2 = Du.ref, ku(Du, z1));
        for (A2 in Du)
          Lu.call(Du, A2) && !K1.hasOwnProperty(A2) && (b2[A2] = Du[A2]);
        if (Mu && Mu.defaultProps) {
          var I2 = Mu.defaultProps;
          for (A2 in I2)
            b2[A2] === void 0 && (b2[A2] = I2[A2]);
        }
        if (R2 || D2) {
          var N2 = typeof Mu == "function" ? Mu.displayName || Mu.name || "Unknown" : Mu;
          R2 && kc(b2, N2), D2 && Ou(b2, N2);
        }
        return U1(Mu, R2, D2, z1, Nc, d1.current, b2);
      }
    }
    var Ic = En.ReactCurrentOwner, X1 = En.ReactDebugCurrentFrame;
    function $2(Mu) {
      if (Mu) {
        var Du = Mu._owner, eh = Pu(Mu.type, Mu._source, Du ? Du.type : null);
        X1.setExtraStackFrame(eh);
      } else
        X1.setExtraStackFrame(null);
    }
    var ah;
    ah = !1;
    function O1(Mu) {
      return typeof Mu == "object" && Mu !== null && Mu.$$typeof === y;
    }
    function T2() {
      {
        if (Ic.current) {
          var Mu = be(Ic.current.type);
          if (Mu)
            return `

Check the render method of \`` + Mu + "`.";
        }
        return "";
      }
    }
    function ih(Mu) {
      {
        if (Mu !== void 0) {
          var Du = Mu.fileName.replace(/^.*[\\\/]/, ""), eh = Mu.lineNumber;
          return `

Check your code at ` + Du + ":" + eh + ".";
        }
        return "";
      }
    }
    var oh = {};
    function j2(Mu) {
      {
        var Du = T2();
        if (!Du) {
          var eh = typeof Mu == "string" ? Mu : Mu.displayName || Mu.name;
          eh && (Du = `

Check the top-level render call using <` + eh + ">.");
        }
        return Du;
      }
    }
    function lh(Mu, Du) {
      {
        if (!Mu._store || Mu._store.validated || Mu.key != null)
          return;
        Mu._store.validated = !0;
        var eh = j2(Du);
        if (oh[eh])
          return;
        oh[eh] = !0;
        var Nc = "";
        Mu && Mu._owner && Mu._owner !== Ic.current && (Nc = " It was passed a child from " + be(Mu._owner.type) + "."), $2(Mu), Rn('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', eh, Nc), $2(null);
      }
    }
    function kh(Mu, Du) {
      {
        if (typeof Mu != "object")
          return;
        if (h1(Mu))
          for (var eh = 0; eh < Mu.length; eh++) {
            var Nc = Mu[eh];
            O1(Nc) && lh(Nc, Du);
          }
        else if (O1(Mu))
          Mu._store && (Mu._store.validated = !0);
        else if (Mu) {
          var z1 = $n(Mu);
          if (typeof z1 == "function" && z1 !== Mu.entries)
            for (var A2 = z1.call(Mu), b2; !(b2 = A2.next()).done; )
              O1(b2.value) && lh(b2.value, Du);
        }
      }
    }
    function P2(Mu) {
      {
        var Du = Mu.type;
        if (Du == null || typeof Du == "string")
          return;
        var eh;
        if (typeof Du == "function")
          eh = Du.propTypes;
        else if (typeof Du == "object" && (Du.$$typeof === we || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Du.$$typeof === $e))
          eh = Du.propTypes;
        else
          return;
        if (eh) {
          var Nc = be(Du);
          Gh(eh, Mu.props, "prop", Nc, Mu);
        } else if (Du.PropTypes !== void 0 && !ah) {
          ah = !0;
          var z1 = be(Du);
          Rn("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z1 || "Unknown");
        }
        typeof Du.getDefaultProps == "function" && !Du.getDefaultProps.isReactClassApproved && Rn("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ch(Mu) {
      {
        for (var Du = Object.keys(Mu.props), eh = 0; eh < Du.length; eh++) {
          var Nc = Du[eh];
          if (Nc !== "children" && Nc !== "key") {
            $2(Mu), Rn("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Nc), $2(null);
            break;
          }
        }
        Mu.ref !== null && ($2(Mu), Rn("Invalid attribute `ref` supplied to `React.Fragment`."), $2(null));
      }
    }
    function Nh(Mu, Du, eh, Nc, z1, A2) {
      {
        var b2 = $o(Mu);
        if (!b2) {
          var R2 = "";
          (Mu === void 0 || typeof Mu == "object" && Mu !== null && Object.keys(Mu).length === 0) && (R2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var D2 = ih(z1);
          D2 ? R2 += D2 : R2 += T2();
          var I2;
          Mu === null ? I2 = "null" : h1(Mu) ? I2 = "array" : Mu !== void 0 && Mu.$$typeof === y ? (I2 = "<" + (be(Mu.type) || "Unknown") + " />", R2 = " Did you accidentally export a JSX literal instead of a component?") : I2 = typeof Mu, Rn("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I2, R2);
        }
        var N2 = g2(Mu, Du, eh, z1, A2);
        if (N2 == null)
          return N2;
        if (b2) {
          var B2 = Du.children;
          if (B2 !== void 0)
            if (Nc)
              if (h1(B2)) {
                for (var z2 = 0; z2 < B2.length; z2++)
                  kh(B2[z2], Mu);
                Object.freeze && Object.freeze(B2);
              } else
                Rn("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kh(B2, Mu);
        }
        return Mu === ne ? ch(N2) : P2(N2), N2;
      }
    }
    function L2(Mu, Du, eh) {
      return Nh(Mu, Du, eh, !0);
    }
    function yh(Mu, Du, eh) {
      return Nh(Mu, Du, eh, !1);
    }
    var Dh = yh, F2 = L2;
    reactJsxRuntime_development.Fragment = ne, reactJsxRuntime_development.jsx = Dh, reactJsxRuntime_development.jsxs = F2;
  }()), reactJsxRuntime_development;
}
process$1.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(v) {
    for (var y = 1; y < arguments.length; y++) {
      var z = arguments[y];
      for (var ne in z)
        Object.prototype.hasOwnProperty.call(z, ne) && (v[ne] = z[ne]);
    }
    return v;
  }, _extends.apply(this, arguments);
}
function $6ed0406888f73fc4$var$setRef(v, y) {
  typeof v == "function" ? v(y) : v != null && (v.current = y);
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...v) {
  return (y) => v.forEach(
    (z) => $6ed0406888f73fc4$var$setRef(z, y)
  );
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ forwardRef((v, y) => {
  const { children: z, ...ne } = v, ue = Children.toArray(z), le = ue.find($5e63c961fc1ce211$var$isSlottable);
  if (le) {
    const he = le.props.children, ge = ue.map((we) => we === le ? Children.count(he) > 1 ? Children.only(null) : /* @__PURE__ */ isValidElement(he) ? he.props.children : null : we);
    return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, ne, {
      ref: y
    }), /* @__PURE__ */ isValidElement(he) ? /* @__PURE__ */ cloneElement(he, void 0, ge) : null);
  }
  return /* @__PURE__ */ createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, ne, {
    ref: y
  }), z);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ forwardRef((v, y) => {
  const { children: z, ...ne } = v;
  return /* @__PURE__ */ isValidElement(z) ? /* @__PURE__ */ cloneElement(z, {
    ...$5e63c961fc1ce211$var$mergeProps(ne, z.props),
    ref: y ? $6ed0406888f73fc4$export$43e446d32b3d21af(y, z.ref) : z.ref
  }) : Children.count(z) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: v }) => /* @__PURE__ */ createElement(Fragment, null, v);
function $5e63c961fc1ce211$var$isSlottable(v) {
  return /* @__PURE__ */ isValidElement(v) && v.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(v, y) {
  const z = {
    ...y
  };
  for (const ne in y) {
    const ue = v[ne], le = y[ne];
    /^on[A-Z]/.test(ne) ? ue && le ? z[ne] = (...ge) => {
      le(...ge), ue(...ge);
    } : ue && (z[ne] = ue) : ne === "style" ? z[ne] = {
      ...ue,
      ...le
    } : ne === "className" && (z[ne] = [
      ue,
      le
    ].filter(Boolean).join(" "));
  }
  return {
    ...v,
    ...z
  };
}
function r$a(v) {
  var y, z, ne = "";
  if (typeof v == "string" || typeof v == "number")
    ne += v;
  else if (typeof v == "object")
    if (Array.isArray(v)) {
      var ue = v.length;
      for (y = 0; y < ue; y++)
        v[y] && (z = r$a(v[y])) && (ne && (ne += " "), ne += z);
    } else
      for (z in v)
        v[z] && (ne && (ne += " "), ne += z);
  return ne;
}
function clsx$1() {
  for (var v, y, z = 0, ne = "", ue = arguments.length; z < ue; z++)
    (v = arguments[z]) && (y = r$a(v)) && (ne && (ne += " "), ne += y);
  return ne;
}
const CLASS_PART_SEPARATOR = "-";
function createClassUtils(v) {
  const y = createClassMap(v), {
    conflictingClassGroups: z,
    conflictingClassGroupModifiers: ne
  } = v;
  function ue(he) {
    const ge = he.split(CLASS_PART_SEPARATOR);
    return ge[0] === "" && ge.length !== 1 && ge.shift(), getGroupRecursive(ge, y) || getGroupIdForArbitraryProperty(he);
  }
  function le(he, ge) {
    const we = z[he] || [];
    return ge && ne[he] ? [...we, ...ne[he]] : we;
  }
  return {
    getClassGroupId: ue,
    getConflictingClassGroupIds: le
  };
}
function getGroupRecursive(v, y) {
  var he;
  if (v.length === 0)
    return y.classGroupId;
  const z = v[0], ne = y.nextPart.get(z), ue = ne ? getGroupRecursive(v.slice(1), ne) : void 0;
  if (ue)
    return ue;
  if (y.validators.length === 0)
    return;
  const le = v.join(CLASS_PART_SEPARATOR);
  return (he = y.validators.find(({
    validator: ge
  }) => ge(le))) == null ? void 0 : he.classGroupId;
}
const arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(v) {
  if (arbitraryPropertyRegex.test(v)) {
    const y = arbitraryPropertyRegex.exec(v)[1], z = y == null ? void 0 : y.substring(0, y.indexOf(":"));
    if (z)
      return "arbitrary.." + z;
  }
}
function createClassMap(v) {
  const {
    theme: y,
    prefix: z
  } = v, ne = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return getPrefixedClassGroupEntries(Object.entries(v.classGroups), z).forEach(([le, he]) => {
    processClassesRecursively(he, ne, le, y);
  }), ne;
}
function processClassesRecursively(v, y, z, ne) {
  v.forEach((ue) => {
    if (typeof ue == "string") {
      const le = ue === "" ? y : getPart(y, ue);
      le.classGroupId = z;
      return;
    }
    if (typeof ue == "function") {
      if (isThemeGetter(ue)) {
        processClassesRecursively(ue(ne), y, z, ne);
        return;
      }
      y.validators.push({
        validator: ue,
        classGroupId: z
      });
      return;
    }
    Object.entries(ue).forEach(([le, he]) => {
      processClassesRecursively(he, getPart(y, le), z, ne);
    });
  });
}
function getPart(v, y) {
  let z = v;
  return y.split(CLASS_PART_SEPARATOR).forEach((ne) => {
    z.nextPart.has(ne) || z.nextPart.set(ne, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), z = z.nextPart.get(ne);
  }), z;
}
function isThemeGetter(v) {
  return v.isThemeGetter;
}
function getPrefixedClassGroupEntries(v, y) {
  return y ? v.map(([z, ne]) => {
    const ue = ne.map((le) => typeof le == "string" ? y + le : typeof le == "object" ? Object.fromEntries(Object.entries(le).map(([he, ge]) => [y + he, ge])) : le);
    return [z, ue];
  }) : v;
}
function createLruCache(v) {
  if (v < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let y = 0, z = /* @__PURE__ */ new Map(), ne = /* @__PURE__ */ new Map();
  function ue(le, he) {
    z.set(le, he), y++, y > v && (y = 0, ne = z, z = /* @__PURE__ */ new Map());
  }
  return {
    get(le) {
      let he = z.get(le);
      if (he !== void 0)
        return he;
      if ((he = ne.get(le)) !== void 0)
        return ue(le, he), he;
    },
    set(le, he) {
      z.has(le) ? z.set(le, he) : ue(le, he);
    }
  };
}
const IMPORTANT_MODIFIER = "!";
function createSplitModifiers(v) {
  const y = v.separator, z = y.length === 1, ne = y[0], ue = y.length;
  return function(he) {
    const ge = [];
    let we = 0, Ee = 0, xe;
    for (let br = 0; br < he.length; br++) {
      let $n = he[br];
      if (we === 0) {
        if ($n === ne && (z || he.slice(br, br + ue) === y)) {
          ge.push(he.slice(Ee, br)), Ee = br + ue;
          continue;
        }
        if ($n === "/") {
          xe = br;
          continue;
        }
      }
      $n === "[" ? we++ : $n === "]" && we--;
    }
    const $e = ge.length === 0 ? he : he.substring(Ee), Ne = $e.startsWith(IMPORTANT_MODIFIER), st = Ne ? $e.substring(1) : $e, Nr = xe && xe > Ee ? xe - Ee : void 0;
    return {
      modifiers: ge,
      hasImportantModifier: Ne,
      baseClassName: st,
      maybePostfixModifierPosition: Nr
    };
  };
}
function sortModifiers(v) {
  if (v.length <= 1)
    return v;
  const y = [];
  let z = [];
  return v.forEach((ne) => {
    ne[0] === "[" ? (y.push(...z.sort(), ne), z = []) : z.push(ne);
  }), y.push(...z.sort()), y;
}
function createConfigUtils(v) {
  return {
    cache: createLruCache(v.cacheSize),
    splitModifiers: createSplitModifiers(v),
    ...createClassUtils(v)
  };
}
const SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(v, y) {
  const {
    splitModifiers: z,
    getClassGroupId: ne,
    getConflictingClassGroupIds: ue
  } = y, le = /* @__PURE__ */ new Set();
  return v.trim().split(SPLIT_CLASSES_REGEX).map((he) => {
    const {
      modifiers: ge,
      hasImportantModifier: we,
      baseClassName: Ee,
      maybePostfixModifierPosition: xe
    } = z(he);
    let $e = ne(xe ? Ee.substring(0, xe) : Ee), Ne = !!xe;
    if (!$e) {
      if (!xe)
        return {
          isTailwindClass: !1,
          originalClassName: he
        };
      if ($e = ne(Ee), !$e)
        return {
          isTailwindClass: !1,
          originalClassName: he
        };
      Ne = !1;
    }
    const st = sortModifiers(ge).join(":");
    return {
      isTailwindClass: !0,
      modifierId: we ? st + IMPORTANT_MODIFIER : st,
      classGroupId: $e,
      originalClassName: he,
      hasPostfixModifier: Ne
    };
  }).reverse().filter((he) => {
    if (!he.isTailwindClass)
      return !0;
    const {
      modifierId: ge,
      classGroupId: we,
      hasPostfixModifier: Ee
    } = he, xe = ge + we;
    return le.has(xe) ? !1 : (le.add(xe), ue(we, Ee).forEach(($e) => le.add(ge + $e)), !0);
  }).reverse().map((he) => he.originalClassName).join(" ");
}
function twJoin() {
  let v = 0, y, z, ne = "";
  for (; v < arguments.length; )
    (y = arguments[v++]) && (z = toValue(y)) && (ne && (ne += " "), ne += z);
  return ne;
}
function toValue(v) {
  if (typeof v == "string")
    return v;
  let y, z = "";
  for (let ne = 0; ne < v.length; ne++)
    v[ne] && (y = toValue(v[ne])) && (z && (z += " "), z += y);
  return z;
}
function createTailwindMerge(v, ...y) {
  let z, ne, ue, le = he;
  function he(we) {
    const Ee = y.reduce((xe, $e) => $e(xe), v());
    return z = createConfigUtils(Ee), ne = z.cache.get, ue = z.cache.set, le = ge, ge(we);
  }
  function ge(we) {
    const Ee = ne(we);
    if (Ee)
      return Ee;
    const xe = mergeClassList(we, z);
    return ue(we, xe), xe;
  }
  return function() {
    return le(twJoin.apply(null, arguments));
  };
}
function fromTheme(v) {
  const y = (z) => z[v] || [];
  return y.isThemeGetter = !0, y;
}
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function isLength(v) {
  return isNumber(v) || stringLengths.has(v) || fractionRegex.test(v);
}
function isArbitraryLength(v) {
  return getIsArbitraryValue(v, "length", isLengthOnly);
}
function isNumber(v) {
  return !!v && !Number.isNaN(Number(v));
}
function isArbitraryNumber(v) {
  return getIsArbitraryValue(v, "number", isNumber);
}
function isInteger(v) {
  return !!v && Number.isInteger(Number(v));
}
function isPercent(v) {
  return v.endsWith("%") && isNumber(v.slice(0, -1));
}
function isArbitraryValue(v) {
  return arbitraryValueRegex.test(v);
}
function isTshirtSize(v) {
  return tshirtUnitRegex.test(v);
}
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function isArbitrarySize(v) {
  return getIsArbitraryValue(v, sizeLabels, isNever);
}
function isArbitraryPosition(v) {
  return getIsArbitraryValue(v, "position", isNever);
}
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
function isArbitraryImage(v) {
  return getIsArbitraryValue(v, imageLabels, isImage);
}
function isArbitraryShadow(v) {
  return getIsArbitraryValue(v, "", isShadow);
}
function isAny() {
  return !0;
}
function getIsArbitraryValue(v, y, z) {
  const ne = arbitraryValueRegex.exec(v);
  return ne ? ne[1] ? typeof y == "string" ? ne[1] === y : y.has(ne[1]) : z(ne[2]) : !1;
}
function isLengthOnly(v) {
  return lengthUnitRegex.test(v) && !colorFunctionRegex.test(v);
}
function isNever() {
  return !1;
}
function isShadow(v) {
  return shadowRegex.test(v);
}
function isImage(v) {
  return imageRegex.test(v);
}
function getDefaultConfig() {
  const v = fromTheme("colors"), y = fromTheme("spacing"), z = fromTheme("blur"), ne = fromTheme("brightness"), ue = fromTheme("borderColor"), le = fromTheme("borderRadius"), he = fromTheme("borderSpacing"), ge = fromTheme("borderWidth"), we = fromTheme("contrast"), Ee = fromTheme("grayscale"), xe = fromTheme("hueRotate"), $e = fromTheme("invert"), Ne = fromTheme("gap"), st = fromTheme("gradientColorStops"), Nr = fromTheme("gradientColorStopPositions"), br = fromTheme("inset"), $n = fromTheme("margin"), En = fromTheme("opacity"), Rn = fromTheme("padding"), wa = fromTheme("saturate"), Aa = fromTheme("scale"), _a = fromTheme("sepia"), Ta = fromTheme("skew"), Zn = fromTheme("space"), Ra = fromTheme("translate"), Yn = () => ["auto", "contain", "none"], $o = () => ["auto", "hidden", "clip", "visible", "scroll"], ct = () => ["auto", isArbitraryValue, y], fe = () => [isArbitraryValue, y], be = () => ["", isLength, isArbitraryLength], ye = () => ["auto", isNumber, isArbitraryValue], Se = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Oe = () => ["solid", "dashed", "dotted", "double", "none"], Fr = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], zn = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Fe = () => ["", "0", isArbitraryValue], pe = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], it = () => [isNumber, isArbitraryNumber], xa = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: it(),
      borderColor: [v],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: fe(),
      borderWidth: be(),
      contrast: it(),
      grayscale: Fe(),
      hueRotate: xa(),
      invert: Fe(),
      gap: fe(),
      gradientColorStops: [v],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: ct(),
      margin: ct(),
      opacity: it(),
      padding: fe(),
      saturate: it(),
      scale: it(),
      sepia: Fe(),
      skew: xa(),
      space: fe(),
      translate: fe()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": pe()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": pe()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Se(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: $o()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": $o()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": $o()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: Yn()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": Yn()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": Yn()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [br]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [br]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [br]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [br]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [br]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [br]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [br]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [br]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [br]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: ct()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Fe()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Fe()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ye()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ye()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ye()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ye()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [Ne]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [Ne]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [Ne]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...zn()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...zn(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...zn(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [Rn]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [Rn]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [Rn]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [Rn]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [Rn]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [Rn]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [Rn]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [Rn]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [Rn]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [$n]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [$n]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [$n]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [$n]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [$n]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [$n]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [$n]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [$n]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [$n]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Zn]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Zn]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, y]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, y, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, y, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, y, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, y, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, y, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, y, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [v]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [En]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [v]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [En]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Oe(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [v]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: fe()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [En]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Se(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [v]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [Nr]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [Nr]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [Nr]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [st]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [st]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [st]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [le]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [le]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [le]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [le]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [le]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [le]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [le]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [le]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [le]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [le]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [le]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [le]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [le]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [le]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [le]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [ge]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [ge]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [ge]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [ge]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [ge]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [ge]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [ge]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [ge]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [ge]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [En]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Oe(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [ge]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [ge]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [En]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Oe()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [ue]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [ue]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [ue]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [ue]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [ue]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [ue]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [ue]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [ue]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Oe()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [v]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: be()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [v]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [En]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [v]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [En]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": Fr()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Fr()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [z]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ne]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [we]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [Ee]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [xe]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [$e]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [wa]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_a]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [z]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ne]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [we]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [Ee]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [xe]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [$e]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [En]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [wa]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_a]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [he]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [he]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [he]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: xa()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: xa()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [Aa]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [Aa]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [Aa]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [Ra]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [Ra]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [Ta]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [Ta]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", v]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [v]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": fe()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": fe()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": fe()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": fe()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": fe()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": fe()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": fe()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": fe()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": fe()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": fe()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": fe()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": fe()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": fe()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": fe()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": fe()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": fe()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": fe()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": fe()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [v, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [v, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
function r$9(v) {
  var y, z, ne = "";
  if (typeof v == "string" || typeof v == "number")
    ne += v;
  else if (typeof v == "object")
    if (Array.isArray(v))
      for (y = 0; y < v.length; y++)
        v[y] && (z = r$9(v[y])) && (ne && (ne += " "), ne += z);
    else
      for (y in v)
        v[y] && (ne && (ne += " "), ne += y);
  return ne;
}
function clsx() {
  for (var v, y, z = 0, ne = ""; z < arguments.length; )
    (v = arguments[z++]) && (y = r$9(v)) && (ne && (ne += " "), ne += y);
  return ne;
}
const falsyToString = (v) => typeof v == "boolean" ? "".concat(v) : v === 0 ? "0" : v, cx = clsx, cva = (v, y) => (z) => {
  var ne;
  if ((y == null ? void 0 : y.variants) == null)
    return cx(v, z == null ? void 0 : z.class, z == null ? void 0 : z.className);
  const { variants: ue, defaultVariants: le } = y, he = Object.keys(ue).map((Ee) => {
    const xe = z == null ? void 0 : z[Ee], $e = le == null ? void 0 : le[Ee];
    if (xe === null)
      return null;
    const Ne = falsyToString(xe) || falsyToString($e);
    return ue[Ee][Ne];
  }), ge = z && Object.entries(z).reduce((Ee, xe) => {
    let [$e, Ne] = xe;
    return Ne === void 0 || (Ee[$e] = Ne), Ee;
  }, {}), we = y == null || (ne = y.compoundVariants) === null || ne === void 0 ? void 0 : ne.reduce((Ee, xe) => {
    let { class: $e, className: Ne, ...st } = xe;
    return Object.entries(st).every((Nr) => {
      let [br, $n] = Nr;
      return Array.isArray($n) ? $n.includes({
        ...le,
        ...ge
      }[br]) : {
        ...le,
        ...ge
      }[br] === $n;
    }) ? [
      ...Ee,
      $e,
      Ne
    ] : Ee;
  }, []);
  return cx(v, he, we, z == null ? void 0 : z.class, z == null ? void 0 : z.className);
};
var hr = { exports: {} }, wn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Da;
function Fu() {
  if (Da)
    return wn;
  Da = 1;
  var v = a__default, y = Symbol.for("react.element"), z = Symbol.for("react.fragment"), ne = Object.prototype.hasOwnProperty, ue = v.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, le = { key: !0, ref: !0, __self: !0, __source: !0 };
  function he(ge, we, Ee) {
    var xe, $e = {}, Ne = null, st = null;
    Ee !== void 0 && (Ne = "" + Ee), we.key !== void 0 && (Ne = "" + we.key), we.ref !== void 0 && (st = we.ref);
    for (xe in we)
      ne.call(we, xe) && !le.hasOwnProperty(xe) && ($e[xe] = we[xe]);
    if (ge && ge.defaultProps)
      for (xe in we = ge.defaultProps, we)
        $e[xe] === void 0 && ($e[xe] = we[xe]);
    return { $$typeof: y, type: ge, key: Ne, ref: st, props: $e, _owner: ue.current };
  }
  return wn.Fragment = z, wn.jsx = he, wn.jsxs = he, wn;
}
var xn$1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ma;
function zu() {
  return Ma || (Ma = 1, process$1.env.NODE_ENV !== "production" && function() {
    var v = a__default, y = Symbol.for("react.element"), z = Symbol.for("react.portal"), ne = Symbol.for("react.fragment"), ue = Symbol.for("react.strict_mode"), le = Symbol.for("react.profiler"), he = Symbol.for("react.provider"), ge = Symbol.for("react.context"), we = Symbol.for("react.forward_ref"), Ee = Symbol.for("react.suspense"), xe = Symbol.for("react.suspense_list"), $e = Symbol.for("react.memo"), Ne = Symbol.for("react.lazy"), st = Symbol.for("react.offscreen"), Nr = Symbol.iterator, br = "@@iterator";
    function $n(Mu) {
      if (Mu === null || typeof Mu != "object")
        return null;
      var Du = Nr && Mu[Nr] || Mu[br];
      return typeof Du == "function" ? Du : null;
    }
    var En = v.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Rn(Mu) {
      {
        for (var Du = arguments.length, eh = new Array(Du > 1 ? Du - 1 : 0), Nc = 1; Nc < Du; Nc++)
          eh[Nc - 1] = arguments[Nc];
        wa("error", Mu, eh);
      }
    }
    function wa(Mu, Du, eh) {
      {
        var Nc = En.ReactDebugCurrentFrame, z1 = Nc.getStackAddendum();
        z1 !== "" && (Du += "%s", eh = eh.concat([z1]));
        var A2 = eh.map(function(b2) {
          return String(b2);
        });
        A2.unshift("Warning: " + Du), Function.prototype.apply.call(console[Mu], console, A2);
      }
    }
    var Aa = !1, _a = !1, Ta = !1, Zn = !1, Ra = !1, Yn;
    Yn = Symbol.for("react.module.reference");
    function $o(Mu) {
      return !!(typeof Mu == "string" || typeof Mu == "function" || Mu === ne || Mu === le || Ra || Mu === ue || Mu === Ee || Mu === xe || Zn || Mu === st || Aa || _a || Ta || typeof Mu == "object" && Mu !== null && (Mu.$$typeof === Ne || Mu.$$typeof === $e || Mu.$$typeof === he || Mu.$$typeof === ge || Mu.$$typeof === we || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Mu.$$typeof === Yn || Mu.getModuleId !== void 0));
    }
    function ct(Mu, Du, eh) {
      var Nc = Mu.displayName;
      if (Nc)
        return Nc;
      var z1 = Du.displayName || Du.name || "";
      return z1 !== "" ? eh + "(" + z1 + ")" : eh;
    }
    function fe(Mu) {
      return Mu.displayName || "Context";
    }
    function be(Mu) {
      if (Mu == null)
        return null;
      if (typeof Mu.tag == "number" && Rn("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Mu == "function")
        return Mu.displayName || Mu.name || null;
      if (typeof Mu == "string")
        return Mu;
      switch (Mu) {
        case ne:
          return "Fragment";
        case z:
          return "Portal";
        case le:
          return "Profiler";
        case ue:
          return "StrictMode";
        case Ee:
          return "Suspense";
        case xe:
          return "SuspenseList";
      }
      if (typeof Mu == "object")
        switch (Mu.$$typeof) {
          case ge:
            var Du = Mu;
            return fe(Du) + ".Consumer";
          case he:
            var eh = Mu;
            return fe(eh._context) + ".Provider";
          case we:
            return ct(Mu, Mu.render, "ForwardRef");
          case $e:
            var Nc = Mu.displayName || null;
            return Nc !== null ? Nc : be(Mu.type) || "Memo";
          case Ne: {
            var z1 = Mu, A2 = z1._payload, b2 = z1._init;
            try {
              return be(b2(A2));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ye = Object.assign, Se = 0, Oe, Fr, zn, Fe, pe, it, xa;
    function wo() {
    }
    wo.__reactDisabledLog = !0;
    function _u() {
      {
        if (Se === 0) {
          Oe = console.log, Fr = console.info, zn = console.warn, Fe = console.error, pe = console.group, it = console.groupCollapsed, xa = console.groupEnd;
          var Mu = {
            configurable: !0,
            enumerable: !0,
            value: wo,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Mu,
            log: Mu,
            warn: Mu,
            error: Mu,
            group: Mu,
            groupCollapsed: Mu,
            groupEnd: Mu
          });
        }
        Se++;
      }
    }
    function Oa() {
      {
        if (Se--, Se === 0) {
          var Mu = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ye({}, Mu, {
              value: Oe
            }),
            info: ye({}, Mu, {
              value: Fr
            }),
            warn: ye({}, Mu, {
              value: zn
            }),
            error: ye({}, Mu, {
              value: Fe
            }),
            group: ye({}, Mu, {
              value: pe
            }),
            groupCollapsed: ye({}, Mu, {
              value: it
            }),
            groupEnd: ye({}, Mu, {
              value: xa
            })
          });
        }
        Se < 0 && Rn("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Os = En.ReactCurrentDispatcher, Pa;
    function Ml(Mu, Du, eh) {
      {
        if (Pa === void 0)
          try {
            throw Error();
          } catch (z1) {
            var Nc = z1.stack.trim().match(/\n( *(at )?)/);
            Pa = Nc && Nc[1] || "";
          }
        return `
` + Pa + Mu;
      }
    }
    var Su = !1, Tu;
    {
      var Au = typeof WeakMap == "function" ? WeakMap : Map;
      Tu = new Au();
    }
    function Zl(Mu, Du) {
      if (!Mu || Su)
        return "";
      {
        var eh = Tu.get(Mu);
        if (eh !== void 0)
          return eh;
      }
      var Nc;
      Su = !0;
      var z1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A2;
      A2 = Os.current, Os.current = null, _u();
      try {
        if (Du) {
          var b2 = function() {
            throw Error();
          };
          if (Object.defineProperty(b2.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b2, []);
            } catch (V2) {
              Nc = V2;
            }
            Reflect.construct(Mu, [], b2);
          } else {
            try {
              b2.call();
            } catch (V2) {
              Nc = V2;
            }
            Mu.call(b2.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (V2) {
            Nc = V2;
          }
          Mu();
        }
      } catch (V2) {
        if (V2 && Nc && typeof V2.stack == "string") {
          for (var R2 = V2.stack.split(`
`), D2 = Nc.stack.split(`
`), I2 = R2.length - 1, N2 = D2.length - 1; I2 >= 1 && N2 >= 0 && R2[I2] !== D2[N2]; )
            N2--;
          for (; I2 >= 1 && N2 >= 0; I2--, N2--)
            if (R2[I2] !== D2[N2]) {
              if (I2 !== 1 || N2 !== 1)
                do
                  if (I2--, N2--, N2 < 0 || R2[I2] !== D2[N2]) {
                    var B2 = `
` + R2[I2].replace(" at new ", " at ");
                    return Mu.displayName && B2.includes("<anonymous>") && (B2 = B2.replace("<anonymous>", Mu.displayName)), typeof Mu == "function" && Tu.set(Mu, B2), B2;
                  }
                while (I2 >= 1 && N2 >= 0);
              break;
            }
        }
      } finally {
        Su = !1, Os.current = A2, Oa(), Error.prepareStackTrace = z1;
      }
      var z2 = Mu ? Mu.displayName || Mu.name : "", W2 = z2 ? Ml(z2) : "";
      return typeof Mu == "function" && Tu.set(Mu, W2), W2;
    }
    function Iu(Mu, Du, eh) {
      return Zl(Mu, !1);
    }
    function Uc(Mu) {
      var Du = Mu.prototype;
      return !!(Du && Du.isReactComponent);
    }
    function Pu(Mu, Du, eh) {
      if (Mu == null)
        return "";
      if (typeof Mu == "function")
        return Zl(Mu, Uc(Mu));
      if (typeof Mu == "string")
        return Ml(Mu);
      switch (Mu) {
        case Ee:
          return Ml("Suspense");
        case xe:
          return Ml("SuspenseList");
      }
      if (typeof Mu == "object")
        switch (Mu.$$typeof) {
          case we:
            return Iu(Mu.render);
          case $e:
            return Pu(Mu.type, Du, eh);
          case Ne: {
            var Nc = Mu, z1 = Nc._payload, A2 = Nc._init;
            try {
              return Pu(A2(z1), Du, eh);
            } catch {
            }
          }
        }
      return "";
    }
    var Lu = Object.prototype.hasOwnProperty, th = {}, Zc = En.ReactDebugCurrentFrame;
    function N1(Mu) {
      if (Mu) {
        var Du = Mu._owner, eh = Pu(Mu.type, Mu._source, Du ? Du.type : null);
        Zc.setExtraStackFrame(eh);
      } else
        Zc.setExtraStackFrame(null);
    }
    function Gh(Mu, Du, eh, Nc, z1) {
      {
        var A2 = Function.call.bind(Lu);
        for (var b2 in Mu)
          if (A2(Mu, b2)) {
            var R2 = void 0;
            try {
              if (typeof Mu[b2] != "function") {
                var D2 = Error((Nc || "React class") + ": " + eh + " type `" + b2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Mu[b2] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D2.name = "Invariant Violation", D2;
              }
              R2 = Mu[b2](Du, b2, Nc, eh, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I2) {
              R2 = I2;
            }
            R2 && !(R2 instanceof Error) && (N1(z1), Rn("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Nc || "React class", eh, b2, typeof R2), N1(null)), R2 instanceof Error && !(R2.message in th) && (th[R2.message] = !0, N1(z1), Rn("Failed %s type: %s", eh, R2.message), N1(null));
          }
      }
    }
    var Mc = Array.isArray;
    function h1(Mu) {
      return Mc(Mu);
    }
    function l2(Mu) {
      {
        var Du = typeof Symbol == "function" && Symbol.toStringTag, eh = Du && Mu[Symbol.toStringTag] || Mu.constructor.name || "Object";
        return eh;
      }
    }
    function Gc(Mu) {
      try {
        return Kc(Mu), !1;
      } catch {
        return !0;
      }
    }
    function Kc(Mu) {
      return "" + Mu;
    }
    function M2(Mu) {
      if (Gc(Mu))
        return Rn("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", l2(Mu)), Kc(Mu);
    }
    var d1 = En.ReactCurrentOwner, K1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, k2, Eu, Zo;
    Zo = {};
    function Fl(Mu) {
      if (Lu.call(Mu, "ref")) {
        var Du = Object.getOwnPropertyDescriptor(Mu, "ref").get;
        if (Du && Du.isReactWarning)
          return !1;
      }
      return Mu.ref !== void 0;
    }
    function Ru(Mu) {
      if (Lu.call(Mu, "key")) {
        var Du = Object.getOwnPropertyDescriptor(Mu, "key").get;
        if (Du && Du.isReactWarning)
          return !1;
      }
      return Mu.key !== void 0;
    }
    function ku(Mu, Du) {
      if (typeof Mu.ref == "string" && d1.current && Du && d1.current.stateNode !== Du) {
        var eh = be(d1.current.type);
        Zo[eh] || (Rn('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', be(d1.current.type), Mu.ref), Zo[eh] = !0);
      }
    }
    function kc(Mu, Du) {
      {
        var eh = function() {
          k2 || (k2 = !0, Rn("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Du));
        };
        eh.isReactWarning = !0, Object.defineProperty(Mu, "key", {
          get: eh,
          configurable: !0
        });
      }
    }
    function Ou(Mu, Du) {
      {
        var eh = function() {
          Eu || (Eu = !0, Rn("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Du));
        };
        eh.isReactWarning = !0, Object.defineProperty(Mu, "ref", {
          get: eh,
          configurable: !0
        });
      }
    }
    var U1 = function(Mu, Du, eh, Nc, z1, A2, b2) {
      var R2 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: y,
        // Built-in properties that belong on the element
        type: Mu,
        key: Du,
        ref: eh,
        props: b2,
        // Record the component responsible for creating this element.
        _owner: A2
      };
      return R2._store = {}, Object.defineProperty(R2._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R2, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Nc
      }), Object.defineProperty(R2, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: z1
      }), Object.freeze && (Object.freeze(R2.props), Object.freeze(R2)), R2;
    };
    function g2(Mu, Du, eh, Nc, z1) {
      {
        var A2, b2 = {}, R2 = null, D2 = null;
        eh !== void 0 && (M2(eh), R2 = "" + eh), Ru(Du) && (M2(Du.key), R2 = "" + Du.key), Fl(Du) && (D2 = Du.ref, ku(Du, z1));
        for (A2 in Du)
          Lu.call(Du, A2) && !K1.hasOwnProperty(A2) && (b2[A2] = Du[A2]);
        if (Mu && Mu.defaultProps) {
          var I2 = Mu.defaultProps;
          for (A2 in I2)
            b2[A2] === void 0 && (b2[A2] = I2[A2]);
        }
        if (R2 || D2) {
          var N2 = typeof Mu == "function" ? Mu.displayName || Mu.name || "Unknown" : Mu;
          R2 && kc(b2, N2), D2 && Ou(b2, N2);
        }
        return U1(Mu, R2, D2, z1, Nc, d1.current, b2);
      }
    }
    var Ic = En.ReactCurrentOwner, X1 = En.ReactDebugCurrentFrame;
    function $2(Mu) {
      if (Mu) {
        var Du = Mu._owner, eh = Pu(Mu.type, Mu._source, Du ? Du.type : null);
        X1.setExtraStackFrame(eh);
      } else
        X1.setExtraStackFrame(null);
    }
    var ah;
    ah = !1;
    function O1(Mu) {
      return typeof Mu == "object" && Mu !== null && Mu.$$typeof === y;
    }
    function T2() {
      {
        if (Ic.current) {
          var Mu = be(Ic.current.type);
          if (Mu)
            return `

Check the render method of \`` + Mu + "`.";
        }
        return "";
      }
    }
    function ih(Mu) {
      {
        if (Mu !== void 0) {
          var Du = Mu.fileName.replace(/^.*[\\\/]/, ""), eh = Mu.lineNumber;
          return `

Check your code at ` + Du + ":" + eh + ".";
        }
        return "";
      }
    }
    var oh = {};
    function j2(Mu) {
      {
        var Du = T2();
        if (!Du) {
          var eh = typeof Mu == "string" ? Mu : Mu.displayName || Mu.name;
          eh && (Du = `

Check the top-level render call using <` + eh + ">.");
        }
        return Du;
      }
    }
    function lh(Mu, Du) {
      {
        if (!Mu._store || Mu._store.validated || Mu.key != null)
          return;
        Mu._store.validated = !0;
        var eh = j2(Du);
        if (oh[eh])
          return;
        oh[eh] = !0;
        var Nc = "";
        Mu && Mu._owner && Mu._owner !== Ic.current && (Nc = " It was passed a child from " + be(Mu._owner.type) + "."), $2(Mu), Rn('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', eh, Nc), $2(null);
      }
    }
    function kh(Mu, Du) {
      {
        if (typeof Mu != "object")
          return;
        if (h1(Mu))
          for (var eh = 0; eh < Mu.length; eh++) {
            var Nc = Mu[eh];
            O1(Nc) && lh(Nc, Du);
          }
        else if (O1(Mu))
          Mu._store && (Mu._store.validated = !0);
        else if (Mu) {
          var z1 = $n(Mu);
          if (typeof z1 == "function" && z1 !== Mu.entries)
            for (var A2 = z1.call(Mu), b2; !(b2 = A2.next()).done; )
              O1(b2.value) && lh(b2.value, Du);
        }
      }
    }
    function P2(Mu) {
      {
        var Du = Mu.type;
        if (Du == null || typeof Du == "string")
          return;
        var eh;
        if (typeof Du == "function")
          eh = Du.propTypes;
        else if (typeof Du == "object" && (Du.$$typeof === we || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Du.$$typeof === $e))
          eh = Du.propTypes;
        else
          return;
        if (eh) {
          var Nc = be(Du);
          Gh(eh, Mu.props, "prop", Nc, Mu);
        } else if (Du.PropTypes !== void 0 && !ah) {
          ah = !0;
          var z1 = be(Du);
          Rn("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", z1 || "Unknown");
        }
        typeof Du.getDefaultProps == "function" && !Du.getDefaultProps.isReactClassApproved && Rn("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ch(Mu) {
      {
        for (var Du = Object.keys(Mu.props), eh = 0; eh < Du.length; eh++) {
          var Nc = Du[eh];
          if (Nc !== "children" && Nc !== "key") {
            $2(Mu), Rn("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Nc), $2(null);
            break;
          }
        }
        Mu.ref !== null && ($2(Mu), Rn("Invalid attribute `ref` supplied to `React.Fragment`."), $2(null));
      }
    }
    function Nh(Mu, Du, eh, Nc, z1, A2) {
      {
        var b2 = $o(Mu);
        if (!b2) {
          var R2 = "";
          (Mu === void 0 || typeof Mu == "object" && Mu !== null && Object.keys(Mu).length === 0) && (R2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var D2 = ih(z1);
          D2 ? R2 += D2 : R2 += T2();
          var I2;
          Mu === null ? I2 = "null" : h1(Mu) ? I2 = "array" : Mu !== void 0 && Mu.$$typeof === y ? (I2 = "<" + (be(Mu.type) || "Unknown") + " />", R2 = " Did you accidentally export a JSX literal instead of a component?") : I2 = typeof Mu, Rn("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I2, R2);
        }
        var N2 = g2(Mu, Du, eh, z1, A2);
        if (N2 == null)
          return N2;
        if (b2) {
          var B2 = Du.children;
          if (B2 !== void 0)
            if (Nc)
              if (h1(B2)) {
                for (var z2 = 0; z2 < B2.length; z2++)
                  kh(B2[z2], Mu);
                Object.freeze && Object.freeze(B2);
              } else
                Rn("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kh(B2, Mu);
        }
        return Mu === ne ? ch(N2) : P2(N2), N2;
      }
    }
    function L2(Mu, Du, eh) {
      return Nh(Mu, Du, eh, !0);
    }
    function yh(Mu, Du, eh) {
      return Nh(Mu, Du, eh, !1);
    }
    var Dh = yh, F2 = L2;
    xn$1.Fragment = ne, xn$1.jsx = Dh, xn$1.jsxs = F2;
  }()), xn$1;
}
process$1.env.NODE_ENV === "production" ? hr.exports = Fu() : hr.exports = zu();
var D$6 = hr.exports;
function _$2() {
  return _$2 = Object.assign ? Object.assign.bind() : function(v) {
    for (var y = 1; y < arguments.length; y++) {
      var z = arguments[y];
      for (var ne in z)
        Object.prototype.hasOwnProperty.call(z, ne) && (v[ne] = z[ne]);
    }
    return v;
  }, _$2.apply(this, arguments);
}
function Le(v, y = []) {
  let z = [];
  function ne(le, he) {
    const ge = /* @__PURE__ */ createContext(he), we = z.length;
    z = [
      ...z,
      he
    ];
    function Ee($e) {
      const { scope: Ne, children: st, ...Nr } = $e, br = (Ne == null ? void 0 : Ne[v][we]) || ge, $n = useMemo(
        () => Nr,
        Object.values(Nr)
      );
      return /* @__PURE__ */ createElement(br.Provider, {
        value: $n
      }, st);
    }
    function xe($e, Ne) {
      const st = (Ne == null ? void 0 : Ne[v][we]) || ge, Nr = useContext(st);
      if (Nr)
        return Nr;
      if (he !== void 0)
        return he;
      throw new Error(`\`${$e}\` must be used within \`${le}\``);
    }
    return Ee.displayName = le + "Provider", [
      Ee,
      xe
    ];
  }
  const ue = () => {
    const le = z.map((he) => /* @__PURE__ */ createContext(he));
    return function(he) {
      const ge = (he == null ? void 0 : he[v]) || le;
      return useMemo(
        () => ({
          [`__scope${v}`]: {
            ...he,
            [v]: ge
          }
        }),
        [
          he,
          ge
        ]
      );
    };
  };
  return ue.scopeName = v, [
    ne,
    ju(ue, ...y)
  ];
}
function ju(...v) {
  const y = v[0];
  if (v.length === 1)
    return y;
  const z = () => {
    const ne = v.map(
      (ue) => ({
        useScope: ue(),
        scopeName: ue.scopeName
      })
    );
    return function(ue) {
      const le = ne.reduce((he, { useScope: ge, scopeName: we }) => {
        const Ee = ge(ue)[`__scope${we}`];
        return {
          ...he,
          ...Ee
        };
      }, {});
      return useMemo(
        () => ({
          [`__scope${y.scopeName}`]: le
        }),
        [
          le
        ]
      );
    };
  };
  return z.scopeName = y.scopeName, z;
}
function Hu(v, y) {
  typeof v == "function" ? v(y) : v != null && (v.current = y);
}
function zr(...v) {
  return (y) => v.forEach(
    (z) => Hu(z, y)
  );
}
function de(...v) {
  return useCallback(zr(...v), v);
}
function xo(v) {
  const y = v + "CollectionProvider", [z, ne] = Le(y), [ue, le] = z(y, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), he = (st) => {
    const { scope: Nr, children: br } = st, $n = a__default.useRef(null), En = a__default.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ a__default.createElement(ue, {
      scope: Nr,
      itemMap: En,
      collectionRef: $n
    }, br);
  }, ge = v + "CollectionSlot", we = /* @__PURE__ */ a__default.forwardRef((st, Nr) => {
    const { scope: br, children: $n } = st, En = le(ge, br), Rn = de(Nr, En.collectionRef);
    return /* @__PURE__ */ a__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      ref: Rn
    }, $n);
  }), Ee = v + "CollectionItemSlot", xe = "data-radix-collection-item", $e = /* @__PURE__ */ a__default.forwardRef((st, Nr) => {
    const { scope: br, children: $n, ...En } = st, Rn = a__default.useRef(null), wa = de(Nr, Rn), Aa = le(Ee, br);
    return a__default.useEffect(() => (Aa.itemMap.set(Rn, {
      ref: Rn,
      ...En
    }), () => void Aa.itemMap.delete(Rn))), /* @__PURE__ */ a__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
      [xe]: "",
      ref: wa
    }, $n);
  });
  function Ne(st) {
    const Nr = le(v + "CollectionConsumer", st);
    return a__default.useCallback(() => {
      const br = Nr.collectionRef.current;
      if (!br)
        return [];
      const $n = Array.from(br.querySelectorAll(`[${xe}]`));
      return Array.from(Nr.itemMap.values()).sort(
        (En, Rn) => $n.indexOf(En.ref.current) - $n.indexOf(Rn.ref.current)
      );
    }, [
      Nr.collectionRef,
      Nr.itemMap
    ]);
  }
  return [
    {
      Provider: he,
      Slot: we,
      ItemSlot: $e
    },
    Ne,
    ne
  ];
}
function H$2(v, y, { checkForDefaultPrevented: z = !0 } = {}) {
  return function(ne) {
    if (v == null || v(ne), z === !1 || !ne.defaultPrevented)
      return y == null ? void 0 : y(ne);
  };
}
function Te$1(v) {
  const y = useRef(v);
  return useEffect(() => {
    y.current = v;
  }), useMemo(
    () => (...z) => {
      var ne;
      return (ne = y.current) === null || ne === void 0 ? void 0 : ne.call(y, ...z);
    },
    []
  );
}
function Be$1({ prop: v, defaultProp: y, onChange: z = () => {
} }) {
  const [ne, ue] = Vu({
    defaultProp: y,
    onChange: z
  }), le = v !== void 0, he = le ? v : ne, ge = Te$1(z), we = useCallback((Ee) => {
    if (le) {
      const xe = typeof Ee == "function" ? Ee(v) : Ee;
      xe !== v && ge(xe);
    } else
      ue(Ee);
  }, [
    le,
    v,
    ue,
    ge
  ]);
  return [
    he,
    we
  ];
}
function Vu({ defaultProp: v, onChange: y }) {
  const z = useState(v), [ne] = z, ue = useRef(ne), le = Te$1(y);
  return useEffect(() => {
    ue.current !== ne && (le(ne), ue.current = ne);
  }, [
    ne,
    ue,
    le
  ]), z;
}
const Bu = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], X$2 = Bu.reduce((v, y) => {
  const z = /* @__PURE__ */ forwardRef((ne, ue) => {
    const { asChild: le, ...he } = ne, ge = le ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : y;
    return useEffect(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ createElement(ge, _$2({}, he, {
      ref: ue
    }));
  });
  return z.displayName = `Primitive.${y}`, {
    ...v,
    [y]: z
  };
}, {});
function Yc(v, y) {
  v && flushSync(
    () => v.dispatchEvent(y)
  );
}
const ke$1 = globalThis != null && globalThis.document ? useLayoutEffect : () => {
};
function Wu(v, y) {
  return useReducer((z, ne) => y[z][ne] ?? z, v);
}
const Ie = (v) => {
  const { present: y, children: z } = v, ne = Uu(y), ue = typeof z == "function" ? z({
    present: ne.isPresent
  }) : Children.only(z), le = de(ne.ref, ue.ref);
  return typeof z == "function" || ne.isPresent ? /* @__PURE__ */ cloneElement(ue, {
    ref: le
  }) : null;
};
Ie.displayName = "Presence";
function Uu(v) {
  const [y, z] = useState(), ne = useRef({}), ue = useRef(v), le = useRef("none"), he = v ? "mounted" : "unmounted", [ge, we] = Wu(he, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return useEffect(() => {
    const Ee = Xn$1(ne.current);
    le.current = ge === "mounted" ? Ee : "none";
  }, [
    ge
  ]), ke$1(() => {
    const Ee = ne.current, xe = ue.current;
    if (xe !== v) {
      const $e = le.current, Ne = Xn$1(Ee);
      v ? we("MOUNT") : Ne === "none" || (Ee == null ? void 0 : Ee.display) === "none" ? we("UNMOUNT") : we(xe && $e !== Ne ? "ANIMATION_OUT" : "UNMOUNT"), ue.current = v;
    }
  }, [
    v,
    we
  ]), ke$1(() => {
    if (y) {
      const Ee = ($e) => {
        const Ne = Xn$1(ne.current).includes($e.animationName);
        $e.target === y && Ne && flushSync(
          () => we("ANIMATION_END")
        );
      }, xe = ($e) => {
        $e.target === y && (le.current = Xn$1(ne.current));
      };
      return y.addEventListener("animationstart", xe), y.addEventListener("animationcancel", Ee), y.addEventListener("animationend", Ee), () => {
        y.removeEventListener("animationstart", xe), y.removeEventListener("animationcancel", Ee), y.removeEventListener("animationend", Ee);
      };
    } else
      we("ANIMATION_END");
  }, [
    y,
    we
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(ge),
    ref: useCallback((Ee) => {
      Ee && (ne.current = getComputedStyle(Ee)), z(Ee);
    }, [])
  };
}
function Xn$1(v) {
  return (v == null ? void 0 : v.animationName) || "none";
}
const Ku = a$z.useId || (() => {
});
let Gu = 0;
function je$1(v) {
  const [y, z] = a$z.useState(Ku());
  return ke$1(() => {
    v || z(
      (ne) => ne ?? String(Gu++)
    );
  }, [
    v
  ]), v || (y ? `radix-${y}` : "");
}
const Xc = "Collapsible", [Zu, qc] = Le(Xc), [Yu, jr] = Zu(Xc), Xu = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeCollapsible: z, open: ne, defaultOpen: ue, disabled: le, onOpenChange: he, ...ge } = v, [we = !1, Ee] = Be$1({
    prop: ne,
    defaultProp: ue,
    onChange: he
  });
  return /* @__PURE__ */ createElement(Yu, {
    scope: z,
    disabled: le,
    contentId: je$1(),
    open: we,
    onOpenToggle: useCallback(
      () => Ee(
        (xe) => !xe
      ),
      [
        Ee
      ]
    )
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-state": Hr(we),
    "data-disabled": le ? "" : void 0
  }, ge, {
    ref: y
  })));
}), qu = "CollapsibleTrigger", Ju = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeCollapsible: z, ...ne } = v, ue = jr(qu, z);
  return /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    "aria-controls": ue.contentId,
    "aria-expanded": ue.open || !1,
    "data-state": Hr(ue.open),
    "data-disabled": ue.disabled ? "" : void 0,
    disabled: ue.disabled
  }, ne, {
    ref: y,
    onClick: H$2(v.onClick, ue.onOpenToggle)
  }));
}), Jc = "CollapsibleContent", Qu = /* @__PURE__ */ forwardRef((v, y) => {
  const { forceMount: z, ...ne } = v, ue = jr(Jc, v.__scopeCollapsible);
  return /* @__PURE__ */ createElement(
    Ie,
    {
      present: z || ue.open
    },
    ({ present: le }) => /* @__PURE__ */ createElement(ed, _$2({}, ne, {
      ref: y,
      present: le
    }))
  );
}), ed = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeCollapsible: z, present: ne, children: ue, ...le } = v, he = jr(Jc, z), [ge, we] = useState(ne), Ee = useRef(null), xe = de(y, Ee), $e = useRef(0), Ne = $e.current, st = useRef(0), Nr = st.current, br = he.open || ge, $n = useRef(br), En = useRef();
  return useEffect(() => {
    const Rn = requestAnimationFrame(
      () => $n.current = !1
    );
    return () => cancelAnimationFrame(Rn);
  }, []), ke$1(() => {
    const Rn = Ee.current;
    if (Rn) {
      En.current = En.current || {
        transitionDuration: Rn.style.transitionDuration,
        animationName: Rn.style.animationName
      }, Rn.style.transitionDuration = "0s", Rn.style.animationName = "none";
      const wa = Rn.getBoundingClientRect();
      $e.current = wa.height, st.current = wa.width, $n.current || (Rn.style.transitionDuration = En.current.transitionDuration, Rn.style.animationName = En.current.animationName), we(ne);
    }
  }, [
    he.open,
    ne
  ]), /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-state": Hr(he.open),
    "data-disabled": he.disabled ? "" : void 0,
    id: he.contentId,
    hidden: !br
  }, le, {
    ref: xe,
    style: {
      "--radix-collapsible-content-height": Ne ? `${Ne}px` : void 0,
      "--radix-collapsible-content-width": Nr ? `${Nr}px` : void 0,
      ...v.style
    }
  }), br && ue);
});
function Hr(v) {
  return v ? "open" : "closed";
}
const td = Xu, nd = Ju, od = Qu, rd = /* @__PURE__ */ createContext(void 0);
function Kt$1(v) {
  const y = useContext(rd);
  return v || y || "ltr";
}
const _t$1 = "Accordion", ad = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [Vr, cd, id$3] = xo(_t$1), [yo, K$] = Le(_t$1, [
  id$3,
  qc
]), Br = qc(), Qc = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { type: z, ...ne } = v, ue = ne, le = ne;
  return /* @__PURE__ */ a__default.createElement(Vr.Provider, {
    scope: v.__scopeAccordion
  }, z === "multiple" ? /* @__PURE__ */ a__default.createElement(dd, _$2({}, le, {
    ref: y
  })) : /* @__PURE__ */ a__default.createElement(ud, _$2({}, ue, {
    ref: y
  })));
});
Qc.propTypes = {
  type(v) {
    const y = v.value || v.defaultValue;
    return v.type && ![
      "single",
      "multiple"
    ].includes(v.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : v.type === "multiple" && typeof y == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : v.type === "single" && Array.isArray(y) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [ei, sd] = yo(_t$1), [ti, ld] = yo(_t$1, {
  collapsible: !1
}), ud = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { value: z, defaultValue: ne, onValueChange: ue = () => {
  }, collapsible: le = !1, ...he } = v, [ge, we] = Be$1({
    prop: z,
    defaultProp: ne,
    onChange: ue
  });
  return /* @__PURE__ */ a__default.createElement(ei, {
    scope: v.__scopeAccordion,
    value: ge ? [
      ge
    ] : [],
    onItemOpen: we,
    onItemClose: a__default.useCallback(
      () => le && we(""),
      [
        le,
        we
      ]
    )
  }, /* @__PURE__ */ a__default.createElement(ti, {
    scope: v.__scopeAccordion,
    collapsible: le
  }, /* @__PURE__ */ a__default.createElement(ni, _$2({}, he, {
    ref: y
  }))));
}), dd = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { value: z, defaultValue: ne, onValueChange: ue = () => {
  }, ...le } = v, [he = [], ge] = Be$1({
    prop: z,
    defaultProp: ne,
    onChange: ue
  }), we = a__default.useCallback(
    (xe) => ge(
      ($e = []) => [
        ...$e,
        xe
      ]
    ),
    [
      ge
    ]
  ), Ee = a__default.useCallback(
    (xe) => ge(
      ($e = []) => $e.filter(
        (Ne) => Ne !== xe
      )
    ),
    [
      ge
    ]
  );
  return /* @__PURE__ */ a__default.createElement(ei, {
    scope: v.__scopeAccordion,
    value: he,
    onItemOpen: we,
    onItemClose: Ee
  }, /* @__PURE__ */ a__default.createElement(ti, {
    scope: v.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ a__default.createElement(ni, _$2({}, le, {
    ref: y
  }))));
}), [fd, Co] = yo(_t$1), ni = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { __scopeAccordion: z, disabled: ne, dir: ue, orientation: le = "vertical", ...he } = v, ge = a__default.useRef(null), we = de(ge, y), Ee = cd(z), xe = Kt$1(ue) === "ltr", $e = H$2(v.onKeyDown, (Ne) => {
    var st;
    if (!ad.includes(Ne.key))
      return;
    const Nr = Ne.target, br = Ee().filter((Ra) => {
      var Yn;
      return !((Yn = Ra.ref.current) !== null && Yn !== void 0 && Yn.disabled);
    }), $n = br.findIndex(
      (Ra) => Ra.ref.current === Nr
    ), En = br.length;
    if ($n === -1)
      return;
    Ne.preventDefault();
    let Rn = $n;
    const wa = 0, Aa = En - 1, _a = () => {
      Rn = $n + 1, Rn > Aa && (Rn = wa);
    }, Ta = () => {
      Rn = $n - 1, Rn < wa && (Rn = Aa);
    };
    switch (Ne.key) {
      case "Home":
        Rn = wa;
        break;
      case "End":
        Rn = Aa;
        break;
      case "ArrowRight":
        le === "horizontal" && (xe ? _a() : Ta());
        break;
      case "ArrowDown":
        le === "vertical" && _a();
        break;
      case "ArrowLeft":
        le === "horizontal" && (xe ? Ta() : _a());
        break;
      case "ArrowUp":
        le === "vertical" && Ta();
        break;
    }
    const Zn = Rn % En;
    (st = br[Zn].ref.current) === null || st === void 0 || st.focus();
  });
  return /* @__PURE__ */ a__default.createElement(fd, {
    scope: z,
    disabled: ne,
    direction: ue,
    orientation: le
  }, /* @__PURE__ */ a__default.createElement(Vr.Slot, {
    scope: z
  }, /* @__PURE__ */ a__default.createElement(X$2.div, _$2({}, he, {
    "data-orientation": le,
    ref: we,
    onKeyDown: ne ? void 0 : $e
  }))));
}), $r = "AccordionItem", [pd, Wr] = yo($r), md = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { __scopeAccordion: z, value: ne, ...ue } = v, le = Co($r, z), he = sd($r, z), ge = Br(z), we = je$1(), Ee = ne && he.value.includes(ne) || !1, xe = le.disabled || v.disabled;
  return /* @__PURE__ */ a__default.createElement(pd, {
    scope: z,
    open: Ee,
    disabled: xe,
    triggerId: we
  }, /* @__PURE__ */ a__default.createElement(td, _$2({
    "data-orientation": le.orientation,
    "data-state": oi(Ee)
  }, ge, ue, {
    ref: y,
    disabled: xe,
    open: Ee,
    onOpenChange: ($e) => {
      $e ? he.onItemOpen(ne) : he.onItemClose(ne);
    }
  })));
}), vd = "AccordionHeader", bd = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { __scopeAccordion: z, ...ne } = v, ue = Co(_t$1, z), le = Wr(vd, z);
  return /* @__PURE__ */ a__default.createElement(X$2.h3, _$2({
    "data-orientation": ue.orientation,
    "data-state": oi(le.open),
    "data-disabled": le.disabled ? "" : void 0
  }, ne, {
    ref: y
  }));
}), Ia = "AccordionTrigger", gd = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { __scopeAccordion: z, ...ne } = v, ue = Co(_t$1, z), le = Wr(Ia, z), he = ld(Ia, z), ge = Br(z);
  return /* @__PURE__ */ a__default.createElement(Vr.ItemSlot, {
    scope: z
  }, /* @__PURE__ */ a__default.createElement(nd, _$2({
    "aria-disabled": le.open && !he.collapsible || void 0,
    "data-orientation": ue.orientation,
    id: le.triggerId
  }, ge, ne, {
    ref: y
  })));
}), hd = "AccordionContent", $d = /* @__PURE__ */ a__default.forwardRef((v, y) => {
  const { __scopeAccordion: z, ...ne } = v, ue = Co(_t$1, z), le = Wr(hd, z), he = Br(z);
  return /* @__PURE__ */ a__default.createElement(od, _$2({
    role: "region",
    "aria-labelledby": le.triggerId,
    "data-orientation": ue.orientation
  }, he, ne, {
    ref: y,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...v.style
    }
  }));
});
function oi(v) {
  return v ? "open" : "closed";
}
const wd = Qc, xd = md, yd = bd, ri = gd, ai = $d, Cd = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
var Ed = Object.defineProperty, fo = Object.getOwnPropertySymbols, ci = Object.prototype.hasOwnProperty, ii = Object.prototype.propertyIsEnumerable, Na = (v, y, z) => y in v ? Ed(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, ka = (v, y) => {
  for (var z in y || (y = {}))
    ci.call(y, z) && Na(v, z, y[z]);
  if (fo)
    for (var z of fo(y))
      ii.call(y, z) && Na(v, z, y[z]);
  return v;
}, La = (v, y) => {
  var z = {};
  for (var ne in v)
    ci.call(v, ne) && y.indexOf(ne) < 0 && (z[ne] = v[ne]);
  if (v != null && fo)
    for (var ne of fo(v))
      y.indexOf(ne) < 0 && ii.call(v, ne) && (z[ne] = v[ne]);
  return z;
};
const vt$1 = forwardRef((v, y) => {
  const z = v, {
    alt: ne,
    color: ue,
    size: le,
    weight: he,
    mirrored: ge,
    children: we,
    weights: Ee
  } = z, xe = La(z, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), $e = useContext(Cd), {
    color: Ne = "currentColor",
    size: st,
    weight: Nr = "regular",
    mirrored: br = !1
  } = $e, $n = La($e, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    ka(ka({
      ref: y,
      xmlns: "http://www.w3.org/2000/svg",
      width: le ?? st,
      height: le ?? st,
      fill: ue ?? Ne,
      viewBox: "0 0 256 256",
      transform: ge || br ? "scale(-1, 1)" : void 0
    }, $n), xe),
    !!ne && /* @__PURE__ */ a__default.createElement("title", null, ne),
    we,
    Ee.get(he ?? Nr)
  );
});
vt$1.displayName = "IconBase";
const Sd = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Pd = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), _d = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,160H48l80-80Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z" }))
  ]
]), Rd = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Ad = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z" }))
  ]
]), Td = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), Od = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), Dd = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]);
var Md = Object.defineProperty, Id$1 = Object.defineProperties, Nd = Object.getOwnPropertyDescriptors, Fa = Object.getOwnPropertySymbols, kd = Object.prototype.hasOwnProperty, Ld = Object.prototype.propertyIsEnumerable, za = (v, y, z) => y in v ? Md(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, Fd = (v, y) => {
  for (var z in y || (y = {}))
    kd.call(y, z) && za(v, z, y[z]);
  if (Fa)
    for (var z of Fa(y))
      Ld.call(y, z) && za(v, z, y[z]);
  return v;
}, zd = (v, y) => Id$1(v, Nd(y));
const Eo = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, zd(Fd({ ref: y }, v), { weights: Sd })));
Eo.displayName = "CaretDown";
var jd = Object.defineProperty, Hd = Object.defineProperties, Vd = Object.getOwnPropertyDescriptors, ja = Object.getOwnPropertySymbols, Bd = Object.prototype.hasOwnProperty, Wd = Object.prototype.propertyIsEnumerable, Ha = (v, y, z) => y in v ? jd(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, Ud = (v, y) => {
  for (var z in y || (y = {}))
    Bd.call(y, z) && Ha(v, z, y[z]);
  if (ja)
    for (var z of ja(y))
      Wd.call(y, z) && Ha(v, z, y[z]);
  return v;
}, Kd = (v, y) => Hd(v, Vd(y));
const si = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, Kd(Ud({ ref: y }, v), { weights: Pd })));
si.displayName = "CaretRight";
var Gd = Object.defineProperty, Zd = Object.defineProperties, Yd = Object.getOwnPropertyDescriptors, Va = Object.getOwnPropertySymbols, Xd = Object.prototype.hasOwnProperty, qd = Object.prototype.propertyIsEnumerable, Ba = (v, y, z) => y in v ? Gd(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, Jd = (v, y) => {
  for (var z in y || (y = {}))
    Xd.call(y, z) && Ba(v, z, y[z]);
  if (Va)
    for (var z of Va(y))
      qd.call(y, z) && Ba(v, z, y[z]);
  return v;
}, Qd = (v, y) => Zd(v, Yd(y));
const li = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, Qd(Jd({ ref: y }, v), { weights: _d })));
li.displayName = "CaretUp";
var ef = Object.defineProperty, tf = Object.defineProperties, nf = Object.getOwnPropertyDescriptors, Wa = Object.getOwnPropertySymbols, of = Object.prototype.hasOwnProperty, rf = Object.prototype.propertyIsEnumerable, Ua = (v, y, z) => y in v ? ef(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, af = (v, y) => {
  for (var z in y || (y = {}))
    of.call(y, z) && Ua(v, z, y[z]);
  if (Wa)
    for (var z of Wa(y))
      rf.call(y, z) && Ua(v, z, y[z]);
  return v;
}, cf = (v, y) => tf(v, nf(y));
const So = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, cf(af({ ref: y }, v), { weights: Rd })));
So.displayName = "Check";
var sf = Object.defineProperty, lf = Object.defineProperties, uf = Object.getOwnPropertyDescriptors, Ka = Object.getOwnPropertySymbols, df = Object.prototype.hasOwnProperty, ff = Object.prototype.propertyIsEnumerable, Ga = (v, y, z) => y in v ? sf(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, pf = (v, y) => {
  for (var z in y || (y = {}))
    df.call(y, z) && Ga(v, z, y[z]);
  if (Ka)
    for (var z of Ka(y))
      ff.call(y, z) && Ga(v, z, y[z]);
  return v;
}, mf = (v, y) => lf(v, uf(y));
const ui = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, mf(pf({ ref: y }, v), { weights: Ad })));
ui.displayName = "Circle";
var vf = Object.defineProperty, bf = Object.defineProperties, gf = Object.getOwnPropertyDescriptors, Za = Object.getOwnPropertySymbols, hf = Object.prototype.hasOwnProperty, $f = Object.prototype.propertyIsEnumerable, Ya = (v, y, z) => y in v ? vf(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, wf = (v, y) => {
  for (var z in y || (y = {}))
    hf.call(y, z) && Ya(v, z, y[z]);
  if (Za)
    for (var z of Za(y))
      $f.call(y, z) && Ya(v, z, y[z]);
  return v;
}, xf = (v, y) => bf(v, gf(y));
const di = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, xf(wf({ ref: y }, v), { weights: Td })));
di.displayName = "DotsSixVertical";
var yf = Object.defineProperty, Cf = Object.defineProperties, Ef = Object.getOwnPropertyDescriptors, Xa = Object.getOwnPropertySymbols, Sf = Object.prototype.hasOwnProperty, Pf = Object.prototype.propertyIsEnumerable, qa = (v, y, z) => y in v ? yf(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, _f = (v, y) => {
  for (var z in y || (y = {}))
    Sf.call(y, z) && qa(v, z, y[z]);
  if (Xa)
    for (var z of Xa(y))
      Pf.call(y, z) && qa(v, z, y[z]);
  return v;
}, Rf = (v, y) => Cf(v, Ef(y));
const fi = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, Rf(_f({ ref: y }, v), { weights: Od })));
fi.displayName = "MagnifyingGlass";
var Af = Object.defineProperty, Tf = Object.defineProperties, Of = Object.getOwnPropertyDescriptors, Ja = Object.getOwnPropertySymbols, Df = Object.prototype.hasOwnProperty, Mf = Object.prototype.propertyIsEnumerable, Qa = (v, y, z) => y in v ? Af(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, If = (v, y) => {
  for (var z in y || (y = {}))
    Df.call(y, z) && Qa(v, z, y[z]);
  if (Ja)
    for (var z of Ja(y))
      Mf.call(y, z) && Qa(v, z, y[z]);
  return v;
}, Nf = (v, y) => Tf(v, Of(y));
const pi = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(vt$1, Nf(If({ ref: y }, v), { weights: Dd })));
pi.displayName = "X";
function Y$1(...v) {
  return twMerge(clsx$1(v));
}
const G$ = wd, kf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  xd,
  {
    ref: z,
    className: Y$1("border-b", v),
    ...y
  }
));
kf.displayName = "AccordionItem";
const Lf = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(yd, { className: "flex", children: /* @__PURE__ */ D$6.jsxs(
  ri,
  {
    ref: ne,
    className: Y$1(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all [&[data-state=open]>svg]:rotate-180 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      v
    ),
    ...z,
    children: [
      y,
      /* @__PURE__ */ D$6.jsx(Eo, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
    ]
  }
) }));
Lf.displayName = ri.displayName;
const Ff = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  ai,
  {
    ref: ne,
    className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...z,
    children: /* @__PURE__ */ D$6.jsx("div", { className: Y$1("pb-4 pt-0", v), children: y })
  }
));
Ff.displayName = ai.displayName;
const zf = cva(
  "relative w-full rounded-lg border p-4 !pb-3 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        warning: "bg-card [&>h5]:text-warning border-warning/50 dark:border-warning [&>svg]:text-warning",
        destructive: "bg-card [&>h5]:text-destructive border-destructive/50 dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), jf = a$z.forwardRef(({ className: v, variant: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  "div",
  {
    ref: ne,
    role: "alert",
    className: Y$1(zf({ variant: y }), v),
    ...z
  }
));
jf.displayName = "Alert";
const Hf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  "h5",
  {
    ref: z,
    className: Y$1("font-medium leading-none tracking-tight", v),
    ...y
  }
));
Hf.displayName = "AlertTitle";
const Vf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  "div",
  {
    ref: z,
    className: Y$1("text-sm font-normal [&_p]:leading-relaxed", v),
    ...y
  }
));
Vf.displayName = "AlertDescription";
const mi = "Avatar", [Bf, Z$] = Le(mi), [Wf, vi] = Bf(mi), Uf = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeAvatar: z, ...ne } = v, [ue, le] = useState("idle");
  return /* @__PURE__ */ createElement(Wf, {
    scope: z,
    imageLoadingStatus: ue,
    onImageLoadingStatusChange: le
  }, /* @__PURE__ */ createElement(X$2.span, _$2({}, ne, {
    ref: y
  })));
}), Kf = "AvatarImage", Gf = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeAvatar: z, src: ne, onLoadingStatusChange: ue = () => {
  }, ...le } = v, he = vi(Kf, z), ge = Xf(ne), we = Te$1((Ee) => {
    ue(Ee), he.onImageLoadingStatusChange(Ee);
  });
  return ke$1(() => {
    ge !== "idle" && we(ge);
  }, [
    ge,
    we
  ]), ge === "loaded" ? /* @__PURE__ */ createElement(X$2.img, _$2({}, le, {
    ref: y,
    src: ne
  })) : null;
}), Zf = "AvatarFallback", Yf = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeAvatar: z, delayMs: ne, ...ue } = v, le = vi(Zf, z), [he, ge] = useState(ne === void 0);
  return useEffect(() => {
    if (ne !== void 0) {
      const we = window.setTimeout(
        () => ge(!0),
        ne
      );
      return () => window.clearTimeout(we);
    }
  }, [
    ne
  ]), he && le.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ createElement(X$2.span, _$2({}, ue, {
    ref: y
  })) : null;
});
function Xf(v) {
  const [y, z] = useState("idle");
  return ke$1(() => {
    if (!v) {
      z("error");
      return;
    }
    let ne = !0;
    const ue = new window.Image(), le = (he) => () => {
      ne && z(he);
    };
    return z("loading"), ue.onload = le("loaded"), ue.onerror = le("error"), ue.src = v, () => {
      ne = !1;
    };
  }, [
    v
  ]), y;
}
const bi = Uf, gi = Gf, hi = Yf, qf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  bi,
  {
    ref: z,
    className: Y$1(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      v
    ),
    ...y
  }
));
qf.displayName = bi.displayName;
const Jf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  gi,
  {
    ref: z,
    className: Y$1("aspect-square h-full w-full", v),
    ...y
  }
));
Jf.displayName = gi.displayName;
const Qf = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  hi,
  {
    ref: z,
    className: Y$1(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      v
    ),
    ...y
  }
));
Qf.displayName = hi.displayName;
const tp = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        "action-primary": "z-[1] bg-primary hover:bg-primary/90 relative text-primary-foreground font-bold rounded-3xl after:w-full after:h-full after:bg-primary/40 after:absolute after:top-[3px] after-left-0 after:rounded-3xl after:z-[-1] after:events-none",
        "action-destructive": "z-[1] bg-destructive hover:bg-destructive/90 relative text-primary-foreground font-bold rounded-3xl after:w-full after:h-full after:bg-destructive/40 after:absolute after:top-[3px] after-left-0 after:rounded-3xl after:z-[-1] after:events-none",
        "action-attention": "z-[1] bg-foreground hover:bg-foreground/90 relative text-background font-bold rounded-3xl after:w-full after:h-full after:bg-foreground/40 after:absolute after:top-[3px] after-left-0 after:rounded-3xl after:z-[-1] after:events-none"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        xs: "rounded-md px-2 py-1",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        "sm-icon": "h-8 w-8",
        "xs-icon": "h-5 w-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), np = a$z.forwardRef(
  ({ className: v, variant: y, size: z, asChild: ne = !1, ...ue }, le) => {
    const he = ne ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : "button";
    return /* @__PURE__ */ D$6.jsx(
      he,
      {
        className: Y$1(tp({ variant: y, size: z, className: v })),
        ref: le,
        ...ue
      }
    );
  }
);
np.displayName = "Button";
function Po(v) {
  const y = useRef({
    value: v,
    previous: v
  });
  return useMemo(() => (y.current.value !== v && (y.current.previous = y.current.value, y.current.value = v), y.current.previous), [
    v
  ]);
}
function _o(v) {
  const [y, z] = useState(void 0);
  return ke$1(() => {
    if (v) {
      z({
        width: v.offsetWidth,
        height: v.offsetHeight
      });
      const ne = new ResizeObserver((ue) => {
        if (!Array.isArray(ue) || !ue.length)
          return;
        const le = ue[0];
        let he, ge;
        if ("borderBoxSize" in le) {
          const we = le.borderBoxSize, Ee = Array.isArray(we) ? we[0] : we;
          he = Ee.inlineSize, ge = Ee.blockSize;
        } else
          he = v.offsetWidth, ge = v.offsetHeight;
        z({
          width: he,
          height: ge
        });
      });
      return ne.observe(v, {
        box: "border-box"
      }), () => ne.unobserve(v);
    } else
      z(void 0);
  }, [
    v
  ]), y;
}
const $i = "Checkbox", [op, X$] = Le($i), [rp, ap] = op($i), cp = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeCheckbox: z, name: ne, checked: ue, defaultChecked: le, required: he, disabled: ge, value: we = "on", onCheckedChange: Ee, ...xe } = v, [$e, Ne] = useState(null), st = de(
    y,
    (wa) => Ne(wa)
  ), Nr = useRef(!1), br = $e ? !!$e.closest("form") : !0, [$n = !1, En] = Be$1({
    prop: ue,
    defaultProp: le,
    onChange: Ee
  }), Rn = useRef($n);
  return useEffect(() => {
    const wa = $e == null ? void 0 : $e.form;
    if (wa) {
      const Aa = () => En(Rn.current);
      return wa.addEventListener("reset", Aa), () => wa.removeEventListener("reset", Aa);
    }
  }, [
    $e,
    En
  ]), /* @__PURE__ */ createElement(rp, {
    scope: z,
    state: $n,
    disabled: ge
  }, /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    role: "checkbox",
    "aria-checked": Ft$1($n) ? "mixed" : $n,
    "aria-required": he,
    "data-state": wi($n),
    "data-disabled": ge ? "" : void 0,
    disabled: ge,
    value: we
  }, xe, {
    ref: st,
    onKeyDown: H$2(v.onKeyDown, (wa) => {
      wa.key === "Enter" && wa.preventDefault();
    }),
    onClick: H$2(v.onClick, (wa) => {
      En(
        (Aa) => Ft$1(Aa) ? !0 : !Aa
      ), br && (Nr.current = wa.isPropagationStopped(), Nr.current || wa.stopPropagation());
    })
  })), br && /* @__PURE__ */ createElement(lp, {
    control: $e,
    bubbles: !Nr.current,
    name: ne,
    value: we,
    checked: $n,
    required: he,
    disabled: ge,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), ip = "CheckboxIndicator", sp = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeCheckbox: z, forceMount: ne, ...ue } = v, le = ap(ip, z);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || Ft$1(le.state) || le.state === !0
  }, /* @__PURE__ */ createElement(X$2.span, _$2({
    "data-state": wi(le.state),
    "data-disabled": le.disabled ? "" : void 0
  }, ue, {
    ref: y,
    style: {
      pointerEvents: "none",
      ...v.style
    }
  })));
}), lp = (v) => {
  const { control: y, checked: z, bubbles: ne = !0, ...ue } = v, le = useRef(null), he = Po(z), ge = _o(y);
  return useEffect(() => {
    const we = le.current, Ee = window.HTMLInputElement.prototype, xe = Object.getOwnPropertyDescriptor(Ee, "checked").set;
    if (he !== z && xe) {
      const $e = new Event("click", {
        bubbles: ne
      });
      we.indeterminate = Ft$1(z), xe.call(we, Ft$1(z) ? !1 : z), we.dispatchEvent($e);
    }
  }, [
    he,
    z,
    ne
  ]), /* @__PURE__ */ createElement("input", _$2({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Ft$1(z) ? !1 : z
  }, ue, {
    tabIndex: -1,
    ref: le,
    style: {
      ...v.style,
      ...ge,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Ft$1(v) {
  return v === "indeterminate";
}
function wi(v) {
  return Ft$1(v) ? "indeterminate" : v ? "checked" : "unchecked";
}
const xi = cp, up = sp, dp = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  xi,
  {
    ref: z,
    className: Y$1(
      "peer h-4 w-4 shrink-0 rounded-xs border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      v
    ),
    ...y,
    children: /* @__PURE__ */ D$6.jsx(
      up,
      {
        className: Y$1("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ D$6.jsx(So, { className: "h-[0.9rem] w-[0.9rem]", weight: "bold" })
      }
    )
  }
));
dp.displayName = xi.displayName;
var ec$1 = 1, fp = 0.9, pp = 0.8, mp = 0.17, or$1 = 0.1, rr = 0.999, vp = 0.9999, bp = 0.99, gp = /[\\\/_+.#"@\[\(\{&]/, hp = /[\\\/_+.#"@\[\(\{&]/g, $p = /[\s-]/, yi = /[\s-]/g;
function wr(v, y, z, ne, ue, le, he) {
  if (le === y.length)
    return ue === v.length ? ec$1 : bp;
  var ge = `${ue},${le}`;
  if (he[ge] !== void 0)
    return he[ge];
  for (var we = ne.charAt(le), Ee = z.indexOf(we, ue), xe = 0, $e, Ne, st, Nr; Ee >= 0; )
    $e = wr(v, y, z, ne, Ee + 1, le + 1, he), $e > xe && (Ee === ue ? $e *= ec$1 : gp.test(v.charAt(Ee - 1)) ? ($e *= pp, st = v.slice(ue, Ee - 1).match(hp), st && ue > 0 && ($e *= Math.pow(rr, st.length))) : $p.test(v.charAt(Ee - 1)) ? ($e *= fp, Nr = v.slice(ue, Ee - 1).match(yi), Nr && ue > 0 && ($e *= Math.pow(rr, Nr.length))) : ($e *= mp, ue > 0 && ($e *= Math.pow(rr, Ee - ue))), v.charAt(Ee) !== y.charAt(le) && ($e *= vp)), ($e < or$1 && z.charAt(Ee - 1) === ne.charAt(le + 1) || ne.charAt(le + 1) === ne.charAt(le) && z.charAt(Ee - 1) !== ne.charAt(le)) && (Ne = wr(v, y, z, ne, Ee + 1, le + 2, he), Ne * or$1 > $e && ($e = Ne * or$1)), $e > xe && (xe = $e), Ee = z.indexOf(we, Ee + 1);
  return he[ge] = xe, xe;
}
function tc(v) {
  return v.toLowerCase().replace(yi, " ");
}
function wp(v, y, z) {
  return v = z && z.length > 0 ? `${v + " " + z.join(" ")}` : v, wr(v, y, tc(v), tc(y), 0, 0, {});
}
function xp(v, y = globalThis == null ? void 0 : globalThis.document) {
  const z = Te$1(v);
  useEffect(() => {
    const ne = (ue) => {
      ue.key === "Escape" && z(ue);
    };
    return y.addEventListener("keydown", ne), () => y.removeEventListener("keydown", ne);
  }, [
    z,
    y
  ]);
}
const xr = "dismissableLayer.update", yp = "dismissableLayer.pointerDownOutside", Cp = "dismissableLayer.focusOutside";
let nc;
const Ep = /* @__PURE__ */ createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), jn = /* @__PURE__ */ forwardRef((v, y) => {
  var z;
  const { disableOutsidePointerEvents: ne = !1, onEscapeKeyDown: ue, onPointerDownOutside: le, onFocusOutside: he, onInteractOutside: ge, onDismiss: we, ...Ee } = v, xe = useContext(Ep), [$e, Ne] = useState(null), st = (z = $e == null ? void 0 : $e.ownerDocument) !== null && z !== void 0 ? z : globalThis == null ? void 0 : globalThis.document, [, Nr] = useState({}), br = de(
    y,
    (Ra) => Ne(Ra)
  ), $n = Array.from(xe.layers), [En] = [
    ...xe.layersWithOutsidePointerEventsDisabled
  ].slice(-1), Rn = $n.indexOf(En), wa = $e ? $n.indexOf($e) : -1, Aa = xe.layersWithOutsidePointerEventsDisabled.size > 0, _a = wa >= Rn, Ta = Sp((Ra) => {
    const Yn = Ra.target, $o = [
      ...xe.branches
    ].some(
      (ct) => ct.contains(Yn)
    );
    !_a || $o || (le == null || le(Ra), ge == null || ge(Ra), Ra.defaultPrevented || we == null || we());
  }, st), Zn = Pp((Ra) => {
    const Yn = Ra.target;
    [
      ...xe.branches
    ].some(
      ($o) => $o.contains(Yn)
    ) || (he == null || he(Ra), ge == null || ge(Ra), Ra.defaultPrevented || we == null || we());
  }, st);
  return xp((Ra) => {
    wa === xe.layers.size - 1 && (ue == null || ue(Ra), !Ra.defaultPrevented && we && (Ra.preventDefault(), we()));
  }, st), useEffect(() => {
    if ($e)
      return ne && (xe.layersWithOutsidePointerEventsDisabled.size === 0 && (nc = st.body.style.pointerEvents, st.body.style.pointerEvents = "none"), xe.layersWithOutsidePointerEventsDisabled.add($e)), xe.layers.add($e), oc(), () => {
        ne && xe.layersWithOutsidePointerEventsDisabled.size === 1 && (st.body.style.pointerEvents = nc);
      };
  }, [
    $e,
    st,
    ne,
    xe
  ]), useEffect(() => () => {
    $e && (xe.layers.delete($e), xe.layersWithOutsidePointerEventsDisabled.delete($e), oc());
  }, [
    $e,
    xe
  ]), useEffect(() => {
    const Ra = () => Nr({});
    return document.addEventListener(xr, Ra), () => document.removeEventListener(xr, Ra);
  }, []), /* @__PURE__ */ createElement(X$2.div, _$2({}, Ee, {
    ref: br,
    style: {
      pointerEvents: Aa ? _a ? "auto" : "none" : void 0,
      ...v.style
    },
    onFocusCapture: H$2(v.onFocusCapture, Zn.onFocusCapture),
    onBlurCapture: H$2(v.onBlurCapture, Zn.onBlurCapture),
    onPointerDownCapture: H$2(v.onPointerDownCapture, Ta.onPointerDownCapture)
  }));
});
function Sp(v, y = globalThis == null ? void 0 : globalThis.document) {
  const z = Te$1(v), ne = useRef(!1), ue = useRef(() => {
  });
  return useEffect(() => {
    const le = (ge) => {
      if (ge.target && !ne.current) {
        let we = function() {
          Ci(yp, z, Ee, {
            discrete: !0
          });
        };
        const Ee = {
          originalEvent: ge
        };
        ge.pointerType === "touch" ? (y.removeEventListener("click", ue.current), ue.current = we, y.addEventListener("click", ue.current, {
          once: !0
        })) : we();
      } else
        y.removeEventListener("click", ue.current);
      ne.current = !1;
    }, he = window.setTimeout(() => {
      y.addEventListener("pointerdown", le);
    }, 0);
    return () => {
      window.clearTimeout(he), y.removeEventListener("pointerdown", le), y.removeEventListener("click", ue.current);
    };
  }, [
    y,
    z
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => ne.current = !0
  };
}
function Pp(v, y = globalThis == null ? void 0 : globalThis.document) {
  const z = Te$1(v), ne = useRef(!1);
  return useEffect(() => {
    const ue = (le) => {
      le.target && !ne.current && Ci(Cp, z, {
        originalEvent: le
      }, {
        discrete: !1
      });
    };
    return y.addEventListener("focusin", ue), () => y.removeEventListener("focusin", ue);
  }, [
    y,
    z
  ]), {
    onFocusCapture: () => ne.current = !0,
    onBlurCapture: () => ne.current = !1
  };
}
function oc() {
  const v = new CustomEvent(xr);
  document.dispatchEvent(v);
}
function Ci(v, y, z, { discrete: ne }) {
  const ue = z.originalEvent.target, le = new CustomEvent(v, {
    bubbles: !1,
    cancelable: !0,
    detail: z
  });
  y && ue.addEventListener(v, y, {
    once: !0
  }), ne ? Yc(ue, le) : ue.dispatchEvent(le);
}
const ar = "focusScope.autoFocusOnMount", cr = "focusScope.autoFocusOnUnmount", rc = {
  bubbles: !1,
  cancelable: !0
}, Ro = /* @__PURE__ */ forwardRef((v, y) => {
  const { loop: z = !1, trapped: ne = !1, onMountAutoFocus: ue, onUnmountAutoFocus: le, ...he } = v, [ge, we] = useState(null), Ee = Te$1(ue), xe = Te$1(le), $e = useRef(null), Ne = de(
    y,
    (br) => we(br)
  ), st = useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  useEffect(() => {
    if (ne) {
      let br = function(wa) {
        if (st.paused || !ge)
          return;
        const Aa = wa.target;
        ge.contains(Aa) ? $e.current = Aa : wt$1($e.current, {
          select: !0
        });
      }, $n = function(wa) {
        if (st.paused || !ge)
          return;
        const Aa = wa.relatedTarget;
        Aa !== null && (ge.contains(Aa) || wt$1($e.current, {
          select: !0
        }));
      }, En = function(wa) {
        if (document.activeElement === document.body)
          for (const Aa of wa)
            Aa.removedNodes.length > 0 && wt$1(ge);
      };
      document.addEventListener("focusin", br), document.addEventListener("focusout", $n);
      const Rn = new MutationObserver(En);
      return ge && Rn.observe(ge, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", br), document.removeEventListener("focusout", $n), Rn.disconnect();
      };
    }
  }, [
    ne,
    ge,
    st.paused
  ]), useEffect(() => {
    if (ge) {
      cc.add(st);
      const br = document.activeElement;
      if (!ge.contains(br)) {
        const $n = new CustomEvent(ar, rc);
        ge.addEventListener(ar, Ee), ge.dispatchEvent($n), $n.defaultPrevented || (_p(Dp(Ei(ge)), {
          select: !0
        }), document.activeElement === br && wt$1(ge));
      }
      return () => {
        ge.removeEventListener(ar, Ee), setTimeout(() => {
          const $n = new CustomEvent(cr, rc);
          ge.addEventListener(cr, xe), ge.dispatchEvent($n), $n.defaultPrevented || wt$1(br ?? document.body, {
            select: !0
          }), ge.removeEventListener(cr, xe), cc.remove(st);
        }, 0);
      };
    }
  }, [
    ge,
    Ee,
    xe,
    st
  ]);
  const Nr = useCallback((br) => {
    if (!z && !ne || st.paused)
      return;
    const $n = br.key === "Tab" && !br.altKey && !br.ctrlKey && !br.metaKey, En = document.activeElement;
    if ($n && En) {
      const Rn = br.currentTarget, [wa, Aa] = Rp(Rn);
      wa && Aa ? !br.shiftKey && En === Aa ? (br.preventDefault(), z && wt$1(wa, {
        select: !0
      })) : br.shiftKey && En === wa && (br.preventDefault(), z && wt$1(Aa, {
        select: !0
      })) : En === Rn && br.preventDefault();
    }
  }, [
    z,
    ne,
    st.paused
  ]);
  return /* @__PURE__ */ createElement(X$2.div, _$2({
    tabIndex: -1
  }, he, {
    ref: Ne,
    onKeyDown: Nr
  }));
});
function _p(v, { select: y = !1 } = {}) {
  const z = document.activeElement;
  for (const ne of v)
    if (wt$1(ne, {
      select: y
    }), document.activeElement !== z)
      return;
}
function Rp(v) {
  const y = Ei(v), z = ac(y, v), ne = ac(y.reverse(), v);
  return [
    z,
    ne
  ];
}
function Ei(v) {
  const y = [], z = document.createTreeWalker(v, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (ne) => {
      const ue = ne.tagName === "INPUT" && ne.type === "hidden";
      return ne.disabled || ne.hidden || ue ? NodeFilter.FILTER_SKIP : ne.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; z.nextNode(); )
    y.push(z.currentNode);
  return y;
}
function ac(v, y) {
  for (const z of v)
    if (!Ap(z, {
      upTo: y
    }))
      return z;
}
function Ap(v, { upTo: y }) {
  if (getComputedStyle(v).visibility === "hidden")
    return !0;
  for (; v; ) {
    if (y !== void 0 && v === y)
      return !1;
    if (getComputedStyle(v).display === "none")
      return !0;
    v = v.parentElement;
  }
  return !1;
}
function Tp(v) {
  return v instanceof HTMLInputElement && "select" in v;
}
function wt$1(v, { select: y = !1 } = {}) {
  if (v && v.focus) {
    const z = document.activeElement;
    v.focus({
      preventScroll: !0
    }), v !== z && Tp(v) && y && v.select();
  }
}
const cc = Op$1();
function Op$1() {
  let v = [];
  return {
    add(y) {
      const z = v[0];
      y !== z && (z == null || z.pause()), v = ic(v, y), v.unshift(y);
    },
    remove(y) {
      var z;
      v = ic(v, y), (z = v[0]) === null || z === void 0 || z.resume();
    }
  };
}
function ic(v, y) {
  const z = [
    ...v
  ], ne = z.indexOf(y);
  return ne !== -1 && z.splice(ne, 1), z;
}
function Dp(v) {
  return v.filter(
    (y) => y.tagName !== "A"
  );
}
const Ao = /* @__PURE__ */ forwardRef((v, y) => {
  var z;
  const { container: ne = globalThis == null || (z = globalThis.document) === null || z === void 0 ? void 0 : z.body, ...ue } = v;
  return ne ? /* @__PURE__ */ Nu__default.createPortal(/* @__PURE__ */ createElement(X$2.div, _$2({}, ue, {
    ref: y
  })), ne) : null;
});
let ir = 0;
function To() {
  useEffect(() => {
    var v, y;
    const z = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (v = z[0]) !== null && v !== void 0 ? v : sc()), document.body.insertAdjacentElement("beforeend", (y = z[1]) !== null && y !== void 0 ? y : sc()), ir++, () => {
      ir === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (ne) => ne.remove()
      ), ir--;
    };
  }, []);
}
function sc() {
  const v = document.createElement("span");
  return v.setAttribute("data-radix-focus-guard", ""), v.tabIndex = 0, v.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", v;
}
var rt$1 = function() {
  return rt$1 = Object.assign || function(v) {
    for (var y, z = 1, ne = arguments.length; z < ne; z++) {
      y = arguments[z];
      for (var ue in y)
        Object.prototype.hasOwnProperty.call(y, ue) && (v[ue] = y[ue]);
    }
    return v;
  }, rt$1.apply(this, arguments);
};
function Si(v, y) {
  var z = {};
  for (var ne in v)
    Object.prototype.hasOwnProperty.call(v, ne) && y.indexOf(ne) < 0 && (z[ne] = v[ne]);
  if (v != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ue = 0, ne = Object.getOwnPropertySymbols(v); ue < ne.length; ue++)
      y.indexOf(ne[ue]) < 0 && Object.prototype.propertyIsEnumerable.call(v, ne[ue]) && (z[ne[ue]] = v[ne[ue]]);
  return z;
}
function Mp(v, y, z) {
  if (z || arguments.length === 2)
    for (var ne = 0, ue = y.length, le; ne < ue; ne++)
      (le || !(ne in y)) && (le || (le = Array.prototype.slice.call(y, 0, ne)), le[ne] = y[ne]);
  return v.concat(le || Array.prototype.slice.call(y));
}
var so = "right-scroll-bar-position", lo = "width-before-scroll-bar", Ip = "with-scroll-bars-hidden", Np = "--removed-body-scroll-bar-size";
function sr(v, y) {
  return typeof v == "function" ? v(y) : v && (v.current = y), v;
}
function kp(v, y) {
  var z = useState(function() {
    return {
      // value
      value: v,
      // last callback
      callback: y,
      // "memoized" public interface
      facade: {
        get current() {
          return z.value;
        },
        set current(ne) {
          var ue = z.value;
          ue !== ne && (z.value = ne, z.callback(ne, ue));
        }
      }
    };
  })[0];
  return z.callback = y, z.facade;
}
var Lp = typeof window < "u" ? a$z.useLayoutEffect : a$z.useEffect, lc = /* @__PURE__ */ new WeakMap();
function Fp(v, y) {
  var z = kp(y || null, function(ne) {
    return v.forEach(function(ue) {
      return sr(ue, ne);
    });
  });
  return Lp(function() {
    var ne = lc.get(z);
    if (ne) {
      var ue = new Set(ne), le = new Set(v), he = z.current;
      ue.forEach(function(ge) {
        le.has(ge) || sr(ge, null);
      }), le.forEach(function(ge) {
        ue.has(ge) || sr(ge, he);
      });
    }
    lc.set(z, v);
  }, [v]), z;
}
function zp(v) {
  return v;
}
function jp(v, y) {
  y === void 0 && (y = zp);
  var z = [], ne = !1, ue = {
    read: function() {
      if (ne)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return z.length ? z[z.length - 1] : v;
    },
    useMedium: function(le) {
      var he = y(le, ne);
      return z.push(he), function() {
        z = z.filter(function(ge) {
          return ge !== he;
        });
      };
    },
    assignSyncMedium: function(le) {
      for (ne = !0; z.length; ) {
        var he = z;
        z = [], he.forEach(le);
      }
      z = {
        push: function(ge) {
          return le(ge);
        },
        filter: function() {
          return z;
        }
      };
    },
    assignMedium: function(le) {
      ne = !0;
      var he = [];
      if (z.length) {
        var ge = z;
        z = [], ge.forEach(le), he = z;
      }
      var we = function() {
        var xe = he;
        he = [], xe.forEach(le);
      }, Ee = function() {
        return Promise.resolve().then(we);
      };
      Ee(), z = {
        push: function(xe) {
          he.push(xe), Ee();
        },
        filter: function(xe) {
          return he = he.filter(xe), z;
        }
      };
    }
  };
  return ue;
}
function Hp(v) {
  v === void 0 && (v = {});
  var y = jp(null);
  return y.options = rt$1({ async: !0, ssr: !1 }, v), y;
}
var Pi$1 = function(v) {
  var y = v.sideCar, z = Si(v, ["sideCar"]);
  if (!y)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var ne = y.read();
  if (!ne)
    throw new Error("Sidecar medium not found");
  return a$z.createElement(ne, rt$1({}, z));
};
Pi$1.isSideCarExport = !0;
function Vp(v, y) {
  return v.useMedium(y), Pi$1;
}
var _i = Hp(), lr = function() {
}, Oo = a$z.forwardRef(function(v, y) {
  var z = a$z.useRef(null), ne = a$z.useState({
    onScrollCapture: lr,
    onWheelCapture: lr,
    onTouchMoveCapture: lr
  }), ue = ne[0], le = ne[1], he = v.forwardProps, ge = v.children, we = v.className, Ee = v.removeScrollBar, xe = v.enabled, $e = v.shards, Ne = v.sideCar, st = v.noIsolation, Nr = v.inert, br = v.allowPinchZoom, $n = v.as, En = $n === void 0 ? "div" : $n, Rn = Si(v, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), wa = Ne, Aa = Fp([z, y]), _a = rt$1(rt$1({}, Rn), ue);
  return a$z.createElement(
    a$z.Fragment,
    null,
    xe && a$z.createElement(wa, { sideCar: _i, removeScrollBar: Ee, shards: $e, noIsolation: st, inert: Nr, setCallbacks: le, allowPinchZoom: !!br, lockRef: z }),
    he ? a$z.cloneElement(a$z.Children.only(ge), rt$1(rt$1({}, _a), { ref: Aa })) : a$z.createElement(En, rt$1({}, _a, { className: we, ref: Aa }), ge)
  );
});
Oo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Oo.classNames = {
  fullWidth: lo,
  zeroRight: so
};
var Bp = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Wp() {
  if (!document)
    return null;
  var v = document.createElement("style");
  v.type = "text/css";
  var y = Bp();
  return y && v.setAttribute("nonce", y), v;
}
function Up(v, y) {
  v.styleSheet ? v.styleSheet.cssText = y : v.appendChild(document.createTextNode(y));
}
function Kp(v) {
  var y = document.head || document.getElementsByTagName("head")[0];
  y.appendChild(v);
}
var Gp = function() {
  var v = 0, y = null;
  return {
    add: function(z) {
      v == 0 && (y = Wp()) && (Up(y, z), Kp(y)), v++;
    },
    remove: function() {
      v--, !v && y && (y.parentNode && y.parentNode.removeChild(y), y = null);
    }
  };
}, Zp = function() {
  var v = Gp();
  return function(y, z) {
    a$z.useEffect(function() {
      return v.add(y), function() {
        v.remove();
      };
    }, [y && z]);
  };
}, Ri = function() {
  var v = Zp(), y = function(z) {
    var ne = z.styles, ue = z.dynamic;
    return v(ne, ue), null;
  };
  return y;
}, Yp = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ur = function(v) {
  return parseInt(v || "", 10) || 0;
}, Xp = function(v) {
  var y = window.getComputedStyle(document.body), z = y[v === "padding" ? "paddingLeft" : "marginLeft"], ne = y[v === "padding" ? "paddingTop" : "marginTop"], ue = y[v === "padding" ? "paddingRight" : "marginRight"];
  return [ur(z), ur(ne), ur(ue)];
}, qp = function(v) {
  if (v === void 0 && (v = "margin"), typeof window > "u")
    return Yp;
  var y = Xp(v), z = document.documentElement.clientWidth, ne = window.innerWidth;
  return {
    left: y[0],
    top: y[1],
    right: y[2],
    gap: Math.max(0, ne - z + y[2] - y[0])
  };
}, Jp = Ri(), cn$1 = "data-scroll-locked", Qp = function(v, y, z, ne) {
  var ue = v.left, le = v.top, he = v.right, ge = v.gap;
  return z === void 0 && (z = "margin"), `
  .`.concat(Ip, ` {
   overflow: hidden `).concat(ne, `;
   padding-right: `).concat(ge, "px ").concat(ne, `;
  }
  body[`).concat(cn$1, `] {
    overflow: hidden `).concat(ne, `;
    overscroll-behavior: contain;
    `).concat([
    y && "position: relative ".concat(ne, ";"),
    z === "margin" && `
    padding-left: `.concat(ue, `px;
    padding-top: `).concat(le, `px;
    padding-right: `).concat(he, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(ge, "px ").concat(ne, `;
    `),
    z === "padding" && "padding-right: ".concat(ge, "px ").concat(ne, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(so, ` {
    right: `).concat(ge, "px ").concat(ne, `;
  }
  
  .`).concat(lo, ` {
    margin-right: `).concat(ge, "px ").concat(ne, `;
  }
  
  .`).concat(so, " .").concat(so, ` {
    right: 0 `).concat(ne, `;
  }
  
  .`).concat(lo, " .").concat(lo, ` {
    margin-right: 0 `).concat(ne, `;
  }
  
  body[`).concat(cn$1, `] {
    `).concat(Np, ": ").concat(ge, `px;
  }
`);
}, uc = function() {
  var v = parseInt(document.body.getAttribute(cn$1) || "0", 10);
  return isFinite(v) ? v : 0;
}, e0 = function() {
  a$z.useEffect(function() {
    return document.body.setAttribute(cn$1, (uc() + 1).toString()), function() {
      var v = uc() - 1;
      v <= 0 ? document.body.removeAttribute(cn$1) : document.body.setAttribute(cn$1, v.toString());
    };
  }, []);
}, t0 = function(v) {
  var y = v.noRelative, z = v.noImportant, ne = v.gapMode, ue = ne === void 0 ? "margin" : ne;
  e0();
  var le = a$z.useMemo(function() {
    return qp(ue);
  }, [ue]);
  return a$z.createElement(Jp, { styles: Qp(le, !y, ue, z ? "" : "!important") });
}, yr = !1;
if (typeof window < "u")
  try {
    var qn$1 = Object.defineProperty({}, "passive", {
      get: function() {
        return yr = !0, !0;
      }
    });
    window.addEventListener("test", qn$1, qn$1), window.removeEventListener("test", qn$1, qn$1);
  } catch {
    yr = !1;
  }
var Jt$1 = yr ? { passive: !1 } : !1, n0 = function(v) {
  return v.tagName === "TEXTAREA";
}, Ai = function(v, y) {
  var z = window.getComputedStyle(v);
  return (
    // not-not-scrollable
    z[y] !== "hidden" && // contains scroll inside self
    !(z.overflowY === z.overflowX && !n0(v) && z[y] === "visible")
  );
}, o0$1 = function(v) {
  return Ai(v, "overflowY");
}, r0 = function(v) {
  return Ai(v, "overflowX");
}, dc = function(v, y) {
  var z = y;
  do {
    typeof ShadowRoot < "u" && z instanceof ShadowRoot && (z = z.host);
    var ne = Ti(v, z);
    if (ne) {
      var ue = Oi(v, z), le = ue[1], he = ue[2];
      if (le > he)
        return !0;
    }
    z = z.parentNode;
  } while (z && z !== document.body);
  return !1;
}, a0 = function(v) {
  var y = v.scrollTop, z = v.scrollHeight, ne = v.clientHeight;
  return [
    y,
    z,
    ne
  ];
}, c0$1 = function(v) {
  var y = v.scrollLeft, z = v.scrollWidth, ne = v.clientWidth;
  return [
    y,
    z,
    ne
  ];
}, Ti = function(v, y) {
  return v === "v" ? o0$1(y) : r0(y);
}, Oi = function(v, y) {
  return v === "v" ? a0(y) : c0$1(y);
}, i0$1 = function(v, y) {
  return v === "h" && y === "rtl" ? -1 : 1;
}, s0$1 = function(v, y, z, ne, ue) {
  var le = i0$1(v, window.getComputedStyle(y).direction), he = le * ne, ge = z.target, we = y.contains(ge), Ee = !1, xe = he > 0, $e = 0, Ne = 0;
  do {
    var st = Oi(v, ge), Nr = st[0], br = st[1], $n = st[2], En = br - $n - le * Nr;
    (Nr || En) && Ti(v, ge) && ($e += En, Ne += Nr), ge = ge.parentNode;
  } while (
    // portaled content
    !we && ge !== document.body || // self content
    we && (y.contains(ge) || y === ge)
  );
  return (xe && (ue && $e === 0 || !ue && he > $e) || !xe && (ue && Ne === 0 || !ue && -he > Ne)) && (Ee = !0), Ee;
}, Jn$1 = function(v) {
  return "changedTouches" in v ? [v.changedTouches[0].clientX, v.changedTouches[0].clientY] : [0, 0];
}, fc = function(v) {
  return [v.deltaX, v.deltaY];
}, pc = function(v) {
  return v && "current" in v ? v.current : v;
}, l0$1 = function(v, y) {
  return v[0] === y[0] && v[1] === y[1];
}, u0$1 = function(v) {
  return `
  .block-interactivity-`.concat(v, ` {pointer-events: none;}
  .allow-interactivity-`).concat(v, ` {pointer-events: all;}
`);
}, d0$1 = 0, Qt$1 = [];
function f0$1(v) {
  var y = a$z.useRef([]), z = a$z.useRef([0, 0]), ne = a$z.useRef(), ue = a$z.useState(d0$1++)[0], le = a$z.useState(function() {
    return Ri();
  })[0], he = a$z.useRef(v);
  a$z.useEffect(function() {
    he.current = v;
  }, [v]), a$z.useEffect(function() {
    if (v.inert) {
      document.body.classList.add("block-interactivity-".concat(ue));
      var br = Mp([v.lockRef.current], (v.shards || []).map(pc), !0).filter(Boolean);
      return br.forEach(function($n) {
        return $n.classList.add("allow-interactivity-".concat(ue));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(ue)), br.forEach(function($n) {
          return $n.classList.remove("allow-interactivity-".concat(ue));
        });
      };
    }
  }, [v.inert, v.lockRef.current, v.shards]);
  var ge = a$z.useCallback(function(br, $n) {
    if ("touches" in br && br.touches.length === 2)
      return !he.current.allowPinchZoom;
    var En = Jn$1(br), Rn = z.current, wa = "deltaX" in br ? br.deltaX : Rn[0] - En[0], Aa = "deltaY" in br ? br.deltaY : Rn[1] - En[1], _a, Ta = br.target, Zn = Math.abs(wa) > Math.abs(Aa) ? "h" : "v";
    if ("touches" in br && Zn === "h" && Ta.type === "range")
      return !1;
    var Ra = dc(Zn, Ta);
    if (!Ra)
      return !0;
    if (Ra ? _a = Zn : (_a = Zn === "v" ? "h" : "v", Ra = dc(Zn, Ta)), !Ra)
      return !1;
    if (!ne.current && "changedTouches" in br && (wa || Aa) && (ne.current = _a), !_a)
      return !0;
    var Yn = ne.current || _a;
    return s0$1(Yn, $n, br, Yn === "h" ? wa : Aa, !0);
  }, []), we = a$z.useCallback(function(br) {
    var $n = br;
    if (!(!Qt$1.length || Qt$1[Qt$1.length - 1] !== le)) {
      var En = "deltaY" in $n ? fc($n) : Jn$1($n), Rn = y.current.filter(function(_a) {
        return _a.name === $n.type && _a.target === $n.target && l0$1(_a.delta, En);
      })[0];
      if (Rn && Rn.should) {
        $n.cancelable && $n.preventDefault();
        return;
      }
      if (!Rn) {
        var wa = (he.current.shards || []).map(pc).filter(Boolean).filter(function(_a) {
          return _a.contains($n.target);
        }), Aa = wa.length > 0 ? ge($n, wa[0]) : !he.current.noIsolation;
        Aa && $n.cancelable && $n.preventDefault();
      }
    }
  }, []), Ee = a$z.useCallback(function(br, $n, En, Rn) {
    var wa = { name: br, delta: $n, target: En, should: Rn };
    y.current.push(wa), setTimeout(function() {
      y.current = y.current.filter(function(Aa) {
        return Aa !== wa;
      });
    }, 1);
  }, []), xe = a$z.useCallback(function(br) {
    z.current = Jn$1(br), ne.current = void 0;
  }, []), $e = a$z.useCallback(function(br) {
    Ee(br.type, fc(br), br.target, ge(br, v.lockRef.current));
  }, []), Ne = a$z.useCallback(function(br) {
    Ee(br.type, Jn$1(br), br.target, ge(br, v.lockRef.current));
  }, []);
  a$z.useEffect(function() {
    return Qt$1.push(le), v.setCallbacks({
      onScrollCapture: $e,
      onWheelCapture: $e,
      onTouchMoveCapture: Ne
    }), document.addEventListener("wheel", we, Jt$1), document.addEventListener("touchmove", we, Jt$1), document.addEventListener("touchstart", xe, Jt$1), function() {
      Qt$1 = Qt$1.filter(function(br) {
        return br !== le;
      }), document.removeEventListener("wheel", we, Jt$1), document.removeEventListener("touchmove", we, Jt$1), document.removeEventListener("touchstart", xe, Jt$1);
    };
  }, []);
  var st = v.removeScrollBar, Nr = v.inert;
  return a$z.createElement(
    a$z.Fragment,
    null,
    Nr ? a$z.createElement(le, { styles: u0$1(ue) }) : null,
    st ? a$z.createElement(t0, { gapMode: "margin" }) : null
  );
}
const p0$1 = Vp(_i, f0$1);
var Di = a$z.forwardRef(function(v, y) {
  return a$z.createElement(Oo, rt$1({}, v, { ref: y, sideCar: p0$1 }));
});
Di.classNames = Oo.classNames;
const Do = Di;
var m0$1 = function(v) {
  if (typeof document > "u")
    return null;
  var y = Array.isArray(v) ? v[0] : v;
  return y.ownerDocument.body;
}, en$1 = /* @__PURE__ */ new WeakMap(), Qn$1 = /* @__PURE__ */ new WeakMap(), eo = {}, dr = 0, Mi = function(v) {
  return v && (v.host || Mi(v.parentNode));
}, v0$1 = function(v, y) {
  return y.map(function(z) {
    if (v.contains(z))
      return z;
    var ne = Mi(z);
    return ne && v.contains(ne) ? ne : (console.error("aria-hidden", z, "in not contained inside", v, ". Doing nothing"), null);
  }).filter(function(z) {
    return !!z;
  });
}, b0 = function(v, y, z, ne) {
  var ue = v0$1(y, Array.isArray(v) ? v : [v]);
  eo[z] || (eo[z] = /* @__PURE__ */ new WeakMap());
  var le = eo[z], he = [], ge = /* @__PURE__ */ new Set(), we = new Set(ue), Ee = function($e) {
    !$e || ge.has($e) || (ge.add($e), Ee($e.parentNode));
  };
  ue.forEach(Ee);
  var xe = function($e) {
    !$e || we.has($e) || Array.prototype.forEach.call($e.children, function(Ne) {
      if (ge.has(Ne))
        xe(Ne);
      else
        try {
          var st = Ne.getAttribute(ne), Nr = st !== null && st !== "false", br = (en$1.get(Ne) || 0) + 1, $n = (le.get(Ne) || 0) + 1;
          en$1.set(Ne, br), le.set(Ne, $n), he.push(Ne), br === 1 && Nr && Qn$1.set(Ne, !0), $n === 1 && Ne.setAttribute(z, "true"), Nr || Ne.setAttribute(ne, "true");
        } catch (En) {
          console.error("aria-hidden: cannot operate on ", Ne, En);
        }
    });
  };
  return xe(y), ge.clear(), dr++, function() {
    he.forEach(function($e) {
      var Ne = en$1.get($e) - 1, st = le.get($e) - 1;
      en$1.set($e, Ne), le.set($e, st), Ne || (Qn$1.has($e) || $e.removeAttribute(ne), Qn$1.delete($e)), st || $e.removeAttribute(z);
    }), dr--, dr || (en$1 = /* @__PURE__ */ new WeakMap(), en$1 = /* @__PURE__ */ new WeakMap(), Qn$1 = /* @__PURE__ */ new WeakMap(), eo = {});
  };
}, Mo = function(v, y, z) {
  z === void 0 && (z = "data-aria-hidden");
  var ne = Array.from(Array.isArray(v) ? v : [v]), ue = y || m0$1(v);
  return ue ? (ne.push.apply(ne, Array.from(ue.querySelectorAll("[aria-live]"))), b0(ne, ue, z, "aria-hidden")) : function() {
    return null;
  };
};
const Ii = "Dialog", [Ni, q$] = Le(Ii), [g0, nt] = Ni(Ii), h0$1 = (v) => {
  const { __scopeDialog: y, children: z, open: ne, defaultOpen: ue, onOpenChange: le, modal: he = !0 } = v, ge = useRef(null), we = useRef(null), [Ee = !1, xe] = Be$1({
    prop: ne,
    defaultProp: ue,
    onChange: le
  });
  return /* @__PURE__ */ createElement(g0, {
    scope: y,
    triggerRef: ge,
    contentRef: we,
    contentId: je$1(),
    titleId: je$1(),
    descriptionId: je$1(),
    open: Ee,
    onOpenChange: xe,
    onOpenToggle: useCallback(
      () => xe(
        ($e) => !$e
      ),
      [
        xe
      ]
    ),
    modal: he
  }, z);
}, $0$1 = "DialogTrigger", w0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, ...ne } = v, ue = nt($0$1, z), le = de(y, ue.triggerRef);
  return /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": ue.open,
    "aria-controls": ue.contentId,
    "data-state": Ur(ue.open)
  }, ne, {
    ref: le,
    onClick: H$2(v.onClick, ue.onOpenToggle)
  }));
}), ki = "DialogPortal", [x0, Li] = Ni(ki, {
  forceMount: void 0
}), y0$1 = (v) => {
  const { __scopeDialog: y, forceMount: z, children: ne, container: ue } = v, le = nt(ki, y);
  return /* @__PURE__ */ createElement(x0, {
    scope: y,
    forceMount: z
  }, Children.map(
    ne,
    (he) => /* @__PURE__ */ createElement(Ie, {
      present: z || le.open
    }, /* @__PURE__ */ createElement(Ao, {
      asChild: !0,
      container: ue
    }, he))
  ));
}, Cr = "DialogOverlay", C0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Li(Cr, v.__scopeDialog), { forceMount: ne = z.forceMount, ...ue } = v, le = nt(Cr, v.__scopeDialog);
  return le.modal ? /* @__PURE__ */ createElement(Ie, {
    present: ne || le.open
  }, /* @__PURE__ */ createElement(E0$1, _$2({}, ue, {
    ref: y
  }))) : null;
}), E0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, ...ne } = v, ue = nt(Cr, z);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ createElement(Do, {
      as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
      allowPinchZoom: !0,
      shards: [
        ue.contentRef
      ]
    }, /* @__PURE__ */ createElement(X$2.div, _$2({
      "data-state": Ur(ue.open)
    }, ne, {
      ref: y,
      style: {
        pointerEvents: "auto",
        ...ne.style
      }
    })))
  );
}), An = "DialogContent", S0 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Li(An, v.__scopeDialog), { forceMount: ne = z.forceMount, ...ue } = v, le = nt(An, v.__scopeDialog);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || le.open
  }, le.modal ? /* @__PURE__ */ createElement(P0$1, _$2({}, ue, {
    ref: y
  })) : /* @__PURE__ */ createElement(_0$1, _$2({}, ue, {
    ref: y
  })));
}), P0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = nt(An, v.__scopeDialog), ne = useRef(null), ue = de(y, z.contentRef, ne);
  return useEffect(() => {
    const le = ne.current;
    if (le)
      return Mo(le);
  }, []), /* @__PURE__ */ createElement(Fi, _$2({}, v, {
    ref: ue,
    trapFocus: z.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: H$2(v.onCloseAutoFocus, (le) => {
      var he;
      le.preventDefault(), (he = z.triggerRef.current) === null || he === void 0 || he.focus();
    }),
    onPointerDownOutside: H$2(v.onPointerDownOutside, (le) => {
      const he = le.detail.originalEvent, ge = he.button === 0 && he.ctrlKey === !0;
      (he.button === 2 || ge) && le.preventDefault();
    }),
    onFocusOutside: H$2(
      v.onFocusOutside,
      (le) => le.preventDefault()
    )
  }));
}), _0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = nt(An, v.__scopeDialog), ne = useRef(!1), ue = useRef(!1);
  return /* @__PURE__ */ createElement(Fi, _$2({}, v, {
    ref: y,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (le) => {
      var he;
      if ((he = v.onCloseAutoFocus) === null || he === void 0 || he.call(v, le), !le.defaultPrevented) {
        var ge;
        ne.current || (ge = z.triggerRef.current) === null || ge === void 0 || ge.focus(), le.preventDefault();
      }
      ne.current = !1, ue.current = !1;
    },
    onInteractOutside: (le) => {
      var he, ge;
      (he = v.onInteractOutside) === null || he === void 0 || he.call(v, le), le.defaultPrevented || (ne.current = !0, le.detail.originalEvent.type === "pointerdown" && (ue.current = !0));
      const we = le.target;
      !((ge = z.triggerRef.current) === null || ge === void 0) && ge.contains(we) && le.preventDefault(), le.detail.originalEvent.type === "focusin" && ue.current && le.preventDefault();
    }
  }));
}), Fi = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, trapFocus: ne, onOpenAutoFocus: ue, onCloseAutoFocus: le, ...he } = v, ge = nt(An, z), we = useRef(null), Ee = de(y, we);
  return To(), /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement(Ro, {
    asChild: !0,
    loop: !0,
    trapped: ne,
    onMountAutoFocus: ue,
    onUnmountAutoFocus: le
  }, /* @__PURE__ */ createElement(jn, _$2({
    role: "dialog",
    id: ge.contentId,
    "aria-describedby": ge.descriptionId,
    "aria-labelledby": ge.titleId,
    "data-state": Ur(ge.open)
  }, he, {
    ref: Ee,
    onDismiss: () => ge.onOpenChange(!1)
  }))), !1);
}), R0$1 = "DialogTitle", A0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, ...ne } = v, ue = nt(R0$1, z);
  return /* @__PURE__ */ createElement(X$2.h2, _$2({
    id: ue.titleId
  }, ne, {
    ref: y
  }));
}), T0$1 = "DialogDescription", O0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, ...ne } = v, ue = nt(T0$1, z);
  return /* @__PURE__ */ createElement(X$2.p, _$2({
    id: ue.descriptionId
  }, ne, {
    ref: y
  }));
}), D0$1 = "DialogClose", M0$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDialog: z, ...ne } = v, ue = nt(D0$1, z);
  return /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button"
  }, ne, {
    ref: y,
    onClick: H$2(
      v.onClick,
      () => ue.onOpenChange(!1)
    )
  }));
});
function Ur(v) {
  return v ? "open" : "closed";
}
const Kr$1 = h0$1, zi = w0$1, Gr = y0$1, Io = C0$1, Hn$1 = S0, Zr = A0$1, Yr = O0$1, Xr = M0$1;
var yn$1 = '[cmdk-group=""]', fr = '[cmdk-group-items=""]', I0$1 = '[cmdk-group-heading=""]', qr = '[cmdk-item=""]', mc = `${qr}:not([aria-disabled="true"])`, Er = "cmdk-item-select", kt$1 = "data-value", N0$1 = (v, y, z) => wp(v, y, z), ji = a$z.createContext(void 0), Vn$1 = () => a$z.useContext(ji), Hi = a$z.createContext(void 0), Jr = () => a$z.useContext(Hi), Vi = a$z.createContext(void 0), Bi = a$z.forwardRef((v, y) => {
  let z = on$1(() => {
    var xa, wo;
    return { search: "", value: (wo = (xa = v.value) != null ? xa : v.defaultValue) != null ? wo : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), ne = on$1(() => /* @__PURE__ */ new Set()), ue = on$1(() => /* @__PURE__ */ new Map()), le = on$1(() => /* @__PURE__ */ new Map()), he = on$1(() => /* @__PURE__ */ new Set()), ge = Wi(v), { label: we, children: Ee, value: xe, onValueChange: $e, filter: Ne, shouldFilter: st, loop: Nr, disablePointerSelection: br = !1, vimBindings: $n = !0, ...En } = v, Rn = a$z.useId(), wa = a$z.useId(), Aa = a$z.useId(), _a = a$z.useRef(null), Ta = K0$1();
  Vt$1(() => {
    if (xe !== void 0) {
      let xa = xe.trim();
      z.current.value = xa, Zn.emit();
    }
  }, [xe]), Vt$1(() => {
    Ta(6, be);
  }, []);
  let Zn = a$z.useMemo(() => ({ subscribe: (xa) => (he.current.add(xa), () => he.current.delete(xa)), snapshot: () => z.current, setState: (xa, wo, _u) => {
    var Oa, Os, Pa;
    if (!Object.is(z.current[xa], wo)) {
      if (z.current[xa] = wo, xa === "search")
        fe(), $o(), Ta(1, ct);
      else if (xa === "value" && (_u || Ta(5, be), ((Oa = ge.current) == null ? void 0 : Oa.value) !== void 0)) {
        let Ml = wo ?? "";
        (Pa = (Os = ge.current).onValueChange) == null || Pa.call(Os, Ml);
        return;
      }
      Zn.emit();
    }
  }, emit: () => {
    he.current.forEach((xa) => xa());
  } }), []), Ra = a$z.useMemo(() => ({ value: (xa, wo, _u) => {
    var Oa;
    wo !== ((Oa = le.current.get(xa)) == null ? void 0 : Oa.value) && (le.current.set(xa, { value: wo, keywords: _u }), z.current.filtered.items.set(xa, Yn(wo, _u)), Ta(2, () => {
      $o(), Zn.emit();
    }));
  }, item: (xa, wo) => (ne.current.add(xa), wo && (ue.current.has(wo) ? ue.current.get(wo).add(xa) : ue.current.set(wo, /* @__PURE__ */ new Set([xa]))), Ta(3, () => {
    fe(), $o(), z.current.value || ct(), Zn.emit();
  }), () => {
    le.current.delete(xa), ne.current.delete(xa), z.current.filtered.items.delete(xa);
    let _u = ye();
    Ta(4, () => {
      fe(), (_u == null ? void 0 : _u.getAttribute("id")) === xa && ct(), Zn.emit();
    });
  }), group: (xa) => (ue.current.has(xa) || ue.current.set(xa, /* @__PURE__ */ new Set()), () => {
    le.current.delete(xa), ue.current.delete(xa);
  }), filter: () => ge.current.shouldFilter, label: we || v["aria-label"], disablePointerSelection: br, listId: Rn, inputId: Aa, labelId: wa, listInnerRef: _a }), []);
  function Yn(xa, wo) {
    var _u, Oa;
    let Os = (Oa = (_u = ge.current) == null ? void 0 : _u.filter) != null ? Oa : N0$1;
    return xa ? Os(xa, z.current.search, wo) : 0;
  }
  function $o() {
    if (!z.current.search || ge.current.shouldFilter === !1)
      return;
    let xa = z.current.filtered.items, wo = [];
    z.current.filtered.groups.forEach((Oa) => {
      let Os = ue.current.get(Oa), Pa = 0;
      Os.forEach((Ml) => {
        let Su = xa.get(Ml);
        Pa = Math.max(Su, Pa);
      }), wo.push([Oa, Pa]);
    });
    let _u = _a.current;
    Se().sort((Oa, Os) => {
      var Pa, Ml;
      let Su = Oa.getAttribute("id"), Tu = Os.getAttribute("id");
      return ((Pa = xa.get(Tu)) != null ? Pa : 0) - ((Ml = xa.get(Su)) != null ? Ml : 0);
    }).forEach((Oa) => {
      let Os = Oa.closest(fr);
      Os ? Os.appendChild(Oa.parentElement === Os ? Oa : Oa.closest(`${fr} > *`)) : _u.appendChild(Oa.parentElement === _u ? Oa : Oa.closest(`${fr} > *`));
    }), wo.sort((Oa, Os) => Os[1] - Oa[1]).forEach((Oa) => {
      let Os = _a.current.querySelector(`${yn$1}[${kt$1}="${encodeURIComponent(Oa[0])}"]`);
      Os == null || Os.parentElement.appendChild(Os);
    });
  }
  function ct() {
    let xa = Se().find((_u) => _u.getAttribute("aria-disabled") !== "true"), wo = xa == null ? void 0 : xa.getAttribute(kt$1);
    Zn.setState("value", wo || void 0);
  }
  function fe() {
    var xa, wo, _u, Oa;
    if (!z.current.search || ge.current.shouldFilter === !1) {
      z.current.filtered.count = ne.current.size;
      return;
    }
    z.current.filtered.groups = /* @__PURE__ */ new Set();
    let Os = 0;
    for (let Pa of ne.current) {
      let Ml = (wo = (xa = le.current.get(Pa)) == null ? void 0 : xa.value) != null ? wo : "", Su = (Oa = (_u = le.current.get(Pa)) == null ? void 0 : _u.keywords) != null ? Oa : [], Tu = Yn(Ml, Su);
      z.current.filtered.items.set(Pa, Tu), Tu > 0 && Os++;
    }
    for (let [Pa, Ml] of ue.current)
      for (let Su of Ml)
        if (z.current.filtered.items.get(Su) > 0) {
          z.current.filtered.groups.add(Pa);
          break;
        }
    z.current.filtered.count = Os;
  }
  function be() {
    var xa, wo, _u;
    let Oa = ye();
    Oa && (((xa = Oa.parentElement) == null ? void 0 : xa.firstChild) === Oa && ((_u = (wo = Oa.closest(yn$1)) == null ? void 0 : wo.querySelector(I0$1)) == null || _u.scrollIntoView({ block: "nearest" })), Oa.scrollIntoView({ block: "nearest" }));
  }
  function ye() {
    var xa;
    return (xa = _a.current) == null ? void 0 : xa.querySelector(`${qr}[aria-selected="true"]`);
  }
  function Se() {
    var xa;
    return Array.from((xa = _a.current) == null ? void 0 : xa.querySelectorAll(mc));
  }
  function Oe(xa) {
    let wo = Se()[xa];
    wo && Zn.setState("value", wo.getAttribute(kt$1));
  }
  function Fr(xa) {
    var wo;
    let _u = ye(), Oa = Se(), Os = Oa.findIndex((Ml) => Ml === _u), Pa = Oa[Os + xa];
    (wo = ge.current) != null && wo.loop && (Pa = Os + xa < 0 ? Oa[Oa.length - 1] : Os + xa === Oa.length ? Oa[0] : Oa[Os + xa]), Pa && Zn.setState("value", Pa.getAttribute(kt$1));
  }
  function zn(xa) {
    let wo = ye(), _u = wo == null ? void 0 : wo.closest(yn$1), Oa;
    for (; _u && !Oa; )
      _u = xa > 0 ? W0$1(_u, yn$1) : U0$1(_u, yn$1), Oa = _u == null ? void 0 : _u.querySelector(mc);
    Oa ? Zn.setState("value", Oa.getAttribute(kt$1)) : Fr(xa);
  }
  let Fe = () => Oe(Se().length - 1), pe = (xa) => {
    xa.preventDefault(), xa.metaKey ? Fe() : xa.altKey ? zn(1) : Fr(1);
  }, it = (xa) => {
    xa.preventDefault(), xa.metaKey ? Oe(0) : xa.altKey ? zn(-1) : Fr(-1);
  };
  return a$z.createElement(X$2.div, { ref: y, tabIndex: -1, ...En, "cmdk-root": "", onKeyDown: (xa) => {
    var wo;
    if ((wo = En.onKeyDown) == null || wo.call(En, xa), !xa.defaultPrevented)
      switch (xa.key) {
        case "n":
        case "j": {
          $n && xa.ctrlKey && pe(xa);
          break;
        }
        case "ArrowDown": {
          pe(xa);
          break;
        }
        case "p":
        case "k": {
          $n && xa.ctrlKey && it(xa);
          break;
        }
        case "ArrowUp": {
          it(xa);
          break;
        }
        case "Home": {
          xa.preventDefault(), Oe(0);
          break;
        }
        case "End": {
          xa.preventDefault(), Fe();
          break;
        }
        case "Enter":
          if (!xa.nativeEvent.isComposing && xa.keyCode !== 229) {
            xa.preventDefault();
            let _u = ye();
            if (_u) {
              let Oa = new Event(Er);
              _u.dispatchEvent(Oa);
            }
          }
      }
  } }, a$z.createElement("label", { "cmdk-label": "", htmlFor: Ra.inputId, id: Ra.labelId, style: Z0$1 }, we), No(v, (xa) => a$z.createElement(Hi.Provider, { value: Zn }, a$z.createElement(ji.Provider, { value: Ra }, xa))));
}), k0$1 = a$z.forwardRef((v, y) => {
  var z, ne;
  let ue = a$z.useId(), le = a$z.useRef(null), he = a$z.useContext(Vi), ge = Vn$1(), we = Wi(v), Ee = (ne = (z = we.current) == null ? void 0 : z.forceMount) != null ? ne : he == null ? void 0 : he.forceMount;
  Vt$1(() => {
    if (!Ee)
      return ge.item(ue, he == null ? void 0 : he.id);
  }, [Ee]);
  let xe = Ui(ue, le, [v.value, v.children, le], v.keywords), $e = Jr(), Ne = Bt$1((Ta) => Ta.value && Ta.value === xe.current), st = Bt$1((Ta) => Ee || ge.filter() === !1 ? !0 : Ta.search ? Ta.filtered.items.get(ue) > 0 : !0);
  a$z.useEffect(() => {
    let Ta = le.current;
    if (!(!Ta || v.disabled))
      return Ta.addEventListener(Er, Nr), () => Ta.removeEventListener(Er, Nr);
  }, [st, v.onSelect, v.disabled]);
  function Nr() {
    var Ta, Zn;
    br(), (Zn = (Ta = we.current).onSelect) == null || Zn.call(Ta, xe.current);
  }
  function br() {
    $e.setState("value", xe.current, !0);
  }
  if (!st)
    return null;
  let { disabled: $n, value: En, onSelect: Rn, forceMount: wa, keywords: Aa, ..._a } = v;
  return a$z.createElement(X$2.div, { ref: Tn([le, y]), ..._a, id: ue, "cmdk-item": "", role: "option", "aria-disabled": !!$n, "aria-selected": !!Ne, "data-disabled": !!$n, "data-selected": !!Ne, onPointerMove: $n || ge.disablePointerSelection ? void 0 : br, onClick: $n ? void 0 : Nr }, v.children);
}), L0$1 = a$z.forwardRef((v, y) => {
  let { heading: z, children: ne, forceMount: ue, ...le } = v, he = a$z.useId(), ge = a$z.useRef(null), we = a$z.useRef(null), Ee = a$z.useId(), xe = Vn$1(), $e = Bt$1((st) => ue || xe.filter() === !1 ? !0 : st.search ? st.filtered.groups.has(he) : !0);
  Vt$1(() => xe.group(he), []), Ui(he, ge, [v.value, v.heading, we]);
  let Ne = a$z.useMemo(() => ({ id: he, forceMount: ue }), [ue]);
  return a$z.createElement(X$2.div, { ref: Tn([ge, y]), ...le, "cmdk-group": "", role: "presentation", hidden: $e ? void 0 : !0 }, z && a$z.createElement("div", { ref: we, "cmdk-group-heading": "", "aria-hidden": !0, id: Ee }, z), No(v, (st) => a$z.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": z ? Ee : void 0 }, a$z.createElement(Vi.Provider, { value: Ne }, st))));
}), F0$1 = a$z.forwardRef((v, y) => {
  let { alwaysRender: z, ...ne } = v, ue = a$z.useRef(null), le = Bt$1((he) => !he.search);
  return !z && !le ? null : a$z.createElement(X$2.div, { ref: Tn([ue, y]), ...ne, "cmdk-separator": "", role: "separator" });
}), z0$1 = a$z.forwardRef((v, y) => {
  let { onValueChange: z, ...ne } = v, ue = v.value != null, le = Jr(), he = Bt$1((xe) => xe.search), ge = Bt$1((xe) => xe.value), we = Vn$1(), Ee = a$z.useMemo(() => {
    var xe;
    let $e = (xe = we.listInnerRef.current) == null ? void 0 : xe.querySelector(`${qr}[${kt$1}="${encodeURIComponent(ge)}"]`);
    return $e == null ? void 0 : $e.getAttribute("id");
  }, []);
  return a$z.useEffect(() => {
    v.value != null && le.setState("search", v.value);
  }, [v.value]), a$z.createElement(X$2.input, { ref: y, ...ne, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": we.listId, "aria-labelledby": we.labelId, "aria-activedescendant": Ee, id: we.inputId, type: "text", value: ue ? v.value : he, onChange: (xe) => {
    ue || le.setState("search", xe.target.value), z == null || z(xe.target.value);
  } });
}), j0$1 = a$z.forwardRef((v, y) => {
  let { children: z, label: ne = "Suggestions", ...ue } = v, le = a$z.useRef(null), he = a$z.useRef(null), ge = Vn$1();
  return a$z.useEffect(() => {
    if (he.current && le.current) {
      let we = he.current, Ee = le.current, xe, $e = new ResizeObserver(() => {
        xe = requestAnimationFrame(() => {
          let Ne = we.offsetHeight;
          Ee.style.setProperty("--cmdk-list-height", Ne.toFixed(1) + "px");
        });
      });
      return $e.observe(we), () => {
        cancelAnimationFrame(xe), $e.unobserve(we);
      };
    }
  }, []), a$z.createElement(X$2.div, { ref: Tn([le, y]), ...ue, "cmdk-list": "", role: "listbox", "aria-label": ne, id: ge.listId }, No(v, (we) => a$z.createElement("div", { ref: Tn([he, ge.listInnerRef]), "cmdk-list-sizer": "" }, we)));
}), H0$1 = a$z.forwardRef((v, y) => {
  let { open: z, onOpenChange: ne, overlayClassName: ue, contentClassName: le, container: he, ...ge } = v;
  return a$z.createElement(Kr$1, { open: z, onOpenChange: ne }, a$z.createElement(Gr, { container: he }, a$z.createElement(Io, { "cmdk-overlay": "", className: ue }), a$z.createElement(Hn$1, { "aria-label": v.label, "cmdk-dialog": "", className: le }, a$z.createElement(Bi, { ref: y, ...ge }))));
}), V0$1 = a$z.forwardRef((v, y) => Bt$1((z) => z.filtered.count === 0) ? a$z.createElement(X$2.div, { ref: y, ...v, "cmdk-empty": "", role: "presentation" }) : null), B0$1 = a$z.forwardRef((v, y) => {
  let { progress: z, children: ne, label: ue = "Loading...", ...le } = v;
  return a$z.createElement(X$2.div, { ref: y, ...le, "cmdk-loading": "", role: "progressbar", "aria-valuenow": z, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": ue }, No(v, (he) => a$z.createElement("div", { "aria-hidden": !0 }, he)));
}), He$1 = Object.assign(Bi, { List: j0$1, Item: k0$1, Input: z0$1, Group: L0$1, Separator: F0$1, Dialog: H0$1, Empty: V0$1, Loading: B0$1 });
function W0$1(v, y) {
  let z = v.nextElementSibling;
  for (; z; ) {
    if (z.matches(y))
      return z;
    z = z.nextElementSibling;
  }
}
function U0$1(v, y) {
  let z = v.previousElementSibling;
  for (; z; ) {
    if (z.matches(y))
      return z;
    z = z.previousElementSibling;
  }
}
function Wi(v) {
  let y = a$z.useRef(v);
  return Vt$1(() => {
    y.current = v;
  }), y;
}
var Vt$1 = typeof window > "u" ? a$z.useEffect : a$z.useLayoutEffect;
function on$1(v) {
  let y = a$z.useRef();
  return y.current === void 0 && (y.current = v()), y;
}
function Tn(v) {
  return (y) => {
    v.forEach((z) => {
      typeof z == "function" ? z(y) : z != null && (z.current = y);
    });
  };
}
function Bt$1(v) {
  let y = Jr(), z = () => v(y.snapshot());
  return a$z.useSyncExternalStore(y.subscribe, z, z);
}
function Ui(v, y, z, ne = []) {
  let ue = a$z.useRef(), le = Vn$1();
  return Vt$1(() => {
    var he;
    let ge = (() => {
      var Ee;
      for (let xe of z) {
        if (typeof xe == "string")
          return xe.trim();
        if (typeof xe == "object" && "current" in xe)
          return xe.current ? (Ee = xe.current.textContent) == null ? void 0 : Ee.trim() : ue.current;
      }
    })(), we = ne.map((Ee) => Ee.trim());
    le.value(v, ge, we), (he = y.current) == null || he.setAttribute(kt$1, ge), ue.current = ge;
  }), ue;
}
var K0$1 = () => {
  let [v, y] = a$z.useState(), z = on$1(() => /* @__PURE__ */ new Map());
  return Vt$1(() => {
    z.current.forEach((ne) => ne()), z.current = /* @__PURE__ */ new Map();
  }, [v]), (ne, ue) => {
    z.current.set(ne, ue), y({});
  };
};
function G0$1(v) {
  let y = v.type;
  return typeof y == "function" ? y(v.props) : "render" in y ? y.render(v.props) : v;
}
function No({ asChild: v, children: y }, z) {
  return v && a$z.isValidElement(y) ? a$z.cloneElement(G0$1(y), { ref: y.ref }, z(y.props.children)) : z(y);
}
var Z0$1 = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Bn$1 = (v = ".leap-ui") => {
  const [y, z] = useState(void 0);
  return useEffect(() => {
    if ("document" in globalThis) {
      const ne = globalThis.document.querySelector(
        v
      );
      z(ne || void 0);
    }
  }, [v]), y;
}, Y0$1 = Kr$1, J$ = zi, X0$1 = Gr, Q$ = Hn$1, Ki = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Io,
  {
    ref: z,
    className: Y$1(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      v
    ),
    ...y
  }
));
Ki.displayName = Io.displayName;
const Gi = a$z.forwardRef(
  ({ className: v, children: y, portalContainer: z, showClose: ne = !0, ...ue }, le) => {
    const he = Bn$1();
    return /* @__PURE__ */ D$6.jsxs(X0$1, { container: z ?? he, children: [
      /* @__PURE__ */ D$6.jsx(Ki, { className: "backdrop-blur-overlay" }),
      /* @__PURE__ */ D$6.jsxs(
        Hn$1,
        {
          ref: le,
          className: Y$1(
            "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
            v
          ),
          ...ue,
          children: [
            y,
            ne ? /* @__PURE__ */ D$6.jsxs(Xr, { className: "absolute right-6 top-6 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
              /* @__PURE__ */ D$6.jsx(pi, { className: "h-4 w-4" }),
              /* @__PURE__ */ D$6.jsx("span", { className: "sr-only", children: "Close" })
            ] }) : null
          ]
        }
      )
    ] });
  }
);
Gi.displayName = Hn$1.displayName;
const q0$1 = ({
  className: v,
  ...y
}) => /* @__PURE__ */ D$6.jsx(
  "div",
  {
    className: Y$1(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      v
    ),
    ...y
  }
);
q0$1.displayName = "DialogHeader";
const Q0$1 = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Zr,
  {
    ref: z,
    className: Y$1(
      "text-lg font-semibold leading-none tracking-tight",
      v
    ),
    ...y
  }
));
Q0$1.displayName = Zr.displayName;
const em = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Yr,
  {
    ref: z,
    className: Y$1("text-sm text-muted-foreground", v),
    ...y
  }
));
em.displayName = Yr.displayName;
const Zi = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1,
  {
    ref: z,
    className: Y$1(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      v
    ),
    ...y
  }
));
Zi.displayName = He$1.displayName;
const tm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ D$6.jsx(fi, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ D$6.jsx(
    He$1.Input,
    {
      ref: z,
      className: Y$1(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        v
      ),
      ...y
    }
  )
] }));
tm.displayName = He$1.Input.displayName;
const nm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1.List,
  {
    ref: z,
    className: Y$1("max-h-[300px] overflow-y-auto overflow-x-hidden", v),
    ...y
  }
));
nm.displayName = He$1.List.displayName;
const om = a$z.forwardRef((v, y) => /* @__PURE__ */ D$6.jsx(
  He$1.Empty,
  {
    ref: y,
    className: "py-6 text-center text-sm",
    ...v
  }
));
om.displayName = He$1.Empty.displayName;
const rm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1.Group,
  {
    ref: z,
    className: Y$1(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      v
    ),
    ...y
  }
));
rm.displayName = He$1.Group.displayName;
const am = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1.Separator,
  {
    ref: z,
    className: Y$1("-mx-1 h-px bg-border", v),
    ...y
  }
));
am.displayName = He$1.Separator.displayName;
const cm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1.Item,
  {
    ref: z,
    className: Y$1(
      'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled="true"]:pointer-events-none data-[disabled="true"]:opacity-50',
      v
    ),
    ...y
  }
));
cm.displayName = He$1.Item.displayName;
const sm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  He$1.Loading,
  {
    ref: z,
    className: Y$1("py-2 text-center text-sm", v),
    ...y
  }
));
sm.displayName = He$1.Loading.displayName;
var Yi = a__default.createContext({ drawerRef: { current: null }, overlayRef: { current: null }, scaleBackground: () => {
}, onPress: () => {
}, onRelease: () => {
}, onDrag: () => {
}, onNestedDrag: () => {
}, onNestedOpenChange: () => {
}, onNestedRelease: () => {
}, openProp: void 0, dismissible: !1, isOpen: !1, keyboardIsOpen: { current: !1 }, snapPointsOffset: null, snapPoints: null, modal: !1, shouldFade: !1, activeSnapPoint: null, onOpenChange: () => {
}, setActiveSnapPoint: () => {
}, visible: !1, closeDrawer: () => {
}, setVisible: () => {
}, direction: "bottom" }), Qr = () => a__default.useContext(Yi);
function lm(v, { insertAt: y } = {}) {
  if (!v || typeof document > "u")
    return;
  let z = document.head || document.getElementsByTagName("head")[0], ne = document.createElement("style");
  ne.type = "text/css", y === "top" && z.firstChild ? z.insertBefore(ne, z.firstChild) : z.appendChild(ne), ne.styleSheet ? ne.styleSheet.cssText = v : ne.appendChild(document.createTextNode(v));
}
lm(`[vaul-drawer]{touch-action:none;transition:transform .5s cubic-bezier(.32,.72,0,1)}[vaul-drawer][vaul-drawer-direction=bottom]{transform:translate3d(0,100%,0)}[vaul-drawer][vaul-drawer-direction=top]{transform:translate3d(0,-100%,0)}[vaul-drawer][vaul-drawer-direction=left]{transform:translate3d(-100%,0,0)}[vaul-drawer][vaul-drawer-direction=right]{transform:translate3d(100%,0,0)}.vaul-dragging .vaul-scrollable [vault-drawer-direction=top],.vaul-dragging .vaul-scrollable [vault-drawer-direction=bottom]{overflow-y:hidden!important}.vaul-dragging .vaul-scrollable [vault-drawer-direction=left],.vaul-dragging .vaul-scrollable [vault-drawer-direction=right]{overflow-x:hidden!important}[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=top],[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height, 0),0)}[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=left],[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height, 0),0,0)}[vaul-overlay]{opacity:0;transition:opacity .5s cubic-bezier(.32,.72,0,1)}[vaul-overlay][vaul-drawer-visible=true]{opacity:1}[vaul-drawer]:after{content:"";position:absolute;background:inherit;background-color:inherit}[vaul-drawer][vaul-drawer-direction=top]:after{top:initial;bottom:100%;left:0;right:0;height:200%}[vaul-drawer][vaul-drawer-direction=bottom]:after{top:100%;bottom:initial;left:0;right:0;height:200%}[vaul-drawer][vaul-drawer-direction=left]:after{left:initial;right:100%;top:0;bottom:0;width:200%}[vaul-drawer][vaul-drawer-direction=right]:after{left:100%;right:initial;top:0;bottom:0;width:200%}[vaul-overlay][vaul-snap-points=true]:not([vaul-snap-points-overlay="true"]):not([data-state="closed"]){opacity:0}[vaul-overlay][vaul-snap-points-overlay=true]:not([vaul-drawer-visible="false"]){opacity:1}@keyframes fake-animation{}@media (hover: hover) and (pointer: fine){[vaul-drawer]{user-select:none}}
`);
var um = typeof window < "u" ? useLayoutEffect : useEffect;
function Sr(...v) {
  return (...y) => {
    for (let z of v)
      typeof z == "function" && z(...y);
  };
}
function dm() {
  return ea(/^Mac/);
}
function fm() {
  return ea(/^iPhone/);
}
function pm() {
  return ea(/^iPad/) || dm() && navigator.maxTouchPoints > 1;
}
function Xi() {
  return fm() || pm();
}
function ea(v) {
  return typeof window < "u" && window.navigator != null ? v.test(window.navigator.platform) : void 0;
}
var pr = typeof document < "u" && window.visualViewport;
function vc(v) {
  let y = window.getComputedStyle(v);
  return /(auto|scroll)/.test(y.overflow + y.overflowX + y.overflowY);
}
function qi(v) {
  for (vc(v) && (v = v.parentElement); v && !vc(v); )
    v = v.parentElement;
  return v || document.scrollingElement || document.documentElement;
}
var mm = /* @__PURE__ */ new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]), to = 0, mr$1;
function vm(v = {}) {
  let { isDisabled: y } = v;
  um(() => {
    if (!y)
      return to++, to === 1 && (Xi() ? mr$1 = gm() : mr$1 = bm()), () => {
        to--, to === 0 && mr$1();
      };
  }, [y]);
}
function bm() {
  return Sr(Ji(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
}
function gm() {
  let v, y = 0, z = ($e) => {
    v = qi($e.target), !(v === document.documentElement && v === document.body) && (y = $e.changedTouches[0].pageY);
  }, ne = ($e) => {
    if (!v || v === document.documentElement || v === document.body) {
      $e.preventDefault();
      return;
    }
    let Ne = $e.changedTouches[0].pageY, st = v.scrollTop, Nr = v.scrollHeight - v.clientHeight;
    Nr !== 0 && ((st <= 0 && Ne > y || st >= Nr && Ne < y) && $e.preventDefault(), y = Ne);
  }, ue = ($e) => {
    let Ne = $e.target;
    Pr(Ne) && Ne !== document.activeElement && ($e.preventDefault(), Ne.style.transform = "translateY(-2000px)", Ne.focus(), requestAnimationFrame(() => {
      Ne.style.transform = "";
    }));
  }, le = ($e) => {
    let Ne = $e.target;
    Pr(Ne) && (Ne.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      Ne.style.transform = "", pr && (pr.height < window.innerHeight ? requestAnimationFrame(() => {
        bc(Ne);
      }) : pr.addEventListener("resize", () => bc(Ne), { once: !0 }));
    }));
  }, he = () => {
    window.scrollTo(0, 0);
  }, ge = window.pageXOffset, we = window.pageYOffset, Ee = Sr(Ji(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let xe = Sr(Cn(document, "touchstart", z, { passive: !1, capture: !0 }), Cn(document, "touchmove", ne, { passive: !1, capture: !0 }), Cn(document, "touchend", ue, { passive: !1, capture: !0 }), Cn(document, "focus", le, !0), Cn(window, "scroll", he));
  return () => {
    Ee(), xe(), window.scrollTo(ge, we);
  };
}
function Ji(v, y, z) {
  let ne = v.style[y];
  return v.style[y] = z, () => {
    v.style[y] = ne;
  };
}
function Cn(v, y, z, ne) {
  return v.addEventListener(y, z, ne), () => {
    v.removeEventListener(y, z, ne);
  };
}
function bc(v) {
  let y = document.scrollingElement || document.documentElement;
  for (; v && v !== y; ) {
    let z = qi(v);
    if (z !== document.documentElement && z !== document.body && z !== v) {
      let ne = z.getBoundingClientRect().top, ue = v.getBoundingClientRect().top, le = v.getBoundingClientRect().bottom, he = z.getBoundingClientRect().bottom;
      le > he && (z.scrollTop += ue - ne);
    }
    v = z.parentElement;
  }
}
function Pr(v) {
  return v instanceof HTMLInputElement && !mm.has(v.type) || v instanceof HTMLTextAreaElement || v instanceof HTMLElement && v.isContentEditable;
}
function hm(v, y) {
  typeof v == "function" ? v(y) : v != null && (v.current = y);
}
function $m(...v) {
  return (y) => v.forEach((z) => hm(z, y));
}
function Qi(...v) {
  return a$z.useCallback($m(...v), v);
}
var $t = null;
function wm({ isOpen: v, modal: y, nested: z, hasBeenOpened: ne, preventScrollRestoration: ue }) {
  let [le, he] = a__default.useState(typeof window < "u" ? window.location.href : ""), ge = a__default.useRef(0), we = a__default.useCallback(() => {
    if ($t === null && v) {
      $t = { position: document.body.style.position, top: document.body.style.top, left: document.body.style.left, height: document.body.style.height };
      let { scrollX: xe, innerHeight: $e } = window;
      document.body.style.setProperty("position", "fixed", "important"), document.body.style.top = `${-ge.current}px`, document.body.style.left = `${-xe}px`, document.body.style.right = "0px", document.body.style.height = "auto", setTimeout(() => requestAnimationFrame(() => {
        let Ne = $e - window.innerHeight;
        Ne && ge.current >= $e && (document.body.style.top = `${-(ge.current + Ne)}px`);
      }), 300);
    }
  }, [v]), Ee = a__default.useCallback(() => {
    if ($t !== null) {
      let xe = -parseInt(document.body.style.top, 10), $e = -parseInt(document.body.style.left, 10);
      document.body.style.position = $t.position, document.body.style.top = $t.top, document.body.style.left = $t.left, document.body.style.height = $t.height, document.body.style.right = "unset", requestAnimationFrame(() => {
        if (ue && le !== window.location.href) {
          he(window.location.href);
          return;
        }
        window.scrollTo($e, xe);
      }), $t = null;
    }
  }, [le]);
  return a__default.useEffect(() => {
    function xe() {
      ge.current = window.scrollY;
    }
    return xe(), window.addEventListener("scroll", xe), () => {
      window.removeEventListener("scroll", xe);
    };
  }, []), a__default.useEffect(() => {
    z || !ne || (v ? (we(), y || setTimeout(() => {
      Ee();
    }, 500)) : Ee());
  }, [v, ne, le, y, z, we, Ee]), { restorePositionSetting: Ee };
}
var es = /* @__PURE__ */ new WeakMap();
function _e$1(v, y, z = !1) {
  if (!v || !(v instanceof HTMLElement) || !y)
    return;
  let ne = {};
  Object.entries(y).forEach(([ue, le]) => {
    if (ue.startsWith("--")) {
      v.style.setProperty(ue, le);
      return;
    }
    ne[ue] = v.style[ue], v.style[ue] = le;
  }), !z && es.set(v, ne);
}
function no(v, y) {
  if (!v || !(v instanceof HTMLElement))
    return;
  let z = es.get(v);
  z && (y ? v.style[y] = z[y] : Object.entries(z).forEach(([ne, ue]) => {
    v.style[ne] = ue;
  }));
}
var De$1 = (v) => {
  switch (v) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return v;
  }
};
function oo(v, y) {
  let z = window.getComputedStyle(v), ne = z.transform || z.webkitTransform || z.mozTransform, ue = ne.match(/^matrix3d\((.+)\)$/);
  return ue ? parseFloat(ue[1].split(", ")[De$1(y) ? 13 : 12]) : (ue = ne.match(/^matrix\((.+)\)$/), ue ? parseFloat(ue[1].split(", ")[De$1(y) ? 5 : 4]) : null);
}
function xm(v) {
  return 8 * (Math.log(v + 1) - 2);
}
var Ce$1 = { DURATION: 0.5, EASE: [0.32, 0.72, 0, 1] }, ts = 0.4;
function ns(v) {
  let y = a__default.useRef(v);
  return a__default.useEffect(() => {
    y.current = v;
  }), a__default.useMemo(() => (...z) => {
    var ne;
    return (ne = y.current) == null ? void 0 : ne.call(y, ...z);
  }, []);
}
function ym({ defaultProp: v, onChange: y }) {
  let z = a__default.useState(v), [ne] = z, ue = a__default.useRef(ne), le = ns(y);
  return a__default.useEffect(() => {
    ue.current !== ne && (le(ne), ue.current = ne);
  }, [ne, ue, le]), z;
}
function Cm({ prop: v, defaultProp: y, onChange: z = () => {
} }) {
  let [ne, ue] = ym({ defaultProp: y, onChange: z }), le = v !== void 0, he = le ? v : ne, ge = ns(z), we = a__default.useCallback((Ee) => {
    if (le) {
      let xe = typeof Ee == "function" ? Ee(v) : Ee;
      xe !== v && ge(xe);
    } else
      ue(Ee);
  }, [le, v, ue, ge]);
  return [he, we];
}
function Em({ activeSnapPointProp: v, setActiveSnapPointProp: y, snapPoints: z, drawerRef: ne, overlayRef: ue, fadeFromIndex: le, onSnapPointChange: he, direction: ge = "bottom" }) {
  let [we, Ee] = Cm({ prop: v, defaultProp: z == null ? void 0 : z[0], onChange: y }), xe = a__default.useMemo(() => we === (z == null ? void 0 : z[z.length - 1]) || null, [z, we]), $e = z && z.length > 0 && (le || le === 0) && !Number.isNaN(le) && z[le] === we || !z, Ne = a__default.useMemo(() => z == null ? void 0 : z.findIndex((wa) => wa === we), [z, we]), st = a__default.useMemo(() => {
    var wa;
    return (wa = z == null ? void 0 : z.map((Aa) => {
      let _a = typeof window < "u", Ta = typeof Aa == "string", Zn = 0;
      if (Ta && (Zn = parseInt(Aa, 10)), De$1(ge)) {
        let Yn = Ta ? Zn : _a ? Aa * window.innerHeight : 0;
        return _a ? ge === "bottom" ? window.innerHeight - Yn : -window.innerHeight + Yn : Yn;
      }
      let Ra = Ta ? Zn : _a ? Aa * window.innerWidth : 0;
      return _a ? ge === "right" ? window.innerWidth - Ra : -window.innerWidth + Ra : Ra;
    })) != null ? wa : [];
  }, [z]), Nr = a__default.useMemo(() => Ne !== null ? st == null ? void 0 : st[Ne] : null, [st, Ne]), br = a__default.useCallback((wa) => {
    var Aa;
    let _a = (Aa = st == null ? void 0 : st.findIndex((Ta) => Ta === wa)) != null ? Aa : null;
    he(_a), _e$1(ne.current, { transition: `transform ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, transform: De$1(ge) ? `translate3d(0, ${wa}px, 0)` : `translate3d(${wa}px, 0, 0)` }), st && _a !== st.length - 1 && _a !== le ? _e$1(ue.current, { transition: `opacity ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, opacity: "0" }) : _e$1(ue.current, { transition: `opacity ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, opacity: "1" }), Ee(_a !== null ? z == null ? void 0 : z[_a] : null);
  }, [ne.current, z, st, le, ue, Ee]);
  a__default.useEffect(() => {
    var wa;
    if (v) {
      let Aa = (wa = z == null ? void 0 : z.findIndex((_a) => _a === v)) != null ? wa : -1;
      st && Aa !== -1 && typeof st[Aa] == "number" && br(st[Aa]);
    }
  }, [v, z, st, br]);
  function $n({ draggedDistance: wa, closeDrawer: Aa, velocity: _a, dismissible: Ta }) {
    if (le === void 0)
      return;
    let Zn = ge === "bottom" || ge === "right" ? (Nr ?? 0) - wa : (Nr ?? 0) + wa, Ra = Ne === le - 1, Yn = Ne === 0, $o = wa > 0;
    if (Ra && _e$1(ue.current, { transition: `opacity ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})` }), _a > 2 && !$o) {
      Ta ? Aa() : br(st[0]);
      return;
    }
    if (_a > 2 && $o && st && z) {
      br(st[z.length - 1]);
      return;
    }
    let ct = st == null ? void 0 : st.reduce((be, ye) => typeof be != "number" || typeof ye != "number" ? be : Math.abs(ye - Zn) < Math.abs(be - Zn) ? ye : be), fe = De$1(ge) ? window.innerHeight : window.innerWidth;
    if (_a > ts && Math.abs(wa) < fe * 0.4) {
      let be = $o ? 1 : -1;
      if (be > 0 && xe) {
        br(st[z.length - 1]);
        return;
      }
      if (Yn && be < 0 && Ta && Aa(), Ne === null)
        return;
      br(st[Ne + be]);
      return;
    }
    br(ct);
  }
  function En({ draggedDistance: wa }) {
    if (Nr === null)
      return;
    let Aa = ge === "bottom" || ge === "right" ? Nr - wa : Nr + wa;
    (ge === "bottom" || ge === "right") && Aa < st[st.length - 1] || (ge === "top" || ge === "left") && Aa > st[st.length - 1] || _e$1(ne.current, { transform: De$1(ge) ? `translate3d(0, ${Aa}px, 0)` : `translate3d(${Aa}px, 0, 0)` });
  }
  function Rn(wa, Aa) {
    if (!z || typeof Ne != "number" || !st || le === void 0)
      return null;
    let _a = Ne === le - 1;
    if (Ne >= le && Aa)
      return 0;
    if (_a && !Aa)
      return 1;
    if (!$e && !_a)
      return null;
    let Ta = _a ? Ne + 1 : Ne - 1, Zn = _a ? st[Ta] - st[Ta - 1] : st[Ta + 1] - st[Ta], Ra = wa / Math.abs(Zn);
    return _a ? 1 - Ra : Ra;
  }
  return { isLastSnapPoint: xe, activeSnapPoint: we, shouldFade: $e, getPercentageDragged: Rn, setActiveSnapPoint: Ee, activeSnapPointIndex: Ne, onRelease: $n, onDrag: En, snapPointsOffset: st };
}
var Sm = 0.25, Pm = 100, gc = 8, It$1 = 16, hc = 26, $c = "vaul-dragging";
function os({ open: v, onOpenChange: y, children: z, shouldScaleBackground: ne, onDrag: ue, onRelease: le, snapPoints: he, nested: ge = !1, closeThreshold: we = Sm, scrollLockTimeout: Ee = Pm, dismissible: xe = !0, fadeFromIndex: $e = he && he.length - 1, activeSnapPoint: Ne, setActiveSnapPoint: st, fixed: Nr, modal: br = !0, onClose: $n, direction: En = "bottom", preventScrollRestoration: Rn = !0 }) {
  var wa;
  let [Aa = !1, _a] = a__default.useState(!1), [Ta, Zn] = a__default.useState(!1), [Ra, Yn] = a__default.useState(!1), [$o, ct] = a__default.useState(!1), [fe, be] = a__default.useState(!1), [ye, Se] = a__default.useState(!1), Oe = a__default.useRef(null), Fr = a__default.useRef(null), zn = a__default.useRef(null), Fe = a__default.useRef(null), pe = a__default.useRef(null), it = a__default.useRef(!1), xa = a__default.useRef(null), wo = a__default.useRef(0), _u = a__default.useRef(!1), Oa = a__default.useRef(0), Os = a__default.useRef(null), Pa = a__default.useRef(((wa = Os.current) == null ? void 0 : wa.getBoundingClientRect().height) || 0), Ml = a__default.useRef(0), Su = a__default.useCallback((Eu) => {
    he && Eu === Uc.length - 1 && (Fr.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Tu, activeSnapPointIndex: Au, setActiveSnapPoint: Zl, onRelease: Iu, snapPointsOffset: Uc, onDrag: Pu, shouldFade: Lu, getPercentageDragged: th } = Em({ snapPoints: he, activeSnapPointProp: Ne, setActiveSnapPointProp: st, drawerRef: Os, fadeFromIndex: $e, overlayRef: Oe, onSnapPointChange: Su, direction: En });
  vm({ isDisabled: !Aa || fe || !br || ye || !Ta });
  let { restorePositionSetting: Zc } = wm({ isOpen: Aa, modal: br, nested: ge, hasBeenOpened: Ta, preventScrollRestoration: Rn });
  function N1() {
    return (window.innerWidth - hc) / window.innerWidth;
  }
  function Gh(Eu) {
    var Zo;
    !xe && !he || Os.current && !Os.current.contains(Eu.target) || (Pa.current = ((Zo = Os.current) == null ? void 0 : Zo.getBoundingClientRect().height) || 0, be(!0), zn.current = /* @__PURE__ */ new Date(), Xi() && window.addEventListener("touchend", () => it.current = !1, { once: !0 }), Eu.target.setPointerCapture(Eu.pointerId), wo.current = De$1(En) ? Eu.screenY : Eu.screenX);
  }
  function Mc(Eu, Zo) {
    var Fl;
    let Ru = Eu, ku = (Fl = window.getSelection()) == null ? void 0 : Fl.toString(), kc = Os.current ? oo(Os.current, En) : null, Ou = /* @__PURE__ */ new Date();
    if (Ru.hasAttribute("data-vaul-no-drag"))
      return !1;
    if (En === "right" || En === "left")
      return !0;
    if (Fr.current && Ou.getTime() - Fr.current.getTime() < 500)
      return !1;
    if (kc !== null && (En === "bottom" ? kc > 0 : kc < 0))
      return !0;
    if (ku && ku.length > 0)
      return !1;
    if (pe.current && Ou.getTime() - pe.current.getTime() < Ee && kc === 0 || Zo)
      return pe.current = Ou, !1;
    for (; Ru; ) {
      if (Ru.scrollHeight > Ru.clientHeight) {
        if (Ru.scrollTop !== 0)
          return pe.current = /* @__PURE__ */ new Date(), !1;
        if (Ru.getAttribute("role") === "dialog")
          return !0;
      }
      Ru = Ru.parentNode;
    }
    return !0;
  }
  function h1(Eu) {
    if (Os.current && fe) {
      let Zo = En === "bottom" || En === "right" ? 1 : -1, Fl = (wo.current - (De$1(En) ? Eu.screenY : Eu.screenX)) * Zo, Ru = Fl > 0;
      if (he && Au === 0 && !xe || !it.current && !Mc(Eu.target, Ru))
        return;
      if (Os.current.classList.add($c), it.current = !0, _e$1(Os.current, { transition: "none" }), _e$1(Oe.current, { transition: "none" }), he && Pu({ draggedDistance: Fl }), Ru && !he) {
        let Ic = xm(Fl), X1 = Math.min(Ic * -1, 0) * Zo;
        _e$1(Os.current, { transform: De$1(En) ? `translate3d(0, ${X1}px, 0)` : `translate3d(${X1}px, 0, 0)` });
        return;
      }
      let ku = Math.abs(Fl), kc = document.querySelector("[vaul-drawer-wrapper]"), Ou = ku / Pa.current, U1 = th(ku, Ru);
      U1 !== null && (Ou = U1);
      let g2 = 1 - Ou;
      if ((Lu || $e && Au === $e - 1) && (ue == null || ue(Eu, Ou), _e$1(Oe.current, { opacity: `${g2}`, transition: "none" }, !0)), kc && Oe.current && ne) {
        let Ic = Math.min(N1() + Ou * (1 - N1()), 1), X1 = 8 - Ou * 8, $2 = Math.max(0, 14 - Ou * 14);
        _e$1(kc, { borderRadius: `${X1}px`, transform: De$1(En) ? `scale(${Ic}) translate3d(0, ${$2}px, 0)` : `scale(${Ic}) translate3d(${$2}px, 0, 0)`, transition: "none" }, !0);
      }
      if (!he) {
        let Ic = ku * Zo;
        _e$1(Os.current, { transform: De$1(En) ? `translate3d(0, ${Ic}px, 0)` : `translate3d(${Ic}px, 0, 0)` });
      }
    }
  }
  a__default.useEffect(() => () => {
    M2(!1), Zc();
  }, []), a__default.useEffect(() => {
    var Eu;
    function Zo() {
      var Fl;
      if (!Os.current)
        return;
      let Ru = document.activeElement;
      if (Pr(Ru) || _u.current) {
        let ku = ((Fl = window.visualViewport) == null ? void 0 : Fl.height) || 0, kc = window.innerHeight - ku, Ou = Os.current.getBoundingClientRect().height || 0;
        Ml.current || (Ml.current = Ou);
        let U1 = Os.current.getBoundingClientRect().top;
        if (Math.abs(Oa.current - kc) > 60 && (_u.current = !_u.current), he && he.length > 0 && Uc && Au) {
          let g2 = Uc[Au] || 0;
          kc += g2;
        }
        if (Oa.current = kc, Ou > ku || _u.current) {
          let g2 = Os.current.getBoundingClientRect().height, Ic = g2;
          g2 > ku && (Ic = ku - hc), Nr ? Os.current.style.height = `${g2 - Math.max(kc, 0)}px` : Os.current.style.height = `${Math.max(Ic, ku - U1)}px`;
        } else
          Os.current.style.height = `${Ml.current}px`;
        he && he.length > 0 && !_u.current ? Os.current.style.bottom = "0px" : Os.current.style.bottom = `${Math.max(kc, 0)}px`;
      }
    }
    return (Eu = window.visualViewport) == null || Eu.addEventListener("resize", Zo), () => {
      var Fl;
      return (Fl = window.visualViewport) == null ? void 0 : Fl.removeEventListener("resize", Zo);
    };
  }, [Au, he, Uc]);
  function l2() {
    Os.current && ($n == null || $n(), _e$1(Os.current, { transform: De$1(En) ? `translate3d(0, ${En === "bottom" ? "100%" : "-100%"}, 0)` : `translate3d(${En === "right" ? "100%" : "-100%"}, 0, 0)`, transition: `transform ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})` }), _e$1(Oe.current, { opacity: "0", transition: `opacity ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})` }), M2(!1), setTimeout(() => {
      Yn(!1), _a(!1);
    }, 300), setTimeout(() => {
      he && Zl(he[0]);
    }, Ce$1.DURATION * 1e3));
  }
  a__default.useEffect(() => {
    if (!Aa && ne) {
      let Eu = setTimeout(() => {
        no(document.body);
      }, 200);
      return () => clearTimeout(Eu);
    }
  }, [Aa, ne]), a__default.useEffect(() => {
    v ? (_a(!0), Zn(!0)) : l2();
  }, [v]), a__default.useEffect(() => {
    $o && (y == null || y(Aa));
  }, [Aa]), a__default.useEffect(() => {
    ct(!0);
  }, []);
  function Gc() {
    if (!Os.current)
      return;
    let Eu = document.querySelector("[vaul-drawer-wrapper]"), Zo = oo(Os.current, En);
    _e$1(Os.current, { transform: "translate3d(0, 0, 0)", transition: `transform ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})` }), _e$1(Oe.current, { transition: `opacity ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, opacity: "1" }), ne && Zo && Zo > 0 && Aa && _e$1(Eu, { borderRadius: `${gc}px`, overflow: "hidden", ...De$1(En) ? { transform: `scale(${N1()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`, transformOrigin: "top" } : { transform: `scale(${N1()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`, transformOrigin: "left" }, transitionProperty: "transform, border-radius", transitionDuration: `${Ce$1.DURATION}s`, transitionTimingFunction: `cubic-bezier(${Ce$1.EASE.join(",")})` }, !0);
  }
  function Kc(Eu) {
    var Zo;
    if (!fe || !Os.current)
      return;
    Os.current.classList.remove($c), it.current = !1, be(!1), Fe.current = /* @__PURE__ */ new Date();
    let Fl = oo(Os.current, En);
    if (!Mc(Eu.target, !1) || !Fl || Number.isNaN(Fl) || zn.current === null)
      return;
    let Ru = Fe.current.getTime() - zn.current.getTime(), ku = wo.current - (De$1(En) ? Eu.screenY : Eu.screenX), kc = Math.abs(ku) / Ru;
    if (kc > 0.05 && (Se(!0), setTimeout(() => {
      Se(!1);
    }, 200)), he) {
      Iu({ draggedDistance: ku * (En === "bottom" || En === "right" ? 1 : -1), closeDrawer: l2, velocity: kc, dismissible: xe }), le == null || le(Eu, !0);
      return;
    }
    if (En === "bottom" || En === "right" ? ku > 0 : ku < 0) {
      Gc(), le == null || le(Eu, !0);
      return;
    }
    if (kc > ts) {
      l2(), le == null || le(Eu, !1);
      return;
    }
    let Ou = Math.min((Zo = Os.current.getBoundingClientRect().height) != null ? Zo : 0, window.innerHeight);
    if (Fl >= Ou * we) {
      l2(), le == null || le(Eu, !1);
      return;
    }
    le == null || le(Eu, !0), Gc();
  }
  a__default.useEffect(() => {
    Aa && (_e$1(document.documentElement, { scrollBehavior: "auto" }), Fr.current = /* @__PURE__ */ new Date(), M2(!0));
  }, [Aa]), a__default.useEffect(() => {
    var Eu;
    if (Os.current && Ra) {
      let Zo = (Eu = Os == null ? void 0 : Os.current) == null ? void 0 : Eu.querySelectorAll("*");
      Zo == null || Zo.forEach((Fl) => {
        let Ru = Fl;
        (Ru.scrollHeight > Ru.clientHeight || Ru.scrollWidth > Ru.clientWidth) && Ru.classList.add("vaul-scrollable");
      });
    }
  }, [Ra]);
  function M2(Eu) {
    let Zo = document.querySelector("[vaul-drawer-wrapper]");
    !Zo || !ne || (Eu ? (_e$1(document.body, { background: document.body.style.backgroundColor || document.body.style.background }), _e$1(document.body, { background: "black" }, !0), _e$1(Zo, { borderRadius: `${gc}px`, overflow: "hidden", ...De$1(En) ? { transform: `scale(${N1()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`, transformOrigin: "top" } : { transform: `scale(${N1()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`, transformOrigin: "left" }, transitionProperty: "transform, border-radius", transitionDuration: `${Ce$1.DURATION}s`, transitionTimingFunction: `cubic-bezier(${Ce$1.EASE.join(",")})` })) : (no(Zo, "overflow"), no(Zo, "transform"), no(Zo, "borderRadius"), _e$1(Zo, { transitionProperty: "transform, border-radius", transitionDuration: `${Ce$1.DURATION}s`, transitionTimingFunction: `cubic-bezier(${Ce$1.EASE.join(",")})` })));
  }
  function d1(Eu) {
    let Zo = Eu ? (window.innerWidth - It$1) / window.innerWidth : 1, Fl = Eu ? -It$1 : 0;
    xa.current && window.clearTimeout(xa.current), _e$1(Os.current, { transition: `transform ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, transform: `scale(${Zo}) translate3d(0, ${Fl}px, 0)` }), !Eu && Os.current && (xa.current = setTimeout(() => {
      let Ru = oo(Os.current, En);
      _e$1(Os.current, { transition: "none", transform: De$1(En) ? `translate3d(0, ${Ru}px, 0)` : `translate3d(${Ru}px, 0, 0)` });
    }, 500));
  }
  function K1(Eu, Zo) {
    if (Zo < 0)
      return;
    let Fl = De$1(En) ? window.innerHeight : window.innerWidth, Ru = (Fl - It$1) / Fl, ku = Ru + Zo * (1 - Ru), kc = -It$1 + Zo * It$1;
    _e$1(Os.current, { transform: De$1(En) ? `scale(${ku}) translate3d(0, ${kc}px, 0)` : `scale(${ku}) translate3d(${kc}px, 0, 0)`, transition: "none" });
  }
  function k2(Eu, Zo) {
    let Fl = De$1(En) ? window.innerHeight : window.innerWidth, Ru = Zo ? (Fl - It$1) / Fl : 1, ku = Zo ? -It$1 : 0;
    Zo && _e$1(Os.current, { transition: `transform ${Ce$1.DURATION}s cubic-bezier(${Ce$1.EASE.join(",")})`, transform: De$1(En) ? `scale(${Ru}) translate3d(0, ${ku}px, 0)` : `scale(${Ru}) translate3d(${ku}px, 0, 0)` });
  }
  return a__default.createElement(Kr$1, { modal: br, onOpenChange: (Eu) => {
    if (v !== void 0) {
      y == null || y(Eu);
      return;
    }
    Eu ? (Zn(!0), _a(Eu)) : l2();
  }, open: Aa }, a__default.createElement(Yi.Provider, { value: { visible: Ra, activeSnapPoint: Tu, snapPoints: he, setActiveSnapPoint: Zl, drawerRef: Os, overlayRef: Oe, scaleBackground: M2, onOpenChange: y, onPress: Gh, setVisible: Yn, onRelease: Kc, onDrag: h1, dismissible: xe, isOpen: Aa, shouldFade: Lu, closeDrawer: l2, onNestedDrag: K1, onNestedOpenChange: d1, onNestedRelease: k2, keyboardIsOpen: _u, openProp: v, modal: br, snapPointsOffset: Uc, direction: En } }, z));
}
var rs = a__default.forwardRef(function({ children: v, ...y }, z) {
  let { overlayRef: ne, snapPoints: ue, onRelease: le, shouldFade: he, isOpen: ge, visible: we } = Qr(), Ee = Qi(z, ne), xe = ue && ue.length > 0;
  return a__default.createElement(Io, { onMouseUp: le, ref: Ee, "vaul-drawer-visible": we ? "true" : "false", "vaul-overlay": "", "vaul-snap-points": ge && xe ? "true" : "false", "vaul-snap-points-overlay": ge && he ? "true" : "false", ...y });
});
rs.displayName = "Drawer.Overlay";
var as = a__default.forwardRef(function({ onOpenAutoFocus: v, onPointerDownOutside: y, onAnimationEnd: z, style: ne, ...ue }, le) {
  let { drawerRef: he, onPress: ge, onRelease: we, onDrag: Ee, dismissible: xe, keyboardIsOpen: $e, snapPointsOffset: Ne, visible: st, closeDrawer: Nr, modal: br, openProp: $n, onOpenChange: En, setVisible: Rn, direction: wa } = Qr(), Aa = Qi(le, he);
  return a__default.useEffect(() => {
    Rn(!0);
  }, []), a__default.createElement(Hn$1, { onOpenAutoFocus: (_a) => {
    var Ta;
    v ? v(_a) : (_a.preventDefault(), (Ta = he.current) == null || Ta.focus());
  }, onPointerDown: ge, onPointerDownOutside: (_a) => {
    if (y == null || y(_a), !br || _a.defaultPrevented) {
      _a.preventDefault();
      return;
    }
    $e.current && ($e.current = !1), _a.preventDefault(), En == null || En(!1), !(!xe || $n !== void 0) && Nr();
  }, onPointerMove: Ee, onPointerUp: we, ref: Aa, style: Ne && Ne.length > 0 ? { "--snap-point-height": `${Ne[0]}px`, ...ne } : ne, ...ue, "vaul-drawer": "", "vaul-drawer-direction": wa, "vaul-drawer-visible": st ? "true" : "false" });
});
as.displayName = "Drawer.Content";
function _m({ onDrag: v, onOpenChange: y, ...z }) {
  let { onNestedDrag: ne, onNestedOpenChange: ue, onNestedRelease: le } = Qr();
  if (!ne)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return a__default.createElement(os, { nested: !0, onClose: () => {
    ue(!1);
  }, onDrag: (he, ge) => {
    ne(he, ge), v == null || v(he, ge);
  }, onOpenChange: (he) => {
    he && ue(he), y == null || y(he);
  }, onRelease: le, ...z });
}
var ot$1 = { Root: os, NestedRoot: _m, Content: as, Overlay: rs, Trigger: zi, Portal: Gr, Close: Xr, Title: Zr, Description: Yr };
const Am = ot$1.Portal, cs = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  ot$1.Overlay,
  {
    ref: z,
    className: Y$1("fixed inset-0 z-50 bg-black/80", v),
    ...y
  }
));
cs.displayName = ot$1.Overlay.displayName;
const Tm = a$z.forwardRef(({ className: v, children: y, portalContainer: z, ...ne }, ue) => {
  const le = Bn$1();
  return /* @__PURE__ */ D$6.jsxs(Am, { container: z ?? le, children: [
    /* @__PURE__ */ D$6.jsx(cs, {}),
    /* @__PURE__ */ D$6.jsxs(
      ot$1.Content,
      {
        ref: ue,
        className: Y$1(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background",
          v
        ),
        ...ne,
        children: [
          /* @__PURE__ */ D$6.jsx("div", { className: "mx-auto mt-3 h-1 w-[4rem] rounded-full bg-muted" }),
          y
        ]
      }
    )
  ] });
});
Tm.displayName = "DrawerContent";
const Mm = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  ot$1.Title,
  {
    ref: z,
    className: Y$1(
      "text-lg font-semibold leading-none tracking-tight",
      v
    ),
    ...y
  }
));
Mm.displayName = ot$1.Title.displayName;
const Im = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  ot$1.Description,
  {
    ref: z,
    className: Y$1("text-sm text-muted-foreground", v),
    ...y
  }
));
Im.displayName = ot$1.Description.displayName;
const Nm = ["top", "right", "bottom", "left"], Ct$1 = Math.min, Ye$1 = Math.max, po = Math.round, ro = Math.floor, Et$1 = (v) => ({
  x: v,
  y: v
}), km = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Lm = {
  start: "end",
  end: "start"
};
function _r(v, y, z) {
  return Ye$1(v, Ct$1(y, z));
}
function ft$1(v, y) {
  return typeof v == "function" ? v(y) : v;
}
function pt$1(v) {
  return v.split("-")[0];
}
function mn$1(v) {
  return v.split("-")[1];
}
function ta(v) {
  return v === "x" ? "y" : "x";
}
function na(v) {
  return v === "y" ? "height" : "width";
}
function vn$1(v) {
  return ["top", "bottom"].includes(pt$1(v)) ? "y" : "x";
}
function oa(v) {
  return ta(vn$1(v));
}
function Fm(v, y, z) {
  z === void 0 && (z = !1);
  const ne = mn$1(v), ue = oa(v), le = na(ue);
  let he = ue === "x" ? ne === (z ? "end" : "start") ? "right" : "left" : ne === "start" ? "bottom" : "top";
  return y.reference[le] > y.floating[le] && (he = mo(he)), [he, mo(he)];
}
function zm(v) {
  const y = mo(v);
  return [Rr(v), y, Rr(y)];
}
function Rr(v) {
  return v.replace(/start|end/g, (y) => Lm[y]);
}
function jm(v, y, z) {
  const ne = ["left", "right"], ue = ["right", "left"], le = ["top", "bottom"], he = ["bottom", "top"];
  switch (v) {
    case "top":
    case "bottom":
      return z ? y ? ue : ne : y ? ne : ue;
    case "left":
    case "right":
      return y ? le : he;
    default:
      return [];
  }
}
function Hm(v, y, z, ne) {
  const ue = mn$1(v);
  let le = jm(pt$1(v), z === "start", ne);
  return ue && (le = le.map((he) => he + "-" + ue), y && (le = le.concat(le.map(Rr)))), le;
}
function mo(v) {
  return v.replace(/left|right|bottom|top/g, (y) => km[y]);
}
function Vm(v) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  };
}
function is(v) {
  return typeof v != "number" ? Vm(v) : {
    top: v,
    right: v,
    bottom: v,
    left: v
  };
}
function vo(v) {
  return {
    ...v,
    top: v.y,
    left: v.x,
    right: v.x + v.width,
    bottom: v.y + v.height
  };
}
function wc(v, y, z) {
  let {
    reference: ne,
    floating: ue
  } = v;
  const le = vn$1(y), he = oa(y), ge = na(he), we = pt$1(y), Ee = le === "y", xe = ne.x + ne.width / 2 - ue.width / 2, $e = ne.y + ne.height / 2 - ue.height / 2, Ne = ne[ge] / 2 - ue[ge] / 2;
  let st;
  switch (we) {
    case "top":
      st = {
        x: xe,
        y: ne.y - ue.height
      };
      break;
    case "bottom":
      st = {
        x: xe,
        y: ne.y + ne.height
      };
      break;
    case "right":
      st = {
        x: ne.x + ne.width,
        y: $e
      };
      break;
    case "left":
      st = {
        x: ne.x - ue.width,
        y: $e
      };
      break;
    default:
      st = {
        x: ne.x,
        y: ne.y
      };
  }
  switch (mn$1(y)) {
    case "start":
      st[he] -= Ne * (z && Ee ? -1 : 1);
      break;
    case "end":
      st[he] += Ne * (z && Ee ? -1 : 1);
      break;
  }
  return st;
}
const Bm = async (v, y, z) => {
  const {
    placement: ne = "bottom",
    strategy: ue = "absolute",
    middleware: le = [],
    platform: he
  } = z, ge = le.filter(Boolean), we = await (he.isRTL == null ? void 0 : he.isRTL(y));
  let Ee = await he.getElementRects({
    reference: v,
    floating: y,
    strategy: ue
  }), {
    x: xe,
    y: $e
  } = wc(Ee, ne, we), Ne = ne, st = {}, Nr = 0;
  for (let br = 0; br < ge.length; br++) {
    const {
      name: $n,
      fn: En
    } = ge[br], {
      x: Rn,
      y: wa,
      data: Aa,
      reset: _a
    } = await En({
      x: xe,
      y: $e,
      initialPlacement: ne,
      placement: Ne,
      strategy: ue,
      middlewareData: st,
      rects: Ee,
      platform: he,
      elements: {
        reference: v,
        floating: y
      }
    });
    xe = Rn ?? xe, $e = wa ?? $e, st = {
      ...st,
      [$n]: {
        ...st[$n],
        ...Aa
      }
    }, _a && Nr <= 50 && (Nr++, typeof _a == "object" && (_a.placement && (Ne = _a.placement), _a.rects && (Ee = _a.rects === !0 ? await he.getElementRects({
      reference: v,
      floating: y,
      strategy: ue
    }) : _a.rects), {
      x: xe,
      y: $e
    } = wc(Ee, Ne, we)), br = -1);
  }
  return {
    x: xe,
    y: $e,
    placement: Ne,
    strategy: ue,
    middlewareData: st
  };
};
async function On(v, y) {
  var z;
  y === void 0 && (y = {});
  const {
    x: ne,
    y: ue,
    platform: le,
    rects: he,
    elements: ge,
    strategy: we
  } = v, {
    boundary: Ee = "clippingAncestors",
    rootBoundary: xe = "viewport",
    elementContext: $e = "floating",
    altBoundary: Ne = !1,
    padding: st = 0
  } = ft$1(y, v), Nr = is(st), br = ge[Ne ? $e === "floating" ? "reference" : "floating" : $e], $n = vo(await le.getClippingRect({
    element: (z = await (le.isElement == null ? void 0 : le.isElement(br))) == null || z ? br : br.contextElement || await (le.getDocumentElement == null ? void 0 : le.getDocumentElement(ge.floating)),
    boundary: Ee,
    rootBoundary: xe,
    strategy: we
  })), En = $e === "floating" ? {
    ...he.floating,
    x: ne,
    y: ue
  } : he.reference, Rn = await (le.getOffsetParent == null ? void 0 : le.getOffsetParent(ge.floating)), wa = await (le.isElement == null ? void 0 : le.isElement(Rn)) ? await (le.getScale == null ? void 0 : le.getScale(Rn)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Aa = vo(le.convertOffsetParentRelativeRectToViewportRelativeRect ? await le.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: ge,
    rect: En,
    offsetParent: Rn,
    strategy: we
  }) : En);
  return {
    top: ($n.top - Aa.top + Nr.top) / wa.y,
    bottom: (Aa.bottom - $n.bottom + Nr.bottom) / wa.y,
    left: ($n.left - Aa.left + Nr.left) / wa.x,
    right: (Aa.right - $n.right + Nr.right) / wa.x
  };
}
const Wm = (v) => ({
  name: "arrow",
  options: v,
  async fn(y) {
    const {
      x: z,
      y: ne,
      placement: ue,
      rects: le,
      platform: he,
      elements: ge,
      middlewareData: we
    } = y, {
      element: Ee,
      padding: xe = 0
    } = ft$1(v, y) || {};
    if (Ee == null)
      return {};
    const $e = is(xe), Ne = {
      x: z,
      y: ne
    }, st = oa(ue), Nr = na(st), br = await he.getDimensions(Ee), $n = st === "y", En = $n ? "top" : "left", Rn = $n ? "bottom" : "right", wa = $n ? "clientHeight" : "clientWidth", Aa = le.reference[Nr] + le.reference[st] - Ne[st] - le.floating[Nr], _a = Ne[st] - le.reference[st], Ta = await (he.getOffsetParent == null ? void 0 : he.getOffsetParent(Ee));
    let Zn = Ta ? Ta[wa] : 0;
    (!Zn || !await (he.isElement == null ? void 0 : he.isElement(Ta))) && (Zn = ge.floating[wa] || le.floating[Nr]);
    const Ra = Aa / 2 - _a / 2, Yn = Zn / 2 - br[Nr] / 2 - 1, $o = Ct$1($e[En], Yn), ct = Ct$1($e[Rn], Yn), fe = $o, be = Zn - br[Nr] - ct, ye = Zn / 2 - br[Nr] / 2 + Ra, Se = _r(fe, ye, be), Oe = !we.arrow && mn$1(ue) != null && ye !== Se && le.reference[Nr] / 2 - (ye < fe ? $o : ct) - br[Nr] / 2 < 0, Fr = Oe ? ye < fe ? ye - fe : ye - be : 0;
    return {
      [st]: Ne[st] + Fr,
      data: {
        [st]: Se,
        centerOffset: ye - Se - Fr,
        ...Oe && {
          alignmentOffset: Fr
        }
      },
      reset: Oe
    };
  }
}), Um = function(v) {
  return v === void 0 && (v = {}), {
    name: "flip",
    options: v,
    async fn(y) {
      var z, ne;
      const {
        placement: ue,
        middlewareData: le,
        rects: he,
        initialPlacement: ge,
        platform: we,
        elements: Ee
      } = y, {
        mainAxis: xe = !0,
        crossAxis: $e = !0,
        fallbackPlacements: Ne,
        fallbackStrategy: st = "bestFit",
        fallbackAxisSideDirection: Nr = "none",
        flipAlignment: br = !0,
        ...$n
      } = ft$1(v, y);
      if ((z = le.arrow) != null && z.alignmentOffset)
        return {};
      const En = pt$1(ue), Rn = pt$1(ge) === ge, wa = await (we.isRTL == null ? void 0 : we.isRTL(Ee.floating)), Aa = Ne || (Rn || !br ? [mo(ge)] : zm(ge));
      !Ne && Nr !== "none" && Aa.push(...Hm(ge, br, Nr, wa));
      const _a = [ge, ...Aa], Ta = await On(y, $n), Zn = [];
      let Ra = ((ne = le.flip) == null ? void 0 : ne.overflows) || [];
      if (xe && Zn.push(Ta[En]), $e) {
        const fe = Fm(ue, he, wa);
        Zn.push(Ta[fe[0]], Ta[fe[1]]);
      }
      if (Ra = [...Ra, {
        placement: ue,
        overflows: Zn
      }], !Zn.every((fe) => fe <= 0)) {
        var Yn, $o;
        const fe = (((Yn = le.flip) == null ? void 0 : Yn.index) || 0) + 1, be = _a[fe];
        if (be)
          return {
            data: {
              index: fe,
              overflows: Ra
            },
            reset: {
              placement: be
            }
          };
        let ye = ($o = Ra.filter((Se) => Se.overflows[0] <= 0).sort((Se, Oe) => Se.overflows[1] - Oe.overflows[1])[0]) == null ? void 0 : $o.placement;
        if (!ye)
          switch (st) {
            case "bestFit": {
              var ct;
              const Se = (ct = Ra.map((Oe) => [Oe.placement, Oe.overflows.filter((Fr) => Fr > 0).reduce((Fr, zn) => Fr + zn, 0)]).sort((Oe, Fr) => Oe[1] - Fr[1])[0]) == null ? void 0 : ct[0];
              Se && (ye = Se);
              break;
            }
            case "initialPlacement":
              ye = ge;
              break;
          }
        if (ue !== ye)
          return {
            reset: {
              placement: ye
            }
          };
      }
      return {};
    }
  };
};
function xc(v, y) {
  return {
    top: v.top - y.height,
    right: v.right - y.width,
    bottom: v.bottom - y.height,
    left: v.left - y.width
  };
}
function yc(v) {
  return Nm.some((y) => v[y] >= 0);
}
const Km = function(v) {
  return v === void 0 && (v = {}), {
    name: "hide",
    options: v,
    async fn(y) {
      const {
        rects: z
      } = y, {
        strategy: ne = "referenceHidden",
        ...ue
      } = ft$1(v, y);
      switch (ne) {
        case "referenceHidden": {
          const le = await On(y, {
            ...ue,
            elementContext: "reference"
          }), he = xc(le, z.reference);
          return {
            data: {
              referenceHiddenOffsets: he,
              referenceHidden: yc(he)
            }
          };
        }
        case "escaped": {
          const le = await On(y, {
            ...ue,
            altBoundary: !0
          }), he = xc(le, z.floating);
          return {
            data: {
              escapedOffsets: he,
              escaped: yc(he)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Gm(v, y) {
  const {
    placement: z,
    platform: ne,
    elements: ue
  } = v, le = await (ne.isRTL == null ? void 0 : ne.isRTL(ue.floating)), he = pt$1(z), ge = mn$1(z), we = vn$1(z) === "y", Ee = ["left", "top"].includes(he) ? -1 : 1, xe = le && we ? -1 : 1, $e = ft$1(y, v);
  let {
    mainAxis: Ne,
    crossAxis: st,
    alignmentAxis: Nr
  } = typeof $e == "number" ? {
    mainAxis: $e,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...$e
  };
  return ge && typeof Nr == "number" && (st = ge === "end" ? Nr * -1 : Nr), we ? {
    x: st * xe,
    y: Ne * Ee
  } : {
    x: Ne * Ee,
    y: st * xe
  };
}
const Zm = function(v) {
  return v === void 0 && (v = 0), {
    name: "offset",
    options: v,
    async fn(y) {
      var z, ne;
      const {
        x: ue,
        y: le,
        placement: he,
        middlewareData: ge
      } = y, we = await Gm(y, v);
      return he === ((z = ge.offset) == null ? void 0 : z.placement) && (ne = ge.arrow) != null && ne.alignmentOffset ? {} : {
        x: ue + we.x,
        y: le + we.y,
        data: {
          ...we,
          placement: he
        }
      };
    }
  };
}, Ym = function(v) {
  return v === void 0 && (v = {}), {
    name: "shift",
    options: v,
    async fn(y) {
      const {
        x: z,
        y: ne,
        placement: ue
      } = y, {
        mainAxis: le = !0,
        crossAxis: he = !1,
        limiter: ge = {
          fn: ($n) => {
            let {
              x: En,
              y: Rn
            } = $n;
            return {
              x: En,
              y: Rn
            };
          }
        },
        ...we
      } = ft$1(v, y), Ee = {
        x: z,
        y: ne
      }, xe = await On(y, we), $e = vn$1(pt$1(ue)), Ne = ta($e);
      let st = Ee[Ne], Nr = Ee[$e];
      if (le) {
        const $n = Ne === "y" ? "top" : "left", En = Ne === "y" ? "bottom" : "right", Rn = st + xe[$n], wa = st - xe[En];
        st = _r(Rn, st, wa);
      }
      if (he) {
        const $n = $e === "y" ? "top" : "left", En = $e === "y" ? "bottom" : "right", Rn = Nr + xe[$n], wa = Nr - xe[En];
        Nr = _r(Rn, Nr, wa);
      }
      const br = ge.fn({
        ...y,
        [Ne]: st,
        [$e]: Nr
      });
      return {
        ...br,
        data: {
          x: br.x - z,
          y: br.y - ne
        }
      };
    }
  };
}, Xm = function(v) {
  return v === void 0 && (v = {}), {
    options: v,
    fn(y) {
      const {
        x: z,
        y: ne,
        placement: ue,
        rects: le,
        middlewareData: he
      } = y, {
        offset: ge = 0,
        mainAxis: we = !0,
        crossAxis: Ee = !0
      } = ft$1(v, y), xe = {
        x: z,
        y: ne
      }, $e = vn$1(ue), Ne = ta($e);
      let st = xe[Ne], Nr = xe[$e];
      const br = ft$1(ge, y), $n = typeof br == "number" ? {
        mainAxis: br,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...br
      };
      if (we) {
        const wa = Ne === "y" ? "height" : "width", Aa = le.reference[Ne] - le.floating[wa] + $n.mainAxis, _a = le.reference[Ne] + le.reference[wa] - $n.mainAxis;
        st < Aa ? st = Aa : st > _a && (st = _a);
      }
      if (Ee) {
        var En, Rn;
        const wa = Ne === "y" ? "width" : "height", Aa = ["top", "left"].includes(pt$1(ue)), _a = le.reference[$e] - le.floating[wa] + (Aa && ((En = he.offset) == null ? void 0 : En[$e]) || 0) + (Aa ? 0 : $n.crossAxis), Ta = le.reference[$e] + le.reference[wa] + (Aa ? 0 : ((Rn = he.offset) == null ? void 0 : Rn[$e]) || 0) - (Aa ? $n.crossAxis : 0);
        Nr < _a ? Nr = _a : Nr > Ta && (Nr = Ta);
      }
      return {
        [Ne]: st,
        [$e]: Nr
      };
    }
  };
}, qm = function(v) {
  return v === void 0 && (v = {}), {
    name: "size",
    options: v,
    async fn(y) {
      const {
        placement: z,
        rects: ne,
        platform: ue,
        elements: le
      } = y, {
        apply: he = () => {
        },
        ...ge
      } = ft$1(v, y), we = await On(y, ge), Ee = pt$1(z), xe = mn$1(z), $e = vn$1(z) === "y", {
        width: Ne,
        height: st
      } = ne.floating;
      let Nr, br;
      Ee === "top" || Ee === "bottom" ? (Nr = Ee, br = xe === (await (ue.isRTL == null ? void 0 : ue.isRTL(le.floating)) ? "start" : "end") ? "left" : "right") : (br = Ee, Nr = xe === "end" ? "top" : "bottom");
      const $n = st - we[Nr], En = Ne - we[br], Rn = !y.middlewareData.shift;
      let wa = $n, Aa = En;
      if ($e) {
        const Ta = Ne - we.left - we.right;
        Aa = xe || Rn ? Ct$1(En, Ta) : Ta;
      } else {
        const Ta = st - we.top - we.bottom;
        wa = xe || Rn ? Ct$1($n, Ta) : Ta;
      }
      if (Rn && !xe) {
        const Ta = Ye$1(we.left, 0), Zn = Ye$1(we.right, 0), Ra = Ye$1(we.top, 0), Yn = Ye$1(we.bottom, 0);
        $e ? Aa = Ne - 2 * (Ta !== 0 || Zn !== 0 ? Ta + Zn : Ye$1(we.left, we.right)) : wa = st - 2 * (Ra !== 0 || Yn !== 0 ? Ra + Yn : Ye$1(we.top, we.bottom));
      }
      await he({
        ...y,
        availableWidth: Aa,
        availableHeight: wa
      });
      const _a = await ue.getDimensions(le.floating);
      return Ne !== _a.width || st !== _a.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function St$1(v) {
  return ss(v) ? (v.nodeName || "").toLowerCase() : "#document";
}
function Xe$1(v) {
  var y;
  return (v == null || (y = v.ownerDocument) == null ? void 0 : y.defaultView) || window;
}
function bt$1(v) {
  var y;
  return (y = (ss(v) ? v.ownerDocument : v.document) || window.document) == null ? void 0 : y.documentElement;
}
function ss(v) {
  return v instanceof Node || v instanceof Xe$1(v).Node;
}
function mt$1(v) {
  return v instanceof Element || v instanceof Xe$1(v).Element;
}
function at$1(v) {
  return v instanceof HTMLElement || v instanceof Xe$1(v).HTMLElement;
}
function Cc(v) {
  return typeof ShadowRoot > "u" ? !1 : v instanceof ShadowRoot || v instanceof Xe$1(v).ShadowRoot;
}
function Wn$1(v) {
  const {
    overflow: y,
    overflowX: z,
    overflowY: ne,
    display: ue
  } = Qe$1(v);
  return /auto|scroll|overlay|hidden|clip/.test(y + ne + z) && !["inline", "contents"].includes(ue);
}
function Jm(v) {
  return ["table", "td", "th"].includes(St$1(v));
}
function ra(v) {
  const y = aa(), z = Qe$1(v);
  return z.transform !== "none" || z.perspective !== "none" || (z.containerType ? z.containerType !== "normal" : !1) || !y && (z.backdropFilter ? z.backdropFilter !== "none" : !1) || !y && (z.filter ? z.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((ne) => (z.willChange || "").includes(ne)) || ["paint", "layout", "strict", "content"].some((ne) => (z.contain || "").includes(ne));
}
function Qm(v) {
  let y = ln$1(v);
  for (; at$1(y) && !ko(y); ) {
    if (ra(y))
      return y;
    y = ln$1(y);
  }
  return null;
}
function aa() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ko(v) {
  return ["html", "body", "#document"].includes(St$1(v));
}
function Qe$1(v) {
  return Xe$1(v).getComputedStyle(v);
}
function Lo(v) {
  return mt$1(v) ? {
    scrollLeft: v.scrollLeft,
    scrollTop: v.scrollTop
  } : {
    scrollLeft: v.pageXOffset,
    scrollTop: v.pageYOffset
  };
}
function ln$1(v) {
  if (St$1(v) === "html")
    return v;
  const y = (
    // Step into the shadow DOM of the parent of a slotted node.
    v.assignedSlot || // DOM Element detected.
    v.parentNode || // ShadowRoot detected.
    Cc(v) && v.host || // Fallback.
    bt$1(v)
  );
  return Cc(y) ? y.host : y;
}
function ls(v) {
  const y = ln$1(v);
  return ko(y) ? v.ownerDocument ? v.ownerDocument.body : v.body : at$1(y) && Wn$1(y) ? y : ls(y);
}
function Dn$1(v, y, z) {
  var ne;
  y === void 0 && (y = []), z === void 0 && (z = !0);
  const ue = ls(v), le = ue === ((ne = v.ownerDocument) == null ? void 0 : ne.body), he = Xe$1(ue);
  return le ? y.concat(he, he.visualViewport || [], Wn$1(ue) ? ue : [], he.frameElement && z ? Dn$1(he.frameElement) : []) : y.concat(ue, Dn$1(ue, [], z));
}
function us(v) {
  const y = Qe$1(v);
  let z = parseFloat(y.width) || 0, ne = parseFloat(y.height) || 0;
  const ue = at$1(v), le = ue ? v.offsetWidth : z, he = ue ? v.offsetHeight : ne, ge = po(z) !== le || po(ne) !== he;
  return ge && (z = le, ne = he), {
    width: z,
    height: ne,
    $: ge
  };
}
function ca(v) {
  return mt$1(v) ? v : v.contextElement;
}
function sn$1(v) {
  const y = ca(v);
  if (!at$1(y))
    return Et$1(1);
  const z = y.getBoundingClientRect(), {
    width: ne,
    height: ue,
    $: le
  } = us(y);
  let he = (le ? po(z.width) : z.width) / ne, ge = (le ? po(z.height) : z.height) / ue;
  return (!he || !Number.isFinite(he)) && (he = 1), (!ge || !Number.isFinite(ge)) && (ge = 1), {
    x: he,
    y: ge
  };
}
const ev = /* @__PURE__ */ Et$1(0);
function ds(v) {
  const y = Xe$1(v);
  return !aa() || !y.visualViewport ? ev : {
    x: y.visualViewport.offsetLeft,
    y: y.visualViewport.offsetTop
  };
}
function tv(v, y, z) {
  return y === void 0 && (y = !1), !z || y && z !== Xe$1(v) ? !1 : y;
}
function Wt$1(v, y, z, ne) {
  y === void 0 && (y = !1), z === void 0 && (z = !1);
  const ue = v.getBoundingClientRect(), le = ca(v);
  let he = Et$1(1);
  y && (ne ? mt$1(ne) && (he = sn$1(ne)) : he = sn$1(v));
  const ge = tv(le, z, ne) ? ds(le) : Et$1(0);
  let we = (ue.left + ge.x) / he.x, Ee = (ue.top + ge.y) / he.y, xe = ue.width / he.x, $e = ue.height / he.y;
  if (le) {
    const Ne = Xe$1(le), st = ne && mt$1(ne) ? Xe$1(ne) : ne;
    let Nr = Ne, br = Nr.frameElement;
    for (; br && ne && st !== Nr; ) {
      const $n = sn$1(br), En = br.getBoundingClientRect(), Rn = Qe$1(br), wa = En.left + (br.clientLeft + parseFloat(Rn.paddingLeft)) * $n.x, Aa = En.top + (br.clientTop + parseFloat(Rn.paddingTop)) * $n.y;
      we *= $n.x, Ee *= $n.y, xe *= $n.x, $e *= $n.y, we += wa, Ee += Aa, Nr = Xe$1(br), br = Nr.frameElement;
    }
  }
  return vo({
    width: xe,
    height: $e,
    x: we,
    y: Ee
  });
}
const nv = [":popover-open", ":modal"];
function fs(v) {
  return nv.some((y) => {
    try {
      return v.matches(y);
    } catch {
      return !1;
    }
  });
}
function ov(v) {
  let {
    elements: y,
    rect: z,
    offsetParent: ne,
    strategy: ue
  } = v;
  const le = ue === "fixed", he = bt$1(ne), ge = y ? fs(y.floating) : !1;
  if (ne === he || ge && le)
    return z;
  let we = {
    scrollLeft: 0,
    scrollTop: 0
  }, Ee = Et$1(1);
  const xe = Et$1(0), $e = at$1(ne);
  if (($e || !$e && !le) && ((St$1(ne) !== "body" || Wn$1(he)) && (we = Lo(ne)), at$1(ne))) {
    const Ne = Wt$1(ne);
    Ee = sn$1(ne), xe.x = Ne.x + ne.clientLeft, xe.y = Ne.y + ne.clientTop;
  }
  return {
    width: z.width * Ee.x,
    height: z.height * Ee.y,
    x: z.x * Ee.x - we.scrollLeft * Ee.x + xe.x,
    y: z.y * Ee.y - we.scrollTop * Ee.y + xe.y
  };
}
function rv(v) {
  return Array.from(v.getClientRects());
}
function ps(v) {
  return Wt$1(bt$1(v)).left + Lo(v).scrollLeft;
}
function av(v) {
  const y = bt$1(v), z = Lo(v), ne = v.ownerDocument.body, ue = Ye$1(y.scrollWidth, y.clientWidth, ne.scrollWidth, ne.clientWidth), le = Ye$1(y.scrollHeight, y.clientHeight, ne.scrollHeight, ne.clientHeight);
  let he = -z.scrollLeft + ps(v);
  const ge = -z.scrollTop;
  return Qe$1(ne).direction === "rtl" && (he += Ye$1(y.clientWidth, ne.clientWidth) - ue), {
    width: ue,
    height: le,
    x: he,
    y: ge
  };
}
function cv(v, y) {
  const z = Xe$1(v), ne = bt$1(v), ue = z.visualViewport;
  let le = ne.clientWidth, he = ne.clientHeight, ge = 0, we = 0;
  if (ue) {
    le = ue.width, he = ue.height;
    const Ee = aa();
    (!Ee || Ee && y === "fixed") && (ge = ue.offsetLeft, we = ue.offsetTop);
  }
  return {
    width: le,
    height: he,
    x: ge,
    y: we
  };
}
function iv(v, y) {
  const z = Wt$1(v, !0, y === "fixed"), ne = z.top + v.clientTop, ue = z.left + v.clientLeft, le = at$1(v) ? sn$1(v) : Et$1(1), he = v.clientWidth * le.x, ge = v.clientHeight * le.y, we = ue * le.x, Ee = ne * le.y;
  return {
    width: he,
    height: ge,
    x: we,
    y: Ee
  };
}
function Ec(v, y, z) {
  let ne;
  if (y === "viewport")
    ne = cv(v, z);
  else if (y === "document")
    ne = av(bt$1(v));
  else if (mt$1(y))
    ne = iv(y, z);
  else {
    const ue = ds(v);
    ne = {
      ...y,
      x: y.x - ue.x,
      y: y.y - ue.y
    };
  }
  return vo(ne);
}
function ms(v, y) {
  const z = ln$1(v);
  return z === y || !mt$1(z) || ko(z) ? !1 : Qe$1(z).position === "fixed" || ms(z, y);
}
function sv(v, y) {
  const z = y.get(v);
  if (z)
    return z;
  let ne = Dn$1(v, [], !1).filter((ge) => mt$1(ge) && St$1(ge) !== "body"), ue = null;
  const le = Qe$1(v).position === "fixed";
  let he = le ? ln$1(v) : v;
  for (; mt$1(he) && !ko(he); ) {
    const ge = Qe$1(he), we = ra(he);
    !we && ge.position === "fixed" && (ue = null), (le ? !we && !ue : !we && ge.position === "static" && ue && ["absolute", "fixed"].includes(ue.position) || Wn$1(he) && !we && ms(v, he)) ? ne = ne.filter((Ee) => Ee !== he) : ue = ge, he = ln$1(he);
  }
  return y.set(v, ne), ne;
}
function lv(v) {
  let {
    element: y,
    boundary: z,
    rootBoundary: ne,
    strategy: ue
  } = v;
  const le = [...z === "clippingAncestors" ? sv(y, this._c) : [].concat(z), ne], he = le[0], ge = le.reduce((we, Ee) => {
    const xe = Ec(y, Ee, ue);
    return we.top = Ye$1(xe.top, we.top), we.right = Ct$1(xe.right, we.right), we.bottom = Ct$1(xe.bottom, we.bottom), we.left = Ye$1(xe.left, we.left), we;
  }, Ec(y, he, ue));
  return {
    width: ge.right - ge.left,
    height: ge.bottom - ge.top,
    x: ge.left,
    y: ge.top
  };
}
function uv(v) {
  const {
    width: y,
    height: z
  } = us(v);
  return {
    width: y,
    height: z
  };
}
function dv(v, y, z) {
  const ne = at$1(y), ue = bt$1(y), le = z === "fixed", he = Wt$1(v, !0, le, y);
  let ge = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const we = Et$1(0);
  if (ne || !ne && !le)
    if ((St$1(y) !== "body" || Wn$1(ue)) && (ge = Lo(y)), ne) {
      const $e = Wt$1(y, !0, le, y);
      we.x = $e.x + y.clientLeft, we.y = $e.y + y.clientTop;
    } else
      ue && (we.x = ps(ue));
  const Ee = he.left + ge.scrollLeft - we.x, xe = he.top + ge.scrollTop - we.y;
  return {
    x: Ee,
    y: xe,
    width: he.width,
    height: he.height
  };
}
function Sc(v, y) {
  return !at$1(v) || Qe$1(v).position === "fixed" ? null : y ? y(v) : v.offsetParent;
}
function vs(v, y) {
  const z = Xe$1(v);
  if (!at$1(v) || fs(v))
    return z;
  let ne = Sc(v, y);
  for (; ne && Jm(ne) && Qe$1(ne).position === "static"; )
    ne = Sc(ne, y);
  return ne && (St$1(ne) === "html" || St$1(ne) === "body" && Qe$1(ne).position === "static" && !ra(ne)) ? z : ne || Qm(v) || z;
}
const fv = async function(v) {
  const y = this.getOffsetParent || vs, z = this.getDimensions;
  return {
    reference: dv(v.reference, await y(v.floating), v.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await z(v.floating)
    }
  };
};
function pv(v) {
  return Qe$1(v).direction === "rtl";
}
const mv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ov,
  getDocumentElement: bt$1,
  getClippingRect: lv,
  getOffsetParent: vs,
  getElementRects: fv,
  getClientRects: rv,
  getDimensions: uv,
  getScale: sn$1,
  isElement: mt$1,
  isRTL: pv
};
function vv(v, y) {
  let z = null, ne;
  const ue = bt$1(v);
  function le() {
    var ge;
    clearTimeout(ne), (ge = z) == null || ge.disconnect(), z = null;
  }
  function he(ge, we) {
    ge === void 0 && (ge = !1), we === void 0 && (we = 1), le();
    const {
      left: Ee,
      top: xe,
      width: $e,
      height: Ne
    } = v.getBoundingClientRect();
    if (ge || y(), !$e || !Ne)
      return;
    const st = ro(xe), Nr = ro(ue.clientWidth - (Ee + $e)), br = ro(ue.clientHeight - (xe + Ne)), $n = ro(Ee), En = {
      rootMargin: -st + "px " + -Nr + "px " + -br + "px " + -$n + "px",
      threshold: Ye$1(0, Ct$1(1, we)) || 1
    };
    let Rn = !0;
    function wa(Aa) {
      const _a = Aa[0].intersectionRatio;
      if (_a !== we) {
        if (!Rn)
          return he();
        _a ? he(!1, _a) : ne = setTimeout(() => {
          he(!1, 1e-7);
        }, 100);
      }
      Rn = !1;
    }
    try {
      z = new IntersectionObserver(wa, {
        ...En,
        // Handle <iframe>s
        root: ue.ownerDocument
      });
    } catch {
      z = new IntersectionObserver(wa, En);
    }
    z.observe(v);
  }
  return he(!0), le;
}
function bv(v, y, z, ne) {
  ne === void 0 && (ne = {});
  const {
    ancestorScroll: ue = !0,
    ancestorResize: le = !0,
    elementResize: he = typeof ResizeObserver == "function",
    layoutShift: ge = typeof IntersectionObserver == "function",
    animationFrame: we = !1
  } = ne, Ee = ca(v), xe = ue || le ? [...Ee ? Dn$1(Ee) : [], ...Dn$1(y)] : [];
  xe.forEach((En) => {
    ue && En.addEventListener("scroll", z, {
      passive: !0
    }), le && En.addEventListener("resize", z);
  });
  const $e = Ee && ge ? vv(Ee, z) : null;
  let Ne = -1, st = null;
  he && (st = new ResizeObserver((En) => {
    let [Rn] = En;
    Rn && Rn.target === Ee && st && (st.unobserve(y), cancelAnimationFrame(Ne), Ne = requestAnimationFrame(() => {
      var wa;
      (wa = st) == null || wa.observe(y);
    })), z();
  }), Ee && !we && st.observe(Ee), st.observe(y));
  let Nr, br = we ? Wt$1(v) : null;
  we && $n();
  function $n() {
    const En = Wt$1(v);
    br && (En.x !== br.x || En.y !== br.y || En.width !== br.width || En.height !== br.height) && z(), br = En, Nr = requestAnimationFrame($n);
  }
  return z(), () => {
    var En;
    xe.forEach((Rn) => {
      ue && Rn.removeEventListener("scroll", z), le && Rn.removeEventListener("resize", z);
    }), $e == null || $e(), (En = st) == null || En.disconnect(), st = null, we && cancelAnimationFrame(Nr);
  };
}
const gv = Ym, hv = Um, $v = qm, wv = Km, Pc = Wm, xv = Xm, yv = (v, y, z) => {
  const ne = /* @__PURE__ */ new Map(), ue = {
    platform: mv,
    ...z
  }, le = {
    ...ue.platform,
    _c: ne
  };
  return Bm(v, y, {
    ...ue,
    platform: le
  });
}, Cv = (v) => {
  function y(z) {
    return {}.hasOwnProperty.call(z, "current");
  }
  return {
    name: "arrow",
    options: v,
    fn(z) {
      const {
        element: ne,
        padding: ue
      } = typeof v == "function" ? v(z) : v;
      return ne && y(ne) ? ne.current != null ? Pc({
        element: ne.current,
        padding: ue
      }).fn(z) : {} : ne ? Pc({
        element: ne,
        padding: ue
      }).fn(z) : {};
    }
  };
};
var uo = typeof document < "u" ? useLayoutEffect : useEffect;
function bo(v, y) {
  if (v === y)
    return !0;
  if (typeof v != typeof y)
    return !1;
  if (typeof v == "function" && v.toString() === y.toString())
    return !0;
  let z, ne, ue;
  if (v && y && typeof v == "object") {
    if (Array.isArray(v)) {
      if (z = v.length, z !== y.length)
        return !1;
      for (ne = z; ne-- !== 0; )
        if (!bo(v[ne], y[ne]))
          return !1;
      return !0;
    }
    if (ue = Object.keys(v), z = ue.length, z !== Object.keys(y).length)
      return !1;
    for (ne = z; ne-- !== 0; )
      if (!{}.hasOwnProperty.call(y, ue[ne]))
        return !1;
    for (ne = z; ne-- !== 0; ) {
      const le = ue[ne];
      if (!(le === "_owner" && v.$$typeof) && !bo(v[le], y[le]))
        return !1;
    }
    return !0;
  }
  return v !== v && y !== y;
}
function bs(v) {
  return typeof window > "u" ? 1 : (v.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _c(v, y) {
  const z = bs(v);
  return Math.round(y * z) / z;
}
function Rc(v) {
  const y = a$z.useRef(v);
  return uo(() => {
    y.current = v;
  }), y;
}
function Ev(v) {
  v === void 0 && (v = {});
  const {
    placement: y = "bottom",
    strategy: z = "absolute",
    middleware: ne = [],
    platform: ue,
    elements: {
      reference: le,
      floating: he
    } = {},
    transform: ge = !0,
    whileElementsMounted: we,
    open: Ee
  } = v, [xe, $e] = a$z.useState({
    x: 0,
    y: 0,
    strategy: z,
    placement: y,
    middlewareData: {},
    isPositioned: !1
  }), [Ne, st] = a$z.useState(ne);
  bo(Ne, ne) || st(ne);
  const [Nr, br] = a$z.useState(null), [$n, En] = a$z.useState(null), Rn = a$z.useCallback((Fr) => {
    Fr !== Ta.current && (Ta.current = Fr, br(Fr));
  }, []), wa = a$z.useCallback((Fr) => {
    Fr !== Zn.current && (Zn.current = Fr, En(Fr));
  }, []), Aa = le || Nr, _a = he || $n, Ta = a$z.useRef(null), Zn = a$z.useRef(null), Ra = a$z.useRef(xe), Yn = we != null, $o = Rc(we), ct = Rc(ue), fe = a$z.useCallback(() => {
    if (!Ta.current || !Zn.current)
      return;
    const Fr = {
      placement: y,
      strategy: z,
      middleware: Ne
    };
    ct.current && (Fr.platform = ct.current), yv(Ta.current, Zn.current, Fr).then((zn) => {
      const Fe = {
        ...zn,
        isPositioned: !0
      };
      be.current && !bo(Ra.current, Fe) && (Ra.current = Fe, Nu.flushSync(() => {
        $e(Fe);
      }));
    });
  }, [Ne, y, z, ct]);
  uo(() => {
    Ee === !1 && Ra.current.isPositioned && (Ra.current.isPositioned = !1, $e((Fr) => ({
      ...Fr,
      isPositioned: !1
    })));
  }, [Ee]);
  const be = a$z.useRef(!1);
  uo(() => (be.current = !0, () => {
    be.current = !1;
  }), []), uo(() => {
    if (Aa && (Ta.current = Aa), _a && (Zn.current = _a), Aa && _a) {
      if ($o.current)
        return $o.current(Aa, _a, fe);
      fe();
    }
  }, [Aa, _a, fe, $o, Yn]);
  const ye = a$z.useMemo(() => ({
    reference: Ta,
    floating: Zn,
    setReference: Rn,
    setFloating: wa
  }), [Rn, wa]), Se = a$z.useMemo(() => ({
    reference: Aa,
    floating: _a
  }), [Aa, _a]), Oe = a$z.useMemo(() => {
    const Fr = {
      position: z,
      left: 0,
      top: 0
    };
    if (!Se.floating)
      return Fr;
    const zn = _c(Se.floating, xe.x), Fe = _c(Se.floating, xe.y);
    return ge ? {
      ...Fr,
      transform: "translate(" + zn + "px, " + Fe + "px)",
      ...bs(Se.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: z,
      left: zn,
      top: Fe
    };
  }, [z, ge, Se.floating, xe.x, xe.y]);
  return a$z.useMemo(() => ({
    ...xe,
    update: fe,
    refs: ye,
    elements: Se,
    floatingStyles: Oe
  }), [xe, fe, ye, Se, Oe]);
}
const gs = "Popper", [hs, Rt$1] = Le(gs), [Sv, $s] = hs(gs), Pv = (v) => {
  const { __scopePopper: y, children: z } = v, [ne, ue] = useState(null);
  return /* @__PURE__ */ createElement(Sv, {
    scope: y,
    anchor: ne,
    onAnchorChange: ue
  }, z);
}, _v = "PopperAnchor", Rv = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopePopper: z, virtualRef: ne, ...ue } = v, le = $s(_v, z), he = useRef(null), ge = de(y, he);
  return useEffect(() => {
    le.onAnchorChange((ne == null ? void 0 : ne.current) || he.current);
  }), ne ? null : /* @__PURE__ */ createElement(X$2.div, _$2({}, ue, {
    ref: ge
  }));
}), ws = "PopperContent", [Av, rw] = hs(ws), Tv = /* @__PURE__ */ forwardRef((v, y) => {
  var z, ne, ue, le, he, ge, we, Ee;
  const { __scopePopper: xe, side: $e = "bottom", sideOffset: Ne = 0, align: st = "center", alignOffset: Nr = 0, arrowPadding: br = 0, avoidCollisions: $n = !0, collisionBoundary: En = [], collisionPadding: Rn = 0, sticky: wa = "partial", hideWhenDetached: Aa = !1, updatePositionStrategy: _a = "optimized", onPlaced: Ta, ...Zn } = v, Ra = $s(ws, xe), [Yn, $o] = useState(null), ct = de(
    y,
    (Pu) => $o(Pu)
  ), [fe, be] = useState(null), ye = _o(fe), Se = (z = ye == null ? void 0 : ye.width) !== null && z !== void 0 ? z : 0, Oe = (ne = ye == null ? void 0 : ye.height) !== null && ne !== void 0 ? ne : 0, Fr = $e + (st !== "center" ? "-" + st : ""), zn = typeof Rn == "number" ? Rn : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...Rn
  }, Fe = Array.isArray(En) ? En : [
    En
  ], pe = Fe.length > 0, it = {
    padding: zn,
    boundary: Fe.filter(Ov),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: pe
  }, { refs: xa, floatingStyles: wo, placement: _u, isPositioned: Oa, middlewareData: Os } = Ev({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: Fr,
    whileElementsMounted: (...Pu) => bv(...Pu, {
      animationFrame: _a === "always"
    }),
    elements: {
      reference: Ra.anchor
    },
    middleware: [
      Zm({
        mainAxis: Ne + Oe,
        alignmentAxis: Nr
      }),
      $n && gv({
        mainAxis: !0,
        crossAxis: !1,
        limiter: wa === "partial" ? xv() : void 0,
        ...it
      }),
      $n && hv({
        ...it
      }),
      $v({
        ...it,
        apply: ({ elements: Pu, rects: Lu, availableWidth: th, availableHeight: Zc }) => {
          const { width: N1, height: Gh } = Lu.reference, Mc = Pu.floating.style;
          Mc.setProperty("--radix-popper-available-width", `${th}px`), Mc.setProperty("--radix-popper-available-height", `${Zc}px`), Mc.setProperty("--radix-popper-anchor-width", `${N1}px`), Mc.setProperty("--radix-popper-anchor-height", `${Gh}px`);
        }
      }),
      fe && Cv({
        element: fe,
        padding: br
      }),
      Dv({
        arrowWidth: Se,
        arrowHeight: Oe
      }),
      Aa && wv({
        strategy: "referenceHidden",
        ...it
      })
    ]
  }), [Pa, Ml] = xs(_u), Su = Te$1(Ta);
  ke$1(() => {
    Oa && (Su == null || Su());
  }, [
    Oa,
    Su
  ]);
  const Tu = (ue = Os.arrow) === null || ue === void 0 ? void 0 : ue.x, Au = (le = Os.arrow) === null || le === void 0 ? void 0 : le.y, Zl = ((he = Os.arrow) === null || he === void 0 ? void 0 : he.centerOffset) !== 0, [Iu, Uc] = useState();
  return ke$1(() => {
    Yn && Uc(window.getComputedStyle(Yn).zIndex);
  }, [
    Yn
  ]), /* @__PURE__ */ createElement("div", {
    ref: xa.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...wo,
      transform: Oa ? wo.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Iu,
      "--radix-popper-transform-origin": [
        (ge = Os.transformOrigin) === null || ge === void 0 ? void 0 : ge.x,
        (we = Os.transformOrigin) === null || we === void 0 ? void 0 : we.y
      ].join(" ")
    },
    dir: v.dir
  }, /* @__PURE__ */ createElement(Av, {
    scope: xe,
    placedSide: Pa,
    onArrowChange: be,
    arrowX: Tu,
    arrowY: Au,
    shouldHideArrow: Zl
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-side": Pa,
    "data-align": Ml
  }, Zn, {
    ref: ct,
    style: {
      ...Zn.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: Oa ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (Ee = Os.hide) !== null && Ee !== void 0 && Ee.referenceHidden ? 0 : void 0
    }
  }))));
});
function Ov(v) {
  return v !== null;
}
const Dv = (v) => ({
  name: "transformOrigin",
  options: v,
  fn(y) {
    var z, ne, ue, le, he;
    const { placement: ge, rects: we, middlewareData: Ee } = y, xe = ((z = Ee.arrow) === null || z === void 0 ? void 0 : z.centerOffset) !== 0, $e = xe ? 0 : v.arrowWidth, Ne = xe ? 0 : v.arrowHeight, [st, Nr] = xs(ge), br = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[Nr], $n = ((ne = (ue = Ee.arrow) === null || ue === void 0 ? void 0 : ue.x) !== null && ne !== void 0 ? ne : 0) + $e / 2, En = ((le = (he = Ee.arrow) === null || he === void 0 ? void 0 : he.y) !== null && le !== void 0 ? le : 0) + Ne / 2;
    let Rn = "", wa = "";
    return st === "bottom" ? (Rn = xe ? br : `${$n}px`, wa = `${-Ne}px`) : st === "top" ? (Rn = xe ? br : `${$n}px`, wa = `${we.floating.height + Ne}px`) : st === "right" ? (Rn = `${-Ne}px`, wa = xe ? br : `${En}px`) : st === "left" && (Rn = `${we.floating.width + Ne}px`, wa = xe ? br : `${En}px`), {
      data: {
        x: Rn,
        y: wa
      }
    };
  }
});
function xs(v) {
  const [y, z = "center"] = v.split("-");
  return [
    y,
    z
  ];
}
const Un$1 = Pv, Fo = Rv, zo = Tv, vr = "rovingFocusGroup.onEntryFocus", Mv = {
  bubbles: !1,
  cancelable: !0
}, ia = "RovingFocusGroup", [Ar, ys, Iv] = xo(ia), [Nv, bn$7] = Le(ia, [
  Iv
]), [kv, Lv] = Nv(ia), Fv = /* @__PURE__ */ forwardRef((v, y) => /* @__PURE__ */ createElement(Ar.Provider, {
  scope: v.__scopeRovingFocusGroup
}, /* @__PURE__ */ createElement(Ar.Slot, {
  scope: v.__scopeRovingFocusGroup
}, /* @__PURE__ */ createElement(zv, _$2({}, v, {
  ref: y
}))))), zv = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRovingFocusGroup: z, orientation: ne, loop: ue = !1, dir: le, currentTabStopId: he, defaultCurrentTabStopId: ge, onCurrentTabStopIdChange: we, onEntryFocus: Ee, ...xe } = v, $e = useRef(null), Ne = de(y, $e), st = Kt$1(le), [Nr = null, br] = Be$1({
    prop: he,
    defaultProp: ge,
    onChange: we
  }), [$n, En] = useState(!1), Rn = Te$1(Ee), wa = ys(z), Aa = useRef(!1), [_a, Ta] = useState(0);
  return useEffect(() => {
    const Zn = $e.current;
    if (Zn)
      return Zn.addEventListener(vr, Rn), () => Zn.removeEventListener(vr, Rn);
  }, [
    Rn
  ]), /* @__PURE__ */ createElement(kv, {
    scope: z,
    orientation: ne,
    dir: st,
    loop: ue,
    currentTabStopId: Nr,
    onItemFocus: useCallback(
      (Zn) => br(Zn),
      [
        br
      ]
    ),
    onItemShiftTab: useCallback(
      () => En(!0),
      []
    ),
    onFocusableItemAdd: useCallback(
      () => Ta(
        (Zn) => Zn + 1
      ),
      []
    ),
    onFocusableItemRemove: useCallback(
      () => Ta(
        (Zn) => Zn - 1
      ),
      []
    )
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    tabIndex: $n || _a === 0 ? -1 : 0,
    "data-orientation": ne
  }, xe, {
    ref: Ne,
    style: {
      outline: "none",
      ...v.style
    },
    onMouseDown: H$2(v.onMouseDown, () => {
      Aa.current = !0;
    }),
    onFocus: H$2(v.onFocus, (Zn) => {
      const Ra = !Aa.current;
      if (Zn.target === Zn.currentTarget && Ra && !$n) {
        const Yn = new CustomEvent(vr, Mv);
        if (Zn.currentTarget.dispatchEvent(Yn), !Yn.defaultPrevented) {
          const $o = wa().filter(
            (ye) => ye.focusable
          ), ct = $o.find(
            (ye) => ye.active
          ), fe = $o.find(
            (ye) => ye.id === Nr
          ), be = [
            ct,
            fe,
            ...$o
          ].filter(Boolean).map(
            (ye) => ye.ref.current
          );
          Cs(be);
        }
      }
      Aa.current = !1;
    }),
    onBlur: H$2(
      v.onBlur,
      () => En(!1)
    )
  })));
}), jv = "RovingFocusGroupItem", Hv = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRovingFocusGroup: z, focusable: ne = !0, active: ue = !1, tabStopId: le, ...he } = v, ge = je$1(), we = le || ge, Ee = Lv(jv, z), xe = Ee.currentTabStopId === we, $e = ys(z), { onFocusableItemAdd: Ne, onFocusableItemRemove: st } = Ee;
  return useEffect(() => {
    if (ne)
      return Ne(), () => st();
  }, [
    ne,
    Ne,
    st
  ]), /* @__PURE__ */ createElement(Ar.ItemSlot, {
    scope: z,
    id: we,
    focusable: ne,
    active: ue
  }, /* @__PURE__ */ createElement(X$2.span, _$2({
    tabIndex: xe ? 0 : -1,
    "data-orientation": Ee.orientation
  }, he, {
    ref: y,
    onMouseDown: H$2(v.onMouseDown, (Nr) => {
      ne ? Ee.onItemFocus(we) : Nr.preventDefault();
    }),
    onFocus: H$2(
      v.onFocus,
      () => Ee.onItemFocus(we)
    ),
    onKeyDown: H$2(v.onKeyDown, (Nr) => {
      if (Nr.key === "Tab" && Nr.shiftKey) {
        Ee.onItemShiftTab();
        return;
      }
      if (Nr.target !== Nr.currentTarget)
        return;
      const br = Wv(Nr, Ee.orientation, Ee.dir);
      if (br !== void 0) {
        Nr.preventDefault();
        let $n = $e().filter(
          (En) => En.focusable
        ).map(
          (En) => En.ref.current
        );
        if (br === "last")
          $n.reverse();
        else if (br === "prev" || br === "next") {
          br === "prev" && $n.reverse();
          const En = $n.indexOf(Nr.currentTarget);
          $n = Ee.loop ? Uv($n, En + 1) : $n.slice(En + 1);
        }
        setTimeout(
          () => Cs($n)
        );
      }
    })
  })));
}), Vv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Bv(v, y) {
  return y !== "rtl" ? v : v === "ArrowLeft" ? "ArrowRight" : v === "ArrowRight" ? "ArrowLeft" : v;
}
function Wv(v, y, z) {
  const ne = Bv(v.key, z);
  if (!(y === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(ne)) && !(y === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(ne)))
    return Vv[ne];
}
function Cs(v) {
  const y = document.activeElement;
  for (const z of v)
    if (z === y || (z.focus(), document.activeElement !== y))
      return;
}
function Uv(v, y) {
  return v.map(
    (z, ne) => v[(y + ne) % v.length]
  );
}
const sa = Fv, la = Hv, Tr = [
  "Enter",
  " "
], Kv = [
  "ArrowDown",
  "PageUp",
  "Home"
], Es = [
  "ArrowUp",
  "PageDown",
  "End"
], Gv = [
  ...Kv,
  ...Es
], Zv = {
  ltr: [
    ...Tr,
    "ArrowRight"
  ],
  rtl: [
    ...Tr,
    "ArrowLeft"
  ]
}, Yv = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, jo = "Menu", [Mn$1, Xv, qv] = xo(jo), [Gt$1, Ss] = Le(jo, [
  qv,
  Rt$1,
  bn$7
]), Ho = Rt$1(), Ps = bn$7(), [_s, At$1] = Gt$1(jo), [Jv, Kn$1] = Gt$1(jo), Rs = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, ...ne } = v, ue = Ho(z);
  return /* @__PURE__ */ createElement(Fo, _$2({}, ue, ne, {
    ref: y
  }));
}), As = "MenuPortal", [e1, Ts] = Gt$1(As, {
  forceMount: void 0
}), t1 = (v) => {
  const { __scopeMenu: y, forceMount: z, children: ne, container: ue } = v, le = At$1(As, y);
  return /* @__PURE__ */ createElement(e1, {
    scope: y,
    forceMount: z
  }, /* @__PURE__ */ createElement(Ie, {
    present: z || le.open
  }, /* @__PURE__ */ createElement(Ao, {
    asChild: !0,
    container: ue
  }, ne)));
}, tt = "MenuContent", [n1, ua] = Gt$1(tt), o1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Ts(tt, v.__scopeMenu), { forceMount: ne = z.forceMount, ...ue } = v, le = At$1(tt, v.__scopeMenu), he = Kn$1(tt, v.__scopeMenu);
  return /* @__PURE__ */ createElement(Mn$1.Provider, {
    scope: v.__scopeMenu
  }, /* @__PURE__ */ createElement(Ie, {
    present: ne || le.open
  }, /* @__PURE__ */ createElement(Mn$1.Slot, {
    scope: v.__scopeMenu
  }, he.modal ? /* @__PURE__ */ createElement(r1, _$2({}, ue, {
    ref: y
  })) : /* @__PURE__ */ createElement(a1, _$2({}, ue, {
    ref: y
  })))));
}), r1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = At$1(tt, v.__scopeMenu), ne = useRef(null), ue = de(y, ne);
  return useEffect(() => {
    const le = ne.current;
    if (le)
      return Mo(le);
  }, []), /* @__PURE__ */ createElement(da, _$2({}, v, {
    ref: ue,
    trapFocus: z.open,
    disableOutsidePointerEvents: z.open,
    disableOutsideScroll: !0,
    onFocusOutside: H$2(
      v.onFocusOutside,
      (le) => le.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => z.onOpenChange(!1)
  }));
}), a1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = At$1(tt, v.__scopeMenu);
  return /* @__PURE__ */ createElement(da, _$2({}, v, {
    ref: y,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => z.onOpenChange(!1)
  }));
}), da = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, loop: ne = !1, trapFocus: ue, onOpenAutoFocus: le, onCloseAutoFocus: he, disableOutsidePointerEvents: ge, onEntryFocus: we, onEscapeKeyDown: Ee, onPointerDownOutside: xe, onFocusOutside: $e, onInteractOutside: Ne, onDismiss: st, disableOutsideScroll: Nr, ...br } = v, $n = At$1(tt, z), En = Kn$1(tt, z), Rn = Ho(z), wa = Ps(z), Aa = Xv(z), [_a, Ta] = useState(null), Zn = useRef(null), Ra = de(y, Zn, $n.onContentChange), Yn = useRef(0), $o = useRef(""), ct = useRef(0), fe = useRef(null), be = useRef("right"), ye = useRef(0), Se = Nr ? Do : Fragment, Oe = Nr ? {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: !0
  } : void 0, Fr = (Fe) => {
    var pe, it;
    const xa = $o.current + Fe, wo = Aa().filter(
      (Su) => !Su.disabled
    ), _u = document.activeElement, Oa = (pe = wo.find(
      (Su) => Su.ref.current === _u
    )) === null || pe === void 0 ? void 0 : pe.textValue, Os = wo.map(
      (Su) => Su.textValue
    ), Pa = E1(Os, xa, Oa), Ml = (it = wo.find(
      (Su) => Su.textValue === Pa
    )) === null || it === void 0 ? void 0 : it.ref.current;
    (function Su(Tu) {
      $o.current = Tu, window.clearTimeout(Yn.current), Tu !== "" && (Yn.current = window.setTimeout(
        () => Su(""),
        1e3
      ));
    })(xa), Ml && setTimeout(
      () => Ml.focus()
    );
  };
  useEffect(() => () => window.clearTimeout(Yn.current), []), To();
  const zn = useCallback((Fe) => {
    var pe, it;
    return be.current === ((pe = fe.current) === null || pe === void 0 ? void 0 : pe.side) && P1$1(Fe, (it = fe.current) === null || it === void 0 ? void 0 : it.area);
  }, []);
  return /* @__PURE__ */ createElement(n1, {
    scope: z,
    searchRef: $o,
    onItemEnter: useCallback((Fe) => {
      zn(Fe) && Fe.preventDefault();
    }, [
      zn
    ]),
    onItemLeave: useCallback((Fe) => {
      var pe;
      zn(Fe) || ((pe = Zn.current) === null || pe === void 0 || pe.focus(), Ta(null));
    }, [
      zn
    ]),
    onTriggerLeave: useCallback((Fe) => {
      zn(Fe) && Fe.preventDefault();
    }, [
      zn
    ]),
    pointerGraceTimerRef: ct,
    onPointerGraceIntentChange: useCallback((Fe) => {
      fe.current = Fe;
    }, [])
  }, /* @__PURE__ */ createElement(Se, Oe, /* @__PURE__ */ createElement(Ro, {
    asChild: !0,
    trapped: ue,
    onMountAutoFocus: H$2(le, (Fe) => {
      var pe;
      Fe.preventDefault(), (pe = Zn.current) === null || pe === void 0 || pe.focus();
    }),
    onUnmountAutoFocus: he
  }, /* @__PURE__ */ createElement(jn, {
    asChild: !0,
    disableOutsidePointerEvents: ge,
    onEscapeKeyDown: Ee,
    onPointerDownOutside: xe,
    onFocusOutside: $e,
    onInteractOutside: Ne,
    onDismiss: st
  }, /* @__PURE__ */ createElement(sa, _$2({
    asChild: !0
  }, wa, {
    dir: En.dir,
    orientation: "vertical",
    loop: ne,
    currentTabStopId: _a,
    onCurrentTabStopIdChange: Ta,
    onEntryFocus: H$2(we, (Fe) => {
      En.isUsingKeyboardRef.current || Fe.preventDefault();
    })
  }), /* @__PURE__ */ createElement(zo, _$2({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": Ls($n.open),
    "data-radix-menu-content": "",
    dir: En.dir
  }, Rn, br, {
    ref: Ra,
    style: {
      outline: "none",
      ...br.style
    },
    onKeyDown: H$2(br.onKeyDown, (Fe) => {
      const pe = Fe.target.closest("[data-radix-menu-content]") === Fe.currentTarget, it = Fe.ctrlKey || Fe.altKey || Fe.metaKey, xa = Fe.key.length === 1;
      pe && (Fe.key === "Tab" && Fe.preventDefault(), !it && xa && Fr(Fe.key));
      const wo = Zn.current;
      if (Fe.target !== wo || !Gv.includes(Fe.key))
        return;
      Fe.preventDefault();
      const _u = Aa().filter(
        (Oa) => !Oa.disabled
      ).map(
        (Oa) => Oa.ref.current
      );
      Es.includes(Fe.key) && _u.reverse(), y1(_u);
    }),
    onBlur: H$2(v.onBlur, (Fe) => {
      Fe.currentTarget.contains(Fe.target) || (window.clearTimeout(Yn.current), $o.current = "");
    }),
    onPointerMove: H$2(v.onPointerMove, In((Fe) => {
      const pe = Fe.target, it = ye.current !== Fe.clientX;
      if (Fe.currentTarget.contains(pe) && it) {
        const xa = Fe.clientX > ye.current ? "right" : "left";
        be.current = xa, ye.current = Fe.clientX;
      }
    }))
  })))))));
}), c1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, ...ne } = v;
  return /* @__PURE__ */ createElement(X$2.div, _$2({}, ne, {
    ref: y
  }));
}), Or = "MenuItem", Ac = "menu.itemSelect", fa = /* @__PURE__ */ forwardRef((v, y) => {
  const { disabled: z = !1, onSelect: ne, ...ue } = v, le = useRef(null), he = Kn$1(Or, v.__scopeMenu), ge = ua(Or, v.__scopeMenu), we = de(y, le), Ee = useRef(!1), xe = () => {
    const $e = le.current;
    if (!z && $e) {
      const Ne = new CustomEvent(Ac, {
        bubbles: !0,
        cancelable: !0
      });
      $e.addEventListener(
        Ac,
        (st) => ne == null ? void 0 : ne(st),
        {
          once: !0
        }
      ), Yc($e, Ne), Ne.defaultPrevented ? Ee.current = !1 : he.onClose();
    }
  };
  return /* @__PURE__ */ createElement(Ds, _$2({}, ue, {
    ref: we,
    disabled: z,
    onClick: H$2(v.onClick, xe),
    onPointerDown: ($e) => {
      var Ne;
      (Ne = v.onPointerDown) === null || Ne === void 0 || Ne.call(v, $e), Ee.current = !0;
    },
    onPointerUp: H$2(v.onPointerUp, ($e) => {
      var Ne;
      Ee.current || (Ne = $e.currentTarget) === null || Ne === void 0 || Ne.click();
    }),
    onKeyDown: H$2(v.onKeyDown, ($e) => {
      const Ne = ge.searchRef.current !== "";
      z || Ne && $e.key === " " || Tr.includes($e.key) && ($e.currentTarget.click(), $e.preventDefault());
    })
  }));
}), Ds = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, disabled: ne = !1, textValue: ue, ...le } = v, he = ua(Or, z), ge = Ps(z), we = useRef(null), Ee = de(y, we), [xe, $e] = useState(!1), [Ne, st] = useState("");
  return useEffect(() => {
    const Nr = we.current;
    if (Nr) {
      var br;
      st(((br = Nr.textContent) !== null && br !== void 0 ? br : "").trim());
    }
  }, [
    le.children
  ]), /* @__PURE__ */ createElement(Mn$1.ItemSlot, {
    scope: z,
    disabled: ne,
    textValue: ue ?? Ne
  }, /* @__PURE__ */ createElement(la, _$2({
    asChild: !0
  }, ge, {
    focusable: !ne
  }), /* @__PURE__ */ createElement(X$2.div, _$2({
    role: "menuitem",
    "data-highlighted": xe ? "" : void 0,
    "aria-disabled": ne || void 0,
    "data-disabled": ne ? "" : void 0
  }, le, {
    ref: Ee,
    onPointerMove: H$2(v.onPointerMove, In((Nr) => {
      ne ? he.onItemLeave(Nr) : (he.onItemEnter(Nr), Nr.defaultPrevented || Nr.currentTarget.focus());
    })),
    onPointerLeave: H$2(v.onPointerLeave, In(
      (Nr) => he.onItemLeave(Nr)
    )),
    onFocus: H$2(
      v.onFocus,
      () => $e(!0)
    ),
    onBlur: H$2(
      v.onBlur,
      () => $e(!1)
    )
  }))));
}), i1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { checked: z = !1, onCheckedChange: ne, ...ue } = v;
  return /* @__PURE__ */ createElement(Is, {
    scope: v.__scopeMenu,
    checked: z
  }, /* @__PURE__ */ createElement(fa, _$2({
    role: "menuitemcheckbox",
    "aria-checked": go(z) ? "mixed" : z
  }, ue, {
    ref: y,
    "data-state": pa(z),
    onSelect: H$2(
      ue.onSelect,
      () => ne == null ? void 0 : ne(go(z) ? !0 : !z),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), s1 = "MenuRadioGroup", [l1, u1] = Gt$1(s1, {
  value: void 0,
  onValueChange: () => {
  }
}), f1 = "MenuRadioItem", p1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { value: z, ...ne } = v, ue = u1(f1, v.__scopeMenu), le = z === ue.value;
  return /* @__PURE__ */ createElement(Is, {
    scope: v.__scopeMenu,
    checked: le
  }, /* @__PURE__ */ createElement(fa, _$2({
    role: "menuitemradio",
    "aria-checked": le
  }, ne, {
    ref: y,
    "data-state": pa(le),
    onSelect: H$2(ne.onSelect, () => {
      var he;
      return (he = ue.onValueChange) === null || he === void 0 ? void 0 : he.call(ue, z);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), Ms = "MenuItemIndicator", [Is, m1] = Gt$1(Ms, {
  checked: !1
}), v1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, forceMount: ne, ...ue } = v, le = m1(Ms, z);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || go(le.checked) || le.checked === !0
  }, /* @__PURE__ */ createElement(X$2.span, _$2({}, ue, {
    ref: y,
    "data-state": pa(le.checked)
  })));
}), b1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeMenu: z, ...ne } = v;
  return /* @__PURE__ */ createElement(X$2.div, _$2({
    role: "separator",
    "aria-orientation": "horizontal"
  }, ne, {
    ref: y
  }));
}), Ns = "MenuSub", [g1, ks] = Gt$1(Ns), ao = "MenuSubTrigger", $1$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = At$1(ao, v.__scopeMenu), ne = Kn$1(ao, v.__scopeMenu), ue = ks(ao, v.__scopeMenu), le = ua(ao, v.__scopeMenu), he = useRef(null), { pointerGraceTimerRef: ge, onPointerGraceIntentChange: we } = le, Ee = {
    __scopeMenu: v.__scopeMenu
  }, xe = useCallback(() => {
    he.current && window.clearTimeout(he.current), he.current = null;
  }, []);
  return useEffect(
    () => xe,
    [
      xe
    ]
  ), useEffect(() => {
    const $e = ge.current;
    return () => {
      window.clearTimeout($e), we(null);
    };
  }, [
    ge,
    we
  ]), /* @__PURE__ */ createElement(Rs, _$2({
    asChild: !0
  }, Ee), /* @__PURE__ */ createElement(Ds, _$2({
    id: ue.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": z.open,
    "aria-controls": ue.contentId,
    "data-state": Ls(z.open)
  }, v, {
    ref: zr(y, ue.onTriggerChange),
    onClick: ($e) => {
      var Ne;
      (Ne = v.onClick) === null || Ne === void 0 || Ne.call(v, $e), !(v.disabled || $e.defaultPrevented) && ($e.currentTarget.focus(), z.open || z.onOpenChange(!0));
    },
    onPointerMove: H$2(v.onPointerMove, In(($e) => {
      le.onItemEnter($e), !$e.defaultPrevented && !v.disabled && !z.open && !he.current && (le.onPointerGraceIntentChange(null), he.current = window.setTimeout(() => {
        z.onOpenChange(!0), xe();
      }, 100));
    })),
    onPointerLeave: H$2(v.onPointerLeave, In(($e) => {
      var Ne;
      xe();
      const st = (Ne = z.content) === null || Ne === void 0 ? void 0 : Ne.getBoundingClientRect();
      if (st) {
        var Nr;
        const br = (Nr = z.content) === null || Nr === void 0 ? void 0 : Nr.dataset.side, $n = br === "right", En = $n ? -5 : 5, Rn = st[$n ? "left" : "right"], wa = st[$n ? "right" : "left"];
        le.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: $e.clientX + En,
              y: $e.clientY
            },
            {
              x: Rn,
              y: st.top
            },
            {
              x: wa,
              y: st.top
            },
            {
              x: wa,
              y: st.bottom
            },
            {
              x: Rn,
              y: st.bottom
            }
          ],
          side: br
        }), window.clearTimeout(ge.current), ge.current = window.setTimeout(
          () => le.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (le.onTriggerLeave($e), $e.defaultPrevented)
          return;
        le.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: H$2(v.onKeyDown, ($e) => {
      const Ne = le.searchRef.current !== "";
      if (!(v.disabled || Ne && $e.key === " ") && Zv[ne.dir].includes($e.key)) {
        var st;
        z.onOpenChange(!0), (st = z.content) === null || st === void 0 || st.focus(), $e.preventDefault();
      }
    })
  })));
}), w1 = "MenuSubContent", x1 = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Ts(tt, v.__scopeMenu), { forceMount: ne = z.forceMount, ...ue } = v, le = At$1(tt, v.__scopeMenu), he = Kn$1(tt, v.__scopeMenu), ge = ks(w1, v.__scopeMenu), we = useRef(null), Ee = de(y, we);
  return /* @__PURE__ */ createElement(Mn$1.Provider, {
    scope: v.__scopeMenu
  }, /* @__PURE__ */ createElement(Ie, {
    present: ne || le.open
  }, /* @__PURE__ */ createElement(Mn$1.Slot, {
    scope: v.__scopeMenu
  }, /* @__PURE__ */ createElement(da, _$2({
    id: ge.contentId,
    "aria-labelledby": ge.triggerId
  }, ue, {
    ref: Ee,
    align: "start",
    side: he.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (xe) => {
      var $e;
      he.isUsingKeyboardRef.current && (($e = we.current) === null || $e === void 0 || $e.focus()), xe.preventDefault();
    },
    onCloseAutoFocus: (xe) => xe.preventDefault(),
    onFocusOutside: H$2(v.onFocusOutside, (xe) => {
      xe.target !== ge.trigger && le.onOpenChange(!1);
    }),
    onEscapeKeyDown: H$2(v.onEscapeKeyDown, (xe) => {
      he.onClose(), xe.preventDefault();
    }),
    onKeyDown: H$2(v.onKeyDown, (xe) => {
      const $e = xe.currentTarget.contains(xe.target), Ne = Yv[he.dir].includes(xe.key);
      if ($e && Ne) {
        var st;
        le.onOpenChange(!1), (st = ge.trigger) === null || st === void 0 || st.focus(), xe.preventDefault();
      }
    })
  })))));
});
function Ls(v) {
  return v ? "open" : "closed";
}
function go(v) {
  return v === "indeterminate";
}
function pa(v) {
  return go(v) ? "indeterminate" : v ? "checked" : "unchecked";
}
function y1(v) {
  const y = document.activeElement;
  for (const z of v)
    if (z === y || (z.focus(), document.activeElement !== y))
      return;
}
function C1(v, y) {
  return v.map(
    (z, ne) => v[(y + ne) % v.length]
  );
}
function E1(v, y, z) {
  const ne = y.length > 1 && Array.from(y).every(
    (ge) => ge === y[0]
  ) ? y[0] : y, ue = z ? v.indexOf(z) : -1;
  let le = C1(v, Math.max(ue, 0));
  ne.length === 1 && (le = le.filter(
    (ge) => ge !== z
  ));
  const he = le.find(
    (ge) => ge.toLowerCase().startsWith(ne.toLowerCase())
  );
  return he !== z ? he : void 0;
}
function S1(v, y) {
  const { x: z, y: ne } = v;
  let ue = !1;
  for (let le = 0, he = y.length - 1; le < y.length; he = le++) {
    const ge = y[le].x, we = y[le].y, Ee = y[he].x, xe = y[he].y;
    we > ne != xe > ne && z < (Ee - ge) * (ne - we) / (xe - we) + ge && (ue = !ue);
  }
  return ue;
}
function P1$1(v, y) {
  if (!y)
    return !1;
  const z = {
    x: v.clientX,
    y: v.clientY
  };
  return S1(z, y);
}
function In(v) {
  return (y) => y.pointerType === "mouse" ? v(y) : void 0;
}
const A1 = t1, T1$1 = o1, D1 = c1, M1 = fa, I1 = i1, k1 = p1, L1 = v1, F1 = b1, j1 = $1$1, H1 = x1, Fs = "DropdownMenu", [V1, aw] = Le(Fs, [
  Ss
]), We$1 = Ss(), [B1$1, zs] = V1(Fs), G1$1 = (v) => {
  const { __scopeDropdownMenu: y, ...z } = v, ne = We$1(y);
  return /* @__PURE__ */ createElement(A1, _$2({}, ne, z));
}, Z1 = "DropdownMenuContent", Y1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = zs(Z1, z), le = We$1(z), he = useRef(!1);
  return /* @__PURE__ */ createElement(T1$1, _$2({
    id: ue.contentId,
    "aria-labelledby": ue.triggerId
  }, le, ne, {
    ref: y,
    onCloseAutoFocus: H$2(v.onCloseAutoFocus, (ge) => {
      var we;
      he.current || (we = ue.triggerRef.current) === null || we === void 0 || we.focus(), he.current = !1, ge.preventDefault();
    }),
    onInteractOutside: H$2(v.onInteractOutside, (ge) => {
      const we = ge.detail.originalEvent, Ee = we.button === 0 && we.ctrlKey === !0, xe = we.button === 2 || Ee;
      (!ue.modal || xe) && (he.current = !0);
    }),
    style: {
      ...v.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), q1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(D1, _$2({}, ue, ne, {
    ref: y
  }));
}), J1$1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(M1, _$2({}, ue, ne, {
    ref: y
  }));
}), Q1 = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(I1, _$2({}, ue, ne, {
    ref: y
  }));
}), tb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(k1, _$2({}, ue, ne, {
    ref: y
  }));
}), nb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(L1, _$2({}, ue, ne, {
    ref: y
  }));
}), ob = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(F1, _$2({}, ue, ne, {
    ref: y
  }));
}), ab = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(j1, _$2({}, ue, ne, {
    ref: y
  }));
}), cb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeDropdownMenu: z, ...ne } = v, ue = We$1(z);
  return /* @__PURE__ */ createElement(H1, _$2({}, ue, ne, {
    ref: y,
    style: {
      ...v.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), js = G1$1, Hs = Y1, Vs = q1, Bs = J1$1, Ws = Q1, Us = tb, db = nb, Ks = ob, Gs = ab, Zs = cb, pb = a$z.forwardRef(({ className: v, inset: y, children: z, ...ne }, ue) => /* @__PURE__ */ D$6.jsxs(
  Gs,
  {
    ref: ue,
    className: Y$1(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      y && "pl-8",
      v
    ),
    ...ne,
    children: [
      z,
      /* @__PURE__ */ D$6.jsx(si, { className: "ml-auto h-4 w-4" })
    ]
  }
));
pb.displayName = Gs.displayName;
const mb = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Zs,
  {
    ref: z,
    className: Y$1(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      v
    ),
    ...y
  }
));
mb.displayName = Zs.displayName;
const vb = a$z.forwardRef(({ className: v, sideOffset: y = 4, ...z }, ne) => /* @__PURE__ */ D$6.jsx(js, { container: Bn$1(), children: /* @__PURE__ */ D$6.jsx(
  Hs,
  {
    ref: ne,
    sideOffset: y,
    className: Y$1(
      "z-50 overflow-hidden  outline-none rounded-md border bg-popover px-3 py-1.5 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      v
    ),
    ...z
  }
) }));
vb.displayName = Hs.displayName;
const bb = a$z.forwardRef(({ className: v, inset: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  Bs,
  {
    ref: ne,
    className: Y$1(
      "relative flex cursor-default select-none items-center text-popover-foreground rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      y && "pl-8",
      v
    ),
    ...z
  }
));
bb.displayName = Bs.displayName;
const gb = a$z.forwardRef(({ className: v, children: y, checked: z, ...ne }, ue) => /* @__PURE__ */ D$6.jsxs(
  Ws,
  {
    ref: ue,
    className: Y$1(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      v
    ),
    checked: z,
    ...ne,
    children: [
      /* @__PURE__ */ D$6.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ D$6.jsx(db, { children: /* @__PURE__ */ D$6.jsx(So, { className: "h-4 w-4" }) }) }),
      y
    ]
  }
));
gb.displayName = Ws.displayName;
const hb = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  Us,
  {
    ref: ne,
    className: Y$1(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      v
    ),
    ...z,
    children: y
  }
));
hb.displayName = Us.displayName;
const $b = a$z.forwardRef(({ className: v, inset: y, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  Vs,
  {
    ref: ne,
    className: Y$1(
      "px-2 py-1.5 text-sm font-semibold",
      y && "pl-8",
      v
    ),
    ...z
  }
));
$b.displayName = Vs.displayName;
const wb = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Ks,
  {
    ref: z,
    className: Y$1("-mx-1 my-1 h-px bg-muted", v),
    ...y
  }
));
wb.displayName = Ks.displayName;
const yb = cva("", {
  variants: {
    variant: {
      default: "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      unstyled: "flex h-10 w-full bg-transparent placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Cb = a$z.forwardRef(
  ({ className: v, type: y, variant: z, ...ne }, ue) => /* @__PURE__ */ D$6.jsx(
    "input",
    {
      type: y,
      className: Y$1(
        yb({
          variant: z,
          className: v
        })
      ),
      ref: ue,
      ...ne
    }
  )
);
Cb.displayName = "Input";
const Eb = /* @__PURE__ */ forwardRef((v, y) => /* @__PURE__ */ createElement(X$2.label, _$2({}, v, {
  ref: y,
  onMouseDown: (z) => {
    var ne;
    (ne = v.onMouseDown) === null || ne === void 0 || ne.call(v, z), !z.defaultPrevented && z.detail > 1 && z.preventDefault();
  }
}))), Ys = Eb, Sb = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Pb = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Ys,
  {
    ref: z,
    className: Y$1(Sb(), v),
    ...y
  }
));
Pb.displayName = Ys.displayName;
const Xs = "Popover", [qs, fw] = Le(Xs, [
  Rt$1
]), ma = Rt$1(), [_b, gn$1] = qs(Xs), Rb = (v) => {
  const { __scopePopover: y, children: z, open: ne, defaultOpen: ue, onOpenChange: le, modal: he = !1 } = v, ge = ma(y), we = useRef(null), [Ee, xe] = useState(!1), [$e = !1, Ne] = Be$1({
    prop: ne,
    defaultProp: ue,
    onChange: le
  });
  return /* @__PURE__ */ createElement(Un$1, ge, /* @__PURE__ */ createElement(_b, {
    scope: y,
    contentId: je$1(),
    triggerRef: we,
    open: $e,
    onOpenChange: Ne,
    onOpenToggle: useCallback(
      () => Ne(
        (st) => !st
      ),
      [
        Ne
      ]
    ),
    hasCustomAnchor: Ee,
    onCustomAnchorAdd: useCallback(
      () => xe(!0),
      []
    ),
    onCustomAnchorRemove: useCallback(
      () => xe(!1),
      []
    ),
    modal: he
  }, z));
}, Ab = "PopoverTrigger", Tb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopePopover: z, ...ne } = v, ue = gn$1(Ab, z), le = ma(z), he = de(y, ue.triggerRef), ge = /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": ue.open,
    "aria-controls": ue.contentId,
    "data-state": el(ue.open)
  }, ne, {
    ref: he,
    onClick: H$2(v.onClick, ue.onOpenToggle)
  }));
  return ue.hasCustomAnchor ? ge : /* @__PURE__ */ createElement(Fo, _$2({
    asChild: !0
  }, le), ge);
}), Js = "PopoverPortal", [Ob, Db] = qs(Js, {
  forceMount: void 0
}), Mb = (v) => {
  const { __scopePopover: y, forceMount: z, children: ne, container: ue } = v, le = gn$1(Js, y);
  return /* @__PURE__ */ createElement(Ob, {
    scope: y,
    forceMount: z
  }, /* @__PURE__ */ createElement(Ie, {
    present: z || le.open
  }, /* @__PURE__ */ createElement(Ao, {
    asChild: !0,
    container: ue
  }, ne)));
}, Nn = "PopoverContent", Ib = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Db(Nn, v.__scopePopover), { forceMount: ne = z.forceMount, ...ue } = v, le = gn$1(Nn, v.__scopePopover);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || le.open
  }, le.modal ? /* @__PURE__ */ createElement(Nb, _$2({}, ue, {
    ref: y
  })) : /* @__PURE__ */ createElement(kb, _$2({}, ue, {
    ref: y
  })));
}), Nb = /* @__PURE__ */ forwardRef((v, y) => {
  const z = gn$1(Nn, v.__scopePopover), ne = useRef(null), ue = de(y, ne), le = useRef(!1);
  return useEffect(() => {
    const he = ne.current;
    if (he)
      return Mo(he);
  }, []), /* @__PURE__ */ createElement(Do, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: !0
  }, /* @__PURE__ */ createElement(Qs, _$2({}, v, {
    ref: ue,
    trapFocus: z.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: H$2(v.onCloseAutoFocus, (he) => {
      var ge;
      he.preventDefault(), le.current || (ge = z.triggerRef.current) === null || ge === void 0 || ge.focus();
    }),
    onPointerDownOutside: H$2(v.onPointerDownOutside, (he) => {
      const ge = he.detail.originalEvent, we = ge.button === 0 && ge.ctrlKey === !0, Ee = ge.button === 2 || we;
      le.current = Ee;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: H$2(
      v.onFocusOutside,
      (he) => he.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), kb = /* @__PURE__ */ forwardRef((v, y) => {
  const z = gn$1(Nn, v.__scopePopover), ne = useRef(!1), ue = useRef(!1);
  return /* @__PURE__ */ createElement(Qs, _$2({}, v, {
    ref: y,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (le) => {
      var he;
      if ((he = v.onCloseAutoFocus) === null || he === void 0 || he.call(v, le), !le.defaultPrevented) {
        var ge;
        ne.current || (ge = z.triggerRef.current) === null || ge === void 0 || ge.focus(), le.preventDefault();
      }
      ne.current = !1, ue.current = !1;
    },
    onInteractOutside: (le) => {
      var he, ge;
      (he = v.onInteractOutside) === null || he === void 0 || he.call(v, le), le.defaultPrevented || (ne.current = !0, le.detail.originalEvent.type === "pointerdown" && (ue.current = !0));
      const we = le.target;
      !((ge = z.triggerRef.current) === null || ge === void 0) && ge.contains(we) && le.preventDefault(), le.detail.originalEvent.type === "focusin" && ue.current && le.preventDefault();
    }
  }));
}), Qs = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopePopover: z, trapFocus: ne, onOpenAutoFocus: ue, onCloseAutoFocus: le, disableOutsidePointerEvents: he, onEscapeKeyDown: ge, onPointerDownOutside: we, onFocusOutside: Ee, onInteractOutside: xe, ...$e } = v, Ne = gn$1(Nn, z), st = ma(z);
  return To(), /* @__PURE__ */ createElement(Ro, {
    asChild: !0,
    loop: !0,
    trapped: ne,
    onMountAutoFocus: ue,
    onUnmountAutoFocus: le
  }, /* @__PURE__ */ createElement(jn, {
    asChild: !0,
    disableOutsidePointerEvents: he,
    onInteractOutside: xe,
    onEscapeKeyDown: ge,
    onPointerDownOutside: we,
    onFocusOutside: Ee,
    onDismiss: () => Ne.onOpenChange(!1)
  }, /* @__PURE__ */ createElement(zo, _$2({
    "data-state": el(Ne.open),
    role: "dialog",
    id: Ne.contentId
  }, st, $e, {
    ref: y,
    style: {
      ...$e.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function el(v) {
  return v ? "open" : "closed";
}
const Lb = Rb, Fb = Tb, zb = Mb, tl = Ib, pw = Lb, mw = Fb, jb = a$z.forwardRef(
  ({ className: v, align: y = "center", portalContainer: z, sideOffset: ne = 4, ...ue }, le) => {
    const he = Bn$1();
    return /* @__PURE__ */ D$6.jsx(zb, { container: z ?? he, children: /* @__PURE__ */ D$6.jsx(
      tl,
      {
        ref: le,
        align: y,
        sideOffset: ne,
        className: Y$1(
          "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          v
        ),
        ...ue
      }
    ) });
  }
);
jb.displayName = tl.displayName;
const nl = "Radio", [Hb, ol] = Le(nl), [Vb, Bb] = Hb(nl), Wb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRadio: z, name: ne, checked: ue = !1, required: le, disabled: he, value: ge = "on", onCheck: we, ...Ee } = v, [xe, $e] = useState(null), Ne = de(
    y,
    (br) => $e(br)
  ), st = useRef(!1), Nr = xe ? !!xe.closest("form") : !0;
  return /* @__PURE__ */ createElement(Vb, {
    scope: z,
    checked: ue,
    disabled: he
  }, /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    role: "radio",
    "aria-checked": ue,
    "data-state": rl(ue),
    "data-disabled": he ? "" : void 0,
    disabled: he,
    value: ge
  }, Ee, {
    ref: Ne,
    onClick: H$2(v.onClick, (br) => {
      ue || we == null || we(), Nr && (st.current = br.isPropagationStopped(), st.current || br.stopPropagation());
    })
  })), Nr && /* @__PURE__ */ createElement(Gb, {
    control: xe,
    bubbles: !st.current,
    name: ne,
    value: ge,
    checked: ue,
    required: le,
    disabled: he,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Ub = "RadioIndicator", Kb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRadio: z, forceMount: ne, ...ue } = v, le = Bb(Ub, z);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || le.checked
  }, /* @__PURE__ */ createElement(X$2.span, _$2({
    "data-state": rl(le.checked),
    "data-disabled": le.disabled ? "" : void 0
  }, ue, {
    ref: y
  })));
}), Gb = (v) => {
  const { control: y, checked: z, bubbles: ne = !0, ...ue } = v, le = useRef(null), he = Po(z), ge = _o(y);
  return useEffect(() => {
    const we = le.current, Ee = window.HTMLInputElement.prototype, xe = Object.getOwnPropertyDescriptor(Ee, "checked").set;
    if (he !== z && xe) {
      const $e = new Event("click", {
        bubbles: ne
      });
      xe.call(we, z), we.dispatchEvent($e);
    }
  }, [
    he,
    z,
    ne
  ]), /* @__PURE__ */ createElement("input", _$2({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: z
  }, ue, {
    tabIndex: -1,
    ref: le,
    style: {
      ...v.style,
      ...ge,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function rl(v) {
  return v ? "checked" : "unchecked";
}
const Zb = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], al = "RadioGroup", [Yb, vw$1] = Le(al, [
  bn$7,
  ol
]), cl = bn$7(), il = ol(), [Xb, qb] = Yb(al), Jb = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRadioGroup: z, name: ne, defaultValue: ue, value: le, required: he = !1, disabled: ge = !1, orientation: we, dir: Ee, loop: xe = !0, onValueChange: $e, ...Ne } = v, st = cl(z), Nr = Kt$1(Ee), [br, $n] = Be$1({
    prop: le,
    defaultProp: ue,
    onChange: $e
  });
  return /* @__PURE__ */ createElement(Xb, {
    scope: z,
    name: ne,
    required: he,
    disabled: ge,
    value: br,
    onValueChange: $n
  }, /* @__PURE__ */ createElement(sa, _$2({
    asChild: !0
  }, st, {
    orientation: we,
    dir: Nr,
    loop: xe
  }), /* @__PURE__ */ createElement(X$2.div, _$2({
    role: "radiogroup",
    "aria-required": he,
    "aria-orientation": we,
    "data-disabled": ge ? "" : void 0,
    dir: Nr
  }, Ne, {
    ref: y
  }))));
}), Qb = "RadioGroupItem", eg = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRadioGroup: z, disabled: ne, ...ue } = v, le = qb(Qb, z), he = le.disabled || ne, ge = cl(z), we = il(z), Ee = useRef(null), xe = de(y, Ee), $e = le.value === ue.value, Ne = useRef(!1);
  return useEffect(() => {
    const st = (br) => {
      Zb.includes(br.key) && (Ne.current = !0);
    }, Nr = () => Ne.current = !1;
    return document.addEventListener("keydown", st), document.addEventListener("keyup", Nr), () => {
      document.removeEventListener("keydown", st), document.removeEventListener("keyup", Nr);
    };
  }, []), /* @__PURE__ */ createElement(la, _$2({
    asChild: !0
  }, ge, {
    focusable: !he,
    active: $e
  }), /* @__PURE__ */ createElement(Wb, _$2({
    disabled: he,
    required: le.required,
    checked: $e
  }, we, ue, {
    name: le.name,
    ref: xe,
    onCheck: () => le.onValueChange(ue.value),
    onKeyDown: H$2((st) => {
      st.key === "Enter" && st.preventDefault();
    }),
    onFocus: H$2(ue.onFocus, () => {
      var st;
      Ne.current && ((st = Ee.current) === null || st === void 0 || st.click());
    })
  })));
}), tg = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeRadioGroup: z, ...ne } = v, ue = il(z);
  return /* @__PURE__ */ createElement(Kb, _$2({}, ue, ne, {
    ref: y
  }));
}), sl = Jb, ll = eg, ng = tg, og = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  sl,
  {
    className: Y$1("grid gap-2", v),
    ...y,
    ref: z
  }
));
og.displayName = sl.displayName;
const rg = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  ll,
  {
    ref: z,
    className: Y$1(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      v
    ),
    ...y,
    children: /* @__PURE__ */ D$6.jsx(ng, { className: "flex items-center justify-center", children: /* @__PURE__ */ D$6.jsx(ui, { weight: "fill", className: "h-2.5 w-2.5 text-current" }) })
  }
));
rg.displayName = ll.displayName;
function Dr(v, [y, z]) {
  return Math.min(z, Math.max(y, v));
}
function ag(v, y) {
  return useReducer((z, ne) => y[z][ne] ?? z, v);
}
const ul = "ScrollArea", [dl, bw] = Le(ul), [cg, et] = dl(ul), ig = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeScrollArea: z, type: ne = "hover", dir: ue, scrollHideDelay: le = 600, ...he } = v, [ge, we] = useState(null), [Ee, xe] = useState(null), [$e, Ne] = useState(null), [st, Nr] = useState(null), [br, $n] = useState(null), [En, Rn] = useState(0), [wa, Aa] = useState(0), [_a, Ta] = useState(!1), [Zn, Ra] = useState(!1), Yn = de(
    y,
    (ct) => we(ct)
  ), $o = Kt$1(ue);
  return /* @__PURE__ */ createElement(cg, {
    scope: z,
    type: ne,
    dir: $o,
    scrollHideDelay: le,
    scrollArea: ge,
    viewport: Ee,
    onViewportChange: xe,
    content: $e,
    onContentChange: Ne,
    scrollbarX: st,
    onScrollbarXChange: Nr,
    scrollbarXEnabled: _a,
    onScrollbarXEnabledChange: Ta,
    scrollbarY: br,
    onScrollbarYChange: $n,
    scrollbarYEnabled: Zn,
    onScrollbarYEnabledChange: Ra,
    onCornerWidthChange: Rn,
    onCornerHeightChange: Aa
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    dir: $o
  }, he, {
    ref: Yn,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      "--radix-scroll-area-corner-width": En + "px",
      "--radix-scroll-area-corner-height": wa + "px",
      ...v.style
    }
  })));
}), sg = "ScrollAreaViewport", lg = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeScrollArea: z, children: ne, ...ue } = v, le = et(sg, z), he = useRef(null), ge = de(y, he, le.onViewportChange);
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-radix-scroll-area-viewport": ""
  }, ue, {
    ref: ge,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: le.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: le.scrollbarYEnabled ? "scroll" : "hidden",
      ...v.style
    }
  }), /* @__PURE__ */ createElement("div", {
    ref: le.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, ne)));
}), gt$1 = "ScrollAreaScrollbar", fl = /* @__PURE__ */ forwardRef((v, y) => {
  const { forceMount: z, ...ne } = v, ue = et(gt$1, v.__scopeScrollArea), { onScrollbarXEnabledChange: le, onScrollbarYEnabledChange: he } = ue, ge = v.orientation === "horizontal";
  return useEffect(() => (ge ? le(!0) : he(!0), () => {
    ge ? le(!1) : he(!1);
  }), [
    ge,
    le,
    he
  ]), ue.type === "hover" ? /* @__PURE__ */ createElement(ug, _$2({}, ne, {
    ref: y,
    forceMount: z
  })) : ue.type === "scroll" ? /* @__PURE__ */ createElement(dg, _$2({}, ne, {
    ref: y,
    forceMount: z
  })) : ue.type === "auto" ? /* @__PURE__ */ createElement(pl, _$2({}, ne, {
    ref: y,
    forceMount: z
  })) : ue.type === "always" ? /* @__PURE__ */ createElement(va, _$2({}, ne, {
    ref: y
  })) : null;
}), ug = /* @__PURE__ */ forwardRef((v, y) => {
  const { forceMount: z, ...ne } = v, ue = et(gt$1, v.__scopeScrollArea), [le, he] = useState(!1);
  return useEffect(() => {
    const ge = ue.scrollArea;
    let we = 0;
    if (ge) {
      const Ee = () => {
        window.clearTimeout(we), he(!0);
      }, xe = () => {
        we = window.setTimeout(
          () => he(!1),
          ue.scrollHideDelay
        );
      };
      return ge.addEventListener("pointerenter", Ee), ge.addEventListener("pointerleave", xe), () => {
        window.clearTimeout(we), ge.removeEventListener("pointerenter", Ee), ge.removeEventListener("pointerleave", xe);
      };
    }
  }, [
    ue.scrollArea,
    ue.scrollHideDelay
  ]), /* @__PURE__ */ createElement(Ie, {
    present: z || le
  }, /* @__PURE__ */ createElement(pl, _$2({
    "data-state": le ? "visible" : "hidden"
  }, ne, {
    ref: y
  })));
}), dg = /* @__PURE__ */ forwardRef((v, y) => {
  const { forceMount: z, ...ne } = v, ue = et(gt$1, v.__scopeScrollArea), le = v.orientation === "horizontal", he = Bo(
    () => we("SCROLL_END"),
    100
  ), [ge, we] = ag("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return useEffect(() => {
    if (ge === "idle") {
      const Ee = window.setTimeout(
        () => we("HIDE"),
        ue.scrollHideDelay
      );
      return () => window.clearTimeout(Ee);
    }
  }, [
    ge,
    ue.scrollHideDelay,
    we
  ]), useEffect(() => {
    const Ee = ue.viewport, xe = le ? "scrollLeft" : "scrollTop";
    if (Ee) {
      let $e = Ee[xe];
      const Ne = () => {
        const st = Ee[xe];
        $e !== st && (we("SCROLL"), he()), $e = st;
      };
      return Ee.addEventListener("scroll", Ne), () => Ee.removeEventListener("scroll", Ne);
    }
  }, [
    ue.viewport,
    le,
    we,
    he
  ]), /* @__PURE__ */ createElement(Ie, {
    present: z || ge !== "hidden"
  }, /* @__PURE__ */ createElement(va, _$2({
    "data-state": ge === "hidden" ? "hidden" : "visible"
  }, ne, {
    ref: y,
    onPointerEnter: H$2(
      v.onPointerEnter,
      () => we("POINTER_ENTER")
    ),
    onPointerLeave: H$2(
      v.onPointerLeave,
      () => we("POINTER_LEAVE")
    )
  })));
}), pl = /* @__PURE__ */ forwardRef((v, y) => {
  const z = et(gt$1, v.__scopeScrollArea), { forceMount: ne, ...ue } = v, [le, he] = useState(!1), ge = v.orientation === "horizontal", we = Bo(() => {
    if (z.viewport) {
      const Ee = z.viewport.offsetWidth < z.viewport.scrollWidth, xe = z.viewport.offsetHeight < z.viewport.scrollHeight;
      he(ge ? Ee : xe);
    }
  }, 10);
  return un$1(z.viewport, we), un$1(z.content, we), /* @__PURE__ */ createElement(Ie, {
    present: ne || le
  }, /* @__PURE__ */ createElement(va, _$2({
    "data-state": le ? "visible" : "hidden"
  }, ue, {
    ref: y
  })));
}), va = /* @__PURE__ */ forwardRef((v, y) => {
  const { orientation: z = "vertical", ...ne } = v, ue = et(gt$1, v.__scopeScrollArea), le = useRef(null), he = useRef(0), [ge, we] = useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), Ee = gl(ge.viewport, ge.content), xe = {
    ...ne,
    sizes: ge,
    onSizesChange: we,
    hasThumb: Ee > 0 && Ee < 1,
    onThumbChange: (Ne) => le.current = Ne,
    onThumbPointerUp: () => he.current = 0,
    onThumbPointerDown: (Ne) => he.current = Ne
  };
  function $e(Ne, st) {
    return $g(Ne, he.current, ge, st);
  }
  return z === "horizontal" ? /* @__PURE__ */ createElement(fg, _$2({}, xe, {
    ref: y,
    onThumbPositionChange: () => {
      if (ue.viewport && le.current) {
        const Ne = ue.viewport.scrollLeft, st = Tc(Ne, ge, ue.dir);
        le.current.style.transform = `translate3d(${st}px, 0, 0)`;
      }
    },
    onWheelScroll: (Ne) => {
      ue.viewport && (ue.viewport.scrollLeft = Ne);
    },
    onDragScroll: (Ne) => {
      ue.viewport && (ue.viewport.scrollLeft = $e(Ne, ue.dir));
    }
  })) : z === "vertical" ? /* @__PURE__ */ createElement(pg, _$2({}, xe, {
    ref: y,
    onThumbPositionChange: () => {
      if (ue.viewport && le.current) {
        const Ne = ue.viewport.scrollTop, st = Tc(Ne, ge);
        le.current.style.transform = `translate3d(0, ${st}px, 0)`;
      }
    },
    onWheelScroll: (Ne) => {
      ue.viewport && (ue.viewport.scrollTop = Ne);
    },
    onDragScroll: (Ne) => {
      ue.viewport && (ue.viewport.scrollTop = $e(Ne));
    }
  })) : null;
}), fg = /* @__PURE__ */ forwardRef((v, y) => {
  const { sizes: z, onSizesChange: ne, ...ue } = v, le = et(gt$1, v.__scopeScrollArea), [he, ge] = useState(), we = useRef(null), Ee = de(y, we, le.onScrollbarXChange);
  return useEffect(() => {
    we.current && ge(getComputedStyle(we.current));
  }, [
    we
  ]), /* @__PURE__ */ createElement(vl, _$2({
    "data-orientation": "horizontal"
  }, ue, {
    ref: Ee,
    sizes: z,
    style: {
      bottom: 0,
      left: le.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: le.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": Vo(z) + "px",
      ...v.style
    },
    onThumbPointerDown: (xe) => v.onThumbPointerDown(xe.x),
    onDragScroll: (xe) => v.onDragScroll(xe.x),
    onWheelScroll: (xe, $e) => {
      if (le.viewport) {
        const Ne = le.viewport.scrollLeft + xe.deltaX;
        v.onWheelScroll(Ne), $l(Ne, $e) && xe.preventDefault();
      }
    },
    onResize: () => {
      we.current && le.viewport && he && ne({
        content: le.viewport.scrollWidth,
        viewport: le.viewport.offsetWidth,
        scrollbar: {
          size: we.current.clientWidth,
          paddingStart: ho(he.paddingLeft),
          paddingEnd: ho(he.paddingRight)
        }
      });
    }
  }));
}), pg = /* @__PURE__ */ forwardRef((v, y) => {
  const { sizes: z, onSizesChange: ne, ...ue } = v, le = et(gt$1, v.__scopeScrollArea), [he, ge] = useState(), we = useRef(null), Ee = de(y, we, le.onScrollbarYChange);
  return useEffect(() => {
    we.current && ge(getComputedStyle(we.current));
  }, [
    we
  ]), /* @__PURE__ */ createElement(vl, _$2({
    "data-orientation": "vertical"
  }, ue, {
    ref: Ee,
    sizes: z,
    style: {
      top: 0,
      right: le.dir === "ltr" ? 0 : void 0,
      left: le.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": Vo(z) + "px",
      ...v.style
    },
    onThumbPointerDown: (xe) => v.onThumbPointerDown(xe.y),
    onDragScroll: (xe) => v.onDragScroll(xe.y),
    onWheelScroll: (xe, $e) => {
      if (le.viewport) {
        const Ne = le.viewport.scrollTop + xe.deltaY;
        v.onWheelScroll(Ne), $l(Ne, $e) && xe.preventDefault();
      }
    },
    onResize: () => {
      we.current && le.viewport && he && ne({
        content: le.viewport.scrollHeight,
        viewport: le.viewport.offsetHeight,
        scrollbar: {
          size: we.current.clientHeight,
          paddingStart: ho(he.paddingTop),
          paddingEnd: ho(he.paddingBottom)
        }
      });
    }
  }));
}), [mg, ml] = dl(gt$1), vl = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeScrollArea: z, sizes: ne, hasThumb: ue, onThumbChange: le, onThumbPointerUp: he, onThumbPointerDown: ge, onThumbPositionChange: we, onDragScroll: Ee, onWheelScroll: xe, onResize: $e, ...Ne } = v, st = et(gt$1, z), [Nr, br] = useState(null), $n = de(
    y,
    (Yn) => br(Yn)
  ), En = useRef(null), Rn = useRef(""), wa = st.viewport, Aa = ne.content - ne.viewport, _a = Te$1(xe), Ta = Te$1(we), Zn = Bo($e, 10);
  function Ra(Yn) {
    if (En.current) {
      const $o = Yn.clientX - En.current.left, ct = Yn.clientY - En.current.top;
      Ee({
        x: $o,
        y: ct
      });
    }
  }
  return useEffect(() => {
    const Yn = ($o) => {
      const ct = $o.target;
      Nr != null && Nr.contains(ct) && _a($o, Aa);
    };
    return document.addEventListener("wheel", Yn, {
      passive: !1
    }), () => document.removeEventListener("wheel", Yn, {
      passive: !1
    });
  }, [
    wa,
    Nr,
    Aa,
    _a
  ]), useEffect(Ta, [
    ne,
    Ta
  ]), un$1(Nr, Zn), un$1(st.content, Zn), /* @__PURE__ */ createElement(mg, {
    scope: z,
    scrollbar: Nr,
    hasThumb: ue,
    onThumbChange: Te$1(le),
    onThumbPointerUp: Te$1(he),
    onThumbPositionChange: Ta,
    onThumbPointerDown: Te$1(ge)
  }, /* @__PURE__ */ createElement(X$2.div, _$2({}, Ne, {
    ref: $n,
    style: {
      position: "absolute",
      ...Ne.style
    },
    onPointerDown: H$2(v.onPointerDown, (Yn) => {
      Yn.button === 0 && (Yn.target.setPointerCapture(Yn.pointerId), En.current = Nr.getBoundingClientRect(), Rn.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", st.viewport && (st.viewport.style.scrollBehavior = "auto"), Ra(Yn));
    }),
    onPointerMove: H$2(v.onPointerMove, Ra),
    onPointerUp: H$2(v.onPointerUp, (Yn) => {
      const $o = Yn.target;
      $o.hasPointerCapture(Yn.pointerId) && $o.releasePointerCapture(Yn.pointerId), document.body.style.webkitUserSelect = Rn.current, st.viewport && (st.viewport.style.scrollBehavior = ""), En.current = null;
    })
  })));
}), Mr = "ScrollAreaThumb", vg = /* @__PURE__ */ forwardRef((v, y) => {
  const { forceMount: z, ...ne } = v, ue = ml(Mr, v.__scopeScrollArea);
  return /* @__PURE__ */ createElement(Ie, {
    present: z || ue.hasThumb
  }, /* @__PURE__ */ createElement(bg, _$2({
    ref: y
  }, ne)));
}), bg = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeScrollArea: z, style: ne, ...ue } = v, le = et(Mr, z), he = ml(Mr, z), { onThumbPositionChange: ge } = he, we = de(
    y,
    ($e) => he.onThumbChange($e)
  ), Ee = useRef(), xe = Bo(() => {
    Ee.current && (Ee.current(), Ee.current = void 0);
  }, 100);
  return useEffect(() => {
    const $e = le.viewport;
    if ($e) {
      const Ne = () => {
        if (xe(), !Ee.current) {
          const st = wg($e, ge);
          Ee.current = st, ge();
        }
      };
      return ge(), $e.addEventListener("scroll", Ne), () => $e.removeEventListener("scroll", Ne);
    }
  }, [
    le.viewport,
    xe,
    ge
  ]), /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-state": he.hasThumb ? "visible" : "hidden"
  }, ue, {
    ref: we,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...ne
    },
    onPointerDownCapture: H$2(v.onPointerDownCapture, ($e) => {
      const Ne = $e.target.getBoundingClientRect(), st = $e.clientX - Ne.left, Nr = $e.clientY - Ne.top;
      he.onThumbPointerDown({
        x: st,
        y: Nr
      });
    }),
    onPointerUp: H$2(v.onPointerUp, he.onThumbPointerUp)
  }));
}), bl = "ScrollAreaCorner", gg = /* @__PURE__ */ forwardRef((v, y) => {
  const z = et(bl, v.__scopeScrollArea), ne = !!(z.scrollbarX && z.scrollbarY);
  return z.type !== "scroll" && ne ? /* @__PURE__ */ createElement(hg, _$2({}, v, {
    ref: y
  })) : null;
}), hg = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeScrollArea: z, ...ne } = v, ue = et(bl, z), [le, he] = useState(0), [ge, we] = useState(0), Ee = !!(le && ge);
  return un$1(ue.scrollbarX, () => {
    var xe;
    const $e = ((xe = ue.scrollbarX) === null || xe === void 0 ? void 0 : xe.offsetHeight) || 0;
    ue.onCornerHeightChange($e), we($e);
  }), un$1(ue.scrollbarY, () => {
    var xe;
    const $e = ((xe = ue.scrollbarY) === null || xe === void 0 ? void 0 : xe.offsetWidth) || 0;
    ue.onCornerWidthChange($e), he($e);
  }), Ee ? /* @__PURE__ */ createElement(X$2.div, _$2({}, ne, {
    ref: y,
    style: {
      width: le,
      height: ge,
      position: "absolute",
      right: ue.dir === "ltr" ? 0 : void 0,
      left: ue.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...v.style
    }
  })) : null;
});
function ho(v) {
  return v ? parseInt(v, 10) : 0;
}
function gl(v, y) {
  const z = v / y;
  return isNaN(z) ? 0 : z;
}
function Vo(v) {
  const y = gl(v.viewport, v.content), z = v.scrollbar.paddingStart + v.scrollbar.paddingEnd, ne = (v.scrollbar.size - z) * y;
  return Math.max(ne, 18);
}
function $g(v, y, z, ne = "ltr") {
  const ue = Vo(z), le = ue / 2, he = y || le, ge = ue - he, we = z.scrollbar.paddingStart + he, Ee = z.scrollbar.size - z.scrollbar.paddingEnd - ge, xe = z.content - z.viewport, $e = ne === "ltr" ? [
    0,
    xe
  ] : [
    xe * -1,
    0
  ];
  return hl([
    we,
    Ee
  ], $e)(v);
}
function Tc(v, y, z = "ltr") {
  const ne = Vo(y), ue = y.scrollbar.paddingStart + y.scrollbar.paddingEnd, le = y.scrollbar.size - ue, he = y.content - y.viewport, ge = le - ne, we = z === "ltr" ? [
    0,
    he
  ] : [
    he * -1,
    0
  ], Ee = Dr(v, we);
  return hl([
    0,
    he
  ], [
    0,
    ge
  ])(Ee);
}
function hl(v, y) {
  return (z) => {
    if (v[0] === v[1] || y[0] === y[1])
      return y[0];
    const ne = (y[1] - y[0]) / (v[1] - v[0]);
    return y[0] + ne * (z - v[0]);
  };
}
function $l(v, y) {
  return v > 0 && v < y;
}
const wg = (v, y = () => {
}) => {
  let z = {
    left: v.scrollLeft,
    top: v.scrollTop
  }, ne = 0;
  return function ue() {
    const le = {
      left: v.scrollLeft,
      top: v.scrollTop
    }, he = z.left !== le.left, ge = z.top !== le.top;
    (he || ge) && y(), z = le, ne = window.requestAnimationFrame(ue);
  }(), () => window.cancelAnimationFrame(ne);
};
function Bo(v, y) {
  const z = Te$1(v), ne = useRef(0);
  return useEffect(
    () => () => window.clearTimeout(ne.current),
    []
  ), useCallback(() => {
    window.clearTimeout(ne.current), ne.current = window.setTimeout(z, y);
  }, [
    z,
    y
  ]);
}
function un$1(v, y) {
  const z = Te$1(y);
  ke$1(() => {
    let ne = 0;
    if (v) {
      const ue = new ResizeObserver(() => {
        cancelAnimationFrame(ne), ne = window.requestAnimationFrame(z);
      });
      return ue.observe(v), () => {
        window.cancelAnimationFrame(ne), ue.unobserve(v);
      };
    }
  }, [
    v,
    z
  ]);
}
const wl = ig, xg = lg, yg = gg, Cg = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsxs(
  wl,
  {
    ref: ne,
    className: Y$1("relative overflow-hidden", v),
    ...z,
    children: [
      /* @__PURE__ */ D$6.jsx(xg, { className: "h-full w-full rounded-[inherit]", children: y }),
      /* @__PURE__ */ D$6.jsx(xl, {}),
      /* @__PURE__ */ D$6.jsx(yg, {})
    ]
  }
));
Cg.displayName = wl.displayName;
const xl = a$z.forwardRef(({ className: v, orientation: y = "vertical", ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  fl,
  {
    ref: ne,
    orientation: y,
    className: Y$1(
      "flex touch-none select-none transition-colors",
      y === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      y === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      v
    ),
    ...z,
    children: /* @__PURE__ */ D$6.jsx(vg, { className: "relative flex-1 rounded-full bg-border" })
  }
));
xl.displayName = fl.displayName;
function gw({
  className: v,
  ...y
}) {
  return /* @__PURE__ */ D$6.jsx(
    "div",
    {
      role: "presentation",
      className: Y$1(
        "relative overflow-hidden rounded-md bg-muted animate-pulse",
        v
      ),
      ...y
    }
  );
}
const yl = /* @__PURE__ */ forwardRef((v, y) => /* @__PURE__ */ createElement(X$2.span, _$2({}, v, {
  ref: y,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...v.style
  }
}))), Eg = yl, [Wo, hw] = Le("Tooltip", [
  Rt$1
]), ba = Rt$1(), Sg = "TooltipProvider", Pg = 700, Ir = "tooltip.open", [_g, ga] = Wo(Sg), Rg = (v) => {
  const { __scopeTooltip: y, delayDuration: z = Pg, skipDelayDuration: ne = 300, disableHoverableContent: ue = !1, children: le } = v, [he, ge] = useState(!0), we = useRef(!1), Ee = useRef(0);
  return useEffect(() => {
    const xe = Ee.current;
    return () => window.clearTimeout(xe);
  }, []), /* @__PURE__ */ createElement(_g, {
    scope: y,
    isOpenDelayed: he,
    delayDuration: z,
    onOpen: useCallback(() => {
      window.clearTimeout(Ee.current), ge(!1);
    }, []),
    onClose: useCallback(() => {
      window.clearTimeout(Ee.current), Ee.current = window.setTimeout(
        () => ge(!0),
        ne
      );
    }, [
      ne
    ]),
    isPointerInTransitRef: we,
    onPointerInTransitChange: useCallback((xe) => {
      we.current = xe;
    }, []),
    disableHoverableContent: ue
  }, le);
}, ha = "Tooltip", [Ag, Uo] = Wo(ha), Tg = (v) => {
  const { __scopeTooltip: y, children: z, open: ne, defaultOpen: ue = !1, onOpenChange: le, disableHoverableContent: he, delayDuration: ge } = v, we = ga(ha, v.__scopeTooltip), Ee = ba(y), [xe, $e] = useState(null), Ne = je$1(), st = useRef(0), Nr = he ?? we.disableHoverableContent, br = ge ?? we.delayDuration, $n = useRef(!1), [En = !1, Rn] = Be$1({
    prop: ne,
    defaultProp: ue,
    onChange: (Zn) => {
      Zn ? (we.onOpen(), document.dispatchEvent(new CustomEvent(Ir))) : we.onClose(), le == null || le(Zn);
    }
  }), wa = useMemo(() => En ? $n.current ? "delayed-open" : "instant-open" : "closed", [
    En
  ]), Aa = useCallback(() => {
    window.clearTimeout(st.current), $n.current = !1, Rn(!0);
  }, [
    Rn
  ]), _a = useCallback(() => {
    window.clearTimeout(st.current), Rn(!1);
  }, [
    Rn
  ]), Ta = useCallback(() => {
    window.clearTimeout(st.current), st.current = window.setTimeout(() => {
      $n.current = !0, Rn(!0);
    }, br);
  }, [
    br,
    Rn
  ]);
  return useEffect(() => () => window.clearTimeout(st.current), []), /* @__PURE__ */ createElement(Un$1, Ee, /* @__PURE__ */ createElement(Ag, {
    scope: y,
    contentId: Ne,
    open: En,
    stateAttribute: wa,
    trigger: xe,
    onTriggerChange: $e,
    onTriggerEnter: useCallback(() => {
      we.isOpenDelayed ? Ta() : Aa();
    }, [
      we.isOpenDelayed,
      Ta,
      Aa
    ]),
    onTriggerLeave: useCallback(() => {
      Nr ? _a() : window.clearTimeout(st.current);
    }, [
      _a,
      Nr
    ]),
    onOpen: Aa,
    onClose: _a,
    disableHoverableContent: Nr
  }, z));
}, Oc = "TooltipTrigger", Og = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeTooltip: z, ...ne } = v, ue = Uo(Oc, z), le = ga(Oc, z), he = ba(z), ge = useRef(null), we = de(y, ge, ue.onTriggerChange), Ee = useRef(!1), xe = useRef(!1), $e = useCallback(
    () => Ee.current = !1,
    []
  );
  return useEffect(() => () => document.removeEventListener("pointerup", $e), [
    $e
  ]), /* @__PURE__ */ createElement(Fo, _$2({
    asChild: !0
  }, he), /* @__PURE__ */ createElement(X$2.button, _$2({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": ue.open ? ue.contentId : void 0,
    "data-state": ue.stateAttribute
  }, ne, {
    ref: we,
    onPointerMove: H$2(v.onPointerMove, (Ne) => {
      Ne.pointerType !== "touch" && !xe.current && !le.isPointerInTransitRef.current && (ue.onTriggerEnter(), xe.current = !0);
    }),
    onPointerLeave: H$2(v.onPointerLeave, () => {
      ue.onTriggerLeave(), xe.current = !1;
    }),
    onPointerDown: H$2(v.onPointerDown, () => {
      Ee.current = !0, document.addEventListener("pointerup", $e, {
        once: !0
      });
    }),
    onFocus: H$2(v.onFocus, () => {
      Ee.current || ue.onOpen();
    }),
    onBlur: H$2(v.onBlur, ue.onClose),
    onClick: H$2(v.onClick, ue.onClose)
  })));
}), Dg = "TooltipPortal", [$w, Mg] = Wo(Dg, {
  forceMount: void 0
}), kn$1 = "TooltipContent", Ig = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Mg(kn$1, v.__scopeTooltip), { forceMount: ne = z.forceMount, side: ue = "top", ...le } = v, he = Uo(kn$1, v.__scopeTooltip);
  return /* @__PURE__ */ createElement(Ie, {
    present: ne || he.open
  }, he.disableHoverableContent ? /* @__PURE__ */ createElement(Cl, _$2({
    side: ue
  }, le, {
    ref: y
  })) : /* @__PURE__ */ createElement(Ng, _$2({
    side: ue
  }, le, {
    ref: y
  })));
}), Ng = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Uo(kn$1, v.__scopeTooltip), ne = ga(kn$1, v.__scopeTooltip), ue = useRef(null), le = de(y, ue), [he, ge] = useState(null), { trigger: we, onClose: Ee } = z, xe = ue.current, { onPointerInTransitChange: $e } = ne, Ne = useCallback(() => {
    ge(null), $e(!1);
  }, [
    $e
  ]), st = useCallback((Nr, br) => {
    const $n = Nr.currentTarget, En = {
      x: Nr.clientX,
      y: Nr.clientY
    }, Rn = Lg(En, $n.getBoundingClientRect()), wa = Fg(En, Rn), Aa = zg(br.getBoundingClientRect()), _a = Hg([
      ...wa,
      ...Aa
    ]);
    ge(_a), $e(!0);
  }, [
    $e
  ]);
  return useEffect(() => () => Ne(), [
    Ne
  ]), useEffect(() => {
    if (we && xe) {
      const Nr = ($n) => st($n, xe), br = ($n) => st($n, we);
      return we.addEventListener("pointerleave", Nr), xe.addEventListener("pointerleave", br), () => {
        we.removeEventListener("pointerleave", Nr), xe.removeEventListener("pointerleave", br);
      };
    }
  }, [
    we,
    xe,
    st,
    Ne
  ]), useEffect(() => {
    if (he) {
      const Nr = (br) => {
        const $n = br.target, En = {
          x: br.clientX,
          y: br.clientY
        }, Rn = (we == null ? void 0 : we.contains($n)) || (xe == null ? void 0 : xe.contains($n)), wa = !jg(En, he);
        Rn ? Ne() : wa && (Ne(), Ee());
      };
      return document.addEventListener("pointermove", Nr), () => document.removeEventListener("pointermove", Nr);
    }
  }, [
    we,
    xe,
    he,
    Ee,
    Ne
  ]), /* @__PURE__ */ createElement(Cl, _$2({}, v, {
    ref: le
  }));
}), [kg, ww] = Wo(ha, {
  isInside: !1
}), Cl = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeTooltip: z, children: ne, "aria-label": ue, onEscapeKeyDown: le, onPointerDownOutside: he, ...ge } = v, we = Uo(kn$1, z), Ee = ba(z), { onClose: xe } = we;
  return useEffect(() => (document.addEventListener(Ir, xe), () => document.removeEventListener(Ir, xe)), [
    xe
  ]), useEffect(() => {
    if (we.trigger) {
      const $e = (Ne) => {
        const st = Ne.target;
        st != null && st.contains(we.trigger) && xe();
      };
      return window.addEventListener("scroll", $e, {
        capture: !0
      }), () => window.removeEventListener("scroll", $e, {
        capture: !0
      });
    }
  }, [
    we.trigger,
    xe
  ]), /* @__PURE__ */ createElement(jn, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: le,
    onPointerDownOutside: he,
    onFocusOutside: ($e) => $e.preventDefault(),
    onDismiss: xe
  }, /* @__PURE__ */ createElement(zo, _$2({
    "data-state": we.stateAttribute
  }, Ee, ge, {
    ref: y,
    style: {
      ...ge.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ createElement($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, null, ne), /* @__PURE__ */ createElement(kg, {
    scope: z,
    isInside: !0
  }, /* @__PURE__ */ createElement(Eg, {
    id: we.contentId,
    role: "tooltip"
  }, ue || ne))));
});
function Lg(v, y) {
  const z = Math.abs(y.top - v.y), ne = Math.abs(y.bottom - v.y), ue = Math.abs(y.right - v.x), le = Math.abs(y.left - v.x);
  switch (Math.min(z, ne, ue, le)) {
    case le:
      return "left";
    case ue:
      return "right";
    case z:
      return "top";
    case ne:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Fg(v, y, z = 5) {
  const ne = [];
  switch (y) {
    case "top":
      ne.push({
        x: v.x - z,
        y: v.y + z
      }, {
        x: v.x + z,
        y: v.y + z
      });
      break;
    case "bottom":
      ne.push({
        x: v.x - z,
        y: v.y - z
      }, {
        x: v.x + z,
        y: v.y - z
      });
      break;
    case "left":
      ne.push({
        x: v.x + z,
        y: v.y - z
      }, {
        x: v.x + z,
        y: v.y + z
      });
      break;
    case "right":
      ne.push({
        x: v.x - z,
        y: v.y - z
      }, {
        x: v.x - z,
        y: v.y + z
      });
      break;
  }
  return ne;
}
function zg(v) {
  const { top: y, right: z, bottom: ne, left: ue } = v;
  return [
    {
      x: ue,
      y
    },
    {
      x: z,
      y
    },
    {
      x: z,
      y: ne
    },
    {
      x: ue,
      y: ne
    }
  ];
}
function jg(v, y) {
  const { x: z, y: ne } = v;
  let ue = !1;
  for (let le = 0, he = y.length - 1; le < y.length; he = le++) {
    const ge = y[le].x, we = y[le].y, Ee = y[he].x, xe = y[he].y;
    we > ne != xe > ne && z < (Ee - ge) * (ne - we) / (xe - we) + ge && (ue = !ue);
  }
  return ue;
}
function Hg(v) {
  const y = v.slice();
  return y.sort((z, ne) => z.x < ne.x ? -1 : z.x > ne.x ? 1 : z.y < ne.y ? -1 : z.y > ne.y ? 1 : 0), Vg(y);
}
function Vg(v) {
  if (v.length <= 1)
    return v.slice();
  const y = [];
  for (let ne = 0; ne < v.length; ne++) {
    const ue = v[ne];
    for (; y.length >= 2; ) {
      const le = y[y.length - 1], he = y[y.length - 2];
      if ((le.x - he.x) * (ue.y - he.y) >= (le.y - he.y) * (ue.x - he.x))
        y.pop();
      else
        break;
    }
    y.push(ue);
  }
  y.pop();
  const z = [];
  for (let ne = v.length - 1; ne >= 0; ne--) {
    const ue = v[ne];
    for (; z.length >= 2; ) {
      const le = z[z.length - 1], he = z[z.length - 2];
      if ((le.x - he.x) * (ue.y - he.y) >= (le.y - he.y) * (ue.x - he.x))
        z.pop();
      else
        break;
    }
    z.push(ue);
  }
  return z.pop(), y.length === 1 && z.length === 1 && y[0].x === z[0].x && y[0].y === z[0].y ? y : y.concat(z);
}
const Bg = Rg, Wg = Tg, Ug = Og, El = Ig, xw = Bg, yw = Wg, Cw = Ug, Kg = a$z.forwardRef(({ className: v, sideOffset: y = 4, ...z }, ne) => /* @__PURE__ */ D$6.jsx(
  El,
  {
    ref: ne,
    sideOffset: y,
    className: Y$1(
      "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      v
    ),
    ...z
  }
));
Kg.displayName = El.displayName;
const Gg = a__default.forwardRef(
  ({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
    "div",
    {
      ref: z,
      className: Y$1("animate-fade-in-up", v),
      ...y
    }
  )
);
Gg.displayName = "Button";
const {
  createElement: dn$1,
  createContext: Zg,
  createRef: Ew,
  forwardRef: Sl,
  useCallback: Ge$1,
  useContext: Pl,
  useEffect: zt$1,
  useImperativeHandle: _l,
  useLayoutEffect: Yg,
  useMemo: Xg,
  useRef: Ke$1,
  useState: _n
} = a$z, Dc = a$z.useId, qg = Yg, Ko = Zg(null);
Ko.displayName = "PanelGroupContext";
const jt$1 = qg, Jg = typeof Dc == "function" ? Dc : () => null;
let Qg = 0;
function $a(v = null) {
  const y = Jg(), z = Ke$1(v || y || null);
  return z.current === null && (z.current = "" + Qg++), v ?? z.current;
}
function Rl({
  children: v,
  className: y = "",
  collapsedSize: z,
  collapsible: ne,
  defaultSize: ue,
  forwardedRef: le,
  id: he,
  maxSize: ge,
  minSize: we,
  onCollapse: Ee,
  onExpand: xe,
  onResize: $e,
  order: Ne,
  style: st,
  tagName: Nr = "div",
  ...br
}) {
  const $n = Pl(Ko);
  if ($n === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: En,
    expandPanel: Rn,
    getPanelSize: wa,
    getPanelStyle: Aa,
    groupId: _a,
    isPanelCollapsed: Ta,
    reevaluatePanelConstraints: Zn,
    registerPanel: Ra,
    resizePanel: Yn,
    unregisterPanel: $o
  } = $n, ct = $a(he), fe = Ke$1({
    callbacks: {
      onCollapse: Ee,
      onExpand: xe,
      onResize: $e
    },
    constraints: {
      collapsedSize: z,
      collapsible: ne,
      defaultSize: ue,
      maxSize: ge,
      minSize: we
    },
    id: ct,
    idIsFromProps: he !== void 0,
    order: Ne
  });
  Ke$1({
    didLogMissingDefaultSizeWarning: !1
  }), jt$1(() => {
    const {
      callbacks: ye,
      constraints: Se
    } = fe.current, Oe = {
      ...Se
    };
    fe.current.id = ct, fe.current.idIsFromProps = he !== void 0, fe.current.order = Ne, ye.onCollapse = Ee, ye.onExpand = xe, ye.onResize = $e, Se.collapsedSize = z, Se.collapsible = ne, Se.defaultSize = ue, Se.maxSize = ge, Se.minSize = we, (Oe.collapsedSize !== Se.collapsedSize || Oe.collapsible !== Se.collapsible || Oe.maxSize !== Se.maxSize || Oe.minSize !== Se.minSize) && Zn(fe.current, Oe);
  }), jt$1(() => {
    const ye = fe.current;
    return Ra(ye), () => {
      $o(ye);
    };
  }, [Ne, ct, Ra, $o]), _l(le, () => ({
    collapse: () => {
      En(fe.current);
    },
    expand: (ye) => {
      Rn(fe.current, ye);
    },
    getId() {
      return ct;
    },
    getSize() {
      return wa(fe.current);
    },
    isCollapsed() {
      return Ta(fe.current);
    },
    isExpanded() {
      return !Ta(fe.current);
    },
    resize: (ye) => {
      Yn(fe.current, ye);
    }
  }), [En, Rn, wa, Ta, ct, Yn]);
  const be = Aa(fe.current, ue);
  return dn$1(Nr, {
    ...br,
    children: v,
    className: y,
    id: he,
    style: {
      ...be,
      ...st
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": ne || void 0,
    "data-panel-group-id": _a,
    "data-panel-id": ct,
    "data-panel-size": parseFloat("" + be.flexGrow).toFixed(1)
  });
}
const Al = Sl((v, y) => dn$1(Rl, {
  ...v,
  forwardedRef: y
}));
Rl.displayName = "Panel";
Al.displayName = "forwardRef(Panel)";
function Tl(v) {
  return v.type === "keydown";
}
function Ol(v) {
  return v.type.startsWith("pointer");
}
function Dl(v) {
  return v.type.startsWith("mouse");
}
function Go(v) {
  if (Ol(v)) {
    if (v.isPrimary)
      return {
        x: v.clientX,
        y: v.clientY
      };
  } else if (Dl(v))
    return {
      x: v.clientX,
      y: v.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function nh() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
const Il = 1, Nl = 2, kl = 4, Ll = 8;
nh();
let Yo = /* @__PURE__ */ new Map();
function gr(v, y) {
  Yo.set(v, y);
}
function me(v, y) {
  if (!v)
    throw console.error(y), Error(y);
}
const ya = 10;
function Ut$1(v, y, z = ya) {
  return v.toFixed(z) === y.toFixed(z) ? 0 : v > y ? 1 : -1;
}
function dt$1(v, y, z = ya) {
  return Ut$1(v, y, z) === 0;
}
function Ze$1(v, y, z) {
  return Ut$1(v, y, z) === 0;
}
function uh(v, y, z) {
  if (v.length !== y.length)
    return !1;
  for (let ne = 0; ne < v.length; ne++) {
    const ue = v[ne], le = y[ne];
    if (!Ze$1(ue, le, z))
      return !1;
  }
  return !0;
}
function an$1({
  panelConstraints: v,
  panelIndex: y,
  size: z
}) {
  const ne = v[y];
  me(ne != null, `Panel constraints not found for index ${y}`);
  let {
    collapsedSize: ue = 0,
    collapsible: le,
    maxSize: he = 100,
    minSize: ge = 0
  } = ne;
  if (Ut$1(z, ge) < 0)
    if (le) {
      const we = (ue + ge) / 2;
      Ut$1(z, we) < 0 ? z = ue : z = ge;
    } else
      z = ge;
  return z = Math.min(he, z), z = parseFloat(z.toFixed(ya)), z;
}
function Sn({
  delta: v,
  initialLayout: y,
  panelConstraints: z,
  pivotIndices: ne,
  prevLayout: ue,
  trigger: le
}) {
  if (Ze$1(v, 0))
    return y;
  const he = [...y], [ge, we] = ne;
  me(ge != null, "Invalid first pivot index"), me(we != null, "Invalid second pivot index");
  let Ee = 0;
  if (le === "keyboard") {
    {
      const $e = v < 0 ? we : ge, Ne = z[$e];
      me(Ne, `Panel constraints not found for index ${$e}`);
      const {
        collapsedSize: st = 0,
        collapsible: Nr,
        minSize: br = 0
      } = Ne;
      if (Nr) {
        const $n = y[$e];
        if (me($n != null, `Previous layout not found for panel index ${$e}`), Ze$1($n, st)) {
          const En = br - $n;
          Ut$1(En, Math.abs(v)) > 0 && (v = v < 0 ? 0 - En : En);
        }
      }
    }
    {
      const $e = v < 0 ? ge : we, Ne = z[$e];
      me(Ne, `No panel constraints found for index ${$e}`);
      const {
        collapsedSize: st = 0,
        collapsible: Nr,
        minSize: br = 0
      } = Ne;
      if (Nr) {
        const $n = y[$e];
        if (me($n != null, `Previous layout not found for panel index ${$e}`), Ze$1($n, br)) {
          const En = $n - st;
          Ut$1(En, Math.abs(v)) > 0 && (v = v < 0 ? 0 - En : En);
        }
      }
    }
  }
  {
    const $e = v < 0 ? 1 : -1;
    let Ne = v < 0 ? we : ge, st = 0;
    for (; ; ) {
      const br = y[Ne];
      me(br != null, `Previous layout not found for panel index ${Ne}`);
      const $n = an$1({
        panelConstraints: z,
        panelIndex: Ne,
        size: 100
      }) - br;
      if (st += $n, Ne += $e, Ne < 0 || Ne >= z.length)
        break;
    }
    const Nr = Math.min(Math.abs(v), Math.abs(st));
    v = v < 0 ? 0 - Nr : Nr;
  }
  {
    let $e = v < 0 ? ge : we;
    for (; $e >= 0 && $e < z.length; ) {
      const Ne = Math.abs(v) - Math.abs(Ee), st = y[$e];
      me(st != null, `Previous layout not found for panel index ${$e}`);
      const Nr = st - Ne, br = an$1({
        panelConstraints: z,
        panelIndex: $e,
        size: Nr
      });
      if (!Ze$1(st, br) && (Ee += st - br, he[$e] = br, Ee.toPrecision(3).localeCompare(Math.abs(v).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      v < 0 ? $e-- : $e++;
    }
  }
  if (uh(ue, he))
    return ue;
  {
    const $e = v < 0 ? we : ge, Ne = y[$e];
    me(Ne != null, `Previous layout not found for panel index ${$e}`);
    const st = Ne + Ee, Nr = an$1({
      panelConstraints: z,
      panelIndex: $e,
      size: st
    });
    if (he[$e] = Nr, !Ze$1(Nr, st)) {
      let br = st - Nr, $n = v < 0 ? we : ge;
      for (; $n >= 0 && $n < z.length; ) {
        const En = he[$n];
        me(En != null, `Previous layout not found for panel index ${$n}`);
        const Rn = En + br, wa = an$1({
          panelConstraints: z,
          panelIndex: $n,
          size: Rn
        });
        if (Ze$1(En, wa) || (br -= wa - En, he[$n] = wa), Ze$1(br, 0))
          break;
        v > 0 ? $n-- : $n++;
      }
    }
  }
  const xe = he.reduce(($e, Ne) => Ne + $e, 0);
  return Ze$1(xe, 100) ? he : ue;
}
function dh$1({
  layout: v,
  panelsArray: y,
  pivotIndices: z
}) {
  let ne = 0, ue = 100, le = 0, he = 0;
  const ge = z[0];
  me(ge != null, "No pivot index found"), y.forEach(($e, Ne) => {
    const {
      constraints: st
    } = $e, {
      maxSize: Nr = 100,
      minSize: br = 0
    } = st;
    Ne === ge ? (ne = br, ue = Nr) : (le += br, he += Nr);
  });
  const we = Math.min(ue, 100 - le), Ee = Math.max(ne, 100 - he), xe = v[ge];
  return {
    valueMax: we,
    valueMin: Ee,
    valueNow: xe
  };
}
function Fn$1(v, y = document) {
  return Array.from(y.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${v}"]`));
}
function zl(v, y, z = document) {
  return Fn$1(v, z).findIndex((ue) => ue.getAttribute("data-panel-resize-handle-id") === y) ?? null;
}
function jl(v, y, z) {
  const ne = zl(v, y, z);
  return ne != null ? [ne, ne + 1] : [-1, -1];
}
function Hl(v, y = document) {
  var z;
  return y instanceof HTMLElement && (y == null || (z = y.dataset) === null || z === void 0 ? void 0 : z.panelGroupId) == v ? y : y.querySelector(`[data-panel-group][data-panel-group-id="${v}"]`) || null;
}
function Xo(v, y = document) {
  return y.querySelector(`[data-panel-resize-handle-id="${v}"]`) || null;
}
function fh(v, y, z, ne = document) {
  var ue, le, he, ge;
  const we = Xo(y, ne), Ee = Fn$1(v, ne), xe = we ? Ee.indexOf(we) : -1, $e = (ue = (le = z[xe]) === null || le === void 0 ? void 0 : le.id) !== null && ue !== void 0 ? ue : null, Ne = (he = (ge = z[xe + 1]) === null || ge === void 0 ? void 0 : ge.id) !== null && he !== void 0 ? he : null;
  return [$e, Ne];
}
function ph({
  committedValuesRef: v,
  eagerValuesRef: y,
  groupId: z,
  layout: ne,
  panelDataArray: ue,
  panelGroupElement: le,
  setLayout: he
}) {
  Ke$1({
    didWarnAboutMissingResizeHandle: !1
  }), jt$1(() => {
    if (!le)
      return;
    const ge = Fn$1(z, le);
    for (let we = 0; we < ue.length - 1; we++) {
      const {
        valueMax: Ee,
        valueMin: xe,
        valueNow: $e
      } = dh$1({
        layout: ne,
        panelsArray: ue,
        pivotIndices: [we, we + 1]
      }), Ne = ge[we];
      if (Ne != null) {
        const st = ue[we];
        me(st, `No panel data found for index "${we}"`), Ne.setAttribute("aria-controls", st.id), Ne.setAttribute("aria-valuemax", "" + Math.round(Ee)), Ne.setAttribute("aria-valuemin", "" + Math.round(xe)), Ne.setAttribute("aria-valuenow", $e != null ? "" + Math.round($e) : "");
      }
    }
    return () => {
      ge.forEach((we, Ee) => {
        we.removeAttribute("aria-controls"), we.removeAttribute("aria-valuemax"), we.removeAttribute("aria-valuemin"), we.removeAttribute("aria-valuenow");
      });
    };
  }, [z, ne, ue, le]), zt$1(() => {
    if (!le)
      return;
    const ge = y.current;
    me(ge, "Eager values not found");
    const {
      panelDataArray: we
    } = ge, Ee = Hl(z, le);
    me(Ee != null, `No group found for id "${z}"`);
    const xe = Fn$1(z, le);
    me(xe, `No resize handles found for group id "${z}"`);
    const $e = xe.map((Ne) => {
      const st = Ne.getAttribute("data-panel-resize-handle-id");
      me(st, "Resize handle element has no handle id attribute");
      const [Nr, br] = fh(z, st, we, le);
      if (Nr == null || br == null)
        return () => {
        };
      const $n = (En) => {
        if (!En.defaultPrevented)
          switch (En.key) {
            case "Enter": {
              En.preventDefault();
              const Rn = we.findIndex((wa) => wa.id === Nr);
              if (Rn >= 0) {
                const wa = we[Rn];
                me(wa, `No panel data found for index ${Rn}`);
                const Aa = ne[Rn], {
                  collapsedSize: _a = 0,
                  collapsible: Ta,
                  minSize: Zn = 0
                } = wa.constraints;
                if (Aa != null && Ta) {
                  const Ra = Sn({
                    delta: Ze$1(Aa, _a) ? Zn - _a : _a - Aa,
                    initialLayout: ne,
                    panelConstraints: we.map((Yn) => Yn.constraints),
                    pivotIndices: jl(z, st, le),
                    prevLayout: ne,
                    trigger: "keyboard"
                  });
                  ne !== Ra && he(Ra);
                }
              }
              break;
            }
          }
      };
      return Ne.addEventListener("keydown", $n), () => {
        Ne.removeEventListener("keydown", $n);
      };
    });
    return () => {
      $e.forEach((Ne) => Ne());
    };
  }, [le, v, y, z, ne, ue, he]);
}
function Lc(v, y) {
  if (v.length !== y.length)
    return !1;
  for (let z = 0; z < v.length; z++)
    if (v[z] !== y[z])
      return !1;
  return !0;
}
function Vl(v, y) {
  const z = v === "horizontal", {
    x: ne,
    y: ue
  } = Go(y);
  return z ? ne : ue;
}
function mh(v, y, z, ne, ue) {
  const le = z === "horizontal", he = Xo(y, ue);
  me(he, `No resize handle element found for id "${y}"`);
  const ge = he.getAttribute("data-panel-group-id");
  me(ge, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: we
  } = ne;
  const Ee = Vl(z, v), xe = Hl(ge, ue);
  me(xe, `No group element found for id "${ge}"`);
  const $e = xe.getBoundingClientRect(), Ne = le ? $e.width : $e.height;
  return (Ee - we) / Ne * 100;
}
function vh$1(v, y, z, ne, ue, le) {
  if (Tl(v)) {
    const he = z === "horizontal";
    let ge = 0;
    v.shiftKey ? ge = 100 : ue != null ? ge = ue : ge = 10;
    let we = 0;
    switch (v.key) {
      case "ArrowDown":
        we = he ? 0 : ge;
        break;
      case "ArrowLeft":
        we = he ? -ge : 0;
        break;
      case "ArrowRight":
        we = he ? ge : 0;
        break;
      case "ArrowUp":
        we = he ? 0 : -ge;
        break;
      case "End":
        we = 100;
        break;
      case "Home":
        we = -100;
        break;
    }
    return we;
  } else
    return ne == null ? 0 : mh(v, y, z, ne, le);
}
function bh({
  panelDataArray: v
}) {
  const y = Array(v.length), z = v.map((le) => le.constraints);
  let ne = 0, ue = 100;
  for (let le = 0; le < v.length; le++) {
    const he = z[le];
    me(he, `Panel constraints not found for index ${le}`);
    const {
      defaultSize: ge
    } = he;
    ge != null && (ne++, y[le] = ge, ue -= ge);
  }
  for (let le = 0; le < v.length; le++) {
    const he = z[le];
    me(he, `Panel constraints not found for index ${le}`);
    const {
      defaultSize: ge
    } = he;
    if (ge != null)
      continue;
    const we = v.length - ne, Ee = ue / we;
    ne++, y[le] = Ee, ue -= Ee;
  }
  return y;
}
function nn$1(v, y, z) {
  y.forEach((ne, ue) => {
    const le = v[ue];
    me(le, `Panel data not found for index ${ue}`);
    const {
      callbacks: he,
      constraints: ge,
      id: we
    } = le, {
      collapsedSize: Ee = 0,
      collapsible: xe
    } = ge, $e = z[we];
    if ($e == null || ne !== $e) {
      z[we] = ne;
      const {
        onCollapse: Ne,
        onExpand: st,
        onResize: Nr
      } = he;
      Nr && Nr(ne, $e), xe && (Ne || st) && (st && ($e == null || dt$1($e, Ee)) && !dt$1(ne, Ee) && st(), Ne && ($e == null || !dt$1($e, Ee)) && dt$1(ne, Ee) && Ne());
    }
  });
}
function co(v, y) {
  if (v.length !== y.length)
    return !1;
  for (let z = 0; z < v.length; z++)
    if (v[z] != y[z])
      return !1;
  return !0;
}
function gh({
  defaultSize: v,
  dragState: y,
  layout: z,
  panelData: ne,
  panelIndex: ue,
  precision: le = 3
}) {
  const he = z[ue];
  let ge;
  return he == null ? ge = v != null ? v.toPrecision(le) : "1" : ne.length === 1 ? ge = "1" : ge = he.toPrecision(le), {
    flexBasis: 0,
    flexGrow: ge,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: y !== null ? "none" : void 0
  };
}
function hh(v, y = 10) {
  let z = null;
  return (...ne) => {
    z !== null && clearTimeout(z), z = setTimeout(() => {
      v(...ne);
    }, y);
  };
}
function Fc(v) {
  try {
    if (typeof localStorage < "u")
      v.getItem = (y) => localStorage.getItem(y), v.setItem = (y, z) => {
        localStorage.setItem(y, z);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (y) {
    console.error(y), v.getItem = () => null, v.setItem = () => {
    };
  }
}
function Bl(v) {
  return `react-resizable-panels:${v}`;
}
function Wl(v) {
  return v.map((y) => {
    const {
      constraints: z,
      id: ne,
      idIsFromProps: ue,
      order: le
    } = y;
    return ue ? ne : le ? `${le}:${JSON.stringify(z)}` : JSON.stringify(z);
  }).sort((y, z) => y.localeCompare(z)).join(",");
}
function Ul(v, y) {
  try {
    const z = Bl(v), ne = y.getItem(z);
    if (ne) {
      const ue = JSON.parse(ne);
      if (typeof ue == "object" && ue != null)
        return ue;
    }
  } catch {
  }
  return null;
}
function $h(v, y, z) {
  var ne, ue;
  const le = (ne = Ul(v, z)) !== null && ne !== void 0 ? ne : {}, he = Wl(y);
  return (ue = le[he]) !== null && ue !== void 0 ? ue : null;
}
function wh(v, y, z, ne, ue) {
  var le;
  const he = Bl(v), ge = Wl(y), we = (le = Ul(v, ue)) !== null && le !== void 0 ? le : {};
  we[ge] = {
    expandToSizes: Object.fromEntries(z.entries()),
    layout: ne
  };
  try {
    ue.setItem(he, JSON.stringify(we));
  } catch (Ee) {
    console.error(Ee);
  }
}
function zc({
  layout: v,
  panelConstraints: y
}) {
  const z = [...v], ne = z.reduce((le, he) => le + he, 0);
  if (z.length !== y.length)
    throw Error(`Invalid ${y.length} panel layout: ${z.map((le) => `${le}%`).join(", ")}`);
  if (!Ze$1(ne, 100))
    for (let le = 0; le < y.length; le++) {
      const he = z[le];
      me(he != null, `No layout data found for index ${le}`);
      const ge = 100 / ne * he;
      z[le] = ge;
    }
  let ue = 0;
  for (let le = 0; le < y.length; le++) {
    const he = z[le];
    me(he != null, `No layout data found for index ${le}`);
    const ge = an$1({
      panelConstraints: y,
      panelIndex: le,
      size: he
    });
    he != ge && (ue += he - ge, z[le] = ge);
  }
  if (!Ze$1(ue, 0))
    for (let le = 0; le < y.length; le++) {
      const he = z[le];
      me(he != null, `No layout data found for index ${le}`);
      const ge = he + ue, we = an$1({
        panelConstraints: y,
        panelIndex: le,
        size: ge
      });
      if (he !== we && (ue -= we - he, z[le] = we, Ze$1(ue, 0)))
        break;
    }
  return z;
}
const xh = 100, Pn = {
  getItem: (v) => (Fc(Pn), Pn.getItem(v)),
  setItem: (v, y) => {
    Fc(Pn), Pn.setItem(v, y);
  }
}, jc = {};
function Kl$1({
  autoSaveId: v = null,
  children: y,
  className: z = "",
  direction: ne,
  forwardedRef: ue,
  id: le = null,
  onLayout: he = null,
  keyboardResizeBy: ge = null,
  storage: we = Pn,
  style: Ee,
  tagName: xe = "div",
  ...$e
}) {
  const Ne = $a(le), st = Ke$1(null), [Nr, br] = _n(null), [$n, En] = _n([]), Rn = Ke$1({}), wa = Ke$1(/* @__PURE__ */ new Map()), Aa = Ke$1(0), _a = Ke$1({
    autoSaveId: v,
    direction: ne,
    dragState: Nr,
    id: Ne,
    keyboardResizeBy: ge,
    onLayout: he,
    storage: we
  }), Ta = Ke$1({
    layout: $n,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  Ke$1({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), _l(ue, () => ({
    getId: () => _a.current.id,
    getLayout: () => {
      const {
        layout: xa
      } = Ta.current;
      return xa;
    },
    setLayout: (xa) => {
      const {
        onLayout: wo
      } = _a.current, {
        layout: _u,
        panelDataArray: Oa
      } = Ta.current, Os = zc({
        layout: xa,
        panelConstraints: Oa.map((Pa) => Pa.constraints)
      });
      Lc(_u, Os) || (En(Os), Ta.current.layout = Os, wo && wo(Os), nn$1(Oa, Os, Rn.current));
    }
  }), []), jt$1(() => {
    _a.current.autoSaveId = v, _a.current.direction = ne, _a.current.dragState = Nr, _a.current.id = Ne, _a.current.onLayout = he, _a.current.storage = we;
  }), ph({
    committedValuesRef: _a,
    eagerValuesRef: Ta,
    groupId: Ne,
    layout: $n,
    panelDataArray: Ta.current.panelDataArray,
    setLayout: En,
    panelGroupElement: st.current
  }), zt$1(() => {
    const {
      panelDataArray: xa
    } = Ta.current;
    if (v) {
      if ($n.length === 0 || $n.length !== xa.length)
        return;
      let wo = jc[v];
      wo == null && (wo = hh(wh, xh), jc[v] = wo);
      const _u = [...xa], Oa = new Map(wa.current);
      wo(v, _u, Oa, $n, we);
    }
  }, [v, $n, we]), zt$1(() => {
  });
  const Zn = Ge$1((xa) => {
    const {
      onLayout: wo
    } = _a.current, {
      layout: _u,
      panelDataArray: Oa
    } = Ta.current;
    if (xa.constraints.collapsible) {
      const Os = Oa.map((Tu) => Tu.constraints), {
        collapsedSize: Pa = 0,
        panelSize: Ml,
        pivotIndices: Su
      } = Nt$1(Oa, xa, _u);
      if (me(Ml != null, `Panel size not found for panel "${xa.id}"`), !dt$1(Ml, Pa)) {
        wa.current.set(xa.id, Ml);
        const Tu = rn$1(Oa, xa) === Oa.length - 1 ? Ml - Pa : Pa - Ml, Au = Sn({
          delta: Tu,
          initialLayout: _u,
          panelConstraints: Os,
          pivotIndices: Su,
          prevLayout: _u,
          trigger: "imperative-api"
        });
        co(_u, Au) || (En(Au), Ta.current.layout = Au, wo && wo(Au), nn$1(Oa, Au, Rn.current));
      }
    }
  }, []), Ra = Ge$1((xa, wo) => {
    const {
      onLayout: _u
    } = _a.current, {
      layout: Oa,
      panelDataArray: Os
    } = Ta.current;
    if (xa.constraints.collapsible) {
      const Pa = Os.map((Iu) => Iu.constraints), {
        collapsedSize: Ml = 0,
        panelSize: Su = 0,
        minSize: Tu = 0,
        pivotIndices: Au
      } = Nt$1(Os, xa, Oa), Zl = wo ?? Tu;
      if (dt$1(Su, Ml)) {
        const Iu = wa.current.get(xa.id), Uc = Iu != null && Iu >= Zl ? Iu : Zl, Pu = rn$1(Os, xa) === Os.length - 1 ? Su - Uc : Uc - Su, Lu = Sn({
          delta: Pu,
          initialLayout: Oa,
          panelConstraints: Pa,
          pivotIndices: Au,
          prevLayout: Oa,
          trigger: "imperative-api"
        });
        co(Oa, Lu) || (En(Lu), Ta.current.layout = Lu, _u && _u(Lu), nn$1(Os, Lu, Rn.current));
      }
    }
  }, []), Yn = Ge$1((xa) => {
    const {
      layout: wo,
      panelDataArray: _u
    } = Ta.current, {
      panelSize: Oa
    } = Nt$1(_u, xa, wo);
    return me(Oa != null, `Panel size not found for panel "${xa.id}"`), Oa;
  }, []), $o = Ge$1((xa, wo) => {
    const {
      panelDataArray: _u
    } = Ta.current, Oa = rn$1(_u, xa);
    return gh({
      defaultSize: wo,
      dragState: Nr,
      layout: $n,
      panelData: _u,
      panelIndex: Oa
    });
  }, [Nr, $n]), ct = Ge$1((xa) => {
    const {
      layout: wo,
      panelDataArray: _u
    } = Ta.current, {
      collapsedSize: Oa = 0,
      collapsible: Os,
      panelSize: Pa
    } = Nt$1(_u, xa, wo);
    return me(Pa != null, `Panel size not found for panel "${xa.id}"`), Os === !0 && dt$1(Pa, Oa);
  }, []), fe = Ge$1((xa) => {
    const {
      layout: wo,
      panelDataArray: _u
    } = Ta.current, {
      collapsedSize: Oa = 0,
      collapsible: Os,
      panelSize: Pa
    } = Nt$1(_u, xa, wo);
    return me(Pa != null, `Panel size not found for panel "${xa.id}"`), !Os || Ut$1(Pa, Oa) > 0;
  }, []), be = Ge$1((xa) => {
    const {
      panelDataArray: wo
    } = Ta.current;
    wo.push(xa), wo.sort((_u, Oa) => {
      const Os = _u.order, Pa = Oa.order;
      return Os == null && Pa == null ? 0 : Os == null ? -1 : Pa == null ? 1 : Os - Pa;
    }), Ta.current.panelDataArrayChanged = !0;
  }, []);
  jt$1(() => {
    if (Ta.current.panelDataArrayChanged) {
      Ta.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: xa,
        onLayout: wo,
        storage: _u
      } = _a.current, {
        layout: Oa,
        panelDataArray: Os
      } = Ta.current;
      let Pa = null;
      if (xa) {
        const Su = $h(xa, Os, _u);
        Su && (wa.current = new Map(Object.entries(Su.expandToSizes)), Pa = Su.layout);
      }
      Pa == null && (Pa = bh({
        panelDataArray: Os
      }));
      const Ml = zc({
        layout: Pa,
        panelConstraints: Os.map((Su) => Su.constraints)
      });
      Lc(Oa, Ml) || (En(Ml), Ta.current.layout = Ml, wo && wo(Ml), nn$1(Os, Ml, Rn.current));
    }
  }), jt$1(() => {
    const xa = Ta.current;
    return () => {
      xa.layout = [];
    };
  }, []);
  const ye = Ge$1((xa) => function(wo) {
    wo.preventDefault();
    const _u = st.current;
    if (!_u)
      return () => null;
    const {
      direction: Oa,
      dragState: Os,
      id: Pa,
      keyboardResizeBy: Ml,
      onLayout: Su
    } = _a.current, {
      layout: Tu,
      panelDataArray: Au
    } = Ta.current, {
      initialLayout: Zl
    } = Os ?? {}, Iu = jl(Pa, xa, _u);
    let Uc = vh$1(wo, xa, Oa, Os, Ml, _u);
    if (Uc === 0)
      return;
    const Pu = Oa === "horizontal";
    document.dir === "rtl" && Pu && (Uc = -Uc);
    const Lu = Au.map((N1) => N1.constraints), th = Sn({
      delta: Uc,
      initialLayout: Zl ?? Tu,
      panelConstraints: Lu,
      pivotIndices: Iu,
      prevLayout: Tu,
      trigger: Tl(wo) ? "keyboard" : "mouse-or-touch"
    }), Zc = !co(Tu, th);
    (Ol(wo) || Dl(wo)) && Aa.current != Uc && (Aa.current = Uc, Zc ? gr(xa, 0) : Pu ? gr(xa, Uc < 0 ? Il : Nl) : gr(xa, Uc < 0 ? kl : Ll)), Zc && (En(th), Ta.current.layout = th, Su && Su(th), nn$1(Au, th, Rn.current));
  }, []), Se = Ge$1((xa, wo) => {
    const {
      onLayout: _u
    } = _a.current, {
      layout: Oa,
      panelDataArray: Os
    } = Ta.current, Pa = Os.map((Zl) => Zl.constraints), {
      panelSize: Ml,
      pivotIndices: Su
    } = Nt$1(Os, xa, Oa);
    me(Ml != null, `Panel size not found for panel "${xa.id}"`);
    const Tu = rn$1(Os, xa) === Os.length - 1 ? Ml - wo : wo - Ml, Au = Sn({
      delta: Tu,
      initialLayout: Oa,
      panelConstraints: Pa,
      pivotIndices: Su,
      prevLayout: Oa,
      trigger: "imperative-api"
    });
    co(Oa, Au) || (En(Au), Ta.current.layout = Au, _u && _u(Au), nn$1(Os, Au, Rn.current));
  }, []), Oe = Ge$1((xa, wo) => {
    const {
      layout: _u,
      panelDataArray: Oa
    } = Ta.current, {
      collapsedSize: Os = 0,
      collapsible: Pa
    } = wo, {
      collapsedSize: Ml = 0,
      collapsible: Su,
      maxSize: Tu = 100,
      minSize: Au = 0
    } = xa.constraints, {
      panelSize: Zl
    } = Nt$1(Oa, xa, _u);
    Zl != null && (Pa && Su && dt$1(Zl, Os) ? dt$1(Os, Ml) || Se(xa, Ml) : Zl < Au ? Se(xa, Au) : Zl > Tu && Se(xa, Tu));
  }, [Se]), Fr = Ge$1((xa, wo) => {
    const {
      direction: _u
    } = _a.current, {
      layout: Oa
    } = Ta.current;
    if (!st.current)
      return;
    const Os = Xo(xa, st.current);
    me(Os, `Drag handle element not found for id "${xa}"`);
    const Pa = Vl(_u, wo);
    br({
      dragHandleId: xa,
      dragHandleRect: Os.getBoundingClientRect(),
      initialCursorPosition: Pa,
      initialLayout: Oa
    });
  }, []), zn = Ge$1(() => {
    br(null);
  }, []), Fe = Ge$1((xa) => {
    const {
      panelDataArray: wo
    } = Ta.current, _u = rn$1(wo, xa);
    _u >= 0 && (wo.splice(_u, 1), delete Rn.current[xa.id], Ta.current.panelDataArrayChanged = !0);
  }, []), pe = Xg(() => ({
    collapsePanel: Zn,
    direction: ne,
    dragState: Nr,
    expandPanel: Ra,
    getPanelSize: Yn,
    getPanelStyle: $o,
    groupId: Ne,
    isPanelCollapsed: ct,
    isPanelExpanded: fe,
    reevaluatePanelConstraints: Oe,
    registerPanel: be,
    registerResizeHandle: ye,
    resizePanel: Se,
    startDragging: Fr,
    stopDragging: zn,
    unregisterPanel: Fe,
    panelGroupElement: st.current
  }), [Zn, Nr, ne, Ra, Yn, $o, Ne, ct, fe, Oe, be, ye, Se, Fr, zn, Fe]), it = {
    display: "flex",
    flexDirection: ne === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return dn$1(Ko.Provider, {
    value: pe
  }, dn$1(xe, {
    ...$e,
    children: y,
    className: z,
    id: le,
    ref: st,
    style: {
      ...it,
      ...Ee
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": ne,
    "data-panel-group-id": Ne
  }));
}
const Gl = Sl((v, y) => dn$1(Kl$1, {
  ...v,
  forwardedRef: y
}));
Kl$1.displayName = "PanelGroup";
Gl.displayName = "forwardRef(PanelGroup)";
function rn$1(v, y) {
  return v.findIndex((z) => z === y || z.id === y.id);
}
function Nt$1(v, y, z) {
  const ne = rn$1(v, y), ue = ne === v.length - 1 ? [ne - 1, ne] : [ne, ne + 1], le = z[ne];
  return {
    ...y.constraints,
    panelSize: le,
    pivotIndices: ue
  };
}
const kr = "horizontal", Ch = [
  "horizontal",
  "vertical"
], Yl = /* @__PURE__ */ forwardRef((v, y) => {
  const { decorative: z, orientation: ne = kr, ...ue } = v, le = Xl(ne) ? ne : kr, he = z ? {
    role: "none"
  } : {
    "aria-orientation": le === "vertical" ? le : void 0,
    role: "separator"
  };
  return /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-orientation": le
  }, he, ue, {
    ref: y
  }));
});
Yl.propTypes = {
  orientation(v, y, z) {
    const ne = v[y], ue = String(ne);
    return ne && !Xl(ne) ? new Error(Eh(ue, z)) : null;
  }
};
function Eh(v, y) {
  return `Invalid prop \`orientation\` of value \`${v}\` supplied to \`${y}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${kr}\`.`;
}
function Xl(v) {
  return Ch.includes(v);
}
const ql = Yl, Sh = a$z.forwardRef(
  ({ className: v, orientation: y = "horizontal", decorative: z = !0, ...ne }, ue) => /* @__PURE__ */ D$6.jsx(
    ql,
    {
      ref: ue,
      decorative: z,
      orientation: y,
      className: Y$1(
        "shrink-0 bg-border",
        y === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        v
      ),
      ...ne
    }
  )
);
Sh.displayName = ql.displayName;
const Ph = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], _h = [
  " ",
  "Enter"
], qo = "Select", [Jo, Qo, Rh] = xo(qo), [hn$1, Rw] = Le(qo, [
  Rh,
  Rt$1
]), Ca = Rt$1(), [Ah, Zt$1] = hn$1(qo), [Th, Oh] = hn$1(qo), Mh = "SelectTrigger", Ih = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, disabled: ne = !1, ...ue } = v, le = Ca(z), he = Zt$1(Mh, z), ge = he.disabled || ne, we = de(y, he.onTriggerChange), Ee = Qo(z), [xe, $e, Ne] = ou((Nr) => {
    const br = Ee().filter(
      (Rn) => !Rn.disabled
    ), $n = br.find(
      (Rn) => Rn.value === he.value
    ), En = ru(br, Nr, $n);
    En !== void 0 && he.onValueChange(En.value);
  }), st = () => {
    ge || (he.onOpenChange(!0), Ne());
  };
  return /* @__PURE__ */ createElement(Fo, _$2({
    asChild: !0
  }, le), /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    role: "combobox",
    "aria-controls": he.contentId,
    "aria-expanded": he.open,
    "aria-required": he.required,
    "aria-autocomplete": "none",
    dir: he.dir,
    "data-state": he.open ? "open" : "closed",
    disabled: ge,
    "data-disabled": ge ? "" : void 0,
    "data-placeholder": tu(he.value) ? "" : void 0
  }, ue, {
    ref: we,
    onClick: H$2(ue.onClick, (Nr) => {
      Nr.currentTarget.focus();
    }),
    onPointerDown: H$2(ue.onPointerDown, (Nr) => {
      const br = Nr.target;
      br.hasPointerCapture(Nr.pointerId) && br.releasePointerCapture(Nr.pointerId), Nr.button === 0 && Nr.ctrlKey === !1 && (st(), he.triggerPointerDownPosRef.current = {
        x: Math.round(Nr.pageX),
        y: Math.round(Nr.pageY)
      }, Nr.preventDefault());
    }),
    onKeyDown: H$2(ue.onKeyDown, (Nr) => {
      const br = xe.current !== "";
      !(Nr.ctrlKey || Nr.altKey || Nr.metaKey) && Nr.key.length === 1 && $e(Nr.key), !(br && Nr.key === " ") && Ph.includes(Nr.key) && (st(), Nr.preventDefault());
    })
  })));
}), Lh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, children: ne, ...ue } = v;
  return /* @__PURE__ */ createElement(X$2.span, _$2({
    "aria-hidden": !0
  }, ue, {
    ref: y
  }), ne || "▼");
}), Fh = (v) => /* @__PURE__ */ createElement(Ao, _$2({
  asChild: !0
}, v)), fn$1 = "SelectContent", zh = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Zt$1(fn$1, v.__scopeSelect), [ne, ue] = useState();
  if (ke$1(() => {
    ue(new DocumentFragment());
  }, []), !z.open) {
    const le = ne;
    return le ? /* @__PURE__ */ createPortal(/* @__PURE__ */ createElement(Jl, {
      scope: v.__scopeSelect
    }, /* @__PURE__ */ createElement(Jo.Slot, {
      scope: v.__scopeSelect
    }, /* @__PURE__ */ createElement("div", null, v.children))), le) : null;
  }
  return /* @__PURE__ */ createElement(jh, _$2({}, v, {
    ref: y
  }));
}), ut$1 = 10, [Jl, Yt$1] = hn$1(fn$1), jh = /* @__PURE__ */ forwardRef((v, y) => {
  const {
    __scopeSelect: z,
    position: ne = "item-aligned",
    onCloseAutoFocus: ue,
    onEscapeKeyDown: le,
    onPointerDownOutside: he,
    side: ge,
    sideOffset: we,
    align: Ee,
    alignOffset: xe,
    arrowPadding: $e,
    collisionBoundary: Ne,
    collisionPadding: st,
    sticky: Nr,
    hideWhenDetached: br,
    avoidCollisions: $n,
    //
    ...En
  } = v, Rn = Zt$1(fn$1, z), [wa, Aa] = useState(null), [_a, Ta] = useState(null), Zn = de(
    y,
    (Pa) => Aa(Pa)
  ), [Ra, Yn] = useState(null), [$o, ct] = useState(null), fe = Qo(z), [be, ye] = useState(!1), Se = useRef(!1);
  useEffect(() => {
    if (wa)
      return Mo(wa);
  }, [
    wa
  ]), To();
  const Oe = useCallback((Pa) => {
    const [Ml, ...Su] = fe().map(
      (Zl) => Zl.ref.current
    ), [Tu] = Su.slice(-1), Au = document.activeElement;
    for (const Zl of Pa)
      if (Zl === Au || (Zl == null || Zl.scrollIntoView({
        block: "nearest"
      }), Zl === Ml && _a && (_a.scrollTop = 0), Zl === Tu && _a && (_a.scrollTop = _a.scrollHeight), Zl == null || Zl.focus(), document.activeElement !== Au))
        return;
  }, [
    fe,
    _a
  ]), Fr = useCallback(
    () => Oe([
      Ra,
      wa
    ]),
    [
      Oe,
      Ra,
      wa
    ]
  );
  useEffect(() => {
    be && Fr();
  }, [
    be,
    Fr
  ]);
  const { onOpenChange: zn, triggerPointerDownPosRef: Fe } = Rn;
  useEffect(() => {
    if (wa) {
      let Pa = {
        x: 0,
        y: 0
      };
      const Ml = (Tu) => {
        var Au, Zl, Iu, Uc;
        Pa = {
          x: Math.abs(Math.round(Tu.pageX) - ((Au = (Zl = Fe.current) === null || Zl === void 0 ? void 0 : Zl.x) !== null && Au !== void 0 ? Au : 0)),
          y: Math.abs(Math.round(Tu.pageY) - ((Iu = (Uc = Fe.current) === null || Uc === void 0 ? void 0 : Uc.y) !== null && Iu !== void 0 ? Iu : 0))
        };
      }, Su = (Tu) => {
        Pa.x <= 10 && Pa.y <= 10 ? Tu.preventDefault() : wa.contains(Tu.target) || zn(!1), document.removeEventListener("pointermove", Ml), Fe.current = null;
      };
      return Fe.current !== null && (document.addEventListener("pointermove", Ml), document.addEventListener("pointerup", Su, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", Ml), document.removeEventListener("pointerup", Su, {
          capture: !0
        });
      };
    }
  }, [
    wa,
    zn,
    Fe
  ]), useEffect(() => {
    const Pa = () => zn(!1);
    return window.addEventListener("blur", Pa), window.addEventListener("resize", Pa), () => {
      window.removeEventListener("blur", Pa), window.removeEventListener("resize", Pa);
    };
  }, [
    zn
  ]);
  const [pe, it] = ou((Pa) => {
    const Ml = fe().filter(
      (Au) => !Au.disabled
    ), Su = Ml.find(
      (Au) => Au.ref.current === document.activeElement
    ), Tu = ru(Ml, Pa, Su);
    Tu && setTimeout(
      () => Tu.ref.current.focus()
    );
  }), xa = useCallback((Pa, Ml, Su) => {
    const Tu = !Se.current && !Su;
    (Rn.value !== void 0 && Rn.value === Ml || Tu) && (Yn(Pa), Tu && (Se.current = !0));
  }, [
    Rn.value
  ]), wo = useCallback(
    () => wa == null ? void 0 : wa.focus(),
    [
      wa
    ]
  ), _u = useCallback((Pa, Ml, Su) => {
    const Tu = !Se.current && !Su;
    (Rn.value !== void 0 && Rn.value === Ml || Tu) && ct(Pa);
  }, [
    Rn.value
  ]), Oa = ne === "popper" ? Hc : Hh, Os = Oa === Hc ? {
    side: ge,
    sideOffset: we,
    align: Ee,
    alignOffset: xe,
    arrowPadding: $e,
    collisionBoundary: Ne,
    collisionPadding: st,
    sticky: Nr,
    hideWhenDetached: br,
    avoidCollisions: $n
  } : {};
  return /* @__PURE__ */ createElement(Jl, {
    scope: z,
    content: wa,
    viewport: _a,
    onViewportChange: Ta,
    itemRefCallback: xa,
    selectedItem: Ra,
    onItemLeave: wo,
    itemTextRefCallback: _u,
    focusSelectedItem: Fr,
    selectedItemText: $o,
    position: ne,
    isPositioned: be,
    searchRef: pe
  }, /* @__PURE__ */ createElement(Do, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360,
    allowPinchZoom: !0
  }, /* @__PURE__ */ createElement(Ro, {
    asChild: !0,
    trapped: Rn.open,
    onMountAutoFocus: (Pa) => {
      Pa.preventDefault();
    },
    onUnmountAutoFocus: H$2(ue, (Pa) => {
      var Ml;
      (Ml = Rn.trigger) === null || Ml === void 0 || Ml.focus({
        preventScroll: !0
      }), Pa.preventDefault();
    })
  }, /* @__PURE__ */ createElement(jn, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: le,
    onPointerDownOutside: he,
    onFocusOutside: (Pa) => Pa.preventDefault(),
    onDismiss: () => Rn.onOpenChange(!1)
  }, /* @__PURE__ */ createElement(Oa, _$2({
    role: "listbox",
    id: Rn.contentId,
    "data-state": Rn.open ? "open" : "closed",
    dir: Rn.dir,
    onContextMenu: (Pa) => Pa.preventDefault()
  }, En, Os, {
    onPlaced: () => ye(!0),
    ref: Zn,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...En.style
    },
    onKeyDown: H$2(En.onKeyDown, (Pa) => {
      const Ml = Pa.ctrlKey || Pa.altKey || Pa.metaKey;
      if (Pa.key === "Tab" && Pa.preventDefault(), !Ml && Pa.key.length === 1 && it(Pa.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(Pa.key)) {
        let Su = fe().filter(
          (Tu) => !Tu.disabled
        ).map(
          (Tu) => Tu.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(Pa.key) && (Su = Su.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(Pa.key)) {
          const Tu = Pa.target, Au = Su.indexOf(Tu);
          Su = Su.slice(Au + 1);
        }
        setTimeout(
          () => Oe(Su)
        ), Pa.preventDefault();
      }
    })
  }))))));
}), Hh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, onPlaced: ne, ...ue } = v, le = Zt$1(fn$1, z), he = Yt$1(fn$1, z), [ge, we] = useState(null), [Ee, xe] = useState(null), $e = de(
    y,
    (Zn) => xe(Zn)
  ), Ne = Qo(z), st = useRef(!1), Nr = useRef(!0), { viewport: br, selectedItem: $n, selectedItemText: En, focusSelectedItem: Rn } = he, wa = useCallback(() => {
    if (le.trigger && le.valueNode && ge && Ee && br && $n && En) {
      const Zn = le.trigger.getBoundingClientRect(), Ra = Ee.getBoundingClientRect(), Yn = le.valueNode.getBoundingClientRect(), $o = En.getBoundingClientRect();
      if (le.dir !== "rtl") {
        const Tu = $o.left - Ra.left, Au = Yn.left - Tu, Zl = Zn.left - Au, Iu = Zn.width + Zl, Uc = Math.max(Iu, Ra.width), Pu = window.innerWidth - ut$1, Lu = Dr(Au, [
          ut$1,
          Pu - Uc
        ]);
        ge.style.minWidth = Iu + "px", ge.style.left = Lu + "px";
      } else {
        const Tu = Ra.right - $o.right, Au = window.innerWidth - Yn.right - Tu, Zl = window.innerWidth - Zn.right - Au, Iu = Zn.width + Zl, Uc = Math.max(Iu, Ra.width), Pu = window.innerWidth - ut$1, Lu = Dr(Au, [
          ut$1,
          Pu - Uc
        ]);
        ge.style.minWidth = Iu + "px", ge.style.right = Lu + "px";
      }
      const ct = Ne(), fe = window.innerHeight - ut$1 * 2, be = br.scrollHeight, ye = window.getComputedStyle(Ee), Se = parseInt(ye.borderTopWidth, 10), Oe = parseInt(ye.paddingTop, 10), Fr = parseInt(ye.borderBottomWidth, 10), zn = parseInt(ye.paddingBottom, 10), Fe = Se + Oe + be + zn + Fr, pe = Math.min($n.offsetHeight * 5, Fe), it = window.getComputedStyle(br), xa = parseInt(it.paddingTop, 10), wo = parseInt(it.paddingBottom, 10), _u = Zn.top + Zn.height / 2 - ut$1, Oa = fe - _u, Os = $n.offsetHeight / 2, Pa = $n.offsetTop + Os, Ml = Se + Oe + Pa, Su = Fe - Ml;
      if (Ml <= _u) {
        const Tu = $n === ct[ct.length - 1].ref.current;
        ge.style.bottom = "0px";
        const Au = Ee.clientHeight - br.offsetTop - br.offsetHeight, Zl = Math.max(Oa, Os + (Tu ? wo : 0) + Au + Fr), Iu = Ml + Zl;
        ge.style.height = Iu + "px";
      } else {
        const Tu = $n === ct[0].ref.current;
        ge.style.top = "0px";
        const Au = Math.max(_u, Se + br.offsetTop + (Tu ? xa : 0) + Os) + Su;
        ge.style.height = Au + "px", br.scrollTop = Ml - _u + br.offsetTop;
      }
      ge.style.margin = `${ut$1}px 0`, ge.style.minHeight = pe + "px", ge.style.maxHeight = fe + "px", ne == null || ne(), requestAnimationFrame(
        () => st.current = !0
      );
    }
  }, [
    Ne,
    le.trigger,
    le.valueNode,
    ge,
    Ee,
    br,
    $n,
    En,
    le.dir,
    ne
  ]);
  ke$1(
    () => wa(),
    [
      wa
    ]
  );
  const [Aa, _a] = useState();
  ke$1(() => {
    Ee && _a(window.getComputedStyle(Ee).zIndex);
  }, [
    Ee
  ]);
  const Ta = useCallback((Zn) => {
    Zn && Nr.current === !0 && (wa(), Rn == null || Rn(), Nr.current = !1);
  }, [
    wa,
    Rn
  ]);
  return /* @__PURE__ */ createElement(Vh, {
    scope: z,
    contentWrapper: ge,
    shouldExpandOnScrollRef: st,
    onScrollButtonChange: Ta
  }, /* @__PURE__ */ createElement("div", {
    ref: we,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: Aa
    }
  }, /* @__PURE__ */ createElement(X$2.div, _$2({}, ue, {
    ref: $e,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...ue.style
    }
  }))));
}), Hc = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, align: ne = "start", collisionPadding: ue = ut$1, ...le } = v, he = Ca(z);
  return /* @__PURE__ */ createElement(zo, _$2({}, he, le, {
    ref: y,
    align: ne,
    collisionPadding: ue,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...le.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [Vh, Ea] = hn$1(fn$1, {}), Vc = "SelectViewport", Bh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, ...ne } = v, ue = Yt$1(Vc, z), le = Ea(Vc, z), he = de(y, ue.onViewportChange), ge = useRef(0);
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ createElement(Jo.Slot, {
    scope: z
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, ne, {
    ref: he,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...ne.style
    },
    onScroll: H$2(ne.onScroll, (we) => {
      const Ee = we.currentTarget, { contentWrapper: xe, shouldExpandOnScrollRef: $e } = le;
      if ($e != null && $e.current && xe) {
        const Ne = Math.abs(ge.current - Ee.scrollTop);
        if (Ne > 0) {
          const st = window.innerHeight - ut$1 * 2, Nr = parseFloat(xe.style.minHeight), br = parseFloat(xe.style.height), $n = Math.max(Nr, br);
          if ($n < st) {
            const En = $n + Ne, Rn = Math.min(st, En), wa = En - Rn;
            xe.style.height = Rn + "px", xe.style.bottom === "0px" && (Ee.scrollTop = wa > 0 ? wa : 0, xe.style.justifyContent = "flex-end");
          }
        }
      }
      ge.current = Ee.scrollTop;
    })
  }))));
}), Wh = "SelectGroup", [Uh, Kh$1] = hn$1(Wh), Zh = "SelectLabel", Yh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, ...ne } = v, ue = Kh$1(Zh, z);
  return /* @__PURE__ */ createElement(X$2.div, _$2({
    id: ue.id
  }, ne, {
    ref: y
  }));
}), Lr = "SelectItem", [Xh, Ql] = hn$1(Lr), qh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, value: ne, disabled: ue = !1, textValue: le, ...he } = v, ge = Zt$1(Lr, z), we = Yt$1(Lr, z), Ee = ge.value === ne, [xe, $e] = useState(le ?? ""), [Ne, st] = useState(!1), Nr = de(y, (En) => {
    var Rn;
    return (Rn = we.itemRefCallback) === null || Rn === void 0 ? void 0 : Rn.call(we, En, ne, ue);
  }), br = je$1(), $n = () => {
    ue || (ge.onValueChange(ne), ge.onOpenChange(!1));
  };
  if (ne === "")
    throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ createElement(Xh, {
    scope: z,
    value: ne,
    disabled: ue,
    textId: br,
    isSelected: Ee,
    onItemTextChange: useCallback((En) => {
      $e((Rn) => {
        var wa;
        return Rn || ((wa = En == null ? void 0 : En.textContent) !== null && wa !== void 0 ? wa : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ createElement(Jo.ItemSlot, {
    scope: z,
    value: ne,
    disabled: ue,
    textValue: xe
  }, /* @__PURE__ */ createElement(X$2.div, _$2({
    role: "option",
    "aria-labelledby": br,
    "data-highlighted": Ne ? "" : void 0,
    "aria-selected": Ee && Ne,
    "data-state": Ee ? "checked" : "unchecked",
    "aria-disabled": ue || void 0,
    "data-disabled": ue ? "" : void 0,
    tabIndex: ue ? void 0 : -1
  }, he, {
    ref: Nr,
    onFocus: H$2(
      he.onFocus,
      () => st(!0)
    ),
    onBlur: H$2(
      he.onBlur,
      () => st(!1)
    ),
    onPointerUp: H$2(he.onPointerUp, $n),
    onPointerMove: H$2(he.onPointerMove, (En) => {
      if (ue) {
        var Rn;
        (Rn = we.onItemLeave) === null || Rn === void 0 || Rn.call(we);
      } else
        En.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: H$2(he.onPointerLeave, (En) => {
      if (En.currentTarget === document.activeElement) {
        var Rn;
        (Rn = we.onItemLeave) === null || Rn === void 0 || Rn.call(we);
      }
    }),
    onKeyDown: H$2(he.onKeyDown, (En) => {
      var Rn;
      ((Rn = we.searchRef) === null || Rn === void 0 ? void 0 : Rn.current) !== "" && En.key === " " || (_h.includes(En.key) && $n(), En.key === " " && En.preventDefault());
    })
  }))));
}), io = "SelectItemText", Jh = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, className: ne, style: ue, ...le } = v, he = Zt$1(io, z), ge = Yt$1(io, z), we = Ql(io, z), Ee = Oh(io, z), [xe, $e] = useState(null), Ne = de(
    y,
    (En) => $e(En),
    we.onItemTextChange,
    (En) => {
      var Rn;
      return (Rn = ge.itemTextRefCallback) === null || Rn === void 0 ? void 0 : Rn.call(ge, En, we.value, we.disabled);
    }
  ), st = xe == null ? void 0 : xe.textContent, Nr = useMemo(
    () => /* @__PURE__ */ createElement("option", {
      key: we.value,
      value: we.value,
      disabled: we.disabled
    }, st),
    [
      we.disabled,
      we.value,
      st
    ]
  ), { onNativeOptionAdd: br, onNativeOptionRemove: $n } = Ee;
  return ke$1(() => (br(Nr), () => $n(Nr)), [
    br,
    $n,
    Nr
  ]), /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement(X$2.span, _$2({
    id: we.textId
  }, le, {
    ref: Ne
  })), we.isSelected && he.valueNode && !he.valueNodeHasChildren ? /* @__PURE__ */ createPortal(le.children, he.valueNode) : null);
}), Qh = "SelectItemIndicator", e$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, ...ne } = v;
  return Ql(Qh, z).isSelected ? /* @__PURE__ */ createElement(X$2.span, _$2({
    "aria-hidden": !0
  }, ne, {
    ref: y
  })) : null;
}), Bc = "SelectScrollUpButton", t$ = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Yt$1(Bc, v.__scopeSelect), ne = Ea(Bc, v.__scopeSelect), [ue, le] = useState(!1), he = de(y, ne.onScrollButtonChange);
  return ke$1(() => {
    if (z.viewport && z.isPositioned) {
      let ge = function() {
        const Ee = we.scrollTop > 0;
        le(Ee);
      };
      const we = z.viewport;
      return ge(), we.addEventListener("scroll", ge), () => we.removeEventListener("scroll", ge);
    }
  }, [
    z.viewport,
    z.isPositioned
  ]), ue ? /* @__PURE__ */ createElement(eu, _$2({}, v, {
    ref: he,
    onAutoScroll: () => {
      const { viewport: ge, selectedItem: we } = z;
      ge && we && (ge.scrollTop = ge.scrollTop - we.offsetHeight);
    }
  })) : null;
}), Wc = "SelectScrollDownButton", n$ = /* @__PURE__ */ forwardRef((v, y) => {
  const z = Yt$1(Wc, v.__scopeSelect), ne = Ea(Wc, v.__scopeSelect), [ue, le] = useState(!1), he = de(y, ne.onScrollButtonChange);
  return ke$1(() => {
    if (z.viewport && z.isPositioned) {
      let ge = function() {
        const Ee = we.scrollHeight - we.clientHeight, xe = Math.ceil(we.scrollTop) < Ee;
        le(xe);
      };
      const we = z.viewport;
      return ge(), we.addEventListener("scroll", ge), () => we.removeEventListener("scroll", ge);
    }
  }, [
    z.viewport,
    z.isPositioned
  ]), ue ? /* @__PURE__ */ createElement(eu, _$2({}, v, {
    ref: he,
    onAutoScroll: () => {
      const { viewport: ge, selectedItem: we } = z;
      ge && we && (ge.scrollTop = ge.scrollTop + we.offsetHeight);
    }
  })) : null;
}), eu = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, onAutoScroll: ne, ...ue } = v, le = Yt$1("SelectScrollButton", z), he = useRef(null), ge = Qo(z), we = useCallback(() => {
    he.current !== null && (window.clearInterval(he.current), he.current = null);
  }, []);
  return useEffect(() => () => we(), [
    we
  ]), ke$1(() => {
    var Ee;
    const xe = ge().find(
      ($e) => $e.ref.current === document.activeElement
    );
    xe == null || (Ee = xe.ref.current) === null || Ee === void 0 || Ee.scrollIntoView({
      block: "nearest"
    });
  }, [
    ge
  ]), /* @__PURE__ */ createElement(X$2.div, _$2({
    "aria-hidden": !0
  }, ue, {
    ref: y,
    style: {
      flexShrink: 0,
      ...ue.style
    },
    onPointerDown: H$2(ue.onPointerDown, () => {
      he.current === null && (he.current = window.setInterval(ne, 50));
    }),
    onPointerMove: H$2(ue.onPointerMove, () => {
      var Ee;
      (Ee = le.onItemLeave) === null || Ee === void 0 || Ee.call(le), he.current === null && (he.current = window.setInterval(ne, 50));
    }),
    onPointerLeave: H$2(ue.onPointerLeave, () => {
      we();
    })
  }));
}), o$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSelect: z, ...ne } = v;
  return /* @__PURE__ */ createElement(X$2.div, _$2({
    "aria-hidden": !0
  }, ne, {
    ref: y
  }));
});
function tu(v) {
  return v === "" || v === void 0;
}
const nu = /* @__PURE__ */ forwardRef((v, y) => {
  const { value: z, ...ne } = v, ue = useRef(null), le = de(y, ue), he = Po(z);
  return useEffect(() => {
    const ge = ue.current, we = window.HTMLSelectElement.prototype, Ee = Object.getOwnPropertyDescriptor(we, "value").set;
    if (he !== z && Ee) {
      const xe = new Event("change", {
        bubbles: !0
      });
      Ee.call(ge, z), ge.dispatchEvent(xe);
    }
  }, [
    he,
    z
  ]), /* @__PURE__ */ createElement(yl, {
    asChild: !0
  }, /* @__PURE__ */ createElement("select", _$2({}, ne, {
    ref: le,
    defaultValue: z
  })));
});
nu.displayName = "BubbleSelect";
function ou(v) {
  const y = Te$1(v), z = useRef(""), ne = useRef(0), ue = useCallback((he) => {
    const ge = z.current + he;
    y(ge), function we(Ee) {
      z.current = Ee, window.clearTimeout(ne.current), Ee !== "" && (ne.current = window.setTimeout(
        () => we(""),
        1e3
      ));
    }(ge);
  }, [
    y
  ]), le = useCallback(() => {
    z.current = "", window.clearTimeout(ne.current);
  }, []);
  return useEffect(() => () => window.clearTimeout(ne.current), []), [
    z,
    ue,
    le
  ];
}
function ru(v, y, z) {
  const ne = y.length > 1 && Array.from(y).every(
    (ge) => ge === y[0]
  ) ? y[0] : y, ue = z ? v.indexOf(z) : -1;
  let le = r$(v, Math.max(ue, 0));
  ne.length === 1 && (le = le.filter(
    (ge) => ge !== z
  ));
  const he = le.find(
    (ge) => ge.textValue.toLowerCase().startsWith(ne.toLowerCase())
  );
  return he !== z ? he : void 0;
}
function r$(v, y) {
  return v.map(
    (z, ne) => v[(y + ne) % v.length]
  );
}
const au = Ih, i$ = Lh, s$ = Fh, cu = zh, l$ = Bh, iu = Yh, su = qh, d$ = Jh, f$ = e$, lu = t$, uu = n$, du = o$, p$ = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsxs(
  au,
  {
    ref: ne,
    className: Y$1(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      v
    ),
    ...z,
    children: [
      y,
      /* @__PURE__ */ D$6.jsx(i$, { asChild: !0, children: /* @__PURE__ */ D$6.jsx(Eo, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
p$.displayName = au.displayName;
const fu = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  lu,
  {
    ref: z,
    className: Y$1(
      "flex cursor-default items-center justify-center py-1",
      v
    ),
    ...y,
    children: /* @__PURE__ */ D$6.jsx(li, { className: "h-4 w-4" })
  }
));
fu.displayName = lu.displayName;
const pu = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  uu,
  {
    ref: z,
    className: Y$1(
      "flex cursor-default items-center justify-center py-1",
      v
    ),
    ...y,
    children: /* @__PURE__ */ D$6.jsx(Eo, { className: "h-4 w-4" })
  }
));
pu.displayName = uu.displayName;
const m$ = a$z.forwardRef(
  ({ className: v, children: y, portalContainer: z, position: ne = "popper", ...ue }, le) => {
    const he = Bn$1();
    return /* @__PURE__ */ D$6.jsx(s$, { container: z ?? he, children: /* @__PURE__ */ D$6.jsxs(
      cu,
      {
        ref: le,
        className: Y$1(
          "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          ne === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
          v
        ),
        position: ne,
        ...ue,
        children: [
          /* @__PURE__ */ D$6.jsx(fu, {}),
          /* @__PURE__ */ D$6.jsx(
            l$,
            {
              className: Y$1(
                "p-1",
                ne === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
              ),
              children: y
            }
          ),
          /* @__PURE__ */ D$6.jsx(pu, {})
        ]
      }
    ) });
  }
);
m$.displayName = cu.displayName;
const v$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  iu,
  {
    ref: z,
    className: Y$1("py-1.5 pl-8 pr-2 text-sm font-semibold", v),
    ...y
  }
));
v$.displayName = iu.displayName;
const b$ = a$z.forwardRef(({ className: v, children: y, ...z }, ne) => /* @__PURE__ */ D$6.jsxs(
  su,
  {
    ref: ne,
    className: Y$1(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      v
    ),
    ...z,
    children: [
      /* @__PURE__ */ D$6.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ D$6.jsx(f$, { children: /* @__PURE__ */ D$6.jsx(So, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ D$6.jsx(d$, { children: y })
    ]
  }
));
b$.displayName = su.displayName;
const g$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  du,
  {
    ref: z,
    className: Y$1("-mx-1 my-1 h-px bg-muted", v),
    ...y
  }
));
g$.displayName = du.displayName;
const mu = "Switch", [h$, Dw] = Le(mu), [$$, w$] = h$(mu), x$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSwitch: z, name: ne, checked: ue, defaultChecked: le, required: he, disabled: ge, value: we = "on", onCheckedChange: Ee, ...xe } = v, [$e, Ne] = useState(null), st = de(
    y,
    (Rn) => Ne(Rn)
  ), Nr = useRef(!1), br = $e ? !!$e.closest("form") : !0, [$n = !1, En] = Be$1({
    prop: ue,
    defaultProp: le,
    onChange: Ee
  });
  return /* @__PURE__ */ createElement($$, {
    scope: z,
    checked: $n,
    disabled: ge
  }, /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    role: "switch",
    "aria-checked": $n,
    "aria-required": he,
    "data-state": vu($n),
    "data-disabled": ge ? "" : void 0,
    disabled: ge,
    value: we
  }, xe, {
    ref: st,
    onClick: H$2(v.onClick, (Rn) => {
      En(
        (wa) => !wa
      ), br && (Nr.current = Rn.isPropagationStopped(), Nr.current || Rn.stopPropagation());
    })
  })), br && /* @__PURE__ */ createElement(E$, {
    control: $e,
    bubbles: !Nr.current,
    name: ne,
    value: we,
    checked: $n,
    required: he,
    disabled: ge,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), y$ = "SwitchThumb", C$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeSwitch: z, ...ne } = v, ue = w$(y$, z);
  return /* @__PURE__ */ createElement(X$2.span, _$2({
    "data-state": vu(ue.checked),
    "data-disabled": ue.disabled ? "" : void 0
  }, ne, {
    ref: y
  }));
}), E$ = (v) => {
  const { control: y, checked: z, bubbles: ne = !0, ...ue } = v, le = useRef(null), he = Po(z), ge = _o(y);
  return useEffect(() => {
    const we = le.current, Ee = window.HTMLInputElement.prototype, xe = Object.getOwnPropertyDescriptor(Ee, "checked").set;
    if (he !== z && xe) {
      const $e = new Event("click", {
        bubbles: ne
      });
      xe.call(we, z), we.dispatchEvent($e);
    }
  }, [
    he,
    z,
    ne
  ]), /* @__PURE__ */ createElement("input", _$2({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: z
  }, ue, {
    tabIndex: -1,
    ref: le,
    style: {
      ...v.style,
      ...ge,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function vu(v) {
  return v ? "checked" : "unchecked";
}
const bu = x$, S$ = C$, P$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  bu,
  {
    className: Y$1(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      v
    ),
    ...y,
    ref: z,
    children: /* @__PURE__ */ D$6.jsx(
      S$,
      {
        className: Y$1(
          "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
P$.displayName = bu.displayName;
const gu = "Tabs", [_$, Mw] = Le(gu, [
  bn$7
]), hu = bn$7(), [R$, Sa] = _$(gu), T$ = "TabsList", O$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeTabs: z, loop: ne = !0, ...ue } = v, le = Sa(T$, z), he = hu(z);
  return /* @__PURE__ */ createElement(sa, _$2({
    asChild: !0
  }, he, {
    orientation: le.orientation,
    dir: le.dir,
    loop: ne
  }), /* @__PURE__ */ createElement(X$2.div, _$2({
    role: "tablist",
    "aria-orientation": le.orientation
  }, ue, {
    ref: y
  })));
}), D$ = "TabsTrigger", M$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeTabs: z, value: ne, disabled: ue = !1, ...le } = v, he = Sa(D$, z), ge = hu(z), we = $u(he.baseId, ne), Ee = wu(he.baseId, ne), xe = ne === he.value;
  return /* @__PURE__ */ createElement(la, _$2({
    asChild: !0
  }, ge, {
    focusable: !ue,
    active: xe
  }), /* @__PURE__ */ createElement(X$2.button, _$2({
    type: "button",
    role: "tab",
    "aria-selected": xe,
    "aria-controls": Ee,
    "data-state": xe ? "active" : "inactive",
    "data-disabled": ue ? "" : void 0,
    disabled: ue,
    id: we
  }, le, {
    ref: y,
    onMouseDown: H$2(v.onMouseDown, ($e) => {
      !ue && $e.button === 0 && $e.ctrlKey === !1 ? he.onValueChange(ne) : $e.preventDefault();
    }),
    onKeyDown: H$2(v.onKeyDown, ($e) => {
      [
        " ",
        "Enter"
      ].includes($e.key) && he.onValueChange(ne);
    }),
    onFocus: H$2(v.onFocus, () => {
      const $e = he.activationMode !== "manual";
      !xe && !ue && $e && he.onValueChange(ne);
    })
  })));
}), I$ = "TabsContent", N$ = /* @__PURE__ */ forwardRef((v, y) => {
  const { __scopeTabs: z, value: ne, forceMount: ue, children: le, ...he } = v, ge = Sa(I$, z), we = $u(ge.baseId, ne), Ee = wu(ge.baseId, ne), xe = ne === ge.value, $e = useRef(xe);
  return useEffect(() => {
    const Ne = requestAnimationFrame(
      () => $e.current = !1
    );
    return () => cancelAnimationFrame(Ne);
  }, []), /* @__PURE__ */ createElement(
    Ie,
    {
      present: ue || xe
    },
    ({ present: Ne }) => /* @__PURE__ */ createElement(X$2.div, _$2({
      "data-state": xe ? "active" : "inactive",
      "data-orientation": ge.orientation,
      role: "tabpanel",
      "aria-labelledby": we,
      hidden: !Ne,
      id: Ee,
      tabIndex: 0
    }, he, {
      ref: y,
      style: {
        ...v.style,
        animationDuration: $e.current ? "0s" : void 0
      }
    }), Ne && le)
  );
});
function $u(v, y) {
  return `${v}-trigger-${y}`;
}
function wu(v, y) {
  return `${v}-content-${y}`;
}
const xu = O$, yu = M$, Cu = N$, L$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  xu,
  {
    ref: z,
    className: Y$1(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      v
    ),
    ...y
  }
));
L$.displayName = xu.displayName;
const F$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  yu,
  {
    ref: z,
    className: Y$1(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      v
    ),
    ...y
  }
));
F$.displayName = yu.displayName;
const z$ = a$z.forwardRef(({ className: v, ...y }, z) => /* @__PURE__ */ D$6.jsx(
  Cu,
  {
    ref: z,
    className: Y$1(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      v
    ),
    ...y
  }
));
z$.displayName = Cu.displayName;
const o$6 = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
var R$7 = Object.defineProperty, l$b = Object.getOwnPropertySymbols, f$z = Object.prototype.hasOwnProperty, g$1 = Object.prototype.propertyIsEnumerable, d$5 = (v, y, z) => y in v ? R$7(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, s$y = (v, y) => {
  for (var z in y || (y = {}))
    f$z.call(y, z) && d$5(v, z, y[z]);
  if (l$b)
    for (var z of l$b(y))
      g$1.call(y, z) && d$5(v, z, y[z]);
  return v;
}, a$y = (v, y) => {
  var z = {};
  for (var ne in v)
    f$z.call(v, ne) && y.indexOf(ne) < 0 && (z[ne] = v[ne]);
  if (v != null && l$b)
    for (var ne of l$b(v))
      y.indexOf(ne) < 0 && g$1.call(v, ne) && (z[ne] = v[ne]);
  return z;
};
const P$1 = forwardRef((v, y) => {
  const z = v, {
    alt: ne,
    color: ue,
    size: le,
    weight: he,
    mirrored: ge,
    children: we,
    weights: Ee
  } = z, xe = a$y(z, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), $e = useContext(o$6), {
    color: Ne = "currentColor",
    size: st,
    weight: Nr = "regular",
    mirrored: br = !1
  } = $e, $n = a$y($e, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    s$y(s$y({
      ref: y,
      xmlns: "http://www.w3.org/2000/svg",
      width: le ?? st,
      height: le ?? st,
      fill: ue ?? Ne,
      viewBox: "0 0 256 256",
      transform: ge || br ? "scale(-1, 1)" : void 0
    }, $n), xe),
    !!ne && /* @__PURE__ */ a__default.createElement("title", null, ne),
    we,
    Ee.get(he ?? Nr)
  );
});
P$1.displayName = "IconBase";
const t$J = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M244,56v48a12,12,0,0,1-12,12H184a12,12,0,1,1,0-24H201.1l-19-17.38c-.13-.12-.26-.24-.38-.37A76,76,0,1,0,127,204h1a75.53,75.53,0,0,0,52.15-20.72,12,12,0,0,1,16.49,17.45A99.45,99.45,0,0,1,128,228h-1.37A100,100,0,1,1,198.51,57.06L220,76.72V56a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,56v48H184Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M235.06,48.57a8,8,0,0,0-8.72,1.73L206.68,70,195.75,60a96,96,0,1,0-69.07,164H128a95.44,95.44,0,0,0,65.88-26.19,8,8,0,0,0-11-11.63A80,80,0,1,1,184.56,71.4l.25.24,10.55,9.65-17,17A8,8,0,0,0,184,112h48a8,8,0,0,0,8-8V56A8,8,0,0,0,235.06,48.57ZM224,96H203.31L224,75.28Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1-5.66-13.66l17-17-10.55-9.65-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,1,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60l10.93,10L226.34,50.3A8,8,0,0,1,240,56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M238,56v48a6,6,0,0,1-6,6H184a6,6,0,0,1,0-12h32.55l-30.38-27.8c-.06-.06-.12-.13-.19-.19a82,82,0,1,0-1.7,117.65,6,6,0,0,1,8.24,8.73A93.46,93.46,0,0,1,128,222h-1.28A94,94,0,1,1,194.37,61.4L226,90.35V56a6,6,0,1,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236,56v48a4,4,0,0,1-4,4H184a4,4,0,0,1,0-8h37.7L187.53,68.69l-.13-.12a84,84,0,1,0-1.75,120.51,4,4,0,0,1,5.5,5.82A91.43,91.43,0,0,1,128,220h-1.26A92,92,0,1,1,193,62.84l35,32.05V56a4,4,0,1,1,8,0Z" }))
  ]
]), t$I = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,152.49l-72,72a12,12,0,0,1-17,0l-72-72a12,12,0,0,1,17-17L116,187V40a12,12,0,0,1,24,0V187l51.51-51.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M200,144l-72,72L56,144Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M207.39,140.94A8,8,0,0,0,200,136H136V40a8,8,0,0,0-16,0v96H56a8,8,0,0,0-5.66,13.66l72,72a8,8,0,0,0,11.32,0l72-72A8,8,0,0,0,207.39,140.94ZM128,204.69,75.31,152H180.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72A8,8,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,148.24l-72,72a6,6,0,0,1-8.48,0l-72-72a6,6,0,0,1,8.48-8.48L122,201.51V40a6,6,0,0,1,12,0V201.51l61.76-61.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,146.83l-72,72a4,4,0,0,1-5.66,0l-72-72a4,4,0,0,1,5.66-5.66L124,206.34V40a4,4,0,0,1,8,0V206.34l65.17-65.17a4,4,0,0,1,5.66,5.66Z" }))
  ]
]), a$x = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,128l-72,72V56Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,122.34l-72-72A8,8,0,0,0,136,56v64H40a8,8,0,0,0,0,16h96v64a8,8,0,0,0,13.66,5.66l72-72A8,8,0,0,0,221.66,122.34ZM152,180.69V75.31L204.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,133.66l-72,72A8,8,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8,8,0,0,1,13.66-5.66l72,72A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220.24,132.24l-72,72a6,6,0,0,1-8.48-8.48L201.51,134H40a6,6,0,0,1,0-12H201.51L139.76,60.24a6,6,0,0,1,8.48-8.48l72,72A6,6,0,0,1,220.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M218.83,130.83l-72,72a4,4,0,0,1-5.66-5.66L206.34,132H40a4,4,0,0,1,0-8H206.34L141.17,58.83a4,4,0,0,1,5.66-5.66l72,72A4,4,0,0,1,218.83,130.83Z" }))
  ]
]), t$H = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,104a12,12,0,0,1-24,0V69l-59.51,59.51a12,12,0,0,1-17-17L187,52H152a12,12,0,0,1,0-24h64a12,12,0,0,1,12,12Zm-44,24a12,12,0,0,0-12,12v64H52V84h64a12,12,0,0,0,0-24H48A20,20,0,0,0,28,80V208a20,20,0,0,0,20,20H176a20,20,0,0,0,20-20V140A12,12,0,0,0,184,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M184,80V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H176A8,8,0,0,1,184,80Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M192,136v72a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64h72a8,8,0,0,1,0,16H48V208H176V136a8,8,0,0,1,16,0Zm32-96a8,8,0,0,0-8-8H152a8,8,0,0,0-5.66,13.66L172.69,72l-42.35,42.34a8,8,0,0,0,11.32,11.32L184,83.31l26.34,26.35A8,8,0,0,0,224,104Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,104a6,6,0,0,1-12,0V54.49l-69.75,69.75a6,6,0,0,1-8.48-8.48L201.51,46H152a6,6,0,0,1,0-12h64a6,6,0,0,1,6,6Zm-38,26a6,6,0,0,0-6,6v72a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V80a2,2,0,0,1,2-2h72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,80V208a14,14,0,0,0,14,14H176a14,14,0,0,0,14-14V136A6,6,0,0,0,184,130Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,104a4,4,0,0,1-8,0V49.66l-73.16,73.17a4,4,0,0,1-5.66-5.66L206.34,44H152a4,4,0,0,1,0-8h64a4,4,0,0,1,4,4Zm-36,28a4,4,0,0,0-4,4v72a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,80V208a12,12,0,0,0,12,12H176a12,12,0,0,0,12-12V136A4,4,0,0,0,184,132Z" }))
  ]
]), t$G = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M200,112H56l72-72Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,106.34l-72-72a8,8,0,0,0-11.32,0l-72,72A8,8,0,0,0,56,120h64v96a8,8,0,0,0,16,0V120h64a8,8,0,0,0,5.66-13.66ZM75.31,104,128,51.31,180.69,104Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M207.39,115.06A8,8,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8,8,0,0,1-5.66-13.66l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,207.39,115.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,116.24a6,6,0,0,1-8.48,0L134,54.49V216a6,6,0,0,1-12,0V54.49L60.24,116.24a6,6,0,0,1-8.48-8.48l72-72a6,6,0,0,1,8.48,0l72,72A6,6,0,0,1,204.24,116.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,114.83a4,4,0,0,1-5.66,0L132,49.66V216a4,4,0,0,1-8,0V49.66L58.83,114.83a4,4,0,0,1-5.66-5.66l72-72a4,4,0,0,1,5.66,0l72,72A4,4,0,0,1,202.83,114.83Z" }))
  ]
]), t$F = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M88,108H40A12,12,0,0,1,28,96V48a12,12,0,0,1,24,0V61.86C68.65,45.46,94.29,28,128,28c44.46,0,71.36,26.39,72.49,27.51a12,12,0,0,1-16.94,17C183.11,72.09,162,52,128,52,99,52,77.06,69.68,64,84H88a12,12,0,0,1,0,24Zm128,40H168a12,12,0,0,0,0,24h24c-13,14.32-35,32-64,32-34,0-55.11-20.09-55.55-20.52a12,12,0,0,0-16.94,17C56.64,201.61,83.54,228,128,228c33.71,0,59.35-17.46,76-33.86V208a12,12,0,0,0,24,0V160A12,12,0,0,0,216,148Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M40,48,88,96H40ZM168,160l48,48V160Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M95.39,99.06a8,8,0,0,0-1.73-8.72L73.08,69.76C86.08,58.85,104.83,48,128,48c35.95,0,58.13,21.44,58.36,21.68a8,8,0,0,0,11.3-11.34C196.58,57.27,170.82,32,128,32c-23.36,0-46.13,9.1-66.28,26.41L45.66,42.34A8,8,0,0,0,32,48V96a8,8,0,0,0,8,8H88A8,8,0,0,0,95.39,99.06ZM48,88V67.31L68.69,88Zm168,64H168a8,8,0,0,0-5.66,13.66l20.58,20.58C169.92,197.15,151.17,208,128,208c-35.84,0-58-21.32-58.36-21.67a8,8,0,0,0-11.3,11.33C59.42,198.73,85.18,224,128,224c23.36,0,46.13-9.1,66.28-26.41l16.06,16.07A8,8,0,0,0,224,208V160A8,8,0,0,0,216,152Zm-8,36.69L187.31,168H208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,160v48a8,8,0,0,1-13.66,5.66l-16.06-16.07C174.13,214.9,151.36,224,128,224c-42.82,0-68.58-25.27-69.66-26.34a8,8,0,0,1,11.3-11.33C70,186.68,92.16,208,128,208c23.17,0,41.92-10.85,54.92-21.76l-20.58-20.58A8,8,0,0,1,168,152h48A8,8,0,0,1,224,160ZM95.39,99.06a8,8,0,0,0-1.73-8.72L73.08,69.76C86.08,58.85,104.83,48,128,48c35.95,0,58.13,21.44,58.36,21.68a8,8,0,0,0,11.3-11.34C196.58,57.27,170.82,32,128,32c-23.36,0-46.13,9.1-66.28,26.41L45.66,42.34A8,8,0,0,0,32,48V96a8,8,0,0,0,8,8H88A8,8,0,0,0,95.39,99.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M88,102H40a6,6,0,0,1-6-6V48a6,6,0,0,1,12,0V77.26C60.41,59.75,88.34,34,128,34c42,0,67.19,24.71,68.24,25.76a6,6,0,0,1-8.47,8.49C187.54,68,164.85,46,128,46,89.59,46,62.76,74.88,51.35,90H88a6,6,0,0,1,0,12Zm128,52H168a6,6,0,0,0,0,12h36.65c-11.41,15.12-38.24,44-76.65,44-36.85,0-59.54-22-59.77-22.25a6,6,0,0,0-8.47,8.49C60.81,197.29,86,222,128,222c39.66,0,67.59-25.75,82-43.26V208a6,6,0,0,0,12,0V160A6,6,0,0,0,216,154Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V71.85C63.47,54.4,90.61,32,128,32c42.82,0,68.58,25.27,69.66,26.34a8,8,0,0,1-11.3,11.34C186.09,69.41,163.92,48,128,48,93,48,67.77,72.65,55.44,88H88a8,8,0,0,1,0,16Zm128,48H168a8,8,0,0,0,0,16h32.56C188.23,183.35,163,208,128,208c-35.92,0-58.09-21.41-58.36-21.68a8,8,0,0,0-11.3,11.34C59.42,198.73,85.18,224,128,224c37.39,0,64.53-22.4,80-39.85V208a8,8,0,0,0,16,0V160A8,8,0,0,0,216,152Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M88,100H40a4,4,0,0,1-4-4V48a4,4,0,0,1,8,0V83.07a146.39,146.39,0,0,1,16.27-18C80.65,46.05,104.07,36,128,36c41.18,0,65.8,24.14,66.83,25.17a4,4,0,1,1-5.66,5.66C188.75,66.41,165.58,44,128,44,85.8,44,57.38,77.94,47.41,92H88a4,4,0,0,1,0,8Zm128,56H168a4,4,0,0,0,0,8h40.59c-10,14.06-38.39,48-80.59,48-37.58,0-60.75-22.41-61.17-22.83a4,4,0,0,0-5.66,5.66c1,1,25.65,25.17,66.83,25.17,23.93,0,47.35-10.05,67.73-29.08a146.39,146.39,0,0,0,16.27-18V208a4,4,0,0,0,8,0V160A4,4,0,0,0,216,156Z" }))
  ]
]), l$a = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M120.49,167.51a12,12,0,0,1,0,17l-32,32a12,12,0,0,1-17,0l-32-32a12,12,0,1,1,17-17L68,179V48a12,12,0,0,1,24,0V179l11.51-11.52A12,12,0,0,1,120.49,167.51Zm96-96-32-32a12,12,0,0,0-17,0l-32,32a12,12,0,0,0,17,17L164,77V208a12,12,0,0,0,24,0V77l11.51,11.52a12,12,0,0,0,17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,80H144l32-32ZM80,208l32-32H48Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M112,168H88V48a8,8,0,0,0-16,0V168H48a8,8,0,0,0-5.66,13.66l32,32a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,112,168ZM80,196.69,67.31,184H92.69ZM213.66,74.34l-32-32a8,8,0,0,0-11.32,0l-32,32A8,8,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8,8,0,0,0,5.66-13.66ZM163.31,72,176,59.31,188.69,72Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M119.39,172.94a8,8,0,0,1-1.73,8.72l-32,32a8,8,0,0,1-11.32,0l-32-32A8,8,0,0,1,48,168H72V48a8,8,0,0,1,16,0V168h24A8,8,0,0,1,119.39,172.94Zm94.27-98.6-32-32a8,8,0,0,0-11.32,0l-32,32A8,8,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8,8,0,0,0,5.66-13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M116.24,171.76a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48,0l-32-32a6,6,0,0,1,8.48-8.48L74,193.51V48a6,6,0,0,1,12,0V193.51l21.76-21.75A6,6,0,0,1,116.24,171.76Zm96-96-32-32a6,6,0,0,0-8.48,0l-32,32a6,6,0,0,0,8.48,8.48L170,62.49V208a6,6,0,0,0,12,0V62.49l21.76,21.75a6,6,0,0,0,8.48-8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M114.83,173.17a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66,0l-32-32a4,4,0,0,1,5.66-5.66L76,198.34V48a4,4,0,0,1,8,0V198.34l25.17-25.17A4,4,0,0,1,114.83,173.17Zm96-96-32-32a4,4,0,0,0-5.66,0l-32,32a4,4,0,0,0,5.66,5.66L172,57.66V208a4,4,0,0,0,8,0V57.66l25.17,25.17a4,4,0,1,0,5.66-5.66Z" }))
  ]
]), l$9 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,184.49l-32,32a12,12,0,0,1-17-17L179,188H48a12,12,0,0,1,0-24H179l-11.52-11.51a12,12,0,0,1,17-17l32,32A12,12,0,0,1,216.49,184.49Zm-145-64a12,12,0,0,0,17-17L77,92H208a12,12,0,0,0,0-24H77L88.49,56.49a12,12,0,0,0-17-17l-32,32a12,12,0,0,0,0,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,176l-32,32V144ZM80,112V48L48,80Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,170.34l-32-32A8,8,0,0,0,168,144v24H48a8,8,0,0,0,0,16H168v24a8,8,0,0,0,13.66,5.66l32-32A8,8,0,0,0,213.66,170.34ZM184,188.69V163.31L196.69,176Zm-109.66-71A8,8,0,0,0,88,112V88H208a8,8,0,0,0,0-16H88V48a8,8,0,0,0-13.66-5.66l-32,32a8,8,0,0,0,0,11.32ZM72,67.31V92.69L59.31,80Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M42.34,85.66a8,8,0,0,1,0-11.32l32-32A8,8,0,0,1,88,48V72H208a8,8,0,0,1,0,16H88v24a8,8,0,0,1-13.66,5.66Zm171.32,84.68-32-32A8,8,0,0,0,168,144v24H48a8,8,0,0,0,0,16H168v24a8,8,0,0,0,13.66,5.66l32-32A8,8,0,0,0,213.66,170.34Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,171.76a6,6,0,0,1,0,8.48l-32,32a6,6,0,0,1-8.48-8.48L193.51,182H48a6,6,0,0,1,0-12H193.51l-21.75-21.76a6,6,0,0,1,8.48-8.48ZM75.76,116.24a6,6,0,0,0,8.48-8.48L62.49,86H208a6,6,0,0,0,0-12H62.49L84.24,52.24a6,6,0,0,0-8.48-8.48l-32,32a6,6,0,0,0,0,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,173.17a4,4,0,0,1,0,5.66l-32,32a4,4,0,0,1-5.66-5.66L198.34,180H48a4,4,0,0,1,0-8H198.34l-25.17-25.17a4,4,0,0,1,5.66-5.66ZM77.17,114.83a4,4,0,0,0,5.66-5.66L57.66,84H208a4,4,0,0,0,0-8H57.66L82.83,50.83a4,4,0,0,0-5.66-5.66l-32,32a4,4,0,0,0,0,5.66Z" }))
  ]
]), V$3 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,156H204V111.49a76.39,76.39,0,0,0,23.49,15,12,12,0,0,0,9-22.25A51.81,51.81,0,0,1,204,56a12,12,0,0,0-24,0A52,52,0,0,1,76,56a12,12,0,0,0-24,0,51.81,51.81,0,0,1-32.5,48.22,12,12,0,1,0,9,22.25,76.39,76.39,0,0,0,23.49-15V156H24a12,12,0,0,0,0,24H52v20a12,12,0,0,0,24,0V180H180v20a12,12,0,0,0,24,0V180h28a12,12,0,0,0,0-24Zm-92-24.95V156H116V131.05a76.26,76.26,0,0,0,24,0ZM76,111.38a76.44,76.44,0,0,0,16,11.53V156H76ZM164,156V122.91a76.44,76.44,0,0,0,16-11.53V156Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M232,168H24V115.35A64,64,0,0,0,64,56a64,64,0,0,0,128,0,64,64,0,0,0,40,59.35Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M232,160H200V101.34a71.89,71.89,0,0,0,29,21.42,8,8,0,0,0,6-14.83A55.78,55.78,0,0,1,200,56a8,8,0,0,0-16,0A56,56,0,0,1,72,56a8,8,0,0,0-16,0,55.78,55.78,0,0,1-35,51.93,8,8,0,0,0,6,14.83,71.89,71.89,0,0,0,29-21.42V160H24a8,8,0,0,0,0,16H56v24a8,8,0,0,0,16,0V176H184v24a8,8,0,0,0,16,0V176h32a8,8,0,0,0,0-16Zm-88-33.8V160H112V126.2a72,72,0,0,0,32,0Zm-72-25a72.47,72.47,0,0,0,24,19.27V160H72ZM160,160V120.48a72.47,72.47,0,0,0,24-19.27V160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,160h-8V120.5c1.63.81,3.29,1.57,5,2.26a8,8,0,0,0,6-14.83A55.78,55.78,0,0,1,200,56a8,8,0,0,0-16,0A56,56,0,0,1,72,56a8,8,0,0,0-16,0,55.78,55.78,0,0,1-35,51.93,8,8,0,0,0,6,14.83c1.71-.69,3.37-1.45,5-2.26V160H24.6c-6.31,0-8.6,4.78-8.6,8a8,8,0,0,0,8,8H56v24a8,8,0,0,0,16,0V176H184v24a8,8,0,0,0,16,0V176h32a8,8,0,0,0,0-16ZM72,152a8,8,0,0,1-16,0V107.35a8,8,0,0,1,16,0Zm40,0a8,8,0,0,1-16,0V131.35a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V131.35a8,8,0,0,1,16,0Zm40,0a8,8,0,0,1-16,0V107.35a8,8,0,0,1,16,0Zm0-50.2v-.46l.41.51Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,162H198V95.28a69.81,69.81,0,0,0,31.75,25.63,6,6,0,1,0,4.5-11.12A57.8,57.8,0,0,1,198,56a6,6,0,0,0-12,0A58,58,0,0,1,70,56a6,6,0,0,0-12,0,57.8,57.8,0,0,1-36.25,53.79,6,6,0,1,0,4.5,11.12A69.81,69.81,0,0,0,58,95.28V162H24a6,6,0,0,0,0,12H58v26a6,6,0,0,0,12,0V174H186v26a6,6,0,0,0,12,0V174h34a6,6,0,0,0,0-12Zm-86-38.35V162H110V123.65a70.11,70.11,0,0,0,36,0ZM70,95.15a70.49,70.49,0,0,0,28,24.09V162H70ZM158,162V119.24a70.49,70.49,0,0,0,28-24.09V162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,160H200V101.34a71.89,71.89,0,0,0,29,21.42,8,8,0,0,0,6-14.83A55.78,55.78,0,0,1,200,56a8,8,0,0,0-16,0A56,56,0,0,1,72,56a8,8,0,0,0-16,0,55.78,55.78,0,0,1-35,51.93,8,8,0,0,0,6,14.83,71.89,71.89,0,0,0,29-21.42V160H24a8,8,0,0,0,0,16H56v24a8,8,0,0,0,16,0V176H184v24a8,8,0,0,0,16,0V176h32a8,8,0,0,0,0-16Zm-88-33.8V160H112V126.2a72,72,0,0,0,32,0Zm-72-25a72.47,72.47,0,0,0,24,19.27V160H72ZM160,160V120.48a72.47,72.47,0,0,0,24-19.27V160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,164H196V88.09a67.81,67.81,0,0,0,34.5,31,4,4,0,1,0,3-7.42A59.77,59.77,0,0,1,196,56a4,4,0,0,0-8,0A60,60,0,0,1,68,56a4,4,0,0,0-8,0,59.77,59.77,0,0,1-37.5,55.64,4,4,0,0,0,3,7.42,67.81,67.81,0,0,0,34.5-31V164H24a4,4,0,0,0,0,8H60v28a4,4,0,0,0,8,0V172H188v28a4,4,0,0,0,8,0V172h36a4,4,0,0,0,0-8Zm-84-43v43H108V121a68,68,0,0,0,40,0ZM68,88a68.43,68.43,0,0,0,32,30v46H68Zm88,76V118a68.43,68.43,0,0,0,32-30v76Z" }))
  ]
]), l$8 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M144.49,136.49l-80,80a12,12,0,0,1-17-17L119,128,47.51,56.49a12,12,0,0,1,17-17l80,80A12,12,0,0,1,144.49,136.49Zm80-17-80-80a12,12,0,1,0-17,17L199,128l-71.52,71.51a12,12,0,0,0,17,17l80-80A12,12,0,0,0,224.49,119.51Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M136,128,56,208V48Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M141.66,122.34l-80-80A8,8,0,0,0,48,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,141.66,122.34ZM64,188.69V67.31L124.69,128Zm157.66-55-80,80a8,8,0,0,1-11.32-11.32L204.69,128,130.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M221.66,133.66l-80,80A8,8,0,0,1,128,208V147.31L61.66,213.66A8,8,0,0,1,48,208V48a8,8,0,0,1,13.66-5.66L128,108.69V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,221.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L127.51,128,51.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,140.24,132.24Zm80-8.48-80-80a6,6,0,0,0-8.48,8.48L207.51,128l-75.75,75.76a6,6,0,1,0,8.48,8.48l80-80A6,6,0,0,0,220.24,123.76Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M141.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L124.69,128,50.34,53.66A8,8,0,0,1,61.66,42.34l80,80A8,8,0,0,1,141.66,133.66Zm80-11.32-80-80a8,8,0,0,0-11.32,11.32L204.69,128l-74.35,74.34a8,8,0,0,0,11.32,11.32l80-80A8,8,0,0,0,221.66,122.34Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M138.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L130.34,128,53.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,138.83,130.83Zm80-5.66-80-80a4,4,0,0,0-5.66,5.66L210.34,128l-77.17,77.17a4,4,0,0,0,5.66,5.66l80-80A4,4,0,0,0,218.83,125.17Z" }))
  ]
]), l$7 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), a$w = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M160,48V208L80,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }))
  ]
]), l$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), t$E = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), t$D = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), t$C = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236,128a108,108,0,0,1-216,0c0-42.52,24.73-81.34,63-98.9A12,12,0,1,1,93,50.91C63.24,64.57,44,94.83,44,128a84,84,0,0,0,168,0c0-33.17-19.24-63.43-49-77.09A12,12,0,1,1,173,29.1C211.27,46.66,236,85.48,236,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,176A72,72,0,0,1,92,65.64a8,8,0,0,1,8,13.85,56,56,0,1,0,56,0,8,8,0,0,1,8-13.85A72,72,0,0,1,128,200Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M230,128a102,102,0,0,1-204,0c0-40.18,23.35-76.86,59.5-93.45a6,6,0,0,1,5,10.9C58.61,60.09,38,92.49,38,128a90,90,0,0,0,180,0c0-35.51-20.61-67.91-52.5-82.55a6,6,0,0,1,5-10.9C206.65,51.14,230,87.82,230,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232,128a104,104,0,0,1-208,0c0-41,23.81-78.36,60.66-95.27a8,8,0,0,1,6.68,14.54C60.15,61.59,40,93.27,40,128a88,88,0,0,0,176,0c0-34.73-20.15-66.41-51.34-80.73a8,8,0,0,1,6.68-14.54C208.19,49.64,232,87,232,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a100,100,0,0,1-200,0c0-39.4,22.9-75.37,58.33-91.63a4,4,0,1,1,3.34,7.27C57.07,58.6,36,91.71,36,128a92,92,0,0,0,184,0c0-36.29-21.07-69.4-53.67-84.36a4,4,0,1,1,3.34-7.27C205.1,52.63,228,88.6,228,128Z" }))
  ]
]), t$B = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,28H88A12,12,0,0,0,76,40V76H40A12,12,0,0,0,28,88V216a12,12,0,0,0,12,12H168a12,12,0,0,0,12-12V180h36a12,12,0,0,0,12-12V40A12,12,0,0,0,216,28ZM156,204H52V100H156Zm48-48H180V88a12,12,0,0,0-12-12H100V52H204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,40V168H168V88H88V40Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,34H88a6,6,0,0,0-6,6V82H40a6,6,0,0,0-6,6V216a6,6,0,0,0,6,6H168a6,6,0,0,0,6-6V174h42a6,6,0,0,0,6-6V40A6,6,0,0,0,216,34ZM162,210H46V94H162Zm48-48H174V88a6,6,0,0,0-6-6H94V46H210Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,36H88a4,4,0,0,0-4,4V84H40a4,4,0,0,0-4,4V216a4,4,0,0,0,4,4H168a4,4,0,0,0,4-4V172h44a4,4,0,0,0,4-4V40A4,4,0,0,0,216,36ZM164,212H44V92H164Zm48-48H172V88a4,4,0,0,0-4-4H92V44H212Z" }))
  ]
]), t$A = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M240,64V192a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V64A16,16,0,0,1,32,48H224A16,16,0,0,1,240,64Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM60,140a12,12,0,1,1,12-12A12,12,0,0,1,60,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,196,140Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128ZM60,118a10,10,0,1,0,10,10A10,10,0,0,0,60,118Zm136,0a10,10,0,1,0,10,10A10,10,0,0,0,196,118Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-76-8a8,8,0,1,0,8,8A8,8,0,0,0,60,120Zm136,0a8,8,0,1,0,8,8A8,8,0,0,0,196,120Z" }))
  ]
]), t$z = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,152v56a20,20,0,0,1-20,20H48a20,20,0,0,1-20-20V152a12,12,0,0,1,24,0v52H204V152a12,12,0,0,1,24,0Zm-108.49,8.49a12,12,0,0,0,17,0l40-40a12,12,0,0,0-17-17L140,123V40a12,12,0,0,0-24,0v83L96.49,103.51a12,12,0,0,0-17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,112l-40,40L88,112Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0ZM82.34,117.66A8,8,0,0,1,88,104h32V40a8,8,0,0,1,16,0v64h32a8,8,0,0,1,5.66,13.66l-40,40a8,8,0,0,1-11.32,0Zm25,2.34L128,140.69,148.69,120Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M82.34,117.66A8,8,0,0,1,88,104h32V40a8,8,0,0,1,16,0v64h32a8,8,0,0,1,5.66,13.66l-40,40a8,8,0,0,1-11.32,0ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,152v56a14,14,0,0,1-14,14H48a14,14,0,0,1-14-14V152a6,6,0,0,1,12,0v56a2,2,0,0,0,2,2H208a2,2,0,0,0,2-2V152a6,6,0,0,1,12,0Zm-98.24,4.24a6,6,0,0,0,8.48,0l40-40a6,6,0,0,0-8.48-8.48L134,137.51V40a6,6,0,0,0-12,0v97.51L92.24,107.76a6,6,0,0,0-8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,152v56a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V152a4,4,0,0,1,8,0v56a4,4,0,0,0,4,4H208a4,4,0,0,0,4-4V152a4,4,0,0,1,8,0Zm-94.83,2.83a4,4,0,0,0,5.66,0l40-40a4,4,0,1,0-5.66-5.66L132,142.34V40a4,4,0,0,0-8,0V142.34L90.83,109.17a4,4,0,0,0-5.66,5.66Z" }))
  ]
]), A$2 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M92,128A156.12,156.12,0,0,1,72.5,203.56a12,12,0,1,1-21-11.64A132,132,0,0,0,68,128a60,60,0,0,1,99.68-45,12,12,0,1,1-15.88,18A36,36,0,0,0,92,128Zm84.16-8H176a12,12,0,0,0-12,11.8,226.76,226.76,0,0,1-17,82.84,12,12,0,1,0,22.19,9.13A250.42,250.42,0,0,0,188,132.2,12,12,0,0,0,176.15,120Zm-62.22,81.21a12,12,0,0,0-16,5.54c-1.37,2.81-2.85,5.65-4.38,8.42a12,12,0,1,0,21,11.63c1.74-3.14,3.41-6.35,5-9.55A12,12,0,0,0,113.93,201.21ZM128,116a12,12,0,0,0-12,12,181,181,0,0,1-4.75,41.26,12,12,0,0,0,8.94,14.42,11.79,11.79,0,0,0,2.75.32,12,12,0,0,0,11.67-9.26A204.55,204.55,0,0,0,140,128,12,12,0,0,0,128,116Zm0-96a108,108,0,0,0-31.5,4.67,12,12,0,0,0,7,23A84.06,84.06,0,0,1,212,128a277.39,277.39,0,0,1-6.84,61.34,12,12,0,0,0,9.05,14.36,11.61,11.61,0,0,0,2.66.3,12,12,0,0,0,11.7-9.34A301.89,301.89,0,0,0,236,128,108.12,108.12,0,0,0,128,20ZM68.47,51.74a12,12,0,0,0-17,0A107.32,107.32,0,0,0,20,128a83.26,83.26,0,0,1-7.61,35,12,12,0,1,0,21.81,10A107.11,107.11,0,0,0,44,128,83.42,83.42,0,0,1,68.5,68.71,12,12,0,0,0,68.47,51.74Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M184,128a246.64,246.64,0,0,1-18.54,94.24,8,8,0,0,1-7.4,5,8.19,8.19,0,0,1-3-.6,8,8,0,0,1-4.36-10.45A230.67,230.67,0,0,0,168,128a8,8,0,0,1,16,0ZM128,88a40.06,40.06,0,0,1,29.81,13.33,8,8,0,1,0,11.92-10.67A56,56,0,0,0,72,128a136.06,136.06,0,0,1-17,65.85,8,8,0,1,0,14,7.76A152.14,152.14,0,0,0,88,128,40,40,0,0,1,128,88Zm0-64a103.75,103.75,0,0,0-34.67,5.92A8,8,0,0,0,98.67,45,88.05,88.05,0,0,1,216,128a281.31,281.31,0,0,1-6.94,62.23,8,8,0,0,0,6,9.57,7.77,7.77,0,0,0,1.78.2,8,8,0,0,0,7.8-6.23A298.11,298.11,0,0,0,232,128,104.11,104.11,0,0,0,128,24ZM69.31,62.42A8,8,0,1,0,58.64,50.49,104.16,104.16,0,0,0,24,128a87.29,87.29,0,0,1-8,36.66,8,8,0,0,0,14.54,6.68A103.17,103.17,0,0,0,40,128,88.13,88.13,0,0,1,69.31,62.42Zm44.58,138.32a8,8,0,0,0-10.6,3.93c-1.93,4.2-4.05,8.39-6.3,12.44A8,8,0,0,0,100.11,228a7.88,7.88,0,0,0,3.87,1,8,8,0,0,0,7-4.12c2.44-4.41,4.74-9,6.84-13.52A8,8,0,0,0,113.89,200.74ZM128,120a8,8,0,0,0-8,8,185.07,185.07,0,0,1-5.79,46,8,8,0,0,0,5.75,9.74,8.12,8.12,0,0,0,2,.25,8,8,0,0,0,7.74-6,200.68,200.68,0,0,0,6.3-50A8,8,0,0,0,128,120Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M126.41,24C70.72,24.85,25.21,70.07,24,125.75a103.48,103.48,0,0,0,13.51,53.5,4,4,0,0,0,7.1-.29A119.29,119.29,0,0,0,56,128,71.93,71.93,0,0,1,73.74,80.67a8.22,8.22,0,0,1,10.8-1.59A8,8,0,0,1,86,91a55.92,55.92,0,0,0-14,37,135.12,135.12,0,0,1-18.44,68.31,4,4,0,0,0,.61,4.85A104.33,104.33,0,0,0,67,212.21,4,4,0,0,0,72.82,211,159.58,159.58,0,0,0,84,189a8,8,0,1,1,14.8,6.1,176.9,176.9,0,0,1-11.85,23.54,4,4,0,0,0,1.89,5.74,103.46,103.46,0,0,0,25,6.7,4,4,0,0,0,4.07-2,206.86,206.86,0,0,0,25.57-85.61,8,8,0,1,1,15.95,1.16,222.83,222.83,0,0,1-21.58,80.75,4,4,0,0,0,4.08,5.74,103.72,103.72,0,0,0,20.6-4.95,4,4,0,0,0,2.35-2.23A247.29,247.29,0,0,0,184,129.76c.22-30.64-23.4-56.67-54-57.73a56.72,56.72,0,0,0-16,1.73,8,8,0,0,1-9.84-6.21,8.23,8.23,0,0,1,6.29-9.39A72.05,72.05,0,0,1,200,128a264.82,264.82,0,0,1-10.66,74.63,4,4,0,0,0,6.47,4.15A104,104,0,0,0,126.41,24ZM128,96a32.05,32.05,0,0,1,23.85,10.67,8,8,0,0,1-1.24,11.79,8.26,8.26,0,0,1-10.88-1.34,16,16,0,0,0-16.78-4.3,16.39,16.39,0,0,0-11,15.67,176.89,176.89,0,0,1-3.19,33A8,8,0,0,1,101,168a7.69,7.69,0,0,1-1.5-.14,8.3,8.3,0,0,1-6.31-9.66A161.12,161.12,0,0,0,96,128,32,32,0,0,1,128,96Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M182,128a244.65,244.65,0,0,1-18.38,93.48,6,6,0,0,1-5.55,3.72,6.13,6.13,0,0,1-2.28-.45,6,6,0,0,1-3.27-7.84A232.64,232.64,0,0,0,170,128a6,6,0,0,1,12,0ZM128,86a42.08,42.08,0,0,1,31.31,14,6,6,0,1,0,8.94-8A54,54,0,0,0,74,128a138.08,138.08,0,0,1-17.22,66.82,6,6,0,1,0,10.49,5.82A150.07,150.07,0,0,0,86,128,42,42,0,0,1,128,86Zm0-60a101.58,101.58,0,0,0-34,5.81,6,6,0,1,0,4,11.31A90.07,90.07,0,0,1,218,128a283.42,283.42,0,0,1-7,62.67,6,6,0,1,0,11.7,2.66A295.41,295.41,0,0,0,230,128,102.12,102.12,0,0,0,128,26ZM68,60.92A6,6,0,0,0,60,52a102.19,102.19,0,0,0-34,76,89.32,89.32,0,0,1-8.15,37.5,6,6,0,1,0,10.9,5A101.12,101.12,0,0,0,38,128,90.15,90.15,0,0,1,68,60.92Zm45.08,141.64a6,6,0,0,0-8,2.95c-2,4.24-4.09,8.47-6.36,12.57a6,6,0,0,0,2.34,8.15,5.88,5.88,0,0,0,2.9.76,6,6,0,0,0,5.25-3.09c2.42-4.36,4.7-8.87,6.78-13.39A6,6,0,0,0,113.08,202.56ZM128,122a6,6,0,0,0-6,6,186.54,186.54,0,0,1-5.86,46.5,6,6,0,0,0,4.32,7.31,5.93,5.93,0,0,0,1.5.19,6,6,0,0,0,5.8-4.5A198.75,198.75,0,0,0,134,128,6,6,0,0,0,128,122Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M184,128a246.64,246.64,0,0,1-18.54,94.24,8,8,0,0,1-7.4,5,8.19,8.19,0,0,1-3-.6,8,8,0,0,1-4.36-10.45A230.67,230.67,0,0,0,168,128a8,8,0,0,1,16,0ZM128,88a40.06,40.06,0,0,1,29.81,13.33,8,8,0,1,0,11.92-10.67A56,56,0,0,0,72,128a136.06,136.06,0,0,1-17,65.85,8,8,0,1,0,14,7.76A152.14,152.14,0,0,0,88,128,40,40,0,0,1,128,88Zm0-64a103.75,103.75,0,0,0-34.67,5.92A8,8,0,0,0,98.67,45,88.05,88.05,0,0,1,216,128a281.31,281.31,0,0,1-6.94,62.23,8,8,0,0,0,6,9.57,7.77,7.77,0,0,0,1.78.2,8,8,0,0,0,7.8-6.23A298.11,298.11,0,0,0,232,128,104.11,104.11,0,0,0,128,24ZM69.34,62.42A8,8,0,1,0,58.67,50.49,104.16,104.16,0,0,0,24,128a87.29,87.29,0,0,1-8,36.66,8,8,0,0,0,14.54,6.68A103.17,103.17,0,0,0,40,128,88.13,88.13,0,0,1,69.34,62.42Zm44.58,138.32a8,8,0,0,0-10.61,3.93c-1.92,4.2-4,8.39-6.29,12.44A8,8,0,0,0,100.14,228a7.88,7.88,0,0,0,3.87,1,8,8,0,0,0,7-4.12c2.44-4.41,4.74-9,6.84-13.52A8,8,0,0,0,113.92,200.74ZM128,120a8,8,0,0,0-8,8,185.07,185.07,0,0,1-5.79,46,8,8,0,0,0,5.75,9.74,8.12,8.12,0,0,0,2,.25,8,8,0,0,0,7.74-6,200.68,200.68,0,0,0,6.3-50A8,8,0,0,0,128,120Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M180,128a242.63,242.63,0,0,1-18.23,92.72,4,4,0,0,1-7.4-3A234.75,234.75,0,0,0,172,128a4,4,0,0,1,8,0ZM160.79,98.67a4,4,0,0,0,6-5.33A52,52,0,0,0,76,128,140,140,0,0,1,58.52,195.8a4,4,0,0,0,7,3.88A148.13,148.13,0,0,0,84,128a44,44,0,0,1,76.79-29.34ZM128,28a99.9,99.9,0,0,0-33.33,5.69,4,4,0,1,0,2.66,7.54A92.08,92.08,0,0,1,220,128a285.69,285.69,0,0,1-7,63.12,4,4,0,0,0,3,4.78,3.86,3.86,0,0,0,.89.1,4,4,0,0,0,3.89-3.12A293,293,0,0,0,228,128,100.11,100.11,0,0,0,128,28ZM66.67,59.43a4,4,0,0,0-5.34-6A100.17,100.17,0,0,0,28,128a91.3,91.3,0,0,1-8.34,38.33,4,4,0,0,0,2,5.3,3.93,3.93,0,0,0,1.66.37,4,4,0,0,0,3.64-2.33A99.15,99.15,0,0,0,36,128,92.16,92.16,0,0,1,66.67,59.43Zm45.58,144.94a4,4,0,0,0-5.31,2c-2,4.29-4.13,8.57-6.42,12.71a4,4,0,1,0,7,3.88c2.39-4.32,4.65-8.78,6.7-13.25A4,4,0,0,0,112.25,204.37ZM128,124a4,4,0,0,0-4,4,188.67,188.67,0,0,1-5.92,47,4,4,0,0,0,2.87,4.87,3.87,3.87,0,0,0,1,.13,4,4,0,0,0,3.87-3A196.62,196.62,0,0,0,132,128,4,4,0,0,0,128,124Z" }))
  ]
]), t$y = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M247.8,66.83,228.49,47.51a12,12,0,0,0-17,17L230.83,83.8A4,4,0,0,1,232,86.63V166a6,6,0,0,1-12,0V128a28,28,0,0,0-28-28H180V56a28,28,0,0,0-28-28H72A28,28,0,0,0,44,56V204H32a12,12,0,0,0,0,24H192a12,12,0,0,0,0-24H180V124h12a4,4,0,0,1,4,4v38a30,30,0,0,0,60,0V86.63A27.81,27.81,0,0,0,247.8,66.83ZM68,204V56a4,4,0,0,1,4-4h80a4,4,0,0,1,4,4V204Zm72-92a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h32A12,12,0,0,1,140,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M168,56V216H56V56A16,16,0,0,1,72,40h80A16,16,0,0,1,168,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M241,69.66,221.66,50.34a8,8,0,0,0-11.32,11.32L229.66,81A8,8,0,0,1,232,86.63V168a8,8,0,0,1-16,0V128a24,24,0,0,0-24-24H176V56a24,24,0,0,0-24-24H72A24,24,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8,8,0,0,1,8,8v40a24,24,0,0,0,48,0V86.63A23.85,23.85,0,0,0,241,69.66ZM64,208V56a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8V208Zm80-96a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M241,69.66,221.66,50.34a8,8,0,0,0-11.32,11.32L229.66,81A8,8,0,0,1,232,86.63V168a8,8,0,0,1-16,0V128a24,24,0,0,0-24-24H176V56a24,24,0,0,0-24-24H72A24,24,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8,8,0,0,1,8,8v40a24,24,0,0,0,48,0V86.63A23.85,23.85,0,0,0,241,69.66ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M239.56,71.07,220.24,51.76a6,6,0,0,0-8.48,8.48l19.31,19.32A9.93,9.93,0,0,1,234,86.63V168a10,10,0,0,1-20,0V128a22,22,0,0,0-22-22H174V56a22,22,0,0,0-22-22H72A22,22,0,0,0,50,56V210H32a6,6,0,0,0,0,12H192a6,6,0,0,0,0-12H174V118h18a10,10,0,0,1,10,10v40a22,22,0,0,0,44,0V86.63A21.88,21.88,0,0,0,239.56,71.07ZM62,210V56A10,10,0,0,1,72,46h80a10,10,0,0,1,10,10V210Zm80-98a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h48A6,6,0,0,1,142,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M241,69.66,221.66,50.34a8,8,0,0,0-11.32,11.32L229.66,81A8,8,0,0,1,232,86.63V168a8,8,0,0,1-16,0V128a24,24,0,0,0-24-24H176V56a24,24,0,0,0-24-24H72A24,24,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8,8,0,0,1,8,8v40a24,24,0,0,0,48,0V86.63A23.85,23.85,0,0,0,241,69.66ZM64,208V56a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8V208Zm80-96a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M238.14,72.49,218.83,53.17a4,4,0,0,0-5.66,5.66l19.32,19.31A12,12,0,0,1,236,86.63V168a12,12,0,0,1-24,0V128a20,20,0,0,0-20-20H172V56a20,20,0,0,0-20-20H72A20,20,0,0,0,52,56V212H32a4,4,0,0,0,0,8H192a4,4,0,0,0,0-8H172V116h20a12,12,0,0,1,12,12v40a20,20,0,0,0,40,0V86.63A19.85,19.85,0,0,0,238.14,72.49ZM60,212V56A12,12,0,0,1,72,44h80a12,12,0,0,1,12,12V212Zm80-100a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h48A4,4,0,0,1,140,112Z" }))
  ]
]), e$3 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,76a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,80a28,28,0,1,1,28-28A28,28,0,0,1,128,156Zm113.86-49.57A12,12,0,0,0,236,98.34L208.21,82.49l-.11-31.31a12,12,0,0,0-4.25-9.12,116,116,0,0,0-38-21.41,12,12,0,0,0-9.68.89L128,37.27,99.83,21.53a12,12,0,0,0-9.7-.9,116.06,116.06,0,0,0-38,21.47,12,12,0,0,0-4.24,9.1l-.14,31.34L20,98.35a12,12,0,0,0-5.85,8.11,110.7,110.7,0,0,0,0,43.11A12,12,0,0,0,20,157.66l27.82,15.85.11,31.31a12,12,0,0,0,4.25,9.12,116,116,0,0,0,38,21.41,12,12,0,0,0,9.68-.89L128,218.73l28.14,15.74a12,12,0,0,0,9.7.9,116.06,116.06,0,0,0,38-21.47,12,12,0,0,0,4.24-9.1l.14-31.34,27.81-15.81a12,12,0,0,0,5.85-8.11A110.7,110.7,0,0,0,241.86,106.43Zm-22.63,33.18-26.88,15.28a11.94,11.94,0,0,0-4.55,4.59c-.54,1-1.11,1.93-1.7,2.88a12,12,0,0,0-1.83,6.31L184.13,199a91.83,91.83,0,0,1-21.07,11.87l-27.15-15.19a12,12,0,0,0-5.86-1.53h-.29c-1.14,0-2.3,0-3.44,0a12.08,12.08,0,0,0-6.14,1.51L93,210.82A92.27,92.27,0,0,1,71.88,199l-.11-30.24a12,12,0,0,0-1.83-6.32c-.58-.94-1.16-1.91-1.7-2.88A11.92,11.92,0,0,0,63.7,155L36.8,139.63a86.53,86.53,0,0,1,0-23.24l26.88-15.28a12,12,0,0,0,4.55-4.58c.54-1,1.11-1.94,1.7-2.89a12,12,0,0,0,1.83-6.31L71.87,57A91.83,91.83,0,0,1,92.94,45.17l27.15,15.19a11.92,11.92,0,0,0,6.15,1.52c1.14,0,2.3,0,3.44,0a12.08,12.08,0,0,0,6.14-1.51L163,45.18A92.27,92.27,0,0,1,184.12,57l.11,30.24a12,12,0,0,0,1.83,6.32c.58.94,1.16,1.91,1.7,2.88A11.92,11.92,0,0,0,192.3,101l26.9,15.33A86.53,86.53,0,0,1,219.23,139.61Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M230.1,108.76,198.25,90.62c-.64-1.16-1.31-2.29-2-3.41l-.12-36A104.61,104.61,0,0,0,162,32L130,49.89c-1.34,0-2.69,0-4,0L94,32A104.58,104.58,0,0,0,59.89,51.25l-.16,36c-.7,1.12-1.37,2.26-2,3.41l-31.84,18.1a99.15,99.15,0,0,0,0,38.46l31.85,18.14c.64,1.16,1.31,2.29,2,3.41l.12,36A104.61,104.61,0,0,0,94,224l32-17.87c1.34,0,2.69,0,4,0L162,224a104.58,104.58,0,0,0,34.08-19.25l.16-36c.7-1.12,1.37-2.26,2-3.41l31.84-18.1A99.15,99.15,0,0,0,230.1,108.76ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A111.92,111.92,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.63a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3,3c-.58,1-1.19,2.06-1.81,3.06a7.94,7.94,0,0,0-1.22,4.21l-.15,32.25a95.89,95.89,0,0,1-25.37,14.3L134,199.13a8,8,0,0,0-3.91-1h-.19c-1.21,0-2.43,0-3.64,0a8.1,8.1,0,0,0-4.1,1l-28.84,16.1A96,96,0,0,1,67.88,201l-.11-32.2a8,8,0,0,0-1.22-4.22c-.62-1-1.23-2-1.8-3.06a8.09,8.09,0,0,0-3-3.06l-28.6-16.29a90.49,90.49,0,0,1,0-28.26L61.67,97.63a8,8,0,0,0,3-3c.58-1,1.19-2.06,1.81-3.06a7.94,7.94,0,0,0,1.22-4.21l.15-32.25a95.89,95.89,0,0,1,25.37-14.3L122,56.87a8,8,0,0,0,4.1,1c1.21,0,2.43,0,3.64,0a8,8,0,0,0,4.1-1l28.84-16.1A96,96,0,0,1,188.12,55l.11,32.2a8,8,0,0,0,1.22,4.22c.62,1,1.23,2,1.8,3.06a8.09,8.09,0,0,0,3,3.06l28.6,16.29A90.49,90.49,0,0,1,222.9,142.12Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M237.94,107.21a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A111.92,111.92,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.63a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,82a46,46,0,1,0,46,46A46.06,46.06,0,0,0,128,82Zm0,80a34,34,0,1,1,34-34A34,34,0,0,1,128,162Zm108-54.4a6,6,0,0,0-2.92-4L202.64,86.22l-.42-.71L202.1,51.2A6,6,0,0,0,200,46.64a110.12,110.12,0,0,0-36.07-20.31,6,6,0,0,0-4.84.45L128.46,43.86h-1L96.91,26.76a6,6,0,0,0-4.86-.44A109.92,109.92,0,0,0,56,46.68a6,6,0,0,0-2.12,4.55l-.16,34.34c-.14.23-.28.47-.41.71L22.91,103.57A6,6,0,0,0,20,107.62a104.81,104.81,0,0,0,0,40.78,6,6,0,0,0,2.92,4l30.42,17.33.42.71.12,34.31A6,6,0,0,0,56,209.36a110.12,110.12,0,0,0,36.07,20.31,6,6,0,0,0,4.84-.45l30.61-17.08h1l30.56,17.1A6.09,6.09,0,0,0,162,230a5.83,5.83,0,0,0,1.93-.32,109.92,109.92,0,0,0,36-20.36,6,6,0,0,0,2.12-4.55l.16-34.34c.14-.23.28-.47.41-.71l30.42-17.29a6,6,0,0,0,2.92-4.05A104.81,104.81,0,0,0,236,107.6Zm-11.25,35.79L195.32,160.1a6.07,6.07,0,0,0-2.28,2.3c-.59,1-1.21,2.11-1.86,3.14a6,6,0,0,0-.91,3.16l-.16,33.21a98.15,98.15,0,0,1-27.52,15.53L133,200.88a6,6,0,0,0-2.93-.77h-.14c-1.24,0-2.5,0-3.74,0a6,6,0,0,0-3.07.76L93.45,217.43a98,98,0,0,1-27.56-15.49l-.12-33.17a6,6,0,0,0-.91-3.16c-.64-1-1.27-2.08-1.86-3.14a6,6,0,0,0-2.27-2.3L31.3,143.4a93,93,0,0,1,0-30.79L60.68,95.9A6.07,6.07,0,0,0,63,93.6c.59-1,1.21-2.11,1.86-3.14a6,6,0,0,0,.91-3.16l.16-33.21A98.15,98.15,0,0,1,93.41,38.56L123,55.12a5.81,5.81,0,0,0,3.07.76c1.24,0,2.5,0,3.74,0a6,6,0,0,0,3.07-.76l29.65-16.56a98,98,0,0,1,27.56,15.49l.12,33.17a6,6,0,0,0,.91,3.16c.64,1,1.27,2.08,1.86,3.14a6,6,0,0,0,2.27,2.3L224.7,112.6A93,93,0,0,1,224.73,143.39Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A112.1,112.1,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.62a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3,3c-.58,1-1.19,2.06-1.81,3.06a7.94,7.94,0,0,0-1.22,4.21l-.15,32.25a95.89,95.89,0,0,1-25.37,14.3L134,199.13a8,8,0,0,0-3.91-1h-.19c-1.21,0-2.43,0-3.64,0a8.08,8.08,0,0,0-4.1,1l-28.84,16.1A96,96,0,0,1,67.88,201l-.11-32.2a8,8,0,0,0-1.22-4.22c-.62-1-1.23-2-1.8-3.06a8.09,8.09,0,0,0-3-3.06l-28.6-16.29a90.49,90.49,0,0,1,0-28.26L61.67,97.63a8,8,0,0,0,3-3c.58-1,1.19-2.06,1.81-3.06a7.94,7.94,0,0,0,1.22-4.21l.15-32.25a95.89,95.89,0,0,1,25.37-14.3L122,56.87a8,8,0,0,0,4.1,1c1.21,0,2.43,0,3.64,0a8.08,8.08,0,0,0,4.1-1l28.84-16.1A96,96,0,0,1,188.12,55l.11,32.2a8,8,0,0,0,1.22,4.22c.62,1,1.23,2,1.8,3.06a8.09,8.09,0,0,0,3,3.06l28.6,16.29A90.49,90.49,0,0,1,222.9,142.12Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,84a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36,36,0,0,1,128,164Zm106-56a4,4,0,0,0-2-2.7l-30.89-17.6q-.47-.82-1-1.62L200.1,51.2a3.94,3.94,0,0,0-1.42-3,107.8,107.8,0,0,0-35.41-19.94,4,4,0,0,0-3.23.29L129,45.87h-2l-31-17.36a4,4,0,0,0-3.23-.3,108.05,108.05,0,0,0-35.39,20,4,4,0,0,0-1.41,3l-.16,34.9-1,1.62L23.9,105.3A4,4,0,0,0,22,108a102.76,102.76,0,0,0,0,40,4,4,0,0,0,1.95,2.7l30.89,17.6q.47.83,1,1.62l.12,34.87a3.94,3.94,0,0,0,1.42,3,107.8,107.8,0,0,0,35.41,19.94,4,4,0,0,0,3.23-.29L127,210.13h2l31,17.36a4,4,0,0,0,3.23.3,108.05,108.05,0,0,0,35.39-20,4,4,0,0,0,1.41-3l.16-34.9,1-1.62L232.1,150.7a4,4,0,0,0,2-2.71A102.76,102.76,0,0,0,234,108Zm-7.48,36.67L196.3,161.84a4,4,0,0,0-1.51,1.53c-.61,1.09-1.25,2.17-1.91,3.24a3.92,3.92,0,0,0-.61,2.1l-.16,34.15a99.8,99.8,0,0,1-29.7,16.77l-30.4-17a4.06,4.06,0,0,0-2-.51H130c-1.28,0-2.57,0-3.84,0a4.1,4.1,0,0,0-2.05.51l-30.45,17A100.23,100.23,0,0,1,63.89,202.9l-.12-34.12a3.93,3.93,0,0,0-.61-2.11c-.66-1-1.3-2.14-1.91-3.23a4,4,0,0,0-1.51-1.53L29.49,144.68a94.78,94.78,0,0,1,0-33.34L59.7,94.16a4,4,0,0,0,1.51-1.53c.61-1.09,1.25-2.17,1.91-3.23a4,4,0,0,0,.61-2.11l.16-34.15a99.8,99.8,0,0,1,29.7-16.77l30.4,17a4.1,4.1,0,0,0,2.05.51c1.28,0,2.57,0,3.84,0a4,4,0,0,0,2.05-.51l30.45-17A100.23,100.23,0,0,1,192.11,53.1l.12,34.12a3.93,3.93,0,0,0,.61,2.11c.66,1,1.3,2.14,1.91,3.23a4,4,0,0,0,1.51,1.53l30.25,17.23A94.78,94.78,0,0,1,226.54,144.66Z" }))
  ]
]), t$x = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), t$w = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a92.47,92.47,0,0,1-37,73.73,7.81,7.81,0,0,0-3,6.27,20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-.23a7.76,7.76,0,0,0-3.25-6.2,91.36,91.36,0,0,1-36.75-73C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.89,59.8,67.56,60,104.39a67.52,67.52,0,0,0,27.18,54h0A32.14,32.14,0,0,1,99.77,180H116V149L87.51,120.49a12,12,0,0,1,17-17L128,127l23.51-23.51a12,12,0,0,1,17,17L140,149v31h16.25a31.89,31.89,0,0,1,12.41-21.49A67.45,67.45,0,0,0,196,104Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M208,104a79.86,79.86,0,0,1-30.59,62.92A24.29,24.29,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6a24.11,24.11,0,0,0-9.3-19A79.87,79.87,0,0,1,48,104.45C47.76,61.09,82.72,25,126.07,24A80,80,0,0,1,208,104Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-50.34,2.34a8,8,0,0,0-11.32,0L128,132.69l-26.34-26.35a8,8,0,0,0-11.32,11.32L120,147.31V184a8,8,0,0,0,16,0V147.31l29.66-29.65A8,8,0,0,0,165.66,106.34Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M174,232a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,232Zm40-128a85.56,85.56,0,0,1-32.88,67.64A18.23,18.23,0,0,0,174,186v6a14,14,0,0,1-14,14H96a14,14,0,0,1-14-14v-6a18,18,0,0,0-7-14.23h0a85.59,85.59,0,0,1-33-67.25C41.74,57.91,79.39,19.12,125.93,18A86,86,0,0,1,214,104Zm-12,0a74,74,0,0,0-75.79-74C86.17,31,53.78,64.34,54,104.42a73.67,73.67,0,0,0,28.4,57.87A29.92,29.92,0,0,1,94,186v6a2,2,0,0,0,2,2h26V146.49L91.76,116.24a6,6,0,0,1,8.48-8.48L128,135.52l27.76-27.76a6,6,0,0,1,8.48,8.48L134,146.49V194h26a2,2,0,0,0,2-2v-6a30.18,30.18,0,0,1,11.7-23.78A73.59,73.59,0,0,0,202,104Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M172,232a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,232Zm40-128a83.59,83.59,0,0,1-32.11,66.06A20.2,20.2,0,0,0,172,186v6a12,12,0,0,1-12,12H96a12,12,0,0,1-12-12v-6a20,20,0,0,0-7.76-15.81A83.58,83.58,0,0,1,44,104.47C43.75,59,80.52,21.09,126,20a84,84,0,0,1,86,84Zm-8,0a76,76,0,0,0-77.84-76C85,29,51.77,63.27,52,104.43a75.62,75.62,0,0,0,29.17,59.43A28,28,0,0,1,92,186v6a4,4,0,0,0,4,4h28V145.66L93.17,114.83a4,4,0,0,1,5.66-5.66L128,138.34l29.17-29.17a4,4,0,1,1,5.66,5.66L132,145.66V196h28a4,4,0,0,0,4-4v-6a28.14,28.14,0,0,1,10.94-22.2A75.62,75.62,0,0,0,204,104Z" }))
  ]
]), t$v = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), V$2 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M172,124a12,12,0,0,1-12,12H96a12,12,0,0,1,0-24h64A12,12,0,0,1,172,124Zm-12,28H96a12,12,0,0,0,0,24h64a12,12,0,0,0,0-24ZM220,48V200a36,36,0,0,1-36,36H72a36,36,0,0,1-36-36V48A20,20,0,0,1,56,28H72V24a12,12,0,0,1,24,0v4h20V24a12,12,0,0,1,24,0v4h20V24a12,12,0,0,1,24,0v4h16A20,20,0,0,1,220,48Zm-24,4H184v4a12,12,0,0,1-24,0V52H140v4a12,12,0,0,1-24,0V52H96v4a12,12,0,0,1-24,0V52H60V200a12,12,0,0,0,12,12H184a12,12,0,0,0,12-12Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M208,48V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48a8,8,0,0,1,8-8H200A8,8,0,0,1,208,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M168,128a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,128Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16ZM216,48V200a32,32,0,0,1-32,32H72a32,32,0,0,1-32-32V48A16,16,0,0,1,56,32H72V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h16A16,16,0,0,1,216,48Zm-16,0H184v8a8,8,0,0,1-16,0V48H136v8a8,8,0,0,1-16,0V48H88v8a8,8,0,0,1-16,0V48H56V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M200,32H184V24a8,8,0,0,0-16,0v8H136V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H56A16,16,0,0,0,40,48V200a32,32,0,0,0,32,32H184a32,32,0,0,0,32-32V48A16,16,0,0,0,200,32ZM160,168H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M166,128a6,6,0,0,1-6,6H96a6,6,0,0,1,0-12h64A6,6,0,0,1,166,128Zm-6,26H96a6,6,0,0,0,0,12h64a6,6,0,0,0,0-12ZM214,48V200a30,30,0,0,1-30,30H72a30,30,0,0,1-30-30V48A14,14,0,0,1,56,34H74V24a6,6,0,0,1,12,0V34h36V24a6,6,0,0,1,12,0V34h36V24a6,6,0,0,1,12,0V34h18A14,14,0,0,1,214,48Zm-12,0a2,2,0,0,0-2-2H182V56a6,6,0,0,1-12,0V46H134V56a6,6,0,0,1-12,0V46H86V56a6,6,0,0,1-12,0V46H56a2,2,0,0,0-2,2V200a18,18,0,0,0,18,18H184a18,18,0,0,0,18-18Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M168,128a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,128Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16ZM216,48V200a32,32,0,0,1-32,32H72a32,32,0,0,1-32-32V48A16,16,0,0,1,56,32H72V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h16A16,16,0,0,1,216,48Zm-16,0H184v8a8,8,0,0,1-16,0V48H136v8a8,8,0,0,1-16,0V48H88v8a8,8,0,0,1-16,0V48H56V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M164,128a4,4,0,0,1-4,4H96a4,4,0,0,1,0-8h64A4,4,0,0,1,164,128Zm-4,28H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8ZM212,48V200a28,28,0,0,1-28,28H72a28,28,0,0,1-28-28V48A12,12,0,0,1,56,36H76V24a4,4,0,0,1,8,0V36h40V24a4,4,0,0,1,8,0V36h40V24a4,4,0,0,1,8,0V36h20A12,12,0,0,1,212,48Zm-8,0a4,4,0,0,0-4-4H180V56a4,4,0,0,1-8,0V44H132V56a4,4,0,0,1-8,0V44H84V56a4,4,0,0,1-8,0V44H56a4,4,0,0,0-4,4V200a20,20,0,0,0,20,20H184a20,20,0,0,0,20-20Z" }))
  ]
]), t$u = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.72V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36s40,16.15,40,36C168,125.38,154.24,139.93,136,143.28Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M138,180a10,10,0,1,1-10-10A10,10,0,0,1,138,180ZM128,74c-21,0-38,15.25-38,34v4a6,6,0,0,0,12,0v-4c0-12.13,11.66-22,26-22s26,9.87,26,22-11.66,22-26,22a6,6,0,0,0-6,6v8a6,6,0,0,0,12,0v-2.42c18.11-2.58,32-16.66,32-33.58C166,89.25,149,74,128,74Zm102,54A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M136,180a8,8,0,1,1-8-8A8,8,0,0,1,136,180ZM128,76c-19.85,0-36,14.36-36,32v4a4,4,0,0,0,8,0v-4c0-13.23,12.56-24,28-24s28,10.77,28,24-12.56,24-28,24a4,4,0,0,0-4,4v8a4,4,0,0,0,8,0v-4.2c18-1.77,32-15.36,32-31.8C164,90.36,147.85,76,128,76Zm100,52A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), t$t = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M225.21,56.31A12,12,0,0,0,216,52H58L53.73,28.42A20,20,0,0,0,34.05,12H16a12,12,0,0,0,0,24H30.71L55.62,173a28,28,0,0,0,4.07,10.21A32,32,0,1,0,115,196h34a32,32,0,1,0,31-24H83.17a4,4,0,0,1-3.93-3.28L76.92,156H188.1a28,28,0,0,0,27.55-23l12.16-66.86A12,12,0,0,0,225.21,56.31ZM92,204a8,8,0,1,1-8-8A8,8,0,0,1,92,204Zm88,8a8,8,0,1,1,8-8A8,8,0,0,1,180,212Zm12-83.28A4,4,0,0,1,188.1,132H72.56L62.38,76H201.62Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,64l-12.16,66.86A16,16,0,0,1,188.1,144H62.55L48,64Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M222.14,58.87A8,8,0,0,0,216,56H54.68L49.79,29.14A16,16,0,0,0,34.05,16H16a8,8,0,0,0,0,16h18L59.56,172.29a24,24,0,0,0,5.33,11.27,28,28,0,1,0,44.4,8.44h45.42A27.75,27.75,0,0,0,152,204a28,28,0,1,0,28-28H83.17a8,8,0,0,1-7.87-6.57L72.13,152h116a24,24,0,0,0,23.61-19.71l12.16-66.86A8,8,0,0,0,222.14,58.87ZM96,204a12,12,0,1,1-12-12A12,12,0,0,1,96,204Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,192,204Zm4-74.57A8,8,0,0,1,188.1,136H69.22L57.59,72H206.41Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222.14,58.87A8,8,0,0,0,216,56H54.68L49.79,29.14A16,16,0,0,0,34.05,16H16a8,8,0,0,0,0,16h18L59.56,172.29a24,24,0,0,0,5.33,11.27,28,28,0,1,0,44.4,8.44h45.42A27.75,27.75,0,0,0,152,204a28,28,0,1,0,28-28H83.17a8,8,0,0,1-7.87-6.57L72.13,152h116a24,24,0,0,0,23.61-19.71l12.16-66.86A8,8,0,0,0,222.14,58.87ZM180,192a12,12,0,1,1-12,12A12,12,0,0,1,180,192Zm-96,0a12,12,0,1,1-12,12A12,12,0,0,1,84,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220.61,60.16A6,6,0,0,0,216,58H53L47.83,29.5A14,14,0,0,0,34.05,18H16a6,6,0,0,0,0,12h18a2,2,0,0,1,2,1.64l25.51,140.3a21.93,21.93,0,0,0,6.24,11.77A26,26,0,1,0,105.89,190h52.22A26,26,0,1,0,180,178H83.17a10,10,0,0,1-9.84-8.21L69.73,150H188.1a22,22,0,0,0,21.65-18.06L221.9,65.07A6,6,0,0,0,220.61,60.16ZM98,204a14,14,0,1,1-14-14A14,14,0,0,1,98,204Zm96,0a14,14,0,1,1-14-14A14,14,0,0,1,194,204Zm3.94-74.21A10,10,0,0,1,188.1,138H67.55L55.19,70H208.81Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222.14,58.87A8,8,0,0,0,216,56H54.68L49.79,29.14A16,16,0,0,0,34.05,16H16a8,8,0,0,0,0,16h18L59.56,172.29a24,24,0,0,0,5.33,11.27,28,28,0,1,0,44.4,8.44h45.42A27.75,27.75,0,0,0,152,204a28,28,0,1,0,28-28H83.17a8,8,0,0,1-7.87-6.57L72.13,152h116a24,24,0,0,0,23.61-19.71l12.16-66.86A8,8,0,0,0,222.14,58.87ZM96,204a12,12,0,1,1-12-12A12,12,0,0,1,96,204Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,192,204Zm4-74.57A8,8,0,0,1,188.1,136H69.22L57.59,72H206.41Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M219.07,61.44A4,4,0,0,0,216,60H51.34L45.86,29.85A12,12,0,0,0,34.05,20H16a4,4,0,0,0,0,8h18A4,4,0,0,1,38,31.28l25.5,140.3A20,20,0,0,0,71,183.85,24,24,0,1,0,101.87,188h60.26A24,24,0,1,0,180,180H83.17a12,12,0,0,1-11.8-9.85l-4-22.15H188.1a20,20,0,0,0,19.68-16.42l12.16-66.86A4,4,0,0,0,219.07,61.44ZM100,204a16,16,0,1,1-16-16A16,16,0,0,1,100,204Zm96,0a16,16,0,1,1-16-16A16,16,0,0,1,196,204Zm3.91-73.85A12,12,0,0,1,188.1,140H65.88L52.79,68H211.21Z" }))
  ]
]), Z$1 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M140,32V64a12,12,0,0,1-24,0V32a12,12,0,0,1,24,0Zm33.25,62.75a12,12,0,0,0,8.49-3.52L204.37,68.6a12,12,0,0,0-17-17L164.77,74.26a12,12,0,0,0,8.48,20.49ZM224,116H192a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24Zm-42.26,48.77a12,12,0,1,0-17,17l22.63,22.63a12,12,0,0,0,17-17ZM128,180a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V192A12,12,0,0,0,128,180ZM74.26,164.77,51.63,187.4a12,12,0,0,0,17,17l22.63-22.63a12,12,0,1,0-17-17ZM76,128a12,12,0,0,0-12-12H32a12,12,0,0,0,0,24H64A12,12,0,0,0,76,128ZM68.6,51.63a12,12,0,1,0-17,17L74.26,91.23a12,12,0,0,0,17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm33.94,58.75,17-17a8,8,0,0,1,11.32,11.32l-17,17a8,8,0,0,1-11.31-11.31ZM48,136a8,8,0,0,1,0-16H72a8,8,0,0,1,0,16Zm46.06,37.25-17,17a8,8,0,0,1-11.32-11.32l17-17a8,8,0,0,1,11.31,11.31Zm0-79.19a8,8,0,0,1-11.31,0l-17-17A8,8,0,0,1,77.09,65.77l17,17A8,8,0,0,1,94.06,94.06ZM136,208a8,8,0,0,1-16,0V184a8,8,0,0,1,16,0Zm0-136a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Zm54.23,118.23a8,8,0,0,1-11.32,0l-17-17a8,8,0,0,1,11.31-11.31l17,17A8,8,0,0,1,190.23,190.23ZM208,136H184a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M134,32V64a6,6,0,0,1-12,0V32a6,6,0,0,1,12,0Zm39.25,56.75A6,6,0,0,0,177.5,87l22.62-22.63a6,6,0,0,0-8.48-8.48L169,78.5a6,6,0,0,0,4.24,10.25ZM224,122H192a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12Zm-46.5,47A6,6,0,0,0,169,177.5l22.63,22.62a6,6,0,0,0,8.48-8.48ZM128,186a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V192A6,6,0,0,0,128,186ZM78.5,169,55.88,191.64a6,6,0,1,0,8.48,8.48L87,177.5A6,6,0,1,0,78.5,169ZM70,128a6,6,0,0,0-6-6H32a6,6,0,0,0,0,12H64A6,6,0,0,0,70,128ZM64.36,55.88a6,6,0,0,0-8.48,8.48L78.5,87A6,6,0,1,0,87,78.5Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M132,32V64a4,4,0,0,1-8,0V32a4,4,0,0,1,8,0Zm41.25,54.75a4,4,0,0,0,2.83-1.18L198.71,63a4,4,0,0,0-5.66-5.66L170.43,79.92a4,4,0,0,0,2.82,6.83ZM224,124H192a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8Zm-47.92,46.43a4,4,0,1,0-5.65,5.65l22.62,22.63a4,4,0,0,0,5.66-5.66ZM128,188a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V192A4,4,0,0,0,128,188ZM79.92,170.43,57.29,193.05A4,4,0,0,0,63,198.71l22.62-22.63a4,4,0,1,0-5.65-5.65ZM68,128a4,4,0,0,0-4-4H32a4,4,0,0,0,0,8H64A4,4,0,0,0,68,128ZM63,57.29A4,4,0,0,0,57.29,63L79.92,85.57a4,4,0,1,0,5.65-5.65Z" }))
  ]
]), t$s = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,44a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,44Zm0,168a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,212ZM164.49,99.51a12,12,0,0,1,0,17l-28,28a12,12,0,0,1-17-17l28-28A12,12,0,0,1,164.49,99.51ZM92,16A12,12,0,0,1,104,4h48a12,12,0,0,1,0,24H104A12,12,0,0,1,92,16Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,136a88,88,0,1,1-88-88A88,88,0,0,1,216,136Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm45.66,61.66-40,40a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,11.32ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM172.24,91.76a6,6,0,0,1,0,8.48l-40,40a6,6,0,1,1-8.48-8.48l40-40A6,6,0,0,1,172.24,91.76ZM98,16a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H104A6,6,0,0,1,98,16Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,44a92,92,0,1,0,92,92A92.1,92.1,0,0,0,128,44Zm0,176a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,220ZM170.83,93.17a4,4,0,0,1,0,5.66l-40,40a4,4,0,1,1-5.66-5.66l40-40A4,4,0,0,1,170.83,93.17ZM100,16a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4,4,0,0,1,100,16Z" }))
  ]
]), t$r = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), t$q = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z" }))
  ]
]), t$p = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]);
var s$x = Object.defineProperty, c$r = Object.defineProperties, w$c = Object.getOwnPropertyDescriptors, t$o = Object.getOwnPropertySymbols, f$y = Object.prototype.hasOwnProperty, p$w = Object.prototype.propertyIsEnumerable, m$t = (v, y, z) => y in v ? s$x(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$v = (v, y) => {
  for (var z in y || (y = {}))
    f$y.call(y, z) && m$t(v, z, y[z]);
  if (t$o)
    for (var z of t$o(y))
      p$w.call(y, z) && m$t(v, z, y[z]);
  return v;
}, i$y = (v, y) => c$r(v, w$c(y));
const A$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$y(a$v({ ref: y }, v), { weights: t$J })));
A$1.displayName = "ArrowClockwise";
var f$x = Object.defineProperty, i$x = Object.defineProperties, n$j = Object.getOwnPropertyDescriptors, t$n = Object.getOwnPropertySymbols, p$v = Object.prototype.hasOwnProperty, s$w = Object.prototype.propertyIsEnumerable, m$s = (v, y, z) => y in v ? f$x(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$u = (v, y) => {
  for (var z in y || (y = {}))
    p$v.call(y, z) && m$s(v, z, y[z]);
  if (t$n)
    for (var z of t$n(y))
      s$w.call(y, z) && m$s(v, z, y[z]);
  return v;
}, w$b = (v, y) => i$x(v, n$j(y));
const D$5 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, w$b(a$u({ ref: y }, v), { weights: t$I })));
D$5.displayName = "ArrowDown";
var f$w = Object.defineProperty, p$u = Object.defineProperties, s$v = Object.getOwnPropertyDescriptors, e$2 = Object.getOwnPropertySymbols, c$q = Object.prototype.hasOwnProperty, w$a = Object.prototype.propertyIsEnumerable, m$r = (v, y, z) => y in v ? f$w(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$t = (v, y) => {
  for (var z in y || (y = {}))
    c$q.call(y, z) && m$r(v, z, y[z]);
  if (e$2)
    for (var z of e$2(y))
      w$a.call(y, z) && m$r(v, z, y[z]);
  return v;
}, i$w = (v, y) => p$u(v, s$v(y));
const d$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$w(a$t({ ref: y }, v), { weights: a$x })));
d$4.displayName = "ArrowRight";
var i$v = Object.defineProperty, p$t = Object.defineProperties, s$u = Object.getOwnPropertyDescriptors, t$m = Object.getOwnPropertySymbols, c$p = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable, a$s = (v, y, z) => y in v ? i$v(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$q = (v, y) => {
  for (var z in y || (y = {}))
    c$p.call(y, z) && a$s(v, z, y[z]);
  if (t$m)
    for (var z of t$m(y))
      u.call(y, z) && a$s(v, z, y[z]);
  return v;
}, f$v = (v, y) => p$t(v, s$u(y));
const q$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$v(m$q({ ref: y }, v), { weights: t$H })));
q$1.displayName = "ArrowSquareOut";
var f$u = Object.defineProperty, i$u = Object.defineProperties, s$t = Object.getOwnPropertyDescriptors, t$l = Object.getOwnPropertySymbols, c$o = Object.prototype.hasOwnProperty, w$9 = Object.prototype.propertyIsEnumerable, m$p = (v, y, z) => y in v ? f$u(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$r = (v, y) => {
  for (var z in y || (y = {}))
    c$o.call(y, z) && m$p(v, z, y[z]);
  if (t$l)
    for (var z of t$l(y))
      w$9.call(y, z) && m$p(v, z, y[z]);
  return v;
}, p$s = (v, y) => i$u(v, s$t(y));
const I$6 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$s(a$r({ ref: y }, v), { weights: t$G })));
I$6.displayName = "ArrowUp";
var i$t = Object.defineProperty, c$n = Object.defineProperties, w$8 = Object.getOwnPropertyDescriptors, t$k = Object.getOwnPropertySymbols, f$t = Object.prototype.hasOwnProperty, n$i = Object.prototype.propertyIsEnumerable, s$s = (v, y, z) => y in v ? i$t(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$o = (v, y) => {
  for (var z in y || (y = {}))
    f$t.call(y, z) && s$s(v, z, y[z]);
  if (t$k)
    for (var z of t$k(y))
      n$i.call(y, z) && s$s(v, z, y[z]);
  return v;
}, a$q = (v, y) => c$n(v, w$8(y));
const k$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, a$q(m$o({ ref: y }, v), { weights: t$F })));
k$2.displayName = "ArrowsCounterClockwise";
var s$r = Object.defineProperty, w$7 = Object.defineProperties, f$s = Object.getOwnPropertyDescriptors, t$j = Object.getOwnPropertySymbols, i$s = Object.prototype.hasOwnProperty, n$h = Object.prototype.propertyIsEnumerable, m$n = (v, y, z) => y in v ? s$r(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$p = (v, y) => {
  for (var z in y || (y = {}))
    i$s.call(y, z) && m$n(v, z, y[z]);
  if (t$j)
    for (var z of t$j(y))
      n$h.call(y, z) && m$n(v, z, y[z]);
  return v;
}, p$r = (v, y) => w$7(v, f$s(y));
const D$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$r(a$p({ ref: y }, v), { weights: l$a })));
D$4.displayName = "ArrowsDownUp";
var i$r = Object.defineProperty, s$q = Object.defineProperties, p$q = Object.getOwnPropertyDescriptors, o$5 = Object.getOwnPropertySymbols, c$m = Object.prototype.hasOwnProperty, w$6 = Object.prototype.propertyIsEnumerable, m$m = (v, y, z) => y in v ? i$r(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$o = (v, y) => {
  for (var z in y || (y = {}))
    c$m.call(y, z) && m$m(v, z, y[z]);
  if (o$5)
    for (var z of o$5(y))
      w$6.call(y, z) && m$m(v, z, y[z]);
  return v;
}, f$r = (v, y) => s$q(v, p$q(y));
const d$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$r(a$o({ ref: y }, v), { weights: l$9 })));
d$3.displayName = "ArrowsLeftRight";
var f$q = Object.defineProperty, p$p = Object.defineProperties, s$p = Object.getOwnPropertyDescriptors, t$i = Object.getOwnPropertySymbols, c$l = Object.prototype.hasOwnProperty, d$2 = Object.prototype.propertyIsEnumerable, m$l = (v, y, z) => y in v ? f$q(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$n = (v, y) => {
  for (var z in y || (y = {}))
    c$l.call(y, z) && m$l(v, z, y[z]);
  if (t$i)
    for (var z of t$i(y))
      d$2.call(y, z) && m$l(v, z, y[z]);
  return v;
}, i$q = (v, y) => p$p(v, s$p(y));
const w$5 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$q(a$n({ ref: y }, v), { weights: V$3 })));
w$5.displayName = "Bridge";
var f$p = Object.defineProperty, p$o = Object.defineProperties, s$o = Object.getOwnPropertyDescriptors, r$8 = Object.getOwnPropertySymbols, c$k = Object.prototype.hasOwnProperty, l$5 = Object.prototype.propertyIsEnumerable, a$m = (v, y, z) => y in v ? f$p(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$k = (v, y) => {
  for (var z in y || (y = {}))
    c$k.call(y, z) && a$m(v, z, y[z]);
  if (r$8)
    for (var z of r$8(y))
      l$5.call(y, z) && a$m(v, z, y[z]);
  return v;
}, i$p = (v, y) => p$o(v, s$o(y));
const b = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$p(m$k({ ref: y }, v), { weights: l$8 })));
b.displayName = "CaretDoubleRight";
var i$o = Object.defineProperty, n$g = Object.defineProperties, p$n = Object.getOwnPropertyDescriptors, t$h = Object.getOwnPropertySymbols, s$n = Object.prototype.hasOwnProperty, c$j = Object.prototype.propertyIsEnumerable, a$l = (v, y, z) => y in v ? i$o(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$j = (v, y) => {
  for (var z in y || (y = {}))
    s$n.call(y, z) && a$l(v, z, y[z]);
  if (t$h)
    for (var z of t$h(y))
      c$j.call(y, z) && a$l(v, z, y[z]);
  return v;
}, f$o = (v, y) => n$g(v, p$n(y));
const D$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$o(m$j({ ref: y }, v), { weights: l$7 })));
D$3.displayName = "CaretDown";
var i$n = Object.defineProperty, p$m = Object.defineProperties, s$m = Object.getOwnPropertyDescriptors, o$4 = Object.getOwnPropertySymbols, c$i = Object.prototype.hasOwnProperty, n$f = Object.prototype.propertyIsEnumerable, a$k = (v, y, z) => y in v ? i$n(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$i = (v, y) => {
  for (var z in y || (y = {}))
    c$i.call(y, z) && a$k(v, z, y[z]);
  if (o$4)
    for (var z of o$4(y))
      n$f.call(y, z) && a$k(v, z, y[z]);
  return v;
}, f$n = (v, y) => p$m(v, s$m(y));
const I$5 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$n(m$i({ ref: y }, v), { weights: a$w })));
I$5.displayName = "CaretLeft";
var f$m = Object.defineProperty, p$l = Object.defineProperties, s$l = Object.getOwnPropertyDescriptors, o$3 = Object.getOwnPropertySymbols, c$h = Object.prototype.hasOwnProperty, R$6 = Object.prototype.propertyIsEnumerable, a$j = (v, y, z) => y in v ? f$m(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$h = (v, y) => {
  for (var z in y || (y = {}))
    c$h.call(y, z) && a$j(v, z, y[z]);
  if (o$3)
    for (var z of o$3(y))
      R$6.call(y, z) && a$j(v, z, y[z]);
  return v;
}, i$m = (v, y) => p$l(v, s$l(y));
const l$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$m(m$h({ ref: y }, v), { weights: l$6 })));
l$4.displayName = "CaretRight";
var f$l = Object.defineProperty, i$l = Object.defineProperties, p$k = Object.getOwnPropertyDescriptors, t$g = Object.getOwnPropertySymbols, s$k = Object.prototype.hasOwnProperty, h$2 = Object.prototype.propertyIsEnumerable, m$g = (v, y, z) => y in v ? f$l(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$i = (v, y) => {
  for (var z in y || (y = {}))
    s$k.call(y, z) && m$g(v, z, y[z]);
  if (t$g)
    for (var z of t$g(y))
      h$2.call(y, z) && m$g(v, z, y[z]);
  return v;
}, c$g = (v, y) => i$l(v, p$k(y));
const w$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, c$g(a$i({ ref: y }, v), { weights: t$E })));
w$4.displayName = "Check";
var i$k = Object.defineProperty, f$k = Object.defineProperties, p$j = Object.getOwnPropertyDescriptors, t$f = Object.getOwnPropertySymbols, s$j = Object.prototype.hasOwnProperty, l$3 = Object.prototype.propertyIsEnumerable, c$f = (v, y, z) => y in v ? i$k(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$f = (v, y) => {
  for (var z in y || (y = {}))
    s$j.call(y, z) && c$f(v, z, y[z]);
  if (t$f)
    for (var z of t$f(y))
      l$3.call(y, z) && c$f(v, z, y[z]);
  return v;
}, a$h = (v, y) => f$k(v, p$j(y));
const k$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, a$h(m$f({ ref: y }, v), { weights: t$D })));
k$1.displayName = "CheckCircle";
var i$j = Object.defineProperty, f$j = Object.defineProperties, p$i = Object.getOwnPropertyDescriptors, t$e = Object.getOwnPropertySymbols, s$i = Object.prototype.hasOwnProperty, l$2 = Object.prototype.propertyIsEnumerable, c$e = (v, y, z) => y in v ? i$j(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$e = (v, y) => {
  for (var z in y || (y = {}))
    s$i.call(y, z) && c$e(v, z, y[z]);
  if (t$e)
    for (var z of t$e(y))
      l$2.call(y, z) && c$e(v, z, y[z]);
  return v;
}, a$g = (v, y) => f$j(v, p$i(y));
const w$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, a$g(m$e({ ref: y }, v), { weights: t$C })));
w$3.displayName = "CircleNotch";
var f$i = Object.defineProperty, i$i = Object.defineProperties, s$h = Object.getOwnPropertyDescriptors, t$d = Object.getOwnPropertySymbols, c$d = Object.prototype.hasOwnProperty, n$e = Object.prototype.propertyIsEnumerable, m$d = (v, y, z) => y in v ? f$i(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$f = (v, y) => {
  for (var z in y || (y = {}))
    c$d.call(y, z) && m$d(v, z, y[z]);
  if (t$d)
    for (var z of t$d(y))
      n$e.call(y, z) && m$d(v, z, y[z]);
  return v;
}, p$h = (v, y) => i$i(v, s$h(y));
const C$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$h(a$f({ ref: y }, v), { weights: t$B })));
C$4.displayName = "Copy";
var f$h = Object.defineProperty, i$h = Object.defineProperties, p$g = Object.getOwnPropertyDescriptors, t$c = Object.getOwnPropertySymbols, c$c = Object.prototype.hasOwnProperty, h$1 = Object.prototype.propertyIsEnumerable, m$c = (v, y, z) => y in v ? f$h(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$e = (v, y) => {
  for (var z in y || (y = {}))
    c$c.call(y, z) && m$c(v, z, y[z]);
  if (t$c)
    for (var z of t$c(y))
      h$1.call(y, z) && m$c(v, z, y[z]);
  return v;
}, s$g = (v, y) => i$h(v, p$g(y));
const D$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, s$g(a$e({ ref: y }, v), { weights: t$A })));
D$2.displayName = "DotsThree";
var p$f = Object.defineProperty, l$1 = Object.defineProperties, f$g = Object.getOwnPropertyDescriptors, r$7 = Object.getOwnPropertySymbols, n$d = Object.prototype.hasOwnProperty, s$f = Object.prototype.propertyIsEnumerable, a$d = (v, y, z) => y in v ? p$f(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, t$b = (v, y) => {
  for (var z in y || (y = {}))
    n$d.call(y, z) && a$d(v, z, y[z]);
  if (r$7)
    for (var z of r$7(y))
      s$f.call(y, z) && a$d(v, z, y[z]);
  return v;
}, i$g = (v, y) => l$1(v, f$g(y));
const I$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$g(t$b({ ref: y }, v), { weights: t$z })));
I$4.displayName = "DownloadSimple";
var a$c = Object.defineProperty, n$c = Object.defineProperties, f$f = Object.getOwnPropertyDescriptors, t$a = Object.getOwnPropertySymbols, s$e = Object.prototype.hasOwnProperty, c$b = Object.prototype.propertyIsEnumerable, m$b = (v, y, z) => y in v ? a$c(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, o$2 = (v, y) => {
  for (var z in y || (y = {}))
    s$e.call(y, z) && m$b(v, z, y[z]);
  if (t$a)
    for (var z of t$a(y))
      c$b.call(y, z) && m$b(v, z, y[z]);
  return v;
}, p$e = (v, y) => n$c(v, f$f(y));
const F$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$e(o$2({ ref: y }, v), { weights: A$2 })));
F$1.displayName = "FingerprintSimple";
var s$d = Object.defineProperty, f$e = Object.defineProperties, i$f = Object.getOwnPropertyDescriptors, r$6 = Object.getOwnPropertySymbols, c$a = Object.prototype.hasOwnProperty, n$b = Object.prototype.propertyIsEnumerable, a$b = (v, y, z) => y in v ? s$d(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, t$9 = (v, y) => {
  for (var z in y || (y = {}))
    c$a.call(y, z) && a$b(v, z, y[z]);
  if (r$6)
    for (var z of r$6(y))
      n$b.call(y, z) && a$b(v, z, y[z]);
  return v;
}, p$d = (v, y) => f$e(v, i$f(y));
const G$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$d(t$9({ ref: y }, v), { weights: t$y })));
G$3.displayName = "GasPump";
var f$d = Object.defineProperty, p$c = Object.defineProperties, s$c = Object.getOwnPropertyDescriptors, a$a = Object.getOwnPropertySymbols, c$9 = Object.prototype.hasOwnProperty, n$a = Object.prototype.propertyIsEnumerable, t$8 = (v, y, z) => y in v ? f$d(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$a = (v, y) => {
  for (var z in y || (y = {}))
    c$9.call(y, z) && t$8(v, z, y[z]);
  if (a$a)
    for (var z of a$a(y))
      n$a.call(y, z) && t$8(v, z, y[z]);
  return v;
}, i$e = (v, y) => p$c(v, s$c(y));
const G$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$e(m$a({ ref: y }, v), { weights: e$3 })));
G$2.displayName = "GearSix";
var i$d = Object.defineProperty, n$9 = Object.defineProperties, p$b = Object.getOwnPropertyDescriptors, t$7 = Object.getOwnPropertySymbols, s$b = Object.prototype.hasOwnProperty, c$8 = Object.prototype.propertyIsEnumerable, m$9 = (v, y, z) => y in v ? i$d(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$9 = (v, y) => {
  for (var z in y || (y = {}))
    s$b.call(y, z) && m$9(v, z, y[z]);
  if (t$7)
    for (var z of t$7(y))
      c$8.call(y, z) && m$9(v, z, y[z]);
  return v;
}, f$c = (v, y) => n$9(v, p$b(y));
const R$5 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$c(a$9({ ref: y }, v), { weights: t$x })));
R$5.displayName = "Info";
var l = Object.defineProperty, f$b = Object.defineProperties, n$8 = Object.getOwnPropertyDescriptors, o$1 = Object.getOwnPropertySymbols, p$a = Object.prototype.hasOwnProperty, s$a = Object.prototype.propertyIsEnumerable, r$5 = (v, y, z) => y in v ? l(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$8 = (v, y) => {
  for (var z in y || (y = {}))
    p$a.call(y, z) && r$5(v, z, y[z]);
  if (o$1)
    for (var z of o$1(y))
      s$a.call(y, z) && r$5(v, z, y[z]);
  return v;
}, i$c = (v, y) => f$b(v, n$8(y));
const d$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$c(a$8({ ref: y }, v), { weights: t$w })));
d$1.displayName = "LightbulbFilament";
var m$8 = Object.defineProperty, f$a = Object.defineProperties, n$7 = Object.getOwnPropertyDescriptors, r$4 = Object.getOwnPropertySymbols, g = Object.prototype.hasOwnProperty, p$9 = Object.prototype.propertyIsEnumerable, i$b = (v, y, z) => y in v ? m$8(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, s$9 = (v, y) => {
  for (var z in y || (y = {}))
    g.call(y, z) && i$b(v, z, y[z]);
  if (r$4)
    for (var z of r$4(y))
      p$9.call(y, z) && i$b(v, z, y[z]);
  return v;
}, t$6 = (v, y) => f$a(v, n$7(y));
const w$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, t$6(s$9({ ref: y }, v), { weights: t$v })));
w$2.displayName = "MagnifyingGlass";
var f$9 = Object.defineProperty, i$a = Object.defineProperties, s$8 = Object.getOwnPropertyDescriptors, r$3 = Object.getOwnPropertySymbols, c$7 = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable, a$7 = (v, y, z) => y in v ? f$9(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$7 = (v, y) => {
  for (var z in y || (y = {}))
    c$7.call(y, z) && a$7(v, z, y[z]);
  if (r$3)
    for (var z of r$3(y))
      d.call(y, z) && a$7(v, z, y[z]);
  return v;
}, p$8 = (v, y) => i$a(v, s$8(y));
const I$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, p$8(m$7({ ref: y }, v), { weights: V$2 })));
I$3.displayName = "Notepad";
var s$7 = Object.defineProperty, f$8 = Object.defineProperties, n$6 = Object.getOwnPropertyDescriptors, r$2 = Object.getOwnPropertySymbols, p$7 = Object.prototype.hasOwnProperty, c$6 = Object.prototype.propertyIsEnumerable, m$6 = (v, y, z) => y in v ? s$7(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$6 = (v, y) => {
  for (var z in y || (y = {}))
    p$7.call(y, z) && m$6(v, z, y[z]);
  if (r$2)
    for (var z of r$2(y))
      c$6.call(y, z) && m$6(v, z, y[z]);
  return v;
}, i$9 = (v, y) => f$8(v, n$6(y));
const I$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$9(a$6({ ref: y }, v), { weights: t$u })));
I$2.displayName = "Question";
var i$8 = Object.defineProperty, f$7 = Object.defineProperties, n$5 = Object.getOwnPropertyDescriptors, e$1 = Object.getOwnPropertySymbols, s$6 = Object.prototype.hasOwnProperty, c$5 = Object.prototype.propertyIsEnumerable, a$5 = (v, y, z) => y in v ? i$8(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, p$6 = (v, y) => {
  for (var z in y || (y = {}))
    s$6.call(y, z) && a$5(v, z, y[z]);
  if (e$1)
    for (var z of e$1(y))
      c$5.call(y, z) && a$5(v, z, y[z]);
  return v;
}, m$5 = (v, y) => f$7(v, n$5(y));
const w$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, m$5(p$6({ ref: y }, v), { weights: t$t })));
w$1.displayName = "ShoppingCart";
var n$4 = Object.defineProperty, p$5 = Object.defineProperties, f$6 = Object.getOwnPropertyDescriptors, t$5 = Object.getOwnPropertySymbols, s$5 = Object.prototype.hasOwnProperty, c$4 = Object.prototype.propertyIsEnumerable, m$4 = (v, y, z) => y in v ? n$4(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$4 = (v, y) => {
  for (var z in y || (y = {}))
    s$5.call(y, z) && m$4(v, z, y[z]);
  if (t$5)
    for (var z of t$5(y))
      c$4.call(y, z) && m$4(v, z, y[z]);
  return v;
}, i$7 = (v, y) => p$5(v, f$6(y));
const R$4 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$7(a$4({ ref: y }, v), { weights: Z$1 })));
R$4.displayName = "Spinner";
var f$5 = Object.defineProperty, p$4 = Object.defineProperties, s$4 = Object.getOwnPropertyDescriptors, o = Object.getOwnPropertySymbols, c$3 = Object.prototype.hasOwnProperty, n$3 = Object.prototype.propertyIsEnumerable, t$4 = (v, y, z) => y in v ? f$5(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a$3 = (v, y) => {
  for (var z in y || (y = {}))
    c$3.call(y, z) && t$4(v, z, y[z]);
  if (o)
    for (var z of o(y))
      n$3.call(y, z) && t$4(v, z, y[z]);
  return v;
}, i$6 = (v, y) => p$4(v, s$4(y));
const R$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$6(a$3({ ref: y }, v), { weights: t$s })));
R$3.displayName = "Timer";
var n$2 = Object.defineProperty, f$4 = Object.defineProperties, p$3 = Object.getOwnPropertyDescriptors, a$2 = Object.getOwnPropertySymbols, s$3 = Object.prototype.hasOwnProperty, c$2 = Object.prototype.propertyIsEnumerable, t$3 = (v, y, z) => y in v ? n$2(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, m$3 = (v, y) => {
  for (var z in y || (y = {}))
    s$3.call(y, z) && t$3(v, z, y[z]);
  if (a$2)
    for (var z of a$2(y))
      c$2.call(y, z) && t$3(v, z, y[z]);
  return v;
}, i$5 = (v, y) => f$4(v, p$3(y));
const I$1 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, i$5(m$3({ ref: y }, v), { weights: t$r })));
I$1.displayName = "Warning";
var n$1 = Object.defineProperty, c$1 = Object.defineProperties, f$3 = Object.getOwnPropertyDescriptors, a$1 = Object.getOwnPropertySymbols, p$2 = Object.prototype.hasOwnProperty, s$2 = Object.prototype.propertyIsEnumerable, i$4 = (v, y, z) => y in v ? n$1(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, t$2 = (v, y) => {
  for (var z in y || (y = {}))
    p$2.call(y, z) && i$4(v, z, y[z]);
  if (a$1)
    for (var z of a$1(y))
      s$2.call(y, z) && i$4(v, z, y[z]);
  return v;
}, m$2 = (v, y) => c$1(v, f$3(y));
const C$3 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, m$2(t$2({ ref: y }, v), { weights: t$q })));
C$3.displayName = "WarningCircle";
var i$3 = Object.defineProperty, p$1 = Object.defineProperties, s$1 = Object.getOwnPropertyDescriptors, t$1 = Object.getOwnPropertySymbols, c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable, m$1 = (v, y, z) => y in v ? i$3(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, a = (v, y) => {
  for (var z in y || (y = {}))
    c.call(y, z) && m$1(v, z, y[z]);
  if (t$1)
    for (var z of t$1(y))
      n.call(y, z) && m$1(v, z, y[z]);
  return v;
}, f$2 = (v, y) => p$1(v, s$1(y));
const R$2 = forwardRef((v, y) => /* @__PURE__ */ a__default.createElement(P$1, f$2(a({ ref: y }, v), { weights: t$p })));
R$2.displayName = "X";
const useDebouncedValue = (v, y) => {
  const [z, ne] = useState(v);
  return useEffect(() => {
    const ue = setTimeout(() => {
      ne(v);
    }, y);
    return () => {
      clearTimeout(ue);
    };
  }, [v, y]), z;
};
var NodeProvider;
(function(v) {
  v.NUMIA = "numia";
})(NodeProvider || (NodeProvider = {}));
var TXN_STATUS;
(function(v) {
  v.INIT = "INIT", v.PENDING = "PENDING", v.SUCCESS = "SUCCESS", v.FAILED = "FAILED", v.SIGNED = "SIGNED";
})(TXN_STATUS || (TXN_STATUS = {}));
class AsyncStorageError extends Error {
  constructor(y) {
    super(y), this.name = "AsyncStorageError";
  }
}
const getPrefixedKey = (v, y) => `${v}:${y}`;
class AsyncStorage {
  /**
   * Create a new AsyncStorage instance. The keyPrefix is used to namespace the keys in the
   * underlying storage layer. It's optional, but recommended to avoid key collisions.
   */
  constructor(y, z = "") {
    Rm(this, "storage");
    Rm(this, "keyPrefix");
    this.storage = y, this.keyPrefix = z;
  }
  /**
   * Create a new AsyncStorage instance with initial data.
   */
  static async withInitialData(y, z, ne = "") {
    const ue = new AsyncStorage(y, ne);
    try {
      await Promise.all(Object.entries(z).map(([le, he]) => ue.setItem(le, he)));
    } catch (le) {
      console.warn("Failed to set initial data", le);
    }
    return ue;
  }
  /**
   * Get the value for the given key.
   */
  async getItem(y) {
    const z = getPrefixedKey(this.keyPrefix, y);
    try {
      const ne = await this.storage.getItem(z);
      return ne ? JSON.parse(ne) : null;
    } catch (ne) {
      throw ne instanceof SyntaxError ? new AsyncStorageError(`Failed to parse value for key ${y}`) : new AsyncStorageError(`Failed to get value for key ${y}`);
    }
  }
  /**
   * Set the value for the given key.
   */
  async setItem(y, z) {
    const ne = getPrefixedKey(this.keyPrefix, y);
    try {
      const ue = JSON.stringify(z);
      if (ue === void 0)
        throw new TypeError();
      await this.storage.setItem(ne, ue);
    } catch (ue) {
      throw ue instanceof TypeError ? new AsyncStorageError(`Failed to stringify value for key ${y}`) : new AsyncStorageError(`Failed to set value for key ${y}`);
    }
  }
  /**
   * Remove the value for the given key.
   */
  async removeItem(y) {
    const z = getPrefixedKey(this.keyPrefix, y);
    try {
      await this.storage.removeItem(z);
    } catch {
      throw new AsyncStorageError(`Failed to remove value for key ${y}`);
    }
  }
  /**
   * Calling this method will clear all data for the given storage layer.
   *
   * It might lead to unexpected behavior and/or data loss if other modules are using the same storage layer.
   */
  async clear() {
    try {
      console.warn("Clearing async storage. Be careful when using this method in production as it might lead to data loss if other parts of the code are using the same storage layer."), await this.storage.clear();
    } catch {
      throw new AsyncStorageError("Failed to clear the storage");
    }
  }
}
class StorageLayer {
  constructor() {
    Rm(this, "warned", !1);
    Rm(this, "storage");
  }
  isInitialized() {
    const y = this.storage !== void 0;
    return !y && !this.warned && (console.warn("🚧 Storage layer is not initialized. We recommend initializing storage layer for caching and improved performance. http://bit.ly/init-caching-layer"), this.warned = !0), y;
  }
  initialize(y) {
    this.storage = y;
  }
  getStorage() {
    if (!this.storage)
      throw new Error("Caching layer is not initialized");
    return this.storage;
  }
}
const storageLayer = new StorageLayer();
var buffer$1 = {}, base64Js$1 = {};
base64Js$1.byteLength = byteLength$1;
base64Js$1.toByteArray = toByteArray$1;
base64Js$1.fromByteArray = fromByteArray$1;
var lookup$1 = [], revLookup$1 = [], Arr$1 = typeof Uint8Array < "u" ? Uint8Array : Array, code$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len$1 = code$1.length; i$2 < len$1; ++i$2)
  lookup$1[i$2] = code$1[i$2], revLookup$1[code$1.charCodeAt(i$2)] = i$2;
revLookup$1[45] = 62;
revLookup$1[95] = 63;
function getLens$1(v) {
  var y = v.length;
  if (y % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var z = v.indexOf("=");
  z === -1 && (z = y);
  var ne = z === y ? 0 : 4 - z % 4;
  return [z, ne];
}
function byteLength$1(v) {
  var y = getLens$1(v), z = y[0], ne = y[1];
  return (z + ne) * 3 / 4 - ne;
}
function _byteLength$1(v, y, z) {
  return (y + z) * 3 / 4 - z;
}
function toByteArray$1(v) {
  var y, z = getLens$1(v), ne = z[0], ue = z[1], le = new Arr$1(_byteLength$1(v, ne, ue)), he = 0, ge = ue > 0 ? ne - 4 : ne, we;
  for (we = 0; we < ge; we += 4)
    y = revLookup$1[v.charCodeAt(we)] << 18 | revLookup$1[v.charCodeAt(we + 1)] << 12 | revLookup$1[v.charCodeAt(we + 2)] << 6 | revLookup$1[v.charCodeAt(we + 3)], le[he++] = y >> 16 & 255, le[he++] = y >> 8 & 255, le[he++] = y & 255;
  return ue === 2 && (y = revLookup$1[v.charCodeAt(we)] << 2 | revLookup$1[v.charCodeAt(we + 1)] >> 4, le[he++] = y & 255), ue === 1 && (y = revLookup$1[v.charCodeAt(we)] << 10 | revLookup$1[v.charCodeAt(we + 1)] << 4 | revLookup$1[v.charCodeAt(we + 2)] >> 2, le[he++] = y >> 8 & 255, le[he++] = y & 255), le;
}
function tripletToBase64$1(v) {
  return lookup$1[v >> 18 & 63] + lookup$1[v >> 12 & 63] + lookup$1[v >> 6 & 63] + lookup$1[v & 63];
}
function encodeChunk$1(v, y, z) {
  for (var ne, ue = [], le = y; le < z; le += 3)
    ne = (v[le] << 16 & 16711680) + (v[le + 1] << 8 & 65280) + (v[le + 2] & 255), ue.push(tripletToBase64$1(ne));
  return ue.join("");
}
function fromByteArray$1(v) {
  for (var y, z = v.length, ne = z % 3, ue = [], le = 16383, he = 0, ge = z - ne; he < ge; he += le)
    ue.push(encodeChunk$1(v, he, he + le > ge ? ge : he + le));
  return ne === 1 ? (y = v[z - 1], ue.push(
    lookup$1[y >> 2] + lookup$1[y << 4 & 63] + "=="
  )) : ne === 2 && (y = (v[z - 2] << 8) + v[z - 1], ue.push(
    lookup$1[y >> 10] + lookup$1[y >> 4 & 63] + lookup$1[y << 2 & 63] + "="
  )), ue.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(v, y, z, ne, ue) {
  var le, he, ge = ue * 8 - ne - 1, we = (1 << ge) - 1, Ee = we >> 1, xe = -7, $e = z ? ue - 1 : 0, Ne = z ? -1 : 1, st = v[y + $e];
  for ($e += Ne, le = st & (1 << -xe) - 1, st >>= -xe, xe += ge; xe > 0; le = le * 256 + v[y + $e], $e += Ne, xe -= 8)
    ;
  for (he = le & (1 << -xe) - 1, le >>= -xe, xe += ne; xe > 0; he = he * 256 + v[y + $e], $e += Ne, xe -= 8)
    ;
  if (le === 0)
    le = 1 - Ee;
  else {
    if (le === we)
      return he ? NaN : (st ? -1 : 1) * (1 / 0);
    he = he + Math.pow(2, ne), le = le - Ee;
  }
  return (st ? -1 : 1) * he * Math.pow(2, le - ne);
};
ieee754.write = function(v, y, z, ne, ue, le) {
  var he, ge, we, Ee = le * 8 - ue - 1, xe = (1 << Ee) - 1, $e = xe >> 1, Ne = ue === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, st = ne ? 0 : le - 1, Nr = ne ? 1 : -1, br = y < 0 || y === 0 && 1 / y < 0 ? 1 : 0;
  for (y = Math.abs(y), isNaN(y) || y === 1 / 0 ? (ge = isNaN(y) ? 1 : 0, he = xe) : (he = Math.floor(Math.log(y) / Math.LN2), y * (we = Math.pow(2, -he)) < 1 && (he--, we *= 2), he + $e >= 1 ? y += Ne / we : y += Ne * Math.pow(2, 1 - $e), y * we >= 2 && (he++, we /= 2), he + $e >= xe ? (ge = 0, he = xe) : he + $e >= 1 ? (ge = (y * we - 1) * Math.pow(2, ue), he = he + $e) : (ge = y * Math.pow(2, $e - 1) * Math.pow(2, ue), he = 0)); ue >= 8; v[z + st] = ge & 255, st += Nr, ge /= 256, ue -= 8)
    ;
  for (he = he << ue | ge, Ee += ue; Ee > 0; v[z + st] = he & 255, st += Nr, he /= 256, Ee -= 8)
    ;
  v[z + st - Nr] |= br * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(v) {
  const y = base64Js$1, z = ieee754, ne = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  v.Buffer = xe, v.SlowBuffer = _a, v.INSPECT_MAX_BYTES = 50;
  const ue = 2147483647;
  v.kMaxLength = ue;
  const { Uint8Array: le, ArrayBuffer: he, SharedArrayBuffer: ge } = globalThis;
  xe.TYPED_ARRAY_SUPPORT = we(), !xe.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function we() {
    try {
      const Eu = new le(1), Zo = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Zo, le.prototype), Object.setPrototypeOf(Eu, Zo), Eu.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(xe.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (xe.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(xe.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (xe.isBuffer(this))
        return this.byteOffset;
    }
  });
  function Ee(Eu) {
    if (Eu > ue)
      throw new RangeError('The value "' + Eu + '" is invalid for option "size"');
    const Zo = new le(Eu);
    return Object.setPrototypeOf(Zo, xe.prototype), Zo;
  }
  function xe(Eu, Zo, Fl) {
    if (typeof Eu == "number") {
      if (typeof Zo == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return Nr(Eu);
    }
    return $e(Eu, Zo, Fl);
  }
  xe.poolSize = 8192;
  function $e(Eu, Zo, Fl) {
    if (typeof Eu == "string")
      return br(Eu, Zo);
    if (he.isView(Eu))
      return En(Eu);
    if (Eu == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Eu
      );
    if (Kc(Eu, he) || Eu && Kc(Eu.buffer, he) || typeof ge < "u" && (Kc(Eu, ge) || Eu && Kc(Eu.buffer, ge)))
      return Rn(Eu, Zo, Fl);
    if (typeof Eu == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Ru = Eu.valueOf && Eu.valueOf();
    if (Ru != null && Ru !== Eu)
      return xe.from(Ru, Zo, Fl);
    const ku = wa(Eu);
    if (ku)
      return ku;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Eu[Symbol.toPrimitive] == "function")
      return xe.from(Eu[Symbol.toPrimitive]("string"), Zo, Fl);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Eu
    );
  }
  xe.from = function(Eu, Zo, Fl) {
    return $e(Eu, Zo, Fl);
  }, Object.setPrototypeOf(xe.prototype, le.prototype), Object.setPrototypeOf(xe, le);
  function Ne(Eu) {
    if (typeof Eu != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Eu < 0)
      throw new RangeError('The value "' + Eu + '" is invalid for option "size"');
  }
  function st(Eu, Zo, Fl) {
    return Ne(Eu), Eu <= 0 ? Ee(Eu) : Zo !== void 0 ? typeof Fl == "string" ? Ee(Eu).fill(Zo, Fl) : Ee(Eu).fill(Zo) : Ee(Eu);
  }
  xe.alloc = function(Eu, Zo, Fl) {
    return st(Eu, Zo, Fl);
  };
  function Nr(Eu) {
    return Ne(Eu), Ee(Eu < 0 ? 0 : Aa(Eu) | 0);
  }
  xe.allocUnsafe = function(Eu) {
    return Nr(Eu);
  }, xe.allocUnsafeSlow = function(Eu) {
    return Nr(Eu);
  };
  function br(Eu, Zo) {
    if ((typeof Zo != "string" || Zo === "") && (Zo = "utf8"), !xe.isEncoding(Zo))
      throw new TypeError("Unknown encoding: " + Zo);
    const Fl = Ta(Eu, Zo) | 0;
    let Ru = Ee(Fl);
    const ku = Ru.write(Eu, Zo);
    return ku !== Fl && (Ru = Ru.slice(0, ku)), Ru;
  }
  function $n(Eu) {
    const Zo = Eu.length < 0 ? 0 : Aa(Eu.length) | 0, Fl = Ee(Zo);
    for (let Ru = 0; Ru < Zo; Ru += 1)
      Fl[Ru] = Eu[Ru] & 255;
    return Fl;
  }
  function En(Eu) {
    if (Kc(Eu, le)) {
      const Zo = new le(Eu);
      return Rn(Zo.buffer, Zo.byteOffset, Zo.byteLength);
    }
    return $n(Eu);
  }
  function Rn(Eu, Zo, Fl) {
    if (Zo < 0 || Eu.byteLength < Zo)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Eu.byteLength < Zo + (Fl || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Ru;
    return Zo === void 0 && Fl === void 0 ? Ru = new le(Eu) : Fl === void 0 ? Ru = new le(Eu, Zo) : Ru = new le(Eu, Zo, Fl), Object.setPrototypeOf(Ru, xe.prototype), Ru;
  }
  function wa(Eu) {
    if (xe.isBuffer(Eu)) {
      const Zo = Aa(Eu.length) | 0, Fl = Ee(Zo);
      return Fl.length === 0 || Eu.copy(Fl, 0, 0, Zo), Fl;
    }
    if (Eu.length !== void 0)
      return typeof Eu.length != "number" || M2(Eu.length) ? Ee(0) : $n(Eu);
    if (Eu.type === "Buffer" && Array.isArray(Eu.data))
      return $n(Eu.data);
  }
  function Aa(Eu) {
    if (Eu >= ue)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + ue.toString(16) + " bytes");
    return Eu | 0;
  }
  function _a(Eu) {
    return +Eu != Eu && (Eu = 0), xe.alloc(+Eu);
  }
  xe.isBuffer = function(Zo) {
    return Zo != null && Zo._isBuffer === !0 && Zo !== xe.prototype;
  }, xe.compare = function(Zo, Fl) {
    if (Kc(Zo, le) && (Zo = xe.from(Zo, Zo.offset, Zo.byteLength)), Kc(Fl, le) && (Fl = xe.from(Fl, Fl.offset, Fl.byteLength)), !xe.isBuffer(Zo) || !xe.isBuffer(Fl))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Zo === Fl)
      return 0;
    let Ru = Zo.length, ku = Fl.length;
    for (let kc = 0, Ou = Math.min(Ru, ku); kc < Ou; ++kc)
      if (Zo[kc] !== Fl[kc]) {
        Ru = Zo[kc], ku = Fl[kc];
        break;
      }
    return Ru < ku ? -1 : ku < Ru ? 1 : 0;
  }, xe.isEncoding = function(Zo) {
    switch (String(Zo).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, xe.concat = function(Zo, Fl) {
    if (!Array.isArray(Zo))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Zo.length === 0)
      return xe.alloc(0);
    let Ru;
    if (Fl === void 0)
      for (Fl = 0, Ru = 0; Ru < Zo.length; ++Ru)
        Fl += Zo[Ru].length;
    const ku = xe.allocUnsafe(Fl);
    let kc = 0;
    for (Ru = 0; Ru < Zo.length; ++Ru) {
      let Ou = Zo[Ru];
      if (Kc(Ou, le))
        kc + Ou.length > ku.length ? (xe.isBuffer(Ou) || (Ou = xe.from(Ou)), Ou.copy(ku, kc)) : le.prototype.set.call(
          ku,
          Ou,
          kc
        );
      else if (xe.isBuffer(Ou))
        Ou.copy(ku, kc);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      kc += Ou.length;
    }
    return ku;
  };
  function Ta(Eu, Zo) {
    if (xe.isBuffer(Eu))
      return Eu.length;
    if (he.isView(Eu) || Kc(Eu, he))
      return Eu.byteLength;
    if (typeof Eu != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Eu
      );
    const Fl = Eu.length, Ru = arguments.length > 2 && arguments[2] === !0;
    if (!Ru && Fl === 0)
      return 0;
    let ku = !1;
    for (; ; )
      switch (Zo) {
        case "ascii":
        case "latin1":
        case "binary":
          return Fl;
        case "utf8":
        case "utf-8":
          return Gh(Eu).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Fl * 2;
        case "hex":
          return Fl >>> 1;
        case "base64":
          return l2(Eu).length;
        default:
          if (ku)
            return Ru ? -1 : Gh(Eu).length;
          Zo = ("" + Zo).toLowerCase(), ku = !0;
      }
  }
  xe.byteLength = Ta;
  function Zn(Eu, Zo, Fl) {
    let Ru = !1;
    if ((Zo === void 0 || Zo < 0) && (Zo = 0), Zo > this.length || ((Fl === void 0 || Fl > this.length) && (Fl = this.length), Fl <= 0) || (Fl >>>= 0, Zo >>>= 0, Fl <= Zo))
      return "";
    for (Eu || (Eu = "utf8"); ; )
      switch (Eu) {
        case "hex":
          return xa(this, Zo, Fl);
        case "utf8":
        case "utf-8":
          return Fr(this, Zo, Fl);
        case "ascii":
          return pe(this, Zo, Fl);
        case "latin1":
        case "binary":
          return it(this, Zo, Fl);
        case "base64":
          return Oe(this, Zo, Fl);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return wo(this, Zo, Fl);
        default:
          if (Ru)
            throw new TypeError("Unknown encoding: " + Eu);
          Eu = (Eu + "").toLowerCase(), Ru = !0;
      }
  }
  xe.prototype._isBuffer = !0;
  function Ra(Eu, Zo, Fl) {
    const Ru = Eu[Zo];
    Eu[Zo] = Eu[Fl], Eu[Fl] = Ru;
  }
  xe.prototype.swap16 = function() {
    const Zo = this.length;
    if (Zo % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Fl = 0; Fl < Zo; Fl += 2)
      Ra(this, Fl, Fl + 1);
    return this;
  }, xe.prototype.swap32 = function() {
    const Zo = this.length;
    if (Zo % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Fl = 0; Fl < Zo; Fl += 4)
      Ra(this, Fl, Fl + 3), Ra(this, Fl + 1, Fl + 2);
    return this;
  }, xe.prototype.swap64 = function() {
    const Zo = this.length;
    if (Zo % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Fl = 0; Fl < Zo; Fl += 8)
      Ra(this, Fl, Fl + 7), Ra(this, Fl + 1, Fl + 6), Ra(this, Fl + 2, Fl + 5), Ra(this, Fl + 3, Fl + 4);
    return this;
  }, xe.prototype.toString = function() {
    const Zo = this.length;
    return Zo === 0 ? "" : arguments.length === 0 ? Fr(this, 0, Zo) : Zn.apply(this, arguments);
  }, xe.prototype.toLocaleString = xe.prototype.toString, xe.prototype.equals = function(Zo) {
    if (!xe.isBuffer(Zo))
      throw new TypeError("Argument must be a Buffer");
    return this === Zo ? !0 : xe.compare(this, Zo) === 0;
  }, xe.prototype.inspect = function() {
    let Zo = "";
    const Fl = v.INSPECT_MAX_BYTES;
    return Zo = this.toString("hex", 0, Fl).replace(/(.{2})/g, "$1 ").trim(), this.length > Fl && (Zo += " ... "), "<Buffer " + Zo + ">";
  }, ne && (xe.prototype[ne] = xe.prototype.inspect), xe.prototype.compare = function(Zo, Fl, Ru, ku, kc) {
    if (Kc(Zo, le) && (Zo = xe.from(Zo, Zo.offset, Zo.byteLength)), !xe.isBuffer(Zo))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Zo
      );
    if (Fl === void 0 && (Fl = 0), Ru === void 0 && (Ru = Zo ? Zo.length : 0), ku === void 0 && (ku = 0), kc === void 0 && (kc = this.length), Fl < 0 || Ru > Zo.length || ku < 0 || kc > this.length)
      throw new RangeError("out of range index");
    if (ku >= kc && Fl >= Ru)
      return 0;
    if (ku >= kc)
      return -1;
    if (Fl >= Ru)
      return 1;
    if (Fl >>>= 0, Ru >>>= 0, ku >>>= 0, kc >>>= 0, this === Zo)
      return 0;
    let Ou = kc - ku, U1 = Ru - Fl;
    const g2 = Math.min(Ou, U1), Ic = this.slice(ku, kc), X1 = Zo.slice(Fl, Ru);
    for (let $2 = 0; $2 < g2; ++$2)
      if (Ic[$2] !== X1[$2]) {
        Ou = Ic[$2], U1 = X1[$2];
        break;
      }
    return Ou < U1 ? -1 : U1 < Ou ? 1 : 0;
  };
  function Yn(Eu, Zo, Fl, Ru, ku) {
    if (Eu.length === 0)
      return -1;
    if (typeof Fl == "string" ? (Ru = Fl, Fl = 0) : Fl > 2147483647 ? Fl = 2147483647 : Fl < -2147483648 && (Fl = -2147483648), Fl = +Fl, M2(Fl) && (Fl = ku ? 0 : Eu.length - 1), Fl < 0 && (Fl = Eu.length + Fl), Fl >= Eu.length) {
      if (ku)
        return -1;
      Fl = Eu.length - 1;
    } else if (Fl < 0)
      if (ku)
        Fl = 0;
      else
        return -1;
    if (typeof Zo == "string" && (Zo = xe.from(Zo, Ru)), xe.isBuffer(Zo))
      return Zo.length === 0 ? -1 : $o(Eu, Zo, Fl, Ru, ku);
    if (typeof Zo == "number")
      return Zo = Zo & 255, typeof le.prototype.indexOf == "function" ? ku ? le.prototype.indexOf.call(Eu, Zo, Fl) : le.prototype.lastIndexOf.call(Eu, Zo, Fl) : $o(Eu, [Zo], Fl, Ru, ku);
    throw new TypeError("val must be string, number or Buffer");
  }
  function $o(Eu, Zo, Fl, Ru, ku) {
    let kc = 1, Ou = Eu.length, U1 = Zo.length;
    if (Ru !== void 0 && (Ru = String(Ru).toLowerCase(), Ru === "ucs2" || Ru === "ucs-2" || Ru === "utf16le" || Ru === "utf-16le")) {
      if (Eu.length < 2 || Zo.length < 2)
        return -1;
      kc = 2, Ou /= 2, U1 /= 2, Fl /= 2;
    }
    function g2(X1, $2) {
      return kc === 1 ? X1[$2] : X1.readUInt16BE($2 * kc);
    }
    let Ic;
    if (ku) {
      let X1 = -1;
      for (Ic = Fl; Ic < Ou; Ic++)
        if (g2(Eu, Ic) === g2(Zo, X1 === -1 ? 0 : Ic - X1)) {
          if (X1 === -1 && (X1 = Ic), Ic - X1 + 1 === U1)
            return X1 * kc;
        } else
          X1 !== -1 && (Ic -= Ic - X1), X1 = -1;
    } else
      for (Fl + U1 > Ou && (Fl = Ou - U1), Ic = Fl; Ic >= 0; Ic--) {
        let X1 = !0;
        for (let $2 = 0; $2 < U1; $2++)
          if (g2(Eu, Ic + $2) !== g2(Zo, $2)) {
            X1 = !1;
            break;
          }
        if (X1)
          return Ic;
      }
    return -1;
  }
  xe.prototype.includes = function(Zo, Fl, Ru) {
    return this.indexOf(Zo, Fl, Ru) !== -1;
  }, xe.prototype.indexOf = function(Zo, Fl, Ru) {
    return Yn(this, Zo, Fl, Ru, !0);
  }, xe.prototype.lastIndexOf = function(Zo, Fl, Ru) {
    return Yn(this, Zo, Fl, Ru, !1);
  };
  function ct(Eu, Zo, Fl, Ru) {
    Fl = Number(Fl) || 0;
    const ku = Eu.length - Fl;
    Ru ? (Ru = Number(Ru), Ru > ku && (Ru = ku)) : Ru = ku;
    const kc = Zo.length;
    Ru > kc / 2 && (Ru = kc / 2);
    let Ou;
    for (Ou = 0; Ou < Ru; ++Ou) {
      const U1 = parseInt(Zo.substr(Ou * 2, 2), 16);
      if (M2(U1))
        return Ou;
      Eu[Fl + Ou] = U1;
    }
    return Ou;
  }
  function fe(Eu, Zo, Fl, Ru) {
    return Gc(Gh(Zo, Eu.length - Fl), Eu, Fl, Ru);
  }
  function be(Eu, Zo, Fl, Ru) {
    return Gc(Mc(Zo), Eu, Fl, Ru);
  }
  function ye(Eu, Zo, Fl, Ru) {
    return Gc(l2(Zo), Eu, Fl, Ru);
  }
  function Se(Eu, Zo, Fl, Ru) {
    return Gc(h1(Zo, Eu.length - Fl), Eu, Fl, Ru);
  }
  xe.prototype.write = function(Zo, Fl, Ru, ku) {
    if (Fl === void 0)
      ku = "utf8", Ru = this.length, Fl = 0;
    else if (Ru === void 0 && typeof Fl == "string")
      ku = Fl, Ru = this.length, Fl = 0;
    else if (isFinite(Fl))
      Fl = Fl >>> 0, isFinite(Ru) ? (Ru = Ru >>> 0, ku === void 0 && (ku = "utf8")) : (ku = Ru, Ru = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const kc = this.length - Fl;
    if ((Ru === void 0 || Ru > kc) && (Ru = kc), Zo.length > 0 && (Ru < 0 || Fl < 0) || Fl > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    ku || (ku = "utf8");
    let Ou = !1;
    for (; ; )
      switch (ku) {
        case "hex":
          return ct(this, Zo, Fl, Ru);
        case "utf8":
        case "utf-8":
          return fe(this, Zo, Fl, Ru);
        case "ascii":
        case "latin1":
        case "binary":
          return be(this, Zo, Fl, Ru);
        case "base64":
          return ye(this, Zo, Fl, Ru);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Se(this, Zo, Fl, Ru);
        default:
          if (Ou)
            throw new TypeError("Unknown encoding: " + ku);
          ku = ("" + ku).toLowerCase(), Ou = !0;
      }
  }, xe.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function Oe(Eu, Zo, Fl) {
    return Zo === 0 && Fl === Eu.length ? y.fromByteArray(Eu) : y.fromByteArray(Eu.slice(Zo, Fl));
  }
  function Fr(Eu, Zo, Fl) {
    Fl = Math.min(Eu.length, Fl);
    const Ru = [];
    let ku = Zo;
    for (; ku < Fl; ) {
      const kc = Eu[ku];
      let Ou = null, U1 = kc > 239 ? 4 : kc > 223 ? 3 : kc > 191 ? 2 : 1;
      if (ku + U1 <= Fl) {
        let g2, Ic, X1, $2;
        switch (U1) {
          case 1:
            kc < 128 && (Ou = kc);
            break;
          case 2:
            g2 = Eu[ku + 1], (g2 & 192) === 128 && ($2 = (kc & 31) << 6 | g2 & 63, $2 > 127 && (Ou = $2));
            break;
          case 3:
            g2 = Eu[ku + 1], Ic = Eu[ku + 2], (g2 & 192) === 128 && (Ic & 192) === 128 && ($2 = (kc & 15) << 12 | (g2 & 63) << 6 | Ic & 63, $2 > 2047 && ($2 < 55296 || $2 > 57343) && (Ou = $2));
            break;
          case 4:
            g2 = Eu[ku + 1], Ic = Eu[ku + 2], X1 = Eu[ku + 3], (g2 & 192) === 128 && (Ic & 192) === 128 && (X1 & 192) === 128 && ($2 = (kc & 15) << 18 | (g2 & 63) << 12 | (Ic & 63) << 6 | X1 & 63, $2 > 65535 && $2 < 1114112 && (Ou = $2));
        }
      }
      Ou === null ? (Ou = 65533, U1 = 1) : Ou > 65535 && (Ou -= 65536, Ru.push(Ou >>> 10 & 1023 | 55296), Ou = 56320 | Ou & 1023), Ru.push(Ou), ku += U1;
    }
    return Fe(Ru);
  }
  const zn = 4096;
  function Fe(Eu) {
    const Zo = Eu.length;
    if (Zo <= zn)
      return String.fromCharCode.apply(String, Eu);
    let Fl = "", Ru = 0;
    for (; Ru < Zo; )
      Fl += String.fromCharCode.apply(
        String,
        Eu.slice(Ru, Ru += zn)
      );
    return Fl;
  }
  function pe(Eu, Zo, Fl) {
    let Ru = "";
    Fl = Math.min(Eu.length, Fl);
    for (let ku = Zo; ku < Fl; ++ku)
      Ru += String.fromCharCode(Eu[ku] & 127);
    return Ru;
  }
  function it(Eu, Zo, Fl) {
    let Ru = "";
    Fl = Math.min(Eu.length, Fl);
    for (let ku = Zo; ku < Fl; ++ku)
      Ru += String.fromCharCode(Eu[ku]);
    return Ru;
  }
  function xa(Eu, Zo, Fl) {
    const Ru = Eu.length;
    (!Zo || Zo < 0) && (Zo = 0), (!Fl || Fl < 0 || Fl > Ru) && (Fl = Ru);
    let ku = "";
    for (let kc = Zo; kc < Fl; ++kc)
      ku += d1[Eu[kc]];
    return ku;
  }
  function wo(Eu, Zo, Fl) {
    const Ru = Eu.slice(Zo, Fl);
    let ku = "";
    for (let kc = 0; kc < Ru.length - 1; kc += 2)
      ku += String.fromCharCode(Ru[kc] + Ru[kc + 1] * 256);
    return ku;
  }
  xe.prototype.slice = function(Zo, Fl) {
    const Ru = this.length;
    Zo = ~~Zo, Fl = Fl === void 0 ? Ru : ~~Fl, Zo < 0 ? (Zo += Ru, Zo < 0 && (Zo = 0)) : Zo > Ru && (Zo = Ru), Fl < 0 ? (Fl += Ru, Fl < 0 && (Fl = 0)) : Fl > Ru && (Fl = Ru), Fl < Zo && (Fl = Zo);
    const ku = this.subarray(Zo, Fl);
    return Object.setPrototypeOf(ku, xe.prototype), ku;
  };
  function _u(Eu, Zo, Fl) {
    if (Eu % 1 !== 0 || Eu < 0)
      throw new RangeError("offset is not uint");
    if (Eu + Zo > Fl)
      throw new RangeError("Trying to access beyond buffer length");
  }
  xe.prototype.readUintLE = xe.prototype.readUIntLE = function(Zo, Fl, Ru) {
    Zo = Zo >>> 0, Fl = Fl >>> 0, Ru || _u(Zo, Fl, this.length);
    let ku = this[Zo], kc = 1, Ou = 0;
    for (; ++Ou < Fl && (kc *= 256); )
      ku += this[Zo + Ou] * kc;
    return ku;
  }, xe.prototype.readUintBE = xe.prototype.readUIntBE = function(Zo, Fl, Ru) {
    Zo = Zo >>> 0, Fl = Fl >>> 0, Ru || _u(Zo, Fl, this.length);
    let ku = this[Zo + --Fl], kc = 1;
    for (; Fl > 0 && (kc *= 256); )
      ku += this[Zo + --Fl] * kc;
    return ku;
  }, xe.prototype.readUint8 = xe.prototype.readUInt8 = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 1, this.length), this[Zo];
  }, xe.prototype.readUint16LE = xe.prototype.readUInt16LE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 2, this.length), this[Zo] | this[Zo + 1] << 8;
  }, xe.prototype.readUint16BE = xe.prototype.readUInt16BE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 2, this.length), this[Zo] << 8 | this[Zo + 1];
  }, xe.prototype.readUint32LE = xe.prototype.readUInt32LE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), (this[Zo] | this[Zo + 1] << 8 | this[Zo + 2] << 16) + this[Zo + 3] * 16777216;
  }, xe.prototype.readUint32BE = xe.prototype.readUInt32BE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), this[Zo] * 16777216 + (this[Zo + 1] << 16 | this[Zo + 2] << 8 | this[Zo + 3]);
  }, xe.prototype.readBigUInt64LE = K1(function(Zo) {
    Zo = Zo >>> 0, Lu(Zo, "offset");
    const Fl = this[Zo], Ru = this[Zo + 7];
    (Fl === void 0 || Ru === void 0) && th(Zo, this.length - 8);
    const ku = Fl + this[++Zo] * 2 ** 8 + this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 24, kc = this[++Zo] + this[++Zo] * 2 ** 8 + this[++Zo] * 2 ** 16 + Ru * 2 ** 24;
    return BigInt(ku) + (BigInt(kc) << BigInt(32));
  }), xe.prototype.readBigUInt64BE = K1(function(Zo) {
    Zo = Zo >>> 0, Lu(Zo, "offset");
    const Fl = this[Zo], Ru = this[Zo + 7];
    (Fl === void 0 || Ru === void 0) && th(Zo, this.length - 8);
    const ku = Fl * 2 ** 24 + this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 8 + this[++Zo], kc = this[++Zo] * 2 ** 24 + this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 8 + Ru;
    return (BigInt(ku) << BigInt(32)) + BigInt(kc);
  }), xe.prototype.readIntLE = function(Zo, Fl, Ru) {
    Zo = Zo >>> 0, Fl = Fl >>> 0, Ru || _u(Zo, Fl, this.length);
    let ku = this[Zo], kc = 1, Ou = 0;
    for (; ++Ou < Fl && (kc *= 256); )
      ku += this[Zo + Ou] * kc;
    return kc *= 128, ku >= kc && (ku -= Math.pow(2, 8 * Fl)), ku;
  }, xe.prototype.readIntBE = function(Zo, Fl, Ru) {
    Zo = Zo >>> 0, Fl = Fl >>> 0, Ru || _u(Zo, Fl, this.length);
    let ku = Fl, kc = 1, Ou = this[Zo + --ku];
    for (; ku > 0 && (kc *= 256); )
      Ou += this[Zo + --ku] * kc;
    return kc *= 128, Ou >= kc && (Ou -= Math.pow(2, 8 * Fl)), Ou;
  }, xe.prototype.readInt8 = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 1, this.length), this[Zo] & 128 ? (255 - this[Zo] + 1) * -1 : this[Zo];
  }, xe.prototype.readInt16LE = function(Zo, Fl) {
    Zo = Zo >>> 0, Fl || _u(Zo, 2, this.length);
    const Ru = this[Zo] | this[Zo + 1] << 8;
    return Ru & 32768 ? Ru | 4294901760 : Ru;
  }, xe.prototype.readInt16BE = function(Zo, Fl) {
    Zo = Zo >>> 0, Fl || _u(Zo, 2, this.length);
    const Ru = this[Zo + 1] | this[Zo] << 8;
    return Ru & 32768 ? Ru | 4294901760 : Ru;
  }, xe.prototype.readInt32LE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), this[Zo] | this[Zo + 1] << 8 | this[Zo + 2] << 16 | this[Zo + 3] << 24;
  }, xe.prototype.readInt32BE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), this[Zo] << 24 | this[Zo + 1] << 16 | this[Zo + 2] << 8 | this[Zo + 3];
  }, xe.prototype.readBigInt64LE = K1(function(Zo) {
    Zo = Zo >>> 0, Lu(Zo, "offset");
    const Fl = this[Zo], Ru = this[Zo + 7];
    (Fl === void 0 || Ru === void 0) && th(Zo, this.length - 8);
    const ku = this[Zo + 4] + this[Zo + 5] * 2 ** 8 + this[Zo + 6] * 2 ** 16 + (Ru << 24);
    return (BigInt(ku) << BigInt(32)) + BigInt(Fl + this[++Zo] * 2 ** 8 + this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 24);
  }), xe.prototype.readBigInt64BE = K1(function(Zo) {
    Zo = Zo >>> 0, Lu(Zo, "offset");
    const Fl = this[Zo], Ru = this[Zo + 7];
    (Fl === void 0 || Ru === void 0) && th(Zo, this.length - 8);
    const ku = (Fl << 24) + // Overflow
    this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 8 + this[++Zo];
    return (BigInt(ku) << BigInt(32)) + BigInt(this[++Zo] * 2 ** 24 + this[++Zo] * 2 ** 16 + this[++Zo] * 2 ** 8 + Ru);
  }), xe.prototype.readFloatLE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), z.read(this, Zo, !0, 23, 4);
  }, xe.prototype.readFloatBE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 4, this.length), z.read(this, Zo, !1, 23, 4);
  }, xe.prototype.readDoubleLE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 8, this.length), z.read(this, Zo, !0, 52, 8);
  }, xe.prototype.readDoubleBE = function(Zo, Fl) {
    return Zo = Zo >>> 0, Fl || _u(Zo, 8, this.length), z.read(this, Zo, !1, 52, 8);
  };
  function Oa(Eu, Zo, Fl, Ru, ku, kc) {
    if (!xe.isBuffer(Eu))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Zo > ku || Zo < kc)
      throw new RangeError('"value" argument is out of bounds');
    if (Fl + Ru > Eu.length)
      throw new RangeError("Index out of range");
  }
  xe.prototype.writeUintLE = xe.prototype.writeUIntLE = function(Zo, Fl, Ru, ku) {
    if (Zo = +Zo, Fl = Fl >>> 0, Ru = Ru >>> 0, !ku) {
      const U1 = Math.pow(2, 8 * Ru) - 1;
      Oa(this, Zo, Fl, Ru, U1, 0);
    }
    let kc = 1, Ou = 0;
    for (this[Fl] = Zo & 255; ++Ou < Ru && (kc *= 256); )
      this[Fl + Ou] = Zo / kc & 255;
    return Fl + Ru;
  }, xe.prototype.writeUintBE = xe.prototype.writeUIntBE = function(Zo, Fl, Ru, ku) {
    if (Zo = +Zo, Fl = Fl >>> 0, Ru = Ru >>> 0, !ku) {
      const U1 = Math.pow(2, 8 * Ru) - 1;
      Oa(this, Zo, Fl, Ru, U1, 0);
    }
    let kc = Ru - 1, Ou = 1;
    for (this[Fl + kc] = Zo & 255; --kc >= 0 && (Ou *= 256); )
      this[Fl + kc] = Zo / Ou & 255;
    return Fl + Ru;
  }, xe.prototype.writeUint8 = xe.prototype.writeUInt8 = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 1, 255, 0), this[Fl] = Zo & 255, Fl + 1;
  }, xe.prototype.writeUint16LE = xe.prototype.writeUInt16LE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 2, 65535, 0), this[Fl] = Zo & 255, this[Fl + 1] = Zo >>> 8, Fl + 2;
  }, xe.prototype.writeUint16BE = xe.prototype.writeUInt16BE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 2, 65535, 0), this[Fl] = Zo >>> 8, this[Fl + 1] = Zo & 255, Fl + 2;
  }, xe.prototype.writeUint32LE = xe.prototype.writeUInt32LE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 4, 4294967295, 0), this[Fl + 3] = Zo >>> 24, this[Fl + 2] = Zo >>> 16, this[Fl + 1] = Zo >>> 8, this[Fl] = Zo & 255, Fl + 4;
  }, xe.prototype.writeUint32BE = xe.prototype.writeUInt32BE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 4, 4294967295, 0), this[Fl] = Zo >>> 24, this[Fl + 1] = Zo >>> 16, this[Fl + 2] = Zo >>> 8, this[Fl + 3] = Zo & 255, Fl + 4;
  };
  function Os(Eu, Zo, Fl, Ru, ku) {
    Pu(Zo, Ru, ku, Eu, Fl, 7);
    let kc = Number(Zo & BigInt(4294967295));
    Eu[Fl++] = kc, kc = kc >> 8, Eu[Fl++] = kc, kc = kc >> 8, Eu[Fl++] = kc, kc = kc >> 8, Eu[Fl++] = kc;
    let Ou = Number(Zo >> BigInt(32) & BigInt(4294967295));
    return Eu[Fl++] = Ou, Ou = Ou >> 8, Eu[Fl++] = Ou, Ou = Ou >> 8, Eu[Fl++] = Ou, Ou = Ou >> 8, Eu[Fl++] = Ou, Fl;
  }
  function Pa(Eu, Zo, Fl, Ru, ku) {
    Pu(Zo, Ru, ku, Eu, Fl, 7);
    let kc = Number(Zo & BigInt(4294967295));
    Eu[Fl + 7] = kc, kc = kc >> 8, Eu[Fl + 6] = kc, kc = kc >> 8, Eu[Fl + 5] = kc, kc = kc >> 8, Eu[Fl + 4] = kc;
    let Ou = Number(Zo >> BigInt(32) & BigInt(4294967295));
    return Eu[Fl + 3] = Ou, Ou = Ou >> 8, Eu[Fl + 2] = Ou, Ou = Ou >> 8, Eu[Fl + 1] = Ou, Ou = Ou >> 8, Eu[Fl] = Ou, Fl + 8;
  }
  xe.prototype.writeBigUInt64LE = K1(function(Zo, Fl = 0) {
    return Os(this, Zo, Fl, BigInt(0), BigInt("0xffffffffffffffff"));
  }), xe.prototype.writeBigUInt64BE = K1(function(Zo, Fl = 0) {
    return Pa(this, Zo, Fl, BigInt(0), BigInt("0xffffffffffffffff"));
  }), xe.prototype.writeIntLE = function(Zo, Fl, Ru, ku) {
    if (Zo = +Zo, Fl = Fl >>> 0, !ku) {
      const g2 = Math.pow(2, 8 * Ru - 1);
      Oa(this, Zo, Fl, Ru, g2 - 1, -g2);
    }
    let kc = 0, Ou = 1, U1 = 0;
    for (this[Fl] = Zo & 255; ++kc < Ru && (Ou *= 256); )
      Zo < 0 && U1 === 0 && this[Fl + kc - 1] !== 0 && (U1 = 1), this[Fl + kc] = (Zo / Ou >> 0) - U1 & 255;
    return Fl + Ru;
  }, xe.prototype.writeIntBE = function(Zo, Fl, Ru, ku) {
    if (Zo = +Zo, Fl = Fl >>> 0, !ku) {
      const g2 = Math.pow(2, 8 * Ru - 1);
      Oa(this, Zo, Fl, Ru, g2 - 1, -g2);
    }
    let kc = Ru - 1, Ou = 1, U1 = 0;
    for (this[Fl + kc] = Zo & 255; --kc >= 0 && (Ou *= 256); )
      Zo < 0 && U1 === 0 && this[Fl + kc + 1] !== 0 && (U1 = 1), this[Fl + kc] = (Zo / Ou >> 0) - U1 & 255;
    return Fl + Ru;
  }, xe.prototype.writeInt8 = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 1, 127, -128), Zo < 0 && (Zo = 255 + Zo + 1), this[Fl] = Zo & 255, Fl + 1;
  }, xe.prototype.writeInt16LE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 2, 32767, -32768), this[Fl] = Zo & 255, this[Fl + 1] = Zo >>> 8, Fl + 2;
  }, xe.prototype.writeInt16BE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 2, 32767, -32768), this[Fl] = Zo >>> 8, this[Fl + 1] = Zo & 255, Fl + 2;
  }, xe.prototype.writeInt32LE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 4, 2147483647, -2147483648), this[Fl] = Zo & 255, this[Fl + 1] = Zo >>> 8, this[Fl + 2] = Zo >>> 16, this[Fl + 3] = Zo >>> 24, Fl + 4;
  }, xe.prototype.writeInt32BE = function(Zo, Fl, Ru) {
    return Zo = +Zo, Fl = Fl >>> 0, Ru || Oa(this, Zo, Fl, 4, 2147483647, -2147483648), Zo < 0 && (Zo = 4294967295 + Zo + 1), this[Fl] = Zo >>> 24, this[Fl + 1] = Zo >>> 16, this[Fl + 2] = Zo >>> 8, this[Fl + 3] = Zo & 255, Fl + 4;
  }, xe.prototype.writeBigInt64LE = K1(function(Zo, Fl = 0) {
    return Os(this, Zo, Fl, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), xe.prototype.writeBigInt64BE = K1(function(Zo, Fl = 0) {
    return Pa(this, Zo, Fl, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Ml(Eu, Zo, Fl, Ru, ku, kc) {
    if (Fl + Ru > Eu.length)
      throw new RangeError("Index out of range");
    if (Fl < 0)
      throw new RangeError("Index out of range");
  }
  function Su(Eu, Zo, Fl, Ru, ku) {
    return Zo = +Zo, Fl = Fl >>> 0, ku || Ml(Eu, Zo, Fl, 4), z.write(Eu, Zo, Fl, Ru, 23, 4), Fl + 4;
  }
  xe.prototype.writeFloatLE = function(Zo, Fl, Ru) {
    return Su(this, Zo, Fl, !0, Ru);
  }, xe.prototype.writeFloatBE = function(Zo, Fl, Ru) {
    return Su(this, Zo, Fl, !1, Ru);
  };
  function Tu(Eu, Zo, Fl, Ru, ku) {
    return Zo = +Zo, Fl = Fl >>> 0, ku || Ml(Eu, Zo, Fl, 8), z.write(Eu, Zo, Fl, Ru, 52, 8), Fl + 8;
  }
  xe.prototype.writeDoubleLE = function(Zo, Fl, Ru) {
    return Tu(this, Zo, Fl, !0, Ru);
  }, xe.prototype.writeDoubleBE = function(Zo, Fl, Ru) {
    return Tu(this, Zo, Fl, !1, Ru);
  }, xe.prototype.copy = function(Zo, Fl, Ru, ku) {
    if (!xe.isBuffer(Zo))
      throw new TypeError("argument should be a Buffer");
    if (Ru || (Ru = 0), !ku && ku !== 0 && (ku = this.length), Fl >= Zo.length && (Fl = Zo.length), Fl || (Fl = 0), ku > 0 && ku < Ru && (ku = Ru), ku === Ru || Zo.length === 0 || this.length === 0)
      return 0;
    if (Fl < 0)
      throw new RangeError("targetStart out of bounds");
    if (Ru < 0 || Ru >= this.length)
      throw new RangeError("Index out of range");
    if (ku < 0)
      throw new RangeError("sourceEnd out of bounds");
    ku > this.length && (ku = this.length), Zo.length - Fl < ku - Ru && (ku = Zo.length - Fl + Ru);
    const kc = ku - Ru;
    return this === Zo && typeof le.prototype.copyWithin == "function" ? this.copyWithin(Fl, Ru, ku) : le.prototype.set.call(
      Zo,
      this.subarray(Ru, ku),
      Fl
    ), kc;
  }, xe.prototype.fill = function(Zo, Fl, Ru, ku) {
    if (typeof Zo == "string") {
      if (typeof Fl == "string" ? (ku = Fl, Fl = 0, Ru = this.length) : typeof Ru == "string" && (ku = Ru, Ru = this.length), ku !== void 0 && typeof ku != "string")
        throw new TypeError("encoding must be a string");
      if (typeof ku == "string" && !xe.isEncoding(ku))
        throw new TypeError("Unknown encoding: " + ku);
      if (Zo.length === 1) {
        const Ou = Zo.charCodeAt(0);
        (ku === "utf8" && Ou < 128 || ku === "latin1") && (Zo = Ou);
      }
    } else
      typeof Zo == "number" ? Zo = Zo & 255 : typeof Zo == "boolean" && (Zo = Number(Zo));
    if (Fl < 0 || this.length < Fl || this.length < Ru)
      throw new RangeError("Out of range index");
    if (Ru <= Fl)
      return this;
    Fl = Fl >>> 0, Ru = Ru === void 0 ? this.length : Ru >>> 0, Zo || (Zo = 0);
    let kc;
    if (typeof Zo == "number")
      for (kc = Fl; kc < Ru; ++kc)
        this[kc] = Zo;
    else {
      const Ou = xe.isBuffer(Zo) ? Zo : xe.from(Zo, ku), U1 = Ou.length;
      if (U1 === 0)
        throw new TypeError('The value "' + Zo + '" is invalid for argument "value"');
      for (kc = 0; kc < Ru - Fl; ++kc)
        this[kc + Fl] = Ou[kc % U1];
    }
    return this;
  };
  const Au = {};
  function Zl(Eu, Zo, Fl) {
    Au[Eu] = class extends Fl {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Zo.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Eu}]`, this.stack, delete this.name;
      }
      get code() {
        return Eu;
      }
      set code(ku) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: ku,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Eu}]: ${this.message}`;
      }
    };
  }
  Zl(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Eu) {
      return Eu ? `${Eu} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Zl(
    "ERR_INVALID_ARG_TYPE",
    function(Eu, Zo) {
      return `The "${Eu}" argument must be of type number. Received type ${typeof Zo}`;
    },
    TypeError
  ), Zl(
    "ERR_OUT_OF_RANGE",
    function(Eu, Zo, Fl) {
      let Ru = `The value of "${Eu}" is out of range.`, ku = Fl;
      return Number.isInteger(Fl) && Math.abs(Fl) > 2 ** 32 ? ku = Iu(String(Fl)) : typeof Fl == "bigint" && (ku = String(Fl), (Fl > BigInt(2) ** BigInt(32) || Fl < -(BigInt(2) ** BigInt(32))) && (ku = Iu(ku)), ku += "n"), Ru += ` It must be ${Zo}. Received ${ku}`, Ru;
    },
    RangeError
  );
  function Iu(Eu) {
    let Zo = "", Fl = Eu.length;
    const Ru = Eu[0] === "-" ? 1 : 0;
    for (; Fl >= Ru + 4; Fl -= 3)
      Zo = `_${Eu.slice(Fl - 3, Fl)}${Zo}`;
    return `${Eu.slice(0, Fl)}${Zo}`;
  }
  function Uc(Eu, Zo, Fl) {
    Lu(Zo, "offset"), (Eu[Zo] === void 0 || Eu[Zo + Fl] === void 0) && th(Zo, Eu.length - (Fl + 1));
  }
  function Pu(Eu, Zo, Fl, Ru, ku, kc) {
    if (Eu > Fl || Eu < Zo) {
      const Ou = typeof Zo == "bigint" ? "n" : "";
      let U1;
      throw kc > 3 ? Zo === 0 || Zo === BigInt(0) ? U1 = `>= 0${Ou} and < 2${Ou} ** ${(kc + 1) * 8}${Ou}` : U1 = `>= -(2${Ou} ** ${(kc + 1) * 8 - 1}${Ou}) and < 2 ** ${(kc + 1) * 8 - 1}${Ou}` : U1 = `>= ${Zo}${Ou} and <= ${Fl}${Ou}`, new Au.ERR_OUT_OF_RANGE("value", U1, Eu);
    }
    Uc(Ru, ku, kc);
  }
  function Lu(Eu, Zo) {
    if (typeof Eu != "number")
      throw new Au.ERR_INVALID_ARG_TYPE(Zo, "number", Eu);
  }
  function th(Eu, Zo, Fl) {
    throw Math.floor(Eu) !== Eu ? (Lu(Eu, Fl), new Au.ERR_OUT_OF_RANGE(Fl || "offset", "an integer", Eu)) : Zo < 0 ? new Au.ERR_BUFFER_OUT_OF_BOUNDS() : new Au.ERR_OUT_OF_RANGE(
      Fl || "offset",
      `>= ${Fl ? 1 : 0} and <= ${Zo}`,
      Eu
    );
  }
  const Zc = /[^+/0-9A-Za-z-_]/g;
  function N1(Eu) {
    if (Eu = Eu.split("=")[0], Eu = Eu.trim().replace(Zc, ""), Eu.length < 2)
      return "";
    for (; Eu.length % 4 !== 0; )
      Eu = Eu + "=";
    return Eu;
  }
  function Gh(Eu, Zo) {
    Zo = Zo || 1 / 0;
    let Fl;
    const Ru = Eu.length;
    let ku = null;
    const kc = [];
    for (let Ou = 0; Ou < Ru; ++Ou) {
      if (Fl = Eu.charCodeAt(Ou), Fl > 55295 && Fl < 57344) {
        if (!ku) {
          if (Fl > 56319) {
            (Zo -= 3) > -1 && kc.push(239, 191, 189);
            continue;
          } else if (Ou + 1 === Ru) {
            (Zo -= 3) > -1 && kc.push(239, 191, 189);
            continue;
          }
          ku = Fl;
          continue;
        }
        if (Fl < 56320) {
          (Zo -= 3) > -1 && kc.push(239, 191, 189), ku = Fl;
          continue;
        }
        Fl = (ku - 55296 << 10 | Fl - 56320) + 65536;
      } else
        ku && (Zo -= 3) > -1 && kc.push(239, 191, 189);
      if (ku = null, Fl < 128) {
        if ((Zo -= 1) < 0)
          break;
        kc.push(Fl);
      } else if (Fl < 2048) {
        if ((Zo -= 2) < 0)
          break;
        kc.push(
          Fl >> 6 | 192,
          Fl & 63 | 128
        );
      } else if (Fl < 65536) {
        if ((Zo -= 3) < 0)
          break;
        kc.push(
          Fl >> 12 | 224,
          Fl >> 6 & 63 | 128,
          Fl & 63 | 128
        );
      } else if (Fl < 1114112) {
        if ((Zo -= 4) < 0)
          break;
        kc.push(
          Fl >> 18 | 240,
          Fl >> 12 & 63 | 128,
          Fl >> 6 & 63 | 128,
          Fl & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return kc;
  }
  function Mc(Eu) {
    const Zo = [];
    for (let Fl = 0; Fl < Eu.length; ++Fl)
      Zo.push(Eu.charCodeAt(Fl) & 255);
    return Zo;
  }
  function h1(Eu, Zo) {
    let Fl, Ru, ku;
    const kc = [];
    for (let Ou = 0; Ou < Eu.length && !((Zo -= 2) < 0); ++Ou)
      Fl = Eu.charCodeAt(Ou), Ru = Fl >> 8, ku = Fl % 256, kc.push(ku), kc.push(Ru);
    return kc;
  }
  function l2(Eu) {
    return y.toByteArray(N1(Eu));
  }
  function Gc(Eu, Zo, Fl, Ru) {
    let ku;
    for (ku = 0; ku < Ru && !(ku + Fl >= Zo.length || ku >= Eu.length); ++ku)
      Zo[ku + Fl] = Eu[ku];
    return ku;
  }
  function Kc(Eu, Zo) {
    return Eu instanceof Zo || Eu != null && Eu.constructor != null && Eu.constructor.name != null && Eu.constructor.name === Zo.name;
  }
  function M2(Eu) {
    return Eu !== Eu;
  }
  const d1 = function() {
    const Eu = "0123456789abcdef", Zo = new Array(256);
    for (let Fl = 0; Fl < 16; ++Fl) {
      const Ru = Fl * 16;
      for (let ku = 0; ku < 16; ++ku)
        Zo[Ru + ku] = Eu[Fl] + Eu[ku];
    }
    return Zo;
  }();
  function K1(Eu) {
    return typeof BigInt > "u" ? k2 : Eu;
  }
  function k2() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const Buffer = buffer$1.Buffer, Blob$1 = buffer$1.Blob, BlobOptions = buffer$1.BlobOptions, Buffer$1 = buffer$1.Buffer, File = buffer$1.File, FileOptions = buffer$1.FileOptions, INSPECT_MAX_BYTES = buffer$1.INSPECT_MAX_BYTES, SlowBuffer = buffer$1.SlowBuffer, TranscodeEncoding = buffer$1.TranscodeEncoding, atob$1 = buffer$1.atob, btoa$1 = buffer$1.btoa, constants$2 = buffer$1.constants, isAscii = buffer$1.isAscii, isUtf8 = buffer$1.isUtf8, kMaxLength = buffer$1.kMaxLength, kStringMaxLength = buffer$1.kStringMaxLength, resolveObjectURL = buffer$1.resolveObjectURL, transcode = buffer$1.transcode, dist = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: Blob$1,
  BlobOptions,
  Buffer: Buffer$1,
  File,
  FileOptions,
  INSPECT_MAX_BYTES,
  SlowBuffer,
  TranscodeEncoding,
  atob: atob$1,
  btoa: btoa$1,
  constants: constants$2,
  default: Buffer,
  isAscii,
  isUtf8,
  kMaxLength,
  kStringMaxLength,
  resolveObjectURL,
  transcode
}, Symbol.toStringTag, { value: "Module" }));
var tx$3 = {}, coin$1 = {}, indexMinimal = {}, minimal$1 = {}, aspromise = asPromise;
function asPromise(v, y) {
  for (var z = new Array(arguments.length - 1), ne = 0, ue = 2, le = !0; ue < arguments.length; )
    z[ne++] = arguments[ue++];
  return new Promise(function(ge, we) {
    z[ne] = function(xe) {
      if (le)
        if (le = !1, xe)
          we(xe);
        else {
          for (var $e = new Array(arguments.length - 1), Ne = 0; Ne < $e.length; )
            $e[Ne++] = arguments[Ne];
          ge.apply(null, $e);
        }
    };
    try {
      v.apply(y || null, z);
    } catch (Ee) {
      le && (le = !1, we(Ee));
    }
  });
}
var base64$6 = {};
(function(v) {
  var y = v;
  y.length = function(ge) {
    var we = ge.length;
    if (!we)
      return 0;
    for (var Ee = 0; --we % 4 > 1 && ge.charAt(we) === "="; )
      ++Ee;
    return Math.ceil(ge.length * 3) / 4 - Ee;
  };
  for (var z = new Array(64), ne = new Array(123), ue = 0; ue < 64; )
    ne[z[ue] = ue < 26 ? ue + 65 : ue < 52 ? ue + 71 : ue < 62 ? ue - 4 : ue - 59 | 43] = ue++;
  y.encode = function(ge, we, Ee) {
    for (var xe = null, $e = [], Ne = 0, st = 0, Nr; we < Ee; ) {
      var br = ge[we++];
      switch (st) {
        case 0:
          $e[Ne++] = z[br >> 2], Nr = (br & 3) << 4, st = 1;
          break;
        case 1:
          $e[Ne++] = z[Nr | br >> 4], Nr = (br & 15) << 2, st = 2;
          break;
        case 2:
          $e[Ne++] = z[Nr | br >> 6], $e[Ne++] = z[br & 63], st = 0;
          break;
      }
      Ne > 8191 && ((xe || (xe = [])).push(String.fromCharCode.apply(String, $e)), Ne = 0);
    }
    return st && ($e[Ne++] = z[Nr], $e[Ne++] = 61, st === 1 && ($e[Ne++] = 61)), xe ? (Ne && xe.push(String.fromCharCode.apply(String, $e.slice(0, Ne))), xe.join("")) : String.fromCharCode.apply(String, $e.slice(0, Ne));
  };
  var le = "invalid encoding";
  y.decode = function(ge, we, Ee) {
    for (var xe = Ee, $e = 0, Ne, st = 0; st < ge.length; ) {
      var Nr = ge.charCodeAt(st++);
      if (Nr === 61 && $e > 1)
        break;
      if ((Nr = ne[Nr]) === void 0)
        throw Error(le);
      switch ($e) {
        case 0:
          Ne = Nr, $e = 1;
          break;
        case 1:
          we[Ee++] = Ne << 2 | (Nr & 48) >> 4, Ne = Nr, $e = 2;
          break;
        case 2:
          we[Ee++] = (Ne & 15) << 4 | (Nr & 60) >> 2, Ne = Nr, $e = 3;
          break;
        case 3:
          we[Ee++] = (Ne & 3) << 6 | Nr, $e = 0;
          break;
      }
    }
    if ($e === 1)
      throw Error(le);
    return Ee - xe;
  }, y.test = function(ge) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(ge);
  };
})(base64$6);
var eventemitter = EventEmitter$3;
function EventEmitter$3() {
  this._listeners = {};
}
EventEmitter$3.prototype.on = function(y, z, ne) {
  return (this._listeners[y] || (this._listeners[y] = [])).push({
    fn: z,
    ctx: ne || this
  }), this;
};
EventEmitter$3.prototype.off = function(y, z) {
  if (y === void 0)
    this._listeners = {};
  else if (z === void 0)
    this._listeners[y] = [];
  else
    for (var ne = this._listeners[y], ue = 0; ue < ne.length; )
      ne[ue].fn === z ? ne.splice(ue, 1) : ++ue;
  return this;
};
EventEmitter$3.prototype.emit = function(y) {
  var z = this._listeners[y];
  if (z) {
    for (var ne = [], ue = 1; ue < arguments.length; )
      ne.push(arguments[ue++]);
    for (ue = 0; ue < z.length; )
      z[ue].fn.apply(z[ue++].ctx, ne);
  }
  return this;
};
var float = factory(factory);
function factory(v) {
  return typeof Float32Array < "u" ? function() {
    var y = new Float32Array([-0]), z = new Uint8Array(y.buffer), ne = z[3] === 128;
    function ue(we, Ee, xe) {
      y[0] = we, Ee[xe] = z[0], Ee[xe + 1] = z[1], Ee[xe + 2] = z[2], Ee[xe + 3] = z[3];
    }
    function le(we, Ee, xe) {
      y[0] = we, Ee[xe] = z[3], Ee[xe + 1] = z[2], Ee[xe + 2] = z[1], Ee[xe + 3] = z[0];
    }
    v.writeFloatLE = ne ? ue : le, v.writeFloatBE = ne ? le : ue;
    function he(we, Ee) {
      return z[0] = we[Ee], z[1] = we[Ee + 1], z[2] = we[Ee + 2], z[3] = we[Ee + 3], y[0];
    }
    function ge(we, Ee) {
      return z[3] = we[Ee], z[2] = we[Ee + 1], z[1] = we[Ee + 2], z[0] = we[Ee + 3], y[0];
    }
    v.readFloatLE = ne ? he : ge, v.readFloatBE = ne ? ge : he;
  }() : function() {
    function y(ne, ue, le, he) {
      var ge = ue < 0 ? 1 : 0;
      if (ge && (ue = -ue), ue === 0)
        ne(1 / ue > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), le, he);
      else if (isNaN(ue))
        ne(2143289344, le, he);
      else if (ue > 34028234663852886e22)
        ne((ge << 31 | 2139095040) >>> 0, le, he);
      else if (ue < 11754943508222875e-54)
        ne((ge << 31 | Math.round(ue / 1401298464324817e-60)) >>> 0, le, he);
      else {
        var we = Math.floor(Math.log(ue) / Math.LN2), Ee = Math.round(ue * Math.pow(2, -we) * 8388608) & 8388607;
        ne((ge << 31 | we + 127 << 23 | Ee) >>> 0, le, he);
      }
    }
    v.writeFloatLE = y.bind(null, writeUintLE$1), v.writeFloatBE = y.bind(null, writeUintBE$1);
    function z(ne, ue, le) {
      var he = ne(ue, le), ge = (he >> 31) * 2 + 1, we = he >>> 23 & 255, Ee = he & 8388607;
      return we === 255 ? Ee ? NaN : ge * (1 / 0) : we === 0 ? ge * 1401298464324817e-60 * Ee : ge * Math.pow(2, we - 150) * (Ee + 8388608);
    }
    v.readFloatLE = z.bind(null, readUintLE$1), v.readFloatBE = z.bind(null, readUintBE$1);
  }(), typeof Float64Array < "u" ? function() {
    var y = new Float64Array([-0]), z = new Uint8Array(y.buffer), ne = z[7] === 128;
    function ue(we, Ee, xe) {
      y[0] = we, Ee[xe] = z[0], Ee[xe + 1] = z[1], Ee[xe + 2] = z[2], Ee[xe + 3] = z[3], Ee[xe + 4] = z[4], Ee[xe + 5] = z[5], Ee[xe + 6] = z[6], Ee[xe + 7] = z[7];
    }
    function le(we, Ee, xe) {
      y[0] = we, Ee[xe] = z[7], Ee[xe + 1] = z[6], Ee[xe + 2] = z[5], Ee[xe + 3] = z[4], Ee[xe + 4] = z[3], Ee[xe + 5] = z[2], Ee[xe + 6] = z[1], Ee[xe + 7] = z[0];
    }
    v.writeDoubleLE = ne ? ue : le, v.writeDoubleBE = ne ? le : ue;
    function he(we, Ee) {
      return z[0] = we[Ee], z[1] = we[Ee + 1], z[2] = we[Ee + 2], z[3] = we[Ee + 3], z[4] = we[Ee + 4], z[5] = we[Ee + 5], z[6] = we[Ee + 6], z[7] = we[Ee + 7], y[0];
    }
    function ge(we, Ee) {
      return z[7] = we[Ee], z[6] = we[Ee + 1], z[5] = we[Ee + 2], z[4] = we[Ee + 3], z[3] = we[Ee + 4], z[2] = we[Ee + 5], z[1] = we[Ee + 6], z[0] = we[Ee + 7], y[0];
    }
    v.readDoubleLE = ne ? he : ge, v.readDoubleBE = ne ? ge : he;
  }() : function() {
    function y(ne, ue, le, he, ge, we) {
      var Ee = he < 0 ? 1 : 0;
      if (Ee && (he = -he), he === 0)
        ne(0, ge, we + ue), ne(1 / he > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), ge, we + le);
      else if (isNaN(he))
        ne(0, ge, we + ue), ne(2146959360, ge, we + le);
      else if (he > 17976931348623157e292)
        ne(0, ge, we + ue), ne((Ee << 31 | 2146435072) >>> 0, ge, we + le);
      else {
        var xe;
        if (he < 22250738585072014e-324)
          xe = he / 5e-324, ne(xe >>> 0, ge, we + ue), ne((Ee << 31 | xe / 4294967296) >>> 0, ge, we + le);
        else {
          var $e = Math.floor(Math.log(he) / Math.LN2);
          $e === 1024 && ($e = 1023), xe = he * Math.pow(2, -$e), ne(xe * 4503599627370496 >>> 0, ge, we + ue), ne((Ee << 31 | $e + 1023 << 20 | xe * 1048576 & 1048575) >>> 0, ge, we + le);
        }
      }
    }
    v.writeDoubleLE = y.bind(null, writeUintLE$1, 0, 4), v.writeDoubleBE = y.bind(null, writeUintBE$1, 4, 0);
    function z(ne, ue, le, he, ge) {
      var we = ne(he, ge + ue), Ee = ne(he, ge + le), xe = (Ee >> 31) * 2 + 1, $e = Ee >>> 20 & 2047, Ne = 4294967296 * (Ee & 1048575) + we;
      return $e === 2047 ? Ne ? NaN : xe * (1 / 0) : $e === 0 ? xe * 5e-324 * Ne : xe * Math.pow(2, $e - 1075) * (Ne + 4503599627370496);
    }
    v.readDoubleLE = z.bind(null, readUintLE$1, 0, 4), v.readDoubleBE = z.bind(null, readUintBE$1, 4, 0);
  }(), v;
}
function writeUintLE$1(v, y, z) {
  y[z] = v & 255, y[z + 1] = v >>> 8 & 255, y[z + 2] = v >>> 16 & 255, y[z + 3] = v >>> 24;
}
function writeUintBE$1(v, y, z) {
  y[z] = v >>> 24, y[z + 1] = v >>> 16 & 255, y[z + 2] = v >>> 8 & 255, y[z + 3] = v & 255;
}
function readUintLE$1(v, y) {
  return (v[y] | v[y + 1] << 8 | v[y + 2] << 16 | v[y + 3] << 24) >>> 0;
}
function readUintBE$1(v, y) {
  return (v[y] << 24 | v[y + 1] << 16 | v[y + 2] << 8 | v[y + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (v) {
  }
  return null;
}
var utf8$5 = {};
(function(v) {
  var y = v;
  y.length = function(ne) {
    for (var ue = 0, le = 0, he = 0; he < ne.length; ++he)
      le = ne.charCodeAt(he), le < 128 ? ue += 1 : le < 2048 ? ue += 2 : (le & 64512) === 55296 && (ne.charCodeAt(he + 1) & 64512) === 56320 ? (++he, ue += 4) : ue += 3;
    return ue;
  }, y.read = function(ne, ue, le) {
    var he = le - ue;
    if (he < 1)
      return "";
    for (var ge = null, we = [], Ee = 0, xe; ue < le; )
      xe = ne[ue++], xe < 128 ? we[Ee++] = xe : xe > 191 && xe < 224 ? we[Ee++] = (xe & 31) << 6 | ne[ue++] & 63 : xe > 239 && xe < 365 ? (xe = ((xe & 7) << 18 | (ne[ue++] & 63) << 12 | (ne[ue++] & 63) << 6 | ne[ue++] & 63) - 65536, we[Ee++] = 55296 + (xe >> 10), we[Ee++] = 56320 + (xe & 1023)) : we[Ee++] = (xe & 15) << 12 | (ne[ue++] & 63) << 6 | ne[ue++] & 63, Ee > 8191 && ((ge || (ge = [])).push(String.fromCharCode.apply(String, we)), Ee = 0);
    return ge ? (Ee && ge.push(String.fromCharCode.apply(String, we.slice(0, Ee))), ge.join("")) : String.fromCharCode.apply(String, we.slice(0, Ee));
  }, y.write = function(ne, ue, le) {
    for (var he = le, ge, we, Ee = 0; Ee < ne.length; ++Ee)
      ge = ne.charCodeAt(Ee), ge < 128 ? ue[le++] = ge : ge < 2048 ? (ue[le++] = ge >> 6 | 192, ue[le++] = ge & 63 | 128) : (ge & 64512) === 55296 && ((we = ne.charCodeAt(Ee + 1)) & 64512) === 56320 ? (ge = 65536 + ((ge & 1023) << 10) + (we & 1023), ++Ee, ue[le++] = ge >> 18 | 240, ue[le++] = ge >> 12 & 63 | 128, ue[le++] = ge >> 6 & 63 | 128, ue[le++] = ge & 63 | 128) : (ue[le++] = ge >> 12 | 224, ue[le++] = ge >> 6 & 63 | 128, ue[le++] = ge & 63 | 128);
    return le - he;
  };
})(utf8$5);
var pool_1 = pool;
function pool(v, y, z) {
  var ne = z || 8192, ue = ne >>> 1, le = null, he = ne;
  return function(we) {
    if (we < 1 || we > ue)
      return v(we);
    he + we > ne && (le = v(ne), he = 0);
    var Ee = y.call(le, he, he += we);
    return he & 7 && (he = (he | 7) + 1), Ee;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = y;
  var v = requireMinimal();
  function y(le, he) {
    this.lo = le >>> 0, this.hi = he >>> 0;
  }
  var z = y.zero = new y(0, 0);
  z.toNumber = function() {
    return 0;
  }, z.zzEncode = z.zzDecode = function() {
    return this;
  }, z.length = function() {
    return 1;
  };
  var ne = y.zeroHash = "\0\0\0\0\0\0\0\0";
  y.fromNumber = function(he) {
    if (he === 0)
      return z;
    var ge = he < 0;
    ge && (he = -he);
    var we = he >>> 0, Ee = (he - we) / 4294967296 >>> 0;
    return ge && (Ee = ~Ee >>> 0, we = ~we >>> 0, ++we > 4294967295 && (we = 0, ++Ee > 4294967295 && (Ee = 0))), new y(we, Ee);
  }, y.from = function(he) {
    if (typeof he == "number")
      return y.fromNumber(he);
    if (v.isString(he))
      if (v.Long)
        he = v.Long.fromString(he);
      else
        return y.fromNumber(parseInt(he, 10));
    return he.low || he.high ? new y(he.low >>> 0, he.high >>> 0) : z;
  }, y.prototype.toNumber = function(he) {
    if (!he && this.hi >>> 31) {
      var ge = ~this.lo + 1 >>> 0, we = ~this.hi >>> 0;
      return ge || (we = we + 1 >>> 0), -(ge + we * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, y.prototype.toLong = function(he) {
    return v.Long ? new v.Long(this.lo | 0, this.hi | 0, !!he) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!he };
  };
  var ue = String.prototype.charCodeAt;
  return y.fromHash = function(he) {
    return he === ne ? z : new y(
      (ue.call(he, 0) | ue.call(he, 1) << 8 | ue.call(he, 2) << 16 | ue.call(he, 3) << 24) >>> 0,
      (ue.call(he, 4) | ue.call(he, 5) << 8 | ue.call(he, 6) << 16 | ue.call(he, 7) << 24) >>> 0
    );
  }, y.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, y.prototype.zzEncode = function() {
    var he = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ he) >>> 0, this.lo = (this.lo << 1 ^ he) >>> 0, this;
  }, y.prototype.zzDecode = function() {
    var he = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ he) >>> 0, this.hi = (this.hi >>> 1 ^ he) >>> 0, this;
  }, y.prototype.length = function() {
    var he = this.lo, ge = (this.lo >>> 28 | this.hi << 4) >>> 0, we = this.hi >>> 24;
    return we === 0 ? ge === 0 ? he < 16384 ? he < 128 ? 1 : 2 : he < 2097152 ? 3 : 4 : ge < 16384 ? ge < 128 ? 5 : 6 : ge < 2097152 ? 7 : 8 : we < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(v) {
    var y = v;
    y.asPromise = aspromise, y.base64 = base64$6, y.EventEmitter = eventemitter, y.float = float, y.inquire = inquire_1, y.utf8 = utf8$5, y.pool = pool_1, y.LongBits = requireLongbits(), y.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), y.global = y.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, y.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), y.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), y.isInteger = Number.isInteger || /* istanbul ignore next */
    function(le) {
      return typeof le == "number" && isFinite(le) && Math.floor(le) === le;
    }, y.isString = function(le) {
      return typeof le == "string" || le instanceof String;
    }, y.isObject = function(le) {
      return le && typeof le == "object";
    }, y.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    y.isSet = function(le, he) {
      var ge = le[he];
      return ge != null && le.hasOwnProperty(he) ? typeof ge != "object" || (Array.isArray(ge) ? ge.length : Object.keys(ge).length) > 0 : !1;
    }, y.Buffer = function() {
      try {
        var ue = y.inquire("buffer").Buffer;
        return ue.prototype.utf8Write ? ue : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), y._Buffer_from = null, y._Buffer_allocUnsafe = null, y.newBuffer = function(le) {
      return typeof le == "number" ? y.Buffer ? y._Buffer_allocUnsafe(le) : new y.Array(le) : y.Buffer ? y._Buffer_from(le) : typeof Uint8Array > "u" ? le : new Uint8Array(le);
    }, y.Array = typeof Uint8Array < "u" ? Uint8Array : Array, y.Long = /* istanbul ignore next */
    y.global.dcodeIO && /* istanbul ignore next */
    y.global.dcodeIO.Long || /* istanbul ignore next */
    y.global.Long || y.inquire("long"), y.key2Re = /^true|false|0|1$/, y.key32Re = /^-?(?:0|[1-9][0-9]*)$/, y.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, y.longToHash = function(le) {
      return le ? y.LongBits.from(le).toHash() : y.LongBits.zeroHash;
    }, y.longFromHash = function(le, he) {
      var ge = y.LongBits.fromHash(le);
      return y.Long ? y.Long.fromBits(ge.lo, ge.hi, he) : ge.toNumber(!!he);
    };
    function z(ue, le, he) {
      for (var ge = Object.keys(le), we = 0; we < ge.length; ++we)
        (ue[ge[we]] === void 0 || !he) && (ue[ge[we]] = le[ge[we]]);
      return ue;
    }
    y.merge = z, y.lcFirst = function(le) {
      return le.charAt(0).toLowerCase() + le.substring(1);
    };
    function ne(ue) {
      function le(he, ge) {
        if (!(this instanceof le))
          return new le(he, ge);
        Object.defineProperty(this, "message", { get: function() {
          return he;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, le) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), ge && z(this, ge);
      }
      return (le.prototype = Object.create(Error.prototype)).constructor = le, Object.defineProperty(le.prototype, "name", { get: function() {
        return ue;
      } }), le.prototype.toString = function() {
        return this.name + ": " + this.message;
      }, le;
    }
    y.newError = ne, y.ProtocolError = ne("ProtocolError"), y.oneOfGetter = function(le) {
      for (var he = {}, ge = 0; ge < le.length; ++ge)
        he[le[ge]] = 1;
      return function() {
        for (var we = Object.keys(this), Ee = we.length - 1; Ee > -1; --Ee)
          if (he[we[Ee]] === 1 && this[we[Ee]] !== void 0 && this[we[Ee]] !== null)
            return we[Ee];
      };
    }, y.oneOfSetter = function(le) {
      return function(he) {
        for (var ge = 0; ge < le.length; ++ge)
          le[ge] !== he && delete this[le[ge]];
      };
    }, y.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, y._configure = function() {
      var ue = y.Buffer;
      if (!ue) {
        y._Buffer_from = y._Buffer_allocUnsafe = null;
        return;
      }
      y._Buffer_from = ue.from !== Uint8Array.from && ue.from || /* istanbul ignore next */
      function(he, ge) {
        return new ue(he, ge);
      }, y._Buffer_allocUnsafe = ue.allocUnsafe || /* istanbul ignore next */
      function(he) {
        return new ue(he);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$5 = requireMinimal(), BufferWriter$1, LongBits$1 = util$5.LongBits, base64$5 = util$5.base64, utf8$4 = util$5.utf8;
function Op(v, y, z) {
  this.fn = v, this.len = y, this.next = void 0, this.val = z;
}
function noop$2() {
}
function State(v) {
  this.head = v.head, this.tail = v.tail, this.len = v.len, this.next = v.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op(noop$2, 0, 0), this.tail = this.head, this.states = null;
}
var create$1 = function v() {
  return util$5.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$1();
Writer$1.alloc = function v(y) {
  return new util$5.Array(y);
};
util$5.Array !== Array && (Writer$1.alloc = util$5.pool(Writer$1.alloc, util$5.Array.prototype.subarray));
Writer$1.prototype._push = function v(y, z, ne) {
  return this.tail = this.tail.next = new Op(y, z, ne), this.len += z, this;
};
function writeByte(v, y, z) {
  y[z] = v & 255;
}
function writeVarint32(v, y, z) {
  for (; v > 127; )
    y[z++] = v & 127 | 128, v >>>= 7;
  y[z] = v;
}
function VarintOp(v, y) {
  this.len = v, this.next = void 0, this.val = y;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$1.prototype.uint32 = function v(y) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (y = y >>> 0) < 128 ? 1 : y < 16384 ? 2 : y < 2097152 ? 3 : y < 268435456 ? 4 : 5,
    y
  )).len, this;
};
Writer$1.prototype.int32 = function v(y) {
  return y < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(y)) : this.uint32(y);
};
Writer$1.prototype.sint32 = function v(y) {
  return this.uint32((y << 1 ^ y >> 31) >>> 0);
};
function writeVarint64(v, y, z) {
  for (; v.hi; )
    y[z++] = v.lo & 127 | 128, v.lo = (v.lo >>> 7 | v.hi << 25) >>> 0, v.hi >>>= 7;
  for (; v.lo > 127; )
    y[z++] = v.lo & 127 | 128, v.lo = v.lo >>> 7;
  y[z++] = v.lo;
}
Writer$1.prototype.uint64 = function v(y) {
  var z = LongBits$1.from(y);
  return this._push(writeVarint64, z.length(), z);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function v(y) {
  var z = LongBits$1.from(y).zzEncode();
  return this._push(writeVarint64, z.length(), z);
};
Writer$1.prototype.bool = function v(y) {
  return this._push(writeByte, 1, y ? 1 : 0);
};
function writeFixed32(v, y, z) {
  y[z] = v & 255, y[z + 1] = v >>> 8 & 255, y[z + 2] = v >>> 16 & 255, y[z + 3] = v >>> 24;
}
Writer$1.prototype.fixed32 = function v(y) {
  return this._push(writeFixed32, 4, y >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function v(y) {
  var z = LongBits$1.from(y);
  return this._push(writeFixed32, 4, z.lo)._push(writeFixed32, 4, z.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function v(y) {
  return this._push(util$5.float.writeFloatLE, 4, y);
};
Writer$1.prototype.double = function v(y) {
  return this._push(util$5.float.writeDoubleLE, 8, y);
};
var writeBytes = util$5.Array.prototype.set ? function v(y, z, ne) {
  z.set(y, ne);
} : function v(y, z, ne) {
  for (var ue = 0; ue < y.length; ++ue)
    z[ne + ue] = y[ue];
};
Writer$1.prototype.bytes = function v(y) {
  var z = y.length >>> 0;
  if (!z)
    return this._push(writeByte, 1, 0);
  if (util$5.isString(y)) {
    var ne = Writer$1.alloc(z = base64$5.length(y));
    base64$5.decode(y, ne, 0), y = ne;
  }
  return this.uint32(z)._push(writeBytes, z, y);
};
Writer$1.prototype.string = function v(y) {
  var z = utf8$4.length(y);
  return z ? this.uint32(z)._push(utf8$4.write, z, y) : this._push(writeByte, 1, 0);
};
Writer$1.prototype.fork = function v() {
  return this.states = new State(this), this.head = this.tail = new Op(noop$2, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function v() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop$2, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function v() {
  var y = this.head, z = this.tail, ne = this.len;
  return this.reset().uint32(ne), ne && (this.tail.next = y.next, this.tail = z, this.len += ne), this;
};
Writer$1.prototype.finish = function v() {
  for (var y = this.head.next, z = this.constructor.alloc(this.len), ne = 0; y; )
    y.fn(y.val, z, ne), ne += y.len, y = y.next;
  return z;
};
Writer$1._configure = function(v) {
  BufferWriter$1 = v, Writer$1.create = create$1(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer = writer;
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util$4 = requireMinimal();
function BufferWriter() {
  Writer.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$4._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$4.Buffer && util$4.Buffer.prototype instanceof Uint8Array && util$4.Buffer.prototype.set.name === "set" ? function(y, z, ne) {
    z.set(y, ne);
  } : function(y, z, ne) {
    if (y.copy)
      y.copy(z, ne, 0, y.length);
    else
      for (var ue = 0; ue < y.length; )
        z[ne++] = y[ue++];
  };
};
BufferWriter.prototype.bytes = function v(y) {
  util$4.isString(y) && (y = util$4._Buffer_from(y, "base64"));
  var z = y.length >>> 0;
  return this.uint32(z), z && this._push(BufferWriter.writeBytesBuffer, z, y), this;
};
function writeStringBuffer(v, y, z) {
  v.length < 40 ? util$4.utf8.write(v, y, z) : y.utf8Write ? y.utf8Write(v, z) : y.write(v, z);
}
BufferWriter.prototype.string = function v(y) {
  var z = util$4.Buffer.byteLength(y);
  return this.uint32(z), z && this._push(writeStringBuffer, z, y), this;
};
BufferWriter._configure();
var reader = Reader$1, util$3 = requireMinimal(), BufferReader$1, LongBits = util$3.LongBits, utf8$3 = util$3.utf8;
function indexOutOfRange(v, y) {
  return RangeError("index out of range: " + v.pos + " + " + (y || 1) + " > " + v.len);
}
function Reader$1(v) {
  this.buf = v, this.pos = 0, this.len = v.length;
}
var create_array = typeof Uint8Array < "u" ? function v(y) {
  if (y instanceof Uint8Array || Array.isArray(y))
    return new Reader$1(y);
  throw Error("illegal buffer");
} : function v(y) {
  if (Array.isArray(y))
    return new Reader$1(y);
  throw Error("illegal buffer");
}, create = function v() {
  return util$3.Buffer ? function(z) {
    return (Reader$1.create = function(ue) {
      return util$3.Buffer.isBuffer(ue) ? new BufferReader$1(ue) : create_array(ue);
    })(z);
  } : create_array;
};
Reader$1.create = create();
Reader$1.prototype._slice = util$3.Array.prototype.subarray || /* istanbul ignore next */
util$3.Array.prototype.slice;
Reader$1.prototype.uint32 = /* @__PURE__ */ function v() {
  var y = 4294967295;
  return function() {
    if (y = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (y = (y | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (y = (y | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (y = (y | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (y = (y | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return y;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return y;
  };
}();
Reader$1.prototype.int32 = function v() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function v() {
  var y = this.uint32();
  return y >>> 1 ^ -(y & 1) | 0;
};
function readLongVarint() {
  var v = new LongBits(0, 0), y = 0;
  if (this.len - this.pos > 4) {
    for (; y < 4; ++y)
      if (v.lo = (v.lo | (this.buf[this.pos] & 127) << y * 7) >>> 0, this.buf[this.pos++] < 128)
        return v;
    if (v.lo = (v.lo | (this.buf[this.pos] & 127) << 28) >>> 0, v.hi = (v.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return v;
    y = 0;
  } else {
    for (; y < 3; ++y) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (v.lo = (v.lo | (this.buf[this.pos] & 127) << y * 7) >>> 0, this.buf[this.pos++] < 128)
        return v;
    }
    return v.lo = (v.lo | (this.buf[this.pos++] & 127) << y * 7) >>> 0, v;
  }
  if (this.len - this.pos > 4) {
    for (; y < 5; ++y)
      if (v.hi = (v.hi | (this.buf[this.pos] & 127) << y * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return v;
  } else
    for (; y < 5; ++y) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (v.hi = (v.hi | (this.buf[this.pos] & 127) << y * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return v;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function v() {
  return this.uint32() !== 0;
};
function readFixed32_end(v, y) {
  return (v[y - 4] | v[y - 3] << 8 | v[y - 2] << 16 | v[y - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function v() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function v() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function v() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var y = util$3.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, y;
};
Reader$1.prototype.double = function v() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var y = util$3.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, y;
};
Reader$1.prototype.bytes = function v() {
  var y = this.uint32(), z = this.pos, ne = this.pos + y;
  if (ne > this.len)
    throw indexOutOfRange(this, y);
  return this.pos += y, Array.isArray(this.buf) ? this.buf.slice(z, ne) : z === ne ? new this.buf.constructor(0) : this._slice.call(this.buf, z, ne);
};
Reader$1.prototype.string = function v() {
  var y = this.bytes();
  return utf8$3.read(y, 0, y.length);
};
Reader$1.prototype.skip = function v(y) {
  if (typeof y == "number") {
    if (this.pos + y > this.len)
      throw indexOutOfRange(this, y);
    this.pos += y;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(v) {
  switch (v) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (v = this.uint32() & 7) !== 4; )
        this.skipType(v);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + v + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(v) {
  BufferReader$1 = v, Reader$1.create = create(), BufferReader$1._configure();
  var y = util$3.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$3.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[y](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[y](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[y](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[y](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[y](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader = reader;
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util$2 = requireMinimal();
function BufferReader(v) {
  Reader.call(this, v);
}
BufferReader._configure = function() {
  util$2.Buffer && (BufferReader.prototype._slice = util$2.Buffer.prototype.slice);
};
BufferReader.prototype.string = function v() {
  var y = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + y, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + y, this.len));
};
BufferReader._configure();
var rpc = {}, service = Service, util$1 = requireMinimal();
(Service.prototype = Object.create(util$1.EventEmitter.prototype)).constructor = Service;
function Service(v, y, z) {
  if (typeof v != "function")
    throw TypeError("rpcImpl must be a function");
  util$1.EventEmitter.call(this), this.rpcImpl = v, this.requestDelimited = !!y, this.responseDelimited = !!z;
}
Service.prototype.rpcCall = function v(y, z, ne, ue, le) {
  if (!ue)
    throw TypeError("request must be specified");
  var he = this;
  if (!le)
    return util$1.asPromise(v, he, y, z, ne, ue);
  if (!he.rpcImpl) {
    setTimeout(function() {
      le(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return he.rpcImpl(
      y,
      z[he.requestDelimited ? "encodeDelimited" : "encode"](ue).finish(),
      function(we, Ee) {
        if (we)
          return he.emit("error", we, y), le(we);
        if (Ee === null) {
          he.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(Ee instanceof ne))
          try {
            Ee = ne[he.responseDelimited ? "decodeDelimited" : "decode"](Ee);
          } catch (xe) {
            return he.emit("error", xe, y), le(xe);
          }
        return he.emit("data", Ee, y), le(null, Ee);
      }
    );
  } catch (ge) {
    he.emit("error", ge, y), setTimeout(function() {
      le(ge);
    }, 0);
    return;
  }
};
Service.prototype.end = function v(y) {
  return this.rpcImpl && (y || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(v) {
  var y = v;
  y.Service = service;
})(rpc);
var roots = {};
(function(v) {
  var y = v;
  y.build = "minimal", y.Writer = writer, y.BufferWriter = writer_buffer, y.Reader = reader, y.BufferReader = reader_buffer, y.util = requireMinimal(), y.rpc = rpc, y.roots = roots, y.configure = z;
  function z() {
    y.util._configure(), y.Writer._configure(y.BufferWriter), y.Reader._configure(y.BufferReader);
  }
  z();
})(indexMinimal);
var minimal = indexMinimal;
const _m0$8 = /* @__PURE__ */ getDefaultExportFromCjs(minimal);
var helpers = {}, __createBinding$f = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$e = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$f = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$f(y, v, z);
  return __setModuleDefault$e(y, v), y;
}, __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(helpers, "__esModule", { value: !0 });
helpers.fromJsonTimestamp = helpers.fromTimestamp = helpers.toTimestamp = helpers.setPaginationParams = helpers.isObject = helpers.isSet = helpers.fromDuration = helpers.toDuration = helpers.omitDefault = helpers.base64FromBytes = helpers.bytesFromBase64 = helpers.Long = void 0;
const _m0$7 = __importStar$f(minimal), long_1$1 = __importDefault$6(Long);
helpers.Long = long_1$1.default;
_m0$7.util.Long !== long_1$1.default && (_m0$7.util.Long = long_1$1.default, _m0$7.configure());
var globalThis$1 = (() => {
  if (typeof globalThis$1 < "u")
    return globalThis$1;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof commonjsGlobal < "u")
    return commonjsGlobal;
  throw "Unable to locate global object";
})();
const atob = globalThis$1.atob || ((v) => globalThis$1.Buffer.from(v, "base64").toString("binary"));
function bytesFromBase64$1(v) {
  const y = atob(v), z = new Uint8Array(y.length);
  for (let ne = 0; ne < y.length; ++ne)
    z[ne] = y.charCodeAt(ne);
  return z;
}
helpers.bytesFromBase64 = bytesFromBase64$1;
const btoa = globalThis$1.btoa || ((v) => globalThis$1.Buffer.from(v, "binary").toString("base64"));
function base64FromBytes$1(v) {
  const y = [];
  return v.forEach((z) => {
    y.push(String.fromCharCode(z));
  }), btoa(y.join(""));
}
helpers.base64FromBytes = base64FromBytes$1;
function omitDefault(v) {
  if (typeof v == "string")
    return v === "" ? void 0 : v;
  if (typeof v == "number")
    return v === 0 ? void 0 : v;
  if (long_1$1.default.isLong(v))
    return v.isZero() ? void 0 : v;
  throw new Error(`Got unsupported type ${typeof v}`);
}
helpers.omitDefault = omitDefault;
function toDuration(v) {
  return {
    seconds: long_1$1.default.fromNumber(Math.floor(parseInt(v) / 1e9)),
    nanos: parseInt(v) % 1e9
  };
}
helpers.toDuration = toDuration;
function fromDuration(v) {
  return (parseInt(v.seconds.toString()) * 1e9 + v.nanos).toString();
}
helpers.fromDuration = fromDuration;
function isSet$1(v) {
  return v != null;
}
helpers.isSet = isSet$1;
function isObject$1(v) {
  return typeof v == "object" && v !== null;
}
helpers.isObject = isObject$1;
const setPaginationParams = (v, y) => (y && (typeof (y == null ? void 0 : y.countTotal) < "u" && (v.params["pagination.count_total"] = y.countTotal), typeof (y == null ? void 0 : y.key) < "u" && (v.params["pagination.key"] = Buffer.from(y.key).toString("base64")), typeof (y == null ? void 0 : y.limit) < "u" && (v.params["pagination.limit"] = y.limit.toString()), typeof (y == null ? void 0 : y.offset) < "u" && (v.params["pagination.offset"] = y.offset.toString()), typeof (y == null ? void 0 : y.reverse) < "u" && (v.params["pagination.reverse"] = y.reverse)), v);
helpers.setPaginationParams = setPaginationParams;
function toTimestamp(v) {
  const y = numberToLong(v.getTime() / 1e3), z = v.getTime() % 1e3 * 1e6;
  return {
    seconds: y,
    nanos: z
  };
}
helpers.toTimestamp = toTimestamp;
function fromTimestamp(v) {
  let y = v.seconds.toNumber() * 1e3;
  return y += v.nanos / 1e6, new Date(y);
}
helpers.fromTimestamp = fromTimestamp;
const timestampFromJSON = (v) => ({
  seconds: isSet$1(v.seconds) ? long_1$1.default.fromValue(v.seconds) : long_1$1.default.ZERO,
  nanos: isSet$1(v.nanos) ? Number(v.nanos) : 0
});
function fromJsonTimestamp(v) {
  return v instanceof Date ? toTimestamp(v) : typeof v == "string" ? toTimestamp(new Date(v)) : timestampFromJSON(v);
}
helpers.fromJsonTimestamp = fromJsonTimestamp;
function numberToLong(v) {
  return long_1$1.default.fromNumber(v);
}
var __createBinding$e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$d = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$e = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$e(y, v, z);
  return __setModuleDefault$d(y, v), y;
};
Object.defineProperty(coin$1, "__esModule", { value: !0 });
coin$1.DecProto = coin$1.IntProto = coin$1.DecCoin = coin$1.Coin = coin$1.protobufPackage = void 0;
const _m0$6 = __importStar$e(minimal), helpers_1$6 = helpers;
coin$1.protobufPackage = "cosmos.base.v1beta1";
function createBaseCoin() {
  return {
    denom: "",
    amount: ""
  };
}
coin$1.Coin = {
  encode(v, y = _m0$6.Writer.create()) {
    return v.denom !== "" && y.uint32(10).string(v.denom), v.amount !== "" && y.uint32(18).string(v.amount), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$6.Reader ? v : new _m0$6.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseCoin();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.denom = z.string();
          break;
        case 2:
          ue.amount = z.string();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      denom: (0, helpers_1$6.isSet)(v.denom) ? String(v.denom) : "",
      amount: (0, helpers_1$6.isSet)(v.amount) ? String(v.amount) : ""
    };
  },
  toJSON(v) {
    const y = {};
    return v.denom !== void 0 && (y.denom = v.denom), v.amount !== void 0 && (y.amount = v.amount), y;
  },
  fromPartial(v) {
    const y = createBaseCoin();
    return y.denom = v.denom ?? "", y.amount = v.amount ?? "", y;
  }
};
function createBaseDecCoin() {
  return {
    denom: "",
    amount: ""
  };
}
coin$1.DecCoin = {
  encode(v, y = _m0$6.Writer.create()) {
    return v.denom !== "" && y.uint32(10).string(v.denom), v.amount !== "" && y.uint32(18).string(v.amount), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$6.Reader ? v : new _m0$6.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseDecCoin();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.denom = z.string();
          break;
        case 2:
          ue.amount = z.string();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      denom: (0, helpers_1$6.isSet)(v.denom) ? String(v.denom) : "",
      amount: (0, helpers_1$6.isSet)(v.amount) ? String(v.amount) : ""
    };
  },
  toJSON(v) {
    const y = {};
    return v.denom !== void 0 && (y.denom = v.denom), v.amount !== void 0 && (y.amount = v.amount), y;
  },
  fromPartial(v) {
    const y = createBaseDecCoin();
    return y.denom = v.denom ?? "", y.amount = v.amount ?? "", y;
  }
};
function createBaseIntProto() {
  return {
    int: ""
  };
}
coin$1.IntProto = {
  encode(v, y = _m0$6.Writer.create()) {
    return v.int !== "" && y.uint32(10).string(v.int), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$6.Reader ? v : new _m0$6.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseIntProto();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.int = z.string();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      int: (0, helpers_1$6.isSet)(v.int) ? String(v.int) : ""
    };
  },
  toJSON(v) {
    const y = {};
    return v.int !== void 0 && (y.int = v.int), y;
  },
  fromPartial(v) {
    const y = createBaseIntProto();
    return y.int = v.int ?? "", y;
  }
};
function createBaseDecProto() {
  return {
    dec: ""
  };
}
coin$1.DecProto = {
  encode(v, y = _m0$6.Writer.create()) {
    return v.dec !== "" && y.uint32(10).string(v.dec), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$6.Reader ? v : new _m0$6.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseDecProto();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.dec = z.string();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      dec: (0, helpers_1$6.isSet)(v.dec) ? String(v.dec) : ""
    };
  },
  toJSON(v) {
    const y = {};
    return v.dec !== void 0 && (y.dec = v.dec), y;
  },
  fromPartial(v) {
    const y = createBaseDecProto();
    return y.dec = v.dec ?? "", y;
  }
};
var client = {}, any = {}, __createBinding$d = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$c = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$d = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$d(y, v, z);
  return __setModuleDefault$c(y, v), y;
};
Object.defineProperty(any, "__esModule", { value: !0 });
any.Any = any.protobufPackage = void 0;
const _m0$5 = __importStar$d(minimal), helpers_1$5 = helpers;
any.protobufPackage = "google.protobuf";
function createBaseAny() {
  return {
    typeUrl: "",
    value: new Uint8Array()
  };
}
any.Any = {
  encode(v, y = _m0$5.Writer.create()) {
    return v.typeUrl !== "" && y.uint32(10).string(v.typeUrl), v.value.length !== 0 && y.uint32(18).bytes(v.value), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$5.Reader ? v : new _m0$5.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseAny();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.typeUrl = z.string();
          break;
        case 2:
          ue.value = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      typeUrl: (0, helpers_1$5.isSet)(v.typeUrl) ? String(v.typeUrl) : "",
      value: (0, helpers_1$5.isSet)(v.value) ? (0, helpers_1$5.bytesFromBase64)(v.value) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.typeUrl !== void 0 && (y.typeUrl = v.typeUrl), v.value !== void 0 && (y.value = (0, helpers_1$5.base64FromBytes)(v.value !== void 0 ? v.value : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBaseAny();
    return y.typeUrl = v.typeUrl ?? "", y.value = v.value ?? new Uint8Array(), y;
  }
};
var upgrade = {}, timestamp = {}, __createBinding$c = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$b = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$c = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$c(y, v, z);
  return __setModuleDefault$b(y, v), y;
};
Object.defineProperty(timestamp, "__esModule", { value: !0 });
timestamp.Timestamp = timestamp.protobufPackage = void 0;
const helpers_1$4 = helpers, _m0$4 = __importStar$c(minimal);
timestamp.protobufPackage = "google.protobuf";
function createBaseTimestamp() {
  return {
    seconds: helpers_1$4.Long.ZERO,
    nanos: 0
  };
}
timestamp.Timestamp = {
  encode(v, y = _m0$4.Writer.create()) {
    return v.seconds.isZero() || y.uint32(8).int64(v.seconds), v.nanos !== 0 && y.uint32(16).int32(v.nanos), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$4.Reader ? v : new _m0$4.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseTimestamp();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.seconds = z.int64();
          break;
        case 2:
          ue.nanos = z.int32();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      seconds: (0, helpers_1$4.isSet)(v.seconds) ? helpers_1$4.Long.fromValue(v.seconds) : helpers_1$4.Long.ZERO,
      nanos: (0, helpers_1$4.isSet)(v.nanos) ? Number(v.nanos) : 0
    };
  },
  toJSON(v) {
    const y = {};
    return v.seconds !== void 0 && (y.seconds = (v.seconds || helpers_1$4.Long.ZERO).toString()), v.nanos !== void 0 && (y.nanos = Math.round(v.nanos)), y;
  },
  fromPartial(v) {
    const y = createBaseTimestamp();
    return y.seconds = v.seconds !== void 0 && v.seconds !== null ? helpers_1$4.Long.fromValue(v.seconds) : helpers_1$4.Long.ZERO, y.nanos = v.nanos ?? 0, y;
  }
};
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Ne, st, Nr, br) {
    br === void 0 && (br = Nr);
    var $n = Object.getOwnPropertyDescriptor(st, Nr);
    (!$n || ("get" in $n ? !st.__esModule : $n.writable || $n.configurable)) && ($n = { enumerable: !0, get: function() {
      return st[Nr];
    } }), Object.defineProperty(Ne, br, $n);
  } : function(Ne, st, Nr, br) {
    br === void 0 && (br = Nr), Ne[br] = st[Nr];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Ne, st) {
    Object.defineProperty(Ne, "default", { enumerable: !0, value: st });
  } : function(Ne, st) {
    Ne.default = st;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(Ne) {
    if (Ne && Ne.__esModule)
      return Ne;
    var st = {};
    if (Ne != null)
      for (var Nr in Ne)
        Nr !== "default" && Object.prototype.hasOwnProperty.call(Ne, Nr) && y(st, Ne, Nr);
    return z(st, Ne), st;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.ModuleVersion = v.CancelSoftwareUpgradeProposal = v.SoftwareUpgradeProposal = v.Plan = v.protobufPackage = void 0;
  const ue = timestamp, le = any, he = helpers, ge = ne(minimal);
  v.protobufPackage = "cosmos.upgrade.v1beta1";
  function we() {
    return {
      name: "",
      time: void 0,
      height: he.Long.ZERO,
      info: "",
      upgradedClientState: void 0
    };
  }
  v.Plan = {
    encode(Ne, st = ge.Writer.create()) {
      return Ne.name !== "" && st.uint32(10).string(Ne.name), Ne.time !== void 0 && ue.Timestamp.encode(Ne.time, st.uint32(18).fork()).ldelim(), Ne.height.isZero() || st.uint32(24).int64(Ne.height), Ne.info !== "" && st.uint32(34).string(Ne.info), Ne.upgradedClientState !== void 0 && le.Any.encode(Ne.upgradedClientState, st.uint32(42).fork()).ldelim(), st;
    },
    decode(Ne, st) {
      const Nr = Ne instanceof ge.Reader ? Ne : new ge.Reader(Ne);
      let br = st === void 0 ? Nr.len : Nr.pos + st;
      const $n = we();
      for (; Nr.pos < br; ) {
        const En = Nr.uint32();
        switch (En >>> 3) {
          case 1:
            $n.name = Nr.string();
            break;
          case 2:
            $n.time = ue.Timestamp.decode(Nr, Nr.uint32());
            break;
          case 3:
            $n.height = Nr.int64();
            break;
          case 4:
            $n.info = Nr.string();
            break;
          case 5:
            $n.upgradedClientState = le.Any.decode(Nr, Nr.uint32());
            break;
          default:
            Nr.skipType(En & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(Ne) {
      return {
        name: (0, he.isSet)(Ne.name) ? String(Ne.name) : "",
        time: (0, he.isSet)(Ne.time) ? (0, he.fromJsonTimestamp)(Ne.time) : void 0,
        height: (0, he.isSet)(Ne.height) ? he.Long.fromValue(Ne.height) : he.Long.ZERO,
        info: (0, he.isSet)(Ne.info) ? String(Ne.info) : "",
        upgradedClientState: (0, he.isSet)(Ne.upgradedClientState) ? le.Any.fromJSON(Ne.upgradedClientState) : void 0
      };
    },
    toJSON(Ne) {
      const st = {};
      return Ne.name !== void 0 && (st.name = Ne.name), Ne.time !== void 0 && (st.time = (0, he.fromTimestamp)(Ne.time).toISOString()), Ne.height !== void 0 && (st.height = (Ne.height || he.Long.ZERO).toString()), Ne.info !== void 0 && (st.info = Ne.info), Ne.upgradedClientState !== void 0 && (st.upgradedClientState = Ne.upgradedClientState ? le.Any.toJSON(Ne.upgradedClientState) : void 0), st;
    },
    fromPartial(Ne) {
      const st = we();
      return st.name = Ne.name ?? "", st.time = Ne.time !== void 0 && Ne.time !== null ? ue.Timestamp.fromPartial(Ne.time) : void 0, st.height = Ne.height !== void 0 && Ne.height !== null ? he.Long.fromValue(Ne.height) : he.Long.ZERO, st.info = Ne.info ?? "", st.upgradedClientState = Ne.upgradedClientState !== void 0 && Ne.upgradedClientState !== null ? le.Any.fromPartial(Ne.upgradedClientState) : void 0, st;
    }
  };
  function Ee() {
    return {
      title: "",
      description: "",
      plan: void 0
    };
  }
  v.SoftwareUpgradeProposal = {
    encode(Ne, st = ge.Writer.create()) {
      return Ne.title !== "" && st.uint32(10).string(Ne.title), Ne.description !== "" && st.uint32(18).string(Ne.description), Ne.plan !== void 0 && v.Plan.encode(Ne.plan, st.uint32(26).fork()).ldelim(), st;
    },
    decode(Ne, st) {
      const Nr = Ne instanceof ge.Reader ? Ne : new ge.Reader(Ne);
      let br = st === void 0 ? Nr.len : Nr.pos + st;
      const $n = Ee();
      for (; Nr.pos < br; ) {
        const En = Nr.uint32();
        switch (En >>> 3) {
          case 1:
            $n.title = Nr.string();
            break;
          case 2:
            $n.description = Nr.string();
            break;
          case 3:
            $n.plan = v.Plan.decode(Nr, Nr.uint32());
            break;
          default:
            Nr.skipType(En & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(Ne) {
      return {
        title: (0, he.isSet)(Ne.title) ? String(Ne.title) : "",
        description: (0, he.isSet)(Ne.description) ? String(Ne.description) : "",
        plan: (0, he.isSet)(Ne.plan) ? v.Plan.fromJSON(Ne.plan) : void 0
      };
    },
    toJSON(Ne) {
      const st = {};
      return Ne.title !== void 0 && (st.title = Ne.title), Ne.description !== void 0 && (st.description = Ne.description), Ne.plan !== void 0 && (st.plan = Ne.plan ? v.Plan.toJSON(Ne.plan) : void 0), st;
    },
    fromPartial(Ne) {
      const st = Ee();
      return st.title = Ne.title ?? "", st.description = Ne.description ?? "", st.plan = Ne.plan !== void 0 && Ne.plan !== null ? v.Plan.fromPartial(Ne.plan) : void 0, st;
    }
  };
  function xe() {
    return {
      title: "",
      description: ""
    };
  }
  v.CancelSoftwareUpgradeProposal = {
    encode(Ne, st = ge.Writer.create()) {
      return Ne.title !== "" && st.uint32(10).string(Ne.title), Ne.description !== "" && st.uint32(18).string(Ne.description), st;
    },
    decode(Ne, st) {
      const Nr = Ne instanceof ge.Reader ? Ne : new ge.Reader(Ne);
      let br = st === void 0 ? Nr.len : Nr.pos + st;
      const $n = xe();
      for (; Nr.pos < br; ) {
        const En = Nr.uint32();
        switch (En >>> 3) {
          case 1:
            $n.title = Nr.string();
            break;
          case 2:
            $n.description = Nr.string();
            break;
          default:
            Nr.skipType(En & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(Ne) {
      return {
        title: (0, he.isSet)(Ne.title) ? String(Ne.title) : "",
        description: (0, he.isSet)(Ne.description) ? String(Ne.description) : ""
      };
    },
    toJSON(Ne) {
      const st = {};
      return Ne.title !== void 0 && (st.title = Ne.title), Ne.description !== void 0 && (st.description = Ne.description), st;
    },
    fromPartial(Ne) {
      const st = xe();
      return st.title = Ne.title ?? "", st.description = Ne.description ?? "", st;
    }
  };
  function $e() {
    return {
      name: "",
      version: he.Long.UZERO
    };
  }
  v.ModuleVersion = {
    encode(Ne, st = ge.Writer.create()) {
      return Ne.name !== "" && st.uint32(10).string(Ne.name), Ne.version.isZero() || st.uint32(16).uint64(Ne.version), st;
    },
    decode(Ne, st) {
      const Nr = Ne instanceof ge.Reader ? Ne : new ge.Reader(Ne);
      let br = st === void 0 ? Nr.len : Nr.pos + st;
      const $n = $e();
      for (; Nr.pos < br; ) {
        const En = Nr.uint32();
        switch (En >>> 3) {
          case 1:
            $n.name = Nr.string();
            break;
          case 2:
            $n.version = Nr.uint64();
            break;
          default:
            Nr.skipType(En & 7);
            break;
        }
      }
      return $n;
    },
    fromJSON(Ne) {
      return {
        name: (0, he.isSet)(Ne.name) ? String(Ne.name) : "",
        version: (0, he.isSet)(Ne.version) ? he.Long.fromValue(Ne.version) : he.Long.UZERO
      };
    },
    toJSON(Ne) {
      const st = {};
      return Ne.name !== void 0 && (st.name = Ne.name), Ne.version !== void 0 && (st.version = (Ne.version || he.Long.UZERO).toString()), st;
    },
    fromPartial(Ne) {
      const st = $e();
      return st.name = Ne.name ?? "", st.version = Ne.version !== void 0 && Ne.version !== null ? he.Long.fromValue(Ne.version) : he.Long.UZERO, st;
    }
  };
})(upgrade);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(br, $n, En, Rn) {
    Rn === void 0 && (Rn = En);
    var wa = Object.getOwnPropertyDescriptor($n, En);
    (!wa || ("get" in wa ? !$n.__esModule : wa.writable || wa.configurable)) && (wa = { enumerable: !0, get: function() {
      return $n[En];
    } }), Object.defineProperty(br, Rn, wa);
  } : function(br, $n, En, Rn) {
    Rn === void 0 && (Rn = En), br[Rn] = $n[En];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(br, $n) {
    Object.defineProperty(br, "default", { enumerable: !0, value: $n });
  } : function(br, $n) {
    br.default = $n;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(br) {
    if (br && br.__esModule)
      return br;
    var $n = {};
    if (br != null)
      for (var En in br)
        En !== "default" && Object.prototype.hasOwnProperty.call(br, En) && y($n, br, En);
    return z($n, br), $n;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.Params = v.Height = v.UpgradeProposal = v.ClientUpdateProposal = v.ClientConsensusStates = v.ConsensusStateWithHeight = v.IdentifiedClientState = v.protobufPackage = void 0;
  const ue = any, le = upgrade, he = helpers, ge = ne(minimal);
  v.protobufPackage = "ibc.core.client.v1";
  function we() {
    return {
      clientId: "",
      clientState: void 0
    };
  }
  v.IdentifiedClientState = {
    encode(br, $n = ge.Writer.create()) {
      return br.clientId !== "" && $n.uint32(10).string(br.clientId), br.clientState !== void 0 && ue.Any.encode(br.clientState, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = we();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.clientId = En.string();
            break;
          case 2:
            wa.clientState = ue.Any.decode(En, En.uint32());
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        clientId: (0, he.isSet)(br.clientId) ? String(br.clientId) : "",
        clientState: (0, he.isSet)(br.clientState) ? ue.Any.fromJSON(br.clientState) : void 0
      };
    },
    toJSON(br) {
      const $n = {};
      return br.clientId !== void 0 && ($n.clientId = br.clientId), br.clientState !== void 0 && ($n.clientState = br.clientState ? ue.Any.toJSON(br.clientState) : void 0), $n;
    },
    fromPartial(br) {
      const $n = we();
      return $n.clientId = br.clientId ?? "", $n.clientState = br.clientState !== void 0 && br.clientState !== null ? ue.Any.fromPartial(br.clientState) : void 0, $n;
    }
  };
  function Ee() {
    return {
      height: void 0,
      consensusState: void 0
    };
  }
  v.ConsensusStateWithHeight = {
    encode(br, $n = ge.Writer.create()) {
      return br.height !== void 0 && v.Height.encode(br.height, $n.uint32(10).fork()).ldelim(), br.consensusState !== void 0 && ue.Any.encode(br.consensusState, $n.uint32(18).fork()).ldelim(), $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = Ee();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.height = v.Height.decode(En, En.uint32());
            break;
          case 2:
            wa.consensusState = ue.Any.decode(En, En.uint32());
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        height: (0, he.isSet)(br.height) ? v.Height.fromJSON(br.height) : void 0,
        consensusState: (0, he.isSet)(br.consensusState) ? ue.Any.fromJSON(br.consensusState) : void 0
      };
    },
    toJSON(br) {
      const $n = {};
      return br.height !== void 0 && ($n.height = br.height ? v.Height.toJSON(br.height) : void 0), br.consensusState !== void 0 && ($n.consensusState = br.consensusState ? ue.Any.toJSON(br.consensusState) : void 0), $n;
    },
    fromPartial(br) {
      const $n = Ee();
      return $n.height = br.height !== void 0 && br.height !== null ? v.Height.fromPartial(br.height) : void 0, $n.consensusState = br.consensusState !== void 0 && br.consensusState !== null ? ue.Any.fromPartial(br.consensusState) : void 0, $n;
    }
  };
  function xe() {
    return {
      clientId: "",
      consensusStates: []
    };
  }
  v.ClientConsensusStates = {
    encode(br, $n = ge.Writer.create()) {
      br.clientId !== "" && $n.uint32(10).string(br.clientId);
      for (const En of br.consensusStates)
        v.ConsensusStateWithHeight.encode(En, $n.uint32(18).fork()).ldelim();
      return $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = xe();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.clientId = En.string();
            break;
          case 2:
            wa.consensusStates.push(v.ConsensusStateWithHeight.decode(En, En.uint32()));
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        clientId: (0, he.isSet)(br.clientId) ? String(br.clientId) : "",
        consensusStates: Array.isArray(br == null ? void 0 : br.consensusStates) ? br.consensusStates.map(($n) => v.ConsensusStateWithHeight.fromJSON($n)) : []
      };
    },
    toJSON(br) {
      const $n = {};
      return br.clientId !== void 0 && ($n.clientId = br.clientId), br.consensusStates ? $n.consensusStates = br.consensusStates.map((En) => En ? v.ConsensusStateWithHeight.toJSON(En) : void 0) : $n.consensusStates = [], $n;
    },
    fromPartial(br) {
      var En;
      const $n = xe();
      return $n.clientId = br.clientId ?? "", $n.consensusStates = ((En = br.consensusStates) == null ? void 0 : En.map((Rn) => v.ConsensusStateWithHeight.fromPartial(Rn))) || [], $n;
    }
  };
  function $e() {
    return {
      title: "",
      description: "",
      subjectClientId: "",
      substituteClientId: ""
    };
  }
  v.ClientUpdateProposal = {
    encode(br, $n = ge.Writer.create()) {
      return br.title !== "" && $n.uint32(10).string(br.title), br.description !== "" && $n.uint32(18).string(br.description), br.subjectClientId !== "" && $n.uint32(26).string(br.subjectClientId), br.substituteClientId !== "" && $n.uint32(34).string(br.substituteClientId), $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = $e();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.title = En.string();
            break;
          case 2:
            wa.description = En.string();
            break;
          case 3:
            wa.subjectClientId = En.string();
            break;
          case 4:
            wa.substituteClientId = En.string();
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        title: (0, he.isSet)(br.title) ? String(br.title) : "",
        description: (0, he.isSet)(br.description) ? String(br.description) : "",
        subjectClientId: (0, he.isSet)(br.subjectClientId) ? String(br.subjectClientId) : "",
        substituteClientId: (0, he.isSet)(br.substituteClientId) ? String(br.substituteClientId) : ""
      };
    },
    toJSON(br) {
      const $n = {};
      return br.title !== void 0 && ($n.title = br.title), br.description !== void 0 && ($n.description = br.description), br.subjectClientId !== void 0 && ($n.subjectClientId = br.subjectClientId), br.substituteClientId !== void 0 && ($n.substituteClientId = br.substituteClientId), $n;
    },
    fromPartial(br) {
      const $n = $e();
      return $n.title = br.title ?? "", $n.description = br.description ?? "", $n.subjectClientId = br.subjectClientId ?? "", $n.substituteClientId = br.substituteClientId ?? "", $n;
    }
  };
  function Ne() {
    return {
      title: "",
      description: "",
      plan: void 0,
      upgradedClientState: void 0
    };
  }
  v.UpgradeProposal = {
    encode(br, $n = ge.Writer.create()) {
      return br.title !== "" && $n.uint32(10).string(br.title), br.description !== "" && $n.uint32(18).string(br.description), br.plan !== void 0 && le.Plan.encode(br.plan, $n.uint32(26).fork()).ldelim(), br.upgradedClientState !== void 0 && ue.Any.encode(br.upgradedClientState, $n.uint32(34).fork()).ldelim(), $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = Ne();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.title = En.string();
            break;
          case 2:
            wa.description = En.string();
            break;
          case 3:
            wa.plan = le.Plan.decode(En, En.uint32());
            break;
          case 4:
            wa.upgradedClientState = ue.Any.decode(En, En.uint32());
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        title: (0, he.isSet)(br.title) ? String(br.title) : "",
        description: (0, he.isSet)(br.description) ? String(br.description) : "",
        plan: (0, he.isSet)(br.plan) ? le.Plan.fromJSON(br.plan) : void 0,
        upgradedClientState: (0, he.isSet)(br.upgradedClientState) ? ue.Any.fromJSON(br.upgradedClientState) : void 0
      };
    },
    toJSON(br) {
      const $n = {};
      return br.title !== void 0 && ($n.title = br.title), br.description !== void 0 && ($n.description = br.description), br.plan !== void 0 && ($n.plan = br.plan ? le.Plan.toJSON(br.plan) : void 0), br.upgradedClientState !== void 0 && ($n.upgradedClientState = br.upgradedClientState ? ue.Any.toJSON(br.upgradedClientState) : void 0), $n;
    },
    fromPartial(br) {
      const $n = Ne();
      return $n.title = br.title ?? "", $n.description = br.description ?? "", $n.plan = br.plan !== void 0 && br.plan !== null ? le.Plan.fromPartial(br.plan) : void 0, $n.upgradedClientState = br.upgradedClientState !== void 0 && br.upgradedClientState !== null ? ue.Any.fromPartial(br.upgradedClientState) : void 0, $n;
    }
  };
  function st() {
    return {
      revisionNumber: he.Long.UZERO,
      revisionHeight: he.Long.UZERO
    };
  }
  v.Height = {
    encode(br, $n = ge.Writer.create()) {
      return br.revisionNumber.isZero() || $n.uint32(8).uint64(br.revisionNumber), br.revisionHeight.isZero() || $n.uint32(16).uint64(br.revisionHeight), $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = st();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.revisionNumber = En.uint64();
            break;
          case 2:
            wa.revisionHeight = En.uint64();
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        revisionNumber: (0, he.isSet)(br.revisionNumber) ? he.Long.fromValue(br.revisionNumber) : he.Long.UZERO,
        revisionHeight: (0, he.isSet)(br.revisionHeight) ? he.Long.fromValue(br.revisionHeight) : he.Long.UZERO
      };
    },
    toJSON(br) {
      const $n = {};
      return br.revisionNumber !== void 0 && ($n.revisionNumber = (br.revisionNumber || he.Long.UZERO).toString()), br.revisionHeight !== void 0 && ($n.revisionHeight = (br.revisionHeight || he.Long.UZERO).toString()), $n;
    },
    fromPartial(br) {
      const $n = st();
      return $n.revisionNumber = br.revisionNumber !== void 0 && br.revisionNumber !== null ? he.Long.fromValue(br.revisionNumber) : he.Long.UZERO, $n.revisionHeight = br.revisionHeight !== void 0 && br.revisionHeight !== null ? he.Long.fromValue(br.revisionHeight) : he.Long.UZERO, $n;
    }
  };
  function Nr() {
    return {
      allowedClients: []
    };
  }
  v.Params = {
    encode(br, $n = ge.Writer.create()) {
      for (const En of br.allowedClients)
        $n.uint32(10).string(En);
      return $n;
    },
    decode(br, $n) {
      const En = br instanceof ge.Reader ? br : new ge.Reader(br);
      let Rn = $n === void 0 ? En.len : En.pos + $n;
      const wa = Nr();
      for (; En.pos < Rn; ) {
        const Aa = En.uint32();
        switch (Aa >>> 3) {
          case 1:
            wa.allowedClients.push(En.string());
            break;
          default:
            En.skipType(Aa & 7);
            break;
        }
      }
      return wa;
    },
    fromJSON(br) {
      return {
        allowedClients: Array.isArray(br == null ? void 0 : br.allowedClients) ? br.allowedClients.map(($n) => String($n)) : []
      };
    },
    toJSON(br) {
      const $n = {};
      return br.allowedClients ? $n.allowedClients = br.allowedClients.map((En) => En) : $n.allowedClients = [], $n;
    },
    fromPartial(br) {
      var En;
      const $n = Nr();
      return $n.allowedClients = ((En = br.allowedClients) == null ? void 0 : En.map((Rn) => Rn)) || [], $n;
    }
  };
})(client);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($e, Ne, st, Nr) {
    Nr === void 0 && (Nr = st);
    var br = Object.getOwnPropertyDescriptor(Ne, st);
    (!br || ("get" in br ? !Ne.__esModule : br.writable || br.configurable)) && (br = { enumerable: !0, get: function() {
      return Ne[st];
    } }), Object.defineProperty($e, Nr, br);
  } : function($e, Ne, st, Nr) {
    Nr === void 0 && (Nr = st), $e[Nr] = Ne[st];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($e, Ne) {
    Object.defineProperty($e, "default", { enumerable: !0, value: Ne });
  } : function($e, Ne) {
    $e.default = Ne;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function($e) {
    if ($e && $e.__esModule)
      return $e;
    var Ne = {};
    if ($e != null)
      for (var st in $e)
        st !== "default" && Object.prototype.hasOwnProperty.call($e, st) && y(Ne, $e, st);
    return z(Ne, $e), Ne;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.MsgClientImpl = v.MsgTransferResponse = v.MsgTransfer = v.protobufPackage = void 0;
  const ue = coin$1, le = client, he = helpers, ge = ne(minimal);
  v.protobufPackage = "ibc.applications.transfer.v1";
  function we() {
    return {
      sourcePort: "",
      sourceChannel: "",
      token: void 0,
      sender: "",
      receiver: "",
      timeoutHeight: void 0,
      timeoutTimestamp: he.Long.UZERO,
      memo: ""
    };
  }
  v.MsgTransfer = {
    encode($e, Ne = ge.Writer.create()) {
      return $e.sourcePort !== "" && Ne.uint32(10).string($e.sourcePort), $e.sourceChannel !== "" && Ne.uint32(18).string($e.sourceChannel), $e.token !== void 0 && ue.Coin.encode($e.token, Ne.uint32(26).fork()).ldelim(), $e.sender !== "" && Ne.uint32(34).string($e.sender), $e.receiver !== "" && Ne.uint32(42).string($e.receiver), $e.timeoutHeight !== void 0 && le.Height.encode($e.timeoutHeight, Ne.uint32(50).fork()).ldelim(), $e.timeoutTimestamp.isZero() || Ne.uint32(56).uint64($e.timeoutTimestamp), $e.memo !== "" && Ne.uint32(66).string($e.memo), Ne;
    },
    decode($e, Ne) {
      const st = $e instanceof ge.Reader ? $e : new ge.Reader($e);
      let Nr = Ne === void 0 ? st.len : st.pos + Ne;
      const br = we();
      for (; st.pos < Nr; ) {
        const $n = st.uint32();
        switch ($n >>> 3) {
          case 1:
            br.sourcePort = st.string();
            break;
          case 2:
            br.sourceChannel = st.string();
            break;
          case 3:
            br.token = ue.Coin.decode(st, st.uint32());
            break;
          case 4:
            br.sender = st.string();
            break;
          case 5:
            br.receiver = st.string();
            break;
          case 6:
            br.timeoutHeight = le.Height.decode(st, st.uint32());
            break;
          case 7:
            br.timeoutTimestamp = st.uint64();
            break;
          case 8:
            br.memo = st.string();
            break;
          default:
            st.skipType($n & 7);
            break;
        }
      }
      return br;
    },
    fromJSON($e) {
      return {
        sourcePort: (0, he.isSet)($e.sourcePort) ? String($e.sourcePort) : "",
        sourceChannel: (0, he.isSet)($e.sourceChannel) ? String($e.sourceChannel) : "",
        token: (0, he.isSet)($e.token) ? ue.Coin.fromJSON($e.token) : void 0,
        sender: (0, he.isSet)($e.sender) ? String($e.sender) : "",
        receiver: (0, he.isSet)($e.receiver) ? String($e.receiver) : "",
        timeoutHeight: (0, he.isSet)($e.timeoutHeight) ? le.Height.fromJSON($e.timeoutHeight) : void 0,
        timeoutTimestamp: (0, he.isSet)($e.timeoutTimestamp) ? he.Long.fromValue($e.timeoutTimestamp) : he.Long.UZERO,
        memo: (0, he.isSet)($e.memo) ? String($e.memo) : ""
      };
    },
    toJSON($e) {
      const Ne = {};
      return $e.sourcePort !== void 0 && (Ne.sourcePort = $e.sourcePort), $e.sourceChannel !== void 0 && (Ne.sourceChannel = $e.sourceChannel), $e.token !== void 0 && (Ne.token = $e.token ? ue.Coin.toJSON($e.token) : void 0), $e.sender !== void 0 && (Ne.sender = $e.sender), $e.receiver !== void 0 && (Ne.receiver = $e.receiver), $e.timeoutHeight !== void 0 && (Ne.timeoutHeight = $e.timeoutHeight ? le.Height.toJSON($e.timeoutHeight) : void 0), $e.timeoutTimestamp !== void 0 && (Ne.timeoutTimestamp = ($e.timeoutTimestamp || he.Long.UZERO).toString()), $e.memo !== void 0 && (Ne.memo = $e.memo), Ne;
    },
    fromPartial($e) {
      const Ne = we();
      return Ne.sourcePort = $e.sourcePort ?? "", Ne.sourceChannel = $e.sourceChannel ?? "", Ne.token = $e.token !== void 0 && $e.token !== null ? ue.Coin.fromPartial($e.token) : void 0, Ne.sender = $e.sender ?? "", Ne.receiver = $e.receiver ?? "", Ne.timeoutHeight = $e.timeoutHeight !== void 0 && $e.timeoutHeight !== null ? le.Height.fromPartial($e.timeoutHeight) : void 0, Ne.timeoutTimestamp = $e.timeoutTimestamp !== void 0 && $e.timeoutTimestamp !== null ? he.Long.fromValue($e.timeoutTimestamp) : he.Long.UZERO, Ne.memo = $e.memo ?? "", Ne;
    }
  };
  function Ee() {
    return {
      sequence: he.Long.UZERO
    };
  }
  v.MsgTransferResponse = {
    encode($e, Ne = ge.Writer.create()) {
      return $e.sequence.isZero() || Ne.uint32(8).uint64($e.sequence), Ne;
    },
    decode($e, Ne) {
      const st = $e instanceof ge.Reader ? $e : new ge.Reader($e);
      let Nr = Ne === void 0 ? st.len : st.pos + Ne;
      const br = Ee();
      for (; st.pos < Nr; ) {
        const $n = st.uint32();
        switch ($n >>> 3) {
          case 1:
            br.sequence = st.uint64();
            break;
          default:
            st.skipType($n & 7);
            break;
        }
      }
      return br;
    },
    fromJSON($e) {
      return {
        sequence: (0, he.isSet)($e.sequence) ? he.Long.fromValue($e.sequence) : he.Long.UZERO
      };
    },
    toJSON($e) {
      const Ne = {};
      return $e.sequence !== void 0 && (Ne.sequence = ($e.sequence || he.Long.UZERO).toString()), Ne;
    },
    fromPartial($e) {
      const Ne = Ee();
      return Ne.sequence = $e.sequence !== void 0 && $e.sequence !== null ? he.Long.fromValue($e.sequence) : he.Long.UZERO, Ne;
    }
  };
  class xe {
    constructor(Ne) {
      this.rpc = Ne, this.Transfer = this.Transfer.bind(this);
    }
    Transfer(Ne) {
      const st = v.MsgTransfer.encode(Ne).finish();
      return this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", st).then((br) => v.MsgTransferResponse.decode(new ge.Reader(br)));
    }
  }
  v.MsgClientImpl = xe;
})(tx$3);
var tx$2 = {}, bank = {};
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Nr, br, $n, En) {
    En === void 0 && (En = $n);
    var Rn = Object.getOwnPropertyDescriptor(br, $n);
    (!Rn || ("get" in Rn ? !br.__esModule : Rn.writable || Rn.configurable)) && (Rn = { enumerable: !0, get: function() {
      return br[$n];
    } }), Object.defineProperty(Nr, En, Rn);
  } : function(Nr, br, $n, En) {
    En === void 0 && (En = $n), Nr[En] = br[$n];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Nr, br) {
    Object.defineProperty(Nr, "default", { enumerable: !0, value: br });
  } : function(Nr, br) {
    Nr.default = br;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(Nr) {
    if (Nr && Nr.__esModule)
      return Nr;
    var br = {};
    if (Nr != null)
      for (var $n in Nr)
        $n !== "default" && Object.prototype.hasOwnProperty.call(Nr, $n) && y(br, Nr, $n);
    return z(br, Nr), br;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.Metadata = v.DenomUnit = v.Supply = v.Output = v.Input = v.SendEnabled = v.Params = v.protobufPackage = void 0;
  const ue = coin$1, le = ne(minimal), he = helpers;
  v.protobufPackage = "cosmos.bank.v1beta1";
  function ge() {
    return {
      sendEnabled: [],
      defaultSendEnabled: !1
    };
  }
  v.Params = {
    encode(Nr, br = le.Writer.create()) {
      for (const $n of Nr.sendEnabled)
        v.SendEnabled.encode($n, br.uint32(10).fork()).ldelim();
      return Nr.defaultSendEnabled === !0 && br.uint32(16).bool(Nr.defaultSendEnabled), br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = ge();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.sendEnabled.push(v.SendEnabled.decode($n, $n.uint32()));
            break;
          case 2:
            Rn.defaultSendEnabled = $n.bool();
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        sendEnabled: Array.isArray(Nr == null ? void 0 : Nr.sendEnabled) ? Nr.sendEnabled.map((br) => v.SendEnabled.fromJSON(br)) : [],
        defaultSendEnabled: (0, he.isSet)(Nr.defaultSendEnabled) ? !!Nr.defaultSendEnabled : !1
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.sendEnabled ? br.sendEnabled = Nr.sendEnabled.map(($n) => $n ? v.SendEnabled.toJSON($n) : void 0) : br.sendEnabled = [], Nr.defaultSendEnabled !== void 0 && (br.defaultSendEnabled = Nr.defaultSendEnabled), br;
    },
    fromPartial(Nr) {
      var $n;
      const br = ge();
      return br.sendEnabled = (($n = Nr.sendEnabled) == null ? void 0 : $n.map((En) => v.SendEnabled.fromPartial(En))) || [], br.defaultSendEnabled = Nr.defaultSendEnabled ?? !1, br;
    }
  };
  function we() {
    return {
      denom: "",
      enabled: !1
    };
  }
  v.SendEnabled = {
    encode(Nr, br = le.Writer.create()) {
      return Nr.denom !== "" && br.uint32(10).string(Nr.denom), Nr.enabled === !0 && br.uint32(16).bool(Nr.enabled), br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = we();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.denom = $n.string();
            break;
          case 2:
            Rn.enabled = $n.bool();
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        denom: (0, he.isSet)(Nr.denom) ? String(Nr.denom) : "",
        enabled: (0, he.isSet)(Nr.enabled) ? !!Nr.enabled : !1
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.denom !== void 0 && (br.denom = Nr.denom), Nr.enabled !== void 0 && (br.enabled = Nr.enabled), br;
    },
    fromPartial(Nr) {
      const br = we();
      return br.denom = Nr.denom ?? "", br.enabled = Nr.enabled ?? !1, br;
    }
  };
  function Ee() {
    return {
      address: "",
      coins: []
    };
  }
  v.Input = {
    encode(Nr, br = le.Writer.create()) {
      Nr.address !== "" && br.uint32(10).string(Nr.address);
      for (const $n of Nr.coins)
        ue.Coin.encode($n, br.uint32(18).fork()).ldelim();
      return br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = Ee();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.address = $n.string();
            break;
          case 2:
            Rn.coins.push(ue.Coin.decode($n, $n.uint32()));
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        address: (0, he.isSet)(Nr.address) ? String(Nr.address) : "",
        coins: Array.isArray(Nr == null ? void 0 : Nr.coins) ? Nr.coins.map((br) => ue.Coin.fromJSON(br)) : []
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.address !== void 0 && (br.address = Nr.address), Nr.coins ? br.coins = Nr.coins.map(($n) => $n ? ue.Coin.toJSON($n) : void 0) : br.coins = [], br;
    },
    fromPartial(Nr) {
      var $n;
      const br = Ee();
      return br.address = Nr.address ?? "", br.coins = (($n = Nr.coins) == null ? void 0 : $n.map((En) => ue.Coin.fromPartial(En))) || [], br;
    }
  };
  function xe() {
    return {
      address: "",
      coins: []
    };
  }
  v.Output = {
    encode(Nr, br = le.Writer.create()) {
      Nr.address !== "" && br.uint32(10).string(Nr.address);
      for (const $n of Nr.coins)
        ue.Coin.encode($n, br.uint32(18).fork()).ldelim();
      return br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = xe();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.address = $n.string();
            break;
          case 2:
            Rn.coins.push(ue.Coin.decode($n, $n.uint32()));
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        address: (0, he.isSet)(Nr.address) ? String(Nr.address) : "",
        coins: Array.isArray(Nr == null ? void 0 : Nr.coins) ? Nr.coins.map((br) => ue.Coin.fromJSON(br)) : []
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.address !== void 0 && (br.address = Nr.address), Nr.coins ? br.coins = Nr.coins.map(($n) => $n ? ue.Coin.toJSON($n) : void 0) : br.coins = [], br;
    },
    fromPartial(Nr) {
      var $n;
      const br = xe();
      return br.address = Nr.address ?? "", br.coins = (($n = Nr.coins) == null ? void 0 : $n.map((En) => ue.Coin.fromPartial(En))) || [], br;
    }
  };
  function $e() {
    return {
      total: []
    };
  }
  v.Supply = {
    encode(Nr, br = le.Writer.create()) {
      for (const $n of Nr.total)
        ue.Coin.encode($n, br.uint32(10).fork()).ldelim();
      return br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = $e();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.total.push(ue.Coin.decode($n, $n.uint32()));
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        total: Array.isArray(Nr == null ? void 0 : Nr.total) ? Nr.total.map((br) => ue.Coin.fromJSON(br)) : []
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.total ? br.total = Nr.total.map(($n) => $n ? ue.Coin.toJSON($n) : void 0) : br.total = [], br;
    },
    fromPartial(Nr) {
      var $n;
      const br = $e();
      return br.total = (($n = Nr.total) == null ? void 0 : $n.map((En) => ue.Coin.fromPartial(En))) || [], br;
    }
  };
  function Ne() {
    return {
      denom: "",
      exponent: 0,
      aliases: []
    };
  }
  v.DenomUnit = {
    encode(Nr, br = le.Writer.create()) {
      Nr.denom !== "" && br.uint32(10).string(Nr.denom), Nr.exponent !== 0 && br.uint32(16).uint32(Nr.exponent);
      for (const $n of Nr.aliases)
        br.uint32(26).string($n);
      return br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = Ne();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.denom = $n.string();
            break;
          case 2:
            Rn.exponent = $n.uint32();
            break;
          case 3:
            Rn.aliases.push($n.string());
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        denom: (0, he.isSet)(Nr.denom) ? String(Nr.denom) : "",
        exponent: (0, he.isSet)(Nr.exponent) ? Number(Nr.exponent) : 0,
        aliases: Array.isArray(Nr == null ? void 0 : Nr.aliases) ? Nr.aliases.map((br) => String(br)) : []
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.denom !== void 0 && (br.denom = Nr.denom), Nr.exponent !== void 0 && (br.exponent = Math.round(Nr.exponent)), Nr.aliases ? br.aliases = Nr.aliases.map(($n) => $n) : br.aliases = [], br;
    },
    fromPartial(Nr) {
      var $n;
      const br = Ne();
      return br.denom = Nr.denom ?? "", br.exponent = Nr.exponent ?? 0, br.aliases = (($n = Nr.aliases) == null ? void 0 : $n.map((En) => En)) || [], br;
    }
  };
  function st() {
    return {
      description: "",
      denomUnits: [],
      base: "",
      display: "",
      name: "",
      symbol: "",
      uri: "",
      uriHash: ""
    };
  }
  v.Metadata = {
    encode(Nr, br = le.Writer.create()) {
      Nr.description !== "" && br.uint32(10).string(Nr.description);
      for (const $n of Nr.denomUnits)
        v.DenomUnit.encode($n, br.uint32(18).fork()).ldelim();
      return Nr.base !== "" && br.uint32(26).string(Nr.base), Nr.display !== "" && br.uint32(34).string(Nr.display), Nr.name !== "" && br.uint32(42).string(Nr.name), Nr.symbol !== "" && br.uint32(50).string(Nr.symbol), Nr.uri !== "" && br.uint32(58).string(Nr.uri), Nr.uriHash !== "" && br.uint32(66).string(Nr.uriHash), br;
    },
    decode(Nr, br) {
      const $n = Nr instanceof le.Reader ? Nr : new le.Reader(Nr);
      let En = br === void 0 ? $n.len : $n.pos + br;
      const Rn = st();
      for (; $n.pos < En; ) {
        const wa = $n.uint32();
        switch (wa >>> 3) {
          case 1:
            Rn.description = $n.string();
            break;
          case 2:
            Rn.denomUnits.push(v.DenomUnit.decode($n, $n.uint32()));
            break;
          case 3:
            Rn.base = $n.string();
            break;
          case 4:
            Rn.display = $n.string();
            break;
          case 5:
            Rn.name = $n.string();
            break;
          case 6:
            Rn.symbol = $n.string();
            break;
          case 7:
            Rn.uri = $n.string();
            break;
          case 8:
            Rn.uriHash = $n.string();
            break;
          default:
            $n.skipType(wa & 7);
            break;
        }
      }
      return Rn;
    },
    fromJSON(Nr) {
      return {
        description: (0, he.isSet)(Nr.description) ? String(Nr.description) : "",
        denomUnits: Array.isArray(Nr == null ? void 0 : Nr.denomUnits) ? Nr.denomUnits.map((br) => v.DenomUnit.fromJSON(br)) : [],
        base: (0, he.isSet)(Nr.base) ? String(Nr.base) : "",
        display: (0, he.isSet)(Nr.display) ? String(Nr.display) : "",
        name: (0, he.isSet)(Nr.name) ? String(Nr.name) : "",
        symbol: (0, he.isSet)(Nr.symbol) ? String(Nr.symbol) : "",
        uri: (0, he.isSet)(Nr.uri) ? String(Nr.uri) : "",
        uriHash: (0, he.isSet)(Nr.uriHash) ? String(Nr.uriHash) : ""
      };
    },
    toJSON(Nr) {
      const br = {};
      return Nr.description !== void 0 && (br.description = Nr.description), Nr.denomUnits ? br.denomUnits = Nr.denomUnits.map(($n) => $n ? v.DenomUnit.toJSON($n) : void 0) : br.denomUnits = [], Nr.base !== void 0 && (br.base = Nr.base), Nr.display !== void 0 && (br.display = Nr.display), Nr.name !== void 0 && (br.name = Nr.name), Nr.symbol !== void 0 && (br.symbol = Nr.symbol), Nr.uri !== void 0 && (br.uri = Nr.uri), Nr.uriHash !== void 0 && (br.uriHash = Nr.uriHash), br;
    },
    fromPartial(Nr) {
      var $n;
      const br = st();
      return br.description = Nr.description ?? "", br.denomUnits = (($n = Nr.denomUnits) == null ? void 0 : $n.map((En) => v.DenomUnit.fromPartial(En))) || [], br.base = Nr.base ?? "", br.display = Nr.display ?? "", br.name = Nr.name ?? "", br.symbol = Nr.symbol ?? "", br.uri = Nr.uri ?? "", br.uriHash = Nr.uriHash ?? "", br;
    }
  };
})(bank);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(En, Rn, wa, Aa) {
    Aa === void 0 && (Aa = wa);
    var _a = Object.getOwnPropertyDescriptor(Rn, wa);
    (!_a || ("get" in _a ? !Rn.__esModule : _a.writable || _a.configurable)) && (_a = { enumerable: !0, get: function() {
      return Rn[wa];
    } }), Object.defineProperty(En, Aa, _a);
  } : function(En, Rn, wa, Aa) {
    Aa === void 0 && (Aa = wa), En[Aa] = Rn[wa];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(En, Rn) {
    Object.defineProperty(En, "default", { enumerable: !0, value: Rn });
  } : function(En, Rn) {
    En.default = Rn;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(En) {
    if (En && En.__esModule)
      return En;
    var Rn = {};
    if (En != null)
      for (var wa in En)
        wa !== "default" && Object.prototype.hasOwnProperty.call(En, wa) && y(Rn, En, wa);
    return z(Rn, En), Rn;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.MsgClientImpl = v.MsgSetSendEnabledResponse = v.MsgSetSendEnabled = v.MsgUpdateParamsResponse = v.MsgUpdateParams = v.MsgMultiSendResponse = v.MsgMultiSend = v.MsgSendResponse = v.MsgSend = v.protobufPackage = void 0;
  const ue = coin$1, le = bank, he = ne(minimal), ge = helpers;
  v.protobufPackage = "cosmos.bank.v1beta1";
  function we() {
    return {
      fromAddress: "",
      toAddress: "",
      amount: []
    };
  }
  v.MsgSend = {
    encode(En, Rn = he.Writer.create()) {
      En.fromAddress !== "" && Rn.uint32(10).string(En.fromAddress), En.toAddress !== "" && Rn.uint32(18).string(En.toAddress);
      for (const wa of En.amount)
        ue.Coin.encode(wa, Rn.uint32(26).fork()).ldelim();
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = we();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          case 1:
            _a.fromAddress = wa.string();
            break;
          case 2:
            _a.toAddress = wa.string();
            break;
          case 3:
            _a.amount.push(ue.Coin.decode(wa, wa.uint32()));
            break;
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {
        fromAddress: (0, ge.isSet)(En.fromAddress) ? String(En.fromAddress) : "",
        toAddress: (0, ge.isSet)(En.toAddress) ? String(En.toAddress) : "",
        amount: Array.isArray(En == null ? void 0 : En.amount) ? En.amount.map((Rn) => ue.Coin.fromJSON(Rn)) : []
      };
    },
    toJSON(En) {
      const Rn = {};
      return En.fromAddress !== void 0 && (Rn.fromAddress = En.fromAddress), En.toAddress !== void 0 && (Rn.toAddress = En.toAddress), En.amount ? Rn.amount = En.amount.map((wa) => wa ? ue.Coin.toJSON(wa) : void 0) : Rn.amount = [], Rn;
    },
    fromPartial(En) {
      var wa;
      const Rn = we();
      return Rn.fromAddress = En.fromAddress ?? "", Rn.toAddress = En.toAddress ?? "", Rn.amount = ((wa = En.amount) == null ? void 0 : wa.map((Aa) => ue.Coin.fromPartial(Aa))) || [], Rn;
    }
  };
  function Ee() {
    return {};
  }
  v.MsgSendResponse = {
    encode(En, Rn = he.Writer.create()) {
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = Ee();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {};
    },
    toJSON(En) {
      return {};
    },
    fromPartial(En) {
      return Ee();
    }
  };
  function xe() {
    return {
      inputs: [],
      outputs: []
    };
  }
  v.MsgMultiSend = {
    encode(En, Rn = he.Writer.create()) {
      for (const wa of En.inputs)
        le.Input.encode(wa, Rn.uint32(10).fork()).ldelim();
      for (const wa of En.outputs)
        le.Output.encode(wa, Rn.uint32(18).fork()).ldelim();
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = xe();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          case 1:
            _a.inputs.push(le.Input.decode(wa, wa.uint32()));
            break;
          case 2:
            _a.outputs.push(le.Output.decode(wa, wa.uint32()));
            break;
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {
        inputs: Array.isArray(En == null ? void 0 : En.inputs) ? En.inputs.map((Rn) => le.Input.fromJSON(Rn)) : [],
        outputs: Array.isArray(En == null ? void 0 : En.outputs) ? En.outputs.map((Rn) => le.Output.fromJSON(Rn)) : []
      };
    },
    toJSON(En) {
      const Rn = {};
      return En.inputs ? Rn.inputs = En.inputs.map((wa) => wa ? le.Input.toJSON(wa) : void 0) : Rn.inputs = [], En.outputs ? Rn.outputs = En.outputs.map((wa) => wa ? le.Output.toJSON(wa) : void 0) : Rn.outputs = [], Rn;
    },
    fromPartial(En) {
      var wa, Aa;
      const Rn = xe();
      return Rn.inputs = ((wa = En.inputs) == null ? void 0 : wa.map((_a) => le.Input.fromPartial(_a))) || [], Rn.outputs = ((Aa = En.outputs) == null ? void 0 : Aa.map((_a) => le.Output.fromPartial(_a))) || [], Rn;
    }
  };
  function $e() {
    return {};
  }
  v.MsgMultiSendResponse = {
    encode(En, Rn = he.Writer.create()) {
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = $e();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {};
    },
    toJSON(En) {
      return {};
    },
    fromPartial(En) {
      return $e();
    }
  };
  function Ne() {
    return {
      authority: "",
      params: void 0
    };
  }
  v.MsgUpdateParams = {
    encode(En, Rn = he.Writer.create()) {
      return En.authority !== "" && Rn.uint32(10).string(En.authority), En.params !== void 0 && le.Params.encode(En.params, Rn.uint32(18).fork()).ldelim(), Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = Ne();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          case 1:
            _a.authority = wa.string();
            break;
          case 2:
            _a.params = le.Params.decode(wa, wa.uint32());
            break;
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {
        authority: (0, ge.isSet)(En.authority) ? String(En.authority) : "",
        params: (0, ge.isSet)(En.params) ? le.Params.fromJSON(En.params) : void 0
      };
    },
    toJSON(En) {
      const Rn = {};
      return En.authority !== void 0 && (Rn.authority = En.authority), En.params !== void 0 && (Rn.params = En.params ? le.Params.toJSON(En.params) : void 0), Rn;
    },
    fromPartial(En) {
      const Rn = Ne();
      return Rn.authority = En.authority ?? "", Rn.params = En.params !== void 0 && En.params !== null ? le.Params.fromPartial(En.params) : void 0, Rn;
    }
  };
  function st() {
    return {};
  }
  v.MsgUpdateParamsResponse = {
    encode(En, Rn = he.Writer.create()) {
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = st();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {};
    },
    toJSON(En) {
      return {};
    },
    fromPartial(En) {
      return st();
    }
  };
  function Nr() {
    return {
      authority: "",
      sendEnabled: [],
      useDefaultFor: []
    };
  }
  v.MsgSetSendEnabled = {
    encode(En, Rn = he.Writer.create()) {
      En.authority !== "" && Rn.uint32(10).string(En.authority);
      for (const wa of En.sendEnabled)
        le.SendEnabled.encode(wa, Rn.uint32(18).fork()).ldelim();
      for (const wa of En.useDefaultFor)
        Rn.uint32(26).string(wa);
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = Nr();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          case 1:
            _a.authority = wa.string();
            break;
          case 2:
            _a.sendEnabled.push(le.SendEnabled.decode(wa, wa.uint32()));
            break;
          case 3:
            _a.useDefaultFor.push(wa.string());
            break;
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {
        authority: (0, ge.isSet)(En.authority) ? String(En.authority) : "",
        sendEnabled: Array.isArray(En == null ? void 0 : En.sendEnabled) ? En.sendEnabled.map((Rn) => le.SendEnabled.fromJSON(Rn)) : [],
        useDefaultFor: Array.isArray(En == null ? void 0 : En.useDefaultFor) ? En.useDefaultFor.map((Rn) => String(Rn)) : []
      };
    },
    toJSON(En) {
      const Rn = {};
      return En.authority !== void 0 && (Rn.authority = En.authority), En.sendEnabled ? Rn.sendEnabled = En.sendEnabled.map((wa) => wa ? le.SendEnabled.toJSON(wa) : void 0) : Rn.sendEnabled = [], En.useDefaultFor ? Rn.useDefaultFor = En.useDefaultFor.map((wa) => wa) : Rn.useDefaultFor = [], Rn;
    },
    fromPartial(En) {
      var wa, Aa;
      const Rn = Nr();
      return Rn.authority = En.authority ?? "", Rn.sendEnabled = ((wa = En.sendEnabled) == null ? void 0 : wa.map((_a) => le.SendEnabled.fromPartial(_a))) || [], Rn.useDefaultFor = ((Aa = En.useDefaultFor) == null ? void 0 : Aa.map((_a) => _a)) || [], Rn;
    }
  };
  function br() {
    return {};
  }
  v.MsgSetSendEnabledResponse = {
    encode(En, Rn = he.Writer.create()) {
      return Rn;
    },
    decode(En, Rn) {
      const wa = En instanceof he.Reader ? En : new he.Reader(En);
      let Aa = Rn === void 0 ? wa.len : wa.pos + Rn;
      const _a = br();
      for (; wa.pos < Aa; ) {
        const Ta = wa.uint32();
        switch (Ta >>> 3) {
          default:
            wa.skipType(Ta & 7);
            break;
        }
      }
      return _a;
    },
    fromJSON(En) {
      return {};
    },
    toJSON(En) {
      return {};
    },
    fromPartial(En) {
      return br();
    }
  };
  class $n {
    constructor(Rn) {
      this.rpc = Rn, this.Send = this.Send.bind(this), this.MultiSend = this.MultiSend.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(Rn) {
      const wa = v.MsgSend.encode(Rn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", wa).then((_a) => v.MsgSendResponse.decode(new he.Reader(_a)));
    }
    MultiSend(Rn) {
      const wa = v.MsgMultiSend.encode(Rn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", wa).then((_a) => v.MsgMultiSendResponse.decode(new he.Reader(_a)));
    }
    UpdateParams(Rn) {
      const wa = v.MsgUpdateParams.encode(Rn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", wa).then((_a) => v.MsgUpdateParamsResponse.decode(new he.Reader(_a)));
    }
    SetSendEnabled(Rn) {
      const wa = v.MsgSetSendEnabled.encode(Rn).finish();
      return this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", wa).then((_a) => v.MsgSetSendEnabledResponse.decode(new he.Reader(_a)));
    }
  }
  v.MsgClientImpl = $n;
})(tx$2);
var tx$1 = {}, types$2 = {};
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(_a, Ta, Zn, Ra) {
    Ra === void 0 && (Ra = Zn);
    var Yn = Object.getOwnPropertyDescriptor(Ta, Zn);
    (!Yn || ("get" in Yn ? !Ta.__esModule : Yn.writable || Yn.configurable)) && (Yn = { enumerable: !0, get: function() {
      return Ta[Zn];
    } }), Object.defineProperty(_a, Ra, Yn);
  } : function(_a, Ta, Zn, Ra) {
    Ra === void 0 && (Ra = Zn), _a[Ra] = Ta[Zn];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(_a, Ta) {
    Object.defineProperty(_a, "default", { enumerable: !0, value: Ta });
  } : function(_a, Ta) {
    _a.default = Ta;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(_a) {
    if (_a && _a.__esModule)
      return _a;
    var Ta = {};
    if (_a != null)
      for (var Zn in _a)
        Zn !== "default" && Object.prototype.hasOwnProperty.call(_a, Zn) && y(Ta, _a, Zn);
    return z(Ta, _a), Ta;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.Model = v.AbsoluteTxPosition = v.ContractCodeHistoryEntry = v.ContractInfo = v.CodeInfo = v.Params = v.AccessConfig = v.AccessTypeParam = v.contractCodeHistoryOperationTypeToJSON = v.contractCodeHistoryOperationTypeFromJSON = v.ContractCodeHistoryOperationType = v.accessTypeToJSON = v.accessTypeFromJSON = v.AccessType = v.protobufPackage = void 0;
  const ue = any, le = helpers, he = ne(minimal);
  v.protobufPackage = "cosmwasm.wasm.v1";
  var ge;
  (function(_a) {
    _a[_a.ACCESS_TYPE_UNSPECIFIED = 0] = "ACCESS_TYPE_UNSPECIFIED", _a[_a.ACCESS_TYPE_NOBODY = 1] = "ACCESS_TYPE_NOBODY", _a[_a.ACCESS_TYPE_ONLY_ADDRESS = 2] = "ACCESS_TYPE_ONLY_ADDRESS", _a[_a.ACCESS_TYPE_EVERYBODY = 3] = "ACCESS_TYPE_EVERYBODY", _a[_a.ACCESS_TYPE_ANY_OF_ADDRESSES = 4] = "ACCESS_TYPE_ANY_OF_ADDRESSES", _a[_a.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(ge = v.AccessType || (v.AccessType = {}));
  function we(_a) {
    switch (_a) {
      case 0:
      case "ACCESS_TYPE_UNSPECIFIED":
        return ge.ACCESS_TYPE_UNSPECIFIED;
      case 1:
      case "ACCESS_TYPE_NOBODY":
        return ge.ACCESS_TYPE_NOBODY;
      case 2:
      case "ACCESS_TYPE_ONLY_ADDRESS":
        return ge.ACCESS_TYPE_ONLY_ADDRESS;
      case 3:
      case "ACCESS_TYPE_EVERYBODY":
        return ge.ACCESS_TYPE_EVERYBODY;
      case 4:
      case "ACCESS_TYPE_ANY_OF_ADDRESSES":
        return ge.ACCESS_TYPE_ANY_OF_ADDRESSES;
      case -1:
      case "UNRECOGNIZED":
      default:
        return ge.UNRECOGNIZED;
    }
  }
  v.accessTypeFromJSON = we;
  function Ee(_a) {
    switch (_a) {
      case ge.ACCESS_TYPE_UNSPECIFIED:
        return "ACCESS_TYPE_UNSPECIFIED";
      case ge.ACCESS_TYPE_NOBODY:
        return "ACCESS_TYPE_NOBODY";
      case ge.ACCESS_TYPE_ONLY_ADDRESS:
        return "ACCESS_TYPE_ONLY_ADDRESS";
      case ge.ACCESS_TYPE_EVERYBODY:
        return "ACCESS_TYPE_EVERYBODY";
      case ge.ACCESS_TYPE_ANY_OF_ADDRESSES:
        return "ACCESS_TYPE_ANY_OF_ADDRESSES";
      case ge.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  v.accessTypeToJSON = Ee;
  var xe;
  (function(_a) {
    _a[_a.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED", _a[_a.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT", _a[_a.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE", _a[_a.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS", _a[_a.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(xe = v.ContractCodeHistoryOperationType || (v.ContractCodeHistoryOperationType = {}));
  function $e(_a) {
    switch (_a) {
      case 0:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
        return xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
      case 1:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
        return xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
      case 2:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
        return xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
      case 3:
      case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
        return xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
      case -1:
      case "UNRECOGNIZED":
      default:
        return xe.UNRECOGNIZED;
    }
  }
  v.contractCodeHistoryOperationTypeFromJSON = $e;
  function Ne(_a) {
    switch (_a) {
      case xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
      case xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
      case xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
      case xe.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
        return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
      case xe.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  v.contractCodeHistoryOperationTypeToJSON = Ne;
  function st() {
    return {
      value: 0
    };
  }
  v.AccessTypeParam = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.value !== 0 && Ta.uint32(8).int32(_a.value), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = st();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.value = Zn.int32();
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        value: (0, le.isSet)(_a.value) ? we(_a.value) : 0
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.value !== void 0 && (Ta.value = Ee(_a.value)), Ta;
    },
    fromPartial(_a) {
      const Ta = st();
      return Ta.value = _a.value ?? 0, Ta;
    }
  };
  function Nr() {
    return {
      permission: 0,
      address: "",
      addresses: []
    };
  }
  v.AccessConfig = {
    encode(_a, Ta = he.Writer.create()) {
      _a.permission !== 0 && Ta.uint32(8).int32(_a.permission), _a.address !== "" && Ta.uint32(18).string(_a.address);
      for (const Zn of _a.addresses)
        Ta.uint32(26).string(Zn);
      return Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = Nr();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.permission = Zn.int32();
            break;
          case 2:
            Yn.address = Zn.string();
            break;
          case 3:
            Yn.addresses.push(Zn.string());
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        permission: (0, le.isSet)(_a.permission) ? we(_a.permission) : 0,
        address: (0, le.isSet)(_a.address) ? String(_a.address) : "",
        addresses: Array.isArray(_a == null ? void 0 : _a.addresses) ? _a.addresses.map((Ta) => String(Ta)) : []
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.permission !== void 0 && (Ta.permission = Ee(_a.permission)), _a.address !== void 0 && (Ta.address = _a.address), _a.addresses ? Ta.addresses = _a.addresses.map((Zn) => Zn) : Ta.addresses = [], Ta;
    },
    fromPartial(_a) {
      var Zn;
      const Ta = Nr();
      return Ta.permission = _a.permission ?? 0, Ta.address = _a.address ?? "", Ta.addresses = ((Zn = _a.addresses) == null ? void 0 : Zn.map((Ra) => Ra)) || [], Ta;
    }
  };
  function br() {
    return {
      codeUploadAccess: void 0,
      instantiateDefaultPermission: 0
    };
  }
  v.Params = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.codeUploadAccess !== void 0 && v.AccessConfig.encode(_a.codeUploadAccess, Ta.uint32(10).fork()).ldelim(), _a.instantiateDefaultPermission !== 0 && Ta.uint32(16).int32(_a.instantiateDefaultPermission), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = br();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.codeUploadAccess = v.AccessConfig.decode(Zn, Zn.uint32());
            break;
          case 2:
            Yn.instantiateDefaultPermission = Zn.int32();
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        codeUploadAccess: (0, le.isSet)(_a.codeUploadAccess) ? v.AccessConfig.fromJSON(_a.codeUploadAccess) : void 0,
        instantiateDefaultPermission: (0, le.isSet)(_a.instantiateDefaultPermission) ? we(_a.instantiateDefaultPermission) : 0
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.codeUploadAccess !== void 0 && (Ta.codeUploadAccess = _a.codeUploadAccess ? v.AccessConfig.toJSON(_a.codeUploadAccess) : void 0), _a.instantiateDefaultPermission !== void 0 && (Ta.instantiateDefaultPermission = Ee(_a.instantiateDefaultPermission)), Ta;
    },
    fromPartial(_a) {
      const Ta = br();
      return Ta.codeUploadAccess = _a.codeUploadAccess !== void 0 && _a.codeUploadAccess !== null ? v.AccessConfig.fromPartial(_a.codeUploadAccess) : void 0, Ta.instantiateDefaultPermission = _a.instantiateDefaultPermission ?? 0, Ta;
    }
  };
  function $n() {
    return {
      codeHash: new Uint8Array(),
      creator: "",
      instantiateConfig: void 0
    };
  }
  v.CodeInfo = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.codeHash.length !== 0 && Ta.uint32(10).bytes(_a.codeHash), _a.creator !== "" && Ta.uint32(18).string(_a.creator), _a.instantiateConfig !== void 0 && v.AccessConfig.encode(_a.instantiateConfig, Ta.uint32(42).fork()).ldelim(), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = $n();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.codeHash = Zn.bytes();
            break;
          case 2:
            Yn.creator = Zn.string();
            break;
          case 5:
            Yn.instantiateConfig = v.AccessConfig.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        codeHash: (0, le.isSet)(_a.codeHash) ? (0, le.bytesFromBase64)(_a.codeHash) : new Uint8Array(),
        creator: (0, le.isSet)(_a.creator) ? String(_a.creator) : "",
        instantiateConfig: (0, le.isSet)(_a.instantiateConfig) ? v.AccessConfig.fromJSON(_a.instantiateConfig) : void 0
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.codeHash !== void 0 && (Ta.codeHash = (0, le.base64FromBytes)(_a.codeHash !== void 0 ? _a.codeHash : new Uint8Array())), _a.creator !== void 0 && (Ta.creator = _a.creator), _a.instantiateConfig !== void 0 && (Ta.instantiateConfig = _a.instantiateConfig ? v.AccessConfig.toJSON(_a.instantiateConfig) : void 0), Ta;
    },
    fromPartial(_a) {
      const Ta = $n();
      return Ta.codeHash = _a.codeHash ?? new Uint8Array(), Ta.creator = _a.creator ?? "", Ta.instantiateConfig = _a.instantiateConfig !== void 0 && _a.instantiateConfig !== null ? v.AccessConfig.fromPartial(_a.instantiateConfig) : void 0, Ta;
    }
  };
  function En() {
    return {
      codeId: le.Long.UZERO,
      creator: "",
      admin: "",
      label: "",
      created: void 0,
      ibcPortId: "",
      extension: void 0
    };
  }
  v.ContractInfo = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.codeId.isZero() || Ta.uint32(8).uint64(_a.codeId), _a.creator !== "" && Ta.uint32(18).string(_a.creator), _a.admin !== "" && Ta.uint32(26).string(_a.admin), _a.label !== "" && Ta.uint32(34).string(_a.label), _a.created !== void 0 && v.AbsoluteTxPosition.encode(_a.created, Ta.uint32(42).fork()).ldelim(), _a.ibcPortId !== "" && Ta.uint32(50).string(_a.ibcPortId), _a.extension !== void 0 && ue.Any.encode(_a.extension, Ta.uint32(58).fork()).ldelim(), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = En();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.codeId = Zn.uint64();
            break;
          case 2:
            Yn.creator = Zn.string();
            break;
          case 3:
            Yn.admin = Zn.string();
            break;
          case 4:
            Yn.label = Zn.string();
            break;
          case 5:
            Yn.created = v.AbsoluteTxPosition.decode(Zn, Zn.uint32());
            break;
          case 6:
            Yn.ibcPortId = Zn.string();
            break;
          case 7:
            Yn.extension = ue.Any.decode(Zn, Zn.uint32());
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        codeId: (0, le.isSet)(_a.codeId) ? le.Long.fromValue(_a.codeId) : le.Long.UZERO,
        creator: (0, le.isSet)(_a.creator) ? String(_a.creator) : "",
        admin: (0, le.isSet)(_a.admin) ? String(_a.admin) : "",
        label: (0, le.isSet)(_a.label) ? String(_a.label) : "",
        created: (0, le.isSet)(_a.created) ? v.AbsoluteTxPosition.fromJSON(_a.created) : void 0,
        ibcPortId: (0, le.isSet)(_a.ibcPortId) ? String(_a.ibcPortId) : "",
        extension: (0, le.isSet)(_a.extension) ? ue.Any.fromJSON(_a.extension) : void 0
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.codeId !== void 0 && (Ta.codeId = (_a.codeId || le.Long.UZERO).toString()), _a.creator !== void 0 && (Ta.creator = _a.creator), _a.admin !== void 0 && (Ta.admin = _a.admin), _a.label !== void 0 && (Ta.label = _a.label), _a.created !== void 0 && (Ta.created = _a.created ? v.AbsoluteTxPosition.toJSON(_a.created) : void 0), _a.ibcPortId !== void 0 && (Ta.ibcPortId = _a.ibcPortId), _a.extension !== void 0 && (Ta.extension = _a.extension ? ue.Any.toJSON(_a.extension) : void 0), Ta;
    },
    fromPartial(_a) {
      const Ta = En();
      return Ta.codeId = _a.codeId !== void 0 && _a.codeId !== null ? le.Long.fromValue(_a.codeId) : le.Long.UZERO, Ta.creator = _a.creator ?? "", Ta.admin = _a.admin ?? "", Ta.label = _a.label ?? "", Ta.created = _a.created !== void 0 && _a.created !== null ? v.AbsoluteTxPosition.fromPartial(_a.created) : void 0, Ta.ibcPortId = _a.ibcPortId ?? "", Ta.extension = _a.extension !== void 0 && _a.extension !== null ? ue.Any.fromPartial(_a.extension) : void 0, Ta;
    }
  };
  function Rn() {
    return {
      operation: 0,
      codeId: le.Long.UZERO,
      updated: void 0,
      msg: new Uint8Array()
    };
  }
  v.ContractCodeHistoryEntry = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.operation !== 0 && Ta.uint32(8).int32(_a.operation), _a.codeId.isZero() || Ta.uint32(16).uint64(_a.codeId), _a.updated !== void 0 && v.AbsoluteTxPosition.encode(_a.updated, Ta.uint32(26).fork()).ldelim(), _a.msg.length !== 0 && Ta.uint32(34).bytes(_a.msg), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = Rn();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.operation = Zn.int32();
            break;
          case 2:
            Yn.codeId = Zn.uint64();
            break;
          case 3:
            Yn.updated = v.AbsoluteTxPosition.decode(Zn, Zn.uint32());
            break;
          case 4:
            Yn.msg = Zn.bytes();
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        operation: (0, le.isSet)(_a.operation) ? $e(_a.operation) : 0,
        codeId: (0, le.isSet)(_a.codeId) ? le.Long.fromValue(_a.codeId) : le.Long.UZERO,
        updated: (0, le.isSet)(_a.updated) ? v.AbsoluteTxPosition.fromJSON(_a.updated) : void 0,
        msg: (0, le.isSet)(_a.msg) ? (0, le.bytesFromBase64)(_a.msg) : new Uint8Array()
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.operation !== void 0 && (Ta.operation = Ne(_a.operation)), _a.codeId !== void 0 && (Ta.codeId = (_a.codeId || le.Long.UZERO).toString()), _a.updated !== void 0 && (Ta.updated = _a.updated ? v.AbsoluteTxPosition.toJSON(_a.updated) : void 0), _a.msg !== void 0 && (Ta.msg = (0, le.base64FromBytes)(_a.msg !== void 0 ? _a.msg : new Uint8Array())), Ta;
    },
    fromPartial(_a) {
      const Ta = Rn();
      return Ta.operation = _a.operation ?? 0, Ta.codeId = _a.codeId !== void 0 && _a.codeId !== null ? le.Long.fromValue(_a.codeId) : le.Long.UZERO, Ta.updated = _a.updated !== void 0 && _a.updated !== null ? v.AbsoluteTxPosition.fromPartial(_a.updated) : void 0, Ta.msg = _a.msg ?? new Uint8Array(), Ta;
    }
  };
  function wa() {
    return {
      blockHeight: le.Long.UZERO,
      txIndex: le.Long.UZERO
    };
  }
  v.AbsoluteTxPosition = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.blockHeight.isZero() || Ta.uint32(8).uint64(_a.blockHeight), _a.txIndex.isZero() || Ta.uint32(16).uint64(_a.txIndex), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = wa();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.blockHeight = Zn.uint64();
            break;
          case 2:
            Yn.txIndex = Zn.uint64();
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        blockHeight: (0, le.isSet)(_a.blockHeight) ? le.Long.fromValue(_a.blockHeight) : le.Long.UZERO,
        txIndex: (0, le.isSet)(_a.txIndex) ? le.Long.fromValue(_a.txIndex) : le.Long.UZERO
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.blockHeight !== void 0 && (Ta.blockHeight = (_a.blockHeight || le.Long.UZERO).toString()), _a.txIndex !== void 0 && (Ta.txIndex = (_a.txIndex || le.Long.UZERO).toString()), Ta;
    },
    fromPartial(_a) {
      const Ta = wa();
      return Ta.blockHeight = _a.blockHeight !== void 0 && _a.blockHeight !== null ? le.Long.fromValue(_a.blockHeight) : le.Long.UZERO, Ta.txIndex = _a.txIndex !== void 0 && _a.txIndex !== null ? le.Long.fromValue(_a.txIndex) : le.Long.UZERO, Ta;
    }
  };
  function Aa() {
    return {
      key: new Uint8Array(),
      value: new Uint8Array()
    };
  }
  v.Model = {
    encode(_a, Ta = he.Writer.create()) {
      return _a.key.length !== 0 && Ta.uint32(10).bytes(_a.key), _a.value.length !== 0 && Ta.uint32(18).bytes(_a.value), Ta;
    },
    decode(_a, Ta) {
      const Zn = _a instanceof he.Reader ? _a : new he.Reader(_a);
      let Ra = Ta === void 0 ? Zn.len : Zn.pos + Ta;
      const Yn = Aa();
      for (; Zn.pos < Ra; ) {
        const $o = Zn.uint32();
        switch ($o >>> 3) {
          case 1:
            Yn.key = Zn.bytes();
            break;
          case 2:
            Yn.value = Zn.bytes();
            break;
          default:
            Zn.skipType($o & 7);
            break;
        }
      }
      return Yn;
    },
    fromJSON(_a) {
      return {
        key: (0, le.isSet)(_a.key) ? (0, le.bytesFromBase64)(_a.key) : new Uint8Array(),
        value: (0, le.isSet)(_a.value) ? (0, le.bytesFromBase64)(_a.value) : new Uint8Array()
      };
    },
    toJSON(_a) {
      const Ta = {};
      return _a.key !== void 0 && (Ta.key = (0, le.base64FromBytes)(_a.key !== void 0 ? _a.key : new Uint8Array())), _a.value !== void 0 && (Ta.value = (0, le.base64FromBytes)(_a.value !== void 0 ? _a.value : new Uint8Array())), Ta;
    },
    fromPartial(_a) {
      const Ta = Aa();
      return Ta.key = _a.key ?? new Uint8Array(), Ta.value = _a.value ?? new Uint8Array(), Ta;
    }
  };
})(types$2);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Yn, $o, ct, fe) {
    fe === void 0 && (fe = ct);
    var be = Object.getOwnPropertyDescriptor($o, ct);
    (!be || ("get" in be ? !$o.__esModule : be.writable || be.configurable)) && (be = { enumerable: !0, get: function() {
      return $o[ct];
    } }), Object.defineProperty(Yn, fe, be);
  } : function(Yn, $o, ct, fe) {
    fe === void 0 && (fe = ct), Yn[fe] = $o[ct];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Yn, $o) {
    Object.defineProperty(Yn, "default", { enumerable: !0, value: $o });
  } : function(Yn, $o) {
    Yn.default = $o;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(Yn) {
    if (Yn && Yn.__esModule)
      return Yn;
    var $o = {};
    if (Yn != null)
      for (var ct in Yn)
        ct !== "default" && Object.prototype.hasOwnProperty.call(Yn, ct) && y($o, Yn, ct);
    return z($o, Yn), $o;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.MsgClientImpl = v.MsgUpdateInstantiateConfigResponse = v.MsgUpdateInstantiateConfig = v.MsgClearAdminResponse = v.MsgClearAdmin = v.MsgUpdateAdminResponse = v.MsgUpdateAdmin = v.MsgMigrateContractResponse = v.MsgMigrateContract = v.MsgExecuteContractResponse = v.MsgExecuteContract = v.MsgInstantiateContract2Response = v.MsgInstantiateContractResponse = v.MsgInstantiateContract2 = v.MsgInstantiateContract = v.MsgStoreCodeResponse = v.MsgStoreCode = v.protobufPackage = void 0;
  const ue = types$2, le = coin$1, he = helpers, ge = ne(minimal);
  v.protobufPackage = "cosmwasm.wasm.v1";
  function we() {
    return {
      sender: "",
      wasmByteCode: new Uint8Array(),
      instantiatePermission: void 0
    };
  }
  v.MsgStoreCode = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.wasmByteCode.length !== 0 && $o.uint32(18).bytes(Yn.wasmByteCode), Yn.instantiatePermission !== void 0 && ue.AccessConfig.encode(Yn.instantiatePermission, $o.uint32(42).fork()).ldelim(), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = we();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.wasmByteCode = ct.bytes();
            break;
          case 5:
            be.instantiatePermission = ue.AccessConfig.decode(ct, ct.uint32());
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        wasmByteCode: (0, he.isSet)(Yn.wasmByteCode) ? (0, he.bytesFromBase64)(Yn.wasmByteCode) : new Uint8Array(),
        instantiatePermission: (0, he.isSet)(Yn.instantiatePermission) ? ue.AccessConfig.fromJSON(Yn.instantiatePermission) : void 0
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.wasmByteCode !== void 0 && ($o.wasmByteCode = (0, he.base64FromBytes)(Yn.wasmByteCode !== void 0 ? Yn.wasmByteCode : new Uint8Array())), Yn.instantiatePermission !== void 0 && ($o.instantiatePermission = Yn.instantiatePermission ? ue.AccessConfig.toJSON(Yn.instantiatePermission) : void 0), $o;
    },
    fromPartial(Yn) {
      const $o = we();
      return $o.sender = Yn.sender ?? "", $o.wasmByteCode = Yn.wasmByteCode ?? new Uint8Array(), $o.instantiatePermission = Yn.instantiatePermission !== void 0 && Yn.instantiatePermission !== null ? ue.AccessConfig.fromPartial(Yn.instantiatePermission) : void 0, $o;
    }
  };
  function Ee() {
    return {
      codeId: he.Long.UZERO,
      checksum: new Uint8Array()
    };
  }
  v.MsgStoreCodeResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.codeId.isZero() || $o.uint32(8).uint64(Yn.codeId), Yn.checksum.length !== 0 && $o.uint32(18).bytes(Yn.checksum), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Ee();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.codeId = ct.uint64();
            break;
          case 2:
            be.checksum = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        codeId: (0, he.isSet)(Yn.codeId) ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO,
        checksum: (0, he.isSet)(Yn.checksum) ? (0, he.bytesFromBase64)(Yn.checksum) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.codeId !== void 0 && ($o.codeId = (Yn.codeId || he.Long.UZERO).toString()), Yn.checksum !== void 0 && ($o.checksum = (0, he.base64FromBytes)(Yn.checksum !== void 0 ? Yn.checksum : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = Ee();
      return $o.codeId = Yn.codeId !== void 0 && Yn.codeId !== null ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO, $o.checksum = Yn.checksum ?? new Uint8Array(), $o;
    }
  };
  function xe() {
    return {
      sender: "",
      admin: "",
      codeId: he.Long.UZERO,
      label: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  v.MsgInstantiateContract = {
    encode(Yn, $o = ge.Writer.create()) {
      Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.admin !== "" && $o.uint32(18).string(Yn.admin), Yn.codeId.isZero() || $o.uint32(24).uint64(Yn.codeId), Yn.label !== "" && $o.uint32(34).string(Yn.label), Yn.msg.length !== 0 && $o.uint32(42).bytes(Yn.msg);
      for (const ct of Yn.funds)
        le.Coin.encode(ct, $o.uint32(50).fork()).ldelim();
      return $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = xe();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.admin = ct.string();
            break;
          case 3:
            be.codeId = ct.uint64();
            break;
          case 4:
            be.label = ct.string();
            break;
          case 5:
            be.msg = ct.bytes();
            break;
          case 6:
            be.funds.push(le.Coin.decode(ct, ct.uint32()));
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        admin: (0, he.isSet)(Yn.admin) ? String(Yn.admin) : "",
        codeId: (0, he.isSet)(Yn.codeId) ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO,
        label: (0, he.isSet)(Yn.label) ? String(Yn.label) : "",
        msg: (0, he.isSet)(Yn.msg) ? (0, he.bytesFromBase64)(Yn.msg) : new Uint8Array(),
        funds: Array.isArray(Yn == null ? void 0 : Yn.funds) ? Yn.funds.map(($o) => le.Coin.fromJSON($o)) : []
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.admin !== void 0 && ($o.admin = Yn.admin), Yn.codeId !== void 0 && ($o.codeId = (Yn.codeId || he.Long.UZERO).toString()), Yn.label !== void 0 && ($o.label = Yn.label), Yn.msg !== void 0 && ($o.msg = (0, he.base64FromBytes)(Yn.msg !== void 0 ? Yn.msg : new Uint8Array())), Yn.funds ? $o.funds = Yn.funds.map((ct) => ct ? le.Coin.toJSON(ct) : void 0) : $o.funds = [], $o;
    },
    fromPartial(Yn) {
      var ct;
      const $o = xe();
      return $o.sender = Yn.sender ?? "", $o.admin = Yn.admin ?? "", $o.codeId = Yn.codeId !== void 0 && Yn.codeId !== null ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO, $o.label = Yn.label ?? "", $o.msg = Yn.msg ?? new Uint8Array(), $o.funds = ((ct = Yn.funds) == null ? void 0 : ct.map((fe) => le.Coin.fromPartial(fe))) || [], $o;
    }
  };
  function $e() {
    return {
      sender: "",
      admin: "",
      codeId: he.Long.UZERO,
      label: "",
      msg: new Uint8Array(),
      funds: [],
      salt: new Uint8Array(),
      fixMsg: !1
    };
  }
  v.MsgInstantiateContract2 = {
    encode(Yn, $o = ge.Writer.create()) {
      Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.admin !== "" && $o.uint32(18).string(Yn.admin), Yn.codeId.isZero() || $o.uint32(24).uint64(Yn.codeId), Yn.label !== "" && $o.uint32(34).string(Yn.label), Yn.msg.length !== 0 && $o.uint32(42).bytes(Yn.msg);
      for (const ct of Yn.funds)
        le.Coin.encode(ct, $o.uint32(50).fork()).ldelim();
      return Yn.salt.length !== 0 && $o.uint32(58).bytes(Yn.salt), Yn.fixMsg === !0 && $o.uint32(64).bool(Yn.fixMsg), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = $e();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.admin = ct.string();
            break;
          case 3:
            be.codeId = ct.uint64();
            break;
          case 4:
            be.label = ct.string();
            break;
          case 5:
            be.msg = ct.bytes();
            break;
          case 6:
            be.funds.push(le.Coin.decode(ct, ct.uint32()));
            break;
          case 7:
            be.salt = ct.bytes();
            break;
          case 8:
            be.fixMsg = ct.bool();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        admin: (0, he.isSet)(Yn.admin) ? String(Yn.admin) : "",
        codeId: (0, he.isSet)(Yn.codeId) ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO,
        label: (0, he.isSet)(Yn.label) ? String(Yn.label) : "",
        msg: (0, he.isSet)(Yn.msg) ? (0, he.bytesFromBase64)(Yn.msg) : new Uint8Array(),
        funds: Array.isArray(Yn == null ? void 0 : Yn.funds) ? Yn.funds.map(($o) => le.Coin.fromJSON($o)) : [],
        salt: (0, he.isSet)(Yn.salt) ? (0, he.bytesFromBase64)(Yn.salt) : new Uint8Array(),
        fixMsg: (0, he.isSet)(Yn.fixMsg) ? !!Yn.fixMsg : !1
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.admin !== void 0 && ($o.admin = Yn.admin), Yn.codeId !== void 0 && ($o.codeId = (Yn.codeId || he.Long.UZERO).toString()), Yn.label !== void 0 && ($o.label = Yn.label), Yn.msg !== void 0 && ($o.msg = (0, he.base64FromBytes)(Yn.msg !== void 0 ? Yn.msg : new Uint8Array())), Yn.funds ? $o.funds = Yn.funds.map((ct) => ct ? le.Coin.toJSON(ct) : void 0) : $o.funds = [], Yn.salt !== void 0 && ($o.salt = (0, he.base64FromBytes)(Yn.salt !== void 0 ? Yn.salt : new Uint8Array())), Yn.fixMsg !== void 0 && ($o.fixMsg = Yn.fixMsg), $o;
    },
    fromPartial(Yn) {
      var ct;
      const $o = $e();
      return $o.sender = Yn.sender ?? "", $o.admin = Yn.admin ?? "", $o.codeId = Yn.codeId !== void 0 && Yn.codeId !== null ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO, $o.label = Yn.label ?? "", $o.msg = Yn.msg ?? new Uint8Array(), $o.funds = ((ct = Yn.funds) == null ? void 0 : ct.map((fe) => le.Coin.fromPartial(fe))) || [], $o.salt = Yn.salt ?? new Uint8Array(), $o.fixMsg = Yn.fixMsg ?? !1, $o;
    }
  };
  function Ne() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  v.MsgInstantiateContractResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.address !== "" && $o.uint32(10).string(Yn.address), Yn.data.length !== 0 && $o.uint32(18).bytes(Yn.data), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Ne();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.address = ct.string();
            break;
          case 2:
            be.data = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        address: (0, he.isSet)(Yn.address) ? String(Yn.address) : "",
        data: (0, he.isSet)(Yn.data) ? (0, he.bytesFromBase64)(Yn.data) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.address !== void 0 && ($o.address = Yn.address), Yn.data !== void 0 && ($o.data = (0, he.base64FromBytes)(Yn.data !== void 0 ? Yn.data : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = Ne();
      return $o.address = Yn.address ?? "", $o.data = Yn.data ?? new Uint8Array(), $o;
    }
  };
  function st() {
    return {
      address: "",
      data: new Uint8Array()
    };
  }
  v.MsgInstantiateContract2Response = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.address !== "" && $o.uint32(10).string(Yn.address), Yn.data.length !== 0 && $o.uint32(18).bytes(Yn.data), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = st();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.address = ct.string();
            break;
          case 2:
            be.data = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        address: (0, he.isSet)(Yn.address) ? String(Yn.address) : "",
        data: (0, he.isSet)(Yn.data) ? (0, he.bytesFromBase64)(Yn.data) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.address !== void 0 && ($o.address = Yn.address), Yn.data !== void 0 && ($o.data = (0, he.base64FromBytes)(Yn.data !== void 0 ? Yn.data : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = st();
      return $o.address = Yn.address ?? "", $o.data = Yn.data ?? new Uint8Array(), $o;
    }
  };
  function Nr() {
    return {
      sender: "",
      contract: "",
      msg: new Uint8Array(),
      funds: []
    };
  }
  v.MsgExecuteContract = {
    encode(Yn, $o = ge.Writer.create()) {
      Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.contract !== "" && $o.uint32(18).string(Yn.contract), Yn.msg.length !== 0 && $o.uint32(26).bytes(Yn.msg);
      for (const ct of Yn.funds)
        le.Coin.encode(ct, $o.uint32(42).fork()).ldelim();
      return $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Nr();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.contract = ct.string();
            break;
          case 3:
            be.msg = ct.bytes();
            break;
          case 5:
            be.funds.push(le.Coin.decode(ct, ct.uint32()));
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        contract: (0, he.isSet)(Yn.contract) ? String(Yn.contract) : "",
        msg: (0, he.isSet)(Yn.msg) ? (0, he.bytesFromBase64)(Yn.msg) : new Uint8Array(),
        funds: Array.isArray(Yn == null ? void 0 : Yn.funds) ? Yn.funds.map(($o) => le.Coin.fromJSON($o)) : []
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.contract !== void 0 && ($o.contract = Yn.contract), Yn.msg !== void 0 && ($o.msg = (0, he.base64FromBytes)(Yn.msg !== void 0 ? Yn.msg : new Uint8Array())), Yn.funds ? $o.funds = Yn.funds.map((ct) => ct ? le.Coin.toJSON(ct) : void 0) : $o.funds = [], $o;
    },
    fromPartial(Yn) {
      var ct;
      const $o = Nr();
      return $o.sender = Yn.sender ?? "", $o.contract = Yn.contract ?? "", $o.msg = Yn.msg ?? new Uint8Array(), $o.funds = ((ct = Yn.funds) == null ? void 0 : ct.map((fe) => le.Coin.fromPartial(fe))) || [], $o;
    }
  };
  function br() {
    return {
      data: new Uint8Array()
    };
  }
  v.MsgExecuteContractResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.data.length !== 0 && $o.uint32(10).bytes(Yn.data), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = br();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.data = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        data: (0, he.isSet)(Yn.data) ? (0, he.bytesFromBase64)(Yn.data) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.data !== void 0 && ($o.data = (0, he.base64FromBytes)(Yn.data !== void 0 ? Yn.data : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = br();
      return $o.data = Yn.data ?? new Uint8Array(), $o;
    }
  };
  function $n() {
    return {
      sender: "",
      contract: "",
      codeId: he.Long.UZERO,
      msg: new Uint8Array()
    };
  }
  v.MsgMigrateContract = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.contract !== "" && $o.uint32(18).string(Yn.contract), Yn.codeId.isZero() || $o.uint32(24).uint64(Yn.codeId), Yn.msg.length !== 0 && $o.uint32(34).bytes(Yn.msg), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = $n();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.contract = ct.string();
            break;
          case 3:
            be.codeId = ct.uint64();
            break;
          case 4:
            be.msg = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        contract: (0, he.isSet)(Yn.contract) ? String(Yn.contract) : "",
        codeId: (0, he.isSet)(Yn.codeId) ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO,
        msg: (0, he.isSet)(Yn.msg) ? (0, he.bytesFromBase64)(Yn.msg) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.contract !== void 0 && ($o.contract = Yn.contract), Yn.codeId !== void 0 && ($o.codeId = (Yn.codeId || he.Long.UZERO).toString()), Yn.msg !== void 0 && ($o.msg = (0, he.base64FromBytes)(Yn.msg !== void 0 ? Yn.msg : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = $n();
      return $o.sender = Yn.sender ?? "", $o.contract = Yn.contract ?? "", $o.codeId = Yn.codeId !== void 0 && Yn.codeId !== null ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO, $o.msg = Yn.msg ?? new Uint8Array(), $o;
    }
  };
  function En() {
    return {
      data: new Uint8Array()
    };
  }
  v.MsgMigrateContractResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.data.length !== 0 && $o.uint32(10).bytes(Yn.data), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = En();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.data = ct.bytes();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        data: (0, he.isSet)(Yn.data) ? (0, he.bytesFromBase64)(Yn.data) : new Uint8Array()
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.data !== void 0 && ($o.data = (0, he.base64FromBytes)(Yn.data !== void 0 ? Yn.data : new Uint8Array())), $o;
    },
    fromPartial(Yn) {
      const $o = En();
      return $o.data = Yn.data ?? new Uint8Array(), $o;
    }
  };
  function Rn() {
    return {
      sender: "",
      newAdmin: "",
      contract: ""
    };
  }
  v.MsgUpdateAdmin = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.newAdmin !== "" && $o.uint32(18).string(Yn.newAdmin), Yn.contract !== "" && $o.uint32(26).string(Yn.contract), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Rn();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.newAdmin = ct.string();
            break;
          case 3:
            be.contract = ct.string();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        newAdmin: (0, he.isSet)(Yn.newAdmin) ? String(Yn.newAdmin) : "",
        contract: (0, he.isSet)(Yn.contract) ? String(Yn.contract) : ""
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.newAdmin !== void 0 && ($o.newAdmin = Yn.newAdmin), Yn.contract !== void 0 && ($o.contract = Yn.contract), $o;
    },
    fromPartial(Yn) {
      const $o = Rn();
      return $o.sender = Yn.sender ?? "", $o.newAdmin = Yn.newAdmin ?? "", $o.contract = Yn.contract ?? "", $o;
    }
  };
  function wa() {
    return {};
  }
  v.MsgUpdateAdminResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = wa();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {};
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return wa();
    }
  };
  function Aa() {
    return {
      sender: "",
      contract: ""
    };
  }
  v.MsgClearAdmin = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.contract !== "" && $o.uint32(26).string(Yn.contract), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Aa();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 3:
            be.contract = ct.string();
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        contract: (0, he.isSet)(Yn.contract) ? String(Yn.contract) : ""
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.contract !== void 0 && ($o.contract = Yn.contract), $o;
    },
    fromPartial(Yn) {
      const $o = Aa();
      return $o.sender = Yn.sender ?? "", $o.contract = Yn.contract ?? "", $o;
    }
  };
  function _a() {
    return {};
  }
  v.MsgClearAdminResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = _a();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {};
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return _a();
    }
  };
  function Ta() {
    return {
      sender: "",
      codeId: he.Long.UZERO,
      newInstantiatePermission: void 0
    };
  }
  v.MsgUpdateInstantiateConfig = {
    encode(Yn, $o = ge.Writer.create()) {
      return Yn.sender !== "" && $o.uint32(10).string(Yn.sender), Yn.codeId.isZero() || $o.uint32(16).uint64(Yn.codeId), Yn.newInstantiatePermission !== void 0 && ue.AccessConfig.encode(Yn.newInstantiatePermission, $o.uint32(26).fork()).ldelim(), $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Ta();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          case 1:
            be.sender = ct.string();
            break;
          case 2:
            be.codeId = ct.uint64();
            break;
          case 3:
            be.newInstantiatePermission = ue.AccessConfig.decode(ct, ct.uint32());
            break;
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {
        sender: (0, he.isSet)(Yn.sender) ? String(Yn.sender) : "",
        codeId: (0, he.isSet)(Yn.codeId) ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO,
        newInstantiatePermission: (0, he.isSet)(Yn.newInstantiatePermission) ? ue.AccessConfig.fromJSON(Yn.newInstantiatePermission) : void 0
      };
    },
    toJSON(Yn) {
      const $o = {};
      return Yn.sender !== void 0 && ($o.sender = Yn.sender), Yn.codeId !== void 0 && ($o.codeId = (Yn.codeId || he.Long.UZERO).toString()), Yn.newInstantiatePermission !== void 0 && ($o.newInstantiatePermission = Yn.newInstantiatePermission ? ue.AccessConfig.toJSON(Yn.newInstantiatePermission) : void 0), $o;
    },
    fromPartial(Yn) {
      const $o = Ta();
      return $o.sender = Yn.sender ?? "", $o.codeId = Yn.codeId !== void 0 && Yn.codeId !== null ? he.Long.fromValue(Yn.codeId) : he.Long.UZERO, $o.newInstantiatePermission = Yn.newInstantiatePermission !== void 0 && Yn.newInstantiatePermission !== null ? ue.AccessConfig.fromPartial(Yn.newInstantiatePermission) : void 0, $o;
    }
  };
  function Zn() {
    return {};
  }
  v.MsgUpdateInstantiateConfigResponse = {
    encode(Yn, $o = ge.Writer.create()) {
      return $o;
    },
    decode(Yn, $o) {
      const ct = Yn instanceof ge.Reader ? Yn : new ge.Reader(Yn);
      let fe = $o === void 0 ? ct.len : ct.pos + $o;
      const be = Zn();
      for (; ct.pos < fe; ) {
        const ye = ct.uint32();
        switch (ye >>> 3) {
          default:
            ct.skipType(ye & 7);
            break;
        }
      }
      return be;
    },
    fromJSON(Yn) {
      return {};
    },
    toJSON(Yn) {
      return {};
    },
    fromPartial(Yn) {
      return Zn();
    }
  };
  class Ra {
    constructor($o) {
      this.rpc = $o, this.StoreCode = this.StoreCode.bind(this), this.InstantiateContract = this.InstantiateContract.bind(this), this.InstantiateContract2 = this.InstantiateContract2.bind(this), this.ExecuteContract = this.ExecuteContract.bind(this), this.MigrateContract = this.MigrateContract.bind(this), this.UpdateAdmin = this.UpdateAdmin.bind(this), this.ClearAdmin = this.ClearAdmin.bind(this), this.UpdateInstantiateConfig = this.UpdateInstantiateConfig.bind(this);
    }
    StoreCode($o) {
      const ct = v.MsgStoreCode.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", ct).then((be) => v.MsgStoreCodeResponse.decode(new ge.Reader(be)));
    }
    InstantiateContract($o) {
      const ct = v.MsgInstantiateContract.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", ct).then((be) => v.MsgInstantiateContractResponse.decode(new ge.Reader(be)));
    }
    InstantiateContract2($o) {
      const ct = v.MsgInstantiateContract2.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract2", ct).then((be) => v.MsgInstantiateContract2Response.decode(new ge.Reader(be)));
    }
    ExecuteContract($o) {
      const ct = v.MsgExecuteContract.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", ct).then((be) => v.MsgExecuteContractResponse.decode(new ge.Reader(be)));
    }
    MigrateContract($o) {
      const ct = v.MsgMigrateContract.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", ct).then((be) => v.MsgMigrateContractResponse.decode(new ge.Reader(be)));
    }
    UpdateAdmin($o) {
      const ct = v.MsgUpdateAdmin.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", ct).then((be) => v.MsgUpdateAdminResponse.decode(new ge.Reader(be)));
    }
    ClearAdmin($o) {
      const ct = v.MsgClearAdmin.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", ct).then((be) => v.MsgClearAdminResponse.decode(new ge.Reader(be)));
    }
    UpdateInstantiateConfig($o) {
      const ct = v.MsgUpdateInstantiateConfig.encode($o).finish();
      return this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateInstantiateConfig", ct).then((be) => v.MsgUpdateInstantiateConfigResponse.decode(new ge.Reader(be)));
    }
  }
  v.MsgClientImpl = Ra;
})(tx$1);
var build$7 = {}, ascii$3 = {};
Object.defineProperty(ascii$3, "__esModule", { value: !0 });
ascii$3.fromAscii = ascii$3.toAscii = void 0;
function toAscii$2(v) {
  const y = (z) => z.split("").map((ne) => {
    const ue = ne.charCodeAt(0);
    if (ue < 32 || ue > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + ue);
    return ue;
  });
  return Uint8Array.from(y(v));
}
ascii$3.toAscii = toAscii$2;
function fromAscii$2(v) {
  return ((z) => z.map((ne) => {
    if (ne < 32 || ne > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + ne);
    return String.fromCharCode(ne);
  }))(Array.from(v)).join("");
}
ascii$3.fromAscii = fromAscii$2;
var base64$4 = {}, base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$1 = 0, len = code.length; i$1 < len; ++i$1)
  lookup[i$1] = code[i$1], revLookup[code.charCodeAt(i$1)] = i$1;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(v) {
  var y = v.length;
  if (y % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var z = v.indexOf("=");
  z === -1 && (z = y);
  var ne = z === y ? 0 : 4 - z % 4;
  return [z, ne];
}
function byteLength(v) {
  var y = getLens(v), z = y[0], ne = y[1];
  return (z + ne) * 3 / 4 - ne;
}
function _byteLength(v, y, z) {
  return (y + z) * 3 / 4 - z;
}
function toByteArray(v) {
  var y, z = getLens(v), ne = z[0], ue = z[1], le = new Arr(_byteLength(v, ne, ue)), he = 0, ge = ue > 0 ? ne - 4 : ne, we;
  for (we = 0; we < ge; we += 4)
    y = revLookup[v.charCodeAt(we)] << 18 | revLookup[v.charCodeAt(we + 1)] << 12 | revLookup[v.charCodeAt(we + 2)] << 6 | revLookup[v.charCodeAt(we + 3)], le[he++] = y >> 16 & 255, le[he++] = y >> 8 & 255, le[he++] = y & 255;
  return ue === 2 && (y = revLookup[v.charCodeAt(we)] << 2 | revLookup[v.charCodeAt(we + 1)] >> 4, le[he++] = y & 255), ue === 1 && (y = revLookup[v.charCodeAt(we)] << 10 | revLookup[v.charCodeAt(we + 1)] << 4 | revLookup[v.charCodeAt(we + 2)] >> 2, le[he++] = y >> 8 & 255, le[he++] = y & 255), le;
}
function tripletToBase64(v) {
  return lookup[v >> 18 & 63] + lookup[v >> 12 & 63] + lookup[v >> 6 & 63] + lookup[v & 63];
}
function encodeChunk(v, y, z) {
  for (var ne, ue = [], le = y; le < z; le += 3)
    ne = (v[le] << 16 & 16711680) + (v[le + 1] << 8 & 65280) + (v[le + 2] & 255), ue.push(tripletToBase64(ne));
  return ue.join("");
}
function fromByteArray(v) {
  for (var y, z = v.length, ne = z % 3, ue = [], le = 16383, he = 0, ge = z - ne; he < ge; he += le)
    ue.push(encodeChunk(v, he, he + le > ge ? ge : he + le));
  return ne === 1 ? (y = v[z - 1], ue.push(
    lookup[y >> 2] + lookup[y << 4 & 63] + "=="
  )) : ne === 2 && (y = (v[z - 2] << 8) + v[z - 1], ue.push(
    lookup[y >> 10] + lookup[y >> 4 & 63] + lookup[y << 2 & 63] + "="
  )), ue.join("");
}
var __createBinding$b = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$a = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$b = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$b(y, v, z);
  return __setModuleDefault$a(y, v), y;
};
Object.defineProperty(base64$4, "__esModule", { value: !0 });
base64$4.fromBase64 = base64$4.toBase64 = void 0;
const base64js$2 = __importStar$b(base64Js);
function toBase64$2(v) {
  return base64js$2.fromByteArray(v);
}
base64$4.toBase64 = toBase64$2;
function fromBase64$2(v) {
  if (!v.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$2.toByteArray(v);
}
base64$4.fromBase64 = fromBase64$2;
var bech32$5 = {}, __createBinding$a = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$9 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$a = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$a(y, v, z);
  return __setModuleDefault$9(y, v), y;
};
Object.defineProperty(bech32$5, "__esModule", { value: !0 });
bech32$5.normalizeBech32 = bech32$5.fromBech32 = bech32$5.toBech32 = void 0;
const bech32$4 = __importStar$a(require$$0$4);
function toBech32$2(v, y, z) {
  return bech32$4.encode(v, bech32$4.toWords(y), z);
}
bech32$5.toBech32 = toBech32$2;
function fromBech32$2(v, y = 1 / 0) {
  const z = bech32$4.decode(v, y);
  return {
    prefix: z.prefix,
    data: new Uint8Array(bech32$4.fromWords(z.words))
  };
}
bech32$5.fromBech32 = fromBech32$2;
function normalizeBech32$2(v) {
  const { prefix: y, data: z } = fromBech32$2(v);
  return toBech32$2(y, z);
}
bech32$5.normalizeBech32 = normalizeBech32$2;
var hex$3 = {};
Object.defineProperty(hex$3, "__esModule", { value: !0 });
hex$3.fromHex = hex$3.toHex = void 0;
function toHex$4(v) {
  let y = "";
  for (const z of v)
    y += ("0" + z.toString(16)).slice(-2);
  return y;
}
hex$3.toHex = toHex$4;
function fromHex$2(v) {
  if (v.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const y = new Uint8Array(v.length / 2);
  for (let z = 0; z < y.length; z++) {
    const ne = 2 * z, ue = v.slice(ne, ne + 2);
    if (!ue.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    y[z] = parseInt(ue, 16);
  }
  return y;
}
hex$3.fromHex = fromHex$2;
var rfc3339$2 = {};
Object.defineProperty(rfc3339$2, "__esModule", { value: !0 });
rfc3339$2.toRfc3339 = rfc3339$2.fromRfc3339 = void 0;
const rfc3339Matcher$2 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$2(v, y = 2) {
  return v.toString().padStart(y, "0");
}
function fromRfc3339$2(v) {
  const y = rfc3339Matcher$2.exec(v);
  if (!y)
    throw new Error("Date string is not in RFC3339 format");
  const z = +y[1], ne = +y[2], ue = +y[3], le = +y[4], he = +y[5], ge = +y[6], we = y[7] ? Math.floor(+y[7] * 1e3) : 0;
  let Ee, xe, $e;
  y[8] === "Z" ? (Ee = 1, xe = 0, $e = 0) : (Ee = y[8].substring(0, 1) === "-" ? -1 : 1, xe = +y[8].substring(1, 3), $e = +y[8].substring(4, 6));
  const Ne = Ee * (xe * 60 + $e) * 60, st = Date.UTC(z, ne - 1, ue, le, he, ge, we) - Ne * 1e3;
  return new Date(st);
}
rfc3339$2.fromRfc3339 = fromRfc3339$2;
function toRfc3339$2(v) {
  const y = v.getUTCFullYear(), z = padded$2(v.getUTCMonth() + 1), ne = padded$2(v.getUTCDate()), ue = padded$2(v.getUTCHours()), le = padded$2(v.getUTCMinutes()), he = padded$2(v.getUTCSeconds()), ge = padded$2(v.getUTCMilliseconds(), 3);
  return `${y}-${z}-${ne}T${ue}:${le}:${he}.${ge}Z`;
}
rfc3339$2.toRfc3339 = toRfc3339$2;
var utf8$2 = {};
Object.defineProperty(utf8$2, "__esModule", { value: !0 });
utf8$2.fromUtf8 = utf8$2.toUtf8 = void 0;
function toUtf8$2(v) {
  return new TextEncoder().encode(v);
}
utf8$2.toUtf8 = toUtf8$2;
function fromUtf8$2(v, y = !1) {
  const z = !y;
  return new TextDecoder("utf-8", { fatal: z }).decode(v);
}
utf8$2.fromUtf8 = fromUtf8$2;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.toUtf8 = v.fromUtf8 = v.toRfc3339 = v.fromRfc3339 = v.toHex = v.fromHex = v.toBech32 = v.normalizeBech32 = v.fromBech32 = v.toBase64 = v.fromBase64 = v.toAscii = v.fromAscii = void 0;
  var y = ascii$3;
  Object.defineProperty(v, "fromAscii", { enumerable: !0, get: function() {
    return y.fromAscii;
  } }), Object.defineProperty(v, "toAscii", { enumerable: !0, get: function() {
    return y.toAscii;
  } });
  var z = base64$4;
  Object.defineProperty(v, "fromBase64", { enumerable: !0, get: function() {
    return z.fromBase64;
  } }), Object.defineProperty(v, "toBase64", { enumerable: !0, get: function() {
    return z.toBase64;
  } });
  var ne = bech32$5;
  Object.defineProperty(v, "fromBech32", { enumerable: !0, get: function() {
    return ne.fromBech32;
  } }), Object.defineProperty(v, "normalizeBech32", { enumerable: !0, get: function() {
    return ne.normalizeBech32;
  } }), Object.defineProperty(v, "toBech32", { enumerable: !0, get: function() {
    return ne.toBech32;
  } });
  var ue = hex$3;
  Object.defineProperty(v, "fromHex", { enumerable: !0, get: function() {
    return ue.fromHex;
  } }), Object.defineProperty(v, "toHex", { enumerable: !0, get: function() {
    return ue.toHex;
  } });
  var le = rfc3339$2;
  Object.defineProperty(v, "fromRfc3339", { enumerable: !0, get: function() {
    return le.fromRfc3339;
  } }), Object.defineProperty(v, "toRfc3339", { enumerable: !0, get: function() {
    return le.toRfc3339;
  } });
  var he = utf8$2;
  Object.defineProperty(v, "fromUtf8", { enumerable: !0, get: function() {
    return he.fromUtf8;
  } }), Object.defineProperty(v, "toUtf8", { enumerable: !0, get: function() {
    return he.toUtf8;
  } });
})(build$7);
function bytesFromBase64(v) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(v, "base64"));
  {
    const y = globalThis.atob(v), z = new Uint8Array(y.length);
    for (let ne = 0; ne < y.length; ++ne)
      z[ne] = y.charCodeAt(ne);
    return z;
  }
}
function base64FromBytes(v) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(v).toString("base64");
  {
    const y = [];
    return v.forEach((z) => {
      y.push(globalThis.String.fromCharCode(z));
    }), globalThis.btoa(y.join(""));
  }
}
_m0$8.util.Long !== Long && (_m0$8.util.Long = Long, _m0$8.configure());
function isSet(v) {
  return v != null;
}
function createBaseMsgDepositForBurn() {
  return {
    from: "",
    amount: "",
    destinationDomain: 0,
    mintRecipient: new Uint8Array(0),
    burnToken: ""
  };
}
const MsgDepositForBurn = {
  encode(v, y = _m0$8.Writer.create()) {
    return v.from !== "" && y.uint32(10).string(v.from), v.amount !== "" && y.uint32(18).string(v.amount), v.destinationDomain !== 0 && y.uint32(24).uint32(v.destinationDomain), v.mintRecipient.length !== 0 && y.uint32(34).bytes(v.mintRecipient), v.burnToken !== "" && y.uint32(42).string(v.burnToken), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$8.Reader ? v : _m0$8.Reader.create(v), ne = y === void 0 ? z.len : z.pos + y, ue = createBaseMsgDepositForBurn();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          if (le !== 10)
            break;
          ue.from = z.string();
          continue;
        case 2:
          if (le !== 18)
            break;
          ue.amount = z.string();
          continue;
        case 3:
          if (le !== 24)
            break;
          ue.destinationDomain = z.uint32();
          continue;
        case 4:
          if (le !== 34)
            break;
          ue.mintRecipient = z.bytes();
          continue;
        case 5:
          if (le !== 42)
            break;
          ue.burnToken = z.string();
          continue;
      }
      if ((le & 7) === 4 || le === 0)
        break;
      z.skipType(le & 7);
    }
    return ue;
  },
  fromJSON(v) {
    return {
      from: isSet(v.from) ? globalThis.String(v.from) : "",
      amount: isSet(v.amount) ? globalThis.String(v.amount) : "",
      destinationDomain: isSet(v.destinationDomain) ? globalThis.Number(v.destinationDomain) : 0,
      mintRecipient: isSet(v.mintRecipient) ? bytesFromBase64(v.mintRecipient) : new Uint8Array(0),
      burnToken: isSet(v.burnToken) ? globalThis.String(v.burnToken) : ""
    };
  },
  toJSON(v) {
    const y = {};
    return v.from !== "" && (y.from = v.from), v.amount !== "" && (y.amount = v.amount), v.destinationDomain !== 0 && (y.destinationDomain = Math.round(v.destinationDomain)), v.mintRecipient.length !== 0 && (y.mintRecipient = base64FromBytes(v.mintRecipient)), v.burnToken !== "" && (y.burnToken = v.burnToken), y;
  },
  create(v) {
    return MsgDepositForBurn.fromPartial(v ?? {});
  },
  fromPartial(v) {
    const y = createBaseMsgDepositForBurn();
    return y.from = v.from ?? "", y.amount = v.amount ?? "", y.destinationDomain = v.destinationDomain ?? 0, y.mintRecipient = v.mintRecipient ?? new Uint8Array(0), y.burnToken = v.burnToken ?? "", y;
  }
};
function createBaseMsgDepositForBurnWithCaller() {
  return {
    from: "",
    amount: "",
    destinationDomain: 0,
    mintRecipient: new Uint8Array(0),
    burnToken: "",
    destinationCaller: new Uint8Array(0)
  };
}
const MsgDepositForBurnWithCaller = {
  encode(v, y = _m0$8.Writer.create()) {
    return v.from !== "" && y.uint32(10).string(v.from), v.amount !== "" && y.uint32(18).string(v.amount), v.destinationDomain !== 0 && y.uint32(24).uint32(v.destinationDomain), v.mintRecipient.length !== 0 && y.uint32(34).bytes(v.mintRecipient), v.burnToken !== "" && y.uint32(42).string(v.burnToken), v.destinationCaller.length !== 0 && y.uint32(50).bytes(v.destinationCaller), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$8.Reader ? v : _m0$8.Reader.create(v), ne = y === void 0 ? z.len : z.pos + y, ue = createBaseMsgDepositForBurnWithCaller();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          if (le !== 10)
            break;
          ue.from = z.string();
          continue;
        case 2:
          if (le !== 18)
            break;
          ue.amount = z.string();
          continue;
        case 3:
          if (le !== 24)
            break;
          ue.destinationDomain = z.uint32();
          continue;
        case 4:
          if (le !== 34)
            break;
          ue.mintRecipient = z.bytes();
          continue;
        case 5:
          if (le !== 42)
            break;
          ue.burnToken = z.string();
          continue;
        case 6:
          if (le !== 50)
            break;
          ue.destinationCaller = z.bytes();
          continue;
      }
      if ((le & 7) === 4 || le === 0)
        break;
      z.skipType(le & 7);
    }
    return ue;
  },
  fromJSON(v) {
    return {
      from: isSet(v.from) ? globalThis.String(v.from) : "",
      amount: isSet(v.amount) ? globalThis.String(v.amount) : "",
      destinationDomain: isSet(v.destinationDomain) ? globalThis.Number(v.destinationDomain) : 0,
      mintRecipient: isSet(v.mintRecipient) ? bytesFromBase64(v.mintRecipient) : new Uint8Array(0),
      burnToken: isSet(v.burnToken) ? globalThis.String(v.burnToken) : "",
      destinationCaller: isSet(v.destinationCaller) ? bytesFromBase64(v.destinationCaller) : new Uint8Array(0)
    };
  },
  toJSON(v) {
    const y = {};
    return v.from !== "" && (y.from = v.from), v.amount !== "" && (y.amount = v.amount), v.destinationDomain !== 0 && (y.destinationDomain = Math.round(v.destinationDomain)), v.mintRecipient.length !== 0 && (y.mintRecipient = base64FromBytes(v.mintRecipient)), v.burnToken !== "" && (y.burnToken = v.burnToken), v.destinationCaller.length !== 0 && (y.destinationCaller = base64FromBytes(v.destinationCaller)), y;
  },
  create(v) {
    return MsgDepositForBurnWithCaller.fromPartial(v ?? {});
  },
  fromPartial(v) {
    const y = createBaseMsgDepositForBurnWithCaller();
    return y.from = v.from ?? "", y.amount = v.amount ?? "", y.destinationDomain = v.destinationDomain ?? 0, y.mintRecipient = v.mintRecipient ?? new Uint8Array(0), y.burnToken = v.burnToken ?? "", y.destinationCaller = v.destinationCaller ?? new Uint8Array(0), y;
  }
}, getDecimalPower10 = (v) => new BigNumber(10).exponentiatedBy(v), getChainFromAddress = (v, y) => {
  const { prefix: z } = bech32$6.decode(v);
  return y.find((ne) => ne.addressPrefix === z);
}, matcher = /_([a-z])/g, snakeCaseToCamelCaseObject = (v) => {
  const y = {};
  for (const z in v) {
    const ne = z.replace(matcher, (le, he) => he.toUpperCase()), ue = v[z];
    typeof ue == "object" && ue !== null ? y[ne] = snakeCaseToCamelCaseObject(ue) : y[ne] = ue;
  }
  return y;
}, withExpiration = (v, y) => ({
  data: v,
  expiration: Date.now() + y
}), withLastModified = (v, y) => ({
  data: v,
  lastModified: y
}), findValueByKey = (v, y) => {
  if (v && typeof v == "object" && v !== null)
    for (const z in v) {
      if (z === y)
        return v[z];
      if (v[z] && typeof v[z] == "object") {
        const ne = findValueByKey(v[z], y);
        if (ne)
          return ne;
      }
    }
  return null;
}, calculateFee = (v, y, z, ne = 1.5) => {
  const ue = new BigNumber(v).times(ne).integerValue(BigNumber.ROUND_UP), le = ue.times(y).integerValue(BigNumber.ROUND_UP);
  return {
    amount: [
      {
        denom: z,
        amount: le.toFixed(0)
      }
    ],
    gas: ue.toFixed(0)
  };
}, getMessageMetadataForSigning = (v, y) => {
  let z, ne, ue;
  if (v === "/ibc.applications.transfer.v1.MsgTransfer") {
    ue = y.sender;
    const le = {
      sourcePort: y.source_port,
      sourceChannel: y.source_channel,
      token: y.token,
      sender: y.sender,
      receiver: y.receiver,
      timeoutHeight: y.timeout_height,
      timeoutTimestamp: y.timeout_timestamp,
      memo: (y == null ? void 0 : y.memo) ?? ""
    };
    z = {
      typeUrl: v,
      value: tx$3.MsgTransfer.fromJSON(le)
    }, ne = {
      typeUrl: v,
      value: tx$3.MsgTransfer.encode(tx$3.MsgTransfer.fromPartial(le)).finish()
    };
  } else if (v === "/cosmos.bank.v1beta1.MsgSend")
    ue = y.from_address, z = {
      typeUrl: v,
      value: tx$2.MsgSend.fromPartial({
        fromAddress: y.from_address,
        toAddress: y.to_address,
        amount: y.amount
      })
    }, ne = {
      typeUrl: v,
      value: tx$2.MsgSend.encode(z.value).finish()
    };
  else if (v === "/cosmwasm.wasm.v1.MsgExecuteContract")
    z = {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx$1.MsgExecuteContract.fromPartial({
        sender: y.sender,
        contract: y.contract,
        msg: Uint8Array.from(Buffer.from(JSON.stringify(y.msg))),
        funds: y.funds
      })
    }, ue = y.sender, ne = {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx$1.MsgExecuteContract.encode(z.value).finish()
    };
  else if (v === "/circle.cctp.v1.MsgDepositForBurn")
    z = {
      typeUrl: "/circle.cctp.v1.MsgDepositForBurn",
      value: MsgDepositForBurn.fromPartial({
        from: y.from,
        amount: y.amount,
        destinationDomain: y.destination_domain,
        mintRecipient: y.mint_recipient,
        burnToken: y.burn_token
      })
    }, ne = {
      typeUrl: v,
      value: MsgDepositForBurn.encode(z.value).finish()
    }, ue = y.sender;
  else if (v === "/circle.cctp.v1.MsgDepositForBurnWithCaller")
    z = {
      typeUrl: "/circle.cctp.v1.MsgDepositForBurnWithCaller",
      value: MsgDepositForBurnWithCaller.fromPartial({
        from: y.from,
        amount: y.amount,
        destinationDomain: y.destination_domain,
        mintRecipient: y.mint_recipient,
        burnToken: y.burn_token,
        destinationCaller: y.destination_caller
      })
    }, ne = {
      typeUrl: v,
      value: MsgDepositForBurnWithCaller.encode(z.value).finish()
    }, ue = y.sender;
  else
    throw new Error("Unsupported message type");
  return { binaryMessage: ne, encodedMessage: z, senderAddress: ue };
}, getDecodedMessage = (v) => {
  const z = new BigNumber(10).pow(9).toString(), ne = JSON.parse(v.msg);
  switch (v.msg_type_url) {
    case "/ibc.applications.transfer.v1.MsgTransfer": {
      const ue = ne.timeout_timestamp ? Long.fromNumber(ne.timeout_timestamp + 6e4).multiply(z) : Long.fromNumber(Date.now() + 6e4).multiply(z);
      return {
        typeUrl: v.msg_type_url,
        value: tx$3.MsgTransfer.encode({
          sourcePort: ne.source_port,
          sourceChannel: ne.source_channel,
          token: ne.token,
          sender: ne.sender,
          receiver: ne.receiver,
          timeoutTimestamp: ue,
          memo: (ne == null ? void 0 : ne.memo) ?? ""
        }).finish()
      };
    }
    case "/cosmos.bank.v1beta1.MsgSend":
      return {
        typeUrl: v.msg_type_url,
        value: tx$2.MsgSend.encode({
          fromAddress: ne.from_address,
          toAddress: ne.to_address,
          amount: ne.amount
        }).finish()
      };
    case "/cosmwasm.wasm.v1.MsgExecuteContract":
      return {
        typeUrl: v.msg_type_url,
        value: tx$1.MsgExecuteContract.encode({
          sender: ne.sender,
          contract: ne.contract,
          msg: build$7.toUtf8(JSON.stringify(ne.msg)),
          funds: ne.funds
        }).finish()
      };
    case "/circle.cctp.v1.MsgDepositForBurn":
      return {
        typeUrl: v.msg_type_url,
        value: MsgDepositForBurn.encode({
          from: ne.from,
          amount: ne.amount,
          destinationDomain: ne.destination_domain,
          mintRecipient: ne.mint_recipient,
          burnToken: ne.burn_token
        }).finish()
      };
    case "/circle.cctp.v1.MsgDepositForBurnWithCaller":
      return {
        typeUrl: v.msg_type_url,
        value: MsgDepositForBurnWithCaller.encode({
          from: ne.from,
          amount: ne.amount,
          destinationDomain: ne.destination_domain,
          mintRecipient: ne.mint_recipient,
          burnToken: ne.burn_token,
          destinationCaller: ne.destination_caller
        }).finish()
      };
  }
  return null;
}, getDecodedMessageMetadataForSigning = ({ typeUrl: v, value: y }) => {
  let z;
  if (v === "/ibc.applications.transfer.v1.MsgTransfer")
    z = {
      typeUrl: v,
      value: tx$3.MsgTransfer.encode(y).finish()
    };
  else if (v === "/cosmos.bank.v1beta1.MsgSend")
    z = {
      typeUrl: v,
      value: tx$2.MsgSend.encode(y).finish()
    };
  else if (v === "/cosmwasm.wasm.v1.MsgExecuteContract")
    z = {
      typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
      value: tx$1.MsgExecuteContract.encode(y).finish()
    };
  else if (v === "/circle.cctp.v1.MsgDepositForBurn")
    z = {
      typeUrl: v,
      value: MsgDepositForBurn.encode(y).finish()
    };
  else if (v === "/circle.cctp.v1.MsgDepositForBurnWithCaller")
    z = {
      typeUrl: v,
      value: MsgDepositForBurnWithCaller.encode(y).finish()
    };
  else
    throw new Error("Unsupported message type");
  return z;
}, cachedRemoteDataWithExpiration = async ({
  remoteUrl: v,
  storageKey: y,
  expiration: z = 1e3 * 60 * 60 * 24
  // 1 day
}) => {
  const ne = storageLayer.isInitialized() ? storageLayer.getStorage() : void 0, ue = await (ne == null ? void 0 : ne.getItem(y));
  if (ue) {
    const he = JSON.parse(ue);
    if (he.expiration > Date.now())
      return he.data;
  }
  const le = await fetch(v);
  if (le.ok) {
    const he = await le.json();
    return await (ne == null ? void 0 : ne.setItem(y, JSON.stringify(withExpiration(he, z)))), he;
  } else {
    if (ue)
      return JSON.parse(ue).data;
    throw new Error(`Error fetching data from ${v}`);
  }
}, cachedRemoteDataWithLastModified = async ({ remoteUrl: v, storageKey: y }) => {
  const z = storageLayer.isInitialized() ? storageLayer.getStorage() : void 0, ne = await (z == null ? void 0 : z.getItem(y));
  if (ne) {
    const ue = JSON.parse(ne);
    try {
      const le = await fetch(v, {
        method: "GET",
        headers: {
          "If-Modified-Since": new Date(ue.lastModified).toUTCString()
        },
        // Download a resource with cache busting when dealing with a
        // properly configured server that will send the correct ETag
        // and Date headers and properly handle If-Modified-Since and
        // If-None-Match request headers, therefore we can rely on the
        // validation to guarantee a fresh response.
        cache: "no-cache"
      });
      if (le.ok) {
        const he = await le.json(), ge = new Date(le.headers.get("last-modified") ?? Date.now()).getTime();
        return await (z == null ? void 0 : z.setItem(y, JSON.stringify(withLastModified(he, ge)))), he;
      } else
        return ue.data;
    } catch {
      return ue.data;
    }
  } else {
    const ue = await fetch(v, {
      // Download a resource with cache busting, but update the HTTP
      // cache with the downloaded resource.
      cache: "reload"
    });
    if (ue.ok) {
      const le = await ue.json(), he = new Date(ue.headers.get("last-modified") ?? Date.now()).getTime();
      return await (z == null ? void 0 : z.setItem(y, JSON.stringify(withLastModified(le, he)))), le;
    } else
      throw new Error(`Error fetching data from ${v}`);
  }
}, coingeckoIdMap = {
  canto: "canto",
  avax: "avalanche-2",
  aurora: "aurora-near",
  bnb: "binancecoin",
  ftm: "fantom",
  eth: "ethereum",
  matic: "matic-network",
  sol: "solana",
  atom: "cosmos",
  med: "medibloc",
  cre: "crescent-network",
  scrt: "secret",
  osmo: "osmosis",
  cro: "crypto-com-chain",
  ctx: "c2x-2",
  rune: "thorchain",
  bld: "agoric",
  akt: "akash-network",
  tori: "teritori",
  swth: "switcheo",
  dot: "polkadot",
  core: "coreum",
  strd: "stride",
  band: "band-protocol",
  bcna: "bitcanna",
  btsg: "bitsong",
  boot: "bostrom",
  ngm: "e-money",
  eeur: "e-money-eur",
  kuji: "kujira",
  tgd: "tgrade",
  mntl: "assetmantle",
  crbrus: "cerberus-2",
  cheqd: "cheqd-network",
  huahua: "chihuahua-token",
  cmdx: "comdex",
  dec: "decentr",
  dsm: "desmos",
  dig: "dig-chain",
  fet: "fetch-ai",
  fct: "firmachain",
  grav: "graviton",
  inj: "injective-protocol",
  iris: "iris-network",
  juno: "juno-network",
  xki: "ki",
  like: "likecoin",
  lum: "lum-network",
  tick: "microtick",
  orai: "oraichain",
  xprt: "persistence",
  hash: "provenance-blockchain",
  atolo: "rizon",
  dvpn: "sentinal",
  ctk: "certik",
  erowan: "sifchain",
  somm: "sommelier",
  stars: "stargaze",
  iov: "starname",
  vdl: "vidulum"
};
var StorageKeys;
(function(v) {
  v.DENOMS = "@leapwallet/elements-core:denoms", v.SQUID_ASSETS = "@leapwallet/elements-core:squid-assets", v.CHAINS = "@leapwallet/elements-core:chains", v.GAS_PRICE_STEPS = "@leapwallet/elements-core:gas-price-steps", v.GAS_ADJUSTMENT = "@leapwallet/elements-core:gas-adjustment", v.NATIVE_FEE_DENOMS = "@leapwallet/elements-core:native-fee-denoms", v.DENOM_TRACES = "@leapwallet/elements-core:denom-traces", v.EVM_ASSET_PRICES = "@leapwallet/elements-core:evm-asset-prices", v.COINGECKO_PRICES = "@leapwallet/elements-core:coingecko-prices", v.SKIP_SUPPORTED_CHAINS = "@leapwallet/elements-core:skip-supported-chains", v.CHANNEL_INFO = "@leapwallet/elements-core:channel-info", v.REST_URLS = "@leapwallet/elements-core:rest-urls", v.RPC_URLS = "@leapwallet/elements-core:rpc-urls";
})(StorageKeys || (StorageKeys = {}));
const defaultExpiryDuration$1 = 60 * 1e3, Dm = class Dm {
  static isCacheInitialized() {
    return Dm.cache !== void 0;
  }
  static initializeCache(y) {
    Dm.cache = new AsyncStorage(y, StorageKeys.COINGECKO_PRICES);
  }
  /**
   * Gets the price of a token from CoinGecko.
   *
   * @param _coinId The coingecko ID for the token to get the price for.
   * @param expiryDuration The duration in milliseconds for which the price should be cached.
   *
   * @returns A Promise that resolves to the price of the token, or -1 if the price cannot be fetched.
   */
  static async getCoinPrice(y, z = defaultExpiryDuration$1) {
    var ge;
    const ne = coingeckoIdMap[y] ?? y;
    !Dm.isCacheInitialized() && storageLayer.isInitialized() && Dm.initializeCache(storageLayer.getStorage());
    const ue = await ((ge = Dm.cache) == null ? void 0 : ge.getItem(ne));
    if (ue && Date.now() - ue.timestamp < z)
      return ue.price;
    if (Dm.activeRequests.has(ne))
      return await Dm.activeRequests.get(ne) ?? -1;
    const le = fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${ne}&vs_currencies=usd`).then((we) => we.json()).then((we) => {
      const Ee = we[ne].usd;
      return new Promise((xe) => {
        var $e;
        ($e = Dm.cache) == null || $e.setItem(ne, {
          price: Ee,
          timestamp: Date.now()
        }).catch(() => {
        }), xe(Ee);
      });
    }).catch(() => -1);
    Dm.activeRequests.set(ne, le);
    const he = await le;
    return Dm.activeRequests.delete(ne), he;
  }
};
Rm(Dm, "cache"), Rm(Dm, "activeRequests", /* @__PURE__ */ new Map());
let CoinGeckoAPI = Dm;
async function fetchAccountDetails(v, y, z = 3) {
  try {
    const ue = await (await fetch(`${v}/cosmos/auth/v1beta1/accounts/${y}`)).json();
    let le = ue.account.base_account ? ue.account.base_account : ue.account;
    if (!le.address || !le.account_number || !le.sequence) {
      const he = findValueByKey(ue, "base_account");
      if (he)
        le = he;
      else
        throw new Error("Invalid account response");
    }
    return {
      address: le.address,
      accountNumber: le.account_number,
      sequence: le.sequence,
      publicKey: {
        typeUrl: le.pub_key ? le.pub_key["@type"] : "",
        value: le.pub_key ? le.pub_key.key : ""
      }
    };
  } catch (ne) {
    if (z > 0)
      return fetchAccountDetails(v, y, z - 1);
    throw new Error(ne.message);
  }
}
const GAS_ESTIMATE = 2e5, getDenoms = () => cachedRemoteDataWithLastModified({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/denoms/base.json",
  storageKey: StorageKeys.DENOMS
}), getChains = () => cachedRemoteDataWithLastModified({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/elements-data/chains.json",
  storageKey: StorageKeys.CHAINS
}), getGasPriceSteps = () => cachedRemoteDataWithLastModified({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/gas/gas-prices.json",
  storageKey: StorageKeys.GAS_PRICE_STEPS
}), getGasAdjustment = () => cachedRemoteDataWithLastModified({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/gas/gas-adjustments.json",
  storageKey: StorageKeys.GAS_ADJUSTMENT
}), getNativeFeeDenoms = () => cachedRemoteDataWithLastModified({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/native-fee-denoms/fee-denoms.json",
  storageKey: StorageKeys.NATIVE_FEE_DENOMS
}), getRestUrls = () => cachedRemoteDataWithExpiration({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/node-management-service/tenants/nms-REST-dashboard.json",
  storageKey: StorageKeys.REST_URLS,
  expiration: 60 * 1e3
}), getRpcUrls = () => cachedRemoteDataWithExpiration({
  remoteUrl: "https://assets.leapwallet.io/cosmos-registry/v1/node-management-service/tenants/nms-RPC-dashboard.json",
  storageKey: StorageKeys.RPC_URLS,
  expiration: 60 * 1e3
}), Om = class Om {
  /**
   *
   * @returns `true` if the cache is initialized, `false` otherwise.
   */
  static isCacheInitialized() {
    return Om.cache !== void 0;
  }
  /**
   * Initializes the cache for storing channel data.
   *
   * @param storage - An implementation of {@link IAsyncStorage} interface.
   */
  static initializeCache(y) {
    Om.cache = new AsyncStorage(y, StorageKeys.COINGECKO_PRICES);
  }
  /**
   * Fetches the destination chain ID for a given source chain and channel ID
   *
   * @param channelId channel ID
   * @param chain chain data object - must include chainId and restUrl
   *
   * @returns {Promise<ChannelData>} object with the destination chainId property
   */
  static async fetchChannelInfo(y, z) {
    var we, Ee;
    if (!y)
      throw new Error("channelId is required");
    const ne = `${z.chainId}:${y}`;
    !Om.isCacheInitialized() && storageLayer.isInitialized() && Om.initializeCache(storageLayer.getStorage());
    const ue = await ((we = Om.cache) == null ? void 0 : we.getItem(ne));
    if (ue)
      return ue;
    const ge = {
      chainId: (await (await fetch(`${z.restUrl}/ibc/core/channel/v1/channels/${y}/ports/transfer/client_state`)).json()).identified_client_state.client_state.chain_id
    };
    return await ((Ee = Om.cache) == null ? void 0 : Ee.setItem(ne, ge)), ge;
  }
};
Rm(Om, "cache");
let ChannelUtils = Om;
const Qv = class Qv {
  /**
   * Checks if the cache has been initialized.
   * @returns `true` if the cache is initialized, `false` otherwise.
   */
  static isCacheInitialized() {
    return Qv.cache !== void 0;
  }
  /**
   * Initializes the cache for storing denom trace data.
   * @param storage - An implementation of `IAsyncStorage` interface ({@link IAsyncStorage}).
   */
  static initializeCache(y) {
    Qv.cache = new AsyncStorage(y, StorageKeys.DENOM_TRACES);
  }
  /**
   * Retrieves the denom trace data for a given denom and chain.
   * It initializes the cache if not already initialized and caches the fetched data.
   * @param denom - The denomination string to fetch the trace for.
   * @param chain - The chain data object ({@link CosmosChainData}).
   * @returns A Promise that resolves to the denom trace data ({@link DenomTraceData}),
   *          or throws an error if the trace cannot be fetched.
   */
  static async getTrace(y, z) {
    var we, Ee;
    if (!Qv.isCacheInitialized() && storageLayer.isInitialized() && Qv.initializeCache(storageLayer.getStorage()), !y.startsWith("ibc/"))
      throw new Error("Can only fetch IBC denom traces");
    const ne = `${z.chainId}:${y}`, ue = await ((we = Qv.cache) == null ? void 0 : we.getItem(ne));
    if (ue)
      return {
        baseDenom: ue.baseDenom.replace("cw20:", ""),
        path: ue.path
      };
    const le = await fetch(`${z.restUrl}/ibc/apps/transfer/v1/denom_traces/${y.replace("ibc/", "")}`);
    if (!le.ok)
      throw new Error("Denom trace not found");
    const he = await le.json();
    if (!he.denom_trace)
      throw new Error("Denom trace not found");
    const ge = {
      baseDenom: he.denom_trace.base_denom.replace("cw20:", ""),
      path: he.denom_trace.path
    };
    return await ((Ee = Qv.cache) == null ? void 0 : Ee.setItem(ne, ge)), ge;
  }
};
Rm(Qv, "cache");
let DenomFetcher = Qv;
var TRANSFER_STATUS;
(function(v) {
  v.UNINITIATED = "uninitiated", v.PENDING = "pending", v.FAILED = "failed", v.SETTLED = "settled", v.UNKNOWN = "unknown";
})(TRANSFER_STATUS || (TRANSFER_STATUS = {}));
const KADO_URLS = {
  test: {
    api: "https://test-api.kado.money",
    webView: "https://sandbox--kado.netlify.app"
  },
  prod: {
    api: "https://api.kado.money",
    webView: "https://app.kado.money"
  }
}, BASE_URL = KADO_URLS.prod.api;
class KadoAPI {
  /**
   * Fetches a list of supported currencies from the Kado API.
   * @returns A Promise resolving to either an object containing a list of currencies
   *          ({@link Currency}[]) on success, or an error message on failure.
   */
  static async getSupportedCurrencies() {
    const y = await fetch(`${BASE_URL}/v1/ramp/currencies`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!y.ok)
      return {
        success: !1,
        error: "Unable to get currencies"
      };
    const z = await y.json();
    return z.success ? {
      success: !0,
      currencies: z.data.currencyData
    } : {
      success: z.success,
      error: z.message
    };
  }
  /**
   * Retrieves the conversion rate between two currencies.
   * @param args - The arguments for the request, including 'from' and 'to' currency identifiers
   *              ({@link ConversionRateArgs}).
   * @returns A Promise resolving to an object containing the conversion rate on success,
   *          or an error message on failure.
   */
  static async getConversionRate(y) {
    const z = await fetch(`${BASE_URL}/v1/ramp/currencyconvert?from=${y.from}&to=${y.to}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!z.ok)
      return {
        success: !1,
        error: "Unable to get conversion rate"
      };
    const ne = await z.json();
    return ne.success ? {
      success: !0,
      conversionRate: ne.data.conversion
    } : {
      success: ne.success,
      error: ne.message
    };
  }
  /**
   * Fetches a list of supported blockchain chains from the Kado API.
   * @returns A Promise resolving to either an object containing a list of chain responses
   *          ({@link KadoAPIChainResponse}[]) on success, or an error message on failure.
   */
  static async getSupportedChains() {
    const y = await fetch(`${BASE_URL}/v1/ramp/blockchains`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    return y.ok ? {
      success: !0,
      chains: (await y.json()).data.blockchains
    } : {
      success: !1,
      error: "Unable to get supported chains"
    };
  }
  /**
   * Requests a quote for a specified transaction.
   * @param args - The arguments for the quote request, including transaction type, fiat method, partner, amount, asset, and blockchain
   *              ({@link RequestQuoteArgs}).
   * @returns A Promise resolving to either an object containing the response quote
   *          ({@link ResponseQuote}) on success, or an error message on failure.
   */
  static async getQuote(y) {
    const z = await fetch(`${BASE_URL}/v2/ramp/quote?transactionType=${y.transactionType}&fiatMethod=${y.fiatMethod}&partner=${y.partner}&amount=${y.amount}&asset=${y.asset}&blockchain=${y.blockchain}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }), ne = await z.json();
    return z.ok ? {
      success: !0,
      quote: ne.data.quote,
      request: ne.data.request
    } : {
      success: !1,
      error: ne.message
    };
  }
  /**
   * Retrieves the status of an order based on the order ID.
   * @param orderId - The unique identifier of the order.
   * @returns A Promise resolving to either an object containing the order status response
   *          ({@link OrderStatusResponse}) on success, or an error message on failure.
   */
  static async getOrderStatus(y) {
    const z = await fetch(`${BASE_URL}/v1/public/orders/${y}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    return z.ok ? {
      success: !0,
      status: (await z.json()).data
    } : {
      success: !1,
      error: "Cannot find order"
    };
  }
}
class HTTPError extends Error {
  constructor(y, z, ne) {
    const ue = y.status || y.status === 0 ? y.status : "", le = y.statusText || "", he = `${ue} ${le}`.trim(), ge = he ? `status code ${he}` : "an unknown error";
    super(`Request failed with ${ge}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = y, this.request = z, this.options = ne;
  }
}
class TimeoutError extends Error {
  constructor(y) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = y;
  }
}
const isObject = (v) => v !== null && typeof v == "object", validateAndMerge = (...v) => {
  for (const y of v)
    if ((!isObject(y) || Array.isArray(y)) && y !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return deepMerge({}, ...v);
}, mergeHeaders = (v = {}, y = {}) => {
  const z = new globalThis.Headers(v), ne = y instanceof globalThis.Headers, ue = new globalThis.Headers(y);
  for (const [le, he] of ue.entries())
    ne && he === "undefined" || he === void 0 ? z.delete(le) : z.set(le, he);
  return z;
}, deepMerge = (...v) => {
  let y = {}, z = {};
  for (const ne of v)
    if (Array.isArray(ne))
      Array.isArray(y) || (y = []), y = [...y, ...ne];
    else if (isObject(ne)) {
      for (let [ue, le] of Object.entries(ne))
        isObject(le) && ue in y && (le = deepMerge(y[ue], le)), y = { ...y, [ue]: le };
      isObject(ne.headers) && (z = mergeHeaders(z, ne.headers), y.headers = z);
    }
  return y;
}, supportsRequestStreams = (() => {
  let v = !1, y = !1;
  const z = typeof globalThis.ReadableStream == "function", ne = typeof globalThis.Request == "function";
  return z && ne && (y = new globalThis.Request("https://empty.invalid", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return v = !0, "half";
    }
  }).headers.has("Content-Type")), v && !y;
})(), supportsAbortController = typeof globalThis.AbortController == "function", supportsResponseStreams = typeof globalThis.ReadableStream == "function", supportsFormData = typeof globalThis.FormData == "function", requestMethods = ["get", "post", "put", "patch", "head", "delete"], responseTypes = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, maxSafeTimeout = 2147483647, stop = Symbol("stop"), kyOptionKeys = {
  json: !0,
  parseJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  fetch: !0
}, requestOptionsRegistry = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, normalizeRequestMethod = (v) => requestMethods.includes(v) ? v.toUpperCase() : v, retryMethods = ["get", "put", "head", "delete", "options", "trace"], retryStatusCodes = [408, 413, 429, 500, 502, 503, 504], retryAfterStatusCodes = [413, 429, 503], defaultRetryOptions = {
  limit: 2,
  methods: retryMethods,
  statusCodes: retryStatusCodes,
  afterStatusCodes: retryAfterStatusCodes,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (v) => 0.3 * 2 ** (v - 1) * 1e3
}, normalizeRetryOptions = (v = {}) => {
  if (typeof v == "number")
    return {
      ...defaultRetryOptions,
      limit: v
    };
  if (v.methods && !Array.isArray(v.methods))
    throw new Error("retry.methods must be an array");
  if (v.statusCodes && !Array.isArray(v.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...defaultRetryOptions,
    ...v,
    afterStatusCodes: retryAfterStatusCodes
  };
};
async function timeout(v, y, z, ne) {
  return new Promise((ue, le) => {
    const he = setTimeout(() => {
      z && z.abort(), le(new TimeoutError(v));
    }, ne.timeout);
    ne.fetch(v, y).then(ue).catch(le).then(() => {
      clearTimeout(he);
    });
  });
}
async function delay$2(v, { signal: y }) {
  return new Promise((z, ne) => {
    y && (y.throwIfAborted(), y.addEventListener("abort", ue, { once: !0 }));
    function ue() {
      clearTimeout(le), ne(y.reason);
    }
    const le = setTimeout(() => {
      y == null || y.removeEventListener("abort", ue), z();
    }, v);
  });
}
const findUnknownOptions = (v, y) => {
  const z = {};
  for (const ne in y)
    !(ne in requestOptionsRegistry) && !(ne in kyOptionKeys) && !(ne in v) && (z[ne] = y[ne]);
  return z;
};
class Ky {
  static create(y, z) {
    const ne = new Ky(y, z), ue = async () => {
      if (typeof ne._options.timeout == "number" && ne._options.timeout > maxSafeTimeout)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${maxSafeTimeout}`);
      await Promise.resolve();
      let ge = await ne._fetch();
      for (const we of ne._options.hooks.afterResponse) {
        const Ee = await we(ne.request, ne._options, ne._decorateResponse(ge.clone()));
        Ee instanceof globalThis.Response && (ge = Ee);
      }
      if (ne._decorateResponse(ge), !ge.ok && ne._options.throwHttpErrors) {
        let we = new HTTPError(ge, ne.request, ne._options);
        for (const Ee of ne._options.hooks.beforeError)
          we = await Ee(we);
        throw we;
      }
      if (ne._options.onDownloadProgress) {
        if (typeof ne._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!supportsResponseStreams)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return ne._stream(ge.clone(), ne._options.onDownloadProgress);
      }
      return ge;
    }, he = ne._options.retry.methods.includes(ne.request.method.toLowerCase()) ? ne._retry(ue) : ue();
    for (const [ge, we] of Object.entries(responseTypes))
      he[ge] = async () => {
        ne.request.headers.set("accept", ne.request.headers.get("accept") || we);
        const xe = (await he).clone();
        if (ge === "json") {
          if (xe.status === 204 || (await xe.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (z.parseJson)
            return z.parseJson(await xe.text());
        }
        return xe[ge]();
      };
    return he;
  }
  // eslint-disable-next-line complexity
  constructor(y, z = {}) {
    Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = y;
    const ne = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : void 0;
    if (this._options = {
      ...ne && { credentials: ne },
      // For exactOptionalPropertyTypes
      ...z,
      headers: mergeHeaders(this._input.headers, z.headers),
      hooks: deepMerge({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, z.hooks),
      method: normalizeRequestMethod(z.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(z.prefixUrl || ""),
      retry: normalizeRetryOptions(z.retry),
      throwHttpErrors: z.throwHttpErrors !== !1,
      timeout: z.timeout ?? 1e4,
      fetch: z.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (supportsAbortController) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const ue = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(ue.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (supportsRequestStreams && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const le = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), he = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, le);
      (supportsFormData && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(he, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(y) {
    if (this._retryCount++, this._retryCount <= this._options.retry.limit && !(y instanceof TimeoutError)) {
      if (y instanceof HTTPError) {
        if (!this._options.retry.statusCodes.includes(y.response.status))
          return 0;
        const ne = y.response.headers.get("Retry-After");
        if (ne && this._options.retry.afterStatusCodes.includes(y.response.status)) {
          let ue = Number(ne);
          return Number.isNaN(ue) ? ue = Date.parse(ne) - Date.now() : ue *= 1e3, this._options.retry.maxRetryAfter !== void 0 && ue > this._options.retry.maxRetryAfter ? 0 : ue;
        }
        if (y.response.status === 413)
          return 0;
      }
      const z = this._options.retry.delay(this._retryCount);
      return Math.min(this._options.retry.backoffLimit, z);
    }
    return 0;
  }
  _decorateResponse(y) {
    return this._options.parseJson && (y.json = async () => this._options.parseJson(await y.text())), y;
  }
  async _retry(y) {
    try {
      return await y();
    } catch (z) {
      const ne = Math.min(this._calculateRetryDelay(z), maxSafeTimeout);
      if (ne !== 0 && this._retryCount > 0) {
        await delay$2(ne, { signal: this._options.signal });
        for (const ue of this._options.hooks.beforeRetry)
          if (await ue({
            request: this.request,
            options: this._options,
            error: z,
            retryCount: this._retryCount
          }) === stop)
            return;
        return this._retry(y);
      }
      throw z;
    }
  }
  async _fetch() {
    for (const z of this._options.hooks.beforeRequest) {
      const ne = await z(this.request, this._options);
      if (ne instanceof Request) {
        this.request = ne;
        break;
      }
      if (ne instanceof Response)
        return ne;
    }
    const y = findUnknownOptions(this.request, this._options);
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone(), y) : timeout(this.request.clone(), y, this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(y, z) {
    const ne = Number(y.headers.get("content-length")) || 0;
    let ue = 0;
    return y.status === 204 ? (z && z({ percent: 1, totalBytes: ne, transferredBytes: ue }, new Uint8Array()), new globalThis.Response(null, {
      status: y.status,
      statusText: y.statusText,
      headers: y.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(le) {
        const he = y.body.getReader();
        z && z({ percent: 0, transferredBytes: 0, totalBytes: ne }, new Uint8Array());
        async function ge() {
          const { done: we, value: Ee } = await he.read();
          if (we) {
            le.close();
            return;
          }
          if (z) {
            ue += Ee.byteLength;
            const xe = ne === 0 ? 0 : ue / ne;
            z({ percent: xe, transferredBytes: ue, totalBytes: ne }, Ee);
          }
          le.enqueue(Ee), await ge();
        }
        await ge();
      }
    }), {
      status: y.status,
      statusText: y.statusText,
      headers: y.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const createInstance = (v) => {
  const y = (z, ne) => Ky.create(z, validateAndMerge(v, ne));
  for (const z of requestMethods)
    y[z] = (ne, ue) => Ky.create(ne, validateAndMerge(v, ue, { method: z }));
  return y.create = (z) => createInstance(validateAndMerge(z)), y.extend = (z) => createInstance(validateAndMerge(v, z)), y.stop = stop, y;
}, ky = createInstance();
var tx = {}, signing$1 = {}, multisig$1 = {}, __createBinding$9 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$8 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$9 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$9(y, v, z);
  return __setModuleDefault$8(y, v), y;
};
Object.defineProperty(multisig$1, "__esModule", { value: !0 });
multisig$1.CompactBitArray = multisig$1.MultiSignature = multisig$1.protobufPackage = void 0;
const _m0$3 = __importStar$9(minimal), helpers_1$3 = helpers;
multisig$1.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function createBaseMultiSignature() {
  return {
    signatures: []
  };
}
multisig$1.MultiSignature = {
  encode(v, y = _m0$3.Writer.create()) {
    for (const z of v.signatures)
      y.uint32(10).bytes(z);
    return y;
  },
  decode(v, y) {
    const z = v instanceof _m0$3.Reader ? v : new _m0$3.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseMultiSignature();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.signatures.push(z.bytes());
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      signatures: Array.isArray(v == null ? void 0 : v.signatures) ? v.signatures.map((y) => (0, helpers_1$3.bytesFromBase64)(y)) : []
    };
  },
  toJSON(v) {
    const y = {};
    return v.signatures ? y.signatures = v.signatures.map((z) => (0, helpers_1$3.base64FromBytes)(z !== void 0 ? z : new Uint8Array())) : y.signatures = [], y;
  },
  fromPartial(v) {
    var z;
    const y = createBaseMultiSignature();
    return y.signatures = ((z = v.signatures) == null ? void 0 : z.map((ne) => ne)) || [], y;
  }
};
function createBaseCompactBitArray() {
  return {
    extraBitsStored: 0,
    elems: new Uint8Array()
  };
}
multisig$1.CompactBitArray = {
  encode(v, y = _m0$3.Writer.create()) {
    return v.extraBitsStored !== 0 && y.uint32(8).uint32(v.extraBitsStored), v.elems.length !== 0 && y.uint32(18).bytes(v.elems), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$3.Reader ? v : new _m0$3.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseCompactBitArray();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.extraBitsStored = z.uint32();
          break;
        case 2:
          ue.elems = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      extraBitsStored: (0, helpers_1$3.isSet)(v.extraBitsStored) ? Number(v.extraBitsStored) : 0,
      elems: (0, helpers_1$3.isSet)(v.elems) ? (0, helpers_1$3.bytesFromBase64)(v.elems) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.extraBitsStored !== void 0 && (y.extraBitsStored = Math.round(v.extraBitsStored)), v.elems !== void 0 && (y.elems = (0, helpers_1$3.base64FromBytes)(v.elems !== void 0 ? v.elems : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBaseCompactBitArray();
    return y.extraBitsStored = v.extraBitsStored ?? 0, y.elems = v.elems ?? new Uint8Array(), y;
  }
};
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function($n, En, Rn, wa) {
    wa === void 0 && (wa = Rn);
    var Aa = Object.getOwnPropertyDescriptor(En, Rn);
    (!Aa || ("get" in Aa ? !En.__esModule : Aa.writable || Aa.configurable)) && (Aa = { enumerable: !0, get: function() {
      return En[Rn];
    } }), Object.defineProperty($n, wa, Aa);
  } : function($n, En, Rn, wa) {
    wa === void 0 && (wa = Rn), $n[wa] = En[Rn];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function($n, En) {
    Object.defineProperty($n, "default", { enumerable: !0, value: En });
  } : function($n, En) {
    $n.default = En;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function($n) {
    if ($n && $n.__esModule)
      return $n;
    var En = {};
    if ($n != null)
      for (var Rn in $n)
        Rn !== "default" && Object.prototype.hasOwnProperty.call($n, Rn) && y(En, $n, Rn);
    return z(En, $n), En;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.SignatureDescriptor_Data_Multi = v.SignatureDescriptor_Data_Single = v.SignatureDescriptor_Data = v.SignatureDescriptor = v.SignatureDescriptors = v.signModeToJSON = v.signModeFromJSON = v.SignMode = v.protobufPackage = void 0;
  const ue = multisig$1, le = any, he = helpers, ge = ne(minimal);
  v.protobufPackage = "cosmos.tx.signing.v1beta1";
  var we;
  (function($n) {
    $n[$n.SIGN_MODE_UNSPECIFIED = 0] = "SIGN_MODE_UNSPECIFIED", $n[$n.SIGN_MODE_DIRECT = 1] = "SIGN_MODE_DIRECT", $n[$n.SIGN_MODE_TEXTUAL = 2] = "SIGN_MODE_TEXTUAL", $n[$n.SIGN_MODE_DIRECT_AUX = 3] = "SIGN_MODE_DIRECT_AUX", $n[$n.SIGN_MODE_LEGACY_AMINO_JSON = 127] = "SIGN_MODE_LEGACY_AMINO_JSON", $n[$n.SIGN_MODE_EIP_191 = 191] = "SIGN_MODE_EIP_191", $n[$n.UNRECOGNIZED = -1] = "UNRECOGNIZED";
  })(we = v.SignMode || (v.SignMode = {}));
  function Ee($n) {
    switch ($n) {
      case 0:
      case "SIGN_MODE_UNSPECIFIED":
        return we.SIGN_MODE_UNSPECIFIED;
      case 1:
      case "SIGN_MODE_DIRECT":
        return we.SIGN_MODE_DIRECT;
      case 2:
      case "SIGN_MODE_TEXTUAL":
        return we.SIGN_MODE_TEXTUAL;
      case 3:
      case "SIGN_MODE_DIRECT_AUX":
        return we.SIGN_MODE_DIRECT_AUX;
      case 127:
      case "SIGN_MODE_LEGACY_AMINO_JSON":
        return we.SIGN_MODE_LEGACY_AMINO_JSON;
      case 191:
      case "SIGN_MODE_EIP_191":
        return we.SIGN_MODE_EIP_191;
      case -1:
      case "UNRECOGNIZED":
      default:
        return we.UNRECOGNIZED;
    }
  }
  v.signModeFromJSON = Ee;
  function xe($n) {
    switch ($n) {
      case we.SIGN_MODE_UNSPECIFIED:
        return "SIGN_MODE_UNSPECIFIED";
      case we.SIGN_MODE_DIRECT:
        return "SIGN_MODE_DIRECT";
      case we.SIGN_MODE_TEXTUAL:
        return "SIGN_MODE_TEXTUAL";
      case we.SIGN_MODE_DIRECT_AUX:
        return "SIGN_MODE_DIRECT_AUX";
      case we.SIGN_MODE_LEGACY_AMINO_JSON:
        return "SIGN_MODE_LEGACY_AMINO_JSON";
      case we.SIGN_MODE_EIP_191:
        return "SIGN_MODE_EIP_191";
      case we.UNRECOGNIZED:
      default:
        return "UNRECOGNIZED";
    }
  }
  v.signModeToJSON = xe;
  function $e() {
    return {
      signatures: []
    };
  }
  v.SignatureDescriptors = {
    encode($n, En = ge.Writer.create()) {
      for (const Rn of $n.signatures)
        v.SignatureDescriptor.encode(Rn, En.uint32(10).fork()).ldelim();
      return En;
    },
    decode($n, En) {
      const Rn = $n instanceof ge.Reader ? $n : new ge.Reader($n);
      let wa = En === void 0 ? Rn.len : Rn.pos + En;
      const Aa = $e();
      for (; Rn.pos < wa; ) {
        const _a = Rn.uint32();
        switch (_a >>> 3) {
          case 1:
            Aa.signatures.push(v.SignatureDescriptor.decode(Rn, Rn.uint32()));
            break;
          default:
            Rn.skipType(_a & 7);
            break;
        }
      }
      return Aa;
    },
    fromJSON($n) {
      return {
        signatures: Array.isArray($n == null ? void 0 : $n.signatures) ? $n.signatures.map((En) => v.SignatureDescriptor.fromJSON(En)) : []
      };
    },
    toJSON($n) {
      const En = {};
      return $n.signatures ? En.signatures = $n.signatures.map((Rn) => Rn ? v.SignatureDescriptor.toJSON(Rn) : void 0) : En.signatures = [], En;
    },
    fromPartial($n) {
      var Rn;
      const En = $e();
      return En.signatures = ((Rn = $n.signatures) == null ? void 0 : Rn.map((wa) => v.SignatureDescriptor.fromPartial(wa))) || [], En;
    }
  };
  function Ne() {
    return {
      publicKey: void 0,
      data: void 0,
      sequence: he.Long.UZERO
    };
  }
  v.SignatureDescriptor = {
    encode($n, En = ge.Writer.create()) {
      return $n.publicKey !== void 0 && le.Any.encode($n.publicKey, En.uint32(10).fork()).ldelim(), $n.data !== void 0 && v.SignatureDescriptor_Data.encode($n.data, En.uint32(18).fork()).ldelim(), $n.sequence.isZero() || En.uint32(24).uint64($n.sequence), En;
    },
    decode($n, En) {
      const Rn = $n instanceof ge.Reader ? $n : new ge.Reader($n);
      let wa = En === void 0 ? Rn.len : Rn.pos + En;
      const Aa = Ne();
      for (; Rn.pos < wa; ) {
        const _a = Rn.uint32();
        switch (_a >>> 3) {
          case 1:
            Aa.publicKey = le.Any.decode(Rn, Rn.uint32());
            break;
          case 2:
            Aa.data = v.SignatureDescriptor_Data.decode(Rn, Rn.uint32());
            break;
          case 3:
            Aa.sequence = Rn.uint64();
            break;
          default:
            Rn.skipType(_a & 7);
            break;
        }
      }
      return Aa;
    },
    fromJSON($n) {
      return {
        publicKey: (0, he.isSet)($n.publicKey) ? le.Any.fromJSON($n.publicKey) : void 0,
        data: (0, he.isSet)($n.data) ? v.SignatureDescriptor_Data.fromJSON($n.data) : void 0,
        sequence: (0, he.isSet)($n.sequence) ? he.Long.fromValue($n.sequence) : he.Long.UZERO
      };
    },
    toJSON($n) {
      const En = {};
      return $n.publicKey !== void 0 && (En.publicKey = $n.publicKey ? le.Any.toJSON($n.publicKey) : void 0), $n.data !== void 0 && (En.data = $n.data ? v.SignatureDescriptor_Data.toJSON($n.data) : void 0), $n.sequence !== void 0 && (En.sequence = ($n.sequence || he.Long.UZERO).toString()), En;
    },
    fromPartial($n) {
      const En = Ne();
      return En.publicKey = $n.publicKey !== void 0 && $n.publicKey !== null ? le.Any.fromPartial($n.publicKey) : void 0, En.data = $n.data !== void 0 && $n.data !== null ? v.SignatureDescriptor_Data.fromPartial($n.data) : void 0, En.sequence = $n.sequence !== void 0 && $n.sequence !== null ? he.Long.fromValue($n.sequence) : he.Long.UZERO, En;
    }
  };
  function st() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  v.SignatureDescriptor_Data = {
    encode($n, En = ge.Writer.create()) {
      return $n.single !== void 0 && v.SignatureDescriptor_Data_Single.encode($n.single, En.uint32(10).fork()).ldelim(), $n.multi !== void 0 && v.SignatureDescriptor_Data_Multi.encode($n.multi, En.uint32(18).fork()).ldelim(), En;
    },
    decode($n, En) {
      const Rn = $n instanceof ge.Reader ? $n : new ge.Reader($n);
      let wa = En === void 0 ? Rn.len : Rn.pos + En;
      const Aa = st();
      for (; Rn.pos < wa; ) {
        const _a = Rn.uint32();
        switch (_a >>> 3) {
          case 1:
            Aa.single = v.SignatureDescriptor_Data_Single.decode(Rn, Rn.uint32());
            break;
          case 2:
            Aa.multi = v.SignatureDescriptor_Data_Multi.decode(Rn, Rn.uint32());
            break;
          default:
            Rn.skipType(_a & 7);
            break;
        }
      }
      return Aa;
    },
    fromJSON($n) {
      return {
        single: (0, he.isSet)($n.single) ? v.SignatureDescriptor_Data_Single.fromJSON($n.single) : void 0,
        multi: (0, he.isSet)($n.multi) ? v.SignatureDescriptor_Data_Multi.fromJSON($n.multi) : void 0
      };
    },
    toJSON($n) {
      const En = {};
      return $n.single !== void 0 && (En.single = $n.single ? v.SignatureDescriptor_Data_Single.toJSON($n.single) : void 0), $n.multi !== void 0 && (En.multi = $n.multi ? v.SignatureDescriptor_Data_Multi.toJSON($n.multi) : void 0), En;
    },
    fromPartial($n) {
      const En = st();
      return En.single = $n.single !== void 0 && $n.single !== null ? v.SignatureDescriptor_Data_Single.fromPartial($n.single) : void 0, En.multi = $n.multi !== void 0 && $n.multi !== null ? v.SignatureDescriptor_Data_Multi.fromPartial($n.multi) : void 0, En;
    }
  };
  function Nr() {
    return {
      mode: 0,
      signature: new Uint8Array()
    };
  }
  v.SignatureDescriptor_Data_Single = {
    encode($n, En = ge.Writer.create()) {
      return $n.mode !== 0 && En.uint32(8).int32($n.mode), $n.signature.length !== 0 && En.uint32(18).bytes($n.signature), En;
    },
    decode($n, En) {
      const Rn = $n instanceof ge.Reader ? $n : new ge.Reader($n);
      let wa = En === void 0 ? Rn.len : Rn.pos + En;
      const Aa = Nr();
      for (; Rn.pos < wa; ) {
        const _a = Rn.uint32();
        switch (_a >>> 3) {
          case 1:
            Aa.mode = Rn.int32();
            break;
          case 2:
            Aa.signature = Rn.bytes();
            break;
          default:
            Rn.skipType(_a & 7);
            break;
        }
      }
      return Aa;
    },
    fromJSON($n) {
      return {
        mode: (0, he.isSet)($n.mode) ? Ee($n.mode) : 0,
        signature: (0, he.isSet)($n.signature) ? (0, he.bytesFromBase64)($n.signature) : new Uint8Array()
      };
    },
    toJSON($n) {
      const En = {};
      return $n.mode !== void 0 && (En.mode = xe($n.mode)), $n.signature !== void 0 && (En.signature = (0, he.base64FromBytes)($n.signature !== void 0 ? $n.signature : new Uint8Array())), En;
    },
    fromPartial($n) {
      const En = Nr();
      return En.mode = $n.mode ?? 0, En.signature = $n.signature ?? new Uint8Array(), En;
    }
  };
  function br() {
    return {
      bitarray: void 0,
      signatures: []
    };
  }
  v.SignatureDescriptor_Data_Multi = {
    encode($n, En = ge.Writer.create()) {
      $n.bitarray !== void 0 && ue.CompactBitArray.encode($n.bitarray, En.uint32(10).fork()).ldelim();
      for (const Rn of $n.signatures)
        v.SignatureDescriptor_Data.encode(Rn, En.uint32(18).fork()).ldelim();
      return En;
    },
    decode($n, En) {
      const Rn = $n instanceof ge.Reader ? $n : new ge.Reader($n);
      let wa = En === void 0 ? Rn.len : Rn.pos + En;
      const Aa = br();
      for (; Rn.pos < wa; ) {
        const _a = Rn.uint32();
        switch (_a >>> 3) {
          case 1:
            Aa.bitarray = ue.CompactBitArray.decode(Rn, Rn.uint32());
            break;
          case 2:
            Aa.signatures.push(v.SignatureDescriptor_Data.decode(Rn, Rn.uint32()));
            break;
          default:
            Rn.skipType(_a & 7);
            break;
        }
      }
      return Aa;
    },
    fromJSON($n) {
      return {
        bitarray: (0, he.isSet)($n.bitarray) ? ue.CompactBitArray.fromJSON($n.bitarray) : void 0,
        signatures: Array.isArray($n == null ? void 0 : $n.signatures) ? $n.signatures.map((En) => v.SignatureDescriptor_Data.fromJSON(En)) : []
      };
    },
    toJSON($n) {
      const En = {};
      return $n.bitarray !== void 0 && (En.bitarray = $n.bitarray ? ue.CompactBitArray.toJSON($n.bitarray) : void 0), $n.signatures ? En.signatures = $n.signatures.map((Rn) => Rn ? v.SignatureDescriptor_Data.toJSON(Rn) : void 0) : En.signatures = [], En;
    },
    fromPartial($n) {
      var Rn;
      const En = br();
      return En.bitarray = $n.bitarray !== void 0 && $n.bitarray !== null ? ue.CompactBitArray.fromPartial($n.bitarray) : void 0, En.signatures = ((Rn = $n.signatures) == null ? void 0 : Rn.map((wa) => v.SignatureDescriptor_Data.fromPartial(wa))) || [], En;
    }
  };
})(signing$1);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(Zn, Ra, Yn, $o) {
    $o === void 0 && ($o = Yn);
    var ct = Object.getOwnPropertyDescriptor(Ra, Yn);
    (!ct || ("get" in ct ? !Ra.__esModule : ct.writable || ct.configurable)) && (ct = { enumerable: !0, get: function() {
      return Ra[Yn];
    } }), Object.defineProperty(Zn, $o, ct);
  } : function(Zn, Ra, Yn, $o) {
    $o === void 0 && ($o = Yn), Zn[$o] = Ra[Yn];
  }), z = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(Zn, Ra) {
    Object.defineProperty(Zn, "default", { enumerable: !0, value: Ra });
  } : function(Zn, Ra) {
    Zn.default = Ra;
  }), ne = commonjsGlobal && commonjsGlobal.__importStar || function(Zn) {
    if (Zn && Zn.__esModule)
      return Zn;
    var Ra = {};
    if (Zn != null)
      for (var Yn in Zn)
        Yn !== "default" && Object.prototype.hasOwnProperty.call(Zn, Yn) && y(Ra, Zn, Yn);
    return z(Ra, Zn), Ra;
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.AuxSignerData = v.Tip = v.Fee = v.ModeInfo_Multi = v.ModeInfo_Single = v.ModeInfo = v.SignerInfo = v.AuthInfo = v.TxBody = v.SignDocDirectAux = v.SignDoc = v.TxRaw = v.Tx = v.protobufPackage = void 0;
  const ue = any, le = signing$1, he = multisig$1, ge = coin$1, we = helpers, Ee = ne(minimal);
  v.protobufPackage = "cosmos.tx.v1beta1";
  function xe() {
    return {
      body: void 0,
      authInfo: void 0,
      signatures: []
    };
  }
  v.Tx = {
    encode(Zn, Ra = Ee.Writer.create()) {
      Zn.body !== void 0 && v.TxBody.encode(Zn.body, Ra.uint32(10).fork()).ldelim(), Zn.authInfo !== void 0 && v.AuthInfo.encode(Zn.authInfo, Ra.uint32(18).fork()).ldelim();
      for (const Yn of Zn.signatures)
        Ra.uint32(26).bytes(Yn);
      return Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = xe();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.body = v.TxBody.decode(Yn, Yn.uint32());
            break;
          case 2:
            ct.authInfo = v.AuthInfo.decode(Yn, Yn.uint32());
            break;
          case 3:
            ct.signatures.push(Yn.bytes());
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        body: (0, we.isSet)(Zn.body) ? v.TxBody.fromJSON(Zn.body) : void 0,
        authInfo: (0, we.isSet)(Zn.authInfo) ? v.AuthInfo.fromJSON(Zn.authInfo) : void 0,
        signatures: Array.isArray(Zn == null ? void 0 : Zn.signatures) ? Zn.signatures.map((Ra) => (0, we.bytesFromBase64)(Ra)) : []
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.body !== void 0 && (Ra.body = Zn.body ? v.TxBody.toJSON(Zn.body) : void 0), Zn.authInfo !== void 0 && (Ra.authInfo = Zn.authInfo ? v.AuthInfo.toJSON(Zn.authInfo) : void 0), Zn.signatures ? Ra.signatures = Zn.signatures.map((Yn) => (0, we.base64FromBytes)(Yn !== void 0 ? Yn : new Uint8Array())) : Ra.signatures = [], Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = xe();
      return Ra.body = Zn.body !== void 0 && Zn.body !== null ? v.TxBody.fromPartial(Zn.body) : void 0, Ra.authInfo = Zn.authInfo !== void 0 && Zn.authInfo !== null ? v.AuthInfo.fromPartial(Zn.authInfo) : void 0, Ra.signatures = ((Yn = Zn.signatures) == null ? void 0 : Yn.map(($o) => $o)) || [], Ra;
    }
  };
  function $e() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      signatures: []
    };
  }
  v.TxRaw = {
    encode(Zn, Ra = Ee.Writer.create()) {
      Zn.bodyBytes.length !== 0 && Ra.uint32(10).bytes(Zn.bodyBytes), Zn.authInfoBytes.length !== 0 && Ra.uint32(18).bytes(Zn.authInfoBytes);
      for (const Yn of Zn.signatures)
        Ra.uint32(26).bytes(Yn);
      return Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = $e();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.bodyBytes = Yn.bytes();
            break;
          case 2:
            ct.authInfoBytes = Yn.bytes();
            break;
          case 3:
            ct.signatures.push(Yn.bytes());
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        bodyBytes: (0, we.isSet)(Zn.bodyBytes) ? (0, we.bytesFromBase64)(Zn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, we.isSet)(Zn.authInfoBytes) ? (0, we.bytesFromBase64)(Zn.authInfoBytes) : new Uint8Array(),
        signatures: Array.isArray(Zn == null ? void 0 : Zn.signatures) ? Zn.signatures.map((Ra) => (0, we.bytesFromBase64)(Ra)) : []
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.bodyBytes !== void 0 && (Ra.bodyBytes = (0, we.base64FromBytes)(Zn.bodyBytes !== void 0 ? Zn.bodyBytes : new Uint8Array())), Zn.authInfoBytes !== void 0 && (Ra.authInfoBytes = (0, we.base64FromBytes)(Zn.authInfoBytes !== void 0 ? Zn.authInfoBytes : new Uint8Array())), Zn.signatures ? Ra.signatures = Zn.signatures.map((Yn) => (0, we.base64FromBytes)(Yn !== void 0 ? Yn : new Uint8Array())) : Ra.signatures = [], Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = $e();
      return Ra.bodyBytes = Zn.bodyBytes ?? new Uint8Array(), Ra.authInfoBytes = Zn.authInfoBytes ?? new Uint8Array(), Ra.signatures = ((Yn = Zn.signatures) == null ? void 0 : Yn.map(($o) => $o)) || [], Ra;
    }
  };
  function Ne() {
    return {
      bodyBytes: new Uint8Array(),
      authInfoBytes: new Uint8Array(),
      chainId: "",
      accountNumber: we.Long.UZERO
    };
  }
  v.SignDoc = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.bodyBytes.length !== 0 && Ra.uint32(10).bytes(Zn.bodyBytes), Zn.authInfoBytes.length !== 0 && Ra.uint32(18).bytes(Zn.authInfoBytes), Zn.chainId !== "" && Ra.uint32(26).string(Zn.chainId), Zn.accountNumber.isZero() || Ra.uint32(32).uint64(Zn.accountNumber), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = Ne();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.bodyBytes = Yn.bytes();
            break;
          case 2:
            ct.authInfoBytes = Yn.bytes();
            break;
          case 3:
            ct.chainId = Yn.string();
            break;
          case 4:
            ct.accountNumber = Yn.uint64();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        bodyBytes: (0, we.isSet)(Zn.bodyBytes) ? (0, we.bytesFromBase64)(Zn.bodyBytes) : new Uint8Array(),
        authInfoBytes: (0, we.isSet)(Zn.authInfoBytes) ? (0, we.bytesFromBase64)(Zn.authInfoBytes) : new Uint8Array(),
        chainId: (0, we.isSet)(Zn.chainId) ? String(Zn.chainId) : "",
        accountNumber: (0, we.isSet)(Zn.accountNumber) ? we.Long.fromValue(Zn.accountNumber) : we.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.bodyBytes !== void 0 && (Ra.bodyBytes = (0, we.base64FromBytes)(Zn.bodyBytes !== void 0 ? Zn.bodyBytes : new Uint8Array())), Zn.authInfoBytes !== void 0 && (Ra.authInfoBytes = (0, we.base64FromBytes)(Zn.authInfoBytes !== void 0 ? Zn.authInfoBytes : new Uint8Array())), Zn.chainId !== void 0 && (Ra.chainId = Zn.chainId), Zn.accountNumber !== void 0 && (Ra.accountNumber = (Zn.accountNumber || we.Long.UZERO).toString()), Ra;
    },
    fromPartial(Zn) {
      const Ra = Ne();
      return Ra.bodyBytes = Zn.bodyBytes ?? new Uint8Array(), Ra.authInfoBytes = Zn.authInfoBytes ?? new Uint8Array(), Ra.chainId = Zn.chainId ?? "", Ra.accountNumber = Zn.accountNumber !== void 0 && Zn.accountNumber !== null ? we.Long.fromValue(Zn.accountNumber) : we.Long.UZERO, Ra;
    }
  };
  function st() {
    return {
      bodyBytes: new Uint8Array(),
      publicKey: void 0,
      chainId: "",
      accountNumber: we.Long.UZERO,
      sequence: we.Long.UZERO,
      tip: void 0
    };
  }
  v.SignDocDirectAux = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.bodyBytes.length !== 0 && Ra.uint32(10).bytes(Zn.bodyBytes), Zn.publicKey !== void 0 && ue.Any.encode(Zn.publicKey, Ra.uint32(18).fork()).ldelim(), Zn.chainId !== "" && Ra.uint32(26).string(Zn.chainId), Zn.accountNumber.isZero() || Ra.uint32(32).uint64(Zn.accountNumber), Zn.sequence.isZero() || Ra.uint32(40).uint64(Zn.sequence), Zn.tip !== void 0 && v.Tip.encode(Zn.tip, Ra.uint32(50).fork()).ldelim(), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = st();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.bodyBytes = Yn.bytes();
            break;
          case 2:
            ct.publicKey = ue.Any.decode(Yn, Yn.uint32());
            break;
          case 3:
            ct.chainId = Yn.string();
            break;
          case 4:
            ct.accountNumber = Yn.uint64();
            break;
          case 5:
            ct.sequence = Yn.uint64();
            break;
          case 6:
            ct.tip = v.Tip.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        bodyBytes: (0, we.isSet)(Zn.bodyBytes) ? (0, we.bytesFromBase64)(Zn.bodyBytes) : new Uint8Array(),
        publicKey: (0, we.isSet)(Zn.publicKey) ? ue.Any.fromJSON(Zn.publicKey) : void 0,
        chainId: (0, we.isSet)(Zn.chainId) ? String(Zn.chainId) : "",
        accountNumber: (0, we.isSet)(Zn.accountNumber) ? we.Long.fromValue(Zn.accountNumber) : we.Long.UZERO,
        sequence: (0, we.isSet)(Zn.sequence) ? we.Long.fromValue(Zn.sequence) : we.Long.UZERO,
        tip: (0, we.isSet)(Zn.tip) ? v.Tip.fromJSON(Zn.tip) : void 0
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.bodyBytes !== void 0 && (Ra.bodyBytes = (0, we.base64FromBytes)(Zn.bodyBytes !== void 0 ? Zn.bodyBytes : new Uint8Array())), Zn.publicKey !== void 0 && (Ra.publicKey = Zn.publicKey ? ue.Any.toJSON(Zn.publicKey) : void 0), Zn.chainId !== void 0 && (Ra.chainId = Zn.chainId), Zn.accountNumber !== void 0 && (Ra.accountNumber = (Zn.accountNumber || we.Long.UZERO).toString()), Zn.sequence !== void 0 && (Ra.sequence = (Zn.sequence || we.Long.UZERO).toString()), Zn.tip !== void 0 && (Ra.tip = Zn.tip ? v.Tip.toJSON(Zn.tip) : void 0), Ra;
    },
    fromPartial(Zn) {
      const Ra = st();
      return Ra.bodyBytes = Zn.bodyBytes ?? new Uint8Array(), Ra.publicKey = Zn.publicKey !== void 0 && Zn.publicKey !== null ? ue.Any.fromPartial(Zn.publicKey) : void 0, Ra.chainId = Zn.chainId ?? "", Ra.accountNumber = Zn.accountNumber !== void 0 && Zn.accountNumber !== null ? we.Long.fromValue(Zn.accountNumber) : we.Long.UZERO, Ra.sequence = Zn.sequence !== void 0 && Zn.sequence !== null ? we.Long.fromValue(Zn.sequence) : we.Long.UZERO, Ra.tip = Zn.tip !== void 0 && Zn.tip !== null ? v.Tip.fromPartial(Zn.tip) : void 0, Ra;
    }
  };
  function Nr() {
    return {
      messages: [],
      memo: "",
      timeoutHeight: we.Long.UZERO,
      extensionOptions: [],
      nonCriticalExtensionOptions: []
    };
  }
  v.TxBody = {
    encode(Zn, Ra = Ee.Writer.create()) {
      for (const Yn of Zn.messages)
        ue.Any.encode(Yn, Ra.uint32(10).fork()).ldelim();
      Zn.memo !== "" && Ra.uint32(18).string(Zn.memo), Zn.timeoutHeight.isZero() || Ra.uint32(24).uint64(Zn.timeoutHeight);
      for (const Yn of Zn.extensionOptions)
        ue.Any.encode(Yn, Ra.uint32(8186).fork()).ldelim();
      for (const Yn of Zn.nonCriticalExtensionOptions)
        ue.Any.encode(Yn, Ra.uint32(16378).fork()).ldelim();
      return Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = Nr();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.messages.push(ue.Any.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ct.memo = Yn.string();
            break;
          case 3:
            ct.timeoutHeight = Yn.uint64();
            break;
          case 1023:
            ct.extensionOptions.push(ue.Any.decode(Yn, Yn.uint32()));
            break;
          case 2047:
            ct.nonCriticalExtensionOptions.push(ue.Any.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        messages: Array.isArray(Zn == null ? void 0 : Zn.messages) ? Zn.messages.map((Ra) => ue.Any.fromJSON(Ra)) : [],
        memo: (0, we.isSet)(Zn.memo) ? String(Zn.memo) : "",
        timeoutHeight: (0, we.isSet)(Zn.timeoutHeight) ? we.Long.fromValue(Zn.timeoutHeight) : we.Long.UZERO,
        extensionOptions: Array.isArray(Zn == null ? void 0 : Zn.extensionOptions) ? Zn.extensionOptions.map((Ra) => ue.Any.fromJSON(Ra)) : [],
        nonCriticalExtensionOptions: Array.isArray(Zn == null ? void 0 : Zn.nonCriticalExtensionOptions) ? Zn.nonCriticalExtensionOptions.map((Ra) => ue.Any.fromJSON(Ra)) : []
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.messages ? Ra.messages = Zn.messages.map((Yn) => Yn ? ue.Any.toJSON(Yn) : void 0) : Ra.messages = [], Zn.memo !== void 0 && (Ra.memo = Zn.memo), Zn.timeoutHeight !== void 0 && (Ra.timeoutHeight = (Zn.timeoutHeight || we.Long.UZERO).toString()), Zn.extensionOptions ? Ra.extensionOptions = Zn.extensionOptions.map((Yn) => Yn ? ue.Any.toJSON(Yn) : void 0) : Ra.extensionOptions = [], Zn.nonCriticalExtensionOptions ? Ra.nonCriticalExtensionOptions = Zn.nonCriticalExtensionOptions.map((Yn) => Yn ? ue.Any.toJSON(Yn) : void 0) : Ra.nonCriticalExtensionOptions = [], Ra;
    },
    fromPartial(Zn) {
      var Yn, $o, ct;
      const Ra = Nr();
      return Ra.messages = ((Yn = Zn.messages) == null ? void 0 : Yn.map((fe) => ue.Any.fromPartial(fe))) || [], Ra.memo = Zn.memo ?? "", Ra.timeoutHeight = Zn.timeoutHeight !== void 0 && Zn.timeoutHeight !== null ? we.Long.fromValue(Zn.timeoutHeight) : we.Long.UZERO, Ra.extensionOptions = (($o = Zn.extensionOptions) == null ? void 0 : $o.map((fe) => ue.Any.fromPartial(fe))) || [], Ra.nonCriticalExtensionOptions = ((ct = Zn.nonCriticalExtensionOptions) == null ? void 0 : ct.map((fe) => ue.Any.fromPartial(fe))) || [], Ra;
    }
  };
  function br() {
    return {
      signerInfos: [],
      fee: void 0,
      tip: void 0
    };
  }
  v.AuthInfo = {
    encode(Zn, Ra = Ee.Writer.create()) {
      for (const Yn of Zn.signerInfos)
        v.SignerInfo.encode(Yn, Ra.uint32(10).fork()).ldelim();
      return Zn.fee !== void 0 && v.Fee.encode(Zn.fee, Ra.uint32(18).fork()).ldelim(), Zn.tip !== void 0 && v.Tip.encode(Zn.tip, Ra.uint32(26).fork()).ldelim(), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = br();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.signerInfos.push(v.SignerInfo.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ct.fee = v.Fee.decode(Yn, Yn.uint32());
            break;
          case 3:
            ct.tip = v.Tip.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        signerInfos: Array.isArray(Zn == null ? void 0 : Zn.signerInfos) ? Zn.signerInfos.map((Ra) => v.SignerInfo.fromJSON(Ra)) : [],
        fee: (0, we.isSet)(Zn.fee) ? v.Fee.fromJSON(Zn.fee) : void 0,
        tip: (0, we.isSet)(Zn.tip) ? v.Tip.fromJSON(Zn.tip) : void 0
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.signerInfos ? Ra.signerInfos = Zn.signerInfos.map((Yn) => Yn ? v.SignerInfo.toJSON(Yn) : void 0) : Ra.signerInfos = [], Zn.fee !== void 0 && (Ra.fee = Zn.fee ? v.Fee.toJSON(Zn.fee) : void 0), Zn.tip !== void 0 && (Ra.tip = Zn.tip ? v.Tip.toJSON(Zn.tip) : void 0), Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = br();
      return Ra.signerInfos = ((Yn = Zn.signerInfos) == null ? void 0 : Yn.map(($o) => v.SignerInfo.fromPartial($o))) || [], Ra.fee = Zn.fee !== void 0 && Zn.fee !== null ? v.Fee.fromPartial(Zn.fee) : void 0, Ra.tip = Zn.tip !== void 0 && Zn.tip !== null ? v.Tip.fromPartial(Zn.tip) : void 0, Ra;
    }
  };
  function $n() {
    return {
      publicKey: void 0,
      modeInfo: void 0,
      sequence: we.Long.UZERO
    };
  }
  v.SignerInfo = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.publicKey !== void 0 && ue.Any.encode(Zn.publicKey, Ra.uint32(10).fork()).ldelim(), Zn.modeInfo !== void 0 && v.ModeInfo.encode(Zn.modeInfo, Ra.uint32(18).fork()).ldelim(), Zn.sequence.isZero() || Ra.uint32(24).uint64(Zn.sequence), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = $n();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.publicKey = ue.Any.decode(Yn, Yn.uint32());
            break;
          case 2:
            ct.modeInfo = v.ModeInfo.decode(Yn, Yn.uint32());
            break;
          case 3:
            ct.sequence = Yn.uint64();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        publicKey: (0, we.isSet)(Zn.publicKey) ? ue.Any.fromJSON(Zn.publicKey) : void 0,
        modeInfo: (0, we.isSet)(Zn.modeInfo) ? v.ModeInfo.fromJSON(Zn.modeInfo) : void 0,
        sequence: (0, we.isSet)(Zn.sequence) ? we.Long.fromValue(Zn.sequence) : we.Long.UZERO
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.publicKey !== void 0 && (Ra.publicKey = Zn.publicKey ? ue.Any.toJSON(Zn.publicKey) : void 0), Zn.modeInfo !== void 0 && (Ra.modeInfo = Zn.modeInfo ? v.ModeInfo.toJSON(Zn.modeInfo) : void 0), Zn.sequence !== void 0 && (Ra.sequence = (Zn.sequence || we.Long.UZERO).toString()), Ra;
    },
    fromPartial(Zn) {
      const Ra = $n();
      return Ra.publicKey = Zn.publicKey !== void 0 && Zn.publicKey !== null ? ue.Any.fromPartial(Zn.publicKey) : void 0, Ra.modeInfo = Zn.modeInfo !== void 0 && Zn.modeInfo !== null ? v.ModeInfo.fromPartial(Zn.modeInfo) : void 0, Ra.sequence = Zn.sequence !== void 0 && Zn.sequence !== null ? we.Long.fromValue(Zn.sequence) : we.Long.UZERO, Ra;
    }
  };
  function En() {
    return {
      single: void 0,
      multi: void 0
    };
  }
  v.ModeInfo = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.single !== void 0 && v.ModeInfo_Single.encode(Zn.single, Ra.uint32(10).fork()).ldelim(), Zn.multi !== void 0 && v.ModeInfo_Multi.encode(Zn.multi, Ra.uint32(18).fork()).ldelim(), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = En();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.single = v.ModeInfo_Single.decode(Yn, Yn.uint32());
            break;
          case 2:
            ct.multi = v.ModeInfo_Multi.decode(Yn, Yn.uint32());
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        single: (0, we.isSet)(Zn.single) ? v.ModeInfo_Single.fromJSON(Zn.single) : void 0,
        multi: (0, we.isSet)(Zn.multi) ? v.ModeInfo_Multi.fromJSON(Zn.multi) : void 0
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.single !== void 0 && (Ra.single = Zn.single ? v.ModeInfo_Single.toJSON(Zn.single) : void 0), Zn.multi !== void 0 && (Ra.multi = Zn.multi ? v.ModeInfo_Multi.toJSON(Zn.multi) : void 0), Ra;
    },
    fromPartial(Zn) {
      const Ra = En();
      return Ra.single = Zn.single !== void 0 && Zn.single !== null ? v.ModeInfo_Single.fromPartial(Zn.single) : void 0, Ra.multi = Zn.multi !== void 0 && Zn.multi !== null ? v.ModeInfo_Multi.fromPartial(Zn.multi) : void 0, Ra;
    }
  };
  function Rn() {
    return {
      mode: 0
    };
  }
  v.ModeInfo_Single = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.mode !== 0 && Ra.uint32(8).int32(Zn.mode), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = Rn();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.mode = Yn.int32();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        mode: (0, we.isSet)(Zn.mode) ? (0, le.signModeFromJSON)(Zn.mode) : 0
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.mode !== void 0 && (Ra.mode = (0, le.signModeToJSON)(Zn.mode)), Ra;
    },
    fromPartial(Zn) {
      const Ra = Rn();
      return Ra.mode = Zn.mode ?? 0, Ra;
    }
  };
  function wa() {
    return {
      bitarray: void 0,
      modeInfos: []
    };
  }
  v.ModeInfo_Multi = {
    encode(Zn, Ra = Ee.Writer.create()) {
      Zn.bitarray !== void 0 && he.CompactBitArray.encode(Zn.bitarray, Ra.uint32(10).fork()).ldelim();
      for (const Yn of Zn.modeInfos)
        v.ModeInfo.encode(Yn, Ra.uint32(18).fork()).ldelim();
      return Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = wa();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.bitarray = he.CompactBitArray.decode(Yn, Yn.uint32());
            break;
          case 2:
            ct.modeInfos.push(v.ModeInfo.decode(Yn, Yn.uint32()));
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        bitarray: (0, we.isSet)(Zn.bitarray) ? he.CompactBitArray.fromJSON(Zn.bitarray) : void 0,
        modeInfos: Array.isArray(Zn == null ? void 0 : Zn.modeInfos) ? Zn.modeInfos.map((Ra) => v.ModeInfo.fromJSON(Ra)) : []
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.bitarray !== void 0 && (Ra.bitarray = Zn.bitarray ? he.CompactBitArray.toJSON(Zn.bitarray) : void 0), Zn.modeInfos ? Ra.modeInfos = Zn.modeInfos.map((Yn) => Yn ? v.ModeInfo.toJSON(Yn) : void 0) : Ra.modeInfos = [], Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = wa();
      return Ra.bitarray = Zn.bitarray !== void 0 && Zn.bitarray !== null ? he.CompactBitArray.fromPartial(Zn.bitarray) : void 0, Ra.modeInfos = ((Yn = Zn.modeInfos) == null ? void 0 : Yn.map(($o) => v.ModeInfo.fromPartial($o))) || [], Ra;
    }
  };
  function Aa() {
    return {
      amount: [],
      gasLimit: we.Long.UZERO,
      payer: "",
      granter: ""
    };
  }
  v.Fee = {
    encode(Zn, Ra = Ee.Writer.create()) {
      for (const Yn of Zn.amount)
        ge.Coin.encode(Yn, Ra.uint32(10).fork()).ldelim();
      return Zn.gasLimit.isZero() || Ra.uint32(16).uint64(Zn.gasLimit), Zn.payer !== "" && Ra.uint32(26).string(Zn.payer), Zn.granter !== "" && Ra.uint32(34).string(Zn.granter), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = Aa();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.amount.push(ge.Coin.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ct.gasLimit = Yn.uint64();
            break;
          case 3:
            ct.payer = Yn.string();
            break;
          case 4:
            ct.granter = Yn.string();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        amount: Array.isArray(Zn == null ? void 0 : Zn.amount) ? Zn.amount.map((Ra) => ge.Coin.fromJSON(Ra)) : [],
        gasLimit: (0, we.isSet)(Zn.gasLimit) ? we.Long.fromValue(Zn.gasLimit) : we.Long.UZERO,
        payer: (0, we.isSet)(Zn.payer) ? String(Zn.payer) : "",
        granter: (0, we.isSet)(Zn.granter) ? String(Zn.granter) : ""
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.amount ? Ra.amount = Zn.amount.map((Yn) => Yn ? ge.Coin.toJSON(Yn) : void 0) : Ra.amount = [], Zn.gasLimit !== void 0 && (Ra.gasLimit = (Zn.gasLimit || we.Long.UZERO).toString()), Zn.payer !== void 0 && (Ra.payer = Zn.payer), Zn.granter !== void 0 && (Ra.granter = Zn.granter), Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = Aa();
      return Ra.amount = ((Yn = Zn.amount) == null ? void 0 : Yn.map(($o) => ge.Coin.fromPartial($o))) || [], Ra.gasLimit = Zn.gasLimit !== void 0 && Zn.gasLimit !== null ? we.Long.fromValue(Zn.gasLimit) : we.Long.UZERO, Ra.payer = Zn.payer ?? "", Ra.granter = Zn.granter ?? "", Ra;
    }
  };
  function _a() {
    return {
      amount: [],
      tipper: ""
    };
  }
  v.Tip = {
    encode(Zn, Ra = Ee.Writer.create()) {
      for (const Yn of Zn.amount)
        ge.Coin.encode(Yn, Ra.uint32(10).fork()).ldelim();
      return Zn.tipper !== "" && Ra.uint32(18).string(Zn.tipper), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = _a();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.amount.push(ge.Coin.decode(Yn, Yn.uint32()));
            break;
          case 2:
            ct.tipper = Yn.string();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        amount: Array.isArray(Zn == null ? void 0 : Zn.amount) ? Zn.amount.map((Ra) => ge.Coin.fromJSON(Ra)) : [],
        tipper: (0, we.isSet)(Zn.tipper) ? String(Zn.tipper) : ""
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.amount ? Ra.amount = Zn.amount.map((Yn) => Yn ? ge.Coin.toJSON(Yn) : void 0) : Ra.amount = [], Zn.tipper !== void 0 && (Ra.tipper = Zn.tipper), Ra;
    },
    fromPartial(Zn) {
      var Yn;
      const Ra = _a();
      return Ra.amount = ((Yn = Zn.amount) == null ? void 0 : Yn.map(($o) => ge.Coin.fromPartial($o))) || [], Ra.tipper = Zn.tipper ?? "", Ra;
    }
  };
  function Ta() {
    return {
      address: "",
      signDoc: void 0,
      mode: 0,
      sig: new Uint8Array()
    };
  }
  v.AuxSignerData = {
    encode(Zn, Ra = Ee.Writer.create()) {
      return Zn.address !== "" && Ra.uint32(10).string(Zn.address), Zn.signDoc !== void 0 && v.SignDocDirectAux.encode(Zn.signDoc, Ra.uint32(18).fork()).ldelim(), Zn.mode !== 0 && Ra.uint32(24).int32(Zn.mode), Zn.sig.length !== 0 && Ra.uint32(34).bytes(Zn.sig), Ra;
    },
    decode(Zn, Ra) {
      const Yn = Zn instanceof Ee.Reader ? Zn : new Ee.Reader(Zn);
      let $o = Ra === void 0 ? Yn.len : Yn.pos + Ra;
      const ct = Ta();
      for (; Yn.pos < $o; ) {
        const fe = Yn.uint32();
        switch (fe >>> 3) {
          case 1:
            ct.address = Yn.string();
            break;
          case 2:
            ct.signDoc = v.SignDocDirectAux.decode(Yn, Yn.uint32());
            break;
          case 3:
            ct.mode = Yn.int32();
            break;
          case 4:
            ct.sig = Yn.bytes();
            break;
          default:
            Yn.skipType(fe & 7);
            break;
        }
      }
      return ct;
    },
    fromJSON(Zn) {
      return {
        address: (0, we.isSet)(Zn.address) ? String(Zn.address) : "",
        signDoc: (0, we.isSet)(Zn.signDoc) ? v.SignDocDirectAux.fromJSON(Zn.signDoc) : void 0,
        mode: (0, we.isSet)(Zn.mode) ? (0, le.signModeFromJSON)(Zn.mode) : 0,
        sig: (0, we.isSet)(Zn.sig) ? (0, we.bytesFromBase64)(Zn.sig) : new Uint8Array()
      };
    },
    toJSON(Zn) {
      const Ra = {};
      return Zn.address !== void 0 && (Ra.address = Zn.address), Zn.signDoc !== void 0 && (Ra.signDoc = Zn.signDoc ? v.SignDocDirectAux.toJSON(Zn.signDoc) : void 0), Zn.mode !== void 0 && (Ra.mode = (0, le.signModeToJSON)(Zn.mode)), Zn.sig !== void 0 && (Ra.sig = (0, we.base64FromBytes)(Zn.sig !== void 0 ? Zn.sig : new Uint8Array())), Ra;
    },
    fromPartial(Zn) {
      const Ra = Ta();
      return Ra.address = Zn.address ?? "", Ra.signDoc = Zn.signDoc !== void 0 && Zn.signDoc !== null ? v.SignDocDirectAux.fromPartial(Zn.signDoc) : void 0, Ra.mode = Zn.mode ?? 0, Ra.sig = Zn.sig ?? new Uint8Array(), Ra;
    }
  };
})(tx);
async function simulateTx(v, y, z, ne = { amount: [] }, ue = "") {
  const le = await fetchAccountDetails(v, y), he = tx.TxRaw.encode({
    bodyBytes: tx.TxBody.encode(tx.TxBody.fromPartial({
      messages: z,
      memo: ue
    })).finish(),
    authInfoBytes: tx.AuthInfo.encode({
      signerInfos: [
        tx.SignerInfo.fromPartial({
          modeInfo: {
            single: {
              mode: signing$1.SignMode.SIGN_MODE_DIRECT
            }
          },
          sequence: le.sequence
        })
      ],
      fee: tx.Fee.fromPartial({
        amount: ne.amount.map((ge) => ({ amount: ge.amount, denom: ge.denom }))
      })
    }).finish(),
    signatures: [new Uint8Array(64)]
  }).finish();
  try {
    const we = await (await ky.post(`${v}/cosmos/tx/v1beta1/simulate`, {
      json: { tx_bytes: Buffer.from(he).toString("base64") },
      timeout: 5e3
    })).json();
    if ("message" in we)
      throw new Error(we.message);
    const Ee = parseInt(we.gas_info.gas_used), xe = parseInt(we.gas_info.gas_wanted);
    if (Number.isNaN(Ee))
      throw new Error(`Invalid integer gas: ${we.gas_info.gas_used}`);
    return {
      gasUsed: Ee,
      gasWanted: xe
    };
  } catch (ge) {
    throw new Error(ge);
  }
}
var BRIDGES;
(function(v) {
  v.IBC = "IBC", v.AXELAR = "AXELAR", v.CCTP = "CCTP", v.HYPERLANE = "HYPERLANE";
})(BRIDGES || (BRIDGES = {}));
var SKIP_TXN_STATUS;
(function(v) {
  v.STATE_SUBMITTED = "STATE_SUBMITTED", v.STATE_PENDING = "STATE_PENDING", v.STATE_COMPLETED = "STATE_COMPLETED", v.STATE_ABANDONED = "STATE_ABANDONED", v.STATE_RECEIVED = "STATE_RECEIVED", v.STATE_COMPLETED_SUCCESS = "STATE_COMPLETED_SUCCESS", v.STATE_COMPLETED_ERROR = "STATE_COMPLETED_ERROR";
})(SKIP_TXN_STATUS || (SKIP_TXN_STATUS = {}));
var TRANSFER_STATE;
(function(v) {
  v.TRANSFER_UNKNOWN = "TRANSFER_UNKNOWN", v.TRANSFER_PENDING = "TRANSFER_PENDING", v.TRANSFER_RECEIVED = "TRANSFER_RECEIVED", v.TRANSFER_SUCCESS = "TRANSFER_SUCCESS", v.TRANSFER_FAILURE = "TRANSFER_FAILURE";
})(TRANSFER_STATE || (TRANSFER_STATE = {}));
const defaultExpiryDuration = 60 * 60 * 1e3, DEFAULT_CLIENT_ID = "elements-sdk", SKIP_API_BASE_URL = "https://api.skip.money", H2 = class H2 {
  static isCacheInitialized() {
    return H2.supportedChainsCache !== void 0;
  }
  static initializeCache(y) {
    H2.supportedChainsCache = new AsyncStorage(y, StorageKeys.SKIP_SUPPORTED_CHAINS);
  }
  static setClientID(y) {
    this.clientID = y;
  }
  static getClientID() {
    return this.clientID;
  }
  /**
   * Retrieves the list of supported chains from the Skip API.
   * @returns A Promise that resolves to an object containing either a list of supported chains
   *          on success, or an error message on failure. See {@link SupportedChains}.
   */
  static async getSupportedChains(y) {
    var le, he;
    const z = (y == null ? void 0 : y.includeEVM) ?? !1, ne = (y == null ? void 0 : y.includeTestnets) ?? !1, ue = (y == null ? void 0 : y.includeSVM) ?? !1;
    if (y != null && y.cached) {
      !H2.isCacheInitialized() && storageLayer.isInitialized() && H2.initializeCache(storageLayer.getStorage());
      const ge = await ((le = H2.supportedChainsCache) == null ? void 0 : le.getItem(`supportedChains:evm-${z}:svm-${ue}:testnets-${ne}`));
      if (ge && Date.now() - ge.timestamp < defaultExpiryDuration && ge.chains.length > 0)
        return {
          success: !0,
          chains: ge.chains
        };
    }
    try {
      const ge = await H2.ky.get("v1/info/chains", {
        searchParams: {
          include_evm: z,
          include_testnets: ne,
          include_svm: ue,
          client_id: H2.clientID
        }
      });
      console.log(ge);
      const Ee = (await ge.json()).chains.map((xe) => ({
        chainId: xe.chain_id,
        chainName: xe.chain_name,
        pfmEnabled: xe.pfm_enabled,
        logoUri: xe.logo_uri,
        bech32Prefix: xe.bech32_prefix,
        chainType: xe.chain_type,
        icon: xe.logo_uri
      }));
      return H2.isCacheInitialized() && ((he = H2.supportedChainsCache) == null || he.setItem(`supportedChains:evm-${z}:svm-${ue}:testnets-${ne}`, {
        chains: Ee,
        timestamp: Date.now()
      })), {
        success: !0,
        chains: Ee
      };
    } catch (ge) {
      return ge instanceof HTTPError && ge.response ? {
        success: !1,
        error: (await ge.response.json()).message
      } : {
        success: !1,
        error: ge.message
      };
    }
  }
  /**
   * Retrieves the supported assets for a specified chain.
   * @param args - The arguments for the request including chainId and nativeOnly flag. See {@link RequestSupportedAssetsForChainArgs}.
   * @returns A promise that resolves to an object containing the supported assets for the given chain,
   *          or an error message if unsuccessful. See {@link SkipSupportedAsset}.
   */
  static async getSupportedAssets(y) {
    try {
      const ne = await (await H2.ky.get("v1/fungible/assets", {
        searchParams: {
          native_only: y.nativeOnly ?? !1,
          include_cw20_assets: y.includeCW20Assets ?? !1,
          include_no_metadata_assets: y.includeNoMetadataAssets ?? !1,
          include_evm_assets: y.includeEVMAssets ?? !1,
          include_svm_assets: y.includeSVMAssets ?? !1,
          client_id: H2.clientID
        }
      })).json(), ue = {};
      for (const le in ne.chain_to_assets_map)
        ue[le] = ne.chain_to_assets_map[le].assets.filter((he) => he.decimals !== void 0).map((he) => ({
          chainId: he.chain_id,
          denom: he.denom,
          originDenom: he.origin_denom,
          originChainId: he.origin_chain_id,
          trace: he.trace,
          symbol: he.recommended_symbol ?? he.symbol ?? he.denom,
          name: he.name ?? null,
          logoUri: he.logo_uri ?? "",
          tokenContract: he.token_contract,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          decimals: he.decimals,
          coingeckoId: he.coingecko_id,
          isCw20: he.is_cw20
        }));
      return {
        success: !0,
        assets: ue
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Retrieves the supported assets for a specified chain.
   * @param args - The arguments for the request including chainId and nativeOnly flag. See {@link RequestSupportedAssetsForChainArgs}.
   * @returns A promise that resolves to an object containing the supported assets for the given chain,
   *          or an error message if unsuccessful. See {@link SupportedAsset}.
   */
  static async getSupportedAssetsForChain(y) {
    try {
      return {
        success: !0,
        assets: (await (await H2.ky.get("v1/fungible/assets", {
          searchParams: {
            chain_id: y.chainId,
            native_only: y.nativeOnly ?? !1,
            include_cw20_assets: y.includeCW20Assets ?? !1,
            include_no_metadata_assets: y.includeNoMetadataAssets ?? !1,
            include_evm_assets: y.includeEVMAssets ?? !1,
            include_svm_assets: y.includeSVMAssets ?? !1,
            client_id: H2.clientID
          }
        })).json()).chain_to_assets_map[y.chainId].assets.map((ue) => ({
          chainId: ue.chain_id,
          denom: ue.denom,
          originDenom: ue.origin_denom,
          originChainId: ue.origin_chain_id,
          trace: ue.trace,
          symbol: ue.recommended_symbol,
          name: ue.name,
          logoUri: ue.logo_uri,
          tokenContract: ue.token_contract,
          decimals: ue.decimals
        }))
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Fetches the IBC origin assets based on provided asset details.
   * @param args - Array of objects containing denom and chainId. See the argument structure in {@link SupportedAsset}.
   * @returns A promise that resolves to an object containing either the origin assets {@link SupportedAsset}
   *          or an error message.
   */
  static async getIbcOriginAssets(y) {
    try {
      return {
        success: !0,
        data: (await (await H2.ky.post("v1/fungible/ibc_origin_assets", {
          json: {
            assets: y.map((le) => ({
              denom: le.denom,
              chain_id: le.chainId
            })),
            client_id: H2.clientID
          }
        })).json()).origin_assets.map((le) => {
          if ("error" in le)
            return null;
          const { asset: he } = le;
          return {
            chainId: he.chain_id,
            denom: he.denom,
            originDenom: he.origin_denom,
            originChainId: he.origin_chain_id,
            trace: he.trace,
            symbol: he.recommended_symbol,
            name: he.name,
            logoUri: he.logo_uri,
            decimals: he.decimals,
            coingeckoId: he.coingecko_id
          };
        })
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Calculates the route for token transfer between two assets.
   * @param args - The arguments required to calculate the route, including source and destination asset details. See {@link RouteRequest}.
   * @returns A promise that resolves to an object containing the route details {@link RouteResponse} or an error message.
   */
  static async getRoute(y) {
    try {
      return {
        success: !0,
        route: await (await H2.ky.post("v2/fungible/route", {
          json: { ...y, client_id: H2.clientID }
        })).json()
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: `Error getting route - ${z.message ?? "unknown error"}`
      };
    }
  }
  /**
   * Fetches recommended chains for a given asset.
   * @param args - The request arguments including source asset denom and chain ID, and an optional flag for multi-tx. See {@link RecommendedChainRequest}.
   * @returns A promise that resolves to an array containing recommended chains {@link RecommendedAssetResponse} or an error message.
   */
  static async getRecommendedAssets(y) {
    try {
      return {
        success: !0,
        recommendations: (await (await H2.ky.post("v1/fungible/recommend_assets", {
          json: {
            ...y,
            client_id: H2.clientID
          }
        })).json()).recommendations.map((ue) => ({
          denom: ue.asset.denom,
          chainId: ue.asset.chain_id,
          originDenom: ue.asset.origin_denom,
          symbol: ue.asset.symbol,
          name: ue.asset.name,
          logoUri: ue.asset.logo_uri,
          decimals: ue.asset.decimals
        }))
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Fetches recommended chains for a given asset.
   * @param args - The request arguments including source asset denom and chain ID, and an optional flag for multi-tx.
   * @returns A promise that resolves to an object containing recommended chains or an error message.
   */
  static async getRecommendedChainAssets(y) {
    try {
      return {
        success: !0,
        chains: (await (await H2.ky.post("v1/fungible/assets_from_source", {
          json: {
            ...y,
            client_id: H2.clientID
          }
        })).json()).dest_assets
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Retrieves the necessary messages for transaction creation.
   * @param args - The request parameters including asset and transaction details. {@link MsgsRequest}
   * @returns A promise that resolves to an object containing transaction messages or an error message.
   */
  static async getMessages(y) {
    try {
      const ne = await (await H2.ky.post("v2/fungible/msgs", {
        json: { ...y, client_id: H2.clientID }
      })).json();
      return {
        success: !0,
        msgs: ne.msgs,
        data: ne
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: `Error while getting transaction messages - ${(await z.response.json()).message}`
      } : {
        success: !1,
        error: `Error while getting transaction messages - ${z.message}`
      };
    }
  }
  /**
   * Submits a transaction to the blockchain.
   * @param args - The transaction request including chain ID and transaction data. {@link SubmitTransactionRequest}
   * @returns A promise that resolves to an object indicating the success of the transaction submission
   *          along with the transaction response {@link TransactionResponse} or an error message.
   */
  static async submitTransaction(y) {
    try {
      return {
        success: !0,
        response: await (await H2.ky.post("v2/tx/submit", {
          json: {
            ...y,
            client_id: H2.clientID
          }
        })).json()
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  static async trackTransaction(y) {
    try {
      return {
        success: !0,
        response: await (await H2.ky.post("v2/tx/track", {
          json: {
            ...y,
            client_id: H2.clientID
          }
        })).json()
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
  /**
   * Retrieves the status of a transaction.
   * @param args - Request parameters including transaction hash and chain ID ({@link TransactionStatusRequest}).
   * @returns A promise resolving to an object containing the transaction status
   *          ({@link TransactionStatusResponse}) or an error message.
   */
  static async getTxnStatus(y) {
    try {
      return {
        success: !0,
        response: await (await H2.ky.get("v2/tx/status", {
          searchParams: {
            ...y,
            client_id: H2.clientID
          }
        })).json()
      };
    } catch (z) {
      return z instanceof HTTPError && z.response ? {
        success: !1,
        error: (await z.response.json()).message
      } : {
        success: !1,
        error: z.message
      };
    }
  }
};
Rm(H2, "ky", ky.create({
  prefixUrl: SKIP_API_BASE_URL,
  timeout: !1
})), Rm(H2, "supportedChainsCache"), Rm(H2, "clientID", DEFAULT_CLIENT_ID);
let SkipAPI = H2;
process$1.env.NODE_ENV;
const getSourceChain = async (v, y, z) => {
  const ue = v.split("/").filter((ge) => ge.startsWith("channel-")), le = [y.chainId];
  let he = y;
  for (const ge of ue) {
    if (!he)
      break;
    const { chainId: we } = await ChannelUtils.fetchChannelInfo(ge, he);
    le.push(we), he = z[we];
  }
  return le.length !== ue.length + 1 ? null : le[le.length - 1];
}, getTokenData = async (v, y, z, ne) => {
  try {
    const ue = Object.values(ne).reduce((le, he) => (le[he.chainId] = he, le), {});
    if (v.denom.startsWith("ibc/")) {
      !DenomFetcher.isCacheInitialized() && storageLayer.isInitialized() && DenomFetcher.initializeCache(storageLayer.getStorage());
      const { baseDenom: le, path: he } = await DenomFetcher.getTrace(v.denom, y);
      let ge;
      if (le === "uluna")
        ge = await getSourceChain(he, y, ne) === "columbus-5" ? z.lunc : z[le];
      else if (le === "uusdc") {
        const Ee = await getSourceChain(he, y, ue);
        ge = Ee && ["noble-1", "grand-1"].includes(Ee) ? z.usdc : z[le];
      } else
        ge = z[le];
      if (!ge)
        return;
      const we = new BigNumber(v.amount).dividedBy(getDecimalPower10(ge.coinDecimals));
      return {
        coin: {
          amount: v.amount,
          denom: v.denom
        },
        amount: we,
        denomData: ge,
        denomTrace: {
          path: he,
          baseDenom: le
        },
        priceInUsd: null,
        valueInUsd: null
      };
    } else {
      const le = v.denom.replace("cw20:", ""), he = le === "uusdc" && ["noble-1", "grand-1"].includes(y.chainId) ? z.usdc : z[le];
      if (!he)
        return;
      const ge = new BigNumber(v.amount).dividedBy(getDecimalPower10(he.coinDecimals));
      return {
        coin: {
          amount: v.amount,
          denom: v.denom
        },
        amount: ge,
        denomData: he,
        priceInUsd: null,
        valueInUsd: null
      };
    }
  } catch {
    return;
  }
}, e3 = class e3 {
  static async getBalances(y, z) {
    const ne = getChainFromAddress(y, z);
    if (!ne)
      throw new Error("Chain not supported");
    try {
      const ue = await fetch(`${ne.restUrl}/cosmos/bank/v1beta1/balances/${y}?pagination.limit=250`), { balances: le } = await ue.json();
      return le;
    } catch {
      throw new Error("Failed to fetch balances");
    }
  }
  static async getCw20Balances(y, z, ne) {
    if (ne.length === 0)
      return [];
    const ue = getChainFromAddress(y, z);
    if (!ue)
      throw new Error("Chain not supported");
    let le;
    e3.COSMWASM_CLIENTS[ue.chainId] ? le = e3.COSMWASM_CLIENTS[ue.chainId] : (le = await CosmWasmClient.connect(ue.rpcUrl), e3.COSMWASM_CLIENTS[ue.chainId] = le);
    const he = ne.map(async (Ee) => {
      const xe = await le.queryContractSmart(Ee.tokenContract, { balance: { address: y } });
      return { denom: Ee.denom, amount: xe.balance };
    });
    return (await Promise.allSettled(he)).reduce((Ee, xe) => xe.status === "fulfilled" ? [...Ee, { ...xe.value }] : Ee, []);
  }
  /**
   * Fetches rich token balances which includes detailed token information along with the balance.
   * @param address - The blockchain address.
   * @param denoms - A record of denom data indexed by denom strings.
   * @param chains - An array of CosmosChainData objects.
   * @returns A Promise resolving to a ChainBalanceData object containing rich balance data ({@link ChainBalanceData}).
   * @throws An error if the chain is not supported or if there's a failure in fetching rich balances.
   */
  static async getRichBalances(y, z, ne, ue = []) {
    const le = getChainFromAddress(y, ne);
    if (!le)
      throw new Error("Chain not supported");
    const he = ne.reduce((ge, we) => (ge[we.chainId] = we, ge), {});
    try {
      const [ge, we] = await Promise.all([
        e3.getBalances(y, ne),
        e3.getCw20Balances(y, ne, ue)
      ]), Ee = ue.reduce((Ne, st) => (Ne[st.denom] = {
        coinDecimals: st.decimals,
        coinDenom: st.denom,
        coinMinimalDenom: st.symbol,
        icon: st.logoUri,
        chain: le.chainId
      }, Ne), {}), $e = (await Promise.allSettled([...ge, ...we].map((Ne) => getTokenData(Ne, le, { ...z, ...Ee }, he)))).map((Ne) => Ne.status === "fulfilled" && Ne.value !== void 0 ? Ne.value : void 0).filter((Ne) => Ne !== void 0);
      return {
        chainId: le.chainId,
        balances: $e.reduce((Ne, st) => ({
          ...Ne,
          [st.coin.denom]: st
        }), {})
      };
    } catch {
      throw new Error("Failed to fetch balances");
    }
  }
};
/**
 * Fetches the token balances for a given address on a specific chain.
 * @param address - The blockchain address.
 * @param chains - An array of CosmosChainData objects.
 * @returns A Promise resolving to an array of token amounts ({@link Amount[]}).
 * @throws An error if the chain is not supported or if there's a failure in fetching balances.
 */
Rm(e3, "COSMWASM_CLIENTS", {});
let TokenBalanceAPI = e3;
var build$6 = {}, coins$2 = {};
Object.defineProperty(coins$2, "__esModule", { value: !0 });
coins$2.parseCoins = void 0;
function parseCoins$1(v) {
  return v.replace(/\s/g, "").split(",").filter(Boolean).map((y) => {
    const z = y.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
    if (!z)
      throw new Error("Got an invalid coin string");
    return {
      amount: z[1].replace(/^0+/, "") || "0",
      denom: z[2]
    };
  });
}
coins$2.parseCoins = parseCoins$1;
var decode$3 = {};
Object.defineProperty(decode$3, "__esModule", { value: !0 });
decode$3.decodeTxRaw = void 0;
const tx_1$2 = tx;
function decodeTxRaw(v) {
  const y = tx_1$2.TxRaw.decode(v);
  return {
    authInfo: tx_1$2.AuthInfo.decode(y.authInfoBytes),
    body: tx_1$2.TxBody.decode(y.bodyBytes),
    signatures: y.signatures
  };
}
decode$3.decodeTxRaw = decodeTxRaw;
var directsecp256k1hdwallet = {}, build$5 = {}, addresses = {}, build$4 = {}, bip39 = {}, build$3 = {}, ascii$2 = {};
Object.defineProperty(ascii$2, "__esModule", { value: !0 });
ascii$2.fromAscii = ascii$2.toAscii = void 0;
function toAscii$1(v) {
  const y = (z) => z.split("").map((ne) => {
    const ue = ne.charCodeAt(0);
    if (ue < 32 || ue > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + ue);
    return ue;
  });
  return Uint8Array.from(y(v));
}
ascii$2.toAscii = toAscii$1;
function fromAscii$1(v) {
  return ((z) => z.map((ne) => {
    if (ne < 32 || ne > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + ne);
    return String.fromCharCode(ne);
  }))(Array.from(v)).join("");
}
ascii$2.fromAscii = fromAscii$1;
var base64$3 = {}, __createBinding$8 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$7 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$8 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$8(y, v, z);
  return __setModuleDefault$7(y, v), y;
};
Object.defineProperty(base64$3, "__esModule", { value: !0 });
base64$3.fromBase64 = base64$3.toBase64 = void 0;
const base64js$1 = __importStar$8(base64Js);
function toBase64$1(v) {
  return base64js$1.fromByteArray(v);
}
base64$3.toBase64 = toBase64$1;
function fromBase64$1(v) {
  if (!v.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js$1.toByteArray(v);
}
base64$3.fromBase64 = fromBase64$1;
var bech32$3 = {}, __createBinding$7 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$6 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$7 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$7(y, v, z);
  return __setModuleDefault$6(y, v), y;
};
Object.defineProperty(bech32$3, "__esModule", { value: !0 });
bech32$3.normalizeBech32 = bech32$3.fromBech32 = bech32$3.toBech32 = void 0;
const bech32$2 = __importStar$7(require$$0$4);
function toBech32$1(v, y, z) {
  return bech32$2.encode(v, bech32$2.toWords(y), z);
}
bech32$3.toBech32 = toBech32$1;
function fromBech32$1(v, y = 1 / 0) {
  const z = bech32$2.decode(v, y);
  return {
    prefix: z.prefix,
    data: new Uint8Array(bech32$2.fromWords(z.words))
  };
}
bech32$3.fromBech32 = fromBech32$1;
function normalizeBech32$1(v) {
  const { prefix: y, data: z } = fromBech32$1(v);
  return toBech32$1(y, z);
}
bech32$3.normalizeBech32 = normalizeBech32$1;
var hex$2 = {};
Object.defineProperty(hex$2, "__esModule", { value: !0 });
hex$2.fromHex = hex$2.toHex = void 0;
function toHex$3(v) {
  let y = "";
  for (const z of v)
    y += ("0" + z.toString(16)).slice(-2);
  return y;
}
hex$2.toHex = toHex$3;
function fromHex$1(v) {
  if (v.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const y = new Uint8Array(v.length / 2);
  for (let z = 0; z < y.length; z++) {
    const ne = 2 * z, ue = v.slice(ne, ne + 2);
    if (!ue.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    y[z] = parseInt(ue, 16);
  }
  return y;
}
hex$2.fromHex = fromHex$1;
var rfc3339$1 = {};
Object.defineProperty(rfc3339$1, "__esModule", { value: !0 });
rfc3339$1.toRfc3339 = rfc3339$1.fromRfc3339 = void 0;
const rfc3339Matcher$1 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded$1(v, y = 2) {
  return v.toString().padStart(y, "0");
}
function fromRfc3339$1(v) {
  const y = rfc3339Matcher$1.exec(v);
  if (!y)
    throw new Error("Date string is not in RFC3339 format");
  const z = +y[1], ne = +y[2], ue = +y[3], le = +y[4], he = +y[5], ge = +y[6], we = y[7] ? Math.floor(+y[7] * 1e3) : 0;
  let Ee, xe, $e;
  y[8] === "Z" ? (Ee = 1, xe = 0, $e = 0) : (Ee = y[8].substring(0, 1) === "-" ? -1 : 1, xe = +y[8].substring(1, 3), $e = +y[8].substring(4, 6));
  const Ne = Ee * (xe * 60 + $e) * 60, st = Date.UTC(z, ne - 1, ue, le, he, ge, we) - Ne * 1e3;
  return new Date(st);
}
rfc3339$1.fromRfc3339 = fromRfc3339$1;
function toRfc3339$1(v) {
  const y = v.getUTCFullYear(), z = padded$1(v.getUTCMonth() + 1), ne = padded$1(v.getUTCDate()), ue = padded$1(v.getUTCHours()), le = padded$1(v.getUTCMinutes()), he = padded$1(v.getUTCSeconds()), ge = padded$1(v.getUTCMilliseconds(), 3);
  return `${y}-${z}-${ne}T${ue}:${le}:${he}.${ge}Z`;
}
rfc3339$1.toRfc3339 = toRfc3339$1;
var utf8$1 = {};
Object.defineProperty(utf8$1, "__esModule", { value: !0 });
utf8$1.fromUtf8 = utf8$1.toUtf8 = void 0;
function toUtf8$1(v) {
  return new TextEncoder().encode(v);
}
utf8$1.toUtf8 = toUtf8$1;
function fromUtf8$1(v, y = !1) {
  const z = !y;
  return new TextDecoder("utf-8", { fatal: z }).decode(v);
}
utf8$1.fromUtf8 = fromUtf8$1;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.toUtf8 = v.fromUtf8 = v.toRfc3339 = v.fromRfc3339 = v.toHex = v.fromHex = v.toBech32 = v.normalizeBech32 = v.fromBech32 = v.toBase64 = v.fromBase64 = v.toAscii = v.fromAscii = void 0;
  var y = ascii$2;
  Object.defineProperty(v, "fromAscii", { enumerable: !0, get: function() {
    return y.fromAscii;
  } }), Object.defineProperty(v, "toAscii", { enumerable: !0, get: function() {
    return y.toAscii;
  } });
  var z = base64$3;
  Object.defineProperty(v, "fromBase64", { enumerable: !0, get: function() {
    return z.fromBase64;
  } }), Object.defineProperty(v, "toBase64", { enumerable: !0, get: function() {
    return z.toBase64;
  } });
  var ne = bech32$3;
  Object.defineProperty(v, "fromBech32", { enumerable: !0, get: function() {
    return ne.fromBech32;
  } }), Object.defineProperty(v, "normalizeBech32", { enumerable: !0, get: function() {
    return ne.normalizeBech32;
  } }), Object.defineProperty(v, "toBech32", { enumerable: !0, get: function() {
    return ne.toBech32;
  } });
  var ue = hex$2;
  Object.defineProperty(v, "fromHex", { enumerable: !0, get: function() {
    return ue.fromHex;
  } }), Object.defineProperty(v, "toHex", { enumerable: !0, get: function() {
    return ue.toHex;
  } });
  var le = rfc3339$1;
  Object.defineProperty(v, "fromRfc3339", { enumerable: !0, get: function() {
    return le.fromRfc3339;
  } }), Object.defineProperty(v, "toRfc3339", { enumerable: !0, get: function() {
    return le.toRfc3339;
  } });
  var he = utf8$1;
  Object.defineProperty(v, "fromUtf8", { enumerable: !0, get: function() {
    return he.fromUtf8;
  } }), Object.defineProperty(v, "toUtf8", { enumerable: !0, get: function() {
    return he.toUtf8;
  } });
})(build$3);
var pbkdf2$2 = {}, build$2 = {}, arrays = {};
Object.defineProperty(arrays, "__esModule", { value: !0 });
arrays.arrayContentStartsWith = arrays.arrayContentEquals = void 0;
function arrayContentEquals(v, y) {
  if (v.length !== y.length)
    return !1;
  for (let z = 0; z < v.length; ++z)
    if (v[z] !== y[z])
      return !1;
  return !0;
}
arrays.arrayContentEquals = arrayContentEquals;
function arrayContentStartsWith(v, y) {
  if (v.length < y.length)
    return !1;
  for (let z = 0; z < y.length; ++z)
    if (v[z] !== y[z])
      return !1;
  return !0;
}
arrays.arrayContentStartsWith = arrayContentStartsWith;
var assert$h = {};
Object.defineProperty(assert$h, "__esModule", { value: !0 });
assert$h.assertDefinedAndNotNull = assert$h.assertDefined = assert$h.assert = void 0;
function assert$g(v, y) {
  if (!v)
    throw new Error(y || "condition is not truthy");
}
assert$h.assert = assert$g;
function assertDefined(v, y) {
  if (v === void 0)
    throw new Error(y ?? "value is undefined");
}
assert$h.assertDefined = assertDefined;
function assertDefinedAndNotNull(v, y) {
  if (v == null)
    throw new Error(y ?? "value is undefined or null");
}
assert$h.assertDefinedAndNotNull = assertDefinedAndNotNull;
var sleep$2 = {};
Object.defineProperty(sleep$2, "__esModule", { value: !0 });
sleep$2.sleep = void 0;
async function sleep$1(v) {
  return new Promise((y) => setTimeout(y, v));
}
sleep$2.sleep = sleep$1;
var typechecks = {};
Object.defineProperty(typechecks, "__esModule", { value: !0 });
typechecks.isDefined = typechecks.isUint8Array = typechecks.isNonNullObject = void 0;
function isNonNullObject(v) {
  return typeof v == "object" && v !== null;
}
typechecks.isNonNullObject = isNonNullObject;
function isUint8Array(v) {
  return !(!isNonNullObject(v) || Object.prototype.toString.call(v) !== "[object Uint8Array]" || typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(v));
}
typechecks.isUint8Array = isUint8Array;
function isDefined$1(v) {
  return v !== void 0;
}
typechecks.isDefined = isDefined$1;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.isUint8Array = v.isNonNullObject = v.isDefined = v.sleep = v.assertDefinedAndNotNull = v.assertDefined = v.assert = v.arrayContentStartsWith = v.arrayContentEquals = void 0;
  var y = arrays;
  Object.defineProperty(v, "arrayContentEquals", { enumerable: !0, get: function() {
    return y.arrayContentEquals;
  } }), Object.defineProperty(v, "arrayContentStartsWith", { enumerable: !0, get: function() {
    return y.arrayContentStartsWith;
  } });
  var z = assert$h;
  Object.defineProperty(v, "assert", { enumerable: !0, get: function() {
    return z.assert;
  } }), Object.defineProperty(v, "assertDefined", { enumerable: !0, get: function() {
    return z.assertDefined;
  } }), Object.defineProperty(v, "assertDefinedAndNotNull", { enumerable: !0, get: function() {
    return z.assertDefinedAndNotNull;
  } });
  var ne = sleep$2;
  Object.defineProperty(v, "sleep", { enumerable: !0, get: function() {
    return ne.sleep;
  } });
  var ue = typechecks;
  Object.defineProperty(v, "isDefined", { enumerable: !0, get: function() {
    return ue.isDefined;
  } }), Object.defineProperty(v, "isNonNullObject", { enumerable: !0, get: function() {
    return ue.isNonNullObject;
  } }), Object.defineProperty(v, "isUint8Array", { enumerable: !0, get: function() {
    return ue.isUint8Array;
  } });
})(build$2);
var pbkdf2$1 = {}, _assert = {};
Object.defineProperty(_assert, "__esModule", { value: !0 });
_assert.output = _assert.exists = _assert.hash = _assert.bytes = _assert.bool = _assert.number = _assert.isBytes = void 0;
function number$1(v) {
  if (!Number.isSafeInteger(v) || v < 0)
    throw new Error(`positive integer expected, not ${v}`);
}
_assert.number = number$1;
function bool(v) {
  if (typeof v != "boolean")
    throw new Error(`boolean expected, not ${v}`);
}
_assert.bool = bool;
function isBytes(v) {
  return v instanceof Uint8Array || v != null && typeof v == "object" && v.constructor.name === "Uint8Array";
}
_assert.isBytes = isBytes;
function bytes(v, ...y) {
  if (!isBytes(v))
    throw new Error("Uint8Array expected");
  if (y.length > 0 && !y.includes(v.length))
    throw new Error(`Uint8Array expected of length ${y}, not of length=${v.length}`);
}
_assert.bytes = bytes;
function hash$5(v) {
  if (typeof v != "function" || typeof v.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  number$1(v.outputLen), number$1(v.blockLen);
}
_assert.hash = hash$5;
function exists(v, y = !0) {
  if (v.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (y && v.finished)
    throw new Error("Hash#digest() has already been called");
}
_assert.exists = exists;
function output(v, y) {
  bytes(v);
  const z = y.outputLen;
  if (v.length < z)
    throw new Error(`digestInto() expects output buffer of length at least ${z}`);
}
_assert.output = output;
const assert$f = { number: number$1, bool, bytes, hash: hash$5, exists, output };
_assert.default = assert$f;
var hmac$4 = {}, utils$p = {}, crypto = {};
Object.defineProperty(crypto, "__esModule", { value: !0 });
crypto.crypto = void 0;
crypto.crypto = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
(function(v) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(v, "__esModule", { value: !0 }), v.randomBytes = v.wrapXOFConstructorWithOpts = v.wrapConstructorWithOpts = v.wrapConstructor = v.checkOpts = v.Hash = v.concatBytes = v.toBytes = v.utf8ToBytes = v.asyncLoop = v.nextTick = v.hexToBytes = v.bytesToHex = v.byteSwap32 = v.byteSwapIfBE = v.byteSwap = v.isLE = v.rotl = v.rotr = v.createView = v.u32 = v.u8 = v.isBytes = void 0;
  const y = crypto, z = _assert;
  function ne(fe) {
    return fe instanceof Uint8Array || fe != null && typeof fe == "object" && fe.constructor.name === "Uint8Array";
  }
  v.isBytes = ne;
  const ue = (fe) => new Uint8Array(fe.buffer, fe.byteOffset, fe.byteLength);
  v.u8 = ue;
  const le = (fe) => new Uint32Array(fe.buffer, fe.byteOffset, Math.floor(fe.byteLength / 4));
  v.u32 = le;
  const he = (fe) => new DataView(fe.buffer, fe.byteOffset, fe.byteLength);
  v.createView = he;
  const ge = (fe, be) => fe << 32 - be | fe >>> be;
  v.rotr = ge;
  const we = (fe, be) => fe << be | fe >>> 32 - be >>> 0;
  v.rotl = we, v.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  const Ee = (fe) => fe << 24 & 4278190080 | fe << 8 & 16711680 | fe >>> 8 & 65280 | fe >>> 24 & 255;
  v.byteSwap = Ee, v.byteSwapIfBE = v.isLE ? (fe) => fe : (fe) => (0, v.byteSwap)(fe);
  function xe(fe) {
    for (let be = 0; be < fe.length; be++)
      fe[be] = (0, v.byteSwap)(fe[be]);
  }
  v.byteSwap32 = xe;
  const $e = /* @__PURE__ */ Array.from({ length: 256 }, (fe, be) => be.toString(16).padStart(2, "0"));
  function Ne(fe) {
    (0, z.bytes)(fe);
    let be = "";
    for (let ye = 0; ye < fe.length; ye++)
      be += $e[fe[ye]];
    return be;
  }
  v.bytesToHex = Ne;
  const st = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
  function Nr(fe) {
    if (fe >= st._0 && fe <= st._9)
      return fe - st._0;
    if (fe >= st._A && fe <= st._F)
      return fe - (st._A - 10);
    if (fe >= st._a && fe <= st._f)
      return fe - (st._a - 10);
  }
  function br(fe) {
    if (typeof fe != "string")
      throw new Error("hex string expected, got " + typeof fe);
    const be = fe.length, ye = be / 2;
    if (be % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + be);
    const Se = new Uint8Array(ye);
    for (let Oe = 0, Fr = 0; Oe < ye; Oe++, Fr += 2) {
      const zn = Nr(fe.charCodeAt(Fr)), Fe = Nr(fe.charCodeAt(Fr + 1));
      if (zn === void 0 || Fe === void 0) {
        const pe = fe[Fr] + fe[Fr + 1];
        throw new Error('hex string expected, got non-hex character "' + pe + '" at index ' + Fr);
      }
      Se[Oe] = zn * 16 + Fe;
    }
    return Se;
  }
  v.hexToBytes = br;
  const $n = async () => {
  };
  v.nextTick = $n;
  async function En(fe, be, ye) {
    let Se = Date.now();
    for (let Oe = 0; Oe < fe; Oe++) {
      ye(Oe);
      const Fr = Date.now() - Se;
      Fr >= 0 && Fr < be || (await (0, v.nextTick)(), Se += Fr);
    }
  }
  v.asyncLoop = En;
  function Rn(fe) {
    if (typeof fe != "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof fe}`);
    return new Uint8Array(new TextEncoder().encode(fe));
  }
  v.utf8ToBytes = Rn;
  function wa(fe) {
    return typeof fe == "string" && (fe = Rn(fe)), (0, z.bytes)(fe), fe;
  }
  v.toBytes = wa;
  function Aa(...fe) {
    let be = 0;
    for (let Se = 0; Se < fe.length; Se++) {
      const Oe = fe[Se];
      (0, z.bytes)(Oe), be += Oe.length;
    }
    const ye = new Uint8Array(be);
    for (let Se = 0, Oe = 0; Se < fe.length; Se++) {
      const Fr = fe[Se];
      ye.set(Fr, Oe), Oe += Fr.length;
    }
    return ye;
  }
  v.concatBytes = Aa;
  class _a {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  v.Hash = _a;
  const Ta = {}.toString;
  function Zn(fe, be) {
    if (be !== void 0 && Ta.call(be) !== "[object Object]")
      throw new Error("Options should be object or undefined");
    return Object.assign(fe, be);
  }
  v.checkOpts = Zn;
  function Ra(fe) {
    const be = (Se) => fe().update(wa(Se)).digest(), ye = fe();
    return be.outputLen = ye.outputLen, be.blockLen = ye.blockLen, be.create = () => fe(), be;
  }
  v.wrapConstructor = Ra;
  function Yn(fe) {
    const be = (Se, Oe) => fe(Oe).update(wa(Se)).digest(), ye = fe({});
    return be.outputLen = ye.outputLen, be.blockLen = ye.blockLen, be.create = (Se) => fe(Se), be;
  }
  v.wrapConstructorWithOpts = Yn;
  function $o(fe) {
    const be = (Se, Oe) => fe(Oe).update(wa(Se)).digest(), ye = fe({});
    return be.outputLen = ye.outputLen, be.blockLen = ye.blockLen, be.create = (Se) => fe(Se), be;
  }
  v.wrapXOFConstructorWithOpts = $o;
  function ct(fe = 32) {
    if (y.crypto && typeof y.crypto.getRandomValues == "function")
      return y.crypto.getRandomValues(new Uint8Array(fe));
    throw new Error("crypto.getRandomValues must be defined");
  }
  v.randomBytes = ct;
})(utils$p);
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.hmac = v.HMAC = void 0;
  const y = _assert, z = utils$p;
  class ne extends z.Hash {
    constructor(he, ge) {
      super(), this.finished = !1, this.destroyed = !1, (0, y.hash)(he);
      const we = (0, z.toBytes)(ge);
      if (this.iHash = he.create(), typeof this.iHash.update != "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const Ee = this.blockLen, xe = new Uint8Array(Ee);
      xe.set(we.length > Ee ? he.create().update(we).digest() : we);
      for (let $e = 0; $e < xe.length; $e++)
        xe[$e] ^= 54;
      this.iHash.update(xe), this.oHash = he.create();
      for (let $e = 0; $e < xe.length; $e++)
        xe[$e] ^= 106;
      this.oHash.update(xe), xe.fill(0);
    }
    update(he) {
      return (0, y.exists)(this), this.iHash.update(he), this;
    }
    digestInto(he) {
      (0, y.exists)(this), (0, y.bytes)(he, this.outputLen), this.finished = !0, this.iHash.digestInto(he), this.oHash.update(he), this.oHash.digestInto(he), this.destroy();
    }
    digest() {
      const he = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(he), he;
    }
    _cloneInto(he) {
      he || (he = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: ge, iHash: we, finished: Ee, destroyed: xe, blockLen: $e, outputLen: Ne } = this;
      return he = he, he.finished = Ee, he.destroyed = xe, he.blockLen = $e, he.outputLen = Ne, he.oHash = ge._cloneInto(he.oHash), he.iHash = we._cloneInto(he.iHash), he;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  v.HMAC = ne;
  const ue = (le, he, ge) => new ne(le, he).update(ge).digest();
  v.hmac = ue, v.hmac.create = (le, he) => new ne(le, he);
})(hmac$4);
Object.defineProperty(pbkdf2$1, "__esModule", { value: !0 });
pbkdf2$1.pbkdf2Async = pbkdf2$1.pbkdf2 = void 0;
const _assert_js_1$2 = _assert, hmac_js_1 = hmac$4, utils_js_1$5 = utils$p;
function pbkdf2Init(v, y, z, ne) {
  (0, _assert_js_1$2.hash)(v);
  const ue = (0, utils_js_1$5.checkOpts)({ dkLen: 32, asyncTick: 10 }, ne), { c: le, dkLen: he, asyncTick: ge } = ue;
  if ((0, _assert_js_1$2.number)(le), (0, _assert_js_1$2.number)(he), (0, _assert_js_1$2.number)(ge), le < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const we = (0, utils_js_1$5.toBytes)(y), Ee = (0, utils_js_1$5.toBytes)(z), xe = new Uint8Array(he), $e = hmac_js_1.hmac.create(v, we), Ne = $e._cloneInto().update(Ee);
  return { c: le, dkLen: he, asyncTick: ge, DK: xe, PRF: $e, PRFSalt: Ne };
}
function pbkdf2Output(v, y, z, ne, ue) {
  return v.destroy(), y.destroy(), ne && ne.destroy(), ue.fill(0), z;
}
function pbkdf2(v, y, z, ne) {
  const { c: ue, dkLen: le, DK: he, PRF: ge, PRFSalt: we } = pbkdf2Init(v, y, z, ne);
  let Ee;
  const xe = new Uint8Array(4), $e = (0, utils_js_1$5.createView)(xe), Ne = new Uint8Array(ge.outputLen);
  for (let st = 1, Nr = 0; Nr < le; st++, Nr += ge.outputLen) {
    const br = he.subarray(Nr, Nr + ge.outputLen);
    $e.setInt32(0, st, !1), (Ee = we._cloneInto(Ee)).update(xe).digestInto(Ne), br.set(Ne.subarray(0, br.length));
    for (let $n = 1; $n < ue; $n++) {
      ge._cloneInto(Ee).update(Ne).digestInto(Ne);
      for (let En = 0; En < br.length; En++)
        br[En] ^= Ne[En];
    }
  }
  return pbkdf2Output(ge, we, he, Ee, Ne);
}
pbkdf2$1.pbkdf2 = pbkdf2;
async function pbkdf2Async(v, y, z, ne) {
  const { c: ue, dkLen: le, asyncTick: he, DK: ge, PRF: we, PRFSalt: Ee } = pbkdf2Init(v, y, z, ne);
  let xe;
  const $e = new Uint8Array(4), Ne = (0, utils_js_1$5.createView)($e), st = new Uint8Array(we.outputLen);
  for (let Nr = 1, br = 0; br < le; Nr++, br += we.outputLen) {
    const $n = ge.subarray(br, br + we.outputLen);
    Ne.setInt32(0, Nr, !1), (xe = Ee._cloneInto(xe)).update($e).digestInto(st), $n.set(st.subarray(0, $n.length)), await (0, utils_js_1$5.asyncLoop)(ue - 1, he, () => {
      we._cloneInto(xe).update(st).digestInto(st);
      for (let En = 0; En < $n.length; En++)
        $n[En] ^= st[En];
    });
  }
  return pbkdf2Output(we, Ee, ge, xe, st);
}
pbkdf2$1.pbkdf2Async = pbkdf2Async;
var sha512$3 = {}, _md = {};
Object.defineProperty(_md, "__esModule", { value: !0 });
_md.HashMD = _md.Maj = _md.Chi = void 0;
const _assert_js_1$1 = _assert, utils_js_1$4 = utils$p;
function setBigUint64(v, y, z, ne) {
  if (typeof v.setBigUint64 == "function")
    return v.setBigUint64(y, z, ne);
  const ue = BigInt(32), le = BigInt(4294967295), he = Number(z >> ue & le), ge = Number(z & le), we = ne ? 4 : 0, Ee = ne ? 0 : 4;
  v.setUint32(y + we, he, ne), v.setUint32(y + Ee, ge, ne);
}
const Chi = (v, y, z) => v & y ^ ~v & z;
_md.Chi = Chi;
const Maj = (v, y, z) => v & y ^ v & z ^ y & z;
_md.Maj = Maj;
class HashMD extends utils_js_1$4.Hash {
  constructor(y, z, ne, ue) {
    super(), this.blockLen = y, this.outputLen = z, this.padOffset = ne, this.isLE = ue, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(y), this.view = (0, utils_js_1$4.createView)(this.buffer);
  }
  update(y) {
    (0, _assert_js_1$1.exists)(this);
    const { view: z, buffer: ne, blockLen: ue } = this;
    y = (0, utils_js_1$4.toBytes)(y);
    const le = y.length;
    for (let he = 0; he < le; ) {
      const ge = Math.min(ue - this.pos, le - he);
      if (ge === ue) {
        const we = (0, utils_js_1$4.createView)(y);
        for (; ue <= le - he; he += ue)
          this.process(we, he);
        continue;
      }
      ne.set(y.subarray(he, he + ge), this.pos), this.pos += ge, he += ge, this.pos === ue && (this.process(z, 0), this.pos = 0);
    }
    return this.length += y.length, this.roundClean(), this;
  }
  digestInto(y) {
    (0, _assert_js_1$1.exists)(this), (0, _assert_js_1$1.output)(y, this), this.finished = !0;
    const { buffer: z, view: ne, blockLen: ue, isLE: le } = this;
    let { pos: he } = this;
    z[he++] = 128, this.buffer.subarray(he).fill(0), this.padOffset > ue - he && (this.process(ne, 0), he = 0);
    for (let $e = he; $e < ue; $e++)
      z[$e] = 0;
    setBigUint64(ne, ue - 8, BigInt(this.length * 8), le), this.process(ne, 0);
    const ge = (0, utils_js_1$4.createView)(y), we = this.outputLen;
    if (we % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const Ee = we / 4, xe = this.get();
    if (Ee > xe.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let $e = 0; $e < Ee; $e++)
      ge.setUint32(4 * $e, xe[$e], le);
  }
  digest() {
    const { buffer: y, outputLen: z } = this;
    this.digestInto(y);
    const ne = y.slice(0, z);
    return this.destroy(), ne;
  }
  _cloneInto(y) {
    y || (y = new this.constructor()), y.set(...this.get());
    const { blockLen: z, buffer: ne, length: ue, finished: le, destroyed: he, pos: ge } = this;
    return y.length = ue, y.pos = ge, y.finished = le, y.destroyed = he, ue % z && y.buffer.set(ne), y;
  }
}
_md.HashMD = HashMD;
var _u64 = {};
Object.defineProperty(_u64, "__esModule", { value: !0 });
_u64.add5L = _u64.add5H = _u64.add4H = _u64.add4L = _u64.add3H = _u64.add3L = _u64.add = _u64.rotlBL = _u64.rotlBH = _u64.rotlSL = _u64.rotlSH = _u64.rotr32L = _u64.rotr32H = _u64.rotrBL = _u64.rotrBH = _u64.rotrSL = _u64.rotrSH = _u64.shrSL = _u64.shrSH = _u64.toBig = _u64.split = _u64.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1), _32n = /* @__PURE__ */ BigInt(32);
function fromBig(v, y = !1) {
  return y ? { h: Number(v & U32_MASK64), l: Number(v >> _32n & U32_MASK64) } : { h: Number(v >> _32n & U32_MASK64) | 0, l: Number(v & U32_MASK64) | 0 };
}
_u64.fromBig = fromBig;
function split$1(v, y = !1) {
  let z = new Uint32Array(v.length), ne = new Uint32Array(v.length);
  for (let ue = 0; ue < v.length; ue++) {
    const { h: le, l: he } = fromBig(v[ue], y);
    [z[ue], ne[ue]] = [le, he];
  }
  return [z, ne];
}
_u64.split = split$1;
const toBig = (v, y) => BigInt(v >>> 0) << _32n | BigInt(y >>> 0);
_u64.toBig = toBig;
const shrSH = (v, y, z) => v >>> z;
_u64.shrSH = shrSH;
const shrSL = (v, y, z) => v << 32 - z | y >>> z;
_u64.shrSL = shrSL;
const rotrSH = (v, y, z) => v >>> z | y << 32 - z;
_u64.rotrSH = rotrSH;
const rotrSL = (v, y, z) => v << 32 - z | y >>> z;
_u64.rotrSL = rotrSL;
const rotrBH = (v, y, z) => v << 64 - z | y >>> z - 32;
_u64.rotrBH = rotrBH;
const rotrBL = (v, y, z) => v >>> z - 32 | y << 64 - z;
_u64.rotrBL = rotrBL;
const rotr32H = (v, y) => y;
_u64.rotr32H = rotr32H;
const rotr32L = (v, y) => v;
_u64.rotr32L = rotr32L;
const rotlSH = (v, y, z) => v << z | y >>> 32 - z;
_u64.rotlSH = rotlSH;
const rotlSL = (v, y, z) => y << z | v >>> 32 - z;
_u64.rotlSL = rotlSL;
const rotlBH = (v, y, z) => y << z - 32 | v >>> 64 - z;
_u64.rotlBH = rotlBH;
const rotlBL = (v, y, z) => v << z - 32 | y >>> 64 - z;
_u64.rotlBL = rotlBL;
function add(v, y, z, ne) {
  const ue = (y >>> 0) + (ne >>> 0);
  return { h: v + z + (ue / 2 ** 32 | 0) | 0, l: ue | 0 };
}
_u64.add = add;
const add3L = (v, y, z) => (v >>> 0) + (y >>> 0) + (z >>> 0);
_u64.add3L = add3L;
const add3H = (v, y, z, ne) => y + z + ne + (v / 2 ** 32 | 0) | 0;
_u64.add3H = add3H;
const add4L = (v, y, z, ne) => (v >>> 0) + (y >>> 0) + (z >>> 0) + (ne >>> 0);
_u64.add4L = add4L;
const add4H = (v, y, z, ne, ue) => y + z + ne + ue + (v / 2 ** 32 | 0) | 0;
_u64.add4H = add4H;
const add5L = (v, y, z, ne, ue) => (v >>> 0) + (y >>> 0) + (z >>> 0) + (ne >>> 0) + (ue >>> 0);
_u64.add5L = add5L;
const add5H = (v, y, z, ne, ue, le) => y + z + ne + ue + le + (v / 2 ** 32 | 0) | 0;
_u64.add5H = add5H;
const u64 = {
  fromBig,
  split: split$1,
  toBig,
  shrSH,
  shrSL,
  rotrSH,
  rotrSL,
  rotrBH,
  rotrBL,
  rotr32H,
  rotr32L,
  rotlSH,
  rotlSL,
  rotlBH,
  rotlBL,
  add,
  add3L,
  add3H,
  add4L,
  add4H,
  add5H,
  add5L
};
_u64.default = u64;
Object.defineProperty(sha512$3, "__esModule", { value: !0 });
sha512$3.sha384 = sha512$3.sha512_256 = sha512$3.sha512_224 = sha512$3.sha512 = sha512$3.SHA512 = void 0;
const _md_js_1$2 = _md, _u64_js_1$1 = _u64, utils_js_1$3 = utils$p, [SHA512_Kh, SHA512_Kl] = _u64_js_1$1.default.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((v) => BigInt(v))), SHA512_W_H = /* @__PURE__ */ new Uint32Array(80), SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
let SHA512$2 = class extends _md_js_1$2.HashMD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: y, Al: z, Bh: ne, Bl: ue, Ch: le, Cl: he, Dh: ge, Dl: we, Eh: Ee, El: xe, Fh: $e, Fl: Ne, Gh: st, Gl: Nr, Hh: br, Hl: $n } = this;
    return [y, z, ne, ue, le, he, ge, we, Ee, xe, $e, Ne, st, Nr, br, $n];
  }
  // prettier-ignore
  set(y, z, ne, ue, le, he, ge, we, Ee, xe, $e, Ne, st, Nr, br, $n) {
    this.Ah = y | 0, this.Al = z | 0, this.Bh = ne | 0, this.Bl = ue | 0, this.Ch = le | 0, this.Cl = he | 0, this.Dh = ge | 0, this.Dl = we | 0, this.Eh = Ee | 0, this.El = xe | 0, this.Fh = $e | 0, this.Fl = Ne | 0, this.Gh = st | 0, this.Gl = Nr | 0, this.Hh = br | 0, this.Hl = $n | 0;
  }
  process(y, z) {
    for (let wa = 0; wa < 16; wa++, z += 4)
      SHA512_W_H[wa] = y.getUint32(z), SHA512_W_L[wa] = y.getUint32(z += 4);
    for (let wa = 16; wa < 80; wa++) {
      const Aa = SHA512_W_H[wa - 15] | 0, _a = SHA512_W_L[wa - 15] | 0, Ta = _u64_js_1$1.default.rotrSH(Aa, _a, 1) ^ _u64_js_1$1.default.rotrSH(Aa, _a, 8) ^ _u64_js_1$1.default.shrSH(Aa, _a, 7), Zn = _u64_js_1$1.default.rotrSL(Aa, _a, 1) ^ _u64_js_1$1.default.rotrSL(Aa, _a, 8) ^ _u64_js_1$1.default.shrSL(Aa, _a, 7), Ra = SHA512_W_H[wa - 2] | 0, Yn = SHA512_W_L[wa - 2] | 0, $o = _u64_js_1$1.default.rotrSH(Ra, Yn, 19) ^ _u64_js_1$1.default.rotrBH(Ra, Yn, 61) ^ _u64_js_1$1.default.shrSH(Ra, Yn, 6), ct = _u64_js_1$1.default.rotrSL(Ra, Yn, 19) ^ _u64_js_1$1.default.rotrBL(Ra, Yn, 61) ^ _u64_js_1$1.default.shrSL(Ra, Yn, 6), fe = _u64_js_1$1.default.add4L(Zn, ct, SHA512_W_L[wa - 7], SHA512_W_L[wa - 16]), be = _u64_js_1$1.default.add4H(fe, Ta, $o, SHA512_W_H[wa - 7], SHA512_W_H[wa - 16]);
      SHA512_W_H[wa] = be | 0, SHA512_W_L[wa] = fe | 0;
    }
    let { Ah: ne, Al: ue, Bh: le, Bl: he, Ch: ge, Cl: we, Dh: Ee, Dl: xe, Eh: $e, El: Ne, Fh: st, Fl: Nr, Gh: br, Gl: $n, Hh: En, Hl: Rn } = this;
    for (let wa = 0; wa < 80; wa++) {
      const Aa = _u64_js_1$1.default.rotrSH($e, Ne, 14) ^ _u64_js_1$1.default.rotrSH($e, Ne, 18) ^ _u64_js_1$1.default.rotrBH($e, Ne, 41), _a = _u64_js_1$1.default.rotrSL($e, Ne, 14) ^ _u64_js_1$1.default.rotrSL($e, Ne, 18) ^ _u64_js_1$1.default.rotrBL($e, Ne, 41), Ta = $e & st ^ ~$e & br, Zn = Ne & Nr ^ ~Ne & $n, Ra = _u64_js_1$1.default.add5L(Rn, _a, Zn, SHA512_Kl[wa], SHA512_W_L[wa]), Yn = _u64_js_1$1.default.add5H(Ra, En, Aa, Ta, SHA512_Kh[wa], SHA512_W_H[wa]), $o = Ra | 0, ct = _u64_js_1$1.default.rotrSH(ne, ue, 28) ^ _u64_js_1$1.default.rotrBH(ne, ue, 34) ^ _u64_js_1$1.default.rotrBH(ne, ue, 39), fe = _u64_js_1$1.default.rotrSL(ne, ue, 28) ^ _u64_js_1$1.default.rotrBL(ne, ue, 34) ^ _u64_js_1$1.default.rotrBL(ne, ue, 39), be = ne & le ^ ne & ge ^ le & ge, ye = ue & he ^ ue & we ^ he & we;
      En = br | 0, Rn = $n | 0, br = st | 0, $n = Nr | 0, st = $e | 0, Nr = Ne | 0, { h: $e, l: Ne } = _u64_js_1$1.default.add(Ee | 0, xe | 0, Yn | 0, $o | 0), Ee = ge | 0, xe = we | 0, ge = le | 0, we = he | 0, le = ne | 0, he = ue | 0;
      const Se = _u64_js_1$1.default.add3L($o, fe, ye);
      ne = _u64_js_1$1.default.add3H(Se, Yn, ct, be), ue = Se | 0;
    }
    ({ h: ne, l: ue } = _u64_js_1$1.default.add(this.Ah | 0, this.Al | 0, ne | 0, ue | 0)), { h: le, l: he } = _u64_js_1$1.default.add(this.Bh | 0, this.Bl | 0, le | 0, he | 0), { h: ge, l: we } = _u64_js_1$1.default.add(this.Ch | 0, this.Cl | 0, ge | 0, we | 0), { h: Ee, l: xe } = _u64_js_1$1.default.add(this.Dh | 0, this.Dl | 0, Ee | 0, xe | 0), { h: $e, l: Ne } = _u64_js_1$1.default.add(this.Eh | 0, this.El | 0, $e | 0, Ne | 0), { h: st, l: Nr } = _u64_js_1$1.default.add(this.Fh | 0, this.Fl | 0, st | 0, Nr | 0), { h: br, l: $n } = _u64_js_1$1.default.add(this.Gh | 0, this.Gl | 0, br | 0, $n | 0), { h: En, l: Rn } = _u64_js_1$1.default.add(this.Hh | 0, this.Hl | 0, En | 0, Rn | 0), this.set(ne, ue, le, he, ge, we, Ee, xe, $e, Ne, st, Nr, br, $n, En, Rn);
  }
  roundClean() {
    SHA512_W_H.fill(0), SHA512_W_L.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
sha512$3.SHA512 = SHA512$2;
class SHA512_224 extends SHA512$2 {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class SHA512_256 extends SHA512$2 {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
let SHA384$1 = class extends SHA512$2 {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
sha512$3.sha512 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512$2());
sha512$3.sha512_224 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512_224());
sha512$3.sha512_256 = (0, utils_js_1$3.wrapConstructor)(() => new SHA512_256());
sha512$3.sha384 = (0, utils_js_1$3.wrapConstructor)(() => new SHA384$1());
var cryptoBrowserify = {}, browser$c = { exports: {} }, safeBuffer$2 = { exports: {} };
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(dist);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredSafeBuffer$2;
function requireSafeBuffer$2() {
  return hasRequiredSafeBuffer$2 || (hasRequiredSafeBuffer$2 = 1, function(v, y) {
    var z = require$$0$3, ne = z.Buffer;
    function ue(he, ge) {
      for (var we in he)
        ge[we] = he[we];
    }
    ne.from && ne.alloc && ne.allocUnsafe && ne.allocUnsafeSlow ? v.exports = z : (ue(z, y), y.Buffer = le);
    function le(he, ge, we) {
      return ne(he, ge, we);
    }
    le.prototype = Object.create(ne.prototype), ue(ne, le), le.from = function(he, ge, we) {
      if (typeof he == "number")
        throw new TypeError("Argument must not be a number");
      return ne(he, ge, we);
    }, le.alloc = function(he, ge, we) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      var Ee = ne(he);
      return ge !== void 0 ? typeof we == "string" ? Ee.fill(ge, we) : Ee.fill(ge) : Ee.fill(0), Ee;
    }, le.allocUnsafe = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return ne(he);
    }, le.allocUnsafeSlow = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return z.SlowBuffer(he);
    };
  }(safeBuffer$2, safeBuffer$2.exports)), safeBuffer$2.exports;
}
var hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b)
    return browser$c.exports;
  hasRequiredBrowser$b = 1;
  var v = 65536, y = 4294967295;
  function z() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var ne = requireSafeBuffer$2().Buffer, ue = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  ue && ue.getRandomValues ? browser$c.exports = le : browser$c.exports = z;
  function le(he, ge) {
    if (he > y)
      throw new RangeError("requested too many random bytes");
    var we = ne.allocUnsafe(he);
    if (he > 0)
      if (he > v)
        for (var Ee = 0; Ee < he; Ee += v)
          ue.getRandomValues(we.slice(Ee, Ee + v));
      else
        ue.getRandomValues(we);
    return typeof ge == "function" ? process$1.nextTick(function() {
      ge(null, we);
    }) : we;
  }
  return browser$c.exports;
}
var inherits_browser = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser.exports = function(y, z) {
    z && (y.super_ = z, y.prototype = Object.create(z.prototype, {
      constructor: {
        value: y,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser.exports = function(y, z) {
    if (z) {
      y.super_ = z;
      var ne = function() {
      };
      ne.prototype = z.prototype, y.prototype = new ne(), y.prototype.constructor = y;
    }
  }), inherits_browser.exports;
}
var readableBrowser$1 = { exports: {} }, events = { exports: {} }, R$1 = typeof Reflect == "object" ? Reflect : null, ReflectApply = R$1 && typeof R$1.apply == "function" ? R$1.apply : function v(y, z, ne) {
  return Function.prototype.apply.call(y, z, ne);
}, ReflectOwnKeys;
R$1 && typeof R$1.ownKeys == "function" ? ReflectOwnKeys = R$1.ownKeys : Object.getOwnPropertySymbols ? ReflectOwnKeys = function(y) {
  return Object.getOwnPropertyNames(y).concat(Object.getOwnPropertySymbols(y));
} : ReflectOwnKeys = function(y) {
  return Object.getOwnPropertyNames(y);
};
function ProcessEmitWarning(v) {
  console && console.warn && console.warn(v);
}
var NumberIsNaN = Number.isNaN || function v(y) {
  return y !== y;
};
function EventEmitter$1() {
  EventEmitter$1.init.call(this);
}
events.exports = EventEmitter$1;
events.exports.once = once;
EventEmitter$1.EventEmitter = EventEmitter$1;
EventEmitter$1.prototype._events = void 0;
EventEmitter$1.prototype._eventsCount = 0;
EventEmitter$1.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(v) {
  if (typeof v != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof v);
}
Object.defineProperty(EventEmitter$1, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(v) {
    if (typeof v != "number" || v < 0 || NumberIsNaN(v))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + v + ".");
    defaultMaxListeners = v;
  }
});
EventEmitter$1.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$1.prototype.setMaxListeners = function v(y) {
  if (typeof y != "number" || y < 0 || NumberIsNaN(y))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + y + ".");
  return this._maxListeners = y, this;
};
function _getMaxListeners(v) {
  return v._maxListeners === void 0 ? EventEmitter$1.defaultMaxListeners : v._maxListeners;
}
EventEmitter$1.prototype.getMaxListeners = function v() {
  return _getMaxListeners(this);
};
EventEmitter$1.prototype.emit = function v(y) {
  for (var z = [], ne = 1; ne < arguments.length; ne++)
    z.push(arguments[ne]);
  var ue = y === "error", le = this._events;
  if (le !== void 0)
    ue = ue && le.error === void 0;
  else if (!ue)
    return !1;
  if (ue) {
    var he;
    if (z.length > 0 && (he = z[0]), he instanceof Error)
      throw he;
    var ge = new Error("Unhandled error." + (he ? " (" + he.message + ")" : ""));
    throw ge.context = he, ge;
  }
  var we = le[y];
  if (we === void 0)
    return !1;
  if (typeof we == "function")
    ReflectApply(we, this, z);
  else
    for (var Ee = we.length, xe = arrayClone(we, Ee), ne = 0; ne < Ee; ++ne)
      ReflectApply(xe[ne], this, z);
  return !0;
};
function _addListener(v, y, z, ne) {
  var ue, le, he;
  if (checkListener(z), le = v._events, le === void 0 ? (le = v._events = /* @__PURE__ */ Object.create(null), v._eventsCount = 0) : (le.newListener !== void 0 && (v.emit(
    "newListener",
    y,
    z.listener ? z.listener : z
  ), le = v._events), he = le[y]), he === void 0)
    he = le[y] = z, ++v._eventsCount;
  else if (typeof he == "function" ? he = le[y] = ne ? [z, he] : [he, z] : ne ? he.unshift(z) : he.push(z), ue = _getMaxListeners(v), ue > 0 && he.length > ue && !he.warned) {
    he.warned = !0;
    var ge = new Error("Possible EventEmitter memory leak detected. " + he.length + " " + String(y) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    ge.name = "MaxListenersExceededWarning", ge.emitter = v, ge.type = y, ge.count = he.length, ProcessEmitWarning(ge);
  }
  return v;
}
EventEmitter$1.prototype.addListener = function v(y, z) {
  return _addListener(this, y, z, !1);
};
EventEmitter$1.prototype.on = EventEmitter$1.prototype.addListener;
EventEmitter$1.prototype.prependListener = function v(y, z) {
  return _addListener(this, y, z, !0);
};
function onceWrapper() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function _onceWrap(v, y, z) {
  var ne = { fired: !1, wrapFn: void 0, target: v, type: y, listener: z }, ue = onceWrapper.bind(ne);
  return ue.listener = z, ne.wrapFn = ue, ue;
}
EventEmitter$1.prototype.once = function v(y, z) {
  return checkListener(z), this.on(y, _onceWrap(this, y, z)), this;
};
EventEmitter$1.prototype.prependOnceListener = function v(y, z) {
  return checkListener(z), this.prependListener(y, _onceWrap(this, y, z)), this;
};
EventEmitter$1.prototype.removeListener = function v(y, z) {
  var ne, ue, le, he, ge;
  if (checkListener(z), ue = this._events, ue === void 0)
    return this;
  if (ne = ue[y], ne === void 0)
    return this;
  if (ne === z || ne.listener === z)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete ue[y], ue.removeListener && this.emit("removeListener", y, ne.listener || z));
  else if (typeof ne != "function") {
    for (le = -1, he = ne.length - 1; he >= 0; he--)
      if (ne[he] === z || ne[he].listener === z) {
        ge = ne[he].listener, le = he;
        break;
      }
    if (le < 0)
      return this;
    le === 0 ? ne.shift() : spliceOne(ne, le), ne.length === 1 && (ue[y] = ne[0]), ue.removeListener !== void 0 && this.emit("removeListener", y, ge || z);
  }
  return this;
};
EventEmitter$1.prototype.off = EventEmitter$1.prototype.removeListener;
EventEmitter$1.prototype.removeAllListeners = function v(y) {
  var z, ne, ue;
  if (ne = this._events, ne === void 0)
    return this;
  if (ne.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : ne[y] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete ne[y]), this;
  if (arguments.length === 0) {
    var le = Object.keys(ne), he;
    for (ue = 0; ue < le.length; ++ue)
      he = le[ue], he !== "removeListener" && this.removeAllListeners(he);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (z = ne[y], typeof z == "function")
    this.removeListener(y, z);
  else if (z !== void 0)
    for (ue = z.length - 1; ue >= 0; ue--)
      this.removeListener(y, z[ue]);
  return this;
};
function _listeners(v, y, z) {
  var ne = v._events;
  if (ne === void 0)
    return [];
  var ue = ne[y];
  return ue === void 0 ? [] : typeof ue == "function" ? z ? [ue.listener || ue] : [ue] : z ? unwrapListeners(ue) : arrayClone(ue, ue.length);
}
EventEmitter$1.prototype.listeners = function v(y) {
  return _listeners(this, y, !0);
};
EventEmitter$1.prototype.rawListeners = function v(y) {
  return _listeners(this, y, !1);
};
EventEmitter$1.listenerCount = function(v, y) {
  return typeof v.listenerCount == "function" ? v.listenerCount(y) : listenerCount.call(v, y);
};
EventEmitter$1.prototype.listenerCount = listenerCount;
function listenerCount(v) {
  var y = this._events;
  if (y !== void 0) {
    var z = y[v];
    if (typeof z == "function")
      return 1;
    if (z !== void 0)
      return z.length;
  }
  return 0;
}
EventEmitter$1.prototype.eventNames = function v() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(v, y) {
  for (var z = new Array(y), ne = 0; ne < y; ++ne)
    z[ne] = v[ne];
  return z;
}
function spliceOne(v, y) {
  for (; y + 1 < v.length; y++)
    v[y] = v[y + 1];
  v.pop();
}
function unwrapListeners(v) {
  for (var y = new Array(v.length), z = 0; z < y.length; ++z)
    y[z] = v[z].listener || v[z];
  return y;
}
function once(v, y) {
  return new Promise(function(z, ne) {
    function ue(he) {
      v.removeListener(y, le), ne(he);
    }
    function le() {
      typeof v.removeListener == "function" && v.removeListener("error", ue), z([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(v, y, le, { once: !0 }), y !== "error" && addErrorHandlerIfEventEmitter(v, ue, { once: !0 });
  });
}
function addErrorHandlerIfEventEmitter(v, y, z) {
  typeof v.on == "function" && eventTargetAgnosticAddListener(v, "error", y, z);
}
function eventTargetAgnosticAddListener(v, y, z, ne) {
  if (typeof v.on == "function")
    ne.once ? v.once(y, z) : v.on(y, z);
  else if (typeof v.addEventListener == "function")
    v.addEventListener(y, function ue(le) {
      ne.once && v.removeEventListener(y, ue), z(le);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof v);
}
var eventsExports = events.exports;
const EventEmitter$2 = /* @__PURE__ */ getDefaultExportFromCjs(eventsExports);
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = eventsExports.EventEmitter), streamBrowser$1;
}
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function v(Nr, br) {
    var $n = Object.keys(Nr);
    if (Object.getOwnPropertySymbols) {
      var En = Object.getOwnPropertySymbols(Nr);
      br && (En = En.filter(function(Rn) {
        return Object.getOwnPropertyDescriptor(Nr, Rn).enumerable;
      })), $n.push.apply($n, En);
    }
    return $n;
  }
  function y(Nr) {
    for (var br = 1; br < arguments.length; br++) {
      var $n = arguments[br] != null ? arguments[br] : {};
      br % 2 ? v(Object($n), !0).forEach(function(En) {
        z(Nr, En, $n[En]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Nr, Object.getOwnPropertyDescriptors($n)) : v(Object($n)).forEach(function(En) {
        Object.defineProperty(Nr, En, Object.getOwnPropertyDescriptor($n, En));
      });
    }
    return Nr;
  }
  function z(Nr, br, $n) {
    return br = he(br), br in Nr ? Object.defineProperty(Nr, br, { value: $n, enumerable: !0, configurable: !0, writable: !0 }) : Nr[br] = $n, Nr;
  }
  function ne(Nr, br) {
    if (!(Nr instanceof br))
      throw new TypeError("Cannot call a class as a function");
  }
  function ue(Nr, br) {
    for (var $n = 0; $n < br.length; $n++) {
      var En = br[$n];
      En.enumerable = En.enumerable || !1, En.configurable = !0, "value" in En && (En.writable = !0), Object.defineProperty(Nr, he(En.key), En);
    }
  }
  function le(Nr, br, $n) {
    return br && ue(Nr.prototype, br), $n && ue(Nr, $n), Object.defineProperty(Nr, "prototype", { writable: !1 }), Nr;
  }
  function he(Nr) {
    var br = ge(Nr, "string");
    return typeof br == "symbol" ? br : String(br);
  }
  function ge(Nr, br) {
    if (typeof Nr != "object" || Nr === null)
      return Nr;
    var $n = Nr[Symbol.toPrimitive];
    if ($n !== void 0) {
      var En = $n.call(Nr, br || "default");
      if (typeof En != "object")
        return En;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (br === "string" ? String : Number)(Nr);
  }
  var we = require$$0$3, Ee = we.Buffer, xe = require$$0$2, $e = xe.inspect, Ne = $e && $e.custom || "inspect";
  function st(Nr, br, $n) {
    Ee.prototype.copy.call(Nr, br, $n);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function Nr() {
      ne(this, Nr), this.head = null, this.tail = null, this.length = 0;
    }
    return le(Nr, [{
      key: "push",
      value: function($n) {
        var En = {
          data: $n,
          next: null
        };
        this.length > 0 ? this.tail.next = En : this.head = En, this.tail = En, ++this.length;
      }
    }, {
      key: "unshift",
      value: function($n) {
        var En = {
          data: $n,
          next: this.head
        };
        this.length === 0 && (this.tail = En), this.head = En, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var $n = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, $n;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function($n) {
        if (this.length === 0)
          return "";
        for (var En = this.head, Rn = "" + En.data; En = En.next; )
          Rn += $n + En.data;
        return Rn;
      }
    }, {
      key: "concat",
      value: function($n) {
        if (this.length === 0)
          return Ee.alloc(0);
        for (var En = Ee.allocUnsafe($n >>> 0), Rn = this.head, wa = 0; Rn; )
          st(Rn.data, En, wa), wa += Rn.data.length, Rn = Rn.next;
        return En;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function($n, En) {
        var Rn;
        return $n < this.head.data.length ? (Rn = this.head.data.slice(0, $n), this.head.data = this.head.data.slice($n)) : $n === this.head.data.length ? Rn = this.shift() : Rn = En ? this._getString($n) : this._getBuffer($n), Rn;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function($n) {
        var En = this.head, Rn = 1, wa = En.data;
        for ($n -= wa.length; En = En.next; ) {
          var Aa = En.data, _a = $n > Aa.length ? Aa.length : $n;
          if (_a === Aa.length ? wa += Aa : wa += Aa.slice(0, $n), $n -= _a, $n === 0) {
            _a === Aa.length ? (++Rn, En.next ? this.head = En.next : this.head = this.tail = null) : (this.head = En, En.data = Aa.slice(_a));
            break;
          }
          ++Rn;
        }
        return this.length -= Rn, wa;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function($n) {
        var En = Ee.allocUnsafe($n), Rn = this.head, wa = 1;
        for (Rn.data.copy(En), $n -= Rn.data.length; Rn = Rn.next; ) {
          var Aa = Rn.data, _a = $n > Aa.length ? Aa.length : $n;
          if (Aa.copy(En, En.length - $n, 0, _a), $n -= _a, $n === 0) {
            _a === Aa.length ? (++wa, Rn.next ? this.head = Rn.next : this.head = this.tail = null) : (this.head = Rn, Rn.data = Aa.slice(_a));
            break;
          }
          ++wa;
        }
        return this.length -= wa, En;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: Ne,
      value: function($n, En) {
        return $e(this, y(y({}, En), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), Nr;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1)
    return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function v(he, ge) {
    var we = this, Ee = this._readableState && this._readableState.destroyed, xe = this._writableState && this._writableState.destroyed;
    return Ee || xe ? (ge ? ge(he) : he && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process$1.nextTick(ue, this, he)) : process$1.nextTick(ue, this, he)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(he || null, function($e) {
      !ge && $e ? we._writableState ? we._writableState.errorEmitted ? process$1.nextTick(z, we) : (we._writableState.errorEmitted = !0, process$1.nextTick(y, we, $e)) : process$1.nextTick(y, we, $e) : ge ? (process$1.nextTick(z, we), ge($e)) : process$1.nextTick(z, we);
    }), this);
  }
  function y(he, ge) {
    ue(he, ge), z(he);
  }
  function z(he) {
    he._writableState && !he._writableState.emitClose || he._readableState && !he._readableState.emitClose || he.emit("close");
  }
  function ne() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function ue(he, ge) {
    he.emit("error", ge);
  }
  function le(he, ge) {
    var we = he._readableState, Ee = he._writableState;
    we && we.autoDestroy || Ee && Ee.autoDestroy ? he.destroy(ge) : he.emit("error", ge);
  }
  return destroy_1$1 = {
    destroy: v,
    undestroy: ne,
    errorOrDestroy: le
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser)
    return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function v(ge, we) {
    ge.prototype = Object.create(we.prototype), ge.prototype.constructor = ge, ge.__proto__ = we;
  }
  var y = {};
  function z(ge, we, Ee) {
    Ee || (Ee = Error);
    function xe(Ne, st, Nr) {
      return typeof we == "string" ? we : we(Ne, st, Nr);
    }
    var $e = /* @__PURE__ */ function(Ne) {
      v(st, Ne);
      function st(Nr, br, $n) {
        return Ne.call(this, xe(Nr, br, $n)) || this;
      }
      return st;
    }(Ee);
    $e.prototype.name = Ee.name, $e.prototype.code = ge, y[ge] = $e;
  }
  function ne(ge, we) {
    if (Array.isArray(ge)) {
      var Ee = ge.length;
      return ge = ge.map(function(xe) {
        return String(xe);
      }), Ee > 2 ? "one of ".concat(we, " ").concat(ge.slice(0, Ee - 1).join(", "), ", or ") + ge[Ee - 1] : Ee === 2 ? "one of ".concat(we, " ").concat(ge[0], " or ").concat(ge[1]) : "of ".concat(we, " ").concat(ge[0]);
    } else
      return "of ".concat(we, " ").concat(String(ge));
  }
  function ue(ge, we, Ee) {
    return ge.substr(!Ee || Ee < 0 ? 0 : +Ee, we.length) === we;
  }
  function le(ge, we, Ee) {
    return (Ee === void 0 || Ee > ge.length) && (Ee = ge.length), ge.substring(Ee - we.length, Ee) === we;
  }
  function he(ge, we, Ee) {
    return typeof Ee != "number" && (Ee = 0), Ee + we.length > ge.length ? !1 : ge.indexOf(we, Ee) !== -1;
  }
  return z("ERR_INVALID_OPT_VALUE", function(ge, we) {
    return 'The value "' + we + '" is invalid for option "' + ge + '"';
  }, TypeError), z("ERR_INVALID_ARG_TYPE", function(ge, we, Ee) {
    var xe;
    typeof we == "string" && ue(we, "not ") ? (xe = "must not be", we = we.replace(/^not /, "")) : xe = "must be";
    var $e;
    if (le(ge, " argument"))
      $e = "The ".concat(ge, " ").concat(xe, " ").concat(ne(we, "type"));
    else {
      var Ne = he(ge, ".") ? "property" : "argument";
      $e = 'The "'.concat(ge, '" ').concat(Ne, " ").concat(xe, " ").concat(ne(we, "type"));
    }
    return $e += ". Received type ".concat(typeof Ee), $e;
  }, TypeError), z("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), z("ERR_METHOD_NOT_IMPLEMENTED", function(ge) {
    return "The " + ge + " method is not implemented";
  }), z("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), z("ERR_STREAM_DESTROYED", function(ge) {
    return "Cannot call " + ge + " after a stream was destroyed";
  }), z("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), z("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), z("ERR_STREAM_WRITE_AFTER_END", "write after end"), z("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), z("ERR_UNKNOWN_ENCODING", function(ge) {
    return "Unknown encoding: " + ge;
  }, TypeError), z("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = y, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState)
    return state;
  hasRequiredState = 1;
  var v = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function y(ne, ue, le) {
    return ne.highWaterMark != null ? ne.highWaterMark : ue ? ne[le] : null;
  }
  function z(ne, ue, le, he) {
    var ge = y(ue, he, le);
    if (ge != null) {
      if (!(isFinite(ge) && Math.floor(ge) === ge) || ge < 0) {
        var we = he ? le : "highWaterMark";
        throw new v(we, ge);
      }
      return Math.floor(ge);
    }
    return ne.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: z
  }, state;
}
var browser$b, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a)
    return browser$b;
  hasRequiredBrowser$a = 1, browser$b = v;
  function v(z, ne) {
    if (y("noDeprecation"))
      return z;
    var ue = !1;
    function le() {
      if (!ue) {
        if (y("throwDeprecation"))
          throw new Error(ne);
        y("traceDeprecation") ? console.trace(ne) : console.warn(ne), ue = !0;
      }
      return z.apply(this, arguments);
    }
    return le;
  }
  function y(z) {
    try {
      if (!commonjsGlobal.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var ne = commonjsGlobal.localStorage[z];
    return ne == null ? !1 : String(ne).toLowerCase() === "true";
  }
  return browser$b;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1)
    return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = Ra;
  function v(Os) {
    var Pa = this;
    this.next = null, this.entry = null, this.finish = function() {
      Oa(Pa, Os);
    };
  }
  var y;
  Ra.WritableState = Ta;
  var z = {
    deprecate: requireBrowser$a()
  }, ne = requireStreamBrowser$1(), ue = require$$0$3.Buffer, le = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function he(Os) {
    return ue.from(Os);
  }
  function ge(Os) {
    return ue.isBuffer(Os) || Os instanceof le;
  }
  var we = requireDestroy$1(), Ee = requireState(), xe = Ee.getHighWaterMark, $e = requireErrorsBrowser().codes, Ne = $e.ERR_INVALID_ARG_TYPE, st = $e.ERR_METHOD_NOT_IMPLEMENTED, Nr = $e.ERR_MULTIPLE_CALLBACK, br = $e.ERR_STREAM_CANNOT_PIPE, $n = $e.ERR_STREAM_DESTROYED, En = $e.ERR_STREAM_NULL_VALUES, Rn = $e.ERR_STREAM_WRITE_AFTER_END, wa = $e.ERR_UNKNOWN_ENCODING, Aa = we.errorOrDestroy;
  requireInherits_browser()(Ra, ne);
  function _a() {
  }
  function Ta(Os, Pa, Ml) {
    y = y || require_stream_duplex$1(), Os = Os || {}, typeof Ml != "boolean" && (Ml = Pa instanceof y), this.objectMode = !!Os.objectMode, Ml && (this.objectMode = this.objectMode || !!Os.writableObjectMode), this.highWaterMark = xe(this, Os, "writableHighWaterMark", Ml), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Su = Os.decodeStrings === !1;
    this.decodeStrings = !Su, this.defaultEncoding = Os.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Tu) {
      Oe(Pa, Tu);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Os.emitClose !== !1, this.autoDestroy = !!Os.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new v(this);
  }
  Ta.prototype.getBuffer = function() {
    for (var Pa = this.bufferedRequest, Ml = []; Pa; )
      Ml.push(Pa), Pa = Pa.next;
    return Ml;
  }, function() {
    try {
      Object.defineProperty(Ta.prototype, "buffer", {
        get: z.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Zn;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Zn = Function.prototype[Symbol.hasInstance], Object.defineProperty(Ra, Symbol.hasInstance, {
    value: function(Pa) {
      return Zn.call(this, Pa) ? !0 : this !== Ra ? !1 : Pa && Pa._writableState instanceof Ta;
    }
  })) : Zn = function(Pa) {
    return Pa instanceof this;
  };
  function Ra(Os) {
    y = y || require_stream_duplex$1();
    var Pa = this instanceof y;
    if (!Pa && !Zn.call(Ra, this))
      return new Ra(Os);
    this._writableState = new Ta(Os, this, Pa), this.writable = !0, Os && (typeof Os.write == "function" && (this._write = Os.write), typeof Os.writev == "function" && (this._writev = Os.writev), typeof Os.destroy == "function" && (this._destroy = Os.destroy), typeof Os.final == "function" && (this._final = Os.final)), ne.call(this);
  }
  Ra.prototype.pipe = function() {
    Aa(this, new br());
  };
  function Yn(Os, Pa) {
    var Ml = new Rn();
    Aa(Os, Ml), process$1.nextTick(Pa, Ml);
  }
  function $o(Os, Pa, Ml, Su) {
    var Tu;
    return Ml === null ? Tu = new En() : typeof Ml != "string" && !Pa.objectMode && (Tu = new Ne("chunk", ["string", "Buffer"], Ml)), Tu ? (Aa(Os, Tu), process$1.nextTick(Su, Tu), !1) : !0;
  }
  Ra.prototype.write = function(Os, Pa, Ml) {
    var Su = this._writableState, Tu = !1, Au = !Su.objectMode && ge(Os);
    return Au && !ue.isBuffer(Os) && (Os = he(Os)), typeof Pa == "function" && (Ml = Pa, Pa = null), Au ? Pa = "buffer" : Pa || (Pa = Su.defaultEncoding), typeof Ml != "function" && (Ml = _a), Su.ending ? Yn(this, Ml) : (Au || $o(this, Su, Os, Ml)) && (Su.pendingcb++, Tu = fe(this, Su, Au, Os, Pa, Ml)), Tu;
  }, Ra.prototype.cork = function() {
    this._writableState.corked++;
  }, Ra.prototype.uncork = function() {
    var Os = this._writableState;
    Os.corked && (Os.corked--, !Os.writing && !Os.corked && !Os.bufferProcessing && Os.bufferedRequest && Fe(this, Os));
  }, Ra.prototype.setDefaultEncoding = function(Pa) {
    if (typeof Pa == "string" && (Pa = Pa.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Pa + "").toLowerCase()) > -1))
      throw new wa(Pa);
    return this._writableState.defaultEncoding = Pa, this;
  }, Object.defineProperty(Ra.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function ct(Os, Pa, Ml) {
    return !Os.objectMode && Os.decodeStrings !== !1 && typeof Pa == "string" && (Pa = ue.from(Pa, Ml)), Pa;
  }
  Object.defineProperty(Ra.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function fe(Os, Pa, Ml, Su, Tu, Au) {
    if (!Ml) {
      var Zl = ct(Pa, Su, Tu);
      Su !== Zl && (Ml = !0, Tu = "buffer", Su = Zl);
    }
    var Iu = Pa.objectMode ? 1 : Su.length;
    Pa.length += Iu;
    var Uc = Pa.length < Pa.highWaterMark;
    if (Uc || (Pa.needDrain = !0), Pa.writing || Pa.corked) {
      var Pu = Pa.lastBufferedRequest;
      Pa.lastBufferedRequest = {
        chunk: Su,
        encoding: Tu,
        isBuf: Ml,
        callback: Au,
        next: null
      }, Pu ? Pu.next = Pa.lastBufferedRequest : Pa.bufferedRequest = Pa.lastBufferedRequest, Pa.bufferedRequestCount += 1;
    } else
      be(Os, Pa, !1, Iu, Su, Tu, Au);
    return Uc;
  }
  function be(Os, Pa, Ml, Su, Tu, Au, Zl) {
    Pa.writelen = Su, Pa.writecb = Zl, Pa.writing = !0, Pa.sync = !0, Pa.destroyed ? Pa.onwrite(new $n("write")) : Ml ? Os._writev(Tu, Pa.onwrite) : Os._write(Tu, Au, Pa.onwrite), Pa.sync = !1;
  }
  function ye(Os, Pa, Ml, Su, Tu) {
    --Pa.pendingcb, Ml ? (process$1.nextTick(Tu, Su), process$1.nextTick(wo, Os, Pa), Os._writableState.errorEmitted = !0, Aa(Os, Su)) : (Tu(Su), Os._writableState.errorEmitted = !0, Aa(Os, Su), wo(Os, Pa));
  }
  function Se(Os) {
    Os.writing = !1, Os.writecb = null, Os.length -= Os.writelen, Os.writelen = 0;
  }
  function Oe(Os, Pa) {
    var Ml = Os._writableState, Su = Ml.sync, Tu = Ml.writecb;
    if (typeof Tu != "function")
      throw new Nr();
    if (Se(Ml), Pa)
      ye(Os, Ml, Su, Pa, Tu);
    else {
      var Au = pe(Ml) || Os.destroyed;
      !Au && !Ml.corked && !Ml.bufferProcessing && Ml.bufferedRequest && Fe(Os, Ml), Su ? process$1.nextTick(Fr, Os, Ml, Au, Tu) : Fr(Os, Ml, Au, Tu);
    }
  }
  function Fr(Os, Pa, Ml, Su) {
    Ml || zn(Os, Pa), Pa.pendingcb--, Su(), wo(Os, Pa);
  }
  function zn(Os, Pa) {
    Pa.length === 0 && Pa.needDrain && (Pa.needDrain = !1, Os.emit("drain"));
  }
  function Fe(Os, Pa) {
    Pa.bufferProcessing = !0;
    var Ml = Pa.bufferedRequest;
    if (Os._writev && Ml && Ml.next) {
      var Su = Pa.bufferedRequestCount, Tu = new Array(Su), Au = Pa.corkedRequestsFree;
      Au.entry = Ml;
      for (var Zl = 0, Iu = !0; Ml; )
        Tu[Zl] = Ml, Ml.isBuf || (Iu = !1), Ml = Ml.next, Zl += 1;
      Tu.allBuffers = Iu, be(Os, Pa, !0, Pa.length, Tu, "", Au.finish), Pa.pendingcb++, Pa.lastBufferedRequest = null, Au.next ? (Pa.corkedRequestsFree = Au.next, Au.next = null) : Pa.corkedRequestsFree = new v(Pa), Pa.bufferedRequestCount = 0;
    } else {
      for (; Ml; ) {
        var Uc = Ml.chunk, Pu = Ml.encoding, Lu = Ml.callback, th = Pa.objectMode ? 1 : Uc.length;
        if (be(Os, Pa, !1, th, Uc, Pu, Lu), Ml = Ml.next, Pa.bufferedRequestCount--, Pa.writing)
          break;
      }
      Ml === null && (Pa.lastBufferedRequest = null);
    }
    Pa.bufferedRequest = Ml, Pa.bufferProcessing = !1;
  }
  Ra.prototype._write = function(Os, Pa, Ml) {
    Ml(new st("_write()"));
  }, Ra.prototype._writev = null, Ra.prototype.end = function(Os, Pa, Ml) {
    var Su = this._writableState;
    return typeof Os == "function" ? (Ml = Os, Os = null, Pa = null) : typeof Pa == "function" && (Ml = Pa, Pa = null), Os != null && this.write(Os, Pa), Su.corked && (Su.corked = 1, this.uncork()), Su.ending || _u(this, Su, Ml), this;
  }, Object.defineProperty(Ra.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function pe(Os) {
    return Os.ending && Os.length === 0 && Os.bufferedRequest === null && !Os.finished && !Os.writing;
  }
  function it(Os, Pa) {
    Os._final(function(Ml) {
      Pa.pendingcb--, Ml && Aa(Os, Ml), Pa.prefinished = !0, Os.emit("prefinish"), wo(Os, Pa);
    });
  }
  function xa(Os, Pa) {
    !Pa.prefinished && !Pa.finalCalled && (typeof Os._final == "function" && !Pa.destroyed ? (Pa.pendingcb++, Pa.finalCalled = !0, process$1.nextTick(it, Os, Pa)) : (Pa.prefinished = !0, Os.emit("prefinish")));
  }
  function wo(Os, Pa) {
    var Ml = pe(Pa);
    if (Ml && (xa(Os, Pa), Pa.pendingcb === 0 && (Pa.finished = !0, Os.emit("finish"), Pa.autoDestroy))) {
      var Su = Os._readableState;
      (!Su || Su.autoDestroy && Su.endEmitted) && Os.destroy();
    }
    return Ml;
  }
  function _u(Os, Pa, Ml) {
    Pa.ending = !0, wo(Os, Pa), Ml && (Pa.finished ? process$1.nextTick(Ml) : Os.once("finish", Ml)), Pa.ended = !0, Os.writable = !1;
  }
  function Oa(Os, Pa, Ml) {
    var Su = Os.entry;
    for (Os.entry = null; Su; ) {
      var Tu = Su.callback;
      Pa.pendingcb--, Tu(Ml), Su = Su.next;
    }
    Pa.corkedRequestsFree.next = Os;
  }
  return Object.defineProperty(Ra.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(Pa) {
      this._writableState && (this._writableState.destroyed = Pa);
    }
  }), Ra.prototype.destroy = we.destroy, Ra.prototype._undestroy = we.undestroy, Ra.prototype._destroy = function(Os, Pa) {
    Pa(Os);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1)
    return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var v = Object.keys || function(Ee) {
    var xe = [];
    for (var $e in Ee)
      xe.push($e);
    return xe;
  };
  _stream_duplex$1 = he;
  var y = require_stream_readable$1(), z = require_stream_writable$1();
  requireInherits_browser()(he, y);
  for (var ne = v(z.prototype), ue = 0; ue < ne.length; ue++) {
    var le = ne[ue];
    he.prototype[le] || (he.prototype[le] = z.prototype[le]);
  }
  function he(Ee) {
    if (!(this instanceof he))
      return new he(Ee);
    y.call(this, Ee), z.call(this, Ee), this.allowHalfOpen = !0, Ee && (Ee.readable === !1 && (this.readable = !1), Ee.writable === !1 && (this.writable = !1), Ee.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", ge)));
  }
  Object.defineProperty(he.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(he.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(he.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function ge() {
    this._writableState.ended || process$1.nextTick(we, this);
  }
  function we(Ee) {
    Ee.end();
  }
  return Object.defineProperty(he.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(xe) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = xe, this._writableState.destroyed = xe);
    }
  }), _stream_duplex$1;
}
var string_decoder$1 = {}, hasRequiredString_decoder$1;
function requireString_decoder$1() {
  if (hasRequiredString_decoder$1)
    return string_decoder$1;
  hasRequiredString_decoder$1 = 1;
  var v = requireSafeBuffer$2().Buffer, y = v.isEncoding || function(En) {
    switch (En = "" + En, En && En.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function z(En) {
    if (!En)
      return "utf8";
    for (var Rn; ; )
      switch (En) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return En;
        default:
          if (Rn)
            return;
          En = ("" + En).toLowerCase(), Rn = !0;
      }
  }
  function ne(En) {
    var Rn = z(En);
    if (typeof Rn != "string" && (v.isEncoding === y || !y(En)))
      throw new Error("Unknown encoding: " + En);
    return Rn || En;
  }
  string_decoder$1.StringDecoder = ue;
  function ue(En) {
    this.encoding = ne(En);
    var Rn;
    switch (this.encoding) {
      case "utf16le":
        this.text = $e, this.end = Ne, Rn = 4;
        break;
      case "utf8":
        this.fillLast = we, Rn = 4;
        break;
      case "base64":
        this.text = st, this.end = Nr, Rn = 3;
        break;
      default:
        this.write = br, this.end = $n;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = v.allocUnsafe(Rn);
  }
  ue.prototype.write = function(En) {
    if (En.length === 0)
      return "";
    var Rn, wa;
    if (this.lastNeed) {
      if (Rn = this.fillLast(En), Rn === void 0)
        return "";
      wa = this.lastNeed, this.lastNeed = 0;
    } else
      wa = 0;
    return wa < En.length ? Rn ? Rn + this.text(En, wa) : this.text(En, wa) : Rn || "";
  }, ue.prototype.end = xe, ue.prototype.text = Ee, ue.prototype.fillLast = function(En) {
    if (this.lastNeed <= En.length)
      return En.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    En.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, En.length), this.lastNeed -= En.length;
  };
  function le(En) {
    return En <= 127 ? 0 : En >> 5 === 6 ? 2 : En >> 4 === 14 ? 3 : En >> 3 === 30 ? 4 : En >> 6 === 2 ? -1 : -2;
  }
  function he(En, Rn, wa) {
    var Aa = Rn.length - 1;
    if (Aa < wa)
      return 0;
    var _a = le(Rn[Aa]);
    return _a >= 0 ? (_a > 0 && (En.lastNeed = _a - 1), _a) : --Aa < wa || _a === -2 ? 0 : (_a = le(Rn[Aa]), _a >= 0 ? (_a > 0 && (En.lastNeed = _a - 2), _a) : --Aa < wa || _a === -2 ? 0 : (_a = le(Rn[Aa]), _a >= 0 ? (_a > 0 && (_a === 2 ? _a = 0 : En.lastNeed = _a - 3), _a) : 0));
  }
  function ge(En, Rn, wa) {
    if ((Rn[0] & 192) !== 128)
      return En.lastNeed = 0, "�";
    if (En.lastNeed > 1 && Rn.length > 1) {
      if ((Rn[1] & 192) !== 128)
        return En.lastNeed = 1, "�";
      if (En.lastNeed > 2 && Rn.length > 2 && (Rn[2] & 192) !== 128)
        return En.lastNeed = 2, "�";
    }
  }
  function we(En) {
    var Rn = this.lastTotal - this.lastNeed, wa = ge(this, En);
    if (wa !== void 0)
      return wa;
    if (this.lastNeed <= En.length)
      return En.copy(this.lastChar, Rn, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    En.copy(this.lastChar, Rn, 0, En.length), this.lastNeed -= En.length;
  }
  function Ee(En, Rn) {
    var wa = he(this, En, Rn);
    if (!this.lastNeed)
      return En.toString("utf8", Rn);
    this.lastTotal = wa;
    var Aa = En.length - (wa - this.lastNeed);
    return En.copy(this.lastChar, 0, Aa), En.toString("utf8", Rn, Aa);
  }
  function xe(En) {
    var Rn = En && En.length ? this.write(En) : "";
    return this.lastNeed ? Rn + "�" : Rn;
  }
  function $e(En, Rn) {
    if ((En.length - Rn) % 2 === 0) {
      var wa = En.toString("utf16le", Rn);
      if (wa) {
        var Aa = wa.charCodeAt(wa.length - 1);
        if (Aa >= 55296 && Aa <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = En[En.length - 2], this.lastChar[1] = En[En.length - 1], wa.slice(0, -1);
      }
      return wa;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = En[En.length - 1], En.toString("utf16le", Rn, En.length - 1);
  }
  function Ne(En) {
    var Rn = En && En.length ? this.write(En) : "";
    if (this.lastNeed) {
      var wa = this.lastTotal - this.lastNeed;
      return Rn + this.lastChar.toString("utf16le", 0, wa);
    }
    return Rn;
  }
  function st(En, Rn) {
    var wa = (En.length - Rn) % 3;
    return wa === 0 ? En.toString("base64", Rn) : (this.lastNeed = 3 - wa, this.lastTotal = 3, wa === 1 ? this.lastChar[0] = En[En.length - 1] : (this.lastChar[0] = En[En.length - 2], this.lastChar[1] = En[En.length - 1]), En.toString("base64", Rn, En.length - wa));
  }
  function Nr(En) {
    var Rn = En && En.length ? this.write(En) : "";
    return this.lastNeed ? Rn + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Rn;
  }
  function br(En) {
    return En.toString(this.encoding);
  }
  function $n(En) {
    return En && En.length ? this.write(En) : "";
  }
  return string_decoder$1;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream)
    return endOfStream;
  hasRequiredEndOfStream = 1;
  var v = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function y(le) {
    var he = !1;
    return function() {
      if (!he) {
        he = !0;
        for (var ge = arguments.length, we = new Array(ge), Ee = 0; Ee < ge; Ee++)
          we[Ee] = arguments[Ee];
        le.apply(this, we);
      }
    };
  }
  function z() {
  }
  function ne(le) {
    return le.setHeader && typeof le.abort == "function";
  }
  function ue(le, he, ge) {
    if (typeof he == "function")
      return ue(le, null, he);
    he || (he = {}), ge = y(ge || z);
    var we = he.readable || he.readable !== !1 && le.readable, Ee = he.writable || he.writable !== !1 && le.writable, xe = function() {
      le.writable || Ne();
    }, $e = le._writableState && le._writableState.finished, Ne = function() {
      Ee = !1, $e = !0, we || ge.call(le);
    }, st = le._readableState && le._readableState.endEmitted, Nr = function() {
      we = !1, st = !0, Ee || ge.call(le);
    }, br = function(wa) {
      ge.call(le, wa);
    }, $n = function() {
      var wa;
      if (we && !st)
        return (!le._readableState || !le._readableState.ended) && (wa = new v()), ge.call(le, wa);
      if (Ee && !$e)
        return (!le._writableState || !le._writableState.ended) && (wa = new v()), ge.call(le, wa);
    }, En = function() {
      le.req.on("finish", Ne);
    };
    return ne(le) ? (le.on("complete", Ne), le.on("abort", $n), le.req ? En() : le.on("request", En)) : Ee && !le._writableState && (le.on("end", xe), le.on("close", xe)), le.on("end", Nr), le.on("finish", Ne), he.error !== !1 && le.on("error", br), le.on("close", $n), function() {
      le.removeListener("complete", Ne), le.removeListener("abort", $n), le.removeListener("request", En), le.req && le.req.removeListener("finish", Ne), le.removeListener("end", xe), le.removeListener("close", xe), le.removeListener("finish", Ne), le.removeListener("end", Nr), le.removeListener("error", br), le.removeListener("close", $n);
    };
  }
  return endOfStream = ue, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var v;
  function y(wa, Aa, _a) {
    return Aa = z(Aa), Aa in wa ? Object.defineProperty(wa, Aa, { value: _a, enumerable: !0, configurable: !0, writable: !0 }) : wa[Aa] = _a, wa;
  }
  function z(wa) {
    var Aa = ne(wa, "string");
    return typeof Aa == "symbol" ? Aa : String(Aa);
  }
  function ne(wa, Aa) {
    if (typeof wa != "object" || wa === null)
      return wa;
    var _a = wa[Symbol.toPrimitive];
    if (_a !== void 0) {
      var Ta = _a.call(wa, Aa || "default");
      if (typeof Ta != "object")
        return Ta;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (Aa === "string" ? String : Number)(wa);
  }
  var ue = requireEndOfStream(), le = Symbol("lastResolve"), he = Symbol("lastReject"), ge = Symbol("error"), we = Symbol("ended"), Ee = Symbol("lastPromise"), xe = Symbol("handlePromise"), $e = Symbol("stream");
  function Ne(wa, Aa) {
    return {
      value: wa,
      done: Aa
    };
  }
  function st(wa) {
    var Aa = wa[le];
    if (Aa !== null) {
      var _a = wa[$e].read();
      _a !== null && (wa[Ee] = null, wa[le] = null, wa[he] = null, Aa(Ne(_a, !1)));
    }
  }
  function Nr(wa) {
    process$1.nextTick(st, wa);
  }
  function br(wa, Aa) {
    return function(_a, Ta) {
      wa.then(function() {
        if (Aa[we]) {
          _a(Ne(void 0, !0));
          return;
        }
        Aa[xe](_a, Ta);
      }, Ta);
    };
  }
  var $n = Object.getPrototypeOf(function() {
  }), En = Object.setPrototypeOf((v = {
    get stream() {
      return this[$e];
    },
    next: function() {
      var Aa = this, _a = this[ge];
      if (_a !== null)
        return Promise.reject(_a);
      if (this[we])
        return Promise.resolve(Ne(void 0, !0));
      if (this[$e].destroyed)
        return new Promise(function(Yn, $o) {
          process$1.nextTick(function() {
            Aa[ge] ? $o(Aa[ge]) : Yn(Ne(void 0, !0));
          });
        });
      var Ta = this[Ee], Zn;
      if (Ta)
        Zn = new Promise(br(Ta, this));
      else {
        var Ra = this[$e].read();
        if (Ra !== null)
          return Promise.resolve(Ne(Ra, !1));
        Zn = new Promise(this[xe]);
      }
      return this[Ee] = Zn, Zn;
    }
  }, y(v, Symbol.asyncIterator, function() {
    return this;
  }), y(v, "return", function() {
    var Aa = this;
    return new Promise(function(_a, Ta) {
      Aa[$e].destroy(null, function(Zn) {
        if (Zn) {
          Ta(Zn);
          return;
        }
        _a(Ne(void 0, !0));
      });
    });
  }), v), $n), Rn = function(Aa) {
    var _a, Ta = Object.create(En, (_a = {}, y(_a, $e, {
      value: Aa,
      writable: !0
    }), y(_a, le, {
      value: null,
      writable: !0
    }), y(_a, he, {
      value: null,
      writable: !0
    }), y(_a, ge, {
      value: null,
      writable: !0
    }), y(_a, we, {
      value: Aa._readableState.endEmitted,
      writable: !0
    }), y(_a, xe, {
      value: function(Ra, Yn) {
        var $o = Ta[$e].read();
        $o ? (Ta[Ee] = null, Ta[le] = null, Ta[he] = null, Ra(Ne($o, !1))) : (Ta[le] = Ra, Ta[he] = Yn);
      },
      writable: !0
    }), _a));
    return Ta[Ee] = null, ue(Aa, function(Zn) {
      if (Zn && Zn.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Ra = Ta[he];
        Ra !== null && (Ta[Ee] = null, Ta[le] = null, Ta[he] = null, Ra(Zn)), Ta[ge] = Zn;
        return;
      }
      var Yn = Ta[le];
      Yn !== null && (Ta[Ee] = null, Ta[le] = null, Ta[he] = null, Yn(Ne(void 0, !0))), Ta[we] = !0;
    }), Aa.on("readable", Nr.bind(null, Ta)), Ta;
  };
  return async_iterator = Rn, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1)
    return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = Yn;
  var v;
  Yn.ReadableState = Ra, eventsExports.EventEmitter;
  var y = function(Zl, Iu) {
    return Zl.listeners(Iu).length;
  }, z = requireStreamBrowser$1(), ne = require$$0$3.Buffer, ue = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function le(Au) {
    return ne.from(Au);
  }
  function he(Au) {
    return ne.isBuffer(Au) || Au instanceof ue;
  }
  var ge = require$$0$2, we;
  ge && ge.debuglog ? we = ge.debuglog("stream") : we = function() {
  };
  var Ee = requireBuffer_list(), xe = requireDestroy$1(), $e = requireState(), Ne = $e.getHighWaterMark, st = requireErrorsBrowser().codes, Nr = st.ERR_INVALID_ARG_TYPE, br = st.ERR_STREAM_PUSH_AFTER_EOF, $n = st.ERR_METHOD_NOT_IMPLEMENTED, En = st.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, Rn, wa, Aa;
  requireInherits_browser()(Yn, z);
  var _a = xe.errorOrDestroy, Ta = ["error", "close", "destroy", "pause", "resume"];
  function Zn(Au, Zl, Iu) {
    if (typeof Au.prependListener == "function")
      return Au.prependListener(Zl, Iu);
    !Au._events || !Au._events[Zl] ? Au.on(Zl, Iu) : Array.isArray(Au._events[Zl]) ? Au._events[Zl].unshift(Iu) : Au._events[Zl] = [Iu, Au._events[Zl]];
  }
  function Ra(Au, Zl, Iu) {
    v = v || require_stream_duplex$1(), Au = Au || {}, typeof Iu != "boolean" && (Iu = Zl instanceof v), this.objectMode = !!Au.objectMode, Iu && (this.objectMode = this.objectMode || !!Au.readableObjectMode), this.highWaterMark = Ne(this, Au, "readableHighWaterMark", Iu), this.buffer = new Ee(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Au.emitClose !== !1, this.autoDestroy = !!Au.autoDestroy, this.destroyed = !1, this.defaultEncoding = Au.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Au.encoding && (Rn || (Rn = requireString_decoder$1().StringDecoder), this.decoder = new Rn(Au.encoding), this.encoding = Au.encoding);
  }
  function Yn(Au) {
    if (v = v || require_stream_duplex$1(), !(this instanceof Yn))
      return new Yn(Au);
    var Zl = this instanceof v;
    this._readableState = new Ra(Au, this, Zl), this.readable = !0, Au && (typeof Au.read == "function" && (this._read = Au.read), typeof Au.destroy == "function" && (this._destroy = Au.destroy)), z.call(this);
  }
  Object.defineProperty(Yn.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Zl) {
      this._readableState && (this._readableState.destroyed = Zl);
    }
  }), Yn.prototype.destroy = xe.destroy, Yn.prototype._undestroy = xe.undestroy, Yn.prototype._destroy = function(Au, Zl) {
    Zl(Au);
  }, Yn.prototype.push = function(Au, Zl) {
    var Iu = this._readableState, Uc;
    return Iu.objectMode ? Uc = !0 : typeof Au == "string" && (Zl = Zl || Iu.defaultEncoding, Zl !== Iu.encoding && (Au = ne.from(Au, Zl), Zl = ""), Uc = !0), $o(this, Au, Zl, !1, Uc);
  }, Yn.prototype.unshift = function(Au) {
    return $o(this, Au, null, !0, !1);
  };
  function $o(Au, Zl, Iu, Uc, Pu) {
    we("readableAddChunk", Zl);
    var Lu = Au._readableState;
    if (Zl === null)
      Lu.reading = !1, Oe(Au, Lu);
    else {
      var th;
      if (Pu || (th = fe(Lu, Zl)), th)
        _a(Au, th);
      else if (Lu.objectMode || Zl && Zl.length > 0)
        if (typeof Zl != "string" && !Lu.objectMode && Object.getPrototypeOf(Zl) !== ne.prototype && (Zl = le(Zl)), Uc)
          Lu.endEmitted ? _a(Au, new En()) : ct(Au, Lu, Zl, !0);
        else if (Lu.ended)
          _a(Au, new br());
        else {
          if (Lu.destroyed)
            return !1;
          Lu.reading = !1, Lu.decoder && !Iu ? (Zl = Lu.decoder.write(Zl), Lu.objectMode || Zl.length !== 0 ? ct(Au, Lu, Zl, !1) : Fe(Au, Lu)) : ct(Au, Lu, Zl, !1);
        }
      else
        Uc || (Lu.reading = !1, Fe(Au, Lu));
    }
    return !Lu.ended && (Lu.length < Lu.highWaterMark || Lu.length === 0);
  }
  function ct(Au, Zl, Iu, Uc) {
    Zl.flowing && Zl.length === 0 && !Zl.sync ? (Zl.awaitDrain = 0, Au.emit("data", Iu)) : (Zl.length += Zl.objectMode ? 1 : Iu.length, Uc ? Zl.buffer.unshift(Iu) : Zl.buffer.push(Iu), Zl.needReadable && Fr(Au)), Fe(Au, Zl);
  }
  function fe(Au, Zl) {
    var Iu;
    return !he(Zl) && typeof Zl != "string" && Zl !== void 0 && !Au.objectMode && (Iu = new Nr("chunk", ["string", "Buffer", "Uint8Array"], Zl)), Iu;
  }
  Yn.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Yn.prototype.setEncoding = function(Au) {
    Rn || (Rn = requireString_decoder$1().StringDecoder);
    var Zl = new Rn(Au);
    this._readableState.decoder = Zl, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var Iu = this._readableState.buffer.head, Uc = ""; Iu !== null; )
      Uc += Zl.write(Iu.data), Iu = Iu.next;
    return this._readableState.buffer.clear(), Uc !== "" && this._readableState.buffer.push(Uc), this._readableState.length = Uc.length, this;
  };
  var be = 1073741824;
  function ye(Au) {
    return Au >= be ? Au = be : (Au--, Au |= Au >>> 1, Au |= Au >>> 2, Au |= Au >>> 4, Au |= Au >>> 8, Au |= Au >>> 16, Au++), Au;
  }
  function Se(Au, Zl) {
    return Au <= 0 || Zl.length === 0 && Zl.ended ? 0 : Zl.objectMode ? 1 : Au !== Au ? Zl.flowing && Zl.length ? Zl.buffer.head.data.length : Zl.length : (Au > Zl.highWaterMark && (Zl.highWaterMark = ye(Au)), Au <= Zl.length ? Au : Zl.ended ? Zl.length : (Zl.needReadable = !0, 0));
  }
  Yn.prototype.read = function(Au) {
    we("read", Au), Au = parseInt(Au, 10);
    var Zl = this._readableState, Iu = Au;
    if (Au !== 0 && (Zl.emittedReadable = !1), Au === 0 && Zl.needReadable && ((Zl.highWaterMark !== 0 ? Zl.length >= Zl.highWaterMark : Zl.length > 0) || Zl.ended))
      return we("read: emitReadable", Zl.length, Zl.ended), Zl.length === 0 && Zl.ended ? Ml(this) : Fr(this), null;
    if (Au = Se(Au, Zl), Au === 0 && Zl.ended)
      return Zl.length === 0 && Ml(this), null;
    var Uc = Zl.needReadable;
    we("need readable", Uc), (Zl.length === 0 || Zl.length - Au < Zl.highWaterMark) && (Uc = !0, we("length less than watermark", Uc)), Zl.ended || Zl.reading ? (Uc = !1, we("reading or ended", Uc)) : Uc && (we("do read"), Zl.reading = !0, Zl.sync = !0, Zl.length === 0 && (Zl.needReadable = !0), this._read(Zl.highWaterMark), Zl.sync = !1, Zl.reading || (Au = Se(Iu, Zl)));
    var Pu;
    return Au > 0 ? Pu = Pa(Au, Zl) : Pu = null, Pu === null ? (Zl.needReadable = Zl.length <= Zl.highWaterMark, Au = 0) : (Zl.length -= Au, Zl.awaitDrain = 0), Zl.length === 0 && (Zl.ended || (Zl.needReadable = !0), Iu !== Au && Zl.ended && Ml(this)), Pu !== null && this.emit("data", Pu), Pu;
  };
  function Oe(Au, Zl) {
    if (we("onEofChunk"), !Zl.ended) {
      if (Zl.decoder) {
        var Iu = Zl.decoder.end();
        Iu && Iu.length && (Zl.buffer.push(Iu), Zl.length += Zl.objectMode ? 1 : Iu.length);
      }
      Zl.ended = !0, Zl.sync ? Fr(Au) : (Zl.needReadable = !1, Zl.emittedReadable || (Zl.emittedReadable = !0, zn(Au)));
    }
  }
  function Fr(Au) {
    var Zl = Au._readableState;
    we("emitReadable", Zl.needReadable, Zl.emittedReadable), Zl.needReadable = !1, Zl.emittedReadable || (we("emitReadable", Zl.flowing), Zl.emittedReadable = !0, process$1.nextTick(zn, Au));
  }
  function zn(Au) {
    var Zl = Au._readableState;
    we("emitReadable_", Zl.destroyed, Zl.length, Zl.ended), !Zl.destroyed && (Zl.length || Zl.ended) && (Au.emit("readable"), Zl.emittedReadable = !1), Zl.needReadable = !Zl.flowing && !Zl.ended && Zl.length <= Zl.highWaterMark, Os(Au);
  }
  function Fe(Au, Zl) {
    Zl.readingMore || (Zl.readingMore = !0, process$1.nextTick(pe, Au, Zl));
  }
  function pe(Au, Zl) {
    for (; !Zl.reading && !Zl.ended && (Zl.length < Zl.highWaterMark || Zl.flowing && Zl.length === 0); ) {
      var Iu = Zl.length;
      if (we("maybeReadMore read 0"), Au.read(0), Iu === Zl.length)
        break;
    }
    Zl.readingMore = !1;
  }
  Yn.prototype._read = function(Au) {
    _a(this, new $n("_read()"));
  }, Yn.prototype.pipe = function(Au, Zl) {
    var Iu = this, Uc = this._readableState;
    switch (Uc.pipesCount) {
      case 0:
        Uc.pipes = Au;
        break;
      case 1:
        Uc.pipes = [Uc.pipes, Au];
        break;
      default:
        Uc.pipes.push(Au);
        break;
    }
    Uc.pipesCount += 1, we("pipe count=%d opts=%j", Uc.pipesCount, Zl);
    var Pu = (!Zl || Zl.end !== !1) && Au !== process$1.stdout && Au !== process$1.stderr, Lu = Pu ? Zc : M2;
    Uc.endEmitted ? process$1.nextTick(Lu) : Iu.once("end", Lu), Au.on("unpipe", th);
    function th(d1, K1) {
      we("onunpipe"), d1 === Iu && K1 && K1.hasUnpiped === !1 && (K1.hasUnpiped = !0, Mc());
    }
    function Zc() {
      we("onend"), Au.end();
    }
    var N1 = it(Iu);
    Au.on("drain", N1);
    var Gh = !1;
    function Mc() {
      we("cleanup"), Au.removeListener("close", Gc), Au.removeListener("finish", Kc), Au.removeListener("drain", N1), Au.removeListener("error", l2), Au.removeListener("unpipe", th), Iu.removeListener("end", Zc), Iu.removeListener("end", M2), Iu.removeListener("data", h1), Gh = !0, Uc.awaitDrain && (!Au._writableState || Au._writableState.needDrain) && N1();
    }
    Iu.on("data", h1);
    function h1(d1) {
      we("ondata");
      var K1 = Au.write(d1);
      we("dest.write", K1), K1 === !1 && ((Uc.pipesCount === 1 && Uc.pipes === Au || Uc.pipesCount > 1 && Tu(Uc.pipes, Au) !== -1) && !Gh && (we("false write response, pause", Uc.awaitDrain), Uc.awaitDrain++), Iu.pause());
    }
    function l2(d1) {
      we("onerror", d1), M2(), Au.removeListener("error", l2), y(Au, "error") === 0 && _a(Au, d1);
    }
    Zn(Au, "error", l2);
    function Gc() {
      Au.removeListener("finish", Kc), M2();
    }
    Au.once("close", Gc);
    function Kc() {
      we("onfinish"), Au.removeListener("close", Gc), M2();
    }
    Au.once("finish", Kc);
    function M2() {
      we("unpipe"), Iu.unpipe(Au);
    }
    return Au.emit("pipe", Iu), Uc.flowing || (we("pipe resume"), Iu.resume()), Au;
  };
  function it(Au) {
    return function() {
      var Iu = Au._readableState;
      we("pipeOnDrain", Iu.awaitDrain), Iu.awaitDrain && Iu.awaitDrain--, Iu.awaitDrain === 0 && y(Au, "data") && (Iu.flowing = !0, Os(Au));
    };
  }
  Yn.prototype.unpipe = function(Au) {
    var Zl = this._readableState, Iu = {
      hasUnpiped: !1
    };
    if (Zl.pipesCount === 0)
      return this;
    if (Zl.pipesCount === 1)
      return Au && Au !== Zl.pipes ? this : (Au || (Au = Zl.pipes), Zl.pipes = null, Zl.pipesCount = 0, Zl.flowing = !1, Au && Au.emit("unpipe", this, Iu), this);
    if (!Au) {
      var Uc = Zl.pipes, Pu = Zl.pipesCount;
      Zl.pipes = null, Zl.pipesCount = 0, Zl.flowing = !1;
      for (var Lu = 0; Lu < Pu; Lu++)
        Uc[Lu].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var th = Tu(Zl.pipes, Au);
    return th === -1 ? this : (Zl.pipes.splice(th, 1), Zl.pipesCount -= 1, Zl.pipesCount === 1 && (Zl.pipes = Zl.pipes[0]), Au.emit("unpipe", this, Iu), this);
  }, Yn.prototype.on = function(Au, Zl) {
    var Iu = z.prototype.on.call(this, Au, Zl), Uc = this._readableState;
    return Au === "data" ? (Uc.readableListening = this.listenerCount("readable") > 0, Uc.flowing !== !1 && this.resume()) : Au === "readable" && !Uc.endEmitted && !Uc.readableListening && (Uc.readableListening = Uc.needReadable = !0, Uc.flowing = !1, Uc.emittedReadable = !1, we("on readable", Uc.length, Uc.reading), Uc.length ? Fr(this) : Uc.reading || process$1.nextTick(wo, this)), Iu;
  }, Yn.prototype.addListener = Yn.prototype.on, Yn.prototype.removeListener = function(Au, Zl) {
    var Iu = z.prototype.removeListener.call(this, Au, Zl);
    return Au === "readable" && process$1.nextTick(xa, this), Iu;
  }, Yn.prototype.removeAllListeners = function(Au) {
    var Zl = z.prototype.removeAllListeners.apply(this, arguments);
    return (Au === "readable" || Au === void 0) && process$1.nextTick(xa, this), Zl;
  };
  function xa(Au) {
    var Zl = Au._readableState;
    Zl.readableListening = Au.listenerCount("readable") > 0, Zl.resumeScheduled && !Zl.paused ? Zl.flowing = !0 : Au.listenerCount("data") > 0 && Au.resume();
  }
  function wo(Au) {
    we("readable nexttick read 0"), Au.read(0);
  }
  Yn.prototype.resume = function() {
    var Au = this._readableState;
    return Au.flowing || (we("resume"), Au.flowing = !Au.readableListening, _u(this, Au)), Au.paused = !1, this;
  };
  function _u(Au, Zl) {
    Zl.resumeScheduled || (Zl.resumeScheduled = !0, process$1.nextTick(Oa, Au, Zl));
  }
  function Oa(Au, Zl) {
    we("resume", Zl.reading), Zl.reading || Au.read(0), Zl.resumeScheduled = !1, Au.emit("resume"), Os(Au), Zl.flowing && !Zl.reading && Au.read(0);
  }
  Yn.prototype.pause = function() {
    return we("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (we("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Os(Au) {
    var Zl = Au._readableState;
    for (we("flow", Zl.flowing); Zl.flowing && Au.read() !== null; )
      ;
  }
  Yn.prototype.wrap = function(Au) {
    var Zl = this, Iu = this._readableState, Uc = !1;
    Au.on("end", function() {
      if (we("wrapped end"), Iu.decoder && !Iu.ended) {
        var th = Iu.decoder.end();
        th && th.length && Zl.push(th);
      }
      Zl.push(null);
    }), Au.on("data", function(th) {
      if (we("wrapped data"), Iu.decoder && (th = Iu.decoder.write(th)), !(Iu.objectMode && th == null) && !(!Iu.objectMode && (!th || !th.length))) {
        var Zc = Zl.push(th);
        Zc || (Uc = !0, Au.pause());
      }
    });
    for (var Pu in Au)
      this[Pu] === void 0 && typeof Au[Pu] == "function" && (this[Pu] = /* @__PURE__ */ function(Zc) {
        return function() {
          return Au[Zc].apply(Au, arguments);
        };
      }(Pu));
    for (var Lu = 0; Lu < Ta.length; Lu++)
      Au.on(Ta[Lu], this.emit.bind(this, Ta[Lu]));
    return this._read = function(th) {
      we("wrapped _read", th), Uc && (Uc = !1, Au.resume());
    }, this;
  }, typeof Symbol == "function" && (Yn.prototype[Symbol.asyncIterator] = function() {
    return wa === void 0 && (wa = requireAsync_iterator()), wa(this);
  }), Object.defineProperty(Yn.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Yn.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Yn.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Zl) {
      this._readableState && (this._readableState.flowing = Zl);
    }
  }), Yn._fromList = Pa, Object.defineProperty(Yn.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function Pa(Au, Zl) {
    if (Zl.length === 0)
      return null;
    var Iu;
    return Zl.objectMode ? Iu = Zl.buffer.shift() : !Au || Au >= Zl.length ? (Zl.decoder ? Iu = Zl.buffer.join("") : Zl.buffer.length === 1 ? Iu = Zl.buffer.first() : Iu = Zl.buffer.concat(Zl.length), Zl.buffer.clear()) : Iu = Zl.buffer.consume(Au, Zl.decoder), Iu;
  }
  function Ml(Au) {
    var Zl = Au._readableState;
    we("endReadable", Zl.endEmitted), Zl.endEmitted || (Zl.ended = !0, process$1.nextTick(Su, Zl, Au));
  }
  function Su(Au, Zl) {
    if (we("endReadableNT", Au.endEmitted, Au.length), !Au.endEmitted && Au.length === 0 && (Au.endEmitted = !0, Zl.readable = !1, Zl.emit("end"), Au.autoDestroy)) {
      var Iu = Zl._writableState;
      (!Iu || Iu.autoDestroy && Iu.finished) && Zl.destroy();
    }
  }
  typeof Symbol == "function" && (Yn.from = function(Au, Zl) {
    return Aa === void 0 && (Aa = requireFromBrowser()), Aa(Yn, Au, Zl);
  });
  function Tu(Au, Zl) {
    for (var Iu = 0, Uc = Au.length; Iu < Uc; Iu++)
      if (Au[Iu] === Zl)
        return Iu;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1)
    return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = ge;
  var v = requireErrorsBrowser().codes, y = v.ERR_METHOD_NOT_IMPLEMENTED, z = v.ERR_MULTIPLE_CALLBACK, ne = v.ERR_TRANSFORM_ALREADY_TRANSFORMING, ue = v.ERR_TRANSFORM_WITH_LENGTH_0, le = require_stream_duplex$1();
  requireInherits_browser()(ge, le);
  function he(xe, $e) {
    var Ne = this._transformState;
    Ne.transforming = !1;
    var st = Ne.writecb;
    if (st === null)
      return this.emit("error", new z());
    Ne.writechunk = null, Ne.writecb = null, $e != null && this.push($e), st(xe);
    var Nr = this._readableState;
    Nr.reading = !1, (Nr.needReadable || Nr.length < Nr.highWaterMark) && this._read(Nr.highWaterMark);
  }
  function ge(xe) {
    if (!(this instanceof ge))
      return new ge(xe);
    le.call(this, xe), this._transformState = {
      afterTransform: he.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, xe && (typeof xe.transform == "function" && (this._transform = xe.transform), typeof xe.flush == "function" && (this._flush = xe.flush)), this.on("prefinish", we);
  }
  function we() {
    var xe = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function($e, Ne) {
      Ee(xe, $e, Ne);
    }) : Ee(this, null, null);
  }
  ge.prototype.push = function(xe, $e) {
    return this._transformState.needTransform = !1, le.prototype.push.call(this, xe, $e);
  }, ge.prototype._transform = function(xe, $e, Ne) {
    Ne(new y("_transform()"));
  }, ge.prototype._write = function(xe, $e, Ne) {
    var st = this._transformState;
    if (st.writecb = Ne, st.writechunk = xe, st.writeencoding = $e, !st.transforming) {
      var Nr = this._readableState;
      (st.needTransform || Nr.needReadable || Nr.length < Nr.highWaterMark) && this._read(Nr.highWaterMark);
    }
  }, ge.prototype._read = function(xe) {
    var $e = this._transformState;
    $e.writechunk !== null && !$e.transforming ? ($e.transforming = !0, this._transform($e.writechunk, $e.writeencoding, $e.afterTransform)) : $e.needTransform = !0;
  }, ge.prototype._destroy = function(xe, $e) {
    le.prototype._destroy.call(this, xe, function(Ne) {
      $e(Ne);
    });
  };
  function Ee(xe, $e, Ne) {
    if ($e)
      return xe.emit("error", $e);
    if (Ne != null && xe.push(Ne), xe._writableState.length)
      throw new ue();
    if (xe._transformState.transforming)
      throw new ne();
    return xe.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1)
    return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = y;
  var v = require_stream_transform$1();
  requireInherits_browser()(y, v);
  function y(z) {
    if (!(this instanceof y))
      return new y(z);
    v.call(this, z);
  }
  return y.prototype._transform = function(z, ne, ue) {
    ue(null, z);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline)
    return pipeline_1;
  hasRequiredPipeline = 1;
  var v;
  function y(Ne) {
    var st = !1;
    return function() {
      st || (st = !0, Ne.apply(void 0, arguments));
    };
  }
  var z = requireErrorsBrowser().codes, ne = z.ERR_MISSING_ARGS, ue = z.ERR_STREAM_DESTROYED;
  function le(Ne) {
    if (Ne)
      throw Ne;
  }
  function he(Ne) {
    return Ne.setHeader && typeof Ne.abort == "function";
  }
  function ge(Ne, st, Nr, br) {
    br = y(br);
    var $n = !1;
    Ne.on("close", function() {
      $n = !0;
    }), v === void 0 && (v = requireEndOfStream()), v(Ne, {
      readable: st,
      writable: Nr
    }, function(Rn) {
      if (Rn)
        return br(Rn);
      $n = !0, br();
    });
    var En = !1;
    return function(Rn) {
      if (!$n && !En) {
        if (En = !0, he(Ne))
          return Ne.abort();
        if (typeof Ne.destroy == "function")
          return Ne.destroy();
        br(Rn || new ue("pipe"));
      }
    };
  }
  function we(Ne) {
    Ne();
  }
  function Ee(Ne, st) {
    return Ne.pipe(st);
  }
  function xe(Ne) {
    return !Ne.length || typeof Ne[Ne.length - 1] != "function" ? le : Ne.pop();
  }
  function $e() {
    for (var Ne = arguments.length, st = new Array(Ne), Nr = 0; Nr < Ne; Nr++)
      st[Nr] = arguments[Nr];
    var br = xe(st);
    if (Array.isArray(st[0]) && (st = st[0]), st.length < 2)
      throw new ne("streams");
    var $n, En = st.map(function(Rn, wa) {
      var Aa = wa < st.length - 1, _a = wa > 0;
      return ge(Rn, Aa, _a, function(Ta) {
        $n || ($n = Ta), Ta && En.forEach(we), !Aa && (En.forEach(we), br($n));
      });
    });
    return st.reduce(Ee);
  }
  return pipeline_1 = $e, pipeline_1;
}
var hasRequiredReadableBrowser$1;
function requireReadableBrowser$1() {
  return hasRequiredReadableBrowser$1 || (hasRequiredReadableBrowser$1 = 1, function(v, y) {
    y = v.exports = require_stream_readable$1(), y.Stream = y, y.Readable = y, y.Writable = require_stream_writable$1(), y.Duplex = require_stream_duplex$1(), y.Transform = require_stream_transform$1(), y.PassThrough = require_stream_passthrough$1(), y.finished = requireEndOfStream(), y.pipeline = requirePipeline();
  }(readableBrowser$1, readableBrowser$1.exports)), readableBrowser$1.exports;
}
var hashBase$1, hasRequiredHashBase$1;
function requireHashBase$1() {
  if (hasRequiredHashBase$1)
    return hashBase$1;
  hasRequiredHashBase$1 = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireReadableBrowser$1().Transform, z = requireInherits_browser();
  function ne(le, he) {
    if (!v.isBuffer(le) && typeof le != "string")
      throw new TypeError(he + " must be a string or a buffer");
  }
  function ue(le) {
    y.call(this), this._block = v.allocUnsafe(le), this._blockSize = le, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return z(ue, y), ue.prototype._transform = function(le, he, ge) {
    var we = null;
    try {
      this.update(le, he);
    } catch (Ee) {
      we = Ee;
    }
    ge(we);
  }, ue.prototype._flush = function(le) {
    var he = null;
    try {
      this.push(this.digest());
    } catch (ge) {
      he = ge;
    }
    le(he);
  }, ue.prototype.update = function(le, he) {
    if (ne(le, "Data"), this._finalized)
      throw new Error("Digest already called");
    v.isBuffer(le) || (le = v.from(le, he));
    for (var ge = this._block, we = 0; this._blockOffset + le.length - we >= this._blockSize; ) {
      for (var Ee = this._blockOffset; Ee < this._blockSize; )
        ge[Ee++] = le[we++];
      this._update(), this._blockOffset = 0;
    }
    for (; we < le.length; )
      ge[this._blockOffset++] = le[we++];
    for (var xe = 0, $e = le.length * 8; $e > 0; ++xe)
      this._length[xe] += $e, $e = this._length[xe] / 4294967296 | 0, $e > 0 && (this._length[xe] -= 4294967296 * $e);
    return this;
  }, ue.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, ue.prototype.digest = function(le) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var he = this._digest();
    le !== void 0 && (he = he.toString(le)), this._block.fill(0), this._blockOffset = 0;
    for (var ge = 0; ge < 4; ++ge)
      this._length[ge] = 0;
    return he;
  }, ue.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase$1 = ue, hashBase$1;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js)
    return md5_js;
  hasRequiredMd5_js = 1;
  var v = requireInherits_browser(), y = requireHashBase$1(), z = requireSafeBuffer$2().Buffer, ne = new Array(16);
  function ue() {
    y.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  v(ue, y), ue.prototype._update = function() {
    for (var xe = ne, $e = 0; $e < 16; ++$e)
      xe[$e] = this._block.readInt32LE($e * 4);
    var Ne = this._a, st = this._b, Nr = this._c, br = this._d;
    Ne = he(Ne, st, Nr, br, xe[0], 3614090360, 7), br = he(br, Ne, st, Nr, xe[1], 3905402710, 12), Nr = he(Nr, br, Ne, st, xe[2], 606105819, 17), st = he(st, Nr, br, Ne, xe[3], 3250441966, 22), Ne = he(Ne, st, Nr, br, xe[4], 4118548399, 7), br = he(br, Ne, st, Nr, xe[5], 1200080426, 12), Nr = he(Nr, br, Ne, st, xe[6], 2821735955, 17), st = he(st, Nr, br, Ne, xe[7], 4249261313, 22), Ne = he(Ne, st, Nr, br, xe[8], 1770035416, 7), br = he(br, Ne, st, Nr, xe[9], 2336552879, 12), Nr = he(Nr, br, Ne, st, xe[10], 4294925233, 17), st = he(st, Nr, br, Ne, xe[11], 2304563134, 22), Ne = he(Ne, st, Nr, br, xe[12], 1804603682, 7), br = he(br, Ne, st, Nr, xe[13], 4254626195, 12), Nr = he(Nr, br, Ne, st, xe[14], 2792965006, 17), st = he(st, Nr, br, Ne, xe[15], 1236535329, 22), Ne = ge(Ne, st, Nr, br, xe[1], 4129170786, 5), br = ge(br, Ne, st, Nr, xe[6], 3225465664, 9), Nr = ge(Nr, br, Ne, st, xe[11], 643717713, 14), st = ge(st, Nr, br, Ne, xe[0], 3921069994, 20), Ne = ge(Ne, st, Nr, br, xe[5], 3593408605, 5), br = ge(br, Ne, st, Nr, xe[10], 38016083, 9), Nr = ge(Nr, br, Ne, st, xe[15], 3634488961, 14), st = ge(st, Nr, br, Ne, xe[4], 3889429448, 20), Ne = ge(Ne, st, Nr, br, xe[9], 568446438, 5), br = ge(br, Ne, st, Nr, xe[14], 3275163606, 9), Nr = ge(Nr, br, Ne, st, xe[3], 4107603335, 14), st = ge(st, Nr, br, Ne, xe[8], 1163531501, 20), Ne = ge(Ne, st, Nr, br, xe[13], 2850285829, 5), br = ge(br, Ne, st, Nr, xe[2], 4243563512, 9), Nr = ge(Nr, br, Ne, st, xe[7], 1735328473, 14), st = ge(st, Nr, br, Ne, xe[12], 2368359562, 20), Ne = we(Ne, st, Nr, br, xe[5], 4294588738, 4), br = we(br, Ne, st, Nr, xe[8], 2272392833, 11), Nr = we(Nr, br, Ne, st, xe[11], 1839030562, 16), st = we(st, Nr, br, Ne, xe[14], 4259657740, 23), Ne = we(Ne, st, Nr, br, xe[1], 2763975236, 4), br = we(br, Ne, st, Nr, xe[4], 1272893353, 11), Nr = we(Nr, br, Ne, st, xe[7], 4139469664, 16), st = we(st, Nr, br, Ne, xe[10], 3200236656, 23), Ne = we(Ne, st, Nr, br, xe[13], 681279174, 4), br = we(br, Ne, st, Nr, xe[0], 3936430074, 11), Nr = we(Nr, br, Ne, st, xe[3], 3572445317, 16), st = we(st, Nr, br, Ne, xe[6], 76029189, 23), Ne = we(Ne, st, Nr, br, xe[9], 3654602809, 4), br = we(br, Ne, st, Nr, xe[12], 3873151461, 11), Nr = we(Nr, br, Ne, st, xe[15], 530742520, 16), st = we(st, Nr, br, Ne, xe[2], 3299628645, 23), Ne = Ee(Ne, st, Nr, br, xe[0], 4096336452, 6), br = Ee(br, Ne, st, Nr, xe[7], 1126891415, 10), Nr = Ee(Nr, br, Ne, st, xe[14], 2878612391, 15), st = Ee(st, Nr, br, Ne, xe[5], 4237533241, 21), Ne = Ee(Ne, st, Nr, br, xe[12], 1700485571, 6), br = Ee(br, Ne, st, Nr, xe[3], 2399980690, 10), Nr = Ee(Nr, br, Ne, st, xe[10], 4293915773, 15), st = Ee(st, Nr, br, Ne, xe[1], 2240044497, 21), Ne = Ee(Ne, st, Nr, br, xe[8], 1873313359, 6), br = Ee(br, Ne, st, Nr, xe[15], 4264355552, 10), Nr = Ee(Nr, br, Ne, st, xe[6], 2734768916, 15), st = Ee(st, Nr, br, Ne, xe[13], 1309151649, 21), Ne = Ee(Ne, st, Nr, br, xe[4], 4149444226, 6), br = Ee(br, Ne, st, Nr, xe[11], 3174756917, 10), Nr = Ee(Nr, br, Ne, st, xe[2], 718787259, 15), st = Ee(st, Nr, br, Ne, xe[9], 3951481745, 21), this._a = this._a + Ne | 0, this._b = this._b + st | 0, this._c = this._c + Nr | 0, this._d = this._d + br | 0;
  }, ue.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var xe = z.allocUnsafe(16);
    return xe.writeInt32LE(this._a, 0), xe.writeInt32LE(this._b, 4), xe.writeInt32LE(this._c, 8), xe.writeInt32LE(this._d, 12), xe;
  };
  function le(xe, $e) {
    return xe << $e | xe >>> 32 - $e;
  }
  function he(xe, $e, Ne, st, Nr, br, $n) {
    return le(xe + ($e & Ne | ~$e & st) + Nr + br | 0, $n) + $e | 0;
  }
  function ge(xe, $e, Ne, st, Nr, br, $n) {
    return le(xe + ($e & st | Ne & ~st) + Nr + br | 0, $n) + $e | 0;
  }
  function we(xe, $e, Ne, st, Nr, br, $n) {
    return le(xe + ($e ^ Ne ^ st) + Nr + br | 0, $n) + $e | 0;
  }
  function Ee(xe, $e, Ne, st, Nr, br, $n) {
    return le(xe + (Ne ^ ($e | ~st)) + Nr + br | 0, $n) + $e | 0;
  }
  return md5_js = ue, md5_js;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase)
    return hashBase;
  hasRequiredHashBase = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireReadableBrowser$1().Transform, z = requireInherits_browser();
  function ne(le, he) {
    if (!v.isBuffer(le) && typeof le != "string")
      throw new TypeError(he + " must be a string or a buffer");
  }
  function ue(le) {
    y.call(this), this._block = v.allocUnsafe(le), this._blockSize = le, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return z(ue, y), ue.prototype._transform = function(le, he, ge) {
    var we = null;
    try {
      this.update(le, he);
    } catch (Ee) {
      we = Ee;
    }
    ge(we);
  }, ue.prototype._flush = function(le) {
    var he = null;
    try {
      this.push(this.digest());
    } catch (ge) {
      he = ge;
    }
    le(he);
  }, ue.prototype.update = function(le, he) {
    if (ne(le, "Data"), this._finalized)
      throw new Error("Digest already called");
    v.isBuffer(le) || (le = v.from(le, he));
    for (var ge = this._block, we = 0; this._blockOffset + le.length - we >= this._blockSize; ) {
      for (var Ee = this._blockOffset; Ee < this._blockSize; )
        ge[Ee++] = le[we++];
      this._update(), this._blockOffset = 0;
    }
    for (; we < le.length; )
      ge[this._blockOffset++] = le[we++];
    for (var xe = 0, $e = le.length * 8; $e > 0; ++xe)
      this._length[xe] += $e, $e = this._length[xe] / 4294967296 | 0, $e > 0 && (this._length[xe] -= 4294967296 * $e);
    return this;
  }, ue.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, ue.prototype.digest = function(le) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var he = this._digest();
    le !== void 0 && (he = he.toString(le)), this._block.fill(0), this._blockOffset = 0;
    for (var ge = 0; ge < 4; ++ge)
      this._length[ge] = 0;
    return he;
  }, ue.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = ue, hashBase;
}
var ripemd160$2, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160)
    return ripemd160$2;
  hasRequiredRipemd160 = 1;
  var v = require$$0$3.Buffer, y = requireInherits_browser(), z = requireHashBase(), ne = new Array(16), ue = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], le = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], he = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], ge = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], we = [0, 1518500249, 1859775393, 2400959708, 2840853838], Ee = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function xe() {
    z.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  y(xe, z), xe.prototype._update = function() {
    for (var En = ne, Rn = 0; Rn < 16; ++Rn)
      En[Rn] = this._block.readInt32LE(Rn * 4);
    for (var wa = this._a | 0, Aa = this._b | 0, _a = this._c | 0, Ta = this._d | 0, Zn = this._e | 0, Ra = this._a | 0, Yn = this._b | 0, $o = this._c | 0, ct = this._d | 0, fe = this._e | 0, be = 0; be < 80; be += 1) {
      var ye, Se;
      be < 16 ? (ye = Ne(wa, Aa, _a, Ta, Zn, En[ue[be]], we[0], he[be]), Se = $n(Ra, Yn, $o, ct, fe, En[le[be]], Ee[0], ge[be])) : be < 32 ? (ye = st(wa, Aa, _a, Ta, Zn, En[ue[be]], we[1], he[be]), Se = br(Ra, Yn, $o, ct, fe, En[le[be]], Ee[1], ge[be])) : be < 48 ? (ye = Nr(wa, Aa, _a, Ta, Zn, En[ue[be]], we[2], he[be]), Se = Nr(Ra, Yn, $o, ct, fe, En[le[be]], Ee[2], ge[be])) : be < 64 ? (ye = br(wa, Aa, _a, Ta, Zn, En[ue[be]], we[3], he[be]), Se = st(Ra, Yn, $o, ct, fe, En[le[be]], Ee[3], ge[be])) : (ye = $n(wa, Aa, _a, Ta, Zn, En[ue[be]], we[4], he[be]), Se = Ne(Ra, Yn, $o, ct, fe, En[le[be]], Ee[4], ge[be])), wa = Zn, Zn = Ta, Ta = $e(_a, 10), _a = Aa, Aa = ye, Ra = fe, fe = ct, ct = $e($o, 10), $o = Yn, Yn = Se;
    }
    var Oe = this._b + _a + ct | 0;
    this._b = this._c + Ta + fe | 0, this._c = this._d + Zn + Ra | 0, this._d = this._e + wa + Yn | 0, this._e = this._a + Aa + $o | 0, this._a = Oe;
  }, xe.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var En = v.alloc ? v.alloc(20) : new v(20);
    return En.writeInt32LE(this._a, 0), En.writeInt32LE(this._b, 4), En.writeInt32LE(this._c, 8), En.writeInt32LE(this._d, 12), En.writeInt32LE(this._e, 16), En;
  };
  function $e(En, Rn) {
    return En << Rn | En >>> 32 - Rn;
  }
  function Ne(En, Rn, wa, Aa, _a, Ta, Zn, Ra) {
    return $e(En + (Rn ^ wa ^ Aa) + Ta + Zn | 0, Ra) + _a | 0;
  }
  function st(En, Rn, wa, Aa, _a, Ta, Zn, Ra) {
    return $e(En + (Rn & wa | ~Rn & Aa) + Ta + Zn | 0, Ra) + _a | 0;
  }
  function Nr(En, Rn, wa, Aa, _a, Ta, Zn, Ra) {
    return $e(En + ((Rn | ~wa) ^ Aa) + Ta + Zn | 0, Ra) + _a | 0;
  }
  function br(En, Rn, wa, Aa, _a, Ta, Zn, Ra) {
    return $e(En + (Rn & Aa | wa & ~Aa) + Ta + Zn | 0, Ra) + _a | 0;
  }
  function $n(En, Rn, wa, Aa, _a, Ta, Zn, Ra) {
    return $e(En + (Rn ^ (wa | ~Aa)) + Ta + Zn | 0, Ra) + _a | 0;
  }
  return ripemd160$2 = xe, ripemd160$2;
}
var sha_js = { exports: {} }, hash$4, hasRequiredHash;
function requireHash() {
  if (hasRequiredHash)
    return hash$4;
  hasRequiredHash = 1;
  var v = requireSafeBuffer$2().Buffer;
  function y(z, ne) {
    this._block = v.alloc(z), this._finalSize = ne, this._blockSize = z, this._len = 0;
  }
  return y.prototype.update = function(z, ne) {
    typeof z == "string" && (ne = ne || "utf8", z = v.from(z, ne));
    for (var ue = this._block, le = this._blockSize, he = z.length, ge = this._len, we = 0; we < he; ) {
      for (var Ee = ge % le, xe = Math.min(he - we, le - Ee), $e = 0; $e < xe; $e++)
        ue[Ee + $e] = z[we + $e];
      ge += xe, we += xe, ge % le === 0 && this._update(ue);
    }
    return this._len += he, this;
  }, y.prototype.digest = function(z) {
    var ne = this._len % this._blockSize;
    this._block[ne] = 128, this._block.fill(0, ne + 1), ne >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var ue = this._len * 8;
    if (ue <= 4294967295)
      this._block.writeUInt32BE(ue, this._blockSize - 4);
    else {
      var le = (ue & 4294967295) >>> 0, he = (ue - le) / 4294967296;
      this._block.writeUInt32BE(he, this._blockSize - 8), this._block.writeUInt32BE(le, this._blockSize - 4);
    }
    this._update(this._block);
    var ge = this._hash();
    return z ? ge.toString(z) : ge;
  }, y.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$4 = y, hash$4;
}
var sha$2, hasRequiredSha;
function requireSha() {
  if (hasRequiredSha)
    return sha$2;
  hasRequiredSha = 1;
  var v = requireInherits_browser(), y = requireHash(), z = requireSafeBuffer$2().Buffer, ne = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], ue = new Array(80);
  function le() {
    this.init(), this._w = ue, y.call(this, 64, 56);
  }
  v(le, y), le.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function he(Ee) {
    return Ee << 5 | Ee >>> 27;
  }
  function ge(Ee) {
    return Ee << 30 | Ee >>> 2;
  }
  function we(Ee, xe, $e, Ne) {
    return Ee === 0 ? xe & $e | ~xe & Ne : Ee === 2 ? xe & $e | xe & Ne | $e & Ne : xe ^ $e ^ Ne;
  }
  return le.prototype._update = function(Ee) {
    for (var xe = this._w, $e = this._a | 0, Ne = this._b | 0, st = this._c | 0, Nr = this._d | 0, br = this._e | 0, $n = 0; $n < 16; ++$n)
      xe[$n] = Ee.readInt32BE($n * 4);
    for (; $n < 80; ++$n)
      xe[$n] = xe[$n - 3] ^ xe[$n - 8] ^ xe[$n - 14] ^ xe[$n - 16];
    for (var En = 0; En < 80; ++En) {
      var Rn = ~~(En / 20), wa = he($e) + we(Rn, Ne, st, Nr) + br + xe[En] + ne[Rn] | 0;
      br = Nr, Nr = st, st = ge(Ne), Ne = $e, $e = wa;
    }
    this._a = $e + this._a | 0, this._b = Ne + this._b | 0, this._c = st + this._c | 0, this._d = Nr + this._d | 0, this._e = br + this._e | 0;
  }, le.prototype._hash = function() {
    var Ee = z.allocUnsafe(20);
    return Ee.writeInt32BE(this._a | 0, 0), Ee.writeInt32BE(this._b | 0, 4), Ee.writeInt32BE(this._c | 0, 8), Ee.writeInt32BE(this._d | 0, 12), Ee.writeInt32BE(this._e | 0, 16), Ee;
  }, sha$2 = le, sha$2;
}
var sha1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1)
    return sha1;
  hasRequiredSha1 = 1;
  var v = requireInherits_browser(), y = requireHash(), z = requireSafeBuffer$2().Buffer, ne = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], ue = new Array(80);
  function le() {
    this.init(), this._w = ue, y.call(this, 64, 56);
  }
  v(le, y), le.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function he(xe) {
    return xe << 1 | xe >>> 31;
  }
  function ge(xe) {
    return xe << 5 | xe >>> 27;
  }
  function we(xe) {
    return xe << 30 | xe >>> 2;
  }
  function Ee(xe, $e, Ne, st) {
    return xe === 0 ? $e & Ne | ~$e & st : xe === 2 ? $e & Ne | $e & st | Ne & st : $e ^ Ne ^ st;
  }
  return le.prototype._update = function(xe) {
    for (var $e = this._w, Ne = this._a | 0, st = this._b | 0, Nr = this._c | 0, br = this._d | 0, $n = this._e | 0, En = 0; En < 16; ++En)
      $e[En] = xe.readInt32BE(En * 4);
    for (; En < 80; ++En)
      $e[En] = he($e[En - 3] ^ $e[En - 8] ^ $e[En - 14] ^ $e[En - 16]);
    for (var Rn = 0; Rn < 80; ++Rn) {
      var wa = ~~(Rn / 20), Aa = ge(Ne) + Ee(wa, st, Nr, br) + $n + $e[Rn] + ne[wa] | 0;
      $n = br, br = Nr, Nr = we(st), st = Ne, Ne = Aa;
    }
    this._a = Ne + this._a | 0, this._b = st + this._b | 0, this._c = Nr + this._c | 0, this._d = br + this._d | 0, this._e = $n + this._e | 0;
  }, le.prototype._hash = function() {
    var xe = z.allocUnsafe(20);
    return xe.writeInt32BE(this._a | 0, 0), xe.writeInt32BE(this._b | 0, 4), xe.writeInt32BE(this._c | 0, 8), xe.writeInt32BE(this._d | 0, 12), xe.writeInt32BE(this._e | 0, 16), xe;
  }, sha1 = le, sha1;
}
var sha256$4, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256)
    return sha256$4;
  hasRequiredSha256 = 1;
  var v = requireInherits_browser(), y = requireHash(), z = requireSafeBuffer$2().Buffer, ne = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], ue = new Array(64);
  function le() {
    this.init(), this._w = ue, y.call(this, 64, 56);
  }
  v(le, y), le.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function he(Ne, st, Nr) {
    return Nr ^ Ne & (st ^ Nr);
  }
  function ge(Ne, st, Nr) {
    return Ne & st | Nr & (Ne | st);
  }
  function we(Ne) {
    return (Ne >>> 2 | Ne << 30) ^ (Ne >>> 13 | Ne << 19) ^ (Ne >>> 22 | Ne << 10);
  }
  function Ee(Ne) {
    return (Ne >>> 6 | Ne << 26) ^ (Ne >>> 11 | Ne << 21) ^ (Ne >>> 25 | Ne << 7);
  }
  function xe(Ne) {
    return (Ne >>> 7 | Ne << 25) ^ (Ne >>> 18 | Ne << 14) ^ Ne >>> 3;
  }
  function $e(Ne) {
    return (Ne >>> 17 | Ne << 15) ^ (Ne >>> 19 | Ne << 13) ^ Ne >>> 10;
  }
  return le.prototype._update = function(Ne) {
    for (var st = this._w, Nr = this._a | 0, br = this._b | 0, $n = this._c | 0, En = this._d | 0, Rn = this._e | 0, wa = this._f | 0, Aa = this._g | 0, _a = this._h | 0, Ta = 0; Ta < 16; ++Ta)
      st[Ta] = Ne.readInt32BE(Ta * 4);
    for (; Ta < 64; ++Ta)
      st[Ta] = $e(st[Ta - 2]) + st[Ta - 7] + xe(st[Ta - 15]) + st[Ta - 16] | 0;
    for (var Zn = 0; Zn < 64; ++Zn) {
      var Ra = _a + Ee(Rn) + he(Rn, wa, Aa) + ne[Zn] + st[Zn] | 0, Yn = we(Nr) + ge(Nr, br, $n) | 0;
      _a = Aa, Aa = wa, wa = Rn, Rn = En + Ra | 0, En = $n, $n = br, br = Nr, Nr = Ra + Yn | 0;
    }
    this._a = Nr + this._a | 0, this._b = br + this._b | 0, this._c = $n + this._c | 0, this._d = En + this._d | 0, this._e = Rn + this._e | 0, this._f = wa + this._f | 0, this._g = Aa + this._g | 0, this._h = _a + this._h | 0;
  }, le.prototype._hash = function() {
    var Ne = z.allocUnsafe(32);
    return Ne.writeInt32BE(this._a, 0), Ne.writeInt32BE(this._b, 4), Ne.writeInt32BE(this._c, 8), Ne.writeInt32BE(this._d, 12), Ne.writeInt32BE(this._e, 16), Ne.writeInt32BE(this._f, 20), Ne.writeInt32BE(this._g, 24), Ne.writeInt32BE(this._h, 28), Ne;
  }, sha256$4 = le, sha256$4;
}
var sha224$1, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224)
    return sha224$1;
  hasRequiredSha224 = 1;
  var v = requireInherits_browser(), y = requireSha256(), z = requireHash(), ne = requireSafeBuffer$2().Buffer, ue = new Array(64);
  function le() {
    this.init(), this._w = ue, z.call(this, 64, 56);
  }
  return v(le, y), le.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, le.prototype._hash = function() {
    var he = ne.allocUnsafe(28);
    return he.writeInt32BE(this._a, 0), he.writeInt32BE(this._b, 4), he.writeInt32BE(this._c, 8), he.writeInt32BE(this._d, 12), he.writeInt32BE(this._e, 16), he.writeInt32BE(this._f, 20), he.writeInt32BE(this._g, 24), he;
  }, sha224$1 = le, sha224$1;
}
var sha512$2, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512)
    return sha512$2;
  hasRequiredSha512 = 1;
  var v = requireInherits_browser(), y = requireHash(), z = requireSafeBuffer$2().Buffer, ne = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], ue = new Array(160);
  function le() {
    this.init(), this._w = ue, y.call(this, 128, 112);
  }
  v(le, y), le.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function he(br, $n, En) {
    return En ^ br & ($n ^ En);
  }
  function ge(br, $n, En) {
    return br & $n | En & (br | $n);
  }
  function we(br, $n) {
    return (br >>> 28 | $n << 4) ^ ($n >>> 2 | br << 30) ^ ($n >>> 7 | br << 25);
  }
  function Ee(br, $n) {
    return (br >>> 14 | $n << 18) ^ (br >>> 18 | $n << 14) ^ ($n >>> 9 | br << 23);
  }
  function xe(br, $n) {
    return (br >>> 1 | $n << 31) ^ (br >>> 8 | $n << 24) ^ br >>> 7;
  }
  function $e(br, $n) {
    return (br >>> 1 | $n << 31) ^ (br >>> 8 | $n << 24) ^ (br >>> 7 | $n << 25);
  }
  function Ne(br, $n) {
    return (br >>> 19 | $n << 13) ^ ($n >>> 29 | br << 3) ^ br >>> 6;
  }
  function st(br, $n) {
    return (br >>> 19 | $n << 13) ^ ($n >>> 29 | br << 3) ^ (br >>> 6 | $n << 26);
  }
  function Nr(br, $n) {
    return br >>> 0 < $n >>> 0 ? 1 : 0;
  }
  return le.prototype._update = function(br) {
    for (var $n = this._w, En = this._ah | 0, Rn = this._bh | 0, wa = this._ch | 0, Aa = this._dh | 0, _a = this._eh | 0, Ta = this._fh | 0, Zn = this._gh | 0, Ra = this._hh | 0, Yn = this._al | 0, $o = this._bl | 0, ct = this._cl | 0, fe = this._dl | 0, be = this._el | 0, ye = this._fl | 0, Se = this._gl | 0, Oe = this._hl | 0, Fr = 0; Fr < 32; Fr += 2)
      $n[Fr] = br.readInt32BE(Fr * 4), $n[Fr + 1] = br.readInt32BE(Fr * 4 + 4);
    for (; Fr < 160; Fr += 2) {
      var zn = $n[Fr - 30], Fe = $n[Fr - 15 * 2 + 1], pe = xe(zn, Fe), it = $e(Fe, zn);
      zn = $n[Fr - 2 * 2], Fe = $n[Fr - 2 * 2 + 1];
      var xa = Ne(zn, Fe), wo = st(Fe, zn), _u = $n[Fr - 7 * 2], Oa = $n[Fr - 7 * 2 + 1], Os = $n[Fr - 16 * 2], Pa = $n[Fr - 16 * 2 + 1], Ml = it + Oa | 0, Su = pe + _u + Nr(Ml, it) | 0;
      Ml = Ml + wo | 0, Su = Su + xa + Nr(Ml, wo) | 0, Ml = Ml + Pa | 0, Su = Su + Os + Nr(Ml, Pa) | 0, $n[Fr] = Su, $n[Fr + 1] = Ml;
    }
    for (var Tu = 0; Tu < 160; Tu += 2) {
      Su = $n[Tu], Ml = $n[Tu + 1];
      var Au = ge(En, Rn, wa), Zl = ge(Yn, $o, ct), Iu = we(En, Yn), Uc = we(Yn, En), Pu = Ee(_a, be), Lu = Ee(be, _a), th = ne[Tu], Zc = ne[Tu + 1], N1 = he(_a, Ta, Zn), Gh = he(be, ye, Se), Mc = Oe + Lu | 0, h1 = Ra + Pu + Nr(Mc, Oe) | 0;
      Mc = Mc + Gh | 0, h1 = h1 + N1 + Nr(Mc, Gh) | 0, Mc = Mc + Zc | 0, h1 = h1 + th + Nr(Mc, Zc) | 0, Mc = Mc + Ml | 0, h1 = h1 + Su + Nr(Mc, Ml) | 0;
      var l2 = Uc + Zl | 0, Gc = Iu + Au + Nr(l2, Uc) | 0;
      Ra = Zn, Oe = Se, Zn = Ta, Se = ye, Ta = _a, ye = be, be = fe + Mc | 0, _a = Aa + h1 + Nr(be, fe) | 0, Aa = wa, fe = ct, wa = Rn, ct = $o, Rn = En, $o = Yn, Yn = Mc + l2 | 0, En = h1 + Gc + Nr(Yn, Mc) | 0;
    }
    this._al = this._al + Yn | 0, this._bl = this._bl + $o | 0, this._cl = this._cl + ct | 0, this._dl = this._dl + fe | 0, this._el = this._el + be | 0, this._fl = this._fl + ye | 0, this._gl = this._gl + Se | 0, this._hl = this._hl + Oe | 0, this._ah = this._ah + En + Nr(this._al, Yn) | 0, this._bh = this._bh + Rn + Nr(this._bl, $o) | 0, this._ch = this._ch + wa + Nr(this._cl, ct) | 0, this._dh = this._dh + Aa + Nr(this._dl, fe) | 0, this._eh = this._eh + _a + Nr(this._el, be) | 0, this._fh = this._fh + Ta + Nr(this._fl, ye) | 0, this._gh = this._gh + Zn + Nr(this._gl, Se) | 0, this._hh = this._hh + Ra + Nr(this._hl, Oe) | 0;
  }, le.prototype._hash = function() {
    var br = z.allocUnsafe(64);
    function $n(En, Rn, wa) {
      br.writeInt32BE(En, wa), br.writeInt32BE(Rn, wa + 4);
    }
    return $n(this._ah, this._al, 0), $n(this._bh, this._bl, 8), $n(this._ch, this._cl, 16), $n(this._dh, this._dl, 24), $n(this._eh, this._el, 32), $n(this._fh, this._fl, 40), $n(this._gh, this._gl, 48), $n(this._hh, this._hl, 56), br;
  }, sha512$2 = le, sha512$2;
}
var sha384$1, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384)
    return sha384$1;
  hasRequiredSha384 = 1;
  var v = requireInherits_browser(), y = requireSha512(), z = requireHash(), ne = requireSafeBuffer$2().Buffer, ue = new Array(160);
  function le() {
    this.init(), this._w = ue, z.call(this, 128, 112);
  }
  return v(le, y), le.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, le.prototype._hash = function() {
    var he = ne.allocUnsafe(48);
    function ge(we, Ee, xe) {
      he.writeInt32BE(we, xe), he.writeInt32BE(Ee, xe + 4);
    }
    return ge(this._ah, this._al, 0), ge(this._bh, this._bl, 8), ge(this._ch, this._cl, 16), ge(this._dh, this._dl, 24), ge(this._eh, this._el, 32), ge(this._fh, this._fl, 40), he;
  }, sha384$1 = le, sha384$1;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js)
    return sha_js.exports;
  hasRequiredSha_js = 1;
  var v = sha_js.exports = function(z) {
    z = z.toLowerCase();
    var ne = v[z];
    if (!ne)
      throw new Error(z + " is not supported (we accept pull requests)");
    return new ne();
  };
  return v.sha = requireSha(), v.sha1 = requireSha1(), v.sha224 = requireSha224(), v.sha256 = requireSha256(), v.sha384 = requireSha384(), v.sha512 = requireSha512(), sha_js.exports;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify)
    return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = z;
  var v = eventsExports.EventEmitter, y = requireInherits_browser();
  y(z, v), z.Readable = require_stream_readable$1(), z.Writable = require_stream_writable$1(), z.Duplex = require_stream_duplex$1(), z.Transform = require_stream_transform$1(), z.PassThrough = require_stream_passthrough$1(), z.finished = requireEndOfStream(), z.pipeline = requirePipeline(), z.Stream = z;
  function z() {
    v.call(this);
  }
  return z.prototype.pipe = function(ne, ue) {
    var le = this;
    function he(st) {
      ne.writable && ne.write(st) === !1 && le.pause && le.pause();
    }
    le.on("data", he);
    function ge() {
      le.readable && le.resume && le.resume();
    }
    ne.on("drain", ge), !ne._isStdio && (!ue || ue.end !== !1) && (le.on("end", Ee), le.on("close", xe));
    var we = !1;
    function Ee() {
      we || (we = !0, ne.end());
    }
    function xe() {
      we || (we = !0, typeof ne.destroy == "function" && ne.destroy());
    }
    function $e(st) {
      if (Ne(), v.listenerCount(this, "error") === 0)
        throw st;
    }
    le.on("error", $e), ne.on("error", $e);
    function Ne() {
      le.removeListener("data", he), ne.removeListener("drain", ge), le.removeListener("end", Ee), le.removeListener("close", xe), le.removeListener("error", $e), ne.removeListener("error", $e), le.removeListener("end", Ne), le.removeListener("close", Ne), ne.removeListener("close", Ne);
    }
    return le.on("end", Ne), le.on("close", Ne), ne.on("close", Ne), ne.emit("pipe", le), ne;
  }, streamBrowserify;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase)
    return cipherBase;
  hasRequiredCipherBase = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireStreamBrowserify().Transform, z = requireString_decoder$1().StringDecoder, ne = requireInherits_browser();
  function ue(le) {
    y.call(this), this.hashMode = typeof le == "string", this.hashMode ? this[le] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return ne(ue, y), ue.prototype.update = function(le, he, ge) {
    typeof le == "string" && (le = v.from(le, he));
    var we = this._update(le);
    return this.hashMode ? this : (ge && (we = this._toString(we, ge)), we);
  }, ue.prototype.setAutoPadding = function() {
  }, ue.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, ue.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, ue.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, ue.prototype._transform = function(le, he, ge) {
    var we;
    try {
      this.hashMode ? this._update(le) : this.push(this._update(le));
    } catch (Ee) {
      we = Ee;
    } finally {
      ge(we);
    }
  }, ue.prototype._flush = function(le) {
    var he;
    try {
      this.push(this.__final());
    } catch (ge) {
      he = ge;
    }
    le(he);
  }, ue.prototype._finalOrDigest = function(le) {
    var he = this.__final() || v.alloc(0);
    return le && (he = this._toString(he, le, !0)), he;
  }, ue.prototype._toString = function(le, he, ge) {
    if (this._decoder || (this._decoder = new z(he), this._encoding = he), this._encoding !== he)
      throw new Error("can't switch encodings");
    var we = this._decoder.write(le);
    return ge && (we += this._decoder.end()), we;
  }, cipherBase = ue, cipherBase;
}
var browser$a, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9)
    return browser$a;
  hasRequiredBrowser$9 = 1;
  var v = requireInherits_browser(), y = requireMd5_js(), z = requireRipemd160(), ne = requireSha_js(), ue = requireCipherBase();
  function le(he) {
    ue.call(this, "digest"), this._hash = he;
  }
  return v(le, ue), le.prototype._update = function(he) {
    this._hash.update(he);
  }, le.prototype._final = function() {
    return this._hash.digest();
  }, browser$a = function(ge) {
    return ge = ge.toLowerCase(), ge === "md5" ? new y() : ge === "rmd160" || ge === "ripemd160" ? new z() : new le(ne(ge));
  }, browser$a;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy)
    return legacy;
  hasRequiredLegacy = 1;
  var v = requireInherits_browser(), y = requireSafeBuffer$2().Buffer, z = requireCipherBase(), ne = y.alloc(128), ue = 64;
  function le(he, ge) {
    z.call(this, "digest"), typeof ge == "string" && (ge = y.from(ge)), this._alg = he, this._key = ge, ge.length > ue ? ge = he(ge) : ge.length < ue && (ge = y.concat([ge, ne], ue));
    for (var we = this._ipad = y.allocUnsafe(ue), Ee = this._opad = y.allocUnsafe(ue), xe = 0; xe < ue; xe++)
      we[xe] = ge[xe] ^ 54, Ee[xe] = ge[xe] ^ 92;
    this._hash = [we];
  }
  return v(le, z), le.prototype._update = function(he) {
    this._hash.push(he);
  }, le.prototype._final = function() {
    var he = this._alg(y.concat(this._hash));
    return this._alg(y.concat([this._opad, he]));
  }, legacy = le, legacy;
}
var md5, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5)
    return md5;
  hasRequiredMd5 = 1;
  var v = requireMd5_js();
  return md5 = function(y) {
    return new v().update(y).digest();
  }, md5;
}
var browser$9, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8)
    return browser$9;
  hasRequiredBrowser$8 = 1;
  var v = requireInherits_browser(), y = requireLegacy(), z = requireCipherBase(), ne = requireSafeBuffer$2().Buffer, ue = requireMd5(), le = requireRipemd160(), he = requireSha_js(), ge = ne.alloc(128);
  function we(Ee, xe) {
    z.call(this, "digest"), typeof xe == "string" && (xe = ne.from(xe));
    var $e = Ee === "sha512" || Ee === "sha384" ? 128 : 64;
    if (this._alg = Ee, this._key = xe, xe.length > $e) {
      var Ne = Ee === "rmd160" ? new le() : he(Ee);
      xe = Ne.update(xe).digest();
    } else
      xe.length < $e && (xe = ne.concat([xe, ge], $e));
    for (var st = this._ipad = ne.allocUnsafe($e), Nr = this._opad = ne.allocUnsafe($e), br = 0; br < $e; br++)
      st[br] = xe[br] ^ 54, Nr[br] = xe[br] ^ 92;
    this._hash = Ee === "rmd160" ? new le() : he(Ee), this._hash.update(st);
  }
  return v(we, z), we.prototype._update = function(Ee) {
    this._hash.update(Ee);
  }, we.prototype._final = function() {
    var Ee = this._hash.digest(), xe = this._alg === "rmd160" ? new le() : he(this._alg);
    return xe.update(this._opad).update(Ee).digest();
  }, browser$9 = function(xe, $e) {
    return xe = xe.toLowerCase(), xe === "rmd160" || xe === "ripemd160" ? new we("rmd160", $e) : xe === "md5" ? new y(ue, $e) : new we(xe, $e);
  }, browser$9;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256$3 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512$1 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: sha256$3,
  sha224,
  sha384,
  sha512: sha512$1,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$8 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition)
    return precondition;
  hasRequiredPrecondition = 1;
  var v = Math.pow(2, 30) - 1;
  return precondition = function(y, z) {
    if (typeof y != "number")
      throw new TypeError("Iterations not a number");
    if (y < 0)
      throw new TypeError("Bad iterations");
    if (typeof z != "number")
      throw new TypeError("Key length not a number");
    if (z < 0 || z > v || z !== z)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding)
    return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var v;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    v = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var y = parseInt(process$1.version.split(".")[0].slice(1), 10);
    v = y >= 6 ? "utf-8" : "binary";
  } else
    v = "utf-8";
  return defaultEncoding_1 = v, defaultEncoding_1;
}
var toBuffer, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer)
    return toBuffer;
  hasRequiredToBuffer = 1;
  var v = requireSafeBuffer$2().Buffer;
  return toBuffer = function(y, z, ne) {
    if (v.isBuffer(y))
      return y;
    if (typeof y == "string")
      return v.from(y, z);
    if (ArrayBuffer.isView(y))
      return v.from(y.buffer);
    throw new TypeError(ne + " must be a string, a Buffer, a typed array or a DataView");
  }, toBuffer;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser)
    return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var v = requireMd5(), y = requireRipemd160(), z = requireSha_js(), ne = requireSafeBuffer$2().Buffer, ue = requirePrecondition(), le = requireDefaultEncoding(), he = requireToBuffer(), ge = ne.alloc(128), we = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function Ee(Ne, st, Nr) {
    var br = xe(Ne), $n = Ne === "sha512" || Ne === "sha384" ? 128 : 64;
    st.length > $n ? st = br(st) : st.length < $n && (st = ne.concat([st, ge], $n));
    for (var En = ne.allocUnsafe($n + we[Ne]), Rn = ne.allocUnsafe($n + we[Ne]), wa = 0; wa < $n; wa++)
      En[wa] = st[wa] ^ 54, Rn[wa] = st[wa] ^ 92;
    var Aa = ne.allocUnsafe($n + Nr + 4);
    En.copy(Aa, 0, 0, $n), this.ipad1 = Aa, this.ipad2 = En, this.opad = Rn, this.alg = Ne, this.blocksize = $n, this.hash = br, this.size = we[Ne];
  }
  Ee.prototype.run = function(Ne, st) {
    Ne.copy(st, this.blocksize);
    var Nr = this.hash(st);
    return Nr.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function xe(Ne) {
    function st(br) {
      return z(Ne).update(br).digest();
    }
    function Nr(br) {
      return new y().update(br).digest();
    }
    return Ne === "rmd160" || Ne === "ripemd160" ? Nr : Ne === "md5" ? v : st;
  }
  function $e(Ne, st, Nr, br, $n) {
    ue(Nr, br), Ne = he(Ne, le, "Password"), st = he(st, le, "Salt"), $n = $n || "sha1";
    var En = new Ee($n, Ne, st.length), Rn = ne.allocUnsafe(br), wa = ne.allocUnsafe(st.length + 4);
    st.copy(wa, 0, 0, st.length);
    for (var Aa = 0, _a = we[$n], Ta = Math.ceil(br / _a), Zn = 1; Zn <= Ta; Zn++) {
      wa.writeUInt32BE(Zn, st.length);
      for (var Ra = En.run(wa, En.ipad1), Yn = Ra, $o = 1; $o < Nr; $o++) {
        Yn = En.run(Yn, En.ipad2);
        for (var ct = 0; ct < _a; ct++)
          Ra[ct] ^= Yn[ct];
      }
      Ra.copy(Rn, Aa), Aa += _a;
    }
    return Rn;
  }
  return syncBrowser = $e, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync)
    return async;
  hasRequiredAsync = 1;
  var v = requireSafeBuffer$2().Buffer, y = requirePrecondition(), z = requireDefaultEncoding(), ne = requireSyncBrowser(), ue = requireToBuffer(), le, he = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, ge = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, we = [];
  function Ee(Nr) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !he || !he.importKey || !he.deriveBits)
      return Promise.resolve(!1);
    if (we[Nr] !== void 0)
      return we[Nr];
    le = le || v.alloc(8);
    var br = Ne(le, le, 10, 128, Nr).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return we[Nr] = br, br;
  }
  var xe;
  function $e() {
    return xe || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? xe = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? xe = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? xe = commonjsGlobal.setImmediate : xe = commonjsGlobal.setTimeout, xe);
  }
  function Ne(Nr, br, $n, En, Rn) {
    return he.importKey(
      "raw",
      Nr,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(wa) {
      return he.deriveBits({
        name: "PBKDF2",
        salt: br,
        iterations: $n,
        hash: {
          name: Rn
        }
      }, wa, En << 3);
    }).then(function(wa) {
      return v.from(wa);
    });
  }
  function st(Nr, br) {
    Nr.then(function($n) {
      $e()(function() {
        br(null, $n);
      });
    }, function($n) {
      $e()(function() {
        br($n);
      });
    });
  }
  return async = function(Nr, br, $n, En, Rn, wa) {
    typeof Rn == "function" && (wa = Rn, Rn = void 0), Rn = Rn || "sha1";
    var Aa = ge[Rn.toLowerCase()];
    if (!Aa || typeof commonjsGlobal.Promise != "function") {
      $e()(function() {
        var _a;
        try {
          _a = ne(Nr, br, $n, En, Rn);
        } catch (Ta) {
          return wa(Ta);
        }
        wa(null, _a);
      });
      return;
    }
    if (y($n, En), Nr = ue(Nr, z, "Password"), br = ue(br, z, "Salt"), typeof wa != "function")
      throw new Error("No callback provided to pbkdf2");
    st(Ee(Aa).then(function(_a) {
      return _a ? Ne(Nr, br, $n, En, Aa) : ne(Nr, br, $n, En, Rn);
    }), wa);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$8.pbkdf2 = requireAsync(), browser$8.pbkdf2Sync = requireSyncBrowser()), browser$8;
}
var browser$7 = {}, des$1 = {}, utils$o = {}, hasRequiredUtils$1;
function requireUtils$1() {
  if (hasRequiredUtils$1)
    return utils$o;
  hasRequiredUtils$1 = 1, utils$o.readUInt32BE = function(ue, le) {
    var he = ue[0 + le] << 24 | ue[1 + le] << 16 | ue[2 + le] << 8 | ue[3 + le];
    return he >>> 0;
  }, utils$o.writeUInt32BE = function(ue, le, he) {
    ue[0 + he] = le >>> 24, ue[1 + he] = le >>> 16 & 255, ue[2 + he] = le >>> 8 & 255, ue[3 + he] = le & 255;
  }, utils$o.ip = function(ue, le, he, ge) {
    for (var we = 0, Ee = 0, xe = 6; xe >= 0; xe -= 2) {
      for (var $e = 0; $e <= 24; $e += 8)
        we <<= 1, we |= le >>> $e + xe & 1;
      for (var $e = 0; $e <= 24; $e += 8)
        we <<= 1, we |= ue >>> $e + xe & 1;
    }
    for (var xe = 6; xe >= 0; xe -= 2) {
      for (var $e = 1; $e <= 25; $e += 8)
        Ee <<= 1, Ee |= le >>> $e + xe & 1;
      for (var $e = 1; $e <= 25; $e += 8)
        Ee <<= 1, Ee |= ue >>> $e + xe & 1;
    }
    he[ge + 0] = we >>> 0, he[ge + 1] = Ee >>> 0;
  }, utils$o.rip = function(ue, le, he, ge) {
    for (var we = 0, Ee = 0, xe = 0; xe < 4; xe++)
      for (var $e = 24; $e >= 0; $e -= 8)
        we <<= 1, we |= le >>> $e + xe & 1, we <<= 1, we |= ue >>> $e + xe & 1;
    for (var xe = 4; xe < 8; xe++)
      for (var $e = 24; $e >= 0; $e -= 8)
        Ee <<= 1, Ee |= le >>> $e + xe & 1, Ee <<= 1, Ee |= ue >>> $e + xe & 1;
    he[ge + 0] = we >>> 0, he[ge + 1] = Ee >>> 0;
  }, utils$o.pc1 = function(ue, le, he, ge) {
    for (var we = 0, Ee = 0, xe = 7; xe >= 5; xe--) {
      for (var $e = 0; $e <= 24; $e += 8)
        we <<= 1, we |= le >> $e + xe & 1;
      for (var $e = 0; $e <= 24; $e += 8)
        we <<= 1, we |= ue >> $e + xe & 1;
    }
    for (var $e = 0; $e <= 24; $e += 8)
      we <<= 1, we |= le >> $e + xe & 1;
    for (var xe = 1; xe <= 3; xe++) {
      for (var $e = 0; $e <= 24; $e += 8)
        Ee <<= 1, Ee |= le >> $e + xe & 1;
      for (var $e = 0; $e <= 24; $e += 8)
        Ee <<= 1, Ee |= ue >> $e + xe & 1;
    }
    for (var $e = 0; $e <= 24; $e += 8)
      Ee <<= 1, Ee |= ue >> $e + xe & 1;
    he[ge + 0] = we >>> 0, he[ge + 1] = Ee >>> 0;
  }, utils$o.r28shl = function(ue, le) {
    return ue << le & 268435455 | ue >>> 28 - le;
  };
  var v = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$o.pc2 = function(ue, le, he, ge) {
    for (var we = 0, Ee = 0, xe = v.length >>> 1, $e = 0; $e < xe; $e++)
      we <<= 1, we |= ue >>> v[$e] & 1;
    for (var $e = xe; $e < v.length; $e++)
      Ee <<= 1, Ee |= le >>> v[$e] & 1;
    he[ge + 0] = we >>> 0, he[ge + 1] = Ee >>> 0;
  }, utils$o.expand = function(ue, le, he) {
    var ge = 0, we = 0;
    ge = (ue & 1) << 5 | ue >>> 27;
    for (var Ee = 23; Ee >= 15; Ee -= 4)
      ge <<= 6, ge |= ue >>> Ee & 63;
    for (var Ee = 11; Ee >= 3; Ee -= 4)
      we |= ue >>> Ee & 63, we <<= 6;
    we |= (ue & 31) << 1 | ue >>> 31, le[he + 0] = ge >>> 0, le[he + 1] = we >>> 0;
  };
  var y = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$o.substitute = function(ue, le) {
    for (var he = 0, ge = 0; ge < 4; ge++) {
      var we = ue >>> 18 - ge * 6 & 63, Ee = y[ge * 64 + we];
      he <<= 4, he |= Ee;
    }
    for (var ge = 0; ge < 4; ge++) {
      var we = le >>> 18 - ge * 6 & 63, Ee = y[4 * 64 + ge * 64 + we];
      he <<= 4, he |= Ee;
    }
    return he >>> 0;
  };
  var z = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$o.permute = function(ue) {
    for (var le = 0, he = 0; he < z.length; he++)
      le <<= 1, le |= ue >>> z[he] & 1;
    return le >>> 0;
  }, utils$o.padSplit = function(ue, le, he) {
    for (var ge = ue.toString(2); ge.length < le; )
      ge = "0" + ge;
    for (var we = [], Ee = 0; Ee < le; Ee += he)
      we.push(ge.slice(Ee, Ee + he));
    return we.join(" ");
  }, utils$o;
}
var minimalisticAssert = assert$e;
function assert$e(v, y) {
  if (!v)
    throw new Error(y || "Assertion failed");
}
assert$e.equal = function v(y, z, ne) {
  if (y != z)
    throw new Error(ne || "Assertion failed: " + y + " != " + z);
};
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher)
    return cipher;
  hasRequiredCipher = 1;
  var v = minimalisticAssert;
  function y(z) {
    this.options = z, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = z.padding !== !1;
  }
  return cipher = y, y.prototype._init = function() {
  }, y.prototype.update = function(ne) {
    return ne.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(ne) : this._updateEncrypt(ne);
  }, y.prototype._buffer = function(ne, ue) {
    for (var le = Math.min(this.buffer.length - this.bufferOff, ne.length - ue), he = 0; he < le; he++)
      this.buffer[this.bufferOff + he] = ne[ue + he];
    return this.bufferOff += le, le;
  }, y.prototype._flushBuffer = function(ne, ue) {
    return this._update(this.buffer, 0, ne, ue), this.bufferOff = 0, this.blockSize;
  }, y.prototype._updateEncrypt = function(ne) {
    var ue = 0, le = 0, he = (this.bufferOff + ne.length) / this.blockSize | 0, ge = new Array(he * this.blockSize);
    this.bufferOff !== 0 && (ue += this._buffer(ne, ue), this.bufferOff === this.buffer.length && (le += this._flushBuffer(ge, le)));
    for (var we = ne.length - (ne.length - ue) % this.blockSize; ue < we; ue += this.blockSize)
      this._update(ne, ue, ge, le), le += this.blockSize;
    for (; ue < ne.length; ue++, this.bufferOff++)
      this.buffer[this.bufferOff] = ne[ue];
    return ge;
  }, y.prototype._updateDecrypt = function(ne) {
    for (var ue = 0, le = 0, he = Math.ceil((this.bufferOff + ne.length) / this.blockSize) - 1, ge = new Array(he * this.blockSize); he > 0; he--)
      ue += this._buffer(ne, ue), le += this._flushBuffer(ge, le);
    return ue += this._buffer(ne, ue), ge;
  }, y.prototype.final = function(ne) {
    var ue;
    ne && (ue = this.update(ne));
    var le;
    return this.type === "encrypt" ? le = this._finalEncrypt() : le = this._finalDecrypt(), ue ? ue.concat(le) : le;
  }, y.prototype._pad = function(ne, ue) {
    if (ue === 0)
      return !1;
    for (; ue < ne.length; )
      ne[ue++] = 0;
    return !0;
  }, y.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var ne = new Array(this.blockSize);
    return this._update(this.buffer, 0, ne, 0), ne;
  }, y.prototype._unpad = function(ne) {
    return ne;
  }, y.prototype._finalDecrypt = function() {
    v.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var ne = new Array(this.blockSize);
    return this._flushBuffer(ne, 0), this._unpad(ne);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1)
    return des;
  hasRequiredDes$1 = 1;
  var v = minimalisticAssert, y = requireInherits_browser(), z = requireUtils$1(), ne = requireCipher();
  function ue() {
    this.tmp = new Array(2), this.keys = null;
  }
  function le(ge) {
    ne.call(this, ge);
    var we = new ue();
    this._desState = we, this.deriveKeys(we, ge.key);
  }
  y(le, ne), des = le, le.create = function(we) {
    return new le(we);
  };
  var he = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return le.prototype.deriveKeys = function(we, Ee) {
    we.keys = new Array(16 * 2), v.equal(Ee.length, this.blockSize, "Invalid key length");
    var xe = z.readUInt32BE(Ee, 0), $e = z.readUInt32BE(Ee, 4);
    z.pc1(xe, $e, we.tmp, 0), xe = we.tmp[0], $e = we.tmp[1];
    for (var Ne = 0; Ne < we.keys.length; Ne += 2) {
      var st = he[Ne >>> 1];
      xe = z.r28shl(xe, st), $e = z.r28shl($e, st), z.pc2(xe, $e, we.keys, Ne);
    }
  }, le.prototype._update = function(we, Ee, xe, $e) {
    var Ne = this._desState, st = z.readUInt32BE(we, Ee), Nr = z.readUInt32BE(we, Ee + 4);
    z.ip(st, Nr, Ne.tmp, 0), st = Ne.tmp[0], Nr = Ne.tmp[1], this.type === "encrypt" ? this._encrypt(Ne, st, Nr, Ne.tmp, 0) : this._decrypt(Ne, st, Nr, Ne.tmp, 0), st = Ne.tmp[0], Nr = Ne.tmp[1], z.writeUInt32BE(xe, st, $e), z.writeUInt32BE(xe, Nr, $e + 4);
  }, le.prototype._pad = function(we, Ee) {
    if (this.padding === !1)
      return !1;
    for (var xe = we.length - Ee, $e = Ee; $e < we.length; $e++)
      we[$e] = xe;
    return !0;
  }, le.prototype._unpad = function(we) {
    if (this.padding === !1)
      return we;
    for (var Ee = we[we.length - 1], xe = we.length - Ee; xe < we.length; xe++)
      v.equal(we[xe], Ee);
    return we.slice(0, we.length - Ee);
  }, le.prototype._encrypt = function(we, Ee, xe, $e, Ne) {
    for (var st = Ee, Nr = xe, br = 0; br < we.keys.length; br += 2) {
      var $n = we.keys[br], En = we.keys[br + 1];
      z.expand(Nr, we.tmp, 0), $n ^= we.tmp[0], En ^= we.tmp[1];
      var Rn = z.substitute($n, En), wa = z.permute(Rn), Aa = Nr;
      Nr = (st ^ wa) >>> 0, st = Aa;
    }
    z.rip(Nr, st, $e, Ne);
  }, le.prototype._decrypt = function(we, Ee, xe, $e, Ne) {
    for (var st = xe, Nr = Ee, br = we.keys.length - 2; br >= 0; br -= 2) {
      var $n = we.keys[br], En = we.keys[br + 1];
      z.expand(st, we.tmp, 0), $n ^= we.tmp[0], En ^= we.tmp[1];
      var Rn = z.substitute($n, En), wa = z.permute(Rn), Aa = st;
      st = (Nr ^ wa) >>> 0, Nr = Aa;
    }
    z.rip(st, Nr, $e, Ne);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1)
    return cbc$1;
  hasRequiredCbc$1 = 1;
  var v = minimalisticAssert, y = requireInherits_browser(), z = {};
  function ne(le) {
    v.equal(le.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var he = 0; he < this.iv.length; he++)
      this.iv[he] = le[he];
  }
  function ue(le) {
    function he(xe) {
      le.call(this, xe), this._cbcInit();
    }
    y(he, le);
    for (var ge = Object.keys(z), we = 0; we < ge.length; we++) {
      var Ee = ge[we];
      he.prototype[Ee] = z[Ee];
    }
    return he.create = function($e) {
      return new he($e);
    }, he;
  }
  return cbc$1.instantiate = ue, z._cbcInit = function() {
    var he = new ne(this.options.iv);
    this._cbcState = he;
  }, z._update = function(he, ge, we, Ee) {
    var xe = this._cbcState, $e = this.constructor.super_.prototype, Ne = xe.iv;
    if (this.type === "encrypt") {
      for (var st = 0; st < this.blockSize; st++)
        Ne[st] ^= he[ge + st];
      $e._update.call(this, Ne, 0, we, Ee);
      for (var st = 0; st < this.blockSize; st++)
        Ne[st] = we[Ee + st];
    } else {
      $e._update.call(this, he, ge, we, Ee);
      for (var st = 0; st < this.blockSize; st++)
        we[Ee + st] ^= Ne[st];
      for (var st = 0; st < this.blockSize; st++)
        Ne[st] = he[ge + st];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde)
    return ede;
  hasRequiredEde = 1;
  var v = minimalisticAssert, y = requireInherits_browser(), z = requireCipher(), ne = requireDes$1();
  function ue(he, ge) {
    v.equal(ge.length, 24, "Invalid key length");
    var we = ge.slice(0, 8), Ee = ge.slice(8, 16), xe = ge.slice(16, 24);
    he === "encrypt" ? this.ciphers = [
      ne.create({ type: "encrypt", key: we }),
      ne.create({ type: "decrypt", key: Ee }),
      ne.create({ type: "encrypt", key: xe })
    ] : this.ciphers = [
      ne.create({ type: "decrypt", key: xe }),
      ne.create({ type: "encrypt", key: Ee }),
      ne.create({ type: "decrypt", key: we })
    ];
  }
  function le(he) {
    z.call(this, he);
    var ge = new ue(this.type, this.options.key);
    this._edeState = ge;
  }
  return y(le, z), ede = le, le.create = function(ge) {
    return new le(ge);
  }, le.prototype._update = function(ge, we, Ee, xe) {
    var $e = this._edeState;
    $e.ciphers[0]._update(ge, we, Ee, xe), $e.ciphers[1]._update(Ee, xe, Ee, xe), $e.ciphers[2]._update(Ee, xe, Ee, xe);
  }, le.prototype._pad = ne.prototype._pad, le.prototype._unpad = ne.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$1(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes)
    return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var v = requireCipherBase(), y = requireDes(), z = requireInherits_browser(), ne = requireSafeBuffer$2().Buffer, ue = {
    "des-ede3-cbc": y.CBC.instantiate(y.EDE),
    "des-ede3": y.EDE,
    "des-ede-cbc": y.CBC.instantiate(y.EDE),
    "des-ede": y.EDE,
    "des-cbc": y.CBC.instantiate(y.DES),
    "des-ecb": y.DES
  };
  ue.des = ue["des-cbc"], ue.des3 = ue["des-ede3-cbc"], browserifyDes = le, z(le, v);
  function le(he) {
    v.call(this);
    var ge = he.mode.toLowerCase(), we = ue[ge], Ee;
    he.decrypt ? Ee = "decrypt" : Ee = "encrypt";
    var xe = he.key;
    ne.isBuffer(xe) || (xe = ne.from(xe)), (ge === "des-ede" || ge === "des-ede-cbc") && (xe = ne.concat([xe, xe.slice(0, 8)]));
    var $e = he.iv;
    ne.isBuffer($e) || ($e = ne.from($e)), this._des = we.create({
      key: xe,
      iv: $e,
      type: Ee
    });
  }
  return le.prototype._update = function(he) {
    return ne.from(this._des.update(he));
  }, le.prototype._final = function() {
    return ne.from(this._des.final());
  }, browserifyDes;
}
var browser$6 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(v, y) {
    return v._cipher.encryptBlock(y);
  }, ecb.decrypt = function(v, y) {
    return v._cipher.decryptBlock(y);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(y, z) {
    for (var ne = Math.min(y.length, z.length), ue = new Buffer(ne), le = 0; le < ne; ++le)
      ue[le] = y[le] ^ z[le];
    return ue;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc)
    return cbc;
  hasRequiredCbc = 1;
  var v = requireBufferXor();
  return cbc.encrypt = function(y, z) {
    var ne = v(z, y._prev);
    return y._prev = y._cipher.encryptBlock(ne), y._prev;
  }, cbc.decrypt = function(y, z) {
    var ne = y._prev;
    y._prev = z;
    var ue = y._cipher.decryptBlock(z);
    return v(ue, ne);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb)
    return cfb;
  hasRequiredCfb = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireBufferXor();
  function z(ne, ue, le) {
    var he = ue.length, ge = y(ue, ne._cache);
    return ne._cache = ne._cache.slice(he), ne._prev = v.concat([ne._prev, le ? ue : ge]), ge;
  }
  return cfb.encrypt = function(ne, ue, le) {
    for (var he = v.allocUnsafe(0), ge; ue.length; )
      if (ne._cache.length === 0 && (ne._cache = ne._cipher.encryptBlock(ne._prev), ne._prev = v.allocUnsafe(0)), ne._cache.length <= ue.length)
        ge = ne._cache.length, he = v.concat([he, z(ne, ue.slice(0, ge), le)]), ue = ue.slice(ge);
      else {
        he = v.concat([he, z(ne, ue, le)]);
        break;
      }
    return he;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8)
    return cfb8;
  hasRequiredCfb8 = 1;
  var v = requireSafeBuffer$2().Buffer;
  function y(z, ne, ue) {
    var le = z._cipher.encryptBlock(z._prev), he = le[0] ^ ne;
    return z._prev = v.concat([
      z._prev.slice(1),
      v.from([ue ? ne : he])
    ]), he;
  }
  return cfb8.encrypt = function(z, ne, ue) {
    for (var le = ne.length, he = v.allocUnsafe(le), ge = -1; ++ge < le; )
      he[ge] = y(z, ne[ge], ue);
    return he;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1)
    return cfb1;
  hasRequiredCfb1 = 1;
  var v = requireSafeBuffer$2().Buffer;
  function y(ne, ue, le) {
    for (var he, ge = -1, we = 8, Ee = 0, xe, $e; ++ge < we; )
      he = ne._cipher.encryptBlock(ne._prev), xe = ue & 1 << 7 - ge ? 128 : 0, $e = he[0] ^ xe, Ee += ($e & 128) >> ge % 8, ne._prev = z(ne._prev, le ? xe : $e);
    return Ee;
  }
  function z(ne, ue) {
    var le = ne.length, he = -1, ge = v.allocUnsafe(ne.length);
    for (ne = v.concat([ne, v.from([ue])]); ++he < le; )
      ge[he] = ne[he] << 1 | ne[he + 1] >> 7;
    return ge;
  }
  return cfb1.encrypt = function(ne, ue, le) {
    for (var he = ue.length, ge = v.allocUnsafe(he), we = -1; ++we < he; )
      ge[we] = y(ne, ue[we], le);
    return ge;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb)
    return ofb;
  hasRequiredOfb = 1;
  var v = requireBufferXor();
  function y(z) {
    return z._prev = z._cipher.encryptBlock(z._prev), z._prev;
  }
  return ofb.encrypt = function(z, ne) {
    for (; z._cache.length < ne.length; )
      z._cache = Buffer.concat([z._cache, y(z)]);
    var ue = z._cache.slice(0, ne.length);
    return z._cache = z._cache.slice(ne.length), v(ne, ue);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32)
    return incr32_1;
  hasRequiredIncr32 = 1;
  function v(y) {
    for (var z = y.length, ne; z--; )
      if (ne = y.readUInt8(z), ne === 255)
        y.writeUInt8(0, z);
      else {
        ne++, y.writeUInt8(ne, z);
        break;
      }
  }
  return incr32_1 = v, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr)
    return ctr;
  hasRequiredCtr = 1;
  var v = requireBufferXor(), y = requireSafeBuffer$2().Buffer, z = requireIncr32();
  function ne(le) {
    var he = le._cipher.encryptBlockRaw(le._prev);
    return z(le._prev), he;
  }
  var ue = 16;
  return ctr.encrypt = function(le, he) {
    var ge = Math.ceil(he.length / ue), we = le._cache.length;
    le._cache = y.concat([
      le._cache,
      y.allocUnsafe(ge * ue)
    ]);
    for (var Ee = 0; Ee < ge; Ee++) {
      var xe = ne(le), $e = we + Ee * ue;
      le._cache.writeUInt32BE(xe[0], $e + 0), le._cache.writeUInt32BE(xe[1], $e + 4), le._cache.writeUInt32BE(xe[2], $e + 8), le._cache.writeUInt32BE(xe[3], $e + 12);
    }
    var Ne = le._cache.slice(0, he.length);
    return le._cache = le._cache.slice(he.length), v(he, Ne);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1)
    return modes_1;
  hasRequiredModes$1 = 1;
  var v = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, y = require$$2;
  for (var z in y)
    y[z].module = v[y[z].mode];
  return modes_1 = y, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes)
    return aes;
  hasRequiredAes = 1;
  var v = requireSafeBuffer$2().Buffer;
  function y(ge) {
    v.isBuffer(ge) || (ge = v.from(ge));
    for (var we = ge.length / 4 | 0, Ee = new Array(we), xe = 0; xe < we; xe++)
      Ee[xe] = ge.readUInt32BE(xe * 4);
    return Ee;
  }
  function z(ge) {
    for (var we = 0; we < ge.length; ge++)
      ge[we] = 0;
  }
  function ne(ge, we, Ee, xe, $e) {
    for (var Ne = Ee[0], st = Ee[1], Nr = Ee[2], br = Ee[3], $n = ge[0] ^ we[0], En = ge[1] ^ we[1], Rn = ge[2] ^ we[2], wa = ge[3] ^ we[3], Aa, _a, Ta, Zn, Ra = 4, Yn = 1; Yn < $e; Yn++)
      Aa = Ne[$n >>> 24] ^ st[En >>> 16 & 255] ^ Nr[Rn >>> 8 & 255] ^ br[wa & 255] ^ we[Ra++], _a = Ne[En >>> 24] ^ st[Rn >>> 16 & 255] ^ Nr[wa >>> 8 & 255] ^ br[$n & 255] ^ we[Ra++], Ta = Ne[Rn >>> 24] ^ st[wa >>> 16 & 255] ^ Nr[$n >>> 8 & 255] ^ br[En & 255] ^ we[Ra++], Zn = Ne[wa >>> 24] ^ st[$n >>> 16 & 255] ^ Nr[En >>> 8 & 255] ^ br[Rn & 255] ^ we[Ra++], $n = Aa, En = _a, Rn = Ta, wa = Zn;
    return Aa = (xe[$n >>> 24] << 24 | xe[En >>> 16 & 255] << 16 | xe[Rn >>> 8 & 255] << 8 | xe[wa & 255]) ^ we[Ra++], _a = (xe[En >>> 24] << 24 | xe[Rn >>> 16 & 255] << 16 | xe[wa >>> 8 & 255] << 8 | xe[$n & 255]) ^ we[Ra++], Ta = (xe[Rn >>> 24] << 24 | xe[wa >>> 16 & 255] << 16 | xe[$n >>> 8 & 255] << 8 | xe[En & 255]) ^ we[Ra++], Zn = (xe[wa >>> 24] << 24 | xe[$n >>> 16 & 255] << 16 | xe[En >>> 8 & 255] << 8 | xe[Rn & 255]) ^ we[Ra++], Aa = Aa >>> 0, _a = _a >>> 0, Ta = Ta >>> 0, Zn = Zn >>> 0, [Aa, _a, Ta, Zn];
  }
  var ue = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], le = function() {
    for (var ge = new Array(256), we = 0; we < 256; we++)
      we < 128 ? ge[we] = we << 1 : ge[we] = we << 1 ^ 283;
    for (var Ee = [], xe = [], $e = [[], [], [], []], Ne = [[], [], [], []], st = 0, Nr = 0, br = 0; br < 256; ++br) {
      var $n = Nr ^ Nr << 1 ^ Nr << 2 ^ Nr << 3 ^ Nr << 4;
      $n = $n >>> 8 ^ $n & 255 ^ 99, Ee[st] = $n, xe[$n] = st;
      var En = ge[st], Rn = ge[En], wa = ge[Rn], Aa = ge[$n] * 257 ^ $n * 16843008;
      $e[0][st] = Aa << 24 | Aa >>> 8, $e[1][st] = Aa << 16 | Aa >>> 16, $e[2][st] = Aa << 8 | Aa >>> 24, $e[3][st] = Aa, Aa = wa * 16843009 ^ Rn * 65537 ^ En * 257 ^ st * 16843008, Ne[0][$n] = Aa << 24 | Aa >>> 8, Ne[1][$n] = Aa << 16 | Aa >>> 16, Ne[2][$n] = Aa << 8 | Aa >>> 24, Ne[3][$n] = Aa, st === 0 ? st = Nr = 1 : (st = En ^ ge[ge[ge[wa ^ En]]], Nr ^= ge[ge[Nr]]);
    }
    return {
      SBOX: Ee,
      INV_SBOX: xe,
      SUB_MIX: $e,
      INV_SUB_MIX: Ne
    };
  }();
  function he(ge) {
    this._key = y(ge), this._reset();
  }
  return he.blockSize = 4 * 4, he.keySize = 256 / 8, he.prototype.blockSize = he.blockSize, he.prototype.keySize = he.keySize, he.prototype._reset = function() {
    for (var ge = this._key, we = ge.length, Ee = we + 6, xe = (Ee + 1) * 4, $e = [], Ne = 0; Ne < we; Ne++)
      $e[Ne] = ge[Ne];
    for (Ne = we; Ne < xe; Ne++) {
      var st = $e[Ne - 1];
      Ne % we === 0 ? (st = st << 8 | st >>> 24, st = le.SBOX[st >>> 24] << 24 | le.SBOX[st >>> 16 & 255] << 16 | le.SBOX[st >>> 8 & 255] << 8 | le.SBOX[st & 255], st ^= ue[Ne / we | 0] << 24) : we > 6 && Ne % we === 4 && (st = le.SBOX[st >>> 24] << 24 | le.SBOX[st >>> 16 & 255] << 16 | le.SBOX[st >>> 8 & 255] << 8 | le.SBOX[st & 255]), $e[Ne] = $e[Ne - we] ^ st;
    }
    for (var Nr = [], br = 0; br < xe; br++) {
      var $n = xe - br, En = $e[$n - (br % 4 ? 0 : 4)];
      br < 4 || $n <= 4 ? Nr[br] = En : Nr[br] = le.INV_SUB_MIX[0][le.SBOX[En >>> 24]] ^ le.INV_SUB_MIX[1][le.SBOX[En >>> 16 & 255]] ^ le.INV_SUB_MIX[2][le.SBOX[En >>> 8 & 255]] ^ le.INV_SUB_MIX[3][le.SBOX[En & 255]];
    }
    this._nRounds = Ee, this._keySchedule = $e, this._invKeySchedule = Nr;
  }, he.prototype.encryptBlockRaw = function(ge) {
    return ge = y(ge), ne(ge, this._keySchedule, le.SUB_MIX, le.SBOX, this._nRounds);
  }, he.prototype.encryptBlock = function(ge) {
    var we = this.encryptBlockRaw(ge), Ee = v.allocUnsafe(16);
    return Ee.writeUInt32BE(we[0], 0), Ee.writeUInt32BE(we[1], 4), Ee.writeUInt32BE(we[2], 8), Ee.writeUInt32BE(we[3], 12), Ee;
  }, he.prototype.decryptBlock = function(ge) {
    ge = y(ge);
    var we = ge[1];
    ge[1] = ge[3], ge[3] = we;
    var Ee = ne(ge, this._invKeySchedule, le.INV_SUB_MIX, le.INV_SBOX, this._nRounds), xe = v.allocUnsafe(16);
    return xe.writeUInt32BE(Ee[0], 0), xe.writeUInt32BE(Ee[3], 4), xe.writeUInt32BE(Ee[2], 8), xe.writeUInt32BE(Ee[1], 12), xe;
  }, he.prototype.scrub = function() {
    z(this._keySchedule), z(this._invKeySchedule), z(this._key);
  }, aes.AES = he, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash)
    return ghash;
  hasRequiredGhash = 1;
  var v = requireSafeBuffer$2().Buffer, y = v.alloc(16, 0);
  function z(le) {
    return [
      le.readUInt32BE(0),
      le.readUInt32BE(4),
      le.readUInt32BE(8),
      le.readUInt32BE(12)
    ];
  }
  function ne(le) {
    var he = v.allocUnsafe(16);
    return he.writeUInt32BE(le[0] >>> 0, 0), he.writeUInt32BE(le[1] >>> 0, 4), he.writeUInt32BE(le[2] >>> 0, 8), he.writeUInt32BE(le[3] >>> 0, 12), he;
  }
  function ue(le) {
    this.h = le, this.state = v.alloc(16, 0), this.cache = v.allocUnsafe(0);
  }
  return ue.prototype.ghash = function(le) {
    for (var he = -1; ++he < le.length; )
      this.state[he] ^= le[he];
    this._multiply();
  }, ue.prototype._multiply = function() {
    for (var le = z(this.h), he = [0, 0, 0, 0], ge, we, Ee, xe = -1; ++xe < 128; ) {
      for (we = (this.state[~~(xe / 8)] & 1 << 7 - xe % 8) !== 0, we && (he[0] ^= le[0], he[1] ^= le[1], he[2] ^= le[2], he[3] ^= le[3]), Ee = (le[3] & 1) !== 0, ge = 3; ge > 0; ge--)
        le[ge] = le[ge] >>> 1 | (le[ge - 1] & 1) << 31;
      le[0] = le[0] >>> 1, Ee && (le[0] = le[0] ^ 225 << 24);
    }
    this.state = ne(he);
  }, ue.prototype.update = function(le) {
    this.cache = v.concat([this.cache, le]);
    for (var he; this.cache.length >= 16; )
      he = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(he);
  }, ue.prototype.final = function(le, he) {
    return this.cache.length && this.ghash(v.concat([this.cache, y], 16)), this.ghash(ne([0, le, 0, he])), this.state;
  }, ghash = ue, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher)
    return authCipher;
  hasRequiredAuthCipher = 1;
  var v = requireAes(), y = requireSafeBuffer$2().Buffer, z = requireCipherBase(), ne = requireInherits_browser(), ue = requireGhash(), le = requireBufferXor(), he = requireIncr32();
  function ge(xe, $e) {
    var Ne = 0;
    xe.length !== $e.length && Ne++;
    for (var st = Math.min(xe.length, $e.length), Nr = 0; Nr < st; ++Nr)
      Ne += xe[Nr] ^ $e[Nr];
    return Ne;
  }
  function we(xe, $e, Ne) {
    if ($e.length === 12)
      return xe._finID = y.concat([$e, y.from([0, 0, 0, 1])]), y.concat([$e, y.from([0, 0, 0, 2])]);
    var st = new ue(Ne), Nr = $e.length, br = Nr % 16;
    st.update($e), br && (br = 16 - br, st.update(y.alloc(br, 0))), st.update(y.alloc(8, 0));
    var $n = Nr * 8, En = y.alloc(8);
    En.writeUIntBE($n, 0, 8), st.update(En), xe._finID = st.state;
    var Rn = y.from(xe._finID);
    return he(Rn), Rn;
  }
  function Ee(xe, $e, Ne, st) {
    z.call(this);
    var Nr = y.alloc(4, 0);
    this._cipher = new v.AES($e);
    var br = this._cipher.encryptBlock(Nr);
    this._ghash = new ue(br), Ne = we(this, Ne, br), this._prev = y.from(Ne), this._cache = y.allocUnsafe(0), this._secCache = y.allocUnsafe(0), this._decrypt = st, this._alen = 0, this._len = 0, this._mode = xe, this._authTag = null, this._called = !1;
  }
  return ne(Ee, z), Ee.prototype._update = function(xe) {
    if (!this._called && this._alen) {
      var $e = 16 - this._alen % 16;
      $e < 16 && ($e = y.alloc($e, 0), this._ghash.update($e));
    }
    this._called = !0;
    var Ne = this._mode.encrypt(this, xe);
    return this._decrypt ? this._ghash.update(xe) : this._ghash.update(Ne), this._len += xe.length, Ne;
  }, Ee.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var xe = le(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && ge(xe, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = xe, this._cipher.scrub();
  }, Ee.prototype.getAuthTag = function() {
    if (this._decrypt || !y.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, Ee.prototype.setAuthTag = function($e) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = $e;
  }, Ee.prototype.setAAD = function($e) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update($e), this._alen += $e.length;
  }, authCipher = Ee, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher)
    return streamCipher;
  hasRequiredStreamCipher = 1;
  var v = requireAes(), y = requireSafeBuffer$2().Buffer, z = requireCipherBase(), ne = requireInherits_browser();
  function ue(le, he, ge, we) {
    z.call(this), this._cipher = new v.AES(he), this._prev = y.from(ge), this._cache = y.allocUnsafe(0), this._secCache = y.allocUnsafe(0), this._decrypt = we, this._mode = le;
  }
  return ne(ue, z), ue.prototype._update = function(le) {
    return this._mode.encrypt(this, le, this._decrypt);
  }, ue.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = ue, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey)
    return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireMd5_js();
  function z(ne, ue, le, he) {
    if (v.isBuffer(ne) || (ne = v.from(ne, "binary")), ue && (v.isBuffer(ue) || (ue = v.from(ue, "binary")), ue.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var ge = le / 8, we = v.alloc(ge), Ee = v.alloc(he || 0), xe = v.alloc(0); ge > 0 || he > 0; ) {
      var $e = new y();
      $e.update(xe), $e.update(ne), ue && $e.update(ue), xe = $e.digest();
      var Ne = 0;
      if (ge > 0) {
        var st = we.length - ge;
        Ne = Math.min(ge, xe.length), xe.copy(we, st, 0, Ne), ge -= Ne;
      }
      if (Ne < xe.length && he > 0) {
        var Nr = Ee.length - he, br = Math.min(he, xe.length - Ne);
        xe.copy(Ee, Nr, Ne, Ne + br), he -= br;
      }
    }
    return xe.fill(0), { key: we, iv: Ee };
  }
  return evp_bytestokey = z, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter)
    return encrypter;
  hasRequiredEncrypter = 1;
  var v = requireModes$1(), y = requireAuthCipher(), z = requireSafeBuffer$2().Buffer, ne = requireStreamCipher(), ue = requireCipherBase(), le = requireAes(), he = requireEvp_bytestokey(), ge = requireInherits_browser();
  function we(st, Nr, br) {
    ue.call(this), this._cache = new xe(), this._cipher = new le.AES(Nr), this._prev = z.from(br), this._mode = st, this._autopadding = !0;
  }
  ge(we, ue), we.prototype._update = function(st) {
    this._cache.add(st);
    for (var Nr, br, $n = []; Nr = this._cache.get(); )
      br = this._mode.encrypt(this, Nr), $n.push(br);
    return z.concat($n);
  };
  var Ee = z.alloc(16, 16);
  we.prototype._final = function() {
    var st = this._cache.flush();
    if (this._autopadding)
      return st = this._mode.encrypt(this, st), this._cipher.scrub(), st;
    if (!st.equals(Ee))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, we.prototype.setAutoPadding = function(st) {
    return this._autopadding = !!st, this;
  };
  function xe() {
    this.cache = z.allocUnsafe(0);
  }
  xe.prototype.add = function(st) {
    this.cache = z.concat([this.cache, st]);
  }, xe.prototype.get = function() {
    if (this.cache.length > 15) {
      var st = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), st;
    }
    return null;
  }, xe.prototype.flush = function() {
    for (var st = 16 - this.cache.length, Nr = z.allocUnsafe(st), br = -1; ++br < st; )
      Nr.writeUInt8(st, br);
    return z.concat([this.cache, Nr]);
  };
  function $e(st, Nr, br) {
    var $n = v[st.toLowerCase()];
    if (!$n)
      throw new TypeError("invalid suite type");
    if (typeof Nr == "string" && (Nr = z.from(Nr)), Nr.length !== $n.key / 8)
      throw new TypeError("invalid key length " + Nr.length);
    if (typeof br == "string" && (br = z.from(br)), $n.mode !== "GCM" && br.length !== $n.iv)
      throw new TypeError("invalid iv length " + br.length);
    return $n.type === "stream" ? new ne($n.module, Nr, br) : $n.type === "auth" ? new y($n.module, Nr, br) : new we($n.module, Nr, br);
  }
  function Ne(st, Nr) {
    var br = v[st.toLowerCase()];
    if (!br)
      throw new TypeError("invalid suite type");
    var $n = he(Nr, !1, br.key, br.iv);
    return $e(st, $n.key, $n.iv);
  }
  return encrypter.createCipheriv = $e, encrypter.createCipher = Ne, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter)
    return decrypter;
  hasRequiredDecrypter = 1;
  var v = requireAuthCipher(), y = requireSafeBuffer$2().Buffer, z = requireModes$1(), ne = requireStreamCipher(), ue = requireCipherBase(), le = requireAes(), he = requireEvp_bytestokey(), ge = requireInherits_browser();
  function we(st, Nr, br) {
    ue.call(this), this._cache = new Ee(), this._last = void 0, this._cipher = new le.AES(Nr), this._prev = y.from(br), this._mode = st, this._autopadding = !0;
  }
  ge(we, ue), we.prototype._update = function(st) {
    this._cache.add(st);
    for (var Nr, br, $n = []; Nr = this._cache.get(this._autopadding); )
      br = this._mode.decrypt(this, Nr), $n.push(br);
    return y.concat($n);
  }, we.prototype._final = function() {
    var st = this._cache.flush();
    if (this._autopadding)
      return xe(this._mode.decrypt(this, st));
    if (st)
      throw new Error("data not multiple of block length");
  }, we.prototype.setAutoPadding = function(st) {
    return this._autopadding = !!st, this;
  };
  function Ee() {
    this.cache = y.allocUnsafe(0);
  }
  Ee.prototype.add = function(st) {
    this.cache = y.concat([this.cache, st]);
  }, Ee.prototype.get = function(st) {
    var Nr;
    if (st) {
      if (this.cache.length > 16)
        return Nr = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Nr;
    } else if (this.cache.length >= 16)
      return Nr = this.cache.slice(0, 16), this.cache = this.cache.slice(16), Nr;
    return null;
  }, Ee.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function xe(st) {
    var Nr = st[15];
    if (Nr < 1 || Nr > 16)
      throw new Error("unable to decrypt data");
    for (var br = -1; ++br < Nr; )
      if (st[br + (16 - Nr)] !== Nr)
        throw new Error("unable to decrypt data");
    if (Nr !== 16)
      return st.slice(0, 16 - Nr);
  }
  function $e(st, Nr, br) {
    var $n = z[st.toLowerCase()];
    if (!$n)
      throw new TypeError("invalid suite type");
    if (typeof br == "string" && (br = y.from(br)), $n.mode !== "GCM" && br.length !== $n.iv)
      throw new TypeError("invalid iv length " + br.length);
    if (typeof Nr == "string" && (Nr = y.from(Nr)), Nr.length !== $n.key / 8)
      throw new TypeError("invalid key length " + Nr.length);
    return $n.type === "stream" ? new ne($n.module, Nr, br, !0) : $n.type === "auth" ? new v($n.module, Nr, br, !0) : new we($n.module, Nr, br);
  }
  function Ne(st, Nr) {
    var br = z[st.toLowerCase()];
    if (!br)
      throw new TypeError("invalid suite type");
    var $n = he(Nr, !1, br.key, br.iv);
    return $e(st, $n.key, $n.iv);
  }
  return decrypter.createDecipher = Ne, decrypter.createDecipheriv = $e, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6)
    return browser$6;
  hasRequiredBrowser$6 = 1;
  var v = requireEncrypter(), y = requireDecrypter(), z = require$$2;
  function ne() {
    return Object.keys(z);
  }
  return browser$6.createCipher = browser$6.Cipher = v.createCipher, browser$6.createCipheriv = browser$6.Cipheriv = v.createCipheriv, browser$6.createDecipher = browser$6.Decipher = y.createDecipher, browser$6.createDecipheriv = browser$6.Decipheriv = y.createDecipheriv, browser$6.listCiphers = browser$6.getCiphers = ne, browser$6;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(v) {
    v["des-ecb"] = {
      key: 8,
      iv: 0
    }, v["des-cbc"] = v.des = {
      key: 8,
      iv: 8
    }, v["des-ede3-cbc"] = v.des3 = {
      key: 24,
      iv: 8
    }, v["des-ede3"] = {
      key: 24,
      iv: 0
    }, v["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, v["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5)
    return browser$7;
  hasRequiredBrowser$5 = 1;
  var v = requireBrowserifyDes(), y = requireBrowser$6(), z = requireModes$1(), ne = requireModes(), ue = requireEvp_bytestokey();
  function le(xe, $e) {
    xe = xe.toLowerCase();
    var Ne, st;
    if (z[xe])
      Ne = z[xe].key, st = z[xe].iv;
    else if (ne[xe])
      Ne = ne[xe].key * 8, st = ne[xe].iv;
    else
      throw new TypeError("invalid suite type");
    var Nr = ue($e, !1, Ne, st);
    return ge(xe, Nr.key, Nr.iv);
  }
  function he(xe, $e) {
    xe = xe.toLowerCase();
    var Ne, st;
    if (z[xe])
      Ne = z[xe].key, st = z[xe].iv;
    else if (ne[xe])
      Ne = ne[xe].key * 8, st = ne[xe].iv;
    else
      throw new TypeError("invalid suite type");
    var Nr = ue($e, !1, Ne, st);
    return we(xe, Nr.key, Nr.iv);
  }
  function ge(xe, $e, Ne) {
    if (xe = xe.toLowerCase(), z[xe])
      return y.createCipheriv(xe, $e, Ne);
    if (ne[xe])
      return new v({ key: $e, iv: Ne, mode: xe });
    throw new TypeError("invalid suite type");
  }
  function we(xe, $e, Ne) {
    if (xe = xe.toLowerCase(), z[xe])
      return y.createDecipheriv(xe, $e, Ne);
    if (ne[xe])
      return new v({ key: $e, iv: Ne, mode: xe, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function Ee() {
    return Object.keys(ne).concat(y.getCiphers());
  }
  return browser$7.createCipher = browser$7.Cipher = le, browser$7.createCipheriv = browser$7.Cipheriv = ge, browser$7.createDecipher = browser$7.Decipher = he, browser$7.createDecipheriv = browser$7.Decipheriv = we, browser$7.listCiphers = browser$7.getCiphers = Ee, browser$7;
}
var browser$5 = {}, bn$6 = { exports: {} };
bn$6.exports;
var hasRequiredBn$4;
function requireBn$4() {
  return hasRequiredBn$4 || (hasRequiredBn$4 = 1, function(v) {
    (function(y, z) {
      function ne(ct, fe) {
        if (!ct)
          throw new Error(fe || "Assertion failed");
      }
      function ue(ct, fe) {
        ct.super_ = fe;
        var be = function() {
        };
        be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
      }
      function le(ct, fe, be) {
        if (le.isBN(ct))
          return ct;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
      }
      typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
      var he;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
      } catch {
      }
      le.isBN = function(fe) {
        return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
      }, le.max = function(fe, be) {
        return fe.cmp(be) > 0 ? fe : be;
      }, le.min = function(fe, be) {
        return fe.cmp(be) < 0 ? fe : be;
      }, le.prototype._init = function(fe, be, ye) {
        if (typeof fe == "number")
          return this._initNumber(fe, be, ye);
        if (typeof fe == "object")
          return this._initArray(fe, be, ye);
        be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
        var Se = 0;
        fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
      }, le.prototype._initNumber = function(fe, be, ye) {
        fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863
        ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863,
          1
        ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
      }, le.prototype._initArray = function(fe, be, ye) {
        if (ne(typeof fe.length == "number"), fe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe, Fr, zn = 0;
        if (ye === "be")
          for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
            Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        else if (ye === "le")
          for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
            Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        return this.strip();
      };
      function ge(ct, fe) {
        var be = ct.charCodeAt(fe);
        return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
      }
      function we(ct, fe, be) {
        var ye = ge(ct, be);
        return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
      }
      le.prototype._parseHex = function(fe, be, ye) {
        this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe = 0, Fr = 0, zn;
        if (ye === "be")
          for (Se = fe.length - 1; Se >= be; Se -= 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        else {
          var Fe = fe.length - be;
          for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        }
        this.strip();
      };
      function Ee(ct, fe, be, ye) {
        for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
          var zn = ct.charCodeAt(Fr) - 48;
          Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
        }
        return Se;
      }
      le.prototype._parseBase = function(fe, be, ye) {
        this.words = [0], this.length = 1;
        for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
          Se++;
        Se--, Oe = Oe / be | 0;
        for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
          pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        if (zn !== 0) {
          var xa = 1;
          for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
            xa *= be;
          this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        }
        this.strip();
      }, le.prototype.copy = function(fe) {
        fe.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          fe.words[be] = this.words[be];
        fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
      }, le.prototype.clone = function() {
        var fe = new le(null);
        return this.copy(fe), fe;
      }, le.prototype._expand = function(fe) {
        for (; this.length < fe; )
          this.words[this.length++] = 0;
        return this;
      }, le.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, le.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, le.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var xe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $e = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ne = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      le.prototype.toString = function(fe, be) {
        fe = fe || 10, be = be | 0 || 1;
        var ye;
        if (fe === 16 || fe === "hex") {
          ye = "";
          for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
            var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
            Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
          }
          for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
          var pe = $e[fe], it = Ne[fe];
          ye = "";
          var xa = this.clone();
          for (xa.negative = 0; !xa.isZero(); ) {
            var wo = xa.modn(it).toString(fe);
            xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
          }
          for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        ne(!1, "Base should be between 2 and 36");
      }, le.prototype.toNumber = function() {
        var fe = this.words[0];
        return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
      }, le.prototype.toJSON = function() {
        return this.toString(16);
      }, le.prototype.toBuffer = function(fe, be) {
        return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
      }, le.prototype.toArray = function(fe, be) {
        return this.toArrayLike(Array, fe, be);
      }, le.prototype.toArrayLike = function(fe, be, ye) {
        var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
        ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
        var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
        if (Fr) {
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
          for (; pe < Oe; pe++)
            zn[pe] = 0;
        } else {
          for (pe = 0; pe < Oe - Se; pe++)
            zn[pe] = 0;
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
        }
        return zn;
      }, Math.clz32 ? le.prototype._countBits = function(fe) {
        return 32 - Math.clz32(fe);
      } : le.prototype._countBits = function(fe) {
        var be = fe, ye = 0;
        return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
      }, le.prototype._zeroBits = function(fe) {
        if (fe === 0)
          return 26;
        var be = fe, ye = 0;
        return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
      }, le.prototype.bitLength = function() {
        var fe = this.words[this.length - 1], be = this._countBits(fe);
        return (this.length - 1) * 26 + be;
      };
      function st(ct) {
        for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
          var ye = be / 26 | 0, Se = be % 26;
          fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
        }
        return fe;
      }
      le.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var fe = 0, be = 0; be < this.length; be++) {
          var ye = this._zeroBits(this.words[be]);
          if (fe += ye, ye !== 26)
            break;
        }
        return fe;
      }, le.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, le.prototype.toTwos = function(fe) {
        return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
      }, le.prototype.fromTwos = function(fe) {
        return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
      }, le.prototype.isNeg = function() {
        return this.negative !== 0;
      }, le.prototype.neg = function() {
        return this.clone().ineg();
      }, le.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, le.prototype.iuor = function(fe) {
        for (; this.length < fe.length; )
          this.words[this.length++] = 0;
        for (var be = 0; be < fe.length; be++)
          this.words[be] = this.words[be] | fe.words[be];
        return this.strip();
      }, le.prototype.ior = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuor(fe);
      }, le.prototype.or = function(fe) {
        return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
      }, le.prototype.uor = function(fe) {
        return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
      }, le.prototype.iuand = function(fe) {
        var be;
        this.length > fe.length ? be = fe : be = this;
        for (var ye = 0; ye < be.length; ye++)
          this.words[ye] = this.words[ye] & fe.words[ye];
        return this.length = be.length, this.strip();
      }, le.prototype.iand = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuand(fe);
      }, le.prototype.and = function(fe) {
        return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
      }, le.prototype.uand = function(fe) {
        return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
      }, le.prototype.iuxor = function(fe) {
        var be, ye;
        this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
        for (var Se = 0; Se < ye.length; Se++)
          this.words[Se] = be.words[Se] ^ ye.words[Se];
        if (this !== be)
          for (; Se < be.length; Se++)
            this.words[Se] = be.words[Se];
        return this.length = be.length, this.strip();
      }, le.prototype.ixor = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
      }, le.prototype.xor = function(fe) {
        return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
      }, le.prototype.uxor = function(fe) {
        return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
      }, le.prototype.inotn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
        this._expand(be), ye > 0 && be--;
        for (var Se = 0; Se < be; Se++)
          this.words[Se] = ~this.words[Se] & 67108863;
        return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
      }, le.prototype.notn = function(fe) {
        return this.clone().inotn(fe);
      }, le.prototype.setn = function(fe, be) {
        ne(typeof fe == "number" && fe >= 0);
        var ye = fe / 26 | 0, Se = fe % 26;
        return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
      }, le.prototype.iadd = function(fe) {
        var be;
        if (this.negative !== 0 && fe.negative === 0)
          return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && fe.negative !== 0)
          return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
        var ye, Se;
        this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
        for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
          be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        for (; Oe !== 0 && Fr < ye.length; Fr++)
          be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        if (this.length = ye.length, Oe !== 0)
          this.words[this.length] = Oe, this.length++;
        else if (ye !== this)
          for (; Fr < ye.length; Fr++)
            this.words[Fr] = ye.words[Fr];
        return this;
      }, le.prototype.add = function(fe) {
        var be;
        return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
      }, le.prototype.isub = function(fe) {
        if (fe.negative !== 0) {
          fe.negative = 0;
          var be = this.iadd(fe);
          return fe.negative = 1, be._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
        var ye = this.cmp(fe);
        if (ye === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Se, Oe;
        ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
        for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
          be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        for (; Fr !== 0 && zn < Se.length; zn++)
          be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        if (Fr === 0 && zn < Se.length && Se !== this)
          for (; zn < Se.length; zn++)
            this.words[zn] = Se.words[zn];
        return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
      }, le.prototype.sub = function(fe) {
        return this.clone().isub(fe);
      };
      function Nr(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative;
        var ye = ct.length + fe.length | 0;
        be.length = ye, ye = ye - 1 | 0;
        var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
        be.words[0] = zn;
        for (var pe = 1; pe < ye; pe++) {
          for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
            var Oa = pe - _u | 0;
            Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
          }
          be.words[pe] = xa | 0, Fe = it | 0;
        }
        return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
      }
      var br = function(fe, be, ye) {
        var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
        ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
        var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
        var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
        var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
        var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
        var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
        var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
        var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
        var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
        var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
        var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
        var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
        var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
        var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
        var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
        var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
        var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
        var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
        var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
        var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
      };
      Math.imul || (br = Nr);
      function $n(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
        for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
          var Fr = Se;
          Se = 0;
          for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
            var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
            Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
          }
          be.words[Oe] = zn, ye = Fr, Fr = Se;
        }
        return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
      }
      function En(ct, fe, be) {
        var ye = new Rn();
        return ye.mulp(ct, fe, be);
      }
      le.prototype.mulTo = function(fe, be) {
        var ye, Se = this.length + fe.length;
        return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
      };
      function Rn(ct, fe) {
        this.x = ct, this.y = fe;
      }
      Rn.prototype.makeRBT = function(fe) {
        for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
          be[Se] = this.revBin(Se, ye, fe);
        return be;
      }, Rn.prototype.revBin = function(fe, be, ye) {
        if (fe === 0 || fe === ye - 1)
          return fe;
        for (var Se = 0, Oe = 0; Oe < be; Oe++)
          Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
        return Se;
      }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
        for (var zn = 0; zn < Fr; zn++)
          Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
      }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
        this.permute(Fr, fe, be, ye, Se, Oe);
        for (var zn = 1; zn < Oe; zn <<= 1)
          for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
            for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
              var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
              Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
            }
      }, Rn.prototype.guessLen13b = function(fe, be) {
        var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
        for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
          Oe++;
        return 1 << Oe + 1 + Se;
      }, Rn.prototype.conjugate = function(fe, be, ye) {
        if (!(ye <= 1))
          for (var Se = 0; Se < ye / 2; Se++) {
            var Oe = fe[Se];
            fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
          }
      }, Rn.prototype.normalize13b = function(fe, be) {
        for (var ye = 0, Se = 0; Se < be / 2; Se++) {
          var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
          fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
        }
        return fe;
      }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
        for (var Oe = 0, Fr = 0; Fr < be; Fr++)
          Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
        for (Fr = 2 * be; Fr < Se; ++Fr)
          ye[Fr] = 0;
        ne(Oe === 0), ne((Oe & -8192) === 0);
      }, Rn.prototype.stub = function(fe) {
        for (var be = new Array(fe), ye = 0; ye < fe; ye++)
          be[ye] = 0;
        return be;
      }, Rn.prototype.mulp = function(fe, be, ye) {
        var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
        _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
        for (var Oa = 0; Oa < Se; Oa++) {
          var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
          pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
        }
        return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
      }, le.prototype.mul = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
      }, le.prototype.mulf = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), En(this, fe, be);
      }, le.prototype.imul = function(fe) {
        return this.clone().mulTo(fe, this);
      }, le.prototype.imuln = function(fe) {
        ne(typeof fe == "number"), ne(fe < 67108864);
        for (var be = 0, ye = 0; ye < this.length; ye++) {
          var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
          be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
        }
        return be !== 0 && (this.words[ye] = be, this.length++), this;
      }, le.prototype.muln = function(fe) {
        return this.clone().imuln(fe);
      }, le.prototype.sqr = function() {
        return this.mul(this);
      }, le.prototype.isqr = function() {
        return this.imul(this.clone());
      }, le.prototype.pow = function(fe) {
        var be = st(fe);
        if (be.length === 0)
          return new le(1);
        for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
          ;
        if (++Se < be.length)
          for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
            be[Se] !== 0 && (ye = ye.mul(Oe));
        return ye;
      }, le.prototype.iushln = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
        if (be !== 0) {
          var Fr = 0;
          for (Oe = 0; Oe < this.length; Oe++) {
            var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
            this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
          }
          Fr && (this.words[Oe] = Fr, this.length++);
        }
        if (ye !== 0) {
          for (Oe = this.length - 1; Oe >= 0; Oe--)
            this.words[Oe + ye] = this.words[Oe];
          for (Oe = 0; Oe < ye; Oe++)
            this.words[Oe] = 0;
          this.length += ye;
        }
        return this.strip();
      }, le.prototype.ishln = function(fe) {
        return ne(this.negative === 0), this.iushln(fe);
      }, le.prototype.iushrn = function(fe, be, ye) {
        ne(typeof fe == "number" && fe >= 0);
        var Se;
        be ? Se = (be - be % 26) / 26 : Se = 0;
        var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
        if (Se -= Fr, Se = Math.max(0, Se), Fe) {
          for (var pe = 0; pe < Fr; pe++)
            Fe.words[pe] = this.words[pe];
          Fe.length = Fr;
        }
        if (Fr !== 0)
          if (this.length > Fr)
            for (this.length -= Fr, pe = 0; pe < this.length; pe++)
              this.words[pe] = this.words[pe + Fr];
          else
            this.words[0] = 0, this.length = 1;
        var it = 0;
        for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
          var xa = this.words[pe] | 0;
          this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
        }
        return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, le.prototype.ishrn = function(fe, be, ye) {
        return ne(this.negative === 0), this.iushrn(fe, be, ye);
      }, le.prototype.shln = function(fe) {
        return this.clone().ishln(fe);
      }, le.prototype.ushln = function(fe) {
        return this.clone().iushln(fe);
      }, le.prototype.shrn = function(fe) {
        return this.clone().ishrn(fe);
      }, le.prototype.ushrn = function(fe) {
        return this.clone().iushrn(fe);
      }, le.prototype.testn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return !1;
        var Oe = this.words[ye];
        return !!(Oe & Se);
      }, le.prototype.imaskn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26;
        if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
          return this;
        if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
          var Se = 67108863 ^ 67108863 >>> be << be;
          this.words[this.length - 1] &= Se;
        }
        return this.strip();
      }, le.prototype.maskn = function(fe) {
        return this.clone().imaskn(fe);
      }, le.prototype.iaddn = function(fe) {
        return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
      }, le.prototype._iaddn = function(fe) {
        this.words[0] += fe;
        for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
          this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
        return this.length = Math.max(this.length, be + 1), this;
      }, le.prototype.isubn = function(fe) {
        if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
          return this.iaddn(-fe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
        if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var be = 0; be < this.length && this.words[be] < 0; be++)
            this.words[be] += 67108864, this.words[be + 1] -= 1;
        return this.strip();
      }, le.prototype.addn = function(fe) {
        return this.clone().iaddn(fe);
      }, le.prototype.subn = function(fe) {
        return this.clone().isubn(fe);
      }, le.prototype.iabs = function() {
        return this.negative = 0, this;
      }, le.prototype.abs = function() {
        return this.clone().iabs();
      }, le.prototype._ishlnsubmul = function(fe, be, ye) {
        var Se = fe.length + ye, Oe;
        this._expand(Se);
        var Fr, zn = 0;
        for (Oe = 0; Oe < fe.length; Oe++) {
          Fr = (this.words[Oe + ye] | 0) + zn;
          var Fe = (fe.words[Oe] | 0) * be;
          Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
        }
        for (; Oe < this.length - ye; Oe++)
          Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
        if (zn === 0)
          return this.strip();
        for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
          Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
        return this.negative = 1, this.strip();
      }, le.prototype._wordDiv = function(fe, be) {
        var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
        ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
        var Fe = Se.length - Oe.length, pe;
        if (be !== "mod") {
          pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
          for (var it = 0; it < pe.length; it++)
            pe.words[it] = 0;
        }
        var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
        xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
        for (var wo = Fe - 1; wo >= 0; wo--) {
          var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
          for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
            _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
          pe && (pe.words[wo] = _u);
        }
        return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
          div: pe || null,
          mod: Se
        };
      }, le.prototype.divmod = function(fe, be, ye) {
        if (ne(!fe.isZero()), this.isZero())
          return {
            div: new le(0),
            mod: new le(0)
          };
        var Se, Oe, Fr;
        return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
          div: Se,
          mod: Oe
        }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
          div: Se,
          mod: Fr.mod
        }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
          div: Fr.div,
          mod: Oe
        }) : fe.length > this.length || this.cmp(fe) < 0 ? {
          div: new le(0),
          mod: this
        } : fe.length === 1 ? be === "div" ? {
          div: this.divn(fe.words[0]),
          mod: null
        } : be === "mod" ? {
          div: null,
          mod: new le(this.modn(fe.words[0]))
        } : {
          div: this.divn(fe.words[0]),
          mod: new le(this.modn(fe.words[0]))
        } : this._wordDiv(fe, be);
      }, le.prototype.div = function(fe) {
        return this.divmod(fe, "div", !1).div;
      }, le.prototype.mod = function(fe) {
        return this.divmod(fe, "mod", !1).mod;
      }, le.prototype.umod = function(fe) {
        return this.divmod(fe, "mod", !0).mod;
      }, le.prototype.divRound = function(fe) {
        var be = this.divmod(fe);
        if (be.mod.isZero())
          return be.div;
        var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
        return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
      }, le.prototype.modn = function(fe) {
        ne(fe <= 67108863);
        for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
          ye = (be * ye + (this.words[Se] | 0)) % fe;
        return ye;
      }, le.prototype.idivn = function(fe) {
        ne(fe <= 67108863);
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = (this.words[ye] | 0) + be * 67108864;
          this.words[ye] = Se / fe | 0, be = Se % fe;
        }
        return this.strip();
      }, le.prototype.divn = function(fe) {
        return this.clone().idivn(fe);
      }, le.prototype.egcd = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
          be.iushrn(1), ye.iushrn(1), ++Fe;
        for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
          for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
            ;
          if (xa > 0)
            for (be.iushrn(xa); xa-- > 0; )
              (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
          for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
            ;
          if (_u > 0)
            for (ye.iushrn(_u); _u-- > 0; )
              (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
        }
        return {
          a: Fr,
          b: zn,
          gcd: ye.iushln(Fe)
        };
      }, le.prototype._invmp = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
          for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
            ;
          if (zn > 0)
            for (be.iushrn(zn); zn-- > 0; )
              Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
          for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
            ;
          if (pe > 0)
            for (ye.iushrn(pe); pe-- > 0; )
              Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
        }
        var xa;
        return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
      }, le.prototype.gcd = function(fe) {
        if (this.isZero())
          return fe.abs();
        if (fe.isZero())
          return this.abs();
        var be = this.clone(), ye = fe.clone();
        be.negative = 0, ye.negative = 0;
        for (var Se = 0; be.isEven() && ye.isEven(); Se++)
          be.iushrn(1), ye.iushrn(1);
        do {
          for (; be.isEven(); )
            be.iushrn(1);
          for (; ye.isEven(); )
            ye.iushrn(1);
          var Oe = be.cmp(ye);
          if (Oe < 0) {
            var Fr = be;
            be = ye, ye = Fr;
          } else if (Oe === 0 || ye.cmpn(1) === 0)
            break;
          be.isub(ye);
        } while (!0);
        return ye.iushln(Se);
      }, le.prototype.invm = function(fe) {
        return this.egcd(fe).a.umod(fe);
      }, le.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, le.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, le.prototype.andln = function(fe) {
        return this.words[0] & fe;
      }, le.prototype.bincn = function(fe) {
        ne(typeof fe == "number");
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return this._expand(ye + 1), this.words[ye] |= Se, this;
        for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
          var zn = this.words[Fr] | 0;
          zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
        }
        return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
      }, le.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, le.prototype.cmpn = function(fe) {
        var be = fe < 0;
        if (this.negative !== 0 && !be)
          return -1;
        if (this.negative === 0 && be)
          return 1;
        this.strip();
        var ye;
        if (this.length > 1)
          ye = 1;
        else {
          be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
          var Se = this.words[0] | 0;
          ye = Se === fe ? 0 : Se < fe ? -1 : 1;
        }
        return this.negative !== 0 ? -ye | 0 : ye;
      }, le.prototype.cmp = function(fe) {
        if (this.negative !== 0 && fe.negative === 0)
          return -1;
        if (this.negative === 0 && fe.negative !== 0)
          return 1;
        var be = this.ucmp(fe);
        return this.negative !== 0 ? -be | 0 : be;
      }, le.prototype.ucmp = function(fe) {
        if (this.length > fe.length)
          return 1;
        if (this.length < fe.length)
          return -1;
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
          if (Se !== Oe) {
            Se < Oe ? be = -1 : Se > Oe && (be = 1);
            break;
          }
        }
        return be;
      }, le.prototype.gtn = function(fe) {
        return this.cmpn(fe) === 1;
      }, le.prototype.gt = function(fe) {
        return this.cmp(fe) === 1;
      }, le.prototype.gten = function(fe) {
        return this.cmpn(fe) >= 0;
      }, le.prototype.gte = function(fe) {
        return this.cmp(fe) >= 0;
      }, le.prototype.ltn = function(fe) {
        return this.cmpn(fe) === -1;
      }, le.prototype.lt = function(fe) {
        return this.cmp(fe) === -1;
      }, le.prototype.lten = function(fe) {
        return this.cmpn(fe) <= 0;
      }, le.prototype.lte = function(fe) {
        return this.cmp(fe) <= 0;
      }, le.prototype.eqn = function(fe) {
        return this.cmpn(fe) === 0;
      }, le.prototype.eq = function(fe) {
        return this.cmp(fe) === 0;
      }, le.red = function(fe) {
        return new Yn(fe);
      }, le.prototype.toRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
      }, le.prototype.fromRed = function() {
        return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, le.prototype._forceRed = function(fe) {
        return this.red = fe, this;
      }, le.prototype.forceRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
      }, le.prototype.redAdd = function(fe) {
        return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
      }, le.prototype.redIAdd = function(fe) {
        return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
      }, le.prototype.redSub = function(fe) {
        return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
      }, le.prototype.redISub = function(fe) {
        return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
      }, le.prototype.redShl = function(fe) {
        return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
      }, le.prototype.redMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
      }, le.prototype.redIMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
      }, le.prototype.redSqr = function() {
        return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, le.prototype.redISqr = function() {
        return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, le.prototype.redSqrt = function() {
        return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, le.prototype.redInvm = function() {
        return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, le.prototype.redNeg = function() {
        return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, le.prototype.redPow = function(fe) {
        return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
      };
      var wa = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Aa(ct, fe) {
        this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Aa.prototype._tmp = function() {
        var fe = new le(null);
        return fe.words = new Array(Math.ceil(this.n / 13)), fe;
      }, Aa.prototype.ireduce = function(fe) {
        var be = fe, ye;
        do
          this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
        while (ye > this.n);
        var Se = ye < this.n ? -1 : be.ucmp(this.p);
        return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
      }, Aa.prototype.split = function(fe, be) {
        fe.iushrn(this.n, 0, be);
      }, Aa.prototype.imulK = function(fe) {
        return fe.imul(this.k);
      };
      function _a() {
        Aa.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      ue(_a, Aa), _a.prototype.split = function(fe, be) {
        for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
          be.words[Oe] = fe.words[Oe];
        if (be.length = Se, fe.length <= 9) {
          fe.words[0] = 0, fe.length = 1;
          return;
        }
        var Fr = fe.words[9];
        for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
          var zn = fe.words[Oe] | 0;
          fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
        }
        Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
      }, _a.prototype.imulK = function(fe) {
        fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = fe.words[ye] | 0;
          be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
        }
        return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
      };
      function Ta() {
        Aa.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      ue(Ta, Aa);
      function Zn() {
        Aa.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      ue(Zn, Aa);
      function Ra() {
        Aa.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
          Se >>>= 26, fe.words[ye] = Oe, be = Se;
        }
        return be !== 0 && (fe.words[fe.length++] = be), fe;
      }, le._prime = function(fe) {
        if (wa[fe])
          return wa[fe];
        var be;
        if (fe === "k256")
          be = new _a();
        else if (fe === "p224")
          be = new Ta();
        else if (fe === "p192")
          be = new Zn();
        else if (fe === "p25519")
          be = new Ra();
        else
          throw new Error("Unknown prime " + fe);
        return wa[fe] = be, be;
      };
      function Yn(ct) {
        if (typeof ct == "string") {
          var fe = le._prime(ct);
          this.m = fe.p, this.prime = fe;
        } else
          ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
      }
      Yn.prototype._verify1 = function(fe) {
        ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
      }, Yn.prototype._verify2 = function(fe, be) {
        ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
          fe.red && fe.red === be.red,
          "red works only with red numbers"
        );
      }, Yn.prototype.imod = function(fe) {
        return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
      }, Yn.prototype.neg = function(fe) {
        return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
      }, Yn.prototype.add = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.add(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
      }, Yn.prototype.iadd = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.iadd(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
      }, Yn.prototype.sub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.sub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
      }, Yn.prototype.isub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.isub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
      }, Yn.prototype.shl = function(fe, be) {
        return this._verify1(fe), this.imod(fe.ushln(be));
      }, Yn.prototype.imul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.imul(be));
      }, Yn.prototype.mul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.mul(be));
      }, Yn.prototype.isqr = function(fe) {
        return this.imul(fe, fe.clone());
      }, Yn.prototype.sqr = function(fe) {
        return this.mul(fe, fe);
      }, Yn.prototype.sqrt = function(fe) {
        if (fe.isZero())
          return fe.clone();
        var be = this.m.andln(3);
        if (ne(be % 2 === 1), be === 3) {
          var ye = this.m.add(new le(1)).iushrn(2);
          return this.pow(fe, ye);
        }
        for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
          Oe++, Se.iushrn(1);
        ne(!Se.isZero());
        var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
        for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
          pe.redIAdd(zn);
        for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
          for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
            Oa = Oa.redSqr();
          ne(Os < _u);
          var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
          xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
        }
        return xa;
      }, Yn.prototype.invm = function(fe) {
        var be = fe._invmp(this.m);
        return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
      }, Yn.prototype.pow = function(fe, be) {
        if (be.isZero())
          return new le(1).toRed(this);
        if (be.cmpn(1) === 0)
          return fe.clone();
        var ye = 4, Se = new Array(1 << ye);
        Se[0] = new le(1).toRed(this), Se[1] = fe;
        for (var Oe = 2; Oe < Se.length; Oe++)
          Se[Oe] = this.mul(Se[Oe - 1], fe);
        var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
        for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
          for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
            var wo = it >> xa & 1;
            if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
              Fe = 0;
              continue;
            }
            zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
          }
          pe = 26;
        }
        return Fr;
      }, Yn.prototype.convertTo = function(fe) {
        var be = fe.umod(this.m);
        return be === fe ? be.clone() : be;
      }, Yn.prototype.convertFrom = function(fe) {
        var be = fe.clone();
        return be.red = null, be;
      }, le.mont = function(fe) {
        return new $o(fe);
      };
      function $o(ct) {
        Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      ue($o, Yn), $o.prototype.convertTo = function(fe) {
        return this.imod(fe.ushln(this.shift));
      }, $o.prototype.convertFrom = function(fe) {
        var be = this.imod(fe.mul(this.rinv));
        return be.red = null, be;
      }, $o.prototype.imul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return fe.words[0] = 0, fe.length = 1, fe;
        var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.mul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return new le(0)._forceRed(this);
        var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.invm = function(fe) {
        var be = this.imod(fe._invmp(this.m).mul(this.r2));
        return be._forceRed(this);
      };
    })(v, commonjsGlobal);
  }(bn$6)), bn$6.exports;
}
var bn$5 = { exports: {} };
bn$5.exports;
var hasRequiredBn$3;
function requireBn$3() {
  return hasRequiredBn$3 || (hasRequiredBn$3 = 1, function(v) {
    (function(y, z) {
      function ne(ct, fe) {
        if (!ct)
          throw new Error(fe || "Assertion failed");
      }
      function ue(ct, fe) {
        ct.super_ = fe;
        var be = function() {
        };
        be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
      }
      function le(ct, fe, be) {
        if (le.isBN(ct))
          return ct;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
      }
      typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
      var he;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
      } catch {
      }
      le.isBN = function(fe) {
        return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
      }, le.max = function(fe, be) {
        return fe.cmp(be) > 0 ? fe : be;
      }, le.min = function(fe, be) {
        return fe.cmp(be) < 0 ? fe : be;
      }, le.prototype._init = function(fe, be, ye) {
        if (typeof fe == "number")
          return this._initNumber(fe, be, ye);
        if (typeof fe == "object")
          return this._initArray(fe, be, ye);
        be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
        var Se = 0;
        fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
      }, le.prototype._initNumber = function(fe, be, ye) {
        fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863
        ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863,
          1
        ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
      }, le.prototype._initArray = function(fe, be, ye) {
        if (ne(typeof fe.length == "number"), fe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe, Fr, zn = 0;
        if (ye === "be")
          for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
            Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        else if (ye === "le")
          for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
            Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        return this.strip();
      };
      function ge(ct, fe) {
        var be = ct.charCodeAt(fe);
        return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
      }
      function we(ct, fe, be) {
        var ye = ge(ct, be);
        return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
      }
      le.prototype._parseHex = function(fe, be, ye) {
        this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe = 0, Fr = 0, zn;
        if (ye === "be")
          for (Se = fe.length - 1; Se >= be; Se -= 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        else {
          var Fe = fe.length - be;
          for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        }
        this.strip();
      };
      function Ee(ct, fe, be, ye) {
        for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
          var zn = ct.charCodeAt(Fr) - 48;
          Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
        }
        return Se;
      }
      le.prototype._parseBase = function(fe, be, ye) {
        this.words = [0], this.length = 1;
        for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
          Se++;
        Se--, Oe = Oe / be | 0;
        for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
          pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        if (zn !== 0) {
          var xa = 1;
          for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
            xa *= be;
          this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        }
        this.strip();
      }, le.prototype.copy = function(fe) {
        fe.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          fe.words[be] = this.words[be];
        fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
      }, le.prototype.clone = function() {
        var fe = new le(null);
        return this.copy(fe), fe;
      }, le.prototype._expand = function(fe) {
        for (; this.length < fe; )
          this.words[this.length++] = 0;
        return this;
      }, le.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, le.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, le.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var xe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $e = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ne = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      le.prototype.toString = function(fe, be) {
        fe = fe || 10, be = be | 0 || 1;
        var ye;
        if (fe === 16 || fe === "hex") {
          ye = "";
          for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
            var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
            Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
          }
          for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
          var pe = $e[fe], it = Ne[fe];
          ye = "";
          var xa = this.clone();
          for (xa.negative = 0; !xa.isZero(); ) {
            var wo = xa.modn(it).toString(fe);
            xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
          }
          for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        ne(!1, "Base should be between 2 and 36");
      }, le.prototype.toNumber = function() {
        var fe = this.words[0];
        return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
      }, le.prototype.toJSON = function() {
        return this.toString(16);
      }, le.prototype.toBuffer = function(fe, be) {
        return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
      }, le.prototype.toArray = function(fe, be) {
        return this.toArrayLike(Array, fe, be);
      }, le.prototype.toArrayLike = function(fe, be, ye) {
        var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
        ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
        var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
        if (Fr) {
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
          for (; pe < Oe; pe++)
            zn[pe] = 0;
        } else {
          for (pe = 0; pe < Oe - Se; pe++)
            zn[pe] = 0;
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
        }
        return zn;
      }, Math.clz32 ? le.prototype._countBits = function(fe) {
        return 32 - Math.clz32(fe);
      } : le.prototype._countBits = function(fe) {
        var be = fe, ye = 0;
        return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
      }, le.prototype._zeroBits = function(fe) {
        if (fe === 0)
          return 26;
        var be = fe, ye = 0;
        return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
      }, le.prototype.bitLength = function() {
        var fe = this.words[this.length - 1], be = this._countBits(fe);
        return (this.length - 1) * 26 + be;
      };
      function st(ct) {
        for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
          var ye = be / 26 | 0, Se = be % 26;
          fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
        }
        return fe;
      }
      le.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var fe = 0, be = 0; be < this.length; be++) {
          var ye = this._zeroBits(this.words[be]);
          if (fe += ye, ye !== 26)
            break;
        }
        return fe;
      }, le.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, le.prototype.toTwos = function(fe) {
        return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
      }, le.prototype.fromTwos = function(fe) {
        return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
      }, le.prototype.isNeg = function() {
        return this.negative !== 0;
      }, le.prototype.neg = function() {
        return this.clone().ineg();
      }, le.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, le.prototype.iuor = function(fe) {
        for (; this.length < fe.length; )
          this.words[this.length++] = 0;
        for (var be = 0; be < fe.length; be++)
          this.words[be] = this.words[be] | fe.words[be];
        return this.strip();
      }, le.prototype.ior = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuor(fe);
      }, le.prototype.or = function(fe) {
        return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
      }, le.prototype.uor = function(fe) {
        return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
      }, le.prototype.iuand = function(fe) {
        var be;
        this.length > fe.length ? be = fe : be = this;
        for (var ye = 0; ye < be.length; ye++)
          this.words[ye] = this.words[ye] & fe.words[ye];
        return this.length = be.length, this.strip();
      }, le.prototype.iand = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuand(fe);
      }, le.prototype.and = function(fe) {
        return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
      }, le.prototype.uand = function(fe) {
        return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
      }, le.prototype.iuxor = function(fe) {
        var be, ye;
        this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
        for (var Se = 0; Se < ye.length; Se++)
          this.words[Se] = be.words[Se] ^ ye.words[Se];
        if (this !== be)
          for (; Se < be.length; Se++)
            this.words[Se] = be.words[Se];
        return this.length = be.length, this.strip();
      }, le.prototype.ixor = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
      }, le.prototype.xor = function(fe) {
        return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
      }, le.prototype.uxor = function(fe) {
        return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
      }, le.prototype.inotn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
        this._expand(be), ye > 0 && be--;
        for (var Se = 0; Se < be; Se++)
          this.words[Se] = ~this.words[Se] & 67108863;
        return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
      }, le.prototype.notn = function(fe) {
        return this.clone().inotn(fe);
      }, le.prototype.setn = function(fe, be) {
        ne(typeof fe == "number" && fe >= 0);
        var ye = fe / 26 | 0, Se = fe % 26;
        return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
      }, le.prototype.iadd = function(fe) {
        var be;
        if (this.negative !== 0 && fe.negative === 0)
          return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && fe.negative !== 0)
          return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
        var ye, Se;
        this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
        for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
          be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        for (; Oe !== 0 && Fr < ye.length; Fr++)
          be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        if (this.length = ye.length, Oe !== 0)
          this.words[this.length] = Oe, this.length++;
        else if (ye !== this)
          for (; Fr < ye.length; Fr++)
            this.words[Fr] = ye.words[Fr];
        return this;
      }, le.prototype.add = function(fe) {
        var be;
        return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
      }, le.prototype.isub = function(fe) {
        if (fe.negative !== 0) {
          fe.negative = 0;
          var be = this.iadd(fe);
          return fe.negative = 1, be._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
        var ye = this.cmp(fe);
        if (ye === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Se, Oe;
        ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
        for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
          be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        for (; Fr !== 0 && zn < Se.length; zn++)
          be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        if (Fr === 0 && zn < Se.length && Se !== this)
          for (; zn < Se.length; zn++)
            this.words[zn] = Se.words[zn];
        return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
      }, le.prototype.sub = function(fe) {
        return this.clone().isub(fe);
      };
      function Nr(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative;
        var ye = ct.length + fe.length | 0;
        be.length = ye, ye = ye - 1 | 0;
        var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
        be.words[0] = zn;
        for (var pe = 1; pe < ye; pe++) {
          for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
            var Oa = pe - _u | 0;
            Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
          }
          be.words[pe] = xa | 0, Fe = it | 0;
        }
        return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
      }
      var br = function(fe, be, ye) {
        var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
        ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
        var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
        var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
        var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
        var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
        var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
        var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
        var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
        var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
        var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
        var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
        var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
        var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
        var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
        var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
        var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
        var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
        var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
        var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
        var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
      };
      Math.imul || (br = Nr);
      function $n(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
        for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
          var Fr = Se;
          Se = 0;
          for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
            var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
            Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
          }
          be.words[Oe] = zn, ye = Fr, Fr = Se;
        }
        return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
      }
      function En(ct, fe, be) {
        var ye = new Rn();
        return ye.mulp(ct, fe, be);
      }
      le.prototype.mulTo = function(fe, be) {
        var ye, Se = this.length + fe.length;
        return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
      };
      function Rn(ct, fe) {
        this.x = ct, this.y = fe;
      }
      Rn.prototype.makeRBT = function(fe) {
        for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
          be[Se] = this.revBin(Se, ye, fe);
        return be;
      }, Rn.prototype.revBin = function(fe, be, ye) {
        if (fe === 0 || fe === ye - 1)
          return fe;
        for (var Se = 0, Oe = 0; Oe < be; Oe++)
          Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
        return Se;
      }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
        for (var zn = 0; zn < Fr; zn++)
          Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
      }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
        this.permute(Fr, fe, be, ye, Se, Oe);
        for (var zn = 1; zn < Oe; zn <<= 1)
          for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
            for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
              var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
              Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
            }
      }, Rn.prototype.guessLen13b = function(fe, be) {
        var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
        for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
          Oe++;
        return 1 << Oe + 1 + Se;
      }, Rn.prototype.conjugate = function(fe, be, ye) {
        if (!(ye <= 1))
          for (var Se = 0; Se < ye / 2; Se++) {
            var Oe = fe[Se];
            fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
          }
      }, Rn.prototype.normalize13b = function(fe, be) {
        for (var ye = 0, Se = 0; Se < be / 2; Se++) {
          var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
          fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
        }
        return fe;
      }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
        for (var Oe = 0, Fr = 0; Fr < be; Fr++)
          Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
        for (Fr = 2 * be; Fr < Se; ++Fr)
          ye[Fr] = 0;
        ne(Oe === 0), ne((Oe & -8192) === 0);
      }, Rn.prototype.stub = function(fe) {
        for (var be = new Array(fe), ye = 0; ye < fe; ye++)
          be[ye] = 0;
        return be;
      }, Rn.prototype.mulp = function(fe, be, ye) {
        var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
        _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
        for (var Oa = 0; Oa < Se; Oa++) {
          var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
          pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
        }
        return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
      }, le.prototype.mul = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
      }, le.prototype.mulf = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), En(this, fe, be);
      }, le.prototype.imul = function(fe) {
        return this.clone().mulTo(fe, this);
      }, le.prototype.imuln = function(fe) {
        ne(typeof fe == "number"), ne(fe < 67108864);
        for (var be = 0, ye = 0; ye < this.length; ye++) {
          var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
          be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
        }
        return be !== 0 && (this.words[ye] = be, this.length++), this;
      }, le.prototype.muln = function(fe) {
        return this.clone().imuln(fe);
      }, le.prototype.sqr = function() {
        return this.mul(this);
      }, le.prototype.isqr = function() {
        return this.imul(this.clone());
      }, le.prototype.pow = function(fe) {
        var be = st(fe);
        if (be.length === 0)
          return new le(1);
        for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
          ;
        if (++Se < be.length)
          for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
            be[Se] !== 0 && (ye = ye.mul(Oe));
        return ye;
      }, le.prototype.iushln = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
        if (be !== 0) {
          var Fr = 0;
          for (Oe = 0; Oe < this.length; Oe++) {
            var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
            this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
          }
          Fr && (this.words[Oe] = Fr, this.length++);
        }
        if (ye !== 0) {
          for (Oe = this.length - 1; Oe >= 0; Oe--)
            this.words[Oe + ye] = this.words[Oe];
          for (Oe = 0; Oe < ye; Oe++)
            this.words[Oe] = 0;
          this.length += ye;
        }
        return this.strip();
      }, le.prototype.ishln = function(fe) {
        return ne(this.negative === 0), this.iushln(fe);
      }, le.prototype.iushrn = function(fe, be, ye) {
        ne(typeof fe == "number" && fe >= 0);
        var Se;
        be ? Se = (be - be % 26) / 26 : Se = 0;
        var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
        if (Se -= Fr, Se = Math.max(0, Se), Fe) {
          for (var pe = 0; pe < Fr; pe++)
            Fe.words[pe] = this.words[pe];
          Fe.length = Fr;
        }
        if (Fr !== 0)
          if (this.length > Fr)
            for (this.length -= Fr, pe = 0; pe < this.length; pe++)
              this.words[pe] = this.words[pe + Fr];
          else
            this.words[0] = 0, this.length = 1;
        var it = 0;
        for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
          var xa = this.words[pe] | 0;
          this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
        }
        return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, le.prototype.ishrn = function(fe, be, ye) {
        return ne(this.negative === 0), this.iushrn(fe, be, ye);
      }, le.prototype.shln = function(fe) {
        return this.clone().ishln(fe);
      }, le.prototype.ushln = function(fe) {
        return this.clone().iushln(fe);
      }, le.prototype.shrn = function(fe) {
        return this.clone().ishrn(fe);
      }, le.prototype.ushrn = function(fe) {
        return this.clone().iushrn(fe);
      }, le.prototype.testn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return !1;
        var Oe = this.words[ye];
        return !!(Oe & Se);
      }, le.prototype.imaskn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26;
        if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
          return this;
        if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
          var Se = 67108863 ^ 67108863 >>> be << be;
          this.words[this.length - 1] &= Se;
        }
        return this.strip();
      }, le.prototype.maskn = function(fe) {
        return this.clone().imaskn(fe);
      }, le.prototype.iaddn = function(fe) {
        return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
      }, le.prototype._iaddn = function(fe) {
        this.words[0] += fe;
        for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
          this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
        return this.length = Math.max(this.length, be + 1), this;
      }, le.prototype.isubn = function(fe) {
        if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
          return this.iaddn(-fe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
        if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var be = 0; be < this.length && this.words[be] < 0; be++)
            this.words[be] += 67108864, this.words[be + 1] -= 1;
        return this.strip();
      }, le.prototype.addn = function(fe) {
        return this.clone().iaddn(fe);
      }, le.prototype.subn = function(fe) {
        return this.clone().isubn(fe);
      }, le.prototype.iabs = function() {
        return this.negative = 0, this;
      }, le.prototype.abs = function() {
        return this.clone().iabs();
      }, le.prototype._ishlnsubmul = function(fe, be, ye) {
        var Se = fe.length + ye, Oe;
        this._expand(Se);
        var Fr, zn = 0;
        for (Oe = 0; Oe < fe.length; Oe++) {
          Fr = (this.words[Oe + ye] | 0) + zn;
          var Fe = (fe.words[Oe] | 0) * be;
          Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
        }
        for (; Oe < this.length - ye; Oe++)
          Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
        if (zn === 0)
          return this.strip();
        for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
          Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
        return this.negative = 1, this.strip();
      }, le.prototype._wordDiv = function(fe, be) {
        var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
        ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
        var Fe = Se.length - Oe.length, pe;
        if (be !== "mod") {
          pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
          for (var it = 0; it < pe.length; it++)
            pe.words[it] = 0;
        }
        var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
        xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
        for (var wo = Fe - 1; wo >= 0; wo--) {
          var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
          for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
            _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
          pe && (pe.words[wo] = _u);
        }
        return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
          div: pe || null,
          mod: Se
        };
      }, le.prototype.divmod = function(fe, be, ye) {
        if (ne(!fe.isZero()), this.isZero())
          return {
            div: new le(0),
            mod: new le(0)
          };
        var Se, Oe, Fr;
        return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
          div: Se,
          mod: Oe
        }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
          div: Se,
          mod: Fr.mod
        }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
          div: Fr.div,
          mod: Oe
        }) : fe.length > this.length || this.cmp(fe) < 0 ? {
          div: new le(0),
          mod: this
        } : fe.length === 1 ? be === "div" ? {
          div: this.divn(fe.words[0]),
          mod: null
        } : be === "mod" ? {
          div: null,
          mod: new le(this.modn(fe.words[0]))
        } : {
          div: this.divn(fe.words[0]),
          mod: new le(this.modn(fe.words[0]))
        } : this._wordDiv(fe, be);
      }, le.prototype.div = function(fe) {
        return this.divmod(fe, "div", !1).div;
      }, le.prototype.mod = function(fe) {
        return this.divmod(fe, "mod", !1).mod;
      }, le.prototype.umod = function(fe) {
        return this.divmod(fe, "mod", !0).mod;
      }, le.prototype.divRound = function(fe) {
        var be = this.divmod(fe);
        if (be.mod.isZero())
          return be.div;
        var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
        return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
      }, le.prototype.modn = function(fe) {
        ne(fe <= 67108863);
        for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
          ye = (be * ye + (this.words[Se] | 0)) % fe;
        return ye;
      }, le.prototype.idivn = function(fe) {
        ne(fe <= 67108863);
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = (this.words[ye] | 0) + be * 67108864;
          this.words[ye] = Se / fe | 0, be = Se % fe;
        }
        return this.strip();
      }, le.prototype.divn = function(fe) {
        return this.clone().idivn(fe);
      }, le.prototype.egcd = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
          be.iushrn(1), ye.iushrn(1), ++Fe;
        for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
          for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
            ;
          if (xa > 0)
            for (be.iushrn(xa); xa-- > 0; )
              (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
          for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
            ;
          if (_u > 0)
            for (ye.iushrn(_u); _u-- > 0; )
              (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
        }
        return {
          a: Fr,
          b: zn,
          gcd: ye.iushln(Fe)
        };
      }, le.prototype._invmp = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
          for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
            ;
          if (zn > 0)
            for (be.iushrn(zn); zn-- > 0; )
              Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
          for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
            ;
          if (pe > 0)
            for (ye.iushrn(pe); pe-- > 0; )
              Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
        }
        var xa;
        return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
      }, le.prototype.gcd = function(fe) {
        if (this.isZero())
          return fe.abs();
        if (fe.isZero())
          return this.abs();
        var be = this.clone(), ye = fe.clone();
        be.negative = 0, ye.negative = 0;
        for (var Se = 0; be.isEven() && ye.isEven(); Se++)
          be.iushrn(1), ye.iushrn(1);
        do {
          for (; be.isEven(); )
            be.iushrn(1);
          for (; ye.isEven(); )
            ye.iushrn(1);
          var Oe = be.cmp(ye);
          if (Oe < 0) {
            var Fr = be;
            be = ye, ye = Fr;
          } else if (Oe === 0 || ye.cmpn(1) === 0)
            break;
          be.isub(ye);
        } while (!0);
        return ye.iushln(Se);
      }, le.prototype.invm = function(fe) {
        return this.egcd(fe).a.umod(fe);
      }, le.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, le.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, le.prototype.andln = function(fe) {
        return this.words[0] & fe;
      }, le.prototype.bincn = function(fe) {
        ne(typeof fe == "number");
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return this._expand(ye + 1), this.words[ye] |= Se, this;
        for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
          var zn = this.words[Fr] | 0;
          zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
        }
        return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
      }, le.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, le.prototype.cmpn = function(fe) {
        var be = fe < 0;
        if (this.negative !== 0 && !be)
          return -1;
        if (this.negative === 0 && be)
          return 1;
        this.strip();
        var ye;
        if (this.length > 1)
          ye = 1;
        else {
          be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
          var Se = this.words[0] | 0;
          ye = Se === fe ? 0 : Se < fe ? -1 : 1;
        }
        return this.negative !== 0 ? -ye | 0 : ye;
      }, le.prototype.cmp = function(fe) {
        if (this.negative !== 0 && fe.negative === 0)
          return -1;
        if (this.negative === 0 && fe.negative !== 0)
          return 1;
        var be = this.ucmp(fe);
        return this.negative !== 0 ? -be | 0 : be;
      }, le.prototype.ucmp = function(fe) {
        if (this.length > fe.length)
          return 1;
        if (this.length < fe.length)
          return -1;
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
          if (Se !== Oe) {
            Se < Oe ? be = -1 : Se > Oe && (be = 1);
            break;
          }
        }
        return be;
      }, le.prototype.gtn = function(fe) {
        return this.cmpn(fe) === 1;
      }, le.prototype.gt = function(fe) {
        return this.cmp(fe) === 1;
      }, le.prototype.gten = function(fe) {
        return this.cmpn(fe) >= 0;
      }, le.prototype.gte = function(fe) {
        return this.cmp(fe) >= 0;
      }, le.prototype.ltn = function(fe) {
        return this.cmpn(fe) === -1;
      }, le.prototype.lt = function(fe) {
        return this.cmp(fe) === -1;
      }, le.prototype.lten = function(fe) {
        return this.cmpn(fe) <= 0;
      }, le.prototype.lte = function(fe) {
        return this.cmp(fe) <= 0;
      }, le.prototype.eqn = function(fe) {
        return this.cmpn(fe) === 0;
      }, le.prototype.eq = function(fe) {
        return this.cmp(fe) === 0;
      }, le.red = function(fe) {
        return new Yn(fe);
      }, le.prototype.toRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
      }, le.prototype.fromRed = function() {
        return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, le.prototype._forceRed = function(fe) {
        return this.red = fe, this;
      }, le.prototype.forceRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
      }, le.prototype.redAdd = function(fe) {
        return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
      }, le.prototype.redIAdd = function(fe) {
        return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
      }, le.prototype.redSub = function(fe) {
        return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
      }, le.prototype.redISub = function(fe) {
        return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
      }, le.prototype.redShl = function(fe) {
        return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
      }, le.prototype.redMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
      }, le.prototype.redIMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
      }, le.prototype.redSqr = function() {
        return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, le.prototype.redISqr = function() {
        return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, le.prototype.redSqrt = function() {
        return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, le.prototype.redInvm = function() {
        return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, le.prototype.redNeg = function() {
        return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, le.prototype.redPow = function(fe) {
        return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
      };
      var wa = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Aa(ct, fe) {
        this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Aa.prototype._tmp = function() {
        var fe = new le(null);
        return fe.words = new Array(Math.ceil(this.n / 13)), fe;
      }, Aa.prototype.ireduce = function(fe) {
        var be = fe, ye;
        do
          this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
        while (ye > this.n);
        var Se = ye < this.n ? -1 : be.ucmp(this.p);
        return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
      }, Aa.prototype.split = function(fe, be) {
        fe.iushrn(this.n, 0, be);
      }, Aa.prototype.imulK = function(fe) {
        return fe.imul(this.k);
      };
      function _a() {
        Aa.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      ue(_a, Aa), _a.prototype.split = function(fe, be) {
        for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
          be.words[Oe] = fe.words[Oe];
        if (be.length = Se, fe.length <= 9) {
          fe.words[0] = 0, fe.length = 1;
          return;
        }
        var Fr = fe.words[9];
        for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
          var zn = fe.words[Oe] | 0;
          fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
        }
        Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
      }, _a.prototype.imulK = function(fe) {
        fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = fe.words[ye] | 0;
          be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
        }
        return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
      };
      function Ta() {
        Aa.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      ue(Ta, Aa);
      function Zn() {
        Aa.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      ue(Zn, Aa);
      function Ra() {
        Aa.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
          Se >>>= 26, fe.words[ye] = Oe, be = Se;
        }
        return be !== 0 && (fe.words[fe.length++] = be), fe;
      }, le._prime = function(fe) {
        if (wa[fe])
          return wa[fe];
        var be;
        if (fe === "k256")
          be = new _a();
        else if (fe === "p224")
          be = new Ta();
        else if (fe === "p192")
          be = new Zn();
        else if (fe === "p25519")
          be = new Ra();
        else
          throw new Error("Unknown prime " + fe);
        return wa[fe] = be, be;
      };
      function Yn(ct) {
        if (typeof ct == "string") {
          var fe = le._prime(ct);
          this.m = fe.p, this.prime = fe;
        } else
          ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
      }
      Yn.prototype._verify1 = function(fe) {
        ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
      }, Yn.prototype._verify2 = function(fe, be) {
        ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
          fe.red && fe.red === be.red,
          "red works only with red numbers"
        );
      }, Yn.prototype.imod = function(fe) {
        return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
      }, Yn.prototype.neg = function(fe) {
        return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
      }, Yn.prototype.add = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.add(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
      }, Yn.prototype.iadd = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.iadd(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
      }, Yn.prototype.sub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.sub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
      }, Yn.prototype.isub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.isub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
      }, Yn.prototype.shl = function(fe, be) {
        return this._verify1(fe), this.imod(fe.ushln(be));
      }, Yn.prototype.imul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.imul(be));
      }, Yn.prototype.mul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.mul(be));
      }, Yn.prototype.isqr = function(fe) {
        return this.imul(fe, fe.clone());
      }, Yn.prototype.sqr = function(fe) {
        return this.mul(fe, fe);
      }, Yn.prototype.sqrt = function(fe) {
        if (fe.isZero())
          return fe.clone();
        var be = this.m.andln(3);
        if (ne(be % 2 === 1), be === 3) {
          var ye = this.m.add(new le(1)).iushrn(2);
          return this.pow(fe, ye);
        }
        for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
          Oe++, Se.iushrn(1);
        ne(!Se.isZero());
        var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
        for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
          pe.redIAdd(zn);
        for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
          for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
            Oa = Oa.redSqr();
          ne(Os < _u);
          var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
          xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
        }
        return xa;
      }, Yn.prototype.invm = function(fe) {
        var be = fe._invmp(this.m);
        return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
      }, Yn.prototype.pow = function(fe, be) {
        if (be.isZero())
          return new le(1).toRed(this);
        if (be.cmpn(1) === 0)
          return fe.clone();
        var ye = 4, Se = new Array(1 << ye);
        Se[0] = new le(1).toRed(this), Se[1] = fe;
        for (var Oe = 2; Oe < Se.length; Oe++)
          Se[Oe] = this.mul(Se[Oe - 1], fe);
        var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
        for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
          for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
            var wo = it >> xa & 1;
            if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
              Fe = 0;
              continue;
            }
            zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
          }
          pe = 26;
        }
        return Fr;
      }, Yn.prototype.convertTo = function(fe) {
        var be = fe.umod(this.m);
        return be === fe ? be.clone() : be;
      }, Yn.prototype.convertFrom = function(fe) {
        var be = fe.clone();
        return be.red = null, be;
      }, le.mont = function(fe) {
        return new $o(fe);
      };
      function $o(ct) {
        Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      ue($o, Yn), $o.prototype.convertTo = function(fe) {
        return this.imod(fe.ushln(this.shift));
      }, $o.prototype.convertFrom = function(fe) {
        var be = this.imod(fe.mul(this.rinv));
        return be.red = null, be;
      }, $o.prototype.imul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return fe.words[0] = 0, fe.length = 1, fe;
        var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.mul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return new le(0)._forceRed(this);
        var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.invm = function(fe) {
        var be = this.imod(fe._invmp(this.m).mul(this.r2));
        return be._forceRed(this);
      };
    })(v, commonjsGlobal);
  }(bn$5)), bn$5.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand)
    return brorand.exports;
  hasRequiredBrorand = 1;
  var v;
  brorand.exports = function(ue) {
    return v || (v = new y(null)), v.generate(ue);
  };
  function y(ne) {
    this.rand = ne;
  }
  if (brorand.exports.Rand = y, y.prototype.generate = function(ue) {
    return this._rand(ue);
  }, y.prototype._rand = function(ue) {
    if (this.rand.getBytes)
      return this.rand.getBytes(ue);
    for (var le = new Uint8Array(ue), he = 0; he < le.length; he++)
      le[he] = this.rand.getByte();
    return le;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? y.prototype._rand = function(ue) {
      var le = new Uint8Array(ue);
      return self.crypto.getRandomValues(le), le;
    } : self.msCrypto && self.msCrypto.getRandomValues ? y.prototype._rand = function(ue) {
      var le = new Uint8Array(ue);
      return self.msCrypto.getRandomValues(le), le;
    } : typeof window == "object" && (y.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var z = requireCryptoBrowserify();
      if (typeof z.randomBytes != "function")
        throw new Error("Not supported");
      y.prototype._rand = function(ue) {
        return z.randomBytes(ue);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr)
    return mr;
  hasRequiredMr = 1;
  var v = requireBn$3(), y = requireBrorand();
  function z(ne) {
    this.rand = ne || new y.Rand();
  }
  return mr = z, z.create = function(ue) {
    return new z(ue);
  }, z.prototype._randbelow = function(ue) {
    var le = ue.bitLength(), he = Math.ceil(le / 8);
    do
      var ge = new v(this.rand.generate(he));
    while (ge.cmp(ue) >= 0);
    return ge;
  }, z.prototype._randrange = function(ue, le) {
    var he = le.sub(ue);
    return ue.add(this._randbelow(he));
  }, z.prototype.test = function(ue, le, he) {
    var ge = ue.bitLength(), we = v.mont(ue), Ee = new v(1).toRed(we);
    le || (le = Math.max(1, ge / 48 | 0));
    for (var xe = ue.subn(1), $e = 0; !xe.testn($e); $e++)
      ;
    for (var Ne = ue.shrn($e), st = xe.toRed(we), Nr = !0; le > 0; le--) {
      var br = this._randrange(new v(2), xe);
      he && he(br);
      var $n = br.toRed(we).redPow(Ne);
      if (!($n.cmp(Ee) === 0 || $n.cmp(st) === 0)) {
        for (var En = 1; En < $e; En++) {
          if ($n = $n.redSqr(), $n.cmp(Ee) === 0)
            return !1;
          if ($n.cmp(st) === 0)
            break;
        }
        if (En === $e)
          return !1;
      }
    }
    return Nr;
  }, z.prototype.getDivisor = function(ue, le) {
    var he = ue.bitLength(), ge = v.mont(ue), we = new v(1).toRed(ge);
    le || (le = Math.max(1, he / 48 | 0));
    for (var Ee = ue.subn(1), xe = 0; !Ee.testn(xe); xe++)
      ;
    for (var $e = ue.shrn(xe), Ne = Ee.toRed(ge); le > 0; le--) {
      var st = this._randrange(new v(2), Ee), Nr = ue.gcd(st);
      if (Nr.cmpn(1) !== 0)
        return Nr;
      var br = st.toRed(ge).redPow($e);
      if (!(br.cmp(we) === 0 || br.cmp(Ne) === 0)) {
        for (var $n = 1; $n < xe; $n++) {
          if (br = br.redSqr(), br.cmp(we) === 0)
            return br.fromRed().subn(1).gcd(ue);
          if (br.cmp(Ne) === 0)
            break;
        }
        if ($n === xe)
          return br = br.redSqr(), br.fromRed().subn(1).gcd(ue);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime)
    return generatePrime;
  hasRequiredGeneratePrime = 1;
  var v = requireBrowser$b();
  generatePrime = $n, $n.simpleSieve = Nr, $n.fermatTest = br;
  var y = requireBn$4(), z = new y(24), ne = requireMr(), ue = new ne(), le = new y(1), he = new y(2), ge = new y(5);
  new y(16), new y(8);
  var we = new y(10), Ee = new y(3);
  new y(7);
  var xe = new y(11), $e = new y(4);
  new y(12);
  var Ne = null;
  function st() {
    if (Ne !== null)
      return Ne;
    var En = 1048576, Rn = [];
    Rn[0] = 2;
    for (var wa = 1, Aa = 3; Aa < En; Aa += 2) {
      for (var _a = Math.ceil(Math.sqrt(Aa)), Ta = 0; Ta < wa && Rn[Ta] <= _a && Aa % Rn[Ta] !== 0; Ta++)
        ;
      wa !== Ta && Rn[Ta] <= _a || (Rn[wa++] = Aa);
    }
    return Ne = Rn, Rn;
  }
  function Nr(En) {
    for (var Rn = st(), wa = 0; wa < Rn.length; wa++)
      if (En.modn(Rn[wa]) === 0)
        return En.cmpn(Rn[wa]) === 0;
    return !0;
  }
  function br(En) {
    var Rn = y.mont(En);
    return he.toRed(Rn).redPow(En.subn(1)).fromRed().cmpn(1) === 0;
  }
  function $n(En, Rn) {
    if (En < 16)
      return Rn === 2 || Rn === 5 ? new y([140, 123]) : new y([140, 39]);
    Rn = new y(Rn);
    for (var wa, Aa; ; ) {
      for (wa = new y(v(Math.ceil(En / 8))); wa.bitLength() > En; )
        wa.ishrn(1);
      if (wa.isEven() && wa.iadd(le), wa.testn(1) || wa.iadd(he), Rn.cmp(he)) {
        if (!Rn.cmp(ge))
          for (; wa.mod(we).cmp(Ee); )
            wa.iadd($e);
      } else
        for (; wa.mod(z).cmp(xe); )
          wa.iadd($e);
      if (Aa = wa.shrn(1), Nr(Aa) && Nr(wa) && br(Aa) && br(wa) && ue.test(Aa) && ue.test(wa))
        return wa;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh)
    return dh;
  hasRequiredDh = 1;
  var v = requireBn$4(), y = requireMr(), z = new y(), ne = new v(24), ue = new v(11), le = new v(10), he = new v(3), ge = new v(7), we = requireGeneratePrime(), Ee = requireBrowser$b();
  dh = Nr;
  function xe($n, En) {
    return En = En || "utf8", Buffer.isBuffer($n) || ($n = new Buffer($n, En)), this._pub = new v($n), this;
  }
  function $e($n, En) {
    return En = En || "utf8", Buffer.isBuffer($n) || ($n = new Buffer($n, En)), this._priv = new v($n), this;
  }
  var Ne = {};
  function st($n, En) {
    var Rn = En.toString("hex"), wa = [Rn, $n.toString(16)].join("_");
    if (wa in Ne)
      return Ne[wa];
    var Aa = 0;
    if ($n.isEven() || !we.simpleSieve || !we.fermatTest($n) || !z.test($n))
      return Aa += 1, Rn === "02" || Rn === "05" ? Aa += 8 : Aa += 4, Ne[wa] = Aa, Aa;
    z.test($n.shrn(1)) || (Aa += 2);
    var _a;
    switch (Rn) {
      case "02":
        $n.mod(ne).cmp(ue) && (Aa += 8);
        break;
      case "05":
        _a = $n.mod(le), _a.cmp(he) && _a.cmp(ge) && (Aa += 8);
        break;
      default:
        Aa += 4;
    }
    return Ne[wa] = Aa, Aa;
  }
  function Nr($n, En, Rn) {
    this.setGenerator(En), this.__prime = new v($n), this._prime = v.mont(this.__prime), this._primeLen = $n.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, Rn ? (this.setPublicKey = xe, this.setPrivateKey = $e) : this._primeCode = 8;
  }
  Object.defineProperty(Nr.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = st(this.__prime, this.__gen)), this._primeCode;
    }
  }), Nr.prototype.generateKeys = function() {
    return this._priv || (this._priv = new v(Ee(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, Nr.prototype.computeSecret = function($n) {
    $n = new v($n), $n = $n.toRed(this._prime);
    var En = $n.redPow(this._priv).fromRed(), Rn = new Buffer(En.toArray()), wa = this.getPrime();
    if (Rn.length < wa.length) {
      var Aa = new Buffer(wa.length - Rn.length);
      Aa.fill(0), Rn = Buffer.concat([Aa, Rn]);
    }
    return Rn;
  }, Nr.prototype.getPublicKey = function(En) {
    return br(this._pub, En);
  }, Nr.prototype.getPrivateKey = function(En) {
    return br(this._priv, En);
  }, Nr.prototype.getPrime = function($n) {
    return br(this.__prime, $n);
  }, Nr.prototype.getGenerator = function($n) {
    return br(this._gen, $n);
  }, Nr.prototype.setGenerator = function($n, En) {
    return En = En || "utf8", Buffer.isBuffer($n) || ($n = new Buffer($n, En)), this.__gen = $n, this._gen = new v($n), this;
  };
  function br($n, En) {
    var Rn = new Buffer($n.toArray());
    return En ? Rn.toString(En) : Rn;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4)
    return browser$5;
  hasRequiredBrowser$4 = 1;
  var v = requireGeneratePrime(), y = require$$1$1, z = requireDh();
  function ne(he) {
    var ge = new Buffer(y[he].prime, "hex"), we = new Buffer(y[he].gen, "hex");
    return new z(ge, we);
  }
  var ue = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function le(he, ge, we, Ee) {
    return Buffer.isBuffer(ge) || ue[ge] === void 0 ? le(he, "binary", ge, we) : (ge = ge || "binary", Ee = Ee || "binary", we = we || new Buffer([2]), Buffer.isBuffer(we) || (we = new Buffer(we, Ee)), typeof he == "number" ? new z(v(he, we), we, !0) : (Buffer.isBuffer(he) || (he = new Buffer(he, ge)), new z(he, we, !0)));
  }
  return browser$5.DiffieHellmanGroup = browser$5.createDiffieHellmanGroup = browser$5.getDiffieHellman = ne, browser$5.createDiffieHellman = browser$5.DiffieHellman = le, browser$5;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs)
    return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof process$1 > "u" || !process$1.version || process$1.version.indexOf("v0.") === 0 || process$1.version.indexOf("v1.") === 0 && process$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: v } : processNextickArgs.exports = process$1;
  function v(y, z, ne, ue) {
    if (typeof y != "function")
      throw new TypeError('"callback" argument must be a function');
    var le = arguments.length, he, ge;
    switch (le) {
      case 0:
      case 1:
        return process$1.nextTick(y);
      case 2:
        return process$1.nextTick(function() {
          y.call(null, z);
        });
      case 3:
        return process$1.nextTick(function() {
          y.call(null, z, ne);
        });
      case 4:
        return process$1.nextTick(function() {
          y.call(null, z, ne, ue);
        });
      default:
        for (he = new Array(le - 1), ge = 0; ge < he.length; )
          he[ge++] = arguments[ge];
        return process$1.nextTick(function() {
          y.apply(null, he);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray)
    return isarray;
  hasRequiredIsarray = 1;
  var v = {}.toString;
  return isarray = Array.isArray || function(y) {
    return v.call(y) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = eventsExports.EventEmitter), streamBrowser;
}
var safeBuffer$1 = { exports: {} }, hasRequiredSafeBuffer$1;
function requireSafeBuffer$1() {
  return hasRequiredSafeBuffer$1 || (hasRequiredSafeBuffer$1 = 1, function(v, y) {
    var z = require$$0$3, ne = z.Buffer;
    function ue(he, ge) {
      for (var we in he)
        ge[we] = he[we];
    }
    ne.from && ne.alloc && ne.allocUnsafe && ne.allocUnsafeSlow ? v.exports = z : (ue(z, y), y.Buffer = le);
    function le(he, ge, we) {
      return ne(he, ge, we);
    }
    ue(ne, le), le.from = function(he, ge, we) {
      if (typeof he == "number")
        throw new TypeError("Argument must not be a number");
      return ne(he, ge, we);
    }, le.alloc = function(he, ge, we) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      var Ee = ne(he);
      return ge !== void 0 ? typeof we == "string" ? Ee.fill(ge, we) : Ee.fill(ge) : Ee.fill(0), Ee;
    }, le.allocUnsafe = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return ne(he);
    }, le.allocUnsafeSlow = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return z.SlowBuffer(he);
    };
  }(safeBuffer$1, safeBuffer$1.exports)), safeBuffer$1.exports;
}
var util = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil)
    return util;
  hasRequiredUtil = 1;
  function v(br) {
    return Array.isArray ? Array.isArray(br) : Nr(br) === "[object Array]";
  }
  util.isArray = v;
  function y(br) {
    return typeof br == "boolean";
  }
  util.isBoolean = y;
  function z(br) {
    return br === null;
  }
  util.isNull = z;
  function ne(br) {
    return br == null;
  }
  util.isNullOrUndefined = ne;
  function ue(br) {
    return typeof br == "number";
  }
  util.isNumber = ue;
  function le(br) {
    return typeof br == "string";
  }
  util.isString = le;
  function he(br) {
    return typeof br == "symbol";
  }
  util.isSymbol = he;
  function ge(br) {
    return br === void 0;
  }
  util.isUndefined = ge;
  function we(br) {
    return Nr(br) === "[object RegExp]";
  }
  util.isRegExp = we;
  function Ee(br) {
    return typeof br == "object" && br !== null;
  }
  util.isObject = Ee;
  function xe(br) {
    return Nr(br) === "[object Date]";
  }
  util.isDate = xe;
  function $e(br) {
    return Nr(br) === "[object Error]" || br instanceof Error;
  }
  util.isError = $e;
  function Ne(br) {
    return typeof br == "function";
  }
  util.isFunction = Ne;
  function st(br) {
    return br === null || typeof br == "boolean" || typeof br == "number" || typeof br == "string" || typeof br == "symbol" || // ES6 symbol
    typeof br > "u";
  }
  util.isPrimitive = st, util.isBuffer = require$$0$3.Buffer.isBuffer;
  function Nr(br) {
    return Object.prototype.toString.call(br);
  }
  return util;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(v) {
    function y(le, he) {
      if (!(le instanceof he))
        throw new TypeError("Cannot call a class as a function");
    }
    var z = requireSafeBuffer$1().Buffer, ne = require$$0$2;
    function ue(le, he, ge) {
      le.copy(he, ge);
    }
    v.exports = function() {
      function le() {
        y(this, le), this.head = null, this.tail = null, this.length = 0;
      }
      return le.prototype.push = function(ge) {
        var we = { data: ge, next: null };
        this.length > 0 ? this.tail.next = we : this.head = we, this.tail = we, ++this.length;
      }, le.prototype.unshift = function(ge) {
        var we = { data: ge, next: this.head };
        this.length === 0 && (this.tail = we), this.head = we, ++this.length;
      }, le.prototype.shift = function() {
        if (this.length !== 0) {
          var ge = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, ge;
        }
      }, le.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, le.prototype.join = function(ge) {
        if (this.length === 0)
          return "";
        for (var we = this.head, Ee = "" + we.data; we = we.next; )
          Ee += ge + we.data;
        return Ee;
      }, le.prototype.concat = function(ge) {
        if (this.length === 0)
          return z.alloc(0);
        for (var we = z.allocUnsafe(ge >>> 0), Ee = this.head, xe = 0; Ee; )
          ue(Ee.data, we, xe), xe += Ee.data.length, Ee = Ee.next;
        return we;
      }, le;
    }(), ne && ne.inspect && ne.inspect.custom && (v.exports.prototype[ne.inspect.custom] = function() {
      var le = ne.inspect({ length: this.length });
      return this.constructor.name + " " + le;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy)
    return destroy_1;
  hasRequiredDestroy = 1;
  var v = requireProcessNextickArgs();
  function y(ue, le) {
    var he = this, ge = this._readableState && this._readableState.destroyed, we = this._writableState && this._writableState.destroyed;
    return ge || we ? (le ? le(ue) : ue && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, v.nextTick(ne, this, ue)) : v.nextTick(ne, this, ue)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(ue || null, function(Ee) {
      !le && Ee ? he._writableState ? he._writableState.errorEmitted || (he._writableState.errorEmitted = !0, v.nextTick(ne, he, Ee)) : v.nextTick(ne, he, Ee) : le && le(Ee);
    }), this);
  }
  function z() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function ne(ue, le) {
    ue.emit("error", le);
  }
  return destroy_1 = {
    destroy: y,
    undestroy: z
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1;
  var v = requireProcessNextickArgs();
  _stream_writable = br;
  function y(Fr) {
    var zn = this;
    this.next = null, this.entry = null, this.finish = function() {
      Oe(zn, Fr);
    };
  }
  var z = !process$1.browser && ["v0.10", "v0.9."].indexOf(process$1.version.slice(0, 5)) > -1 ? setImmediate : v.nextTick, ne;
  br.WritableState = st;
  var ue = Object.create(requireUtil());
  ue.inherits = requireInherits_browser();
  var le = {
    deprecate: requireBrowser$a()
  }, he = requireStreamBrowser(), ge = requireSafeBuffer$1().Buffer, we = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function Ee(Fr) {
    return ge.from(Fr);
  }
  function xe(Fr) {
    return ge.isBuffer(Fr) || Fr instanceof we;
  }
  var $e = requireDestroy();
  ue.inherits(br, he);
  function Ne() {
  }
  function st(Fr, zn) {
    ne = ne || require_stream_duplex(), Fr = Fr || {};
    var Fe = zn instanceof ne;
    this.objectMode = !!Fr.objectMode, Fe && (this.objectMode = this.objectMode || !!Fr.writableObjectMode);
    var pe = Fr.highWaterMark, it = Fr.writableHighWaterMark, xa = this.objectMode ? 16 : 16 * 1024;
    pe || pe === 0 ? this.highWaterMark = pe : Fe && (it || it === 0) ? this.highWaterMark = it : this.highWaterMark = xa, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var wo = Fr.decodeStrings === !1;
    this.decodeStrings = !wo, this.defaultEncoding = Fr.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(_u) {
      Zn(zn, _u);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new y(this);
  }
  st.prototype.getBuffer = function() {
    for (var zn = this.bufferedRequest, Fe = []; zn; )
      Fe.push(zn), zn = zn.next;
    return Fe;
  }, function() {
    try {
      Object.defineProperty(st.prototype, "buffer", {
        get: le.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Nr;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Nr = Function.prototype[Symbol.hasInstance], Object.defineProperty(br, Symbol.hasInstance, {
    value: function(Fr) {
      return Nr.call(this, Fr) ? !0 : this !== br ? !1 : Fr && Fr._writableState instanceof st;
    }
  })) : Nr = function(Fr) {
    return Fr instanceof this;
  };
  function br(Fr) {
    if (ne = ne || require_stream_duplex(), !Nr.call(br, this) && !(this instanceof ne))
      return new br(Fr);
    this._writableState = new st(Fr, this), this.writable = !0, Fr && (typeof Fr.write == "function" && (this._write = Fr.write), typeof Fr.writev == "function" && (this._writev = Fr.writev), typeof Fr.destroy == "function" && (this._destroy = Fr.destroy), typeof Fr.final == "function" && (this._final = Fr.final)), he.call(this);
  }
  br.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function $n(Fr, zn) {
    var Fe = new Error("write after end");
    Fr.emit("error", Fe), v.nextTick(zn, Fe);
  }
  function En(Fr, zn, Fe, pe) {
    var it = !0, xa = !1;
    return Fe === null ? xa = new TypeError("May not write null values to stream") : typeof Fe != "string" && Fe !== void 0 && !zn.objectMode && (xa = new TypeError("Invalid non-string/buffer chunk")), xa && (Fr.emit("error", xa), v.nextTick(pe, xa), it = !1), it;
  }
  br.prototype.write = function(Fr, zn, Fe) {
    var pe = this._writableState, it = !1, xa = !pe.objectMode && xe(Fr);
    return xa && !ge.isBuffer(Fr) && (Fr = Ee(Fr)), typeof zn == "function" && (Fe = zn, zn = null), xa ? zn = "buffer" : zn || (zn = pe.defaultEncoding), typeof Fe != "function" && (Fe = Ne), pe.ended ? $n(this, Fe) : (xa || En(this, pe, Fr, Fe)) && (pe.pendingcb++, it = wa(this, pe, xa, Fr, zn, Fe)), it;
  }, br.prototype.cork = function() {
    var Fr = this._writableState;
    Fr.corked++;
  }, br.prototype.uncork = function() {
    var Fr = this._writableState;
    Fr.corked && (Fr.corked--, !Fr.writing && !Fr.corked && !Fr.bufferProcessing && Fr.bufferedRequest && $o(this, Fr));
  }, br.prototype.setDefaultEncoding = function(zn) {
    if (typeof zn == "string" && (zn = zn.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((zn + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + zn);
    return this._writableState.defaultEncoding = zn, this;
  };
  function Rn(Fr, zn, Fe) {
    return !Fr.objectMode && Fr.decodeStrings !== !1 && typeof zn == "string" && (zn = ge.from(zn, Fe)), zn;
  }
  Object.defineProperty(br.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function wa(Fr, zn, Fe, pe, it, xa) {
    if (!Fe) {
      var wo = Rn(zn, pe, it);
      pe !== wo && (Fe = !0, it = "buffer", pe = wo);
    }
    var _u = zn.objectMode ? 1 : pe.length;
    zn.length += _u;
    var Oa = zn.length < zn.highWaterMark;
    if (Oa || (zn.needDrain = !0), zn.writing || zn.corked) {
      var Os = zn.lastBufferedRequest;
      zn.lastBufferedRequest = {
        chunk: pe,
        encoding: it,
        isBuf: Fe,
        callback: xa,
        next: null
      }, Os ? Os.next = zn.lastBufferedRequest : zn.bufferedRequest = zn.lastBufferedRequest, zn.bufferedRequestCount += 1;
    } else
      Aa(Fr, zn, !1, _u, pe, it, xa);
    return Oa;
  }
  function Aa(Fr, zn, Fe, pe, it, xa, wo) {
    zn.writelen = pe, zn.writecb = wo, zn.writing = !0, zn.sync = !0, Fe ? Fr._writev(it, zn.onwrite) : Fr._write(it, xa, zn.onwrite), zn.sync = !1;
  }
  function _a(Fr, zn, Fe, pe, it) {
    --zn.pendingcb, Fe ? (v.nextTick(it, pe), v.nextTick(ye, Fr, zn), Fr._writableState.errorEmitted = !0, Fr.emit("error", pe)) : (it(pe), Fr._writableState.errorEmitted = !0, Fr.emit("error", pe), ye(Fr, zn));
  }
  function Ta(Fr) {
    Fr.writing = !1, Fr.writecb = null, Fr.length -= Fr.writelen, Fr.writelen = 0;
  }
  function Zn(Fr, zn) {
    var Fe = Fr._writableState, pe = Fe.sync, it = Fe.writecb;
    if (Ta(Fe), zn)
      _a(Fr, Fe, pe, zn, it);
    else {
      var xa = ct(Fe);
      !xa && !Fe.corked && !Fe.bufferProcessing && Fe.bufferedRequest && $o(Fr, Fe), pe ? z(Ra, Fr, Fe, xa, it) : Ra(Fr, Fe, xa, it);
    }
  }
  function Ra(Fr, zn, Fe, pe) {
    Fe || Yn(Fr, zn), zn.pendingcb--, pe(), ye(Fr, zn);
  }
  function Yn(Fr, zn) {
    zn.length === 0 && zn.needDrain && (zn.needDrain = !1, Fr.emit("drain"));
  }
  function $o(Fr, zn) {
    zn.bufferProcessing = !0;
    var Fe = zn.bufferedRequest;
    if (Fr._writev && Fe && Fe.next) {
      var pe = zn.bufferedRequestCount, it = new Array(pe), xa = zn.corkedRequestsFree;
      xa.entry = Fe;
      for (var wo = 0, _u = !0; Fe; )
        it[wo] = Fe, Fe.isBuf || (_u = !1), Fe = Fe.next, wo += 1;
      it.allBuffers = _u, Aa(Fr, zn, !0, zn.length, it, "", xa.finish), zn.pendingcb++, zn.lastBufferedRequest = null, xa.next ? (zn.corkedRequestsFree = xa.next, xa.next = null) : zn.corkedRequestsFree = new y(zn), zn.bufferedRequestCount = 0;
    } else {
      for (; Fe; ) {
        var Oa = Fe.chunk, Os = Fe.encoding, Pa = Fe.callback, Ml = zn.objectMode ? 1 : Oa.length;
        if (Aa(Fr, zn, !1, Ml, Oa, Os, Pa), Fe = Fe.next, zn.bufferedRequestCount--, zn.writing)
          break;
      }
      Fe === null && (zn.lastBufferedRequest = null);
    }
    zn.bufferedRequest = Fe, zn.bufferProcessing = !1;
  }
  br.prototype._write = function(Fr, zn, Fe) {
    Fe(new Error("_write() is not implemented"));
  }, br.prototype._writev = null, br.prototype.end = function(Fr, zn, Fe) {
    var pe = this._writableState;
    typeof Fr == "function" ? (Fe = Fr, Fr = null, zn = null) : typeof zn == "function" && (Fe = zn, zn = null), Fr != null && this.write(Fr, zn), pe.corked && (pe.corked = 1, this.uncork()), pe.ending || Se(this, pe, Fe);
  };
  function ct(Fr) {
    return Fr.ending && Fr.length === 0 && Fr.bufferedRequest === null && !Fr.finished && !Fr.writing;
  }
  function fe(Fr, zn) {
    Fr._final(function(Fe) {
      zn.pendingcb--, Fe && Fr.emit("error", Fe), zn.prefinished = !0, Fr.emit("prefinish"), ye(Fr, zn);
    });
  }
  function be(Fr, zn) {
    !zn.prefinished && !zn.finalCalled && (typeof Fr._final == "function" ? (zn.pendingcb++, zn.finalCalled = !0, v.nextTick(fe, Fr, zn)) : (zn.prefinished = !0, Fr.emit("prefinish")));
  }
  function ye(Fr, zn) {
    var Fe = ct(zn);
    return Fe && (be(Fr, zn), zn.pendingcb === 0 && (zn.finished = !0, Fr.emit("finish"))), Fe;
  }
  function Se(Fr, zn, Fe) {
    zn.ending = !0, ye(Fr, zn), Fe && (zn.finished ? v.nextTick(Fe) : Fr.once("finish", Fe)), zn.ended = !0, Fr.writable = !1;
  }
  function Oe(Fr, zn, Fe) {
    var pe = Fr.entry;
    for (Fr.entry = null; pe; ) {
      var it = pe.callback;
      zn.pendingcb--, it(Fe), pe = pe.next;
    }
    zn.corkedRequestsFree.next = Fr;
  }
  return Object.defineProperty(br.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(Fr) {
      this._writableState && (this._writableState.destroyed = Fr);
    }
  }), br.prototype.destroy = $e.destroy, br.prototype._undestroy = $e.undestroy, br.prototype._destroy = function(Fr, zn) {
    this.end(), zn(Fr);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var v = requireProcessNextickArgs(), y = Object.keys || function($e) {
    var Ne = [];
    for (var st in $e)
      Ne.push(st);
    return Ne;
  };
  _stream_duplex = we;
  var z = Object.create(requireUtil());
  z.inherits = requireInherits_browser();
  var ne = require_stream_readable(), ue = require_stream_writable();
  z.inherits(we, ne);
  for (var le = y(ue.prototype), he = 0; he < le.length; he++) {
    var ge = le[he];
    we.prototype[ge] || (we.prototype[ge] = ue.prototype[ge]);
  }
  function we($e) {
    if (!(this instanceof we))
      return new we($e);
    ne.call(this, $e), ue.call(this, $e), $e && $e.readable === !1 && (this.readable = !1), $e && $e.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, $e && $e.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", Ee);
  }
  Object.defineProperty(we.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ee() {
    this.allowHalfOpen || this._writableState.ended || v.nextTick(xe, this);
  }
  function xe($e) {
    $e.end();
  }
  return Object.defineProperty(we.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function($e) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = $e, this._writableState.destroyed = $e);
    }
  }), we.prototype._destroy = function($e, Ne) {
    this.push(null), this.end(), v.nextTick(Ne, $e);
  }, _stream_duplex;
}
var string_decoder = {}, safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(v, y) {
    var z = require$$0$3, ne = z.Buffer;
    function ue(he, ge) {
      for (var we in he)
        ge[we] = he[we];
    }
    ne.from && ne.alloc && ne.allocUnsafe && ne.allocUnsafeSlow ? v.exports = z : (ue(z, y), y.Buffer = le);
    function le(he, ge, we) {
      return ne(he, ge, we);
    }
    ue(ne, le), le.from = function(he, ge, we) {
      if (typeof he == "number")
        throw new TypeError("Argument must not be a number");
      return ne(he, ge, we);
    }, le.alloc = function(he, ge, we) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      var Ee = ne(he);
      return ge !== void 0 ? typeof we == "string" ? Ee.fill(ge, we) : Ee.fill(ge) : Ee.fill(0), Ee;
    }, le.allocUnsafe = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return ne(he);
    }, le.allocUnsafeSlow = function(he) {
      if (typeof he != "number")
        throw new TypeError("Argument must be a number");
      return z.SlowBuffer(he);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder)
    return string_decoder;
  hasRequiredString_decoder = 1;
  var v = requireSafeBuffer().Buffer, y = v.isEncoding || function(En) {
    switch (En = "" + En, En && En.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function z(En) {
    if (!En)
      return "utf8";
    for (var Rn; ; )
      switch (En) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return En;
        default:
          if (Rn)
            return;
          En = ("" + En).toLowerCase(), Rn = !0;
      }
  }
  function ne(En) {
    var Rn = z(En);
    if (typeof Rn != "string" && (v.isEncoding === y || !y(En)))
      throw new Error("Unknown encoding: " + En);
    return Rn || En;
  }
  string_decoder.StringDecoder = ue;
  function ue(En) {
    this.encoding = ne(En);
    var Rn;
    switch (this.encoding) {
      case "utf16le":
        this.text = $e, this.end = Ne, Rn = 4;
        break;
      case "utf8":
        this.fillLast = we, Rn = 4;
        break;
      case "base64":
        this.text = st, this.end = Nr, Rn = 3;
        break;
      default:
        this.write = br, this.end = $n;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = v.allocUnsafe(Rn);
  }
  ue.prototype.write = function(En) {
    if (En.length === 0)
      return "";
    var Rn, wa;
    if (this.lastNeed) {
      if (Rn = this.fillLast(En), Rn === void 0)
        return "";
      wa = this.lastNeed, this.lastNeed = 0;
    } else
      wa = 0;
    return wa < En.length ? Rn ? Rn + this.text(En, wa) : this.text(En, wa) : Rn || "";
  }, ue.prototype.end = xe, ue.prototype.text = Ee, ue.prototype.fillLast = function(En) {
    if (this.lastNeed <= En.length)
      return En.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    En.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, En.length), this.lastNeed -= En.length;
  };
  function le(En) {
    return En <= 127 ? 0 : En >> 5 === 6 ? 2 : En >> 4 === 14 ? 3 : En >> 3 === 30 ? 4 : En >> 6 === 2 ? -1 : -2;
  }
  function he(En, Rn, wa) {
    var Aa = Rn.length - 1;
    if (Aa < wa)
      return 0;
    var _a = le(Rn[Aa]);
    return _a >= 0 ? (_a > 0 && (En.lastNeed = _a - 1), _a) : --Aa < wa || _a === -2 ? 0 : (_a = le(Rn[Aa]), _a >= 0 ? (_a > 0 && (En.lastNeed = _a - 2), _a) : --Aa < wa || _a === -2 ? 0 : (_a = le(Rn[Aa]), _a >= 0 ? (_a > 0 && (_a === 2 ? _a = 0 : En.lastNeed = _a - 3), _a) : 0));
  }
  function ge(En, Rn, wa) {
    if ((Rn[0] & 192) !== 128)
      return En.lastNeed = 0, "�";
    if (En.lastNeed > 1 && Rn.length > 1) {
      if ((Rn[1] & 192) !== 128)
        return En.lastNeed = 1, "�";
      if (En.lastNeed > 2 && Rn.length > 2 && (Rn[2] & 192) !== 128)
        return En.lastNeed = 2, "�";
    }
  }
  function we(En) {
    var Rn = this.lastTotal - this.lastNeed, wa = ge(this, En);
    if (wa !== void 0)
      return wa;
    if (this.lastNeed <= En.length)
      return En.copy(this.lastChar, Rn, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    En.copy(this.lastChar, Rn, 0, En.length), this.lastNeed -= En.length;
  }
  function Ee(En, Rn) {
    var wa = he(this, En, Rn);
    if (!this.lastNeed)
      return En.toString("utf8", Rn);
    this.lastTotal = wa;
    var Aa = En.length - (wa - this.lastNeed);
    return En.copy(this.lastChar, 0, Aa), En.toString("utf8", Rn, Aa);
  }
  function xe(En) {
    var Rn = En && En.length ? this.write(En) : "";
    return this.lastNeed ? Rn + "�" : Rn;
  }
  function $e(En, Rn) {
    if ((En.length - Rn) % 2 === 0) {
      var wa = En.toString("utf16le", Rn);
      if (wa) {
        var Aa = wa.charCodeAt(wa.length - 1);
        if (Aa >= 55296 && Aa <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = En[En.length - 2], this.lastChar[1] = En[En.length - 1], wa.slice(0, -1);
      }
      return wa;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = En[En.length - 1], En.toString("utf16le", Rn, En.length - 1);
  }
  function Ne(En) {
    var Rn = En && En.length ? this.write(En) : "";
    if (this.lastNeed) {
      var wa = this.lastTotal - this.lastNeed;
      return Rn + this.lastChar.toString("utf16le", 0, wa);
    }
    return Rn;
  }
  function st(En, Rn) {
    var wa = (En.length - Rn) % 3;
    return wa === 0 ? En.toString("base64", Rn) : (this.lastNeed = 3 - wa, this.lastTotal = 3, wa === 1 ? this.lastChar[0] = En[En.length - 1] : (this.lastChar[0] = En[En.length - 2], this.lastChar[1] = En[En.length - 1]), En.toString("base64", Rn, En.length - wa));
  }
  function Nr(En) {
    var Rn = En && En.length ? this.write(En) : "";
    return this.lastNeed ? Rn + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : Rn;
  }
  function br(En) {
    return En.toString(this.encoding);
  }
  function $n(En) {
    return En && En.length ? this.write(En) : "";
  }
  return string_decoder;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1;
  var v = requireProcessNextickArgs();
  _stream_readable = Rn;
  var y = requireIsarray(), z;
  Rn.ReadableState = En, eventsExports.EventEmitter;
  var ne = function(Pa, Ml) {
    return Pa.listeners(Ml).length;
  }, ue = requireStreamBrowser(), le = requireSafeBuffer$1().Buffer, he = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function ge(Pa) {
    return le.from(Pa);
  }
  function we(Pa) {
    return le.isBuffer(Pa) || Pa instanceof he;
  }
  var Ee = Object.create(requireUtil());
  Ee.inherits = requireInherits_browser();
  var xe = require$$0$2, $e = void 0;
  xe && xe.debuglog ? $e = xe.debuglog("stream") : $e = function() {
  };
  var Ne = requireBufferList(), st = requireDestroy(), Nr;
  Ee.inherits(Rn, ue);
  var br = ["error", "close", "destroy", "pause", "resume"];
  function $n(Pa, Ml, Su) {
    if (typeof Pa.prependListener == "function")
      return Pa.prependListener(Ml, Su);
    !Pa._events || !Pa._events[Ml] ? Pa.on(Ml, Su) : y(Pa._events[Ml]) ? Pa._events[Ml].unshift(Su) : Pa._events[Ml] = [Su, Pa._events[Ml]];
  }
  function En(Pa, Ml) {
    z = z || require_stream_duplex(), Pa = Pa || {};
    var Su = Ml instanceof z;
    this.objectMode = !!Pa.objectMode, Su && (this.objectMode = this.objectMode || !!Pa.readableObjectMode);
    var Tu = Pa.highWaterMark, Au = Pa.readableHighWaterMark, Zl = this.objectMode ? 16 : 16 * 1024;
    Tu || Tu === 0 ? this.highWaterMark = Tu : Su && (Au || Au === 0) ? this.highWaterMark = Au : this.highWaterMark = Zl, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new Ne(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = Pa.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Pa.encoding && (Nr || (Nr = requireString_decoder().StringDecoder), this.decoder = new Nr(Pa.encoding), this.encoding = Pa.encoding);
  }
  function Rn(Pa) {
    if (z = z || require_stream_duplex(), !(this instanceof Rn))
      return new Rn(Pa);
    this._readableState = new En(Pa, this), this.readable = !0, Pa && (typeof Pa.read == "function" && (this._read = Pa.read), typeof Pa.destroy == "function" && (this._destroy = Pa.destroy)), ue.call(this);
  }
  Object.defineProperty(Rn.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Pa) {
      this._readableState && (this._readableState.destroyed = Pa);
    }
  }), Rn.prototype.destroy = st.destroy, Rn.prototype._undestroy = st.undestroy, Rn.prototype._destroy = function(Pa, Ml) {
    this.push(null), Ml(Pa);
  }, Rn.prototype.push = function(Pa, Ml) {
    var Su = this._readableState, Tu;
    return Su.objectMode ? Tu = !0 : typeof Pa == "string" && (Ml = Ml || Su.defaultEncoding, Ml !== Su.encoding && (Pa = le.from(Pa, Ml), Ml = ""), Tu = !0), wa(this, Pa, Ml, !1, Tu);
  }, Rn.prototype.unshift = function(Pa) {
    return wa(this, Pa, null, !0, !1);
  };
  function wa(Pa, Ml, Su, Tu, Au) {
    var Zl = Pa._readableState;
    if (Ml === null)
      Zl.reading = !1, $o(Pa, Zl);
    else {
      var Iu;
      Au || (Iu = _a(Zl, Ml)), Iu ? Pa.emit("error", Iu) : Zl.objectMode || Ml && Ml.length > 0 ? (typeof Ml != "string" && !Zl.objectMode && Object.getPrototypeOf(Ml) !== le.prototype && (Ml = ge(Ml)), Tu ? Zl.endEmitted ? Pa.emit("error", new Error("stream.unshift() after end event")) : Aa(Pa, Zl, Ml, !0) : Zl.ended ? Pa.emit("error", new Error("stream.push() after EOF")) : (Zl.reading = !1, Zl.decoder && !Su ? (Ml = Zl.decoder.write(Ml), Zl.objectMode || Ml.length !== 0 ? Aa(Pa, Zl, Ml, !1) : be(Pa, Zl)) : Aa(Pa, Zl, Ml, !1))) : Tu || (Zl.reading = !1);
    }
    return Ta(Zl);
  }
  function Aa(Pa, Ml, Su, Tu) {
    Ml.flowing && Ml.length === 0 && !Ml.sync ? (Pa.emit("data", Su), Pa.read(0)) : (Ml.length += Ml.objectMode ? 1 : Su.length, Tu ? Ml.buffer.unshift(Su) : Ml.buffer.push(Su), Ml.needReadable && ct(Pa)), be(Pa, Ml);
  }
  function _a(Pa, Ml) {
    var Su;
    return !we(Ml) && typeof Ml != "string" && Ml !== void 0 && !Pa.objectMode && (Su = new TypeError("Invalid non-string/buffer chunk")), Su;
  }
  function Ta(Pa) {
    return !Pa.ended && (Pa.needReadable || Pa.length < Pa.highWaterMark || Pa.length === 0);
  }
  Rn.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Rn.prototype.setEncoding = function(Pa) {
    return Nr || (Nr = requireString_decoder().StringDecoder), this._readableState.decoder = new Nr(Pa), this._readableState.encoding = Pa, this;
  };
  var Zn = 8388608;
  function Ra(Pa) {
    return Pa >= Zn ? Pa = Zn : (Pa--, Pa |= Pa >>> 1, Pa |= Pa >>> 2, Pa |= Pa >>> 4, Pa |= Pa >>> 8, Pa |= Pa >>> 16, Pa++), Pa;
  }
  function Yn(Pa, Ml) {
    return Pa <= 0 || Ml.length === 0 && Ml.ended ? 0 : Ml.objectMode ? 1 : Pa !== Pa ? Ml.flowing && Ml.length ? Ml.buffer.head.data.length : Ml.length : (Pa > Ml.highWaterMark && (Ml.highWaterMark = Ra(Pa)), Pa <= Ml.length ? Pa : Ml.ended ? Ml.length : (Ml.needReadable = !0, 0));
  }
  Rn.prototype.read = function(Pa) {
    $e("read", Pa), Pa = parseInt(Pa, 10);
    var Ml = this._readableState, Su = Pa;
    if (Pa !== 0 && (Ml.emittedReadable = !1), Pa === 0 && Ml.needReadable && (Ml.length >= Ml.highWaterMark || Ml.ended))
      return $e("read: emitReadable", Ml.length, Ml.ended), Ml.length === 0 && Ml.ended ? _u(this) : ct(this), null;
    if (Pa = Yn(Pa, Ml), Pa === 0 && Ml.ended)
      return Ml.length === 0 && _u(this), null;
    var Tu = Ml.needReadable;
    $e("need readable", Tu), (Ml.length === 0 || Ml.length - Pa < Ml.highWaterMark) && (Tu = !0, $e("length less than watermark", Tu)), Ml.ended || Ml.reading ? (Tu = !1, $e("reading or ended", Tu)) : Tu && ($e("do read"), Ml.reading = !0, Ml.sync = !0, Ml.length === 0 && (Ml.needReadable = !0), this._read(Ml.highWaterMark), Ml.sync = !1, Ml.reading || (Pa = Yn(Su, Ml)));
    var Au;
    return Pa > 0 ? Au = pe(Pa, Ml) : Au = null, Au === null ? (Ml.needReadable = !0, Pa = 0) : Ml.length -= Pa, Ml.length === 0 && (Ml.ended || (Ml.needReadable = !0), Su !== Pa && Ml.ended && _u(this)), Au !== null && this.emit("data", Au), Au;
  };
  function $o(Pa, Ml) {
    if (!Ml.ended) {
      if (Ml.decoder) {
        var Su = Ml.decoder.end();
        Su && Su.length && (Ml.buffer.push(Su), Ml.length += Ml.objectMode ? 1 : Su.length);
      }
      Ml.ended = !0, ct(Pa);
    }
  }
  function ct(Pa) {
    var Ml = Pa._readableState;
    Ml.needReadable = !1, Ml.emittedReadable || ($e("emitReadable", Ml.flowing), Ml.emittedReadable = !0, Ml.sync ? v.nextTick(fe, Pa) : fe(Pa));
  }
  function fe(Pa) {
    $e("emit readable"), Pa.emit("readable"), Fe(Pa);
  }
  function be(Pa, Ml) {
    Ml.readingMore || (Ml.readingMore = !0, v.nextTick(ye, Pa, Ml));
  }
  function ye(Pa, Ml) {
    for (var Su = Ml.length; !Ml.reading && !Ml.flowing && !Ml.ended && Ml.length < Ml.highWaterMark && ($e("maybeReadMore read 0"), Pa.read(0), Su !== Ml.length); )
      Su = Ml.length;
    Ml.readingMore = !1;
  }
  Rn.prototype._read = function(Pa) {
    this.emit("error", new Error("_read() is not implemented"));
  }, Rn.prototype.pipe = function(Pa, Ml) {
    var Su = this, Tu = this._readableState;
    switch (Tu.pipesCount) {
      case 0:
        Tu.pipes = Pa;
        break;
      case 1:
        Tu.pipes = [Tu.pipes, Pa];
        break;
      default:
        Tu.pipes.push(Pa);
        break;
    }
    Tu.pipesCount += 1, $e("pipe count=%d opts=%j", Tu.pipesCount, Ml);
    var Au = (!Ml || Ml.end !== !1) && Pa !== process$1.stdout && Pa !== process$1.stderr, Zl = Au ? Uc : l2;
    Tu.endEmitted ? v.nextTick(Zl) : Su.once("end", Zl), Pa.on("unpipe", Iu);
    function Iu(Gc, Kc) {
      $e("onunpipe"), Gc === Su && Kc && Kc.hasUnpiped === !1 && (Kc.hasUnpiped = !0, th());
    }
    function Uc() {
      $e("onend"), Pa.end();
    }
    var Pu = Se(Su);
    Pa.on("drain", Pu);
    var Lu = !1;
    function th() {
      $e("cleanup"), Pa.removeListener("close", Mc), Pa.removeListener("finish", h1), Pa.removeListener("drain", Pu), Pa.removeListener("error", Gh), Pa.removeListener("unpipe", Iu), Su.removeListener("end", Uc), Su.removeListener("end", l2), Su.removeListener("data", N1), Lu = !0, Tu.awaitDrain && (!Pa._writableState || Pa._writableState.needDrain) && Pu();
    }
    var Zc = !1;
    Su.on("data", N1);
    function N1(Gc) {
      $e("ondata"), Zc = !1;
      var Kc = Pa.write(Gc);
      Kc === !1 && !Zc && ((Tu.pipesCount === 1 && Tu.pipes === Pa || Tu.pipesCount > 1 && Os(Tu.pipes, Pa) !== -1) && !Lu && ($e("false write response, pause", Tu.awaitDrain), Tu.awaitDrain++, Zc = !0), Su.pause());
    }
    function Gh(Gc) {
      $e("onerror", Gc), l2(), Pa.removeListener("error", Gh), ne(Pa, "error") === 0 && Pa.emit("error", Gc);
    }
    $n(Pa, "error", Gh);
    function Mc() {
      Pa.removeListener("finish", h1), l2();
    }
    Pa.once("close", Mc);
    function h1() {
      $e("onfinish"), Pa.removeListener("close", Mc), l2();
    }
    Pa.once("finish", h1);
    function l2() {
      $e("unpipe"), Su.unpipe(Pa);
    }
    return Pa.emit("pipe", Su), Tu.flowing || ($e("pipe resume"), Su.resume()), Pa;
  };
  function Se(Pa) {
    return function() {
      var Ml = Pa._readableState;
      $e("pipeOnDrain", Ml.awaitDrain), Ml.awaitDrain && Ml.awaitDrain--, Ml.awaitDrain === 0 && ne(Pa, "data") && (Ml.flowing = !0, Fe(Pa));
    };
  }
  Rn.prototype.unpipe = function(Pa) {
    var Ml = this._readableState, Su = { hasUnpiped: !1 };
    if (Ml.pipesCount === 0)
      return this;
    if (Ml.pipesCount === 1)
      return Pa && Pa !== Ml.pipes ? this : (Pa || (Pa = Ml.pipes), Ml.pipes = null, Ml.pipesCount = 0, Ml.flowing = !1, Pa && Pa.emit("unpipe", this, Su), this);
    if (!Pa) {
      var Tu = Ml.pipes, Au = Ml.pipesCount;
      Ml.pipes = null, Ml.pipesCount = 0, Ml.flowing = !1;
      for (var Zl = 0; Zl < Au; Zl++)
        Tu[Zl].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var Iu = Os(Ml.pipes, Pa);
    return Iu === -1 ? this : (Ml.pipes.splice(Iu, 1), Ml.pipesCount -= 1, Ml.pipesCount === 1 && (Ml.pipes = Ml.pipes[0]), Pa.emit("unpipe", this, Su), this);
  }, Rn.prototype.on = function(Pa, Ml) {
    var Su = ue.prototype.on.call(this, Pa, Ml);
    if (Pa === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (Pa === "readable") {
      var Tu = this._readableState;
      !Tu.endEmitted && !Tu.readableListening && (Tu.readableListening = Tu.needReadable = !0, Tu.emittedReadable = !1, Tu.reading ? Tu.length && ct(this) : v.nextTick(Oe, this));
    }
    return Su;
  }, Rn.prototype.addListener = Rn.prototype.on;
  function Oe(Pa) {
    $e("readable nexttick read 0"), Pa.read(0);
  }
  Rn.prototype.resume = function() {
    var Pa = this._readableState;
    return Pa.flowing || ($e("resume"), Pa.flowing = !0, Fr(this, Pa)), this;
  };
  function Fr(Pa, Ml) {
    Ml.resumeScheduled || (Ml.resumeScheduled = !0, v.nextTick(zn, Pa, Ml));
  }
  function zn(Pa, Ml) {
    Ml.reading || ($e("resume read 0"), Pa.read(0)), Ml.resumeScheduled = !1, Ml.awaitDrain = 0, Pa.emit("resume"), Fe(Pa), Ml.flowing && !Ml.reading && Pa.read(0);
  }
  Rn.prototype.pause = function() {
    return $e("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && ($e("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function Fe(Pa) {
    var Ml = Pa._readableState;
    for ($e("flow", Ml.flowing); Ml.flowing && Pa.read() !== null; )
      ;
  }
  Rn.prototype.wrap = function(Pa) {
    var Ml = this, Su = this._readableState, Tu = !1;
    Pa.on("end", function() {
      if ($e("wrapped end"), Su.decoder && !Su.ended) {
        var Iu = Su.decoder.end();
        Iu && Iu.length && Ml.push(Iu);
      }
      Ml.push(null);
    }), Pa.on("data", function(Iu) {
      if ($e("wrapped data"), Su.decoder && (Iu = Su.decoder.write(Iu)), !(Su.objectMode && Iu == null) && !(!Su.objectMode && (!Iu || !Iu.length))) {
        var Uc = Ml.push(Iu);
        Uc || (Tu = !0, Pa.pause());
      }
    });
    for (var Au in Pa)
      this[Au] === void 0 && typeof Pa[Au] == "function" && (this[Au] = /* @__PURE__ */ function(Iu) {
        return function() {
          return Pa[Iu].apply(Pa, arguments);
        };
      }(Au));
    for (var Zl = 0; Zl < br.length; Zl++)
      Pa.on(br[Zl], this.emit.bind(this, br[Zl]));
    return this._read = function(Iu) {
      $e("wrapped _read", Iu), Tu && (Tu = !1, Pa.resume());
    }, this;
  }, Object.defineProperty(Rn.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Rn._fromList = pe;
  function pe(Pa, Ml) {
    if (Ml.length === 0)
      return null;
    var Su;
    return Ml.objectMode ? Su = Ml.buffer.shift() : !Pa || Pa >= Ml.length ? (Ml.decoder ? Su = Ml.buffer.join("") : Ml.buffer.length === 1 ? Su = Ml.buffer.head.data : Su = Ml.buffer.concat(Ml.length), Ml.buffer.clear()) : Su = it(Pa, Ml.buffer, Ml.decoder), Su;
  }
  function it(Pa, Ml, Su) {
    var Tu;
    return Pa < Ml.head.data.length ? (Tu = Ml.head.data.slice(0, Pa), Ml.head.data = Ml.head.data.slice(Pa)) : Pa === Ml.head.data.length ? Tu = Ml.shift() : Tu = Su ? xa(Pa, Ml) : wo(Pa, Ml), Tu;
  }
  function xa(Pa, Ml) {
    var Su = Ml.head, Tu = 1, Au = Su.data;
    for (Pa -= Au.length; Su = Su.next; ) {
      var Zl = Su.data, Iu = Pa > Zl.length ? Zl.length : Pa;
      if (Iu === Zl.length ? Au += Zl : Au += Zl.slice(0, Pa), Pa -= Iu, Pa === 0) {
        Iu === Zl.length ? (++Tu, Su.next ? Ml.head = Su.next : Ml.head = Ml.tail = null) : (Ml.head = Su, Su.data = Zl.slice(Iu));
        break;
      }
      ++Tu;
    }
    return Ml.length -= Tu, Au;
  }
  function wo(Pa, Ml) {
    var Su = le.allocUnsafe(Pa), Tu = Ml.head, Au = 1;
    for (Tu.data.copy(Su), Pa -= Tu.data.length; Tu = Tu.next; ) {
      var Zl = Tu.data, Iu = Pa > Zl.length ? Zl.length : Pa;
      if (Zl.copy(Su, Su.length - Pa, 0, Iu), Pa -= Iu, Pa === 0) {
        Iu === Zl.length ? (++Au, Tu.next ? Ml.head = Tu.next : Ml.head = Ml.tail = null) : (Ml.head = Tu, Tu.data = Zl.slice(Iu));
        break;
      }
      ++Au;
    }
    return Ml.length -= Au, Su;
  }
  function _u(Pa) {
    var Ml = Pa._readableState;
    if (Ml.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    Ml.endEmitted || (Ml.ended = !0, v.nextTick(Oa, Ml, Pa));
  }
  function Oa(Pa, Ml) {
    !Pa.endEmitted && Pa.length === 0 && (Pa.endEmitted = !0, Ml.readable = !1, Ml.emit("end"));
  }
  function Os(Pa, Ml) {
    for (var Su = 0, Tu = Pa.length; Su < Tu; Su++)
      if (Pa[Su] === Ml)
        return Su;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform)
    return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = ne;
  var v = require_stream_duplex(), y = Object.create(requireUtil());
  y.inherits = requireInherits_browser(), y.inherits(ne, v);
  function z(he, ge) {
    var we = this._transformState;
    we.transforming = !1;
    var Ee = we.writecb;
    if (!Ee)
      return this.emit("error", new Error("write callback called multiple times"));
    we.writechunk = null, we.writecb = null, ge != null && this.push(ge), Ee(he);
    var xe = this._readableState;
    xe.reading = !1, (xe.needReadable || xe.length < xe.highWaterMark) && this._read(xe.highWaterMark);
  }
  function ne(he) {
    if (!(this instanceof ne))
      return new ne(he);
    v.call(this, he), this._transformState = {
      afterTransform: z.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, he && (typeof he.transform == "function" && (this._transform = he.transform), typeof he.flush == "function" && (this._flush = he.flush)), this.on("prefinish", ue);
  }
  function ue() {
    var he = this;
    typeof this._flush == "function" ? this._flush(function(ge, we) {
      le(he, ge, we);
    }) : le(this, null, null);
  }
  ne.prototype.push = function(he, ge) {
    return this._transformState.needTransform = !1, v.prototype.push.call(this, he, ge);
  }, ne.prototype._transform = function(he, ge, we) {
    throw new Error("_transform() is not implemented");
  }, ne.prototype._write = function(he, ge, we) {
    var Ee = this._transformState;
    if (Ee.writecb = we, Ee.writechunk = he, Ee.writeencoding = ge, !Ee.transforming) {
      var xe = this._readableState;
      (Ee.needTransform || xe.needReadable || xe.length < xe.highWaterMark) && this._read(xe.highWaterMark);
    }
  }, ne.prototype._read = function(he) {
    var ge = this._transformState;
    ge.writechunk !== null && ge.writecb && !ge.transforming ? (ge.transforming = !0, this._transform(ge.writechunk, ge.writeencoding, ge.afterTransform)) : ge.needTransform = !0;
  }, ne.prototype._destroy = function(he, ge) {
    var we = this;
    v.prototype._destroy.call(this, he, function(Ee) {
      ge(Ee), we.emit("close");
    });
  };
  function le(he, ge, we) {
    if (ge)
      return he.emit("error", ge);
    if (we != null && he.push(we), he._writableState.length)
      throw new Error("Calling transform done when ws.length != 0");
    if (he._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return he.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough)
    return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = z;
  var v = require_stream_transform(), y = Object.create(requireUtil());
  y.inherits = requireInherits_browser(), y.inherits(z, v);
  function z(ne) {
    if (!(this instanceof z))
      return new z(ne);
    v.call(this, ne);
  }
  return z.prototype._transform = function(ne, ue, le) {
    le(null, ne);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(v, y) {
    y = v.exports = require_stream_readable(), y.Stream = y, y.Readable = y, y.Writable = require_stream_writable(), y.Duplex = require_stream_duplex(), y.Transform = require_stream_transform(), y.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign = { exports: {} }, bn$4 = { exports: {} };
bn$4.exports;
(function(v) {
  (function(y, z) {
    function ne(be, ye) {
      if (!be)
        throw new Error(ye || "Assertion failed");
    }
    function ue(be, ye) {
      be.super_ = ye;
      var Se = function() {
      };
      Se.prototype = ye.prototype, be.prototype = new Se(), be.prototype.constructor = be;
    }
    function le(be, ye, Se) {
      if (le.isBN(be))
        return be;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, be !== null && ((ye === "le" || ye === "be") && (Se = ye, ye = 10), this._init(be || 0, ye || 10, Se || "be"));
    }
    typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
    var he;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
    } catch {
    }
    le.isBN = function(ye) {
      return ye instanceof le ? !0 : ye !== null && typeof ye == "object" && ye.constructor.wordSize === le.wordSize && Array.isArray(ye.words);
    }, le.max = function(ye, Se) {
      return ye.cmp(Se) > 0 ? ye : Se;
    }, le.min = function(ye, Se) {
      return ye.cmp(Se) < 0 ? ye : Se;
    }, le.prototype._init = function(ye, Se, Oe) {
      if (typeof ye == "number")
        return this._initNumber(ye, Se, Oe);
      if (typeof ye == "object")
        return this._initArray(ye, Se, Oe);
      Se === "hex" && (Se = 16), ne(Se === (Se | 0) && Se >= 2 && Se <= 36), ye = ye.toString().replace(/\s+/g, "");
      var Fr = 0;
      ye[0] === "-" && (Fr++, this.negative = 1), Fr < ye.length && (Se === 16 ? this._parseHex(ye, Fr, Oe) : (this._parseBase(ye, Se, Fr), Oe === "le" && this._initArray(this.toArray(), Se, Oe)));
    }, le.prototype._initNumber = function(ye, Se, Oe) {
      ye < 0 && (this.negative = 1, ye = -ye), ye < 67108864 ? (this.words = [ye & 67108863], this.length = 1) : ye < 4503599627370496 ? (this.words = [
        ye & 67108863,
        ye / 67108864 & 67108863
      ], this.length = 2) : (ne(ye < 9007199254740992), this.words = [
        ye & 67108863,
        ye / 67108864 & 67108863,
        1
      ], this.length = 3), Oe === "le" && this._initArray(this.toArray(), Se, Oe);
    }, le.prototype._initArray = function(ye, Se, Oe) {
      if (ne(typeof ye.length == "number"), ye.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(ye.length / 3), this.words = new Array(this.length);
      for (var Fr = 0; Fr < this.length; Fr++)
        this.words[Fr] = 0;
      var zn, Fe, pe = 0;
      if (Oe === "be")
        for (Fr = ye.length - 1, zn = 0; Fr >= 0; Fr -= 3)
          Fe = ye[Fr] | ye[Fr - 1] << 8 | ye[Fr - 2] << 16, this.words[zn] |= Fe << pe & 67108863, this.words[zn + 1] = Fe >>> 26 - pe & 67108863, pe += 24, pe >= 26 && (pe -= 26, zn++);
      else if (Oe === "le")
        for (Fr = 0, zn = 0; Fr < ye.length; Fr += 3)
          Fe = ye[Fr] | ye[Fr + 1] << 8 | ye[Fr + 2] << 16, this.words[zn] |= Fe << pe & 67108863, this.words[zn + 1] = Fe >>> 26 - pe & 67108863, pe += 24, pe >= 26 && (pe -= 26, zn++);
      return this._strip();
    };
    function ge(be, ye) {
      var Se = be.charCodeAt(ye);
      if (Se >= 48 && Se <= 57)
        return Se - 48;
      if (Se >= 65 && Se <= 70)
        return Se - 55;
      if (Se >= 97 && Se <= 102)
        return Se - 87;
      ne(!1, "Invalid character in " + be);
    }
    function we(be, ye, Se) {
      var Oe = ge(be, Se);
      return Se - 1 >= ye && (Oe |= ge(be, Se - 1) << 4), Oe;
    }
    le.prototype._parseHex = function(ye, Se, Oe) {
      this.length = Math.ceil((ye.length - Se) / 6), this.words = new Array(this.length);
      for (var Fr = 0; Fr < this.length; Fr++)
        this.words[Fr] = 0;
      var zn = 0, Fe = 0, pe;
      if (Oe === "be")
        for (Fr = ye.length - 1; Fr >= Se; Fr -= 2)
          pe = we(ye, Se, Fr) << zn, this.words[Fe] |= pe & 67108863, zn >= 18 ? (zn -= 18, Fe += 1, this.words[Fe] |= pe >>> 26) : zn += 8;
      else {
        var it = ye.length - Se;
        for (Fr = it % 2 === 0 ? Se + 1 : Se; Fr < ye.length; Fr += 2)
          pe = we(ye, Se, Fr) << zn, this.words[Fe] |= pe & 67108863, zn >= 18 ? (zn -= 18, Fe += 1, this.words[Fe] |= pe >>> 26) : zn += 8;
      }
      this._strip();
    };
    function Ee(be, ye, Se, Oe) {
      for (var Fr = 0, zn = 0, Fe = Math.min(be.length, Se), pe = ye; pe < Fe; pe++) {
        var it = be.charCodeAt(pe) - 48;
        Fr *= Oe, it >= 49 ? zn = it - 49 + 10 : it >= 17 ? zn = it - 17 + 10 : zn = it, ne(it >= 0 && zn < Oe, "Invalid character"), Fr += zn;
      }
      return Fr;
    }
    le.prototype._parseBase = function(ye, Se, Oe) {
      this.words = [0], this.length = 1;
      for (var Fr = 0, zn = 1; zn <= 67108863; zn *= Se)
        Fr++;
      Fr--, zn = zn / Se | 0;
      for (var Fe = ye.length - Oe, pe = Fe % Fr, it = Math.min(Fe, Fe - pe) + Oe, xa = 0, wo = Oe; wo < it; wo += Fr)
        xa = Ee(ye, wo, wo + Fr, Se), this.imuln(zn), this.words[0] + xa < 67108864 ? this.words[0] += xa : this._iaddn(xa);
      if (pe !== 0) {
        var _u = 1;
        for (xa = Ee(ye, wo, ye.length, Se), wo = 0; wo < pe; wo++)
          _u *= Se;
        this.imuln(_u), this.words[0] + xa < 67108864 ? this.words[0] += xa : this._iaddn(xa);
      }
      this._strip();
    }, le.prototype.copy = function(ye) {
      ye.words = new Array(this.length);
      for (var Se = 0; Se < this.length; Se++)
        ye.words[Se] = this.words[Se];
      ye.length = this.length, ye.negative = this.negative, ye.red = this.red;
    };
    function xe(be, ye) {
      be.words = ye.words, be.length = ye.length, be.negative = ye.negative, be.red = ye.red;
    }
    if (le.prototype._move = function(ye) {
      xe(ye, this);
    }, le.prototype.clone = function() {
      var ye = new le(null);
      return this.copy(ye), ye;
    }, le.prototype._expand = function(ye) {
      for (; this.length < ye; )
        this.words[this.length++] = 0;
      return this;
    }, le.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, le.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        le.prototype[Symbol.for("nodejs.util.inspect.custom")] = $e;
      } catch {
        le.prototype.inspect = $e;
      }
    else
      le.prototype.inspect = $e;
    function $e() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var Ne = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], st = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Nr = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    le.prototype.toString = function(ye, Se) {
      ye = ye || 10, Se = Se | 0 || 1;
      var Oe;
      if (ye === 16 || ye === "hex") {
        Oe = "";
        for (var Fr = 0, zn = 0, Fe = 0; Fe < this.length; Fe++) {
          var pe = this.words[Fe], it = ((pe << Fr | zn) & 16777215).toString(16);
          zn = pe >>> 24 - Fr & 16777215, Fr += 2, Fr >= 26 && (Fr -= 26, Fe--), zn !== 0 || Fe !== this.length - 1 ? Oe = Ne[6 - it.length] + it + Oe : Oe = it + Oe;
        }
        for (zn !== 0 && (Oe = zn.toString(16) + Oe); Oe.length % Se !== 0; )
          Oe = "0" + Oe;
        return this.negative !== 0 && (Oe = "-" + Oe), Oe;
      }
      if (ye === (ye | 0) && ye >= 2 && ye <= 36) {
        var xa = st[ye], wo = Nr[ye];
        Oe = "";
        var _u = this.clone();
        for (_u.negative = 0; !_u.isZero(); ) {
          var Oa = _u.modrn(wo).toString(ye);
          _u = _u.idivn(wo), _u.isZero() ? Oe = Oa + Oe : Oe = Ne[xa - Oa.length] + Oa + Oe;
        }
        for (this.isZero() && (Oe = "0" + Oe); Oe.length % Se !== 0; )
          Oe = "0" + Oe;
        return this.negative !== 0 && (Oe = "-" + Oe), Oe;
      }
      ne(!1, "Base should be between 2 and 36");
    }, le.prototype.toNumber = function() {
      var ye = this.words[0];
      return this.length === 2 ? ye += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? ye += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -ye : ye;
    }, le.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, he && (le.prototype.toBuffer = function(ye, Se) {
      return this.toArrayLike(he, ye, Se);
    }), le.prototype.toArray = function(ye, Se) {
      return this.toArrayLike(Array, ye, Se);
    };
    var br = function(ye, Se) {
      return ye.allocUnsafe ? ye.allocUnsafe(Se) : new ye(Se);
    };
    le.prototype.toArrayLike = function(ye, Se, Oe) {
      this._strip();
      var Fr = this.byteLength(), zn = Oe || Math.max(1, Fr);
      ne(Fr <= zn, "byte array longer than desired length"), ne(zn > 0, "Requested array length <= 0");
      var Fe = br(ye, zn), pe = Se === "le" ? "LE" : "BE";
      return this["_toArrayLike" + pe](Fe, Fr), Fe;
    }, le.prototype._toArrayLikeLE = function(ye, Se) {
      for (var Oe = 0, Fr = 0, zn = 0, Fe = 0; zn < this.length; zn++) {
        var pe = this.words[zn] << Fe | Fr;
        ye[Oe++] = pe & 255, Oe < ye.length && (ye[Oe++] = pe >> 8 & 255), Oe < ye.length && (ye[Oe++] = pe >> 16 & 255), Fe === 6 ? (Oe < ye.length && (ye[Oe++] = pe >> 24 & 255), Fr = 0, Fe = 0) : (Fr = pe >>> 24, Fe += 2);
      }
      if (Oe < ye.length)
        for (ye[Oe++] = Fr; Oe < ye.length; )
          ye[Oe++] = 0;
    }, le.prototype._toArrayLikeBE = function(ye, Se) {
      for (var Oe = ye.length - 1, Fr = 0, zn = 0, Fe = 0; zn < this.length; zn++) {
        var pe = this.words[zn] << Fe | Fr;
        ye[Oe--] = pe & 255, Oe >= 0 && (ye[Oe--] = pe >> 8 & 255), Oe >= 0 && (ye[Oe--] = pe >> 16 & 255), Fe === 6 ? (Oe >= 0 && (ye[Oe--] = pe >> 24 & 255), Fr = 0, Fe = 0) : (Fr = pe >>> 24, Fe += 2);
      }
      if (Oe >= 0)
        for (ye[Oe--] = Fr; Oe >= 0; )
          ye[Oe--] = 0;
    }, Math.clz32 ? le.prototype._countBits = function(ye) {
      return 32 - Math.clz32(ye);
    } : le.prototype._countBits = function(ye) {
      var Se = ye, Oe = 0;
      return Se >= 4096 && (Oe += 13, Se >>>= 13), Se >= 64 && (Oe += 7, Se >>>= 7), Se >= 8 && (Oe += 4, Se >>>= 4), Se >= 2 && (Oe += 2, Se >>>= 2), Oe + Se;
    }, le.prototype._zeroBits = function(ye) {
      if (ye === 0)
        return 26;
      var Se = ye, Oe = 0;
      return Se & 8191 || (Oe += 13, Se >>>= 13), Se & 127 || (Oe += 7, Se >>>= 7), Se & 15 || (Oe += 4, Se >>>= 4), Se & 3 || (Oe += 2, Se >>>= 2), Se & 1 || Oe++, Oe;
    }, le.prototype.bitLength = function() {
      var ye = this.words[this.length - 1], Se = this._countBits(ye);
      return (this.length - 1) * 26 + Se;
    };
    function $n(be) {
      for (var ye = new Array(be.bitLength()), Se = 0; Se < ye.length; Se++) {
        var Oe = Se / 26 | 0, Fr = Se % 26;
        ye[Se] = be.words[Oe] >>> Fr & 1;
      }
      return ye;
    }
    le.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var ye = 0, Se = 0; Se < this.length; Se++) {
        var Oe = this._zeroBits(this.words[Se]);
        if (ye += Oe, Oe !== 26)
          break;
      }
      return ye;
    }, le.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, le.prototype.toTwos = function(ye) {
      return this.negative !== 0 ? this.abs().inotn(ye).iaddn(1) : this.clone();
    }, le.prototype.fromTwos = function(ye) {
      return this.testn(ye - 1) ? this.notn(ye).iaddn(1).ineg() : this.clone();
    }, le.prototype.isNeg = function() {
      return this.negative !== 0;
    }, le.prototype.neg = function() {
      return this.clone().ineg();
    }, le.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, le.prototype.iuor = function(ye) {
      for (; this.length < ye.length; )
        this.words[this.length++] = 0;
      for (var Se = 0; Se < ye.length; Se++)
        this.words[Se] = this.words[Se] | ye.words[Se];
      return this._strip();
    }, le.prototype.ior = function(ye) {
      return ne((this.negative | ye.negative) === 0), this.iuor(ye);
    }, le.prototype.or = function(ye) {
      return this.length > ye.length ? this.clone().ior(ye) : ye.clone().ior(this);
    }, le.prototype.uor = function(ye) {
      return this.length > ye.length ? this.clone().iuor(ye) : ye.clone().iuor(this);
    }, le.prototype.iuand = function(ye) {
      var Se;
      this.length > ye.length ? Se = ye : Se = this;
      for (var Oe = 0; Oe < Se.length; Oe++)
        this.words[Oe] = this.words[Oe] & ye.words[Oe];
      return this.length = Se.length, this._strip();
    }, le.prototype.iand = function(ye) {
      return ne((this.negative | ye.negative) === 0), this.iuand(ye);
    }, le.prototype.and = function(ye) {
      return this.length > ye.length ? this.clone().iand(ye) : ye.clone().iand(this);
    }, le.prototype.uand = function(ye) {
      return this.length > ye.length ? this.clone().iuand(ye) : ye.clone().iuand(this);
    }, le.prototype.iuxor = function(ye) {
      var Se, Oe;
      this.length > ye.length ? (Se = this, Oe = ye) : (Se = ye, Oe = this);
      for (var Fr = 0; Fr < Oe.length; Fr++)
        this.words[Fr] = Se.words[Fr] ^ Oe.words[Fr];
      if (this !== Se)
        for (; Fr < Se.length; Fr++)
          this.words[Fr] = Se.words[Fr];
      return this.length = Se.length, this._strip();
    }, le.prototype.ixor = function(ye) {
      return ne((this.negative | ye.negative) === 0), this.iuxor(ye);
    }, le.prototype.xor = function(ye) {
      return this.length > ye.length ? this.clone().ixor(ye) : ye.clone().ixor(this);
    }, le.prototype.uxor = function(ye) {
      return this.length > ye.length ? this.clone().iuxor(ye) : ye.clone().iuxor(this);
    }, le.prototype.inotn = function(ye) {
      ne(typeof ye == "number" && ye >= 0);
      var Se = Math.ceil(ye / 26) | 0, Oe = ye % 26;
      this._expand(Se), Oe > 0 && Se--;
      for (var Fr = 0; Fr < Se; Fr++)
        this.words[Fr] = ~this.words[Fr] & 67108863;
      return Oe > 0 && (this.words[Fr] = ~this.words[Fr] & 67108863 >> 26 - Oe), this._strip();
    }, le.prototype.notn = function(ye) {
      return this.clone().inotn(ye);
    }, le.prototype.setn = function(ye, Se) {
      ne(typeof ye == "number" && ye >= 0);
      var Oe = ye / 26 | 0, Fr = ye % 26;
      return this._expand(Oe + 1), Se ? this.words[Oe] = this.words[Oe] | 1 << Fr : this.words[Oe] = this.words[Oe] & ~(1 << Fr), this._strip();
    }, le.prototype.iadd = function(ye) {
      var Se;
      if (this.negative !== 0 && ye.negative === 0)
        return this.negative = 0, Se = this.isub(ye), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && ye.negative !== 0)
        return ye.negative = 0, Se = this.isub(ye), ye.negative = 1, Se._normSign();
      var Oe, Fr;
      this.length > ye.length ? (Oe = this, Fr = ye) : (Oe = ye, Fr = this);
      for (var zn = 0, Fe = 0; Fe < Fr.length; Fe++)
        Se = (Oe.words[Fe] | 0) + (Fr.words[Fe] | 0) + zn, this.words[Fe] = Se & 67108863, zn = Se >>> 26;
      for (; zn !== 0 && Fe < Oe.length; Fe++)
        Se = (Oe.words[Fe] | 0) + zn, this.words[Fe] = Se & 67108863, zn = Se >>> 26;
      if (this.length = Oe.length, zn !== 0)
        this.words[this.length] = zn, this.length++;
      else if (Oe !== this)
        for (; Fe < Oe.length; Fe++)
          this.words[Fe] = Oe.words[Fe];
      return this;
    }, le.prototype.add = function(ye) {
      var Se;
      return ye.negative !== 0 && this.negative === 0 ? (ye.negative = 0, Se = this.sub(ye), ye.negative ^= 1, Se) : ye.negative === 0 && this.negative !== 0 ? (this.negative = 0, Se = ye.sub(this), this.negative = 1, Se) : this.length > ye.length ? this.clone().iadd(ye) : ye.clone().iadd(this);
    }, le.prototype.isub = function(ye) {
      if (ye.negative !== 0) {
        ye.negative = 0;
        var Se = this.iadd(ye);
        return ye.negative = 1, Se._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(ye), this.negative = 1, this._normSign();
      var Oe = this.cmp(ye);
      if (Oe === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var Fr, zn;
      Oe > 0 ? (Fr = this, zn = ye) : (Fr = ye, zn = this);
      for (var Fe = 0, pe = 0; pe < zn.length; pe++)
        Se = (Fr.words[pe] | 0) - (zn.words[pe] | 0) + Fe, Fe = Se >> 26, this.words[pe] = Se & 67108863;
      for (; Fe !== 0 && pe < Fr.length; pe++)
        Se = (Fr.words[pe] | 0) + Fe, Fe = Se >> 26, this.words[pe] = Se & 67108863;
      if (Fe === 0 && pe < Fr.length && Fr !== this)
        for (; pe < Fr.length; pe++)
          this.words[pe] = Fr.words[pe];
      return this.length = Math.max(this.length, pe), Fr !== this && (this.negative = 1), this._strip();
    }, le.prototype.sub = function(ye) {
      return this.clone().isub(ye);
    };
    function En(be, ye, Se) {
      Se.negative = ye.negative ^ be.negative;
      var Oe = be.length + ye.length | 0;
      Se.length = Oe, Oe = Oe - 1 | 0;
      var Fr = be.words[0] | 0, zn = ye.words[0] | 0, Fe = Fr * zn, pe = Fe & 67108863, it = Fe / 67108864 | 0;
      Se.words[0] = pe;
      for (var xa = 1; xa < Oe; xa++) {
        for (var wo = it >>> 26, _u = it & 67108863, Oa = Math.min(xa, ye.length - 1), Os = Math.max(0, xa - be.length + 1); Os <= Oa; Os++) {
          var Pa = xa - Os | 0;
          Fr = be.words[Pa] | 0, zn = ye.words[Os] | 0, Fe = Fr * zn + _u, wo += Fe / 67108864 | 0, _u = Fe & 67108863;
        }
        Se.words[xa] = _u | 0, it = wo | 0;
      }
      return it !== 0 ? Se.words[xa] = it | 0 : Se.length--, Se._strip();
    }
    var Rn = function(ye, Se, Oe) {
      var Fr = ye.words, zn = Se.words, Fe = Oe.words, pe = 0, it, xa, wo, _u = Fr[0] | 0, Oa = _u & 8191, Os = _u >>> 13, Pa = Fr[1] | 0, Ml = Pa & 8191, Su = Pa >>> 13, Tu = Fr[2] | 0, Au = Tu & 8191, Zl = Tu >>> 13, Iu = Fr[3] | 0, Uc = Iu & 8191, Pu = Iu >>> 13, Lu = Fr[4] | 0, th = Lu & 8191, Zc = Lu >>> 13, N1 = Fr[5] | 0, Gh = N1 & 8191, Mc = N1 >>> 13, h1 = Fr[6] | 0, l2 = h1 & 8191, Gc = h1 >>> 13, Kc = Fr[7] | 0, M2 = Kc & 8191, d1 = Kc >>> 13, K1 = Fr[8] | 0, k2 = K1 & 8191, Eu = K1 >>> 13, Zo = Fr[9] | 0, Fl = Zo & 8191, Ru = Zo >>> 13, ku = zn[0] | 0, kc = ku & 8191, Ou = ku >>> 13, U1 = zn[1] | 0, g2 = U1 & 8191, Ic = U1 >>> 13, X1 = zn[2] | 0, $2 = X1 & 8191, ah = X1 >>> 13, O1 = zn[3] | 0, T2 = O1 & 8191, ih = O1 >>> 13, oh = zn[4] | 0, j2 = oh & 8191, lh = oh >>> 13, kh = zn[5] | 0, P2 = kh & 8191, ch = kh >>> 13, Nh = zn[6] | 0, L2 = Nh & 8191, yh = Nh >>> 13, Dh = zn[7] | 0, F2 = Dh & 8191, Mu = Dh >>> 13, Du = zn[8] | 0, eh = Du & 8191, Nc = Du >>> 13, z1 = zn[9] | 0, A2 = z1 & 8191, b2 = z1 >>> 13;
      Oe.negative = ye.negative ^ Se.negative, Oe.length = 19, it = Math.imul(Oa, kc), xa = Math.imul(Oa, Ou), xa = xa + Math.imul(Os, kc) | 0, wo = Math.imul(Os, Ou);
      var R2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, it = Math.imul(Ml, kc), xa = Math.imul(Ml, Ou), xa = xa + Math.imul(Su, kc) | 0, wo = Math.imul(Su, Ou), it = it + Math.imul(Oa, g2) | 0, xa = xa + Math.imul(Oa, Ic) | 0, xa = xa + Math.imul(Os, g2) | 0, wo = wo + Math.imul(Os, Ic) | 0;
      var D2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, it = Math.imul(Au, kc), xa = Math.imul(Au, Ou), xa = xa + Math.imul(Zl, kc) | 0, wo = Math.imul(Zl, Ou), it = it + Math.imul(Ml, g2) | 0, xa = xa + Math.imul(Ml, Ic) | 0, xa = xa + Math.imul(Su, g2) | 0, wo = wo + Math.imul(Su, Ic) | 0, it = it + Math.imul(Oa, $2) | 0, xa = xa + Math.imul(Oa, ah) | 0, xa = xa + Math.imul(Os, $2) | 0, wo = wo + Math.imul(Os, ah) | 0;
      var I2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, it = Math.imul(Uc, kc), xa = Math.imul(Uc, Ou), xa = xa + Math.imul(Pu, kc) | 0, wo = Math.imul(Pu, Ou), it = it + Math.imul(Au, g2) | 0, xa = xa + Math.imul(Au, Ic) | 0, xa = xa + Math.imul(Zl, g2) | 0, wo = wo + Math.imul(Zl, Ic) | 0, it = it + Math.imul(Ml, $2) | 0, xa = xa + Math.imul(Ml, ah) | 0, xa = xa + Math.imul(Su, $2) | 0, wo = wo + Math.imul(Su, ah) | 0, it = it + Math.imul(Oa, T2) | 0, xa = xa + Math.imul(Oa, ih) | 0, xa = xa + Math.imul(Os, T2) | 0, wo = wo + Math.imul(Os, ih) | 0;
      var N2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, it = Math.imul(th, kc), xa = Math.imul(th, Ou), xa = xa + Math.imul(Zc, kc) | 0, wo = Math.imul(Zc, Ou), it = it + Math.imul(Uc, g2) | 0, xa = xa + Math.imul(Uc, Ic) | 0, xa = xa + Math.imul(Pu, g2) | 0, wo = wo + Math.imul(Pu, Ic) | 0, it = it + Math.imul(Au, $2) | 0, xa = xa + Math.imul(Au, ah) | 0, xa = xa + Math.imul(Zl, $2) | 0, wo = wo + Math.imul(Zl, ah) | 0, it = it + Math.imul(Ml, T2) | 0, xa = xa + Math.imul(Ml, ih) | 0, xa = xa + Math.imul(Su, T2) | 0, wo = wo + Math.imul(Su, ih) | 0, it = it + Math.imul(Oa, j2) | 0, xa = xa + Math.imul(Oa, lh) | 0, xa = xa + Math.imul(Os, j2) | 0, wo = wo + Math.imul(Os, lh) | 0;
      var B2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, it = Math.imul(Gh, kc), xa = Math.imul(Gh, Ou), xa = xa + Math.imul(Mc, kc) | 0, wo = Math.imul(Mc, Ou), it = it + Math.imul(th, g2) | 0, xa = xa + Math.imul(th, Ic) | 0, xa = xa + Math.imul(Zc, g2) | 0, wo = wo + Math.imul(Zc, Ic) | 0, it = it + Math.imul(Uc, $2) | 0, xa = xa + Math.imul(Uc, ah) | 0, xa = xa + Math.imul(Pu, $2) | 0, wo = wo + Math.imul(Pu, ah) | 0, it = it + Math.imul(Au, T2) | 0, xa = xa + Math.imul(Au, ih) | 0, xa = xa + Math.imul(Zl, T2) | 0, wo = wo + Math.imul(Zl, ih) | 0, it = it + Math.imul(Ml, j2) | 0, xa = xa + Math.imul(Ml, lh) | 0, xa = xa + Math.imul(Su, j2) | 0, wo = wo + Math.imul(Su, lh) | 0, it = it + Math.imul(Oa, P2) | 0, xa = xa + Math.imul(Oa, ch) | 0, xa = xa + Math.imul(Os, P2) | 0, wo = wo + Math.imul(Os, ch) | 0;
      var z2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, it = Math.imul(l2, kc), xa = Math.imul(l2, Ou), xa = xa + Math.imul(Gc, kc) | 0, wo = Math.imul(Gc, Ou), it = it + Math.imul(Gh, g2) | 0, xa = xa + Math.imul(Gh, Ic) | 0, xa = xa + Math.imul(Mc, g2) | 0, wo = wo + Math.imul(Mc, Ic) | 0, it = it + Math.imul(th, $2) | 0, xa = xa + Math.imul(th, ah) | 0, xa = xa + Math.imul(Zc, $2) | 0, wo = wo + Math.imul(Zc, ah) | 0, it = it + Math.imul(Uc, T2) | 0, xa = xa + Math.imul(Uc, ih) | 0, xa = xa + Math.imul(Pu, T2) | 0, wo = wo + Math.imul(Pu, ih) | 0, it = it + Math.imul(Au, j2) | 0, xa = xa + Math.imul(Au, lh) | 0, xa = xa + Math.imul(Zl, j2) | 0, wo = wo + Math.imul(Zl, lh) | 0, it = it + Math.imul(Ml, P2) | 0, xa = xa + Math.imul(Ml, ch) | 0, xa = xa + Math.imul(Su, P2) | 0, wo = wo + Math.imul(Su, ch) | 0, it = it + Math.imul(Oa, L2) | 0, xa = xa + Math.imul(Oa, yh) | 0, xa = xa + Math.imul(Os, L2) | 0, wo = wo + Math.imul(Os, yh) | 0;
      var W2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, it = Math.imul(M2, kc), xa = Math.imul(M2, Ou), xa = xa + Math.imul(d1, kc) | 0, wo = Math.imul(d1, Ou), it = it + Math.imul(l2, g2) | 0, xa = xa + Math.imul(l2, Ic) | 0, xa = xa + Math.imul(Gc, g2) | 0, wo = wo + Math.imul(Gc, Ic) | 0, it = it + Math.imul(Gh, $2) | 0, xa = xa + Math.imul(Gh, ah) | 0, xa = xa + Math.imul(Mc, $2) | 0, wo = wo + Math.imul(Mc, ah) | 0, it = it + Math.imul(th, T2) | 0, xa = xa + Math.imul(th, ih) | 0, xa = xa + Math.imul(Zc, T2) | 0, wo = wo + Math.imul(Zc, ih) | 0, it = it + Math.imul(Uc, j2) | 0, xa = xa + Math.imul(Uc, lh) | 0, xa = xa + Math.imul(Pu, j2) | 0, wo = wo + Math.imul(Pu, lh) | 0, it = it + Math.imul(Au, P2) | 0, xa = xa + Math.imul(Au, ch) | 0, xa = xa + Math.imul(Zl, P2) | 0, wo = wo + Math.imul(Zl, ch) | 0, it = it + Math.imul(Ml, L2) | 0, xa = xa + Math.imul(Ml, yh) | 0, xa = xa + Math.imul(Su, L2) | 0, wo = wo + Math.imul(Su, yh) | 0, it = it + Math.imul(Oa, F2) | 0, xa = xa + Math.imul(Oa, Mu) | 0, xa = xa + Math.imul(Os, F2) | 0, wo = wo + Math.imul(Os, Mu) | 0;
      var V2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, it = Math.imul(k2, kc), xa = Math.imul(k2, Ou), xa = xa + Math.imul(Eu, kc) | 0, wo = Math.imul(Eu, Ou), it = it + Math.imul(M2, g2) | 0, xa = xa + Math.imul(M2, Ic) | 0, xa = xa + Math.imul(d1, g2) | 0, wo = wo + Math.imul(d1, Ic) | 0, it = it + Math.imul(l2, $2) | 0, xa = xa + Math.imul(l2, ah) | 0, xa = xa + Math.imul(Gc, $2) | 0, wo = wo + Math.imul(Gc, ah) | 0, it = it + Math.imul(Gh, T2) | 0, xa = xa + Math.imul(Gh, ih) | 0, xa = xa + Math.imul(Mc, T2) | 0, wo = wo + Math.imul(Mc, ih) | 0, it = it + Math.imul(th, j2) | 0, xa = xa + Math.imul(th, lh) | 0, xa = xa + Math.imul(Zc, j2) | 0, wo = wo + Math.imul(Zc, lh) | 0, it = it + Math.imul(Uc, P2) | 0, xa = xa + Math.imul(Uc, ch) | 0, xa = xa + Math.imul(Pu, P2) | 0, wo = wo + Math.imul(Pu, ch) | 0, it = it + Math.imul(Au, L2) | 0, xa = xa + Math.imul(Au, yh) | 0, xa = xa + Math.imul(Zl, L2) | 0, wo = wo + Math.imul(Zl, yh) | 0, it = it + Math.imul(Ml, F2) | 0, xa = xa + Math.imul(Ml, Mu) | 0, xa = xa + Math.imul(Su, F2) | 0, wo = wo + Math.imul(Su, Mu) | 0, it = it + Math.imul(Oa, eh) | 0, xa = xa + Math.imul(Oa, Nc) | 0, xa = xa + Math.imul(Os, eh) | 0, wo = wo + Math.imul(Os, Nc) | 0;
      var Z2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, it = Math.imul(Fl, kc), xa = Math.imul(Fl, Ou), xa = xa + Math.imul(Ru, kc) | 0, wo = Math.imul(Ru, Ou), it = it + Math.imul(k2, g2) | 0, xa = xa + Math.imul(k2, Ic) | 0, xa = xa + Math.imul(Eu, g2) | 0, wo = wo + Math.imul(Eu, Ic) | 0, it = it + Math.imul(M2, $2) | 0, xa = xa + Math.imul(M2, ah) | 0, xa = xa + Math.imul(d1, $2) | 0, wo = wo + Math.imul(d1, ah) | 0, it = it + Math.imul(l2, T2) | 0, xa = xa + Math.imul(l2, ih) | 0, xa = xa + Math.imul(Gc, T2) | 0, wo = wo + Math.imul(Gc, ih) | 0, it = it + Math.imul(Gh, j2) | 0, xa = xa + Math.imul(Gh, lh) | 0, xa = xa + Math.imul(Mc, j2) | 0, wo = wo + Math.imul(Mc, lh) | 0, it = it + Math.imul(th, P2) | 0, xa = xa + Math.imul(th, ch) | 0, xa = xa + Math.imul(Zc, P2) | 0, wo = wo + Math.imul(Zc, ch) | 0, it = it + Math.imul(Uc, L2) | 0, xa = xa + Math.imul(Uc, yh) | 0, xa = xa + Math.imul(Pu, L2) | 0, wo = wo + Math.imul(Pu, yh) | 0, it = it + Math.imul(Au, F2) | 0, xa = xa + Math.imul(Au, Mu) | 0, xa = xa + Math.imul(Zl, F2) | 0, wo = wo + Math.imul(Zl, Mu) | 0, it = it + Math.imul(Ml, eh) | 0, xa = xa + Math.imul(Ml, Nc) | 0, xa = xa + Math.imul(Su, eh) | 0, wo = wo + Math.imul(Su, Nc) | 0, it = it + Math.imul(Oa, A2) | 0, xa = xa + Math.imul(Oa, b2) | 0, xa = xa + Math.imul(Os, A2) | 0, wo = wo + Math.imul(Os, b2) | 0;
      var G2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, it = Math.imul(Fl, g2), xa = Math.imul(Fl, Ic), xa = xa + Math.imul(Ru, g2) | 0, wo = Math.imul(Ru, Ic), it = it + Math.imul(k2, $2) | 0, xa = xa + Math.imul(k2, ah) | 0, xa = xa + Math.imul(Eu, $2) | 0, wo = wo + Math.imul(Eu, ah) | 0, it = it + Math.imul(M2, T2) | 0, xa = xa + Math.imul(M2, ih) | 0, xa = xa + Math.imul(d1, T2) | 0, wo = wo + Math.imul(d1, ih) | 0, it = it + Math.imul(l2, j2) | 0, xa = xa + Math.imul(l2, lh) | 0, xa = xa + Math.imul(Gc, j2) | 0, wo = wo + Math.imul(Gc, lh) | 0, it = it + Math.imul(Gh, P2) | 0, xa = xa + Math.imul(Gh, ch) | 0, xa = xa + Math.imul(Mc, P2) | 0, wo = wo + Math.imul(Mc, ch) | 0, it = it + Math.imul(th, L2) | 0, xa = xa + Math.imul(th, yh) | 0, xa = xa + Math.imul(Zc, L2) | 0, wo = wo + Math.imul(Zc, yh) | 0, it = it + Math.imul(Uc, F2) | 0, xa = xa + Math.imul(Uc, Mu) | 0, xa = xa + Math.imul(Pu, F2) | 0, wo = wo + Math.imul(Pu, Mu) | 0, it = it + Math.imul(Au, eh) | 0, xa = xa + Math.imul(Au, Nc) | 0, xa = xa + Math.imul(Zl, eh) | 0, wo = wo + Math.imul(Zl, Nc) | 0, it = it + Math.imul(Ml, A2) | 0, xa = xa + Math.imul(Ml, b2) | 0, xa = xa + Math.imul(Su, A2) | 0, wo = wo + Math.imul(Su, b2) | 0;
      var K2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, it = Math.imul(Fl, $2), xa = Math.imul(Fl, ah), xa = xa + Math.imul(Ru, $2) | 0, wo = Math.imul(Ru, ah), it = it + Math.imul(k2, T2) | 0, xa = xa + Math.imul(k2, ih) | 0, xa = xa + Math.imul(Eu, T2) | 0, wo = wo + Math.imul(Eu, ih) | 0, it = it + Math.imul(M2, j2) | 0, xa = xa + Math.imul(M2, lh) | 0, xa = xa + Math.imul(d1, j2) | 0, wo = wo + Math.imul(d1, lh) | 0, it = it + Math.imul(l2, P2) | 0, xa = xa + Math.imul(l2, ch) | 0, xa = xa + Math.imul(Gc, P2) | 0, wo = wo + Math.imul(Gc, ch) | 0, it = it + Math.imul(Gh, L2) | 0, xa = xa + Math.imul(Gh, yh) | 0, xa = xa + Math.imul(Mc, L2) | 0, wo = wo + Math.imul(Mc, yh) | 0, it = it + Math.imul(th, F2) | 0, xa = xa + Math.imul(th, Mu) | 0, xa = xa + Math.imul(Zc, F2) | 0, wo = wo + Math.imul(Zc, Mu) | 0, it = it + Math.imul(Uc, eh) | 0, xa = xa + Math.imul(Uc, Nc) | 0, xa = xa + Math.imul(Pu, eh) | 0, wo = wo + Math.imul(Pu, Nc) | 0, it = it + Math.imul(Au, A2) | 0, xa = xa + Math.imul(Au, b2) | 0, xa = xa + Math.imul(Zl, A2) | 0, wo = wo + Math.imul(Zl, b2) | 0;
      var Y2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, it = Math.imul(Fl, T2), xa = Math.imul(Fl, ih), xa = xa + Math.imul(Ru, T2) | 0, wo = Math.imul(Ru, ih), it = it + Math.imul(k2, j2) | 0, xa = xa + Math.imul(k2, lh) | 0, xa = xa + Math.imul(Eu, j2) | 0, wo = wo + Math.imul(Eu, lh) | 0, it = it + Math.imul(M2, P2) | 0, xa = xa + Math.imul(M2, ch) | 0, xa = xa + Math.imul(d1, P2) | 0, wo = wo + Math.imul(d1, ch) | 0, it = it + Math.imul(l2, L2) | 0, xa = xa + Math.imul(l2, yh) | 0, xa = xa + Math.imul(Gc, L2) | 0, wo = wo + Math.imul(Gc, yh) | 0, it = it + Math.imul(Gh, F2) | 0, xa = xa + Math.imul(Gh, Mu) | 0, xa = xa + Math.imul(Mc, F2) | 0, wo = wo + Math.imul(Mc, Mu) | 0, it = it + Math.imul(th, eh) | 0, xa = xa + Math.imul(th, Nc) | 0, xa = xa + Math.imul(Zc, eh) | 0, wo = wo + Math.imul(Zc, Nc) | 0, it = it + Math.imul(Uc, A2) | 0, xa = xa + Math.imul(Uc, b2) | 0, xa = xa + Math.imul(Pu, A2) | 0, wo = wo + Math.imul(Pu, b2) | 0;
      var J2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, it = Math.imul(Fl, j2), xa = Math.imul(Fl, lh), xa = xa + Math.imul(Ru, j2) | 0, wo = Math.imul(Ru, lh), it = it + Math.imul(k2, P2) | 0, xa = xa + Math.imul(k2, ch) | 0, xa = xa + Math.imul(Eu, P2) | 0, wo = wo + Math.imul(Eu, ch) | 0, it = it + Math.imul(M2, L2) | 0, xa = xa + Math.imul(M2, yh) | 0, xa = xa + Math.imul(d1, L2) | 0, wo = wo + Math.imul(d1, yh) | 0, it = it + Math.imul(l2, F2) | 0, xa = xa + Math.imul(l2, Mu) | 0, xa = xa + Math.imul(Gc, F2) | 0, wo = wo + Math.imul(Gc, Mu) | 0, it = it + Math.imul(Gh, eh) | 0, xa = xa + Math.imul(Gh, Nc) | 0, xa = xa + Math.imul(Mc, eh) | 0, wo = wo + Math.imul(Mc, Nc) | 0, it = it + Math.imul(th, A2) | 0, xa = xa + Math.imul(th, b2) | 0, xa = xa + Math.imul(Zc, A2) | 0, wo = wo + Math.imul(Zc, b2) | 0;
      var Q2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, it = Math.imul(Fl, P2), xa = Math.imul(Fl, ch), xa = xa + Math.imul(Ru, P2) | 0, wo = Math.imul(Ru, ch), it = it + Math.imul(k2, L2) | 0, xa = xa + Math.imul(k2, yh) | 0, xa = xa + Math.imul(Eu, L2) | 0, wo = wo + Math.imul(Eu, yh) | 0, it = it + Math.imul(M2, F2) | 0, xa = xa + Math.imul(M2, Mu) | 0, xa = xa + Math.imul(d1, F2) | 0, wo = wo + Math.imul(d1, Mu) | 0, it = it + Math.imul(l2, eh) | 0, xa = xa + Math.imul(l2, Nc) | 0, xa = xa + Math.imul(Gc, eh) | 0, wo = wo + Math.imul(Gc, Nc) | 0, it = it + Math.imul(Gh, A2) | 0, xa = xa + Math.imul(Gh, b2) | 0, xa = xa + Math.imul(Mc, A2) | 0, wo = wo + Math.imul(Mc, b2) | 0;
      var X2 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, it = Math.imul(Fl, L2), xa = Math.imul(Fl, yh), xa = xa + Math.imul(Ru, L2) | 0, wo = Math.imul(Ru, yh), it = it + Math.imul(k2, F2) | 0, xa = xa + Math.imul(k2, Mu) | 0, xa = xa + Math.imul(Eu, F2) | 0, wo = wo + Math.imul(Eu, Mu) | 0, it = it + Math.imul(M2, eh) | 0, xa = xa + Math.imul(M2, Nc) | 0, xa = xa + Math.imul(d1, eh) | 0, wo = wo + Math.imul(d1, Nc) | 0, it = it + Math.imul(l2, A2) | 0, xa = xa + Math.imul(l2, b2) | 0, xa = xa + Math.imul(Gc, A2) | 0, wo = wo + Math.imul(Gc, b2) | 0;
      var ep = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, it = Math.imul(Fl, F2), xa = Math.imul(Fl, Mu), xa = xa + Math.imul(Ru, F2) | 0, wo = Math.imul(Ru, Mu), it = it + Math.imul(k2, eh) | 0, xa = xa + Math.imul(k2, Nc) | 0, xa = xa + Math.imul(Eu, eh) | 0, wo = wo + Math.imul(Eu, Nc) | 0, it = it + Math.imul(M2, A2) | 0, xa = xa + Math.imul(M2, b2) | 0, xa = xa + Math.imul(d1, A2) | 0, wo = wo + Math.imul(d1, b2) | 0;
      var im = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, it = Math.imul(Fl, eh), xa = Math.imul(Fl, Nc), xa = xa + Math.imul(Ru, eh) | 0, wo = Math.imul(Ru, Nc), it = it + Math.imul(k2, A2) | 0, xa = xa + Math.imul(k2, b2) | 0, xa = xa + Math.imul(Eu, A2) | 0, wo = wo + Math.imul(Eu, b2) | 0;
      var t3 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      pe = (wo + (xa >>> 13) | 0) + (t3 >>> 26) | 0, t3 &= 67108863, it = Math.imul(Fl, A2), xa = Math.imul(Fl, b2), xa = xa + Math.imul(Ru, A2) | 0, wo = Math.imul(Ru, b2);
      var r3 = (pe + it | 0) + ((xa & 8191) << 13) | 0;
      return pe = (wo + (xa >>> 13) | 0) + (r3 >>> 26) | 0, r3 &= 67108863, Fe[0] = R2, Fe[1] = D2, Fe[2] = I2, Fe[3] = N2, Fe[4] = B2, Fe[5] = z2, Fe[6] = W2, Fe[7] = V2, Fe[8] = Z2, Fe[9] = G2, Fe[10] = K2, Fe[11] = Y2, Fe[12] = J2, Fe[13] = Q2, Fe[14] = X2, Fe[15] = ep, Fe[16] = im, Fe[17] = t3, Fe[18] = r3, pe !== 0 && (Fe[19] = pe, Oe.length++), Oe;
    };
    Math.imul || (Rn = En);
    function wa(be, ye, Se) {
      Se.negative = ye.negative ^ be.negative, Se.length = be.length + ye.length;
      for (var Oe = 0, Fr = 0, zn = 0; zn < Se.length - 1; zn++) {
        var Fe = Fr;
        Fr = 0;
        for (var pe = Oe & 67108863, it = Math.min(zn, ye.length - 1), xa = Math.max(0, zn - be.length + 1); xa <= it; xa++) {
          var wo = zn - xa, _u = be.words[wo] | 0, Oa = ye.words[xa] | 0, Os = _u * Oa, Pa = Os & 67108863;
          Fe = Fe + (Os / 67108864 | 0) | 0, Pa = Pa + pe | 0, pe = Pa & 67108863, Fe = Fe + (Pa >>> 26) | 0, Fr += Fe >>> 26, Fe &= 67108863;
        }
        Se.words[zn] = pe, Oe = Fe, Fe = Fr;
      }
      return Oe !== 0 ? Se.words[zn] = Oe : Se.length--, Se._strip();
    }
    function Aa(be, ye, Se) {
      return wa(be, ye, Se);
    }
    le.prototype.mulTo = function(ye, Se) {
      var Oe, Fr = this.length + ye.length;
      return this.length === 10 && ye.length === 10 ? Oe = Rn(this, ye, Se) : Fr < 63 ? Oe = En(this, ye, Se) : Fr < 1024 ? Oe = wa(this, ye, Se) : Oe = Aa(this, ye, Se), Oe;
    }, le.prototype.mul = function(ye) {
      var Se = new le(null);
      return Se.words = new Array(this.length + ye.length), this.mulTo(ye, Se);
    }, le.prototype.mulf = function(ye) {
      var Se = new le(null);
      return Se.words = new Array(this.length + ye.length), Aa(this, ye, Se);
    }, le.prototype.imul = function(ye) {
      return this.clone().mulTo(ye, this);
    }, le.prototype.imuln = function(ye) {
      var Se = ye < 0;
      Se && (ye = -ye), ne(typeof ye == "number"), ne(ye < 67108864);
      for (var Oe = 0, Fr = 0; Fr < this.length; Fr++) {
        var zn = (this.words[Fr] | 0) * ye, Fe = (zn & 67108863) + (Oe & 67108863);
        Oe >>= 26, Oe += zn / 67108864 | 0, Oe += Fe >>> 26, this.words[Fr] = Fe & 67108863;
      }
      return Oe !== 0 && (this.words[Fr] = Oe, this.length++), Se ? this.ineg() : this;
    }, le.prototype.muln = function(ye) {
      return this.clone().imuln(ye);
    }, le.prototype.sqr = function() {
      return this.mul(this);
    }, le.prototype.isqr = function() {
      return this.imul(this.clone());
    }, le.prototype.pow = function(ye) {
      var Se = $n(ye);
      if (Se.length === 0)
        return new le(1);
      for (var Oe = this, Fr = 0; Fr < Se.length && Se[Fr] === 0; Fr++, Oe = Oe.sqr())
        ;
      if (++Fr < Se.length)
        for (var zn = Oe.sqr(); Fr < Se.length; Fr++, zn = zn.sqr())
          Se[Fr] !== 0 && (Oe = Oe.mul(zn));
      return Oe;
    }, le.prototype.iushln = function(ye) {
      ne(typeof ye == "number" && ye >= 0);
      var Se = ye % 26, Oe = (ye - Se) / 26, Fr = 67108863 >>> 26 - Se << 26 - Se, zn;
      if (Se !== 0) {
        var Fe = 0;
        for (zn = 0; zn < this.length; zn++) {
          var pe = this.words[zn] & Fr, it = (this.words[zn] | 0) - pe << Se;
          this.words[zn] = it | Fe, Fe = pe >>> 26 - Se;
        }
        Fe && (this.words[zn] = Fe, this.length++);
      }
      if (Oe !== 0) {
        for (zn = this.length - 1; zn >= 0; zn--)
          this.words[zn + Oe] = this.words[zn];
        for (zn = 0; zn < Oe; zn++)
          this.words[zn] = 0;
        this.length += Oe;
      }
      return this._strip();
    }, le.prototype.ishln = function(ye) {
      return ne(this.negative === 0), this.iushln(ye);
    }, le.prototype.iushrn = function(ye, Se, Oe) {
      ne(typeof ye == "number" && ye >= 0);
      var Fr;
      Se ? Fr = (Se - Se % 26) / 26 : Fr = 0;
      var zn = ye % 26, Fe = Math.min((ye - zn) / 26, this.length), pe = 67108863 ^ 67108863 >>> zn << zn, it = Oe;
      if (Fr -= Fe, Fr = Math.max(0, Fr), it) {
        for (var xa = 0; xa < Fe; xa++)
          it.words[xa] = this.words[xa];
        it.length = Fe;
      }
      if (Fe !== 0)
        if (this.length > Fe)
          for (this.length -= Fe, xa = 0; xa < this.length; xa++)
            this.words[xa] = this.words[xa + Fe];
        else
          this.words[0] = 0, this.length = 1;
      var wo = 0;
      for (xa = this.length - 1; xa >= 0 && (wo !== 0 || xa >= Fr); xa--) {
        var _u = this.words[xa] | 0;
        this.words[xa] = wo << 26 - zn | _u >>> zn, wo = _u & pe;
      }
      return it && wo !== 0 && (it.words[it.length++] = wo), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, le.prototype.ishrn = function(ye, Se, Oe) {
      return ne(this.negative === 0), this.iushrn(ye, Se, Oe);
    }, le.prototype.shln = function(ye) {
      return this.clone().ishln(ye);
    }, le.prototype.ushln = function(ye) {
      return this.clone().iushln(ye);
    }, le.prototype.shrn = function(ye) {
      return this.clone().ishrn(ye);
    }, le.prototype.ushrn = function(ye) {
      return this.clone().iushrn(ye);
    }, le.prototype.testn = function(ye) {
      ne(typeof ye == "number" && ye >= 0);
      var Se = ye % 26, Oe = (ye - Se) / 26, Fr = 1 << Se;
      if (this.length <= Oe)
        return !1;
      var zn = this.words[Oe];
      return !!(zn & Fr);
    }, le.prototype.imaskn = function(ye) {
      ne(typeof ye == "number" && ye >= 0);
      var Se = ye % 26, Oe = (ye - Se) / 26;
      if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= Oe)
        return this;
      if (Se !== 0 && Oe++, this.length = Math.min(Oe, this.length), Se !== 0) {
        var Fr = 67108863 ^ 67108863 >>> Se << Se;
        this.words[this.length - 1] &= Fr;
      }
      return this._strip();
    }, le.prototype.maskn = function(ye) {
      return this.clone().imaskn(ye);
    }, le.prototype.iaddn = function(ye) {
      return ne(typeof ye == "number"), ne(ye < 67108864), ye < 0 ? this.isubn(-ye) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= ye ? (this.words[0] = ye - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(ye), this.negative = 1, this) : this._iaddn(ye);
    }, le.prototype._iaddn = function(ye) {
      this.words[0] += ye;
      for (var Se = 0; Se < this.length && this.words[Se] >= 67108864; Se++)
        this.words[Se] -= 67108864, Se === this.length - 1 ? this.words[Se + 1] = 1 : this.words[Se + 1]++;
      return this.length = Math.max(this.length, Se + 1), this;
    }, le.prototype.isubn = function(ye) {
      if (ne(typeof ye == "number"), ne(ye < 67108864), ye < 0)
        return this.iaddn(-ye);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(ye), this.negative = 1, this;
      if (this.words[0] -= ye, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var Se = 0; Se < this.length && this.words[Se] < 0; Se++)
          this.words[Se] += 67108864, this.words[Se + 1] -= 1;
      return this._strip();
    }, le.prototype.addn = function(ye) {
      return this.clone().iaddn(ye);
    }, le.prototype.subn = function(ye) {
      return this.clone().isubn(ye);
    }, le.prototype.iabs = function() {
      return this.negative = 0, this;
    }, le.prototype.abs = function() {
      return this.clone().iabs();
    }, le.prototype._ishlnsubmul = function(ye, Se, Oe) {
      var Fr = ye.length + Oe, zn;
      this._expand(Fr);
      var Fe, pe = 0;
      for (zn = 0; zn < ye.length; zn++) {
        Fe = (this.words[zn + Oe] | 0) + pe;
        var it = (ye.words[zn] | 0) * Se;
        Fe -= it & 67108863, pe = (Fe >> 26) - (it / 67108864 | 0), this.words[zn + Oe] = Fe & 67108863;
      }
      for (; zn < this.length - Oe; zn++)
        Fe = (this.words[zn + Oe] | 0) + pe, pe = Fe >> 26, this.words[zn + Oe] = Fe & 67108863;
      if (pe === 0)
        return this._strip();
      for (ne(pe === -1), pe = 0, zn = 0; zn < this.length; zn++)
        Fe = -(this.words[zn] | 0) + pe, pe = Fe >> 26, this.words[zn] = Fe & 67108863;
      return this.negative = 1, this._strip();
    }, le.prototype._wordDiv = function(ye, Se) {
      var Oe = this.length - ye.length, Fr = this.clone(), zn = ye, Fe = zn.words[zn.length - 1] | 0, pe = this._countBits(Fe);
      Oe = 26 - pe, Oe !== 0 && (zn = zn.ushln(Oe), Fr.iushln(Oe), Fe = zn.words[zn.length - 1] | 0);
      var it = Fr.length - zn.length, xa;
      if (Se !== "mod") {
        xa = new le(null), xa.length = it + 1, xa.words = new Array(xa.length);
        for (var wo = 0; wo < xa.length; wo++)
          xa.words[wo] = 0;
      }
      var _u = Fr.clone()._ishlnsubmul(zn, 1, it);
      _u.negative === 0 && (Fr = _u, xa && (xa.words[it] = 1));
      for (var Oa = it - 1; Oa >= 0; Oa--) {
        var Os = (Fr.words[zn.length + Oa] | 0) * 67108864 + (Fr.words[zn.length + Oa - 1] | 0);
        for (Os = Math.min(Os / Fe | 0, 67108863), Fr._ishlnsubmul(zn, Os, Oa); Fr.negative !== 0; )
          Os--, Fr.negative = 0, Fr._ishlnsubmul(zn, 1, Oa), Fr.isZero() || (Fr.negative ^= 1);
        xa && (xa.words[Oa] = Os);
      }
      return xa && xa._strip(), Fr._strip(), Se !== "div" && Oe !== 0 && Fr.iushrn(Oe), {
        div: xa || null,
        mod: Fr
      };
    }, le.prototype.divmod = function(ye, Se, Oe) {
      if (ne(!ye.isZero()), this.isZero())
        return {
          div: new le(0),
          mod: new le(0)
        };
      var Fr, zn, Fe;
      return this.negative !== 0 && ye.negative === 0 ? (Fe = this.neg().divmod(ye, Se), Se !== "mod" && (Fr = Fe.div.neg()), Se !== "div" && (zn = Fe.mod.neg(), Oe && zn.negative !== 0 && zn.iadd(ye)), {
        div: Fr,
        mod: zn
      }) : this.negative === 0 && ye.negative !== 0 ? (Fe = this.divmod(ye.neg(), Se), Se !== "mod" && (Fr = Fe.div.neg()), {
        div: Fr,
        mod: Fe.mod
      }) : this.negative & ye.negative ? (Fe = this.neg().divmod(ye.neg(), Se), Se !== "div" && (zn = Fe.mod.neg(), Oe && zn.negative !== 0 && zn.isub(ye)), {
        div: Fe.div,
        mod: zn
      }) : ye.length > this.length || this.cmp(ye) < 0 ? {
        div: new le(0),
        mod: this
      } : ye.length === 1 ? Se === "div" ? {
        div: this.divn(ye.words[0]),
        mod: null
      } : Se === "mod" ? {
        div: null,
        mod: new le(this.modrn(ye.words[0]))
      } : {
        div: this.divn(ye.words[0]),
        mod: new le(this.modrn(ye.words[0]))
      } : this._wordDiv(ye, Se);
    }, le.prototype.div = function(ye) {
      return this.divmod(ye, "div", !1).div;
    }, le.prototype.mod = function(ye) {
      return this.divmod(ye, "mod", !1).mod;
    }, le.prototype.umod = function(ye) {
      return this.divmod(ye, "mod", !0).mod;
    }, le.prototype.divRound = function(ye) {
      var Se = this.divmod(ye);
      if (Se.mod.isZero())
        return Se.div;
      var Oe = Se.div.negative !== 0 ? Se.mod.isub(ye) : Se.mod, Fr = ye.ushrn(1), zn = ye.andln(1), Fe = Oe.cmp(Fr);
      return Fe < 0 || zn === 1 && Fe === 0 ? Se.div : Se.div.negative !== 0 ? Se.div.isubn(1) : Se.div.iaddn(1);
    }, le.prototype.modrn = function(ye) {
      var Se = ye < 0;
      Se && (ye = -ye), ne(ye <= 67108863);
      for (var Oe = (1 << 26) % ye, Fr = 0, zn = this.length - 1; zn >= 0; zn--)
        Fr = (Oe * Fr + (this.words[zn] | 0)) % ye;
      return Se ? -Fr : Fr;
    }, le.prototype.modn = function(ye) {
      return this.modrn(ye);
    }, le.prototype.idivn = function(ye) {
      var Se = ye < 0;
      Se && (ye = -ye), ne(ye <= 67108863);
      for (var Oe = 0, Fr = this.length - 1; Fr >= 0; Fr--) {
        var zn = (this.words[Fr] | 0) + Oe * 67108864;
        this.words[Fr] = zn / ye | 0, Oe = zn % ye;
      }
      return this._strip(), Se ? this.ineg() : this;
    }, le.prototype.divn = function(ye) {
      return this.clone().idivn(ye);
    }, le.prototype.egcd = function(ye) {
      ne(ye.negative === 0), ne(!ye.isZero());
      var Se = this, Oe = ye.clone();
      Se.negative !== 0 ? Se = Se.umod(ye) : Se = Se.clone();
      for (var Fr = new le(1), zn = new le(0), Fe = new le(0), pe = new le(1), it = 0; Se.isEven() && Oe.isEven(); )
        Se.iushrn(1), Oe.iushrn(1), ++it;
      for (var xa = Oe.clone(), wo = Se.clone(); !Se.isZero(); ) {
        for (var _u = 0, Oa = 1; !(Se.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
          ;
        if (_u > 0)
          for (Se.iushrn(_u); _u-- > 0; )
            (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(xa), zn.isub(wo)), Fr.iushrn(1), zn.iushrn(1);
        for (var Os = 0, Pa = 1; !(Oe.words[0] & Pa) && Os < 26; ++Os, Pa <<= 1)
          ;
        if (Os > 0)
          for (Oe.iushrn(Os); Os-- > 0; )
            (Fe.isOdd() || pe.isOdd()) && (Fe.iadd(xa), pe.isub(wo)), Fe.iushrn(1), pe.iushrn(1);
        Se.cmp(Oe) >= 0 ? (Se.isub(Oe), Fr.isub(Fe), zn.isub(pe)) : (Oe.isub(Se), Fe.isub(Fr), pe.isub(zn));
      }
      return {
        a: Fe,
        b: pe,
        gcd: Oe.iushln(it)
      };
    }, le.prototype._invmp = function(ye) {
      ne(ye.negative === 0), ne(!ye.isZero());
      var Se = this, Oe = ye.clone();
      Se.negative !== 0 ? Se = Se.umod(ye) : Se = Se.clone();
      for (var Fr = new le(1), zn = new le(0), Fe = Oe.clone(); Se.cmpn(1) > 0 && Oe.cmpn(1) > 0; ) {
        for (var pe = 0, it = 1; !(Se.words[0] & it) && pe < 26; ++pe, it <<= 1)
          ;
        if (pe > 0)
          for (Se.iushrn(pe); pe-- > 0; )
            Fr.isOdd() && Fr.iadd(Fe), Fr.iushrn(1);
        for (var xa = 0, wo = 1; !(Oe.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
          ;
        if (xa > 0)
          for (Oe.iushrn(xa); xa-- > 0; )
            zn.isOdd() && zn.iadd(Fe), zn.iushrn(1);
        Se.cmp(Oe) >= 0 ? (Se.isub(Oe), Fr.isub(zn)) : (Oe.isub(Se), zn.isub(Fr));
      }
      var _u;
      return Se.cmpn(1) === 0 ? _u = Fr : _u = zn, _u.cmpn(0) < 0 && _u.iadd(ye), _u;
    }, le.prototype.gcd = function(ye) {
      if (this.isZero())
        return ye.abs();
      if (ye.isZero())
        return this.abs();
      var Se = this.clone(), Oe = ye.clone();
      Se.negative = 0, Oe.negative = 0;
      for (var Fr = 0; Se.isEven() && Oe.isEven(); Fr++)
        Se.iushrn(1), Oe.iushrn(1);
      do {
        for (; Se.isEven(); )
          Se.iushrn(1);
        for (; Oe.isEven(); )
          Oe.iushrn(1);
        var zn = Se.cmp(Oe);
        if (zn < 0) {
          var Fe = Se;
          Se = Oe, Oe = Fe;
        } else if (zn === 0 || Oe.cmpn(1) === 0)
          break;
        Se.isub(Oe);
      } while (!0);
      return Oe.iushln(Fr);
    }, le.prototype.invm = function(ye) {
      return this.egcd(ye).a.umod(ye);
    }, le.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, le.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, le.prototype.andln = function(ye) {
      return this.words[0] & ye;
    }, le.prototype.bincn = function(ye) {
      ne(typeof ye == "number");
      var Se = ye % 26, Oe = (ye - Se) / 26, Fr = 1 << Se;
      if (this.length <= Oe)
        return this._expand(Oe + 1), this.words[Oe] |= Fr, this;
      for (var zn = Fr, Fe = Oe; zn !== 0 && Fe < this.length; Fe++) {
        var pe = this.words[Fe] | 0;
        pe += zn, zn = pe >>> 26, pe &= 67108863, this.words[Fe] = pe;
      }
      return zn !== 0 && (this.words[Fe] = zn, this.length++), this;
    }, le.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, le.prototype.cmpn = function(ye) {
      var Se = ye < 0;
      if (this.negative !== 0 && !Se)
        return -1;
      if (this.negative === 0 && Se)
        return 1;
      this._strip();
      var Oe;
      if (this.length > 1)
        Oe = 1;
      else {
        Se && (ye = -ye), ne(ye <= 67108863, "Number is too big");
        var Fr = this.words[0] | 0;
        Oe = Fr === ye ? 0 : Fr < ye ? -1 : 1;
      }
      return this.negative !== 0 ? -Oe | 0 : Oe;
    }, le.prototype.cmp = function(ye) {
      if (this.negative !== 0 && ye.negative === 0)
        return -1;
      if (this.negative === 0 && ye.negative !== 0)
        return 1;
      var Se = this.ucmp(ye);
      return this.negative !== 0 ? -Se | 0 : Se;
    }, le.prototype.ucmp = function(ye) {
      if (this.length > ye.length)
        return 1;
      if (this.length < ye.length)
        return -1;
      for (var Se = 0, Oe = this.length - 1; Oe >= 0; Oe--) {
        var Fr = this.words[Oe] | 0, zn = ye.words[Oe] | 0;
        if (Fr !== zn) {
          Fr < zn ? Se = -1 : Fr > zn && (Se = 1);
          break;
        }
      }
      return Se;
    }, le.prototype.gtn = function(ye) {
      return this.cmpn(ye) === 1;
    }, le.prototype.gt = function(ye) {
      return this.cmp(ye) === 1;
    }, le.prototype.gten = function(ye) {
      return this.cmpn(ye) >= 0;
    }, le.prototype.gte = function(ye) {
      return this.cmp(ye) >= 0;
    }, le.prototype.ltn = function(ye) {
      return this.cmpn(ye) === -1;
    }, le.prototype.lt = function(ye) {
      return this.cmp(ye) === -1;
    }, le.prototype.lten = function(ye) {
      return this.cmpn(ye) <= 0;
    }, le.prototype.lte = function(ye) {
      return this.cmp(ye) <= 0;
    }, le.prototype.eqn = function(ye) {
      return this.cmpn(ye) === 0;
    }, le.prototype.eq = function(ye) {
      return this.cmp(ye) === 0;
    }, le.red = function(ye) {
      return new ct(ye);
    }, le.prototype.toRed = function(ye) {
      return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), ye.convertTo(this)._forceRed(ye);
    }, le.prototype.fromRed = function() {
      return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, le.prototype._forceRed = function(ye) {
      return this.red = ye, this;
    }, le.prototype.forceRed = function(ye) {
      return ne(!this.red, "Already a number in reduction context"), this._forceRed(ye);
    }, le.prototype.redAdd = function(ye) {
      return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, ye);
    }, le.prototype.redIAdd = function(ye) {
      return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, ye);
    }, le.prototype.redSub = function(ye) {
      return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, ye);
    }, le.prototype.redISub = function(ye) {
      return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, ye);
    }, le.prototype.redShl = function(ye) {
      return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, ye);
    }, le.prototype.redMul = function(ye) {
      return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, ye), this.red.mul(this, ye);
    }, le.prototype.redIMul = function(ye) {
      return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, ye), this.red.imul(this, ye);
    }, le.prototype.redSqr = function() {
      return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, le.prototype.redISqr = function() {
      return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, le.prototype.redSqrt = function() {
      return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, le.prototype.redInvm = function() {
      return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, le.prototype.redNeg = function() {
      return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, le.prototype.redPow = function(ye) {
      return ne(this.red && !ye.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, ye);
    };
    var _a = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ta(be, ye) {
      this.name = be, this.p = new le(ye, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ta.prototype._tmp = function() {
      var ye = new le(null);
      return ye.words = new Array(Math.ceil(this.n / 13)), ye;
    }, Ta.prototype.ireduce = function(ye) {
      var Se = ye, Oe;
      do
        this.split(Se, this.tmp), Se = this.imulK(Se), Se = Se.iadd(this.tmp), Oe = Se.bitLength();
      while (Oe > this.n);
      var Fr = Oe < this.n ? -1 : Se.ucmp(this.p);
      return Fr === 0 ? (Se.words[0] = 0, Se.length = 1) : Fr > 0 ? Se.isub(this.p) : Se.strip !== void 0 ? Se.strip() : Se._strip(), Se;
    }, Ta.prototype.split = function(ye, Se) {
      ye.iushrn(this.n, 0, Se);
    }, Ta.prototype.imulK = function(ye) {
      return ye.imul(this.k);
    };
    function Zn() {
      Ta.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    ue(Zn, Ta), Zn.prototype.split = function(ye, Se) {
      for (var Oe = 4194303, Fr = Math.min(ye.length, 9), zn = 0; zn < Fr; zn++)
        Se.words[zn] = ye.words[zn];
      if (Se.length = Fr, ye.length <= 9) {
        ye.words[0] = 0, ye.length = 1;
        return;
      }
      var Fe = ye.words[9];
      for (Se.words[Se.length++] = Fe & Oe, zn = 10; zn < ye.length; zn++) {
        var pe = ye.words[zn] | 0;
        ye.words[zn - 10] = (pe & Oe) << 4 | Fe >>> 22, Fe = pe;
      }
      Fe >>>= 22, ye.words[zn - 10] = Fe, Fe === 0 && ye.length > 10 ? ye.length -= 10 : ye.length -= 9;
    }, Zn.prototype.imulK = function(ye) {
      ye.words[ye.length] = 0, ye.words[ye.length + 1] = 0, ye.length += 2;
      for (var Se = 0, Oe = 0; Oe < ye.length; Oe++) {
        var Fr = ye.words[Oe] | 0;
        Se += Fr * 977, ye.words[Oe] = Se & 67108863, Se = Fr * 64 + (Se / 67108864 | 0);
      }
      return ye.words[ye.length - 1] === 0 && (ye.length--, ye.words[ye.length - 1] === 0 && ye.length--), ye;
    };
    function Ra() {
      Ta.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    ue(Ra, Ta);
    function Yn() {
      Ta.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    ue(Yn, Ta);
    function $o() {
      Ta.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    ue($o, Ta), $o.prototype.imulK = function(ye) {
      for (var Se = 0, Oe = 0; Oe < ye.length; Oe++) {
        var Fr = (ye.words[Oe] | 0) * 19 + Se, zn = Fr & 67108863;
        Fr >>>= 26, ye.words[Oe] = zn, Se = Fr;
      }
      return Se !== 0 && (ye.words[ye.length++] = Se), ye;
    }, le._prime = function(ye) {
      if (_a[ye])
        return _a[ye];
      var Se;
      if (ye === "k256")
        Se = new Zn();
      else if (ye === "p224")
        Se = new Ra();
      else if (ye === "p192")
        Se = new Yn();
      else if (ye === "p25519")
        Se = new $o();
      else
        throw new Error("Unknown prime " + ye);
      return _a[ye] = Se, Se;
    };
    function ct(be) {
      if (typeof be == "string") {
        var ye = le._prime(be);
        this.m = ye.p, this.prime = ye;
      } else
        ne(be.gtn(1), "modulus must be greater than 1"), this.m = be, this.prime = null;
    }
    ct.prototype._verify1 = function(ye) {
      ne(ye.negative === 0, "red works only with positives"), ne(ye.red, "red works only with red numbers");
    }, ct.prototype._verify2 = function(ye, Se) {
      ne((ye.negative | Se.negative) === 0, "red works only with positives"), ne(
        ye.red && ye.red === Se.red,
        "red works only with red numbers"
      );
    }, ct.prototype.imod = function(ye) {
      return this.prime ? this.prime.ireduce(ye)._forceRed(this) : (xe(ye, ye.umod(this.m)._forceRed(this)), ye);
    }, ct.prototype.neg = function(ye) {
      return ye.isZero() ? ye.clone() : this.m.sub(ye)._forceRed(this);
    }, ct.prototype.add = function(ye, Se) {
      this._verify2(ye, Se);
      var Oe = ye.add(Se);
      return Oe.cmp(this.m) >= 0 && Oe.isub(this.m), Oe._forceRed(this);
    }, ct.prototype.iadd = function(ye, Se) {
      this._verify2(ye, Se);
      var Oe = ye.iadd(Se);
      return Oe.cmp(this.m) >= 0 && Oe.isub(this.m), Oe;
    }, ct.prototype.sub = function(ye, Se) {
      this._verify2(ye, Se);
      var Oe = ye.sub(Se);
      return Oe.cmpn(0) < 0 && Oe.iadd(this.m), Oe._forceRed(this);
    }, ct.prototype.isub = function(ye, Se) {
      this._verify2(ye, Se);
      var Oe = ye.isub(Se);
      return Oe.cmpn(0) < 0 && Oe.iadd(this.m), Oe;
    }, ct.prototype.shl = function(ye, Se) {
      return this._verify1(ye), this.imod(ye.ushln(Se));
    }, ct.prototype.imul = function(ye, Se) {
      return this._verify2(ye, Se), this.imod(ye.imul(Se));
    }, ct.prototype.mul = function(ye, Se) {
      return this._verify2(ye, Se), this.imod(ye.mul(Se));
    }, ct.prototype.isqr = function(ye) {
      return this.imul(ye, ye.clone());
    }, ct.prototype.sqr = function(ye) {
      return this.mul(ye, ye);
    }, ct.prototype.sqrt = function(ye) {
      if (ye.isZero())
        return ye.clone();
      var Se = this.m.andln(3);
      if (ne(Se % 2 === 1), Se === 3) {
        var Oe = this.m.add(new le(1)).iushrn(2);
        return this.pow(ye, Oe);
      }
      for (var Fr = this.m.subn(1), zn = 0; !Fr.isZero() && Fr.andln(1) === 0; )
        zn++, Fr.iushrn(1);
      ne(!Fr.isZero());
      var Fe = new le(1).toRed(this), pe = Fe.redNeg(), it = this.m.subn(1).iushrn(1), xa = this.m.bitLength();
      for (xa = new le(2 * xa * xa).toRed(this); this.pow(xa, it).cmp(pe) !== 0; )
        xa.redIAdd(pe);
      for (var wo = this.pow(xa, Fr), _u = this.pow(ye, Fr.addn(1).iushrn(1)), Oa = this.pow(ye, Fr), Os = zn; Oa.cmp(Fe) !== 0; ) {
        for (var Pa = Oa, Ml = 0; Pa.cmp(Fe) !== 0; Ml++)
          Pa = Pa.redSqr();
        ne(Ml < Os);
        var Su = this.pow(wo, new le(1).iushln(Os - Ml - 1));
        _u = _u.redMul(Su), wo = Su.redSqr(), Oa = Oa.redMul(wo), Os = Ml;
      }
      return _u;
    }, ct.prototype.invm = function(ye) {
      var Se = ye._invmp(this.m);
      return Se.negative !== 0 ? (Se.negative = 0, this.imod(Se).redNeg()) : this.imod(Se);
    }, ct.prototype.pow = function(ye, Se) {
      if (Se.isZero())
        return new le(1).toRed(this);
      if (Se.cmpn(1) === 0)
        return ye.clone();
      var Oe = 4, Fr = new Array(1 << Oe);
      Fr[0] = new le(1).toRed(this), Fr[1] = ye;
      for (var zn = 2; zn < Fr.length; zn++)
        Fr[zn] = this.mul(Fr[zn - 1], ye);
      var Fe = Fr[0], pe = 0, it = 0, xa = Se.bitLength() % 26;
      for (xa === 0 && (xa = 26), zn = Se.length - 1; zn >= 0; zn--) {
        for (var wo = Se.words[zn], _u = xa - 1; _u >= 0; _u--) {
          var Oa = wo >> _u & 1;
          if (Fe !== Fr[0] && (Fe = this.sqr(Fe)), Oa === 0 && pe === 0) {
            it = 0;
            continue;
          }
          pe <<= 1, pe |= Oa, it++, !(it !== Oe && (zn !== 0 || _u !== 0)) && (Fe = this.mul(Fe, Fr[pe]), it = 0, pe = 0);
        }
        xa = 26;
      }
      return Fe;
    }, ct.prototype.convertTo = function(ye) {
      var Se = ye.umod(this.m);
      return Se === ye ? Se.clone() : Se;
    }, ct.prototype.convertFrom = function(ye) {
      var Se = ye.clone();
      return Se.red = null, Se;
    }, le.mont = function(ye) {
      return new fe(ye);
    };
    function fe(be) {
      ct.call(this, be), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    ue(fe, ct), fe.prototype.convertTo = function(ye) {
      return this.imod(ye.ushln(this.shift));
    }, fe.prototype.convertFrom = function(ye) {
      var Se = this.imod(ye.mul(this.rinv));
      return Se.red = null, Se;
    }, fe.prototype.imul = function(ye, Se) {
      if (ye.isZero() || Se.isZero())
        return ye.words[0] = 0, ye.length = 1, ye;
      var Oe = ye.imul(Se), Fr = Oe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), zn = Oe.isub(Fr).iushrn(this.shift), Fe = zn;
      return zn.cmp(this.m) >= 0 ? Fe = zn.isub(this.m) : zn.cmpn(0) < 0 && (Fe = zn.iadd(this.m)), Fe._forceRed(this);
    }, fe.prototype.mul = function(ye, Se) {
      if (ye.isZero() || Se.isZero())
        return new le(0)._forceRed(this);
      var Oe = ye.mul(Se), Fr = Oe.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), zn = Oe.isub(Fr).iushrn(this.shift), Fe = zn;
      return zn.cmp(this.m) >= 0 ? Fe = zn.isub(this.m) : zn.cmpn(0) < 0 && (Fe = zn.iadd(this.m)), Fe._forceRed(this);
    }, fe.prototype.invm = function(ye) {
      var Se = this.imod(ye._invmp(this.m).mul(this.r2));
      return Se._forceRed(this);
    };
  })(v, commonjsGlobal);
})(bn$4);
var bnExports$1 = bn$4.exports, browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa)
    return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var v = bnExports$1, y = requireBrowser$b();
  function z(le) {
    var he = ne(le), ge = he.toRed(v.mont(le.modulus)).redPow(new v(le.publicExponent)).fromRed();
    return { blinder: ge, unblinder: he.invm(le.modulus) };
  }
  function ne(le) {
    var he = le.modulus.byteLength(), ge;
    do
      ge = new v(y(he));
    while (ge.cmp(le.modulus) >= 0 || !ge.umod(le.prime1) || !ge.umod(le.prime2));
    return ge;
  }
  function ue(le, he) {
    var ge = z(he), we = he.modulus.byteLength(), Ee = new v(le).mul(ge.blinder).umod(he.modulus), xe = Ee.toRed(v.mont(he.prime1)), $e = Ee.toRed(v.mont(he.prime2)), Ne = he.coefficient, st = he.prime1, Nr = he.prime2, br = xe.redPow(he.exponent1).fromRed(), $n = $e.redPow(he.exponent2).fromRed(), En = br.isub($n).imul(Ne).umod(st).imul(Nr);
    return $n.iadd(En).imul(ge.unblinder).umod(he.modulus).toArrayLike(Buffer, "be", we);
  }
  return ue.getr = ne, browserifyRsa = ue, browserifyRsa;
}
var elliptic = {};
const name = "elliptic", version$1 = "6.5.5", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$1 = {
  name,
  version: version$1,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$n = {}, bn$3 = { exports: {} };
bn$3.exports;
(function(v) {
  (function(y, z) {
    function ne(ct, fe) {
      if (!ct)
        throw new Error(fe || "Assertion failed");
    }
    function ue(ct, fe) {
      ct.super_ = fe;
      var be = function() {
      };
      be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
    }
    function le(ct, fe, be) {
      if (le.isBN(ct))
        return ct;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
    }
    typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
    var he;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
    } catch {
    }
    le.isBN = function(fe) {
      return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
    }, le.max = function(fe, be) {
      return fe.cmp(be) > 0 ? fe : be;
    }, le.min = function(fe, be) {
      return fe.cmp(be) < 0 ? fe : be;
    }, le.prototype._init = function(fe, be, ye) {
      if (typeof fe == "number")
        return this._initNumber(fe, be, ye);
      if (typeof fe == "object")
        return this._initArray(fe, be, ye);
      be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
      var Se = 0;
      fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
    }, le.prototype._initNumber = function(fe, be, ye) {
      fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
        fe & 67108863,
        fe / 67108864 & 67108863
      ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
        fe & 67108863,
        fe / 67108864 & 67108863,
        1
      ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
    }, le.prototype._initArray = function(fe, be, ye) {
      if (ne(typeof fe.length == "number"), fe.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
      for (var Se = 0; Se < this.length; Se++)
        this.words[Se] = 0;
      var Oe, Fr, zn = 0;
      if (ye === "be")
        for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
          Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
      else if (ye === "le")
        for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
          Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
      return this.strip();
    };
    function ge(ct, fe) {
      var be = ct.charCodeAt(fe);
      return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
    }
    function we(ct, fe, be) {
      var ye = ge(ct, be);
      return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
    }
    le.prototype._parseHex = function(fe, be, ye) {
      this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
      for (var Se = 0; Se < this.length; Se++)
        this.words[Se] = 0;
      var Oe = 0, Fr = 0, zn;
      if (ye === "be")
        for (Se = fe.length - 1; Se >= be; Se -= 2)
          zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
      else {
        var Fe = fe.length - be;
        for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
          zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
      }
      this.strip();
    };
    function Ee(ct, fe, be, ye) {
      for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
        var zn = ct.charCodeAt(Fr) - 48;
        Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
      }
      return Se;
    }
    le.prototype._parseBase = function(fe, be, ye) {
      this.words = [0], this.length = 1;
      for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
        Se++;
      Se--, Oe = Oe / be | 0;
      for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
        pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
      if (zn !== 0) {
        var xa = 1;
        for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
          xa *= be;
        this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
      }
      this.strip();
    }, le.prototype.copy = function(fe) {
      fe.words = new Array(this.length);
      for (var be = 0; be < this.length; be++)
        fe.words[be] = this.words[be];
      fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
    }, le.prototype.clone = function() {
      var fe = new le(null);
      return this.copy(fe), fe;
    }, le.prototype._expand = function(fe) {
      for (; this.length < fe; )
        this.words[this.length++] = 0;
      return this;
    }, le.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, le.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, le.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var xe = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], $e = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Ne = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    le.prototype.toString = function(fe, be) {
      fe = fe || 10, be = be | 0 || 1;
      var ye;
      if (fe === 16 || fe === "hex") {
        ye = "";
        for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
          var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
          Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
        }
        for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
          ye = "0" + ye;
        return this.negative !== 0 && (ye = "-" + ye), ye;
      }
      if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
        var pe = $e[fe], it = Ne[fe];
        ye = "";
        var xa = this.clone();
        for (xa.negative = 0; !xa.isZero(); ) {
          var wo = xa.modn(it).toString(fe);
          xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
        }
        for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
          ye = "0" + ye;
        return this.negative !== 0 && (ye = "-" + ye), ye;
      }
      ne(!1, "Base should be between 2 and 36");
    }, le.prototype.toNumber = function() {
      var fe = this.words[0];
      return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
    }, le.prototype.toJSON = function() {
      return this.toString(16);
    }, le.prototype.toBuffer = function(fe, be) {
      return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
    }, le.prototype.toArray = function(fe, be) {
      return this.toArrayLike(Array, fe, be);
    }, le.prototype.toArrayLike = function(fe, be, ye) {
      var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
      ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
      var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
      if (Fr) {
        for (pe = 0; !it.isZero(); pe++)
          Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
        for (; pe < Oe; pe++)
          zn[pe] = 0;
      } else {
        for (pe = 0; pe < Oe - Se; pe++)
          zn[pe] = 0;
        for (pe = 0; !it.isZero(); pe++)
          Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
      }
      return zn;
    }, Math.clz32 ? le.prototype._countBits = function(fe) {
      return 32 - Math.clz32(fe);
    } : le.prototype._countBits = function(fe) {
      var be = fe, ye = 0;
      return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
    }, le.prototype._zeroBits = function(fe) {
      if (fe === 0)
        return 26;
      var be = fe, ye = 0;
      return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
    }, le.prototype.bitLength = function() {
      var fe = this.words[this.length - 1], be = this._countBits(fe);
      return (this.length - 1) * 26 + be;
    };
    function st(ct) {
      for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
        var ye = be / 26 | 0, Se = be % 26;
        fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
      }
      return fe;
    }
    le.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var fe = 0, be = 0; be < this.length; be++) {
        var ye = this._zeroBits(this.words[be]);
        if (fe += ye, ye !== 26)
          break;
      }
      return fe;
    }, le.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, le.prototype.toTwos = function(fe) {
      return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
    }, le.prototype.fromTwos = function(fe) {
      return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
    }, le.prototype.isNeg = function() {
      return this.negative !== 0;
    }, le.prototype.neg = function() {
      return this.clone().ineg();
    }, le.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, le.prototype.iuor = function(fe) {
      for (; this.length < fe.length; )
        this.words[this.length++] = 0;
      for (var be = 0; be < fe.length; be++)
        this.words[be] = this.words[be] | fe.words[be];
      return this.strip();
    }, le.prototype.ior = function(fe) {
      return ne((this.negative | fe.negative) === 0), this.iuor(fe);
    }, le.prototype.or = function(fe) {
      return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
    }, le.prototype.uor = function(fe) {
      return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
    }, le.prototype.iuand = function(fe) {
      var be;
      this.length > fe.length ? be = fe : be = this;
      for (var ye = 0; ye < be.length; ye++)
        this.words[ye] = this.words[ye] & fe.words[ye];
      return this.length = be.length, this.strip();
    }, le.prototype.iand = function(fe) {
      return ne((this.negative | fe.negative) === 0), this.iuand(fe);
    }, le.prototype.and = function(fe) {
      return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
    }, le.prototype.uand = function(fe) {
      return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
    }, le.prototype.iuxor = function(fe) {
      var be, ye;
      this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
      for (var Se = 0; Se < ye.length; Se++)
        this.words[Se] = be.words[Se] ^ ye.words[Se];
      if (this !== be)
        for (; Se < be.length; Se++)
          this.words[Se] = be.words[Se];
      return this.length = be.length, this.strip();
    }, le.prototype.ixor = function(fe) {
      return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
    }, le.prototype.xor = function(fe) {
      return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
    }, le.prototype.uxor = function(fe) {
      return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
    }, le.prototype.inotn = function(fe) {
      ne(typeof fe == "number" && fe >= 0);
      var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
      this._expand(be), ye > 0 && be--;
      for (var Se = 0; Se < be; Se++)
        this.words[Se] = ~this.words[Se] & 67108863;
      return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
    }, le.prototype.notn = function(fe) {
      return this.clone().inotn(fe);
    }, le.prototype.setn = function(fe, be) {
      ne(typeof fe == "number" && fe >= 0);
      var ye = fe / 26 | 0, Se = fe % 26;
      return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
    }, le.prototype.iadd = function(fe) {
      var be;
      if (this.negative !== 0 && fe.negative === 0)
        return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && fe.negative !== 0)
        return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
      var ye, Se;
      this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
      for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
        be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
      for (; Oe !== 0 && Fr < ye.length; Fr++)
        be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
      if (this.length = ye.length, Oe !== 0)
        this.words[this.length] = Oe, this.length++;
      else if (ye !== this)
        for (; Fr < ye.length; Fr++)
          this.words[Fr] = ye.words[Fr];
      return this;
    }, le.prototype.add = function(fe) {
      var be;
      return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
    }, le.prototype.isub = function(fe) {
      if (fe.negative !== 0) {
        fe.negative = 0;
        var be = this.iadd(fe);
        return fe.negative = 1, be._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
      var ye = this.cmp(fe);
      if (ye === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var Se, Oe;
      ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
      for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
        be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
      for (; Fr !== 0 && zn < Se.length; zn++)
        be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
      if (Fr === 0 && zn < Se.length && Se !== this)
        for (; zn < Se.length; zn++)
          this.words[zn] = Se.words[zn];
      return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
    }, le.prototype.sub = function(fe) {
      return this.clone().isub(fe);
    };
    function Nr(ct, fe, be) {
      be.negative = fe.negative ^ ct.negative;
      var ye = ct.length + fe.length | 0;
      be.length = ye, ye = ye - 1 | 0;
      var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
      be.words[0] = zn;
      for (var pe = 1; pe < ye; pe++) {
        for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
          var Oa = pe - _u | 0;
          Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
        }
        be.words[pe] = xa | 0, Fe = it | 0;
      }
      return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
    }
    var br = function(fe, be, ye) {
      var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
      ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
      var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
      var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
      var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
      var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
      var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
      var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
      var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
      var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
      var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
      var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
      var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
      var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
      var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
      var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
      var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
      var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
      var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
      var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
      var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
      return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
    };
    Math.imul || (br = Nr);
    function $n(ct, fe, be) {
      be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
      for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
        var Fr = Se;
        Se = 0;
        for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
          var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
          Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
        }
        be.words[Oe] = zn, ye = Fr, Fr = Se;
      }
      return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
    }
    function En(ct, fe, be) {
      var ye = new Rn();
      return ye.mulp(ct, fe, be);
    }
    le.prototype.mulTo = function(fe, be) {
      var ye, Se = this.length + fe.length;
      return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
    };
    function Rn(ct, fe) {
      this.x = ct, this.y = fe;
    }
    Rn.prototype.makeRBT = function(fe) {
      for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
        be[Se] = this.revBin(Se, ye, fe);
      return be;
    }, Rn.prototype.revBin = function(fe, be, ye) {
      if (fe === 0 || fe === ye - 1)
        return fe;
      for (var Se = 0, Oe = 0; Oe < be; Oe++)
        Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
      return Se;
    }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
      for (var zn = 0; zn < Fr; zn++)
        Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
    }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
      this.permute(Fr, fe, be, ye, Se, Oe);
      for (var zn = 1; zn < Oe; zn <<= 1)
        for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
          for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
            var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
            Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
          }
    }, Rn.prototype.guessLen13b = function(fe, be) {
      var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
      for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
        Oe++;
      return 1 << Oe + 1 + Se;
    }, Rn.prototype.conjugate = function(fe, be, ye) {
      if (!(ye <= 1))
        for (var Se = 0; Se < ye / 2; Se++) {
          var Oe = fe[Se];
          fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
        }
    }, Rn.prototype.normalize13b = function(fe, be) {
      for (var ye = 0, Se = 0; Se < be / 2; Se++) {
        var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
        fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
      }
      return fe;
    }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
      for (var Oe = 0, Fr = 0; Fr < be; Fr++)
        Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
      for (Fr = 2 * be; Fr < Se; ++Fr)
        ye[Fr] = 0;
      ne(Oe === 0), ne((Oe & -8192) === 0);
    }, Rn.prototype.stub = function(fe) {
      for (var be = new Array(fe), ye = 0; ye < fe; ye++)
        be[ye] = 0;
      return be;
    }, Rn.prototype.mulp = function(fe, be, ye) {
      var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
      _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
      for (var Oa = 0; Oa < Se; Oa++) {
        var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
        pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
      }
      return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
    }, le.prototype.mul = function(fe) {
      var be = new le(null);
      return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
    }, le.prototype.mulf = function(fe) {
      var be = new le(null);
      return be.words = new Array(this.length + fe.length), En(this, fe, be);
    }, le.prototype.imul = function(fe) {
      return this.clone().mulTo(fe, this);
    }, le.prototype.imuln = function(fe) {
      ne(typeof fe == "number"), ne(fe < 67108864);
      for (var be = 0, ye = 0; ye < this.length; ye++) {
        var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
        be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
      }
      return be !== 0 && (this.words[ye] = be, this.length++), this;
    }, le.prototype.muln = function(fe) {
      return this.clone().imuln(fe);
    }, le.prototype.sqr = function() {
      return this.mul(this);
    }, le.prototype.isqr = function() {
      return this.imul(this.clone());
    }, le.prototype.pow = function(fe) {
      var be = st(fe);
      if (be.length === 0)
        return new le(1);
      for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
        ;
      if (++Se < be.length)
        for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
          be[Se] !== 0 && (ye = ye.mul(Oe));
      return ye;
    }, le.prototype.iushln = function(fe) {
      ne(typeof fe == "number" && fe >= 0);
      var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
      if (be !== 0) {
        var Fr = 0;
        for (Oe = 0; Oe < this.length; Oe++) {
          var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
          this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
        }
        Fr && (this.words[Oe] = Fr, this.length++);
      }
      if (ye !== 0) {
        for (Oe = this.length - 1; Oe >= 0; Oe--)
          this.words[Oe + ye] = this.words[Oe];
        for (Oe = 0; Oe < ye; Oe++)
          this.words[Oe] = 0;
        this.length += ye;
      }
      return this.strip();
    }, le.prototype.ishln = function(fe) {
      return ne(this.negative === 0), this.iushln(fe);
    }, le.prototype.iushrn = function(fe, be, ye) {
      ne(typeof fe == "number" && fe >= 0);
      var Se;
      be ? Se = (be - be % 26) / 26 : Se = 0;
      var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
      if (Se -= Fr, Se = Math.max(0, Se), Fe) {
        for (var pe = 0; pe < Fr; pe++)
          Fe.words[pe] = this.words[pe];
        Fe.length = Fr;
      }
      if (Fr !== 0)
        if (this.length > Fr)
          for (this.length -= Fr, pe = 0; pe < this.length; pe++)
            this.words[pe] = this.words[pe + Fr];
        else
          this.words[0] = 0, this.length = 1;
      var it = 0;
      for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
        var xa = this.words[pe] | 0;
        this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
      }
      return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, le.prototype.ishrn = function(fe, be, ye) {
      return ne(this.negative === 0), this.iushrn(fe, be, ye);
    }, le.prototype.shln = function(fe) {
      return this.clone().ishln(fe);
    }, le.prototype.ushln = function(fe) {
      return this.clone().iushln(fe);
    }, le.prototype.shrn = function(fe) {
      return this.clone().ishrn(fe);
    }, le.prototype.ushrn = function(fe) {
      return this.clone().iushrn(fe);
    }, le.prototype.testn = function(fe) {
      ne(typeof fe == "number" && fe >= 0);
      var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
      if (this.length <= ye)
        return !1;
      var Oe = this.words[ye];
      return !!(Oe & Se);
    }, le.prototype.imaskn = function(fe) {
      ne(typeof fe == "number" && fe >= 0);
      var be = fe % 26, ye = (fe - be) / 26;
      if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
        return this;
      if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
        var Se = 67108863 ^ 67108863 >>> be << be;
        this.words[this.length - 1] &= Se;
      }
      return this.strip();
    }, le.prototype.maskn = function(fe) {
      return this.clone().imaskn(fe);
    }, le.prototype.iaddn = function(fe) {
      return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
    }, le.prototype._iaddn = function(fe) {
      this.words[0] += fe;
      for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
        this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
      return this.length = Math.max(this.length, be + 1), this;
    }, le.prototype.isubn = function(fe) {
      if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
        return this.iaddn(-fe);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
      if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var be = 0; be < this.length && this.words[be] < 0; be++)
          this.words[be] += 67108864, this.words[be + 1] -= 1;
      return this.strip();
    }, le.prototype.addn = function(fe) {
      return this.clone().iaddn(fe);
    }, le.prototype.subn = function(fe) {
      return this.clone().isubn(fe);
    }, le.prototype.iabs = function() {
      return this.negative = 0, this;
    }, le.prototype.abs = function() {
      return this.clone().iabs();
    }, le.prototype._ishlnsubmul = function(fe, be, ye) {
      var Se = fe.length + ye, Oe;
      this._expand(Se);
      var Fr, zn = 0;
      for (Oe = 0; Oe < fe.length; Oe++) {
        Fr = (this.words[Oe + ye] | 0) + zn;
        var Fe = (fe.words[Oe] | 0) * be;
        Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
      }
      for (; Oe < this.length - ye; Oe++)
        Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
      if (zn === 0)
        return this.strip();
      for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
        Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
      return this.negative = 1, this.strip();
    }, le.prototype._wordDiv = function(fe, be) {
      var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
      ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
      var Fe = Se.length - Oe.length, pe;
      if (be !== "mod") {
        pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
        for (var it = 0; it < pe.length; it++)
          pe.words[it] = 0;
      }
      var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
      xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
      for (var wo = Fe - 1; wo >= 0; wo--) {
        var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
        for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
          _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
        pe && (pe.words[wo] = _u);
      }
      return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
        div: pe || null,
        mod: Se
      };
    }, le.prototype.divmod = function(fe, be, ye) {
      if (ne(!fe.isZero()), this.isZero())
        return {
          div: new le(0),
          mod: new le(0)
        };
      var Se, Oe, Fr;
      return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
        div: Se,
        mod: Oe
      }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
        div: Se,
        mod: Fr.mod
      }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
        div: Fr.div,
        mod: Oe
      }) : fe.length > this.length || this.cmp(fe) < 0 ? {
        div: new le(0),
        mod: this
      } : fe.length === 1 ? be === "div" ? {
        div: this.divn(fe.words[0]),
        mod: null
      } : be === "mod" ? {
        div: null,
        mod: new le(this.modn(fe.words[0]))
      } : {
        div: this.divn(fe.words[0]),
        mod: new le(this.modn(fe.words[0]))
      } : this._wordDiv(fe, be);
    }, le.prototype.div = function(fe) {
      return this.divmod(fe, "div", !1).div;
    }, le.prototype.mod = function(fe) {
      return this.divmod(fe, "mod", !1).mod;
    }, le.prototype.umod = function(fe) {
      return this.divmod(fe, "mod", !0).mod;
    }, le.prototype.divRound = function(fe) {
      var be = this.divmod(fe);
      if (be.mod.isZero())
        return be.div;
      var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
      return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
    }, le.prototype.modn = function(fe) {
      ne(fe <= 67108863);
      for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
        ye = (be * ye + (this.words[Se] | 0)) % fe;
      return ye;
    }, le.prototype.idivn = function(fe) {
      ne(fe <= 67108863);
      for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
        var Se = (this.words[ye] | 0) + be * 67108864;
        this.words[ye] = Se / fe | 0, be = Se % fe;
      }
      return this.strip();
    }, le.prototype.divn = function(fe) {
      return this.clone().idivn(fe);
    }, le.prototype.egcd = function(fe) {
      ne(fe.negative === 0), ne(!fe.isZero());
      var be = this, ye = fe.clone();
      be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
      for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
        be.iushrn(1), ye.iushrn(1), ++Fe;
      for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
        for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
          ;
        if (xa > 0)
          for (be.iushrn(xa); xa-- > 0; )
            (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
        for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
          ;
        if (_u > 0)
          for (ye.iushrn(_u); _u-- > 0; )
            (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
        be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
      }
      return {
        a: Fr,
        b: zn,
        gcd: ye.iushln(Fe)
      };
    }, le.prototype._invmp = function(fe) {
      ne(fe.negative === 0), ne(!fe.isZero());
      var be = this, ye = fe.clone();
      be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
      for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
        for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
          ;
        if (zn > 0)
          for (be.iushrn(zn); zn-- > 0; )
            Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
        for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
          ;
        if (pe > 0)
          for (ye.iushrn(pe); pe-- > 0; )
            Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
        be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
      }
      var xa;
      return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
    }, le.prototype.gcd = function(fe) {
      if (this.isZero())
        return fe.abs();
      if (fe.isZero())
        return this.abs();
      var be = this.clone(), ye = fe.clone();
      be.negative = 0, ye.negative = 0;
      for (var Se = 0; be.isEven() && ye.isEven(); Se++)
        be.iushrn(1), ye.iushrn(1);
      do {
        for (; be.isEven(); )
          be.iushrn(1);
        for (; ye.isEven(); )
          ye.iushrn(1);
        var Oe = be.cmp(ye);
        if (Oe < 0) {
          var Fr = be;
          be = ye, ye = Fr;
        } else if (Oe === 0 || ye.cmpn(1) === 0)
          break;
        be.isub(ye);
      } while (!0);
      return ye.iushln(Se);
    }, le.prototype.invm = function(fe) {
      return this.egcd(fe).a.umod(fe);
    }, le.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, le.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, le.prototype.andln = function(fe) {
      return this.words[0] & fe;
    }, le.prototype.bincn = function(fe) {
      ne(typeof fe == "number");
      var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
      if (this.length <= ye)
        return this._expand(ye + 1), this.words[ye] |= Se, this;
      for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
        var zn = this.words[Fr] | 0;
        zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
      }
      return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
    }, le.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, le.prototype.cmpn = function(fe) {
      var be = fe < 0;
      if (this.negative !== 0 && !be)
        return -1;
      if (this.negative === 0 && be)
        return 1;
      this.strip();
      var ye;
      if (this.length > 1)
        ye = 1;
      else {
        be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
        var Se = this.words[0] | 0;
        ye = Se === fe ? 0 : Se < fe ? -1 : 1;
      }
      return this.negative !== 0 ? -ye | 0 : ye;
    }, le.prototype.cmp = function(fe) {
      if (this.negative !== 0 && fe.negative === 0)
        return -1;
      if (this.negative === 0 && fe.negative !== 0)
        return 1;
      var be = this.ucmp(fe);
      return this.negative !== 0 ? -be | 0 : be;
    }, le.prototype.ucmp = function(fe) {
      if (this.length > fe.length)
        return 1;
      if (this.length < fe.length)
        return -1;
      for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
        var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
        if (Se !== Oe) {
          Se < Oe ? be = -1 : Se > Oe && (be = 1);
          break;
        }
      }
      return be;
    }, le.prototype.gtn = function(fe) {
      return this.cmpn(fe) === 1;
    }, le.prototype.gt = function(fe) {
      return this.cmp(fe) === 1;
    }, le.prototype.gten = function(fe) {
      return this.cmpn(fe) >= 0;
    }, le.prototype.gte = function(fe) {
      return this.cmp(fe) >= 0;
    }, le.prototype.ltn = function(fe) {
      return this.cmpn(fe) === -1;
    }, le.prototype.lt = function(fe) {
      return this.cmp(fe) === -1;
    }, le.prototype.lten = function(fe) {
      return this.cmpn(fe) <= 0;
    }, le.prototype.lte = function(fe) {
      return this.cmp(fe) <= 0;
    }, le.prototype.eqn = function(fe) {
      return this.cmpn(fe) === 0;
    }, le.prototype.eq = function(fe) {
      return this.cmp(fe) === 0;
    }, le.red = function(fe) {
      return new Yn(fe);
    }, le.prototype.toRed = function(fe) {
      return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
    }, le.prototype.fromRed = function() {
      return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, le.prototype._forceRed = function(fe) {
      return this.red = fe, this;
    }, le.prototype.forceRed = function(fe) {
      return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
    }, le.prototype.redAdd = function(fe) {
      return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
    }, le.prototype.redIAdd = function(fe) {
      return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
    }, le.prototype.redSub = function(fe) {
      return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
    }, le.prototype.redISub = function(fe) {
      return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
    }, le.prototype.redShl = function(fe) {
      return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
    }, le.prototype.redMul = function(fe) {
      return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
    }, le.prototype.redIMul = function(fe) {
      return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
    }, le.prototype.redSqr = function() {
      return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, le.prototype.redISqr = function() {
      return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, le.prototype.redSqrt = function() {
      return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, le.prototype.redInvm = function() {
      return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, le.prototype.redNeg = function() {
      return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, le.prototype.redPow = function(fe) {
      return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
    };
    var wa = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Aa(ct, fe) {
      this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Aa.prototype._tmp = function() {
      var fe = new le(null);
      return fe.words = new Array(Math.ceil(this.n / 13)), fe;
    }, Aa.prototype.ireduce = function(fe) {
      var be = fe, ye;
      do
        this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
      while (ye > this.n);
      var Se = ye < this.n ? -1 : be.ucmp(this.p);
      return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
    }, Aa.prototype.split = function(fe, be) {
      fe.iushrn(this.n, 0, be);
    }, Aa.prototype.imulK = function(fe) {
      return fe.imul(this.k);
    };
    function _a() {
      Aa.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    ue(_a, Aa), _a.prototype.split = function(fe, be) {
      for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
        be.words[Oe] = fe.words[Oe];
      if (be.length = Se, fe.length <= 9) {
        fe.words[0] = 0, fe.length = 1;
        return;
      }
      var Fr = fe.words[9];
      for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
        var zn = fe.words[Oe] | 0;
        fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
      }
      Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
    }, _a.prototype.imulK = function(fe) {
      fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
      for (var be = 0, ye = 0; ye < fe.length; ye++) {
        var Se = fe.words[ye] | 0;
        be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
      }
      return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
    };
    function Ta() {
      Aa.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    ue(Ta, Aa);
    function Zn() {
      Aa.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    ue(Zn, Aa);
    function Ra() {
      Aa.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
      for (var be = 0, ye = 0; ye < fe.length; ye++) {
        var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
        Se >>>= 26, fe.words[ye] = Oe, be = Se;
      }
      return be !== 0 && (fe.words[fe.length++] = be), fe;
    }, le._prime = function(fe) {
      if (wa[fe])
        return wa[fe];
      var be;
      if (fe === "k256")
        be = new _a();
      else if (fe === "p224")
        be = new Ta();
      else if (fe === "p192")
        be = new Zn();
      else if (fe === "p25519")
        be = new Ra();
      else
        throw new Error("Unknown prime " + fe);
      return wa[fe] = be, be;
    };
    function Yn(ct) {
      if (typeof ct == "string") {
        var fe = le._prime(ct);
        this.m = fe.p, this.prime = fe;
      } else
        ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
    }
    Yn.prototype._verify1 = function(fe) {
      ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
    }, Yn.prototype._verify2 = function(fe, be) {
      ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
        fe.red && fe.red === be.red,
        "red works only with red numbers"
      );
    }, Yn.prototype.imod = function(fe) {
      return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
    }, Yn.prototype.neg = function(fe) {
      return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
    }, Yn.prototype.add = function(fe, be) {
      this._verify2(fe, be);
      var ye = fe.add(be);
      return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
    }, Yn.prototype.iadd = function(fe, be) {
      this._verify2(fe, be);
      var ye = fe.iadd(be);
      return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
    }, Yn.prototype.sub = function(fe, be) {
      this._verify2(fe, be);
      var ye = fe.sub(be);
      return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
    }, Yn.prototype.isub = function(fe, be) {
      this._verify2(fe, be);
      var ye = fe.isub(be);
      return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
    }, Yn.prototype.shl = function(fe, be) {
      return this._verify1(fe), this.imod(fe.ushln(be));
    }, Yn.prototype.imul = function(fe, be) {
      return this._verify2(fe, be), this.imod(fe.imul(be));
    }, Yn.prototype.mul = function(fe, be) {
      return this._verify2(fe, be), this.imod(fe.mul(be));
    }, Yn.prototype.isqr = function(fe) {
      return this.imul(fe, fe.clone());
    }, Yn.prototype.sqr = function(fe) {
      return this.mul(fe, fe);
    }, Yn.prototype.sqrt = function(fe) {
      if (fe.isZero())
        return fe.clone();
      var be = this.m.andln(3);
      if (ne(be % 2 === 1), be === 3) {
        var ye = this.m.add(new le(1)).iushrn(2);
        return this.pow(fe, ye);
      }
      for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
        Oe++, Se.iushrn(1);
      ne(!Se.isZero());
      var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
      for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
        pe.redIAdd(zn);
      for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
        for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
          Oa = Oa.redSqr();
        ne(Os < _u);
        var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
        xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
      }
      return xa;
    }, Yn.prototype.invm = function(fe) {
      var be = fe._invmp(this.m);
      return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
    }, Yn.prototype.pow = function(fe, be) {
      if (be.isZero())
        return new le(1).toRed(this);
      if (be.cmpn(1) === 0)
        return fe.clone();
      var ye = 4, Se = new Array(1 << ye);
      Se[0] = new le(1).toRed(this), Se[1] = fe;
      for (var Oe = 2; Oe < Se.length; Oe++)
        Se[Oe] = this.mul(Se[Oe - 1], fe);
      var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
      for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
        for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
          var wo = it >> xa & 1;
          if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
            Fe = 0;
            continue;
          }
          zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
        }
        pe = 26;
      }
      return Fr;
    }, Yn.prototype.convertTo = function(fe) {
      var be = fe.umod(this.m);
      return be === fe ? be.clone() : be;
    }, Yn.prototype.convertFrom = function(fe) {
      var be = fe.clone();
      return be.red = null, be;
    }, le.mont = function(fe) {
      return new $o(fe);
    };
    function $o(ct) {
      Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    ue($o, Yn), $o.prototype.convertTo = function(fe) {
      return this.imod(fe.ushln(this.shift));
    }, $o.prototype.convertFrom = function(fe) {
      var be = this.imod(fe.mul(this.rinv));
      return be.red = null, be;
    }, $o.prototype.imul = function(fe, be) {
      if (fe.isZero() || be.isZero())
        return fe.words[0] = 0, fe.length = 1, fe;
      var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
      return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
    }, $o.prototype.mul = function(fe, be) {
      if (fe.isZero() || be.isZero())
        return new le(0)._forceRed(this);
      var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
      return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
    }, $o.prototype.invm = function(fe) {
      var be = this.imod(fe._invmp(this.m).mul(this.r2));
      return be._forceRed(this);
    };
  })(v, commonjsGlobal);
})(bn$3);
var bnExports = bn$3.exports, utils$m = {};
(function(v) {
  var y = v;
  function z(le, he) {
    if (Array.isArray(le))
      return le.slice();
    if (!le)
      return [];
    var ge = [];
    if (typeof le != "string") {
      for (var we = 0; we < le.length; we++)
        ge[we] = le[we] | 0;
      return ge;
    }
    if (he === "hex") {
      le = le.replace(/[^a-z0-9]+/ig, ""), le.length % 2 !== 0 && (le = "0" + le);
      for (var we = 0; we < le.length; we += 2)
        ge.push(parseInt(le[we] + le[we + 1], 16));
    } else
      for (var we = 0; we < le.length; we++) {
        var Ee = le.charCodeAt(we), xe = Ee >> 8, $e = Ee & 255;
        xe ? ge.push(xe, $e) : ge.push($e);
      }
    return ge;
  }
  y.toArray = z;
  function ne(le) {
    return le.length === 1 ? "0" + le : le;
  }
  y.zero2 = ne;
  function ue(le) {
    for (var he = "", ge = 0; ge < le.length; ge++)
      he += ne(le[ge].toString(16));
    return he;
  }
  y.toHex = ue, y.encode = function(he, ge) {
    return ge === "hex" ? ue(he) : he;
  };
})(utils$m);
(function(v) {
  var y = v, z = bnExports, ne = minimalisticAssert, ue = utils$m;
  y.assert = ne, y.toArray = ue.toArray, y.zero2 = ue.zero2, y.toHex = ue.toHex, y.encode = ue.encode;
  function le(xe, $e, Ne) {
    var st = new Array(Math.max(xe.bitLength(), Ne) + 1), Nr;
    for (Nr = 0; Nr < st.length; Nr += 1)
      st[Nr] = 0;
    var br = 1 << $e + 1, $n = xe.clone();
    for (Nr = 0; Nr < st.length; Nr++) {
      var En, Rn = $n.andln(br - 1);
      $n.isOdd() ? (Rn > (br >> 1) - 1 ? En = (br >> 1) - Rn : En = Rn, $n.isubn(En)) : En = 0, st[Nr] = En, $n.iushrn(1);
    }
    return st;
  }
  y.getNAF = le;
  function he(xe, $e) {
    var Ne = [
      [],
      []
    ];
    xe = xe.clone(), $e = $e.clone();
    for (var st = 0, Nr = 0, br; xe.cmpn(-st) > 0 || $e.cmpn(-Nr) > 0; ) {
      var $n = xe.andln(3) + st & 3, En = $e.andln(3) + Nr & 3;
      $n === 3 && ($n = -1), En === 3 && (En = -1);
      var Rn;
      $n & 1 ? (br = xe.andln(7) + st & 7, (br === 3 || br === 5) && En === 2 ? Rn = -$n : Rn = $n) : Rn = 0, Ne[0].push(Rn);
      var wa;
      En & 1 ? (br = $e.andln(7) + Nr & 7, (br === 3 || br === 5) && $n === 2 ? wa = -En : wa = En) : wa = 0, Ne[1].push(wa), 2 * st === Rn + 1 && (st = 1 - st), 2 * Nr === wa + 1 && (Nr = 1 - Nr), xe.iushrn(1), $e.iushrn(1);
    }
    return Ne;
  }
  y.getJSF = he;
  function ge(xe, $e, Ne) {
    var st = "_" + $e;
    xe.prototype[$e] = function() {
      return this[st] !== void 0 ? this[st] : this[st] = Ne.call(this);
    };
  }
  y.cachedProperty = ge;
  function we(xe) {
    return typeof xe == "string" ? y.toArray(xe, "hex") : xe;
  }
  y.parseBytes = we;
  function Ee(xe) {
    return new z(xe, "hex", "le");
  }
  y.intFromLE = Ee;
})(utils$n);
var curve = {}, BN$6 = bnExports, utils$l = utils$n, getNAF = utils$l.getNAF, getJSF = utils$l.getJSF, assert$d = utils$l.assert;
function BaseCurve(v, y) {
  this.type = v, this.p = new BN$6(y.p, 16), this.red = y.prime ? BN$6.red(y.prime) : BN$6.mont(this.p), this.zero = new BN$6(0).toRed(this.red), this.one = new BN$6(1).toRed(this.red), this.two = new BN$6(2).toRed(this.red), this.n = y.n && new BN$6(y.n, 16), this.g = y.g && this.pointFromJSON(y.g, y.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var z = this.n && this.p.div(this.n);
  !z || z.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base$3 = BaseCurve;
BaseCurve.prototype.point = function v() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function v() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function v(y, z) {
  assert$d(y.precomputed);
  var ne = y._getDoubles(), ue = getNAF(z, 1, this._bitLength), le = (1 << ne.step + 1) - (ne.step % 2 === 0 ? 2 : 1);
  le /= 3;
  var he = [], ge, we;
  for (ge = 0; ge < ue.length; ge += ne.step) {
    we = 0;
    for (var Ee = ge + ne.step - 1; Ee >= ge; Ee--)
      we = (we << 1) + ue[Ee];
    he.push(we);
  }
  for (var xe = this.jpoint(null, null, null), $e = this.jpoint(null, null, null), Ne = le; Ne > 0; Ne--) {
    for (ge = 0; ge < he.length; ge++)
      we = he[ge], we === Ne ? $e = $e.mixedAdd(ne.points[ge]) : we === -Ne && ($e = $e.mixedAdd(ne.points[ge].neg()));
    xe = xe.add($e);
  }
  return xe.toP();
};
BaseCurve.prototype._wnafMul = function v(y, z) {
  var ne = 4, ue = y._getNAFPoints(ne);
  ne = ue.wnd;
  for (var le = ue.points, he = getNAF(z, ne, this._bitLength), ge = this.jpoint(null, null, null), we = he.length - 1; we >= 0; we--) {
    for (var Ee = 0; we >= 0 && he[we] === 0; we--)
      Ee++;
    if (we >= 0 && Ee++, ge = ge.dblp(Ee), we < 0)
      break;
    var xe = he[we];
    assert$d(xe !== 0), y.type === "affine" ? xe > 0 ? ge = ge.mixedAdd(le[xe - 1 >> 1]) : ge = ge.mixedAdd(le[-xe - 1 >> 1].neg()) : xe > 0 ? ge = ge.add(le[xe - 1 >> 1]) : ge = ge.add(le[-xe - 1 >> 1].neg());
  }
  return y.type === "affine" ? ge.toP() : ge;
};
BaseCurve.prototype._wnafMulAdd = function v(y, z, ne, ue, le) {
  var he = this._wnafT1, ge = this._wnafT2, we = this._wnafT3, Ee = 0, xe, $e, Ne;
  for (xe = 0; xe < ue; xe++) {
    Ne = z[xe];
    var st = Ne._getNAFPoints(y);
    he[xe] = st.wnd, ge[xe] = st.points;
  }
  for (xe = ue - 1; xe >= 1; xe -= 2) {
    var Nr = xe - 1, br = xe;
    if (he[Nr] !== 1 || he[br] !== 1) {
      we[Nr] = getNAF(ne[Nr], he[Nr], this._bitLength), we[br] = getNAF(ne[br], he[br], this._bitLength), Ee = Math.max(we[Nr].length, Ee), Ee = Math.max(we[br].length, Ee);
      continue;
    }
    var $n = [
      z[Nr],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      z[br]
      /* 7 */
    ];
    z[Nr].y.cmp(z[br].y) === 0 ? ($n[1] = z[Nr].add(z[br]), $n[2] = z[Nr].toJ().mixedAdd(z[br].neg())) : z[Nr].y.cmp(z[br].y.redNeg()) === 0 ? ($n[1] = z[Nr].toJ().mixedAdd(z[br]), $n[2] = z[Nr].add(z[br].neg())) : ($n[1] = z[Nr].toJ().mixedAdd(z[br]), $n[2] = z[Nr].toJ().mixedAdd(z[br].neg()));
    var En = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], Rn = getJSF(ne[Nr], ne[br]);
    for (Ee = Math.max(Rn[0].length, Ee), we[Nr] = new Array(Ee), we[br] = new Array(Ee), $e = 0; $e < Ee; $e++) {
      var wa = Rn[0][$e] | 0, Aa = Rn[1][$e] | 0;
      we[Nr][$e] = En[(wa + 1) * 3 + (Aa + 1)], we[br][$e] = 0, ge[Nr] = $n;
    }
  }
  var _a = this.jpoint(null, null, null), Ta = this._wnafT4;
  for (xe = Ee; xe >= 0; xe--) {
    for (var Zn = 0; xe >= 0; ) {
      var Ra = !0;
      for ($e = 0; $e < ue; $e++)
        Ta[$e] = we[$e][xe] | 0, Ta[$e] !== 0 && (Ra = !1);
      if (!Ra)
        break;
      Zn++, xe--;
    }
    if (xe >= 0 && Zn++, _a = _a.dblp(Zn), xe < 0)
      break;
    for ($e = 0; $e < ue; $e++) {
      var Yn = Ta[$e];
      Yn !== 0 && (Yn > 0 ? Ne = ge[$e][Yn - 1 >> 1] : Yn < 0 && (Ne = ge[$e][-Yn - 1 >> 1].neg()), Ne.type === "affine" ? _a = _a.mixedAdd(Ne) : _a = _a.add(Ne));
    }
  }
  for (xe = 0; xe < ue; xe++)
    ge[xe] = null;
  return le ? _a : _a.toP();
};
function BasePoint(v, y) {
  this.curve = v, this.type = y, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function v() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function v() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function v(y, z) {
  y = utils$l.toArray(y, z);
  var ne = this.p.byteLength();
  if ((y[0] === 4 || y[0] === 6 || y[0] === 7) && y.length - 1 === 2 * ne) {
    y[0] === 6 ? assert$d(y[y.length - 1] % 2 === 0) : y[0] === 7 && assert$d(y[y.length - 1] % 2 === 1);
    var ue = this.point(
      y.slice(1, 1 + ne),
      y.slice(1 + ne, 1 + 2 * ne)
    );
    return ue;
  } else if ((y[0] === 2 || y[0] === 3) && y.length - 1 === ne)
    return this.pointFromX(y.slice(1, 1 + ne), y[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function v(y) {
  return this.encode(y, !0);
};
BasePoint.prototype._encode = function v(y) {
  var z = this.curve.p.byteLength(), ne = this.getX().toArray("be", z);
  return y ? [this.getY().isEven() ? 2 : 3].concat(ne) : [4].concat(ne, this.getY().toArray("be", z));
};
BasePoint.prototype.encode = function v(y, z) {
  return utils$l.encode(this._encode(z), y);
};
BasePoint.prototype.precompute = function v(y) {
  if (this.precomputed)
    return this;
  var z = {
    doubles: null,
    naf: null,
    beta: null
  };
  return z.naf = this._getNAFPoints(8), z.doubles = this._getDoubles(4, y), z.beta = this._getBeta(), this.precomputed = z, this;
};
BasePoint.prototype._hasDoubles = function v(y) {
  if (!this.precomputed)
    return !1;
  var z = this.precomputed.doubles;
  return z ? z.points.length >= Math.ceil((y.bitLength() + 1) / z.step) : !1;
};
BasePoint.prototype._getDoubles = function v(y, z) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var ne = [this], ue = this, le = 0; le < z; le += y) {
    for (var he = 0; he < y; he++)
      ue = ue.dbl();
    ne.push(ue);
  }
  return {
    step: y,
    points: ne
  };
};
BasePoint.prototype._getNAFPoints = function v(y) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var z = [this], ne = (1 << y) - 1, ue = ne === 1 ? null : this.dbl(), le = 1; le < ne; le++)
    z[le] = z[le - 1].add(ue);
  return {
    wnd: y,
    points: z
  };
};
BasePoint.prototype._getBeta = function v() {
  return null;
};
BasePoint.prototype.dblp = function v(y) {
  for (var z = this, ne = 0; ne < y; ne++)
    z = z.dbl();
  return z;
};
var utils$k = utils$n, BN$5 = bnExports, inherits$3 = requireInherits_browser(), Base$2 = base$3, assert$c = utils$k.assert;
function ShortCurve(v) {
  Base$2.call(this, "short", v), this.a = new BN$5(v.a, 16).toRed(this.red), this.b = new BN$5(v.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(v), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$3(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function v(y) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var z, ne;
    if (y.beta)
      z = new BN$5(y.beta, 16).toRed(this.red);
    else {
      var ue = this._getEndoRoots(this.p);
      z = ue[0].cmp(ue[1]) < 0 ? ue[0] : ue[1], z = z.toRed(this.red);
    }
    if (y.lambda)
      ne = new BN$5(y.lambda, 16);
    else {
      var le = this._getEndoRoots(this.n);
      this.g.mul(le[0]).x.cmp(this.g.x.redMul(z)) === 0 ? ne = le[0] : (ne = le[1], assert$c(this.g.mul(ne).x.cmp(this.g.x.redMul(z)) === 0));
    }
    var he;
    return y.basis ? he = y.basis.map(function(ge) {
      return {
        a: new BN$5(ge.a, 16),
        b: new BN$5(ge.b, 16)
      };
    }) : he = this._getEndoBasis(ne), {
      beta: z,
      lambda: ne,
      basis: he
    };
  }
};
ShortCurve.prototype._getEndoRoots = function v(y) {
  var z = y === this.p ? this.red : BN$5.mont(y), ne = new BN$5(2).toRed(z).redInvm(), ue = ne.redNeg(), le = new BN$5(3).toRed(z).redNeg().redSqrt().redMul(ne), he = ue.redAdd(le).fromRed(), ge = ue.redSub(le).fromRed();
  return [he, ge];
};
ShortCurve.prototype._getEndoBasis = function v(y) {
  for (var z = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), ne = y, ue = this.n.clone(), le = new BN$5(1), he = new BN$5(0), ge = new BN$5(0), we = new BN$5(1), Ee, xe, $e, Ne, st, Nr, br, $n = 0, En, Rn; ne.cmpn(0) !== 0; ) {
    var wa = ue.div(ne);
    En = ue.sub(wa.mul(ne)), Rn = ge.sub(wa.mul(le));
    var Aa = we.sub(wa.mul(he));
    if (!$e && En.cmp(z) < 0)
      Ee = br.neg(), xe = le, $e = En.neg(), Ne = Rn;
    else if ($e && ++$n === 2)
      break;
    br = En, ue = ne, ne = En, ge = le, le = Rn, we = he, he = Aa;
  }
  st = En.neg(), Nr = Rn;
  var _a = $e.sqr().add(Ne.sqr()), Ta = st.sqr().add(Nr.sqr());
  return Ta.cmp(_a) >= 0 && (st = Ee, Nr = xe), $e.negative && ($e = $e.neg(), Ne = Ne.neg()), st.negative && (st = st.neg(), Nr = Nr.neg()), [
    { a: $e, b: Ne },
    { a: st, b: Nr }
  ];
};
ShortCurve.prototype._endoSplit = function v(y) {
  var z = this.endo.basis, ne = z[0], ue = z[1], le = ue.b.mul(y).divRound(this.n), he = ne.b.neg().mul(y).divRound(this.n), ge = le.mul(ne.a), we = he.mul(ue.a), Ee = le.mul(ne.b), xe = he.mul(ue.b), $e = y.sub(ge).sub(we), Ne = Ee.add(xe).neg();
  return { k1: $e, k2: Ne };
};
ShortCurve.prototype.pointFromX = function v(y, z) {
  y = new BN$5(y, 16), y.red || (y = y.toRed(this.red));
  var ne = y.redSqr().redMul(y).redIAdd(y.redMul(this.a)).redIAdd(this.b), ue = ne.redSqrt();
  if (ue.redSqr().redSub(ne).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var le = ue.fromRed().isOdd();
  return (z && !le || !z && le) && (ue = ue.redNeg()), this.point(y, ue);
};
ShortCurve.prototype.validate = function v(y) {
  if (y.inf)
    return !0;
  var z = y.x, ne = y.y, ue = this.a.redMul(z), le = z.redSqr().redMul(z).redIAdd(ue).redIAdd(this.b);
  return ne.redSqr().redISub(le).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function v(y, z, ne) {
  for (var ue = this._endoWnafT1, le = this._endoWnafT2, he = 0; he < y.length; he++) {
    var ge = this._endoSplit(z[he]), we = y[he], Ee = we._getBeta();
    ge.k1.negative && (ge.k1.ineg(), we = we.neg(!0)), ge.k2.negative && (ge.k2.ineg(), Ee = Ee.neg(!0)), ue[he * 2] = we, ue[he * 2 + 1] = Ee, le[he * 2] = ge.k1, le[he * 2 + 1] = ge.k2;
  }
  for (var xe = this._wnafMulAdd(1, ue, le, he * 2, ne), $e = 0; $e < he * 2; $e++)
    ue[$e] = null, le[$e] = null;
  return xe;
};
function Point$2(v, y, z, ne) {
  Base$2.BasePoint.call(this, v, "affine"), y === null && z === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$5(y, 16), this.y = new BN$5(z, 16), ne && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$3(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function v(y, z, ne) {
  return new Point$2(this, y, z, ne);
};
ShortCurve.prototype.pointFromJSON = function v(y, z) {
  return Point$2.fromJSON(this, y, z);
};
Point$2.prototype._getBeta = function v() {
  if (this.curve.endo) {
    var y = this.precomputed;
    if (y && y.beta)
      return y.beta;
    var z = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (y) {
      var ne = this.curve, ue = function(le) {
        return ne.point(le.x.redMul(ne.endo.beta), le.y);
      };
      y.beta = z, z.precomputed = {
        beta: null,
        naf: y.naf && {
          wnd: y.naf.wnd,
          points: y.naf.points.map(ue)
        },
        doubles: y.doubles && {
          step: y.doubles.step,
          points: y.doubles.points.map(ue)
        }
      };
    }
    return z;
  }
};
Point$2.prototype.toJSON = function v() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function v(y, z, ne) {
  typeof z == "string" && (z = JSON.parse(z));
  var ue = y.point(z[0], z[1], ne);
  if (!z[2])
    return ue;
  function le(ge) {
    return y.point(ge[0], ge[1], ne);
  }
  var he = z[2];
  return ue.precomputed = {
    beta: null,
    doubles: he.doubles && {
      step: he.doubles.step,
      points: [ue].concat(he.doubles.points.map(le))
    },
    naf: he.naf && {
      wnd: he.naf.wnd,
      points: [ue].concat(he.naf.points.map(le))
    }
  }, ue;
};
Point$2.prototype.inspect = function v() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function v() {
  return this.inf;
};
Point$2.prototype.add = function v(y) {
  if (this.inf)
    return y;
  if (y.inf)
    return this;
  if (this.eq(y))
    return this.dbl();
  if (this.neg().eq(y))
    return this.curve.point(null, null);
  if (this.x.cmp(y.x) === 0)
    return this.curve.point(null, null);
  var z = this.y.redSub(y.y);
  z.cmpn(0) !== 0 && (z = z.redMul(this.x.redSub(y.x).redInvm()));
  var ne = z.redSqr().redISub(this.x).redISub(y.x), ue = z.redMul(this.x.redSub(ne)).redISub(this.y);
  return this.curve.point(ne, ue);
};
Point$2.prototype.dbl = function v() {
  if (this.inf)
    return this;
  var y = this.y.redAdd(this.y);
  if (y.cmpn(0) === 0)
    return this.curve.point(null, null);
  var z = this.curve.a, ne = this.x.redSqr(), ue = y.redInvm(), le = ne.redAdd(ne).redIAdd(ne).redIAdd(z).redMul(ue), he = le.redSqr().redISub(this.x.redAdd(this.x)), ge = le.redMul(this.x.redSub(he)).redISub(this.y);
  return this.curve.point(he, ge);
};
Point$2.prototype.getX = function v() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function v() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function v(y) {
  return y = new BN$5(y, 16), this.isInfinity() ? this : this._hasDoubles(y) ? this.curve._fixedNafMul(this, y) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [y]) : this.curve._wnafMul(this, y);
};
Point$2.prototype.mulAdd = function v(y, z, ne) {
  var ue = [this, z], le = [y, ne];
  return this.curve.endo ? this.curve._endoWnafMulAdd(ue, le) : this.curve._wnafMulAdd(1, ue, le, 2);
};
Point$2.prototype.jmulAdd = function v(y, z, ne) {
  var ue = [this, z], le = [y, ne];
  return this.curve.endo ? this.curve._endoWnafMulAdd(ue, le, !0) : this.curve._wnafMulAdd(1, ue, le, 2, !0);
};
Point$2.prototype.eq = function v(y) {
  return this === y || this.inf === y.inf && (this.inf || this.x.cmp(y.x) === 0 && this.y.cmp(y.y) === 0);
};
Point$2.prototype.neg = function v(y) {
  if (this.inf)
    return this;
  var z = this.curve.point(this.x, this.y.redNeg());
  if (y && this.precomputed) {
    var ne = this.precomputed, ue = function(le) {
      return le.neg();
    };
    z.precomputed = {
      naf: ne.naf && {
        wnd: ne.naf.wnd,
        points: ne.naf.points.map(ue)
      },
      doubles: ne.doubles && {
        step: ne.doubles.step,
        points: ne.doubles.points.map(ue)
      }
    };
  }
  return z;
};
Point$2.prototype.toJ = function v() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var y = this.curve.jpoint(this.x, this.y, this.curve.one);
  return y;
};
function JPoint(v, y, z, ne) {
  Base$2.BasePoint.call(this, v, "jacobian"), y === null && z === null && ne === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$5(0)) : (this.x = new BN$5(y, 16), this.y = new BN$5(z, 16), this.z = new BN$5(ne, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$3(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function v(y, z, ne) {
  return new JPoint(this, y, z, ne);
};
JPoint.prototype.toP = function v() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var y = this.z.redInvm(), z = y.redSqr(), ne = this.x.redMul(z), ue = this.y.redMul(z).redMul(y);
  return this.curve.point(ne, ue);
};
JPoint.prototype.neg = function v() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function v(y) {
  if (this.isInfinity())
    return y;
  if (y.isInfinity())
    return this;
  var z = y.z.redSqr(), ne = this.z.redSqr(), ue = this.x.redMul(z), le = y.x.redMul(ne), he = this.y.redMul(z.redMul(y.z)), ge = y.y.redMul(ne.redMul(this.z)), we = ue.redSub(le), Ee = he.redSub(ge);
  if (we.cmpn(0) === 0)
    return Ee.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var xe = we.redSqr(), $e = xe.redMul(we), Ne = ue.redMul(xe), st = Ee.redSqr().redIAdd($e).redISub(Ne).redISub(Ne), Nr = Ee.redMul(Ne.redISub(st)).redISub(he.redMul($e)), br = this.z.redMul(y.z).redMul(we);
  return this.curve.jpoint(st, Nr, br);
};
JPoint.prototype.mixedAdd = function v(y) {
  if (this.isInfinity())
    return y.toJ();
  if (y.isInfinity())
    return this;
  var z = this.z.redSqr(), ne = this.x, ue = y.x.redMul(z), le = this.y, he = y.y.redMul(z).redMul(this.z), ge = ne.redSub(ue), we = le.redSub(he);
  if (ge.cmpn(0) === 0)
    return we.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var Ee = ge.redSqr(), xe = Ee.redMul(ge), $e = ne.redMul(Ee), Ne = we.redSqr().redIAdd(xe).redISub($e).redISub($e), st = we.redMul($e.redISub(Ne)).redISub(le.redMul(xe)), Nr = this.z.redMul(ge);
  return this.curve.jpoint(Ne, st, Nr);
};
JPoint.prototype.dblp = function v(y) {
  if (y === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!y)
    return this.dbl();
  var z;
  if (this.curve.zeroA || this.curve.threeA) {
    var ne = this;
    for (z = 0; z < y; z++)
      ne = ne.dbl();
    return ne;
  }
  var ue = this.curve.a, le = this.curve.tinv, he = this.x, ge = this.y, we = this.z, Ee = we.redSqr().redSqr(), xe = ge.redAdd(ge);
  for (z = 0; z < y; z++) {
    var $e = he.redSqr(), Ne = xe.redSqr(), st = Ne.redSqr(), Nr = $e.redAdd($e).redIAdd($e).redIAdd(ue.redMul(Ee)), br = he.redMul(Ne), $n = Nr.redSqr().redISub(br.redAdd(br)), En = br.redISub($n), Rn = Nr.redMul(En);
    Rn = Rn.redIAdd(Rn).redISub(st);
    var wa = xe.redMul(we);
    z + 1 < y && (Ee = Ee.redMul(st)), he = $n, we = wa, xe = Rn;
  }
  return this.curve.jpoint(he, xe.redMul(le), we);
};
JPoint.prototype.dbl = function v() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function v() {
  var y, z, ne;
  if (this.zOne) {
    var ue = this.x.redSqr(), le = this.y.redSqr(), he = le.redSqr(), ge = this.x.redAdd(le).redSqr().redISub(ue).redISub(he);
    ge = ge.redIAdd(ge);
    var we = ue.redAdd(ue).redIAdd(ue), Ee = we.redSqr().redISub(ge).redISub(ge), xe = he.redIAdd(he);
    xe = xe.redIAdd(xe), xe = xe.redIAdd(xe), y = Ee, z = we.redMul(ge.redISub(Ee)).redISub(xe), ne = this.y.redAdd(this.y);
  } else {
    var $e = this.x.redSqr(), Ne = this.y.redSqr(), st = Ne.redSqr(), Nr = this.x.redAdd(Ne).redSqr().redISub($e).redISub(st);
    Nr = Nr.redIAdd(Nr);
    var br = $e.redAdd($e).redIAdd($e), $n = br.redSqr(), En = st.redIAdd(st);
    En = En.redIAdd(En), En = En.redIAdd(En), y = $n.redISub(Nr).redISub(Nr), z = br.redMul(Nr.redISub(y)).redISub(En), ne = this.y.redMul(this.z), ne = ne.redIAdd(ne);
  }
  return this.curve.jpoint(y, z, ne);
};
JPoint.prototype._threeDbl = function v() {
  var y, z, ne;
  if (this.zOne) {
    var ue = this.x.redSqr(), le = this.y.redSqr(), he = le.redSqr(), ge = this.x.redAdd(le).redSqr().redISub(ue).redISub(he);
    ge = ge.redIAdd(ge);
    var we = ue.redAdd(ue).redIAdd(ue).redIAdd(this.curve.a), Ee = we.redSqr().redISub(ge).redISub(ge);
    y = Ee;
    var xe = he.redIAdd(he);
    xe = xe.redIAdd(xe), xe = xe.redIAdd(xe), z = we.redMul(ge.redISub(Ee)).redISub(xe), ne = this.y.redAdd(this.y);
  } else {
    var $e = this.z.redSqr(), Ne = this.y.redSqr(), st = this.x.redMul(Ne), Nr = this.x.redSub($e).redMul(this.x.redAdd($e));
    Nr = Nr.redAdd(Nr).redIAdd(Nr);
    var br = st.redIAdd(st);
    br = br.redIAdd(br);
    var $n = br.redAdd(br);
    y = Nr.redSqr().redISub($n), ne = this.y.redAdd(this.z).redSqr().redISub(Ne).redISub($e);
    var En = Ne.redSqr();
    En = En.redIAdd(En), En = En.redIAdd(En), En = En.redIAdd(En), z = Nr.redMul(br.redISub(y)).redISub(En);
  }
  return this.curve.jpoint(y, z, ne);
};
JPoint.prototype._dbl = function v() {
  var y = this.curve.a, z = this.x, ne = this.y, ue = this.z, le = ue.redSqr().redSqr(), he = z.redSqr(), ge = ne.redSqr(), we = he.redAdd(he).redIAdd(he).redIAdd(y.redMul(le)), Ee = z.redAdd(z);
  Ee = Ee.redIAdd(Ee);
  var xe = Ee.redMul(ge), $e = we.redSqr().redISub(xe.redAdd(xe)), Ne = xe.redISub($e), st = ge.redSqr();
  st = st.redIAdd(st), st = st.redIAdd(st), st = st.redIAdd(st);
  var Nr = we.redMul(Ne).redISub(st), br = ne.redAdd(ne).redMul(ue);
  return this.curve.jpoint($e, Nr, br);
};
JPoint.prototype.trpl = function v() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var y = this.x.redSqr(), z = this.y.redSqr(), ne = this.z.redSqr(), ue = z.redSqr(), le = y.redAdd(y).redIAdd(y), he = le.redSqr(), ge = this.x.redAdd(z).redSqr().redISub(y).redISub(ue);
  ge = ge.redIAdd(ge), ge = ge.redAdd(ge).redIAdd(ge), ge = ge.redISub(he);
  var we = ge.redSqr(), Ee = ue.redIAdd(ue);
  Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee);
  var xe = le.redIAdd(ge).redSqr().redISub(he).redISub(we).redISub(Ee), $e = z.redMul(xe);
  $e = $e.redIAdd($e), $e = $e.redIAdd($e);
  var Ne = this.x.redMul(we).redISub($e);
  Ne = Ne.redIAdd(Ne), Ne = Ne.redIAdd(Ne);
  var st = this.y.redMul(xe.redMul(Ee.redISub(xe)).redISub(ge.redMul(we)));
  st = st.redIAdd(st), st = st.redIAdd(st), st = st.redIAdd(st);
  var Nr = this.z.redAdd(ge).redSqr().redISub(ne).redISub(we);
  return this.curve.jpoint(Ne, st, Nr);
};
JPoint.prototype.mul = function v(y, z) {
  return y = new BN$5(y, z), this.curve._wnafMul(this, y);
};
JPoint.prototype.eq = function v(y) {
  if (y.type === "affine")
    return this.eq(y.toJ());
  if (this === y)
    return !0;
  var z = this.z.redSqr(), ne = y.z.redSqr();
  if (this.x.redMul(ne).redISub(y.x.redMul(z)).cmpn(0) !== 0)
    return !1;
  var ue = z.redMul(this.z), le = ne.redMul(y.z);
  return this.y.redMul(le).redISub(y.y.redMul(ue)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function v(y) {
  var z = this.z.redSqr(), ne = y.toRed(this.curve.red).redMul(z);
  if (this.x.cmp(ne) === 0)
    return !0;
  for (var ue = y.clone(), le = this.curve.redN.redMul(z); ; ) {
    if (ue.iadd(this.curve.n), ue.cmp(this.curve.p) >= 0)
      return !1;
    if (ne.redIAdd(le), this.x.cmp(ne) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function v() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function v() {
  return this.z.cmpn(0) === 0;
};
var BN$4 = bnExports, inherits$2 = requireInherits_browser(), Base$1 = base$3, utils$j = utils$n;
function MontCurve(v) {
  Base$1.call(this, "mont", v), this.a = new BN$4(v.a, 16).toRed(this.red), this.b = new BN$4(v.b, 16).toRed(this.red), this.i4 = new BN$4(4).toRed(this.red).redInvm(), this.two = new BN$4(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$2(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function v(y) {
  var z = y.normalize().x, ne = z.redSqr(), ue = ne.redMul(z).redAdd(ne.redMul(this.a)).redAdd(z), le = ue.redSqrt();
  return le.redSqr().cmp(ue) === 0;
};
function Point$1(v, y, z) {
  Base$1.BasePoint.call(this, v, "projective"), y === null && z === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$4(y, 16), this.z = new BN$4(z, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$2(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function v(y, z) {
  return this.point(utils$j.toArray(y, z), 1);
};
MontCurve.prototype.point = function v(y, z) {
  return new Point$1(this, y, z);
};
MontCurve.prototype.pointFromJSON = function v(y) {
  return Point$1.fromJSON(this, y);
};
Point$1.prototype.precompute = function v() {
};
Point$1.prototype._encode = function v() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function v(y, z) {
  return new Point$1(y, z[0], z[1] || y.one);
};
Point$1.prototype.inspect = function v() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function v() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function v() {
  var y = this.x.redAdd(this.z), z = y.redSqr(), ne = this.x.redSub(this.z), ue = ne.redSqr(), le = z.redSub(ue), he = z.redMul(ue), ge = le.redMul(ue.redAdd(this.curve.a24.redMul(le)));
  return this.curve.point(he, ge);
};
Point$1.prototype.add = function v() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function v(y, z) {
  var ne = this.x.redAdd(this.z), ue = this.x.redSub(this.z), le = y.x.redAdd(y.z), he = y.x.redSub(y.z), ge = he.redMul(ne), we = le.redMul(ue), Ee = z.z.redMul(ge.redAdd(we).redSqr()), xe = z.x.redMul(ge.redISub(we).redSqr());
  return this.curve.point(Ee, xe);
};
Point$1.prototype.mul = function v(y) {
  for (var z = y.clone(), ne = this, ue = this.curve.point(null, null), le = this, he = []; z.cmpn(0) !== 0; z.iushrn(1))
    he.push(z.andln(1));
  for (var ge = he.length - 1; ge >= 0; ge--)
    he[ge] === 0 ? (ne = ne.diffAdd(ue, le), ue = ue.dbl()) : (ue = ne.diffAdd(ue, le), ne = ne.dbl());
  return ue;
};
Point$1.prototype.mulAdd = function v() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function v() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function v(y) {
  return this.getX().cmp(y.getX()) === 0;
};
Point$1.prototype.normalize = function v() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function v() {
  return this.normalize(), this.x.fromRed();
};
var utils$i = utils$n, BN$3 = bnExports, inherits$1 = requireInherits_browser(), Base = base$3, assert$b = utils$i.assert;
function EdwardsCurve(v) {
  this.twisted = (v.a | 0) !== 1, this.mOneA = this.twisted && (v.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", v), this.a = new BN$3(v.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$3(v.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$3(v.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$b(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (v.c | 0) === 1;
}
inherits$1(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function v(y) {
  return this.mOneA ? y.redNeg() : this.a.redMul(y);
};
EdwardsCurve.prototype._mulC = function v(y) {
  return this.oneC ? y : this.c.redMul(y);
};
EdwardsCurve.prototype.jpoint = function v(y, z, ne, ue) {
  return this.point(y, z, ne, ue);
};
EdwardsCurve.prototype.pointFromX = function v(y, z) {
  y = new BN$3(y, 16), y.red || (y = y.toRed(this.red));
  var ne = y.redSqr(), ue = this.c2.redSub(this.a.redMul(ne)), le = this.one.redSub(this.c2.redMul(this.d).redMul(ne)), he = ue.redMul(le.redInvm()), ge = he.redSqrt();
  if (ge.redSqr().redSub(he).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var we = ge.fromRed().isOdd();
  return (z && !we || !z && we) && (ge = ge.redNeg()), this.point(y, ge);
};
EdwardsCurve.prototype.pointFromY = function v(y, z) {
  y = new BN$3(y, 16), y.red || (y = y.toRed(this.red));
  var ne = y.redSqr(), ue = ne.redSub(this.c2), le = ne.redMul(this.d).redMul(this.c2).redSub(this.a), he = ue.redMul(le.redInvm());
  if (he.cmp(this.zero) === 0) {
    if (z)
      throw new Error("invalid point");
    return this.point(this.zero, y);
  }
  var ge = he.redSqrt();
  if (ge.redSqr().redSub(he).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return ge.fromRed().isOdd() !== z && (ge = ge.redNeg()), this.point(ge, y);
};
EdwardsCurve.prototype.validate = function v(y) {
  if (y.isInfinity())
    return !0;
  y.normalize();
  var z = y.x.redSqr(), ne = y.y.redSqr(), ue = z.redMul(this.a).redAdd(ne), le = this.c2.redMul(this.one.redAdd(this.d.redMul(z).redMul(ne)));
  return ue.cmp(le) === 0;
};
function Point(v, y, z, ne, ue) {
  Base.BasePoint.call(this, v, "projective"), y === null && z === null && ne === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$3(y, 16), this.y = new BN$3(z, 16), this.z = ne ? new BN$3(ne, 16) : this.curve.one, this.t = ue && new BN$3(ue, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$1(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function v(y) {
  return Point.fromJSON(this, y);
};
EdwardsCurve.prototype.point = function v(y, z, ne, ue) {
  return new Point(this, y, z, ne, ue);
};
Point.fromJSON = function v(y, z) {
  return new Point(y, z[0], z[1], z[2]);
};
Point.prototype.inspect = function v() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function v() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function v() {
  var y = this.x.redSqr(), z = this.y.redSqr(), ne = this.z.redSqr();
  ne = ne.redIAdd(ne);
  var ue = this.curve._mulA(y), le = this.x.redAdd(this.y).redSqr().redISub(y).redISub(z), he = ue.redAdd(z), ge = he.redSub(ne), we = ue.redSub(z), Ee = le.redMul(ge), xe = he.redMul(we), $e = le.redMul(we), Ne = ge.redMul(he);
  return this.curve.point(Ee, xe, Ne, $e);
};
Point.prototype._projDbl = function v() {
  var y = this.x.redAdd(this.y).redSqr(), z = this.x.redSqr(), ne = this.y.redSqr(), ue, le, he, ge, we, Ee;
  if (this.curve.twisted) {
    ge = this.curve._mulA(z);
    var xe = ge.redAdd(ne);
    this.zOne ? (ue = y.redSub(z).redSub(ne).redMul(xe.redSub(this.curve.two)), le = xe.redMul(ge.redSub(ne)), he = xe.redSqr().redSub(xe).redSub(xe)) : (we = this.z.redSqr(), Ee = xe.redSub(we).redISub(we), ue = y.redSub(z).redISub(ne).redMul(Ee), le = xe.redMul(ge.redSub(ne)), he = xe.redMul(Ee));
  } else
    ge = z.redAdd(ne), we = this.curve._mulC(this.z).redSqr(), Ee = ge.redSub(we).redSub(we), ue = this.curve._mulC(y.redISub(ge)).redMul(Ee), le = this.curve._mulC(ge).redMul(z.redISub(ne)), he = ge.redMul(Ee);
  return this.curve.point(ue, le, he);
};
Point.prototype.dbl = function v() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function v(y) {
  var z = this.y.redSub(this.x).redMul(y.y.redSub(y.x)), ne = this.y.redAdd(this.x).redMul(y.y.redAdd(y.x)), ue = this.t.redMul(this.curve.dd).redMul(y.t), le = this.z.redMul(y.z.redAdd(y.z)), he = ne.redSub(z), ge = le.redSub(ue), we = le.redAdd(ue), Ee = ne.redAdd(z), xe = he.redMul(ge), $e = we.redMul(Ee), Ne = he.redMul(Ee), st = ge.redMul(we);
  return this.curve.point(xe, $e, st, Ne);
};
Point.prototype._projAdd = function v(y) {
  var z = this.z.redMul(y.z), ne = z.redSqr(), ue = this.x.redMul(y.x), le = this.y.redMul(y.y), he = this.curve.d.redMul(ue).redMul(le), ge = ne.redSub(he), we = ne.redAdd(he), Ee = this.x.redAdd(this.y).redMul(y.x.redAdd(y.y)).redISub(ue).redISub(le), xe = z.redMul(ge).redMul(Ee), $e, Ne;
  return this.curve.twisted ? ($e = z.redMul(we).redMul(le.redSub(this.curve._mulA(ue))), Ne = ge.redMul(we)) : ($e = z.redMul(we).redMul(le.redSub(ue)), Ne = this.curve._mulC(ge).redMul(we)), this.curve.point(xe, $e, Ne);
};
Point.prototype.add = function v(y) {
  return this.isInfinity() ? y : y.isInfinity() ? this : this.curve.extended ? this._extAdd(y) : this._projAdd(y);
};
Point.prototype.mul = function v(y) {
  return this._hasDoubles(y) ? this.curve._fixedNafMul(this, y) : this.curve._wnafMul(this, y);
};
Point.prototype.mulAdd = function v(y, z, ne) {
  return this.curve._wnafMulAdd(1, [this, z], [y, ne], 2, !1);
};
Point.prototype.jmulAdd = function v(y, z, ne) {
  return this.curve._wnafMulAdd(1, [this, z], [y, ne], 2, !0);
};
Point.prototype.normalize = function v() {
  if (this.zOne)
    return this;
  var y = this.z.redInvm();
  return this.x = this.x.redMul(y), this.y = this.y.redMul(y), this.t && (this.t = this.t.redMul(y)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function v() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function v() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function v() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function v(y) {
  return this === y || this.getX().cmp(y.getX()) === 0 && this.getY().cmp(y.getY()) === 0;
};
Point.prototype.eqXToP = function v(y) {
  var z = y.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(z) === 0)
    return !0;
  for (var ne = y.clone(), ue = this.curve.redN.redMul(this.z); ; ) {
    if (ne.iadd(this.curve.n), ne.cmp(this.curve.p) >= 0)
      return !1;
    if (z.redIAdd(ue), this.x.cmp(z) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(v) {
  var y = v;
  y.base = base$3, y.short = short, y.mont = mont, y.edwards = edwards;
})(curve);
var curves$1 = {}, hash$3 = {}, utils$h = {}, assert$a = minimalisticAssert, inherits = requireInherits_browser();
utils$h.inherits = inherits;
function isSurrogatePair(v, y) {
  return (v.charCodeAt(y) & 64512) !== 55296 || y < 0 || y + 1 >= v.length ? !1 : (v.charCodeAt(y + 1) & 64512) === 56320;
}
function toArray(v, y) {
  if (Array.isArray(v))
    return v.slice();
  if (!v)
    return [];
  var z = [];
  if (typeof v == "string")
    if (y) {
      if (y === "hex")
        for (v = v.replace(/[^a-z0-9]+/ig, ""), v.length % 2 !== 0 && (v = "0" + v), ue = 0; ue < v.length; ue += 2)
          z.push(parseInt(v[ue] + v[ue + 1], 16));
    } else
      for (var ne = 0, ue = 0; ue < v.length; ue++) {
        var le = v.charCodeAt(ue);
        le < 128 ? z[ne++] = le : le < 2048 ? (z[ne++] = le >> 6 | 192, z[ne++] = le & 63 | 128) : isSurrogatePair(v, ue) ? (le = 65536 + ((le & 1023) << 10) + (v.charCodeAt(++ue) & 1023), z[ne++] = le >> 18 | 240, z[ne++] = le >> 12 & 63 | 128, z[ne++] = le >> 6 & 63 | 128, z[ne++] = le & 63 | 128) : (z[ne++] = le >> 12 | 224, z[ne++] = le >> 6 & 63 | 128, z[ne++] = le & 63 | 128);
      }
  else
    for (ue = 0; ue < v.length; ue++)
      z[ue] = v[ue] | 0;
  return z;
}
utils$h.toArray = toArray;
function toHex$2(v) {
  for (var y = "", z = 0; z < v.length; z++)
    y += zero2(v[z].toString(16));
  return y;
}
utils$h.toHex = toHex$2;
function htonl(v) {
  var y = v >>> 24 | v >>> 8 & 65280 | v << 8 & 16711680 | (v & 255) << 24;
  return y >>> 0;
}
utils$h.htonl = htonl;
function toHex32(v, y) {
  for (var z = "", ne = 0; ne < v.length; ne++) {
    var ue = v[ne];
    y === "little" && (ue = htonl(ue)), z += zero8(ue.toString(16));
  }
  return z;
}
utils$h.toHex32 = toHex32;
function zero2(v) {
  return v.length === 1 ? "0" + v : v;
}
utils$h.zero2 = zero2;
function zero8(v) {
  return v.length === 7 ? "0" + v : v.length === 6 ? "00" + v : v.length === 5 ? "000" + v : v.length === 4 ? "0000" + v : v.length === 3 ? "00000" + v : v.length === 2 ? "000000" + v : v.length === 1 ? "0000000" + v : v;
}
utils$h.zero8 = zero8;
function join32(v, y, z, ne) {
  var ue = z - y;
  assert$a(ue % 4 === 0);
  for (var le = new Array(ue / 4), he = 0, ge = y; he < le.length; he++, ge += 4) {
    var we;
    ne === "big" ? we = v[ge] << 24 | v[ge + 1] << 16 | v[ge + 2] << 8 | v[ge + 3] : we = v[ge + 3] << 24 | v[ge + 2] << 16 | v[ge + 1] << 8 | v[ge], le[he] = we >>> 0;
  }
  return le;
}
utils$h.join32 = join32;
function split32(v, y) {
  for (var z = new Array(v.length * 4), ne = 0, ue = 0; ne < v.length; ne++, ue += 4) {
    var le = v[ne];
    y === "big" ? (z[ue] = le >>> 24, z[ue + 1] = le >>> 16 & 255, z[ue + 2] = le >>> 8 & 255, z[ue + 3] = le & 255) : (z[ue + 3] = le >>> 24, z[ue + 2] = le >>> 16 & 255, z[ue + 1] = le >>> 8 & 255, z[ue] = le & 255);
  }
  return z;
}
utils$h.split32 = split32;
function rotr32$1(v, y) {
  return v >>> y | v << 32 - y;
}
utils$h.rotr32 = rotr32$1;
function rotl32$2(v, y) {
  return v << y | v >>> 32 - y;
}
utils$h.rotl32 = rotl32$2;
function sum32$3(v, y) {
  return v + y >>> 0;
}
utils$h.sum32 = sum32$3;
function sum32_3$1(v, y, z) {
  return v + y + z >>> 0;
}
utils$h.sum32_3 = sum32_3$1;
function sum32_4$2(v, y, z, ne) {
  return v + y + z + ne >>> 0;
}
utils$h.sum32_4 = sum32_4$2;
function sum32_5$2(v, y, z, ne, ue) {
  return v + y + z + ne + ue >>> 0;
}
utils$h.sum32_5 = sum32_5$2;
function sum64$1(v, y, z, ne) {
  var ue = v[y], le = v[y + 1], he = ne + le >>> 0, ge = (he < ne ? 1 : 0) + z + ue;
  v[y] = ge >>> 0, v[y + 1] = he;
}
utils$h.sum64 = sum64$1;
function sum64_hi$1(v, y, z, ne) {
  var ue = y + ne >>> 0, le = (ue < y ? 1 : 0) + v + z;
  return le >>> 0;
}
utils$h.sum64_hi = sum64_hi$1;
function sum64_lo$1(v, y, z, ne) {
  var ue = y + ne;
  return ue >>> 0;
}
utils$h.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(v, y, z, ne, ue, le, he, ge) {
  var we = 0, Ee = y;
  Ee = Ee + ne >>> 0, we += Ee < y ? 1 : 0, Ee = Ee + le >>> 0, we += Ee < le ? 1 : 0, Ee = Ee + ge >>> 0, we += Ee < ge ? 1 : 0;
  var xe = v + z + ue + he + we;
  return xe >>> 0;
}
utils$h.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(v, y, z, ne, ue, le, he, ge) {
  var we = y + ne + le + ge;
  return we >>> 0;
}
utils$h.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(v, y, z, ne, ue, le, he, ge, we, Ee) {
  var xe = 0, $e = y;
  $e = $e + ne >>> 0, xe += $e < y ? 1 : 0, $e = $e + le >>> 0, xe += $e < le ? 1 : 0, $e = $e + ge >>> 0, xe += $e < ge ? 1 : 0, $e = $e + Ee >>> 0, xe += $e < Ee ? 1 : 0;
  var Ne = v + z + ue + he + we + xe;
  return Ne >>> 0;
}
utils$h.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(v, y, z, ne, ue, le, he, ge, we, Ee) {
  var xe = y + ne + le + ge + Ee;
  return xe >>> 0;
}
utils$h.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(v, y, z) {
  var ne = y << 32 - z | v >>> z;
  return ne >>> 0;
}
utils$h.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(v, y, z) {
  var ne = v << 32 - z | y >>> z;
  return ne >>> 0;
}
utils$h.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(v, y, z) {
  return v >>> z;
}
utils$h.shr64_hi = shr64_hi$1;
function shr64_lo$1(v, y, z) {
  var ne = v << 32 - z | y >>> z;
  return ne >>> 0;
}
utils$h.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$g = utils$h, assert$9 = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function v(y, z) {
  if (y = utils$g.toArray(y, z), this.pending ? this.pending = this.pending.concat(y) : this.pending = y, this.pendingTotal += y.length, this.pending.length >= this._delta8) {
    y = this.pending;
    var ne = y.length % this._delta8;
    this.pending = y.slice(y.length - ne, y.length), this.pending.length === 0 && (this.pending = null), y = utils$g.join32(y, 0, y.length - ne, this.endian);
    for (var ue = 0; ue < y.length; ue += this._delta32)
      this._update(y, ue, ue + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function v(y) {
  return this.update(this._pad()), assert$9(this.pending === null), this._digest(y);
};
BlockHash$4.prototype._pad = function v() {
  var y = this.pendingTotal, z = this._delta8, ne = z - (y + this.padLength) % z, ue = new Array(ne + this.padLength);
  ue[0] = 128;
  for (var le = 1; le < ne; le++)
    ue[le] = 0;
  if (y <<= 3, this.endian === "big") {
    for (var he = 8; he < this.padLength; he++)
      ue[le++] = 0;
    ue[le++] = 0, ue[le++] = 0, ue[le++] = 0, ue[le++] = 0, ue[le++] = y >>> 24 & 255, ue[le++] = y >>> 16 & 255, ue[le++] = y >>> 8 & 255, ue[le++] = y & 255;
  } else
    for (ue[le++] = y & 255, ue[le++] = y >>> 8 & 255, ue[le++] = y >>> 16 & 255, ue[le++] = y >>> 24 & 255, ue[le++] = 0, ue[le++] = 0, ue[le++] = 0, ue[le++] = 0, he = 8; he < this.padLength; he++)
      ue[le++] = 0;
  return ue;
};
var sha$1 = {}, common$4 = {}, utils$f = utils$h, rotr32 = utils$f.rotr32;
function ft_1$1(v, y, z, ne) {
  if (v === 0)
    return ch32$1(y, z, ne);
  if (v === 1 || v === 3)
    return p32(y, z, ne);
  if (v === 2)
    return maj32$1(y, z, ne);
}
common$4.ft_1 = ft_1$1;
function ch32$1(v, y, z) {
  return v & y ^ ~v & z;
}
common$4.ch32 = ch32$1;
function maj32$1(v, y, z) {
  return v & y ^ v & z ^ y & z;
}
common$4.maj32 = maj32$1;
function p32(v, y, z) {
  return v ^ y ^ z;
}
common$4.p32 = p32;
function s0_256$1(v) {
  return rotr32(v, 2) ^ rotr32(v, 13) ^ rotr32(v, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(v) {
  return rotr32(v, 6) ^ rotr32(v, 11) ^ rotr32(v, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(v) {
  return rotr32(v, 7) ^ rotr32(v, 18) ^ v >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(v) {
  return rotr32(v, 17) ^ rotr32(v, 19) ^ v >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$e = utils$h, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$e.rotl32, sum32$2 = utils$e.sum32, sum32_5$1 = utils$e.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$e.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function v(y, z) {
  for (var ne = this.W, ue = 0; ue < 16; ue++)
    ne[ue] = y[z + ue];
  for (; ue < ne.length; ue++)
    ne[ue] = rotl32$1(ne[ue - 3] ^ ne[ue - 8] ^ ne[ue - 14] ^ ne[ue - 16], 1);
  var le = this.h[0], he = this.h[1], ge = this.h[2], we = this.h[3], Ee = this.h[4];
  for (ue = 0; ue < ne.length; ue++) {
    var xe = ~~(ue / 20), $e = sum32_5$1(rotl32$1(le, 5), ft_1(xe, he, ge, we), Ee, ne[ue], sha1_K[xe]);
    Ee = we, we = ge, ge = rotl32$1(he, 30), he = le, le = $e;
  }
  this.h[0] = sum32$2(this.h[0], le), this.h[1] = sum32$2(this.h[1], he), this.h[2] = sum32$2(this.h[2], ge), this.h[3] = sum32$2(this.h[3], we), this.h[4] = sum32$2(this.h[4], Ee);
};
SHA1.prototype._digest = function v(y) {
  return y === "hex" ? utils$e.toHex32(this.h, "big") : utils$e.split32(this.h, "big");
};
var utils$d = utils$h, common$2 = common$5, shaCommon = common$4, assert$8 = minimalisticAssert, sum32$1 = utils$d.sum32, sum32_4$1 = utils$d.sum32_4, sum32_5 = utils$d.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$2() {
  if (!(this instanceof SHA256$2))
    return new SHA256$2();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$d.inherits(SHA256$2, BlockHash$2);
var _256 = SHA256$2;
SHA256$2.blockSize = 512;
SHA256$2.outSize = 256;
SHA256$2.hmacStrength = 192;
SHA256$2.padLength = 64;
SHA256$2.prototype._update = function v(y, z) {
  for (var ne = this.W, ue = 0; ue < 16; ue++)
    ne[ue] = y[z + ue];
  for (; ue < ne.length; ue++)
    ne[ue] = sum32_4$1(g1_256(ne[ue - 2]), ne[ue - 7], g0_256(ne[ue - 15]), ne[ue - 16]);
  var le = this.h[0], he = this.h[1], ge = this.h[2], we = this.h[3], Ee = this.h[4], xe = this.h[5], $e = this.h[6], Ne = this.h[7];
  for (assert$8(this.k.length === ne.length), ue = 0; ue < ne.length; ue++) {
    var st = sum32_5(Ne, s1_256(Ee), ch32(Ee, xe, $e), this.k[ue], ne[ue]), Nr = sum32$1(s0_256(le), maj32(le, he, ge));
    Ne = $e, $e = xe, xe = Ee, Ee = sum32$1(we, st), we = ge, ge = he, he = le, le = sum32$1(st, Nr);
  }
  this.h[0] = sum32$1(this.h[0], le), this.h[1] = sum32$1(this.h[1], he), this.h[2] = sum32$1(this.h[2], ge), this.h[3] = sum32$1(this.h[3], we), this.h[4] = sum32$1(this.h[4], Ee), this.h[5] = sum32$1(this.h[5], xe), this.h[6] = sum32$1(this.h[6], $e), this.h[7] = sum32$1(this.h[7], Ne);
};
SHA256$2.prototype._digest = function v(y) {
  return y === "hex" ? utils$d.toHex32(this.h, "big") : utils$d.split32(this.h, "big");
};
var utils$c = utils$h, SHA256$1 = _256;
function SHA224$1() {
  if (!(this instanceof SHA224$1))
    return new SHA224$1();
  SHA256$1.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$c.inherits(SHA224$1, SHA256$1);
var _224 = SHA224$1;
SHA224$1.blockSize = 512;
SHA224$1.outSize = 224;
SHA224$1.hmacStrength = 192;
SHA224$1.padLength = 64;
SHA224$1.prototype._digest = function v(y) {
  return y === "hex" ? utils$c.toHex32(this.h.slice(0, 7), "big") : utils$c.split32(this.h.slice(0, 7), "big");
};
var utils$b = utils$h, common$1 = common$5, assert$7 = minimalisticAssert, rotr64_hi = utils$b.rotr64_hi, rotr64_lo = utils$b.rotr64_lo, shr64_hi = utils$b.shr64_hi, shr64_lo = utils$b.shr64_lo, sum64 = utils$b.sum64, sum64_hi = utils$b.sum64_hi, sum64_lo = utils$b.sum64_lo, sum64_4_hi = utils$b.sum64_4_hi, sum64_4_lo = utils$b.sum64_4_lo, sum64_5_hi = utils$b.sum64_5_hi, sum64_5_lo = utils$b.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$b.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function v(y, z) {
  for (var ne = this.W, ue = 0; ue < 32; ue++)
    ne[ue] = y[z + ue];
  for (; ue < ne.length; ue += 2) {
    var le = g1_512_hi(ne[ue - 4], ne[ue - 3]), he = g1_512_lo(ne[ue - 4], ne[ue - 3]), ge = ne[ue - 14], we = ne[ue - 13], Ee = g0_512_hi(ne[ue - 30], ne[ue - 29]), xe = g0_512_lo(ne[ue - 30], ne[ue - 29]), $e = ne[ue - 32], Ne = ne[ue - 31];
    ne[ue] = sum64_4_hi(
      le,
      he,
      ge,
      we,
      Ee,
      xe,
      $e,
      Ne
    ), ne[ue + 1] = sum64_4_lo(
      le,
      he,
      ge,
      we,
      Ee,
      xe,
      $e,
      Ne
    );
  }
};
SHA512$1.prototype._update = function v(y, z) {
  this._prepareBlock(y, z);
  var ne = this.W, ue = this.h[0], le = this.h[1], he = this.h[2], ge = this.h[3], we = this.h[4], Ee = this.h[5], xe = this.h[6], $e = this.h[7], Ne = this.h[8], st = this.h[9], Nr = this.h[10], br = this.h[11], $n = this.h[12], En = this.h[13], Rn = this.h[14], wa = this.h[15];
  assert$7(this.k.length === ne.length);
  for (var Aa = 0; Aa < ne.length; Aa += 2) {
    var _a = Rn, Ta = wa, Zn = s1_512_hi(Ne, st), Ra = s1_512_lo(Ne, st), Yn = ch64_hi(Ne, st, Nr, br, $n), $o = ch64_lo(Ne, st, Nr, br, $n, En), ct = this.k[Aa], fe = this.k[Aa + 1], be = ne[Aa], ye = ne[Aa + 1], Se = sum64_5_hi(
      _a,
      Ta,
      Zn,
      Ra,
      Yn,
      $o,
      ct,
      fe,
      be,
      ye
    ), Oe = sum64_5_lo(
      _a,
      Ta,
      Zn,
      Ra,
      Yn,
      $o,
      ct,
      fe,
      be,
      ye
    );
    _a = s0_512_hi(ue, le), Ta = s0_512_lo(ue, le), Zn = maj64_hi(ue, le, he, ge, we), Ra = maj64_lo(ue, le, he, ge, we, Ee);
    var Fr = sum64_hi(_a, Ta, Zn, Ra), zn = sum64_lo(_a, Ta, Zn, Ra);
    Rn = $n, wa = En, $n = Nr, En = br, Nr = Ne, br = st, Ne = sum64_hi(xe, $e, Se, Oe), st = sum64_lo($e, $e, Se, Oe), xe = we, $e = Ee, we = he, Ee = ge, he = ue, ge = le, ue = sum64_hi(Se, Oe, Fr, zn), le = sum64_lo(Se, Oe, Fr, zn);
  }
  sum64(this.h, 0, ue, le), sum64(this.h, 2, he, ge), sum64(this.h, 4, we, Ee), sum64(this.h, 6, xe, $e), sum64(this.h, 8, Ne, st), sum64(this.h, 10, Nr, br), sum64(this.h, 12, $n, En), sum64(this.h, 14, Rn, wa);
};
SHA512$1.prototype._digest = function v(y) {
  return y === "hex" ? utils$b.toHex32(this.h, "big") : utils$b.split32(this.h, "big");
};
function ch64_hi(v, y, z, ne, ue) {
  var le = v & z ^ ~v & ue;
  return le < 0 && (le += 4294967296), le;
}
function ch64_lo(v, y, z, ne, ue, le) {
  var he = y & ne ^ ~y & le;
  return he < 0 && (he += 4294967296), he;
}
function maj64_hi(v, y, z, ne, ue) {
  var le = v & z ^ v & ue ^ z & ue;
  return le < 0 && (le += 4294967296), le;
}
function maj64_lo(v, y, z, ne, ue, le) {
  var he = y & ne ^ y & le ^ ne & le;
  return he < 0 && (he += 4294967296), he;
}
function s0_512_hi(v, y) {
  var z = rotr64_hi(v, y, 28), ne = rotr64_hi(y, v, 2), ue = rotr64_hi(y, v, 7), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function s0_512_lo(v, y) {
  var z = rotr64_lo(v, y, 28), ne = rotr64_lo(y, v, 2), ue = rotr64_lo(y, v, 7), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function s1_512_hi(v, y) {
  var z = rotr64_hi(v, y, 14), ne = rotr64_hi(v, y, 18), ue = rotr64_hi(y, v, 9), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function s1_512_lo(v, y) {
  var z = rotr64_lo(v, y, 14), ne = rotr64_lo(v, y, 18), ue = rotr64_lo(y, v, 9), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function g0_512_hi(v, y) {
  var z = rotr64_hi(v, y, 1), ne = rotr64_hi(v, y, 8), ue = shr64_hi(v, y, 7), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function g0_512_lo(v, y) {
  var z = rotr64_lo(v, y, 1), ne = rotr64_lo(v, y, 8), ue = shr64_lo(v, y, 7), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function g1_512_hi(v, y) {
  var z = rotr64_hi(v, y, 19), ne = rotr64_hi(y, v, 29), ue = shr64_hi(v, y, 6), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
function g1_512_lo(v, y) {
  var z = rotr64_lo(v, y, 19), ne = rotr64_lo(y, v, 29), ue = shr64_lo(v, y, 6), le = z ^ ne ^ ue;
  return le < 0 && (le += 4294967296), le;
}
var utils$a = utils$h, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$a.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function v(y) {
  return y === "hex" ? utils$a.toHex32(this.h.slice(0, 12), "big") : utils$a.split32(this.h.slice(0, 12), "big");
};
sha$1.sha1 = _1;
sha$1.sha224 = _224;
sha$1.sha256 = _256;
sha$1.sha384 = _384;
sha$1.sha512 = _512;
var ripemd$1 = {}, utils$9 = utils$h, common = common$5, rotl32 = utils$9.rotl32, sum32 = utils$9.sum32, sum32_3 = utils$9.sum32_3, sum32_4 = utils$9.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160$1() {
  if (!(this instanceof RIPEMD160$1))
    return new RIPEMD160$1();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$9.inherits(RIPEMD160$1, BlockHash);
ripemd$1.ripemd160 = RIPEMD160$1;
RIPEMD160$1.blockSize = 512;
RIPEMD160$1.outSize = 160;
RIPEMD160$1.hmacStrength = 192;
RIPEMD160$1.padLength = 64;
RIPEMD160$1.prototype._update = function v(y, z) {
  for (var ne = this.h[0], ue = this.h[1], le = this.h[2], he = this.h[3], ge = this.h[4], we = ne, Ee = ue, xe = le, $e = he, Ne = ge, st = 0; st < 80; st++) {
    var Nr = sum32(
      rotl32(
        sum32_4(ne, f$1(st, ue, le, he), y[r$1[st] + z], K$2(st)),
        s[st]
      ),
      ge
    );
    ne = ge, ge = he, he = rotl32(le, 10), le = ue, ue = Nr, Nr = sum32(
      rotl32(
        sum32_4(we, f$1(79 - st, Ee, xe, $e), y[rh[st] + z], Kh(st)),
        sh[st]
      ),
      Ne
    ), we = Ne, Ne = $e, $e = rotl32(xe, 10), xe = Ee, Ee = Nr;
  }
  Nr = sum32_3(this.h[1], le, $e), this.h[1] = sum32_3(this.h[2], he, Ne), this.h[2] = sum32_3(this.h[3], ge, we), this.h[3] = sum32_3(this.h[4], ne, Ee), this.h[4] = sum32_3(this.h[0], ue, xe), this.h[0] = Nr;
};
RIPEMD160$1.prototype._digest = function v(y) {
  return y === "hex" ? utils$9.toHex32(this.h, "little") : utils$9.split32(this.h, "little");
};
function f$1(v, y, z, ne) {
  return v <= 15 ? y ^ z ^ ne : v <= 31 ? y & z | ~y & ne : v <= 47 ? (y | ~z) ^ ne : v <= 63 ? y & ne | z & ~ne : y ^ (z | ~ne);
}
function K$2(v) {
  return v <= 15 ? 0 : v <= 31 ? 1518500249 : v <= 47 ? 1859775393 : v <= 63 ? 2400959708 : 2840853838;
}
function Kh(v) {
  return v <= 15 ? 1352829926 : v <= 31 ? 1548603684 : v <= 47 ? 1836072691 : v <= 63 ? 2053994217 : 0;
}
var r$1 = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$8 = utils$h, assert$6 = minimalisticAssert;
function Hmac$1(v, y, z) {
  if (!(this instanceof Hmac$1))
    return new Hmac$1(v, y, z);
  this.Hash = v, this.blockSize = v.blockSize / 8, this.outSize = v.outSize / 8, this.inner = null, this.outer = null, this._init(utils$8.toArray(y, z));
}
var hmac$3 = Hmac$1;
Hmac$1.prototype._init = function v(y) {
  y.length > this.blockSize && (y = new this.Hash().update(y).digest()), assert$6(y.length <= this.blockSize);
  for (var z = y.length; z < this.blockSize; z++)
    y.push(0);
  for (z = 0; z < y.length; z++)
    y[z] ^= 54;
  for (this.inner = new this.Hash().update(y), z = 0; z < y.length; z++)
    y[z] ^= 106;
  this.outer = new this.Hash().update(y);
};
Hmac$1.prototype.update = function v(y, z) {
  return this.inner.update(y, z), this;
};
Hmac$1.prototype.digest = function v(y) {
  return this.outer.update(this.inner.digest()), this.outer.digest(y);
};
(function(v) {
  var y = v;
  y.utils = utils$h, y.common = common$5, y.sha = sha$1, y.ripemd = ripemd$1, y.hmac = hmac$3, y.sha1 = y.sha.sha1, y.sha256 = y.sha.sha256, y.sha224 = y.sha.sha224, y.sha384 = y.sha.sha384, y.sha512 = y.sha.sha512, y.ripemd160 = y.ripemd.ripemd160;
})(hash$3);
var secp256k1$2, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1$2 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$2;
}
(function(v) {
  var y = v, z = hash$3, ne = curve, ue = utils$n, le = ue.assert;
  function he(Ee) {
    Ee.type === "short" ? this.curve = new ne.short(Ee) : Ee.type === "edwards" ? this.curve = new ne.edwards(Ee) : this.curve = new ne.mont(Ee), this.g = this.curve.g, this.n = this.curve.n, this.hash = Ee.hash, le(this.g.validate(), "Invalid curve"), le(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  y.PresetCurve = he;
  function ge(Ee, xe) {
    Object.defineProperty(y, Ee, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var $e = new he(xe);
        return Object.defineProperty(y, Ee, {
          configurable: !0,
          enumerable: !0,
          value: $e
        }), $e;
      }
    });
  }
  ge("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: z.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), ge("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: z.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), ge("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: z.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), ge("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: z.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), ge("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: z.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), ge("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: z.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), ge("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: z.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var we;
  try {
    we = requireSecp256k1();
  } catch {
    we = void 0;
  }
  ge("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: z.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      we
    ]
  });
})(curves$1);
var hash$2 = hash$3, utils$7 = utils$m, assert$5 = minimalisticAssert;
function HmacDRBG(v) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(v);
  this.hash = v.hash, this.predResist = !!v.predResist, this.outLen = this.hash.outSize, this.minEntropy = v.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var y = utils$7.toArray(v.entropy, v.entropyEnc || "hex"), z = utils$7.toArray(v.nonce, v.nonceEnc || "hex"), ne = utils$7.toArray(v.pers, v.persEnc || "hex");
  assert$5(
    y.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(y, z, ne);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function v(y, z, ne) {
  var ue = y.concat(z).concat(ne);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var le = 0; le < this.V.length; le++)
    this.K[le] = 0, this.V[le] = 1;
  this._update(ue), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG.prototype._hmac = function v() {
  return new hash$2.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function v(y) {
  var z = this._hmac().update(this.V).update([0]);
  y && (z = z.update(y)), this.K = z.digest(), this.V = this._hmac().update(this.V).digest(), y && (this.K = this._hmac().update(this.V).update([1]).update(y).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG.prototype.reseed = function v(y, z, ne, ue) {
  typeof z != "string" && (ue = ne, ne = z, z = null), y = utils$7.toArray(y, z), ne = utils$7.toArray(ne, ue), assert$5(
    y.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(y.concat(ne || [])), this._reseed = 1;
};
HmacDRBG.prototype.generate = function v(y, z, ne, ue) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof z != "string" && (ue = ne, ne = z, z = null), ne && (ne = utils$7.toArray(ne, ue || "hex"), this._update(ne));
  for (var le = []; le.length < y; )
    this.V = this._hmac().update(this.V).digest(), le = le.concat(this.V);
  var he = le.slice(0, y);
  return this._update(ne), this._reseed++, utils$7.encode(he, z);
};
var BN$2 = bnExports, utils$6 = utils$n, assert$4 = utils$6.assert;
function KeyPair$2(v, y) {
  this.ec = v, this.priv = null, this.pub = null, y.priv && this._importPrivate(y.priv, y.privEnc), y.pub && this._importPublic(y.pub, y.pubEnc);
}
var key$1 = KeyPair$2;
KeyPair$2.fromPublic = function v(y, z, ne) {
  return z instanceof KeyPair$2 ? z : new KeyPair$2(y, {
    pub: z,
    pubEnc: ne
  });
};
KeyPair$2.fromPrivate = function v(y, z, ne) {
  return z instanceof KeyPair$2 ? z : new KeyPair$2(y, {
    priv: z,
    privEnc: ne
  });
};
KeyPair$2.prototype.validate = function v() {
  var y = this.getPublic();
  return y.isInfinity() ? { result: !1, reason: "Invalid public key" } : y.validate() ? y.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$2.prototype.getPublic = function v(y, z) {
  return typeof y == "string" && (z = y, y = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), z ? this.pub.encode(z, y) : this.pub;
};
KeyPair$2.prototype.getPrivate = function v(y) {
  return y === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$2.prototype._importPrivate = function v(y, z) {
  this.priv = new BN$2(y, z || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$2.prototype._importPublic = function v(y, z) {
  if (y.x || y.y) {
    this.ec.curve.type === "mont" ? assert$4(y.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$4(y.x && y.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(y.x, y.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(y, z);
};
KeyPair$2.prototype.derive = function v(y) {
  return y.validate() || assert$4(y.validate(), "public point not validated"), y.mul(this.priv).getX();
};
KeyPair$2.prototype.sign = function v(y, z, ne) {
  return this.ec.sign(y, this, z, ne);
};
KeyPair$2.prototype.verify = function v(y, z) {
  return this.ec.verify(y, z, this);
};
KeyPair$2.prototype.inspect = function v() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$1 = bnExports, utils$5 = utils$n, assert$3 = utils$5.assert;
function Signature$2(v, y) {
  if (v instanceof Signature$2)
    return v;
  this._importDER(v, y) || (assert$3(v.r && v.s, "Signature without r or s"), this.r = new BN$1(v.r, 16), this.s = new BN$1(v.s, 16), v.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = v.recoveryParam);
}
var signature$2 = Signature$2;
function Position() {
  this.place = 0;
}
function getLength(v, y) {
  var z = v[y.place++];
  if (!(z & 128))
    return z;
  var ne = z & 15;
  if (ne === 0 || ne > 4)
    return !1;
  for (var ue = 0, le = 0, he = y.place; le < ne; le++, he++)
    ue <<= 8, ue |= v[he], ue >>>= 0;
  return ue <= 127 ? !1 : (y.place = he, ue);
}
function rmPadding(v) {
  for (var y = 0, z = v.length - 1; !v[y] && !(v[y + 1] & 128) && y < z; )
    y++;
  return y === 0 ? v : v.slice(y);
}
Signature$2.prototype._importDER = function v(y, z) {
  y = utils$5.toArray(y, z);
  var ne = new Position();
  if (y[ne.place++] !== 48)
    return !1;
  var ue = getLength(y, ne);
  if (ue === !1 || ue + ne.place !== y.length || y[ne.place++] !== 2)
    return !1;
  var le = getLength(y, ne);
  if (le === !1)
    return !1;
  var he = y.slice(ne.place, le + ne.place);
  if (ne.place += le, y[ne.place++] !== 2)
    return !1;
  var ge = getLength(y, ne);
  if (ge === !1 || y.length !== ge + ne.place)
    return !1;
  var we = y.slice(ne.place, ge + ne.place);
  if (he[0] === 0)
    if (he[1] & 128)
      he = he.slice(1);
    else
      return !1;
  if (we[0] === 0)
    if (we[1] & 128)
      we = we.slice(1);
    else
      return !1;
  return this.r = new BN$1(he), this.s = new BN$1(we), this.recoveryParam = null, !0;
};
function constructLength(v, y) {
  if (y < 128) {
    v.push(y);
    return;
  }
  var z = 1 + (Math.log(y) / Math.LN2 >>> 3);
  for (v.push(z | 128); --z; )
    v.push(y >>> (z << 3) & 255);
  v.push(y);
}
Signature$2.prototype.toDER = function v(y) {
  var z = this.r.toArray(), ne = this.s.toArray();
  for (z[0] & 128 && (z = [0].concat(z)), ne[0] & 128 && (ne = [0].concat(ne)), z = rmPadding(z), ne = rmPadding(ne); !ne[0] && !(ne[1] & 128); )
    ne = ne.slice(1);
  var ue = [2];
  constructLength(ue, z.length), ue = ue.concat(z), ue.push(2), constructLength(ue, ne.length);
  var le = ue.concat(ne), he = [48];
  return constructLength(he, le.length), he = he.concat(le), utils$5.encode(he, y);
};
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc)
    return ec;
  hasRequiredEc = 1;
  var v = bnExports, y = hmacDrbg, z = utils$n, ne = curves$1, ue = requireBrorand(), le = z.assert, he = key$1, ge = signature$2;
  function we(Ee) {
    if (!(this instanceof we))
      return new we(Ee);
    typeof Ee == "string" && (le(
      Object.prototype.hasOwnProperty.call(ne, Ee),
      "Unknown curve " + Ee
    ), Ee = ne[Ee]), Ee instanceof ne.PresetCurve && (Ee = { curve: Ee }), this.curve = Ee.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = Ee.curve.g, this.g.precompute(Ee.curve.n.bitLength() + 1), this.hash = Ee.hash || Ee.curve.hash;
  }
  return ec = we, we.prototype.keyPair = function(xe) {
    return new he(this, xe);
  }, we.prototype.keyFromPrivate = function(xe, $e) {
    return he.fromPrivate(this, xe, $e);
  }, we.prototype.keyFromPublic = function(xe, $e) {
    return he.fromPublic(this, xe, $e);
  }, we.prototype.genKeyPair = function(xe) {
    xe || (xe = {});
    for (var $e = new y({
      hash: this.hash,
      pers: xe.pers,
      persEnc: xe.persEnc || "utf8",
      entropy: xe.entropy || ue(this.hash.hmacStrength),
      entropyEnc: xe.entropy && xe.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), Ne = this.n.byteLength(), st = this.n.sub(new v(2)); ; ) {
      var Nr = new v($e.generate(Ne));
      if (!(Nr.cmp(st) > 0))
        return Nr.iaddn(1), this.keyFromPrivate(Nr);
    }
  }, we.prototype._truncateToN = function(xe, $e) {
    var Ne = xe.byteLength() * 8 - this.n.bitLength();
    return Ne > 0 && (xe = xe.ushrn(Ne)), !$e && xe.cmp(this.n) >= 0 ? xe.sub(this.n) : xe;
  }, we.prototype.sign = function(xe, $e, Ne, st) {
    typeof Ne == "object" && (st = Ne, Ne = null), st || (st = {}), $e = this.keyFromPrivate($e, Ne), xe = this._truncateToN(new v(xe, 16));
    for (var Nr = this.n.byteLength(), br = $e.getPrivate().toArray("be", Nr), $n = xe.toArray("be", Nr), En = new y({
      hash: this.hash,
      entropy: br,
      nonce: $n,
      pers: st.pers,
      persEnc: st.persEnc || "utf8"
    }), Rn = this.n.sub(new v(1)), wa = 0; ; wa++) {
      var Aa = st.k ? st.k(wa) : new v(En.generate(this.n.byteLength()));
      if (Aa = this._truncateToN(Aa, !0), !(Aa.cmpn(1) <= 0 || Aa.cmp(Rn) >= 0)) {
        var _a = this.g.mul(Aa);
        if (!_a.isInfinity()) {
          var Ta = _a.getX(), Zn = Ta.umod(this.n);
          if (Zn.cmpn(0) !== 0) {
            var Ra = Aa.invm(this.n).mul(Zn.mul($e.getPrivate()).iadd(xe));
            if (Ra = Ra.umod(this.n), Ra.cmpn(0) !== 0) {
              var Yn = (_a.getY().isOdd() ? 1 : 0) | (Ta.cmp(Zn) !== 0 ? 2 : 0);
              return st.canonical && Ra.cmp(this.nh) > 0 && (Ra = this.n.sub(Ra), Yn ^= 1), new ge({ r: Zn, s: Ra, recoveryParam: Yn });
            }
          }
        }
      }
    }
  }, we.prototype.verify = function(xe, $e, Ne, st) {
    xe = this._truncateToN(new v(xe, 16)), Ne = this.keyFromPublic(Ne, st), $e = new ge($e, "hex");
    var Nr = $e.r, br = $e.s;
    if (Nr.cmpn(1) < 0 || Nr.cmp(this.n) >= 0 || br.cmpn(1) < 0 || br.cmp(this.n) >= 0)
      return !1;
    var $n = br.invm(this.n), En = $n.mul(xe).umod(this.n), Rn = $n.mul(Nr).umod(this.n), wa;
    return this.curve._maxwellTrick ? (wa = this.g.jmulAdd(En, Ne.getPublic(), Rn), wa.isInfinity() ? !1 : wa.eqXToP(Nr)) : (wa = this.g.mulAdd(En, Ne.getPublic(), Rn), wa.isInfinity() ? !1 : wa.getX().umod(this.n).cmp(Nr) === 0);
  }, we.prototype.recoverPubKey = function(Ee, xe, $e, Ne) {
    le((3 & $e) === $e, "The recovery param is more than two bits"), xe = new ge(xe, Ne);
    var st = this.n, Nr = new v(Ee), br = xe.r, $n = xe.s, En = $e & 1, Rn = $e >> 1;
    if (br.cmp(this.curve.p.umod(this.curve.n)) >= 0 && Rn)
      throw new Error("Unable to find sencond key candinate");
    Rn ? br = this.curve.pointFromX(br.add(this.curve.n), En) : br = this.curve.pointFromX(br, En);
    var wa = xe.r.invm(st), Aa = st.sub(Nr).mul(wa).umod(st), _a = $n.mul(wa).umod(st);
    return this.g.mulAdd(Aa, br, _a);
  }, we.prototype.getKeyRecoveryParam = function(Ee, xe, $e, Ne) {
    if (xe = new ge(xe, Ne), xe.recoveryParam !== null)
      return xe.recoveryParam;
    for (var st = 0; st < 4; st++) {
      var Nr;
      try {
        Nr = this.recoverPubKey(Ee, xe, st);
      } catch {
        continue;
      }
      if (Nr.eq($e))
        return st;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var utils$4 = utils$n, assert$2 = utils$4.assert, parseBytes$2 = utils$4.parseBytes, cachedProperty$1 = utils$4.cachedProperty;
function KeyPair$1(v, y) {
  this.eddsa = v, this._secret = parseBytes$2(y.secret), v.isPoint(y.pub) ? this._pub = y.pub : this._pubBytes = parseBytes$2(y.pub);
}
KeyPair$1.fromPublic = function v(y, z) {
  return z instanceof KeyPair$1 ? z : new KeyPair$1(y, { pub: z });
};
KeyPair$1.fromSecret = function v(y, z) {
  return z instanceof KeyPair$1 ? z : new KeyPair$1(y, { secret: z });
};
KeyPair$1.prototype.secret = function v() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function v() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function v() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function v() {
  var y = this.eddsa, z = this.hash(), ne = y.encodingLength - 1, ue = z.slice(0, y.encodingLength);
  return ue[0] &= 248, ue[ne] &= 127, ue[ne] |= 64, ue;
});
cachedProperty$1(KeyPair$1, "priv", function v() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function v() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function v() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function v(y) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(y, this);
};
KeyPair$1.prototype.verify = function v(y, z) {
  return this.eddsa.verify(y, z, this);
};
KeyPair$1.prototype.getSecret = function v(y) {
  return assert$2(this._secret, "KeyPair is public only"), utils$4.encode(this.secret(), y);
};
KeyPair$1.prototype.getPublic = function v(y) {
  return utils$4.encode(this.pubBytes(), y);
};
var key = KeyPair$1, BN = bnExports, utils$3 = utils$n, assert$1 = utils$3.assert, cachedProperty = utils$3.cachedProperty, parseBytes$1 = utils$3.parseBytes;
function Signature$1(v, y) {
  this.eddsa = v, typeof y != "object" && (y = parseBytes$1(y)), Array.isArray(y) && (y = {
    R: y.slice(0, v.encodingLength),
    S: y.slice(v.encodingLength)
  }), assert$1(y.R && y.S, "Signature without R or S"), v.isPoint(y.R) && (this._R = y.R), y.S instanceof BN && (this._S = y.S), this._Rencoded = Array.isArray(y.R) ? y.R : y.Rencoded, this._Sencoded = Array.isArray(y.S) ? y.S : y.Sencoded;
}
cachedProperty(Signature$1, "S", function v() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function v() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function v() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function v() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function v() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function v() {
  return utils$3.encode(this.toBytes(), "hex").toUpperCase();
};
var signature$1 = Signature$1, hash$1 = hash$3, curves = curves$1, utils$2 = utils$n, assert = utils$2.assert, parseBytes = utils$2.parseBytes, KeyPair = key, Signature = signature$1;
function EDDSA(v) {
  if (assert(v === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(v);
  v = curves[v].curve, this.curve = v, this.g = v.g, this.g.precompute(v.n.bitLength() + 1), this.pointClass = v.point().constructor, this.encodingLength = Math.ceil(v.n.bitLength() / 8), this.hash = hash$1.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function v(y, z) {
  y = parseBytes(y);
  var ne = this.keyFromSecret(z), ue = this.hashInt(ne.messagePrefix(), y), le = this.g.mul(ue), he = this.encodePoint(le), ge = this.hashInt(he, ne.pubBytes(), y).mul(ne.priv()), we = ue.add(ge).umod(this.curve.n);
  return this.makeSignature({ R: le, S: we, Rencoded: he });
};
EDDSA.prototype.verify = function v(y, z, ne) {
  y = parseBytes(y), z = this.makeSignature(z);
  var ue = this.keyFromPublic(ne), le = this.hashInt(z.Rencoded(), ue.pubBytes(), y), he = this.g.mul(z.S()), ge = z.R().add(ue.pub().mul(le));
  return ge.eq(he);
};
EDDSA.prototype.hashInt = function v() {
  for (var y = this.hash(), z = 0; z < arguments.length; z++)
    y.update(arguments[z]);
  return utils$2.intFromLE(y.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function v(y) {
  return KeyPair.fromPublic(this, y);
};
EDDSA.prototype.keyFromSecret = function v(y) {
  return KeyPair.fromSecret(this, y);
};
EDDSA.prototype.makeSignature = function v(y) {
  return y instanceof Signature ? y : new Signature(this, y);
};
EDDSA.prototype.encodePoint = function v(y) {
  var z = y.getY().toArray("le", this.encodingLength);
  return z[this.encodingLength - 1] |= y.getX().isOdd() ? 128 : 0, z;
};
EDDSA.prototype.decodePoint = function v(y) {
  y = utils$2.parseBytes(y);
  var z = y.length - 1, ne = y.slice(0, z).concat(y[z] & -129), ue = (y[z] & 128) !== 0, le = utils$2.intFromLE(ne);
  return this.curve.pointFromY(le, ue);
};
EDDSA.prototype.encodeInt = function v(y) {
  return y.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function v(y) {
  return utils$2.intFromLE(y);
};
EDDSA.prototype.isPoint = function v(y) {
  return y instanceof this.pointClass;
};
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(v) {
    var y = v;
    y.version = require$$0$1.version, y.utils = utils$n, y.rand = requireBrorand(), y.curve = curve, y.curves = curves$1, y.ec = requireEc(), y.eddsa = eddsa;
  }(elliptic)), elliptic;
}
var asn1$1 = {}, asn1 = {}, bn$2 = { exports: {} };
bn$2.exports;
var hasRequiredBn$2;
function requireBn$2() {
  return hasRequiredBn$2 || (hasRequiredBn$2 = 1, function(v) {
    (function(y, z) {
      function ne(ct, fe) {
        if (!ct)
          throw new Error(fe || "Assertion failed");
      }
      function ue(ct, fe) {
        ct.super_ = fe;
        var be = function() {
        };
        be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
      }
      function le(ct, fe, be) {
        if (le.isBN(ct))
          return ct;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
      }
      typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
      var he;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
      } catch {
      }
      le.isBN = function(fe) {
        return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
      }, le.max = function(fe, be) {
        return fe.cmp(be) > 0 ? fe : be;
      }, le.min = function(fe, be) {
        return fe.cmp(be) < 0 ? fe : be;
      }, le.prototype._init = function(fe, be, ye) {
        if (typeof fe == "number")
          return this._initNumber(fe, be, ye);
        if (typeof fe == "object")
          return this._initArray(fe, be, ye);
        be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
        var Se = 0;
        fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
      }, le.prototype._initNumber = function(fe, be, ye) {
        fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863
        ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863,
          1
        ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
      }, le.prototype._initArray = function(fe, be, ye) {
        if (ne(typeof fe.length == "number"), fe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe, Fr, zn = 0;
        if (ye === "be")
          for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
            Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        else if (ye === "le")
          for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
            Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        return this.strip();
      };
      function ge(ct, fe) {
        var be = ct.charCodeAt(fe);
        return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
      }
      function we(ct, fe, be) {
        var ye = ge(ct, be);
        return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
      }
      le.prototype._parseHex = function(fe, be, ye) {
        this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe = 0, Fr = 0, zn;
        if (ye === "be")
          for (Se = fe.length - 1; Se >= be; Se -= 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        else {
          var Fe = fe.length - be;
          for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        }
        this.strip();
      };
      function Ee(ct, fe, be, ye) {
        for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
          var zn = ct.charCodeAt(Fr) - 48;
          Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
        }
        return Se;
      }
      le.prototype._parseBase = function(fe, be, ye) {
        this.words = [0], this.length = 1;
        for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
          Se++;
        Se--, Oe = Oe / be | 0;
        for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
          pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        if (zn !== 0) {
          var xa = 1;
          for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
            xa *= be;
          this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        }
        this.strip();
      }, le.prototype.copy = function(fe) {
        fe.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          fe.words[be] = this.words[be];
        fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
      }, le.prototype.clone = function() {
        var fe = new le(null);
        return this.copy(fe), fe;
      }, le.prototype._expand = function(fe) {
        for (; this.length < fe; )
          this.words[this.length++] = 0;
        return this;
      }, le.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, le.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, le.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var xe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $e = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ne = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      le.prototype.toString = function(fe, be) {
        fe = fe || 10, be = be | 0 || 1;
        var ye;
        if (fe === 16 || fe === "hex") {
          ye = "";
          for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
            var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
            Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
          }
          for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
          var pe = $e[fe], it = Ne[fe];
          ye = "";
          var xa = this.clone();
          for (xa.negative = 0; !xa.isZero(); ) {
            var wo = xa.modn(it).toString(fe);
            xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
          }
          for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        ne(!1, "Base should be between 2 and 36");
      }, le.prototype.toNumber = function() {
        var fe = this.words[0];
        return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
      }, le.prototype.toJSON = function() {
        return this.toString(16);
      }, le.prototype.toBuffer = function(fe, be) {
        return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
      }, le.prototype.toArray = function(fe, be) {
        return this.toArrayLike(Array, fe, be);
      }, le.prototype.toArrayLike = function(fe, be, ye) {
        var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
        ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
        var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
        if (Fr) {
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
          for (; pe < Oe; pe++)
            zn[pe] = 0;
        } else {
          for (pe = 0; pe < Oe - Se; pe++)
            zn[pe] = 0;
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
        }
        return zn;
      }, Math.clz32 ? le.prototype._countBits = function(fe) {
        return 32 - Math.clz32(fe);
      } : le.prototype._countBits = function(fe) {
        var be = fe, ye = 0;
        return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
      }, le.prototype._zeroBits = function(fe) {
        if (fe === 0)
          return 26;
        var be = fe, ye = 0;
        return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
      }, le.prototype.bitLength = function() {
        var fe = this.words[this.length - 1], be = this._countBits(fe);
        return (this.length - 1) * 26 + be;
      };
      function st(ct) {
        for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
          var ye = be / 26 | 0, Se = be % 26;
          fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
        }
        return fe;
      }
      le.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var fe = 0, be = 0; be < this.length; be++) {
          var ye = this._zeroBits(this.words[be]);
          if (fe += ye, ye !== 26)
            break;
        }
        return fe;
      }, le.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, le.prototype.toTwos = function(fe) {
        return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
      }, le.prototype.fromTwos = function(fe) {
        return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
      }, le.prototype.isNeg = function() {
        return this.negative !== 0;
      }, le.prototype.neg = function() {
        return this.clone().ineg();
      }, le.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, le.prototype.iuor = function(fe) {
        for (; this.length < fe.length; )
          this.words[this.length++] = 0;
        for (var be = 0; be < fe.length; be++)
          this.words[be] = this.words[be] | fe.words[be];
        return this.strip();
      }, le.prototype.ior = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuor(fe);
      }, le.prototype.or = function(fe) {
        return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
      }, le.prototype.uor = function(fe) {
        return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
      }, le.prototype.iuand = function(fe) {
        var be;
        this.length > fe.length ? be = fe : be = this;
        for (var ye = 0; ye < be.length; ye++)
          this.words[ye] = this.words[ye] & fe.words[ye];
        return this.length = be.length, this.strip();
      }, le.prototype.iand = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuand(fe);
      }, le.prototype.and = function(fe) {
        return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
      }, le.prototype.uand = function(fe) {
        return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
      }, le.prototype.iuxor = function(fe) {
        var be, ye;
        this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
        for (var Se = 0; Se < ye.length; Se++)
          this.words[Se] = be.words[Se] ^ ye.words[Se];
        if (this !== be)
          for (; Se < be.length; Se++)
            this.words[Se] = be.words[Se];
        return this.length = be.length, this.strip();
      }, le.prototype.ixor = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
      }, le.prototype.xor = function(fe) {
        return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
      }, le.prototype.uxor = function(fe) {
        return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
      }, le.prototype.inotn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
        this._expand(be), ye > 0 && be--;
        for (var Se = 0; Se < be; Se++)
          this.words[Se] = ~this.words[Se] & 67108863;
        return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
      }, le.prototype.notn = function(fe) {
        return this.clone().inotn(fe);
      }, le.prototype.setn = function(fe, be) {
        ne(typeof fe == "number" && fe >= 0);
        var ye = fe / 26 | 0, Se = fe % 26;
        return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
      }, le.prototype.iadd = function(fe) {
        var be;
        if (this.negative !== 0 && fe.negative === 0)
          return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && fe.negative !== 0)
          return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
        var ye, Se;
        this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
        for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
          be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        for (; Oe !== 0 && Fr < ye.length; Fr++)
          be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        if (this.length = ye.length, Oe !== 0)
          this.words[this.length] = Oe, this.length++;
        else if (ye !== this)
          for (; Fr < ye.length; Fr++)
            this.words[Fr] = ye.words[Fr];
        return this;
      }, le.prototype.add = function(fe) {
        var be;
        return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
      }, le.prototype.isub = function(fe) {
        if (fe.negative !== 0) {
          fe.negative = 0;
          var be = this.iadd(fe);
          return fe.negative = 1, be._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
        var ye = this.cmp(fe);
        if (ye === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Se, Oe;
        ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
        for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
          be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        for (; Fr !== 0 && zn < Se.length; zn++)
          be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        if (Fr === 0 && zn < Se.length && Se !== this)
          for (; zn < Se.length; zn++)
            this.words[zn] = Se.words[zn];
        return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
      }, le.prototype.sub = function(fe) {
        return this.clone().isub(fe);
      };
      function Nr(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative;
        var ye = ct.length + fe.length | 0;
        be.length = ye, ye = ye - 1 | 0;
        var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
        be.words[0] = zn;
        for (var pe = 1; pe < ye; pe++) {
          for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
            var Oa = pe - _u | 0;
            Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
          }
          be.words[pe] = xa | 0, Fe = it | 0;
        }
        return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
      }
      var br = function(fe, be, ye) {
        var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
        ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
        var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
        var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
        var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
        var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
        var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
        var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
        var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
        var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
        var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
        var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
        var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
        var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
        var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
        var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
        var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
        var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
        var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
        var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
        var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
      };
      Math.imul || (br = Nr);
      function $n(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
        for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
          var Fr = Se;
          Se = 0;
          for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
            var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
            Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
          }
          be.words[Oe] = zn, ye = Fr, Fr = Se;
        }
        return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
      }
      function En(ct, fe, be) {
        var ye = new Rn();
        return ye.mulp(ct, fe, be);
      }
      le.prototype.mulTo = function(fe, be) {
        var ye, Se = this.length + fe.length;
        return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
      };
      function Rn(ct, fe) {
        this.x = ct, this.y = fe;
      }
      Rn.prototype.makeRBT = function(fe) {
        for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
          be[Se] = this.revBin(Se, ye, fe);
        return be;
      }, Rn.prototype.revBin = function(fe, be, ye) {
        if (fe === 0 || fe === ye - 1)
          return fe;
        for (var Se = 0, Oe = 0; Oe < be; Oe++)
          Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
        return Se;
      }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
        for (var zn = 0; zn < Fr; zn++)
          Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
      }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
        this.permute(Fr, fe, be, ye, Se, Oe);
        for (var zn = 1; zn < Oe; zn <<= 1)
          for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
            for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
              var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
              Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
            }
      }, Rn.prototype.guessLen13b = function(fe, be) {
        var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
        for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
          Oe++;
        return 1 << Oe + 1 + Se;
      }, Rn.prototype.conjugate = function(fe, be, ye) {
        if (!(ye <= 1))
          for (var Se = 0; Se < ye / 2; Se++) {
            var Oe = fe[Se];
            fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
          }
      }, Rn.prototype.normalize13b = function(fe, be) {
        for (var ye = 0, Se = 0; Se < be / 2; Se++) {
          var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
          fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
        }
        return fe;
      }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
        for (var Oe = 0, Fr = 0; Fr < be; Fr++)
          Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
        for (Fr = 2 * be; Fr < Se; ++Fr)
          ye[Fr] = 0;
        ne(Oe === 0), ne((Oe & -8192) === 0);
      }, Rn.prototype.stub = function(fe) {
        for (var be = new Array(fe), ye = 0; ye < fe; ye++)
          be[ye] = 0;
        return be;
      }, Rn.prototype.mulp = function(fe, be, ye) {
        var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
        _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
        for (var Oa = 0; Oa < Se; Oa++) {
          var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
          pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
        }
        return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
      }, le.prototype.mul = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
      }, le.prototype.mulf = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), En(this, fe, be);
      }, le.prototype.imul = function(fe) {
        return this.clone().mulTo(fe, this);
      }, le.prototype.imuln = function(fe) {
        ne(typeof fe == "number"), ne(fe < 67108864);
        for (var be = 0, ye = 0; ye < this.length; ye++) {
          var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
          be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
        }
        return be !== 0 && (this.words[ye] = be, this.length++), this;
      }, le.prototype.muln = function(fe) {
        return this.clone().imuln(fe);
      }, le.prototype.sqr = function() {
        return this.mul(this);
      }, le.prototype.isqr = function() {
        return this.imul(this.clone());
      }, le.prototype.pow = function(fe) {
        var be = st(fe);
        if (be.length === 0)
          return new le(1);
        for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
          ;
        if (++Se < be.length)
          for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
            be[Se] !== 0 && (ye = ye.mul(Oe));
        return ye;
      }, le.prototype.iushln = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
        if (be !== 0) {
          var Fr = 0;
          for (Oe = 0; Oe < this.length; Oe++) {
            var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
            this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
          }
          Fr && (this.words[Oe] = Fr, this.length++);
        }
        if (ye !== 0) {
          for (Oe = this.length - 1; Oe >= 0; Oe--)
            this.words[Oe + ye] = this.words[Oe];
          for (Oe = 0; Oe < ye; Oe++)
            this.words[Oe] = 0;
          this.length += ye;
        }
        return this.strip();
      }, le.prototype.ishln = function(fe) {
        return ne(this.negative === 0), this.iushln(fe);
      }, le.prototype.iushrn = function(fe, be, ye) {
        ne(typeof fe == "number" && fe >= 0);
        var Se;
        be ? Se = (be - be % 26) / 26 : Se = 0;
        var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
        if (Se -= Fr, Se = Math.max(0, Se), Fe) {
          for (var pe = 0; pe < Fr; pe++)
            Fe.words[pe] = this.words[pe];
          Fe.length = Fr;
        }
        if (Fr !== 0)
          if (this.length > Fr)
            for (this.length -= Fr, pe = 0; pe < this.length; pe++)
              this.words[pe] = this.words[pe + Fr];
          else
            this.words[0] = 0, this.length = 1;
        var it = 0;
        for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
          var xa = this.words[pe] | 0;
          this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
        }
        return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, le.prototype.ishrn = function(fe, be, ye) {
        return ne(this.negative === 0), this.iushrn(fe, be, ye);
      }, le.prototype.shln = function(fe) {
        return this.clone().ishln(fe);
      }, le.prototype.ushln = function(fe) {
        return this.clone().iushln(fe);
      }, le.prototype.shrn = function(fe) {
        return this.clone().ishrn(fe);
      }, le.prototype.ushrn = function(fe) {
        return this.clone().iushrn(fe);
      }, le.prototype.testn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return !1;
        var Oe = this.words[ye];
        return !!(Oe & Se);
      }, le.prototype.imaskn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26;
        if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
          return this;
        if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
          var Se = 67108863 ^ 67108863 >>> be << be;
          this.words[this.length - 1] &= Se;
        }
        return this.strip();
      }, le.prototype.maskn = function(fe) {
        return this.clone().imaskn(fe);
      }, le.prototype.iaddn = function(fe) {
        return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
      }, le.prototype._iaddn = function(fe) {
        this.words[0] += fe;
        for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
          this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
        return this.length = Math.max(this.length, be + 1), this;
      }, le.prototype.isubn = function(fe) {
        if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
          return this.iaddn(-fe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
        if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var be = 0; be < this.length && this.words[be] < 0; be++)
            this.words[be] += 67108864, this.words[be + 1] -= 1;
        return this.strip();
      }, le.prototype.addn = function(fe) {
        return this.clone().iaddn(fe);
      }, le.prototype.subn = function(fe) {
        return this.clone().isubn(fe);
      }, le.prototype.iabs = function() {
        return this.negative = 0, this;
      }, le.prototype.abs = function() {
        return this.clone().iabs();
      }, le.prototype._ishlnsubmul = function(fe, be, ye) {
        var Se = fe.length + ye, Oe;
        this._expand(Se);
        var Fr, zn = 0;
        for (Oe = 0; Oe < fe.length; Oe++) {
          Fr = (this.words[Oe + ye] | 0) + zn;
          var Fe = (fe.words[Oe] | 0) * be;
          Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
        }
        for (; Oe < this.length - ye; Oe++)
          Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
        if (zn === 0)
          return this.strip();
        for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
          Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
        return this.negative = 1, this.strip();
      }, le.prototype._wordDiv = function(fe, be) {
        var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
        ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
        var Fe = Se.length - Oe.length, pe;
        if (be !== "mod") {
          pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
          for (var it = 0; it < pe.length; it++)
            pe.words[it] = 0;
        }
        var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
        xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
        for (var wo = Fe - 1; wo >= 0; wo--) {
          var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
          for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
            _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
          pe && (pe.words[wo] = _u);
        }
        return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
          div: pe || null,
          mod: Se
        };
      }, le.prototype.divmod = function(fe, be, ye) {
        if (ne(!fe.isZero()), this.isZero())
          return {
            div: new le(0),
            mod: new le(0)
          };
        var Se, Oe, Fr;
        return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
          div: Se,
          mod: Oe
        }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
          div: Se,
          mod: Fr.mod
        }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
          div: Fr.div,
          mod: Oe
        }) : fe.length > this.length || this.cmp(fe) < 0 ? {
          div: new le(0),
          mod: this
        } : fe.length === 1 ? be === "div" ? {
          div: this.divn(fe.words[0]),
          mod: null
        } : be === "mod" ? {
          div: null,
          mod: new le(this.modn(fe.words[0]))
        } : {
          div: this.divn(fe.words[0]),
          mod: new le(this.modn(fe.words[0]))
        } : this._wordDiv(fe, be);
      }, le.prototype.div = function(fe) {
        return this.divmod(fe, "div", !1).div;
      }, le.prototype.mod = function(fe) {
        return this.divmod(fe, "mod", !1).mod;
      }, le.prototype.umod = function(fe) {
        return this.divmod(fe, "mod", !0).mod;
      }, le.prototype.divRound = function(fe) {
        var be = this.divmod(fe);
        if (be.mod.isZero())
          return be.div;
        var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
        return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
      }, le.prototype.modn = function(fe) {
        ne(fe <= 67108863);
        for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
          ye = (be * ye + (this.words[Se] | 0)) % fe;
        return ye;
      }, le.prototype.idivn = function(fe) {
        ne(fe <= 67108863);
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = (this.words[ye] | 0) + be * 67108864;
          this.words[ye] = Se / fe | 0, be = Se % fe;
        }
        return this.strip();
      }, le.prototype.divn = function(fe) {
        return this.clone().idivn(fe);
      }, le.prototype.egcd = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
          be.iushrn(1), ye.iushrn(1), ++Fe;
        for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
          for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
            ;
          if (xa > 0)
            for (be.iushrn(xa); xa-- > 0; )
              (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
          for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
            ;
          if (_u > 0)
            for (ye.iushrn(_u); _u-- > 0; )
              (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
        }
        return {
          a: Fr,
          b: zn,
          gcd: ye.iushln(Fe)
        };
      }, le.prototype._invmp = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
          for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
            ;
          if (zn > 0)
            for (be.iushrn(zn); zn-- > 0; )
              Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
          for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
            ;
          if (pe > 0)
            for (ye.iushrn(pe); pe-- > 0; )
              Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
        }
        var xa;
        return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
      }, le.prototype.gcd = function(fe) {
        if (this.isZero())
          return fe.abs();
        if (fe.isZero())
          return this.abs();
        var be = this.clone(), ye = fe.clone();
        be.negative = 0, ye.negative = 0;
        for (var Se = 0; be.isEven() && ye.isEven(); Se++)
          be.iushrn(1), ye.iushrn(1);
        do {
          for (; be.isEven(); )
            be.iushrn(1);
          for (; ye.isEven(); )
            ye.iushrn(1);
          var Oe = be.cmp(ye);
          if (Oe < 0) {
            var Fr = be;
            be = ye, ye = Fr;
          } else if (Oe === 0 || ye.cmpn(1) === 0)
            break;
          be.isub(ye);
        } while (!0);
        return ye.iushln(Se);
      }, le.prototype.invm = function(fe) {
        return this.egcd(fe).a.umod(fe);
      }, le.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, le.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, le.prototype.andln = function(fe) {
        return this.words[0] & fe;
      }, le.prototype.bincn = function(fe) {
        ne(typeof fe == "number");
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return this._expand(ye + 1), this.words[ye] |= Se, this;
        for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
          var zn = this.words[Fr] | 0;
          zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
        }
        return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
      }, le.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, le.prototype.cmpn = function(fe) {
        var be = fe < 0;
        if (this.negative !== 0 && !be)
          return -1;
        if (this.negative === 0 && be)
          return 1;
        this.strip();
        var ye;
        if (this.length > 1)
          ye = 1;
        else {
          be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
          var Se = this.words[0] | 0;
          ye = Se === fe ? 0 : Se < fe ? -1 : 1;
        }
        return this.negative !== 0 ? -ye | 0 : ye;
      }, le.prototype.cmp = function(fe) {
        if (this.negative !== 0 && fe.negative === 0)
          return -1;
        if (this.negative === 0 && fe.negative !== 0)
          return 1;
        var be = this.ucmp(fe);
        return this.negative !== 0 ? -be | 0 : be;
      }, le.prototype.ucmp = function(fe) {
        if (this.length > fe.length)
          return 1;
        if (this.length < fe.length)
          return -1;
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
          if (Se !== Oe) {
            Se < Oe ? be = -1 : Se > Oe && (be = 1);
            break;
          }
        }
        return be;
      }, le.prototype.gtn = function(fe) {
        return this.cmpn(fe) === 1;
      }, le.prototype.gt = function(fe) {
        return this.cmp(fe) === 1;
      }, le.prototype.gten = function(fe) {
        return this.cmpn(fe) >= 0;
      }, le.prototype.gte = function(fe) {
        return this.cmp(fe) >= 0;
      }, le.prototype.ltn = function(fe) {
        return this.cmpn(fe) === -1;
      }, le.prototype.lt = function(fe) {
        return this.cmp(fe) === -1;
      }, le.prototype.lten = function(fe) {
        return this.cmpn(fe) <= 0;
      }, le.prototype.lte = function(fe) {
        return this.cmp(fe) <= 0;
      }, le.prototype.eqn = function(fe) {
        return this.cmpn(fe) === 0;
      }, le.prototype.eq = function(fe) {
        return this.cmp(fe) === 0;
      }, le.red = function(fe) {
        return new Yn(fe);
      }, le.prototype.toRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
      }, le.prototype.fromRed = function() {
        return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, le.prototype._forceRed = function(fe) {
        return this.red = fe, this;
      }, le.prototype.forceRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
      }, le.prototype.redAdd = function(fe) {
        return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
      }, le.prototype.redIAdd = function(fe) {
        return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
      }, le.prototype.redSub = function(fe) {
        return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
      }, le.prototype.redISub = function(fe) {
        return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
      }, le.prototype.redShl = function(fe) {
        return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
      }, le.prototype.redMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
      }, le.prototype.redIMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
      }, le.prototype.redSqr = function() {
        return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, le.prototype.redISqr = function() {
        return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, le.prototype.redSqrt = function() {
        return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, le.prototype.redInvm = function() {
        return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, le.prototype.redNeg = function() {
        return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, le.prototype.redPow = function(fe) {
        return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
      };
      var wa = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Aa(ct, fe) {
        this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Aa.prototype._tmp = function() {
        var fe = new le(null);
        return fe.words = new Array(Math.ceil(this.n / 13)), fe;
      }, Aa.prototype.ireduce = function(fe) {
        var be = fe, ye;
        do
          this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
        while (ye > this.n);
        var Se = ye < this.n ? -1 : be.ucmp(this.p);
        return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
      }, Aa.prototype.split = function(fe, be) {
        fe.iushrn(this.n, 0, be);
      }, Aa.prototype.imulK = function(fe) {
        return fe.imul(this.k);
      };
      function _a() {
        Aa.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      ue(_a, Aa), _a.prototype.split = function(fe, be) {
        for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
          be.words[Oe] = fe.words[Oe];
        if (be.length = Se, fe.length <= 9) {
          fe.words[0] = 0, fe.length = 1;
          return;
        }
        var Fr = fe.words[9];
        for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
          var zn = fe.words[Oe] | 0;
          fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
        }
        Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
      }, _a.prototype.imulK = function(fe) {
        fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = fe.words[ye] | 0;
          be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
        }
        return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
      };
      function Ta() {
        Aa.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      ue(Ta, Aa);
      function Zn() {
        Aa.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      ue(Zn, Aa);
      function Ra() {
        Aa.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
          Se >>>= 26, fe.words[ye] = Oe, be = Se;
        }
        return be !== 0 && (fe.words[fe.length++] = be), fe;
      }, le._prime = function(fe) {
        if (wa[fe])
          return wa[fe];
        var be;
        if (fe === "k256")
          be = new _a();
        else if (fe === "p224")
          be = new Ta();
        else if (fe === "p192")
          be = new Zn();
        else if (fe === "p25519")
          be = new Ra();
        else
          throw new Error("Unknown prime " + fe);
        return wa[fe] = be, be;
      };
      function Yn(ct) {
        if (typeof ct == "string") {
          var fe = le._prime(ct);
          this.m = fe.p, this.prime = fe;
        } else
          ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
      }
      Yn.prototype._verify1 = function(fe) {
        ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
      }, Yn.prototype._verify2 = function(fe, be) {
        ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
          fe.red && fe.red === be.red,
          "red works only with red numbers"
        );
      }, Yn.prototype.imod = function(fe) {
        return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
      }, Yn.prototype.neg = function(fe) {
        return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
      }, Yn.prototype.add = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.add(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
      }, Yn.prototype.iadd = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.iadd(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
      }, Yn.prototype.sub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.sub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
      }, Yn.prototype.isub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.isub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
      }, Yn.prototype.shl = function(fe, be) {
        return this._verify1(fe), this.imod(fe.ushln(be));
      }, Yn.prototype.imul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.imul(be));
      }, Yn.prototype.mul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.mul(be));
      }, Yn.prototype.isqr = function(fe) {
        return this.imul(fe, fe.clone());
      }, Yn.prototype.sqr = function(fe) {
        return this.mul(fe, fe);
      }, Yn.prototype.sqrt = function(fe) {
        if (fe.isZero())
          return fe.clone();
        var be = this.m.andln(3);
        if (ne(be % 2 === 1), be === 3) {
          var ye = this.m.add(new le(1)).iushrn(2);
          return this.pow(fe, ye);
        }
        for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
          Oe++, Se.iushrn(1);
        ne(!Se.isZero());
        var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
        for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
          pe.redIAdd(zn);
        for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
          for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
            Oa = Oa.redSqr();
          ne(Os < _u);
          var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
          xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
        }
        return xa;
      }, Yn.prototype.invm = function(fe) {
        var be = fe._invmp(this.m);
        return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
      }, Yn.prototype.pow = function(fe, be) {
        if (be.isZero())
          return new le(1).toRed(this);
        if (be.cmpn(1) === 0)
          return fe.clone();
        var ye = 4, Se = new Array(1 << ye);
        Se[0] = new le(1).toRed(this), Se[1] = fe;
        for (var Oe = 2; Oe < Se.length; Oe++)
          Se[Oe] = this.mul(Se[Oe - 1], fe);
        var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
        for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
          for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
            var wo = it >> xa & 1;
            if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
              Fe = 0;
              continue;
            }
            zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
          }
          pe = 26;
        }
        return Fr;
      }, Yn.prototype.convertTo = function(fe) {
        var be = fe.umod(this.m);
        return be === fe ? be.clone() : be;
      }, Yn.prototype.convertFrom = function(fe) {
        var be = fe.clone();
        return be.red = null, be;
      }, le.mont = function(fe) {
        return new $o(fe);
      };
      function $o(ct) {
        Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      ue($o, Yn), $o.prototype.convertTo = function(fe) {
        return this.imod(fe.ushln(this.shift));
      }, $o.prototype.convertFrom = function(fe) {
        var be = this.imod(fe.mul(this.rinv));
        return be.red = null, be;
      }, $o.prototype.imul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return fe.words[0] = 0, fe.length = 1, fe;
        var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.mul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return new le(0)._forceRed(this);
        var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.invm = function(fe) {
        var be = this.imod(fe._invmp(this.m).mul(this.r2));
        return be._forceRed(this);
      };
    })(v, commonjsGlobal);
  }(bn$2)), bn$2.exports;
}
var api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(v, y) {
      if (v.indexOf)
        return v.indexOf(y);
      for (var z = 0; z < v.length; z++)
        if (v[z] === y)
          return z;
      return -1;
    }, Object_keys = function(v) {
      if (Object.keys)
        return Object.keys(v);
      var y = [];
      for (var z in v)
        y.push(z);
      return y;
    }, forEach = function(v, y) {
      if (v.forEach)
        return v.forEach(y);
      for (var z = 0; z < v.length; z++)
        y(v[z], z, v);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(v, y, z) {
          Object.defineProperty(v, y, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: z
          });
        };
      } catch {
        return function(y, z, ne) {
          y[z] = ne;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(y) {
      if (!(this instanceof Script))
        return new Script(y);
      this.code = y;
    };
    Script.prototype.runInContext = function(v) {
      if (!(v instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var y = document.createElement("iframe");
      y.style || (y.style = {}), y.style.display = "none", document.body.appendChild(y);
      var z = y.contentWindow, ne = z.eval, ue = z.execScript;
      !ne && ue && (ue.call(z, "null"), ne = z.eval), forEach(Object_keys(v), function(ge) {
        z[ge] = v[ge];
      }), forEach(globals, function(ge) {
        v[ge] && (z[ge] = v[ge]);
      });
      var le = Object_keys(z), he = ne.call(z, this.code);
      return forEach(Object_keys(z), function(ge) {
        (ge in v || indexOf(le, ge) === -1) && (v[ge] = z[ge]);
      }), forEach(globals, function(ge) {
        ge in v || defineProp(v, ge, z[ge]);
      }), document.body.removeChild(y), he;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(v) {
      var y = Script.createContext(v), z = this.runInContext(y);
      return v && forEach(Object_keys(y), function(ne) {
        v[ne] = y[ne];
      }), z;
    }, forEach(Object_keys(Script.prototype), function(v) {
      exports[v] = Script[v] = function(y) {
        var z = Script(y);
        return z[v].apply(z, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(v) {
      return v instanceof Context;
    }, exports.createScript = function(v) {
      return exports.Script(v);
    }, exports.createContext = Script.createContext = function(v) {
      var y = new Context();
      return typeof v == "object" && forEach(Object_keys(v), function(z) {
        y[z] = v[z];
      }), y;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(v) {
    var y = requireAsn1$1(), z = requireInherits_browser(), ne = v;
    ne.define = function(he, ge) {
      return new ue(he, ge);
    };
    function ue(le, he) {
      this.name = le, this.body = he, this.decoders = {}, this.encoders = {};
    }
    ue.prototype._createNamed = function(he) {
      var ge;
      try {
        ge = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        ge = function(Ee) {
          this._initNamed(Ee);
        };
      }
      return z(ge, he), ge.prototype._initNamed = function(Ee) {
        he.call(this, Ee);
      }, new ge(this);
    }, ue.prototype._getDecoder = function(he) {
      return he = he || "der", this.decoders.hasOwnProperty(he) || (this.decoders[he] = this._createNamed(y.decoders[he])), this.decoders[he];
    }, ue.prototype.decode = function(he, ge, we) {
      return this._getDecoder(ge).decode(he, we);
    }, ue.prototype._getEncoder = function(he) {
      return he = he || "der", this.encoders.hasOwnProperty(he) || (this.encoders[he] = this._createNamed(y.encoders[he])), this.encoders[he];
    }, ue.prototype.encode = function(he, ge, we) {
      return this._getEncoder(ge).encode(he, we);
    };
  }(api)), api;
}
var base$2 = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter)
    return reporter;
  hasRequiredReporter = 1;
  var v = requireInherits_browser();
  function y(ne) {
    this._reporterState = {
      obj: null,
      path: [],
      options: ne || {},
      errors: []
    };
  }
  reporter.Reporter = y, y.prototype.isError = function(ue) {
    return ue instanceof z;
  }, y.prototype.save = function() {
    var ue = this._reporterState;
    return { obj: ue.obj, pathLen: ue.path.length };
  }, y.prototype.restore = function(ue) {
    var le = this._reporterState;
    le.obj = ue.obj, le.path = le.path.slice(0, ue.pathLen);
  }, y.prototype.enterKey = function(ue) {
    return this._reporterState.path.push(ue);
  }, y.prototype.exitKey = function(ue) {
    var le = this._reporterState;
    le.path = le.path.slice(0, ue - 1);
  }, y.prototype.leaveKey = function(ue, le, he) {
    var ge = this._reporterState;
    this.exitKey(ue), ge.obj !== null && (ge.obj[le] = he);
  }, y.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, y.prototype.enterObject = function() {
    var ue = this._reporterState, le = ue.obj;
    return ue.obj = {}, le;
  }, y.prototype.leaveObject = function(ue) {
    var le = this._reporterState, he = le.obj;
    return le.obj = ue, he;
  }, y.prototype.error = function(ue) {
    var le, he = this._reporterState, ge = ue instanceof z;
    if (ge ? le = ue : le = new z(he.path.map(function(we) {
      return "[" + JSON.stringify(we) + "]";
    }).join(""), ue.message || ue, ue.stack), !he.options.partial)
      throw le;
    return ge || he.errors.push(le), le;
  }, y.prototype.wrapResult = function(ue) {
    var le = this._reporterState;
    return le.options.partial ? {
      result: this.isError(ue) ? null : ue,
      errors: le.errors
    } : ue;
  };
  function z(ne, ue) {
    this.path = ne, this.rethrow(ue);
  }
  return v(z, Error), z.prototype.rethrow = function(ue) {
    if (this.message = ue + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, z), !this.stack)
      try {
        throw new Error(this.message);
      } catch (le) {
        this.stack = le.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer)
    return buffer;
  hasRequiredBuffer = 1;
  var v = requireInherits_browser(), y = requireBase().Reporter, z = require$$0$3.Buffer;
  function ne(le, he) {
    if (y.call(this, he), !z.isBuffer(le)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = le, this.offset = 0, this.length = le.length;
  }
  v(ne, y), buffer.DecoderBuffer = ne, ne.prototype.save = function() {
    return { offset: this.offset, reporter: y.prototype.save.call(this) };
  }, ne.prototype.restore = function(he) {
    var ge = new ne(this.base);
    return ge.offset = he.offset, ge.length = this.offset, this.offset = he.offset, y.prototype.restore.call(this, he.reporter), ge;
  }, ne.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, ne.prototype.readUInt8 = function(he) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(he || "DecoderBuffer overrun");
  }, ne.prototype.skip = function(he, ge) {
    if (!(this.offset + he <= this.length))
      return this.error(ge || "DecoderBuffer overrun");
    var we = new ne(this.base);
    return we._reporterState = this._reporterState, we.offset = this.offset, we.length = this.offset + he, this.offset += he, we;
  }, ne.prototype.raw = function(he) {
    return this.base.slice(he ? he.offset : this.offset, this.length);
  };
  function ue(le, he) {
    if (Array.isArray(le))
      this.length = 0, this.value = le.map(function(ge) {
        return ge instanceof ue || (ge = new ue(ge, he)), this.length += ge.length, ge;
      }, this);
    else if (typeof le == "number") {
      if (!(0 <= le && le <= 255))
        return he.error("non-byte EncoderBuffer value");
      this.value = le, this.length = 1;
    } else if (typeof le == "string")
      this.value = le, this.length = z.byteLength(le);
    else if (z.isBuffer(le))
      this.value = le, this.length = le.length;
    else
      return he.error("Unsupported type: " + typeof le);
  }
  return buffer.EncoderBuffer = ue, ue.prototype.join = function(he, ge) {
    return he || (he = new z(this.length)), ge || (ge = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(we) {
      we.join(he, ge), ge += we.length;
    }) : (typeof this.value == "number" ? he[ge] = this.value : typeof this.value == "string" ? he.write(this.value, ge) : z.isBuffer(this.value) && this.value.copy(he, ge), ge += this.length)), he;
  }, buffer;
}
var node$1, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode)
    return node$1;
  hasRequiredNode = 1;
  var v = requireBase().Reporter, y = requireBase().EncoderBuffer, z = requireBase().DecoderBuffer, ne = minimalisticAssert, ue = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], le = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(ue), he = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function ge(Ee, xe) {
    var $e = {};
    this._baseState = $e, $e.enc = Ee, $e.parent = xe || null, $e.children = null, $e.tag = null, $e.args = null, $e.reverseArgs = null, $e.choice = null, $e.optional = !1, $e.any = !1, $e.obj = !1, $e.use = null, $e.useDecoder = null, $e.key = null, $e.default = null, $e.explicit = null, $e.implicit = null, $e.contains = null, $e.parent || ($e.children = [], this._wrap());
  }
  node$1 = ge;
  var we = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return ge.prototype.clone = function() {
    var xe = this._baseState, $e = {};
    we.forEach(function(st) {
      $e[st] = xe[st];
    });
    var Ne = new this.constructor($e.parent);
    return Ne._baseState = $e, Ne;
  }, ge.prototype._wrap = function() {
    var xe = this._baseState;
    le.forEach(function($e) {
      this[$e] = function() {
        var st = new this.constructor(this);
        return xe.children.push(st), st[$e].apply(st, arguments);
      };
    }, this);
  }, ge.prototype._init = function(xe) {
    var $e = this._baseState;
    ne($e.parent === null), xe.call(this), $e.children = $e.children.filter(function(Ne) {
      return Ne._baseState.parent === this;
    }, this), ne.equal($e.children.length, 1, "Root node can have only one child");
  }, ge.prototype._useArgs = function(xe) {
    var $e = this._baseState, Ne = xe.filter(function(st) {
      return st instanceof this.constructor;
    }, this);
    xe = xe.filter(function(st) {
      return !(st instanceof this.constructor);
    }, this), Ne.length !== 0 && (ne($e.children === null), $e.children = Ne, Ne.forEach(function(st) {
      st._baseState.parent = this;
    }, this)), xe.length !== 0 && (ne($e.args === null), $e.args = xe, $e.reverseArgs = xe.map(function(st) {
      if (typeof st != "object" || st.constructor !== Object)
        return st;
      var Nr = {};
      return Object.keys(st).forEach(function(br) {
        br == (br | 0) && (br |= 0);
        var $n = st[br];
        Nr[$n] = br;
      }), Nr;
    }));
  }, he.forEach(function(Ee) {
    ge.prototype[Ee] = function() {
      var $e = this._baseState;
      throw new Error(Ee + " not implemented for encoding: " + $e.enc);
    };
  }), ue.forEach(function(Ee) {
    ge.prototype[Ee] = function() {
      var $e = this._baseState, Ne = Array.prototype.slice.call(arguments);
      return ne($e.tag === null), $e.tag = Ee, this._useArgs(Ne), this;
    };
  }), ge.prototype.use = function(xe) {
    ne(xe);
    var $e = this._baseState;
    return ne($e.use === null), $e.use = xe, this;
  }, ge.prototype.optional = function() {
    var xe = this._baseState;
    return xe.optional = !0, this;
  }, ge.prototype.def = function(xe) {
    var $e = this._baseState;
    return ne($e.default === null), $e.default = xe, $e.optional = !0, this;
  }, ge.prototype.explicit = function(xe) {
    var $e = this._baseState;
    return ne($e.explicit === null && $e.implicit === null), $e.explicit = xe, this;
  }, ge.prototype.implicit = function(xe) {
    var $e = this._baseState;
    return ne($e.explicit === null && $e.implicit === null), $e.implicit = xe, this;
  }, ge.prototype.obj = function() {
    var xe = this._baseState, $e = Array.prototype.slice.call(arguments);
    return xe.obj = !0, $e.length !== 0 && this._useArgs($e), this;
  }, ge.prototype.key = function(xe) {
    var $e = this._baseState;
    return ne($e.key === null), $e.key = xe, this;
  }, ge.prototype.any = function() {
    var xe = this._baseState;
    return xe.any = !0, this;
  }, ge.prototype.choice = function(xe) {
    var $e = this._baseState;
    return ne($e.choice === null), $e.choice = xe, this._useArgs(Object.keys(xe).map(function(Ne) {
      return xe[Ne];
    })), this;
  }, ge.prototype.contains = function(xe) {
    var $e = this._baseState;
    return ne($e.use === null), $e.contains = xe, this;
  }, ge.prototype._decode = function(xe, $e) {
    var Ne = this._baseState;
    if (Ne.parent === null)
      return xe.wrapResult(Ne.children[0]._decode(xe, $e));
    var st = Ne.default, Nr = !0, br = null;
    if (Ne.key !== null && (br = xe.enterKey(Ne.key)), Ne.optional) {
      var $n = null;
      if (Ne.explicit !== null ? $n = Ne.explicit : Ne.implicit !== null ? $n = Ne.implicit : Ne.tag !== null && ($n = Ne.tag), $n === null && !Ne.any) {
        var En = xe.save();
        try {
          Ne.choice === null ? this._decodeGeneric(Ne.tag, xe, $e) : this._decodeChoice(xe, $e), Nr = !0;
        } catch {
          Nr = !1;
        }
        xe.restore(En);
      } else if (Nr = this._peekTag(xe, $n, Ne.any), xe.isError(Nr))
        return Nr;
    }
    var Rn;
    if (Ne.obj && Nr && (Rn = xe.enterObject()), Nr) {
      if (Ne.explicit !== null) {
        var wa = this._decodeTag(xe, Ne.explicit);
        if (xe.isError(wa))
          return wa;
        xe = wa;
      }
      var Aa = xe.offset;
      if (Ne.use === null && Ne.choice === null) {
        if (Ne.any)
          var En = xe.save();
        var _a = this._decodeTag(
          xe,
          Ne.implicit !== null ? Ne.implicit : Ne.tag,
          Ne.any
        );
        if (xe.isError(_a))
          return _a;
        Ne.any ? st = xe.raw(En) : xe = _a;
      }
      if ($e && $e.track && Ne.tag !== null && $e.track(xe.path(), Aa, xe.length, "tagged"), $e && $e.track && Ne.tag !== null && $e.track(xe.path(), xe.offset, xe.length, "content"), Ne.any ? st = st : Ne.choice === null ? st = this._decodeGeneric(Ne.tag, xe, $e) : st = this._decodeChoice(xe, $e), xe.isError(st))
        return st;
      if (!Ne.any && Ne.choice === null && Ne.children !== null && Ne.children.forEach(function(Ra) {
        Ra._decode(xe, $e);
      }), Ne.contains && (Ne.tag === "octstr" || Ne.tag === "bitstr")) {
        var Ta = new z(st);
        st = this._getUse(Ne.contains, xe._reporterState.obj)._decode(Ta, $e);
      }
    }
    return Ne.obj && Nr && (st = xe.leaveObject(Rn)), Ne.key !== null && (st !== null || Nr === !0) ? xe.leaveKey(br, Ne.key, st) : br !== null && xe.exitKey(br), st;
  }, ge.prototype._decodeGeneric = function(xe, $e, Ne) {
    var st = this._baseState;
    return xe === "seq" || xe === "set" ? null : xe === "seqof" || xe === "setof" ? this._decodeList($e, xe, st.args[0], Ne) : /str$/.test(xe) ? this._decodeStr($e, xe, Ne) : xe === "objid" && st.args ? this._decodeObjid($e, st.args[0], st.args[1], Ne) : xe === "objid" ? this._decodeObjid($e, null, null, Ne) : xe === "gentime" || xe === "utctime" ? this._decodeTime($e, xe, Ne) : xe === "null_" ? this._decodeNull($e, Ne) : xe === "bool" ? this._decodeBool($e, Ne) : xe === "objDesc" ? this._decodeStr($e, xe, Ne) : xe === "int" || xe === "enum" ? this._decodeInt($e, st.args && st.args[0], Ne) : st.use !== null ? this._getUse(st.use, $e._reporterState.obj)._decode($e, Ne) : $e.error("unknown tag: " + xe);
  }, ge.prototype._getUse = function(xe, $e) {
    var Ne = this._baseState;
    return Ne.useDecoder = this._use(xe, $e), ne(Ne.useDecoder._baseState.parent === null), Ne.useDecoder = Ne.useDecoder._baseState.children[0], Ne.implicit !== Ne.useDecoder._baseState.implicit && (Ne.useDecoder = Ne.useDecoder.clone(), Ne.useDecoder._baseState.implicit = Ne.implicit), Ne.useDecoder;
  }, ge.prototype._decodeChoice = function(xe, $e) {
    var Ne = this._baseState, st = null, Nr = !1;
    return Object.keys(Ne.choice).some(function(br) {
      var $n = xe.save(), En = Ne.choice[br];
      try {
        var Rn = En._decode(xe, $e);
        if (xe.isError(Rn))
          return !1;
        st = { type: br, value: Rn }, Nr = !0;
      } catch {
        return xe.restore($n), !1;
      }
      return !0;
    }, this), Nr ? st : xe.error("Choice not matched");
  }, ge.prototype._createEncoderBuffer = function(xe) {
    return new y(xe, this.reporter);
  }, ge.prototype._encode = function(xe, $e, Ne) {
    var st = this._baseState;
    if (!(st.default !== null && st.default === xe)) {
      var Nr = this._encodeValue(xe, $e, Ne);
      if (Nr !== void 0 && !this._skipDefault(Nr, $e, Ne))
        return Nr;
    }
  }, ge.prototype._encodeValue = function(xe, $e, Ne) {
    var st = this._baseState;
    if (st.parent === null)
      return st.children[0]._encode(xe, $e || new v());
    var En = null;
    if (this.reporter = $e, st.optional && xe === void 0)
      if (st.default !== null)
        xe = st.default;
      else
        return;
    var Nr = null, br = !1;
    if (st.any)
      En = this._createEncoderBuffer(xe);
    else if (st.choice)
      En = this._encodeChoice(xe, $e);
    else if (st.contains)
      Nr = this._getUse(st.contains, Ne)._encode(xe, $e), br = !0;
    else if (st.children)
      Nr = st.children.map(function(Aa) {
        if (Aa._baseState.tag === "null_")
          return Aa._encode(null, $e, xe);
        if (Aa._baseState.key === null)
          return $e.error("Child should have a key");
        var _a = $e.enterKey(Aa._baseState.key);
        if (typeof xe != "object")
          return $e.error("Child expected, but input is not object");
        var Ta = Aa._encode(xe[Aa._baseState.key], $e, xe);
        return $e.leaveKey(_a), Ta;
      }, this).filter(function(Aa) {
        return Aa;
      }), Nr = this._createEncoderBuffer(Nr);
    else if (st.tag === "seqof" || st.tag === "setof") {
      if (!(st.args && st.args.length === 1))
        return $e.error("Too many args for : " + st.tag);
      if (!Array.isArray(xe))
        return $e.error("seqof/setof, but data is not Array");
      var $n = this.clone();
      $n._baseState.implicit = null, Nr = this._createEncoderBuffer(xe.map(function(Aa) {
        var _a = this._baseState;
        return this._getUse(_a.args[0], xe)._encode(Aa, $e);
      }, $n));
    } else
      st.use !== null ? En = this._getUse(st.use, Ne)._encode(xe, $e) : (Nr = this._encodePrimitive(st.tag, xe), br = !0);
    var En;
    if (!st.any && st.choice === null) {
      var Rn = st.implicit !== null ? st.implicit : st.tag, wa = st.implicit === null ? "universal" : "context";
      Rn === null ? st.use === null && $e.error("Tag could be omitted only for .use()") : st.use === null && (En = this._encodeComposite(Rn, br, wa, Nr));
    }
    return st.explicit !== null && (En = this._encodeComposite(st.explicit, !1, "context", En)), En;
  }, ge.prototype._encodeChoice = function(xe, $e) {
    var Ne = this._baseState, st = Ne.choice[xe.type];
    return st || ne(
      !1,
      xe.type + " not found in " + JSON.stringify(Object.keys(Ne.choice))
    ), st._encode(xe.value, $e);
  }, ge.prototype._encodePrimitive = function(xe, $e) {
    var Ne = this._baseState;
    if (/str$/.test(xe))
      return this._encodeStr($e, xe);
    if (xe === "objid" && Ne.args)
      return this._encodeObjid($e, Ne.reverseArgs[0], Ne.args[1]);
    if (xe === "objid")
      return this._encodeObjid($e, null, null);
    if (xe === "gentime" || xe === "utctime")
      return this._encodeTime($e, xe);
    if (xe === "null_")
      return this._encodeNull();
    if (xe === "int" || xe === "enum")
      return this._encodeInt($e, Ne.args && Ne.reverseArgs[0]);
    if (xe === "bool")
      return this._encodeBool($e);
    if (xe === "objDesc")
      return this._encodeStr($e, xe);
    throw new Error("Unsupported tag: " + xe);
  }, ge.prototype._isNumstr = function(xe) {
    return /^[0-9 ]*$/.test(xe);
  }, ge.prototype._isPrintstr = function(xe) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(xe);
  }, node$1;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(v) {
    var y = v;
    y.Reporter = requireReporter().Reporter, y.DecoderBuffer = requireBuffer().DecoderBuffer, y.EncoderBuffer = requireBuffer().EncoderBuffer, y.Node = requireNode();
  }(base$2)), base$2;
}
var constants$1 = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(v) {
    var y = requireConstants$1();
    v.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, v.tagClassByName = y._reverse(v.tagClass), v.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, v.tagByName = y._reverse(v.tag);
  }(der)), der;
}
var hasRequiredConstants$1;
function requireConstants$1() {
  return hasRequiredConstants$1 || (hasRequiredConstants$1 = 1, function(v) {
    var y = v;
    y._reverse = function(ne) {
      var ue = {};
      return Object.keys(ne).forEach(function(le) {
        (le | 0) == le && (le = le | 0);
        var he = ne[le];
        ue[he] = le;
      }), ue;
    }, y.der = requireDer$2();
  }(constants$1)), constants$1;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1)
    return der_1$1;
  hasRequiredDer$1 = 1;
  var v = requireInherits_browser(), y = requireAsn1$1(), z = y.base, ne = y.bignum, ue = y.constants.der;
  function le(Ee) {
    this.enc = "der", this.name = Ee.name, this.entity = Ee, this.tree = new he(), this.tree._init(Ee.body);
  }
  der_1$1 = le, le.prototype.decode = function(xe, $e) {
    return xe instanceof z.DecoderBuffer || (xe = new z.DecoderBuffer(xe, $e)), this.tree._decode(xe, $e);
  };
  function he(Ee) {
    z.Node.call(this, "der", Ee);
  }
  v(he, z.Node), he.prototype._peekTag = function(xe, $e, Ne) {
    if (xe.isEmpty())
      return !1;
    var st = xe.save(), Nr = ge(xe, 'Failed to peek tag: "' + $e + '"');
    return xe.isError(Nr) ? Nr : (xe.restore(st), Nr.tag === $e || Nr.tagStr === $e || Nr.tagStr + "of" === $e || Ne);
  }, he.prototype._decodeTag = function(xe, $e, Ne) {
    var st = ge(
      xe,
      'Failed to decode tag of "' + $e + '"'
    );
    if (xe.isError(st))
      return st;
    var Nr = we(
      xe,
      st.primitive,
      'Failed to get length of "' + $e + '"'
    );
    if (xe.isError(Nr))
      return Nr;
    if (!Ne && st.tag !== $e && st.tagStr !== $e && st.tagStr + "of" !== $e)
      return xe.error('Failed to match tag: "' + $e + '"');
    if (st.primitive || Nr !== null)
      return xe.skip(Nr, 'Failed to match body of: "' + $e + '"');
    var br = xe.save(), $n = this._skipUntilEnd(
      xe,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return xe.isError($n) ? $n : (Nr = xe.offset - br.offset, xe.restore(br), xe.skip(Nr, 'Failed to match body of: "' + $e + '"'));
  }, he.prototype._skipUntilEnd = function(xe, $e) {
    for (; ; ) {
      var Ne = ge(xe, $e);
      if (xe.isError(Ne))
        return Ne;
      var st = we(xe, Ne.primitive, $e);
      if (xe.isError(st))
        return st;
      var Nr;
      if (Ne.primitive || st !== null ? Nr = xe.skip(st) : Nr = this._skipUntilEnd(xe, $e), xe.isError(Nr))
        return Nr;
      if (Ne.tagStr === "end")
        break;
    }
  }, he.prototype._decodeList = function(xe, $e, Ne, st) {
    for (var Nr = []; !xe.isEmpty(); ) {
      var br = this._peekTag(xe, "end");
      if (xe.isError(br))
        return br;
      var $n = Ne.decode(xe, "der", st);
      if (xe.isError($n) && br)
        break;
      Nr.push($n);
    }
    return Nr;
  }, he.prototype._decodeStr = function(xe, $e) {
    if ($e === "bitstr") {
      var Ne = xe.readUInt8();
      return xe.isError(Ne) ? Ne : { unused: Ne, data: xe.raw() };
    } else if ($e === "bmpstr") {
      var st = xe.raw();
      if (st.length % 2 === 1)
        return xe.error("Decoding of string type: bmpstr length mismatch");
      for (var Nr = "", br = 0; br < st.length / 2; br++)
        Nr += String.fromCharCode(st.readUInt16BE(br * 2));
      return Nr;
    } else if ($e === "numstr") {
      var $n = xe.raw().toString("ascii");
      return this._isNumstr($n) ? $n : xe.error("Decoding of string type: numstr unsupported characters");
    } else {
      if ($e === "octstr")
        return xe.raw();
      if ($e === "objDesc")
        return xe.raw();
      if ($e === "printstr") {
        var En = xe.raw().toString("ascii");
        return this._isPrintstr(En) ? En : xe.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test($e) ? xe.raw().toString() : xe.error("Decoding of string type: " + $e + " unsupported");
    }
  }, he.prototype._decodeObjid = function(xe, $e, Ne) {
    for (var st, Nr = [], br = 0; !xe.isEmpty(); ) {
      var $n = xe.readUInt8();
      br <<= 7, br |= $n & 127, $n & 128 || (Nr.push(br), br = 0);
    }
    $n & 128 && Nr.push(br);
    var En = Nr[0] / 40 | 0, Rn = Nr[0] % 40;
    if (Ne ? st = Nr : st = [En, Rn].concat(Nr.slice(1)), $e) {
      var wa = $e[st.join(" ")];
      wa === void 0 && (wa = $e[st.join(".")]), wa !== void 0 && (st = wa);
    }
    return st;
  }, he.prototype._decodeTime = function(xe, $e) {
    var Ne = xe.raw().toString();
    if ($e === "gentime")
      var st = Ne.slice(0, 4) | 0, Nr = Ne.slice(4, 6) | 0, br = Ne.slice(6, 8) | 0, $n = Ne.slice(8, 10) | 0, En = Ne.slice(10, 12) | 0, Rn = Ne.slice(12, 14) | 0;
    else if ($e === "utctime") {
      var st = Ne.slice(0, 2) | 0, Nr = Ne.slice(2, 4) | 0, br = Ne.slice(4, 6) | 0, $n = Ne.slice(6, 8) | 0, En = Ne.slice(8, 10) | 0, Rn = Ne.slice(10, 12) | 0;
      st < 70 ? st = 2e3 + st : st = 1900 + st;
    } else
      return xe.error("Decoding " + $e + " time is not supported yet");
    return Date.UTC(st, Nr - 1, br, $n, En, Rn, 0);
  }, he.prototype._decodeNull = function(xe) {
    return null;
  }, he.prototype._decodeBool = function(xe) {
    var $e = xe.readUInt8();
    return xe.isError($e) ? $e : $e !== 0;
  }, he.prototype._decodeInt = function(xe, $e) {
    var Ne = xe.raw(), st = new ne(Ne);
    return $e && (st = $e[st.toString(10)] || st), st;
  }, he.prototype._use = function(xe, $e) {
    return typeof xe == "function" && (xe = xe($e)), xe._getDecoder("der").tree;
  };
  function ge(Ee, xe) {
    var $e = Ee.readUInt8(xe);
    if (Ee.isError($e))
      return $e;
    var Ne = ue.tagClass[$e >> 6], st = ($e & 32) === 0;
    if (($e & 31) === 31) {
      var Nr = $e;
      for ($e = 0; (Nr & 128) === 128; ) {
        if (Nr = Ee.readUInt8(xe), Ee.isError(Nr))
          return Nr;
        $e <<= 7, $e |= Nr & 127;
      }
    } else
      $e &= 31;
    var br = ue.tag[$e];
    return {
      cls: Ne,
      primitive: st,
      tag: $e,
      tagStr: br
    };
  }
  function we(Ee, xe, $e) {
    var Ne = Ee.readUInt8($e);
    if (Ee.isError(Ne))
      return Ne;
    if (!xe && Ne === 128)
      return null;
    if (!(Ne & 128))
      return Ne;
    var st = Ne & 127;
    if (st > 4)
      return Ee.error("length octect is too long");
    Ne = 0;
    for (var Nr = 0; Nr < st; Nr++) {
      Ne <<= 8;
      var br = Ee.readUInt8($e);
      if (Ee.isError(br))
        return br;
      Ne |= br;
    }
    return Ne;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1)
    return pem$1;
  hasRequiredPem$1 = 1;
  var v = requireInherits_browser(), y = require$$0$3.Buffer, z = requireDer$1();
  function ne(ue) {
    z.call(this, ue), this.enc = "pem";
  }
  return v(ne, z), pem$1 = ne, ne.prototype.decode = function(le, he) {
    for (var ge = le.toString().split(/[\r\n]+/g), we = he.label.toUpperCase(), Ee = /^-----(BEGIN|END) ([^-]+)-----$/, xe = -1, $e = -1, Ne = 0; Ne < ge.length; Ne++) {
      var st = ge[Ne].match(Ee);
      if (st !== null && st[2] === we)
        if (xe === -1) {
          if (st[1] !== "BEGIN")
            break;
          xe = Ne;
        } else {
          if (st[1] !== "END")
            break;
          $e = Ne;
          break;
        }
    }
    if (xe === -1 || $e === -1)
      throw new Error("PEM section not found for: " + we);
    var Nr = ge.slice(xe + 1, $e).join("");
    Nr.replace(/[^a-z0-9\+\/=]+/gi, "");
    var br = new y(Nr, "base64");
    return z.prototype.decode.call(this, br, he);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(v) {
    var y = v;
    y.der = requireDer$1(), y.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer)
    return der_1;
  hasRequiredDer = 1;
  var v = requireInherits_browser(), y = require$$0$3.Buffer, z = requireAsn1$1(), ne = z.base, ue = z.constants.der;
  function le(Ee) {
    this.enc = "der", this.name = Ee.name, this.entity = Ee, this.tree = new he(), this.tree._init(Ee.body);
  }
  der_1 = le, le.prototype.encode = function(xe, $e) {
    return this.tree._encode(xe, $e).join();
  };
  function he(Ee) {
    ne.Node.call(this, "der", Ee);
  }
  v(he, ne.Node), he.prototype._encodeComposite = function(xe, $e, Ne, st) {
    var Nr = we(xe, $e, Ne, this.reporter);
    if (st.length < 128) {
      var En = new y(2);
      return En[0] = Nr, En[1] = st.length, this._createEncoderBuffer([En, st]);
    }
    for (var br = 1, $n = st.length; $n >= 256; $n >>= 8)
      br++;
    var En = new y(2 + br);
    En[0] = Nr, En[1] = 128 | br;
    for (var $n = 1 + br, Rn = st.length; Rn > 0; $n--, Rn >>= 8)
      En[$n] = Rn & 255;
    return this._createEncoderBuffer([En, st]);
  }, he.prototype._encodeStr = function(xe, $e) {
    if ($e === "bitstr")
      return this._createEncoderBuffer([xe.unused | 0, xe.data]);
    if ($e === "bmpstr") {
      for (var Ne = new y(xe.length * 2), st = 0; st < xe.length; st++)
        Ne.writeUInt16BE(xe.charCodeAt(st), st * 2);
      return this._createEncoderBuffer(Ne);
    } else
      return $e === "numstr" ? this._isNumstr(xe) ? this._createEncoderBuffer(xe) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : $e === "printstr" ? this._isPrintstr(xe) ? this._createEncoderBuffer(xe) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test($e) ? this._createEncoderBuffer(xe) : $e === "objDesc" ? this._createEncoderBuffer(xe) : this.reporter.error("Encoding of string type: " + $e + " unsupported");
  }, he.prototype._encodeObjid = function(xe, $e, Ne) {
    if (typeof xe == "string") {
      if (!$e)
        return this.reporter.error("string objid given, but no values map found");
      if (!$e.hasOwnProperty(xe))
        return this.reporter.error("objid not found in values map");
      xe = $e[xe].split(/[\s\.]+/g);
      for (var st = 0; st < xe.length; st++)
        xe[st] |= 0;
    } else if (Array.isArray(xe)) {
      xe = xe.slice();
      for (var st = 0; st < xe.length; st++)
        xe[st] |= 0;
    }
    if (!Array.isArray(xe))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(xe));
    if (!Ne) {
      if (xe[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      xe.splice(0, 2, xe[0] * 40 + xe[1]);
    }
    for (var Nr = 0, st = 0; st < xe.length; st++) {
      var br = xe[st];
      for (Nr++; br >= 128; br >>= 7)
        Nr++;
    }
    for (var $n = new y(Nr), En = $n.length - 1, st = xe.length - 1; st >= 0; st--) {
      var br = xe[st];
      for ($n[En--] = br & 127; (br >>= 7) > 0; )
        $n[En--] = 128 | br & 127;
    }
    return this._createEncoderBuffer($n);
  };
  function ge(Ee) {
    return Ee < 10 ? "0" + Ee : Ee;
  }
  he.prototype._encodeTime = function(xe, $e) {
    var Ne, st = new Date(xe);
    return $e === "gentime" ? Ne = [
      ge(st.getFullYear()),
      ge(st.getUTCMonth() + 1),
      ge(st.getUTCDate()),
      ge(st.getUTCHours()),
      ge(st.getUTCMinutes()),
      ge(st.getUTCSeconds()),
      "Z"
    ].join("") : $e === "utctime" ? Ne = [
      ge(st.getFullYear() % 100),
      ge(st.getUTCMonth() + 1),
      ge(st.getUTCDate()),
      ge(st.getUTCHours()),
      ge(st.getUTCMinutes()),
      ge(st.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + $e + " time is not supported yet"), this._encodeStr(Ne, "octstr");
  }, he.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, he.prototype._encodeInt = function(xe, $e) {
    if (typeof xe == "string") {
      if (!$e)
        return this.reporter.error("String int or enum given, but no values map");
      if (!$e.hasOwnProperty(xe))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(xe));
      xe = $e[xe];
    }
    if (typeof xe != "number" && !y.isBuffer(xe)) {
      var Ne = xe.toArray();
      !xe.sign && Ne[0] & 128 && Ne.unshift(0), xe = new y(Ne);
    }
    if (y.isBuffer(xe)) {
      var st = xe.length;
      xe.length === 0 && st++;
      var br = new y(st);
      return xe.copy(br), xe.length === 0 && (br[0] = 0), this._createEncoderBuffer(br);
    }
    if (xe < 128)
      return this._createEncoderBuffer(xe);
    if (xe < 256)
      return this._createEncoderBuffer([0, xe]);
    for (var st = 1, Nr = xe; Nr >= 256; Nr >>= 8)
      st++;
    for (var br = new Array(st), Nr = br.length - 1; Nr >= 0; Nr--)
      br[Nr] = xe & 255, xe >>= 8;
    return br[0] & 128 && br.unshift(0), this._createEncoderBuffer(new y(br));
  }, he.prototype._encodeBool = function(xe) {
    return this._createEncoderBuffer(xe ? 255 : 0);
  }, he.prototype._use = function(xe, $e) {
    return typeof xe == "function" && (xe = xe($e)), xe._getEncoder("der").tree;
  }, he.prototype._skipDefault = function(xe, $e, Ne) {
    var st = this._baseState, Nr;
    if (st.default === null)
      return !1;
    var br = xe.join();
    if (st.defaultBuffer === void 0 && (st.defaultBuffer = this._encodeValue(st.default, $e, Ne).join()), br.length !== st.defaultBuffer.length)
      return !1;
    for (Nr = 0; Nr < br.length; Nr++)
      if (br[Nr] !== st.defaultBuffer[Nr])
        return !1;
    return !0;
  };
  function we(Ee, xe, $e, Ne) {
    var st;
    if (Ee === "seqof" ? Ee = "seq" : Ee === "setof" && (Ee = "set"), ue.tagByName.hasOwnProperty(Ee))
      st = ue.tagByName[Ee];
    else if (typeof Ee == "number" && (Ee | 0) === Ee)
      st = Ee;
    else
      return Ne.error("Unknown tag: " + Ee);
    return st >= 31 ? Ne.error("Multi-octet tag encoding unsupported") : (xe || (st |= 32), st |= ue.tagClassByName[$e || "universal"] << 6, st);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem)
    return pem;
  hasRequiredPem = 1;
  var v = requireInherits_browser(), y = requireDer();
  function z(ne) {
    y.call(this, ne), this.enc = "pem";
  }
  return v(z, y), pem = z, z.prototype.encode = function(ue, le) {
    for (var he = y.prototype.encode.call(this, ue), ge = he.toString("base64"), we = ["-----BEGIN " + le.label + "-----"], Ee = 0; Ee < ge.length; Ee += 64)
      we.push(ge.slice(Ee, Ee + 64));
    return we.push("-----END " + le.label + "-----"), we.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(v) {
    var y = v;
    y.der = requireDer(), y.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(v) {
    var y = v;
    y.bignum = requireBn$2(), y.define = requireApi().define, y.base = requireBase(), y.constants = requireConstants$1(), y.decoders = requireDecoders(), y.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate)
    return certificate;
  hasRequiredCertificate = 1;
  var v = requireAsn1$1(), y = v.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), z = v.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), ne = v.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), ue = v.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(ne),
      this.key("subjectPublicKey").bitstr()
    );
  }), le = v.define("RelativeDistinguishedName", function() {
    this.setof(z);
  }), he = v.define("RDNSequence", function() {
    this.seqof(le);
  }), ge = v.define("Name", function() {
    this.choice({
      rdnSequence: this.use(he)
    });
  }), we = v.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(y),
      this.key("notAfter").use(y)
    );
  }), Ee = v.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), xe = v.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(ne),
      this.key("issuer").use(ge),
      this.key("validity").use(we),
      this.key("subject").use(ge),
      this.key("subjectPublicKeyInfo").use(ue),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(Ee).optional()
    );
  }), $e = v.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(xe),
      this.key("signatureAlgorithm").use(ne),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = $e, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1)
    return asn1$1;
  hasRequiredAsn1 = 1;
  var v = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var y = v.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = y;
  var z = v.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = z;
  var ne = v.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), ue = v.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(ne),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = ue;
  var le = v.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(ne),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = le;
  var he = v.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = he;
  var ge = v.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = ge, asn1$1.DSAparam = v.define("DSAparam", function() {
    this.int();
  });
  var we = v.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), Ee = v.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(we),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = Ee, asn1$1.signature = v.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc)
    return fixProc;
  hasRequiredFixProc = 1;
  var v = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, y = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, z = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, ne = requireEvp_bytestokey(), ue = requireBrowser$6(), le = requireSafeBuffer$2().Buffer;
  return fixProc = function(he, ge) {
    var we = he.toString(), Ee = we.match(v), xe;
    if (Ee) {
      var Ne = "aes" + Ee[1], st = le.from(Ee[2], "hex"), Nr = le.from(Ee[3].replace(/[\r\n]/g, ""), "base64"), br = ne(ge, st.slice(0, 8), parseInt(Ee[1], 10)).key, $n = [], En = ue.createDecipheriv(Ne, br, st);
      $n.push(En.update(Nr)), $n.push(En.final()), xe = le.concat($n);
    } else {
      var $e = we.match(z);
      xe = le.from($e[2].replace(/[\r\n]/g, ""), "base64");
    }
    var Rn = we.match(y)[1];
    return {
      tag: Rn,
      data: xe
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1)
    return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var v = requireAsn1(), y = require$$1, z = requireFixProc(), ne = requireBrowser$6(), ue = requireBrowser$7(), le = requireSafeBuffer$2().Buffer;
  function he(we, Ee) {
    var xe = we.algorithm.decrypt.kde.kdeparams.salt, $e = parseInt(we.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), Ne = y[we.algorithm.decrypt.cipher.algo.join(".")], st = we.algorithm.decrypt.cipher.iv, Nr = we.subjectPrivateKey, br = parseInt(Ne.split("-")[1], 10) / 8, $n = ue.pbkdf2Sync(Ee, xe, $e, br, "sha1"), En = ne.createDecipheriv(Ne, $n, st), Rn = [];
    return Rn.push(En.update(Nr)), Rn.push(En.final()), le.concat(Rn);
  }
  function ge(we) {
    var Ee;
    typeof we == "object" && !le.isBuffer(we) && (Ee = we.passphrase, we = we.key), typeof we == "string" && (we = le.from(we));
    var xe = z(we, Ee), $e = xe.tag, Ne = xe.data, st, Nr;
    switch ($e) {
      case "CERTIFICATE":
        Nr = v.certificate.decode(Ne, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (Nr || (Nr = v.PublicKey.decode(Ne, "der")), st = Nr.algorithm.algorithm.join("."), st) {
          case "1.2.840.113549.1.1.1":
            return v.RSAPublicKey.decode(Nr.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return Nr.subjectPrivateKey = Nr.subjectPublicKey, {
              type: "ec",
              data: Nr
            };
          case "1.2.840.10040.4.1":
            return Nr.algorithm.params.pub_key = v.DSAparam.decode(Nr.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: Nr.algorithm.params
            };
          default:
            throw new Error("unknown key id " + st);
        }
      case "ENCRYPTED PRIVATE KEY":
        Ne = v.EncryptedPrivateKey.decode(Ne, "der"), Ne = he(Ne, Ee);
      case "PRIVATE KEY":
        switch (Nr = v.PrivateKey.decode(Ne, "der"), st = Nr.algorithm.algorithm.join("."), st) {
          case "1.2.840.113549.1.1.1":
            return v.RSAPrivateKey.decode(Nr.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: Nr.algorithm.curve,
              privateKey: v.ECPrivateKey.decode(Nr.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return Nr.algorithm.params.priv_key = v.DSAparam.decode(Nr.subjectPrivateKey, "der"), {
              type: "dsa",
              params: Nr.algorithm.params
            };
          default:
            throw new Error("unknown key id " + st);
        }
      case "RSA PUBLIC KEY":
        return v.RSAPublicKey.decode(Ne, "der");
      case "RSA PRIVATE KEY":
        return v.RSAPrivateKey.decode(Ne, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: v.DSAPrivateKey.decode(Ne, "der")
        };
      case "EC PRIVATE KEY":
        return Ne = v.ECPrivateKey.decode(Ne, "der"), {
          curve: Ne.parameters.value,
          privateKey: Ne.privateKey
        };
      default:
        throw new Error("unknown key type " + $e);
    }
  }
  return ge.signature = v.signature, parseAsn1 = ge, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign)
    return sign.exports;
  hasRequiredSign = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireBrowser$8(), z = requireBrowserifyRsa(), ne = requireElliptic().ec, ue = bnExports$1, le = requireParseAsn1(), he = require$$4, ge = 1;
  function we(En, Rn, wa, Aa, _a) {
    var Ta = le(Rn);
    if (Ta.curve) {
      if (Aa !== "ecdsa" && Aa !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return Ee(En, Ta);
    } else if (Ta.type === "dsa") {
      if (Aa !== "dsa")
        throw new Error("wrong private key type");
      return xe(En, Ta, wa);
    }
    if (Aa !== "rsa" && Aa !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (Rn.padding !== void 0 && Rn.padding !== ge)
      throw new Error("illegal or unsupported padding mode");
    En = v.concat([_a, En]);
    for (var Zn = Ta.modulus.byteLength(), Ra = [0, 1]; En.length + Ra.length + 1 < Zn; )
      Ra.push(255);
    Ra.push(0);
    for (var Yn = -1; ++Yn < En.length; )
      Ra.push(En[Yn]);
    var $o = z(Ra, Ta);
    return $o;
  }
  function Ee(En, Rn) {
    var wa = he[Rn.curve.join(".")];
    if (!wa)
      throw new Error("unknown curve " + Rn.curve.join("."));
    var Aa = new ne(wa), _a = Aa.keyFromPrivate(Rn.privateKey), Ta = _a.sign(En);
    return v.from(Ta.toDER());
  }
  function xe(En, Rn, wa) {
    for (var Aa = Rn.params.priv_key, _a = Rn.params.p, Ta = Rn.params.q, Zn = Rn.params.g, Ra = new ue(0), Yn, $o = st(En, Ta).mod(Ta), ct = !1, fe = Ne(Aa, Ta, En, wa); ct === !1; )
      Yn = br(Ta, fe, wa), Ra = $n(Zn, Yn, _a, Ta), ct = Yn.invm(Ta).imul($o.add(Aa.mul(Ra))).mod(Ta), ct.cmpn(0) === 0 && (ct = !1, Ra = new ue(0));
    return $e(Ra, ct);
  }
  function $e(En, Rn) {
    En = En.toArray(), Rn = Rn.toArray(), En[0] & 128 && (En = [0].concat(En)), Rn[0] & 128 && (Rn = [0].concat(Rn));
    var wa = En.length + Rn.length + 4, Aa = [
      48,
      wa,
      2,
      En.length
    ];
    return Aa = Aa.concat(En, [2, Rn.length], Rn), v.from(Aa);
  }
  function Ne(En, Rn, wa, Aa) {
    if (En = v.from(En.toArray()), En.length < Rn.byteLength()) {
      var _a = v.alloc(Rn.byteLength() - En.length);
      En = v.concat([_a, En]);
    }
    var Ta = wa.length, Zn = Nr(wa, Rn), Ra = v.alloc(Ta);
    Ra.fill(1);
    var Yn = v.alloc(Ta);
    return Yn = y(Aa, Yn).update(Ra).update(v.from([0])).update(En).update(Zn).digest(), Ra = y(Aa, Yn).update(Ra).digest(), Yn = y(Aa, Yn).update(Ra).update(v.from([1])).update(En).update(Zn).digest(), Ra = y(Aa, Yn).update(Ra).digest(), { k: Yn, v: Ra };
  }
  function st(En, Rn) {
    var wa = new ue(En), Aa = (En.length << 3) - Rn.bitLength();
    return Aa > 0 && wa.ishrn(Aa), wa;
  }
  function Nr(En, Rn) {
    En = st(En, Rn), En = En.mod(Rn);
    var wa = v.from(En.toArray());
    if (wa.length < Rn.byteLength()) {
      var Aa = v.alloc(Rn.byteLength() - wa.length);
      wa = v.concat([Aa, wa]);
    }
    return wa;
  }
  function br(En, Rn, wa) {
    var Aa, _a;
    do {
      for (Aa = v.alloc(0); Aa.length * 8 < En.bitLength(); )
        Rn.v = y(wa, Rn.k).update(Rn.v).digest(), Aa = v.concat([Aa, Rn.v]);
      _a = st(Aa, En), Rn.k = y(wa, Rn.k).update(Rn.v).update(v.from([0])).digest(), Rn.v = y(wa, Rn.k).update(Rn.v).digest();
    } while (_a.cmp(En) !== -1);
    return _a;
  }
  function $n(En, Rn, wa, Aa) {
    return En.toRed(ue.mont(wa)).redPow(Rn).fromRed().mod(Aa);
  }
  return sign.exports = we, sign.exports.getKey = Ne, sign.exports.makeKey = br, sign.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify)
    return verify_1;
  hasRequiredVerify = 1;
  var v = requireSafeBuffer$2().Buffer, y = bnExports$1, z = requireElliptic().ec, ne = requireParseAsn1(), ue = require$$4;
  function le(Ee, xe, $e, Ne, st) {
    var Nr = ne($e);
    if (Nr.type === "ec") {
      if (Ne !== "ecdsa" && Ne !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return he(Ee, xe, Nr);
    } else if (Nr.type === "dsa") {
      if (Ne !== "dsa")
        throw new Error("wrong public key type");
      return ge(Ee, xe, Nr);
    }
    if (Ne !== "rsa" && Ne !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    xe = v.concat([st, xe]);
    for (var br = Nr.modulus.byteLength(), $n = [1], En = 0; xe.length + $n.length + 2 < br; )
      $n.push(255), En += 1;
    $n.push(0);
    for (var Rn = -1; ++Rn < xe.length; )
      $n.push(xe[Rn]);
    $n = v.from($n);
    var wa = y.mont(Nr.modulus);
    Ee = new y(Ee).toRed(wa), Ee = Ee.redPow(new y(Nr.publicExponent)), Ee = v.from(Ee.fromRed().toArray());
    var Aa = En < 8 ? 1 : 0;
    for (br = Math.min(Ee.length, $n.length), Ee.length !== $n.length && (Aa = 1), Rn = -1; ++Rn < br; )
      Aa |= Ee[Rn] ^ $n[Rn];
    return Aa === 0;
  }
  function he(Ee, xe, $e) {
    var Ne = ue[$e.data.algorithm.curve.join(".")];
    if (!Ne)
      throw new Error("unknown curve " + $e.data.algorithm.curve.join("."));
    var st = new z(Ne), Nr = $e.data.subjectPrivateKey.data;
    return st.verify(xe, Ee, Nr);
  }
  function ge(Ee, xe, $e) {
    var Ne = $e.data.p, st = $e.data.q, Nr = $e.data.g, br = $e.data.pub_key, $n = ne.signature.decode(Ee, "der"), En = $n.s, Rn = $n.r;
    we(En, st), we(Rn, st);
    var wa = y.mont(Ne), Aa = En.invm(st), _a = Nr.toRed(wa).redPow(new y(xe).mul(Aa).mod(st)).fromRed().mul(br.toRed(wa).redPow(Rn.mul(Aa).mod(st)).fromRed()).mod(Ne).mod(st);
    return _a.cmp(Rn) === 0;
  }
  function we(Ee, xe) {
    if (Ee.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (Ee.cmp(xe) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = le, verify_1;
}
var browser$4, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3)
    return browser$4;
  hasRequiredBrowser$3 = 1;
  var v = requireSafeBuffer$2().Buffer, y = requireBrowser$9(), z = requireReadableBrowser(), ne = requireInherits_browser(), ue = requireSign(), le = requireVerify(), he = require$$6;
  Object.keys(he).forEach(function($e) {
    he[$e].id = v.from(he[$e].id, "hex"), he[$e.toLowerCase()] = he[$e];
  });
  function ge($e) {
    z.Writable.call(this);
    var Ne = he[$e];
    if (!Ne)
      throw new Error("Unknown message digest");
    this._hashType = Ne.hash, this._hash = y(Ne.hash), this._tag = Ne.id, this._signType = Ne.sign;
  }
  ne(ge, z.Writable), ge.prototype._write = function(Ne, st, Nr) {
    this._hash.update(Ne), Nr();
  }, ge.prototype.update = function(Ne, st) {
    return this._hash.update(typeof Ne == "string" ? v.from(Ne, st) : Ne), this;
  }, ge.prototype.sign = function(Ne, st) {
    this.end();
    var Nr = this._hash.digest(), br = ue(Nr, Ne, this._hashType, this._signType, this._tag);
    return st ? br.toString(st) : br;
  };
  function we($e) {
    z.Writable.call(this);
    var Ne = he[$e];
    if (!Ne)
      throw new Error("Unknown message digest");
    this._hash = y(Ne.hash), this._tag = Ne.id, this._signType = Ne.sign;
  }
  ne(we, z.Writable), we.prototype._write = function(Ne, st, Nr) {
    this._hash.update(Ne), Nr();
  }, we.prototype.update = function(Ne, st) {
    return this._hash.update(typeof Ne == "string" ? v.from(Ne, st) : Ne), this;
  }, we.prototype.verify = function(Ne, st, Nr) {
    var br = typeof st == "string" ? v.from(st, Nr) : st;
    this.end();
    var $n = this._hash.digest();
    return le(br, $n, Ne, this._signType, this._tag);
  };
  function Ee($e) {
    return new ge($e);
  }
  function xe($e) {
    return new we($e);
  }
  return browser$4 = {
    Sign: Ee,
    Verify: xe,
    createSign: Ee,
    createVerify: xe
  }, browser$4;
}
var bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(v) {
    (function(y, z) {
      function ne(ct, fe) {
        if (!ct)
          throw new Error(fe || "Assertion failed");
      }
      function ue(ct, fe) {
        ct.super_ = fe;
        var be = function() {
        };
        be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
      }
      function le(ct, fe, be) {
        if (le.isBN(ct))
          return ct;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
      }
      typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
      var he;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
      } catch {
      }
      le.isBN = function(fe) {
        return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
      }, le.max = function(fe, be) {
        return fe.cmp(be) > 0 ? fe : be;
      }, le.min = function(fe, be) {
        return fe.cmp(be) < 0 ? fe : be;
      }, le.prototype._init = function(fe, be, ye) {
        if (typeof fe == "number")
          return this._initNumber(fe, be, ye);
        if (typeof fe == "object")
          return this._initArray(fe, be, ye);
        be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
        var Se = 0;
        fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
      }, le.prototype._initNumber = function(fe, be, ye) {
        fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863
        ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863,
          1
        ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
      }, le.prototype._initArray = function(fe, be, ye) {
        if (ne(typeof fe.length == "number"), fe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe, Fr, zn = 0;
        if (ye === "be")
          for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
            Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        else if (ye === "le")
          for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
            Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        return this.strip();
      };
      function ge(ct, fe) {
        var be = ct.charCodeAt(fe);
        return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
      }
      function we(ct, fe, be) {
        var ye = ge(ct, be);
        return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
      }
      le.prototype._parseHex = function(fe, be, ye) {
        this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe = 0, Fr = 0, zn;
        if (ye === "be")
          for (Se = fe.length - 1; Se >= be; Se -= 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        else {
          var Fe = fe.length - be;
          for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        }
        this.strip();
      };
      function Ee(ct, fe, be, ye) {
        for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
          var zn = ct.charCodeAt(Fr) - 48;
          Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
        }
        return Se;
      }
      le.prototype._parseBase = function(fe, be, ye) {
        this.words = [0], this.length = 1;
        for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
          Se++;
        Se--, Oe = Oe / be | 0;
        for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
          pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        if (zn !== 0) {
          var xa = 1;
          for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
            xa *= be;
          this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        }
        this.strip();
      }, le.prototype.copy = function(fe) {
        fe.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          fe.words[be] = this.words[be];
        fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
      }, le.prototype.clone = function() {
        var fe = new le(null);
        return this.copy(fe), fe;
      }, le.prototype._expand = function(fe) {
        for (; this.length < fe; )
          this.words[this.length++] = 0;
        return this;
      }, le.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, le.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, le.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var xe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $e = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ne = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      le.prototype.toString = function(fe, be) {
        fe = fe || 10, be = be | 0 || 1;
        var ye;
        if (fe === 16 || fe === "hex") {
          ye = "";
          for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
            var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
            Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
          }
          for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
          var pe = $e[fe], it = Ne[fe];
          ye = "";
          var xa = this.clone();
          for (xa.negative = 0; !xa.isZero(); ) {
            var wo = xa.modn(it).toString(fe);
            xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
          }
          for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        ne(!1, "Base should be between 2 and 36");
      }, le.prototype.toNumber = function() {
        var fe = this.words[0];
        return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
      }, le.prototype.toJSON = function() {
        return this.toString(16);
      }, le.prototype.toBuffer = function(fe, be) {
        return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
      }, le.prototype.toArray = function(fe, be) {
        return this.toArrayLike(Array, fe, be);
      }, le.prototype.toArrayLike = function(fe, be, ye) {
        var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
        ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
        var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
        if (Fr) {
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
          for (; pe < Oe; pe++)
            zn[pe] = 0;
        } else {
          for (pe = 0; pe < Oe - Se; pe++)
            zn[pe] = 0;
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
        }
        return zn;
      }, Math.clz32 ? le.prototype._countBits = function(fe) {
        return 32 - Math.clz32(fe);
      } : le.prototype._countBits = function(fe) {
        var be = fe, ye = 0;
        return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
      }, le.prototype._zeroBits = function(fe) {
        if (fe === 0)
          return 26;
        var be = fe, ye = 0;
        return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
      }, le.prototype.bitLength = function() {
        var fe = this.words[this.length - 1], be = this._countBits(fe);
        return (this.length - 1) * 26 + be;
      };
      function st(ct) {
        for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
          var ye = be / 26 | 0, Se = be % 26;
          fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
        }
        return fe;
      }
      le.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var fe = 0, be = 0; be < this.length; be++) {
          var ye = this._zeroBits(this.words[be]);
          if (fe += ye, ye !== 26)
            break;
        }
        return fe;
      }, le.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, le.prototype.toTwos = function(fe) {
        return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
      }, le.prototype.fromTwos = function(fe) {
        return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
      }, le.prototype.isNeg = function() {
        return this.negative !== 0;
      }, le.prototype.neg = function() {
        return this.clone().ineg();
      }, le.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, le.prototype.iuor = function(fe) {
        for (; this.length < fe.length; )
          this.words[this.length++] = 0;
        for (var be = 0; be < fe.length; be++)
          this.words[be] = this.words[be] | fe.words[be];
        return this.strip();
      }, le.prototype.ior = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuor(fe);
      }, le.prototype.or = function(fe) {
        return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
      }, le.prototype.uor = function(fe) {
        return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
      }, le.prototype.iuand = function(fe) {
        var be;
        this.length > fe.length ? be = fe : be = this;
        for (var ye = 0; ye < be.length; ye++)
          this.words[ye] = this.words[ye] & fe.words[ye];
        return this.length = be.length, this.strip();
      }, le.prototype.iand = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuand(fe);
      }, le.prototype.and = function(fe) {
        return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
      }, le.prototype.uand = function(fe) {
        return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
      }, le.prototype.iuxor = function(fe) {
        var be, ye;
        this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
        for (var Se = 0; Se < ye.length; Se++)
          this.words[Se] = be.words[Se] ^ ye.words[Se];
        if (this !== be)
          for (; Se < be.length; Se++)
            this.words[Se] = be.words[Se];
        return this.length = be.length, this.strip();
      }, le.prototype.ixor = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
      }, le.prototype.xor = function(fe) {
        return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
      }, le.prototype.uxor = function(fe) {
        return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
      }, le.prototype.inotn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
        this._expand(be), ye > 0 && be--;
        for (var Se = 0; Se < be; Se++)
          this.words[Se] = ~this.words[Se] & 67108863;
        return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
      }, le.prototype.notn = function(fe) {
        return this.clone().inotn(fe);
      }, le.prototype.setn = function(fe, be) {
        ne(typeof fe == "number" && fe >= 0);
        var ye = fe / 26 | 0, Se = fe % 26;
        return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
      }, le.prototype.iadd = function(fe) {
        var be;
        if (this.negative !== 0 && fe.negative === 0)
          return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && fe.negative !== 0)
          return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
        var ye, Se;
        this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
        for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
          be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        for (; Oe !== 0 && Fr < ye.length; Fr++)
          be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        if (this.length = ye.length, Oe !== 0)
          this.words[this.length] = Oe, this.length++;
        else if (ye !== this)
          for (; Fr < ye.length; Fr++)
            this.words[Fr] = ye.words[Fr];
        return this;
      }, le.prototype.add = function(fe) {
        var be;
        return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
      }, le.prototype.isub = function(fe) {
        if (fe.negative !== 0) {
          fe.negative = 0;
          var be = this.iadd(fe);
          return fe.negative = 1, be._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
        var ye = this.cmp(fe);
        if (ye === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Se, Oe;
        ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
        for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
          be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        for (; Fr !== 0 && zn < Se.length; zn++)
          be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        if (Fr === 0 && zn < Se.length && Se !== this)
          for (; zn < Se.length; zn++)
            this.words[zn] = Se.words[zn];
        return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
      }, le.prototype.sub = function(fe) {
        return this.clone().isub(fe);
      };
      function Nr(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative;
        var ye = ct.length + fe.length | 0;
        be.length = ye, ye = ye - 1 | 0;
        var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
        be.words[0] = zn;
        for (var pe = 1; pe < ye; pe++) {
          for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
            var Oa = pe - _u | 0;
            Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
          }
          be.words[pe] = xa | 0, Fe = it | 0;
        }
        return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
      }
      var br = function(fe, be, ye) {
        var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
        ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
        var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
        var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
        var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
        var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
        var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
        var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
        var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
        var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
        var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
        var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
        var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
        var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
        var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
        var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
        var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
        var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
        var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
        var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
        var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
      };
      Math.imul || (br = Nr);
      function $n(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
        for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
          var Fr = Se;
          Se = 0;
          for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
            var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
            Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
          }
          be.words[Oe] = zn, ye = Fr, Fr = Se;
        }
        return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
      }
      function En(ct, fe, be) {
        var ye = new Rn();
        return ye.mulp(ct, fe, be);
      }
      le.prototype.mulTo = function(fe, be) {
        var ye, Se = this.length + fe.length;
        return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
      };
      function Rn(ct, fe) {
        this.x = ct, this.y = fe;
      }
      Rn.prototype.makeRBT = function(fe) {
        for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
          be[Se] = this.revBin(Se, ye, fe);
        return be;
      }, Rn.prototype.revBin = function(fe, be, ye) {
        if (fe === 0 || fe === ye - 1)
          return fe;
        for (var Se = 0, Oe = 0; Oe < be; Oe++)
          Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
        return Se;
      }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
        for (var zn = 0; zn < Fr; zn++)
          Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
      }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
        this.permute(Fr, fe, be, ye, Se, Oe);
        for (var zn = 1; zn < Oe; zn <<= 1)
          for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
            for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
              var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
              Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
            }
      }, Rn.prototype.guessLen13b = function(fe, be) {
        var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
        for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
          Oe++;
        return 1 << Oe + 1 + Se;
      }, Rn.prototype.conjugate = function(fe, be, ye) {
        if (!(ye <= 1))
          for (var Se = 0; Se < ye / 2; Se++) {
            var Oe = fe[Se];
            fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
          }
      }, Rn.prototype.normalize13b = function(fe, be) {
        for (var ye = 0, Se = 0; Se < be / 2; Se++) {
          var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
          fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
        }
        return fe;
      }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
        for (var Oe = 0, Fr = 0; Fr < be; Fr++)
          Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
        for (Fr = 2 * be; Fr < Se; ++Fr)
          ye[Fr] = 0;
        ne(Oe === 0), ne((Oe & -8192) === 0);
      }, Rn.prototype.stub = function(fe) {
        for (var be = new Array(fe), ye = 0; ye < fe; ye++)
          be[ye] = 0;
        return be;
      }, Rn.prototype.mulp = function(fe, be, ye) {
        var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
        _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
        for (var Oa = 0; Oa < Se; Oa++) {
          var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
          pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
        }
        return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
      }, le.prototype.mul = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
      }, le.prototype.mulf = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), En(this, fe, be);
      }, le.prototype.imul = function(fe) {
        return this.clone().mulTo(fe, this);
      }, le.prototype.imuln = function(fe) {
        ne(typeof fe == "number"), ne(fe < 67108864);
        for (var be = 0, ye = 0; ye < this.length; ye++) {
          var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
          be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
        }
        return be !== 0 && (this.words[ye] = be, this.length++), this;
      }, le.prototype.muln = function(fe) {
        return this.clone().imuln(fe);
      }, le.prototype.sqr = function() {
        return this.mul(this);
      }, le.prototype.isqr = function() {
        return this.imul(this.clone());
      }, le.prototype.pow = function(fe) {
        var be = st(fe);
        if (be.length === 0)
          return new le(1);
        for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
          ;
        if (++Se < be.length)
          for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
            be[Se] !== 0 && (ye = ye.mul(Oe));
        return ye;
      }, le.prototype.iushln = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
        if (be !== 0) {
          var Fr = 0;
          for (Oe = 0; Oe < this.length; Oe++) {
            var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
            this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
          }
          Fr && (this.words[Oe] = Fr, this.length++);
        }
        if (ye !== 0) {
          for (Oe = this.length - 1; Oe >= 0; Oe--)
            this.words[Oe + ye] = this.words[Oe];
          for (Oe = 0; Oe < ye; Oe++)
            this.words[Oe] = 0;
          this.length += ye;
        }
        return this.strip();
      }, le.prototype.ishln = function(fe) {
        return ne(this.negative === 0), this.iushln(fe);
      }, le.prototype.iushrn = function(fe, be, ye) {
        ne(typeof fe == "number" && fe >= 0);
        var Se;
        be ? Se = (be - be % 26) / 26 : Se = 0;
        var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
        if (Se -= Fr, Se = Math.max(0, Se), Fe) {
          for (var pe = 0; pe < Fr; pe++)
            Fe.words[pe] = this.words[pe];
          Fe.length = Fr;
        }
        if (Fr !== 0)
          if (this.length > Fr)
            for (this.length -= Fr, pe = 0; pe < this.length; pe++)
              this.words[pe] = this.words[pe + Fr];
          else
            this.words[0] = 0, this.length = 1;
        var it = 0;
        for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
          var xa = this.words[pe] | 0;
          this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
        }
        return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, le.prototype.ishrn = function(fe, be, ye) {
        return ne(this.negative === 0), this.iushrn(fe, be, ye);
      }, le.prototype.shln = function(fe) {
        return this.clone().ishln(fe);
      }, le.prototype.ushln = function(fe) {
        return this.clone().iushln(fe);
      }, le.prototype.shrn = function(fe) {
        return this.clone().ishrn(fe);
      }, le.prototype.ushrn = function(fe) {
        return this.clone().iushrn(fe);
      }, le.prototype.testn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return !1;
        var Oe = this.words[ye];
        return !!(Oe & Se);
      }, le.prototype.imaskn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26;
        if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
          return this;
        if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
          var Se = 67108863 ^ 67108863 >>> be << be;
          this.words[this.length - 1] &= Se;
        }
        return this.strip();
      }, le.prototype.maskn = function(fe) {
        return this.clone().imaskn(fe);
      }, le.prototype.iaddn = function(fe) {
        return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
      }, le.prototype._iaddn = function(fe) {
        this.words[0] += fe;
        for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
          this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
        return this.length = Math.max(this.length, be + 1), this;
      }, le.prototype.isubn = function(fe) {
        if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
          return this.iaddn(-fe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
        if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var be = 0; be < this.length && this.words[be] < 0; be++)
            this.words[be] += 67108864, this.words[be + 1] -= 1;
        return this.strip();
      }, le.prototype.addn = function(fe) {
        return this.clone().iaddn(fe);
      }, le.prototype.subn = function(fe) {
        return this.clone().isubn(fe);
      }, le.prototype.iabs = function() {
        return this.negative = 0, this;
      }, le.prototype.abs = function() {
        return this.clone().iabs();
      }, le.prototype._ishlnsubmul = function(fe, be, ye) {
        var Se = fe.length + ye, Oe;
        this._expand(Se);
        var Fr, zn = 0;
        for (Oe = 0; Oe < fe.length; Oe++) {
          Fr = (this.words[Oe + ye] | 0) + zn;
          var Fe = (fe.words[Oe] | 0) * be;
          Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
        }
        for (; Oe < this.length - ye; Oe++)
          Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
        if (zn === 0)
          return this.strip();
        for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
          Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
        return this.negative = 1, this.strip();
      }, le.prototype._wordDiv = function(fe, be) {
        var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
        ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
        var Fe = Se.length - Oe.length, pe;
        if (be !== "mod") {
          pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
          for (var it = 0; it < pe.length; it++)
            pe.words[it] = 0;
        }
        var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
        xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
        for (var wo = Fe - 1; wo >= 0; wo--) {
          var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
          for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
            _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
          pe && (pe.words[wo] = _u);
        }
        return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
          div: pe || null,
          mod: Se
        };
      }, le.prototype.divmod = function(fe, be, ye) {
        if (ne(!fe.isZero()), this.isZero())
          return {
            div: new le(0),
            mod: new le(0)
          };
        var Se, Oe, Fr;
        return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
          div: Se,
          mod: Oe
        }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
          div: Se,
          mod: Fr.mod
        }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
          div: Fr.div,
          mod: Oe
        }) : fe.length > this.length || this.cmp(fe) < 0 ? {
          div: new le(0),
          mod: this
        } : fe.length === 1 ? be === "div" ? {
          div: this.divn(fe.words[0]),
          mod: null
        } : be === "mod" ? {
          div: null,
          mod: new le(this.modn(fe.words[0]))
        } : {
          div: this.divn(fe.words[0]),
          mod: new le(this.modn(fe.words[0]))
        } : this._wordDiv(fe, be);
      }, le.prototype.div = function(fe) {
        return this.divmod(fe, "div", !1).div;
      }, le.prototype.mod = function(fe) {
        return this.divmod(fe, "mod", !1).mod;
      }, le.prototype.umod = function(fe) {
        return this.divmod(fe, "mod", !0).mod;
      }, le.prototype.divRound = function(fe) {
        var be = this.divmod(fe);
        if (be.mod.isZero())
          return be.div;
        var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
        return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
      }, le.prototype.modn = function(fe) {
        ne(fe <= 67108863);
        for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
          ye = (be * ye + (this.words[Se] | 0)) % fe;
        return ye;
      }, le.prototype.idivn = function(fe) {
        ne(fe <= 67108863);
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = (this.words[ye] | 0) + be * 67108864;
          this.words[ye] = Se / fe | 0, be = Se % fe;
        }
        return this.strip();
      }, le.prototype.divn = function(fe) {
        return this.clone().idivn(fe);
      }, le.prototype.egcd = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
          be.iushrn(1), ye.iushrn(1), ++Fe;
        for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
          for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
            ;
          if (xa > 0)
            for (be.iushrn(xa); xa-- > 0; )
              (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
          for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
            ;
          if (_u > 0)
            for (ye.iushrn(_u); _u-- > 0; )
              (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
        }
        return {
          a: Fr,
          b: zn,
          gcd: ye.iushln(Fe)
        };
      }, le.prototype._invmp = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
          for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
            ;
          if (zn > 0)
            for (be.iushrn(zn); zn-- > 0; )
              Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
          for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
            ;
          if (pe > 0)
            for (ye.iushrn(pe); pe-- > 0; )
              Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
        }
        var xa;
        return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
      }, le.prototype.gcd = function(fe) {
        if (this.isZero())
          return fe.abs();
        if (fe.isZero())
          return this.abs();
        var be = this.clone(), ye = fe.clone();
        be.negative = 0, ye.negative = 0;
        for (var Se = 0; be.isEven() && ye.isEven(); Se++)
          be.iushrn(1), ye.iushrn(1);
        do {
          for (; be.isEven(); )
            be.iushrn(1);
          for (; ye.isEven(); )
            ye.iushrn(1);
          var Oe = be.cmp(ye);
          if (Oe < 0) {
            var Fr = be;
            be = ye, ye = Fr;
          } else if (Oe === 0 || ye.cmpn(1) === 0)
            break;
          be.isub(ye);
        } while (!0);
        return ye.iushln(Se);
      }, le.prototype.invm = function(fe) {
        return this.egcd(fe).a.umod(fe);
      }, le.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, le.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, le.prototype.andln = function(fe) {
        return this.words[0] & fe;
      }, le.prototype.bincn = function(fe) {
        ne(typeof fe == "number");
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return this._expand(ye + 1), this.words[ye] |= Se, this;
        for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
          var zn = this.words[Fr] | 0;
          zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
        }
        return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
      }, le.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, le.prototype.cmpn = function(fe) {
        var be = fe < 0;
        if (this.negative !== 0 && !be)
          return -1;
        if (this.negative === 0 && be)
          return 1;
        this.strip();
        var ye;
        if (this.length > 1)
          ye = 1;
        else {
          be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
          var Se = this.words[0] | 0;
          ye = Se === fe ? 0 : Se < fe ? -1 : 1;
        }
        return this.negative !== 0 ? -ye | 0 : ye;
      }, le.prototype.cmp = function(fe) {
        if (this.negative !== 0 && fe.negative === 0)
          return -1;
        if (this.negative === 0 && fe.negative !== 0)
          return 1;
        var be = this.ucmp(fe);
        return this.negative !== 0 ? -be | 0 : be;
      }, le.prototype.ucmp = function(fe) {
        if (this.length > fe.length)
          return 1;
        if (this.length < fe.length)
          return -1;
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
          if (Se !== Oe) {
            Se < Oe ? be = -1 : Se > Oe && (be = 1);
            break;
          }
        }
        return be;
      }, le.prototype.gtn = function(fe) {
        return this.cmpn(fe) === 1;
      }, le.prototype.gt = function(fe) {
        return this.cmp(fe) === 1;
      }, le.prototype.gten = function(fe) {
        return this.cmpn(fe) >= 0;
      }, le.prototype.gte = function(fe) {
        return this.cmp(fe) >= 0;
      }, le.prototype.ltn = function(fe) {
        return this.cmpn(fe) === -1;
      }, le.prototype.lt = function(fe) {
        return this.cmp(fe) === -1;
      }, le.prototype.lten = function(fe) {
        return this.cmpn(fe) <= 0;
      }, le.prototype.lte = function(fe) {
        return this.cmp(fe) <= 0;
      }, le.prototype.eqn = function(fe) {
        return this.cmpn(fe) === 0;
      }, le.prototype.eq = function(fe) {
        return this.cmp(fe) === 0;
      }, le.red = function(fe) {
        return new Yn(fe);
      }, le.prototype.toRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
      }, le.prototype.fromRed = function() {
        return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, le.prototype._forceRed = function(fe) {
        return this.red = fe, this;
      }, le.prototype.forceRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
      }, le.prototype.redAdd = function(fe) {
        return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
      }, le.prototype.redIAdd = function(fe) {
        return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
      }, le.prototype.redSub = function(fe) {
        return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
      }, le.prototype.redISub = function(fe) {
        return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
      }, le.prototype.redShl = function(fe) {
        return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
      }, le.prototype.redMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
      }, le.prototype.redIMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
      }, le.prototype.redSqr = function() {
        return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, le.prototype.redISqr = function() {
        return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, le.prototype.redSqrt = function() {
        return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, le.prototype.redInvm = function() {
        return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, le.prototype.redNeg = function() {
        return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, le.prototype.redPow = function(fe) {
        return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
      };
      var wa = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Aa(ct, fe) {
        this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Aa.prototype._tmp = function() {
        var fe = new le(null);
        return fe.words = new Array(Math.ceil(this.n / 13)), fe;
      }, Aa.prototype.ireduce = function(fe) {
        var be = fe, ye;
        do
          this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
        while (ye > this.n);
        var Se = ye < this.n ? -1 : be.ucmp(this.p);
        return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
      }, Aa.prototype.split = function(fe, be) {
        fe.iushrn(this.n, 0, be);
      }, Aa.prototype.imulK = function(fe) {
        return fe.imul(this.k);
      };
      function _a() {
        Aa.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      ue(_a, Aa), _a.prototype.split = function(fe, be) {
        for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
          be.words[Oe] = fe.words[Oe];
        if (be.length = Se, fe.length <= 9) {
          fe.words[0] = 0, fe.length = 1;
          return;
        }
        var Fr = fe.words[9];
        for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
          var zn = fe.words[Oe] | 0;
          fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
        }
        Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
      }, _a.prototype.imulK = function(fe) {
        fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = fe.words[ye] | 0;
          be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
        }
        return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
      };
      function Ta() {
        Aa.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      ue(Ta, Aa);
      function Zn() {
        Aa.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      ue(Zn, Aa);
      function Ra() {
        Aa.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
          Se >>>= 26, fe.words[ye] = Oe, be = Se;
        }
        return be !== 0 && (fe.words[fe.length++] = be), fe;
      }, le._prime = function(fe) {
        if (wa[fe])
          return wa[fe];
        var be;
        if (fe === "k256")
          be = new _a();
        else if (fe === "p224")
          be = new Ta();
        else if (fe === "p192")
          be = new Zn();
        else if (fe === "p25519")
          be = new Ra();
        else
          throw new Error("Unknown prime " + fe);
        return wa[fe] = be, be;
      };
      function Yn(ct) {
        if (typeof ct == "string") {
          var fe = le._prime(ct);
          this.m = fe.p, this.prime = fe;
        } else
          ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
      }
      Yn.prototype._verify1 = function(fe) {
        ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
      }, Yn.prototype._verify2 = function(fe, be) {
        ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
          fe.red && fe.red === be.red,
          "red works only with red numbers"
        );
      }, Yn.prototype.imod = function(fe) {
        return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
      }, Yn.prototype.neg = function(fe) {
        return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
      }, Yn.prototype.add = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.add(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
      }, Yn.prototype.iadd = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.iadd(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
      }, Yn.prototype.sub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.sub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
      }, Yn.prototype.isub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.isub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
      }, Yn.prototype.shl = function(fe, be) {
        return this._verify1(fe), this.imod(fe.ushln(be));
      }, Yn.prototype.imul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.imul(be));
      }, Yn.prototype.mul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.mul(be));
      }, Yn.prototype.isqr = function(fe) {
        return this.imul(fe, fe.clone());
      }, Yn.prototype.sqr = function(fe) {
        return this.mul(fe, fe);
      }, Yn.prototype.sqrt = function(fe) {
        if (fe.isZero())
          return fe.clone();
        var be = this.m.andln(3);
        if (ne(be % 2 === 1), be === 3) {
          var ye = this.m.add(new le(1)).iushrn(2);
          return this.pow(fe, ye);
        }
        for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
          Oe++, Se.iushrn(1);
        ne(!Se.isZero());
        var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
        for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
          pe.redIAdd(zn);
        for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
          for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
            Oa = Oa.redSqr();
          ne(Os < _u);
          var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
          xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
        }
        return xa;
      }, Yn.prototype.invm = function(fe) {
        var be = fe._invmp(this.m);
        return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
      }, Yn.prototype.pow = function(fe, be) {
        if (be.isZero())
          return new le(1).toRed(this);
        if (be.cmpn(1) === 0)
          return fe.clone();
        var ye = 4, Se = new Array(1 << ye);
        Se[0] = new le(1).toRed(this), Se[1] = fe;
        for (var Oe = 2; Oe < Se.length; Oe++)
          Se[Oe] = this.mul(Se[Oe - 1], fe);
        var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
        for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
          for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
            var wo = it >> xa & 1;
            if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
              Fe = 0;
              continue;
            }
            zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
          }
          pe = 26;
        }
        return Fr;
      }, Yn.prototype.convertTo = function(fe) {
        var be = fe.umod(this.m);
        return be === fe ? be.clone() : be;
      }, Yn.prototype.convertFrom = function(fe) {
        var be = fe.clone();
        return be.red = null, be;
      }, le.mont = function(fe) {
        return new $o(fe);
      };
      function $o(ct) {
        Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      ue($o, Yn), $o.prototype.convertTo = function(fe) {
        return this.imod(fe.ushln(this.shift));
      }, $o.prototype.convertFrom = function(fe) {
        var be = this.imod(fe.mul(this.rinv));
        return be.red = null, be;
      }, $o.prototype.imul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return fe.words[0] = 0, fe.length = 1, fe;
        var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.mul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return new le(0)._forceRed(this);
        var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.invm = function(fe) {
        var be = this.imod(fe._invmp(this.m).mul(this.r2));
        return be._forceRed(this);
      };
    })(v, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var browser$3, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2)
    return browser$3;
  hasRequiredBrowser$2 = 1;
  var v = requireElliptic(), y = requireBn$1();
  browser$3 = function(he) {
    return new ne(he);
  };
  var z = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  z.p224 = z.secp224r1, z.p256 = z.secp256r1 = z.prime256v1, z.p192 = z.secp192r1 = z.prime192v1, z.p384 = z.secp384r1, z.p521 = z.secp521r1;
  function ne(le) {
    this.curveType = z[le], this.curveType || (this.curveType = {
      name: le
    }), this.curve = new v.ec(this.curveType.name), this.keys = void 0;
  }
  ne.prototype.generateKeys = function(le, he) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(le, he);
  }, ne.prototype.computeSecret = function(le, he, ge) {
    he = he || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, he));
    var we = this.curve.keyFromPublic(le).getPublic(), Ee = we.mul(this.keys.getPrivate()).getX();
    return ue(Ee, ge, this.curveType.byteLength);
  }, ne.prototype.getPublicKey = function(le, he) {
    var ge = this.keys.getPublic(he === "compressed", !0);
    return he === "hybrid" && (ge[ge.length - 1] % 2 ? ge[0] = 7 : ge[0] = 6), ue(ge, le);
  }, ne.prototype.getPrivateKey = function(le) {
    return ue(this.keys.getPrivate(), le);
  }, ne.prototype.setPublicKey = function(le, he) {
    return he = he || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, he)), this.keys._importPublic(le), this;
  }, ne.prototype.setPrivateKey = function(le, he) {
    he = he || "utf8", Buffer.isBuffer(le) || (le = new Buffer(le, he));
    var ge = new y(le);
    return ge = ge.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(ge), this;
  };
  function ue(le, he, ge) {
    Array.isArray(le) || (le = le.toArray());
    var we = new Buffer(le);
    if (ge && we.length < ge) {
      var Ee = new Buffer(ge - we.length);
      Ee.fill(0), we = Buffer.concat([Ee, we]);
    }
    return he ? we.toString(he) : we;
  }
  return browser$3;
}
var browser$2 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf)
    return mgf;
  hasRequiredMgf = 1;
  var v = requireBrowser$9(), y = requireSafeBuffer$2().Buffer;
  mgf = function(ne, ue) {
    for (var le = y.alloc(0), he = 0, ge; le.length < ue; )
      ge = z(he++), le = y.concat([le, v("sha1").update(ne).update(ge).digest()]);
    return le.slice(0, ue);
  };
  function z(ne) {
    var ue = y.allocUnsafe(4);
    return ue.writeUInt32BE(ne, 0), ue;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(y, z) {
    for (var ne = y.length, ue = -1; ++ue < ne; )
      y[ue] ^= z[ue];
    return y;
  }), xor;
}
var bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(v) {
    (function(y, z) {
      function ne(ct, fe) {
        if (!ct)
          throw new Error(fe || "Assertion failed");
      }
      function ue(ct, fe) {
        ct.super_ = fe;
        var be = function() {
        };
        be.prototype = fe.prototype, ct.prototype = new be(), ct.prototype.constructor = ct;
      }
      function le(ct, fe, be) {
        if (le.isBN(ct))
          return ct;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ct !== null && ((fe === "le" || fe === "be") && (be = fe, fe = 10), this._init(ct || 0, fe || 10, be || "be"));
      }
      typeof y == "object" ? y.exports = le : z.BN = le, le.BN = le, le.wordSize = 26;
      var he;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? he = window.Buffer : he = require$$0$3.Buffer;
      } catch {
      }
      le.isBN = function(fe) {
        return fe instanceof le ? !0 : fe !== null && typeof fe == "object" && fe.constructor.wordSize === le.wordSize && Array.isArray(fe.words);
      }, le.max = function(fe, be) {
        return fe.cmp(be) > 0 ? fe : be;
      }, le.min = function(fe, be) {
        return fe.cmp(be) < 0 ? fe : be;
      }, le.prototype._init = function(fe, be, ye) {
        if (typeof fe == "number")
          return this._initNumber(fe, be, ye);
        if (typeof fe == "object")
          return this._initArray(fe, be, ye);
        be === "hex" && (be = 16), ne(be === (be | 0) && be >= 2 && be <= 36), fe = fe.toString().replace(/\s+/g, "");
        var Se = 0;
        fe[0] === "-" && (Se++, this.negative = 1), Se < fe.length && (be === 16 ? this._parseHex(fe, Se, ye) : (this._parseBase(fe, be, Se), ye === "le" && this._initArray(this.toArray(), be, ye)));
      }, le.prototype._initNumber = function(fe, be, ye) {
        fe < 0 && (this.negative = 1, fe = -fe), fe < 67108864 ? (this.words = [fe & 67108863], this.length = 1) : fe < 4503599627370496 ? (this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863
        ], this.length = 2) : (ne(fe < 9007199254740992), this.words = [
          fe & 67108863,
          fe / 67108864 & 67108863,
          1
        ], this.length = 3), ye === "le" && this._initArray(this.toArray(), be, ye);
      }, le.prototype._initArray = function(fe, be, ye) {
        if (ne(typeof fe.length == "number"), fe.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(fe.length / 3), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe, Fr, zn = 0;
        if (ye === "be")
          for (Se = fe.length - 1, Oe = 0; Se >= 0; Se -= 3)
            Fr = fe[Se] | fe[Se - 1] << 8 | fe[Se - 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        else if (ye === "le")
          for (Se = 0, Oe = 0; Se < fe.length; Se += 3)
            Fr = fe[Se] | fe[Se + 1] << 8 | fe[Se + 2] << 16, this.words[Oe] |= Fr << zn & 67108863, this.words[Oe + 1] = Fr >>> 26 - zn & 67108863, zn += 24, zn >= 26 && (zn -= 26, Oe++);
        return this.strip();
      };
      function ge(ct, fe) {
        var be = ct.charCodeAt(fe);
        return be >= 65 && be <= 70 ? be - 55 : be >= 97 && be <= 102 ? be - 87 : be - 48 & 15;
      }
      function we(ct, fe, be) {
        var ye = ge(ct, be);
        return be - 1 >= fe && (ye |= ge(ct, be - 1) << 4), ye;
      }
      le.prototype._parseHex = function(fe, be, ye) {
        this.length = Math.ceil((fe.length - be) / 6), this.words = new Array(this.length);
        for (var Se = 0; Se < this.length; Se++)
          this.words[Se] = 0;
        var Oe = 0, Fr = 0, zn;
        if (ye === "be")
          for (Se = fe.length - 1; Se >= be; Se -= 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        else {
          var Fe = fe.length - be;
          for (Se = Fe % 2 === 0 ? be + 1 : be; Se < fe.length; Se += 2)
            zn = we(fe, be, Se) << Oe, this.words[Fr] |= zn & 67108863, Oe >= 18 ? (Oe -= 18, Fr += 1, this.words[Fr] |= zn >>> 26) : Oe += 8;
        }
        this.strip();
      };
      function Ee(ct, fe, be, ye) {
        for (var Se = 0, Oe = Math.min(ct.length, be), Fr = fe; Fr < Oe; Fr++) {
          var zn = ct.charCodeAt(Fr) - 48;
          Se *= ye, zn >= 49 ? Se += zn - 49 + 10 : zn >= 17 ? Se += zn - 17 + 10 : Se += zn;
        }
        return Se;
      }
      le.prototype._parseBase = function(fe, be, ye) {
        this.words = [0], this.length = 1;
        for (var Se = 0, Oe = 1; Oe <= 67108863; Oe *= be)
          Se++;
        Se--, Oe = Oe / be | 0;
        for (var Fr = fe.length - ye, zn = Fr % Se, Fe = Math.min(Fr, Fr - zn) + ye, pe = 0, it = ye; it < Fe; it += Se)
          pe = Ee(fe, it, it + Se, be), this.imuln(Oe), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        if (zn !== 0) {
          var xa = 1;
          for (pe = Ee(fe, it, fe.length, be), it = 0; it < zn; it++)
            xa *= be;
          this.imuln(xa), this.words[0] + pe < 67108864 ? this.words[0] += pe : this._iaddn(pe);
        }
        this.strip();
      }, le.prototype.copy = function(fe) {
        fe.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          fe.words[be] = this.words[be];
        fe.length = this.length, fe.negative = this.negative, fe.red = this.red;
      }, le.prototype.clone = function() {
        var fe = new le(null);
        return this.copy(fe), fe;
      }, le.prototype._expand = function(fe) {
        for (; this.length < fe; )
          this.words[this.length++] = 0;
        return this;
      }, le.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, le.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, le.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var xe = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], $e = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], Ne = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      le.prototype.toString = function(fe, be) {
        fe = fe || 10, be = be | 0 || 1;
        var ye;
        if (fe === 16 || fe === "hex") {
          ye = "";
          for (var Se = 0, Oe = 0, Fr = 0; Fr < this.length; Fr++) {
            var zn = this.words[Fr], Fe = ((zn << Se | Oe) & 16777215).toString(16);
            Oe = zn >>> 24 - Se & 16777215, Oe !== 0 || Fr !== this.length - 1 ? ye = xe[6 - Fe.length] + Fe + ye : ye = Fe + ye, Se += 2, Se >= 26 && (Se -= 26, Fr--);
          }
          for (Oe !== 0 && (ye = Oe.toString(16) + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        if (fe === (fe | 0) && fe >= 2 && fe <= 36) {
          var pe = $e[fe], it = Ne[fe];
          ye = "";
          var xa = this.clone();
          for (xa.negative = 0; !xa.isZero(); ) {
            var wo = xa.modn(it).toString(fe);
            xa = xa.idivn(it), xa.isZero() ? ye = wo + ye : ye = xe[pe - wo.length] + wo + ye;
          }
          for (this.isZero() && (ye = "0" + ye); ye.length % be !== 0; )
            ye = "0" + ye;
          return this.negative !== 0 && (ye = "-" + ye), ye;
        }
        ne(!1, "Base should be between 2 and 36");
      }, le.prototype.toNumber = function() {
        var fe = this.words[0];
        return this.length === 2 ? fe += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? fe += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && ne(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -fe : fe;
      }, le.prototype.toJSON = function() {
        return this.toString(16);
      }, le.prototype.toBuffer = function(fe, be) {
        return ne(typeof he < "u"), this.toArrayLike(he, fe, be);
      }, le.prototype.toArray = function(fe, be) {
        return this.toArrayLike(Array, fe, be);
      }, le.prototype.toArrayLike = function(fe, be, ye) {
        var Se = this.byteLength(), Oe = ye || Math.max(1, Se);
        ne(Se <= Oe, "byte array longer than desired length"), ne(Oe > 0, "Requested array length <= 0"), this.strip();
        var Fr = be === "le", zn = new fe(Oe), Fe, pe, it = this.clone();
        if (Fr) {
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[pe] = Fe;
          for (; pe < Oe; pe++)
            zn[pe] = 0;
        } else {
          for (pe = 0; pe < Oe - Se; pe++)
            zn[pe] = 0;
          for (pe = 0; !it.isZero(); pe++)
            Fe = it.andln(255), it.iushrn(8), zn[Oe - pe - 1] = Fe;
        }
        return zn;
      }, Math.clz32 ? le.prototype._countBits = function(fe) {
        return 32 - Math.clz32(fe);
      } : le.prototype._countBits = function(fe) {
        var be = fe, ye = 0;
        return be >= 4096 && (ye += 13, be >>>= 13), be >= 64 && (ye += 7, be >>>= 7), be >= 8 && (ye += 4, be >>>= 4), be >= 2 && (ye += 2, be >>>= 2), ye + be;
      }, le.prototype._zeroBits = function(fe) {
        if (fe === 0)
          return 26;
        var be = fe, ye = 0;
        return be & 8191 || (ye += 13, be >>>= 13), be & 127 || (ye += 7, be >>>= 7), be & 15 || (ye += 4, be >>>= 4), be & 3 || (ye += 2, be >>>= 2), be & 1 || ye++, ye;
      }, le.prototype.bitLength = function() {
        var fe = this.words[this.length - 1], be = this._countBits(fe);
        return (this.length - 1) * 26 + be;
      };
      function st(ct) {
        for (var fe = new Array(ct.bitLength()), be = 0; be < fe.length; be++) {
          var ye = be / 26 | 0, Se = be % 26;
          fe[be] = (ct.words[ye] & 1 << Se) >>> Se;
        }
        return fe;
      }
      le.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var fe = 0, be = 0; be < this.length; be++) {
          var ye = this._zeroBits(this.words[be]);
          if (fe += ye, ye !== 26)
            break;
        }
        return fe;
      }, le.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, le.prototype.toTwos = function(fe) {
        return this.negative !== 0 ? this.abs().inotn(fe).iaddn(1) : this.clone();
      }, le.prototype.fromTwos = function(fe) {
        return this.testn(fe - 1) ? this.notn(fe).iaddn(1).ineg() : this.clone();
      }, le.prototype.isNeg = function() {
        return this.negative !== 0;
      }, le.prototype.neg = function() {
        return this.clone().ineg();
      }, le.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, le.prototype.iuor = function(fe) {
        for (; this.length < fe.length; )
          this.words[this.length++] = 0;
        for (var be = 0; be < fe.length; be++)
          this.words[be] = this.words[be] | fe.words[be];
        return this.strip();
      }, le.prototype.ior = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuor(fe);
      }, le.prototype.or = function(fe) {
        return this.length > fe.length ? this.clone().ior(fe) : fe.clone().ior(this);
      }, le.prototype.uor = function(fe) {
        return this.length > fe.length ? this.clone().iuor(fe) : fe.clone().iuor(this);
      }, le.prototype.iuand = function(fe) {
        var be;
        this.length > fe.length ? be = fe : be = this;
        for (var ye = 0; ye < be.length; ye++)
          this.words[ye] = this.words[ye] & fe.words[ye];
        return this.length = be.length, this.strip();
      }, le.prototype.iand = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuand(fe);
      }, le.prototype.and = function(fe) {
        return this.length > fe.length ? this.clone().iand(fe) : fe.clone().iand(this);
      }, le.prototype.uand = function(fe) {
        return this.length > fe.length ? this.clone().iuand(fe) : fe.clone().iuand(this);
      }, le.prototype.iuxor = function(fe) {
        var be, ye;
        this.length > fe.length ? (be = this, ye = fe) : (be = fe, ye = this);
        for (var Se = 0; Se < ye.length; Se++)
          this.words[Se] = be.words[Se] ^ ye.words[Se];
        if (this !== be)
          for (; Se < be.length; Se++)
            this.words[Se] = be.words[Se];
        return this.length = be.length, this.strip();
      }, le.prototype.ixor = function(fe) {
        return ne((this.negative | fe.negative) === 0), this.iuxor(fe);
      }, le.prototype.xor = function(fe) {
        return this.length > fe.length ? this.clone().ixor(fe) : fe.clone().ixor(this);
      }, le.prototype.uxor = function(fe) {
        return this.length > fe.length ? this.clone().iuxor(fe) : fe.clone().iuxor(this);
      }, le.prototype.inotn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = Math.ceil(fe / 26) | 0, ye = fe % 26;
        this._expand(be), ye > 0 && be--;
        for (var Se = 0; Se < be; Se++)
          this.words[Se] = ~this.words[Se] & 67108863;
        return ye > 0 && (this.words[Se] = ~this.words[Se] & 67108863 >> 26 - ye), this.strip();
      }, le.prototype.notn = function(fe) {
        return this.clone().inotn(fe);
      }, le.prototype.setn = function(fe, be) {
        ne(typeof fe == "number" && fe >= 0);
        var ye = fe / 26 | 0, Se = fe % 26;
        return this._expand(ye + 1), be ? this.words[ye] = this.words[ye] | 1 << Se : this.words[ye] = this.words[ye] & ~(1 << Se), this.strip();
      }, le.prototype.iadd = function(fe) {
        var be;
        if (this.negative !== 0 && fe.negative === 0)
          return this.negative = 0, be = this.isub(fe), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && fe.negative !== 0)
          return fe.negative = 0, be = this.isub(fe), fe.negative = 1, be._normSign();
        var ye, Se;
        this.length > fe.length ? (ye = this, Se = fe) : (ye = fe, Se = this);
        for (var Oe = 0, Fr = 0; Fr < Se.length; Fr++)
          be = (ye.words[Fr] | 0) + (Se.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        for (; Oe !== 0 && Fr < ye.length; Fr++)
          be = (ye.words[Fr] | 0) + Oe, this.words[Fr] = be & 67108863, Oe = be >>> 26;
        if (this.length = ye.length, Oe !== 0)
          this.words[this.length] = Oe, this.length++;
        else if (ye !== this)
          for (; Fr < ye.length; Fr++)
            this.words[Fr] = ye.words[Fr];
        return this;
      }, le.prototype.add = function(fe) {
        var be;
        return fe.negative !== 0 && this.negative === 0 ? (fe.negative = 0, be = this.sub(fe), fe.negative ^= 1, be) : fe.negative === 0 && this.negative !== 0 ? (this.negative = 0, be = fe.sub(this), this.negative = 1, be) : this.length > fe.length ? this.clone().iadd(fe) : fe.clone().iadd(this);
      }, le.prototype.isub = function(fe) {
        if (fe.negative !== 0) {
          fe.negative = 0;
          var be = this.iadd(fe);
          return fe.negative = 1, be._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(fe), this.negative = 1, this._normSign();
        var ye = this.cmp(fe);
        if (ye === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Se, Oe;
        ye > 0 ? (Se = this, Oe = fe) : (Se = fe, Oe = this);
        for (var Fr = 0, zn = 0; zn < Oe.length; zn++)
          be = (Se.words[zn] | 0) - (Oe.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        for (; Fr !== 0 && zn < Se.length; zn++)
          be = (Se.words[zn] | 0) + Fr, Fr = be >> 26, this.words[zn] = be & 67108863;
        if (Fr === 0 && zn < Se.length && Se !== this)
          for (; zn < Se.length; zn++)
            this.words[zn] = Se.words[zn];
        return this.length = Math.max(this.length, zn), Se !== this && (this.negative = 1), this.strip();
      }, le.prototype.sub = function(fe) {
        return this.clone().isub(fe);
      };
      function Nr(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative;
        var ye = ct.length + fe.length | 0;
        be.length = ye, ye = ye - 1 | 0;
        var Se = ct.words[0] | 0, Oe = fe.words[0] | 0, Fr = Se * Oe, zn = Fr & 67108863, Fe = Fr / 67108864 | 0;
        be.words[0] = zn;
        for (var pe = 1; pe < ye; pe++) {
          for (var it = Fe >>> 26, xa = Fe & 67108863, wo = Math.min(pe, fe.length - 1), _u = Math.max(0, pe - ct.length + 1); _u <= wo; _u++) {
            var Oa = pe - _u | 0;
            Se = ct.words[Oa] | 0, Oe = fe.words[_u] | 0, Fr = Se * Oe + xa, it += Fr / 67108864 | 0, xa = Fr & 67108863;
          }
          be.words[pe] = xa | 0, Fe = it | 0;
        }
        return Fe !== 0 ? be.words[pe] = Fe | 0 : be.length--, be.strip();
      }
      var br = function(fe, be, ye) {
        var Se = fe.words, Oe = be.words, Fr = ye.words, zn = 0, Fe, pe, it, xa = Se[0] | 0, wo = xa & 8191, _u = xa >>> 13, Oa = Se[1] | 0, Os = Oa & 8191, Pa = Oa >>> 13, Ml = Se[2] | 0, Su = Ml & 8191, Tu = Ml >>> 13, Au = Se[3] | 0, Zl = Au & 8191, Iu = Au >>> 13, Uc = Se[4] | 0, Pu = Uc & 8191, Lu = Uc >>> 13, th = Se[5] | 0, Zc = th & 8191, N1 = th >>> 13, Gh = Se[6] | 0, Mc = Gh & 8191, h1 = Gh >>> 13, l2 = Se[7] | 0, Gc = l2 & 8191, Kc = l2 >>> 13, M2 = Se[8] | 0, d1 = M2 & 8191, K1 = M2 >>> 13, k2 = Se[9] | 0, Eu = k2 & 8191, Zo = k2 >>> 13, Fl = Oe[0] | 0, Ru = Fl & 8191, ku = Fl >>> 13, kc = Oe[1] | 0, Ou = kc & 8191, U1 = kc >>> 13, g2 = Oe[2] | 0, Ic = g2 & 8191, X1 = g2 >>> 13, $2 = Oe[3] | 0, ah = $2 & 8191, O1 = $2 >>> 13, T2 = Oe[4] | 0, ih = T2 & 8191, oh = T2 >>> 13, j2 = Oe[5] | 0, lh = j2 & 8191, kh = j2 >>> 13, P2 = Oe[6] | 0, ch = P2 & 8191, Nh = P2 >>> 13, L2 = Oe[7] | 0, yh = L2 & 8191, Dh = L2 >>> 13, F2 = Oe[8] | 0, Mu = F2 & 8191, Du = F2 >>> 13, eh = Oe[9] | 0, Nc = eh & 8191, z1 = eh >>> 13;
        ye.negative = fe.negative ^ be.negative, ye.length = 19, Fe = Math.imul(wo, Ru), pe = Math.imul(wo, ku), pe = pe + Math.imul(_u, Ru) | 0, it = Math.imul(_u, ku);
        var A2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (A2 >>> 26) | 0, A2 &= 67108863, Fe = Math.imul(Os, Ru), pe = Math.imul(Os, ku), pe = pe + Math.imul(Pa, Ru) | 0, it = Math.imul(Pa, ku), Fe = Fe + Math.imul(wo, Ou) | 0, pe = pe + Math.imul(wo, U1) | 0, pe = pe + Math.imul(_u, Ou) | 0, it = it + Math.imul(_u, U1) | 0;
        var b2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (b2 >>> 26) | 0, b2 &= 67108863, Fe = Math.imul(Su, Ru), pe = Math.imul(Su, ku), pe = pe + Math.imul(Tu, Ru) | 0, it = Math.imul(Tu, ku), Fe = Fe + Math.imul(Os, Ou) | 0, pe = pe + Math.imul(Os, U1) | 0, pe = pe + Math.imul(Pa, Ou) | 0, it = it + Math.imul(Pa, U1) | 0, Fe = Fe + Math.imul(wo, Ic) | 0, pe = pe + Math.imul(wo, X1) | 0, pe = pe + Math.imul(_u, Ic) | 0, it = it + Math.imul(_u, X1) | 0;
        var R2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (R2 >>> 26) | 0, R2 &= 67108863, Fe = Math.imul(Zl, Ru), pe = Math.imul(Zl, ku), pe = pe + Math.imul(Iu, Ru) | 0, it = Math.imul(Iu, ku), Fe = Fe + Math.imul(Su, Ou) | 0, pe = pe + Math.imul(Su, U1) | 0, pe = pe + Math.imul(Tu, Ou) | 0, it = it + Math.imul(Tu, U1) | 0, Fe = Fe + Math.imul(Os, Ic) | 0, pe = pe + Math.imul(Os, X1) | 0, pe = pe + Math.imul(Pa, Ic) | 0, it = it + Math.imul(Pa, X1) | 0, Fe = Fe + Math.imul(wo, ah) | 0, pe = pe + Math.imul(wo, O1) | 0, pe = pe + Math.imul(_u, ah) | 0, it = it + Math.imul(_u, O1) | 0;
        var D2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (D2 >>> 26) | 0, D2 &= 67108863, Fe = Math.imul(Pu, Ru), pe = Math.imul(Pu, ku), pe = pe + Math.imul(Lu, Ru) | 0, it = Math.imul(Lu, ku), Fe = Fe + Math.imul(Zl, Ou) | 0, pe = pe + Math.imul(Zl, U1) | 0, pe = pe + Math.imul(Iu, Ou) | 0, it = it + Math.imul(Iu, U1) | 0, Fe = Fe + Math.imul(Su, Ic) | 0, pe = pe + Math.imul(Su, X1) | 0, pe = pe + Math.imul(Tu, Ic) | 0, it = it + Math.imul(Tu, X1) | 0, Fe = Fe + Math.imul(Os, ah) | 0, pe = pe + Math.imul(Os, O1) | 0, pe = pe + Math.imul(Pa, ah) | 0, it = it + Math.imul(Pa, O1) | 0, Fe = Fe + Math.imul(wo, ih) | 0, pe = pe + Math.imul(wo, oh) | 0, pe = pe + Math.imul(_u, ih) | 0, it = it + Math.imul(_u, oh) | 0;
        var I2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (I2 >>> 26) | 0, I2 &= 67108863, Fe = Math.imul(Zc, Ru), pe = Math.imul(Zc, ku), pe = pe + Math.imul(N1, Ru) | 0, it = Math.imul(N1, ku), Fe = Fe + Math.imul(Pu, Ou) | 0, pe = pe + Math.imul(Pu, U1) | 0, pe = pe + Math.imul(Lu, Ou) | 0, it = it + Math.imul(Lu, U1) | 0, Fe = Fe + Math.imul(Zl, Ic) | 0, pe = pe + Math.imul(Zl, X1) | 0, pe = pe + Math.imul(Iu, Ic) | 0, it = it + Math.imul(Iu, X1) | 0, Fe = Fe + Math.imul(Su, ah) | 0, pe = pe + Math.imul(Su, O1) | 0, pe = pe + Math.imul(Tu, ah) | 0, it = it + Math.imul(Tu, O1) | 0, Fe = Fe + Math.imul(Os, ih) | 0, pe = pe + Math.imul(Os, oh) | 0, pe = pe + Math.imul(Pa, ih) | 0, it = it + Math.imul(Pa, oh) | 0, Fe = Fe + Math.imul(wo, lh) | 0, pe = pe + Math.imul(wo, kh) | 0, pe = pe + Math.imul(_u, lh) | 0, it = it + Math.imul(_u, kh) | 0;
        var N2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (N2 >>> 26) | 0, N2 &= 67108863, Fe = Math.imul(Mc, Ru), pe = Math.imul(Mc, ku), pe = pe + Math.imul(h1, Ru) | 0, it = Math.imul(h1, ku), Fe = Fe + Math.imul(Zc, Ou) | 0, pe = pe + Math.imul(Zc, U1) | 0, pe = pe + Math.imul(N1, Ou) | 0, it = it + Math.imul(N1, U1) | 0, Fe = Fe + Math.imul(Pu, Ic) | 0, pe = pe + Math.imul(Pu, X1) | 0, pe = pe + Math.imul(Lu, Ic) | 0, it = it + Math.imul(Lu, X1) | 0, Fe = Fe + Math.imul(Zl, ah) | 0, pe = pe + Math.imul(Zl, O1) | 0, pe = pe + Math.imul(Iu, ah) | 0, it = it + Math.imul(Iu, O1) | 0, Fe = Fe + Math.imul(Su, ih) | 0, pe = pe + Math.imul(Su, oh) | 0, pe = pe + Math.imul(Tu, ih) | 0, it = it + Math.imul(Tu, oh) | 0, Fe = Fe + Math.imul(Os, lh) | 0, pe = pe + Math.imul(Os, kh) | 0, pe = pe + Math.imul(Pa, lh) | 0, it = it + Math.imul(Pa, kh) | 0, Fe = Fe + Math.imul(wo, ch) | 0, pe = pe + Math.imul(wo, Nh) | 0, pe = pe + Math.imul(_u, ch) | 0, it = it + Math.imul(_u, Nh) | 0;
        var B2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (B2 >>> 26) | 0, B2 &= 67108863, Fe = Math.imul(Gc, Ru), pe = Math.imul(Gc, ku), pe = pe + Math.imul(Kc, Ru) | 0, it = Math.imul(Kc, ku), Fe = Fe + Math.imul(Mc, Ou) | 0, pe = pe + Math.imul(Mc, U1) | 0, pe = pe + Math.imul(h1, Ou) | 0, it = it + Math.imul(h1, U1) | 0, Fe = Fe + Math.imul(Zc, Ic) | 0, pe = pe + Math.imul(Zc, X1) | 0, pe = pe + Math.imul(N1, Ic) | 0, it = it + Math.imul(N1, X1) | 0, Fe = Fe + Math.imul(Pu, ah) | 0, pe = pe + Math.imul(Pu, O1) | 0, pe = pe + Math.imul(Lu, ah) | 0, it = it + Math.imul(Lu, O1) | 0, Fe = Fe + Math.imul(Zl, ih) | 0, pe = pe + Math.imul(Zl, oh) | 0, pe = pe + Math.imul(Iu, ih) | 0, it = it + Math.imul(Iu, oh) | 0, Fe = Fe + Math.imul(Su, lh) | 0, pe = pe + Math.imul(Su, kh) | 0, pe = pe + Math.imul(Tu, lh) | 0, it = it + Math.imul(Tu, kh) | 0, Fe = Fe + Math.imul(Os, ch) | 0, pe = pe + Math.imul(Os, Nh) | 0, pe = pe + Math.imul(Pa, ch) | 0, it = it + Math.imul(Pa, Nh) | 0, Fe = Fe + Math.imul(wo, yh) | 0, pe = pe + Math.imul(wo, Dh) | 0, pe = pe + Math.imul(_u, yh) | 0, it = it + Math.imul(_u, Dh) | 0;
        var z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (z2 >>> 26) | 0, z2 &= 67108863, Fe = Math.imul(d1, Ru), pe = Math.imul(d1, ku), pe = pe + Math.imul(K1, Ru) | 0, it = Math.imul(K1, ku), Fe = Fe + Math.imul(Gc, Ou) | 0, pe = pe + Math.imul(Gc, U1) | 0, pe = pe + Math.imul(Kc, Ou) | 0, it = it + Math.imul(Kc, U1) | 0, Fe = Fe + Math.imul(Mc, Ic) | 0, pe = pe + Math.imul(Mc, X1) | 0, pe = pe + Math.imul(h1, Ic) | 0, it = it + Math.imul(h1, X1) | 0, Fe = Fe + Math.imul(Zc, ah) | 0, pe = pe + Math.imul(Zc, O1) | 0, pe = pe + Math.imul(N1, ah) | 0, it = it + Math.imul(N1, O1) | 0, Fe = Fe + Math.imul(Pu, ih) | 0, pe = pe + Math.imul(Pu, oh) | 0, pe = pe + Math.imul(Lu, ih) | 0, it = it + Math.imul(Lu, oh) | 0, Fe = Fe + Math.imul(Zl, lh) | 0, pe = pe + Math.imul(Zl, kh) | 0, pe = pe + Math.imul(Iu, lh) | 0, it = it + Math.imul(Iu, kh) | 0, Fe = Fe + Math.imul(Su, ch) | 0, pe = pe + Math.imul(Su, Nh) | 0, pe = pe + Math.imul(Tu, ch) | 0, it = it + Math.imul(Tu, Nh) | 0, Fe = Fe + Math.imul(Os, yh) | 0, pe = pe + Math.imul(Os, Dh) | 0, pe = pe + Math.imul(Pa, yh) | 0, it = it + Math.imul(Pa, Dh) | 0, Fe = Fe + Math.imul(wo, Mu) | 0, pe = pe + Math.imul(wo, Du) | 0, pe = pe + Math.imul(_u, Mu) | 0, it = it + Math.imul(_u, Du) | 0;
        var W2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (W2 >>> 26) | 0, W2 &= 67108863, Fe = Math.imul(Eu, Ru), pe = Math.imul(Eu, ku), pe = pe + Math.imul(Zo, Ru) | 0, it = Math.imul(Zo, ku), Fe = Fe + Math.imul(d1, Ou) | 0, pe = pe + Math.imul(d1, U1) | 0, pe = pe + Math.imul(K1, Ou) | 0, it = it + Math.imul(K1, U1) | 0, Fe = Fe + Math.imul(Gc, Ic) | 0, pe = pe + Math.imul(Gc, X1) | 0, pe = pe + Math.imul(Kc, Ic) | 0, it = it + Math.imul(Kc, X1) | 0, Fe = Fe + Math.imul(Mc, ah) | 0, pe = pe + Math.imul(Mc, O1) | 0, pe = pe + Math.imul(h1, ah) | 0, it = it + Math.imul(h1, O1) | 0, Fe = Fe + Math.imul(Zc, ih) | 0, pe = pe + Math.imul(Zc, oh) | 0, pe = pe + Math.imul(N1, ih) | 0, it = it + Math.imul(N1, oh) | 0, Fe = Fe + Math.imul(Pu, lh) | 0, pe = pe + Math.imul(Pu, kh) | 0, pe = pe + Math.imul(Lu, lh) | 0, it = it + Math.imul(Lu, kh) | 0, Fe = Fe + Math.imul(Zl, ch) | 0, pe = pe + Math.imul(Zl, Nh) | 0, pe = pe + Math.imul(Iu, ch) | 0, it = it + Math.imul(Iu, Nh) | 0, Fe = Fe + Math.imul(Su, yh) | 0, pe = pe + Math.imul(Su, Dh) | 0, pe = pe + Math.imul(Tu, yh) | 0, it = it + Math.imul(Tu, Dh) | 0, Fe = Fe + Math.imul(Os, Mu) | 0, pe = pe + Math.imul(Os, Du) | 0, pe = pe + Math.imul(Pa, Mu) | 0, it = it + Math.imul(Pa, Du) | 0, Fe = Fe + Math.imul(wo, Nc) | 0, pe = pe + Math.imul(wo, z1) | 0, pe = pe + Math.imul(_u, Nc) | 0, it = it + Math.imul(_u, z1) | 0;
        var V2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (V2 >>> 26) | 0, V2 &= 67108863, Fe = Math.imul(Eu, Ou), pe = Math.imul(Eu, U1), pe = pe + Math.imul(Zo, Ou) | 0, it = Math.imul(Zo, U1), Fe = Fe + Math.imul(d1, Ic) | 0, pe = pe + Math.imul(d1, X1) | 0, pe = pe + Math.imul(K1, Ic) | 0, it = it + Math.imul(K1, X1) | 0, Fe = Fe + Math.imul(Gc, ah) | 0, pe = pe + Math.imul(Gc, O1) | 0, pe = pe + Math.imul(Kc, ah) | 0, it = it + Math.imul(Kc, O1) | 0, Fe = Fe + Math.imul(Mc, ih) | 0, pe = pe + Math.imul(Mc, oh) | 0, pe = pe + Math.imul(h1, ih) | 0, it = it + Math.imul(h1, oh) | 0, Fe = Fe + Math.imul(Zc, lh) | 0, pe = pe + Math.imul(Zc, kh) | 0, pe = pe + Math.imul(N1, lh) | 0, it = it + Math.imul(N1, kh) | 0, Fe = Fe + Math.imul(Pu, ch) | 0, pe = pe + Math.imul(Pu, Nh) | 0, pe = pe + Math.imul(Lu, ch) | 0, it = it + Math.imul(Lu, Nh) | 0, Fe = Fe + Math.imul(Zl, yh) | 0, pe = pe + Math.imul(Zl, Dh) | 0, pe = pe + Math.imul(Iu, yh) | 0, it = it + Math.imul(Iu, Dh) | 0, Fe = Fe + Math.imul(Su, Mu) | 0, pe = pe + Math.imul(Su, Du) | 0, pe = pe + Math.imul(Tu, Mu) | 0, it = it + Math.imul(Tu, Du) | 0, Fe = Fe + Math.imul(Os, Nc) | 0, pe = pe + Math.imul(Os, z1) | 0, pe = pe + Math.imul(Pa, Nc) | 0, it = it + Math.imul(Pa, z1) | 0;
        var Z2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Z2 >>> 26) | 0, Z2 &= 67108863, Fe = Math.imul(Eu, Ic), pe = Math.imul(Eu, X1), pe = pe + Math.imul(Zo, Ic) | 0, it = Math.imul(Zo, X1), Fe = Fe + Math.imul(d1, ah) | 0, pe = pe + Math.imul(d1, O1) | 0, pe = pe + Math.imul(K1, ah) | 0, it = it + Math.imul(K1, O1) | 0, Fe = Fe + Math.imul(Gc, ih) | 0, pe = pe + Math.imul(Gc, oh) | 0, pe = pe + Math.imul(Kc, ih) | 0, it = it + Math.imul(Kc, oh) | 0, Fe = Fe + Math.imul(Mc, lh) | 0, pe = pe + Math.imul(Mc, kh) | 0, pe = pe + Math.imul(h1, lh) | 0, it = it + Math.imul(h1, kh) | 0, Fe = Fe + Math.imul(Zc, ch) | 0, pe = pe + Math.imul(Zc, Nh) | 0, pe = pe + Math.imul(N1, ch) | 0, it = it + Math.imul(N1, Nh) | 0, Fe = Fe + Math.imul(Pu, yh) | 0, pe = pe + Math.imul(Pu, Dh) | 0, pe = pe + Math.imul(Lu, yh) | 0, it = it + Math.imul(Lu, Dh) | 0, Fe = Fe + Math.imul(Zl, Mu) | 0, pe = pe + Math.imul(Zl, Du) | 0, pe = pe + Math.imul(Iu, Mu) | 0, it = it + Math.imul(Iu, Du) | 0, Fe = Fe + Math.imul(Su, Nc) | 0, pe = pe + Math.imul(Su, z1) | 0, pe = pe + Math.imul(Tu, Nc) | 0, it = it + Math.imul(Tu, z1) | 0;
        var G2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (G2 >>> 26) | 0, G2 &= 67108863, Fe = Math.imul(Eu, ah), pe = Math.imul(Eu, O1), pe = pe + Math.imul(Zo, ah) | 0, it = Math.imul(Zo, O1), Fe = Fe + Math.imul(d1, ih) | 0, pe = pe + Math.imul(d1, oh) | 0, pe = pe + Math.imul(K1, ih) | 0, it = it + Math.imul(K1, oh) | 0, Fe = Fe + Math.imul(Gc, lh) | 0, pe = pe + Math.imul(Gc, kh) | 0, pe = pe + Math.imul(Kc, lh) | 0, it = it + Math.imul(Kc, kh) | 0, Fe = Fe + Math.imul(Mc, ch) | 0, pe = pe + Math.imul(Mc, Nh) | 0, pe = pe + Math.imul(h1, ch) | 0, it = it + Math.imul(h1, Nh) | 0, Fe = Fe + Math.imul(Zc, yh) | 0, pe = pe + Math.imul(Zc, Dh) | 0, pe = pe + Math.imul(N1, yh) | 0, it = it + Math.imul(N1, Dh) | 0, Fe = Fe + Math.imul(Pu, Mu) | 0, pe = pe + Math.imul(Pu, Du) | 0, pe = pe + Math.imul(Lu, Mu) | 0, it = it + Math.imul(Lu, Du) | 0, Fe = Fe + Math.imul(Zl, Nc) | 0, pe = pe + Math.imul(Zl, z1) | 0, pe = pe + Math.imul(Iu, Nc) | 0, it = it + Math.imul(Iu, z1) | 0;
        var K2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (K2 >>> 26) | 0, K2 &= 67108863, Fe = Math.imul(Eu, ih), pe = Math.imul(Eu, oh), pe = pe + Math.imul(Zo, ih) | 0, it = Math.imul(Zo, oh), Fe = Fe + Math.imul(d1, lh) | 0, pe = pe + Math.imul(d1, kh) | 0, pe = pe + Math.imul(K1, lh) | 0, it = it + Math.imul(K1, kh) | 0, Fe = Fe + Math.imul(Gc, ch) | 0, pe = pe + Math.imul(Gc, Nh) | 0, pe = pe + Math.imul(Kc, ch) | 0, it = it + Math.imul(Kc, Nh) | 0, Fe = Fe + Math.imul(Mc, yh) | 0, pe = pe + Math.imul(Mc, Dh) | 0, pe = pe + Math.imul(h1, yh) | 0, it = it + Math.imul(h1, Dh) | 0, Fe = Fe + Math.imul(Zc, Mu) | 0, pe = pe + Math.imul(Zc, Du) | 0, pe = pe + Math.imul(N1, Mu) | 0, it = it + Math.imul(N1, Du) | 0, Fe = Fe + Math.imul(Pu, Nc) | 0, pe = pe + Math.imul(Pu, z1) | 0, pe = pe + Math.imul(Lu, Nc) | 0, it = it + Math.imul(Lu, z1) | 0;
        var Y2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Y2 >>> 26) | 0, Y2 &= 67108863, Fe = Math.imul(Eu, lh), pe = Math.imul(Eu, kh), pe = pe + Math.imul(Zo, lh) | 0, it = Math.imul(Zo, kh), Fe = Fe + Math.imul(d1, ch) | 0, pe = pe + Math.imul(d1, Nh) | 0, pe = pe + Math.imul(K1, ch) | 0, it = it + Math.imul(K1, Nh) | 0, Fe = Fe + Math.imul(Gc, yh) | 0, pe = pe + Math.imul(Gc, Dh) | 0, pe = pe + Math.imul(Kc, yh) | 0, it = it + Math.imul(Kc, Dh) | 0, Fe = Fe + Math.imul(Mc, Mu) | 0, pe = pe + Math.imul(Mc, Du) | 0, pe = pe + Math.imul(h1, Mu) | 0, it = it + Math.imul(h1, Du) | 0, Fe = Fe + Math.imul(Zc, Nc) | 0, pe = pe + Math.imul(Zc, z1) | 0, pe = pe + Math.imul(N1, Nc) | 0, it = it + Math.imul(N1, z1) | 0;
        var J2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (J2 >>> 26) | 0, J2 &= 67108863, Fe = Math.imul(Eu, ch), pe = Math.imul(Eu, Nh), pe = pe + Math.imul(Zo, ch) | 0, it = Math.imul(Zo, Nh), Fe = Fe + Math.imul(d1, yh) | 0, pe = pe + Math.imul(d1, Dh) | 0, pe = pe + Math.imul(K1, yh) | 0, it = it + Math.imul(K1, Dh) | 0, Fe = Fe + Math.imul(Gc, Mu) | 0, pe = pe + Math.imul(Gc, Du) | 0, pe = pe + Math.imul(Kc, Mu) | 0, it = it + Math.imul(Kc, Du) | 0, Fe = Fe + Math.imul(Mc, Nc) | 0, pe = pe + Math.imul(Mc, z1) | 0, pe = pe + Math.imul(h1, Nc) | 0, it = it + Math.imul(h1, z1) | 0;
        var Q2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (Q2 >>> 26) | 0, Q2 &= 67108863, Fe = Math.imul(Eu, yh), pe = Math.imul(Eu, Dh), pe = pe + Math.imul(Zo, yh) | 0, it = Math.imul(Zo, Dh), Fe = Fe + Math.imul(d1, Mu) | 0, pe = pe + Math.imul(d1, Du) | 0, pe = pe + Math.imul(K1, Mu) | 0, it = it + Math.imul(K1, Du) | 0, Fe = Fe + Math.imul(Gc, Nc) | 0, pe = pe + Math.imul(Gc, z1) | 0, pe = pe + Math.imul(Kc, Nc) | 0, it = it + Math.imul(Kc, z1) | 0;
        var X2 = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (X2 >>> 26) | 0, X2 &= 67108863, Fe = Math.imul(Eu, Mu), pe = Math.imul(Eu, Du), pe = pe + Math.imul(Zo, Mu) | 0, it = Math.imul(Zo, Du), Fe = Fe + Math.imul(d1, Nc) | 0, pe = pe + Math.imul(d1, z1) | 0, pe = pe + Math.imul(K1, Nc) | 0, it = it + Math.imul(K1, z1) | 0;
        var ep = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        zn = (it + (pe >>> 13) | 0) + (ep >>> 26) | 0, ep &= 67108863, Fe = Math.imul(Eu, Nc), pe = Math.imul(Eu, z1), pe = pe + Math.imul(Zo, Nc) | 0, it = Math.imul(Zo, z1);
        var im = (zn + Fe | 0) + ((pe & 8191) << 13) | 0;
        return zn = (it + (pe >>> 13) | 0) + (im >>> 26) | 0, im &= 67108863, Fr[0] = A2, Fr[1] = b2, Fr[2] = R2, Fr[3] = D2, Fr[4] = I2, Fr[5] = N2, Fr[6] = B2, Fr[7] = z2, Fr[8] = W2, Fr[9] = V2, Fr[10] = Z2, Fr[11] = G2, Fr[12] = K2, Fr[13] = Y2, Fr[14] = J2, Fr[15] = Q2, Fr[16] = X2, Fr[17] = ep, Fr[18] = im, zn !== 0 && (Fr[19] = zn, ye.length++), ye;
      };
      Math.imul || (br = Nr);
      function $n(ct, fe, be) {
        be.negative = fe.negative ^ ct.negative, be.length = ct.length + fe.length;
        for (var ye = 0, Se = 0, Oe = 0; Oe < be.length - 1; Oe++) {
          var Fr = Se;
          Se = 0;
          for (var zn = ye & 67108863, Fe = Math.min(Oe, fe.length - 1), pe = Math.max(0, Oe - ct.length + 1); pe <= Fe; pe++) {
            var it = Oe - pe, xa = ct.words[it] | 0, wo = fe.words[pe] | 0, _u = xa * wo, Oa = _u & 67108863;
            Fr = Fr + (_u / 67108864 | 0) | 0, Oa = Oa + zn | 0, zn = Oa & 67108863, Fr = Fr + (Oa >>> 26) | 0, Se += Fr >>> 26, Fr &= 67108863;
          }
          be.words[Oe] = zn, ye = Fr, Fr = Se;
        }
        return ye !== 0 ? be.words[Oe] = ye : be.length--, be.strip();
      }
      function En(ct, fe, be) {
        var ye = new Rn();
        return ye.mulp(ct, fe, be);
      }
      le.prototype.mulTo = function(fe, be) {
        var ye, Se = this.length + fe.length;
        return this.length === 10 && fe.length === 10 ? ye = br(this, fe, be) : Se < 63 ? ye = Nr(this, fe, be) : Se < 1024 ? ye = $n(this, fe, be) : ye = En(this, fe, be), ye;
      };
      function Rn(ct, fe) {
        this.x = ct, this.y = fe;
      }
      Rn.prototype.makeRBT = function(fe) {
        for (var be = new Array(fe), ye = le.prototype._countBits(fe) - 1, Se = 0; Se < fe; Se++)
          be[Se] = this.revBin(Se, ye, fe);
        return be;
      }, Rn.prototype.revBin = function(fe, be, ye) {
        if (fe === 0 || fe === ye - 1)
          return fe;
        for (var Se = 0, Oe = 0; Oe < be; Oe++)
          Se |= (fe & 1) << be - Oe - 1, fe >>= 1;
        return Se;
      }, Rn.prototype.permute = function(fe, be, ye, Se, Oe, Fr) {
        for (var zn = 0; zn < Fr; zn++)
          Se[zn] = be[fe[zn]], Oe[zn] = ye[fe[zn]];
      }, Rn.prototype.transform = function(fe, be, ye, Se, Oe, Fr) {
        this.permute(Fr, fe, be, ye, Se, Oe);
        for (var zn = 1; zn < Oe; zn <<= 1)
          for (var Fe = zn << 1, pe = Math.cos(2 * Math.PI / Fe), it = Math.sin(2 * Math.PI / Fe), xa = 0; xa < Oe; xa += Fe)
            for (var wo = pe, _u = it, Oa = 0; Oa < zn; Oa++) {
              var Os = ye[xa + Oa], Pa = Se[xa + Oa], Ml = ye[xa + Oa + zn], Su = Se[xa + Oa + zn], Tu = wo * Ml - _u * Su;
              Su = wo * Su + _u * Ml, Ml = Tu, ye[xa + Oa] = Os + Ml, Se[xa + Oa] = Pa + Su, ye[xa + Oa + zn] = Os - Ml, Se[xa + Oa + zn] = Pa - Su, Oa !== Fe && (Tu = pe * wo - it * _u, _u = pe * _u + it * wo, wo = Tu);
            }
      }, Rn.prototype.guessLen13b = function(fe, be) {
        var ye = Math.max(be, fe) | 1, Se = ye & 1, Oe = 0;
        for (ye = ye / 2 | 0; ye; ye = ye >>> 1)
          Oe++;
        return 1 << Oe + 1 + Se;
      }, Rn.prototype.conjugate = function(fe, be, ye) {
        if (!(ye <= 1))
          for (var Se = 0; Se < ye / 2; Se++) {
            var Oe = fe[Se];
            fe[Se] = fe[ye - Se - 1], fe[ye - Se - 1] = Oe, Oe = be[Se], be[Se] = -be[ye - Se - 1], be[ye - Se - 1] = -Oe;
          }
      }, Rn.prototype.normalize13b = function(fe, be) {
        for (var ye = 0, Se = 0; Se < be / 2; Se++) {
          var Oe = Math.round(fe[2 * Se + 1] / be) * 8192 + Math.round(fe[2 * Se] / be) + ye;
          fe[Se] = Oe & 67108863, Oe < 67108864 ? ye = 0 : ye = Oe / 67108864 | 0;
        }
        return fe;
      }, Rn.prototype.convert13b = function(fe, be, ye, Se) {
        for (var Oe = 0, Fr = 0; Fr < be; Fr++)
          Oe = Oe + (fe[Fr] | 0), ye[2 * Fr] = Oe & 8191, Oe = Oe >>> 13, ye[2 * Fr + 1] = Oe & 8191, Oe = Oe >>> 13;
        for (Fr = 2 * be; Fr < Se; ++Fr)
          ye[Fr] = 0;
        ne(Oe === 0), ne((Oe & -8192) === 0);
      }, Rn.prototype.stub = function(fe) {
        for (var be = new Array(fe), ye = 0; ye < fe; ye++)
          be[ye] = 0;
        return be;
      }, Rn.prototype.mulp = function(fe, be, ye) {
        var Se = 2 * this.guessLen13b(fe.length, be.length), Oe = this.makeRBT(Se), Fr = this.stub(Se), zn = new Array(Se), Fe = new Array(Se), pe = new Array(Se), it = new Array(Se), xa = new Array(Se), wo = new Array(Se), _u = ye.words;
        _u.length = Se, this.convert13b(fe.words, fe.length, zn, Se), this.convert13b(be.words, be.length, it, Se), this.transform(zn, Fr, Fe, pe, Se, Oe), this.transform(it, Fr, xa, wo, Se, Oe);
        for (var Oa = 0; Oa < Se; Oa++) {
          var Os = Fe[Oa] * xa[Oa] - pe[Oa] * wo[Oa];
          pe[Oa] = Fe[Oa] * wo[Oa] + pe[Oa] * xa[Oa], Fe[Oa] = Os;
        }
        return this.conjugate(Fe, pe, Se), this.transform(Fe, pe, _u, Fr, Se, Oe), this.conjugate(_u, Fr, Se), this.normalize13b(_u, Se), ye.negative = fe.negative ^ be.negative, ye.length = fe.length + be.length, ye.strip();
      }, le.prototype.mul = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), this.mulTo(fe, be);
      }, le.prototype.mulf = function(fe) {
        var be = new le(null);
        return be.words = new Array(this.length + fe.length), En(this, fe, be);
      }, le.prototype.imul = function(fe) {
        return this.clone().mulTo(fe, this);
      }, le.prototype.imuln = function(fe) {
        ne(typeof fe == "number"), ne(fe < 67108864);
        for (var be = 0, ye = 0; ye < this.length; ye++) {
          var Se = (this.words[ye] | 0) * fe, Oe = (Se & 67108863) + (be & 67108863);
          be >>= 26, be += Se / 67108864 | 0, be += Oe >>> 26, this.words[ye] = Oe & 67108863;
        }
        return be !== 0 && (this.words[ye] = be, this.length++), this;
      }, le.prototype.muln = function(fe) {
        return this.clone().imuln(fe);
      }, le.prototype.sqr = function() {
        return this.mul(this);
      }, le.prototype.isqr = function() {
        return this.imul(this.clone());
      }, le.prototype.pow = function(fe) {
        var be = st(fe);
        if (be.length === 0)
          return new le(1);
        for (var ye = this, Se = 0; Se < be.length && be[Se] === 0; Se++, ye = ye.sqr())
          ;
        if (++Se < be.length)
          for (var Oe = ye.sqr(); Se < be.length; Se++, Oe = Oe.sqr())
            be[Se] !== 0 && (ye = ye.mul(Oe));
        return ye;
      }, le.prototype.iushln = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 67108863 >>> 26 - be << 26 - be, Oe;
        if (be !== 0) {
          var Fr = 0;
          for (Oe = 0; Oe < this.length; Oe++) {
            var zn = this.words[Oe] & Se, Fe = (this.words[Oe] | 0) - zn << be;
            this.words[Oe] = Fe | Fr, Fr = zn >>> 26 - be;
          }
          Fr && (this.words[Oe] = Fr, this.length++);
        }
        if (ye !== 0) {
          for (Oe = this.length - 1; Oe >= 0; Oe--)
            this.words[Oe + ye] = this.words[Oe];
          for (Oe = 0; Oe < ye; Oe++)
            this.words[Oe] = 0;
          this.length += ye;
        }
        return this.strip();
      }, le.prototype.ishln = function(fe) {
        return ne(this.negative === 0), this.iushln(fe);
      }, le.prototype.iushrn = function(fe, be, ye) {
        ne(typeof fe == "number" && fe >= 0);
        var Se;
        be ? Se = (be - be % 26) / 26 : Se = 0;
        var Oe = fe % 26, Fr = Math.min((fe - Oe) / 26, this.length), zn = 67108863 ^ 67108863 >>> Oe << Oe, Fe = ye;
        if (Se -= Fr, Se = Math.max(0, Se), Fe) {
          for (var pe = 0; pe < Fr; pe++)
            Fe.words[pe] = this.words[pe];
          Fe.length = Fr;
        }
        if (Fr !== 0)
          if (this.length > Fr)
            for (this.length -= Fr, pe = 0; pe < this.length; pe++)
              this.words[pe] = this.words[pe + Fr];
          else
            this.words[0] = 0, this.length = 1;
        var it = 0;
        for (pe = this.length - 1; pe >= 0 && (it !== 0 || pe >= Se); pe--) {
          var xa = this.words[pe] | 0;
          this.words[pe] = it << 26 - Oe | xa >>> Oe, it = xa & zn;
        }
        return Fe && it !== 0 && (Fe.words[Fe.length++] = it), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, le.prototype.ishrn = function(fe, be, ye) {
        return ne(this.negative === 0), this.iushrn(fe, be, ye);
      }, le.prototype.shln = function(fe) {
        return this.clone().ishln(fe);
      }, le.prototype.ushln = function(fe) {
        return this.clone().iushln(fe);
      }, le.prototype.shrn = function(fe) {
        return this.clone().ishrn(fe);
      }, le.prototype.ushrn = function(fe) {
        return this.clone().iushrn(fe);
      }, le.prototype.testn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return !1;
        var Oe = this.words[ye];
        return !!(Oe & Se);
      }, le.prototype.imaskn = function(fe) {
        ne(typeof fe == "number" && fe >= 0);
        var be = fe % 26, ye = (fe - be) / 26;
        if (ne(this.negative === 0, "imaskn works only with positive numbers"), this.length <= ye)
          return this;
        if (be !== 0 && ye++, this.length = Math.min(ye, this.length), be !== 0) {
          var Se = 67108863 ^ 67108863 >>> be << be;
          this.words[this.length - 1] &= Se;
        }
        return this.strip();
      }, le.prototype.maskn = function(fe) {
        return this.clone().imaskn(fe);
      }, le.prototype.iaddn = function(fe) {
        return ne(typeof fe == "number"), ne(fe < 67108864), fe < 0 ? this.isubn(-fe) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < fe ? (this.words[0] = fe - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(fe), this.negative = 1, this) : this._iaddn(fe);
      }, le.prototype._iaddn = function(fe) {
        this.words[0] += fe;
        for (var be = 0; be < this.length && this.words[be] >= 67108864; be++)
          this.words[be] -= 67108864, be === this.length - 1 ? this.words[be + 1] = 1 : this.words[be + 1]++;
        return this.length = Math.max(this.length, be + 1), this;
      }, le.prototype.isubn = function(fe) {
        if (ne(typeof fe == "number"), ne(fe < 67108864), fe < 0)
          return this.iaddn(-fe);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(fe), this.negative = 1, this;
        if (this.words[0] -= fe, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var be = 0; be < this.length && this.words[be] < 0; be++)
            this.words[be] += 67108864, this.words[be + 1] -= 1;
        return this.strip();
      }, le.prototype.addn = function(fe) {
        return this.clone().iaddn(fe);
      }, le.prototype.subn = function(fe) {
        return this.clone().isubn(fe);
      }, le.prototype.iabs = function() {
        return this.negative = 0, this;
      }, le.prototype.abs = function() {
        return this.clone().iabs();
      }, le.prototype._ishlnsubmul = function(fe, be, ye) {
        var Se = fe.length + ye, Oe;
        this._expand(Se);
        var Fr, zn = 0;
        for (Oe = 0; Oe < fe.length; Oe++) {
          Fr = (this.words[Oe + ye] | 0) + zn;
          var Fe = (fe.words[Oe] | 0) * be;
          Fr -= Fe & 67108863, zn = (Fr >> 26) - (Fe / 67108864 | 0), this.words[Oe + ye] = Fr & 67108863;
        }
        for (; Oe < this.length - ye; Oe++)
          Fr = (this.words[Oe + ye] | 0) + zn, zn = Fr >> 26, this.words[Oe + ye] = Fr & 67108863;
        if (zn === 0)
          return this.strip();
        for (ne(zn === -1), zn = 0, Oe = 0; Oe < this.length; Oe++)
          Fr = -(this.words[Oe] | 0) + zn, zn = Fr >> 26, this.words[Oe] = Fr & 67108863;
        return this.negative = 1, this.strip();
      }, le.prototype._wordDiv = function(fe, be) {
        var ye = this.length - fe.length, Se = this.clone(), Oe = fe, Fr = Oe.words[Oe.length - 1] | 0, zn = this._countBits(Fr);
        ye = 26 - zn, ye !== 0 && (Oe = Oe.ushln(ye), Se.iushln(ye), Fr = Oe.words[Oe.length - 1] | 0);
        var Fe = Se.length - Oe.length, pe;
        if (be !== "mod") {
          pe = new le(null), pe.length = Fe + 1, pe.words = new Array(pe.length);
          for (var it = 0; it < pe.length; it++)
            pe.words[it] = 0;
        }
        var xa = Se.clone()._ishlnsubmul(Oe, 1, Fe);
        xa.negative === 0 && (Se = xa, pe && (pe.words[Fe] = 1));
        for (var wo = Fe - 1; wo >= 0; wo--) {
          var _u = (Se.words[Oe.length + wo] | 0) * 67108864 + (Se.words[Oe.length + wo - 1] | 0);
          for (_u = Math.min(_u / Fr | 0, 67108863), Se._ishlnsubmul(Oe, _u, wo); Se.negative !== 0; )
            _u--, Se.negative = 0, Se._ishlnsubmul(Oe, 1, wo), Se.isZero() || (Se.negative ^= 1);
          pe && (pe.words[wo] = _u);
        }
        return pe && pe.strip(), Se.strip(), be !== "div" && ye !== 0 && Se.iushrn(ye), {
          div: pe || null,
          mod: Se
        };
      }, le.prototype.divmod = function(fe, be, ye) {
        if (ne(!fe.isZero()), this.isZero())
          return {
            div: new le(0),
            mod: new le(0)
          };
        var Se, Oe, Fr;
        return this.negative !== 0 && fe.negative === 0 ? (Fr = this.neg().divmod(fe, be), be !== "mod" && (Se = Fr.div.neg()), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.iadd(fe)), {
          div: Se,
          mod: Oe
        }) : this.negative === 0 && fe.negative !== 0 ? (Fr = this.divmod(fe.neg(), be), be !== "mod" && (Se = Fr.div.neg()), {
          div: Se,
          mod: Fr.mod
        }) : this.negative & fe.negative ? (Fr = this.neg().divmod(fe.neg(), be), be !== "div" && (Oe = Fr.mod.neg(), ye && Oe.negative !== 0 && Oe.isub(fe)), {
          div: Fr.div,
          mod: Oe
        }) : fe.length > this.length || this.cmp(fe) < 0 ? {
          div: new le(0),
          mod: this
        } : fe.length === 1 ? be === "div" ? {
          div: this.divn(fe.words[0]),
          mod: null
        } : be === "mod" ? {
          div: null,
          mod: new le(this.modn(fe.words[0]))
        } : {
          div: this.divn(fe.words[0]),
          mod: new le(this.modn(fe.words[0]))
        } : this._wordDiv(fe, be);
      }, le.prototype.div = function(fe) {
        return this.divmod(fe, "div", !1).div;
      }, le.prototype.mod = function(fe) {
        return this.divmod(fe, "mod", !1).mod;
      }, le.prototype.umod = function(fe) {
        return this.divmod(fe, "mod", !0).mod;
      }, le.prototype.divRound = function(fe) {
        var be = this.divmod(fe);
        if (be.mod.isZero())
          return be.div;
        var ye = be.div.negative !== 0 ? be.mod.isub(fe) : be.mod, Se = fe.ushrn(1), Oe = fe.andln(1), Fr = ye.cmp(Se);
        return Fr < 0 || Oe === 1 && Fr === 0 ? be.div : be.div.negative !== 0 ? be.div.isubn(1) : be.div.iaddn(1);
      }, le.prototype.modn = function(fe) {
        ne(fe <= 67108863);
        for (var be = (1 << 26) % fe, ye = 0, Se = this.length - 1; Se >= 0; Se--)
          ye = (be * ye + (this.words[Se] | 0)) % fe;
        return ye;
      }, le.prototype.idivn = function(fe) {
        ne(fe <= 67108863);
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = (this.words[ye] | 0) + be * 67108864;
          this.words[ye] = Se / fe | 0, be = Se % fe;
        }
        return this.strip();
      }, le.prototype.divn = function(fe) {
        return this.clone().idivn(fe);
      }, le.prototype.egcd = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = new le(0), zn = new le(1), Fe = 0; be.isEven() && ye.isEven(); )
          be.iushrn(1), ye.iushrn(1), ++Fe;
        for (var pe = ye.clone(), it = be.clone(); !be.isZero(); ) {
          for (var xa = 0, wo = 1; !(be.words[0] & wo) && xa < 26; ++xa, wo <<= 1)
            ;
          if (xa > 0)
            for (be.iushrn(xa); xa-- > 0; )
              (Se.isOdd() || Oe.isOdd()) && (Se.iadd(pe), Oe.isub(it)), Se.iushrn(1), Oe.iushrn(1);
          for (var _u = 0, Oa = 1; !(ye.words[0] & Oa) && _u < 26; ++_u, Oa <<= 1)
            ;
          if (_u > 0)
            for (ye.iushrn(_u); _u-- > 0; )
              (Fr.isOdd() || zn.isOdd()) && (Fr.iadd(pe), zn.isub(it)), Fr.iushrn(1), zn.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Fr), Oe.isub(zn)) : (ye.isub(be), Fr.isub(Se), zn.isub(Oe));
        }
        return {
          a: Fr,
          b: zn,
          gcd: ye.iushln(Fe)
        };
      }, le.prototype._invmp = function(fe) {
        ne(fe.negative === 0), ne(!fe.isZero());
        var be = this, ye = fe.clone();
        be.negative !== 0 ? be = be.umod(fe) : be = be.clone();
        for (var Se = new le(1), Oe = new le(0), Fr = ye.clone(); be.cmpn(1) > 0 && ye.cmpn(1) > 0; ) {
          for (var zn = 0, Fe = 1; !(be.words[0] & Fe) && zn < 26; ++zn, Fe <<= 1)
            ;
          if (zn > 0)
            for (be.iushrn(zn); zn-- > 0; )
              Se.isOdd() && Se.iadd(Fr), Se.iushrn(1);
          for (var pe = 0, it = 1; !(ye.words[0] & it) && pe < 26; ++pe, it <<= 1)
            ;
          if (pe > 0)
            for (ye.iushrn(pe); pe-- > 0; )
              Oe.isOdd() && Oe.iadd(Fr), Oe.iushrn(1);
          be.cmp(ye) >= 0 ? (be.isub(ye), Se.isub(Oe)) : (ye.isub(be), Oe.isub(Se));
        }
        var xa;
        return be.cmpn(1) === 0 ? xa = Se : xa = Oe, xa.cmpn(0) < 0 && xa.iadd(fe), xa;
      }, le.prototype.gcd = function(fe) {
        if (this.isZero())
          return fe.abs();
        if (fe.isZero())
          return this.abs();
        var be = this.clone(), ye = fe.clone();
        be.negative = 0, ye.negative = 0;
        for (var Se = 0; be.isEven() && ye.isEven(); Se++)
          be.iushrn(1), ye.iushrn(1);
        do {
          for (; be.isEven(); )
            be.iushrn(1);
          for (; ye.isEven(); )
            ye.iushrn(1);
          var Oe = be.cmp(ye);
          if (Oe < 0) {
            var Fr = be;
            be = ye, ye = Fr;
          } else if (Oe === 0 || ye.cmpn(1) === 0)
            break;
          be.isub(ye);
        } while (!0);
        return ye.iushln(Se);
      }, le.prototype.invm = function(fe) {
        return this.egcd(fe).a.umod(fe);
      }, le.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, le.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, le.prototype.andln = function(fe) {
        return this.words[0] & fe;
      }, le.prototype.bincn = function(fe) {
        ne(typeof fe == "number");
        var be = fe % 26, ye = (fe - be) / 26, Se = 1 << be;
        if (this.length <= ye)
          return this._expand(ye + 1), this.words[ye] |= Se, this;
        for (var Oe = Se, Fr = ye; Oe !== 0 && Fr < this.length; Fr++) {
          var zn = this.words[Fr] | 0;
          zn += Oe, Oe = zn >>> 26, zn &= 67108863, this.words[Fr] = zn;
        }
        return Oe !== 0 && (this.words[Fr] = Oe, this.length++), this;
      }, le.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, le.prototype.cmpn = function(fe) {
        var be = fe < 0;
        if (this.negative !== 0 && !be)
          return -1;
        if (this.negative === 0 && be)
          return 1;
        this.strip();
        var ye;
        if (this.length > 1)
          ye = 1;
        else {
          be && (fe = -fe), ne(fe <= 67108863, "Number is too big");
          var Se = this.words[0] | 0;
          ye = Se === fe ? 0 : Se < fe ? -1 : 1;
        }
        return this.negative !== 0 ? -ye | 0 : ye;
      }, le.prototype.cmp = function(fe) {
        if (this.negative !== 0 && fe.negative === 0)
          return -1;
        if (this.negative === 0 && fe.negative !== 0)
          return 1;
        var be = this.ucmp(fe);
        return this.negative !== 0 ? -be | 0 : be;
      }, le.prototype.ucmp = function(fe) {
        if (this.length > fe.length)
          return 1;
        if (this.length < fe.length)
          return -1;
        for (var be = 0, ye = this.length - 1; ye >= 0; ye--) {
          var Se = this.words[ye] | 0, Oe = fe.words[ye] | 0;
          if (Se !== Oe) {
            Se < Oe ? be = -1 : Se > Oe && (be = 1);
            break;
          }
        }
        return be;
      }, le.prototype.gtn = function(fe) {
        return this.cmpn(fe) === 1;
      }, le.prototype.gt = function(fe) {
        return this.cmp(fe) === 1;
      }, le.prototype.gten = function(fe) {
        return this.cmpn(fe) >= 0;
      }, le.prototype.gte = function(fe) {
        return this.cmp(fe) >= 0;
      }, le.prototype.ltn = function(fe) {
        return this.cmpn(fe) === -1;
      }, le.prototype.lt = function(fe) {
        return this.cmp(fe) === -1;
      }, le.prototype.lten = function(fe) {
        return this.cmpn(fe) <= 0;
      }, le.prototype.lte = function(fe) {
        return this.cmp(fe) <= 0;
      }, le.prototype.eqn = function(fe) {
        return this.cmpn(fe) === 0;
      }, le.prototype.eq = function(fe) {
        return this.cmp(fe) === 0;
      }, le.red = function(fe) {
        return new Yn(fe);
      }, le.prototype.toRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), ne(this.negative === 0, "red works only with positives"), fe.convertTo(this)._forceRed(fe);
      }, le.prototype.fromRed = function() {
        return ne(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, le.prototype._forceRed = function(fe) {
        return this.red = fe, this;
      }, le.prototype.forceRed = function(fe) {
        return ne(!this.red, "Already a number in reduction context"), this._forceRed(fe);
      }, le.prototype.redAdd = function(fe) {
        return ne(this.red, "redAdd works only with red numbers"), this.red.add(this, fe);
      }, le.prototype.redIAdd = function(fe) {
        return ne(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, fe);
      }, le.prototype.redSub = function(fe) {
        return ne(this.red, "redSub works only with red numbers"), this.red.sub(this, fe);
      }, le.prototype.redISub = function(fe) {
        return ne(this.red, "redISub works only with red numbers"), this.red.isub(this, fe);
      }, le.prototype.redShl = function(fe) {
        return ne(this.red, "redShl works only with red numbers"), this.red.shl(this, fe);
      }, le.prototype.redMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.mul(this, fe);
      }, le.prototype.redIMul = function(fe) {
        return ne(this.red, "redMul works only with red numbers"), this.red._verify2(this, fe), this.red.imul(this, fe);
      }, le.prototype.redSqr = function() {
        return ne(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, le.prototype.redISqr = function() {
        return ne(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, le.prototype.redSqrt = function() {
        return ne(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, le.prototype.redInvm = function() {
        return ne(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, le.prototype.redNeg = function() {
        return ne(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, le.prototype.redPow = function(fe) {
        return ne(this.red && !fe.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, fe);
      };
      var wa = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Aa(ct, fe) {
        this.name = ct, this.p = new le(fe, 16), this.n = this.p.bitLength(), this.k = new le(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Aa.prototype._tmp = function() {
        var fe = new le(null);
        return fe.words = new Array(Math.ceil(this.n / 13)), fe;
      }, Aa.prototype.ireduce = function(fe) {
        var be = fe, ye;
        do
          this.split(be, this.tmp), be = this.imulK(be), be = be.iadd(this.tmp), ye = be.bitLength();
        while (ye > this.n);
        var Se = ye < this.n ? -1 : be.ucmp(this.p);
        return Se === 0 ? (be.words[0] = 0, be.length = 1) : Se > 0 ? be.isub(this.p) : be.strip !== void 0 ? be.strip() : be._strip(), be;
      }, Aa.prototype.split = function(fe, be) {
        fe.iushrn(this.n, 0, be);
      }, Aa.prototype.imulK = function(fe) {
        return fe.imul(this.k);
      };
      function _a() {
        Aa.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      ue(_a, Aa), _a.prototype.split = function(fe, be) {
        for (var ye = 4194303, Se = Math.min(fe.length, 9), Oe = 0; Oe < Se; Oe++)
          be.words[Oe] = fe.words[Oe];
        if (be.length = Se, fe.length <= 9) {
          fe.words[0] = 0, fe.length = 1;
          return;
        }
        var Fr = fe.words[9];
        for (be.words[be.length++] = Fr & ye, Oe = 10; Oe < fe.length; Oe++) {
          var zn = fe.words[Oe] | 0;
          fe.words[Oe - 10] = (zn & ye) << 4 | Fr >>> 22, Fr = zn;
        }
        Fr >>>= 22, fe.words[Oe - 10] = Fr, Fr === 0 && fe.length > 10 ? fe.length -= 10 : fe.length -= 9;
      }, _a.prototype.imulK = function(fe) {
        fe.words[fe.length] = 0, fe.words[fe.length + 1] = 0, fe.length += 2;
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = fe.words[ye] | 0;
          be += Se * 977, fe.words[ye] = be & 67108863, be = Se * 64 + (be / 67108864 | 0);
        }
        return fe.words[fe.length - 1] === 0 && (fe.length--, fe.words[fe.length - 1] === 0 && fe.length--), fe;
      };
      function Ta() {
        Aa.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      ue(Ta, Aa);
      function Zn() {
        Aa.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      ue(Zn, Aa);
      function Ra() {
        Aa.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      ue(Ra, Aa), Ra.prototype.imulK = function(fe) {
        for (var be = 0, ye = 0; ye < fe.length; ye++) {
          var Se = (fe.words[ye] | 0) * 19 + be, Oe = Se & 67108863;
          Se >>>= 26, fe.words[ye] = Oe, be = Se;
        }
        return be !== 0 && (fe.words[fe.length++] = be), fe;
      }, le._prime = function(fe) {
        if (wa[fe])
          return wa[fe];
        var be;
        if (fe === "k256")
          be = new _a();
        else if (fe === "p224")
          be = new Ta();
        else if (fe === "p192")
          be = new Zn();
        else if (fe === "p25519")
          be = new Ra();
        else
          throw new Error("Unknown prime " + fe);
        return wa[fe] = be, be;
      };
      function Yn(ct) {
        if (typeof ct == "string") {
          var fe = le._prime(ct);
          this.m = fe.p, this.prime = fe;
        } else
          ne(ct.gtn(1), "modulus must be greater than 1"), this.m = ct, this.prime = null;
      }
      Yn.prototype._verify1 = function(fe) {
        ne(fe.negative === 0, "red works only with positives"), ne(fe.red, "red works only with red numbers");
      }, Yn.prototype._verify2 = function(fe, be) {
        ne((fe.negative | be.negative) === 0, "red works only with positives"), ne(
          fe.red && fe.red === be.red,
          "red works only with red numbers"
        );
      }, Yn.prototype.imod = function(fe) {
        return this.prime ? this.prime.ireduce(fe)._forceRed(this) : fe.umod(this.m)._forceRed(this);
      }, Yn.prototype.neg = function(fe) {
        return fe.isZero() ? fe.clone() : this.m.sub(fe)._forceRed(this);
      }, Yn.prototype.add = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.add(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye._forceRed(this);
      }, Yn.prototype.iadd = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.iadd(be);
        return ye.cmp(this.m) >= 0 && ye.isub(this.m), ye;
      }, Yn.prototype.sub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.sub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye._forceRed(this);
      }, Yn.prototype.isub = function(fe, be) {
        this._verify2(fe, be);
        var ye = fe.isub(be);
        return ye.cmpn(0) < 0 && ye.iadd(this.m), ye;
      }, Yn.prototype.shl = function(fe, be) {
        return this._verify1(fe), this.imod(fe.ushln(be));
      }, Yn.prototype.imul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.imul(be));
      }, Yn.prototype.mul = function(fe, be) {
        return this._verify2(fe, be), this.imod(fe.mul(be));
      }, Yn.prototype.isqr = function(fe) {
        return this.imul(fe, fe.clone());
      }, Yn.prototype.sqr = function(fe) {
        return this.mul(fe, fe);
      }, Yn.prototype.sqrt = function(fe) {
        if (fe.isZero())
          return fe.clone();
        var be = this.m.andln(3);
        if (ne(be % 2 === 1), be === 3) {
          var ye = this.m.add(new le(1)).iushrn(2);
          return this.pow(fe, ye);
        }
        for (var Se = this.m.subn(1), Oe = 0; !Se.isZero() && Se.andln(1) === 0; )
          Oe++, Se.iushrn(1);
        ne(!Se.isZero());
        var Fr = new le(1).toRed(this), zn = Fr.redNeg(), Fe = this.m.subn(1).iushrn(1), pe = this.m.bitLength();
        for (pe = new le(2 * pe * pe).toRed(this); this.pow(pe, Fe).cmp(zn) !== 0; )
          pe.redIAdd(zn);
        for (var it = this.pow(pe, Se), xa = this.pow(fe, Se.addn(1).iushrn(1)), wo = this.pow(fe, Se), _u = Oe; wo.cmp(Fr) !== 0; ) {
          for (var Oa = wo, Os = 0; Oa.cmp(Fr) !== 0; Os++)
            Oa = Oa.redSqr();
          ne(Os < _u);
          var Pa = this.pow(it, new le(1).iushln(_u - Os - 1));
          xa = xa.redMul(Pa), it = Pa.redSqr(), wo = wo.redMul(it), _u = Os;
        }
        return xa;
      }, Yn.prototype.invm = function(fe) {
        var be = fe._invmp(this.m);
        return be.negative !== 0 ? (be.negative = 0, this.imod(be).redNeg()) : this.imod(be);
      }, Yn.prototype.pow = function(fe, be) {
        if (be.isZero())
          return new le(1).toRed(this);
        if (be.cmpn(1) === 0)
          return fe.clone();
        var ye = 4, Se = new Array(1 << ye);
        Se[0] = new le(1).toRed(this), Se[1] = fe;
        for (var Oe = 2; Oe < Se.length; Oe++)
          Se[Oe] = this.mul(Se[Oe - 1], fe);
        var Fr = Se[0], zn = 0, Fe = 0, pe = be.bitLength() % 26;
        for (pe === 0 && (pe = 26), Oe = be.length - 1; Oe >= 0; Oe--) {
          for (var it = be.words[Oe], xa = pe - 1; xa >= 0; xa--) {
            var wo = it >> xa & 1;
            if (Fr !== Se[0] && (Fr = this.sqr(Fr)), wo === 0 && zn === 0) {
              Fe = 0;
              continue;
            }
            zn <<= 1, zn |= wo, Fe++, !(Fe !== ye && (Oe !== 0 || xa !== 0)) && (Fr = this.mul(Fr, Se[zn]), Fe = 0, zn = 0);
          }
          pe = 26;
        }
        return Fr;
      }, Yn.prototype.convertTo = function(fe) {
        var be = fe.umod(this.m);
        return be === fe ? be.clone() : be;
      }, Yn.prototype.convertFrom = function(fe) {
        var be = fe.clone();
        return be.red = null, be;
      }, le.mont = function(fe) {
        return new $o(fe);
      };
      function $o(ct) {
        Yn.call(this, ct), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new le(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      ue($o, Yn), $o.prototype.convertTo = function(fe) {
        return this.imod(fe.ushln(this.shift));
      }, $o.prototype.convertFrom = function(fe) {
        var be = this.imod(fe.mul(this.rinv));
        return be.red = null, be;
      }, $o.prototype.imul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return fe.words[0] = 0, fe.length = 1, fe;
        var ye = fe.imul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.mul = function(fe, be) {
        if (fe.isZero() || be.isZero())
          return new le(0)._forceRed(this);
        var ye = fe.mul(be), Se = ye.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), Oe = ye.isub(Se).iushrn(this.shift), Fr = Oe;
        return Oe.cmp(this.m) >= 0 ? Fr = Oe.isub(this.m) : Oe.cmpn(0) < 0 && (Fr = Oe.iadd(this.m)), Fr._forceRed(this);
      }, $o.prototype.invm = function(fe) {
        var be = this.imod(fe._invmp(this.m).mul(this.r2));
        return be._forceRed(this);
      };
    })(v, commonjsGlobal);
  }(bn)), bn.exports;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic)
    return withPublic_1;
  hasRequiredWithPublic = 1;
  var v = requireBn(), y = requireSafeBuffer$2().Buffer;
  function z(ne, ue) {
    return y.from(ne.toRed(v.mont(ue.modulus)).redPow(new v(ue.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = z, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt)
    return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var v = requireParseAsn1(), y = requireBrowser$b(), z = requireBrowser$9(), ne = requireMgf(), ue = requireXor(), le = requireBn(), he = requireWithPublic(), ge = requireBrowserifyRsa(), we = requireSafeBuffer$2().Buffer;
  publicEncrypt = function(st, Nr, br) {
    var $n;
    st.padding ? $n = st.padding : br ? $n = 1 : $n = 4;
    var En = v(st), Rn;
    if ($n === 4)
      Rn = Ee(En, Nr);
    else if ($n === 1)
      Rn = xe(En, Nr, br);
    else if ($n === 3) {
      if (Rn = new le(Nr), Rn.cmp(En.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return br ? ge(Rn, En) : he(Rn, En);
  };
  function Ee(Ne, st) {
    var Nr = Ne.modulus.byteLength(), br = st.length, $n = z("sha1").update(we.alloc(0)).digest(), En = $n.length, Rn = 2 * En;
    if (br > Nr - Rn - 2)
      throw new Error("message too long");
    var wa = we.alloc(Nr - br - Rn - 2), Aa = Nr - En - 1, _a = y(En), Ta = ue(we.concat([$n, wa, we.alloc(1, 1), st], Aa), ne(_a, Aa)), Zn = ue(_a, ne(Ta, En));
    return new le(we.concat([we.alloc(1), Zn, Ta], Nr));
  }
  function xe(Ne, st, Nr) {
    var br = st.length, $n = Ne.modulus.byteLength();
    if (br > $n - 11)
      throw new Error("message too long");
    var En;
    return Nr ? En = we.alloc($n - br - 3, 255) : En = $e($n - br - 3), new le(we.concat([we.from([0, Nr ? 1 : 2]), En, we.alloc(1), st], $n));
  }
  function $e(Ne) {
    for (var st = we.allocUnsafe(Ne), Nr = 0, br = y(Ne * 2), $n = 0, En; Nr < Ne; )
      $n === br.length && (br = y(Ne * 2), $n = 0), En = br[$n++], En && (st[Nr++] = En);
    return st;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt)
    return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var v = requireParseAsn1(), y = requireMgf(), z = requireXor(), ne = requireBn(), ue = requireBrowserifyRsa(), le = requireBrowser$9(), he = requireWithPublic(), ge = requireSafeBuffer$2().Buffer;
  privateDecrypt = function(Ne, st, Nr) {
    var br;
    Ne.padding ? br = Ne.padding : Nr ? br = 1 : br = 4;
    var $n = v(Ne), En = $n.modulus.byteLength();
    if (st.length > En || new ne(st).cmp($n.modulus) >= 0)
      throw new Error("decryption error");
    var Rn;
    Nr ? Rn = he(new ne(st), $n) : Rn = ue(st, $n);
    var wa = ge.alloc(En - Rn.length);
    if (Rn = ge.concat([wa, Rn], En), br === 4)
      return we($n, Rn);
    if (br === 1)
      return Ee($n, Rn, Nr);
    if (br === 3)
      return Rn;
    throw new Error("unknown padding");
  };
  function we($e, Ne) {
    var st = $e.modulus.byteLength(), Nr = le("sha1").update(ge.alloc(0)).digest(), br = Nr.length;
    if (Ne[0] !== 0)
      throw new Error("decryption error");
    var $n = Ne.slice(1, br + 1), En = Ne.slice(br + 1), Rn = z($n, y(En, br)), wa = z(En, y(Rn, st - br - 1));
    if (xe(Nr, wa.slice(0, br)))
      throw new Error("decryption error");
    for (var Aa = br; wa[Aa] === 0; )
      Aa++;
    if (wa[Aa++] !== 1)
      throw new Error("decryption error");
    return wa.slice(Aa);
  }
  function Ee($e, Ne, st) {
    for (var Nr = Ne.slice(0, 2), br = 2, $n = 0; Ne[br++] !== 0; )
      if (br >= Ne.length) {
        $n++;
        break;
      }
    var En = Ne.slice(2, br - 1);
    if ((Nr.toString("hex") !== "0002" && !st || Nr.toString("hex") !== "0001" && st) && $n++, En.length < 8 && $n++, $n)
      throw new Error("decryption error");
    return Ne.slice(br);
  }
  function xe($e, Ne) {
    $e = ge.from($e), Ne = ge.from(Ne);
    var st = 0, Nr = $e.length;
    $e.length !== Ne.length && (st++, Nr = Math.min($e.length, Ne.length));
    for (var br = -1; ++br < Nr; )
      st += $e[br] ^ Ne[br];
    return st;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(v) {
    v.publicEncrypt = requirePublicEncrypt(), v.privateDecrypt = requirePrivateDecrypt(), v.privateEncrypt = function(z, ne) {
      return v.publicEncrypt(z, ne, !0);
    }, v.publicDecrypt = function(z, ne) {
      return v.privateDecrypt(z, ne, !0);
    };
  }(browser$2)), browser$2;
}
var browser$1 = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser$1;
  hasRequiredBrowser = 1;
  function v() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var y = requireSafeBuffer$2(), z = requireBrowser$b(), ne = y.Buffer, ue = y.kMaxLength, le = commonjsGlobal.crypto || commonjsGlobal.msCrypto, he = Math.pow(2, 32) - 1;
  function ge(Ne, st) {
    if (typeof Ne != "number" || Ne !== Ne)
      throw new TypeError("offset must be a number");
    if (Ne > he || Ne < 0)
      throw new TypeError("offset must be a uint32");
    if (Ne > ue || Ne > st)
      throw new RangeError("offset out of range");
  }
  function we(Ne, st, Nr) {
    if (typeof Ne != "number" || Ne !== Ne)
      throw new TypeError("size must be a number");
    if (Ne > he || Ne < 0)
      throw new TypeError("size must be a uint32");
    if (Ne + st > Nr || Ne > ue)
      throw new RangeError("buffer too small");
  }
  le && le.getRandomValues || !process$1.browser ? (browser$1.randomFill = Ee, browser$1.randomFillSync = $e) : (browser$1.randomFill = v, browser$1.randomFillSync = v);
  function Ee(Ne, st, Nr, br) {
    if (!ne.isBuffer(Ne) && !(Ne instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof st == "function")
      br = st, st = 0, Nr = Ne.length;
    else if (typeof Nr == "function")
      br = Nr, Nr = Ne.length - st;
    else if (typeof br != "function")
      throw new TypeError('"cb" argument must be a function');
    return ge(st, Ne.length), we(Nr, st, Ne.length), xe(Ne, st, Nr, br);
  }
  function xe(Ne, st, Nr, br) {
    if (process$1.browser) {
      var $n = Ne.buffer, En = new Uint8Array($n, st, Nr);
      if (le.getRandomValues(En), br) {
        process$1.nextTick(function() {
          br(null, Ne);
        });
        return;
      }
      return Ne;
    }
    if (br) {
      z(Nr, function(wa, Aa) {
        if (wa)
          return br(wa);
        Aa.copy(Ne, st), br(null, Ne);
      });
      return;
    }
    var Rn = z(Nr);
    return Rn.copy(Ne, st), Ne;
  }
  function $e(Ne, st, Nr) {
    if (typeof st > "u" && (st = 0), !ne.isBuffer(Ne) && !(Ne instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return ge(st, Ne.length), Nr === void 0 && (Nr = Ne.length - st), we(Nr, st, Ne.length), xe(Ne, st, Nr);
  }
  return browser$1;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify)
    return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var v = requireAlgos(), y = Object.keys(v), z = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(y);
  cryptoBrowserify.getHashes = function() {
    return z;
  };
  var ne = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = ne.pbkdf2, cryptoBrowserify.pbkdf2Sync = ne.pbkdf2Sync;
  var ue = requireBrowser$5();
  cryptoBrowserify.Cipher = ue.Cipher, cryptoBrowserify.createCipher = ue.createCipher, cryptoBrowserify.Cipheriv = ue.Cipheriv, cryptoBrowserify.createCipheriv = ue.createCipheriv, cryptoBrowserify.Decipher = ue.Decipher, cryptoBrowserify.createDecipher = ue.createDecipher, cryptoBrowserify.Decipheriv = ue.Decipheriv, cryptoBrowserify.createDecipheriv = ue.createDecipheriv, cryptoBrowserify.getCiphers = ue.getCiphers, cryptoBrowserify.listCiphers = ue.listCiphers;
  var le = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = le.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = le.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = le.getDiffieHellman, cryptoBrowserify.createDiffieHellman = le.createDiffieHellman, cryptoBrowserify.DiffieHellman = le.DiffieHellman;
  var he = requireBrowser$3();
  cryptoBrowserify.createSign = he.createSign, cryptoBrowserify.Sign = he.Sign, cryptoBrowserify.createVerify = he.createVerify, cryptoBrowserify.Verify = he.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var ge = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = ge.publicEncrypt, cryptoBrowserify.privateEncrypt = ge.privateEncrypt, cryptoBrowserify.publicDecrypt = ge.publicDecrypt, cryptoBrowserify.privateDecrypt = ge.privateDecrypt;
  var we = requireBrowser();
  return cryptoBrowserify.randomFill = we.randomFill, cryptoBrowserify.randomFillSync = we.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var __createBinding$6 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$5 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$6 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$6(y, v, z);
  return __setModuleDefault$5(y, v), y;
};
Object.defineProperty(pbkdf2$2, "__esModule", { value: !0 });
pbkdf2$2.pbkdf2Sha512 = pbkdf2$2.pbkdf2Sha512Noble = pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2$2.getSubtle = pbkdf2$2.getNodeCrypto = void 0;
const utils_1$8 = build$2, pbkdf2_1$1 = pbkdf2$1, sha512_1$1 = sha512$3;
async function getNodeCrypto() {
  try {
    const v = await Promise.resolve().then(() => __importStar$6(requireCryptoBrowserify()));
    return typeof v == "object" && Object.keys(v).length <= 1 ? void 0 : v;
  } catch {
    return;
  }
}
pbkdf2$2.getNodeCrypto = getNodeCrypto;
async function getSubtle() {
  var y, z, ne;
  let v = (y = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : y.subtle;
  return v || (v = (ne = (z = globalThis == null ? void 0 : globalThis.crypto) == null ? void 0 : z.webcrypto) == null ? void 0 : ne.subtle), v;
}
pbkdf2$2.getSubtle = getSubtle;
async function pbkdf2Sha512Subtle(v, y, z, ne, ue) {
  return (0, utils_1$8.assert)(v, "Argument subtle is falsy"), (0, utils_1$8.assert)(typeof v == "object", "Argument subtle is not of type object"), (0, utils_1$8.assert)(typeof v.importKey == "function", "subtle.importKey is not a function"), (0, utils_1$8.assert)(typeof v.deriveBits == "function", "subtle.deriveBits is not a function"), v.importKey("raw", y, { name: "PBKDF2" }, !1, ["deriveBits"]).then((le) => v.deriveBits({
    name: "PBKDF2",
    salt: z,
    iterations: ne,
    hash: { name: "SHA-512" }
  }, le, ue * 8).then((he) => new Uint8Array(he)));
}
pbkdf2$2.pbkdf2Sha512Subtle = pbkdf2Sha512Subtle;
async function pbkdf2Sha512NodeCrypto(v, y, z, ne, ue) {
  return (0, utils_1$8.assert)(v, "Argument nodeCrypto is falsy"), (0, utils_1$8.assert)(typeof v == "object", "Argument nodeCrypto is not of type object"), (0, utils_1$8.assert)(typeof v.pbkdf2 == "function", "nodeCrypto.pbkdf2 is not a function"), new Promise((le, he) => {
    v.pbkdf2(y, z, ne, ue, "sha512", (ge, we) => {
      ge ? he(ge) : le(Uint8Array.from(we));
    });
  });
}
pbkdf2$2.pbkdf2Sha512NodeCrypto = pbkdf2Sha512NodeCrypto;
async function pbkdf2Sha512Noble(v, y, z, ne) {
  return (0, pbkdf2_1$1.pbkdf2Async)(sha512_1$1.sha512, v, y, { c: z, dkLen: ne });
}
pbkdf2$2.pbkdf2Sha512Noble = pbkdf2Sha512Noble;
async function pbkdf2Sha512(v, y, z, ne) {
  const ue = await getSubtle();
  if (ue)
    return pbkdf2Sha512Subtle(ue, v, y, z, ne);
  {
    const le = await getNodeCrypto();
    return le ? pbkdf2Sha512NodeCrypto(le, v, y, z, ne) : pbkdf2Sha512Noble(v, y, z, ne);
  }
}
pbkdf2$2.pbkdf2Sha512 = pbkdf2Sha512;
var sha = {}, sha256$2 = {};
Object.defineProperty(sha256$2, "__esModule", { value: !0 });
sha256$2.sha224 = sha256$2.sha256 = void 0;
const _md_js_1$1 = _md, utils_js_1$2 = utils$p, SHA256_K = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), SHA256_IV = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _md_js_1$1.HashMD {
  constructor() {
    super(64, 32, 8, !1), this.A = SHA256_IV[0] | 0, this.B = SHA256_IV[1] | 0, this.C = SHA256_IV[2] | 0, this.D = SHA256_IV[3] | 0, this.E = SHA256_IV[4] | 0, this.F = SHA256_IV[5] | 0, this.G = SHA256_IV[6] | 0, this.H = SHA256_IV[7] | 0;
  }
  get() {
    const { A: y, B: z, C: ne, D: ue, E: le, F: he, G: ge, H: we } = this;
    return [y, z, ne, ue, le, he, ge, we];
  }
  // prettier-ignore
  set(y, z, ne, ue, le, he, ge, we) {
    this.A = y | 0, this.B = z | 0, this.C = ne | 0, this.D = ue | 0, this.E = le | 0, this.F = he | 0, this.G = ge | 0, this.H = we | 0;
  }
  process(y, z) {
    for (let $e = 0; $e < 16; $e++, z += 4)
      SHA256_W[$e] = y.getUint32(z, !1);
    for (let $e = 16; $e < 64; $e++) {
      const Ne = SHA256_W[$e - 15], st = SHA256_W[$e - 2], Nr = (0, utils_js_1$2.rotr)(Ne, 7) ^ (0, utils_js_1$2.rotr)(Ne, 18) ^ Ne >>> 3, br = (0, utils_js_1$2.rotr)(st, 17) ^ (0, utils_js_1$2.rotr)(st, 19) ^ st >>> 10;
      SHA256_W[$e] = br + SHA256_W[$e - 7] + Nr + SHA256_W[$e - 16] | 0;
    }
    let { A: ne, B: ue, C: le, D: he, E: ge, F: we, G: Ee, H: xe } = this;
    for (let $e = 0; $e < 64; $e++) {
      const Ne = (0, utils_js_1$2.rotr)(ge, 6) ^ (0, utils_js_1$2.rotr)(ge, 11) ^ (0, utils_js_1$2.rotr)(ge, 25), st = xe + Ne + (0, _md_js_1$1.Chi)(ge, we, Ee) + SHA256_K[$e] + SHA256_W[$e] | 0, br = ((0, utils_js_1$2.rotr)(ne, 2) ^ (0, utils_js_1$2.rotr)(ne, 13) ^ (0, utils_js_1$2.rotr)(ne, 22)) + (0, _md_js_1$1.Maj)(ne, ue, le) | 0;
      xe = Ee, Ee = we, we = ge, ge = he + st | 0, he = le, le = ue, ue = ne, ne = st + br | 0;
    }
    ne = ne + this.A | 0, ue = ue + this.B | 0, le = le + this.C | 0, he = he + this.D | 0, ge = ge + this.E | 0, we = we + this.F | 0, Ee = Ee + this.G | 0, xe = xe + this.H | 0, this.set(ne, ue, le, he, ge, we, Ee, xe);
  }
  roundClean() {
    SHA256_W.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class SHA224 extends SHA256 {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
sha256$2.sha256 = (0, utils_js_1$2.wrapConstructor)(() => new SHA256());
sha256$2.sha224 = (0, utils_js_1$2.wrapConstructor)(() => new SHA224());
var utils$1 = {};
Object.defineProperty(utils$1, "__esModule", { value: !0 });
utils$1.toRealUint8Array = void 0;
function toRealUint8Array(v) {
  return v instanceof Uint8Array ? v : Uint8Array.from(v);
}
utils$1.toRealUint8Array = toRealUint8Array;
Object.defineProperty(sha, "__esModule", { value: !0 });
sha.sha512 = sha.Sha512 = sha.sha256 = sha.Sha256 = void 0;
const sha256_1 = sha256$2, sha512_1 = sha512$3, utils_1$7 = utils$1;
class Sha256 {
  constructor(y) {
    this.blockSize = 512 / 8, this.impl = sha256_1.sha256.create(), y && this.update(y);
  }
  update(y) {
    return this.impl.update((0, utils_1$7.toRealUint8Array)(y)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha256 = Sha256;
function sha256$1(v) {
  return new Sha256(v).digest();
}
sha.sha256 = sha256$1;
class Sha512 {
  constructor(y) {
    this.blockSize = 1024 / 8, this.impl = sha512_1.sha512.create(), y && this.update(y);
  }
  update(y) {
    return this.impl.update((0, utils_1$7.toRealUint8Array)(y)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
sha.Sha512 = Sha512;
function sha512(v) {
  return new Sha512(v).digest();
}
sha.sha512 = sha512;
Object.defineProperty(bip39, "__esModule", { value: !0 });
bip39.Bip39 = bip39.EnglishMnemonic = bip39.mnemonicToEntropy = bip39.entropyToMnemonic = void 0;
const encoding_1$b = build$3, pbkdf2_1 = pbkdf2$2, sha_1 = sha, wordlist = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
function bytesToBitstring(v) {
  return Array.from(v).map((y) => y.toString(2).padStart(8, "0")).join("");
}
function deriveChecksumBits(v) {
  const z = v.length * 8 / 32, ne = (0, sha_1.sha256)(v);
  return bytesToBitstring(ne).slice(0, z);
}
function bitstringToByte(v) {
  return parseInt(v, 2);
}
const allowedEntropyLengths = [16, 20, 24, 28, 32], allowedWordLengths = [12, 15, 18, 21, 24];
function entropyToMnemonic(v) {
  if (allowedEntropyLengths.indexOf(v.length) === -1)
    throw new Error("invalid input length");
  const y = bytesToBitstring(v), z = deriveChecksumBits(v);
  return (y + z).match(/(.{11})/g).map((he) => {
    const ge = bitstringToByte(he);
    return wordlist[ge];
  }).join(" ");
}
bip39.entropyToMnemonic = entropyToMnemonic;
const invalidNumberOfWorks = "Invalid number of words", wordNotInWordlist = "Found word that is not in the wordlist", invalidEntropy = "Invalid entropy", invalidChecksum = "Invalid mnemonic checksum";
function normalize(v) {
  return v.normalize("NFKD");
}
function mnemonicToEntropy(v) {
  const y = normalize(v).split(" ");
  if (!allowedWordLengths.includes(y.length))
    throw new Error(invalidNumberOfWorks);
  const z = y.map((Ee) => {
    const xe = wordlist.indexOf(Ee);
    if (xe === -1)
      throw new Error(wordNotInWordlist);
    return xe.toString(2).padStart(11, "0");
  }).join(""), ne = Math.floor(z.length / 33) * 32, ue = z.slice(0, ne), le = z.slice(ne), he = ue.match(/(.{1,8})/g).map(bitstringToByte);
  if (he.length < 16 || he.length > 32 || he.length % 4 !== 0)
    throw new Error(invalidEntropy);
  const ge = Uint8Array.from(he);
  if (deriveChecksumBits(ge) !== le)
    throw new Error(invalidChecksum);
  return ge;
}
bip39.mnemonicToEntropy = mnemonicToEntropy;
class EnglishMnemonic {
  constructor(y) {
    if (!EnglishMnemonic.mnemonicMatcher.test(y))
      throw new Error("Invalid mnemonic format");
    const z = y.split(" "), ne = [12, 15, 18, 21, 24];
    if (ne.indexOf(z.length) === -1)
      throw new Error(`Invalid word count in mnemonic (allowed: ${ne} got: ${z.length})`);
    for (const ue of z)
      if (EnglishMnemonic.wordlist.indexOf(ue) === -1)
        throw new Error("Mnemonic contains invalid word");
    mnemonicToEntropy(y), this.data = y;
  }
  toString() {
    return this.data;
  }
}
bip39.EnglishMnemonic = EnglishMnemonic;
EnglishMnemonic.wordlist = wordlist;
EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class Bip39 {
  /**
   * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
   *
   * | Entropy            | Words |
   * |--------------------|-------|
   * | 128 bit (16 bytes) |    12 |
   * | 160 bit (20 bytes) |    15 |
   * | 192 bit (24 bytes) |    18 |
   * | 224 bit (28 bytes) |    21 |
   * | 256 bit (32 bytes) |    24 |
   *
   *
   * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
   * @param entropy The entropy to be encoded. This must be cryptographically secure.
   */
  static encode(y) {
    return new EnglishMnemonic(entropyToMnemonic(y));
  }
  static decode(y) {
    return mnemonicToEntropy(y.toString());
  }
  static async mnemonicToSeed(y, z) {
    const ne = (0, encoding_1$b.toUtf8)(normalize(y.toString())), ue = "mnemonic" + (z ? normalize(z) : ""), le = (0, encoding_1$b.toUtf8)(ue);
    return (0, pbkdf2_1.pbkdf2Sha512)(ne, le, 2048, 64);
  }
}
bip39.Bip39 = Bip39;
var hmac$2 = {};
Object.defineProperty(hmac$2, "__esModule", { value: !0 });
hmac$2.Hmac = void 0;
class Hmac {
  constructor(y, z) {
    const ne = new y().blockSize;
    this.hash = (le) => new y().update(le).digest();
    let ue = z;
    if (ue.length > ne && (ue = this.hash(ue)), ue.length < ne) {
      const le = new Uint8Array(ne - ue.length);
      ue = new Uint8Array([...ue, ...le]);
    }
    this.oKeyPad = ue.map((le) => le ^ 92), this.iKeyPad = ue.map((le) => le ^ 54), this.messageHasher = new y(), this.blockSize = ne, this.update(this.iKeyPad);
  }
  update(y) {
    return this.messageHasher.update(y), this;
  }
  digest() {
    const y = this.messageHasher.digest();
    return this.hash(new Uint8Array([...this.oKeyPad, ...y]));
  }
}
hmac$2.Hmac = Hmac;
var keccak = {}, sha3 = {};
Object.defineProperty(sha3, "__esModule", { value: !0 });
sha3.shake256 = sha3.shake128 = sha3.keccak_512 = sha3.keccak_384 = sha3.keccak_256 = sha3.keccak_224 = sha3.sha3_512 = sha3.sha3_384 = sha3.sha3_256 = sha3.sha3_224 = sha3.Keccak = sha3.keccakP = void 0;
const _assert_js_1 = _assert, _u64_js_1 = _u64, utils_js_1$1 = utils$p, SHA3_PI = [], SHA3_ROTL = [], _SHA3_IOTA = [], _0n = /* @__PURE__ */ BigInt(0), _1n = /* @__PURE__ */ BigInt(1), _2n = /* @__PURE__ */ BigInt(2), _7n = /* @__PURE__ */ BigInt(7), _256n = /* @__PURE__ */ BigInt(256), _0x71n = /* @__PURE__ */ BigInt(113);
for (let v = 0, y = _1n, z = 1, ne = 0; v < 24; v++) {
  [z, ne] = [ne, (2 * z + 3 * ne) % 5], SHA3_PI.push(2 * (5 * ne + z)), SHA3_ROTL.push((v + 1) * (v + 2) / 2 % 64);
  let ue = _0n;
  for (let le = 0; le < 7; le++)
    y = (y << _1n ^ (y >> _7n) * _0x71n) % _256n, y & _2n && (ue ^= _1n << (_1n << /* @__PURE__ */ BigInt(le)) - _1n);
  _SHA3_IOTA.push(ue);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, !0), rotlH = (v, y, z) => z > 32 ? (0, _u64_js_1.rotlBH)(v, y, z) : (0, _u64_js_1.rotlSH)(v, y, z), rotlL = (v, y, z) => z > 32 ? (0, _u64_js_1.rotlBL)(v, y, z) : (0, _u64_js_1.rotlSL)(v, y, z);
function keccakP(v, y = 24) {
  const z = new Uint32Array(10);
  for (let ne = 24 - y; ne < 24; ne++) {
    for (let he = 0; he < 10; he++)
      z[he] = v[he] ^ v[he + 10] ^ v[he + 20] ^ v[he + 30] ^ v[he + 40];
    for (let he = 0; he < 10; he += 2) {
      const ge = (he + 8) % 10, we = (he + 2) % 10, Ee = z[we], xe = z[we + 1], $e = rotlH(Ee, xe, 1) ^ z[ge], Ne = rotlL(Ee, xe, 1) ^ z[ge + 1];
      for (let st = 0; st < 50; st += 10)
        v[he + st] ^= $e, v[he + st + 1] ^= Ne;
    }
    let ue = v[2], le = v[3];
    for (let he = 0; he < 24; he++) {
      const ge = SHA3_ROTL[he], we = rotlH(ue, le, ge), Ee = rotlL(ue, le, ge), xe = SHA3_PI[he];
      ue = v[xe], le = v[xe + 1], v[xe] = we, v[xe + 1] = Ee;
    }
    for (let he = 0; he < 50; he += 10) {
      for (let ge = 0; ge < 10; ge++)
        z[ge] = v[he + ge];
      for (let ge = 0; ge < 10; ge++)
        v[he + ge] ^= ~z[(ge + 2) % 10] & z[(ge + 4) % 10];
    }
    v[0] ^= SHA3_IOTA_H[ne], v[1] ^= SHA3_IOTA_L[ne];
  }
  z.fill(0);
}
sha3.keccakP = keccakP;
class Keccak extends utils_js_1$1.Hash {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(y, z, ne, ue = !1, le = 24) {
    if (super(), this.blockLen = y, this.suffix = z, this.outputLen = ne, this.enableXOF = ue, this.rounds = le, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, (0, _assert_js_1.number)(ne), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = (0, utils_js_1$1.u32)(this.state);
  }
  keccak() {
    utils_js_1$1.isLE || (0, utils_js_1$1.byteSwap32)(this.state32), keccakP(this.state32, this.rounds), utils_js_1$1.isLE || (0, utils_js_1$1.byteSwap32)(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(y) {
    (0, _assert_js_1.exists)(this);
    const { blockLen: z, state: ne } = this;
    y = (0, utils_js_1$1.toBytes)(y);
    const ue = y.length;
    for (let le = 0; le < ue; ) {
      const he = Math.min(z - this.pos, ue - le);
      for (let ge = 0; ge < he; ge++)
        ne[this.pos++] ^= y[le++];
      this.pos === z && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: y, suffix: z, pos: ne, blockLen: ue } = this;
    y[ne] ^= z, z & 128 && ne === ue - 1 && this.keccak(), y[ue - 1] ^= 128, this.keccak();
  }
  writeInto(y) {
    (0, _assert_js_1.exists)(this, !1), (0, _assert_js_1.bytes)(y), this.finish();
    const z = this.state, { blockLen: ne } = this;
    for (let ue = 0, le = y.length; ue < le; ) {
      this.posOut >= ne && this.keccak();
      const he = Math.min(ne - this.posOut, le - ue);
      y.set(z.subarray(this.posOut, this.posOut + he), ue), this.posOut += he, ue += he;
    }
    return y;
  }
  xofInto(y) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(y);
  }
  xof(y) {
    return (0, _assert_js_1.number)(y), this.xofInto(new Uint8Array(y));
  }
  digestInto(y) {
    if ((0, _assert_js_1.output)(y, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(y), this.destroy(), y;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(y) {
    const { blockLen: z, suffix: ne, outputLen: ue, rounds: le, enableXOF: he } = this;
    return y || (y = new Keccak(z, ne, ue, he, le)), y.state32.set(this.state32), y.pos = this.pos, y.posOut = this.posOut, y.finished = this.finished, y.rounds = le, y.suffix = ne, y.outputLen = ue, y.enableXOF = he, y.destroyed = this.destroyed, y;
  }
}
sha3.Keccak = Keccak;
const gen = (v, y, z) => (0, utils_js_1$1.wrapConstructor)(() => new Keccak(y, v, z));
sha3.sha3_224 = gen(6, 144, 224 / 8);
sha3.sha3_256 = gen(6, 136, 256 / 8);
sha3.sha3_384 = gen(6, 104, 384 / 8);
sha3.sha3_512 = gen(6, 72, 512 / 8);
sha3.keccak_224 = gen(1, 144, 224 / 8);
sha3.keccak_256 = gen(1, 136, 256 / 8);
sha3.keccak_384 = gen(1, 104, 384 / 8);
sha3.keccak_512 = gen(1, 72, 512 / 8);
const genShake = (v, y, z) => (0, utils_js_1$1.wrapXOFConstructorWithOpts)((ne = {}) => new Keccak(y, v, ne.dkLen === void 0 ? z : ne.dkLen, !0));
sha3.shake128 = genShake(31, 168, 128 / 8);
sha3.shake256 = genShake(31, 136, 256 / 8);
Object.defineProperty(keccak, "__esModule", { value: !0 });
keccak.keccak256 = keccak.Keccak256 = void 0;
const sha3_1 = sha3, utils_1$6 = utils$1;
class Keccak256 {
  constructor(y) {
    this.blockSize = 512 / 8, this.impl = sha3_1.keccak_256.create(), y && this.update(y);
  }
  update(y) {
    return this.impl.update((0, utils_1$6.toRealUint8Array)(y)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
keccak.Keccak256 = Keccak256;
function keccak256(v) {
  return new Keccak256(v).digest();
}
keccak.keccak256 = keccak256;
var libsodium = {}, __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(libsodium, "__esModule", { value: !0 });
libsodium.Xchacha20poly1305Ietf = libsodium.xchacha20NonceLength = libsodium.Ed25519 = libsodium.Ed25519Keypair = libsodium.Argon2id = libsodium.isArgon2idOptions = void 0;
const utils_1$5 = build$2, libsodium_wrappers_sumo_1 = __importDefault$5(require$$1$2);
function isArgon2idOptions(v) {
  return !(!(0, utils_1$5.isNonNullObject)(v) || typeof v.outputLength != "number" || typeof v.opsLimit != "number" || typeof v.memLimitKib != "number");
}
libsodium.isArgon2idOptions = isArgon2idOptions;
class Argon2id {
  static async execute(y, z, ne) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_pwhash(
      ne.outputLength,
      y,
      z,
      // libsodium only supports 16 byte salts and will throw when you don't respect that
      ne.opsLimit,
      ne.memLimitKib * 1024,
      libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13
    );
  }
}
libsodium.Argon2id = Argon2id;
class Ed25519Keypair {
  // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
  static fromLibsodiumPrivkey(y) {
    if (y.length !== 64)
      throw new Error(`Unexpected key length ${y.length}. Must be 64.`);
    return new Ed25519Keypair(y.slice(0, 32), y.slice(32, 64));
  }
  constructor(y, z) {
    this.privkey = y, this.pubkey = z;
  }
  toLibsodiumPrivkey() {
    return new Uint8Array([...this.privkey, ...this.pubkey]);
  }
}
libsodium.Ed25519Keypair = Ed25519Keypair;
class Ed25519 {
  /**
   * Generates a keypair deterministically from a given 32 bytes seed.
   *
   * This seed equals the Ed25519 private key.
   * For implementation details see crypto_sign_seed_keypair in
   * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
   * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  static async makeKeypair(y) {
    await libsodium_wrappers_sumo_1.default.ready;
    const z = libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(y);
    return Ed25519Keypair.fromLibsodiumPrivkey(z.privateKey);
  }
  static async createSignature(y, z) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_detached(y, z.toLibsodiumPrivkey());
  }
  static async verifySignature(y, z, ne) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(y, z, ne);
  }
}
libsodium.Ed25519 = Ed25519;
libsodium.xchacha20NonceLength = 24;
class Xchacha20poly1305Ietf {
  static async encrypt(y, z, ne) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(
      y,
      null,
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      ne,
      z
    );
  }
  static async decrypt(y, z, ne) {
    return await libsodium_wrappers_sumo_1.default.ready, libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(
      null,
      // secret nonce: unused and should be null (https://download.libsodium.org/doc/secret-key_cryptography/aead/chacha20-poly1305/xchacha20-poly1305_construction)
      y,
      null,
      ne,
      z
    );
  }
}
libsodium.Xchacha20poly1305Ietf = Xchacha20poly1305Ietf;
var random$1 = {};
Object.defineProperty(random$1, "__esModule", { value: !0 });
random$1.Random = void 0;
class Random {
  /**
   * Returns `count` cryptographically secure random bytes
   */
  static getBytes(y) {
    try {
      const z = typeof window == "object" ? window : self, ne = typeof z.crypto < "u" ? z.crypto : z.msCrypto, ue = new Uint8Array(y);
      return ne.getRandomValues(ue), ue;
    } catch {
      try {
        const z = requireCryptoBrowserify();
        return new Uint8Array([...z.randomBytes(y)]);
      } catch {
        throw new Error("No secure random number generator found");
      }
    }
  }
}
random$1.Random = Random;
var ripemd = {}, ripemd160$1 = {};
Object.defineProperty(ripemd160$1, "__esModule", { value: !0 });
ripemd160$1.ripemd160 = ripemd160$1.RIPEMD160 = void 0;
const _md_js_1 = _md, utils_js_1 = utils$p, Rho = /* @__PURE__ */ new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((v, y) => y)), Pi = /* @__PURE__ */ Id.map((v) => (9 * v + 5) % 16);
let idxL = [Id], idxR = [Pi];
for (let v = 0; v < 4; v++)
  for (let y of [idxL, idxR])
    y.push(y[v].map((z) => Rho[z]));
const shifts = /* @__PURE__ */ [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((v) => new Uint8Array(v)), shiftsL = /* @__PURE__ */ idxL.map((v, y) => v.map((z) => shifts[y][z])), shiftsR = /* @__PURE__ */ idxR.map((v, y) => v.map((z) => shifts[y][z])), Kl = /* @__PURE__ */ new Uint32Array([
  0,
  1518500249,
  1859775393,
  2400959708,
  2840853838
]), Kr = /* @__PURE__ */ new Uint32Array([
  1352829926,
  1548603684,
  1836072691,
  2053994217,
  0
]);
function f(v, y, z, ne) {
  return v === 0 ? y ^ z ^ ne : v === 1 ? y & z | ~y & ne : v === 2 ? (y | ~z) ^ ne : v === 3 ? y & ne | z & ~ne : y ^ (z | ~ne);
}
const R_BUF = /* @__PURE__ */ new Uint32Array(16);
class RIPEMD160 extends _md_js_1.HashMD {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: y, h1: z, h2: ne, h3: ue, h4: le } = this;
    return [y, z, ne, ue, le];
  }
  set(y, z, ne, ue, le) {
    this.h0 = y | 0, this.h1 = z | 0, this.h2 = ne | 0, this.h3 = ue | 0, this.h4 = le | 0;
  }
  process(y, z) {
    for (let st = 0; st < 16; st++, z += 4)
      R_BUF[st] = y.getUint32(z, !0);
    let ne = this.h0 | 0, ue = ne, le = this.h1 | 0, he = le, ge = this.h2 | 0, we = ge, Ee = this.h3 | 0, xe = Ee, $e = this.h4 | 0, Ne = $e;
    for (let st = 0; st < 5; st++) {
      const Nr = 4 - st, br = Kl[st], $n = Kr[st], En = idxL[st], Rn = idxR[st], wa = shiftsL[st], Aa = shiftsR[st];
      for (let _a = 0; _a < 16; _a++) {
        const Ta = (0, utils_js_1.rotl)(ne + f(st, le, ge, Ee) + R_BUF[En[_a]] + br, wa[_a]) + $e | 0;
        ne = $e, $e = Ee, Ee = (0, utils_js_1.rotl)(ge, 10) | 0, ge = le, le = Ta;
      }
      for (let _a = 0; _a < 16; _a++) {
        const Ta = (0, utils_js_1.rotl)(ue + f(Nr, he, we, xe) + R_BUF[Rn[_a]] + $n, Aa[_a]) + Ne | 0;
        ue = Ne, Ne = xe, xe = (0, utils_js_1.rotl)(we, 10) | 0, we = he, he = Ta;
      }
    }
    this.set(this.h1 + ge + xe | 0, this.h2 + Ee + Ne | 0, this.h3 + $e + ue | 0, this.h4 + ne + he | 0, this.h0 + le + we | 0);
  }
  roundClean() {
    R_BUF.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
ripemd160$1.RIPEMD160 = RIPEMD160;
ripemd160$1.ripemd160 = (0, utils_js_1.wrapConstructor)(() => new RIPEMD160());
Object.defineProperty(ripemd, "__esModule", { value: !0 });
ripemd.ripemd160 = ripemd.Ripemd160 = void 0;
const ripemd160_1 = ripemd160$1, utils_1$4 = utils$1;
class Ripemd160 {
  constructor(y) {
    this.blockSize = 512 / 8, this.impl = ripemd160_1.ripemd160.create(), y && this.update(y);
  }
  update(y) {
    return this.impl.update((0, utils_1$4.toRealUint8Array)(y)), this;
  }
  digest() {
    return this.impl.digest();
  }
}
ripemd.Ripemd160 = Ripemd160;
function ripemd160(v) {
  return new Ripemd160(v).digest();
}
ripemd.ripemd160 = ripemd160;
var secp256k1$1 = {}, secp256k1signature = {};
Object.defineProperty(secp256k1signature, "__esModule", { value: !0 });
secp256k1signature.ExtendedSecp256k1Signature = secp256k1signature.Secp256k1Signature = void 0;
function trimLeadingNullBytes(v) {
  let y = 0;
  for (const z of v)
    if (z === 0)
      y++;
    else
      break;
  return v.slice(y);
}
const derTagInteger = 2;
class Secp256k1Signature {
  /**
   * Takes the pair of integers (r, s) as 2x32 byte of binary data.
   *
   * Note: This is the format Cosmos SDK uses natively.
   *
   * @param data a 64 byte value containing integers r and s.
   */
  static fromFixedLength(y) {
    if (y.length !== 64)
      throw new Error(`Got invalid data length: ${y.length}. Expected 2x 32 bytes for the pair (r, s)`);
    return new Secp256k1Signature(trimLeadingNullBytes(y.slice(0, 32)), trimLeadingNullBytes(y.slice(32, 64)));
  }
  static fromDer(y) {
    let z = 0;
    if (y[z++] !== 48)
      throw new Error("Prefix 0x30 expected");
    const ne = y[z++];
    if (y.length - z !== ne)
      throw new Error("Data length mismatch detected");
    if (y[z++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const le = y[z++];
    if (le >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const he = y.slice(z, z + le);
    if (z += le, y[z++] !== derTagInteger)
      throw new Error("INTEGER tag expected");
    const we = y[z++];
    if (we >= 128)
      throw new Error("Decoding length values above 127 not supported");
    const Ee = y.slice(z, z + we);
    return z += we, new Secp256k1Signature(
      // r/s data can contain leading 0 bytes to express integers being non-negative in DER
      trimLeadingNullBytes(he),
      trimLeadingNullBytes(Ee)
    );
  }
  constructor(y, z) {
    if (y.length > 32 || y.length === 0 || y[0] === 0)
      throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
    if (z.length > 32 || z.length === 0 || z[0] === 0)
      throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
    this.data = {
      r: y,
      s: z
    };
  }
  r(y) {
    if (y === void 0)
      return this.data.r;
    {
      const z = y - this.data.r.length;
      if (z < 0)
        throw new Error("Length too small to hold parameter r");
      const ne = new Uint8Array(z);
      return new Uint8Array([...ne, ...this.data.r]);
    }
  }
  s(y) {
    if (y === void 0)
      return this.data.s;
    {
      const z = y - this.data.s.length;
      if (z < 0)
        throw new Error("Length too small to hold parameter s");
      const ne = new Uint8Array(z);
      return new Uint8Array([...ne, ...this.data.s]);
    }
  }
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32)]);
  }
  toDer() {
    const y = this.data.r[0] >= 128 ? new Uint8Array([0, ...this.data.r]) : this.data.r, z = this.data.s[0] >= 128 ? new Uint8Array([0, ...this.data.s]) : this.data.s, ne = y.length, ue = z.length, le = new Uint8Array([derTagInteger, ne, ...y, derTagInteger, ue, ...z]);
    return new Uint8Array([48, le.length, ...le]);
  }
}
secp256k1signature.Secp256k1Signature = Secp256k1Signature;
class ExtendedSecp256k1Signature extends Secp256k1Signature {
  /**
   * Decode extended signature from the simple fixed length encoding
   * described in toFixedLength().
   */
  static fromFixedLength(y) {
    if (y.length !== 65)
      throw new Error(`Got invalid data length ${y.length}. Expected 32 + 32 + 1`);
    return new ExtendedSecp256k1Signature(trimLeadingNullBytes(y.slice(0, 32)), trimLeadingNullBytes(y.slice(32, 64)), y[64]);
  }
  constructor(y, z, ne) {
    if (super(y, z), !Number.isInteger(ne))
      throw new Error("The recovery parameter must be an integer.");
    if (ne < 0 || ne > 4)
      throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
    this.recovery = ne;
  }
  /**
   * A simple custom encoding that encodes the extended signature as
   * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
   * where | denotes concatenation of bonary data.
   */
  toFixedLength() {
    return new Uint8Array([...this.r(32), ...this.s(32), this.recovery]);
  }
}
secp256k1signature.ExtendedSecp256k1Signature = ExtendedSecp256k1Signature;
var __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(secp256k1$1, "__esModule", { value: !0 });
secp256k1$1.Secp256k1 = void 0;
const encoding_1$a = build$3, bn_js_1$2 = __importDefault$4(bnExports$1), elliptic_1 = __importDefault$4(requireElliptic()), secp256k1signature_1 = secp256k1signature, secp256k1 = new elliptic_1.default.ec("secp256k1"), secp256k1N = new bn_js_1$2.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class Secp256k1 {
  /**
   * Takes a 32 byte private key and returns a privkey/pubkey pair.
   *
   * The resulting pubkey is uncompressed. For the use in Cosmos it should
   * be compressed first using `Secp256k1.compressPubkey`.
   */
  static async makeKeypair(y) {
    if (y.length !== 32)
      throw new Error("input data is not a valid secp256k1 private key");
    const z = secp256k1.keyFromPrivate(y);
    if (z.validate().result !== !0)
      throw new Error("input data is not a valid secp256k1 private key");
    if (new bn_js_1$2.default(y).gte(secp256k1N))
      throw new Error("input data is not a valid secp256k1 private key");
    return {
      privkey: (0, encoding_1$a.fromHex)(z.getPrivate("hex")),
      // encodes uncompressed as
      // - 1-byte prefix "04"
      // - 32-byte x coordinate
      // - 32-byte y coordinate
      pubkey: Uint8Array.from(z.getPublic("array"))
    };
  }
  /**
   * Creates a signature that is
   * - deterministic (RFC 6979)
   * - lowS signature
   * - DER encoded
   */
  static async createSignature(y, z) {
    if (y.length === 0)
      throw new Error("Message hash must not be empty");
    if (y.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const ne = secp256k1.keyFromPrivate(z), { r: ue, s: le, recoveryParam: he } = ne.sign(y, { canonical: !0 });
    if (typeof he != "number")
      throw new Error("Recovery param missing");
    return new secp256k1signature_1.ExtendedSecp256k1Signature(Uint8Array.from(ue.toArray()), Uint8Array.from(le.toArray()), he);
  }
  static async verifySignature(y, z, ne) {
    if (z.length === 0)
      throw new Error("Message hash must not be empty");
    if (z.length > 32)
      throw new Error("Message hash length must not exceed 32 bytes");
    const ue = secp256k1.keyFromPublic(ne);
    try {
      return ue.verify(z, y.toDer());
    } catch {
      return !1;
    }
  }
  static recoverPubkey(y, z) {
    const ne = { r: (0, encoding_1$a.toHex)(y.r()), s: (0, encoding_1$a.toHex)(y.s()) }, ue = secp256k1.recoverPubKey(z, ne, y.recovery), le = secp256k1.keyFromPublic(ue);
    return (0, encoding_1$a.fromHex)(le.getPublic(!1, "hex"));
  }
  /**
   * Takes a compressed or uncompressed pubkey and return a compressed one.
   *
   * This function is idempotent.
   */
  static compressPubkey(y) {
    switch (y.length) {
      case 33:
        return y;
      case 65:
        return Uint8Array.from(secp256k1.keyFromPublic(y).getPublic(!0, "array"));
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  /**
   * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
   *
   * This function is idempotent.
   */
  static uncompressPubkey(y) {
    switch (y.length) {
      case 33:
        return Uint8Array.from(secp256k1.keyFromPublic(y).getPublic(!1, "array"));
      case 65:
        return y;
      default:
        throw new Error("Invalid pubkey length");
    }
  }
  static trimRecoveryByte(y) {
    switch (y.length) {
      case 64:
        return y;
      case 65:
        return y.slice(0, 64);
      default:
        throw new Error("Invalid signature length");
    }
  }
}
secp256k1$1.Secp256k1 = Secp256k1;
var slip10 = {}, build$1 = {}, decimal = {}, __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(decimal, "__esModule", { value: !0 });
decimal.Decimal = void 0;
const bn_js_1$1 = __importDefault$3(bnExports$1), maxFractionalDigits = 100;
class Decimal {
  static fromUserInput(y, z) {
    Decimal.verifyFractionalDigits(z);
    const ne = y.match(/[^0-9.]/);
    if (ne)
      throw new Error(`Invalid character at position ${ne.index + 1}`);
    let ue, le;
    if (y === "")
      ue = "0", le = "";
    else if (y.search(/\./) === -1)
      ue = y, le = "";
    else {
      const ge = y.split(".");
      switch (ge.length) {
        case 0:
        case 1:
          throw new Error("Fewer than two elements in split result. This must not happen here.");
        case 2:
          if (!ge[1])
            throw new Error("Fractional part missing");
          ue = ge[0], le = ge[1].replace(/0+$/, "");
          break;
        default:
          throw new Error("More than one separator found");
      }
    }
    if (le.length > z)
      throw new Error("Got more fractional digits than supported");
    const he = `${ue}${le.padEnd(z, "0")}`;
    return new Decimal(he, z);
  }
  static fromAtomics(y, z) {
    return Decimal.verifyFractionalDigits(z), new Decimal(y, z);
  }
  /**
   * Creates a Decimal with value 0.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static zero(y) {
    return Decimal.verifyFractionalDigits(y), new Decimal("0", y);
  }
  /**
   * Creates a Decimal with value 1.0 and the given number of fractial digits.
   *
   * Fractional digits are not relevant for the value but needed to be able
   * to perform arithmetic operations with other decimals.
   */
  static one(y) {
    return Decimal.verifyFractionalDigits(y), new Decimal("1" + "0".repeat(y), y);
  }
  static verifyFractionalDigits(y) {
    if (!Number.isInteger(y))
      throw new Error("Fractional digits is not an integer");
    if (y < 0)
      throw new Error("Fractional digits must not be negative");
    if (y > maxFractionalDigits)
      throw new Error(`Fractional digits must not exceed ${maxFractionalDigits}`);
  }
  static compare(y, z) {
    if (y.fractionalDigits !== z.fractionalDigits)
      throw new Error("Fractional digits do not match");
    return y.data.atomics.cmp(new bn_js_1$1.default(z.atomics));
  }
  get atomics() {
    return this.data.atomics.toString();
  }
  get fractionalDigits() {
    return this.data.fractionalDigits;
  }
  constructor(y, z) {
    if (!y.match(/^[0-9]+$/))
      throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
    this.data = {
      atomics: new bn_js_1$1.default(y),
      fractionalDigits: z
    };
  }
  /** Creates a new instance with the same value */
  clone() {
    return new Decimal(this.atomics, this.fractionalDigits);
  }
  /** Returns the greatest decimal <= this which has no fractional part (rounding down) */
  floor() {
    const y = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), z = this.data.atomics.div(y);
    return this.data.atomics.mod(y).isZero() ? this.clone() : Decimal.fromAtomics(z.mul(y).toString(), this.fractionalDigits);
  }
  /** Returns the smallest decimal >= this which has no fractional part (rounding up) */
  ceil() {
    const y = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), z = this.data.atomics.div(y);
    return this.data.atomics.mod(y).isZero() ? this.clone() : Decimal.fromAtomics(z.addn(1).mul(y).toString(), this.fractionalDigits);
  }
  toString() {
    const y = new bn_js_1$1.default(10).pow(new bn_js_1$1.default(this.data.fractionalDigits)), z = this.data.atomics.div(y), ne = this.data.atomics.mod(y);
    if (ne.isZero())
      return z.toString();
    {
      const le = ne.toString().padStart(this.data.fractionalDigits, "0").replace(/0+$/, "");
      return `${z.toString()}.${le}`;
    }
  }
  /**
   * Returns an approximation as a float type. Only use this if no
   * exact calculation is required.
   */
  toFloatApproximation() {
    const y = Number(this.toString());
    if (Number.isNaN(y))
      throw new Error("Conversion to number failed");
    return y;
  }
  /**
   * a.plus(b) returns a+b.
   *
   * Both values need to have the same fractional digits.
   */
  plus(y) {
    if (this.fractionalDigits !== y.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const z = this.data.atomics.add(new bn_js_1$1.default(y.atomics));
    return new Decimal(z.toString(), this.fractionalDigits);
  }
  /**
   * a.minus(b) returns a-b.
   *
   * Both values need to have the same fractional digits.
   * The resulting difference needs to be non-negative.
   */
  minus(y) {
    if (this.fractionalDigits !== y.fractionalDigits)
      throw new Error("Fractional digits do not match");
    const z = this.data.atomics.sub(new bn_js_1$1.default(y.atomics));
    if (z.ltn(0))
      throw new Error("Difference must not be negative");
    return new Decimal(z.toString(), this.fractionalDigits);
  }
  /**
   * a.multiply(b) returns a*b.
   *
   * We only allow multiplication by unsigned integers to avoid rounding errors.
   */
  multiply(y) {
    const z = this.data.atomics.mul(new bn_js_1$1.default(y.toString()));
    return new Decimal(z.toString(), this.fractionalDigits);
  }
  equals(y) {
    return Decimal.compare(this, y) === 0;
  }
  isLessThan(y) {
    return Decimal.compare(this, y) < 0;
  }
  isLessThanOrEqual(y) {
    return Decimal.compare(this, y) <= 0;
  }
  isGreaterThan(y) {
    return Decimal.compare(this, y) > 0;
  }
  isGreaterThanOrEqual(y) {
    return Decimal.compare(this, y) >= 0;
  }
}
decimal.Decimal = Decimal;
var integers = {}, __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(integers, "__esModule", { value: !0 });
integers.Uint64 = integers.Uint53 = integers.Int53 = integers.Uint32 = void 0;
const bn_js_1 = __importDefault$2(bnExports$1), uint64MaxValue = new bn_js_1.default("18446744073709551615", 10, "be");
class Uint32 {
  /** @deprecated use Uint32.fromBytes */
  static fromBigEndianBytes(y) {
    return Uint32.fromBytes(y);
  }
  /**
   * Creates a Uint32 from a fixed length byte array.
   *
   * @param bytes a list of exactly 4 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(y, z = "be") {
    if (y.length !== 4)
      throw new Error("Invalid input length. Expected 4 bytes.");
    for (let ue = 0; ue < y.length; ++ue)
      if (!Number.isInteger(y[ue]) || y[ue] > 255 || y[ue] < 0)
        throw new Error("Invalid value in byte. Found: " + y[ue]);
    const ne = z === "be" ? y : Array.from(y).reverse();
    return new Uint32(ne[0] * 2 ** 24 + ne[1] * 2 ** 16 + ne[2] * 2 ** 8 + ne[3]);
  }
  static fromString(y) {
    if (!y.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint32(Number.parseInt(y, 10));
  }
  constructor(y) {
    if (Number.isNaN(y))
      throw new Error("Input is not a number");
    if (!Number.isInteger(y))
      throw new Error("Input is not an integer");
    if (y < 0 || y > 4294967295)
      throw new Error("Input not in uint32 range: " + y.toString());
    this.data = y;
  }
  toBytesBigEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 24) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 0) & 255
    ]);
  }
  toBytesLittleEndian() {
    return new Uint8Array([
      Math.floor(this.data / 2 ** 0) & 255,
      Math.floor(this.data / 2 ** 8) & 255,
      Math.floor(this.data / 2 ** 16) & 255,
      Math.floor(this.data / 2 ** 24) & 255
    ]);
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint32 = Uint32;
class Int53 {
  static fromString(y) {
    if (!y.match(/^-?[0-9]+$/))
      throw new Error("Invalid string format");
    return new Int53(Number.parseInt(y, 10));
  }
  constructor(y) {
    if (Number.isNaN(y))
      throw new Error("Input is not a number");
    if (!Number.isInteger(y))
      throw new Error("Input is not an integer");
    if (y < Number.MIN_SAFE_INTEGER || y > Number.MAX_SAFE_INTEGER)
      throw new Error("Input not in int53 range: " + y.toString());
    this.data = y;
  }
  toNumber() {
    return this.data;
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Int53 = Int53;
class Uint53 {
  static fromString(y) {
    const z = Int53.fromString(y);
    return new Uint53(z.toNumber());
  }
  constructor(y) {
    const z = new Int53(y);
    if (z.toNumber() < 0)
      throw new Error("Input is negative");
    this.data = z;
  }
  toNumber() {
    return this.data.toNumber();
  }
  toBigInt() {
    return BigInt(this.toNumber());
  }
  toString() {
    return this.data.toString();
  }
}
integers.Uint53 = Uint53;
class Uint64 {
  /** @deprecated use Uint64.fromBytes */
  static fromBytesBigEndian(y) {
    return Uint64.fromBytes(y);
  }
  /**
   * Creates a Uint64 from a fixed length byte array.
   *
   * @param bytes a list of exactly 8 bytes
   * @param endianess defaults to big endian
   */
  static fromBytes(y, z = "be") {
    if (y.length !== 8)
      throw new Error("Invalid input length. Expected 8 bytes.");
    for (let ue = 0; ue < y.length; ++ue)
      if (!Number.isInteger(y[ue]) || y[ue] > 255 || y[ue] < 0)
        throw new Error("Invalid value in byte. Found: " + y[ue]);
    const ne = z === "be" ? Array.from(y) : Array.from(y).reverse();
    return new Uint64(new bn_js_1.default(ne));
  }
  static fromString(y) {
    if (!y.match(/^[0-9]+$/))
      throw new Error("Invalid string format");
    return new Uint64(new bn_js_1.default(y, 10, "be"));
  }
  static fromNumber(y) {
    if (Number.isNaN(y))
      throw new Error("Input is not a number");
    if (!Number.isInteger(y))
      throw new Error("Input is not an integer");
    let z;
    try {
      z = new bn_js_1.default(y);
    } catch {
      throw new Error("Input is not a safe integer");
    }
    return new Uint64(z);
  }
  constructor(y) {
    if (y.isNeg())
      throw new Error("Input is negative");
    if (y.gt(uint64MaxValue))
      throw new Error("Input exceeds uint64 range");
    this.data = y;
  }
  toBytesBigEndian() {
    return Uint8Array.from(this.data.toArray("be", 8));
  }
  toBytesLittleEndian() {
    return Uint8Array.from(this.data.toArray("le", 8));
  }
  toString() {
    return this.data.toString(10);
  }
  toBigInt() {
    return BigInt(this.toString());
  }
  toNumber() {
    return this.data.toNumber();
  }
}
integers.Uint64 = Uint64;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.Uint64 = v.Uint53 = v.Uint32 = v.Int53 = v.Decimal = void 0;
  var y = decimal;
  Object.defineProperty(v, "Decimal", { enumerable: !0, get: function() {
    return y.Decimal;
  } });
  var z = integers;
  Object.defineProperty(v, "Int53", { enumerable: !0, get: function() {
    return z.Int53;
  } }), Object.defineProperty(v, "Uint32", { enumerable: !0, get: function() {
    return z.Uint32;
  } }), Object.defineProperty(v, "Uint53", { enumerable: !0, get: function() {
    return z.Uint53;
  } }), Object.defineProperty(v, "Uint64", { enumerable: !0, get: function() {
    return z.Uint64;
  } });
})(build$1);
(function(v) {
  var y = commonjsGlobal && commonjsGlobal.__importDefault || function(br) {
    return br && br.__esModule ? br : { default: br };
  };
  Object.defineProperty(v, "__esModule", { value: !0 }), v.stringToPath = v.pathToString = v.Slip10 = v.Slip10RawIndex = v.slip10CurveFromString = v.Slip10Curve = void 0;
  const z = build$3, ne = build$1, ue = y(bnExports$1), le = y(requireElliptic()), he = hmac$2, ge = sha;
  var we;
  (function(br) {
    br.Secp256k1 = "Bitcoin seed", br.Ed25519 = "ed25519 seed";
  })(we = v.Slip10Curve || (v.Slip10Curve = {}));
  function Ee(br) {
    switch (br) {
      case we.Ed25519:
        return we.Ed25519;
      case we.Secp256k1:
        return we.Secp256k1;
      default:
        throw new Error(`Unknown curve string: '${br}'`);
    }
  }
  v.slip10CurveFromString = Ee;
  class xe extends ne.Uint32 {
    static hardened($n) {
      return new xe($n + 2 ** 31);
    }
    static normal($n) {
      return new xe($n);
    }
    isHardened() {
      return this.data >= 2 ** 31;
    }
  }
  v.Slip10RawIndex = xe;
  const $e = new le.default.ec("secp256k1");
  class Ne {
    static derivePath($n, En, Rn) {
      let wa = this.master($n, En);
      for (const Aa of Rn)
        wa = this.child($n, wa.privkey, wa.chainCode, Aa);
      return wa;
    }
    static master($n, En) {
      const Rn = new he.Hmac(ge.Sha512, (0, z.toAscii)($n)).update(En).digest(), wa = Rn.slice(0, 32), Aa = Rn.slice(32, 64);
      return $n !== we.Ed25519 && (this.isZero(wa) || this.isGteN($n, wa)) ? this.master($n, Rn) : {
        chainCode: Aa,
        privkey: wa
      };
    }
    static child($n, En, Rn, wa) {
      let Aa;
      if (wa.isHardened()) {
        const _a = new Uint8Array([0, ...En, ...wa.toBytesBigEndian()]);
        Aa = new he.Hmac(ge.Sha512, Rn).update(_a).digest();
      } else {
        if ($n === we.Ed25519)
          throw new Error("Normal keys are not allowed with ed25519");
        {
          const _a = new Uint8Array([
            ...Ne.serializedPoint($n, new ue.default(En)),
            ...wa.toBytesBigEndian()
          ]);
          Aa = new he.Hmac(ge.Sha512, Rn).update(_a).digest();
        }
      }
      return this.childImpl($n, En, Rn, wa, Aa);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */
    static serializedPoint($n, En) {
      switch ($n) {
        case we.Secp256k1:
          return (0, z.fromHex)($e.g.mul(En).encodeCompressed("hex"));
        default:
          throw new Error("curve not supported");
      }
    }
    static childImpl($n, En, Rn, wa, Aa) {
      const _a = Aa.slice(0, 32), Ta = Aa.slice(32, 64), Zn = Ta;
      if ($n === we.Ed25519)
        return {
          chainCode: Zn,
          privkey: _a
        };
      const Ra = this.n($n), Yn = new ue.default(_a).add(new ue.default(En)).mod(Ra), $o = Uint8Array.from(Yn.toArray("be", 32));
      if (this.isGteN($n, _a) || this.isZero($o)) {
        const ct = new he.Hmac(ge.Sha512, Rn).update(new Uint8Array([1, ...Ta, ...wa.toBytesBigEndian()])).digest();
        return this.childImpl($n, En, Rn, wa, ct);
      }
      return {
        chainCode: Zn,
        privkey: $o
      };
    }
    static isZero($n) {
      return $n.every((En) => En === 0);
    }
    static isGteN($n, En) {
      return new ue.default(En).gte(this.n($n));
    }
    static n($n) {
      switch ($n) {
        case we.Secp256k1:
          return new ue.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
        default:
          throw new Error("curve not supported");
      }
    }
  }
  v.Slip10 = Ne;
  function st(br) {
    return br.reduce(($n, En) => {
      const Rn = En.isHardened() ? `${En.toNumber() - 2147483648}'` : En.toString();
      return $n + "/" + Rn;
    }, "m");
  }
  v.pathToString = st;
  function Nr(br) {
    if (!br.startsWith("m"))
      throw new Error("Path string must start with 'm'");
    let $n = br.slice(1);
    const En = new Array();
    for (; $n; ) {
      const Rn = $n.match(/^\/([0-9]+)('?)/);
      if (!Rn)
        throw new Error("Syntax error while reading path component");
      const [wa, Aa, _a] = Rn, Ta = ne.Uint53.fromString(Aa).toNumber();
      if (Ta >= 2 ** 31)
        throw new Error("Component value too high. Must not exceed 2**31-1.");
      _a ? En.push(xe.hardened(Ta)) : En.push(xe.normal(Ta)), $n = $n.slice(wa.length);
    }
    return En;
  }
  v.stringToPath = Nr;
})(slip10);
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.stringToPath = v.Slip10RawIndex = v.slip10CurveFromString = v.Slip10Curve = v.Slip10 = v.pathToString = v.sha512 = v.Sha512 = v.sha256 = v.Sha256 = v.Secp256k1Signature = v.ExtendedSecp256k1Signature = v.Secp256k1 = v.ripemd160 = v.Ripemd160 = v.Random = v.Xchacha20poly1305Ietf = v.xchacha20NonceLength = v.isArgon2idOptions = v.Ed25519Keypair = v.Ed25519 = v.Argon2id = v.keccak256 = v.Keccak256 = v.Hmac = v.EnglishMnemonic = v.Bip39 = void 0;
  var y = bip39;
  Object.defineProperty(v, "Bip39", { enumerable: !0, get: function() {
    return y.Bip39;
  } }), Object.defineProperty(v, "EnglishMnemonic", { enumerable: !0, get: function() {
    return y.EnglishMnemonic;
  } });
  var z = hmac$2;
  Object.defineProperty(v, "Hmac", { enumerable: !0, get: function() {
    return z.Hmac;
  } });
  var ne = keccak;
  Object.defineProperty(v, "Keccak256", { enumerable: !0, get: function() {
    return ne.Keccak256;
  } }), Object.defineProperty(v, "keccak256", { enumerable: !0, get: function() {
    return ne.keccak256;
  } });
  var ue = libsodium;
  Object.defineProperty(v, "Argon2id", { enumerable: !0, get: function() {
    return ue.Argon2id;
  } }), Object.defineProperty(v, "Ed25519", { enumerable: !0, get: function() {
    return ue.Ed25519;
  } }), Object.defineProperty(v, "Ed25519Keypair", { enumerable: !0, get: function() {
    return ue.Ed25519Keypair;
  } }), Object.defineProperty(v, "isArgon2idOptions", { enumerable: !0, get: function() {
    return ue.isArgon2idOptions;
  } }), Object.defineProperty(v, "xchacha20NonceLength", { enumerable: !0, get: function() {
    return ue.xchacha20NonceLength;
  } }), Object.defineProperty(v, "Xchacha20poly1305Ietf", { enumerable: !0, get: function() {
    return ue.Xchacha20poly1305Ietf;
  } });
  var le = random$1;
  Object.defineProperty(v, "Random", { enumerable: !0, get: function() {
    return le.Random;
  } });
  var he = ripemd;
  Object.defineProperty(v, "Ripemd160", { enumerable: !0, get: function() {
    return he.Ripemd160;
  } }), Object.defineProperty(v, "ripemd160", { enumerable: !0, get: function() {
    return he.ripemd160;
  } });
  var ge = secp256k1$1;
  Object.defineProperty(v, "Secp256k1", { enumerable: !0, get: function() {
    return ge.Secp256k1;
  } });
  var we = secp256k1signature;
  Object.defineProperty(v, "ExtendedSecp256k1Signature", { enumerable: !0, get: function() {
    return we.ExtendedSecp256k1Signature;
  } }), Object.defineProperty(v, "Secp256k1Signature", { enumerable: !0, get: function() {
    return we.Secp256k1Signature;
  } });
  var Ee = sha;
  Object.defineProperty(v, "Sha256", { enumerable: !0, get: function() {
    return Ee.Sha256;
  } }), Object.defineProperty(v, "sha256", { enumerable: !0, get: function() {
    return Ee.sha256;
  } }), Object.defineProperty(v, "Sha512", { enumerable: !0, get: function() {
    return Ee.Sha512;
  } }), Object.defineProperty(v, "sha512", { enumerable: !0, get: function() {
    return Ee.sha512;
  } });
  var xe = slip10;
  Object.defineProperty(v, "pathToString", { enumerable: !0, get: function() {
    return xe.pathToString;
  } }), Object.defineProperty(v, "Slip10", { enumerable: !0, get: function() {
    return xe.Slip10;
  } }), Object.defineProperty(v, "Slip10Curve", { enumerable: !0, get: function() {
    return xe.Slip10Curve;
  } }), Object.defineProperty(v, "slip10CurveFromString", { enumerable: !0, get: function() {
    return xe.slip10CurveFromString;
  } }), Object.defineProperty(v, "Slip10RawIndex", { enumerable: !0, get: function() {
    return xe.Slip10RawIndex;
  } }), Object.defineProperty(v, "stringToPath", { enumerable: !0, get: function() {
    return xe.stringToPath;
  } });
})(build$4);
var encoding = {}, pubkeys = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.isMultisigThresholdPubkey = v.isSinglePubkey = v.pubkeyType = v.isSecp256k1Pubkey = v.isEd25519Pubkey = void 0;
  function y(le) {
    return le.type === "tendermint/PubKeyEd25519";
  }
  v.isEd25519Pubkey = y;
  function z(le) {
    return le.type === "tendermint/PubKeySecp256k1";
  }
  v.isSecp256k1Pubkey = z, v.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */
    secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */
    ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */
    sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
  };
  function ne(le) {
    return [v.pubkeyType.ed25519, v.pubkeyType.secp256k1, v.pubkeyType.sr25519].includes(le.type);
  }
  v.isSinglePubkey = ne;
  function ue(le) {
    return le.type === "tendermint/PubKeyMultisigThreshold";
  }
  v.isMultisigThresholdPubkey = ue;
})(pubkeys);
Object.defineProperty(encoding, "__esModule", { value: !0 });
encoding.encodeBech32Pubkey = encoding.encodeAminoPubkey = encoding.decodeBech32Pubkey = encoding.decodeAminoPubkey = encoding.encodeEd25519Pubkey = encoding.encodeSecp256k1Pubkey = void 0;
const encoding_1$9 = build$3, math_1$4 = build$1, utils_1$3 = build$2, pubkeys_1$2 = pubkeys;
function encodeSecp256k1Pubkey(v) {
  if (v.length !== 33 || v[0] !== 2 && v[0] !== 3)
    throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
  return {
    type: pubkeys_1$2.pubkeyType.secp256k1,
    value: (0, encoding_1$9.toBase64)(v)
  };
}
encoding.encodeSecp256k1Pubkey = encodeSecp256k1Pubkey;
function encodeEd25519Pubkey(v) {
  if (v.length !== 32)
    throw new Error("Ed25519 public key must be 32 bytes long");
  return {
    type: pubkeys_1$2.pubkeyType.ed25519,
    value: (0, encoding_1$9.toBase64)(v)
  };
}
encoding.encodeEd25519Pubkey = encodeEd25519Pubkey;
const pubkeyAminoPrefixSecp256k1 = (0, encoding_1$9.fromHex)(
  "eb5ae98721"
  /* fixed length */
), pubkeyAminoPrefixEd25519 = (0, encoding_1$9.fromHex)(
  "1624de6420"
  /* fixed length */
), pubkeyAminoPrefixSr25519 = (0, encoding_1$9.fromHex)(
  "0dfb100520"
  /* fixed length */
), pubkeyAminoPrefixMultisigThreshold = (0, encoding_1$9.fromHex)(
  "22c1f7e2"
  /* variable length not included */
);
function decodeAminoPubkey(v) {
  if ((0, utils_1$3.arrayContentStartsWith)(v, pubkeyAminoPrefixSecp256k1)) {
    const y = v.slice(pubkeyAminoPrefixSecp256k1.length);
    if (y.length !== 33)
      throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.secp256k1,
      value: (0, encoding_1$9.toBase64)(y)
    };
  } else if ((0, utils_1$3.arrayContentStartsWith)(v, pubkeyAminoPrefixEd25519)) {
    const y = v.slice(pubkeyAminoPrefixEd25519.length);
    if (y.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.ed25519,
      value: (0, encoding_1$9.toBase64)(y)
    };
  } else if ((0, utils_1$3.arrayContentStartsWith)(v, pubkeyAminoPrefixSr25519)) {
    const y = v.slice(pubkeyAminoPrefixSr25519.length);
    if (y.length !== 32)
      throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
    return {
      type: pubkeys_1$2.pubkeyType.sr25519,
      value: (0, encoding_1$9.toBase64)(y)
    };
  } else {
    if ((0, utils_1$3.arrayContentStartsWith)(v, pubkeyAminoPrefixMultisigThreshold))
      return decodeMultisigPubkey(v);
    throw new Error("Unsupported public key type. Amino data starts with: " + (0, encoding_1$9.toHex)(v.slice(0, 5)));
  }
}
encoding.decodeAminoPubkey = decodeAminoPubkey;
function decodeBech32Pubkey(v) {
  const { data: y } = (0, encoding_1$9.fromBech32)(v);
  return decodeAminoPubkey(y);
}
encoding.decodeBech32Pubkey = decodeBech32Pubkey;
function decodeUvarint(v) {
  if (v.length < 1)
    throw new Error("Can't decode varint. EOF");
  if (v[0] > 127)
    throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
  return [v[0], 1];
}
function decodeMultisigPubkey(v) {
  const y = Array.from(v), z = y.splice(0, pubkeyAminoPrefixMultisigThreshold.length);
  if (!(0, utils_1$3.arrayContentStartsWith)(z, pubkeyAminoPrefixMultisigThreshold))
    throw new Error("Invalid multisig prefix.");
  if (y.shift() != 8)
    throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
  const [ne, ue] = decodeUvarint(y);
  y.splice(0, ue);
  const le = [];
  for (; y.length > 0; ) {
    if (y.shift() != 18)
      throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
    const [he, ge] = decodeUvarint(y);
    if (y.splice(0, ge), y.length < he)
      throw new Error("Invalid multisig data length.");
    const we = y.splice(0, he), Ee = decodeAminoPubkey(Uint8Array.from(we));
    le.push(Ee);
  }
  return {
    type: pubkeys_1$2.pubkeyType.multisigThreshold,
    value: {
      threshold: ne.toString(),
      pubkeys: le
    }
  };
}
function encodeUvarint(v) {
  const y = math_1$4.Uint53.fromString(v.toString()).toNumber();
  if (y > 127)
    throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
  return [y];
}
function encodeAminoPubkey(v) {
  if ((0, pubkeys_1$2.isMultisigThresholdPubkey)(v)) {
    const y = Array.from(pubkeyAminoPrefixMultisigThreshold);
    y.push(8), y.push(...encodeUvarint(v.value.threshold));
    for (const z of v.value.pubkeys.map((ne) => encodeAminoPubkey(ne)))
      y.push(18), y.push(...encodeUvarint(z.length)), y.push(...z);
    return new Uint8Array(y);
  } else {
    if ((0, pubkeys_1$2.isEd25519Pubkey)(v))
      return new Uint8Array([...pubkeyAminoPrefixEd25519, ...(0, encoding_1$9.fromBase64)(v.value)]);
    if ((0, pubkeys_1$2.isSecp256k1Pubkey)(v))
      return new Uint8Array([...pubkeyAminoPrefixSecp256k1, ...(0, encoding_1$9.fromBase64)(v.value)]);
    throw new Error("Unsupported pubkey type");
  }
}
encoding.encodeAminoPubkey = encodeAminoPubkey;
function encodeBech32Pubkey(v, y) {
  return (0, encoding_1$9.toBech32)(y, encodeAminoPubkey(v));
}
encoding.encodeBech32Pubkey = encodeBech32Pubkey;
Object.defineProperty(addresses, "__esModule", { value: !0 });
addresses.pubkeyToAddress = addresses.pubkeyToRawAddress = addresses.rawSecp256k1PubkeyToRawAddress = addresses.rawEd25519PubkeyToRawAddress = void 0;
const crypto_1$6 = build$4, encoding_1$8 = build$3, encoding_2$1 = encoding, pubkeys_1$1 = pubkeys;
function rawEd25519PubkeyToRawAddress(v) {
  if (v.length !== 32)
    throw new Error(`Invalid Ed25519 pubkey length: ${v.length}`);
  return (0, crypto_1$6.sha256)(v).slice(0, 20);
}
addresses.rawEd25519PubkeyToRawAddress = rawEd25519PubkeyToRawAddress;
function rawSecp256k1PubkeyToRawAddress(v) {
  if (v.length !== 33)
    throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${v.length}`);
  return (0, crypto_1$6.ripemd160)((0, crypto_1$6.sha256)(v));
}
addresses.rawSecp256k1PubkeyToRawAddress = rawSecp256k1PubkeyToRawAddress;
function pubkeyToRawAddress(v) {
  if ((0, pubkeys_1$1.isSecp256k1Pubkey)(v)) {
    const y = (0, encoding_1$8.fromBase64)(v.value);
    return rawSecp256k1PubkeyToRawAddress(y);
  } else if ((0, pubkeys_1$1.isEd25519Pubkey)(v)) {
    const y = (0, encoding_1$8.fromBase64)(v.value);
    return rawEd25519PubkeyToRawAddress(y);
  } else if ((0, pubkeys_1$1.isMultisigThresholdPubkey)(v)) {
    const y = (0, encoding_2$1.encodeAminoPubkey)(v);
    return (0, crypto_1$6.sha256)(y).slice(0, 20);
  } else
    throw new Error("Unsupported public key type");
}
addresses.pubkeyToRawAddress = pubkeyToRawAddress;
function pubkeyToAddress(v, y) {
  return (0, encoding_1$8.toBech32)(y, pubkeyToRawAddress(v));
}
addresses.pubkeyToAddress = pubkeyToAddress;
var coins$1 = {};
Object.defineProperty(coins$1, "__esModule", { value: !0 });
coins$1.addCoins = coins$1.parseCoins = coins$1.coins = coins$1.coin = void 0;
const math_1$3 = build$1;
function coin(v, y) {
  let z;
  if (typeof v == "number")
    try {
      z = new math_1$3.Uint53(v).toString();
    } catch {
      throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
  else {
    if (!v.match(/^[0-9]+$/))
      throw new Error("Invalid unsigned integer string format");
    z = v.replace(/^0*/, "") || "0";
  }
  return {
    amount: z,
    denom: y
  };
}
coins$1.coin = coin;
function coins(v, y) {
  return [coin(v, y)];
}
coins$1.coins = coins;
function parseCoins(v) {
  return v.replace(/\s/g, "").split(",").filter(Boolean).map((y) => {
    const z = y.match(/^([0-9]+)([a-zA-Z]+)/);
    if (!z)
      throw new Error("Got an invalid coin string");
    return {
      amount: z[1].replace(/^0+/, "") || "0",
      denom: z[2]
    };
  });
}
coins$1.parseCoins = parseCoins;
function addCoins(v, y) {
  if (v.denom !== y.denom)
    throw new Error("Trying to add two coins with different denoms");
  return {
    amount: math_1$3.Decimal.fromAtomics(v.amount, 0).plus(math_1$3.Decimal.fromAtomics(y.amount, 0)).atomics,
    denom: v.denom
  };
}
coins$1.addCoins = addCoins;
var multisig = {};
Object.defineProperty(multisig, "__esModule", { value: !0 });
multisig.createMultisigThresholdPubkey = multisig.compareArrays = void 0;
const encoding_1$7 = build$3, math_1$2 = build$1, addresses_1$2 = addresses;
function compareArrays(v, y) {
  const z = (0, encoding_1$7.toHex)(v), ne = (0, encoding_1$7.toHex)(y);
  return z === ne ? 0 : z < ne ? -1 : 1;
}
multisig.compareArrays = compareArrays;
function createMultisigThresholdPubkey(v, y, z = !1) {
  const ne = new math_1$2.Uint53(y);
  if (ne.toNumber() > v.length)
    throw new Error(`Threshold k = ${ne.toNumber()} exceeds number of keys n = ${v.length}`);
  const ue = z ? v : Array.from(v).sort((le, he) => {
    const ge = (0, addresses_1$2.pubkeyToRawAddress)(le), we = (0, addresses_1$2.pubkeyToRawAddress)(he);
    return compareArrays(ge, we);
  });
  return {
    type: "tendermint/PubKeyMultisigThreshold",
    value: {
      threshold: ne.toString(),
      pubkeys: ue
    }
  };
}
multisig.createMultisigThresholdPubkey = createMultisigThresholdPubkey;
var paths$1 = {};
Object.defineProperty(paths$1, "__esModule", { value: !0 });
paths$1.makeCosmoshubPath = void 0;
const crypto_1$5 = build$4;
function makeCosmoshubPath$1(v) {
  return [
    crypto_1$5.Slip10RawIndex.hardened(44),
    crypto_1$5.Slip10RawIndex.hardened(118),
    crypto_1$5.Slip10RawIndex.hardened(0),
    crypto_1$5.Slip10RawIndex.normal(0),
    crypto_1$5.Slip10RawIndex.normal(v)
  ];
}
paths$1.makeCosmoshubPath = makeCosmoshubPath$1;
var secp256k1hdwallet = {}, signature = {};
Object.defineProperty(signature, "__esModule", { value: !0 });
signature.decodeSignature = signature.encodeSecp256k1Signature = void 0;
const encoding_1$6 = build$3, encoding_2 = encoding, pubkeys_1 = pubkeys;
function encodeSecp256k1Signature(v, y) {
  if (y.length !== 64)
    throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
  return {
    pub_key: (0, encoding_2.encodeSecp256k1Pubkey)(v),
    signature: (0, encoding_1$6.toBase64)(y)
  };
}
signature.encodeSecp256k1Signature = encodeSecp256k1Signature;
function decodeSignature(v) {
  switch (v.pub_key.type) {
    case pubkeys_1.pubkeyType.secp256k1:
      return {
        pubkey: (0, encoding_1$6.fromBase64)(v.pub_key.value),
        signature: (0, encoding_1$6.fromBase64)(v.signature)
      };
    default:
      throw new Error("Unsupported pubkey type");
  }
}
signature.decodeSignature = decodeSignature;
var signdoc = {};
Object.defineProperty(signdoc, "__esModule", { value: !0 });
signdoc.serializeSignDoc = signdoc.escapeCharacters = signdoc.makeSignDoc = signdoc.sortedJsonStringify = void 0;
const encoding_1$5 = build$3, math_1$1 = build$1;
function sortedObject(v) {
  if (typeof v != "object" || v === null)
    return v;
  if (Array.isArray(v))
    return v.map(sortedObject);
  const y = Object.keys(v).sort(), z = {};
  return y.forEach((ne) => {
    z[ne] = sortedObject(v[ne]);
  }), z;
}
function sortedJsonStringify(v) {
  return JSON.stringify(sortedObject(v));
}
signdoc.sortedJsonStringify = sortedJsonStringify;
function makeSignDoc$1(v, y, z, ne, ue, le) {
  return {
    chain_id: z,
    account_number: math_1$1.Uint53.fromString(ue.toString()).toString(),
    sequence: math_1$1.Uint53.fromString(le.toString()).toString(),
    fee: y,
    msgs: v,
    memo: ne || ""
  };
}
signdoc.makeSignDoc = makeSignDoc$1;
function escapeCharacters(v) {
  const y = /&/g, z = /</g, ne = />/g;
  return v.replace(y, "\\u0026").replace(z, "\\u003c").replace(ne, "\\u003e");
}
signdoc.escapeCharacters = escapeCharacters;
function serializeSignDoc(v) {
  const y = escapeCharacters(sortedJsonStringify(v));
  return (0, encoding_1$5.toUtf8)(y);
}
signdoc.serializeSignDoc = serializeSignDoc;
var wallet$1 = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.decrypt = v.encrypt = v.supportedAlgorithms = v.executeKdf = v.cosmjsSalt = void 0;
  const y = build$4, z = build$3;
  v.cosmjsSalt = (0, z.toAscii)("The CosmJS salt.");
  async function ne(he, ge) {
    switch (ge.algorithm) {
      case "argon2id": {
        const we = ge.params;
        if (!(0, y.isArgon2idOptions)(we))
          throw new Error("Invalid format of argon2id params");
        return y.Argon2id.execute(he, v.cosmjsSalt, we);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  v.executeKdf = ne, v.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function ue(he, ge, we) {
    switch (we.algorithm) {
      case v.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ee = y.Random.getBytes(y.xchacha20NonceLength);
        return new Uint8Array([
          ...Ee,
          ...await y.Xchacha20poly1305Ietf.encrypt(he, ge, Ee)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${we.algorithm}'`);
    }
  }
  v.encrypt = ue;
  async function le(he, ge, we) {
    switch (we.algorithm) {
      case v.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ee = he.slice(0, y.xchacha20NonceLength);
        return y.Xchacha20poly1305Ietf.decrypt(he.slice(y.xchacha20NonceLength), ge, Ee);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${we.algorithm}'`);
    }
  }
  v.decrypt = le;
})(wallet$1);
Object.defineProperty(secp256k1hdwallet, "__esModule", { value: !0 });
secp256k1hdwallet.Secp256k1HdWallet = secp256k1hdwallet.extractKdfConfiguration = void 0;
const crypto_1$4 = build$4, encoding_1$4 = build$3, utils_1$2 = build$2, addresses_1$1 = addresses, paths_1 = paths$1, signature_1$1 = signature, signdoc_1$1 = signdoc, wallet_1$1 = wallet$1, serializationTypeV1$1 = "secp256k1wallet-v1", basicPasswordHashingOptions$1 = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson$1(v) {
  return !(!(0, utils_1$2.isNonNullObject)(v) || typeof v.hdPath != "string" || typeof v.prefix != "string");
}
function extractKdfConfigurationV1$1(v) {
  return v.kdf;
}
function extractKdfConfiguration$1(v) {
  const y = JSON.parse(v);
  if (!(0, utils_1$2.isNonNullObject)(y))
    throw new Error("Root document is not an object.");
  switch (y.type) {
    case serializationTypeV1$1:
      return extractKdfConfigurationV1$1(y);
    default:
      throw new Error("Unsupported serialization type");
  }
}
secp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration$1;
const defaultOptions$2 = {
  bip39Password: "",
  hdPaths: [(0, paths_1.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class Secp256k1HdWallet {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(y, z = {}) {
    const ne = new crypto_1$4.EnglishMnemonic(y), ue = await crypto_1$4.Bip39.mnemonicToSeed(ne, z.bip39Password);
    return new Secp256k1HdWallet(ne, {
      ...z,
      seed: ue
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(y = 12, z = {}) {
    const ne = 4 * Math.floor(11 * y / 33), ue = crypto_1$4.Random.getBytes(ne), le = crypto_1$4.Bip39.encode(ue);
    return Secp256k1HdWallet.fromMnemonic(le.toString(), z);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1$2.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    switch (ne.type) {
      case serializationTypeV1$1:
        return Secp256k1HdWallet.deserializeTypeV1(y, z);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1$2.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    const ue = ne;
    switch (ue.type) {
      case serializationTypeV1$1: {
        const le = await (0, wallet_1$1.decrypt)((0, encoding_1$4.fromBase64)(ue.data), z, ue.encryption), he = JSON.parse((0, encoding_1$4.fromUtf8)(le)), { mnemonic: ge, accounts: we } = he;
        if ((0, utils_1$2.assert)(typeof ge == "string"), !Array.isArray(we))
          throw new Error("Property 'accounts' is not an array");
        if (!we.every(($e) => isDerivationJson$1($e)))
          throw new Error("Account is not in the correct format.");
        const Ee = we[0].prefix;
        if (!we.every(({ prefix: $e }) => $e === Ee))
          throw new Error("Accounts do not all have the same prefix");
        const xe = we.map(({ hdPath: $e }) => (0, crypto_1$4.stringToPath)($e));
        return Secp256k1HdWallet.fromMnemonic(ge, {
          hdPaths: xe,
          prefix: Ee
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1$2.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    const ue = await (0, wallet_1$1.executeKdf)(z, ne.kdf);
    return Secp256k1HdWallet.deserializeWithEncryptionKey(y, ue);
  }
  constructor(y, z) {
    const ne = z.hdPaths ?? defaultOptions$2.hdPaths, ue = z.prefix ?? defaultOptions$2.prefix;
    this.secret = y, this.seed = z.seed, this.accounts = ne.map((le) => ({
      hdPath: le,
      prefix: ue
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: z, pubkey: ne, address: ue }) => ({
      algo: z,
      pubkey: ne,
      address: ue
    }));
  }
  async signAmino(y, z) {
    const ue = (await this.getAccountsWithPrivkeys()).find(({ address: xe }) => xe === y);
    if (ue === void 0)
      throw new Error(`Address ${y} not found in wallet`);
    const { privkey: le, pubkey: he } = ue, ge = (0, crypto_1$4.sha256)((0, signdoc_1$1.serializeSignDoc)(z)), we = await crypto_1$4.Secp256k1.createSignature(ge, le), Ee = new Uint8Array([...we.r(32), ...we.s(32)]);
    return {
      signed: z,
      signature: (0, signature_1$1.encodeSecp256k1Signature)(he, Ee)
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(y) {
    const z = basicPasswordHashingOptions$1, ne = await (0, wallet_1$1.executeKdf)(y, z);
    return this.serializeWithEncryptionKey(ne, z);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(y, z) {
    const ne = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: we, prefix: Ee }) => ({
        hdPath: (0, crypto_1$4.pathToString)(we),
        prefix: Ee
      }))
    }, ue = (0, encoding_1$4.toUtf8)(JSON.stringify(ne)), le = {
      algorithm: wallet_1$1.supportedAlgorithms.xchacha20poly1305Ietf
    }, he = await (0, wallet_1$1.encrypt)(ue, y, le), ge = {
      type: serializationTypeV1$1,
      kdf: z,
      encryption: le,
      data: (0, encoding_1$4.toBase64)(he)
    };
    return JSON.stringify(ge);
  }
  async getKeyPair(y) {
    const { privkey: z } = crypto_1$4.Slip10.derivePath(crypto_1$4.Slip10Curve.Secp256k1, this.seed, y), { pubkey: ne } = await crypto_1$4.Secp256k1.makeKeypair(z);
    return {
      privkey: z,
      pubkey: crypto_1$4.Secp256k1.compressPubkey(ne)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: y, prefix: z }) => {
      const { privkey: ne, pubkey: ue } = await this.getKeyPair(y), le = (0, encoding_1$4.toBech32)(z, (0, addresses_1$1.rawSecp256k1PubkeyToRawAddress)(ue));
      return {
        algo: "secp256k1",
        privkey: ne,
        pubkey: ue,
        address: le
      };
    }));
  }
}
secp256k1hdwallet.Secp256k1HdWallet = Secp256k1HdWallet;
var secp256k1wallet = {};
Object.defineProperty(secp256k1wallet, "__esModule", { value: !0 });
secp256k1wallet.Secp256k1Wallet = void 0;
const crypto_1$3 = build$4, encoding_1$3 = build$3, addresses_1 = addresses, signature_1 = signature, signdoc_1 = signdoc;
class Secp256k1Wallet {
  /**
   * Creates a Secp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(y, z = "cosmos") {
    const ne = (await crypto_1$3.Secp256k1.makeKeypair(y)).pubkey;
    return new Secp256k1Wallet(y, crypto_1$3.Secp256k1.compressPubkey(ne), z);
  }
  constructor(y, z, ne) {
    this.privkey = y, this.pubkey = z, this.prefix = ne;
  }
  get address() {
    return (0, encoding_1$3.toBech32)(this.prefix, (0, addresses_1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signAmino(y, z) {
    if (y !== this.address)
      throw new Error(`Address ${y} not found in wallet`);
    const ne = new crypto_1$3.Sha256((0, signdoc_1.serializeSignDoc)(z)).digest(), ue = await crypto_1$3.Secp256k1.createSignature(ne, this.privkey), le = new Uint8Array([...ue.r(32), ...ue.s(32)]);
    return {
      signed: z,
      signature: (0, signature_1.encodeSecp256k1Signature)(this.pubkey, le)
    };
  }
}
secp256k1wallet.Secp256k1Wallet = Secp256k1Wallet;
var stdtx = {};
Object.defineProperty(stdtx, "__esModule", { value: !0 });
stdtx.makeStdTx = stdtx.isStdTx = void 0;
function isStdTx(v) {
  const { memo: y, msg: z, fee: ne, signatures: ue } = v;
  return typeof y == "string" && Array.isArray(z) && typeof ne == "object" && Array.isArray(ue);
}
stdtx.isStdTx = isStdTx;
function makeStdTx(v, y) {
  return {
    msg: v.msgs,
    fee: v.fee,
    memo: v.memo,
    signatures: Array.isArray(y) ? y : [y]
  };
}
stdtx.makeStdTx = makeStdTx;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.executeKdf = v.makeStdTx = v.isStdTx = v.serializeSignDoc = v.makeSignDoc = v.encodeSecp256k1Signature = v.decodeSignature = v.Secp256k1Wallet = v.Secp256k1HdWallet = v.extractKdfConfiguration = v.pubkeyType = v.isSinglePubkey = v.isSecp256k1Pubkey = v.isMultisigThresholdPubkey = v.isEd25519Pubkey = v.makeCosmoshubPath = v.createMultisigThresholdPubkey = v.encodeSecp256k1Pubkey = v.encodeEd25519Pubkey = v.encodeBech32Pubkey = v.encodeAminoPubkey = v.decodeBech32Pubkey = v.decodeAminoPubkey = v.parseCoins = v.coins = v.coin = v.addCoins = v.rawSecp256k1PubkeyToRawAddress = v.rawEd25519PubkeyToRawAddress = v.pubkeyToRawAddress = v.pubkeyToAddress = void 0;
  var y = addresses;
  Object.defineProperty(v, "pubkeyToAddress", { enumerable: !0, get: function() {
    return y.pubkeyToAddress;
  } }), Object.defineProperty(v, "pubkeyToRawAddress", { enumerable: !0, get: function() {
    return y.pubkeyToRawAddress;
  } }), Object.defineProperty(v, "rawEd25519PubkeyToRawAddress", { enumerable: !0, get: function() {
    return y.rawEd25519PubkeyToRawAddress;
  } }), Object.defineProperty(v, "rawSecp256k1PubkeyToRawAddress", { enumerable: !0, get: function() {
    return y.rawSecp256k1PubkeyToRawAddress;
  } });
  var z = coins$1;
  Object.defineProperty(v, "addCoins", { enumerable: !0, get: function() {
    return z.addCoins;
  } }), Object.defineProperty(v, "coin", { enumerable: !0, get: function() {
    return z.coin;
  } }), Object.defineProperty(v, "coins", { enumerable: !0, get: function() {
    return z.coins;
  } }), Object.defineProperty(v, "parseCoins", { enumerable: !0, get: function() {
    return z.parseCoins;
  } });
  var ne = encoding;
  Object.defineProperty(v, "decodeAminoPubkey", { enumerable: !0, get: function() {
    return ne.decodeAminoPubkey;
  } }), Object.defineProperty(v, "decodeBech32Pubkey", { enumerable: !0, get: function() {
    return ne.decodeBech32Pubkey;
  } }), Object.defineProperty(v, "encodeAminoPubkey", { enumerable: !0, get: function() {
    return ne.encodeAminoPubkey;
  } }), Object.defineProperty(v, "encodeBech32Pubkey", { enumerable: !0, get: function() {
    return ne.encodeBech32Pubkey;
  } }), Object.defineProperty(v, "encodeEd25519Pubkey", { enumerable: !0, get: function() {
    return ne.encodeEd25519Pubkey;
  } }), Object.defineProperty(v, "encodeSecp256k1Pubkey", { enumerable: !0, get: function() {
    return ne.encodeSecp256k1Pubkey;
  } });
  var ue = multisig;
  Object.defineProperty(v, "createMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return ue.createMultisigThresholdPubkey;
  } });
  var le = paths$1;
  Object.defineProperty(v, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return le.makeCosmoshubPath;
  } });
  var he = pubkeys;
  Object.defineProperty(v, "isEd25519Pubkey", { enumerable: !0, get: function() {
    return he.isEd25519Pubkey;
  } }), Object.defineProperty(v, "isMultisigThresholdPubkey", { enumerable: !0, get: function() {
    return he.isMultisigThresholdPubkey;
  } }), Object.defineProperty(v, "isSecp256k1Pubkey", { enumerable: !0, get: function() {
    return he.isSecp256k1Pubkey;
  } }), Object.defineProperty(v, "isSinglePubkey", { enumerable: !0, get: function() {
    return he.isSinglePubkey;
  } }), Object.defineProperty(v, "pubkeyType", { enumerable: !0, get: function() {
    return he.pubkeyType;
  } });
  var ge = secp256k1hdwallet;
  Object.defineProperty(v, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return ge.extractKdfConfiguration;
  } }), Object.defineProperty(v, "Secp256k1HdWallet", { enumerable: !0, get: function() {
    return ge.Secp256k1HdWallet;
  } });
  var we = secp256k1wallet;
  Object.defineProperty(v, "Secp256k1Wallet", { enumerable: !0, get: function() {
    return we.Secp256k1Wallet;
  } });
  var Ee = signature;
  Object.defineProperty(v, "decodeSignature", { enumerable: !0, get: function() {
    return Ee.decodeSignature;
  } }), Object.defineProperty(v, "encodeSecp256k1Signature", { enumerable: !0, get: function() {
    return Ee.encodeSecp256k1Signature;
  } });
  var xe = signdoc;
  Object.defineProperty(v, "makeSignDoc", { enumerable: !0, get: function() {
    return xe.makeSignDoc;
  } }), Object.defineProperty(v, "serializeSignDoc", { enumerable: !0, get: function() {
    return xe.serializeSignDoc;
  } });
  var $e = stdtx;
  Object.defineProperty(v, "isStdTx", { enumerable: !0, get: function() {
    return $e.isStdTx;
  } }), Object.defineProperty(v, "makeStdTx", { enumerable: !0, get: function() {
    return $e.makeStdTx;
  } });
  var Ne = wallet$1;
  Object.defineProperty(v, "executeKdf", { enumerable: !0, get: function() {
    return Ne.executeKdf;
  } });
})(build$5);
var build = {}, ascii$1 = {};
Object.defineProperty(ascii$1, "__esModule", { value: !0 });
ascii$1.fromAscii = ascii$1.toAscii = void 0;
function toAscii(v) {
  const y = (z) => z.split("").map((ne) => {
    const ue = ne.charCodeAt(0);
    if (ue < 32 || ue > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + ue);
    return ue;
  });
  return Uint8Array.from(y(v));
}
ascii$1.toAscii = toAscii;
function fromAscii(v) {
  return ((z) => z.map((ne) => {
    if (ne < 32 || ne > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + ne);
    return String.fromCharCode(ne);
  }))(Array.from(v)).join("");
}
ascii$1.fromAscii = fromAscii;
var base64$2 = {}, __createBinding$5 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$5 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$5(y, v, z);
  return __setModuleDefault$4(y, v), y;
};
Object.defineProperty(base64$2, "__esModule", { value: !0 });
base64$2.fromBase64 = base64$2.toBase64 = void 0;
const base64js = __importStar$5(base64Js);
function toBase64(v) {
  return base64js.fromByteArray(v);
}
base64$2.toBase64 = toBase64;
function fromBase64(v) {
  if (!v.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return base64js.toByteArray(v);
}
base64$2.fromBase64 = fromBase64;
var bech32$1 = {}, __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$4(y, v, z);
  return __setModuleDefault$3(y, v), y;
};
Object.defineProperty(bech32$1, "__esModule", { value: !0 });
bech32$1.normalizeBech32 = bech32$1.fromBech32 = bech32$1.toBech32 = void 0;
const bech32 = __importStar$4(require$$0$4);
function toBech32(v, y, z) {
  return bech32.encode(v, bech32.toWords(y), z);
}
bech32$1.toBech32 = toBech32;
function fromBech32(v, y = 1 / 0) {
  const z = bech32.decode(v, y);
  return {
    prefix: z.prefix,
    data: new Uint8Array(bech32.fromWords(z.words))
  };
}
bech32$1.fromBech32 = fromBech32;
function normalizeBech32(v) {
  const { prefix: y, data: z } = fromBech32(v);
  return toBech32(y, z);
}
bech32$1.normalizeBech32 = normalizeBech32;
var hex$1 = {};
Object.defineProperty(hex$1, "__esModule", { value: !0 });
hex$1.fromHex = hex$1.toHex = void 0;
function toHex$1(v) {
  let y = "";
  for (const z of v)
    y += ("0" + z.toString(16)).slice(-2);
  return y;
}
hex$1.toHex = toHex$1;
function fromHex(v) {
  if (v.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const y = new Uint8Array(v.length / 2);
  for (let z = 0; z < y.length; z++) {
    const ne = 2 * z, ue = v.slice(ne, ne + 2);
    if (!ue.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    y[z] = parseInt(ue, 16);
  }
  return y;
}
hex$1.fromHex = fromHex;
var rfc3339 = {};
Object.defineProperty(rfc3339, "__esModule", { value: !0 });
rfc3339.toRfc3339 = rfc3339.fromRfc3339 = void 0;
const rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function padded(v, y = 2) {
  return v.toString().padStart(y, "0");
}
function fromRfc3339(v) {
  const y = rfc3339Matcher.exec(v);
  if (!y)
    throw new Error("Date string is not in RFC3339 format");
  const z = +y[1], ne = +y[2], ue = +y[3], le = +y[4], he = +y[5], ge = +y[6], we = y[7] ? Math.floor(+y[7] * 1e3) : 0;
  let Ee, xe, $e;
  y[8] === "Z" ? (Ee = 1, xe = 0, $e = 0) : (Ee = y[8].substring(0, 1) === "-" ? -1 : 1, xe = +y[8].substring(1, 3), $e = +y[8].substring(4, 6));
  const Ne = Ee * (xe * 60 + $e) * 60, st = Date.UTC(z, ne - 1, ue, le, he, ge, we) - Ne * 1e3;
  return new Date(st);
}
rfc3339.fromRfc3339 = fromRfc3339;
function toRfc3339(v) {
  const y = v.getUTCFullYear(), z = padded(v.getUTCMonth() + 1), ne = padded(v.getUTCDate()), ue = padded(v.getUTCHours()), le = padded(v.getUTCMinutes()), he = padded(v.getUTCSeconds()), ge = padded(v.getUTCMilliseconds(), 3);
  return `${y}-${z}-${ne}T${ue}:${le}:${he}.${ge}Z`;
}
rfc3339.toRfc3339 = toRfc3339;
var utf8 = {};
Object.defineProperty(utf8, "__esModule", { value: !0 });
utf8.fromUtf8 = utf8.toUtf8 = void 0;
function toUtf8(v) {
  return new TextEncoder().encode(v);
}
utf8.toUtf8 = toUtf8;
function fromUtf8(v, y = !1) {
  const z = !y;
  return new TextDecoder("utf-8", { fatal: z }).decode(v);
}
utf8.fromUtf8 = fromUtf8;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.toUtf8 = v.fromUtf8 = v.toRfc3339 = v.fromRfc3339 = v.toHex = v.fromHex = v.toBech32 = v.normalizeBech32 = v.fromBech32 = v.toBase64 = v.fromBase64 = v.toAscii = v.fromAscii = void 0;
  var y = ascii$1;
  Object.defineProperty(v, "fromAscii", { enumerable: !0, get: function() {
    return y.fromAscii;
  } }), Object.defineProperty(v, "toAscii", { enumerable: !0, get: function() {
    return y.toAscii;
  } });
  var z = base64$2;
  Object.defineProperty(v, "fromBase64", { enumerable: !0, get: function() {
    return z.fromBase64;
  } }), Object.defineProperty(v, "toBase64", { enumerable: !0, get: function() {
    return z.toBase64;
  } });
  var ne = bech32$1;
  Object.defineProperty(v, "fromBech32", { enumerable: !0, get: function() {
    return ne.fromBech32;
  } }), Object.defineProperty(v, "normalizeBech32", { enumerable: !0, get: function() {
    return ne.normalizeBech32;
  } }), Object.defineProperty(v, "toBech32", { enumerable: !0, get: function() {
    return ne.toBech32;
  } });
  var ue = hex$1;
  Object.defineProperty(v, "fromHex", { enumerable: !0, get: function() {
    return ue.fromHex;
  } }), Object.defineProperty(v, "toHex", { enumerable: !0, get: function() {
    return ue.toHex;
  } });
  var le = rfc3339;
  Object.defineProperty(v, "fromRfc3339", { enumerable: !0, get: function() {
    return le.fromRfc3339;
  } }), Object.defineProperty(v, "toRfc3339", { enumerable: !0, get: function() {
    return le.toRfc3339;
  } });
  var he = utf8;
  Object.defineProperty(v, "fromUtf8", { enumerable: !0, get: function() {
    return he.fromUtf8;
  } }), Object.defineProperty(v, "toUtf8", { enumerable: !0, get: function() {
    return he.toUtf8;
  } });
})(build);
var signing = {}, __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(v) {
  return v && v.__esModule ? v : { default: v };
};
Object.defineProperty(signing, "__esModule", { value: !0 });
signing.makeSignBytes = signing.makeSignDoc = signing.makeAuthInfoBytes = void 0;
const utils_1$1 = build$2, signing_1$2 = signing$1, tx_1$1 = tx, long_1 = __importDefault$1(Long);
function makeSignerInfos(v, y) {
  return v.map(({ pubkey: z, sequence: ne }) => ({
    publicKey: z,
    modeInfo: {
      single: { mode: y }
    },
    sequence: long_1.default.fromNumber(ne)
  }));
}
function makeAuthInfoBytes(v, y, z, ne, ue, le = signing_1$2.SignMode.SIGN_MODE_DIRECT) {
  (0, utils_1$1.assert)(ne === void 0 || typeof ne == "string", "feeGranter must be undefined or string"), (0, utils_1$1.assert)(ue === void 0 || typeof ue == "string", "feePayer must be undefined or string");
  const he = tx_1$1.AuthInfo.fromPartial({
    signerInfos: makeSignerInfos(v, le),
    fee: {
      amount: [...y],
      gasLimit: long_1.default.fromNumber(z),
      granter: ne,
      payer: ue
    }
  });
  return tx_1$1.AuthInfo.encode(he).finish();
}
signing.makeAuthInfoBytes = makeAuthInfoBytes;
function makeSignDoc(v, y, z, ne) {
  return {
    bodyBytes: v,
    authInfoBytes: y,
    chainId: z,
    accountNumber: long_1.default.fromNumber(ne)
  };
}
signing.makeSignDoc = makeSignDoc;
function makeSignBytes({ accountNumber: v, authInfoBytes: y, bodyBytes: z, chainId: ne }) {
  const ue = tx_1$1.SignDoc.fromPartial({
    accountNumber: v,
    authInfoBytes: y,
    bodyBytes: z,
    chainId: ne
  });
  return tx_1$1.SignDoc.encode(ue).finish();
}
signing.makeSignBytes = makeSignBytes;
var wallet = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.decrypt = v.encrypt = v.supportedAlgorithms = v.executeKdf = v.cosmjsSalt = void 0;
  const y = build$4, z = build;
  v.cosmjsSalt = (0, z.toAscii)("The CosmJS salt.");
  async function ne(he, ge) {
    switch (ge.algorithm) {
      case "argon2id": {
        const we = ge.params;
        if (!(0, y.isArgon2idOptions)(we))
          throw new Error("Invalid format of argon2id params");
        return y.Argon2id.execute(he, v.cosmjsSalt, we);
      }
      default:
        throw new Error("Unsupported KDF algorithm");
    }
  }
  v.executeKdf = ne, v.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
  };
  async function ue(he, ge, we) {
    switch (we.algorithm) {
      case v.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ee = y.Random.getBytes(y.xchacha20NonceLength);
        return new Uint8Array([
          ...Ee,
          ...await y.Xchacha20poly1305Ietf.encrypt(he, ge, Ee)
        ]);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${we.algorithm}'`);
    }
  }
  v.encrypt = ue;
  async function le(he, ge, we) {
    switch (we.algorithm) {
      case v.supportedAlgorithms.xchacha20poly1305Ietf: {
        const Ee = he.slice(0, y.xchacha20NonceLength);
        return y.Xchacha20poly1305Ietf.decrypt(he.slice(y.xchacha20NonceLength), ge, Ee);
      }
      default:
        throw new Error(`Unsupported encryption algorithm: '${we.algorithm}'`);
    }
  }
  v.decrypt = le;
})(wallet);
Object.defineProperty(directsecp256k1hdwallet, "__esModule", { value: !0 });
directsecp256k1hdwallet.DirectSecp256k1HdWallet = directsecp256k1hdwallet.extractKdfConfiguration = void 0;
const amino_1$2 = build$5, crypto_1$2 = build$4, encoding_1$2 = build, utils_1 = build$2, signing_1$1 = signing, wallet_1 = wallet, serializationTypeV1 = "directsecp256k1hdwallet-v1", basicPasswordHashingOptions = {
  algorithm: "argon2id",
  params: {
    outputLength: 32,
    opsLimit: 24,
    memLimitKib: 12 * 1024
  }
};
function isDerivationJson(v) {
  return !(!(0, utils_1.isNonNullObject)(v) || typeof v.hdPath != "string" || typeof v.prefix != "string");
}
function extractKdfConfigurationV1(v) {
  return v.kdf;
}
function extractKdfConfiguration(v) {
  const y = JSON.parse(v);
  if (!(0, utils_1.isNonNullObject)(y))
    throw new Error("Root document is not an object.");
  switch (y.type) {
    case serializationTypeV1:
      return extractKdfConfigurationV1(y);
    default:
      throw new Error("Unsupported serialization type");
  }
}
directsecp256k1hdwallet.extractKdfConfiguration = extractKdfConfiguration;
const defaultOptions$1 = {
  bip39Password: "",
  hdPaths: [(0, amino_1$2.makeCosmoshubPath)(0)],
  prefix: "cosmos"
};
class DirectSecp256k1HdWallet {
  /**
   * Restores a wallet from the given BIP39 mnemonic.
   *
   * @param mnemonic Any valid English mnemonic.
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async fromMnemonic(y, z = {}) {
    const ne = new crypto_1$2.EnglishMnemonic(y), ue = await crypto_1$2.Bip39.mnemonicToSeed(ne, z.bip39Password);
    return new DirectSecp256k1HdWallet(ne, {
      ...z,
      seed: ue
    });
  }
  /**
   * Generates a new wallet with a BIP39 mnemonic of the given length.
   *
   * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
   * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
   */
  static async generate(y = 12, z = {}) {
    const ne = 4 * Math.floor(11 * y / 33), ue = crypto_1$2.Random.getBytes(ne), le = crypto_1$2.Bip39.encode(ue);
    return DirectSecp256k1HdWallet.fromMnemonic(le.toString(), z);
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  static async deserialize(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    switch (ne.type) {
      case serializationTypeV1:
        return DirectSecp256k1HdWallet.deserializeTypeV1(y, z);
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  /**
   * Restores a wallet from an encrypted serialization.
   *
   * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
   * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
   * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
   */
  static async deserializeWithEncryptionKey(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    const ue = ne;
    switch (ue.type) {
      case serializationTypeV1: {
        const le = await (0, wallet_1.decrypt)((0, encoding_1$2.fromBase64)(ue.data), z, ue.encryption), he = JSON.parse((0, encoding_1$2.fromUtf8)(le)), { mnemonic: ge, accounts: we } = he;
        if ((0, utils_1.assert)(typeof ge == "string"), !Array.isArray(we))
          throw new Error("Property 'accounts' is not an array");
        if (!we.every(($e) => isDerivationJson($e)))
          throw new Error("Account is not in the correct format.");
        const Ee = we[0].prefix;
        if (!we.every(({ prefix: $e }) => $e === Ee))
          throw new Error("Accounts do not all have the same prefix");
        const xe = we.map(({ hdPath: $e }) => (0, crypto_1$2.stringToPath)($e));
        return DirectSecp256k1HdWallet.fromMnemonic(ge, {
          hdPaths: xe,
          prefix: Ee
        });
      }
      default:
        throw new Error("Unsupported serialization type");
    }
  }
  static async deserializeTypeV1(y, z) {
    const ne = JSON.parse(y);
    if (!(0, utils_1.isNonNullObject)(ne))
      throw new Error("Root document is not an object.");
    const ue = await (0, wallet_1.executeKdf)(z, ne.kdf);
    return DirectSecp256k1HdWallet.deserializeWithEncryptionKey(y, ue);
  }
  constructor(y, z) {
    const ne = z.prefix ?? defaultOptions$1.prefix, ue = z.hdPaths ?? defaultOptions$1.hdPaths;
    this.secret = y, this.seed = z.seed, this.accounts = ue.map((le) => ({
      hdPath: le,
      prefix: ne
    }));
  }
  get mnemonic() {
    return this.secret.toString();
  }
  async getAccounts() {
    return (await this.getAccountsWithPrivkeys()).map(({ algo: z, pubkey: ne, address: ue }) => ({
      algo: z,
      pubkey: ne,
      address: ue
    }));
  }
  async signDirect(y, z) {
    const ue = (await this.getAccountsWithPrivkeys()).find(({ address: Ne }) => Ne === y);
    if (ue === void 0)
      throw new Error(`Address ${y} not found in wallet`);
    const { privkey: le, pubkey: he } = ue, ge = (0, signing_1$1.makeSignBytes)(z), we = (0, crypto_1$2.sha256)(ge), Ee = await crypto_1$2.Secp256k1.createSignature(we, le), xe = new Uint8Array([...Ee.r(32), ...Ee.s(32)]), $e = (0, amino_1$2.encodeSecp256k1Signature)(he, xe);
    return {
      signed: z,
      signature: $e
    };
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * @param password The user provided password used to generate an encryption key via a KDF.
   *                 This is not normalized internally (see "Unicode normalization" to learn more).
   */
  async serialize(y) {
    const z = basicPasswordHashingOptions, ne = await (0, wallet_1.executeKdf)(y, z);
    return this.serializeWithEncryptionKey(ne, z);
  }
  /**
   * Generates an encrypted serialization of this wallet.
   *
   * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
   * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
   *
   * The caller is responsible for ensuring the key was derived with the given KDF options. If this
   * is not the case, the wallet cannot be restored with the original password.
   */
  async serializeWithEncryptionKey(y, z) {
    const ne = {
      mnemonic: this.mnemonic,
      accounts: this.accounts.map(({ hdPath: we, prefix: Ee }) => ({
        hdPath: (0, crypto_1$2.pathToString)(we),
        prefix: Ee
      }))
    }, ue = (0, encoding_1$2.toUtf8)(JSON.stringify(ne)), le = {
      algorithm: wallet_1.supportedAlgorithms.xchacha20poly1305Ietf
    }, he = await (0, wallet_1.encrypt)(ue, y, le), ge = {
      type: serializationTypeV1,
      kdf: z,
      encryption: le,
      data: (0, encoding_1$2.toBase64)(he)
    };
    return JSON.stringify(ge);
  }
  async getKeyPair(y) {
    const { privkey: z } = crypto_1$2.Slip10.derivePath(crypto_1$2.Slip10Curve.Secp256k1, this.seed, y), { pubkey: ne } = await crypto_1$2.Secp256k1.makeKeypair(z);
    return {
      privkey: z,
      pubkey: crypto_1$2.Secp256k1.compressPubkey(ne)
    };
  }
  async getAccountsWithPrivkeys() {
    return Promise.all(this.accounts.map(async ({ hdPath: y, prefix: z }) => {
      const { privkey: ne, pubkey: ue } = await this.getKeyPair(y), le = (0, encoding_1$2.toBech32)(z, (0, amino_1$2.rawSecp256k1PubkeyToRawAddress)(ue));
      return {
        algo: "secp256k1",
        privkey: ne,
        pubkey: ue,
        address: le
      };
    }));
  }
}
directsecp256k1hdwallet.DirectSecp256k1HdWallet = DirectSecp256k1HdWallet;
var directsecp256k1wallet = {};
Object.defineProperty(directsecp256k1wallet, "__esModule", { value: !0 });
directsecp256k1wallet.DirectSecp256k1Wallet = void 0;
const amino_1$1 = build$5, crypto_1$1 = build$4, encoding_1$1 = build, signing_1 = signing;
class DirectSecp256k1Wallet {
  /**
   * Creates a DirectSecp256k1Wallet from the given private key
   *
   * @param privkey The private key.
   * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
   */
  static async fromKey(y, z = "cosmos") {
    const ne = (await crypto_1$1.Secp256k1.makeKeypair(y)).pubkey;
    return new DirectSecp256k1Wallet(y, crypto_1$1.Secp256k1.compressPubkey(ne), z);
  }
  constructor(y, z, ne) {
    this.privkey = y, this.pubkey = z, this.prefix = ne;
  }
  get address() {
    return (0, encoding_1$1.toBech32)(this.prefix, (0, amino_1$1.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
  }
  async getAccounts() {
    return [
      {
        algo: "secp256k1",
        address: this.address,
        pubkey: this.pubkey
      }
    ];
  }
  async signDirect(y, z) {
    const ne = (0, signing_1.makeSignBytes)(z);
    if (y !== this.address)
      throw new Error(`Address ${y} not found in wallet`);
    const ue = (0, crypto_1$1.sha256)(ne), le = await crypto_1$1.Secp256k1.createSignature(ue, this.privkey), he = new Uint8Array([...le.r(32), ...le.s(32)]), ge = (0, amino_1$1.encodeSecp256k1Signature)(this.pubkey, he);
    return {
      signed: z,
      signature: ge
    };
  }
}
directsecp256k1wallet.DirectSecp256k1Wallet = DirectSecp256k1Wallet;
var paths = {};
Object.defineProperty(paths, "__esModule", { value: !0 });
paths.makeCosmoshubPath = void 0;
const crypto_1 = build$4;
function makeCosmoshubPath(v) {
  return [
    crypto_1.Slip10RawIndex.hardened(44),
    crypto_1.Slip10RawIndex.hardened(118),
    crypto_1.Slip10RawIndex.hardened(0),
    crypto_1.Slip10RawIndex.normal(0),
    crypto_1.Slip10RawIndex.normal(v)
  ];
}
paths.makeCosmoshubPath = makeCosmoshubPath;
var pubkey = {}, keys$2 = {}, __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$3(y, v, z);
  return __setModuleDefault$2(y, v), y;
};
Object.defineProperty(keys$2, "__esModule", { value: !0 });
keys$2.PrivKey = keys$2.PubKey = keys$2.protobufPackage = void 0;
const _m0$2 = __importStar$3(minimal), helpers_1$2 = helpers;
keys$2.protobufPackage = "cosmos.crypto.ed25519";
function createBasePubKey$1() {
  return {
    key: new Uint8Array()
  };
}
keys$2.PubKey = {
  encode(v, y = _m0$2.Writer.create()) {
    return v.key.length !== 0 && y.uint32(10).bytes(v.key), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$2.Reader ? v : new _m0$2.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBasePubKey$1();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.key = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      key: (0, helpers_1$2.isSet)(v.key) ? (0, helpers_1$2.bytesFromBase64)(v.key) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.key !== void 0 && (y.key = (0, helpers_1$2.base64FromBytes)(v.key !== void 0 ? v.key : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBasePubKey$1();
    return y.key = v.key ?? new Uint8Array(), y;
  }
};
function createBasePrivKey$1() {
  return {
    key: new Uint8Array()
  };
}
keys$2.PrivKey = {
  encode(v, y = _m0$2.Writer.create()) {
    return v.key.length !== 0 && y.uint32(10).bytes(v.key), y;
  },
  decode(v, y) {
    const z = v instanceof _m0$2.Reader ? v : new _m0$2.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBasePrivKey$1();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.key = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      key: (0, helpers_1$2.isSet)(v.key) ? (0, helpers_1$2.bytesFromBase64)(v.key) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.key !== void 0 && (y.key = (0, helpers_1$2.base64FromBytes)(v.key !== void 0 ? v.key : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBasePrivKey$1();
    return y.key = v.key ?? new Uint8Array(), y;
  }
};
var keys$1 = {}, __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$2(y, v, z);
  return __setModuleDefault$1(y, v), y;
};
Object.defineProperty(keys$1, "__esModule", { value: !0 });
keys$1.LegacyAminoPubKey = keys$1.protobufPackage = void 0;
const any_1$2 = any, _m0$1 = __importStar$2(minimal), helpers_1$1 = helpers;
keys$1.protobufPackage = "cosmos.crypto.multisig";
function createBaseLegacyAminoPubKey() {
  return {
    threshold: 0,
    publicKeys: []
  };
}
keys$1.LegacyAminoPubKey = {
  encode(v, y = _m0$1.Writer.create()) {
    v.threshold !== 0 && y.uint32(8).uint32(v.threshold);
    for (const z of v.publicKeys)
      any_1$2.Any.encode(z, y.uint32(18).fork()).ldelim();
    return y;
  },
  decode(v, y) {
    const z = v instanceof _m0$1.Reader ? v : new _m0$1.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBaseLegacyAminoPubKey();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.threshold = z.uint32();
          break;
        case 2:
          ue.publicKeys.push(any_1$2.Any.decode(z, z.uint32()));
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      threshold: (0, helpers_1$1.isSet)(v.threshold) ? Number(v.threshold) : 0,
      publicKeys: Array.isArray(v == null ? void 0 : v.publicKeys) ? v.publicKeys.map((y) => any_1$2.Any.fromJSON(y)) : []
    };
  },
  toJSON(v) {
    const y = {};
    return v.threshold !== void 0 && (y.threshold = Math.round(v.threshold)), v.publicKeys ? y.publicKeys = v.publicKeys.map((z) => z ? any_1$2.Any.toJSON(z) : void 0) : y.publicKeys = [], y;
  },
  fromPartial(v) {
    var z;
    const y = createBaseLegacyAminoPubKey();
    return y.threshold = v.threshold ?? 0, y.publicKeys = ((z = v.publicKeys) == null ? void 0 : z.map((ne) => any_1$2.Any.fromPartial(ne))) || [], y;
  }
};
var keys = {}, __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(v, y, z, ne) {
  ne === void 0 && (ne = z);
  var ue = Object.getOwnPropertyDescriptor(y, z);
  (!ue || ("get" in ue ? !y.__esModule : ue.writable || ue.configurable)) && (ue = { enumerable: !0, get: function() {
    return y[z];
  } }), Object.defineProperty(v, ne, ue);
} : function(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}), __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(v, y) {
  Object.defineProperty(v, "default", { enumerable: !0, value: y });
} : function(v, y) {
  v.default = y;
}), __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      z !== "default" && Object.prototype.hasOwnProperty.call(v, z) && __createBinding$1(y, v, z);
  return __setModuleDefault(y, v), y;
};
Object.defineProperty(keys, "__esModule", { value: !0 });
keys.PrivKey = keys.PubKey = keys.protobufPackage = void 0;
const _m0 = __importStar$1(minimal), helpers_1 = helpers;
keys.protobufPackage = "cosmos.crypto.secp256k1";
function createBasePubKey() {
  return {
    key: new Uint8Array()
  };
}
keys.PubKey = {
  encode(v, y = _m0.Writer.create()) {
    return v.key.length !== 0 && y.uint32(10).bytes(v.key), y;
  },
  decode(v, y) {
    const z = v instanceof _m0.Reader ? v : new _m0.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBasePubKey();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.key = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      key: (0, helpers_1.isSet)(v.key) ? (0, helpers_1.bytesFromBase64)(v.key) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.key !== void 0 && (y.key = (0, helpers_1.base64FromBytes)(v.key !== void 0 ? v.key : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBasePubKey();
    return y.key = v.key ?? new Uint8Array(), y;
  }
};
function createBasePrivKey() {
  return {
    key: new Uint8Array()
  };
}
keys.PrivKey = {
  encode(v, y = _m0.Writer.create()) {
    return v.key.length !== 0 && y.uint32(10).bytes(v.key), y;
  },
  decode(v, y) {
    const z = v instanceof _m0.Reader ? v : new _m0.Reader(v);
    let ne = y === void 0 ? z.len : z.pos + y;
    const ue = createBasePrivKey();
    for (; z.pos < ne; ) {
      const le = z.uint32();
      switch (le >>> 3) {
        case 1:
          ue.key = z.bytes();
          break;
        default:
          z.skipType(le & 7);
          break;
      }
    }
    return ue;
  },
  fromJSON(v) {
    return {
      key: (0, helpers_1.isSet)(v.key) ? (0, helpers_1.bytesFromBase64)(v.key) : new Uint8Array()
    };
  },
  toJSON(v) {
    const y = {};
    return v.key !== void 0 && (y.key = (0, helpers_1.base64FromBytes)(v.key !== void 0 ? v.key : new Uint8Array())), y;
  },
  fromPartial(v) {
    const y = createBasePrivKey();
    return y.key = v.key ?? new Uint8Array(), y;
  }
};
Object.defineProperty(pubkey, "__esModule", { value: !0 });
pubkey.decodePubkey = pubkey.anyToSinglePubkey = pubkey.encodePubkey = void 0;
const amino_1 = build$5, encoding_1 = build, math_1 = build$1, keys_1 = keys$2, keys_2 = keys$1, keys_3 = keys, any_1$1 = any;
function encodePubkey(v) {
  if ((0, amino_1.isSecp256k1Pubkey)(v)) {
    const y = keys_3.PubKey.fromPartial({
      key: (0, encoding_1.fromBase64)(v.value)
    });
    return any_1$1.Any.fromPartial({
      typeUrl: "/cosmos.crypto.secp256k1.PubKey",
      value: Uint8Array.from(keys_3.PubKey.encode(y).finish())
    });
  } else if ((0, amino_1.isEd25519Pubkey)(v)) {
    const y = keys_1.PubKey.fromPartial({
      key: (0, encoding_1.fromBase64)(v.value)
    });
    return any_1$1.Any.fromPartial({
      typeUrl: "/cosmos.crypto.ed25519.PubKey",
      value: Uint8Array.from(keys_1.PubKey.encode(y).finish())
    });
  } else if ((0, amino_1.isMultisigThresholdPubkey)(v)) {
    const y = keys_2.LegacyAminoPubKey.fromPartial({
      threshold: math_1.Uint53.fromString(v.value.threshold).toNumber(),
      publicKeys: v.value.pubkeys.map(encodePubkey)
    });
    return any_1$1.Any.fromPartial({
      typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
      value: Uint8Array.from(keys_2.LegacyAminoPubKey.encode(y).finish())
    });
  } else
    throw new Error(`Pubkey type ${v.type} not recognized`);
}
pubkey.encodePubkey = encodePubkey;
function anyToSinglePubkey(v) {
  switch (v.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey": {
      const { key: y } = keys_3.PubKey.decode(v.value);
      return (0, amino_1.encodeSecp256k1Pubkey)(y);
    }
    case "/cosmos.crypto.ed25519.PubKey": {
      const { key: y } = keys_1.PubKey.decode(v.value);
      return (0, amino_1.encodeEd25519Pubkey)(y);
    }
    default:
      throw new Error(`Pubkey type_url ${v.typeUrl} not recognized as single public key type`);
  }
}
pubkey.anyToSinglePubkey = anyToSinglePubkey;
function decodePubkey(v) {
  switch (v.typeUrl) {
    case "/cosmos.crypto.secp256k1.PubKey":
    case "/cosmos.crypto.ed25519.PubKey":
      return anyToSinglePubkey(v);
    case "/cosmos.crypto.multisig.LegacyAminoPubKey": {
      const { threshold: y, publicKeys: z } = keys_2.LegacyAminoPubKey.decode(v.value);
      return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
          threshold: y.toString(),
          pubkeys: z.map(anyToSinglePubkey)
        }
      };
    }
    default:
      throw new Error(`Pubkey type_url ${v.typeUrl} not recognized`);
  }
}
pubkey.decodePubkey = decodePubkey;
var registry = {};
Object.defineProperty(registry, "__esModule", { value: !0 });
registry.Registry = registry.isTxBodyEncodeObject = registry.isPbjsGeneratedType = registry.isTsProtoGeneratedType = void 0;
const tx_1 = tx$2, coin_1 = coin$1, tx_2 = tx, any_1 = any;
function isTsProtoGeneratedType(v) {
  return typeof v.fromPartial == "function";
}
registry.isTsProtoGeneratedType = isTsProtoGeneratedType;
function isPbjsGeneratedType(v) {
  return !isTsProtoGeneratedType(v);
}
registry.isPbjsGeneratedType = isPbjsGeneratedType;
const defaultTypeUrls = {
  cosmosCoin: "/cosmos.base.v1beta1.Coin",
  cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
  cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
  googleAny: "/google.protobuf.Any"
};
function isTxBodyEncodeObject(v) {
  return v.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
registry.isTxBodyEncodeObject = isTxBodyEncodeObject;
class Registry {
  /**
   * Creates a new Registry for mapping protobuf type identifiers/type URLs to
   * actual implementations. Those implementations are typically generated with ts-proto
   * but we also support protobuf.js as a type generator.
   *
   * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
   * for historic reasons. Those can be overriden by customTypes.
   *
   * There are currently two methods for adding new types:
   * 1. Passing types to the constructor.
   * 2. Using the `register()` method
   */
  constructor(y) {
    const { cosmosCoin: z, cosmosMsgSend: ne } = defaultTypeUrls;
    this.types = y ? new Map([...y]) : /* @__PURE__ */ new Map([
      [z, coin_1.Coin],
      [ne, tx_1.MsgSend]
    ]);
  }
  register(y, z) {
    this.types.set(y, z);
  }
  /**
   * Looks up a type that was previously added to the registry.
   *
   * The generator information (ts-proto or pbjs) gets lost along the way.
   * If you need to work with the result type in TypeScript, you can use:
   *
   * ```
   * import { assert } from "@cosmjs/utils";
   *
   * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
   * assert(Coin); // Ensures not unset
   * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
   *
   * // Coin is typed TsProtoGeneratedType now.
   * ```
   */
  lookupType(y) {
    return this.types.get(y);
  }
  lookupTypeWithError(y) {
    const z = this.lookupType(y);
    if (!z)
      throw new Error(`Unregistered type url: ${y}`);
    return z;
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to protobuf if
   * the given type was previously registered.
   *
   * If the value has to be wrapped in an Any, this needs to be done
   * manually after this call. Or use `encodeAsAny` instead.
   */
  encode(y) {
    const { value: z, typeUrl: ne } = y;
    if (isTxBodyEncodeObject(y))
      return this.encodeTxBody(z);
    const ue = this.lookupTypeWithError(ne), le = isTsProtoGeneratedType(ue) ? ue.fromPartial(z) : ue.create(z);
    return ue.encode(le).finish();
  }
  /**
   * Takes a typeUrl/value pair and encodes the value to an Any if
   * the given type was previously registered.
   */
  encodeAsAny(y) {
    const z = this.encode(y);
    return any_1.Any.fromPartial({
      typeUrl: y.typeUrl,
      value: z
    });
  }
  encodeTxBody(y) {
    const z = y.messages.map((ue) => this.encodeAsAny(ue)), ne = tx_2.TxBody.fromPartial({
      ...y,
      messages: z
    });
    return tx_2.TxBody.encode(ne).finish();
  }
  decode({ typeUrl: y, value: z }) {
    if (y === defaultTypeUrls.cosmosTxBody)
      return this.decodeTxBody(z);
    const ue = this.lookupTypeWithError(y).decode(z);
    return Object.entries(ue).forEach(([le, he]) => {
      typeof Buffer < "u" && typeof Buffer.isBuffer < "u" && Buffer.isBuffer(he) && (ue[le] = Uint8Array.from(he));
    }), ue;
  }
  decodeTxBody(y) {
    const z = tx_2.TxBody.decode(y);
    return {
      ...z,
      messages: z.messages.map(({ typeUrl: ne, value: ue }) => {
        if (!ne)
          throw new Error("Missing type_url in Any");
        if (!ue)
          throw new Error("Missing value in Any");
        return this.decode({ typeUrl: ne, value: ue });
      })
    };
  }
}
registry.Registry = Registry;
var signer = {};
Object.defineProperty(signer, "__esModule", { value: !0 });
signer.isOfflineDirectSigner = void 0;
function isOfflineDirectSigner(v) {
  return v.signDirect !== void 0;
}
signer.isOfflineDirectSigner = isOfflineDirectSigner;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.coins = v.coin = v.executeKdf = v.makeSignDoc = v.makeSignBytes = v.makeAuthInfoBytes = v.isOfflineDirectSigner = v.Registry = v.isTxBodyEncodeObject = v.isTsProtoGeneratedType = v.isPbjsGeneratedType = v.encodePubkey = v.decodePubkey = v.anyToSinglePubkey = v.makeCosmoshubPath = v.DirectSecp256k1Wallet = v.extractKdfConfiguration = v.DirectSecp256k1HdWallet = v.decodeTxRaw = v.parseCoins = void 0;
  var y = coins$2;
  Object.defineProperty(v, "parseCoins", { enumerable: !0, get: function() {
    return y.parseCoins;
  } });
  var z = decode$3;
  Object.defineProperty(v, "decodeTxRaw", { enumerable: !0, get: function() {
    return z.decodeTxRaw;
  } });
  var ne = directsecp256k1hdwallet;
  Object.defineProperty(v, "DirectSecp256k1HdWallet", { enumerable: !0, get: function() {
    return ne.DirectSecp256k1HdWallet;
  } }), Object.defineProperty(v, "extractKdfConfiguration", { enumerable: !0, get: function() {
    return ne.extractKdfConfiguration;
  } });
  var ue = directsecp256k1wallet;
  Object.defineProperty(v, "DirectSecp256k1Wallet", { enumerable: !0, get: function() {
    return ue.DirectSecp256k1Wallet;
  } });
  var le = paths;
  Object.defineProperty(v, "makeCosmoshubPath", { enumerable: !0, get: function() {
    return le.makeCosmoshubPath;
  } });
  var he = pubkey;
  Object.defineProperty(v, "anyToSinglePubkey", { enumerable: !0, get: function() {
    return he.anyToSinglePubkey;
  } }), Object.defineProperty(v, "decodePubkey", { enumerable: !0, get: function() {
    return he.decodePubkey;
  } }), Object.defineProperty(v, "encodePubkey", { enumerable: !0, get: function() {
    return he.encodePubkey;
  } });
  var ge = registry;
  Object.defineProperty(v, "isPbjsGeneratedType", { enumerable: !0, get: function() {
    return ge.isPbjsGeneratedType;
  } }), Object.defineProperty(v, "isTsProtoGeneratedType", { enumerable: !0, get: function() {
    return ge.isTsProtoGeneratedType;
  } }), Object.defineProperty(v, "isTxBodyEncodeObject", { enumerable: !0, get: function() {
    return ge.isTxBodyEncodeObject;
  } }), Object.defineProperty(v, "Registry", { enumerable: !0, get: function() {
    return ge.Registry;
  } });
  var we = signer;
  Object.defineProperty(v, "isOfflineDirectSigner", { enumerable: !0, get: function() {
    return we.isOfflineDirectSigner;
  } });
  var Ee = signing;
  Object.defineProperty(v, "makeAuthInfoBytes", { enumerable: !0, get: function() {
    return Ee.makeAuthInfoBytes;
  } }), Object.defineProperty(v, "makeSignBytes", { enumerable: !0, get: function() {
    return Ee.makeSignBytes;
  } }), Object.defineProperty(v, "makeSignDoc", { enumerable: !0, get: function() {
    return Ee.makeSignDoc;
  } });
  var xe = wallet;
  Object.defineProperty(v, "executeKdf", { enumerable: !0, get: function() {
    return xe.executeKdf;
  } });
  var $e = build$5;
  Object.defineProperty(v, "coin", { enumerable: !0, get: function() {
    return $e.coin;
  } }), Object.defineProperty(v, "coins", { enumerable: !0, get: function() {
    return $e.coins;
  } });
})(build$6);
const getPublicKey = ({ chainId: v, coinType: y, key: z }) => {
  const ne = build$6.encodePubkey(build$5.encodeSecp256k1Pubkey(z));
  let ue = "";
  return v.startsWith("injective") ? ue = "/injective.crypto.v1beta1.ethsecp256k1.PubKey" : v.startsWith("evmos") || y === "60" ? ue = "/ethermint.crypto.v1.ethsecp256k1.PubKey" : ue = "/cosmos.crypto.secp256k1.PubKey", {
    typeUrl: ue,
    value: ne.value
  };
}, createSignDoc = (v, y, z, ne, ue, le) => {
  const he = getPublicKey({ chainId: v, coinType: y, key: z.pubKey });
  return tx.SignDoc.fromPartial({
    chainId: v,
    accountNumber: z.accountNumber,
    bodyBytes: tx.TxBody.encode(tx.TxBody.fromPartial({
      messages: ne,
      memo: le
    })).finish(),
    authInfoBytes: tx.AuthInfo.encode({
      signerInfos: [
        tx.SignerInfo.fromPartial({
          publicKey: he,
          modeInfo: {
            single: {
              mode: signing$1.SignMode.SIGN_MODE_DIRECT
            }
          },
          sequence: z.sequence
        })
      ],
      fee: tx.Fee.fromPartial({
        amount: ue.amount.map((ge) => ({ amount: ge.amount, denom: ge.denom })),
        gasLimit: ue.gas,
        granter: ue.granter ?? "",
        payer: ue.payer ?? ""
      })
    }).finish()
  });
};
class TxClient {
  /**
   * Constructs a `TxClient` instance.
   * @param chainId - The blockchain chain ID.
   * @param restUrl - The REST URL of the blockchain node.
   * @param coinType - The coin type identifier.
   * @param signer - The object responsible for signing transactions ({@link Signer}).
   * @param account - The account information ({@link Account}).
   */
  constructor(y, z, ne, ue, le) {
    Rm(this, "chainId");
    Rm(this, "restUrl");
    Rm(this, "coinType");
    Rm(this, "signer");
    Rm(this, "account");
    Rm(this, "registry");
    /**
     * Signs a transaction using the direct signing method.
     * @param address - The address of the account.
     * @param messages - An array of messages to be included in the transaction ({@link DecodeObject}[]).
     * @param fee - The transaction fee information ({@link StdFee}).
     * @param memo - Optional transaction memo.
     * @returns A Promise resolving to the signed transaction as a base64 encoded string.
     */
    Rm(this, "signDirect", async (y, z, ne, ue) => {
      const le = await fetchAccountDetails(this.restUrl, y), he = createSignDoc(this.chainId, this.coinType, {
        ...le,
        pubKey: this.account.pubKey
      }, z.map(($e) => ({
        typeUrl: $e.typeUrl,
        value: $e.value
      })), ne, ue ?? ""), ge = await this.signer.signDirect(y, he);
      let we;
      "signed" in ge && "signature" in ge ? we = tx.TxRaw.fromPartial({
        bodyBytes: ge.signed.bodyBytes,
        authInfoBytes: ge.signed.authInfoBytes,
        signatures: [ge.signature]
      }) : we = ge;
      const Ee = tx.TxRaw.encode(we).finish();
      return Buffer.from(Ee).toString("base64");
    });
    /**
     * Signs a transaction using the Amino signing method.
     * @param address - The address of the account.
     * @param messages - An array of messages to be included in the transaction ({@link EncodeObject}[]).
     * @param fee - The transaction fee information ({@link StdFee}).
     * @param memo - Optional transaction memo.
     * @returns A Promise resolving to the signed transaction as a base64 encoded string.
     */
    Rm(this, "signAmino", async (y, z, ne, ue) => {
      const le = new AminoTypes({
        ...createDefaultAminoConverters(),
        ...createWasmAminoConverters()
      }), he = await fetchAccountDetails(this.restUrl, y), ge = [le.toAmino(z[0])];
      z[0].value.memo && (ge[0].value.memo = z[0].value.memo);
      const we = build$5.makeSignDoc(ge, ne, this.chainId, ue ?? "", he.accountNumber, he.sequence), Ee = await this.signer.signAmino(y, we);
      let xe;
      if ("signed" in Ee && "signature" in Ee) {
        const st = {
          messages: Ee.signed.msgs.map((_a) => le.fromAmino(_a)),
          memo: Ee.signed.memo
        };
        z[0].value.memo && (st.messages[0].value.memo = z[0].value.memo);
        const Nr = {
          typeUrl: "/cosmos.tx.v1beta1.TxBody",
          value: st
        }, br = this.registry.encode(Nr), $n = build$1.Int53.fromString(Ee.signed.fee.gas).toNumber(), En = build$1.Int53.fromString(Ee.signed.sequence).toNumber(), Rn = signing$1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON, wa = getPublicKey({
          chainId: this.chainId,
          coinType: this.coinType,
          key: this.account.pubKey
        }), Aa = build$6.makeAuthInfoBytes([{ pubkey: wa, sequence: En }], Ee.signed.fee.amount, $n, Ee.signed.fee.granter, Ee.signed.fee.payer, Rn);
        xe = tx.TxRaw.fromPartial({
          bodyBytes: br,
          authInfoBytes: Aa,
          signatures: [Ee.signature]
        });
      } else
        xe = Ee;
      const $e = tx.TxRaw.encode(xe).finish();
      return Buffer.from($e).toString("base64");
    });
    /**
     * Signs a transaction using the appropriate method based on the account type.
     * @param address - The address of the account.
     * @param messages - An array of messages to be included in the transaction ({@link EncodeObject}[]).
     * @param fee - The transaction fee information ({@link StdFee}).
     * @param memo - Optional transaction memo.
     * @returns A Promise resolving to the signed transaction as a base64 encoded string.
     */
    Rm(this, "sign", async (y, z, ne, ue) => {
      if (this.account.isNanoLedger)
        return await this.signAmino(y, z, ne, ue);
      const le = z.map((ge) => getDecodedMessageMetadataForSigning(ge));
      return await this.signDirect(y, le, ne, ue);
    });
    /**
     * Broadcasts a signed transaction to the blockchain.
     * @param txBytesString - The signed transaction as a base64 encoded string.
     * @returns A Promise resolving to the broadcast transaction response ({@link SignAndBroadcastResponse}).
     */
    Rm(this, "broadcastTx", async (y) => {
      const z = await fetch(`${this.restUrl}/cosmos/tx/v1beta1/txs`, {
        method: "POST",
        headers: {
          "x-requested-with": "leap-client"
        },
        body: JSON.stringify({
          tx_bytes: y,
          mode: "BROADCAST_MODE_SYNC"
        })
      });
      if (!z.ok)
        throw new Error(`Error broadcasting tx: ${await z.text()}`);
      const { tx_response: { txhash: ne, code: ue, gas_wanted: le, gas_used: he, timestamp: ge, height: we, codespace: Ee } } = await z.json();
      return {
        code: ue,
        codespace: Ee,
        transactionHash: ne,
        height: parseInt(we),
        gasWanted: parseInt(le),
        gasUsed: parseInt(he),
        timestamp: ge
      };
    });
    /**
     * Signs and broadcasts a transaction.
     * @param address - The address of the account.
     * @param messages - An array of messages to be included in the transaction ({@link EncodeObject}[]).
     * @param fee - The transaction fee information ({@link StdFee}).
     * @param memo - Optional transaction memo.
     * @returns A Promise resolving to the broadcast transaction response ({@link SignAndBroadcastResponse}).
     */
    Rm(this, "signAndBroadcastTx", async (y, z, ne, ue) => {
      const le = await this.sign(y, z, ne, ue);
      return this.broadcastTx(le);
    });
    /**
     * Submits a transaction using the Skip API.
     * @param chainId - The blockchain chain ID.
     * @param txBytesString - The signed transaction as a base64 encoded string.
     * @returns A Promise resolving to the result of the transaction submission.
     */
    Rm(this, "submitTx", async (y, z) => {
      const ne = await SkipAPI.submitTransaction({
        chain_id: y,
        tx: z
      });
      if (ne.success)
        return ne;
      throw new Error(ne.error);
    });
    this.chainId = y, this.restUrl = z, this.coinType = ne, this.signer = ue, this.account = le, this.registry = new build$6.Registry(defaultRegistryTypes), this.registry.register("/cosmwasm.wasm.v1.MsgExecuteContract", tx$1.MsgExecuteContract);
  }
}
var QueryKeys;
(function(v) {
  v.DENOMS = "@leapwallet/elements-hooks:denoms", v.BALANCES = "@leapwallet/elements-hooks:balances", v.CHAINS = "@leapwallet/elements-hooks:chains", v.SQUID_CHAINS = "@leapwallet/elements-hooks:squid-chains", v.SQUID_ASSETS = "@leapwallet/elements-hooks:squid-assets", v.GAS_PRICE_STEPS = "@leapwallet/elements-hooks:gas-price-steps", v.GAS_ADJUSTMENT = "@leapwallet/elements-hooks:gas-adjustment", v.NATIVE_FEE_DENOMS = "@leapwallet/elements-core:native-fee-denoms", v.SKIP_ASSETS_BY_CHAIN = "@leapwallet/elements-hooks:skip-assets-by-chain", v.ALL_SKIP_ASSETS = "@leapwallet/elements-hooks:all-skip-assets", v.SKIP_SUPPORTED_CHAINS = "@leapwallet/elements-hooks:skip-supported-chains", v.SKIP_SUPPORTED_EVM_CHAINS = "@leapwallet/elements-hooks:skip-supported-evm-chains", v.SKIP_DESTINATION_CHAINS = "@leapwallet/elements-hooks:skip-destination-chains", v.SKIP_DESTINATION_EVM_CHAINS = "@leapwallet/elements-hooks:skip-destination-evm-chains", v.IBC_SOURCE_CHANNEL_ID = "@leapwallet/elements-hooks:ibc-source-channel-id", v.KADO_QUOTE = "@leapwallet/elements-hooks:kado-quote", v.KADO_FIAT_CONVERSION_RATE = "@leapwallet/elements-hooks:kado-fiat-conversion-rate", v.KADO_CURRENCY_LIST = "@leapwallet/elements-hooks:kado-currency-list", v.KADO_ASSETS = "@leapwallet/elements-hooks:kado-assets", v.KADO_SUPPORTED_COSMOS_CHAINS = "@leapwallet/elements-hooks:kado-supported-cosmos-chains";
})(QueryKeys || (QueryKeys = {}));
const useChains = (v = !1) => useSWR(`${QueryKeys.CHAINS}-${v}`, async () => {
  const [y, z, ne] = await Promise.allSettled([
    getChains(),
    getRestUrls(),
    getRpcUrls()
  ]);
  if (y.status === "rejected")
    throw y.reason;
  const ue = y.value.map((le) => {
    var we, Ee, xe, $e, Ne, st, Nr, br, $n, En;
    const he = z.status === "fulfilled" ? (xe = (Ee = (we = z.value) == null ? void 0 : we[le.chainId]) == null ? void 0 : Ee[0]) == null ? void 0 : xe.nodeUrl : void 0, ge = ne.status === "fulfilled" ? (st = (Ne = ($e = ne.value) == null ? void 0 : $e[le.chainId]) == null ? void 0 : Ne[0]) == null ? void 0 : st.nodeUrl : void 0;
    return {
      ...le,
      chainType: "cosmos",
      restUrl: he ?? ((br = (Nr = le == null ? void 0 : le.privateInfra) == null ? void 0 : Nr[NodeProvider.NUMIA]) == null ? void 0 : br.restUrl) ?? le.restUrl,
      rpcUrl: ge ?? ((En = ($n = le == null ? void 0 : le.privateInfra) == null ? void 0 : $n[NodeProvider.NUMIA]) == null ? void 0 : En.rpcUrl) ?? le.rpcUrl
    };
  });
  return v ? ue == null ? void 0 : ue.filter((le) => le == null ? void 0 : le.testnetChainId).map((le) => ({
    ...le,
    chainId: le.testnetChainId,
    restUrl: le.restTestUrl,
    rpcUrl: le.rpcTestUrl
  })) : ue;
}, {
  dedupingInterval: 1e3 * 10
  // 10 seconds
}), useDenoms = () => useSWR(QueryKeys.DENOMS, getDenoms, {
  dedupingInterval: 1e3 * 60
  // 1 minute
}), getDenomData = async (v, y, z, ne) => {
  const ue = z.find((he) => he.chainId === y);
  if (!ue)
    return;
  if (v.startsWith("ibc/")) {
    const { baseDenom: he, path: ge } = await DenomFetcher.getTrace(v, ue), we = z.reduce((xe, $e) => (xe[$e.chainId] = $e, xe), {});
    let Ee;
    if (he === "uluna")
      Ee = await getSourceChain(ge, ue, we) === "columbus-5" ? ne.lunc : ne[he];
    else if (he === "uusdc") {
      const xe = await getSourceChain(ge, ue, we);
      Ee = xe && ["noble-1", "grand-1"].includes(xe) ? ne.usdc : ne[he];
    } else
      Ee = ne[he];
    return Ee || void 0;
  }
  const le = v.replace("cw20:", "");
  return le === "uusdc" && ["noble-1", "grand-1"].includes(y) ? ne.usdc : ne[le];
}, useDenomData = (v, y) => {
  const { data: z } = useDenoms(), { data: ne } = useChains();
  return useSWR(z && v && ne ? `denom-data:${v}` : null, async () => {
    if (!v || !ne || !z)
      throw new Error("Missing denom, chains, or denoms");
    return getDenomData(v, y, ne, z);
  });
}, useGasPriceSteps = () => useSWR(QueryKeys.GAS_PRICE_STEPS, getGasPriceSteps, {
  dedupingInterval: 1e3 * 60
  // 1 minute
}), useGasAdjustment = () => useSWR(QueryKeys.GAS_ADJUSTMENT, getGasAdjustment, {
  dedupingInterval: 1e3 * 60
  // 1 minute
}), useKadoSupportedChains = (v, y = !0) => {
  const { data: z } = useChains();
  return useSWR(z && y ? QueryKeys.KADO_SUPPORTED_COSMOS_CHAINS : null, async () => {
    if (!z)
      throw new Error("Chains not loaded");
    const ne = await KadoAPI.getSupportedChains();
    if (ne.success) {
      const ue = [];
      return ne.chains.forEach((le) => {
        const he = z.findIndex((we) => we.chainId === le.officialId), ge = z[he];
        he !== -1 && ue.push({
          ...le,
          ...ge,
          logoUri: ge.icon
        });
      }), {
        success: !0,
        chains: ue
      };
    } else
      return ne;
  }, v ?? {
    revalidateOnFocus: !1,
    revalidateOnReconnect: !1
  });
}, useSkipAssets = (v, y) => {
  const z = (y == null ? void 0 : y.nativeOnly) ?? !1, ne = (y == null ? void 0 : y.includeEVMAssets) ?? !1, ue = (y == null ? void 0 : y.includeCW20Assets) ?? !1, le = (y == null ? void 0 : y.includeSVMAssets) ?? !1, he = (y == null ? void 0 : y.includeNoMetadataAssets) ?? !1, ge = v ? unstable_serialize([
    QueryKeys.SKIP_ASSETS_BY_CHAIN,
    v,
    `includeEVMAssets-${ne}`,
    `includeCW20Assets-${ue}`,
    `includeSvmAssets-${le}`,
    `nativeOnly-${z}`,
    `includeNoMetadataAssets-${he}`
  ]) : null;
  return useSWR(ge, async () => {
    if (!v)
      throw new Error("Chain ID is required");
    const we = await SkipAPI.getSupportedAssetsForChain({
      chainId: v,
      nativeOnly: z,
      includeEVMAssets: ne,
      includeCW20Assets: ue,
      includeNoMetadataAssets: he,
      includeSVMAssets: le
    });
    if (we.success)
      return we.assets;
  });
}, useAllSkipAssets = (v) => {
  const y = (v == null ? void 0 : v.includeEVMAssets) ?? !0, z = (v == null ? void 0 : v.includeCW20Assets) ?? !0, ne = (v == null ? void 0 : v.includeNoMetadataAssets) ?? !1, ue = (v == null ? void 0 : v.nativeOnly) ?? !1, le = (v == null ? void 0 : v.includeSVMAssets) ?? !0, he = unstable_serialize([
    QueryKeys.ALL_SKIP_ASSETS,
    `nativeOnly-${ue}`,
    `includeEVMAssets-${y}`,
    `includeCW20Assets-${z}`,
    `includeSvmAssets-${le}`,
    `includeNoMetadataAssets-${ne}`
  ]);
  return useSWR(he, async () => {
    const ge = await SkipAPI.getSupportedAssets({
      nativeOnly: ue,
      includeEVMAssets: y,
      includeCW20Assets: z,
      includeNoMetadataAssets: ne,
      includeSVMAssets: le
    });
    if (ge.success)
      return ge.assets;
    throw new Error(ge.error);
  }, {
    revalidateOnFocus: !1,
    dedupingInterval: 60 * 1e3
    // 1 minute
  });
}, useKadoAssets = () => {
  const v = useKadoSupportedChains(), y = useAllSkipAssets({
    includeEVMAssets: !1,
    includeCW20Assets: !0,
    includeNoMetadataAssets: !1,
    includeSVMAssets: !1,
    nativeOnly: !1
  }), z = useMemo(() => {
    var ne;
    if (!(!v.data || !((ne = v.data) != null && ne.success)))
      return v.data.chains;
  }, [v == null ? void 0 : v.data]);
  return useSWR(z && y.data ? QueryKeys.KADO_ASSETS : null, async () => {
    if (!y.data || !z)
      throw new Error("Assets or chains not loaded");
    return z.reduce((ue, le) => (ue[le.chainId] = le.associatedAssets.map((he) => {
      var ge, we;
      return (we = (ge = y.data) == null ? void 0 : ge[le.chainId]) == null ? void 0 : we.find((Ee) => Ee.symbol === he.symbol);
    }).filter((he) => he !== void 0), ue), {});
  });
};
function convertAddress$1(v, y) {
  const z = bech32$6.decode(v);
  return bech32$6.encode(y, z.words);
}
const tenMillion = new BigNumber(10).pow(7), formatAmount$1 = (v, y = 0, z = 2) => {
  const ne = new BigNumber(v), ue = new BigNumber(10).pow(-z);
  return ne.isNaN() ? "" : ne.isZero() ? "0" : ne.isLessThan(ue) ? `< ${ue}` : Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: ne.isGreaterThanOrEqualTo(tenMillion) ? "compact" : "standard",
    maximumFractionDigits: z,
    minimumFractionDigits: y
  }).format(ne.toNumber()).slice(1);
}, useUSDPrice = (v) => useSWR(v ? `coingecko-usd-price:${v}` : null, async () => {
  if (!v)
    throw new Error("coingeckoId is not defined");
  const y = await CoinGeckoAPI.getCoinPrice(v);
  if (y !== -1)
    return y;
}, {
  dedupingInterval: 1e3 * 60 * 5
  // 5 minutes
}), useFiatConversionRateSWR = (v, y, z = !0, ne = {}) => useSWR(z ? `${QueryKeys.KADO_FIAT_CONVERSION_RATE}:${v}:${y}` : null, async () => {
  if (!v || !y)
    throw new Error("Missing from or to");
  return v === y ? {
    success: !0,
    conversionRate: 1
  } : KadoAPI.getConversionRate({
    from: v,
    to: y
  });
}, {
  ...ne,
  errorRetryCount: 2
});
async function getDestinationChainIdFromSourceChannelId(v, y) {
  const ne = await (await fetch(`${v.restUrl}/ibc/core/channel/v1/channels/${y}/ports/transfer/client_state`)).json();
  if ("identified_client_state" in ne)
    return ne.identified_client_state.client_state.chain_id;
}
const useCosmosBalances = (v, y, z = !0, ne = [], ue = void 0) => {
  const { data: le } = useDenoms();
  return useSWR(z && le && y && v ? `${QueryKeys.BALANCES}-${v}` : null, async () => {
    if (!y)
      throw new Error("Chain data missing");
    if (!le)
      throw new Error("Denom data missing");
    if (y)
      return TokenBalanceAPI.getRichBalances(v, le, [y], ne);
  }, ue ?? {
    refreshInterval: 1e3 * 60,
    dedupingInterval: 1e3 * 30,
    revalidateOnFocus: !1
  });
}, useRevalidateBalances = () => {
  const { mutate: v } = useSWRConfig();
  return useCallback(() => {
    v(QueryKeys.BALANCES);
  }, [v]);
}, global$1 = globalThis || void 0 || self;
var A0 = Object.defineProperty, k0 = (v, y, z) => y in v ? A0(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, t2 = (v, y, z) => (k0(v, typeof y != "symbol" ? y + "" : y, z), z), N0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global$1 < "u" ? global$1 : typeof self < "u" ? self : {}, R1 = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", G1 = {};
for (var B1 = 0; B1 < R1.length; B1++) {
  var J1 = R1.charAt(B1);
  if (G1[J1] !== void 0)
    throw new TypeError(J1 + " is ambiguous");
  G1[J1] = B1;
}
function E2(v) {
  var y = v >> 25;
  return (v & 33554431) << 5 ^ -(y >> 0 & 1) & 996825010 ^ -(y >> 1 & 1) & 642813549 ^ -(y >> 2 & 1) & 513874426 ^ -(y >> 3 & 1) & 1027748829 ^ -(y >> 4 & 1) & 705979059;
}
function h0(v) {
  for (var y = 1, z = 0; z < v.length; ++z) {
    var ne = v.charCodeAt(z);
    if (ne < 33 || ne > 126)
      return "Invalid prefix (" + v + ")";
    y = E2(y) ^ ne >> 5;
  }
  for (y = E2(y), z = 0; z < v.length; ++z) {
    var ue = v.charCodeAt(z);
    y = E2(y) ^ ue & 31;
  }
  return y;
}
function _0(v, y, z) {
  if (z = z || 90, v.length + 7 + y.length > z)
    throw new TypeError("Exceeds length limit");
  v = v.toLowerCase();
  var ne = h0(v);
  if (typeof ne == "string")
    throw new Error(ne);
  for (var ue = v + "1", le = 0; le < y.length; ++le) {
    var he = y[le];
    if (he >> 5)
      throw new Error("Non 5-bit word");
    ne = E2(ne) ^ he, ue += R1.charAt(he);
  }
  for (le = 0; le < 6; ++le)
    ne = E2(ne);
  for (ne ^= 1, le = 0; le < 6; ++le) {
    var ge = ne >> (5 - le) * 5 & 31;
    ue += R1.charAt(ge);
  }
  return ue;
}
function u0(v, y) {
  if (y = y || 90, v.length < 8)
    return v + " too short";
  if (v.length > y)
    return "Exceeds length limit";
  var z = v.toLowerCase(), ne = v.toUpperCase();
  if (v !== z && v !== ne)
    return "Mixed-case string " + v;
  v = z;
  var ue = v.lastIndexOf("1");
  if (ue === -1)
    return "No separator character for " + v;
  if (ue === 0)
    return "Missing prefix for " + v;
  var le = v.slice(0, ue), he = v.slice(ue + 1);
  if (he.length < 6)
    return "Data too short";
  var ge = h0(le);
  if (typeof ge == "string")
    return ge;
  for (var we = [], Ee = 0; Ee < he.length; ++Ee) {
    var xe = he.charAt(Ee), $e = G1[xe];
    if ($e === void 0)
      return "Unknown character " + xe;
    ge = E2(ge) ^ $e, !(Ee + 6 >= he.length) && we.push($e);
  }
  return ge !== 1 ? "Invalid checksum for " + v : { prefix: le, words: we };
}
function C0() {
  var v = u0.apply(null, arguments);
  if (typeof v == "object")
    return v;
}
function O0(v) {
  var y = u0.apply(null, arguments);
  if (typeof y == "object")
    return y;
  throw new Error(y);
}
function T1(v, y, z, ne) {
  for (var ue = 0, le = 0, he = (1 << z) - 1, ge = [], we = 0; we < v.length; ++we)
    for (ue = ue << y | v[we], le += y; le >= z; )
      le -= z, ge.push(ue >> le & he);
  if (ne)
    le > 0 && ge.push(ue << z - le & he);
  else {
    if (le >= y)
      return "Excess padding";
    if (ue << z - le & he)
      return "Non-zero padding";
  }
  return ge;
}
function E0(v) {
  var y = T1(v, 8, 5, !0);
  if (Array.isArray(y))
    return y;
}
function F0(v) {
  var y = T1(v, 8, 5, !0);
  if (Array.isArray(y))
    return y;
  throw new Error(y);
}
function I0(v) {
  var y = T1(v, 5, 8, !1);
  if (Array.isArray(y))
    return y;
}
function j0(v) {
  var y = T1(v, 5, 8, !1);
  if (Array.isArray(y))
    return y;
  throw new Error(y);
}
var x2 = {
  decodeUnsafe: C0,
  decode: O0,
  encode: _0,
  toWordsUnsafe: E0,
  toWords: F0,
  fromWordsUnsafe: I0,
  fromWords: j0
}, S$1 = /* @__PURE__ */ ((v) => (v.NETWORK = "network", v.NOT_FOUND = "not-found", v.UNREGISTERED_SERVICE = "unregistered-service", v.DUPLICATE_SERVICE = "duplicate-service", v.INVALID_ADDRESS = "invalid-address", v))(S$1 || {});
let N$1 = class extends Error {
  constructor(y, z) {
    super(y), t2(this, "type"), this.name = "MatchaError", this.type = z;
  }
};
const P1 = class {
};
let U2 = P1;
t2(U2, "clients", {}), t2(U2, "getClient", async (v) => {
  let y = P1.clients[v];
  return y === void 0 && (y = await CosmWasmClient.connect(v), P1.clients[v] = y), y;
});
class q2 {
  /**
   * @param network The network to use
   */
  getCosmWasmClient(y) {
    return U2.getClient(y);
  }
}
const o0 = {
  mainnet: "https://rpc.cosmos.directory/osmosis",
  testnet: "https://rpc-test.osmosis.zone"
}, d0 = "icns";
class D0 extends q2 {
  constructor() {
    super(...arguments), t2(this, "serviceID", d0), t2(this, "chain", "osmosis"), t2(this, "contractAddress", {
      mainnet: "osmo1xk0s8xgktn9x5vwcgtjdxqzadg88fgn33p8u9cnpdxwemvxscvast52cdd",
      testnet: "osmo1q2qpencrnnlamwalxt6tac2ytl35z5jejn0v4frnp6jff7gwp37sjcnhu5"
    });
  }
  async resolve(y, z, ne) {
    var ue;
    const le = await this.getCosmWasmClient(o0[z]), [he, ge] = y.split(".");
    try {
      const we = await (le == null ? void 0 : le.queryContractSmart(
        this.contractAddress[z],
        {
          address: {
            name: he,
            bech32_prefix: ge
          }
        }
      ));
      if (!(we != null && we.address) || ((ue = ne == null ? void 0 : ne.icns) == null ? void 0 : ue.indexOf(ge)) === -1)
        throw new N$1("", S$1.NOT_FOUND);
      return we.address;
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
  async lookup(y, z) {
    const ne = await this.getCosmWasmClient(o0[z]), ue = {
      prefix: null,
      words: null
    };
    try {
      const { prefix: le, words: he } = x2.decode(y);
      ue.prefix = le, ue.words = he;
    } catch {
      throw new N$1("", S$1.INVALID_ADDRESS);
    }
    try {
      const le = await (ne == null ? void 0 : ne.queryContractSmart(
        this.contractAddress[z],
        {
          primary_name: {
            address: y
          }
        }
      ));
      if (!(le != null && le.name))
        throw new N$1("", S$1.NOT_FOUND);
      return `${le.name}.${ue.prefix}`;
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
}
const i0 = {
  mainnet: "https://rpc.cosmos.directory/juno",
  testnet: "https://rpc.uni.kingnodes.com"
}, l0 = "ibcDomains";
class U0 extends q2 {
  constructor() {
    super(...arguments), t2(this, "serviceID", l0), t2(this, "chain", "juno"), t2(this, "contractAddress", {
      mainnet: "juno1ce7wjfsuk79t2mdvpdjtv8280pcc64yh9mh62qptuvxe64twt4pqa68z2a",
      testnet: "juno19al2ptpxz3xk6q8nl3eyvyslkz8g6nz25w48dfpaepwaxavq3mhqsjjqe5"
    });
  }
  async resolve(y, z, ne) {
    var ue;
    const le = await this.getCosmWasmClient(i0[z]), [he, ge] = y.split(".");
    try {
      const we = await (le == null ? void 0 : le.queryContractSmart(
        this.contractAddress[z],
        {
          owner_of: {
            token_id: he
          }
        }
      ));
      if (!(we != null && we.owner) || ((ue = ne == null ? void 0 : ne.ibcDomains) == null ? void 0 : ue.indexOf(ge)) === -1)
        throw new N$1("", S$1.NOT_FOUND);
      try {
        const { words: Ee } = x2.decode(we.owner);
        return x2.encode(ge, Ee);
      } catch {
        throw new N$1("", S$1.NOT_FOUND);
      }
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
  async lookup(y, z) {
    const ne = await this.getCosmWasmClient(i0[z]), ue = {
      prefix: null,
      words: null
    };
    try {
      const { prefix: he, words: ge } = x2.decode(y);
      ue.prefix = he, ue.words = ge;
    } catch {
      throw new N$1("", S$1.INVALID_ADDRESS);
    }
    const le = x2.encode("juno", ue.words);
    try {
      const he = await (ne == null ? void 0 : ne.queryContractSmart(
        this.contractAddress[z],
        {
          primary_domain: {
            address: le
          }
        }
      ));
      if (!(he != null && he.domain))
        throw new N$1("", S$1.NOT_FOUND);
      return `${he.domain}.${ue.prefix}`;
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
}
const c0 = {
  mainnet: "https://rpc.cosmos.directory/stargaze",
  testnet: "https://rpc.elgafar-1.stargaze-apis.com"
}, p0 = "stargazeNames";
class q0 extends q2 {
  constructor() {
    super(...arguments), t2(this, "serviceID", p0), t2(this, "chain", "stargaze"), t2(this, "contractAddress", {
      mainnet: "stars1fx74nkqkw2748av8j7ew7r3xt9cgjqduwn8m0ur5lhe49uhlsasszc5fhr",
      testnet: "stars1rp5ttjvd5g0vlpltrkyvq62tcrdz949gjtpah000ynh4n2laz52qarz2z8"
    });
  }
  async resolve(y, z, ne) {
    var ue;
    const le = await this.getCosmWasmClient(c0[z]), [he, ge] = y.split(".");
    try {
      const we = await le.queryContractSmart(
        this.contractAddress[z],
        {
          associated_address: {
            name: he
          }
        }
      );
      if (!we || ((ue = ne == null ? void 0 : ne.stargazeNames) == null ? void 0 : ue.indexOf(ge)) === -1)
        throw new N$1("", S$1.NOT_FOUND);
      try {
        const { words: Ee } = x2.decode(we);
        return x2.encode(ge, Ee);
      } catch {
        throw new N$1("", S$1.NOT_FOUND);
      }
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
  async lookup(y, z) {
    const ne = await this.getCosmWasmClient(c0[z]), ue = {
      prefix: null,
      words: null
    };
    try {
      const { prefix: le, words: he } = x2.decode(y);
      ue.prefix = le, ue.words = he;
    } catch {
      throw new N$1("", S$1.INVALID_ADDRESS);
    }
    try {
      return `${await ne.queryContractSmart(
        this.contractAddress[z],
        {
          name: {
            address: y
          }
        }
      )}.${ue.prefix}`;
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
}
const s0 = {
  mainnet: "https://rpc.mainnet.archway.io",
  testnet: "https://rpc.constantine.archway.tech"
}, w0 = "archIds";
class z0 extends q2 {
  constructor() {
    super(...arguments), t2(this, "serviceID", w0), t2(this, "chain", "archway"), t2(this, "contractAddress", {
      mainnet: "archway1275jwjpktae4y4y0cdq274a2m0jnpekhttnfuljm6n59wnpyd62qppqxq0",
      testnet: "archway1lr8rstt40s697hqpedv2nvt27f4cuccqwvly9gnvuszxmcevrlns60xw4r"
    });
  }
  // reference: https://gist.github.com/drewstaylor/088af645dd36c013c02a2b4d05110479#file-archid-resolve-address-js
  async resolve(y, z, ne) {
    var ue;
    const le = await this.getCosmWasmClient(s0[z]), [, he] = y.split(".");
    try {
      const ge = await (le == null ? void 0 : le.queryContractSmart(
        this.contractAddress[z],
        {
          resolve_record: {
            name: y
          }
        }
      ));
      if (!(ge != null && ge.address) || ((ue = ne == null ? void 0 : ne.archIds) == null ? void 0 : ue.indexOf(he)) === -1)
        throw new N$1("", S$1.NOT_FOUND);
      return ge.address;
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
  // reference: https://gist.github.com/drewstaylor/088af645dd36c013c02a2b4d05110479#file-archid-check-domains-resolve-to-address-js
  async lookup(y, z) {
    var ne;
    const ue = await this.getCosmWasmClient(s0[z]), le = {
      prefix: null,
      words: null
    };
    try {
      const { prefix: he, words: ge } = x2.decode(y);
      le.prefix = he, le.words = ge;
    } catch {
      throw new N$1("", S$1.INVALID_ADDRESS);
    }
    try {
      const he = await (ue == null ? void 0 : ue.queryContractSmart(
        this.contractAddress[z],
        {
          resolve_address: {
            address: y
          }
        }
      ));
      if (!(he != null && he.names) || !((ne = he == null ? void 0 : he.names) != null && ne.length))
        throw new N$1("", S$1.NOT_FOUND);
      return he.names.join(", ");
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
}
var W1 = {}, B0 = {
  get exports() {
    return W1;
  },
  set exports(v) {
    W1 = v;
  }
};
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(v) {
  (function() {
    var y = "input is invalid type", z = "finalize already called", ne = typeof window == "object", ue = ne ? window : {};
    ue.JS_SHA3_NO_WINDOW && (ne = !1);
    var le = !ne && typeof self == "object", he = !ue.JS_SHA3_NO_NODE_JS && typeof process$1 == "object" && process$1.versions && process$1.versions.node;
    he ? ue = N0 : le && (ue = self);
    var ge = !ue.JS_SHA3_NO_COMMON_JS && !0 && v.exports, we = !ue.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", Ee = "0123456789abcdef".split(""), xe = [31, 7936, 2031616, 520093696], $e = [4, 1024, 262144, 67108864], Ne = [1, 256, 65536, 16777216], st = [6, 1536, 393216, 100663296], Nr = [0, 8, 16, 24], br = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], $n = [224, 256, 384, 512], En = [128, 256], Rn = ["hex", "buffer", "arrayBuffer", "array", "digest"], wa = {
      128: 168,
      256: 136
    };
    (ue.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(Oa) {
      return Object.prototype.toString.call(Oa) === "[object Array]";
    }), we && (ue.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(Oa) {
      return typeof Oa == "object" && Oa.buffer && Oa.buffer.constructor === ArrayBuffer;
    });
    for (var Aa = function(Oa, Os, Pa) {
      return function(Ml) {
        return new xa(Oa, Os, Oa).update(Ml)[Pa]();
      };
    }, _a = function(Oa, Os, Pa) {
      return function(Ml, Su) {
        return new xa(Oa, Os, Su).update(Ml)[Pa]();
      };
    }, Ta = function(Oa, Os, Pa) {
      return function(Ml, Su, Tu, Au) {
        return ye["cshake" + Oa].update(Ml, Su, Tu, Au)[Pa]();
      };
    }, Zn = function(Oa, Os, Pa) {
      return function(Ml, Su, Tu, Au) {
        return ye["kmac" + Oa].update(Ml, Su, Tu, Au)[Pa]();
      };
    }, Ra = function(Oa, Os, Pa, Ml) {
      for (var Su = 0; Su < Rn.length; ++Su) {
        var Tu = Rn[Su];
        Oa[Tu] = Os(Pa, Ml, Tu);
      }
      return Oa;
    }, Yn = function(Oa, Os) {
      var Pa = Aa(Oa, Os, "hex");
      return Pa.create = function() {
        return new xa(Oa, Os, Oa);
      }, Pa.update = function(Ml) {
        return Pa.create().update(Ml);
      }, Ra(Pa, Aa, Oa, Os);
    }, $o = function(Oa, Os) {
      var Pa = _a(Oa, Os, "hex");
      return Pa.create = function(Ml) {
        return new xa(Oa, Os, Ml);
      }, Pa.update = function(Ml, Su) {
        return Pa.create(Su).update(Ml);
      }, Ra(Pa, _a, Oa, Os);
    }, ct = function(Oa, Os) {
      var Pa = wa[Oa], Ml = Ta(Oa, Os, "hex");
      return Ml.create = function(Su, Tu, Au) {
        return !Tu && !Au ? ye["shake" + Oa].create(Su) : new xa(Oa, Os, Su).bytepad([Tu, Au], Pa);
      }, Ml.update = function(Su, Tu, Au, Zl) {
        return Ml.create(Tu, Au, Zl).update(Su);
      }, Ra(Ml, Ta, Oa, Os);
    }, fe = function(Oa, Os) {
      var Pa = wa[Oa], Ml = Zn(Oa, Os, "hex");
      return Ml.create = function(Su, Tu, Au) {
        return new wo(Oa, Os, Tu).bytepad(["KMAC", Au], Pa).bytepad([Su], Pa);
      }, Ml.update = function(Su, Tu, Au, Zl) {
        return Ml.create(Su, Au, Zl).update(Tu);
      }, Ra(Ml, Zn, Oa, Os);
    }, be = [
      { name: "keccak", padding: Ne, bits: $n, createMethod: Yn },
      { name: "sha3", padding: st, bits: $n, createMethod: Yn },
      { name: "shake", padding: xe, bits: En, createMethod: $o },
      { name: "cshake", padding: $e, bits: En, createMethod: ct },
      { name: "kmac", padding: $e, bits: En, createMethod: fe }
    ], ye = {}, Se = [], Oe = 0; Oe < be.length; ++Oe)
      for (var Fr = be[Oe], zn = Fr.bits, Fe = 0; Fe < zn.length; ++Fe) {
        var pe = Fr.name + "_" + zn[Fe];
        if (Se.push(pe), ye[pe] = Fr.createMethod(zn[Fe], Fr.padding), Fr.name !== "sha3") {
          var it = Fr.name + zn[Fe];
          Se.push(it), ye[it] = ye[pe];
        }
      }
    function xa(Oa, Os, Pa) {
      this.blocks = [], this.s = [], this.padding = Os, this.outputBits = Pa, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (Oa << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = Pa >> 5, this.extraBytes = (Pa & 31) >> 3;
      for (var Ml = 0; Ml < 50; ++Ml)
        this.s[Ml] = 0;
    }
    xa.prototype.update = function(Oa) {
      if (this.finalized)
        throw new Error(z);
      var Os, Pa = typeof Oa;
      if (Pa !== "string") {
        if (Pa === "object") {
          if (Oa === null)
            throw new Error(y);
          if (we && Oa.constructor === ArrayBuffer)
            Oa = new Uint8Array(Oa);
          else if (!Array.isArray(Oa) && (!we || !ArrayBuffer.isView(Oa)))
            throw new Error(y);
        } else
          throw new Error(y);
        Os = !0;
      }
      for (var Ml = this.blocks, Su = this.byteCount, Tu = Oa.length, Au = this.blockCount, Zl = 0, Iu = this.s, Uc, Pu; Zl < Tu; ) {
        if (this.reset)
          for (this.reset = !1, Ml[0] = this.block, Uc = 1; Uc < Au + 1; ++Uc)
            Ml[Uc] = 0;
        if (Os)
          for (Uc = this.start; Zl < Tu && Uc < Su; ++Zl)
            Ml[Uc >> 2] |= Oa[Zl] << Nr[Uc++ & 3];
        else
          for (Uc = this.start; Zl < Tu && Uc < Su; ++Zl)
            Pu = Oa.charCodeAt(Zl), Pu < 128 ? Ml[Uc >> 2] |= Pu << Nr[Uc++ & 3] : Pu < 2048 ? (Ml[Uc >> 2] |= (192 | Pu >> 6) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu & 63) << Nr[Uc++ & 3]) : Pu < 55296 || Pu >= 57344 ? (Ml[Uc >> 2] |= (224 | Pu >> 12) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu >> 6 & 63) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu & 63) << Nr[Uc++ & 3]) : (Pu = 65536 + ((Pu & 1023) << 10 | Oa.charCodeAt(++Zl) & 1023), Ml[Uc >> 2] |= (240 | Pu >> 18) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu >> 12 & 63) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu >> 6 & 63) << Nr[Uc++ & 3], Ml[Uc >> 2] |= (128 | Pu & 63) << Nr[Uc++ & 3]);
        if (this.lastByteIndex = Uc, Uc >= Su) {
          for (this.start = Uc - Su, this.block = Ml[Au], Uc = 0; Uc < Au; ++Uc)
            Iu[Uc] ^= Ml[Uc];
          _u(Iu), this.reset = !0;
        } else
          this.start = Uc;
      }
      return this;
    }, xa.prototype.encode = function(Oa, Os) {
      var Pa = Oa & 255, Ml = 1, Su = [Pa];
      for (Oa = Oa >> 8, Pa = Oa & 255; Pa > 0; )
        Su.unshift(Pa), Oa = Oa >> 8, Pa = Oa & 255, ++Ml;
      return Os ? Su.push(Ml) : Su.unshift(Ml), this.update(Su), Su.length;
    }, xa.prototype.encodeString = function(Oa) {
      var Os, Pa = typeof Oa;
      if (Pa !== "string") {
        if (Pa === "object") {
          if (Oa === null)
            throw new Error(y);
          if (we && Oa.constructor === ArrayBuffer)
            Oa = new Uint8Array(Oa);
          else if (!Array.isArray(Oa) && (!we || !ArrayBuffer.isView(Oa)))
            throw new Error(y);
        } else
          throw new Error(y);
        Os = !0;
      }
      var Ml = 0, Su = Oa.length;
      if (Os)
        Ml = Su;
      else
        for (var Tu = 0; Tu < Oa.length; ++Tu) {
          var Au = Oa.charCodeAt(Tu);
          Au < 128 ? Ml += 1 : Au < 2048 ? Ml += 2 : Au < 55296 || Au >= 57344 ? Ml += 3 : (Au = 65536 + ((Au & 1023) << 10 | Oa.charCodeAt(++Tu) & 1023), Ml += 4);
        }
      return Ml += this.encode(Ml * 8), this.update(Oa), Ml;
    }, xa.prototype.bytepad = function(Oa, Os) {
      for (var Pa = this.encode(Os), Ml = 0; Ml < Oa.length; ++Ml)
        Pa += this.encodeString(Oa[Ml]);
      var Su = Os - Pa % Os, Tu = [];
      return Tu.length = Su, this.update(Tu), this;
    }, xa.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var Oa = this.blocks, Os = this.lastByteIndex, Pa = this.blockCount, Ml = this.s;
        if (Oa[Os >> 2] |= this.padding[Os & 3], this.lastByteIndex === this.byteCount)
          for (Oa[0] = Oa[Pa], Os = 1; Os < Pa + 1; ++Os)
            Oa[Os] = 0;
        for (Oa[Pa - 1] |= 2147483648, Os = 0; Os < Pa; ++Os)
          Ml[Os] ^= Oa[Os];
        _u(Ml);
      }
    }, xa.prototype.toString = xa.prototype.hex = function() {
      this.finalize();
      for (var Oa = this.blockCount, Os = this.s, Pa = this.outputBlocks, Ml = this.extraBytes, Su = 0, Tu = 0, Au = "", Zl; Tu < Pa; ) {
        for (Su = 0; Su < Oa && Tu < Pa; ++Su, ++Tu)
          Zl = Os[Su], Au += Ee[Zl >> 4 & 15] + Ee[Zl & 15] + Ee[Zl >> 12 & 15] + Ee[Zl >> 8 & 15] + Ee[Zl >> 20 & 15] + Ee[Zl >> 16 & 15] + Ee[Zl >> 28 & 15] + Ee[Zl >> 24 & 15];
        Tu % Oa === 0 && (_u(Os), Su = 0);
      }
      return Ml && (Zl = Os[Su], Au += Ee[Zl >> 4 & 15] + Ee[Zl & 15], Ml > 1 && (Au += Ee[Zl >> 12 & 15] + Ee[Zl >> 8 & 15]), Ml > 2 && (Au += Ee[Zl >> 20 & 15] + Ee[Zl >> 16 & 15])), Au;
    }, xa.prototype.arrayBuffer = function() {
      this.finalize();
      var Oa = this.blockCount, Os = this.s, Pa = this.outputBlocks, Ml = this.extraBytes, Su = 0, Tu = 0, Au = this.outputBits >> 3, Zl;
      Ml ? Zl = new ArrayBuffer(Pa + 1 << 2) : Zl = new ArrayBuffer(Au);
      for (var Iu = new Uint32Array(Zl); Tu < Pa; ) {
        for (Su = 0; Su < Oa && Tu < Pa; ++Su, ++Tu)
          Iu[Tu] = Os[Su];
        Tu % Oa === 0 && _u(Os);
      }
      return Ml && (Iu[Su] = Os[Su], Zl = Zl.slice(0, Au)), Zl;
    }, xa.prototype.buffer = xa.prototype.arrayBuffer, xa.prototype.digest = xa.prototype.array = function() {
      this.finalize();
      for (var Oa = this.blockCount, Os = this.s, Pa = this.outputBlocks, Ml = this.extraBytes, Su = 0, Tu = 0, Au = [], Zl, Iu; Tu < Pa; ) {
        for (Su = 0; Su < Oa && Tu < Pa; ++Su, ++Tu)
          Zl = Tu << 2, Iu = Os[Su], Au[Zl] = Iu & 255, Au[Zl + 1] = Iu >> 8 & 255, Au[Zl + 2] = Iu >> 16 & 255, Au[Zl + 3] = Iu >> 24 & 255;
        Tu % Oa === 0 && _u(Os);
      }
      return Ml && (Zl = Tu << 2, Iu = Os[Su], Au[Zl] = Iu & 255, Ml > 1 && (Au[Zl + 1] = Iu >> 8 & 255), Ml > 2 && (Au[Zl + 2] = Iu >> 16 & 255)), Au;
    };
    function wo(Oa, Os, Pa) {
      xa.call(this, Oa, Os, Pa);
    }
    wo.prototype = new xa(), wo.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), xa.prototype.finalize.call(this);
    };
    var _u = function(Oa) {
      var Os, Pa, Ml, Su, Tu, Au, Zl, Iu, Uc, Pu, Lu, th, Zc, N1, Gh, Mc, h1, l2, Gc, Kc, M2, d1, K1, k2, Eu, Zo, Fl, Ru, ku, kc, Ou, U1, g2, Ic, X1, $2, ah, O1, T2, ih, oh, j2, lh, kh, P2, ch, Nh, L2, yh, Dh, F2, Mu, Du, eh, Nc, z1, A2, b2, R2, D2, I2, N2, B2;
      for (Ml = 0; Ml < 48; Ml += 2)
        Su = Oa[0] ^ Oa[10] ^ Oa[20] ^ Oa[30] ^ Oa[40], Tu = Oa[1] ^ Oa[11] ^ Oa[21] ^ Oa[31] ^ Oa[41], Au = Oa[2] ^ Oa[12] ^ Oa[22] ^ Oa[32] ^ Oa[42], Zl = Oa[3] ^ Oa[13] ^ Oa[23] ^ Oa[33] ^ Oa[43], Iu = Oa[4] ^ Oa[14] ^ Oa[24] ^ Oa[34] ^ Oa[44], Uc = Oa[5] ^ Oa[15] ^ Oa[25] ^ Oa[35] ^ Oa[45], Pu = Oa[6] ^ Oa[16] ^ Oa[26] ^ Oa[36] ^ Oa[46], Lu = Oa[7] ^ Oa[17] ^ Oa[27] ^ Oa[37] ^ Oa[47], th = Oa[8] ^ Oa[18] ^ Oa[28] ^ Oa[38] ^ Oa[48], Zc = Oa[9] ^ Oa[19] ^ Oa[29] ^ Oa[39] ^ Oa[49], Os = th ^ (Au << 1 | Zl >>> 31), Pa = Zc ^ (Zl << 1 | Au >>> 31), Oa[0] ^= Os, Oa[1] ^= Pa, Oa[10] ^= Os, Oa[11] ^= Pa, Oa[20] ^= Os, Oa[21] ^= Pa, Oa[30] ^= Os, Oa[31] ^= Pa, Oa[40] ^= Os, Oa[41] ^= Pa, Os = Su ^ (Iu << 1 | Uc >>> 31), Pa = Tu ^ (Uc << 1 | Iu >>> 31), Oa[2] ^= Os, Oa[3] ^= Pa, Oa[12] ^= Os, Oa[13] ^= Pa, Oa[22] ^= Os, Oa[23] ^= Pa, Oa[32] ^= Os, Oa[33] ^= Pa, Oa[42] ^= Os, Oa[43] ^= Pa, Os = Au ^ (Pu << 1 | Lu >>> 31), Pa = Zl ^ (Lu << 1 | Pu >>> 31), Oa[4] ^= Os, Oa[5] ^= Pa, Oa[14] ^= Os, Oa[15] ^= Pa, Oa[24] ^= Os, Oa[25] ^= Pa, Oa[34] ^= Os, Oa[35] ^= Pa, Oa[44] ^= Os, Oa[45] ^= Pa, Os = Iu ^ (th << 1 | Zc >>> 31), Pa = Uc ^ (Zc << 1 | th >>> 31), Oa[6] ^= Os, Oa[7] ^= Pa, Oa[16] ^= Os, Oa[17] ^= Pa, Oa[26] ^= Os, Oa[27] ^= Pa, Oa[36] ^= Os, Oa[37] ^= Pa, Oa[46] ^= Os, Oa[47] ^= Pa, Os = Pu ^ (Su << 1 | Tu >>> 31), Pa = Lu ^ (Tu << 1 | Su >>> 31), Oa[8] ^= Os, Oa[9] ^= Pa, Oa[18] ^= Os, Oa[19] ^= Pa, Oa[28] ^= Os, Oa[29] ^= Pa, Oa[38] ^= Os, Oa[39] ^= Pa, Oa[48] ^= Os, Oa[49] ^= Pa, N1 = Oa[0], Gh = Oa[1], ch = Oa[11] << 4 | Oa[10] >>> 28, Nh = Oa[10] << 4 | Oa[11] >>> 28, Ru = Oa[20] << 3 | Oa[21] >>> 29, ku = Oa[21] << 3 | Oa[20] >>> 29, D2 = Oa[31] << 9 | Oa[30] >>> 23, I2 = Oa[30] << 9 | Oa[31] >>> 23, j2 = Oa[40] << 18 | Oa[41] >>> 14, lh = Oa[41] << 18 | Oa[40] >>> 14, Ic = Oa[2] << 1 | Oa[3] >>> 31, X1 = Oa[3] << 1 | Oa[2] >>> 31, Mc = Oa[13] << 12 | Oa[12] >>> 20, h1 = Oa[12] << 12 | Oa[13] >>> 20, L2 = Oa[22] << 10 | Oa[23] >>> 22, yh = Oa[23] << 10 | Oa[22] >>> 22, kc = Oa[33] << 13 | Oa[32] >>> 19, Ou = Oa[32] << 13 | Oa[33] >>> 19, N2 = Oa[42] << 2 | Oa[43] >>> 30, B2 = Oa[43] << 2 | Oa[42] >>> 30, eh = Oa[5] << 30 | Oa[4] >>> 2, Nc = Oa[4] << 30 | Oa[5] >>> 2, $2 = Oa[14] << 6 | Oa[15] >>> 26, ah = Oa[15] << 6 | Oa[14] >>> 26, l2 = Oa[25] << 11 | Oa[24] >>> 21, Gc = Oa[24] << 11 | Oa[25] >>> 21, Dh = Oa[34] << 15 | Oa[35] >>> 17, F2 = Oa[35] << 15 | Oa[34] >>> 17, U1 = Oa[45] << 29 | Oa[44] >>> 3, g2 = Oa[44] << 29 | Oa[45] >>> 3, k2 = Oa[6] << 28 | Oa[7] >>> 4, Eu = Oa[7] << 28 | Oa[6] >>> 4, z1 = Oa[17] << 23 | Oa[16] >>> 9, A2 = Oa[16] << 23 | Oa[17] >>> 9, O1 = Oa[26] << 25 | Oa[27] >>> 7, T2 = Oa[27] << 25 | Oa[26] >>> 7, Kc = Oa[36] << 21 | Oa[37] >>> 11, M2 = Oa[37] << 21 | Oa[36] >>> 11, Mu = Oa[47] << 24 | Oa[46] >>> 8, Du = Oa[46] << 24 | Oa[47] >>> 8, kh = Oa[8] << 27 | Oa[9] >>> 5, P2 = Oa[9] << 27 | Oa[8] >>> 5, Zo = Oa[18] << 20 | Oa[19] >>> 12, Fl = Oa[19] << 20 | Oa[18] >>> 12, b2 = Oa[29] << 7 | Oa[28] >>> 25, R2 = Oa[28] << 7 | Oa[29] >>> 25, ih = Oa[38] << 8 | Oa[39] >>> 24, oh = Oa[39] << 8 | Oa[38] >>> 24, d1 = Oa[48] << 14 | Oa[49] >>> 18, K1 = Oa[49] << 14 | Oa[48] >>> 18, Oa[0] = N1 ^ ~Mc & l2, Oa[1] = Gh ^ ~h1 & Gc, Oa[10] = k2 ^ ~Zo & Ru, Oa[11] = Eu ^ ~Fl & ku, Oa[20] = Ic ^ ~$2 & O1, Oa[21] = X1 ^ ~ah & T2, Oa[30] = kh ^ ~ch & L2, Oa[31] = P2 ^ ~Nh & yh, Oa[40] = eh ^ ~z1 & b2, Oa[41] = Nc ^ ~A2 & R2, Oa[2] = Mc ^ ~l2 & Kc, Oa[3] = h1 ^ ~Gc & M2, Oa[12] = Zo ^ ~Ru & kc, Oa[13] = Fl ^ ~ku & Ou, Oa[22] = $2 ^ ~O1 & ih, Oa[23] = ah ^ ~T2 & oh, Oa[32] = ch ^ ~L2 & Dh, Oa[33] = Nh ^ ~yh & F2, Oa[42] = z1 ^ ~b2 & D2, Oa[43] = A2 ^ ~R2 & I2, Oa[4] = l2 ^ ~Kc & d1, Oa[5] = Gc ^ ~M2 & K1, Oa[14] = Ru ^ ~kc & U1, Oa[15] = ku ^ ~Ou & g2, Oa[24] = O1 ^ ~ih & j2, Oa[25] = T2 ^ ~oh & lh, Oa[34] = L2 ^ ~Dh & Mu, Oa[35] = yh ^ ~F2 & Du, Oa[44] = b2 ^ ~D2 & N2, Oa[45] = R2 ^ ~I2 & B2, Oa[6] = Kc ^ ~d1 & N1, Oa[7] = M2 ^ ~K1 & Gh, Oa[16] = kc ^ ~U1 & k2, Oa[17] = Ou ^ ~g2 & Eu, Oa[26] = ih ^ ~j2 & Ic, Oa[27] = oh ^ ~lh & X1, Oa[36] = Dh ^ ~Mu & kh, Oa[37] = F2 ^ ~Du & P2, Oa[46] = D2 ^ ~N2 & eh, Oa[47] = I2 ^ ~B2 & Nc, Oa[8] = d1 ^ ~N1 & Mc, Oa[9] = K1 ^ ~Gh & h1, Oa[18] = U1 ^ ~k2 & Zo, Oa[19] = g2 ^ ~Eu & Fl, Oa[28] = j2 ^ ~Ic & $2, Oa[29] = lh ^ ~X1 & ah, Oa[38] = Mu ^ ~kh & ch, Oa[39] = Du ^ ~P2 & Nh, Oa[48] = N2 ^ ~eh & z1, Oa[49] = B2 ^ ~Nc & A2, Oa[0] ^= br[Ml], Oa[1] ^= br[Ml + 1];
    };
    if (ge)
      v.exports = ye;
    else
      for (Oe = 0; Oe < Se.length; ++Oe)
        ue[Se[Oe]] = ye[Se[Oe]];
  })();
})(B0);
const $1 = 2147483647, O2 = 36, R0 = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, S2 = Math.floor;
function _2(v) {
  throw new RangeError(R0[v]);
}
function W0(v) {
  const y = [];
  let z = 0;
  const ne = v.length;
  for (; z < ne; ) {
    const ue = v.charCodeAt(z++);
    if (ue >= 55296 && ue <= 56319 && z < ne) {
      const le = v.charCodeAt(z++);
      (64512 & le) == 56320 ? y.push(((1023 & ue) << 10) + (1023 & le) + 65536) : (y.push(ue), z--);
    } else
      y.push(ue);
  }
  return y;
}
const P0 = (v) => String.fromCodePoint(...v), T0 = function(v, y, z) {
  let ne = 0;
  for (v = z ? S2(v / 700) : v >> 1, v += S2(v / y); v > 455; ne += O2)
    v = S2(v / 35);
  return S2(ne + 36 * v / (v + 38));
}, M0 = function(v) {
  const y = [], z = v.length;
  let ne = 0, ue = 128, le = 72, he = v.lastIndexOf("-");
  he < 0 && (he = 0);
  for (let we = 0; we < he; ++we)
    v.charCodeAt(we) >= 128 && _2("not-basic"), y.push(v.charCodeAt(we));
  for (let we = he > 0 ? he + 1 : 0; we < z; ) {
    const Ee = ne;
    for (let $e = 1, Ne = O2; ; Ne += O2) {
      we >= z && _2("invalid-input");
      const st = (ge = v.charCodeAt(we++)) >= 48 && ge < 58 ? ge - 48 + 26 : ge >= 65 && ge < 91 ? ge - 65 : ge >= 97 && ge < 123 ? ge - 97 : O2;
      st >= O2 && _2("invalid-input"), st > S2(($1 - ne) / $e) && _2("overflow"), ne += st * $e;
      const Nr = Ne <= le ? 1 : Ne >= le + 26 ? 26 : Ne - le;
      if (st < Nr)
        break;
      const br = O2 - Nr;
      $e > S2($1 / br) && _2("overflow"), $e *= br;
    }
    const xe = y.length + 1;
    le = T0(ne - Ee, xe, Ee == 0), S2(ne / xe) > $1 - ue && _2("overflow"), ue += S2(ne / xe), ne %= xe, y.splice(ne++, 0, ue);
  }
  var ge;
  return String.fromCodePoint(...y);
};
let i = (v, y) => Array(y).fill(v), r = (v) => new Uint32Array(v), t = 6291456, e = 23068672, x = 14680064, _$1 = 2097409, C$2 = 2097889, O$1 = 2097249, E = 2097825, I = 2097217, j = 2097505, D$1 = 2097697, U$1 = 2097857, q = 2106753, B$1 = 2097153, R = 2097281, W = 2097441, P = 2097537, T$1 = 2097729, M = 2097761, V$1 = 2097793, K$1 = 2097921, J$1 = 2097953, $$1 = 2097377, H$1 = 2097473, G$1 = 2097601, Y = 2097665, X$1 = 18874368, e2 = 2097185, r2 = 2097313, n2 = 2097345, a2 = 2097569, o2 = 2097633, i2 = 2107105, c2 = 2106945, s2 = 2106977, f2 = 2107009, h2 = 2106657, u2 = 2106785, d2 = 10486593, p2 = 2106593, w2 = 2106561, v2 = 2107137, y2 = 2107073, m2 = 2107201;
const V0 = [r([x, x, x, x, x, x, x, x, x, x, x, x, x, x, x, x]), r([x, x, x, x, x, x, x, x, x, x, x, x, x, t, t, x]), r([t, t, t, t, t, t, t, t, t, t, x, x, x, x, x, x]), r([x, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1]), r([o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, x, x, x, x, x]), r([x, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, x, x, x, x, x]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([d2, t, t, t, t, t, t, t, 10486626, t, B$1, t, t, 2097152, t, 10486690]), r([t, t, 2098145, 2098177, 10486818, 2098273, t, t, 10486914, 2098369, G$1, t, 2098403, 2098499, 2098595, t]), r([2098689, 2098721, 2098753, 2098785, 2098817, 2098849, 2098881, 2098913, 2098945, 2098977, 2099009, 2099041, 2099073, 2099105, 2099137, 2099169]), r([2099201, 2099233, 2099265, 2099297, 2099329, 2099361, 2099393, t, 2099425, 2099457, 2099489, 2099521, 2099553, 2099585, 2099617, 4196802]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([2099713, t, 2099745, t, 2099777, t, 2099809, t, 2099841, t, 2099873, t, 2099905, t, 2099937, t]), r([2099969, t, 2100001, t, 2100033, t, 2100065, t, 2100097, t, 2100129, t, 2100161, t, 2100193, t]), r([2100225, t, 2100257, t, 2100289, t, 2100321, t, 2100353, t, 2100385, t, 2100417, t, 2100449, t]), r([2100482, t, 2097410, 2097410, 2100545, t, 2100577, t, t, 2100609, t, 2100641, t, 2100673, t, 2100706]), r([2100706, 2100769, t, 2100801, t, 2100833, t, 2100865, t, 2100898, 2100961, t, 2100993, t, 2101025, t]), r([2101057, t, 2101089, t, 2101121, t, 2101153, t, 2101185, t, 2101217, t, 2101249, t, 2101281, t]), r([2101313, t, 2101345, t, 2101377, t, 2101409, t, 2101441, t, 2101473, t, 2101505, t, 2101537, t]), r([2101569, t, 2101601, t, 2101633, t, 2101665, t, 2101697, 2101729, t, 2101761, t, 2101793, t, T$1]), r([t, 2101825, 2101857, t, 2101889, t, 2101921, 2101953, t, 2101985, 2102017, 2102049, t, t, 2102081, 2102113]), r([2102145, 2102177, t, 2102209, 2102241, t, 2102273, 2102305, 2102337, t, t, t, 2102369, 2102401, t, 2102433]), r([2102465, t, 2102497, t, 2102529, t, 2102561, 2102593, t, 2102625, t, t, 2102657, t, 2102689, 2102721]), r([t, 2102753, 2102785, 2102817, t, 2102849, t, 2102881, 2102913, t, t, t, 2102945, t, t, t]), r([t, t, t, t, 2102978, 2102978, 2102978, 2103042, 2103042, 2103042, 2103106, 2103106, 2103106, 2103169, t, 2103201]), r([t, 2103233, t, 2103265, t, 2103297, t, 2103329, t, 2103361, t, 2103393, t, t, 2103425, t]), r([2103457, t, 2103489, t, 2103521, t, 2103553, t, 2103585, t, 2103617, t, 2103649, t, 2103681, t]), r([t, 2103714, 2103714, 2103714, 2103777, t, 2103809, 2103841, 2103873, t, 2103905, t, 2103937, t, 2103969, t]), r([2104001, t, 2104033, t, 2104065, t, 2104097, t, 2104129, t, 2104161, t, 2104193, t, 2104225, t]), r([2104257, t, 2104289, t, 2104321, t, 2104353, t, 2104385, t, 2104417, t, 2104449, t, 2104481, t]), r([2104513, t, 2104545, t, 2104577, t, 2104609, t, 2104641, t, 2104673, t, 2104705, t, 2104737, t]), r([2104769, t, 2104801, t, t, t, t, t, t, t, 2104833, 2104865, t, 2104897, 2104929, t]), r([t, 2104961, t, 2104993, 2105025, 2105057, 2105089, t, 2105121, t, 2105153, t, 2105185, t, 2105217, t]), r([$$1, 2105249, W, D$1, 2105281, 2105313, 2105345, U$1, K$1, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, 10493986, 10494050, 10494114, 10494178, 10494242, 10494306, t, t]), r([2102241, j, T$1, C$2, 2105761, t, t, t, t, t, t, t, t, t, t, t]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([18883009, 18875457, e, 18883041, 18883074, 18883137, e, e, e, e, e, e, e, e, e, X$1]), r([2105953, t, 2105985, t, 2106017, t, 2106049, t, 0, 0, 10494690, t, t, t, 10494753, 2106177]), r([0, 0, 0, 0, 10486818, 10494819, 2106305, 2100737, 2106337, 2106369, 2106401, 0, 2106433, 0, 2106465, 2106497]), r([t, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913]), r([c2, s2, 0, f2, 2107041, y2, i2, v2, 2107169, m2, 2107233, 2107265, t, t, t, t]), r([t, t, 4204161, t, t, t, t, t, t, t, t, t, t, t, t, 2107297]), r([w2, q, y2, 2106465, 2107265, i2, c2, t, 2107329, t, 2107361, t, 2107393, t, 2107425, t]), r([2107457, t, 2107489, t, 2107521, t, 2107553, t, 2107585, t, 2107617, t, 2107649, t, 2107681, t]), r([u2, s2, f2, t, q, h2, t, 2107713, t, f2, 2107745, t, t, 2107777, 2107809, 2107841]), r([2107873, 2107905, 2107937, 2107969, 2108001, 2108033, 2108065, 2108097, 2108129, 2108161, 2108193, 2108225, 2108257, 2108289, 2108321, 2108353]), r([2108385, 2108417, 2108449, 2108481, 2108513, 2108545, 2108577, 2108609, 2108641, 2108673, 2108705, 2108737, 2108769, 2108801, 2108833, 2108865]), r([2108897, 2108929, 2108961, 2108993, 2109025, 2109057, 2109089, 2109121, 2109153, 2109185, 2109217, 2109249, 2109281, 2109313, 2109345, 2109377]), r([2109409, t, 2109441, t, 2109473, t, 2109505, t, 2109537, t, 2109569, t, 2109601, t, 2109633, t]), r([2109665, t, 2109697, t, 2109729, t, 2109761, t, 2109793, t, 2109825, t, 2109857, t, 2109889, t]), r([2109921, t, t, e, e, e, e, e, e, e, 2109953, t, 2109985, t, 2110017, t]), r([2110049, t, 2110081, t, 2110113, t, 2110145, t, 2110177, t, 2110209, t, 2110241, t, 2110273, t]), r([2110305, t, 2110337, t, 2110369, t, 2110401, t, 2110433, t, 2110465, t, 2110497, t, 2110529, t]), r([2110561, t, 2110593, t, 2110625, t, 2110657, t, 2110689, t, 2110721, t, 2110753, t, 2110785, t]), r([0, 2110817, t, 2110849, t, 2110881, t, 2110913, t, 2110945, t, 2110977, t, 2111009, t, t]), r([2111041, t, 2111073, t, 2111105, t, 2111137, t, 2111169, t, 2111201, t, 2111233, t, 2111265, t]), r([2111297, t, 2111329, t, 2111361, t, 2111393, t, 2111425, t, 2111457, t, 2111489, t, 2111521, t]), r([2111553, t, 2111585, t, 2111617, t, 2111649, t, 2111681, t, 2111713, t, 2111745, t, 2111777, t]), r([2111809, t, 2111841, t, 2111873, t, 2111905, t, 2111937, t, 2111969, t, 2112001, t, 2112033, t]), r([2112065, t, 2112097, t, 2112129, t, 2112161, t, 2112193, t, 2112225, t, 2112257, t, 2112289, t]), r([2112321, t, 2112353, t, 2112385, t, 2112417, t, 2112449, t, 2112481, t, 2112513, t, 2112545, t]), r([0, 2112577, 2112609, 2112641, 2112673, 2112705, 2112737, 2112769, 2112801, 2112833, 2112865, 2112897, 2112929, 2112961, 2112993, 2113025]), r([2113057, 2113089, 2113121, 2113153, 2113185, 2113217, 2113249, 2113281, 2113313, 2113345, 2113377, 2113409, 2113441, 2113473, 2113505, 2113537]), r([2113569, 2113601, 2113633, 2113665, 2113697, 2113729, 2113761, 0, 0, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, 2113794, t, t, t, 0, 0, t, t, t]), r([0, e, e, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, e, t, e]), r([t, e, e, t, e, e, t, e, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, t]), r([t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, t, t, t, t, t, t, t, t, t, t]), r([e, e, e, e, e, e, e, e, e, e, e, t, 0, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, e, e, e, e, e]), r([e, t, t, t, t, 2113858, 2113922, 2113986, 2114050, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, e, e, e, e, e, e, e, 0, t, e]), r([e, e, e, e, e, t, t, e, e, t, e, e, e, e, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, 0, 0]), r([t, e, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([e, e, e, e, e, e, e, e, e, e, e, 0, 0, t, t, t]), r([t, t, t, t, t, t, e, e, e, e, e, e, e, e, e, e]), r([e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, t, t, t, t, t, t, t, 0, 0, e, t, t]), r([t, t, t, t, t, t, e, e, e, e, t, e, e, e, e, e]), r([e, e, e, e, t, e, e, e, t, e, e, e, e, e, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, t, 0]), r([t, t, t, t, t, t, t, t, t, e, e, e, 0, 0, t, 0]), r([t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, e, e, e, e, e, e, e, e]), r([t, t, t, t, t, t, t, t, t, t, e, e, e, e, e, e]), r([e, e, 0, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, e, e, e, t, e, e]), r([t, e, e, e, e, e, e, e, 2114114, 2114178, 2114242, 2114306, 2114370, 2114434, 2114498, 2114562]), r([t, t, e, e, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, e, e, e, 0, t, t, t, t, t, t, t, t, 0, 0, t]), r([t, 0, 0, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, 0, t, t, t, t, t, t]), r([t, 0, t, 0, 0, 0, t, t, t, t, 0, 0, e, t, e, e]), r([e, e, e, e, e, 0, 0, e, e, 0, 0, e, e, e, t, 0]), r([0, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 2114626, 2114690, 0, 2114754]), r([t, t, e, e, 0, 0, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, e, 0]), r([0, e, e, e, 0, t, t, t, t, t, t, 0, 0, 0, 0, t]), r([t, 0, t, 2114818, 0, t, 2114882, 0, t, t, 0, 0, e, 0, e, e]), r([e, e, e, 0, 0, 0, 0, e, e, 0, 0, e, e, e, 0, 0]), r([0, e, 0, 0, 0, 0, 0, 0, 0, 2114946, 2115010, 2115074, t, 0, 2115138, 0]), r([e, e, t, t, t, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, e, e, e, 0, t, t, t, t, t, t, t, t, t, 0, t]), r([t, t, 0, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, 0, t, t, 0, t, t, t, t, t, 0, 0, e, t, e, e]), r([e, e, e, e, e, e, 0, e, e, e, 0, e, e, e, 0, 0]), r([t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, 0, 0, 0, 0, 0, 0, 0, t, e, e, e, e, e, e]), r([0, e, e, e, 0, t, t, t, t, t, t, t, t, 0, 0, t]), r([e, e, e, e, e, 0, 0, e, e, 0, 0, e, e, e, 0, 0]), r([0, 0, 0, 0, 0, e, e, e, 0, 0, 0, 0, 2115202, 2115266, 0, t]), r([t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, e, t, 0, t, t, t, t, t, t, 0, 0, 0, t, t]), r([t, 0, t, t, t, t, 0, 0, 0, t, t, 0, t, 0, t, t]), r([0, 0, 0, t, t, 0, 0, 0, t, t, t, 0, 0, 0, t, t]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, e, e]), r([e, e, e, 0, 0, 0, e, e, e, 0, e, e, e, e, 0, 0]), r([t, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, t, t, t, t, t, t, t, t, 0, t, t]), r([t, 0, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, e, t, e, e]), r([e, e, e, e, e, 0, e, e, e, 0, e, e, e, e, 0, 0]), r([0, 0, 0, 0, 0, e, e, 0, t, t, t, 0, 0, t, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, t, t, t, t, t, t, t, t, t]), r([t, e, e, e, t, t, t, t, t, t, t, t, t, 0, t, t]), r([t, t, t, t, 0, t, t, t, t, t, 0, 0, e, t, e, e]), r([0, 0, 0, 0, 0, e, e, 0, 0, 0, 0, 0, 0, t, t, 0]), r([0, t, t, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, t, t, t, t, t, t, t, t, t, 0, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, e, e, t, e, e]), r([e, e, e, e, e, 0, e, e, e, 0, e, e, e, e, t, t]), r([0, 0, 0, 0, t, t, t, e, t, t, t, t, t, t, t, t]), r([0, e, e, e, 0, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, 0, 0, 0, t, t, t, t, t, t]), r([t, t, 0, t, t, t, t, t, t, t, t, t, 0, t, 0, 0]), r([t, t, t, t, t, t, t, 0, 0, 0, e, 0, 0, 0, 0, e]), r([e, e, e, e, e, 0, e, 0, e, e, e, e, e, e, e, e]), r([0, 0, e, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, e, t, 2115330, e, e, e, e, e, e, e, 0, 0, 0, 0, t]), r([t, t, t, t, t, t, t, e, e, e, e, e, e, e, e, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0]), r([0, t, t, 0, t, 0, t, t, t, t, t, 0, t, t, t, t]), r([t, t, t, t, 0, t, 0, t, t, t, t, t, t, t, t, t]), r([t, e, t, 2115394, e, e, e, e, e, e, e, e, e, t, 0, 0]), r([t, t, t, t, t, 0, t, 0, e, e, e, e, e, e, e, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 2115458, 2115522, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2115585, t, t, t]), r([t, t, t, t, t, t, t, t, e, e, t, t, t, t, t, t]), r([t, t, t, t, t, e, t, e, t, e, t, t, t, t, e, e]), r([t, t, t, 2115618, t, t, t, t, 0, t, t, t, t, 2115682, t, t]), r([t, t, 2115746, t, t, t, t, 2115810, t, t, t, t, 2115874, t, t, t]), r([t, t, t, t, t, t, t, t, t, 2115938, t, t, t, 0, 0, 0]), r([0, e, e, 18893218, e, 18893282, 18893346, 18893411, 18893506, 18893571, e, e, e, e, e, e]), r([e, 18893442, e, e, e, t, e, e, t, t, t, t, t, e, e, e]), r([e, e, e, 18893666, e, e, e, e, 0, e, e, e, e, 18893730, e, e]), r([e, e, 18893794, e, e, e, e, 18893858, e, e, e, e, 18893922, e, e, e]), r([e, e, e, e, e, e, e, e, e, 18893986, e, e, e, 0, t, t]), r([t, t, t, t, t, t, e, t, t, t, t, t, t, 0, t, t]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, e, e, t]), r([t, t, t, t, t, t, e, e, e, e, t, t, t, t, e, e]), r([e, t, e, e, e, t, t, e, e, e, e, e, e, e, t, t]), r([t, e, e, e, e, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, e, e, e, e, e, e, e, e, e, e, e, e, t, e]), r([t, t, t, t, t, t, t, t, t, t, e, e, e, e, t, t]), r([0, 0, 0, 0, 0, 0, 0, 2116833, 0, 0, 0, 0, 0, 2116865, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2116897, t, t, t]), r([t, t, t, t, t, t, t, t, t, 0, t, t, t, t, 0, 0]), r([t, t, t, t, t, t, t, 0, t, 0, t, t, t, t, 0, 0]), r([t, 0, t, t, t, t, 0, 0, t, t, t, t, t, t, t, 0]), r([t, 0, t, t, t, t, 0, 0, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, 0, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, 0, 0, e, e, e]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, 0, 0, 2116929, 2116961, 2116993, 2117025, 2117057, 2117089, 0, 0]), r([t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0]), r([t, t, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, t]), r([t, t, e, e, e, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, 0, t, t]), r([t, 0, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, 16777216, 16777216, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, t, t, t, t, t, t, t, t, t, e, 0, 0]), r([t, t, t, t, t, t, 0, t, t, t, t, X$1, X$1, X$1, 0, X$1]), r([t, t, t, t, t, e, e, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, e, t, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, e, e, e, e, e, e, 0, 0, 0, 0]), r([t, 0, 0, 0, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, t, t]), r([t, t, t, t, t, t, t, e, e, e, e, e, 0, 0, t, t]), r([t, t, t, t, t, e, e, e, e, e, e, e, e, e, e, 0]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, 0, 0, e]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, e, e, 0]), r([e, e, e, e, e, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, t, t, t, t, t, t, t, t, 0, 0, 0]), r([e, e, e, e, t, t, t, t, t, t, t, t, t, t, t, 0]), r([e, e, e, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, e, e, e, e, e, e, e, e, e, e, e, e, e, t, t]), r([e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, t, t, t, t]), r([e, e, e, e, e, e, e, e, 0, 0, 0, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 0, t, t, t]), r([2108449, 2108513, 2108833, 2108929, 2108961, 2108961, 2109217, 2109441, 2117121, 0, 0, 0, 0, 0, 0, 0]), r([2117153, 2117185, 2117217, 2117249, 2117281, 2117313, 2117345, 2117377, 2117409, 2117441, 2117473, 2117505, 2116897, 2117537, 2117569, 2117601]), r([2117633, 2117665, 2117697, 2117729, 2117761, 2117793, 2117825, 2117857, 2117889, 2117921, 2117953, 2117985, 2118017, 2118049, 2118081, 2118113]), r([2118145, 2118177, 2118209, 2118241, 2118273, 2118305, 2118337, 2118369, 2118401, 2118433, 2118465, 0, 0, 2118497, 2118529, 2118561]), r([e, e, e, t, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, e, e, t, t, t, t, e, t, t]), r([t, t, t, t, e, t, t, e, e, e, t, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, B$1, 2098881, e2, t]), r([O$1, R, 2102081, n2, $$1, _$1, W, H$1, j, P, a2, t, G$1, 2104545, o2, D$1]), r([M, V$1, U$1, B$1, 2118593, 2118625, 2118657, e2, O$1, R, 2102113, 2102145, 2118689, n2, t, H$1]), r([P, 2100961, G$1, 2101921, 2118721, 2118753, o2, M, V$1, 2118785, 2102369, E, 2118817, w2, p2, 2106625]), r([i2, v2, _$1, D$1, V$1, E, w2, p2, s2, i2, v2, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, 2108801, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, 2118849, I, 2118881, 2099201, 2118689]), r([r2, 2118913, 2118945, 2118977, 2102305, 2102273, 2119009, 2119041, 2119073, 2119105, 2119137, 2119169, 2119201, 2119233, 2102401, 2119265]), r([2119297, 2102433, 2119329, 2119361, 2102625, 2119393, 2105025, 2102753, 2119425, 2102785, 2105057, J$1, 2119457, 2119489, 2102881, q]), r([2119521, t, 2119553, t, 2119585, t, 2119617, t, 2119649, t, 2119681, t, 2119713, t, 2119745, t]), r([2119777, t, 2119809, t, 2119841, t, 2119873, t, 2119905, t, 2119937, t, 2119969, t, 2120001, t]), r([2120033, t, 2120065, t, 2120097, t, 2120129, t, 2120161, t, 2120193, t, 2120225, t, 2120257, t]), r([2120289, t, 2120321, t, 2120353, t, 2120385, t, 2120417, t, 2120449, t, 2120481, t, 2120513, t]), r([2120545, t, 2120577, t, 2120609, t, 2120641, t, 2120673, t, 2120705, t, 2120737, t, 2120769, t]), r([2120801, t, 2120833, t, 2120865, t, 2120897, t, 2120929, t, 2120961, t, 2120993, t, 2121025, t]), r([2121057, t, 2121089, t, 2121121, t, 2121153, t, 2121185, t, 2121217, t, 2121249, t, 2121281, t]), r([2121313, t, 2121345, t, 2121377, t, 2121409, t, 2121441, t, 2121473, t, 2121505, t, 2121537, t]), r([2121569, t, 2121601, t, 2121633, t, 2121665, t, 2121697, t, 2121729, t, 2121761, t, 2121793, t]), r([2121825, t, 2121857, t, 2121889, t, t, t, t, t, 2121922, 2121057, t, t, 2099650, t]), r([2121985, t, 2122017, t, 2122049, t, 2122081, t, 2122113, t, 2122145, t, 2122177, t, 2122209, t]), r([2122241, t, 2122273, t, 2122305, t, 2122337, t, 2122369, t, 2122401, t, 2122433, t, 2122465, t]), r([2122497, t, 2122529, t, 2122561, t, 2122593, t, 2122625, t, 2122657, t, 2122689, t, 2122721, t]), r([2122753, t, 2122785, t, 2122817, t, 2122849, t, 2122881, t, 2122913, t, 2122945, t, 2122977, t]), r([2123009, t, 2123041, t, 2123073, t, 2123105, t, 2123137, t, 2123169, t, 2123201, t, 2123233, t]), r([2123265, t, 2123297, t, 2123329, t, 2123361, t, 2123393, t, 2123425, t, 2123457, t, 2123489, t]), r([t, t, t, t, t, t, t, t, 2123521, 2123553, 2123585, 2123617, 2123649, 2123681, 2123713, 2123745]), r([t, t, t, t, t, t, 0, 0, 2123777, 2123809, 2123841, 2123873, 2123905, 2123937, 0, 0]), r([t, t, t, t, t, t, t, t, 2123969, 2124001, 2124033, 2124065, 2124097, 2124129, 2124161, 2124193]), r([t, t, t, t, t, t, t, t, 2124225, 2124257, 2124289, 2124321, 2124353, 2124385, 2124417, 2124449]), r([t, t, t, t, t, t, 0, 0, 2124481, 2124513, 2124545, 2124577, 2124609, 2124641, 0, 0]), r([t, t, t, t, t, t, t, t, 0, 2124673, 0, 2124705, 0, 2124737, 0, 2124769]), r([t, t, t, t, t, t, t, t, 2124801, 2124833, 2124865, 2124897, 2124929, 2124961, 2124993, 2125025]), r([t, 2106305, t, 2106337, t, 2106369, t, 2106401, t, 2106433, t, 2106465, t, 2106497, 0, 0]), r([2125058, 2125122, 2125186, 2125250, 2125314, 2125378, 2125442, 2125506, 2125058, 2125122, 2125186, 2125250, 2125314, 2125378, 2125442, 2125506]), r([2125570, 2125634, 2125698, 2125762, 2125826, 2125890, 2125954, 2126018, 2125570, 2125634, 2125698, 2125762, 2125826, 2125890, 2125954, 2126018]), r([2126082, 2126146, 2126210, 2126274, 2126338, 2126402, 2126466, 2126530, 2126082, 2126146, 2126210, 2126274, 2126338, 2126402, 2126466, 2126530]), r([t, t, 2126594, 2126658, 2126722, 0, t, 2126786, 2126849, 2126881, 2126593, 2106305, 2126658, 10515522, 2105921, 10515522]), r([10515586, 10515651, 2127138, 2127202, 2127266, 0, t, 2127330, 2127393, 2106337, 2127137, 2106369, 2127202, 10516035, 10516131, 10516227]), r([t, t, t, 2127713, 0, 0, t, t, 2127745, 2127777, 2127809, 2106401, 0, 10516451, 10516547, 10516643]), r([t, t, t, 2128129, t, t, t, t, 2128161, 2128193, 2128225, 2106465, 2128257, 10516899, 10494819, 10516993]), r([0, 0, 2128418, 2128482, 2128546, 0, t, 2128610, 2128673, 2106433, 2128417, 2106497, 2128482, 10486818, 10516450, 0]), r([d2, d2, d2, d2, d2, d2, d2, d2, d2, d2, d2, 2097152, 4194304, 4194304, 0, 0]), r([t, 2128705, t, t, t, t, t, 10517346, t, t, t, t, t, t, t, t]), r([t, t, t, t, 0, 0, 0, t, 0, 0, 0, 0, 0, 0, 0, d2]), r([t, t, t, 2128802, 2128867, t, 2128962, 2129027, t, t, t, t, 10517730, t, 10517794, t]), r([t, t, t, t, t, t, t, 10517858, 10517922, 10517986, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, 2128804, t, t, t, t, t, t, t, d2]), r([2097152, 0, 0, 0, 2097152, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([2129441, _$1, 0, 0, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 10518241, 2129665, 10518305, 10518337, 10518369, a2]), r([2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 10518241, 2129665, 10518305, 10518337, 10518369, 0]), r([B$1, R, G$1, C$2, 2102113, $$1, H$1, j, P, a2, o2, T$1, M, 0, 0, 0]), r([t, t, t, t, t, t, t, t, 2097698, t, t, t, t, t, t, t]), r([e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([10518403, 10518499, I, 2129986, t, 10518659, 10518755, 2102145, t, 2130242, n2, $$1, $$1, $$1, $$1, 2100321]), r([_$1, _$1, j, j, t, a2, 2097570, t, t, o2, Y, D$1, D$1, D$1, t, t]), r([2130306, 2130371, 2130466, t, J$1, t, m2, t, J$1, t, H$1, 2098849, e2, I, t, R]), r([R, r2, 0, P, G$1, 2130529, 2130561, 2130593, 2130625, _$1, t, 2130659, c2, p2, p2, c2]), r([2130753, t, t, t, t, O$1, O$1, R, _$1, W, t, t, t, t, t, t]), r([2130787, 2130883, 2130980, 2131107, 2131203, 2131299, 2131395, 2131491, 2131587, 2131683, 2131779, 2131875, 2131971, 2132067, 2132163, 2098402]), r([_$1, 2132258, 2132323, 2132418, E, 2132482, 2132547, 2132644, 2132770, C$2, 2132834, 2132899, j, I, O$1, P]), r([_$1, 2132258, 2132259, 2132418, E, 2132482, 2132547, 2132644, 2132770, C$2, 2132834, 2132899, j, I, O$1, P]), r([t, t, t, 0, t, t, t, t, t, 2132995, t, t, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2133090, 2133155, t, 2133250]), r([2133315, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([x, t, t, t, t, t, t, t, t, t, t, t, t, t, x, x]), r([t, t, t, t, t, t, t, t, t, 2133409, 2133441, t, t, t, t, t]), r([t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 2131042, 2098370, 2133474, 2133538, 2133602, 2133666, 2133730]), r([2133794, 2133858, 2133922, 2133986, 10522659, 10522755, 10522851, 10522947, 10523043, 10523139, 10523235, 10523331, 10523427, 10523524, 10523652, 10523780]), r([10523908, 10524036, 10524164, 10524292, 10524420, 10524548, 10524676, 10524804, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10524931, 10525027, 10525123, 10525219]), r([10525315, 10525411, 10525507, 10525603, 10525699, 10525795, 10525891, 10525987, 10526083, 10526179, 10526275, 10526371, 10526467, 10526563, 10526659, 10526755]), r([10526851, 10526947, 10527043, 10527139, 10527235, 10527331, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W]), r([H$1, j, P, a2, G$1, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1]), r([B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1, o2]), r([Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, 2129441, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2133092, t, t, t]), r([t, t, t, t, 10527427, 10527522, 10527491, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2138978, t, t, t]), r([t, t, t, t, 0, 0, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, 0, t, t, t, t, t, t, t, t, t]), r([2139041, 2139073, 2139105, 2139137, 2139169, 2139201, 2139233, 2139265, 2139297, 2139329, 2139361, 2139393, 2139425, 2139457, 2139489, 2139521]), r([2139553, 2139585, 2139617, 2139649, 2139681, 2139713, 2139745, 2139777, 2139809, 2139841, 2139873, 2139905, 2139937, 2139969, 2140001, 2140033]), r([2140065, 2140097, 2140129, 2140161, 2140193, 2140225, 2140257, 2140289, 2140321, 2140353, 2140385, 2140417, 2140449, 2140481, 2140513, 2140545]), r([2140577, t, 2140609, 2140641, 2140673, t, t, 2140705, t, 2140737, t, 2140769, t, 2118625, 2119201, 2118593]), r([2118849, t, 2140801, t, t, 2140833, t, t, t, t, t, t, W, E, 2140865, 2140897]), r([2140929, t, 2140961, t, 2140993, t, 2141025, t, 2141057, t, 2141089, t, 2141121, t, 2141153, t]), r([2141185, t, 2141217, t, 2141249, t, 2141281, t, 2141313, t, 2141345, t, 2141377, t, 2141409, t]), r([2141441, t, 2141473, t, 2141505, t, 2141537, t, 2141569, t, 2141601, t, 2141633, t, 2141665, t]), r([2141697, t, 2141729, t, 2141761, t, 2141793, t, 2141825, t, 2141857, t, 2141889, t, 2141921, t]), r([2141953, t, 2141985, t, 2142017, t, 2142049, t, 2142081, t, 2142113, t, 2142145, t, 2142177, t]), r([2142209, t, 2142241, t, 2142273, t, 2142305, t, 2142337, t, 2142369, t, 2142401, t, 2142433, t]), r([2142465, t, 2142497, t, t, t, t, t, t, t, t, 2142529, t, 2142561, t, e]), r([e, e, 2142593, t, 0, 0, 0, 0, 0, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, 0, t, 0, 0, 0, 0, 0, t, 0, 0]), r([t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 2142625]), r([t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, e]), r([t, t, t, t, t, t, t, 0, t, t, t, t, t, t, t, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, t, t, t, t, 2142657]), r([t, t, t, 2142689, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([2142721, 2142753, 2142785, 2142817, 2142849, 2142881, 2142913, 2142945, 2142977, 2143009, 2143041, 2143073, 2143105, 2143137, 2143169, 2143201]), r([2143233, 2143265, 2143297, 2143329, 2143361, 2143393, 2143425, 2143457, 2143489, 2143521, 2143553, 2143585, 2143617, 2143649, 2143681, 2143713]), r([2143745, 2143777, 2143809, 2143841, 2143873, 2143905, 2143937, 2143969, 2144001, 2144033, 2144065, 2144097, 2144129, 2144161, 2144193, 2144225]), r([2144257, 2144289, 2144321, 2144353, 2144385, 2144417, 2144449, 2144481, 2144513, 2144545, 2144577, 2144609, 2144641, 2144673, 2144705, 2144737]), r([2144769, 2144801, 2144833, 2144865, 2144897, 2144929, 2144961, 2144993, 2145025, 2145057, 2145089, 2145121, 2145153, 2145185, 2145217, 2145249]), r([2145281, 2145313, 2145345, 2145377, 2145409, 2145441, 2145473, 2145505, 2145537, 2145569, 2145601, 2145633, 2145665, 2145697, 2145729, 2145761]), r([2145793, 2145825, 2145857, 2145889, 2145921, 2145953, 2145985, 2146017, 2146049, 2146081, 2146113, 2146145, 2146177, 2146209, 2146241, 2146273]), r([2146305, 2146337, 2146369, 2146401, 2146433, 2146465, 2146497, 2146529, 2146561, 2146593, 2146625, 2146657, 2146689, 2146721, 2146753, 2146785]), r([2146817, 2146849, 2146881, 2146913, 2146945, 2146977, 2147009, 2147041, 2147073, 2147105, 2147137, 2147169, 2147201, 2147233, 2147265, 2147297]), r([2147329, 2147361, 2147393, 2147425, 2147457, 2147489, 2147521, 2147553, 2147585, 2147617, 2147649, 2147681, 2147713, 2147745, 2147777, 2147809]), r([2147841, 2147873, 2147905, 2147937, 2147969, 2148001, 2148033, 2148065, 2148097, 2148129, 2148161, 2148193, 2148225, 2148257, 2148289, 2148321]), r([2148353, 2148385, 2148417, 2148449, 2148481, 2148513, 2148545, 2148577, 2148609, 2148641, 2148673, 2148705, 2148737, 2148769, 2148801, 2148833]), r([2148865, 2148897, 2148929, 2148961, 2148993, 2149025, 2149057, 2149089, 2149121, 2149153, 2149185, 2149217, 2149249, 2149281, 2149313, 2149345]), r([2149377, 2149409, 2149441, 2149473, 2149505, 2149537, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([d2, t, 2149569, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, 2149601, t, 2143457, 2149633, 2149665, t, t, t, t, t]), r([t, t, t, t, t, t, t, 0, 0, e, e, 10538306, 10538370, t, t, 2149826]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, t, 2149890]), r([0, 0, 0, 0, 0, t, t, t, t, t, t, t, t, t, t, t]), r([0, 2149953, 2149985, 2150017, 2150049, 2150081, 2150113, 2150145, 2150177, 2150209, 2150241, 2150273, 2150305, 2150337, 2150369, 2150401]), r([2150433, 2150465, 2150497, 2150529, 2150561, 2150593, 2150625, 2150657, 2150689, 2150721, 2150753, 2150785, 2150817, 2150849, 2150881, 2150913]), r([2150945, 2150977, 2151009, 2151041, 2151073, 2151105, 2151137, 2151169, 2151201, 2151233, 2151265, 2151297, 2151329, 2151361, 2151393, 2151425]), r([2151457, 2151489, 2151521, 2151553, 0, 2151585, 2151617, 2151649, 2151681, 2151713, 2151745, 2151777, 2151809, 2151841, 2151873, 2151905]), r([2151937, 2151969, 2152001, 2152033, 2152065, 2152097, 2152129, 2152161, 2152193, 2152225, 2152257, 2152289, 2152321, 2152353, 2152385, 2152417]), r([2152449, 2152481, 2152513, 2152545, 2152577, 2152609, 2152641, 2152673, 2152705, 2152737, 2152769, 2152801, 2152833, 2152865, 2152897, 0]), r([t, t, 2142721, 2142913, 2152929, 2152961, 2152993, 2153025, 2153057, 2153089, 2142849, 2153121, 2153153, 2153185, 2153217, 2142977]), r([t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([10541859, 10541955, 10542051, 10542147, 10542243, 10542339, 10542435, 10542531, 10542627, 10542723, 10542819, 10542915, 10543011, 10543107, 10543203, 10543299]), r([10543395, 10543491, 10543587, 10543683, 10543779, 10543875, 10543971, 10544067, 10544163, 10544259, 10544355, 10544451, 10544547, 10544644, 10544772, 0]), r([10544899, 10544995, 10545091, 10545187, 10545283, 10545379, 10545475, 10545571, 10545667, 10545763, 10545859, 10545955, 10546051, 10546147, 10546243, 10546339]), r([10546435, 10546531, 10546627, 10546723, 10546819, 10546915, 10547011, 10547107, 10547203, 10547299, 10547395, 10547491, 10547587, 10547683, 10547779, 10547875]), r([10547971, 10548067, 10548163, 10548259, 2159745, 2159777, 2144833, 2159809, t, t, t, t, t, t, t, t]), r([2159843, 2133506, 2159938, 2098146, 2160002, 2160066, 2160130, 2160194, 2160258, 2160322, 2160386, 2131266, 2131170, 2160450, 2160514, 2160578]), r([2149953, 2150049, 2150145, 2150209, 2150465, 2150497, 2150593, 2150657, 2150689, 2150753, 2150785, 2150817, 2150849, 2150881, 2154625, 2154721]), r([2154817, 2154913, 2155009, 2155105, 2155201, 2155297, 2155393, 2155489, 2155585, 2155681, 2155777, 2155873, 2160642, 2160706, 2160769, t]), r([2142721, 2142913, 2152929, 2152961, 2156705, 2156801, 2156897, 2143073, 2157089, 2143457, 2145057, 2145441, 2145409, 2145089, 2148033, 2143713]), r([2144993, 2157953, 2158049, 2158145, 2158241, 2158337, 2158433, 2158529, 2158625, 2160801, 2160833, 2143905, 2160865, 2160897, 2160929, 2160961]), r([2160993, 2159489, 2161025, 2161057, 2152993, 2153025, 2153057, 2161089, 2161121, 2161153, 2161185, 2158913, 2159009, 2159105, 2159201, 2159297]), r([2161217, 2161250, 2161314, 2161378, 2161442, 2161506, 2098466, 2160034, 2160546, 2161570, 2161634, 2161698, 2161762, 2161826, 2161890, 2161954]), r([2162018, 2162082, 2162146, 2162210, 2162274, 2162338, 2162402, 2162466, 2162530, 2162595, 2162691, 2162787, 2162882, 2162947, 2163042, 2163107]), r([2163201, 2163233, 2163265, 2163297, 2163329, 2163361, 2163393, 2163425, 2163457, 2149889, 2163489, 2163521, 2163553, 2163585, 2163617, 2163649]), r([2163681, 2163713, 2163745, 2149921, 2163777, 2163809, 2163841, 2163873, 2163905, 2163937, 2163969, 2164001, 2164033, 2164065, 2164097, 2164129]), r([2164161, 2164193, 2164225, 2164257, 2164289, 2164321, 2164353, 2164385, 2164417, 2164449, 2164481, 2164513, 2164545, 2164577, 2164609, 2164642]), r([2164708, 2164836, 2164964, 2165091, 2165188, 2165315, 2165411, 2165509, 2165668, 2165795, 2165891, 2165987, 2166084, 2166212, 2166339, 2166435]), r([2166530, 2166595, 2166692, 2166820, 2166946, 2167013, 2167174, 2167365, 2167075, 2167525, 2167685, 2167844, 2167971, 2168067, 2168163, 2168260]), r([2168389, 2168548, 2168675, 2168771, 2168867, 2168962, 2169026, 2167618, 2169090, 2169155, 2169251, 2169349, 2169507, 2169604, 2169733, 2169891]), r([2169986, 2170050, 2170117, 2170276, 2170405, 2170563, 2170661, 2170818, 2170883, 2170979, 2171075, 2171171, 2171267, 2171364, 2171491, 2171586]), r([2171651, 2171747, 2171843, 2171940, 2172067, 2172163, 2172259, 2172357, 2172516, 2172642, 2172709, 2172866, 2172932, 2167236, 2173059, 2173155]), r([2173251, 2173348, 2173474, 2173539, 2173636, 2173762, 2173829, 2167427, 2173986, 2174050, 2174114, 2174178, 2174242, 2174306, 2174370, 2174434]), r([2174498, 2174562, 2174627, 2174723, 2174819, 2174915, 2175011, 2175107, 2175203, 2175299, 2175395, 2175491, 2175587, 2175683, 2175779, 2175875]), r([2175971, 2176067, 2176162, 2176226, 2176291, 2176386, 2176450, 2176514, 2176579, 2176675, 2176770, 2176834, 2176898, 2176962, 2177026, 2177092]), r([2176098, 2177218, 2177282, 2177346, 2177410, 2177474, 2177538, 2177602, 2177667, 2177764, 2177890, 2177954, 2178018, 2178082, 2178146, 2178210]), r([2178274, 2178339, 2178435, 2178243, 2178531, 2178626, 2178690, 2178754, 2097474, 2178818, 2178882, 2178946, 2179010, 2179074, 2179138, 2179203]), r([2179299, 2176610, 2179395, 2179491, 2179587, 2176706, 2179683, 2179779, 2179876, 2176098, 2180003, 2180099, 2180195, 2180291, 2180389, 2180550]), r([2180738, 2180802, 2180866, 2180930, 2180994, 2181058, 2181122, 2181186, 2181250, 2181186, 2181314, 2181378, 2181442, 2181506, 2181570, 2181506]), r([2181634, 2181698, 0, 2181762, 2130018, 2097218, 2181828, 0, 2181954, 2182018, 2182082, 2176066, 2182146, 2182210, 2179138, 2182274]), r([2097506, 2182338, 2182403, 2182498, 2177538, 2182563, 2182659, 2182754, 0, 2182819, 2182914, 2180514, 2182978, 2183042, 2183107, 2183203]), r([2183298, 2183362, 2183426, 2183490, 2183554, 2183618, 2183682, 2183746, 2183810, 2183875, 2183971, 2184067, 2184163, 2184259, 2184355, 2184451]), r([2184547, 2184643, 2184739, 2184835, 2184931, 2185027, 2185123, 2185219, 2185315, 2185411, 2185507, 2185603, 2185699, 2185795, 2185891, 2185987]), r([2186081, t, 2186113, t, 2186145, t, 2186177, t, 2186209, t, 2117121, t, 2186241, t, 2186273, t]), r([2186305, t, 2186337, t, 2186369, t, 2186401, t, 2186433, t, 2186465, t, 2186497, t, 2186529, t]), r([2186561, t, 2186593, t, 2186625, t, 2186657, t, 2186689, t, 2186721, t, 2186753, t, t, e]), r([e, e, e, t, e, e, e, e, e, e, e, e, e, e, t, t]), r([2186785, t, 2186817, t, 2186849, t, 2186881, t, 2186913, t, 2186945, t, 2186977, t, 2187009, t]), r([2187041, t, 2187073, t, 2187105, t, 2187137, t, 2187169, t, 2187201, t, 2109217, 2109281, e, e]), r([e, e, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, 2187233, t, 2187265, t, 2187297, t, 2187329, t, 2187361, t, 2187393, t, 2187425, t]), r([t, t, 2187457, t, 2187489, t, 2187521, t, 2187553, t, 2187585, t, 2187617, t, 2187649, t]), r([2187681, t, 2187713, t, 2187745, t, 2187777, t, 2187809, t, 2187841, t, 2187873, t, 2187905, t]), r([2187937, t, 2187969, t, 2188001, t, 2188033, t, 2188065, t, 2188097, t, 2188129, t, 2188161, t]), r([2188193, t, 2188225, t, 2188257, t, 2188289, t, 2188321, t, 2188353, t, 2188385, t, 2188417, t]), r([2188417, t, t, t, t, t, t, t, t, 2188449, t, 2188481, t, 2188513, 2188545, t]), r([2188577, t, 2188609, t, 2188641, t, 2188673, t, t, t, t, 2188705, t, 2118977, t, t]), r([2188737, t, 2188769, t, t, t, 2188801, t, 2188833, t, 2188865, t, 2188897, t, 2188929, t]), r([2188961, t, 2188993, t, 2189025, t, 2189057, t, 2189089, t, 2105249, 2118689, 2118945, 2189121, 2119009, t]), r([2189153, 2189185, 2119073, 2189217, 2189249, t, 2189281, t, 2189313, t, 2189345, t, 2189377, t, 2189409, t]), r([2189441, t, 2189473, t, 2189505, 2119361, 2189537, 2189569, t, 2189601, t, 0, 0, 0, 0, 0]), r([2189633, t, 0, t, 0, t, 2189665, t, 2189697, t, 0, 0, 0, 0, 0, 0]), r([0, 0, I, r2, Y, 2189729, t, t, 2100321, 2101089, t, t, t, t, t, t]), r([t, t, e, t, t, t, e, t, t, t, t, e, t, t, t, t]), r([t, t, t, e, e, e, e, e, t, t, t, t, e, 0, 0, 0]), r([e, e, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([e, e, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, t, t]), r([e, e, t, t, t, t, t, t, t, t, t, t, t, t, t, e]), r([t, t, t, t, t, t, e, e, e, e, e, e, e, e, t, t]), r([t, t, t, t, t, t, t, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, t]), r([t, t, t, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, t, t, t, t, t, t, t, t, t, t, t, t, t, 0, t]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, t, t]), r([t, t, t, t, t, e, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, e, t, t, t, t, t, t, t, t, e, e, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, e, e, e, t, t]), r([e, t, e, e, e, t, t, e, e, t, t, t, t, t, e, e]), r([t, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, t, t, t, t, t]), r([t, t, t, t, t, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, t, t, t, t, t, t, 0, 0, t, t, t, t, t, t, 0]), r([0, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, 2187297, 2189761, 2140609, 2189793]), r([t, t, t, t, t, t, t, t, t, 2189825, t, t, 0, 0, 0, 0]), r([2189857, 2189889, 2189921, 2189953, 2189985, 2190017, 2190049, 2190081, 2190113, 2190145, 2190177, 2190209, 2190241, 2190273, 2190305, 2190337]), r([2190369, 2190401, 2190433, 2190465, 2190497, 2190529, 2190561, 2190593, 2190625, 2190657, 2190689, 2190721, 2190753, 2190785, 2190817, 2190849]), r([2190881, 2190913, 2190945, 2190977, 2191009, 2191041, 2191073, 2191105, 2191137, 2191169, 2191201, 2191233, 2191265, 2191297, 2191329, 2191361]), r([2191393, 2191425, 2191457, 2191489, 2191521, 2191553, 2191585, 2191617, 2191649, 2191681, 2191713, 2191745, 2191777, 2191809, 2191841, 2191873]), r([2191905, 2191937, 2191969, 2192001, 2192033, 2192065, 2192097, 2192129, 2192161, 2192193, 2192225, 2192257, 2192289, 2192321, 2192353, 2192385]), r([t, t, t, e, e, e, e, e, e, e, e, t, e, e, 0, 0]), r([t, t, t, t, t, t, t, 0, 0, 0, 0, t, t, t, t, t]), r([2192417, 2192449, 2147777, 2192481, 2192513, 2192545, 2192577, 2149505, 2149505, 2192609, 2148033, 2192641, 2192673, 2192705, 2192737, 2192769]), r([2192801, 2192833, 2192865, 2192897, 2192929, 2192961, 2192993, 2193025, 2193057, 2193089, 2193121, 2193153, 2193185, 2193217, 2193249, 2193281]), r([2193313, 2193345, 2193377, 2193409, 2193441, 2193473, 2193505, 2193537, 2193569, 2193601, 2193633, 2193665, 2193697, 2193729, 2193761, 2193793]), r([2193825, 2193857, 2193889, 2193921, 2146689, 2193953, 2193985, 2194017, 2194049, 2194081, 2194113, 2194145, 2194177, 2194209, 2194241, 2194273]), r([2149025, 2194305, 2194337, 2194369, 2194401, 2194433, 2194465, 2194497, 2194529, 2194561, 2194593, 2194625, 2194657, 2194689, 2194721, 2194753]), r([2194785, 2194817, 2194849, 2194881, 2194913, 2194945, 2194977, 2195009, 2195041, 2195073, 2195105, 2195137, 2192929, 2195169, 2195201, 2195233]), r([2195265, 2195297, 2195329, 2195361, 2195393, 2195425, 2195457, 2195489, 2195521, 2195553, 2195585, 2195617, 2195649, 2195681, 2195713, 2195745]), r([2195777, 2147841, 2195809, 2195841, 2195873, 2195905, 2195937, 2195969, 2196001, 2196033, 2196065, 2196097, 2196129, 2196161, 2196193, 2196225]), r([2196257, 2143905, 2196289, 2196321, 2196353, 2196385, 2196417, 2196449, 2196481, 2196513, 2143297, 2196545, 2196577, 2196609, 2196641, 2196673]), r([2196705, 2196737, 2196769, 2196801, 2196833, 2196865, 2196897, 2196929, 2196961, 2196993, 2197025, 2197057, 2197089, 2197121, 2197153, 2197185]), r([2197217, 2195745, 2197249, 2197281, 2197313, 2197345, 2197377, 2197409, 2164641, 2197441, 2195233, 2197473, 2197505, 2197537, 2197569, 2197601]), r([2197633, 2197665, 2197697, 2197729, 2197761, 2197793, 2197825, 2197857, 2197889, 2197921, 2197953, 2197985, 2198017, 2198049, 2198081, 2192929]), r([2198113, 2198145, 2198177, 2198209, 2149473, 2198241, 2198273, 2198305, 2198337, 2198369, 2198401, 2198433, 2198465, 2198497, 2198529, 2198561]), r([2198593, 2156801, 2198625, 2198657, 2198689, 2198721, 2198753, 2198785, 2198817, 2198849, 2198881, 2195297, 2198913, 2198945, 2198977, 2199009]), r([2199041, 2199073, 2199105, 2199137, 2199169, 2199201, 2199233, 2199265, 2199297, 2148001, 2199329, 2199361, 2199393, 2199425, 2199457, 2199489]), r([2199521, 2199553, 2199585, 2199617, 2199649, 2199681, 2199713, 2146433, 2199745, 2199777, 2199809, 2199841, 2199873, 2199905, 2199937, 2199969]), r([2200001, 2200033, 2200065, 2200097, 2200129, 2200161, 2200193, 2200225, 2147297, 2200257, 2147393, 2200289, 2200321, 2200353, t, t]), r([2200385, t, 2200417, t, t, 2200449, 2200481, 2200513, 2200545, 2200577, 2200609, 2200641, 2200673, 2200705, 2146657, t]), r([2200737, t, 2200769, t, t, 2200801, 2200833, t, t, t, 2200865, 2200897, 2200929, 2200961, 2200993, 2201025]), r([2201057, 2201089, 2201121, 2201153, 2201185, 2201217, 2201249, 2201281, 2201313, 2201345, 2201377, 2201409, 2144129, 2201441, 2201473, 2201505]), r([2201537, 2201569, 2201601, 2201633, 2201665, 2201697, 2201729, 2201761, 2201793, 2201825, 2201857, 2201889, 2158145, 2201921, 2201953, 2201985]), r([2202017, 2158529, 2202049, 2202081, 2202113, 2202145, 2202177, 2196897, 2202209, 2202241, 2202273, 2202305, 2202337, 2202369, 2202369, 2202401]), r([2202433, 2202465, 2202497, 2202529, 2202561, 2202593, 2202625, 2200801, 2202657, 2202689, 2202721, 2202753, 2202786, 2202849, 0, 0]), r([2202881, 2202913, 2202945, 2202977, 2203009, 2203041, 2203073, 2203105, 2201249, 2203137, 2203169, 2203201, 2200385, 2203233, 2203265, 2203297]), r([2203329, 2203361, 2203393, 2203425, 2203457, 2203489, 2203521, 2203553, 2203585, 2201505, 2203617, 2201537, 2203649, 2203681, 2203713, 2203745]), r([2203777, 2200417, 2193601, 2203809, 2203841, 2145185, 2195777, 2198401, 2203873, 2203905, 2201761, 2203937, 2201793, 2203969, 2204001, 2204033]), r([2200481, 2204065, 2204097, 2204129, 2204161, 2204193, 2200513, 2204225, 2204257, 2204289, 2204321, 2204353, 2204385, 2202177, 2204417, 2204449]), r([2196897, 2204481, 2202305, 2204513, 2204545, 2204577, 2204609, 2204641, 2202465, 2204673, 2200769, 2204705, 2202497, 2195169, 2204737, 2202529]), r([2204769, 2202593, 2204801, 2204833, 2204865, 2204897, 2204929, 2202657, 2200673, 2204961, 2202689, 2204993, 2202721, 2205025, 2149505, 2205058]), r([2205122, 2205186, 2205249, 2205281, 2205313, 2205346, 2205410, 2205474, 2205537, 2205569, 0, 0, 0, 0, 0, 0]), r([2205602, 2205666, 2205730, 2205635, 2205795, 2097730, 2097730, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 2205890, 2205954, 2206018, 2206082, 2206146, 0, 0, 0, 0, 0, 2206210, e, 2206274]), r([2206337, 2130529, 2130625, 2206369, 2206401, 2206433, 2206465, 2206497, 2206529, 10518241, 2206562, 2206626, 2206691, 2206787, 2206882, 2206946]), r([2207010, 2207074, 2207138, 2207202, 2207266, 2207330, 2207394, 0, 2207458, 2207522, 2207586, 2207650, 2207714, 0, 2207778, 0]), r([2207842, 2207906, 0, 2207970, 2208034, 0, 2208098, 2208162, 2208226, 2206690, 2208290, 2208354, 2208418, 2208482, 2208546, 2208610]), r([2208673, 2208673, 2208705, 2208705, 2208705, 2208705, 2208737, 2208737, 2208737, 2208737, 2208769, 2208769, 2208769, 2208769, 2208801, 2208801]), r([2208801, 2208801, 2208833, 2208833, 2208833, 2208833, 2208865, 2208865, 2208865, 2208865, 2208897, 2208897, 2208897, 2208897, 2208929, 2208929]), r([2208929, 2208929, 2208961, 2208961, 2208961, 2208961, 2208993, 2208993, 2208993, 2208993, 2209025, 2209025, 2209025, 2209025, 2209057, 2209057]), r([2209057, 2209057, 2209089, 2209089, 2209121, 2209121, 2209153, 2209153, 2209185, 2209185, 2209217, 2209217, 2209249, 2209249, 2209281, 2209281]), r([2209281, 2209281, 2209313, 2209313, 2209313, 2209313, 2209345, 2209345, 2209345, 2209345, 2209377, 2209377, 2209377, 2209377, 2209409, 2209409]), r([2209441, 2209441, 2209441, 2209441, 2209473, 2209473, 2209505, 2209505, 2209505, 2209505, 2209537, 2209537, 2209537, 2209537, 2209569, 2209569]), r([2209601, 2209601, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 2209633, 2209633, 2209633, 2209633, 2113985, 2113985, 2209665, 2209665, 2209697, 2209697, 2113986, 2209729, 2209729]), r([2209761, 2209761, 2209793, 2209793, 2209825, 2209825, 2209825, 2209825, 2209857, 2209857, 2209890, 2209890, 2209954, 2209954, 2210018, 2210018]), r([2210082, 2210082, 2210146, 2210146, 2210210, 2210210, 2210274, 2210274, 2210274, 2210338, 2210338, 2210338, 2210401, 2210401, 2210401, 2210401]), r([2210434, 2210498, 2210562, 2210338, 2210626, 2210690, 2210754, 2210818, 2210882, 2210946, 2211010, 2211074, 2211138, 2211202, 2211266, 2211330]), r([2211394, 2211458, 2211522, 2211586, 2211650, 2211714, 2211778, 2211746, 2211842, 2211906, 2211970, 2212034, 2212098, 2212162, 2212226, 2212290]), r([2212354, 2212418, 2212482, 2212546, 2212610, 2212674, 2212738, 2212802, 2212866, 2212930, 2212994, 2213058, 2213122, 2213186, 2213250, 2213314]), r([2213378, 2213442, 2213506, 2213570, 2213634, 2213698, 2213762, 2213826, 2213890, 2213954, 2214018, 2214082, 2214146, 2214210, 2214274, 2214338]), r([2214402, 2214466, 2214530, 2214594, 2214658, 2214722, 2211810, 2211874, 2214786, 2214850, 2214914, 2214978, 2215042, 2215106, 2215170, 2215234]), r([2215298, 2215362, 2215426, 2215490, 2215554, 2211682, 2215618, 2215682, 2214690, 2215746, 2215586, 2215810, 2215874, 2215938, 10604611, 10604707]), r([10604803, 10604899, 10604995, 10605091, 2216578, 2216642, 2210562, 2216706, 2210338, 2210626, 2216770, 2216834, 2210882, 2216898, 2210946, 2211010]), r([2216962, 2217026, 2211266, 2217090, 2211330, 2211394, 2217154, 2217218, 2211522, 2217282, 2211586, 2211650, 2213442, 2213506, 2213698, 2213762]), r([2213826, 2214082, 2214146, 2214210, 2214274, 2214530, 2214594, 2214658, 2217346, 2214786, 2217410, 2217474, 2215170, 2217538, 2215234, 2215298]), r([2215938, 2217602, 2217666, 2214690, 2214946, 2215746, 2215586, 2210434, 2210498, 2217730, 2210562, 2217794, 2210690, 2210754, 2210818, 2210882]), r([2217858, 2211074, 2211138, 2211202, 2211266, 2217922, 2211522, 2211714, 2211778, 2211746, 2211842, 2211906, 2212034, 2212098, 2212162, 2212226]), r([2212290, 2212354, 2217986, 2212418, 2212482, 2212546, 2212610, 2212674, 2212738, 2212866, 2212930, 2212994, 2213058, 2213122, 2213186, 2213250]), r([2213314, 2213378, 2213570, 2213634, 2213890, 2213954, 2214018, 2214082, 2214146, 2214338, 2214402, 2214466, 2214530, 2218050, 2214722, 2211810]), r([2211874, 2214786, 2214978, 2215042, 2215106, 2215170, 2218114, 2215362, 2215426, 2218178, 2211682, 2215618, 2215682, 2214690, 2215330, 2210562]), r([2217794, 2210882, 2217858, 2211266, 2217922, 2211522, 2218242, 2212290, 2218306, 2218370, 2218434, 2214082, 2214146, 2214530, 2215170, 2218114]), r([2214690, 2215330, 2218499, 2218595, 2218691, 2218786, 2218850, 2218914, 2218978, 2219042, 2219106, 2219170, 2219234, 2219298, 2219362, 2219426]), r([2215650, 2219490, 2219554, 2219618, 2215714, 2219682, 2219746, 2219810, 2219874, 2219938, 2220002, 2220066, 2218370, 2220130, 2220194, 2220258]), r([2220322, 2218786, 2218850, 2218914, 2218978, 2219042, 2219106, 2219170, 2219234, 2219298, 2219362, 2219426, 2215650, 2219490, 2219554, 2219618]), r([2215714, 2219682, 2219746, 2219810, 2219874, 2219938, 2220002, 2220066, 2218370, 2220130, 2220194, 2220258, 2220322, 2219938, 2220002, 2220066]), r([2218370, 2218306, 2218434, 2212802, 2212098, 2212162, 2212226, 2219938, 2220002, 2220066, 2212802, 2212866, 2220386, 2220386, t, t]), r([2220451, 2220547, 2220547, 2220643, 2220739, 2220835, 2220931, 2221027, 2211779, 2211779, 2221123, 2221219, 2221315, 2221411, 2221507, 2221603]), r([2221603, 2221699, 2221795, 2221795, 2221891, 2221891, 2221987, 2222083, 2222083, 2222179, 2222275, 2222275, 2222371, 2222371, 2222467, 2222563]), r([2222563, 2222659, 2222659, 2222755, 2222851, 2222947, 2223043, 2223043, 2223139, 2223235, 2223331, 2223427, 2223523, 2223523, 2223619, 2223715]), r([2223811, 2223907, 2224003, 2224099, 2224099, 2224195, 2224195, 2224291, 2224291, 2224387, 2211811, 2224483, 2224579, 2214723, 2211875, 2224675]), r([0, 0, 2224771, 2224867, 2224963, 2225059, 2225155, 2225251, 2225251, 2225347, 2225443, 2225539, 2225635, 2225635, 2225731, 2225827]), r([2225923, 2226019, 2226115, 2226211, 2226307, 2226403, 2226499, 2226595, 2226691, 2226787, 2226883, 2226979, 2227075, 2227171, 2215619, 2227267]), r([2227363, 2227459, 2227555, 2227651, 2223619, 2223811, 2227747, 2227843, 2227939, 2228035, 2228131, 2228227, 2228131, 2227939, 2228323, 2228419]), r([2228515, 2228611, 2228707, 2228227, 2222947, 2221987, 2228803, 2228899, 0, 0, 0, 0, 0, 0, 0, t]), r([2228995, 2229091, 2229188, 2229316, 2229444, 2229572, 2229700, 2229828, 2229956, 2230083, 10618802, 10619368, 2231012, t, t, t]), r([X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1, X$1]), r([10619745, 2231169, 0, 10527425, 10494753, 10517729, 10517857, 2231201, 2231233, 0, 0, 0, 0, 0, 0, 0]), r([0, 2231265, 2231297, 10619937, 10619937, 10518337, 10518369, 10619969, 10620001, 2231425, 2231457, 2231489, 2231521, 2231553, 2231585, 2133409]), r([2133441, 2231617, 2231649, 2231681, 2231713, t, t, 10620353, 10620385, 10517794, 10517794, 10517794, 10517794, 10619937, 10619937, 10619937]), r([10619745, 2231169, 0, 0, 10494753, 10527425, 10517857, 10517729, 2231265, 10518337, 10518369, 10619969, 10620001, 2231425, 2231457, 10620417]), r([10620449, 10620481, 10518241, 2231905, 10620545, 10620577, 10518305, 0, 10620609, 10620641, 10620673, 10620705, 0, 0, 0, 0]), r([10620738, 2232194, 10604610, t, 10604706, 0, 10604802, 2218498, 10604898, 2218594, 10604994, 2218690, 10605090, 2232258, 10620930, 2232386]), r([2232449, 2232481, 2232481, 2232513, 2232513, 2232545, 2232545, 2232577, 2232577, 2209889, 2209889, 2209889, 2209889, 2113857, 2113857, 2210689]), r([2210689, 2210689, 2210689, 2232609, 2232609, 2211073, 2211073, 2211073, 2211073, 2211457, 2211457, 2211457, 2211457, 2210465, 2210465, 2210465]), r([2210465, 2210529, 2210529, 2210529, 2210529, 2210849, 2210849, 2210849, 2210849, 2229537, 2229537, 2215809, 2215809, 2215873, 2215873, 2216673]), r([2216673, 2212097, 2212097, 2212097, 2212097, 2218369, 2218369, 2218369, 2218369, 2212353, 2212353, 2212353, 2212353, 2212481, 2212481, 2212481]), r([2212481, 2212737, 2212737, 2212737, 2212737, 2212865, 2212865, 2212865, 2212865, 2212929, 2212929, 2212929, 2212929, 2213057, 2213057, 2213057]), r([2213057, 2213185, 2213185, 2213185, 2213185, 2213569, 2213569, 2213569, 2213569, 2213825, 2213825, 2213825, 2213825, 2214113, 2214113, 2214113]), r([2214113, 2210593, 2210593, 2210593, 2210593, 2214977, 2214977, 2214977, 2214977, 2215361, 2215361, 2215361, 2215361, 2113921, 2113921, 2209857]), r([2209857, 2114049, 2114049, 2114049, 2114049, 2232642, 2232642, 2232706, 2232706, 2232770, 2232770, 2230882, 2230882, 0, 0, 2097152]), r([0, 10517729, 10621441, 10620417, 10620641, 10620673, 10620449, 10621473, 10518337, 10518369, 10620481, 10518241, 10619745, 2231905, 2149569, 10518433]), r([2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 10527425, 10494753, 10620545, 10518305, 10620577, 10517857]), r([10620705, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1]), r([o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, 10620353, 10620609, 10620385, 10621505, 10619937]), r([10516993, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1]), r([o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, 10619969, 10621537, 10620001, 10621569, 2232993]), r([2233025, 2149569, 2231617, 2231649, 2231169, 2233057, 2164609, 2164929, 2170305, 2233089, 2170497, 2165441, 2233121, 2166721, 2172449, 2166145]), r([2164769, 2163201, 2163233, 2163265, 2163297, 2163329, 2163361, 2163393, 2163425, 2163457, 2149889, 2163489, 2163521, 2163553, 2163585, 2163617]), r([2163649, 2163681, 2163713, 2163745, 2149921, 2163777, 2163809, 2163841, 2163873, 2163905, 2163937, 2163969, 2164001, 2164033, 2164065, 2164097]), r([2164129, 2164161, 2164193, 2164225, 2164257, 2164289, 2164321, 2164353, 2164385, 2164417, 2164449, 2164481, 2164513, 2164993, 2149729, 2149793]), r([2150433, 2150465, 2150497, 2150529, 2150561, 2150593, 2150625, 2150657, 2150689, 2150721, 2150753, 2150785, 2150817, 2150849, 2150881, 0]), r([0, 0, 2150913, 2150945, 2150977, 2151009, 2151041, 2151073, 0, 0, 2151105, 2151137, 2151169, 2151201, 2151233, 2151265]), r([0, 0, 2151297, 2151329, 2151361, 2151393, 2151425, 2151457, 0, 0, 2151489, 2151521, 2151553, 0, 0, 0]), r([2233153, 2233185, 2233217, 10486690, 2233249, 2233281, 2233313, 0, 2233345, 2233377, 2233409, 2233441, 2233473, 2233505, 2233537, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, 0, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, 0, t, t, 0, t]), r([t, t, t, 0, 0, 0, 0, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, 0, 0, 0, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, e, 0, 0]), r([e, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, t, t, t]), r([t, t, t, t, t, t, e, e, e, e, e, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, 0, t]), r([t, t, t, t, 0, 0, 0, 0, t, t, t, t, t, t, t, t]), r([2233570, 2233634, 2233698, 2233762, 2233826, 2233890, 2233954, 2234018, 2234082, 2234146, 2234210, 2234274, 2234338, 2234402, 2234466, 2234530]), r([2234594, 2234658, 2234722, 2234786, 2234850, 2234914, 2234978, 2235042, 2235106, 2235170, 2235234, 2235298, 2235362, 2235426, 2235490, 2235554]), r([2235618, 2235682, 2235746, 2235810, 2235874, 2235938, 2236002, 2236066, t, t, t, t, t, t, t, t]), r([2236130, 2236194, 2236258, 2236322, 2236386, 2236450, 2236514, 2236578, 2236642, 2236706, 2236770, 2236834, 2236898, 2236962, 2237026, 2237090]), r([2237154, 2237218, 2237282, 2237346, 2237410, 2237474, 2237538, 2237602, 2237666, 2237730, 2237794, 2237858, 2237922, 2237986, 2238050, 2238114]), r([2238178, 2238242, 2238306, 2238370, 0, 0, 0, 0, t, t, t, t, t, t, t, t]), r([t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, t]), r([2238434, 2238498, 2238562, 2238626, 2238690, 2238754, 2238818, 2238882, 2238946, 2239010, 2239074, 0, 2239138, 2239202, 2239266, 2239330]), r([2239394, 2239458, 2239522, 2239586, 2239650, 2239714, 2239778, 2239842, 2239906, 2239970, 2240034, 0, 2240098, 2240162, 2240226, 2240290]), r([2240354, 2240418, 2240482, 0, 2240546, 2240610, 0, t, t, t, t, t, t, t, t, t]), r([t, t, 0, t, t, t, t, t, t, t, 0, t, t, 0, 0, 0]), r([t, 2240673, 2240705, 2098881, 2240737, 2101825, 0, 2240769, 2240801, 2240833, 2240865, 2101985, 2102017, 2240897, 2240929, 2240961]), r([2240993, 2241025, 2241057, 2102209, 2241089, 2100321, 2241121, 2241153, 2241185, 2241217, 2241249, 2189121, 2241282, 2241345, 2241377, 2241410]), r([2241473, 2241506, 2099425, 2241569, 2241601, Y, 2241633, 2241666, 2140673, 2241729, 2102561, 2241761, 2241793, 2241825, 2241857, 2102689]), r([2241889, 0, 2241921, 2241953, 2241985, 2242017, 2242049, 2242081, 2242113, 2242146, 2242210, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, 0, 0, t, 0, t, t, t, t, t, t]), r([t, t, t, t, t, t, 0, t, t, 0, 0, 0, t, 0, 0, t]), r([t, t, t, 0, t, t, 0, 0, 0, 0, 0, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, t]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, t]), r([t, t, t, t, t, t, t, t, 0, 0, 0, 0, t, t, t, t]), r([0, 0, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, e, e, e, 0, e, e, 0, 0, 0, 0, 0, e, e, e, e]), r([t, t, t, t, 0, t, t, t, 0, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, 0, 0, e, e, e, 0, 0, 0, 0, e]), r([t, t, t, t, t, e, e, 0, 0, 0, 0, t, t, t, t, t]), r([t, t, t, t, t, t, 0, 0, 0, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, 0, 0, t, t, t, t, t, t, t, t]), r([t, t, t, 0, 0, 0, 0, 0, t, t, t, t, t, t, t, t]), r([t, t, 0, 0, 0, 0, 0, 0, 0, t, t, t, t, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, t, t, t, t, t, t, t]), r([2242274, 2242338, 2242402, 2242466, 2242530, 2242594, 2242658, 2242722, 2242786, 2242850, 2242914, 2242978, 2243042, 2243106, 2243170, 2243234]), r([2243298, 2243362, 2243426, 2243490, 2243554, 2243618, 2243682, 2243746, 2243810, 2243874, 2243938, 2244002, 2244066, 2244130, 2244194, 2244258]), r([2244322, 2244386, 2244450, 2244514, 2244578, 2244642, 2244706, 2244770, 2244834, 2244898, 2244962, 2245026, 2245090, 2245154, 2245218, 2245282]), r([2245346, 2245410, 2245474, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, 0, 0, 0, 0, 0, 0, 0, t, t, t, t, t, t]), r([t, t, t, t, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, e, e, t, 0, 0]), r([t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, e, e, e]), r([e, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, 0]), r([t, t, e, e, e, e, t, t, t, t, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, t, t, t, t, t, t, t, 0, 0]), r([e, t, t, e, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, e]), r([e, e, e, e, e, e, e, e, e, e, e, t, t, 0, t, t]), r([t, t, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, 0, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, e, e, t, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, e, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, t, t, t, t, t, t, t, t, e, e, e, e, t, e, e]), r([t, t, t, t, t, t, t, t, t, t, t, t, e, e, e, e]), r([e, e, e, e, e, e, e, e, t, t, t, t, t, t, e, t]), r([t, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, 0, t, 0, t, t, t, t, 0, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, t, e]), r([e, e, e, e, e, e, e, e, e, e, e, 0, 0, 0, 0, 0]), r([e, e, e, e, 0, t, t, t, t, t, t, t, t, 0, 0, t]), r([t, 0, t, t, 0, t, t, t, t, t, 0, e, e, t, e, e]), r([t, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 0, t, t, t]), r([t, t, e, e, 0, 0, e, e, e, e, e, e, e, 0, 0, 0]), r([e, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, 0, t, e, t]), r([e, e, e, e, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, 0, 0, e, e, e, e, e, e, e, e]), r([t, t, t, t, t, t, t, t, t, t, t, t, e, e, 0, 0]), r([e, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, e, e, t, t, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, e, e, e, e, e, t, 0, 0, 0, 0]), r([2245538, 2245602, 2245666, 2245730, 2245794, 2245858, 2245922, 2245986, 2246050, 2246114, 2246178, 2246242, 2246306, 2246370, 2246434, 2246498]), r([2246562, 2246626, 2246690, 2246754, 2246818, 2246882, 2246946, 2247010, 2247074, 2247138, 2247202, 2247266, 2247330, 2247394, 2247458, 2247522]), r([t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, t]), r([t, t, t, t, t, t, t, 0, 0, t, 0, 0, t, t, t, t]), r([t, t, t, t, 0, t, t, 0, t, t, t, t, t, t, t, t]), r([e, e, e, e, e, e, 0, e, e, 0, 0, e, e, e, e, t]), r([e, t, e, e, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, 0, 0, t, t, t, t, t, t]), r([t, e, e, e, e, e, e, e, 0, 0, e, e, e, e, e, e]), r([e, t, t, t, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, e, e, e, e, e, e, e, e, e, e, t, t, t, t, t]), r([t, t, t, e, e, e, e, e, e, e, t, e, e, e, e, t]), r([t, t, t, t, t, t, t, e, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, e, e, e, e, e, e, e, e, e, e, e, t, t, t, t]), r([e, e, e, e, e, e, e, e, e, e, t, t, t, t, t, t]), r([e, e, e, e, e, e, e, 0, e, e, e, e, e, e, e, e]), r([0, 0, e, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, e, 0, e, e, e, e, e, e, e]), r([t, t, t, t, t, t, t, 0, t, t, 0, t, t, t, t, t]), r([t, e, e, e, e, e, e, 0, 0, 0, e, 0, e, e, 0, e]), r([e, e, e, e, e, e, t, e, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, 0, t, t, 0, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, e, e, e, e, e, 0]), r([e, e, 0, e, e, e, e, e, t, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, e, e, e, e, t, t, 0, 0, 0, 0, 0, 0, 0]), r([e, e, t, e, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, e, e, e, e, e, e, e, 0, 0, 0, e, e]), r([t, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, t]), r([e, t, t, t, t, t, t, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, 0, 0, 0, 0, 0, t, t, t]), r([2247586, 2247650, 2247714, 2247778, 2247842, 2247906, 2247970, 2248034, 2248098, 2248162, 2248226, 2248290, 2248354, 2248418, 2248482, 2248546]), r([2248610, 2248674, 2248738, 2248802, 2248866, 2248930, 2248994, 2249058, 2249122, 2249186, 2249250, 2249314, 2249378, 2249442, 2249506, 2249570]), r([t, t, t, t, t, t, t, t, t, t, t, 0, 0, 0, 0, e]), r([t, e, e, e, e, e, e, e, e, e, e, e, e, e, e, e]), r([e, e, e, e, e, e, e, e, 0, 0, 0, 0, 0, 0, 0, e]), r([t, t, t, t, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, 0, t, t, t, t, t, t, t, 0, t, t, 0]), r([0, 0, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, 0, 0, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([0, 0, 0, 0, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, 0, 0, t, e, e, t]), r([2097152, 2097152, 2097152, 2097152, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, e, 0, 0]), r([t, t, t, t, t, t, t, 0, 0, t, t, t, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, t, t, t, 2249636, 2249764]), r([2249894, 2250086, 2250278, 2250470, 2250662, e, e, e, e, e, t, t, t, e, e, e]), r([e, e, e, 0, 0, 0, 0, 0, 0, 0, 0, e, e, e, e, e]), r([e, e, e, t, t, e, e, e, e, e, e, e, t, t, t, t]), r([t, t, t, t, t, t, t, t, t, t, t, 2250852, 2250980, 2251110, 2251302, 2251494]), r([2251686, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, e, e, e, t, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, e2, I, O$1, R, r2]), r([n2, $$1, _$1, W, H$1, j, P, a2, G$1, o2, Y, D$1, T$1, M, V$1, E]), r([U$1, C$2, K$1, J$1, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j]), r([P, a2, G$1, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, e2]), r([I, O$1, R, r2, n2, 0, _$1, W, H$1, j, P, a2, G$1, o2, Y, D$1]), r([T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, e2, I, O$1, R, r2, n2, $$1]), r([_$1, W, H$1, j, P, a2, G$1, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2]), r([K$1, J$1, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2]), r([G$1, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, 0, I, O$1]), r([0, 0, n2, 0, 0, W, H$1, 0, 0, a2, G$1, o2, Y, 0, T$1, M]), r([V$1, E, U$1, C$2, K$1, J$1, B$1, e2, I, O$1, 0, r2, 0, $$1, _$1, W]), r([H$1, j, P, a2, 0, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1]), r([U$1, C$2, K$1, J$1, B$1, e2, 0, O$1, R, r2, n2, 0, 0, W, H$1, j]), r([P, a2, G$1, o2, Y, 0, T$1, M, V$1, E, U$1, C$2, K$1, 0, B$1, e2]), r([I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1, o2, Y, D$1]), r([T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, e2, 0, O$1, R, r2, n2, 0]), r([_$1, W, H$1, j, P, 0, G$1, 0, 0, 0, T$1, M, V$1, E, U$1, C$2]), r([K$1, 0, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W, H$1, j, P, a2]), r([G$1, o2, Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, B$1, e2, I, O$1]), r([R, r2, n2, $$1, _$1, W, H$1, j, P, a2, G$1, o2, Y, D$1, T$1, M]), r([V$1, E, U$1, C$2, K$1, J$1, B$1, e2, I, O$1, R, r2, n2, $$1, _$1, W]), r([U$1, C$2, K$1, J$1, 2251873, 2251905, 0, 0, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q]), r([2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, q, f2, 2107041, y2, i2, v2, 2107169]), r([m2, 2251937, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881]), r([2106913, c2, s2, f2, f2, 2107041, y2, i2, v2, 2107169, m2, 2251969, h2, q, u2, i2]), r([s2, c2, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881]), r([2106913, c2, s2, q, f2, 2107041, y2, i2, v2, 2107169, m2, 2251937, 2106529, w2, p2, 2106625]), r([h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, f2, f2, 2107041]), r([y2, i2, v2, 2107169, m2, 2251969, h2, q, u2, i2, s2, c2, 2106529, w2, p2, 2106625]), r([h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, q, f2, 2107041]), r([y2, i2, v2, 2107169, m2, 2251937, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2]), r([2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, f2, f2, 2107041, y2, i2, v2, 2107169, m2, 2251969]), r([h2, q, u2, i2, s2, c2, 2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2]), r([2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, q, f2, 2107041, y2, i2, v2, 2107169, m2, 2251937]), r([2106529, w2, p2, 2106625, h2, 2106689, 2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913, c2]), r([s2, f2, f2, 2107041, y2, i2, v2, 2107169, m2, 2251969, h2, q, u2, i2, s2, c2]), r([s2, q, f2, 2107041, y2, i2, v2, 2107169, m2, 2251937, 2106529, w2, p2, 2106625, h2, 2106689]), r([2106721, q, 2105921, u2, 2106817, 2098273, 2106849, 2106881, 2106913, c2, s2, f2, f2, 2107041, y2, i2]), r([v2, 2107169, m2, 2251969, h2, q, u2, i2, s2, c2, 2107393, 2107393, 0, 0, 2129441, 2098369]), r([2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537]), r([2129569, 2129601, 2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 2129441, 2098369, 2098145, 2098177]), r([2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601]), r([e, e, e, e, e, e, e, t, t, t, t, e, e, e, e, e]), r([e, e, e, e, e, e, e, e, e, e, e, e, e, t, t, t]), r([t, t, t, t, e, t, t, t, t, t, t, t, 0, 0, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, e, e, e, e, e]), r([0, 0, 0, 0, 0, t, t, t, t, t, t, 0, 0, 0, 0, 0]), r([e, e, e, e, e, e, e, e, e, 0, 0, e, e, e, e, e]), r([e, e, 0, e, e, 0, e, e, e, e, e, 0, 0, 0, 0, 0]), r([2108385, 2108417, 2108449, 2108481, 2108513, 2108545, 2108577, 2108609, 2108641, 2108705, 2108737, 2108769, 2108833, 2108865, 2108897, 2108929]), r([2108961, 2108993, 2109025, 2109057, 2109089, 2109121, 2109153, 2109249, 2109313, 2109345, 2186913, 2111169, 2108065, 2108129, 2111425, 2110529]), r([2252001, 2108385, 2108417, 2108449, 2108481, 2108513, 2108545, 2108577, 2108609, 2108641, 2108705, 2108737, 2108833, 2108865, 2108929, 2108993]), r([2109025, 2109057, 2109089, 2109121, 2109153, 2109217, 2109249, 2110049, 2108065, 2108033, 2108353, 2110465, 2186305, 2110561, 0, 0]), r([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, e]), r([t, t, t, t, t, t, t, 0, t, t, t, t, 0, t, t, 0]), r([t, t, t, t, t, 0, 0, t, t, t, t, t, t, t, t, t]), r([2252034, 2252098, 2252162, 2252226, 2252290, 2252354, 2252418, 2252482, 2252546, 2252610, 2252674, 2252738, 2252802, 2252866, 2252930, 2252994]), r([2253058, 2253122, 2253186, 2253250, 2253314, 2253378, 2253442, 2253506, 2253570, 2253634, 2253698, 2253762, 2253826, 2253890, 2253954, 2254018]), r([2254082, 2254146, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([t, t, t, t, e, e, e, e, e, e, e, t, 0, 0, 0, 0]), r([2113857, 2210689, 2210465, 2229537, 0, 2113921, 2216673, 2210529, 2212737, 2114049, 2213825, 2214113, 2210593, 2214977, 2212097, 2212929]), r([2213185, 2212353, 2213569, 2215873, 2218369, 2211073, 2211457, 2210849, 2215809, 2212481, 2212865, 2213057, 2254209, 2209409, 2254241, 2254273]), r([0, 2210689, 2210465, 0, 2215361, 0, 0, 2210529, 0, 2114049, 2213825, 2214113, 2210593, 2214977, 2212097, 2212929]), r([2213185, 2212353, 2213569, 0, 2218369, 2211073, 2211457, 2210849, 0, 2212481, 0, 2213057, 0, 0, 0, 0]), r([0, 0, 2210465, 0, 0, 0, 0, 2210529, 0, 2114049, 0, 2214113, 0, 2214977, 2212097, 2212929]), r([0, 2212353, 2213569, 0, 2218369, 0, 0, 2210849, 0, 2212481, 0, 2213057, 0, 2209409, 0, 2254273]), r([0, 2210689, 2210465, 0, 2215361, 0, 0, 2210529, 2212737, 2114049, 2213825, 0, 2210593, 2214977, 2212097, 2212929]), r([2213185, 2212353, 2213569, 0, 2218369, 2211073, 2211457, 2210849, 0, 2212481, 2212865, 2213057, 2254209, 0, 2254241, 0]), r([2113857, 2210689, 2210465, 2229537, 2215361, 2113921, 2216673, 2210529, 2212737, 2114049, 0, 2214113, 2210593, 2214977, 2212097, 2212929]), r([2213185, 2212353, 2213569, 2215873, 2218369, 2211073, 2211457, 2210849, 2215809, 2212481, 2212865, 2213057, 0, 0, 0, 0]), r([0, 2210689, 2210465, 2229537, 0, 2113921, 2216673, 2210529, 2212737, 2114049, 0, 2214113, 2210593, 2214977, 2212097, 2212929]), r([0, 10642914, 10642978, 10643042, 10643106, 10643170, 10643234, 10643298, 10643362, 10643426, 10643490, t, t, t, t, t]), r([10524931, 10525027, 10525123, 10525219, 10525315, 10525411, 10525507, 10525603, 10525699, 10525795, 10525891, 10525987, 10526083, 10526179, 10526275, 10526371]), r([10526467, 10526563, 10526659, 10526755, 10526851, 10526947, 10527043, 10527139, 10527235, 10527331, 2254947, I, D$1, 2097218, 2255042, t]), r([Y, D$1, T$1, M, V$1, E, U$1, C$2, K$1, J$1, 2255106, 2181186, 2255170, 2099650, 2255235, 2255330]), r([t, t, t, t, t, t, t, t, t, t, 2179042, 2176546, 2255394, t, t, t]), r([2255458, t, t, t, t, t, t, t, t, t, t, t, t, t, t, t]), r([2255522, 2255586, 2163489, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([2144737, 2255649, 2255681, 2168961, 2142913, 2255713, 2255745, 2153185, 2255777, 2255809, 2255841, 2198081, 2255873, 2255905, 2255937, 2255969]), r([2256001, 2256033, 2145889, 2256065, 2256097, 2256129, 2256161, 2256193, 2256225, 2142721, 2152929, 2256257, 2161089, 2153025, 2161121, 2256289]), r([2147681, 2256321, 2256353, 2256385, 2256417, 2256449, 2158049, 2145057, 2256481, 2256513, 2256545, 2256577, 0, 0, 0, 0]), r([2256611, 2256707, 2256803, 2256899, 2256995, 2257091, 2257187, 2257283, 2257379, 0, 0, 0, 0, 0, 0, 0]), r([2257473, 2257505, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), r([t, t, t, t, t, t, 0, 0, 0, 0, 0, 0, 0, 0, t, t]), r([t, t, t, 0, t, t, t, t, t, t, t, t, t, t, t, t]), r([2129441, 2098369, 2098145, 2098177, 2098465, 2129473, 2129505, 2129537, 2129569, 2129601, 0, 0, 0, 0, 0, 0]), r([2257537, 2257569, 2257601, 2257634, 2257697, 2201057, 2257729, 2257761, 2257793, 2257825, 2201089, 2257857, 2257889, 2257922, 2201121, 2257985]), r([2258017, 2258049, 2258082, 2258145, 2258177, 2255937, 2258210, 2258273, 2258305, 2258337, 2258369, 2202913, 2258402, 2143233, 2258465, 2258497]), r([2258529, 2258561, 2256513, 2258593, 2258625, 2203073, 2201153, 2201185, 2203105, 2258657, 2258689, 2195361, 2258721, 2201217, 2258753, 2258785]), r([2258817, 2258849, 2258849, 2258849, 2258882, 2258945, 2258977, 2259009, 2259042, 2259105, 2259137, 2259169, 2259201, 2259233, 2259265, 2259297]), r([2259329, 2259361, 2259393, 2259425, 2259457, 2259489, 2259489, 2203169, 2259521, 2259553, 2259585, 2259617, 2201281, 2259649, 2259681, 2259713]), r([2200001, 2259745, 2259777, 2259809, 2259841, 2259873, 2259905, 2259937, 2259969, 2260002, 2260065, 2260097, 2260129, 2255713, 2260161, 2260193]), r([2260226, 2260290, 2260353, 2260385, 2260417, 2260449, 2260481, 2260513, 0, 2260545, 2260577, 2260577, 2260610, 2260673, 2260705, 2195233]), r([2260737, 2260770, 2260833, 2260865, 0, 2144065, 2260897, 2260929, 2144129, 2260961, 2260993, 2261026, 2261089, 2261122, 2261185, 2261217]), r([2261249, 2261281, 2261313, 2261345, 2261377, 2261409, 2261441, 2261473, 2261505, 2261538, 2261601, 2261633, 2261665, 2261697, 2193569, 2261730]), r([2144449, 2261794, 2261794, 2261857, 2261889, 2261889, 2261921, 2261954, 2262018, 2262081, 2262113, 2262145, 2262177, 2262209, 2262241, 2262273]), r([2262305, 2262337, 2262369, 2201441, 2262402, 2262465, 2262497, 2262529, 2203553, 2262529, 2262561, 2201505, 2262593, 2262625, 2262657, 2262689]), r([2201537, 2192705, 2176865, 2262721, 2262753, 2262785, 2262817, 2262849, 2262882, 2262945, 2262977, 2263009, 2263041, 2263073, 2263106, 2263169]), r([2263201, 2263233, 2263265, 2263297, 2263329, 2263361, 2263393, 2263425, 2201569, 2263457, 2263490, 2263553, 2263585, 2263617, 2263649, 2201633]), r([2263681, 2263713, 2263745, 2263777, 2263809, 2263841, 2263873, 2263905, 2193601, 2203809, 2263937, 2263969, 2264001, 2264034, 2264097, 2264129]), r([2264161, 2264193, 2201665, 2264226, 2264289, 2264321, 2264353, 2205249, 2264385, 2264417, 2264449, 2264481, 2264514, 2264577, 2264609, 2264641]), r([2264674, 2264737, 2264769, 2264801, 2264833, 2195777, 2264865, 2264898, 2264962, 2265026, 2265089, 2265122, 2265185, 2265217, 2265249, 2265281]), r([2265313, 2201697, 2198401, 2265345, 2265377, 2265409, 2265442, 2265505, 2265537, 2265569, 2265601, 2203905, 2265633, 2265666, 2265729, 2265761]), r([2265794, 2265858, 2265921, 2265953, 2203937, 2265985, 2266017, 2266049, 2266081, 2266113, 2266145, 2266178, 2266241, 2266274, 2266337, 0]), r([2266369, 2204001, 2266401, 2266434, 2266497, 2266529, 2266562, 2266626, 2266689, 2266721, 2266753, 2266785, 2266817, 2266817, 2266849, 2266881]), r([2204065, 2266913, 2266945, 2266977, 2267009, 2267042, 2267105, 2267138, 2195329, 2267202, 2267265, 2267298, 2267362, 2267426, 2267489, 2267521]), r([2204257, 2267554, 2267618, 2267682, 2267746, 2267809, 2267841, 2267841, 2204289, 2205313, 2267873, 2267905, 2267937, 2267970, 2268033, 2194145]), r([2204353, 2268065, 2268098, 2202017, 2268162, 2268226, 2200641, 2268289, 2268321, 2202113, 2268353, 2268385, 2268418, 2268482, 2268482, 0]), r([2268545, 2268578, 2268641, 2268673, 2268705, 2268738, 2268801, 2268833, 2268865, 2268897, 2268929, 2268962, 2269025, 2269057, 2269089, 2269121]), r([2269153, 2269185, 2269218, 2269282, 2269345, 2269378, 2269441, 2269474, 2269537, 2269569, 2202305, 2269602, 2269666, 2269729, 2269762, 2269825]), r([2269858, 2269921, 2269953, 2269985, 2270017, 2270049, 2270081, 2270114, 2270178, 2270242, 2270306, 2261857, 2270369, 2270401, 2270433, 2270465]), r([2270497, 2270529, 2270561, 2270593, 2270625, 2270657, 2270689, 2270722, 2195873, 2270785, 2270817, 2270849, 2270881, 2270913, 2270945, 2202401]), r([2270977, 2271009, 2271041, 2271073, 2271106, 2271170, 2271234, 2271297, 2271329, 2271361, 2271393, 2271426, 2271489, 2271522, 2271585, 2271617]), r([2271650, 2271714, 2271777, 2271809, 2193985, 2271841, 2271873, 2271905, 2271937, 2271969, 2272001, 2204577, 2272033, 2272065, 2272097, 0]), r([2272129, 2272161, 2272193, 2272225, 2147329, 2272258, 2272321, 2272353, 2272385, 2272417, 2272449, 2272482, 2272546, 2272609, 2272641, 2272673]), r([2204737, 2204769, 2147553, 2272706, 2272769, 2272801, 2272833, 2272865, 2272898, 2272962, 2273025, 2273057, 2273089, 2273122, 2273185, 2204801]), r([2273218, 2273282, 2273345, 2273377, 2273409, 2273442, 2273505, 2273537, 2273569, 2273601, 2273633, 2273665, 2273697, 2273730, 2273793, 2273825]), r([2273857, 2273890, 2273953, 2273985, 2274017, 2274049, 2274082, 2274146, 2274209, 2274241, 2274273, 2274306, 2274369, 2274402, 2204993, 2204993]), r([2274465, 2274498, 2274561, 2274593, 2274625, 2274657, 2274689, 2274721, 2274753, 2274786, 2205025, 2274849, 2274881, 2274913, 2274945, 2274977]), r([2275010, 2275073, 2275106, 2275170, 2275234, 2149089, 2275297, 2149217, 2275329, 2275361, 2275393, 2275425, 2149377, 2275458, 0, 0]), r([t, t, t, t, t, t, t, t, t, t, t])], K0 = new Uint16Array([0, 0, 1, 2, 3, 4, 5, 6, 7, 7, 8, 9, 10, 11, 12, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, ...i(12, 6), 34, 12, 35, 36, 12, ...i(37, 4), 38, 37, 37, 39, 40, 41, 42, 12, 43, 44, 45, 46, 47, 48, 49, 12, 12, 12, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 12, 12, 66, 67, 37, 68, 69, 12, 70, 71, 72, 73, 12, 12, 74, 37, 12, 75, ...i(12, 5), 76, 77, 12, 78, 79, 12, 37, 80, ...i(12, 5), 81, 82, 12, 12, 74, 83, 12, 84, 85, 86, 12, 87, 88, 12, 86, 89, 12, 12, 90, 37, 91, 37, 92, 12, 12, 93, 37, 94, 95, 12, 96, 97, 98, 99, 100, 101, 102, 103, 104, 97, 98, 105, 106, 107, 72, 108, 109, 110, 98, 111, 112, 113, 102, 114, 115, 97, 98, 111, 116, 117, 102, 118, 119, 120, 121, 122, 123, 124, 72, 88, 125, 126, 98, 127, 128, 129, 102, 130, 131, 126, 98, 132, 128, 133, 102, 134, 135, 126, 12, 136, 137, 138, 102, 12, 139, 140, 12, 141, 142, 143, 72, 144, 145, 12, 12, 146, 147, 148, 7, 7, 149, 12, 150, 151, 152, 153, 7, 7, 154, 155, 12, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 88, 7, 7, 12, 12, 74, 166, 12, 167, 168, 169, 170, 171, 7, 7, 172, 12, 12, 173, ...i(12, 5), 86, 145, ...i(12, 13), 174, 175, 12, 12, 174, 12, 12, 176, 177, 178, 12, 12, 12, 177, 12, 12, 12, 179, 12, 180, 12, 181, ...i(12, 5), 182, ...i(12, 40), 145, 180, ...i(12, 5), 183, 12, 184, 12, 185, 12, 186, 187, 188, 12, 12, 12, 189, 37, 190, 181, 181, 191, 181, ...i(12, 5), 183, 192, 12, 193, ...i(12, 4), 194, 12, 86, 195, 195, 196, 12, 78, 71, 12, 12, 148, 12, 181, 197, 12, 12, 12, 198, 12, 12, 12, 199, 37, 200, 181, 181, 78, 37, 201, 7, 7, 7, 202, 12, 12, 203, 204, 12, 74, 205, 206, 12, 207, 12, 12, 12, 81, 208, 12, 12, 203, 209, 210, 12, 12, 12, 211, 212, 213, 214, 118, 215, 216, 217, 12, 12, 218, 219, 220, 221, 222, 223, 12, 224, 225, 226, ...i(37, 4), 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 12, 113, 37, 37, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, ...i(12, 9), 280, 281, 12, 12, 282, ...i(12, 11), 283, ...i(12, 15), 284, 7, 88, 7, 285, 286, 287, 288, 289, 290, 291, 292, 293, ...i(12, 81), 294, ...i(12, 6), 295, ...i(12, 5), 296, ...i(12, 9), 297, 12, 298, ...i(12, 6), 299, 300, 301, 12, 12, 12, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 12, 12, 312, 12, 12, 12, 313, 314, 12, 284, ...i(315, 4), 37, 37, ...i(12, 5), 78, 7, 7, 12, 316, ...i(12, 5), 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 7, 7, 332, 12, 90, 333, 145, ...i(12, 4), 334, ...i(12, 5), 335, 336, 12, 12, 337, 338, 339, 340, 341, 342, 343, ...i(12, 4), 344, 12, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, ...i(12, 1800), 180, 12, 12, 12, 284, ...i(12, 21), 148, 7, 377, 378, 379, 380, 381, 382, ...i(12, 5), 383, 12, 12, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 7, 396, 397, 12, 398, 181, 12, 12, 12, 118, 399, 12, 12, 203, 400, 181, 37, 401, 12, 12, 402, 12, 403, 404, 12, 180, 92, 12, 12, 405, 406, 407, 408, 86, 12, 12, 409, 410, 411, 412, 12, 413, 12, 12, 12, 414, 415, 416, 74, 417, 418, 419, 315, 12, 12, 420, 421, 422, 423, 424, 425, 426, 12, 12, 427, 181, ...i(12, 698), 344, 12, 428, 12, 12, 148, ...i(7, 528), 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 7, 7, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 12, 495, 496, 497, 498, 499, 500, 501, 502, 7, 7, 503, 504, 505, 37, 506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 337, 529, 530, 531, 532, 7, 533, 12, 178, 534, 78, 78, 7, 7, ...i(12, 7), 88, 535, 12, 12, 536, ...i(12, 4), 86, 180, 113, 7, 7, 12, 12, 537, ...i(7, 8), 12, 180, 12, 12, 12, 113, 538, 148, 12, 12, 539, 12, 88, 12, 12, 540, 12, 541, 12, 12, 542, 194, 7, 7, 543, 544, 545, ...i(12, 6), 78, 181, 546, 547, 548, 12, 148, 12, 12, 118, 12, 12, 12, 549, 550, 551, 552, 110, 553, 7, 7, 7, 7, ...i(12, 19), 284, 12, 194, 118, 7, 554, 555, 556, 557, 7, 7, 7, 7, 558, 12, 12, 559, 12, 298, 12, 12, 12, 86, 130, 7, 7, 7, 12, 560, 12, 561, 12, 562, 7, 7, 7, 7, 12, 12, 12, 563, 12, 564, 12, 12, 565, 566, 12, 567, 183, 183, ...i(12, 4), 7, 7, 12, 12, 568, 284, 12, 12, 12, 569, 12, 570, 12, 571, 12, 572, 573, ...i(7, 5), ...i(12, 4), 183, 7, 7, 7, 574, 575, 576, 577, 12, 12, 12, 578, 12, 12, 579, 181, ...i(7, 18), 12, 86, 12, 12, 580, 581, 7, 7, 7, 582, 12, 12, 118, 12, 81, 583, 7, 12, 584, 7, 7, 12, 148, 7, 12, 284, 206, 12, 12, 585, 586, 564, 12, 587, 206, 12, 12, 588, 589, 12, 183, 181, 206, 12, 403, 590, 591, 12, 12, 592, 206, 12, 12, 405, 593, 12, 145, 71, 12, 110, 594, 595, 596, 7, 7, 7, 597, 541, 181, 12, 12, 598, 599, 181, 600, 97, 98, 601, 116, 602, 603, 604, ...i(7, 8), 12, 12, 12, 605, 606, 607, 581, 7, 12, 12, 12, 37, 608, 181, ...i(7, 10), 12, 12, 598, 609, 538, 610, 7, 7, 12, 12, 12, 37, 611, 181, 180, 7, 12, 12, 74, 612, 181, 7, 7, 7, 12, 179, 195, 12, 284, ...i(7, 11), 12, 12, 594, 613, ...i(7, 6), 614, 615, 12, 12, 12, 616, 617, 618, 12, 619, 620, 181, 7, 7, 7, 7, 621, 12, 12, 622, 623, 7, 624, 12, 12, 625, 626, 627, 12, 12, 90, 628, 471, ...i(12, 4), 183, 181, ...i(7, 15), 98, 12, 598, 629, 194, 12, 180, 12, 12, 630, 631, 410, 7, 7, 7, 7, 632, 12, 12, 633, 634, 181, 635, 12, 636, 637, 181, ...i(7, 19), 12, 638, 639, 126, 12, 640, 206, 181, ...i(7, 5), 113, 12, 12, 12, 641, ...i(12, 57), 181, ...i(7, 6), ...i(12, 6), 86, 71, ...i(12, 12), 344, ...i(7, 164), ...i(12, 6), 471, ...i(12, 67), 7, 642, 643, ...i(7, 250), ...i(12, 36), 284, ...i(7, 539), ...i(12, 35), 183, 12, 86, 407, ...i(12, 4), 86, 181, 12, 78, 644, 12, 12, 12, 606, 194, 645, 110, 646, 12, ...i(7, 43), 647, 648, 12, 12, 12, 88, ...i(7, 6), ...i(12, 4), 649, 650, 37, 37, 651, 206, 7, 7, 7, 7, 652, 653, ...i(12, 383), 118, ...i(12, 77), 194, 7, 7, 183, ...i(7, 558), 654, ...i(12, 18), 471, 655, 7, 656, 657, ...i(12, 24), 148, ...i(7, 144), ...i(12, 6), 88, 180, 183, 658, 659, ...i(7, 293), 37, 37, 660, 37, 410, ...i(12, 7), 344, 7, 7, 7, ...i(12, 15), 194, 12, 12, 661, 12, 12, 662, 663, 664, 665, 12, 171, 666, 667, 12, 88, 7, ...i(12, 4), 668, ...i(7, 7), 12, 344, 12, 344, ...i(12, 5), 284, 12, 183, ...i(7, 8), 292, 669, 670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 292, 669, 670, 681, 682, 683, 684, 685, 686, 687, 688, 689, 291, 292, 669, 670, 671, 672, 683, 674, 675, 676, 687, 688, 689, 291, 292, 669, 670, 690, 691, 692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 703, 705, 706, 707, 708, 709, 710, ...i(12, 32), 37, 37, 37, 711, 37, 37, 712, 408, 713, 714, 67, ...i(7, 69), 12, 86, 715, ...i(7, 13), 629, 716, 717, 718, 719, 720, 721, 7, 722, ...i(7, 7), 12, 12, 180, 586, 407, ...i(7, 20), 12, 103, 7, 12, 12, 594, 562, ...i(7, 29), 12, 594, 181, ...i(7, 46), 723, 86, ...i(12, 12), 724, 410, 7, 7, 725, 726, 727, 12, 728, 407, ...i(7, 49), 145, 12, 12, 12, 71, 7, 7, 7, 7, 145, 12, 12, 78, ...i(7, 12), 729, 730, 731, 732, 733, 734, 735, 736, 737, 738, 739, 738, 7, 7, 7, 581, ...i(7, 16), 12, 12, 148, ...i(12, 6), 344, 86, ...i(145, 3), 12, 194, 740, 741, 742, 292, 743, 12, 744, 12, 12, 745, 78, 7, 7, 7, 72, 12, 746, 747, 748, 749, 750, 751, 194, ...i(7, 9), ...i(12, 61), 563, 180, 180, ...i(12, 7), 428, ...i(12, 5), 181, 148, 113, 148, 12, 12, 12, 118, 181, 12, 12, 118, 12, 78, 581, 7, 7, 7, 7, ...i(12, 21), 344, 78, 180, 183, 12, 12, 541, 752, 148, 183, 183, ...i(12, 9), 753, 12, 12, 88, 7, 7, 754, ...i(7, 64), ...i(12, 2670), 7, 7, ...i(12, 259), 181, ...i(12, 13), 78, ...i(12, 360), 581, ...i(12, 467), 113, ...i(7, 193), 755, 756, 757, 758, 759, 760, 761, 762, 763, 764, 765, 766, 767, 768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, ...i(7, 93), 7]), J0 = "abcdefghijklmnopqrstuvwxyz  ̈ ̄23 ́μ ̧11⁄41⁄23⁄4àáâãäåæçèéêëìíîïðñòóôõöøùúûüýþssāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįi̇ĵķĺļľl·łńņňʼnŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷÿźżžɓƃƅɔƈɖɗƌǝəɛƒɠɣɩɨƙɯɲɵơƣƥʀƨʃƭʈưʊʋƴƶʒƹƽdžljnjǎǐǒǔǖǘǚǜǟǡǣǥǧǩǫǭǯdzǵƕƿǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟƞȣȥȧȩȫȭȯȱȳⱥȼƚⱦɂƀʉʌɇɉɋɍɏɦɹɻʁ ̆ ̇ ̊ ̨ ̃ ̋ʕ̀̓̈́ιͱͳʹͷ ι;ϳ ̈́άέήίόύώαβγδεζηθκλνξοπρστυφχψωϊϋϗϙϛϝϟϡϣϥϧϩϫϭϯϸϻͻͼͽѐёђѓєѕіїјљњћќѝўџабвгдежзийклмнопрстуфхцчшщъыьэюяѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯաբգդեզէըթժիլխծկհձղճմյնշոչպջռսվտրցւփքօֆեւاٴوٴۇٴيٴक़ख़ग़ज़ड़ढ़फ़य़ড়ঢ়য়ਲ਼ਸ਼ਖ਼ਗ਼ਜ਼ਫ਼ଡ଼ଢ଼ําໍາຫນຫມ་གྷཌྷདྷབྷཛྷཀྵཱཱིུྲྀྲཱྀླྀླཱྀྒྷྜྷྡྷྦྷྫྷྐྵⴧⴭნᏰᏱᏲᏳᏴᏵꙋაბგდევზთიკლმოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶჷჸჹჺჽჾჿɐɑᴂɜᴖᴗᴝᴥɒɕɟɡɥɪᵻʝɭᶅʟɱɰɳɴɸʂƫᴜʐʑḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕaʾạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὑὓὕὗὠὡὢὣὤὥὦὧἀιἁιἂιἃιἄιἅιἆιἇιἠιἡιἢιἣιἤιἥιἦιἧιὠιὡιὢιὣιὤιὥιὦιὧιὰιαιάιᾶιᾰᾱ ̓ ͂ ̈͂ὴιηιήιῆιὲ ̓̀ ̓́ ̓͂ΐῐῑὶ ̔̀ ̔́ ̔͂ΰῠῡὺῥ ̈̀`ὼιωιώιῶιὸ‐ ̳′′′′′‵‵‵‵‵!! ̅???!!?056789+−=()a/ca/s°cc/oc/u°fsmteltmאבגדfax∑1⁄71⁄91⁄101⁄32⁄31⁄52⁄53⁄54⁄51⁄65⁄61⁄83⁄85⁄87⁄8iiiiiivviviiviiiixxixii0⁄3∫∫∫∫∫∮∮∮∮∮〈〉121314151617181920(1)(2)(3)(4)(5)(6)(7)(8)(9)(10)(11)(12)(13)(14)(15)(16)(17)(18)(19)(20)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)(k)(l)(m)(n)(o)(p)(q)(r)(s)(t)(u)(v)(w)(x)(y)(z)::===⫝̸ⰰⰱⰲⰳⰴⰵⰶⰷⰸⰹⰺⰻⰼⰽⰾⰿⱀⱁⱂⱃⱄⱅⱆⱇⱈⱉⱊⱋⱌⱍⱎⱏⱐⱑⱒⱓⱔⱕⱖⱗⱘⱙⱚⱛⱜⱝⱞⱟⱡɫᵽɽⱨⱪⱬⱳⱶȿɀⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳬⳮⳳⵡ母龟一丨丶丿乙亅二亠人儿入八冂冖冫几凵刀力勹匕匚匸十卜卩厂厶又口囗土士夂夊夕大女子宀寸小尢尸屮山巛工己巾干幺广廴廾弋弓彐彡彳心戈戶手支攴文斗斤方无日曰月木欠止歹殳毋比毛氏气水火爪父爻爿片牙牛犬玄玉瓜瓦甘生用田疋疒癶白皮皿目矛矢石示禸禾穴立竹米糸缶网羊羽老而耒耳聿肉臣自至臼舌舛舟艮色艸虍虫血行衣襾見角言谷豆豕豸貝赤走足身車辛辰辵邑酉釆里金長門阜隶隹雨靑非面革韋韭音頁風飛食首香馬骨高髟鬥鬯鬲鬼魚鳥鹵鹿麥麻黃黍黑黹黽鼎鼓鼠鼻齊齒龍龜龠.〒卄卅 ゙ ゚よりコトᄀᄁᆪᄂᆬᆭᄃᄄᄅᆰᆱᆲᆳᆴᆵᄚᄆᄇᄈᄡᄉᄊᄋᄌᄍᄎᄏᄐᄑ하ᅢᅣᅤᅥᅦᅧᅨᅩᅪᅫᅬᅭᅮᅯᅰᅱᅲᅳᅴᅵᄔᄕᇇᇈᇌᇎᇓᇗᇙᄜᇝᇟᄝᄞᄠᄢᄣᄧᄩᄫᄬᄭᄮᄯᄲᄶᅀᅇᅌᇱᇲᅗᅘᅙᆄᆅᆈᆑᆒᆔᆞᆡ三四上中下甲丙丁天地(ᄀ)(ᄂ)(ᄃ)(ᄅ)(ᄆ)(ᄇ)(ᄉ)(ᄋ)(ᄌ)(ᄎ)(ᄏ)(ᄐ)(ᄑ)(ᄒ)(가)(나)(다)(라)(마)(바)(사)(아)(자)(차)(카)(타)(파)(하)(주)(오전)(오후)(一)(二)(三)(四)(五)(六)(七)(八)(九)(十)(月)(火)(水)(木)(金)(土)(日)(株)(有)(社)(名)(特)(財)(祝)(労)(代)(呼)(学)(監)(企)(資)(協)(祭)(休)(自)(至)問幼箏pte2224252627282930333435참고주의우秘男適優印注項写正左右医宗夜3637383940444546474849501月2月3月4月5月6月7月8月9月10月11月12月hgergevltdアイウエオカキクケサシスセソタチツテナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲ令和アパートアルファアンペアアールイニングインチウォンエスクードエーカーオンスオームカイリカラットカロリーガロンガンマギガギニーキュリーギルダーキロキログラムキロメートルキロワットグラムトンクルゼイロクローネケースコルナコーポサイクルサンチームシリングセンチセントダースデシドルナノノットハイツパーセントパーツバーレルピアストルピクルピコビルファラッドフィートブッシェルフランヘクタールペソペニヒヘルツペンスページベータポイントボルトホンポンドホールホーンマイクロマイルマッハマルクマンションミクロンミリミリバールメガメガトンヤードヤールユアンリットルリラルピールーブルレムレントゲン0点1点2点3点4点5点6点7点8点9点10点11点12点13点14点15点16点17点18点19点20点21点22点23点24点hpadaaubarovpcdmdm2dm3iu平成昭和大正明治株式会社naμamakakbmbgbcalkcalpfnfμfμgmgkghzkhzmhzthzμlmldlfmnmμmmmcmkmmm2cm2km2mm3cm3km3m∕sm∕s2kpampagparadrad∕srad∕s2psnsμsmspvnvμvmvkvpwnwμwmwkwkωmωbqc∕kgdbgyhainkkktlnloglxmilmolphppmprsvwbv∕ma∕m1日2日3日4日5日6日7日8日9日10日11日12日13日14日15日16日17日18日19日20日21日22日23日24日25日26日27日28日29日30日31日galꙁꙃꙅꙇꙉꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝺꝼᵹꝿꞁꞃꞅꞇꞌꞑꞓꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩɬʞʇꭓꞵꞷꞹꞻꞽꞿꟁꟃꞔᶎꟈꟊꟑꟗꟙꟶꬷꭒʍᎠᎡᎢᎣᎤᎥᎦᎧᎨᎩᎪᎫᎬᎭᎮᎯᎰᎱᎲᎳᎴᎵᎶᎷᎸᎹᎺᎻᎼᎽᎾᎿᏀᏁᏂᏃᏄᏅᏆᏇᏈᏉᏊᏋᏌᏍᏎᏏᏐᏑᏒᏓᏔᏕᏖᏗᏘᏙᏚᏛᏜᏝᏞᏟᏠᏡᏢᏣᏤᏥᏦᏧᏨᏩᏪᏫᏬᏭᏮᏯ豈更賈滑串句契喇奈懶癩羅蘿螺裸邏樂洛烙珞落酪駱亂卵欄爛蘭鸞嵐濫藍襤拉臘蠟廊朗浪狼郎來冷勞擄櫓爐盧蘆虜路露魯鷺碌祿綠菉錄論壟弄籠聾牢磊賂雷壘屢樓淚漏累縷陋勒肋凜凌稜綾菱陵讀拏諾丹寧怒率異北磻便復不泌數索參塞省葉說殺沈拾若掠略亮兩凉梁糧良諒量勵呂廬旅濾礪閭驪麗黎曆歷轢年憐戀撚漣煉璉秊練聯輦蓮連鍊列劣咽烈裂廉念捻殮簾獵囹嶺怜玲瑩羚聆鈴零靈領例禮醴隸惡了僚寮尿料燎療蓼遼暈阮劉杻柳流溜琉留硫紐類戮陸倫崙淪輪律慄栗隆利吏履易李梨泥理痢罹裏裡離匿溺吝燐璘藺隣鱗麟林淋臨笠粒狀炙識什茶刺切度拓糖宅洞暴輻降廓兀嗀塚晴凞猪益礼神祥福靖精蘒諸逸都飯飼館鶴郞隷侮僧免勉勤卑喝嘆器塀墨層悔慨憎懲敏既暑梅海渚漢煮爫琢碑祉祈祐祖禍禎穀突節縉繁署者臭艹著褐視謁謹賓贈辶難響頻恵𤋮舘並况全侀充冀勇勺啕喙嗢墳奄奔婢嬨廒廙彩徭惘慎愈慠戴揄搜摒敖望杖滛滋瀞瞧爵犯瑱甆画瘝瘟盛直睊着磌窱类絛缾荒華蝹襁覆調請諭變輸遲醙鉶陼韛頋鬒𢡊𢡄𣏕㮝䀘䀹𥉉𥳐𧻓齃龎fffiflfflմնմեմիվնմխיִײַעהכלםרתשׁשׂשּׁשּׂאַאָאּבּגּדּהּוּזּטּיּךּכּלּמּנּסּףּפּצּקּרּתּוֹבֿכֿפֿאלٱٻپڀٺٿٹڤڦڄڃچڇڍڌڎڈژڑکگڳڱںڻۀہھےۓڭۆۈۋۅۉېىئائەئوئۇئۆئۈئېئىیئجئحئمئيبجبحبخبمبىبيتجتحتختمتىتيثجثمثىثيجحجمحمخجخحخمسجسحسخسمصحصمضجضحضخضمطحطمظمعجعمغجغمفجفحفخفمفىفيقحقمقىقيكاكجكحكخكلكمكىكيلجلحلخلملىليمجمممىمينجنحنخنمنىنيهجهمهىهييحيخيىذٰرٰىٰ ٌّ ٍّ َّ ُّ ِّ ّٰئرئزئنبربزبنترتزتنثرثزثنمانرنزننيريزئخئهبهتهصخلهنههٰثهسهشمشهـَّـُّـِّطىطيعىعيغىغيسىسيشىشيحىجىجيخىصىصيضىضيشجشحشخشرسرصرضراًتجمتحجتحمتخمتمجتمحتمخحميحمىسحجسجحسجىسمحسمجسممصححصممشحمشجيشمخشممضحىضخمطمحطممطميعجمعممعمىغممغميغمىفخمقمحقمملحملحيلحىلججلخملمحمحجمحيمجحمخممجخهمجهممنحمنحىنجمنجىنمينمىيممبخيتجيتجىتخيتخىتميتمىجميجحىجمىسخىصحيشحيضحيلجيلمييجييميمميقمينحيعميكمينجحمخيلجمكممجحيحجيمجيفميبحيسخينجيصلےقلےاللهاكبرمحمدصلعمرسولعليهوسلمصلىصلى الله عليه وسلمجل جلالهریال,、〖〗—–_{}〔〕【】《》「」『』[]#&*-<>\\$%@ ًـًـّ ْـْءآأؤإةلآلألإ\"'^|~⦅⦆・ゥャ¢£¬¦¥₩│←↑→↓■○𐐨𐐩𐐪𐐫𐐬𐐭𐐮𐐯𐐰𐐱𐐲𐐳𐐴𐐵𐐶𐐷𐐸𐐹𐐺𐐻𐐼𐐽𐐾𐐿𐑀𐑁𐑂𐑃𐑄𐑅𐑆𐑇𐑈𐑉𐑊𐑋𐑌𐑍𐑎𐑏𐓘𐓙𐓚𐓛𐓜𐓝𐓞𐓟𐓠𐓡𐓢𐓣𐓤𐓥𐓦𐓧𐓨𐓩𐓪𐓫𐓬𐓭𐓮𐓯𐓰𐓱𐓲𐓳𐓴𐓵𐓶𐓷𐓸𐓹𐓺𐓻𐖗𐖘𐖙𐖚𐖛𐖜𐖝𐖞𐖟𐖠𐖡𐖣𐖤𐖥𐖦𐖧𐖨𐖩𐖪𐖫𐖬𐖭𐖮𐖯𐖰𐖱𐖳𐖴𐖵𐖶𐖷𐖸𐖹𐖻𐖼ːˑʙʣꭦʥʤᶑɘɞʩɤɢʛʜɧʄʪʫ𝼄ꞎɮ𝼅ʎ𝼆ɶɷɺ𝼈ɾʨʦꭧʧⱱʏʡʢʘǀǁǂ𝼊𝼞𐳀𐳁𐳂𐳃𐳄𐳅𐳆𐳇𐳈𐳉𐳊𐳋𐳌𐳍𐳎𐳏𐳐𐳑𐳒𐳓𐳔𐳕𐳖𐳗𐳘𐳙𐳚𐳛𐳜𐳝𐳞𐳟𐳠𐳡𐳢𐳣𐳤𐳥𐳦𐳧𐳨𐳩𐳪𐳫𐳬𐳭𐳮𐳯𐳰𐳱𐳲𑣀𑣁𑣂𑣃𑣄𑣅𑣆𑣇𑣈𑣉𑣊𑣋𑣌𑣍𑣎𑣏𑣐𑣑𑣒𑣓𑣔𑣕𑣖𑣗𑣘𑣙𑣚𑣛𑣜𑣝𑣞𑣟𖹠𖹡𖹢𖹣𖹤𖹥𖹦𖹧𖹨𖹩𖹪𖹫𖹬𖹭𖹮𖹯𖹰𖹱𖹲𖹳𖹴𖹵𖹶𖹷𖹸𖹹𖹺𖹻𖹼𖹽𖹾𖹿𝅗𝅥𝅘𝅥𝅘𝅥𝅮𝅘𝅥𝅯𝅘𝅥𝅰𝅘𝅥𝅱𝅘𝅥𝅲𝆹𝅥𝆺𝅥𝆹𝅥𝅮𝆺𝅥𝅮𝆹𝅥𝅯𝆺𝅥𝅯ıȷ∇∂ӏ𞤢𞤣𞤤𞤥𞤦𞤧𞤨𞤩𞤪𞤫𞤬𞤭𞤮𞤯𞤰𞤱𞤲𞤳𞤴𞤵𞤶𞤷𞤸𞤹𞤺𞤻𞤼𞤽𞤾𞤿𞥀𞥁𞥂𞥃ٮڡٯ0,1,2,3,4,5,6,7,8,9,〔s〕wzhvsdppvwcmrdjほかココ字双多解交映無前後再新初終販声吹演投捕遊指打禁空合満申割営配〔本〕〔三〕〔二〕〔安〕〔点〕〔打〕〔盗〕〔勝〕〔敗〕得可丽丸乁𠄢你侻倂偺備像㒞𠘺兔兤具𠔜㒹內𠕋冗冤仌冬𩇟刃㓟刻剆剷㔕包匆卉博即卽卿𠨬灰及叟𠭣叫叱吆咞吸呈周咢哶唐啓啣善喫喳嗂圖圗噑噴壮城埴堍型堲報墬𡓤売壷夆夢奢𡚨𡛪姬娛娧姘婦㛮嬈嬾𡧈寃寘寳𡬘寿将㞁屠峀岍𡷤嵃𡷦嵮嵫嵼巡巢㠯巽帨帽幩㡢𢆃㡼庰庳庶𪎒𢌱舁弢㣇𣊸𦇚形彫㣣徚忍志忹悁㤺㤜𢛔惇慈慌慺憲憤憯懞戛扝抱拔捐𢬌挽拼捨掃揤𢯱搢揅掩㨮摩摾撝摷㩬敬𣀊旣書晉㬙㬈㫤冒冕最暜肭䏙朡杞杓𣏃㭉柺枅桒𣑭梎栟椔楂榣槪檨𣚣櫛㰘次𣢧歔㱎歲殟殻𣪍𡴋𣫺汎𣲼沿泍汧洖派浩浸涅𣴞洴港湮㴳滇𣻑淹潮𣽞𣾎濆瀹瀛㶖灊災灷炭𠔥煅𤉣熜爨牐𤘈犀犕𤜵𤠔獺王㺬玥㺸瑇瑜璅瓊㼛甤𤰶甾𤲒𢆟瘐𤾡𤾸𥁄㿼䀈𥃳𥃲𥄙𥄳眞真瞋䁆䂖𥐝硎䃣𥘦𥚚𥛅秫䄯穊穏𥥼𥪧䈂𥮫篆築䈧𥲀糒䊠糨糣紀𥾆絣䌁緇縂繅䌴𦈨𦉇䍙𦋙罺𦌾羕翺𦓚𦔣聠𦖨聰𣍟䏕育脃䐋脾媵𦞧𦞵𣎓𣎜舄辞䑫芑芋芝劳花芳芽苦𦬼茝荣莭茣莽菧荓菊菌菜𦰶𦵫𦳕䔫蓱蓳蔖𧏊蕤𦼬䕝䕡𦾱𧃒䕫虐虧虩蚩蚈蜎蛢蜨蝫螆蟡蠁䗹衠𧙧裗裞䘵裺㒻𧢮𧥦䚾䛇誠𧲨貫賁贛起𧼯𠠄跋趼跰𠣞軔𨗒𨗭邔郱鄑𨜮鄛鈸鋗鋘鉼鏹鐕𨯺開䦕閷𨵷䧦雃嶲霣𩅅𩈚䩮䩶韠𩐊䪲𩒖頩𩖶飢䬳餩馧駂駾䯎𩬰鱀鳽䳎䳭鵧𪃎䳸𪄅𪈎𪊑䵖黾鼅鼏鼖𪘀";
function v0(v) {
  return v >= 196608 ? v >= 917760 && v <= 917999 ? 18874368 : 0 : V0[K0[v >> 4]][15 & v];
}
function y0(v, y, z) {
  const ne = [], ue = W0(v);
  for (let le = 0; le < ue.length; le++) {
    const he = ue[le], ge = P0([ue[le]]), we = v0(he), Ee = we >> 23, xe = we >> 21 & 3, $e = we >> 5 & 65535, Ne = 31 & we, st = J0.substr($e, Ne);
    if (xe === 0 || y && 1 & Ee)
      throw new Error("Illegal char " + ge);
    xe === 1 ? ne.push(st) : xe === 2 ? ne.push(z ? st : ge) : xe === 3 && ne.push(ge);
  }
  return ne.join("").normalize("NFC");
}
function $0(v, y, z) {
  z === void 0 && (z = !1);
  let ne = y0(v, z, y).split(".");
  return ne = ne.map(function(ue) {
    return ue.startsWith("xn--") ? f0(ue = M0(ue.substring(4)), z, !1) : f0(ue, z, y), ue;
  }), ne.join(".");
}
function f0(v, y, z) {
  if (v[2] === "-" && v[3] === "-")
    throw new Error("Failed to validate " + v);
  if (v.startsWith("-") || v.endsWith("-"))
    throw new Error("Failed to validate " + v);
  if (v.includes("."))
    throw new Error("Failed to validate " + v);
  if (y0(v, y, z) !== v)
    throw new Error("Failed to validate " + v);
  const ne = v.codePointAt(0);
  if (v0(ne) & 2 << 23)
    throw new Error("Label contains illegal character: " + ne);
}
function H0(v, y) {
  return y === void 0 && (y = {}), $0(v, !1, "useStd3ASCII" in y && y.useStd3ASCII);
}
const G0 = (v) => v && H0(v, { useStd3ASCII: !0 }), Y0 = (v) => {
  if (!(v.startsWith("[") && v.endsWith("]")))
    throw Error(
      "Expected encoded labelhash to start and end with square brackets"
    );
  if (v.length !== 66)
    throw Error("Expected encoded labelhash to have a length of 66");
  return `${v.slice(1, -1)}`;
}, X0 = (v) => v.startsWith("[") && v.endsWith("]") && v.length === 66, Z0 = (v) => {
  let y = "";
  for (let z = 0; z < 32; z++)
    y += "00";
  if (v) {
    const z = v.split(".");
    for (let ne = z.length - 1; ne >= 0; ne--) {
      let ue;
      if (X0(z[ne]))
        ue = Y0(z[ne]);
      else {
        const le = G0(z[ne]);
        ue = W1.keccak_256(le);
      }
      y = W1.keccak_256(Buffer.from(y + ue, "hex"));
    }
  }
  return "0x" + y;
};
function Q0(v) {
  if (!v)
    return [];
  const y = Z0(v);
  return Array.from(Buffer.from(y.slice(2), "hex"));
}
const C2 = {
  inj: {
    mainnet: "https://tm.injective.network",
    testnet: "https://testnet.tm.injective.dev"
  },
  sei: {
    mainnet: "https://rpc.wallet.pacific-1.sei.io",
    testnet: "https://sei-testnet-rpc.polkachu.com"
  }
}, m0 = "spaceIds";
class L0 extends q2 {
  constructor() {
    super(...arguments), t2(this, "serviceID", m0), t2(this, "chain", ["injective", "sei"]), t2(this, "contractAddress", {
      inj: {
        mainnet: "inj1x9m0hceug9qylcyrrtwqtytslv2jrph433thgu",
        testnet: "inj1ppneyx6qfnye26k9mwnf3ngyelvqng67f5v948"
      },
      sei: {
        mainnet: "sei1qujw7gxacyk08fpg0lsf377f727ldq8f9cmjlrxt6awdkag9ypjsdnkh98",
        testnet: "sei1a59k7mc9hsvtaeu532etl2geqmqdyufjncjkg0h3lxsu5u2rpensanaxwf"
      }
    });
  }
  async resolve(y, z, ne) {
    var ue, le;
    try {
      const [, he] = y.split("."), ge = (ue = C2 == null ? void 0 : C2[he]) == null ? void 0 : ue[z], we = this.contractAddress[he][z];
      if (ge && we) {
        const Ee = await this.getCosmWasmClient(ge), xe = await (Ee == null ? void 0 : Ee.queryContractSmart(we, {
          address: {
            node: Q0(y)
          }
        }));
        if (!(xe != null && xe.address) || ((le = ne == null ? void 0 : ne.spaceIds) == null ? void 0 : le.indexOf(he)) === -1)
          throw new N$1("", S$1.NOT_FOUND);
        return xe == null ? void 0 : xe.address;
      } else
        throw new N$1("", S$1.NOT_FOUND);
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
  async lookup(y, z) {
    var ne;
    const ue = {
      prefix: null,
      words: null
    };
    try {
      const { prefix: le, words: he } = x2.decode(y);
      ue.prefix = le, ue.words = he;
    } catch {
      throw new N$1("", S$1.INVALID_ADDRESS);
    }
    try {
      const le = (ne = C2 == null ? void 0 : C2[ue.prefix]) == null ? void 0 : ne[z], he = this.contractAddress[ue.prefix][z];
      if (le && he) {
        const ge = await this.getCosmWasmClient(le), we = await (ge == null ? void 0 : ge.queryContractSmart(he, {
          name: {
            address: y.toLowerCase()
          }
        }));
        if (!(we != null && we.name))
          throw new N$1("", S$1.NOT_FOUND);
        return we.name.endsWith(ue.prefix) ? we.name : we.name + ue.prefix;
      } else
        throw new N$1("", S$1.NOT_FOUND);
    } catch {
      throw new N$1("", S$1.NOT_FOUND);
    }
  }
}
class e9 {
  constructor(y) {
    t2(this, "services", {}), this.network = y, this.network = y, this.registerService(new D0()), this.registerService(new U0()), this.registerService(new q0()), this.registerService(new z0()), this.registerService(new L0());
  }
  registerService(y) {
    if (this.services[y.serviceID])
      throw new N$1(
        "Service already registered",
        S$1.DUPLICATE_SERVICE
      );
    this.services[y.serviceID] = y;
  }
  getService(y) {
    const z = this.services[y];
    if (!z)
      throw new N$1(
        "Service not registered",
        S$1.UNREGISTERED_SERVICE
      );
    return z;
  }
  listServices() {
    return Object.keys(this.services);
  }
  setNetwork(y) {
    this.network = y;
  }
  getNetwork() {
    return this.network;
  }
  async resolve(y, z, ne) {
    return this.getService(z).resolve(y, this.network, ne);
  }
  async lookup(y, z) {
    return this.getService(z).lookup(y, this.network);
  }
  async resolveAll(y, z) {
    const ne = {};
    return await Promise.all(
      Object.entries(this.services).map(async ([ue, le]) => {
        try {
          const he = await le.resolve(
            y,
            this.network,
            z
          );
          ne[ue] = he;
        } catch {
          ne[ue] = null;
        }
      })
    ), ne;
  }
  async lookupAll(y) {
    const z = {};
    return await Promise.all(
      Object.entries(this.services).map(async ([ne, ue]) => {
        try {
          const le = await ue.lookup(y, this.network);
          z[ne] = le;
        } catch {
          z[ne] = null;
        }
      })
    ), z;
  }
}
new e9("mainnet");
var isProduction = process$1.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant$1(v, y) {
  if (!v) {
    if (isProduction)
      throw new Error(prefix);
    var z = typeof y == "function" ? y() : y, ne = z ? "".concat(prefix, ": ").concat(z) : prefix;
    throw new Error(ne);
  }
}
const defaultOptions = {
  slippageTolerancePercent: "2.0",
  affiliates: []
}, onError = (v) => !(v instanceof Error && v.message.toLowerCase().includes("not found")), useMessagesSWR = (v, y, z, ne, ue) => {
  const le = useMemo(() => (z == null ? void 0 : z.slippageTolerancePercent) ?? defaultOptions.slippageTolerancePercent, [z == null ? void 0 : z.slippageTolerancePercent]), he = useMemo(() => (z == null ? void 0 : z.affiliates) ?? defaultOptions.affiliates, [z == null ? void 0 : z.affiliates]), ge = useMemo(() => (z == null ? void 0 : z.isSmartRelayEnabled) ?? !1, [z == null ? void 0 : z.isSmartRelayEnabled]), we = useMemo(() => y ? `${y.source_asset_denom}-${y.source_asset_chain_id}-${y.dest_asset_denom}-${y.dest_asset_chain_id}-${y.amount_in}-${y.amount_out}` : "", [y]);
  return useSWR(ne && y && v ? unstable_serialize([
    "getMessages",
    we,
    v,
    le,
    he.join(","),
    ge
  ]) : null, async () => {
    if (!y || !v)
      return;
    const Ee = await SkipAPI.getMessages({
      source_asset_denom: y.source_asset_denom,
      source_asset_chain_id: y.source_asset_chain_id,
      dest_asset_denom: y.dest_asset_denom,
      dest_asset_chain_id: y.dest_asset_chain_id,
      amount_in: y.amount_in,
      address_list: Array.isArray(v) ? v : y.chain_ids.map((xe) => v[xe]),
      operations: y.operations,
      amount_out: y.amount_out,
      slippage_tolerance_percent: le,
      affiliates: he
    });
    if (Ee.success)
      return ge ? Ee.data.txs : Ee.msgs;
    throw new Error(`API Error: ${Ee.error}`);
  }, ue ? {
    ...ue,
    onError
  } : {
    onError
  });
};
class RouteError extends Error {
  constructor(y) {
    super(y), this.name = "RouteError";
  }
}
function onErrorRetry(v) {
  return !(v instanceof RouteError);
}
const useRoute = (v, y, z, ne, ue, le = !0, he, ge, we = !1, Ee, xe) => {
  const { mutate: $e } = useSWRConfig(), Ne = le ? unstable_serialize([
    "route",
    (y == null ? void 0 : y.denom) ?? "source-asset-denom",
    (z == null ? void 0 : z.chainId) ?? "source-chain-id",
    (ne == null ? void 0 : ne.denom) ?? "dest-asset-denom",
    (ue == null ? void 0 : ue.chainId) ?? "dest-chain-id",
    v || "amountIn",
    ge || "swap-venues",
    (he == null ? void 0 : he.join("-")) ?? "bridges",
    xe ? "direct-transfer" : "ibc-transfer"
  ]) : null, { data: st, error: Nr, isLoading: br, isValidating: $n } = useSWR(Ne, async () => {
    if (!v || !y || !z || !ne || !ue || !le)
      return;
    if (!xe && y.denom === ne.denom)
      throw new RouteError("Source and destination token cannot be same");
    const Rn = new BigNumber(v);
    if (Rn.isNaN() || Rn.isZero() || Rn.isNegative())
      throw new RouteError("Please enter a valid amount");
    if (!(y != null && y.decimals) || !(ne != null && ne.decimals))
      throw new RouteError("Asset metadata unavailable");
    const wa = Rn.multipliedBy(getDecimalPower10(y.decimals)).toFixed(0, BigNumber.ROUND_FLOOR), Aa = {
      source_asset_chain_id: z.chainId.toString(),
      source_asset_denom: y.denom,
      dest_asset_chain_id: ue.chainId.toString(),
      dest_asset_denom: ne.denom,
      amount_in: wa,
      cumulative_affiliate_fee_bps: "0",
      allow_unsafe: !0,
      allow_multi_tx: !0,
      smart_relay: we,
      experimental_features: ["hyperlane", "cctp"]
    };
    he != null && he.length && (Aa.bridges = he, Aa.experimental_features = [], he.includes(BRIDGES.CCTP) && Aa.experimental_features.push("cctp"), he.includes(BRIDGES.HYPERLANE) && Aa.experimental_features.push("hyperlane")), ge && (Aa.swap_venues = ge);
    const _a = await SkipAPI.getRoute(Aa);
    if (_a.success)
      return {
        sourceAssetChain: z,
        sourceAsset: y,
        destinationAssetChain: ue,
        destinationAsset: ne,
        transactionCount: _a.route.txs_required,
        operations: _a.route.operations,
        amountIn: v,
        amountOut: String(new BigNumber(_a.route.amount_out).dividedBy(getDecimalPower10(ne == null ? void 0 : ne.decimals))),
        response: _a.route
      };
    throw new RouteError(_a.error);
  }, Ee ? {
    ...Ee,
    onErrorRetry
  } : {
    onErrorRetry
  }), En = useMemo(() => !st || !ne ? "-" : st.response.amount_out ? String(new BigNumber(st.response.amount_out).dividedBy(getDecimalPower10((ne == null ? void 0 : ne.decimals) ?? 6))) : v, [v, ne, st]);
  return useMemo(() => ({
    routeResponse: st,
    routeError: Nr,
    amountOut: En,
    isLoadingRoute: br,
    routeKey: Ne,
    refresh: () => $e(Ne),
    isValidatingRoute: $n
  }), [
    En,
    br,
    $n,
    Ne,
    $e,
    Nr,
    st
  ]);
}, useSkipSupportedChains = (v, y, z = !0) => {
  const { data: ne } = useChains(v == null ? void 0 : v.onlyTestnets), ue = useMemo(() => {
    if (ne)
      return ne.reduce((he, ge) => (he[ge.chainId] = ge, he), {});
  }, [ne]), le = useMemo(() => ne == null ? void 0 : ne.map((he) => he.chainId).join(","), [ne]);
  return useSWR(ue && z ? unstable_serialize([
    QueryKeys.SKIP_SUPPORTED_CHAINS,
    v == null ? void 0 : v.chainTypes,
    v == null ? void 0 : v.onlyTestnets,
    le
  ]) : null, async () => {
    var xe, $e, Ne;
    invariant$1(ue, "Elements chains have not been loaded");
    const he = (xe = v == null ? void 0 : v.chainTypes) == null ? void 0 : xe.includes("evm"), ge = ($e = v == null ? void 0 : v.chainTypes) == null ? void 0 : $e.includes("svm"), we = ((Ne = v == null ? void 0 : v.chainTypes) == null ? void 0 : Ne.length) === 1 && he, Ee = await SkipAPI.getSupportedChains({
      cached: !0,
      includeEVM: he,
      includeSVM: ge
    });
    if (Ee.success)
      return we ? Ee.chains.filter((st) => st.chainType === "evm") : he || ge ? Ee.chains.map((st) => {
        const Nr = ue[st.chainId];
        return st.chainType === "cosmos" ? {
          ...st,
          ...Nr,
          logoUri: (Nr == null ? void 0 : Nr.icon) ?? st.logoUri
        } : st;
      }).filter(Boolean) : Ee.chains.map((st) => {
        const Nr = ue[st.chainId];
        return Nr ? {
          ...st,
          ...Nr,
          logoUri: Nr.icon ?? st.logoUri
        } : null;
      }).filter(Boolean);
  }, y ?? {
    revalidateOnFocus: !1,
    revalidateOnReconnect: !1
  });
}, useTransactions = (v) => {
  const y = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm"]
  }), z = useMemo(() => {
    if (!v || !y.data)
      return [];
    const ue = [];
    let le = 0, he = 0, ge = v.sourceAsset.denom;
    return v.operations.forEach((we, Ee) => {
      if ("swap" in we) {
        "swap_in" in we.swap && (ue.push({
          type: "SWAP",
          sourceAsset: we.swap.swap_in.swap_operations[0].denom_in,
          destinationAsset: we.swap.swap_in.swap_operations[we.swap.swap_in.swap_operations.length - 1].denom_out,
          chain: we.swap.swap_in.swap_venue.chain_id,
          venue: we.swap.swap_in.swap_venue.name,
          index: Ee,
          id: `swap-${le}-${Ee}`,
          transactionNumber: we.tx_index + 1
        }), ge = we.swap.swap_in.swap_operations[we.swap.swap_in.swap_operations.length - 1].denom_out), "swap_out" in we.swap && (ue.push({
          type: "SWAP",
          sourceAsset: we.swap.swap_out.swap_operations[0].denom_in,
          destinationAsset: we.swap.swap_out.swap_operations[we.swap.swap_out.swap_operations.length - 1].denom_out,
          chain: we.swap.swap_out.swap_venue.chain_id,
          venue: we.swap.swap_out.swap_venue.name,
          index: Ee,
          id: `swap-${le}-${Ee}`,
          transactionNumber: we.tx_index + 1
        }), ge = we.swap.swap_out.swap_operations[we.swap.swap_out.swap_operations.length - 1].denom_out), le++;
        return;
      }
      if ("axelar_transfer" in we) {
        ue.push({
          type: "TRANSFER",
          asset: ge,
          sourceChain: we.axelar_transfer.from_chain_id,
          destinationChain: we.axelar_transfer.to_chain_id,
          index: Ee,
          id: `transfer-${he}-${Ee}`,
          transactionNumber: we.tx_index + 1
        }), ge = we.axelar_transfer.asset, he++;
        return;
      }
      if ("cctp_transfer" in we) {
        ue.push({
          type: "TRANSFER",
          asset: ge,
          sourceChain: we.cctp_transfer.from_chain_id,
          destinationChain: we.cctp_transfer.to_chain_id,
          index: Ee,
          id: `transfer-${he}-${Ee}`,
          transactionNumber: we.tx_index + 1
        }), he++, ge = we.cctp_transfer.denom_out;
        return;
      }
      if ("bank_send" in we) {
        ue.push({
          type: "SEND",
          asset: we.bank_send.denom,
          sourceChain: we.bank_send.chain_id,
          index: Ee,
          id: `send-${he}-${Ee}`,
          transactionNumber: we.tx_index + 1
        });
        return;
      }
      if ("hyperlane_transfer" in we) {
        ue.push({
          type: "TRANSFER",
          asset: ge,
          sourceChain: we.hyperlane_transfer.from_chain_id,
          destinationChain: we.hyperlane_transfer.to_chain_id,
          id: `transfer-${he}-${Ee}`,
          index: Ee,
          transactionNumber: we.tx_index + 1
        }), ge = we.hyperlane_transfer.denom_in, he++;
        return;
      }
      const xe = we.transfer.from_chain_id;
      let $e = "";
      if (Ee === v.operations.length - 1)
        $e = v.destinationAssetChain.chainId.toString();
      else {
        const Ne = v.operations[Ee + 1];
        "swap" in Ne ? ("swap_in" in Ne.swap && ($e = Ne.swap.swap_in.swap_venue.chain_id), "swap_out" in Ne.swap && ($e = Ne.swap.swap_out.swap_venue.chain_id)) : "axelar_transfer" in Ne ? $e = Ne.axelar_transfer.from_chain_id : "cctp_transfer" in Ne ? $e = Ne.cctp_transfer.from_chain_id : "hyperlane_transfer" in Ne ? $e = Ne.hyperlane_transfer.from_chain_id : $e = "transfer" in Ne ? Ne.transfer.from_chain_id : Ne.bank_send.chain_id;
      }
      ue.push({
        type: "TRANSFER",
        asset: ge,
        sourceChain: xe,
        destinationChain: $e,
        index: Ee,
        id: `transfer-${he}-${Ee}`,
        transactionNumber: we.tx_index + 1
      }), he++, ge = we.transfer.denom_out;
    }), ue;
  }, [v, y.data]);
  return {
    groupedTransactions: useMemo(() => {
      const ue = {};
      return z.forEach((le) => {
        const he = `Transaction ${le.transactionNumber}`;
        ue[he] || (ue[he] = []), ue[he].push(le);
      }), ue;
    }, [z]),
    actions: z
  };
}, useSkipDestinationChains = (v, y, z) => {
  const { data: ne } = useChains(!z);
  return useSWR(v && y && ne ? `${QueryKeys.SKIP_DESTINATION_CHAINS}:${v.denom}:${y.chainId}` : null, async () => {
    if (!y || !v || !ne)
      return [];
    const ue = {};
    ne.forEach((ge) => {
      ue[ge.chainId] = ge;
    });
    const le = await SkipAPI.getRecommendedChainAssets({
      source_asset_denom: v.denom,
      source_asset_chain_id: y.chainId,
      allow_multi_tx: !0
    }), he = [];
    return le.success && Object.entries(le.chains).forEach(([ge, we]) => {
      if (ge !== y.chainId && ue[ge]) {
        const Ee = we.assets[0];
        he.push({
          ...ue[ge],
          asset: {
            denom: Ee.denom,
            originDenom: Ee.origin_denom,
            logoUri: Ee.logo_uri,
            decimals: Ee.decimals,
            symbol: Ee.recommended_symbol ?? Ee.symbol,
            name: Ee.name,
            originChainId: Ee.origin_chain_id,
            chainId: Ee.chain_id,
            trace: Ee.trace,
            tokenContract: Ee.token_contract,
            coingeckoId: Ee.coingecko_id,
            isCw20: Ee.is_cw20
          }
        });
      }
    }), [
      ...he,
      {
        ...y,
        asset: {
          ...v,
          name: v.symbol
        }
      }
    ];
  });
}, useNativeFeeDenoms = () => useSWR(QueryKeys.NATIVE_FEE_DENOMS, getNativeFeeDenoms, {
  dedupingInterval: 1e3 * 60
  // 1 minute
}), useSkipGasFeeSWR = (v, y, z, ne, ue = !0) => {
  const { data: le } = useChains(!z), { data: he } = useDenoms(), { data: ge } = useGasPriceSteps(), { data: we } = useGasAdjustment(), { data: Ee } = useNativeFeeDenoms();
  return useSWR(le && he && ge && v && y && ue ? unstable_serialize([v, y]) : null, async function() {
    if (!le || !he || !ge || !y || !v || !Ee)
      throw new Error("missing data");
    const $e = v.filter((wa) => "multi_chain_msg" in wa).map((wa) => wa.multi_chain_msg), Ne = v.filter((wa) => "cosmos_tx" in wa).map((wa) => wa.cosmos_tx), st = $e.length ? $e : Ne, Nr = new Array(st.length), br = new Array(st.length), $n = new Array(st.length), En = new Array(st.length);
    await Promise.all(st.map(async (wa, Aa) => {
      var Oe;
      const _a = le.find((Fr) => Fr.chainId === wa.chain_id);
      if (!_a) {
        $n[Aa] = `Chain ${wa.chain_id} info not found`;
        return;
      }
      const Ta = await getDenomData(_a.baseDenom, _a.chainId, le, he);
      if (!Ta) {
        $n[Aa] = `Denom info for ${_a.baseDenom} (${_a.chainName}) not found`;
        return;
      }
      const Zn = new BigNumber(((Oe = ge[_a.key]) == null ? void 0 : Oe.low) ?? 0.025);
      let Ra = GAS_ESTIMATE;
      const Yn = Array.isArray(y) ? y[Aa] : y[_a.chainId], $o = [];
      try {
        if ("msgs" in wa && wa.msgs.forEach((zn) => {
          const Fe = getDecodedMessage({
            msg: zn.msg,
            msg_type_url: zn.msg_type_url
          }), pe = JSON.parse(zn.msg);
          if ((Fe == null ? void 0 : Fe.typeUrl) === "/cosmwasm.wasm.v1.MsgExecuteContract" && (Ra = GAS_ESTIMATE * 6), "memo" in pe && (pe.memo.includes("swap") ? Ra = GAS_ESTIMATE * 6 : Ra = GAS_ESTIMATE * 1.5), Fe === null) {
            console.warn("Encountered unsupported message type while executing skip gas fee calculation", `
Message Object:
`, zn), $n[Aa] = `Unsupported message type ${zn.msg_type_url}`;
            return;
          }
          $o.push(Fe);
        }), "msg" in wa && "msg_type_url" in wa) {
          const zn = getDecodedMessage({
            msg: wa.msg,
            msg_type_url: wa.msg_type_url
          }), Fe = JSON.parse(wa.msg);
          if ((zn == null ? void 0 : zn.typeUrl) === "/cosmwasm.wasm.v1.MsgExecuteContract" && (Ra = GAS_ESTIMATE * 6), "memo" in Fe && (Fe.memo.includes("swap") ? Ra = GAS_ESTIMATE * 6 : Ra = GAS_ESTIMATE * 1.5), zn === null) {
            console.warn("Encountered unsupported message type while executing skip gas fee calculation", `
Message Object:
`, wa), $n[Aa] = `Unsupported message type ${wa.msg_type_url}`;
            return;
          }
          $o.push(zn);
        }
        const { gasUsed: Fr } = await simulateTx(_a.restUrl, Yn, $o);
        Ra = Fr;
      } catch (Fr) {
        console.warn("Encountered error while executing skip gas fee calculation, using default gas fee", Fr);
      }
      const ct = (we == null ? void 0 : we[_a.key]) ?? 1.5, fe = calculateFee(Ra, Zn.toNumber(), _a.baseDenom, ct);
      Nr[Aa] = fe;
      const be = new BigNumber(fe.amount[0].amount).dividedBy(getDecimalPower10(Ta.coinDecimals)), ye = `${be.isLessThan(1e-5) ? "<0.00001" : be.toFixed()} ${Ta.coinDenom}`;
      br[Aa] = ye;
      const Se = await CoinGeckoAPI.getCoinPrice(Ta.coinGeckoId);
      if (En[Aa] = Se !== -1 ? be.multipliedBy(Se) : void 0, Aa === 0)
        try {
          const Fr = await TokenBalanceAPI.getBalances(Yn, le), zn = Ee.mainnet[_a.key], Fe = he[zn], pe = Fr.find((wo) => wo.denom === Fe.coinMinimalDenom), it = new BigNumber((pe == null ? void 0 : pe.amount) ?? 0).dividedBy(getDecimalPower10(Ta.coinDecimals)), xa = `${be.isLessThan(1e-5) ? "<0.00001" : it.toFixed()} ${Ta.coinDenom}`;
          be.isGreaterThan(it) && ($n[Aa] = `Insufficient balance for gas fee on ${_a.chainName}. Balance: ${xa}, Fee: ${ye}.`, console.log(Aa, _a, $n));
        } catch {
        }
    }));
    const Rn = $n.filter((wa) => !!wa).join(" ");
    return {
      gasFees: br,
      usdGasFees: En,
      gasFeesAmount: Nr,
      gasFeesError: Rn
    };
  }, ne);
}, useBridgeFee = (v) => {
  const y = useMemo(() => {
    if (v) {
      for (const he of v.operations)
        if ("axelar_transfer" in he)
          return he;
    }
  }, [v]), z = useMemo(() => {
    if (v) {
      for (const he of v.operations)
        if ("hyperlane_transfer" in he)
          return he;
    }
  }, [v]), ne = useMemo(() => {
    if (!y)
      return;
    const { fee_amount: he, fee_asset: ge, usd_fee_amount: we } = y.axelar_transfer;
    invariant$1(ge.decimals, `Bridging fee asset decimals not available: ${ge.symbol} (${ge.denom})`);
    const Ee = `${formatAmount$1(new BigNumber(he).dividedBy(getDecimalPower10(ge.decimals)), 2, 6)} ${ge.symbol}`, xe = we ? new BigNumber(we) : new BigNumber(0);
    return {
      fee: Ee,
      feeUSD: xe,
      feeAmount: {
        amount: [
          {
            denom: ge.denom,
            amount: he
          }
        ],
        gas: ""
      }
    };
  }, [y]), ue = useMemo(() => {
    if (!z)
      return;
    const { fee_amount: he, fee_asset: ge, usd_fee_amount: we } = z.hyperlane_transfer;
    invariant$1(ge.decimals, `Bridging fee asset decimals not available: ${ge.symbol} (${ge.denom})`);
    const Ee = `${formatAmount$1(new BigNumber(he).dividedBy(getDecimalPower10(ge.decimals)), 2, 6)} ${ge.symbol}`, xe = we ? new BigNumber(we) : new BigNumber(0);
    return {
      fee: Ee,
      feeUSD: xe,
      feeAmount: {
        amount: [
          {
            denom: ge.denom,
            amount: he
          }
        ],
        gas: ""
      }
    };
  }, [z]);
  return useMemo(() => {
    const he = {
      bridgeFees: [],
      bridgeFeesAmount: [{}],
      bridgeFeesError: void 0,
      usdBridgeFees: [new BigNumber(0)]
    };
    return ne && (he.bridgeFees = [ne.fee], he.bridgeFeesAmount = [ne.feeAmount], he.usdBridgeFees = [ne.feeUSD]), ue && (he.bridgeFees = [ue.fee], he.bridgeFeesAmount = [ue.feeAmount], he.usdBridgeFees = [ue.feeUSD]), he;
  }, [ne, ue]);
};
new BigNumber(10).pow(6).toNumber();
const useAddressCoinType = (v) => {
  const { data: y } = useChains();
  return useMemo(() => {
    try {
      if (!v)
        return;
      const ne = bech32$6.decodeUnsafe(v);
      if (!ne)
        return {
          error: "Invalid address"
        };
      if (!y)
        return;
      const ue = y.find((le) => le.addressPrefix === ne.prefix);
      return ue ? {
        coinType: ue.coinType
      } : {
        error: "Chain not supported"
      };
    } catch {
      return {
        error: "Invalid address"
      };
    }
  }, [v, y]);
}, useAddressList = ({ chainIds: v = [], destinationChainId: y, destinationAddress: z, userAddress: ne, walletClient: ue, chains: le }) => {
  const [he, ge] = useState(null), [we, Ee] = useState(), { data: xe } = useChains(), $e = useAddressCoinType(ne), Ne = le || xe;
  return useEffect(() => {
    async function st() {
      const Nr = [], br = [], $n = [];
      for (let En = 0; En < v.length; En++) {
        const Rn = v[En];
        if (Rn === y && En === v.length - 1)
          br.push(z);
        else {
          const wa = Ne == null ? void 0 : Ne.find((Aa) => Aa.chainId === Rn);
          if (!wa) {
            $n.push(`Chain ${Rn} is not supported.`);
            continue;
          }
          if (wa.coinType === ($e == null ? void 0 : $e.coinType)) {
            const Aa = convertAddress$1(ne, wa.addressPrefix);
            br.push(Aa);
          } else
            br.push(`pending-${Rn}`), Nr.push(Rn);
        }
      }
      if (Nr.length > 0) {
        await ue.enable(Nr);
        for (const En of Nr)
          try {
            const { bech32Address: Rn } = await ue.getAccount(En), wa = br.indexOf(`pending-${En}`);
            br[wa] = Rn;
          } catch (Rn) {
            Rn instanceof Error && ((Rn.message.includes("rejected") || Rn.message.includes("denied")) && $n.push(`Please approve chain ${En} from wallet.`), $n.push(`Wallet does not support chain ${En}.`));
          }
      }
      ge(br), Ee($n.join(" "));
    }
    return v != null && v.length && ne && ue && (Ne != null && Ne.length) && z && y && st(), () => {
      ge(null), Ee(void 0);
    };
  }, [
    v,
    Ne,
    y,
    z,
    ne,
    ue,
    $e
  ]), {
    userAddressList: he,
    error: we
  };
}, useRelayerFee = (v) => {
  const y = useMemo(() => {
    if (v) {
      for (const ue of v.operations)
        if ("cctp_transfer" in ue)
          return ue;
    }
  }, [v]), z = useMemo(() => {
    if (!y)
      return;
    const ue = v == null ? void 0 : v.response.estimated_fees.find((xe) => xe.bridge_id === "CCTP" && xe.fee_type === "SMART_RELAY");
    if (!ue)
      return;
    const { amount: le, origin_asset: he, usd_amount: ge } = ue, we = `${formatAmount$1(new BigNumber(le).dividedBy(getDecimalPower10(he.decimals)), 2, 6)} ${he.symbol}`, Ee = ge ? new BigNumber(ge) : new BigNumber(0);
    return { fee: we, feeUSD: Ee };
  }, [v, y]);
  return useMemo(() => {
    const ue = {
      gasFees: "",
      gasFeesError: "",
      usdGasFees: new BigNumber(0)
    };
    return z && (ue.gasFees = z.fee, ue.usdGasFees = z.feeUSD), ue;
  }, [z]);
}, useKadoQuoteSWR = (v, y, z, ne = !0, ue = {}) => {
  const { mutate: le } = useSWRConfig(), he = ne && v && y && z ? `${QueryKeys.KADO_QUOTE}:${v}:${y}:${z}` : null, { data: ge, error: we, isValidating: Ee, isLoading: xe } = useSWR(he, async () => {
    if (!v || !y || !z)
      throw new Error("Missing asset, blockchain, or amountUsd");
    const $e = await KadoAPI.getQuote({
      transactionType: "buy",
      fiatMethod: "ach",
      partner: "fortress",
      amount: z,
      asset: v,
      blockchain: y,
      currency: "USD"
    });
    if (!$e.success)
      throw new Error($e.error);
    return $e;
  }, ue);
  return useMemo(() => ({
    data: ge,
    error: we,
    isValidating: Ee,
    isLoading: xe,
    refresh: () => le(he)
  }), [ge, we, Ee, xe, le, he]);
}, useKadoCurrencyListSWR = (v = !0, y = {}) => useSWR(v ? QueryKeys.KADO_CURRENCY_LIST : null, () => KadoAPI.getSupportedCurrencies(), y);
class AddressError {
  constructor(y, z) {
    Rm(this, "message");
    Rm(this, "code");
    this.message = y, this.code = z;
  }
}
function useSourceAddress$1(v, y, z) {
  const [ne, ue] = useState(), [le, he] = useState(), { data: ge } = useChains(), we = useCallback(async (Ee) => {
    if (!(!z || !y))
      try {
        const xe = await y.getAccount(z.chainId);
        if (Ee != null && Ee.current)
          return;
        ue(xe.bech32Address), he(void 0);
      } catch (xe) {
        if (Ee != null && Ee.current)
          return;
        const $e = xe;
        ue(void 0), he($e.message.toLowerCase().includes("invalid chain") ? new AddressError("Chain is not supported by the wallet", 2) : new AddressError("Could not get address from wallet", 3));
      }
  }, [z, y]);
  return useEffect(() => {
    if (!z || !y)
      return;
    if (!v) {
      ue(void 0), he(void 0);
      return;
    }
    const Ee = bech32$6.decodeUnsafe(v);
    if (!Ee) {
      ue(void 0), he(new AddressError("Invalid address", 4));
      return;
    }
    if (!ge)
      return;
    const xe = ge.find((st) => st.addressPrefix === Ee.prefix);
    if (!xe) {
      ue(void 0), he(new AddressError("We do not support this chain", 1));
      return;
    }
    const $e = xe.coinType, Ne = {
      current: !1
    };
    if ($e === z.coinType)
      try {
        const st = convertAddress$1(v, z.addressPrefix);
        ue(st), he(void 0);
      } catch {
        ue(void 0), he(new AddressError("Invalid address", 4));
      }
    else
      we(Ne);
    return () => {
      Ne.current = !0;
    };
  }, [ge, we, z, v, y]), useEffect(() => {
    v || (ue(void 0), he(void 0));
  }, [v]), useMemo(() => ({
    address: ne,
    error: le,
    refetch: we
  }), [ne, le, we]);
}
const setSkipAPIClientID = (v) => {
  SkipAPI.setClientID(v);
}, initCachingLayer = (v) => {
  storageLayer.isInitialized() || storageLayer.initialize(v);
}, MotionConfigContext = createContext({
  transformPagePoint: (v) => v,
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({}), PresenceContext = createContext(null), isBrowser = typeof document < "u", useIsomorphicLayoutEffect$3 = isBrowser ? useLayoutEffect : useEffect, LazyContext = createContext({ strict: !1 }), camelToDash = (v) => v.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), optimizedAppearDataId = "framerAppearId", optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId), MotionGlobalConfig = {
  skipAnimations: !1,
  useManualTiming: !1
};
class Queue {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(y) {
    if (!this.scheduled.has(y))
      return this.scheduled.add(y), this.order.push(y), !0;
  }
  remove(y) {
    const z = this.order.indexOf(y);
    z !== -1 && (this.order.splice(z, 1), this.scheduled.delete(y));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function createRenderStep(v) {
  let y = new Queue(), z = new Queue(), ne = 0, ue = !1, le = !1;
  const he = /* @__PURE__ */ new WeakSet(), ge = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (we, Ee = !1, xe = !1) => {
      const $e = xe && ue, Ne = $e ? y : z;
      return Ee && he.add(we), Ne.add(we) && $e && ue && (ne = y.order.length), we;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (we) => {
      z.remove(we), he.delete(we);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (we) => {
      if (ue) {
        le = !0;
        return;
      }
      if (ue = !0, [y, z] = [z, y], z.clear(), ne = y.order.length, ne)
        for (let Ee = 0; Ee < ne; Ee++) {
          const xe = y.order[Ee];
          he.has(xe) && (ge.schedule(xe), v()), xe(we);
        }
      ue = !1, le && (le = !1, ge.process(we));
    }
  };
  return ge;
}
const stepsOrder = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], maxElapsed = 40;
function createRenderBatcher(v, y) {
  let z = !1, ne = !0;
  const ue = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, le = stepsOrder.reduce(($e, Ne) => ($e[Ne] = createRenderStep(() => z = !0), $e), {}), he = ($e) => {
    le[$e].process(ue);
  }, ge = () => {
    const $e = performance.now();
    z = !1, ue.delta = ne ? 1e3 / 60 : Math.max(Math.min($e - ue.timestamp, maxElapsed), 1), ue.timestamp = $e, ue.isProcessing = !0, stepsOrder.forEach(he), ue.isProcessing = !1, z && y && (ne = !1, v(ge));
  }, we = () => {
    z = !0, ne = !0, ue.isProcessing || v(ge);
  };
  return { schedule: stepsOrder.reduce(($e, Ne) => {
    const st = le[Ne];
    return $e[Ne] = (Nr, br = !1, $n = !1) => (z || we(), st.schedule(Nr, br, $n)), $e;
  }, {}), cancel: ($e) => stepsOrder.forEach((Ne) => le[Ne].cancel($e)), state: ue, steps: le };
}
const { schedule: microtask, cancel: cancelMicrotask } = createRenderBatcher(queueMicrotask, !1);
function useVisualElement(v, y, z, ne) {
  const { visualElement: ue } = useContext(MotionContext), le = useContext(LazyContext), he = useContext(PresenceContext), ge = useContext(MotionConfigContext).reducedMotion, we = useRef();
  ne = ne || le.renderer, !we.current && ne && (we.current = ne(v, {
    visualState: y,
    parent: ue,
    props: z,
    presenceContext: he,
    blockInitialAnimation: he ? he.initial === !1 : !1,
    reducedMotionConfig: ge
  }));
  const Ee = we.current;
  useInsertionEffect(() => {
    Ee && Ee.update(z, he);
  });
  const xe = useRef(!!(z[optimizedAppearDataAttribute] && !window.HandoffComplete));
  return useIsomorphicLayoutEffect$3(() => {
    Ee && (microtask.postRender(Ee.render), xe.current && Ee.animationState && Ee.animationState.animateChanges());
  }), useEffect(() => {
    Ee && (Ee.updateFeatures(), !xe.current && Ee.animationState && Ee.animationState.animateChanges(), xe.current && (xe.current = !1, window.HandoffComplete = !0));
  }), Ee;
}
function isRefObject(v) {
  return v && typeof v == "object" && Object.prototype.hasOwnProperty.call(v, "current");
}
function useMotionRef(v, y, z) {
  return useCallback(
    (ne) => {
      ne && v.mount && v.mount(ne), y && (ne ? y.mount(ne) : y.unmount()), z && (typeof z == "function" ? z(ne) : isRefObject(z) && (z.current = ne));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [y]
  );
}
function isVariantLabel(v) {
  return typeof v == "string" || Array.isArray(v);
}
function isAnimationControls(v) {
  return v !== null && typeof v == "object" && typeof v.start == "function";
}
const variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], variantProps = ["initial", ...variantPriorityOrder];
function isControllingVariants(v) {
  return isAnimationControls(v.animate) || variantProps.some((y) => isVariantLabel(v[y]));
}
function isVariantNode(v) {
  return !!(isControllingVariants(v) || v.variants);
}
function getCurrentTreeVariants(v, y) {
  if (isControllingVariants(v)) {
    const { initial: z, animate: ne } = v;
    return {
      initial: z === !1 || isVariantLabel(z) ? z : void 0,
      animate: isVariantLabel(ne) ? ne : void 0
    };
  }
  return v.inherit !== !1 ? y : {};
}
function useCreateMotionContext(v) {
  const { initial: y, animate: z } = getCurrentTreeVariants(v, useContext(MotionContext));
  return useMemo(() => ({ initial: y, animate: z }), [variantLabelsAsDependency(y), variantLabelsAsDependency(z)]);
}
function variantLabelsAsDependency(v) {
  return Array.isArray(v) ? v.join(" ") : v;
}
const featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, featureDefinitions = {};
for (const v in featureProps)
  featureDefinitions[v] = {
    isEnabled: (y) => featureProps[v].some((z) => !!y[z])
  };
function loadFeatures(v) {
  for (const y in v)
    featureDefinitions[y] = {
      ...featureDefinitions[y],
      ...v[y]
    };
}
const LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({}), motionComponentSymbol = Symbol.for("motionComponentSymbol");
function createMotionComponent({ preloadedFeatures: v, createVisualElement: y, useRender: z, useVisualState: ne, Component: ue }) {
  v && loadFeatures(v);
  function le(ge, we) {
    let Ee;
    const xe = {
      ...useContext(MotionConfigContext),
      ...ge,
      layoutId: useLayoutId(ge)
    }, { isStatic: $e } = xe, Ne = useCreateMotionContext(ge), st = ne(ge, $e);
    if (!$e && isBrowser) {
      Ne.visualElement = useVisualElement(ue, st, xe, y);
      const Nr = useContext(SwitchLayoutGroupContext), br = useContext(LazyContext).strict;
      Ne.visualElement && (Ee = Ne.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        xe,
        br,
        v,
        Nr
      ));
    }
    return a$z.createElement(
      MotionContext.Provider,
      { value: Ne },
      Ee && Ne.visualElement ? a$z.createElement(Ee, { visualElement: Ne.visualElement, ...xe }) : null,
      z(ue, ge, useMotionRef(st, Ne.visualElement, we), st, $e, Ne.visualElement)
    );
  }
  const he = forwardRef(le);
  return he[motionComponentSymbol] = ue, he;
}
function useLayoutId({ layoutId: v }) {
  const y = useContext(LayoutGroupContext).id;
  return y && v !== void 0 ? y + "-" + v : v;
}
function createMotionProxy(v) {
  function y(ne, ue = {}) {
    return createMotionComponent(v(ne, ue));
  }
  if (typeof Proxy > "u")
    return y;
  const z = /* @__PURE__ */ new Map();
  return new Proxy(y, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (ne, ue) => (z.has(ue) || z.set(ue, y(ue)), z.get(ue))
  });
}
const lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(v) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof v != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    v.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(v) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(v))
    )
  );
}
const scaleCorrectors = {};
function addScaleCorrector(v) {
  Object.assign(scaleCorrectors, v);
}
const transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], transformProps = new Set(transformPropOrder);
function isForcedMotionValue(v, { layout: y, layoutId: z }) {
  return transformProps.has(v) || v.startsWith("origin") || (y || z !== void 0) && (!!scaleCorrectors[v] || v === "opacity");
}
const isMotionValue = (v) => !!(v && v.getVelocity), translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, numTransforms = transformPropOrder.length;
function buildTransform(v, { enableHardwareAcceleration: y = !0, allowTransformNone: z = !0 }, ne, ue) {
  let le = "";
  for (let he = 0; he < numTransforms; he++) {
    const ge = transformPropOrder[he];
    if (v[ge] !== void 0) {
      const we = translateAlias[ge] || ge;
      le += `${we}(${v[ge]}) `;
    }
  }
  return y && !v.z && (le += "translateZ(0)"), le = le.trim(), ue ? le = ue(v, ne ? "" : le) : z && ne && (le = "none"), le;
}
const checkStringStartsWith = (v) => (y) => typeof y == "string" && y.startsWith(v), isCSSVariableName = checkStringStartsWith("--"), startsAsVariableToken = checkStringStartsWith("var(--"), isCSSVariableToken = (v) => startsAsVariableToken(v) ? singleCssVariableRegex.test(v.split("/*")[0].trim()) : !1, singleCssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)$/i, getValueAsType = (v, y) => y && typeof v == "number" ? y.transform(v) : v, clamp = (v, y, z) => z > y ? y : z < v ? v : z, number = {
  test: (v) => typeof v == "number",
  parse: parseFloat,
  transform: (v) => v
}, alpha = {
  ...number,
  transform: (v) => clamp(0, 1, v)
}, scale = {
  ...number,
  default: 1
}, sanitize = (v) => Math.round(v * 1e5) / 1e5, floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
  return typeof v == "string";
}
const createUnitType = (v) => ({
  test: (y) => isString(y) && y.endsWith(v) && y.split(" ").length === 1,
  parse: parseFloat,
  transform: (y) => `${y}${v}`
}), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = {
  ...percent,
  parse: (v) => percent.parse(v) / 100,
  transform: (v) => percent.transform(v * 100)
}, int$1 = {
  ...number,
  transform: Math.round
}, numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int$1,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int$1
};
function buildHTMLStyles(v, y, z, ne) {
  const { style: ue, vars: le, transform: he, transformOrigin: ge } = v;
  let we = !1, Ee = !1, xe = !0;
  for (const $e in y) {
    const Ne = y[$e];
    if (isCSSVariableName($e)) {
      le[$e] = Ne;
      continue;
    }
    const st = numberValueTypes[$e], Nr = getValueAsType(Ne, st);
    if (transformProps.has($e)) {
      if (we = !0, he[$e] = Nr, !xe)
        continue;
      Ne !== (st.default || 0) && (xe = !1);
    } else
      $e.startsWith("origin") ? (Ee = !0, ge[$e] = Nr) : ue[$e] = Nr;
  }
  if (y.transform || (we || ne ? ue.transform = buildTransform(v.transform, z, xe, ne) : ue.transform && (ue.transform = "none")), Ee) {
    const { originX: $e = "50%", originY: Ne = "50%", originZ: st = 0 } = ge;
    ue.transformOrigin = `${$e} ${Ne} ${st}`;
  }
}
const createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function copyRawValuesOnly(v, y, z) {
  for (const ne in y)
    !isMotionValue(y[ne]) && !isForcedMotionValue(ne, z) && (v[ne] = y[ne]);
}
function useInitialMotionValues({ transformTemplate: v }, y, z) {
  return useMemo(() => {
    const ne = createHtmlRenderState();
    return buildHTMLStyles(ne, y, { enableHardwareAcceleration: !z }, v), Object.assign({}, ne.vars, ne.style);
  }, [y]);
}
function useStyle(v, y, z) {
  const ne = v.style || {}, ue = {};
  return copyRawValuesOnly(ue, ne, v), Object.assign(ue, useInitialMotionValues(v, y, z)), ue;
}
function useHTMLProps(v, y, z) {
  const ne = {}, ue = useStyle(v, y, z);
  return v.drag && v.dragListener !== !1 && (ne.draggable = !1, ue.userSelect = ue.WebkitUserSelect = ue.WebkitTouchCallout = "none", ue.touchAction = v.drag === !0 ? "none" : `pan-${v.drag === "x" ? "y" : "x"}`), v.tabIndex === void 0 && (v.onTap || v.onTapStart || v.whileTap) && (ne.tabIndex = 0), ne.style = ue, ne;
}
const validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(v) {
  return v.startsWith("while") || v.startsWith("drag") && v !== "draggable" || v.startsWith("layout") || v.startsWith("onTap") || v.startsWith("onPan") || v.startsWith("onLayout") || validMotionProps.has(v);
}
let shouldForward = (v) => !isValidMotionProp(v);
function loadExternalIsValidProp(v) {
  v && (shouldForward = (y) => y.startsWith("on") ? !isValidMotionProp(y) : v(y));
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch (v) {
}
function filterProps(v, y, z) {
  const ne = {};
  for (const ue in v)
    ue === "values" && typeof v.values == "object" || (shouldForward(ue) || z === !0 && isValidMotionProp(ue) || !y && !isValidMotionProp(ue) || // If trying to use native HTML drag events, forward drag listeners
    v.draggable && ue.startsWith("onDrag")) && (ne[ue] = v[ue]);
  return ne;
}
function calcOrigin$1(v, y, z) {
  return typeof v == "string" ? v : px.transform(y + z * v);
}
function calcSVGTransformOrigin(v, y, z) {
  const ne = calcOrigin$1(y, v.x, v.width), ue = calcOrigin$1(z, v.y, v.height);
  return `${ne} ${ue}`;
}
const dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(v, y, z = 1, ne = 0, ue = !0) {
  v.pathLength = 1;
  const le = ue ? dashKeys : camelKeys;
  v[le.offset] = px.transform(-ne);
  const he = px.transform(y), ge = px.transform(z);
  v[le.array] = `${he} ${ge}`;
}
function buildSVGAttrs(v, {
  attrX: y,
  attrY: z,
  attrScale: ne,
  originX: ue,
  originY: le,
  pathLength: he,
  pathSpacing: ge = 1,
  pathOffset: we = 0,
  // This is object creation, which we try to avoid per-frame.
  ...Ee
}, xe, $e, Ne) {
  if (buildHTMLStyles(v, Ee, xe, Ne), $e) {
    v.style.viewBox && (v.attrs.viewBox = v.style.viewBox);
    return;
  }
  v.attrs = v.style, v.style = {};
  const { attrs: st, style: Nr, dimensions: br } = v;
  st.transform && (br && (Nr.transform = st.transform), delete st.transform), br && (ue !== void 0 || le !== void 0 || Nr.transform) && (Nr.transformOrigin = calcSVGTransformOrigin(br, ue !== void 0 ? ue : 0.5, le !== void 0 ? le : 0.5)), y !== void 0 && (st.x = y), z !== void 0 && (st.y = z), ne !== void 0 && (st.scale = ne), he !== void 0 && buildSVGPath(st, he, ge, we, !1);
}
const createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
}), isSVGTag = (v) => typeof v == "string" && v.toLowerCase() === "svg";
function useSVGProps(v, y, z, ne) {
  const ue = useMemo(() => {
    const le = createSvgRenderState();
    return buildSVGAttrs(le, y, { enableHardwareAcceleration: !1 }, isSVGTag(ne), v.transformTemplate), {
      ...le.attrs,
      style: { ...le.style }
    };
  }, [y]);
  if (v.style) {
    const le = {};
    copyRawValuesOnly(le, v.style, v), ue.style = { ...le, ...ue.style };
  }
  return ue;
}
function createUseRender(v = !1) {
  return (z, ne, ue, { latestValues: le }, he) => {
    const we = (isSVGComponent(z) ? useSVGProps : useHTMLProps)(ne, le, he, z), Ee = filterProps(ne, typeof z == "string", v), xe = z !== Fragment ? { ...Ee, ...we, ref: ue } : {}, { children: $e } = ne, Ne = useMemo(() => isMotionValue($e) ? $e.get() : $e, [$e]);
    return createElement(z, {
      ...xe,
      children: Ne
    });
  };
}
function renderHTML(v, { style: y, vars: z }, ne, ue) {
  Object.assign(v.style, y, ue && ue.getProjectionStyles(ne));
  for (const le in z)
    v.style.setProperty(le, z[le]);
}
const camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function renderSVG(v, y, z, ne) {
  renderHTML(v, y, void 0, ne);
  for (const ue in y.attrs)
    v.setAttribute(camelCaseAttributes.has(ue) ? ue : camelToDash(ue), y.attrs[ue]);
}
function scrapeMotionValuesFromProps$1(v, y) {
  const { style: z } = v, ne = {};
  for (const ue in z)
    (isMotionValue(z[ue]) || y.style && isMotionValue(y.style[ue]) || isForcedMotionValue(ue, v)) && (ne[ue] = z[ue]);
  return ne;
}
function scrapeMotionValuesFromProps(v, y) {
  const z = scrapeMotionValuesFromProps$1(v, y);
  for (const ne in v)
    if (isMotionValue(v[ne]) || isMotionValue(y[ne])) {
      const ue = transformPropOrder.indexOf(ne) !== -1 ? "attr" + ne.charAt(0).toUpperCase() + ne.substring(1) : ne;
      z[ue] = v[ne];
    }
  return z;
}
function resolveVariantFromProps(v, y, z, ne = {}, ue = {}) {
  return typeof y == "function" && (y = y(z !== void 0 ? z : v.custom, ne, ue)), typeof y == "string" && (y = v.variants && v.variants[y]), typeof y == "function" && (y = y(z !== void 0 ? z : v.custom, ne, ue)), y;
}
function useConstant(v) {
  const y = useRef(null);
  return y.current === null && (y.current = v()), y.current;
}
const isKeyframesTarget = (v) => Array.isArray(v), isCustomValue = (v) => !!(v && typeof v == "object" && v.mix && v.toValue), resolveFinalValueInKeyframes = (v) => isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
function resolveMotionValue(v) {
  const y = isMotionValue(v) ? v.get() : v;
  return isCustomValue(y) ? y.toValue() : y;
}
function makeState({ scrapeMotionValuesFromProps: v, createRenderState: y, onMount: z }, ne, ue, le) {
  const he = {
    latestValues: makeLatestValues(ne, ue, le, v),
    renderState: y()
  };
  return z && (he.mount = (ge) => z(ne, ge, he)), he;
}
const makeUseVisualState = (v) => (y, z) => {
  const ne = useContext(MotionContext), ue = useContext(PresenceContext), le = () => makeState(v, y, ne, ue);
  return z ? le() : useConstant(le);
};
function makeLatestValues(v, y, z, ne) {
  const ue = {}, le = ne(v, {});
  for (const Ne in le)
    ue[Ne] = resolveMotionValue(le[Ne]);
  let { initial: he, animate: ge } = v;
  const we = isControllingVariants(v), Ee = isVariantNode(v);
  y && Ee && !we && v.inherit !== !1 && (he === void 0 && (he = y.initial), ge === void 0 && (ge = y.animate));
  let xe = z ? z.initial === !1 : !1;
  xe = xe || he === !1;
  const $e = xe ? ge : he;
  return $e && typeof $e != "boolean" && !isAnimationControls($e) && (Array.isArray($e) ? $e : [$e]).forEach((st) => {
    const Nr = resolveVariantFromProps(v, st);
    if (!Nr)
      return;
    const { transitionEnd: br, transition: $n, ...En } = Nr;
    for (const Rn in En) {
      let wa = En[Rn];
      if (Array.isArray(wa)) {
        const Aa = xe ? wa.length - 1 : 0;
        wa = wa[Aa];
      }
      wa !== null && (ue[Rn] = wa);
    }
    for (const Rn in br)
      ue[Rn] = br[Rn];
  }), ue;
}
const noop$1 = (v) => v, { schedule: frame, cancel: cancelFrame, state: frameData, steps } = createRenderBatcher(typeof requestAnimationFrame < "u" ? requestAnimationFrame : noop$1, !0), svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: (v, y, { renderState: z, latestValues: ne }) => {
      frame.read(() => {
        try {
          z.dimensions = typeof y.getBBox == "function" ? y.getBBox() : y.getBoundingClientRect();
        } catch {
          z.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), frame.render(() => {
        buildSVGAttrs(z, ne, { enableHardwareAcceleration: !1 }, isSVGTag(y.tagName), v.transformTemplate), renderSVG(y, z);
      });
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(v, { forwardMotionProps: y = !1 }, z, ne) {
  return {
    ...isSVGComponent(v) ? svgMotionConfig : htmlMotionConfig,
    preloadedFeatures: z,
    useRender: createUseRender(y),
    createVisualElement: ne,
    Component: v
  };
}
function addDomEvent(v, y, z, ne = { passive: !0 }) {
  return v.addEventListener(y, z, ne), () => v.removeEventListener(y, z);
}
const isPrimaryPointer = (v) => v.pointerType === "mouse" ? typeof v.button != "number" || v.button <= 0 : v.isPrimary !== !1;
function extractEventInfo(v, y = "page") {
  return {
    point: {
      x: v[y + "X"],
      y: v[y + "Y"]
    }
  };
}
const addPointerInfo = (v) => (y) => isPrimaryPointer(y) && v(y, extractEventInfo(y));
function addPointerEvent(v, y, z, ne) {
  return addDomEvent(v, y, addPointerInfo(z), ne);
}
const combineFunctions = (v, y) => (z) => y(v(z)), pipe$1 = (...v) => v.reduce(combineFunctions);
function createLock(v) {
  let y = null;
  return () => {
    const z = () => {
      y = null;
    };
    return y === null ? (y = v, z) : !1;
  };
}
const globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(v) {
  let y = !1;
  if (v === "y")
    y = globalVerticalLock();
  else if (v === "x")
    y = globalHorizontalLock();
  else {
    const z = globalHorizontalLock(), ne = globalVerticalLock();
    z && ne ? y = () => {
      z(), ne();
    } : (z && z(), ne && ne());
  }
  return y;
}
function isDragActive() {
  const v = getGlobalLock(!0);
  return v ? (v(), !1) : !0;
}
class Feature {
  constructor(y) {
    this.isMounted = !1, this.node = y;
  }
  update() {
  }
}
function addHoverEvent(v, y) {
  const z = "pointer" + (y ? "enter" : "leave"), ne = "onHover" + (y ? "Start" : "End"), ue = (le, he) => {
    if (le.pointerType === "touch" || isDragActive())
      return;
    const ge = v.getProps();
    v.animationState && ge.whileHover && v.animationState.setActive("whileHover", y), ge[ne] && frame.update(() => ge[ne](le, he));
  };
  return addPointerEvent(v.current, z, ue, {
    passive: !v.getProps()[ne]
  });
}
class HoverGesture extends Feature {
  mount() {
    this.unmount = pipe$1(addHoverEvent(this.node, !0), addHoverEvent(this.node, !1));
  }
  unmount() {
  }
}
class FocusGesture extends Feature {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let y = !1;
    try {
      y = this.node.current.matches(":focus-visible");
    } catch {
      y = !0;
    }
    !y || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = pipe$1(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const isNodeOrChild = (v, y) => y ? v === y ? !0 : isNodeOrChild(v, y.parentElement) : !1;
function fireSyntheticPointerEvent(v, y) {
  if (!y)
    return;
  const z = new PointerEvent("pointer" + v);
  y(z, extractEventInfo(z));
}
class PressGesture extends Feature {
  constructor() {
    super(...arguments), this.removeStartListeners = noop$1, this.removeEndListeners = noop$1, this.removeAccessibleListeners = noop$1, this.startPointerPress = (y, z) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const ne = this.node.getProps(), le = addPointerEvent(window, "pointerup", (ge, we) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: Ee, onTapCancel: xe, globalTapTarget: $e } = this.node.getProps();
        frame.update(() => {
          !$e && !isNodeOrChild(this.node.current, ge.target) ? xe && xe(ge, we) : Ee && Ee(ge, we);
        });
      }, { passive: !(ne.onTap || ne.onPointerUp) }), he = addPointerEvent(window, "pointercancel", (ge, we) => this.cancelPress(ge, we), { passive: !(ne.onTapCancel || ne.onPointerCancel) });
      this.removeEndListeners = pipe$1(le, he), this.startPress(y, z);
    }, this.startAccessiblePress = () => {
      const y = (le) => {
        if (le.key !== "Enter" || this.isPressing)
          return;
        const he = (ge) => {
          ge.key !== "Enter" || !this.checkPressEnd() || fireSyntheticPointerEvent("up", (we, Ee) => {
            const { onTap: xe } = this.node.getProps();
            xe && frame.update(() => xe(we, Ee));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = addDomEvent(this.node.current, "keyup", he), fireSyntheticPointerEvent("down", (ge, we) => {
          this.startPress(ge, we);
        });
      }, z = addDomEvent(this.node.current, "keydown", y), ne = () => {
        this.isPressing && fireSyntheticPointerEvent("cancel", (le, he) => this.cancelPress(le, he));
      }, ue = addDomEvent(this.node.current, "blur", ne);
      this.removeAccessibleListeners = pipe$1(z, ue);
    };
  }
  startPress(y, z) {
    this.isPressing = !0;
    const { onTapStart: ne, whileTap: ue } = this.node.getProps();
    ue && this.node.animationState && this.node.animationState.setActive("whileTap", !0), ne && frame.update(() => ne(y, z));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !isDragActive();
  }
  cancelPress(y, z) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: ne } = this.node.getProps();
    ne && frame.update(() => ne(y, z));
  }
  mount() {
    const y = this.node.getProps(), z = addPointerEvent(y.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(y.onTapStart || y.onPointerStart) }), ne = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = pipe$1(z, ne);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = (v) => {
  const y = observerCallbacks.get(v.target);
  y && y(v);
}, fireAllObserverCallbacks = (v) => {
  v.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root: v, ...y }) {
  const z = v || document;
  observers.has(z) || observers.set(z, {});
  const ne = observers.get(z), ue = JSON.stringify(y);
  return ne[ue] || (ne[ue] = new IntersectionObserver(fireAllObserverCallbacks, { root: v, ...y })), ne[ue];
}
function observeIntersection(v, y, z) {
  const ne = initIntersectionObserver(y);
  return observerCallbacks.set(v, z), ne.observe(v), () => {
    observerCallbacks.delete(v), ne.unobserve(v);
  };
}
const thresholdNames = {
  some: 0,
  all: 1
};
class InViewFeature extends Feature {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: y = {} } = this.node.getProps(), { root: z, margin: ne, amount: ue = "some", once: le } = y, he = {
      root: z ? z.current : void 0,
      rootMargin: ne,
      threshold: typeof ue == "number" ? ue : thresholdNames[ue]
    }, ge = (we) => {
      const { isIntersecting: Ee } = we;
      if (this.isInView === Ee || (this.isInView = Ee, le && !Ee && this.hasEnteredView))
        return;
      Ee && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", Ee);
      const { onViewportEnter: xe, onViewportLeave: $e } = this.node.getProps(), Ne = Ee ? xe : $e;
      Ne && Ne(we);
    };
    return observeIntersection(this.node.current, he, ge);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: y, prevProps: z } = this.node;
    ["amount", "margin", "root"].some(hasViewportOptionChanged(y, z)) && this.startObserver();
  }
  unmount() {
  }
}
function hasViewportOptionChanged({ viewport: v = {} }, { viewport: y = {} } = {}) {
  return (z) => v[z] !== y[z];
}
const gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};
function shallowCompare(v, y) {
  if (!Array.isArray(y))
    return !1;
  const z = y.length;
  if (z !== v.length)
    return !1;
  for (let ne = 0; ne < z; ne++)
    if (y[ne] !== v[ne])
      return !1;
  return !0;
}
function getCurrent(v) {
  const y = {};
  return v.values.forEach((z, ne) => y[ne] = z.get()), y;
}
function getVelocity$1(v) {
  const y = {};
  return v.values.forEach((z, ne) => y[ne] = z.getVelocity()), y;
}
function resolveVariant(v, y, z) {
  const ne = v.getProps();
  return resolveVariantFromProps(ne, y, z !== void 0 ? z : ne.custom, getCurrent(v), getVelocity$1(v));
}
let warning = noop$1, invariant = noop$1;
process$1.env.NODE_ENV !== "production" && (warning = (v, y) => {
  !v && typeof console < "u" && console.warn(y);
}, invariant = (v, y) => {
  if (!v)
    throw new Error(y);
});
const secondsToMilliseconds = (v) => v * 1e3, millisecondsToSeconds = (v) => v / 1e3, instantAnimationState = {
  current: !1
}, isBezierDefinition = (v) => Array.isArray(v) && typeof v[0] == "number";
function isWaapiSupportedEasing(v) {
  return !!(!v || typeof v == "string" && supportedWaapiEasing[v] || isBezierDefinition(v) || Array.isArray(v) && v.every(isWaapiSupportedEasing));
}
const cubicBezierAsString = ([v, y, z, ne]) => `cubic-bezier(${v}, ${y}, ${z}, ${ne})`, supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(v) {
  if (v)
    return isBezierDefinition(v) ? cubicBezierAsString(v) : Array.isArray(v) ? v.map(mapEasingToNativeEasing) : supportedWaapiEasing[v];
}
function animateStyle(v, y, z, { delay: ne = 0, duration: ue, repeat: le = 0, repeatType: he = "loop", ease: ge, times: we } = {}) {
  const Ee = { [y]: z };
  we && (Ee.offset = we);
  const xe = mapEasingToNativeEasing(ge);
  return Array.isArray(xe) && (Ee.easing = xe), v.animate(Ee, {
    delay: ne,
    duration: ue,
    easing: Array.isArray(xe) ? "linear" : xe,
    fill: "both",
    iterations: le + 1,
    direction: he === "reverse" ? "alternate" : "normal"
  });
}
function getFinalKeyframe(v, { repeat: y, repeatType: z = "loop" }) {
  const ne = y && z !== "loop" && y % 2 === 1 ? 0 : v.length - 1;
  return v[ne];
}
const calcBezier = (v, y, z) => (((1 - 3 * z + 3 * y) * v + (3 * z - 6 * y)) * v + 3 * y) * v, subdivisionPrecision = 1e-7, subdivisionMaxIterations = 12;
function binarySubdivide(v, y, z, ne, ue) {
  let le, he, ge = 0;
  do
    he = y + (z - y) / 2, le = calcBezier(he, ne, ue) - v, le > 0 ? z = he : y = he;
  while (Math.abs(le) > subdivisionPrecision && ++ge < subdivisionMaxIterations);
  return he;
}
function cubicBezier(v, y, z, ne) {
  if (v === y && z === ne)
    return noop$1;
  const ue = (le) => binarySubdivide(le, 0, 1, v, z);
  return (le) => le === 0 || le === 1 ? le : calcBezier(ue(le), y, ne);
}
const easeIn = cubicBezier(0.42, 0, 1, 1), easeOut = cubicBezier(0, 0, 0.58, 1), easeInOut = cubicBezier(0.42, 0, 0.58, 1), isEasingArray = (v) => Array.isArray(v) && typeof v[0] != "number", mirrorEasing = (v) => (y) => y <= 0.5 ? v(2 * y) / 2 : (2 - v(2 * (1 - y))) / 2, reverseEasing = (v) => (y) => 1 - v(1 - y), circIn = (v) => 1 - Math.sin(Math.acos(v)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circIn), backOut = cubicBezier(0.33, 1.53, 0.69, 0.99), backIn = reverseEasing(backOut), backInOut = mirrorEasing(backIn), anticipate = (v) => (v *= 2) < 1 ? 0.5 * backIn(v) : 0.5 * (2 - Math.pow(2, -10 * (v - 1))), easingLookup = {
  linear: noop$1,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
}, easingDefinitionToFunction = (v) => {
  if (Array.isArray(v)) {
    invariant(v.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [y, z, ne, ue] = v;
    return cubicBezier(y, z, ne, ue);
  } else if (typeof v == "string")
    return invariant(easingLookup[v] !== void 0, `Invalid easing type '${v}'`), easingLookup[v];
  return v;
}, progress = (v, y, z) => {
  const ne = y - v;
  return ne === 0 ? 1 : (z - v) / ne;
}, mixNumber$1 = (v, y, z) => v + (y - v) * z;
function hueToRgb(v, y, z) {
  return z < 0 && (z += 1), z > 1 && (z -= 1), z < 1 / 6 ? v + (y - v) * 6 * z : z < 1 / 2 ? y : z < 2 / 3 ? v + (y - v) * (2 / 3 - z) * 6 : v;
}
function hslaToRgba({ hue: v, saturation: y, lightness: z, alpha: ne }) {
  v /= 360, y /= 100, z /= 100;
  let ue = 0, le = 0, he = 0;
  if (!y)
    ue = le = he = z;
  else {
    const ge = z < 0.5 ? z * (1 + y) : z + y - z * y, we = 2 * z - ge;
    ue = hueToRgb(we, ge, v + 1 / 3), le = hueToRgb(we, ge, v), he = hueToRgb(we, ge, v - 1 / 3);
  }
  return {
    red: Math.round(ue * 255),
    green: Math.round(le * 255),
    blue: Math.round(he * 255),
    alpha: ne
  };
}
const isColorString = (v, y) => (z) => !!(isString(z) && singleColorRegex.test(z) && z.startsWith(v) || y && Object.prototype.hasOwnProperty.call(z, y)), splitColor = (v, y, z) => (ne) => {
  if (!isString(ne))
    return ne;
  const [ue, le, he, ge] = ne.match(floatRegex);
  return {
    [v]: parseFloat(ue),
    [y]: parseFloat(le),
    [z]: parseFloat(he),
    alpha: ge !== void 0 ? parseFloat(ge) : 1
  };
}, clampRgbUnit = (v) => clamp(0, 255, v), rgbUnit = {
  ...number,
  transform: (v) => Math.round(clampRgbUnit(v))
}, rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red: v, green: y, blue: z, alpha: ne = 1 }) => "rgba(" + rgbUnit.transform(v) + ", " + rgbUnit.transform(y) + ", " + rgbUnit.transform(z) + ", " + sanitize(alpha.transform(ne)) + ")"
};
function parseHex(v) {
  let y = "", z = "", ne = "", ue = "";
  return v.length > 5 ? (y = v.substring(1, 3), z = v.substring(3, 5), ne = v.substring(5, 7), ue = v.substring(7, 9)) : (y = v.substring(1, 2), z = v.substring(2, 3), ne = v.substring(3, 4), ue = v.substring(4, 5), y += y, z += z, ne += ne, ue += ue), {
    red: parseInt(y, 16),
    green: parseInt(z, 16),
    blue: parseInt(ne, 16),
    alpha: ue ? parseInt(ue, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: v, saturation: y, lightness: z, alpha: ne = 1 }) => "hsla(" + Math.round(v) + ", " + percent.transform(sanitize(y)) + ", " + percent.transform(sanitize(z)) + ", " + sanitize(alpha.transform(ne)) + ")"
}, mixLinearColor = (v, y, z) => {
  const ne = v * v, ue = z * (y * y - ne) + ne;
  return ue < 0 ? 0 : Math.sqrt(ue);
}, colorTypes = [hex, rgba, hsla], getColorType = (v) => colorTypes.find((y) => y.test(v));
function asRGBA(v) {
  const y = getColorType(v);
  invariant(!!y, `'${v}' is not an animatable color. Use the equivalent color code instead.`);
  let z = y.parse(v);
  return y === hsla && (z = hslaToRgba(z)), z;
}
const mixColor = (v, y) => {
  const z = asRGBA(v), ne = asRGBA(y), ue = { ...z };
  return (le) => (ue.red = mixLinearColor(z.red, ne.red, le), ue.green = mixLinearColor(z.green, ne.green, le), ue.blue = mixLinearColor(z.blue, ne.blue, le), ue.alpha = mixNumber$1(z.alpha, ne.alpha, le), rgba.transform(ue));
}, color = {
  test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: (v) => rgba.test(v) ? rgba.parse(v) : hsla.test(v) ? hsla.parse(v) : hex.parse(v),
  transform: (v) => isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v)
};
function test(v) {
  var y, z;
  return isNaN(v) && isString(v) && (((y = v.match(floatRegex)) === null || y === void 0 ? void 0 : y.length) || 0) + (((z = v.match(colorRegex)) === null || z === void 0 ? void 0 : z.length) || 0) > 0;
}
const NUMBER_TOKEN = "number", COLOR_TOKEN = "color", VAR_TOKEN = "var", VAR_FUNCTION_TOKEN = "var(", SPLIT_TOKEN = "${}", complexRegex = /(var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\))|(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))|((-)?([\d]*\.?[\d])+)/gi;
function analyseComplexValue(v) {
  const y = v.toString(), z = y.match(complexRegex) || [], ne = [], ue = {
    color: [],
    number: [],
    var: []
  }, le = [];
  for (let we = 0; we < z.length; we++) {
    const Ee = z[we];
    color.test(Ee) ? (ue.color.push(we), le.push(COLOR_TOKEN), ne.push(color.parse(Ee))) : Ee.startsWith(VAR_FUNCTION_TOKEN) ? (ue.var.push(we), le.push(VAR_TOKEN), ne.push(Ee)) : (ue.number.push(we), le.push(NUMBER_TOKEN), ne.push(parseFloat(Ee)));
  }
  const ge = y.replace(complexRegex, SPLIT_TOKEN).split(SPLIT_TOKEN);
  return { values: ne, split: ge, indexes: ue, types: le };
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(v) {
  const { split: y, types: z } = analyseComplexValue(v), ne = y.length;
  return (ue) => {
    let le = "";
    for (let he = 0; he < ne; he++)
      if (le += y[he], ue[he] !== void 0) {
        const ge = z[he];
        ge === NUMBER_TOKEN ? le += sanitize(ue[he]) : ge === COLOR_TOKEN ? le += color.transform(ue[he]) : le += ue[he];
      }
    return le;
  };
}
const convertNumbersToZero = (v) => typeof v == "number" ? 0 : v;
function getAnimatableNone$1(v) {
  const y = parseComplexValue(v);
  return createTransformer(v)(y.map(convertNumbersToZero));
}
const complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1
};
function mixImmediate(v, y) {
  return (z) => z > 0 ? y : v;
}
function mixNumber(v, y) {
  return (z) => mixNumber$1(v, y, z);
}
function getMixer(v) {
  return typeof v == "number" ? mixNumber : typeof v == "string" ? isCSSVariableToken(v) ? mixImmediate : color.test(v) ? mixColor : mixComplex : Array.isArray(v) ? mixArray : typeof v == "object" ? color.test(v) ? mixColor : mixObject : mixImmediate;
}
function mixArray(v, y) {
  const z = [...v], ne = z.length, ue = v.map((le, he) => getMixer(le)(le, y[he]));
  return (le) => {
    for (let he = 0; he < ne; he++)
      z[he] = ue[he](le);
    return z;
  };
}
function mixObject(v, y) {
  const z = { ...v, ...y }, ne = {};
  for (const ue in z)
    v[ue] !== void 0 && y[ue] !== void 0 && (ne[ue] = getMixer(v[ue])(v[ue], y[ue]));
  return (ue) => {
    for (const le in ne)
      z[le] = ne[le](ue);
    return z;
  };
}
function matchOrder(v, y) {
  var z;
  const ne = [], ue = { color: 0, var: 0, number: 0 };
  for (let le = 0; le < y.values.length; le++) {
    const he = y.types[le], ge = v.indexes[he][ue[he]], we = (z = v.values[ge]) !== null && z !== void 0 ? z : 0;
    ne[le] = we, ue[he]++;
  }
  return ne;
}
const mixComplex = (v, y) => {
  const z = complex.createTransformer(y), ne = analyseComplexValue(v), ue = analyseComplexValue(y);
  return ne.indexes.var.length === ue.indexes.var.length && ne.indexes.color.length === ue.indexes.color.length && ne.indexes.number.length >= ue.indexes.number.length ? pipe$1(mixArray(matchOrder(ne, ue), ue.values), z) : (warning(!0, `Complex values '${v}' and '${y}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), mixImmediate(v, y));
};
function mix(v, y, z) {
  return typeof v == "number" && typeof y == "number" && typeof z == "number" ? mixNumber$1(v, y, z) : getMixer(v)(v, y);
}
function createMixers(v, y, z) {
  const ne = [], ue = z || mix, le = v.length - 1;
  for (let he = 0; he < le; he++) {
    let ge = ue(v[he], v[he + 1]);
    if (y) {
      const we = Array.isArray(y) ? y[he] || noop$1 : y;
      ge = pipe$1(we, ge);
    }
    ne.push(ge);
  }
  return ne;
}
function interpolate(v, y, { clamp: z = !0, ease: ne, mixer: ue } = {}) {
  const le = v.length;
  if (invariant(le === y.length, "Both input and output ranges must be the same length"), le === 1)
    return () => y[0];
  v[0] > v[le - 1] && (v = [...v].reverse(), y = [...y].reverse());
  const he = createMixers(y, ne, ue), ge = he.length, we = (Ee) => {
    let xe = 0;
    if (ge > 1)
      for (; xe < v.length - 2 && !(Ee < v[xe + 1]); xe++)
        ;
    const $e = progress(v[xe], v[xe + 1], Ee);
    return he[xe]($e);
  };
  return z ? (Ee) => we(clamp(v[0], v[le - 1], Ee)) : we;
}
function fillOffset(v, y) {
  const z = v[v.length - 1];
  for (let ne = 1; ne <= y; ne++) {
    const ue = progress(0, y, ne);
    v.push(mixNumber$1(z, 1, ue));
  }
}
function defaultOffset(v) {
  const y = [0];
  return fillOffset(y, v.length - 1), y;
}
function convertOffsetToTimes(v, y) {
  return v.map((z) => z * y);
}
function defaultEasing(v, y) {
  return v.map(() => y || easeInOut).splice(0, v.length - 1);
}
function keyframes({ duration: v = 300, keyframes: y, times: z, ease: ne = "easeInOut" }) {
  const ue = isEasingArray(ne) ? ne.map(easingDefinitionToFunction) : easingDefinitionToFunction(ne), le = {
    done: !1,
    value: y[0]
  }, he = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    z && z.length === y.length ? z : defaultOffset(y),
    v
  ), ge = interpolate(he, y, {
    ease: Array.isArray(ue) ? ue : defaultEasing(y, ue)
  });
  return {
    calculatedDuration: v,
    next: (we) => (le.value = ge(we), le.done = we >= v, le)
  };
}
function velocityPerSecond(v, y) {
  return y ? v * (1e3 / y) : 0;
}
const velocitySampleDuration = 5;
function calcGeneratorVelocity(v, y, z) {
  const ne = Math.max(y - velocitySampleDuration, 0);
  return velocityPerSecond(z - v(ne), y - ne);
}
const safeMin = 1e-3, minDuration = 0.01, maxDuration$1 = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration: v = 800, bounce: y = 0.25, velocity: z = 0, mass: ne = 1 }) {
  let ue, le;
  warning(v <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
  let he = 1 - y;
  he = clamp(minDamping, maxDamping, he), v = clamp(minDuration, maxDuration$1, millisecondsToSeconds(v)), he < 1 ? (ue = (Ee) => {
    const xe = Ee * he, $e = xe * v, Ne = xe - z, st = calcAngularFreq(Ee, he), Nr = Math.exp(-$e);
    return safeMin - Ne / st * Nr;
  }, le = (Ee) => {
    const $e = Ee * he * v, Ne = $e * z + z, st = Math.pow(he, 2) * Math.pow(Ee, 2) * v, Nr = Math.exp(-$e), br = calcAngularFreq(Math.pow(Ee, 2), he);
    return (-ue(Ee) + safeMin > 0 ? -1 : 1) * ((Ne - st) * Nr) / br;
  }) : (ue = (Ee) => {
    const xe = Math.exp(-Ee * v), $e = (Ee - z) * v + 1;
    return -safeMin + xe * $e;
  }, le = (Ee) => {
    const xe = Math.exp(-Ee * v), $e = (z - Ee) * (v * v);
    return xe * $e;
  });
  const ge = 5 / v, we = approximateRoot(ue, le, ge);
  if (v = secondsToMilliseconds(v), isNaN(we))
    return {
      stiffness: 100,
      damping: 10,
      duration: v
    };
  {
    const Ee = Math.pow(we, 2) * ne;
    return {
      stiffness: Ee,
      damping: he * 2 * Math.sqrt(ne * Ee),
      duration: v
    };
  }
}
const rootIterations = 12;
function approximateRoot(v, y, z) {
  let ne = z;
  for (let ue = 1; ue < rootIterations; ue++)
    ne = ne - v(ne) / y(ne);
  return ne;
}
function calcAngularFreq(v, y) {
  return v * Math.sqrt(1 - y * y);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(v, y) {
  return y.some((z) => v[z] !== void 0);
}
function getSpringOptions(v) {
  let y = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...v
  };
  if (!isSpringType(v, physicsKeys) && isSpringType(v, durationKeys)) {
    const z = findSpring(v);
    y = {
      ...y,
      ...z,
      mass: 1
    }, y.isResolvedFromDuration = !0;
  }
  return y;
}
function spring({ keyframes: v, restDelta: y, restSpeed: z, ...ne }) {
  const ue = v[0], le = v[v.length - 1], he = { done: !1, value: ue }, { stiffness: ge, damping: we, mass: Ee, duration: xe, velocity: $e, isResolvedFromDuration: Ne } = getSpringOptions({
    ...ne,
    velocity: -millisecondsToSeconds(ne.velocity || 0)
  }), st = $e || 0, Nr = we / (2 * Math.sqrt(ge * Ee)), br = le - ue, $n = millisecondsToSeconds(Math.sqrt(ge / Ee)), En = Math.abs(br) < 5;
  z || (z = En ? 0.01 : 2), y || (y = En ? 5e-3 : 0.5);
  let Rn;
  if (Nr < 1) {
    const wa = calcAngularFreq($n, Nr);
    Rn = (Aa) => {
      const _a = Math.exp(-Nr * $n * Aa);
      return le - _a * ((st + Nr * $n * br) / wa * Math.sin(wa * Aa) + br * Math.cos(wa * Aa));
    };
  } else if (Nr === 1)
    Rn = (wa) => le - Math.exp(-$n * wa) * (br + (st + $n * br) * wa);
  else {
    const wa = $n * Math.sqrt(Nr * Nr - 1);
    Rn = (Aa) => {
      const _a = Math.exp(-Nr * $n * Aa), Ta = Math.min(wa * Aa, 300);
      return le - _a * ((st + Nr * $n * br) * Math.sinh(Ta) + wa * br * Math.cosh(Ta)) / wa;
    };
  }
  return {
    calculatedDuration: Ne && xe || null,
    next: (wa) => {
      const Aa = Rn(wa);
      if (Ne)
        he.done = wa >= xe;
      else {
        let _a = st;
        wa !== 0 && (Nr < 1 ? _a = calcGeneratorVelocity(Rn, wa, Aa) : _a = 0);
        const Ta = Math.abs(_a) <= z, Zn = Math.abs(le - Aa) <= y;
        he.done = Ta && Zn;
      }
      return he.value = he.done ? le : Aa, he;
    }
  };
}
function inertia({ keyframes: v, velocity: y = 0, power: z = 0.8, timeConstant: ne = 325, bounceDamping: ue = 10, bounceStiffness: le = 500, modifyTarget: he, min: ge, max: we, restDelta: Ee = 0.5, restSpeed: xe }) {
  const $e = v[0], Ne = {
    done: !1,
    value: $e
  }, st = (Ra) => ge !== void 0 && Ra < ge || we !== void 0 && Ra > we, Nr = (Ra) => ge === void 0 ? we : we === void 0 || Math.abs(ge - Ra) < Math.abs(we - Ra) ? ge : we;
  let br = z * y;
  const $n = $e + br, En = he === void 0 ? $n : he($n);
  En !== $n && (br = En - $e);
  const Rn = (Ra) => -br * Math.exp(-Ra / ne), wa = (Ra) => En + Rn(Ra), Aa = (Ra) => {
    const Yn = Rn(Ra), $o = wa(Ra);
    Ne.done = Math.abs(Yn) <= Ee, Ne.value = Ne.done ? En : $o;
  };
  let _a, Ta;
  const Zn = (Ra) => {
    st(Ne.value) && (_a = Ra, Ta = spring({
      keyframes: [Ne.value, Nr(Ne.value)],
      velocity: calcGeneratorVelocity(wa, Ra, Ne.value),
      damping: ue,
      stiffness: le,
      restDelta: Ee,
      restSpeed: xe
    }));
  };
  return Zn(0), {
    calculatedDuration: null,
    next: (Ra) => {
      let Yn = !1;
      return !Ta && _a === void 0 && (Yn = !0, Aa(Ra), Zn(Ra)), _a !== void 0 && Ra > _a ? Ta.next(Ra - _a) : (!Yn && Aa(Ra), Ne);
    }
  };
}
let now;
function clearTime() {
  now = void 0;
}
const time$1 = {
  now: () => (now === void 0 && time$1.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now()), now),
  set: (v) => {
    now = v, queueMicrotask(clearTime);
  }
}, frameloopDriver = (v) => {
  const y = ({ timestamp: z }) => v(z);
  return {
    start: () => frame.update(y, !0),
    stop: () => cancelFrame(y),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time$1.now()
  };
}, maxGeneratorDuration = 2e4;
function calcGeneratorDuration(v) {
  let y = 0;
  const z = 50;
  let ne = v.next(y);
  for (; !ne.done && y < maxGeneratorDuration; )
    y += z, ne = v.next(y);
  return y >= maxGeneratorDuration ? 1 / 0 : y;
}
const types$1 = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
}, percentToProgress = (v) => v / 100;
function animateValue({ autoplay: v = !0, delay: y = 0, driver: z = frameloopDriver, keyframes: ne, type: ue = "keyframes", repeat: le = 0, repeatDelay: he = 0, repeatType: ge = "loop", onPlay: we, onStop: Ee, onComplete: xe, onUpdate: $e, ...Ne }) {
  let st = 1, Nr = !1, br, $n;
  const En = () => {
    $n = new Promise((it) => {
      br = it;
    });
  };
  En();
  let Rn;
  const wa = types$1[ue] || keyframes;
  let Aa;
  wa !== keyframes && typeof ne[0] != "number" && (process$1.env.NODE_ENV !== "production" && invariant(ne.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${ne}`), Aa = pipe$1(percentToProgress, mix(ne[0], ne[1])), ne = [0, 100]);
  const _a = wa({ ...Ne, keyframes: ne });
  let Ta;
  ge === "mirror" && (Ta = wa({
    ...Ne,
    keyframes: [...ne].reverse(),
    velocity: -(Ne.velocity || 0)
  }));
  let Zn = "idle", Ra = null, Yn = null, $o = null;
  _a.calculatedDuration === null && le && (_a.calculatedDuration = calcGeneratorDuration(_a));
  const { calculatedDuration: ct } = _a;
  let fe = 1 / 0, be = 1 / 0;
  ct !== null && (fe = ct + he, be = fe * (le + 1) - he);
  let ye = 0;
  const Se = (it) => {
    if (Yn === null)
      return;
    st > 0 && (Yn = Math.min(Yn, it)), st < 0 && (Yn = Math.min(it - be / st, Yn)), Ra !== null ? ye = Ra : ye = Math.round(it - Yn) * st;
    const xa = ye - y * (st >= 0 ? 1 : -1), wo = st >= 0 ? xa < 0 : xa > be;
    ye = Math.max(xa, 0), Zn === "finished" && Ra === null && (ye = be);
    let _u = ye, Oa = _a;
    if (le) {
      const Su = Math.min(ye, be) / fe;
      let Tu = Math.floor(Su), Au = Su % 1;
      !Au && Su >= 1 && (Au = 1), Au === 1 && Tu--, Tu = Math.min(Tu, le + 1), !!(Tu % 2) && (ge === "reverse" ? (Au = 1 - Au, he && (Au -= he / fe)) : ge === "mirror" && (Oa = Ta)), _u = clamp(0, 1, Au) * fe;
    }
    const Os = wo ? { done: !1, value: ne[0] } : Oa.next(_u);
    Aa && (Os.value = Aa(Os.value));
    let { done: Pa } = Os;
    !wo && ct !== null && (Pa = st >= 0 ? ye >= be : ye <= 0);
    const Ml = Ra === null && (Zn === "finished" || Zn === "running" && Pa);
    return $e && $e(Os.value), Ml && zn(), Os;
  }, Oe = () => {
    Rn && Rn.stop(), Rn = void 0;
  }, Fr = () => {
    Zn = "idle", Oe(), br(), En(), Yn = $o = null;
  }, zn = () => {
    Zn = "finished", xe && xe(), Oe(), br();
  }, Fe = () => {
    if (Nr)
      return;
    Rn || (Rn = z(Se));
    const it = Rn.now();
    we && we(), Ra !== null ? Yn = it - Ra : (!Yn || Zn === "finished") && (Yn = it), Zn === "finished" && En(), $o = Yn, Ra = null, Zn = "running", Rn.start();
  };
  v && Fe();
  const pe = {
    then(it, xa) {
      return $n.then(it, xa);
    },
    get time() {
      return millisecondsToSeconds(ye);
    },
    set time(it) {
      it = secondsToMilliseconds(it), ye = it, Ra !== null || !Rn || st === 0 ? Ra = it : Yn = Rn.now() - it / st;
    },
    get duration() {
      const it = _a.calculatedDuration === null ? calcGeneratorDuration(_a) : _a.calculatedDuration;
      return millisecondsToSeconds(it);
    },
    get speed() {
      return st;
    },
    set speed(it) {
      it === st || !Rn || (st = it, pe.time = millisecondsToSeconds(ye));
    },
    get state() {
      return Zn;
    },
    play: Fe,
    pause: () => {
      Zn = "paused", Ra = ye;
    },
    stop: () => {
      Nr = !0, Zn !== "idle" && (Zn = "idle", Ee && Ee(), Fr());
    },
    cancel: () => {
      $o !== null && Se($o), Fr();
    },
    complete: () => {
      Zn = "finished";
    },
    sample: (it) => (Yn = 0, Se(it))
  };
  return pe;
}
function memo(v) {
  let y;
  return () => (y === void 0 && (y = v()), y);
}
const supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate")), acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
]), sampleDelta = 10, maxDuration = 2e4, requiresPregeneratedKeyframes = (v, y) => y.type === "spring" || v === "backgroundColor" || !isWaapiSupportedEasing(y.ease);
function createAcceleratedAnimation(v, y, { onUpdate: z, onComplete: ne, ...ue }) {
  if (!(supportsWaapi() && acceleratedValues.has(y) && !ue.repeatDelay && ue.repeatType !== "mirror" && ue.damping !== 0 && ue.type !== "inertia"))
    return !1;
  let he = !1, ge, we, Ee = !1;
  const xe = () => {
    we = new Promise((wa) => {
      ge = wa;
    });
  };
  xe();
  let { keyframes: $e, duration: Ne = 300, ease: st, times: Nr } = ue;
  if (requiresPregeneratedKeyframes(y, ue)) {
    const wa = animateValue({
      ...ue,
      repeat: 0,
      delay: 0
    });
    let Aa = { done: !1, value: $e[0] };
    const _a = [];
    let Ta = 0;
    for (; !Aa.done && Ta < maxDuration; )
      Aa = wa.sample(Ta), _a.push(Aa.value), Ta += sampleDelta;
    Nr = void 0, $e = _a, Ne = Ta - sampleDelta, st = "linear";
  }
  const br = animateStyle(v.owner.current, y, $e, {
    ...ue,
    duration: Ne,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: st,
    times: Nr
  }), $n = () => {
    Ee = !1, br.cancel();
  }, En = () => {
    Ee = !0, frame.update($n), ge(), xe();
  };
  return br.onfinish = () => {
    Ee || (v.set(getFinalKeyframe($e, ue)), ne && ne(), En());
  }, {
    then(wa, Aa) {
      return we.then(wa, Aa);
    },
    attachTimeline(wa) {
      return br.timeline = wa, br.onfinish = null, noop$1;
    },
    get time() {
      return millisecondsToSeconds(br.currentTime || 0);
    },
    set time(wa) {
      br.currentTime = secondsToMilliseconds(wa);
    },
    get speed() {
      return br.playbackRate;
    },
    set speed(wa) {
      br.playbackRate = wa;
    },
    get duration() {
      return millisecondsToSeconds(Ne);
    },
    play: () => {
      he || (br.play(), cancelFrame($n));
    },
    pause: () => br.pause(),
    stop: () => {
      if (he = !0, br.playState === "idle")
        return;
      const { currentTime: wa } = br;
      if (wa) {
        const Aa = animateValue({
          ...ue,
          autoplay: !1
        });
        v.setWithVelocity(Aa.sample(wa - sampleDelta).value, Aa.sample(wa).value, sampleDelta);
      }
      En();
    },
    complete: () => {
      Ee || br.finish();
    },
    cancel: En
  };
}
function createInstantAnimation({ keyframes: v, delay: y, onUpdate: z, onComplete: ne }) {
  const ue = () => (z && z(v[v.length - 1]), ne && ne(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: noop$1,
    pause: noop$1,
    stop: noop$1,
    then: (le) => (le(), Promise.resolve()),
    cancel: noop$1,
    complete: noop$1
  });
  return y ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: y,
    onComplete: ue
  }) : ue();
}
const underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, criticallyDampedSpring = (v) => ({
  type: "spring",
  stiffness: 550,
  damping: v === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), keyframesTransition = {
  type: "keyframes",
  duration: 0.8
}, ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, getDefaultTransition = (v, { keyframes: y }) => y.length > 2 ? keyframesTransition : transformProps.has(v) ? v.startsWith("scale") ? criticallyDampedSpring(y[1]) : underDampedSpring : ease, isAnimatable = (v, y) => v === "zIndex" ? !1 : !!(typeof y == "number" || Array.isArray(y) || typeof y == "string" && // It's animatable if we have a string
(complex.test(y) || y === "0") && // And it contains numbers and/or colors
!y.startsWith("url(")), maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [y, z] = v.slice(0, -1).split("(");
  if (y === "drop-shadow")
    return v;
  const [ne] = z.match(floatRegex) || [];
  if (!ne)
    return v;
  const ue = z.replace(ne, "");
  let le = maxDefaults.has(y) ? 1 : 0;
  return ne !== z && (le *= 100), y + "(" + le + ue + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g, filter$1 = {
  ...complex,
  getAnimatableNone: (v) => {
    const y = v.match(functionRegex);
    return y ? y.map(applyDefaultFilter).join(" ") : v;
  }
}, defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter: filter$1,
  WebkitFilter: filter$1
}, getDefaultValueType = (v) => defaultValueTypes[v];
function getAnimatableNone(v, y) {
  let z = getDefaultValueType(v);
  return z !== filter$1 && (z = complex), z.getAnimatableNone ? z.getAnimatableNone(y) : void 0;
}
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);
function isNone(v) {
  if (typeof v == "number")
    return v === 0;
  if (v !== null)
    return v === "none" || v === "0" || isZeroValueString(v);
}
function getKeyframes(v, y, z, ne) {
  const ue = isAnimatable(y, z);
  let le;
  Array.isArray(z) ? le = [...z] : le = [null, z];
  const he = ne.from !== void 0 ? ne.from : v.get();
  let ge;
  const we = [];
  for (let Ee = 0; Ee < le.length; Ee++)
    le[Ee] === null && (le[Ee] = Ee === 0 ? he : le[Ee - 1]), isNone(le[Ee]) && we.push(Ee), typeof le[Ee] == "string" && le[Ee] !== "none" && le[Ee] !== "0" && (ge = le[Ee]);
  if (ue && we.length && ge)
    for (let Ee = 0; Ee < we.length; Ee++) {
      const xe = we[Ee];
      le[xe] = getAnimatableNone(y, ge);
    }
  return le;
}
function isTransitionDefined({ when: v, delay: y, delayChildren: z, staggerChildren: ne, staggerDirection: ue, repeat: le, repeatType: he, repeatDelay: ge, from: we, elapsed: Ee, ...xe }) {
  return !!Object.keys(xe).length;
}
function getValueTransition(v, y) {
  return v[y] || v.default || v;
}
const animateMotionValue = (v, y, z, ne = {}) => (ue) => {
  const le = getValueTransition(ne, v) || {}, he = le.delay || ne.delay || 0;
  let { elapsed: ge = 0 } = ne;
  ge = ge - secondsToMilliseconds(he);
  const we = getKeyframes(y, v, z, le), Ee = we[0], xe = we[we.length - 1], $e = isAnimatable(v, Ee), Ne = isAnimatable(v, xe);
  warning($e === Ne, `You are trying to animate ${v} from "${Ee}" to "${xe}". ${Ee} is not an animatable value - to enable this animation set ${Ee} to a value animatable to ${xe} via the \`style\` property.`);
  let st = {
    keyframes: we,
    velocity: y.getVelocity(),
    ease: "easeOut",
    ...le,
    delay: -ge,
    onUpdate: (Nr) => {
      y.set(Nr), le.onUpdate && le.onUpdate(Nr);
    },
    onComplete: () => {
      ue(), le.onComplete && le.onComplete();
    }
  };
  if (isTransitionDefined(le) || (st = {
    ...st,
    ...getDefaultTransition(v, st)
  }), st.duration && (st.duration = secondsToMilliseconds(st.duration)), st.repeatDelay && (st.repeatDelay = secondsToMilliseconds(st.repeatDelay)), !$e || !Ne || instantAnimationState.current || le.type === !1 || MotionGlobalConfig.skipAnimations)
    return createInstantAnimation(st);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !ne.isHandoff && y.owner && y.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !y.owner.getProps().onUpdate
  ) {
    const Nr = createAcceleratedAnimation(y, v, st);
    if (Nr)
      return Nr;
  }
  return animateValue(st);
};
function isWillChangeMotionValue(v) {
  return !!(isMotionValue(v) && v.add);
}
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);
function addUniqueItem(v, y) {
  v.indexOf(y) === -1 && v.push(y);
}
function removeItem(v, y) {
  const z = v.indexOf(y);
  z > -1 && v.splice(z, 1);
}
class SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(y) {
    return addUniqueItem(this.subscriptions, y), () => removeItem(this.subscriptions, y);
  }
  notify(y, z, ne) {
    const ue = this.subscriptions.length;
    if (ue)
      if (ue === 1)
        this.subscriptions[0](y, z, ne);
      else
        for (let le = 0; le < ue; le++) {
          const he = this.subscriptions[le];
          he && he(y, z, ne);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const warned = /* @__PURE__ */ new Set();
function warnOnce(v, y, z) {
  v || warned.has(y) || (console.warn(y), z && console.warn(z), warned.add(y));
}
const MAX_VELOCITY_DELTA = 30, isFloat = (v) => !isNaN(parseFloat(v));
class MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(y, z = {}) {
    this.version = "11.0.8", this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (ne, ue = !0) => {
      const le = time$1.now();
      this.updatedAt !== le && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(ne), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), ue && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(y), this.canTrackVelocity = isFloat(this.current), this.owner = z.owner;
  }
  setCurrent(y) {
    this.current = y, this.updatedAt = time$1.now();
  }
  setPrevFrameValue(y = this.current) {
    this.prevFrameValue = y, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(y) {
    return process$1.env.NODE_ENV !== "production" && warnOnce(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", y);
  }
  on(y, z) {
    this.events[y] || (this.events[y] = new SubscriptionManager());
    const ne = this.events[y].add(z);
    return y === "change" ? () => {
      ne(), frame.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : ne;
  }
  clearListeners() {
    for (const y in this.events)
      this.events[y].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(y, z) {
    this.passiveEffect = y, this.stopPassiveEffect = z;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(y, z = !0) {
    !z || !this.passiveEffect ? this.updateAndNotify(y, z) : this.passiveEffect(y, this.updateAndNotify);
  }
  setWithVelocity(y, z, ne) {
    this.set(z), this.prev = void 0, this.prevFrameValue = y, this.prevUpdatedAt = this.updatedAt - ne;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(y) {
    this.updateAndNotify(y), this.prev = y, this.prevUpdatedAt = this.prevFrameValue = void 0, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const y = time$1.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || y - this.updatedAt > MAX_VELOCITY_DELTA)
      return 0;
    const z = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), z);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(y) {
    return this.stop(), new Promise((z) => {
      this.hasAnimated = !0, this.animation = y(z), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function motionValue(v, y) {
  return new MotionValue(v, y);
}
const testValueType = (v) => (y) => y.test(v), auto = {
  test: (v) => v === "auto",
  parse: (v) => v
}, dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto], findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v)), valueTypes = [...dimensionValueTypes, color, complex], findValueType = (v) => valueTypes.find(testValueType(v));
function setMotionValue(v, y, z) {
  v.hasValue(y) ? v.getValue(y).set(z) : v.addValue(y, motionValue(z));
}
function setTarget(v, y) {
  const z = resolveVariant(v, y);
  let { transitionEnd: ne = {}, transition: ue = {}, ...le } = z ? v.makeTargetAnimatable(z, !1) : {};
  le = { ...le, ...ne };
  for (const he in le) {
    const ge = resolveFinalValueInKeyframes(le[he]);
    setMotionValue(v, he, ge);
  }
}
function checkTargetForNewValues(v, y, z) {
  var ne, ue;
  const le = Object.keys(y).filter((ge) => !v.hasValue(ge)), he = le.length;
  if (he)
    for (let ge = 0; ge < he; ge++) {
      const we = le[ge], Ee = y[we];
      let xe = null;
      Array.isArray(Ee) && (xe = Ee[0]), xe === null && (xe = (ue = (ne = z[we]) !== null && ne !== void 0 ? ne : v.readValue(we)) !== null && ue !== void 0 ? ue : y[we]), xe != null && (typeof xe == "string" && (isNumericalString(xe) || isZeroValueString(xe)) ? xe = parseFloat(xe) : !findValueType(xe) && complex.test(Ee) && (xe = getAnimatableNone(we, Ee)), v.addValue(we, motionValue(xe, { owner: v })), z[we] === void 0 && (z[we] = xe), xe !== null && v.setBaseTarget(we, xe));
    }
}
function getOriginFromTransition(v, y) {
  return y ? (y[v] || y.default || y).from : void 0;
}
function getOrigin(v, y, z) {
  const ne = {};
  for (const ue in v) {
    const le = getOriginFromTransition(ue, y);
    if (le !== void 0)
      ne[ue] = le;
    else {
      const he = z.getValue(ue);
      he && (ne[ue] = he.get());
    }
  }
  return ne;
}
function shouldBlockAnimation({ protectedKeys: v, needsAnimating: y }, z) {
  const ne = v.hasOwnProperty(z) && y[z] !== !0;
  return y[z] = !1, ne;
}
function hasKeyframesChanged(v, y) {
  const z = v.get();
  if (Array.isArray(y)) {
    for (let ne = 0; ne < y.length; ne++)
      if (y[ne] !== z)
        return !0;
  } else
    return z !== y;
}
function animateTarget(v, y, { delay: z = 0, transitionOverride: ne, type: ue } = {}) {
  let { transition: le = v.getDefaultTransition(), transitionEnd: he, ...ge } = v.makeTargetAnimatable(y);
  const we = v.getValue("willChange");
  ne && (le = ne);
  const Ee = [], xe = ue && v.animationState && v.animationState.getState()[ue];
  for (const $e in ge) {
    const Ne = v.getValue($e), st = ge[$e];
    if (!Ne || st === void 0 || xe && shouldBlockAnimation(xe, $e))
      continue;
    const Nr = {
      delay: z,
      elapsed: 0,
      ...getValueTransition(le || {}, $e)
    };
    if (window.HandoffAppearAnimations) {
      const En = v.getProps()[optimizedAppearDataAttribute];
      if (En) {
        const Rn = window.HandoffAppearAnimations(En, $e, Ne, frame);
        Rn !== null && (Nr.elapsed = Rn, Nr.isHandoff = !0);
      }
    }
    let br = !Nr.isHandoff && !hasKeyframesChanged(Ne, st);
    if (Nr.type === "spring" && (Ne.getVelocity() || Nr.velocity) && (br = !1), Ne.animation && (br = !1), br)
      continue;
    Ne.start(animateMotionValue($e, Ne, st, v.shouldReduceMotion && transformProps.has($e) ? { type: !1 } : Nr));
    const $n = Ne.animation;
    isWillChangeMotionValue(we) && (we.add($e), $n.then(() => we.remove($e))), Ee.push($n);
  }
  return he && Promise.all(Ee).then(() => {
    he && setTarget(v, he);
  }), Ee;
}
function animateVariant(v, y, z = {}) {
  const ne = resolveVariant(v, y, z.custom);
  let { transition: ue = v.getDefaultTransition() || {} } = ne || {};
  z.transitionOverride && (ue = z.transitionOverride);
  const le = ne ? () => Promise.all(animateTarget(v, ne, z)) : () => Promise.resolve(), he = v.variantChildren && v.variantChildren.size ? (we = 0) => {
    const { delayChildren: Ee = 0, staggerChildren: xe, staggerDirection: $e } = ue;
    return animateChildren(v, y, Ee + we, xe, $e, z);
  } : () => Promise.resolve(), { when: ge } = ue;
  if (ge) {
    const [we, Ee] = ge === "beforeChildren" ? [le, he] : [he, le];
    return we().then(() => Ee());
  } else
    return Promise.all([le(), he(z.delay)]);
}
function animateChildren(v, y, z = 0, ne = 0, ue = 1, le) {
  const he = [], ge = (v.variantChildren.size - 1) * ne, we = ue === 1 ? (Ee = 0) => Ee * ne : (Ee = 0) => ge - Ee * ne;
  return Array.from(v.variantChildren).sort(sortByTreeOrder).forEach((Ee, xe) => {
    Ee.notify("AnimationStart", y), he.push(animateVariant(Ee, y, {
      ...le,
      delay: z + we(xe)
    }).then(() => Ee.notify("AnimationComplete", y)));
  }), Promise.all(he);
}
function sortByTreeOrder(v, y) {
  return v.sortNodePosition(y);
}
function animateVisualElement(v, y, z = {}) {
  v.notify("AnimationStart", y);
  let ne;
  if (Array.isArray(y)) {
    const ue = y.map((le) => animateVariant(v, le, z));
    ne = Promise.all(ue);
  } else if (typeof y == "string")
    ne = animateVariant(v, y, z);
  else {
    const ue = typeof y == "function" ? resolveVariant(v, y, z.custom) : y;
    ne = Promise.all(animateTarget(v, ue, z));
  }
  return ne.then(() => v.notify("AnimationComplete", y));
}
const reversePriorityOrder = [...variantPriorityOrder].reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(v) {
  return (y) => Promise.all(y.map(({ animation: z, options: ne }) => animateVisualElement(v, z, ne)));
}
function createAnimationState(v) {
  let y = animateList(v);
  const z = createState();
  let ne = !0;
  const ue = (we, Ee) => {
    const xe = resolveVariant(v, Ee);
    if (xe) {
      const { transition: $e, transitionEnd: Ne, ...st } = xe;
      we = { ...we, ...st, ...Ne };
    }
    return we;
  };
  function le(we) {
    y = we(v);
  }
  function he(we, Ee) {
    const xe = v.getProps(), $e = v.getVariantContext(!0) || {}, Ne = [], st = /* @__PURE__ */ new Set();
    let Nr = {}, br = 1 / 0;
    for (let En = 0; En < numAnimationTypes; En++) {
      const Rn = reversePriorityOrder[En], wa = z[Rn], Aa = xe[Rn] !== void 0 ? xe[Rn] : $e[Rn], _a = isVariantLabel(Aa), Ta = Rn === Ee ? wa.isActive : null;
      Ta === !1 && (br = En);
      let Zn = Aa === $e[Rn] && Aa !== xe[Rn] && _a;
      if (Zn && ne && v.manuallyAnimateOnMount && (Zn = !1), wa.protectedKeys = { ...Nr }, // If it isn't active and hasn't *just* been set as inactive
      !wa.isActive && Ta === null || // If we didn't and don't have any defined prop for this animation type
      !Aa && !wa.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(Aa) || typeof Aa == "boolean")
        continue;
      let Yn = checkVariantsDidChange(wa.prevProp, Aa) || // If we're making this variant active, we want to always make it active
      Rn === Ee && wa.isActive && !Zn && _a || // If we removed a higher-priority variant (i is in reverse order)
      En > br && _a, $o = !1;
      const ct = Array.isArray(Aa) ? Aa : [Aa];
      let fe = ct.reduce(ue, {});
      Ta === !1 && (fe = {});
      const { prevResolvedValues: be = {} } = wa, ye = {
        ...be,
        ...fe
      }, Se = (Oe) => {
        Yn = !0, st.has(Oe) && ($o = !0, st.delete(Oe)), wa.needsAnimating[Oe] = !0;
      };
      for (const Oe in ye) {
        const Fr = fe[Oe], zn = be[Oe];
        if (Nr.hasOwnProperty(Oe))
          continue;
        let Fe = !1;
        isKeyframesTarget(Fr) && isKeyframesTarget(zn) ? Fe = !shallowCompare(Fr, zn) : Fe = Fr !== zn, Fe ? Fr !== void 0 ? Se(Oe) : st.add(Oe) : Fr !== void 0 && st.has(Oe) ? Se(Oe) : wa.protectedKeys[Oe] = !0;
      }
      wa.prevProp = Aa, wa.prevResolvedValues = fe, wa.isActive && (Nr = { ...Nr, ...fe }), ne && v.blockInitialAnimation && (Yn = !1), Yn && (!Zn || $o) && Ne.push(...ct.map((Oe) => ({
        animation: Oe,
        options: { type: Rn, ...we }
      })));
    }
    if (st.size) {
      const En = {};
      st.forEach((Rn) => {
        const wa = v.getBaseTarget(Rn);
        wa !== void 0 && (En[Rn] = wa);
      }), Ne.push({ animation: En });
    }
    let $n = !!Ne.length;
    return ne && (xe.initial === !1 || xe.initial === xe.animate) && !v.manuallyAnimateOnMount && ($n = !1), ne = !1, $n ? y(Ne) : Promise.resolve();
  }
  function ge(we, Ee, xe) {
    var $e;
    if (z[we].isActive === Ee)
      return Promise.resolve();
    ($e = v.variantChildren) === null || $e === void 0 || $e.forEach((st) => {
      var Nr;
      return (Nr = st.animationState) === null || Nr === void 0 ? void 0 : Nr.setActive(we, Ee);
    }), z[we].isActive = Ee;
    const Ne = he(xe, we);
    for (const st in z)
      z[st].protectedKeys = {};
    return Ne;
  }
  return {
    animateChanges: he,
    setActive: ge,
    setAnimateFunction: le,
    getState: () => z
  };
}
function checkVariantsDidChange(v, y) {
  return typeof y == "string" ? y !== v : Array.isArray(y) ? !shallowCompare(y, v) : !1;
}
function createTypeState(v = !1) {
  return {
    isActive: v,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(!0),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}
class AnimationFeature extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(y) {
    super(y), y.animationState || (y.animationState = createAnimationState(y));
  }
  updateAnimationControlsSubscription() {
    const { animate: y } = this.node.getProps();
    this.unmount(), isAnimationControls(y) && (this.unmount = y.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: y } = this.node.getProps(), { animate: z } = this.node.prevProps || {};
    y !== z && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let id$2 = 0;
class ExitAnimationFeature extends Feature {
  constructor() {
    super(...arguments), this.id = id$2++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: y, onExitComplete: z, custom: ne } = this.node.presenceContext, { isPresent: ue } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || y === ue)
      return;
    const le = this.node.animationState.setActive("exit", !y, { custom: ne ?? this.node.getProps().custom });
    z && !y && le.then(() => z(this.id));
  }
  mount() {
    const { register: y } = this.node.presenceContext || {};
    y && (this.unmount = y(this.id));
  }
  unmount() {
  }
}
const animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
}, distance = (v, y) => Math.abs(v - y);
function distance2D(v, y) {
  const z = distance(v.x, y.x), ne = distance(v.y, y.y);
  return Math.sqrt(z ** 2 + ne ** 2);
}
class PanSession {
  constructor(y, z, { transformPagePoint: ne, contextWindow: ue, dragSnapToOrigin: le = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const $e = getPanInfo(this.lastMoveEventInfo, this.history), Ne = this.startEvent !== null, st = distance2D($e.offset, { x: 0, y: 0 }) >= 3;
      if (!Ne && !st)
        return;
      const { point: Nr } = $e, { timestamp: br } = frameData;
      this.history.push({ ...Nr, timestamp: br });
      const { onStart: $n, onMove: En } = this.handlers;
      Ne || ($n && $n(this.lastMoveEvent, $e), this.startEvent = this.lastMoveEvent), En && En(this.lastMoveEvent, $e);
    }, this.handlePointerMove = ($e, Ne) => {
      this.lastMoveEvent = $e, this.lastMoveEventInfo = transformPoint(Ne, this.transformPagePoint), frame.update(this.updatePoint, !0);
    }, this.handlePointerUp = ($e, Ne) => {
      this.end();
      const { onEnd: st, onSessionEnd: Nr, resumeAnimation: br } = this.handlers;
      if (this.dragSnapToOrigin && br && br(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const $n = getPanInfo($e.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(Ne, this.transformPagePoint), this.history);
      this.startEvent && st && st($e, $n), Nr && Nr($e, $n);
    }, !isPrimaryPointer(y))
      return;
    this.dragSnapToOrigin = le, this.handlers = z, this.transformPagePoint = ne, this.contextWindow = ue || window;
    const he = extractEventInfo(y), ge = transformPoint(he, this.transformPagePoint), { point: we } = ge, { timestamp: Ee } = frameData;
    this.history = [{ ...we, timestamp: Ee }];
    const { onSessionStart: xe } = z;
    xe && xe(y, getPanInfo(ge, this.history)), this.removeListeners = pipe$1(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(y) {
    this.handlers = y;
  }
  end() {
    this.removeListeners && this.removeListeners(), cancelFrame(this.updatePoint);
  }
}
function transformPoint(v, y) {
  return y ? { point: y(v.point) } : v;
}
function subtractPoint(v, y) {
  return { x: v.x - y.x, y: v.y - y.y };
}
function getPanInfo({ point: v }, y) {
  return {
    point: v,
    delta: subtractPoint(v, lastDevicePoint(y)),
    offset: subtractPoint(v, startDevicePoint(y)),
    velocity: getVelocity(y, 0.1)
  };
}
function startDevicePoint(v) {
  return v[0];
}
function lastDevicePoint(v) {
  return v[v.length - 1];
}
function getVelocity(v, y) {
  if (v.length < 2)
    return { x: 0, y: 0 };
  let z = v.length - 1, ne = null;
  const ue = lastDevicePoint(v);
  for (; z >= 0 && (ne = v[z], !(ue.timestamp - ne.timestamp > secondsToMilliseconds(y))); )
    z--;
  if (!ne)
    return { x: 0, y: 0 };
  const le = millisecondsToSeconds(ue.timestamp - ne.timestamp);
  if (le === 0)
    return { x: 0, y: 0 };
  const he = {
    x: (ue.x - ne.x) / le,
    y: (ue.y - ne.y) / le
  };
  return he.x === 1 / 0 && (he.x = 0), he.y === 1 / 0 && (he.y = 0), he;
}
function calcLength(v) {
  return v.max - v.min;
}
function isNear(v, y = 0, z = 0.01) {
  return Math.abs(v - y) <= z;
}
function calcAxisDelta(v, y, z, ne = 0.5) {
  v.origin = ne, v.originPoint = mixNumber$1(y.min, y.max, v.origin), v.scale = calcLength(z) / calcLength(y), (isNear(v.scale, 1, 1e-4) || isNaN(v.scale)) && (v.scale = 1), v.translate = mixNumber$1(z.min, z.max, v.origin) - v.originPoint, (isNear(v.translate) || isNaN(v.translate)) && (v.translate = 0);
}
function calcBoxDelta(v, y, z, ne) {
  calcAxisDelta(v.x, y.x, z.x, ne ? ne.originX : void 0), calcAxisDelta(v.y, y.y, z.y, ne ? ne.originY : void 0);
}
function calcRelativeAxis(v, y, z) {
  v.min = z.min + y.min, v.max = v.min + calcLength(y);
}
function calcRelativeBox(v, y, z) {
  calcRelativeAxis(v.x, y.x, z.x), calcRelativeAxis(v.y, y.y, z.y);
}
function calcRelativeAxisPosition(v, y, z) {
  v.min = y.min - z.min, v.max = v.min + calcLength(y);
}
function calcRelativePosition(v, y, z) {
  calcRelativeAxisPosition(v.x, y.x, z.x), calcRelativeAxisPosition(v.y, y.y, z.y);
}
function applyConstraints(v, { min: y, max: z }, ne) {
  return y !== void 0 && v < y ? v = ne ? mixNumber$1(y, v, ne.min) : Math.max(v, y) : z !== void 0 && v > z && (v = ne ? mixNumber$1(z, v, ne.max) : Math.min(v, z)), v;
}
function calcRelativeAxisConstraints(v, y, z) {
  return {
    min: y !== void 0 ? v.min + y : void 0,
    max: z !== void 0 ? v.max + z - (v.max - v.min) : void 0
  };
}
function calcRelativeConstraints(v, { top: y, left: z, bottom: ne, right: ue }) {
  return {
    x: calcRelativeAxisConstraints(v.x, z, ue),
    y: calcRelativeAxisConstraints(v.y, y, ne)
  };
}
function calcViewportAxisConstraints(v, y) {
  let z = y.min - v.min, ne = y.max - v.max;
  return y.max - y.min < v.max - v.min && ([z, ne] = [ne, z]), { min: z, max: ne };
}
function calcViewportConstraints(v, y) {
  return {
    x: calcViewportAxisConstraints(v.x, y.x),
    y: calcViewportAxisConstraints(v.y, y.y)
  };
}
function calcOrigin(v, y) {
  let z = 0.5;
  const ne = calcLength(v), ue = calcLength(y);
  return ue > ne ? z = progress(y.min, y.max - ne, v.min) : ne > ue && (z = progress(v.min, v.max - ue, y.min)), clamp(0, 1, z);
}
function rebaseAxisConstraints(v, y) {
  const z = {};
  return y.min !== void 0 && (z.min = y.min - v.min), y.max !== void 0 && (z.max = y.max - v.min), z;
}
const defaultElastic = 0.35;
function resolveDragElastic(v = defaultElastic) {
  return v === !1 ? v = 0 : v === !0 && (v = defaultElastic), {
    x: resolveAxisElastic(v, "left", "right"),
    y: resolveAxisElastic(v, "top", "bottom")
  };
}
function resolveAxisElastic(v, y, z) {
  return {
    min: resolvePointElastic(v, y),
    max: resolvePointElastic(v, z)
  };
}
function resolvePointElastic(v, y) {
  return typeof v == "number" ? v : v[y] || 0;
}
const createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
}), createAxis = () => ({ min: 0, max: 0 }), createBox = () => ({
  x: createAxis(),
  y: createAxis()
});
function eachAxis(v) {
  return [v("x"), v("y")];
}
function convertBoundingBoxToBox({ top: v, left: y, right: z, bottom: ne }) {
  return {
    x: { min: y, max: z },
    y: { min: v, max: ne }
  };
}
function convertBoxToBoundingBox({ x: v, y }) {
  return { top: y.min, right: v.max, bottom: y.max, left: v.min };
}
function transformBoxPoints(v, y) {
  if (!y)
    return v;
  const z = y({ x: v.left, y: v.top }), ne = y({ x: v.right, y: v.bottom });
  return {
    top: z.y,
    left: z.x,
    bottom: ne.y,
    right: ne.x
  };
}
function isIdentityScale(v) {
  return v === void 0 || v === 1;
}
function hasScale({ scale: v, scaleX: y, scaleY: z }) {
  return !isIdentityScale(v) || !isIdentityScale(y) || !isIdentityScale(z);
}
function hasTransform(v) {
  return hasScale(v) || has2DTranslate(v) || v.z || v.rotate || v.rotateX || v.rotateY;
}
function has2DTranslate(v) {
  return is2DTranslate(v.x) || is2DTranslate(v.y);
}
function is2DTranslate(v) {
  return v && v !== "0%";
}
function scalePoint(v, y, z) {
  const ne = v - z, ue = y * ne;
  return z + ue;
}
function applyPointDelta(v, y, z, ne, ue) {
  return ue !== void 0 && (v = scalePoint(v, ue, ne)), scalePoint(v, z, ne) + y;
}
function applyAxisDelta(v, y = 0, z = 1, ne, ue) {
  v.min = applyPointDelta(v.min, y, z, ne, ue), v.max = applyPointDelta(v.max, y, z, ne, ue);
}
function applyBoxDelta(v, { x: y, y: z }) {
  applyAxisDelta(v.x, y.translate, y.scale, y.originPoint), applyAxisDelta(v.y, z.translate, z.scale, z.originPoint);
}
function applyTreeDeltas(v, y, z, ne = !1) {
  const ue = z.length;
  if (!ue)
    return;
  y.x = y.y = 1;
  let le, he;
  for (let ge = 0; ge < ue; ge++) {
    le = z[ge], he = le.projectionDelta;
    const we = le.instance;
    we && we.style && we.style.display === "contents" || (ne && le.options.layoutScroll && le.scroll && le !== le.root && transformBox(v, {
      x: -le.scroll.offset.x,
      y: -le.scroll.offset.y
    }), he && (y.x *= he.x.scale, y.y *= he.y.scale, applyBoxDelta(v, he)), ne && hasTransform(le.latestValues) && transformBox(v, le.latestValues));
  }
  y.x = snapToDefault(y.x), y.y = snapToDefault(y.y);
}
function snapToDefault(v) {
  return Number.isInteger(v) || v > 1.0000000000001 || v < 0.999999999999 ? v : 1;
}
function translateAxis(v, y) {
  v.min = v.min + y, v.max = v.max + y;
}
function transformAxis(v, y, [z, ne, ue]) {
  const le = y[ue] !== void 0 ? y[ue] : 0.5, he = mixNumber$1(v.min, v.max, le);
  applyAxisDelta(v, y[z], y[ne], he, y.scale);
}
const xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(v, y) {
  transformAxis(v.x, y, xKeys$1), transformAxis(v.y, y, yKeys$1);
}
function measureViewportBox(v, y) {
  return convertBoundingBoxToBox(transformBoxPoints(v.getBoundingClientRect(), y));
}
function measurePageBox(v, y, z) {
  const ne = measureViewportBox(v, z), { scroll: ue } = y;
  return ue && (translateAxis(ne.x, ue.offset.x), translateAxis(ne.y, ue.offset.y)), ne;
}
const getContextWindow = ({ current: v }) => v ? v.ownerDocument.defaultView : null, elementDragControls = /* @__PURE__ */ new WeakMap();
class VisualElementDragControls {
  constructor(y) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = y;
  }
  start(y, { snapToCursor: z = !1 } = {}) {
    const { presenceContext: ne } = this.visualElement;
    if (ne && ne.isPresent === !1)
      return;
    const ue = (xe) => {
      const { dragSnapToOrigin: $e } = this.getProps();
      $e ? this.pauseAnimation() : this.stopAnimation(), z && this.snapToCursor(extractEventInfo(xe, "page").point);
    }, le = (xe, $e) => {
      const { drag: Ne, dragPropagation: st, onDragStart: Nr } = this.getProps();
      if (Ne && !st && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = getGlobalLock(Ne), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), eachAxis(($n) => {
        let En = this.getAxisMotionValue($n).get() || 0;
        if (percent.test(En)) {
          const { projection: Rn } = this.visualElement;
          if (Rn && Rn.layout) {
            const wa = Rn.layout.layoutBox[$n];
            wa && (En = calcLength(wa) * (parseFloat(En) / 100));
          }
        }
        this.originPoint[$n] = En;
      }), Nr && frame.update(() => Nr(xe, $e), !1, !0);
      const { animationState: br } = this.visualElement;
      br && br.setActive("whileDrag", !0);
    }, he = (xe, $e) => {
      const { dragPropagation: Ne, dragDirectionLock: st, onDirectionLock: Nr, onDrag: br } = this.getProps();
      if (!Ne && !this.openGlobalLock)
        return;
      const { offset: $n } = $e;
      if (st && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection($n), this.currentDirection !== null && Nr && Nr(this.currentDirection);
        return;
      }
      this.updateAxis("x", $e.point, $n), this.updateAxis("y", $e.point, $n), this.visualElement.render(), br && br(xe, $e);
    }, ge = (xe, $e) => this.stop(xe, $e), we = () => eachAxis((xe) => {
      var $e;
      return this.getAnimationState(xe) === "paused" && (($e = this.getAxisMotionValue(xe).animation) === null || $e === void 0 ? void 0 : $e.play());
    }), { dragSnapToOrigin: Ee } = this.getProps();
    this.panSession = new PanSession(y, {
      onSessionStart: ue,
      onStart: le,
      onMove: he,
      onSessionEnd: ge,
      resumeAnimation: we
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: Ee,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(y, z) {
    const ne = this.isDragging;
    if (this.cancel(), !ne)
      return;
    const { velocity: ue } = z;
    this.startAnimation(ue);
    const { onDragEnd: le } = this.getProps();
    le && frame.update(() => le(y, z));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: y, animationState: z } = this.visualElement;
    y && (y.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: ne } = this.getProps();
    !ne && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), z && z.setActive("whileDrag", !1);
  }
  updateAxis(y, z, ne) {
    const { drag: ue } = this.getProps();
    if (!ne || !shouldDrag(y, ue, this.currentDirection))
      return;
    const le = this.getAxisMotionValue(y);
    let he = this.originPoint[y] + ne[y];
    this.constraints && this.constraints[y] && (he = applyConstraints(he, this.constraints[y], this.elastic[y])), le.set(he);
  }
  resolveConstraints() {
    var y;
    const { dragConstraints: z, dragElastic: ne } = this.getProps(), ue = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (y = this.visualElement.projection) === null || y === void 0 ? void 0 : y.layout, le = this.constraints;
    z && isRefObject(z) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : z && ue ? this.constraints = calcRelativeConstraints(ue.layoutBox, z) : this.constraints = !1, this.elastic = resolveDragElastic(ne), le !== this.constraints && ue && this.constraints && !this.hasMutatedConstraints && eachAxis((he) => {
      this.getAxisMotionValue(he) && (this.constraints[he] = rebaseAxisConstraints(ue.layoutBox[he], this.constraints[he]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: y, onMeasureDragConstraints: z } = this.getProps();
    if (!y || !isRefObject(y))
      return !1;
    const ne = y.current;
    invariant(ne !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: ue } = this.visualElement;
    if (!ue || !ue.layout)
      return !1;
    const le = measurePageBox(ne, ue.root, this.visualElement.getTransformPagePoint());
    let he = calcViewportConstraints(ue.layout.layoutBox, le);
    if (z) {
      const ge = z(convertBoxToBoundingBox(he));
      this.hasMutatedConstraints = !!ge, ge && (he = convertBoundingBoxToBox(ge));
    }
    return he;
  }
  startAnimation(y) {
    const { drag: z, dragMomentum: ne, dragElastic: ue, dragTransition: le, dragSnapToOrigin: he, onDragTransitionEnd: ge } = this.getProps(), we = this.constraints || {}, Ee = eachAxis((xe) => {
      if (!shouldDrag(xe, z, this.currentDirection))
        return;
      let $e = we && we[xe] || {};
      he && ($e = { min: 0, max: 0 });
      const Ne = ue ? 200 : 1e6, st = ue ? 40 : 1e7, Nr = {
        type: "inertia",
        velocity: ne ? y[xe] : 0,
        bounceStiffness: Ne,
        bounceDamping: st,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...le,
        ...$e
      };
      return this.startAxisValueAnimation(xe, Nr);
    });
    return Promise.all(Ee).then(ge);
  }
  startAxisValueAnimation(y, z) {
    const ne = this.getAxisMotionValue(y);
    return ne.start(animateMotionValue(y, ne, 0, z));
  }
  stopAnimation() {
    eachAxis((y) => this.getAxisMotionValue(y).stop());
  }
  pauseAnimation() {
    eachAxis((y) => {
      var z;
      return (z = this.getAxisMotionValue(y).animation) === null || z === void 0 ? void 0 : z.pause();
    });
  }
  getAnimationState(y) {
    var z;
    return (z = this.getAxisMotionValue(y).animation) === null || z === void 0 ? void 0 : z.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(y) {
    const z = "_drag" + y.toUpperCase(), ne = this.visualElement.getProps(), ue = ne[z];
    return ue || this.visualElement.getValue(y, (ne.initial ? ne.initial[y] : void 0) || 0);
  }
  snapToCursor(y) {
    eachAxis((z) => {
      const { drag: ne } = this.getProps();
      if (!shouldDrag(z, ne, this.currentDirection))
        return;
      const { projection: ue } = this.visualElement, le = this.getAxisMotionValue(z);
      if (ue && ue.layout) {
        const { min: he, max: ge } = ue.layout.layoutBox[z];
        le.set(y[z] - mixNumber$1(he, ge, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: y, dragConstraints: z } = this.getProps(), { projection: ne } = this.visualElement;
    if (!isRefObject(z) || !ne || !this.constraints)
      return;
    this.stopAnimation();
    const ue = { x: 0, y: 0 };
    eachAxis((he) => {
      const ge = this.getAxisMotionValue(he);
      if (ge) {
        const we = ge.get();
        ue[he] = calcOrigin({ min: we, max: we }, this.constraints[he]);
      }
    });
    const { transformTemplate: le } = this.visualElement.getProps();
    this.visualElement.current.style.transform = le ? le({}, "") : "none", ne.root && ne.root.updateScroll(), ne.updateLayout(), this.resolveConstraints(), eachAxis((he) => {
      if (!shouldDrag(he, y, null))
        return;
      const ge = this.getAxisMotionValue(he), { min: we, max: Ee } = this.constraints[he];
      ge.set(mixNumber$1(we, Ee, ue[he]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const y = this.visualElement.current, z = addPointerEvent(y, "pointerdown", (we) => {
      const { drag: Ee, dragListener: xe = !0 } = this.getProps();
      Ee && xe && this.start(we);
    }), ne = () => {
      const { dragConstraints: we } = this.getProps();
      isRefObject(we) && (this.constraints = this.resolveRefConstraints());
    }, { projection: ue } = this.visualElement, le = ue.addEventListener("measure", ne);
    ue && !ue.layout && (ue.root && ue.root.updateScroll(), ue.updateLayout()), ne();
    const he = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints()), ge = ue.addEventListener("didUpdate", ({ delta: we, hasLayoutChanged: Ee }) => {
      this.isDragging && Ee && (eachAxis((xe) => {
        const $e = this.getAxisMotionValue(xe);
        $e && (this.originPoint[xe] += we[xe].translate, $e.set($e.get() + we[xe].translate));
      }), this.visualElement.render());
    });
    return () => {
      he(), z(), le(), ge && ge();
    };
  }
  getProps() {
    const y = this.visualElement.getProps(), { drag: z = !1, dragDirectionLock: ne = !1, dragPropagation: ue = !1, dragConstraints: le = !1, dragElastic: he = defaultElastic, dragMomentum: ge = !0 } = y;
    return {
      ...y,
      drag: z,
      dragDirectionLock: ne,
      dragPropagation: ue,
      dragConstraints: le,
      dragElastic: he,
      dragMomentum: ge
    };
  }
}
function shouldDrag(v, y, z) {
  return (y === !0 || y === v) && (z === null || z === v);
}
function getCurrentDirection(v, y = 10) {
  let z = null;
  return Math.abs(v.y) > y ? z = "y" : Math.abs(v.x) > y && (z = "x"), z;
}
class DragGesture extends Feature {
  constructor(y) {
    super(y), this.removeGroupControls = noop$1, this.removeListeners = noop$1, this.controls = new VisualElementDragControls(y);
  }
  mount() {
    const { dragControls: y } = this.node.getProps();
    y && (this.removeGroupControls = y.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || noop$1;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const asyncHandler = (v) => (y, z) => {
  v && frame.update(() => v(y, z));
};
class PanGesture extends Feature {
  constructor() {
    super(...arguments), this.removePointerDownListener = noop$1;
  }
  onPointerDown(y) {
    this.session = new PanSession(y, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: y, onPanStart: z, onPan: ne, onPanEnd: ue } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(y),
      onStart: asyncHandler(z),
      onMove: ne,
      onEnd: (le, he) => {
        delete this.session, ue && frame.update(() => ue(le, he));
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (y) => this.onPointerDown(y));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function usePresence() {
  const v = useContext(PresenceContext);
  if (v === null)
    return [!0, null];
  const { isPresent: y, onExitComplete: z, register: ne } = v, ue = useId();
  return useEffect(() => ne(ue), []), !y && z ? [!1, () => z && z(ue)] : [!0];
}
const globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function pixelsToPercent(v, y) {
  return y.max === y.min ? 0 : v / (y.max - y.min) * 100;
}
const correctBorderRadius = {
  correct: (v, y) => {
    if (!y.target)
      return v;
    if (typeof v == "string")
      if (px.test(v))
        v = parseFloat(v);
      else
        return v;
    const z = pixelsToPercent(v, y.target.x), ne = pixelsToPercent(v, y.target.y);
    return `${z}% ${ne}%`;
  }
}, correctBoxShadow = {
  correct: (v, { treeScale: y, projectionDelta: z }) => {
    const ne = v, ue = complex.parse(v);
    if (ue.length > 5)
      return ne;
    const le = complex.createTransformer(v), he = typeof ue[0] != "number" ? 1 : 0, ge = z.x.scale * y.x, we = z.y.scale * y.y;
    ue[0 + he] /= ge, ue[1 + he] /= we;
    const Ee = mixNumber$1(ge, we, 0.5);
    return typeof ue[2 + he] == "number" && (ue[2 + he] /= Ee), typeof ue[3 + he] == "number" && (ue[3 + he] /= Ee), le(ue);
  }
};
class MeasureLayoutWithContext extends a__default.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: y, layoutGroup: z, switchLayoutGroup: ne, layoutId: ue } = this.props, { projection: le } = y;
    addScaleCorrector(defaultScaleCorrectors), le && (z.group && z.group.add(le), ne && ne.register && ue && ne.register(le), le.root.didUpdate(), le.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), le.setOptions({
      ...le.options,
      onExitComplete: () => this.safeToRemove()
    })), globalProjectionState.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(y) {
    const { layoutDependency: z, visualElement: ne, drag: ue, isPresent: le } = this.props, he = ne.projection;
    return he && (he.isPresent = le, ue || y.layoutDependency !== z || z === void 0 ? he.willUpdate() : this.safeToRemove(), y.isPresent !== le && (le ? he.promote() : he.relegate() || frame.postRender(() => {
      const ge = he.getStack();
      (!ge || !ge.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: y } = this.props.visualElement;
    y && (y.root.didUpdate(), microtask.postRender(() => {
      !y.currentAnimation && y.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: y, layoutGroup: z, switchLayoutGroup: ne } = this.props, { projection: ue } = y;
    ue && (ue.scheduleCheckAfterUnmount(), z && z.group && z.group.remove(ue), ne && ne.deregister && ne.deregister(ue));
  }
  safeToRemove() {
    const { safeToRemove: y } = this.props;
    y && y();
  }
  render() {
    return null;
  }
}
function MeasureLayout(v) {
  const [y, z] = usePresence(), ne = useContext(LayoutGroupContext);
  return a__default.createElement(MeasureLayoutWithContext, { ...v, layoutGroup: ne, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: y, safeToRemove: z });
}
const defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = (v) => typeof v == "string" ? parseFloat(v) : v, isPx = (v) => typeof v == "number" || px.test(v);
function mixValues(v, y, z, ne, ue, le) {
  ue ? (v.opacity = mixNumber$1(
    0,
    // TODO Reinstate this if only child
    z.opacity !== void 0 ? z.opacity : 1,
    easeCrossfadeIn(ne)
  ), v.opacityExit = mixNumber$1(y.opacity !== void 0 ? y.opacity : 1, 0, easeCrossfadeOut(ne))) : le && (v.opacity = mixNumber$1(y.opacity !== void 0 ? y.opacity : 1, z.opacity !== void 0 ? z.opacity : 1, ne));
  for (let he = 0; he < numBorders; he++) {
    const ge = `border${borders[he]}Radius`;
    let we = getRadius(y, ge), Ee = getRadius(z, ge);
    if (we === void 0 && Ee === void 0)
      continue;
    we || (we = 0), Ee || (Ee = 0), we === 0 || Ee === 0 || isPx(we) === isPx(Ee) ? (v[ge] = Math.max(mixNumber$1(asNumber(we), asNumber(Ee), ne), 0), (percent.test(Ee) || percent.test(we)) && (v[ge] += "%")) : v[ge] = Ee;
  }
  (y.rotate || z.rotate) && (v.rotate = mixNumber$1(y.rotate || 0, z.rotate || 0, ne));
}
function getRadius(v, y) {
  return v[y] !== void 0 ? v[y] : v.borderRadius;
}
const easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, noop$1);
function compress(v, y, z) {
  return (ne) => ne < v ? 0 : ne > y ? 1 : z(progress(v, y, ne));
}
function copyAxisInto(v, y) {
  v.min = y.min, v.max = y.max;
}
function copyBoxInto(v, y) {
  copyAxisInto(v.x, y.x), copyAxisInto(v.y, y.y);
}
function removePointDelta(v, y, z, ne, ue) {
  return v -= y, v = scalePoint(v, 1 / z, ne), ue !== void 0 && (v = scalePoint(v, 1 / ue, ne)), v;
}
function removeAxisDelta(v, y = 0, z = 1, ne = 0.5, ue, le = v, he = v) {
  if (percent.test(y) && (y = parseFloat(y), y = mixNumber$1(he.min, he.max, y / 100) - he.min), typeof y != "number")
    return;
  let ge = mixNumber$1(le.min, le.max, ne);
  v === le && (ge -= y), v.min = removePointDelta(v.min, y, z, ge, ue), v.max = removePointDelta(v.max, y, z, ge, ue);
}
function removeAxisTransforms(v, y, [z, ne, ue], le, he) {
  removeAxisDelta(v, y[z], y[ne], y[ue], y.scale, le, he);
}
const xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(v, y, z, ne) {
  removeAxisTransforms(v.x, y, xKeys, z ? z.x : void 0, ne ? ne.x : void 0), removeAxisTransforms(v.y, y, yKeys, z ? z.y : void 0, ne ? ne.y : void 0);
}
function isAxisDeltaZero(v) {
  return v.translate === 0 && v.scale === 1;
}
function isDeltaZero(v) {
  return isAxisDeltaZero(v.x) && isAxisDeltaZero(v.y);
}
function boxEquals(v, y) {
  return v.x.min === y.x.min && v.x.max === y.x.max && v.y.min === y.y.min && v.y.max === y.y.max;
}
function boxEqualsRounded(v, y) {
  return Math.round(v.x.min) === Math.round(y.x.min) && Math.round(v.x.max) === Math.round(y.x.max) && Math.round(v.y.min) === Math.round(y.y.min) && Math.round(v.y.max) === Math.round(y.y.max);
}
function aspectRatio(v) {
  return calcLength(v.x) / calcLength(v.y);
}
class NodeStack {
  constructor() {
    this.members = [];
  }
  add(y) {
    addUniqueItem(this.members, y), y.scheduleRender();
  }
  remove(y) {
    if (removeItem(this.members, y), y === this.prevLead && (this.prevLead = void 0), y === this.lead) {
      const z = this.members[this.members.length - 1];
      z && this.promote(z);
    }
  }
  relegate(y) {
    const z = this.members.findIndex((ue) => y === ue);
    if (z === 0)
      return !1;
    let ne;
    for (let ue = z; ue >= 0; ue--) {
      const le = this.members[ue];
      if (le.isPresent !== !1) {
        ne = le;
        break;
      }
    }
    return ne ? (this.promote(ne), !0) : !1;
  }
  promote(y, z) {
    const ne = this.lead;
    if (y !== ne && (this.prevLead = ne, this.lead = y, y.show(), ne)) {
      ne.instance && ne.scheduleRender(), y.scheduleRender(), y.resumeFrom = ne, z && (y.resumeFrom.preserveOpacity = !0), ne.snapshot && (y.snapshot = ne.snapshot, y.snapshot.latestValues = ne.animationValues || ne.latestValues), y.root && y.root.isUpdating && (y.isLayoutDirty = !0);
      const { crossfade: ue } = y.options;
      ue === !1 && ne.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((y) => {
      const { options: z, resumingFrom: ne } = y;
      z.onExitComplete && z.onExitComplete(), ne && ne.options.onExitComplete && ne.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((y) => {
      y.instance && y.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function buildProjectionTransform(v, y, z) {
  let ne = "";
  const ue = v.x.translate / y.x, le = v.y.translate / y.y;
  if ((ue || le) && (ne = `translate3d(${ue}px, ${le}px, 0) `), (y.x !== 1 || y.y !== 1) && (ne += `scale(${1 / y.x}, ${1 / y.y}) `), z) {
    const { rotate: we, rotateX: Ee, rotateY: xe } = z;
    we && (ne += `rotate(${we}deg) `), Ee && (ne += `rotateX(${Ee}deg) `), xe && (ne += `rotateY(${xe}deg) `);
  }
  const he = v.x.scale * y.x, ge = v.y.scale * y.y;
  return (he !== 1 || ge !== 1) && (ne += `scale(${he}, ${ge})`), ne || "none";
}
const compareByDepth = (v, y) => v.depth - y.depth;
class FlatTree {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(y) {
    addUniqueItem(this.children, y), this.isDirty = !0;
  }
  remove(y) {
    removeItem(this.children, y), this.isDirty = !0;
  }
  forEach(y) {
    this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(y);
  }
}
function delay$1(v, y) {
  const z = time$1.now(), ne = ({ timestamp: ue }) => {
    const le = ue - z;
    le >= y && (cancelFrame(ne), v(le - y));
  };
  return frame.read(ne, !0), () => cancelFrame(ne);
}
function record(v) {
  window.MotionDebug && window.MotionDebug.record(v);
}
function isSVGElement(v) {
  return v instanceof SVGElement && v.tagName !== "svg";
}
function animateSingleValue(v, y, z) {
  const ne = isMotionValue(v) ? v : motionValue(v);
  return ne.start(animateMotionValue("", ne, y, z)), ne.animation;
}
const transformAxes = ["", "X", "Y", "Z"], hiddenVisibility = { visibility: "hidden" }, animationTarget = 1e3;
let id$1 = 0;
const projectionFrameData = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function createProjectionNode({ attachResizeListener: v, defaultParent: y, measureScroll: z, checkIsScrollRoot: ne, resetTransform: ue }) {
  return class {
    constructor(he = {}, ge = y == null ? void 0 : y()) {
      this.id = id$1++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0, this.nodes.forEach(propagateDirtyNodes), this.nodes.forEach(resolveTargetDelta), this.nodes.forEach(calcProjection), this.nodes.forEach(cleanDirtyNodes), record(projectionFrameData);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = he, this.root = ge ? ge.root || ge : this, this.path = ge ? [...ge.path, ge] : [], this.parent = ge, this.depth = ge ? ge.depth + 1 : 0;
      for (let we = 0; we < this.path.length; we++)
        this.path[we].shouldResetTransform = !0;
      this.root === this && (this.nodes = new FlatTree());
    }
    addEventListener(he, ge) {
      return this.eventHandlers.has(he) || this.eventHandlers.set(he, new SubscriptionManager()), this.eventHandlers.get(he).add(ge);
    }
    notifyListeners(he, ...ge) {
      const we = this.eventHandlers.get(he);
      we && we.notify(...ge);
    }
    hasListeners(he) {
      return this.eventHandlers.has(he);
    }
    /**
     * Lifecycles
     */
    mount(he, ge = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(he), this.instance = he;
      const { layoutId: we, layout: Ee, visualElement: xe } = this.options;
      if (xe && !xe.current && xe.mount(he), this.root.nodes.add(this), this.parent && this.parent.children.add(this), ge && (Ee || we) && (this.isLayoutDirty = !0), v) {
        let $e;
        const Ne = () => this.root.updateBlockedByResize = !1;
        v(he, () => {
          this.root.updateBlockedByResize = !0, $e && $e(), $e = delay$1(Ne, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, this.nodes.forEach(finishAnimation));
        });
      }
      we && this.root.registerSharedNode(we, this), this.options.animate !== !1 && xe && (we || Ee) && this.addEventListener("didUpdate", ({ delta: $e, hasLayoutChanged: Ne, hasRelativeTargetChanged: st, layout: Nr }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const br = this.options.transition || xe.getDefaultTransition() || defaultLayoutTransition, { onLayoutAnimationStart: $n, onLayoutAnimationComplete: En } = xe.getProps(), Rn = !this.targetLayout || !boxEqualsRounded(this.targetLayout, Nr) || st, wa = !Ne && st;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || wa || Ne && (Rn || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin($e, wa);
          const Aa = {
            ...getValueTransition(br, "layout"),
            onPlay: $n,
            onComplete: En
          };
          (xe.shouldReduceMotion || this.options.layoutRoot) && (Aa.delay = 0, Aa.type = !1), this.startAnimation(Aa);
        } else
          Ne || finishAnimation(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = Nr;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const he = this.getStack();
      he && he.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(resetRotation), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: he } = this.options;
      return he && he.getProps().transformTemplate;
    }
    willUpdate(he = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let xe = 0; xe < this.path.length; xe++) {
        const $e = this.path[xe];
        $e.shouldResetTransform = !0, $e.updateScroll("snapshot"), $e.options.layoutRoot && $e.willUpdate(!1);
      }
      const { layoutId: ge, layout: we } = this.options;
      if (ge === void 0 && !we)
        return;
      const Ee = this.getTransformTemplate();
      this.prevTransformTemplateValue = Ee ? Ee(this.latestValues, "") : void 0, this.updateSnapshot(), he && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
        return;
      }
      this.isUpdating || this.nodes.forEach(clearIsLayoutDirty), this.isUpdating = !1, window.HandoffCancelAllAnimations && window.HandoffCancelAllAnimations(), this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots();
      const ge = time$1.now();
      frameData.delta = clamp(0, 1e3 / 60, ge - frameData.timestamp), frameData.timestamp = ge, frameData.isProcessing = !0, steps.update.process(frameData), steps.preRender.process(frameData), steps.render.process(frameData), frameData.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, microtask.read(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, frame.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let we = 0; we < this.path.length; we++)
          this.path[we].updateScroll();
      const he = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: ge } = this.options;
      ge && ge.notify("LayoutMeasure", this.layout.layoutBox, he ? he.layoutBox : void 0);
    }
    updateScroll(he = "measure") {
      let ge = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === he && (ge = !1), ge && (this.scroll = {
        animationId: this.root.animationId,
        phase: he,
        isRoot: ne(this.instance),
        offset: z(this.instance)
      });
    }
    resetTransform() {
      if (!ue)
        return;
      const he = this.isLayoutDirty || this.shouldResetTransform, ge = this.projectionDelta && !isDeltaZero(this.projectionDelta), we = this.getTransformTemplate(), Ee = we ? we(this.latestValues, "") : void 0, xe = Ee !== this.prevTransformTemplateValue;
      he && (ge || hasTransform(this.latestValues) || xe) && (ue(this.instance, Ee), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(he = !0) {
      const ge = this.measurePageBox();
      let we = this.removeElementScroll(ge);
      return he && (we = this.removeTransform(we)), roundBox(we), {
        animationId: this.root.animationId,
        measuredBox: ge,
        layoutBox: we,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: he } = this.options;
      if (!he)
        return createBox();
      const ge = he.measureViewportBox(), { scroll: we } = this.root;
      return we && (translateAxis(ge.x, we.offset.x), translateAxis(ge.y, we.offset.y)), ge;
    }
    removeElementScroll(he) {
      const ge = createBox();
      copyBoxInto(ge, he);
      for (let we = 0; we < this.path.length; we++) {
        const Ee = this.path[we], { scroll: xe, options: $e } = Ee;
        if (Ee !== this.root && xe && $e.layoutScroll) {
          if (xe.isRoot) {
            copyBoxInto(ge, he);
            const { scroll: Ne } = this.root;
            Ne && (translateAxis(ge.x, -Ne.offset.x), translateAxis(ge.y, -Ne.offset.y));
          }
          translateAxis(ge.x, xe.offset.x), translateAxis(ge.y, xe.offset.y);
        }
      }
      return ge;
    }
    applyTransform(he, ge = !1) {
      const we = createBox();
      copyBoxInto(we, he);
      for (let Ee = 0; Ee < this.path.length; Ee++) {
        const xe = this.path[Ee];
        !ge && xe.options.layoutScroll && xe.scroll && xe !== xe.root && transformBox(we, {
          x: -xe.scroll.offset.x,
          y: -xe.scroll.offset.y
        }), hasTransform(xe.latestValues) && transformBox(we, xe.latestValues);
      }
      return hasTransform(this.latestValues) && transformBox(we, this.latestValues), we;
    }
    removeTransform(he) {
      const ge = createBox();
      copyBoxInto(ge, he);
      for (let we = 0; we < this.path.length; we++) {
        const Ee = this.path[we];
        if (!Ee.instance || !hasTransform(Ee.latestValues))
          continue;
        hasScale(Ee.latestValues) && Ee.updateSnapshot();
        const xe = createBox(), $e = Ee.measurePageBox();
        copyBoxInto(xe, $e), removeBoxTransforms(ge, Ee.latestValues, Ee.snapshot ? Ee.snapshot.layoutBox : void 0, xe);
      }
      return hasTransform(this.latestValues) && removeBoxTransforms(ge, this.latestValues), ge;
    }
    setTargetDelta(he) {
      this.targetDelta = he, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(he) {
      this.options = {
        ...this.options,
        ...he,
        crossfade: he.crossfade !== void 0 ? he.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(he = !1) {
      var ge;
      const we = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = we.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = we.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = we.isSharedProjectionDirty);
      const Ee = !!this.resumingFrom || this !== we;
      if (!(he || Ee && this.isSharedProjectionDirty || this.isProjectionDirty || !((ge = this.parent) === null || ge === void 0) && ge.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: $e, layoutId: Ne } = this.options;
      if (!(!this.layout || !($e || Ne))) {
        if (this.resolvedRelativeTargetAt = frameData.timestamp, !this.targetDelta && !this.relativeTarget) {
          const st = this.getClosestProjectingParent();
          st && st.layout && this.animationProgress !== 1 ? (this.relativeParent = st, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, st.layout.layoutBox), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : copyBoxInto(this.target, this.layout.layoutBox), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const st = this.getClosestProjectingParent();
            st && !!st.resumingFrom == !!this.resumingFrom && !st.options.layoutScroll && st.target && this.animationProgress !== 1 ? (this.relativeParent = st, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, st.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          projectionFrameData.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var he;
      const ge = this.getLead(), we = !!this.resumingFrom || this !== ge;
      let Ee = !0;
      if ((this.isProjectionDirty || !((he = this.parent) === null || he === void 0) && he.isProjectionDirty) && (Ee = !1), we && (this.isSharedProjectionDirty || this.isTransformDirty) && (Ee = !1), this.resolvedRelativeTargetAt === frameData.timestamp && (Ee = !1), Ee)
        return;
      const { layout: xe, layoutId: $e } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(xe || $e))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const Ne = this.treeScale.x, st = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, we), ge.layout && !ge.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (ge.target = ge.layout.layoutBox, ge.targetWithTransforms = createBox());
      const { target: Nr } = ge;
      if (!Nr) {
        this.projectionTransform && (this.projectionDelta = createDelta(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
      const br = this.projectionTransform;
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, Nr, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== br || this.treeScale.x !== Ne || this.treeScale.y !== st) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", Nr)), projectionFrameData.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(he = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), he) {
        const ge = this.getStack();
        ge && ge.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(he, ge = !1) {
      const we = this.snapshot, Ee = we ? we.latestValues : {}, xe = { ...this.latestValues }, $e = createDelta();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !ge;
      const Ne = createBox(), st = we ? we.source : void 0, Nr = this.layout ? this.layout.source : void 0, br = st !== Nr, $n = this.getStack(), En = !$n || $n.members.length <= 1, Rn = !!(br && !En && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let wa;
      this.mixTargetDelta = (Aa) => {
        const _a = Aa / 1e3;
        mixAxisDelta($e.x, he.x, _a), mixAxisDelta($e.y, he.y, _a), this.setTargetDelta($e), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (calcRelativePosition(Ne, this.layout.layoutBox, this.relativeParent.layout.layoutBox), mixBox(this.relativeTarget, this.relativeTargetOrigin, Ne, _a), wa && boxEquals(this.relativeTarget, wa) && (this.isProjectionDirty = !1), wa || (wa = createBox()), copyBoxInto(wa, this.relativeTarget)), br && (this.animationValues = xe, mixValues(xe, Ee, this.latestValues, _a, Rn, En)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = _a;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(he) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (cancelFrame(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = !0, this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...he,
          onUpdate: (ge) => {
            this.mixTargetDelta(ge), he.onUpdate && he.onUpdate(ge);
          },
          onComplete: () => {
            he.onComplete && he.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const he = this.getStack();
      he && he.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(animationTarget), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const he = this.getLead();
      let { targetWithTransforms: ge, target: we, layout: Ee, latestValues: xe } = he;
      if (!(!ge || !we || !Ee)) {
        if (this !== he && this.layout && Ee && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, Ee.layoutBox)) {
          we = this.target || createBox();
          const $e = calcLength(this.layout.layoutBox.x);
          we.x.min = he.target.x.min, we.x.max = we.x.min + $e;
          const Ne = calcLength(this.layout.layoutBox.y);
          we.y.min = he.target.y.min, we.y.max = we.y.min + Ne;
        }
        copyBoxInto(ge, we), transformBox(ge, xe), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, ge, xe);
      }
    }
    registerSharedNode(he, ge) {
      this.sharedNodes.has(he) || this.sharedNodes.set(he, new NodeStack()), this.sharedNodes.get(he).add(ge);
      const Ee = ge.options.initialPromotionConfig;
      ge.promote({
        transition: Ee ? Ee.transition : void 0,
        preserveFollowOpacity: Ee && Ee.shouldPreserveFollowOpacity ? Ee.shouldPreserveFollowOpacity(ge) : void 0
      });
    }
    isLead() {
      const he = this.getStack();
      return he ? he.lead === this : !0;
    }
    getLead() {
      var he;
      const { layoutId: ge } = this.options;
      return ge ? ((he = this.getStack()) === null || he === void 0 ? void 0 : he.lead) || this : this;
    }
    getPrevLead() {
      var he;
      const { layoutId: ge } = this.options;
      return ge ? (he = this.getStack()) === null || he === void 0 ? void 0 : he.prevLead : void 0;
    }
    getStack() {
      const { layoutId: he } = this.options;
      if (he)
        return this.root.sharedNodes.get(he);
    }
    promote({ needsReset: he, transition: ge, preserveFollowOpacity: we } = {}) {
      const Ee = this.getStack();
      Ee && Ee.promote(this, we), he && (this.projectionDelta = void 0, this.needsReset = !0), ge && this.setOptions({ transition: ge });
    }
    relegate() {
      const he = this.getStack();
      return he ? he.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: he } = this.options;
      if (!he)
        return;
      let ge = !1;
      const { latestValues: we } = he;
      if ((we.rotate || we.rotateX || we.rotateY || we.rotateZ) && (ge = !0), !ge)
        return;
      const Ee = {};
      for (let xe = 0; xe < transformAxes.length; xe++) {
        const $e = "rotate" + transformAxes[xe];
        we[$e] && (Ee[$e] = we[$e], he.setStaticValue($e, 0));
      }
      he.render();
      for (const xe in Ee)
        he.setStaticValue(xe, Ee[xe]);
      he.scheduleRender();
    }
    getProjectionStyles(he) {
      var ge, we;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return hiddenVisibility;
      const Ee = {
        visibility: ""
      }, xe = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, Ee.opacity = "", Ee.pointerEvents = resolveMotionValue(he == null ? void 0 : he.pointerEvents) || "", Ee.transform = xe ? xe(this.latestValues, "") : "none", Ee;
      const $e = this.getLead();
      if (!this.projectionDelta || !this.layout || !$e.target) {
        const br = {};
        return this.options.layoutId && (br.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, br.pointerEvents = resolveMotionValue(he == null ? void 0 : he.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (br.transform = xe ? xe({}, "") : "none", this.hasProjected = !1), br;
      }
      const Ne = $e.animationValues || $e.latestValues;
      this.applyTransformsToTarget(), Ee.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, Ne), xe && (Ee.transform = xe(Ne, Ee.transform));
      const { x: st, y: Nr } = this.projectionDelta;
      Ee.transformOrigin = `${st.origin * 100}% ${Nr.origin * 100}% 0`, $e.animationValues ? Ee.opacity = $e === this ? (we = (ge = Ne.opacity) !== null && ge !== void 0 ? ge : this.latestValues.opacity) !== null && we !== void 0 ? we : 1 : this.preserveOpacity ? this.latestValues.opacity : Ne.opacityExit : Ee.opacity = $e === this ? Ne.opacity !== void 0 ? Ne.opacity : "" : Ne.opacityExit !== void 0 ? Ne.opacityExit : 0;
      for (const br in scaleCorrectors) {
        if (Ne[br] === void 0)
          continue;
        const { correct: $n, applyTo: En } = scaleCorrectors[br], Rn = Ee.transform === "none" ? Ne[br] : $n(Ne[br], $e);
        if (En) {
          const wa = En.length;
          for (let Aa = 0; Aa < wa; Aa++)
            Ee[En[Aa]] = Rn;
        } else
          Ee[br] = Rn;
      }
      return this.options.layoutId && (Ee.pointerEvents = $e === this ? resolveMotionValue(he == null ? void 0 : he.pointerEvents) || "" : "none"), Ee;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((he) => {
        var ge;
        return (ge = he.currentAnimation) === null || ge === void 0 ? void 0 : ge.stop();
      }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(v) {
  v.updateLayout();
}
function notifyLayoutUpdate(v) {
  var y;
  const z = ((y = v.resumeFrom) === null || y === void 0 ? void 0 : y.snapshot) || v.snapshot;
  if (v.isLead() && v.layout && z && v.hasListeners("didUpdate")) {
    const { layoutBox: ne, measuredBox: ue } = v.layout, { animationType: le } = v.options, he = z.source !== v.layout.source;
    le === "size" ? eachAxis(($e) => {
      const Ne = he ? z.measuredBox[$e] : z.layoutBox[$e], st = calcLength(Ne);
      Ne.min = ne[$e].min, Ne.max = Ne.min + st;
    }) : shouldAnimatePositionOnly(le, z.layoutBox, ne) && eachAxis(($e) => {
      const Ne = he ? z.measuredBox[$e] : z.layoutBox[$e], st = calcLength(ne[$e]);
      Ne.max = Ne.min + st, v.relativeTarget && !v.currentAnimation && (v.isProjectionDirty = !0, v.relativeTarget[$e].max = v.relativeTarget[$e].min + st);
    });
    const ge = createDelta();
    calcBoxDelta(ge, ne, z.layoutBox);
    const we = createDelta();
    he ? calcBoxDelta(we, v.applyTransform(ue, !0), z.measuredBox) : calcBoxDelta(we, ne, z.layoutBox);
    const Ee = !isDeltaZero(ge);
    let xe = !1;
    if (!v.resumeFrom) {
      const $e = v.getClosestProjectingParent();
      if ($e && !$e.resumeFrom) {
        const { snapshot: Ne, layout: st } = $e;
        if (Ne && st) {
          const Nr = createBox();
          calcRelativePosition(Nr, z.layoutBox, Ne.layoutBox);
          const br = createBox();
          calcRelativePosition(br, ne, st.layoutBox), boxEqualsRounded(Nr, br) || (xe = !0), $e.options.layoutRoot && (v.relativeTarget = br, v.relativeTargetOrigin = Nr, v.relativeParent = $e);
        }
      }
    }
    v.notifyListeners("didUpdate", {
      layout: ne,
      snapshot: z,
      delta: we,
      layoutDelta: ge,
      hasLayoutChanged: Ee,
      hasRelativeTargetChanged: xe
    });
  } else if (v.isLead()) {
    const { onExitComplete: ne } = v.options;
    ne && ne();
  }
  v.options.transition = void 0;
}
function propagateDirtyNodes(v) {
  projectionFrameData.totalNodes++, v.parent && (v.isProjecting() || (v.isProjectionDirty = v.parent.isProjectionDirty), v.isSharedProjectionDirty || (v.isSharedProjectionDirty = !!(v.isProjectionDirty || v.parent.isProjectionDirty || v.parent.isSharedProjectionDirty)), v.isTransformDirty || (v.isTransformDirty = v.parent.isTransformDirty));
}
function cleanDirtyNodes(v) {
  v.isProjectionDirty = v.isSharedProjectionDirty = v.isTransformDirty = !1;
}
function clearSnapshot(v) {
  v.clearSnapshot();
}
function clearMeasurements(v) {
  v.clearMeasurements();
}
function clearIsLayoutDirty(v) {
  v.isLayoutDirty = !1;
}
function resetTransformStyle(v) {
  const { visualElement: y } = v.options;
  y && y.getProps().onBeforeLayoutMeasure && y.notify("BeforeLayoutMeasure"), v.resetTransform();
}
function finishAnimation(v) {
  v.finishAnimation(), v.targetDelta = v.relativeTarget = v.target = void 0, v.isProjectionDirty = !0;
}
function resolveTargetDelta(v) {
  v.resolveTargetDelta();
}
function calcProjection(v) {
  v.calcProjection();
}
function resetRotation(v) {
  v.resetRotation();
}
function removeLeadSnapshots(v) {
  v.removeLeadSnapshot();
}
function mixAxisDelta(v, y, z) {
  v.translate = mixNumber$1(y.translate, 0, z), v.scale = mixNumber$1(y.scale, 1, z), v.origin = y.origin, v.originPoint = y.originPoint;
}
function mixAxis(v, y, z, ne) {
  v.min = mixNumber$1(y.min, z.min, ne), v.max = mixNumber$1(y.max, z.max, ne);
}
function mixBox(v, y, z, ne) {
  mixAxis(v.x, y.x, z.x, ne), mixAxis(v.y, y.y, z.y, ne);
}
function hasOpacityCrossfade(v) {
  return v.animationValues && v.animationValues.opacityExit !== void 0;
}
const defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, userAgentContains = (v) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(v), roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop$1;
function roundAxis(v) {
  v.min = roundPoint(v.min), v.max = roundPoint(v.max);
}
function roundBox(v) {
  roundAxis(v.x), roundAxis(v.y);
}
function shouldAnimatePositionOnly(v, y, z) {
  return v === "position" || v === "preserve-aspect" && !isNear(aspectRatio(y), aspectRatio(z), 0.2);
}
const DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (v, y) => addDomEvent(v, "resize", y),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: (v) => ({
    x: v.scrollLeft,
    y: v.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const v = new DocumentProjectionNode({});
      v.mount(window), v.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = v;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (v, y) => {
    v.style.transform = y !== void 0 ? y : "none";
  },
  checkIsScrollRoot: (v) => window.getComputedStyle(v).position === "fixed"
}), drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
}, splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(v) {
  const y = splitCSSVariableRegex.exec(v);
  if (!y)
    return [,];
  const [, z, ne] = y;
  return [z, ne];
}
const maxDepth = 4;
function getVariableValue(v, y, z = 1) {
  invariant(z <= maxDepth, `Max CSS variable fallback depth detected in property "${v}". This may indicate a circular fallback dependency.`);
  const [ne, ue] = parseCSSVariable(v);
  if (!ne)
    return;
  const le = window.getComputedStyle(y).getPropertyValue(ne);
  if (le) {
    const he = le.trim();
    return isNumericalString(he) ? parseFloat(he) : he;
  } else
    return isCSSVariableToken(ue) ? getVariableValue(ue, y, z + 1) : ue;
}
function resolveCSSVariables(v, { ...y }, z) {
  const ne = v.current;
  if (!(ne instanceof Element))
    return { target: y, transitionEnd: z };
  z && (z = { ...z }), v.values.forEach((ue) => {
    const le = ue.get();
    if (!isCSSVariableToken(le))
      return;
    const he = getVariableValue(le, ne);
    he && ue.set(he);
  });
  for (const ue in y) {
    const le = y[ue];
    if (!isCSSVariableToken(le))
      continue;
    const he = getVariableValue(le, ne);
    he && (y[ue] = he, z || (z = {}), z[ue] === void 0 && (z[ue] = le));
  }
  return { target: y, transitionEnd: z };
}
const positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), isPositionalKey = (v) => positionalKeys.has(v), hasPositionalKey = (v) => Object.keys(v).some(isPositionalKey), isNumOrPxType = (v) => v === number || v === px, getPosFromMatrix = (v, y) => parseFloat(v.split(", ")[y]), getTranslateFromMatrix = (v, y) => (z, { transform: ne }) => {
  if (ne === "none" || !ne)
    return 0;
  const ue = ne.match(/^matrix3d\((.+)\)$/);
  if (ue)
    return getPosFromMatrix(ue[1], y);
  {
    const le = ne.match(/^matrix\((.+)\)$/);
    return le ? getPosFromMatrix(le[1], v) : 0;
  }
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformPropOrder.filter((v) => !transformKeys.has(v));
function removeNonTranslationalTransform(v) {
  const y = [];
  return nonTranslationalTransformKeys.forEach((z) => {
    const ne = v.getValue(z);
    ne !== void 0 && (y.push([z, ne.get()]), ne.set(z.startsWith("scale") ? 1 : 0));
  }), y.length && v.render(), y;
}
const positionalValues = {
  // Dimensions
  width: ({ x: v }, { paddingLeft: y = "0", paddingRight: z = "0" }) => v.max - v.min - parseFloat(y) - parseFloat(z),
  height: ({ y: v }, { paddingTop: y = "0", paddingBottom: z = "0" }) => v.max - v.min - parseFloat(y) - parseFloat(z),
  top: (v, { top: y }) => parseFloat(y),
  left: (v, { left: y }) => parseFloat(y),
  bottom: ({ y: v }, { top: y }) => parseFloat(y) + (v.max - v.min),
  right: ({ x: v }, { left: y }) => parseFloat(y) + (v.max - v.min),
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const convertChangedValueTypes = (v, y, z) => {
  const ne = y.measureViewportBox(), ue = y.current, le = getComputedStyle(ue), { display: he } = le, ge = {};
  he === "none" && y.setStaticValue("display", v.display || "block"), z.forEach((Ee) => {
    ge[Ee] = positionalValues[Ee](ne, le);
  }), y.render();
  const we = y.measureViewportBox();
  return z.forEach((Ee) => {
    const xe = y.getValue(Ee);
    xe && xe.jump(ge[Ee]), v[Ee] = positionalValues[Ee](we, le);
  }), v;
}, checkAndConvertChangedValueTypes = (v, y, z = {}, ne = {}) => {
  y = { ...y }, ne = { ...ne };
  const ue = Object.keys(y).filter(isPositionalKey);
  let le = [], he = !1;
  const ge = [];
  if (ue.forEach((we) => {
    const Ee = v.getValue(we);
    if (!v.hasValue(we))
      return;
    let xe = z[we], $e = findDimensionValueType(xe);
    const Ne = y[we];
    let st;
    if (isKeyframesTarget(Ne)) {
      const Nr = Ne.length, br = Ne[0] === null ? 1 : 0;
      xe = Ne[br], $e = findDimensionValueType(xe);
      for (let $n = br; $n < Nr && Ne[$n] !== null; $n++)
        st ? invariant(findDimensionValueType(Ne[$n]) === st, "All keyframes must be of the same type") : (st = findDimensionValueType(Ne[$n]), invariant(st === $e || isNumOrPxType($e) && isNumOrPxType(st), "Keyframes must be of the same dimension as the current value"));
    } else
      st = findDimensionValueType(Ne);
    if ($e !== st)
      if (isNumOrPxType($e) && isNumOrPxType(st)) {
        const Nr = Ee.get();
        typeof Nr == "string" && Ee.set(parseFloat(Nr)), typeof Ne == "string" ? y[we] = parseFloat(Ne) : Array.isArray(Ne) && st === px && (y[we] = Ne.map(parseFloat));
      } else
        $e != null && $e.transform && (st != null && st.transform) && (xe === 0 || Ne === 0) ? xe === 0 ? Ee.set(st.transform(xe)) : y[we] = $e.transform(Ne) : (he || (le = removeNonTranslationalTransform(v), he = !0), ge.push(we), ne[we] = ne[we] !== void 0 ? ne[we] : y[we], Ee.jump(Ne));
  }), ge.length) {
    const we = ge.indexOf("height") >= 0 ? window.pageYOffset : null, Ee = convertChangedValueTypes(y, v, ge);
    return le.length && le.forEach(([xe, $e]) => {
      v.getValue(xe).set($e);
    }), v.render(), isBrowser && we !== null && window.scrollTo({ top: we }), { target: Ee, transitionEnd: ne };
  } else
    return { target: y, transitionEnd: ne };
};
function unitConversion(v, y, z, ne) {
  return hasPositionalKey(y) ? checkAndConvertChangedValueTypes(v, y, z, ne) : { target: y, transitionEnd: ne };
}
const parseDomVariant = (v, y, z, ne) => {
  const ue = resolveCSSVariables(v, y, ne);
  return y = ue.target, ne = ue.transitionEnd, unitConversion(v, y, z, ne);
}, prefersReducedMotion = { current: null }, hasReducedMotionListener = { current: !1 };
function initPrefersReducedMotion() {
  if (hasReducedMotionListener.current = !0, !!isBrowser)
    if (window.matchMedia) {
      const v = window.matchMedia("(prefers-reduced-motion)"), y = () => prefersReducedMotion.current = v.matches;
      v.addListener(y), y();
    } else
      prefersReducedMotion.current = !1;
}
function updateMotionValuesFromProps(v, y, z) {
  const { willChange: ne } = y;
  for (const ue in y) {
    const le = y[ue], he = z[ue];
    if (isMotionValue(le))
      v.addValue(ue, le), isWillChangeMotionValue(ne) && ne.add(ue), process$1.env.NODE_ENV === "development" && warnOnce(le.version === "11.0.8", `Attempting to mix Framer Motion versions ${le.version} with 11.0.8 may not work as expected.`);
    else if (isMotionValue(he))
      v.addValue(ue, motionValue(le, { owner: v })), isWillChangeMotionValue(ne) && ne.remove(ue);
    else if (he !== le)
      if (v.hasValue(ue)) {
        const ge = v.getValue(ue);
        !ge.hasAnimated && ge.set(le);
      } else {
        const ge = v.getStaticValue(ue);
        v.addValue(ue, motionValue(ge !== void 0 ? ge : le, { owner: v }));
      }
  }
  for (const ue in z)
    y[ue] === void 0 && v.removeValue(ue);
  return y;
}
const visualElementStore = /* @__PURE__ */ new WeakMap(), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length, propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], numVariantProps = variantProps.length;
class VisualElement {
  constructor({ parent: y, props: z, presenceContext: ne, reducedMotionConfig: ue, visualState: le }, he = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => frame.render(this.render, !1, !0);
    const { latestValues: ge, renderState: we } = le;
    this.latestValues = ge, this.baseTarget = { ...ge }, this.initialValues = z.initial ? { ...ge } : {}, this.renderState = we, this.parent = y, this.props = z, this.presenceContext = ne, this.depth = y ? y.depth + 1 : 0, this.reducedMotionConfig = ue, this.options = he, this.isControllingVariants = isControllingVariants(z), this.isVariantNode = isVariantNode(z), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(y && y.current);
    const { willChange: Ee, ...xe } = this.scrapeMotionValuesFromProps(z, {});
    for (const $e in xe) {
      const Ne = xe[$e];
      ge[$e] !== void 0 && isMotionValue(Ne) && (Ne.set(ge[$e], !1), isWillChangeMotionValue(Ee) && Ee.add($e));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(y, z) {
    return {};
  }
  mount(y) {
    this.current = y, visualElementStore.set(y, this), this.projection && !this.projection.instance && this.projection.mount(y), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((z, ne) => this.bindToMotionValue(ne, z)), hasReducedMotionListener.current || initPrefersReducedMotion(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : prefersReducedMotion.current, process$1.env.NODE_ENV !== "production" && warnOnce(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore.delete(this.current), this.projection && this.projection.unmount(), cancelFrame(this.notifyUpdate), cancelFrame(this.render), this.valueSubscriptions.forEach((y) => y()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const y in this.events)
      this.events[y].clear();
    for (const y in this.features)
      this.features[y].unmount();
    this.current = null;
  }
  bindToMotionValue(y, z) {
    const ne = transformProps.has(y), ue = z.on("change", (he) => {
      this.latestValues[y] = he, this.props.onUpdate && frame.update(this.notifyUpdate, !1, !0), ne && this.projection && (this.projection.isTransformDirty = !0);
    }), le = z.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(y, () => {
      ue(), le();
    });
  }
  sortNodePosition(y) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== y.type ? 0 : this.sortInstanceNodePosition(this.current, y.current);
  }
  loadFeatures({ children: y, ...z }, ne, ue, le) {
    let he, ge;
    if (process$1.env.NODE_ENV !== "production" && ue && ne) {
      const we = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      z.ignoreStrict ? warning(!1, we) : invariant(!1, we);
    }
    for (let we = 0; we < numFeatures; we++) {
      const Ee = featureNames[we], { isEnabled: xe, Feature: $e, ProjectionNode: Ne, MeasureLayout: st } = featureDefinitions[Ee];
      Ne && (he = Ne), xe(z) && (!this.features[Ee] && $e && (this.features[Ee] = new $e(this)), st && (ge = st));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && he) {
      this.projection = new he(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: we, layout: Ee, drag: xe, dragConstraints: $e, layoutScroll: Ne, layoutRoot: st } = z;
      this.projection.setOptions({
        layoutId: we,
        layout: Ee,
        alwaysMeasureLayout: !!xe || $e && isRefObject($e),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof Ee == "string" ? Ee : "both",
        initialPromotionConfig: le,
        layoutScroll: Ne,
        layoutRoot: st
      });
    }
    return ge;
  }
  updateFeatures() {
    for (const y in this.features) {
      const z = this.features[y];
      z.isMounted ? z.update() : (z.mount(), z.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(y) {
    return this.latestValues[y];
  }
  setStaticValue(y, z) {
    this.latestValues[y] = z;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(y, z = !0) {
    return this.makeTargetAnimatableFromInstance(y, z);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(y, z) {
    (y.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = y, this.prevPresenceContext = this.presenceContext, this.presenceContext = z;
    for (let ne = 0; ne < propEventHandlers.length; ne++) {
      const ue = propEventHandlers[ne];
      this.propEventSubscriptions[ue] && (this.propEventSubscriptions[ue](), delete this.propEventSubscriptions[ue]);
      const le = y["on" + ue];
      le && (this.propEventSubscriptions[ue] = this.on(ue, le));
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(y, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(y) {
    return this.props.variants ? this.props.variants[y] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(y = !1) {
    if (y)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const ne = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (ne.initial = this.props.initial), ne;
    }
    const z = {};
    for (let ne = 0; ne < numVariantProps; ne++) {
      const ue = variantProps[ne], le = this.props[ue];
      (isVariantLabel(le) || le === !1) && (z[ue] = le);
    }
    return z;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(y) {
    const z = this.getClosestVariantNode();
    if (z)
      return z.variantChildren && z.variantChildren.add(y), () => z.variantChildren.delete(y);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(y, z) {
    z !== this.values.get(y) && (this.removeValue(y), this.bindToMotionValue(y, z)), this.values.set(y, z), this.latestValues[y] = z.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(y) {
    this.values.delete(y);
    const z = this.valueSubscriptions.get(y);
    z && (z(), this.valueSubscriptions.delete(y)), delete this.latestValues[y], this.removeValueFromRenderState(y, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(y) {
    return this.values.has(y);
  }
  getValue(y, z) {
    if (this.props.values && this.props.values[y])
      return this.props.values[y];
    let ne = this.values.get(y);
    return ne === void 0 && z !== void 0 && (ne = motionValue(z, { owner: this }), this.addValue(y, ne)), ne;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(y) {
    var z;
    return this.latestValues[y] !== void 0 || !this.current ? this.latestValues[y] : (z = this.getBaseTargetFromProps(this.props, y)) !== null && z !== void 0 ? z : this.readValueFromInstance(this.current, y, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(y, z) {
    this.baseTarget[y] = z;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(y) {
    var z;
    const { initial: ne } = this.props, ue = typeof ne == "string" || typeof ne == "object" ? (z = resolveVariantFromProps(this.props, ne)) === null || z === void 0 ? void 0 : z[y] : void 0;
    if (ne && ue !== void 0)
      return ue;
    const le = this.getBaseTargetFromProps(this.props, y);
    return le !== void 0 && !isMotionValue(le) ? le : this.initialValues[y] !== void 0 && ue === void 0 ? void 0 : this.baseTarget[y];
  }
  on(y, z) {
    return this.events[y] || (this.events[y] = new SubscriptionManager()), this.events[y].add(z);
  }
  notify(y, ...z) {
    this.events[y] && this.events[y].notify(...z);
  }
}
class DOMVisualElement extends VisualElement {
  sortInstanceNodePosition(y, z) {
    return y.compareDocumentPosition(z) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(y, z) {
    return y.style ? y.style[z] : void 0;
  }
  removeValueFromRenderState(y, { vars: z, style: ne }) {
    delete z[y], delete ne[y];
  }
  makeTargetAnimatableFromInstance({ transition: y, transitionEnd: z, ...ne }, ue) {
    const le = getOrigin(ne, y || {}, this);
    if (ue) {
      checkTargetForNewValues(this, ne, le);
      const he = parseDomVariant(this, ne, le, z);
      z = he.transitionEnd, ne = he.target;
    }
    return {
      transition: y,
      transitionEnd: z,
      ...ne
    };
  }
}
function getComputedStyle$1(v) {
  return window.getComputedStyle(v);
}
class HTMLVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(y, z) {
    if (transformProps.has(z)) {
      const ne = getDefaultValueType(z);
      return ne && ne.default || 0;
    } else {
      const ne = getComputedStyle$1(y), ue = (isCSSVariableName(z) ? ne.getPropertyValue(z) : ne[z]) || 0;
      return typeof ue == "string" ? ue.trim() : ue;
    }
  }
  measureInstanceViewportBox(y, { transformPagePoint: z }) {
    return measureViewportBox(y, z);
  }
  build(y, z, ne, ue) {
    buildHTMLStyles(y, z, ne, ue.transformTemplate);
  }
  scrapeMotionValuesFromProps(y, z) {
    return scrapeMotionValuesFromProps$1(y, z);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: y } = this.props;
    isMotionValue(y) && (this.childSubscription = y.on("change", (z) => {
      this.current && (this.current.textContent = `${z}`);
    }));
  }
  renderInstance(y, z, ne, ue) {
    renderHTML(y, z, ne, ue);
  }
}
class SVGVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(y, z) {
    return y[z];
  }
  readValueFromInstance(y, z) {
    if (transformProps.has(z)) {
      const ne = getDefaultValueType(z);
      return ne && ne.default || 0;
    }
    return z = camelCaseAttributes.has(z) ? z : camelToDash(z), y.getAttribute(z);
  }
  measureInstanceViewportBox() {
    return createBox();
  }
  scrapeMotionValuesFromProps(y, z) {
    return scrapeMotionValuesFromProps(y, z);
  }
  build(y, z, ne, ue) {
    buildSVGAttrs(y, z, ne, this.isSVGTag, ue.transformTemplate);
  }
  renderInstance(y, z, ne, ue) {
    renderSVG(y, z, ne, ue);
  }
  mount(y) {
    this.isSVGTag = isSVGTag(y.tagName), super.mount(y);
  }
}
const createDomVisualElement = (v, y) => isSVGComponent(v) ? new SVGVisualElement(y, { enableHardwareAcceleration: !1 }) : new HTMLVisualElement(y, { enableHardwareAcceleration: !0 }), layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
}, preloadedFeatures = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
}, motion = /* @__PURE__ */ createMotionProxy((v, y) => createDomMotionConfig(v, y, preloadedFeatures, createDomVisualElement));
function useIsMounted() {
  const v = useRef(!1);
  return useIsomorphicLayoutEffect$3(() => (v.current = !0, () => {
    v.current = !1;
  }), []), v;
}
function useForceUpdate() {
  const v = useIsMounted(), [y, z] = useState(0), ne = useCallback(() => {
    v.current && z(y + 1);
  }, [y]);
  return [useCallback(() => frame.postRender(ne), [ne]), y];
}
class PopChildMeasure extends a$z.Component {
  getSnapshotBeforeUpdate(y) {
    const z = this.props.childRef.current;
    if (z && y.isPresent && !this.props.isPresent) {
      const ne = this.props.sizeRef.current;
      ne.height = z.offsetHeight || 0, ne.width = z.offsetWidth || 0, ne.top = z.offsetTop, ne.left = z.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function PopChild({ children: v, isPresent: y }) {
  const z = useId(), ne = useRef(null), ue = useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return useInsertionEffect(() => {
    const { width: le, height: he, top: ge, left: we } = ue.current;
    if (y || !ne.current || !le || !he)
      return;
    ne.current.dataset.motionPopId = z;
    const Ee = document.createElement("style");
    return document.head.appendChild(Ee), Ee.sheet && Ee.sheet.insertRule(`
          [data-motion-pop-id="${z}"] {
            position: absolute !important;
            width: ${le}px !important;
            height: ${he}px !important;
            top: ${ge}px !important;
            left: ${we}px !important;
          }
        `), () => {
      document.head.removeChild(Ee);
    };
  }, [y]), a$z.createElement(PopChildMeasure, { isPresent: y, childRef: ne, sizeRef: ue }, a$z.cloneElement(v, { ref: ne }));
}
const PresenceChild = ({ children: v, initial: y, isPresent: z, onExitComplete: ne, custom: ue, presenceAffectsLayout: le, mode: he }) => {
  const ge = useConstant(newChildrenMap), we = useId(), Ee = useMemo(
    () => ({
      id: we,
      initial: y,
      isPresent: z,
      custom: ue,
      onExitComplete: (xe) => {
        ge.set(xe, !0);
        for (const $e of ge.values())
          if (!$e)
            return;
        ne && ne();
      },
      register: (xe) => (ge.set(xe, !1), () => ge.delete(xe))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    le ? void 0 : [z]
  );
  return useMemo(() => {
    ge.forEach((xe, $e) => ge.set($e, !1));
  }, [z]), a$z.useEffect(() => {
    !z && !ge.size && ne && ne();
  }, [z]), he === "popLayout" && (v = a$z.createElement(PopChild, { isPresent: z }, v)), a$z.createElement(PresenceContext.Provider, { value: Ee }, v);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
function useUnmountEffect(v) {
  return useEffect(() => () => v(), []);
}
const getChildKey = (v) => v.key || "";
function updateChildLookup(v, y) {
  v.forEach((z) => {
    const ne = getChildKey(z);
    y.set(ne, z);
  });
}
function onlyElements(v) {
  const y = [];
  return Children.forEach(v, (z) => {
    isValidElement(z) && y.push(z);
  }), y;
}
const AnimatePresence = ({ children: v, custom: y, initial: z = !0, onExitComplete: ne, exitBeforeEnter: ue, presenceAffectsLayout: le = !0, mode: he = "sync" }) => {
  invariant(!ue, "Replace exitBeforeEnter with mode='wait'");
  const ge = useContext(LayoutGroupContext).forceRender || useForceUpdate()[0], we = useIsMounted(), Ee = onlyElements(v);
  let xe = Ee;
  const $e = useRef(/* @__PURE__ */ new Map()).current, Ne = useRef(xe), st = useRef(/* @__PURE__ */ new Map()).current, Nr = useRef(!0);
  if (useIsomorphicLayoutEffect$3(() => {
    Nr.current = !1, updateChildLookup(Ee, st), Ne.current = xe;
  }), useUnmountEffect(() => {
    Nr.current = !0, st.clear(), $e.clear();
  }), Nr.current)
    return a$z.createElement(a$z.Fragment, null, xe.map((Rn) => a$z.createElement(PresenceChild, { key: getChildKey(Rn), isPresent: !0, initial: z ? void 0 : !1, presenceAffectsLayout: le, mode: he }, Rn)));
  xe = [...xe];
  const br = Ne.current.map(getChildKey), $n = Ee.map(getChildKey), En = br.length;
  for (let Rn = 0; Rn < En; Rn++) {
    const wa = br[Rn];
    $n.indexOf(wa) === -1 && !$e.has(wa) && $e.set(wa, void 0);
  }
  return he === "wait" && $e.size && (xe = []), $e.forEach((Rn, wa) => {
    if ($n.indexOf(wa) !== -1)
      return;
    const Aa = st.get(wa);
    if (!Aa)
      return;
    const _a = br.indexOf(wa);
    let Ta = Rn;
    if (!Ta) {
      const Zn = () => {
        $e.delete(wa);
        const Ra = Array.from(st.keys()).filter((Yn) => !$n.includes(Yn));
        if (Ra.forEach((Yn) => st.delete(Yn)), Ne.current = Ee.filter((Yn) => {
          const $o = getChildKey(Yn);
          return (
            // filter out the node exiting
            $o === wa || // filter out the leftover children
            Ra.includes($o)
          );
        }), !$e.size) {
          if (we.current === !1)
            return;
          ge(), ne && ne();
        }
      };
      Ta = a$z.createElement(PresenceChild, { key: getChildKey(Aa), isPresent: !1, onExitComplete: Zn, custom: y, presenceAffectsLayout: le, mode: he }, Aa), $e.set(wa, Ta);
    }
    xe.splice(_a, 0, Ta);
  }), xe = xe.map((Rn) => {
    const wa = Rn.key;
    return $e.has(wa) ? Rn : a$z.createElement(PresenceChild, { key: getChildKey(Rn), isPresent: !0, presenceAffectsLayout: le, mode: he }, Rn);
  }), process$1.env.NODE_ENV !== "production" && he === "wait" && xe.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), a$z.createElement(a$z.Fragment, null, $e.size ? xe : xe.map((Rn) => cloneElement(Rn)));
}, WalletClientContext = createContext(
  null
), WalletClientContextProvider = ({
  children: v,
  value: { connectWallet: y, userAddress: z, walletClient: ne, network: ue = Network.MAINNET }
}) => {
  const [le, he] = useState(!1), [ge, we] = useState(void 0);
  useEffect(() => {
    if (!window)
      return;
    const xe = window.sessionStorage.getItem(
      SessionStorageKeys.IS_COSMOS_WALLET_CONNECTED
    ), $e = z ? "true" : "false";
    window.sessionStorage.setItem(
      SessionStorageKeys.IS_COSMOS_WALLET_CONNECTED,
      $e
    );
    const Ne = new StorageEvent("storage", {
      key: SessionStorageKeys.IS_COSMOS_WALLET_CONNECTED,
      oldValue: xe,
      newValue: $e
    });
    return window.dispatchEvent(Ne), () => {
      window.sessionStorage.removeItem(
        SessionStorageKeys.IS_COSMOS_WALLET_CONNECTED
      );
    };
  }, [z]), useEffect(() => {
    window && (window.ELEMENTS_VERSION = "1.2.4");
  }, []);
  const Ee = useMemo(() => ({
    connectWallet: y,
    network: ue,
    userAddress: z,
    walletClient: ne,
    isLedgerWallet: le,
    isMainnet: ue === "mainnet",
    setIsLedgerWallet: he,
    walletConnectError: ge,
    setWalletConnectError: we
  }), [
    y,
    le,
    ue,
    z,
    ne,
    ge
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WalletClientContext.Provider, { value: Ee, children: v });
}, useWalletClientContext = () => {
  const v = useContext(WalletClientContext);
  if (!v)
    throw new Error(
      "useWalletClientContext must be used within a WalletClientContextProvider"
    );
  return v;
}, KADO_API_KEY = "aa0b559d-f936-43d0-a989-c42b5e0d3ea4", KADO_MIN_USD_AMOUNT = 3, currencyToCountryCode = {
  USD: "US",
  CAD: "CA",
  GBP: "GB",
  EUR: "EU",
  MXN: "MX",
  COP: "CO",
  INR: "IN",
  CHF: "CH",
  AUD: "AU",
  ARS: "AR",
  BRL: "BR",
  CLP: "CL",
  JPY: "JP",
  KRW: "KR",
  PEN: "PE",
  PHP: "PH",
  SGD: "SG",
  TRY: "TR",
  UYU: "UY",
  TWD: "TW",
  VND: "VN",
  CRC: "CR",
  SEK: "SE",
  PLN: "PL",
  DKK: "DK",
  NOK: "NO",
  NZD: "NZ"
}, multicall3ABI = [
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes[]", name: "returnData", type: "bytes[]" }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bool", name: "allowFailure", type: "bool" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call3[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bool", name: "allowFailure", type: "bool" },
          { internalType: "uint256", name: "value", type: "uint256" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call3Value[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3Value",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "blockAndAggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes32", name: "blockHash", type: "bytes32" },
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "getBasefee",
    outputs: [{ internalType: "uint256", name: "basefee", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "blockNumber", type: "uint256" }],
    name: "getBlockHash",
    outputs: [{ internalType: "bytes32", name: "blockHash", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getChainId",
    outputs: [{ internalType: "uint256", name: "chainid", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [{ internalType: "address", name: "coinbase", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [{ internalType: "uint256", name: "difficulty", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [{ internalType: "uint256", name: "gaslimit", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [{ internalType: "uint256", name: "timestamp", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "getEthBalance",
    outputs: [{ internalType: "uint256", name: "balance", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [{ internalType: "bytes32", name: "blockHash", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bool", name: "requireSuccess", type: "bool" },
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryAggregate",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bool", name: "requireSuccess", type: "bool" },
      {
        components: [
          { internalType: "address", name: "target", type: "address" },
          { internalType: "bytes", name: "callData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Call[]",
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "tryBlockAndAggregate",
    outputs: [
      { internalType: "uint256", name: "blockNumber", type: "uint256" },
      { internalType: "bytes32", name: "blockHash", type: "bytes32" },
      {
        components: [
          { internalType: "bool", name: "success", type: "bool" },
          { internalType: "bytes", name: "returnData", type: "bytes" }
        ],
        internalType: "struct Multicall3.Result[]",
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "payable",
    type: "function"
  }
];
function createAbi(v) {
  return v;
}
const erc20ABI = [
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "allowance",
    stateMutability: "view",
    inputs: [
      {
        name: "owner",
        type: "address"
      },
      {
        name: "spender",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "approve",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "spender",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [
      {
        name: "account",
        type: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ]
  },
  {
    type: "function",
    name: "name",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "symbol",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string"
      }
    ]
  },
  {
    type: "function",
    name: "totalSupply",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "transfer",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  },
  {
    type: "function",
    name: "transferFrom",
    stateMutability: "nonpayable",
    inputs: [
      {
        name: "sender",
        type: "address"
      },
      {
        name: "recipient",
        type: "address"
      },
      {
        name: "amount",
        type: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ]
  }
];
function useSourceAddress(v) {
  const { userAddress: y, walletClient: z, setIsLedgerWallet: ne, isLedgerWallet: ue } = useWalletClientContext(), le = useSourceAddress$1(y, z, v);
  return useEffect(() => {
    le.address ? (async () => {
      const ge = await (z == null ? void 0 : z.getAccount(
        v == null ? void 0 : v.chainId
      ));
      ge != null && ge.isNanoLedger ? ne(!0) : ne(!1);
    })() : ne(!1);
  }, [le, v, z, ne, ue]), le;
}
const useChainBalances = ({
  chainId: v
}) => {
  var he;
  const z = (he = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }).data) == null ? void 0 : he.find((ge) => ge.chainId === v), ne = useCosmosChainBalances({ chainId: v }), ue = useEvmChainBalances({ chainId: v }), le = useSvmChainBalances({ chainId: v });
  return (z == null ? void 0 : z.chainType) === "cosmos" ? ne : (z == null ? void 0 : z.chainType) === "evm" ? ue : le;
}, useCosmosChainBalances = ({
  chainId: v
}) => {
  var ge;
  const y = useChains(), { data: z } = useAllSkipAssets(), ne = useMemo(() => {
    var we;
    return !v || !z ? [] : ((we = z == null ? void 0 : z[v]) == null ? void 0 : we.filter(
      (Ee) => Ee.isCw20 && Ee.tokenContract
    )) ?? [];
  }, [z, v]), ue = useWalletClientContext(), le = (ge = y.data) == null ? void 0 : ge.find((we) => we.chainId === v), he = useSourceAddress(le);
  return useCosmosBalances(
    (he == null ? void 0 : he.address) ?? "",
    le,
    !!ue.userAddress && !!he.address,
    ne
  );
}, useEvmChainBalances = ({
  chainId: v
}) => {
  const { address: y } = useAccount(), z = usePublicClient({
    chainId: v ? parseInt(v) : void 0
  }), ne = useAllSkipAssets();
  return useSWR(
    v && y && z && ne.data ? `chainBalances:${v}:${y}` : null,
    async () => {
      var ge;
      const ue = (ge = ne.data) == null ? void 0 : ge[v], le = await z.multicall({
        multicallAddress: "0xcA11bde05977b3631167028862bE2a173976CA11",
        contracts: (ue == null ? void 0 : ue.map((we) => we.tokenContract ? {
          address: we.tokenContract,
          abi: erc20ABI$1,
          functionName: "balanceOf",
          args: [y]
        } : {
          address: "0xcA11bde05977b3631167028862bE2a173976CA11",
          abi: multicall3ABI,
          functionName: "getEthBalance",
          args: [y]
        })) ?? []
      }), he = ue == null ? void 0 : ue.reduce(
        (we, Ee, xe) => {
          var $e, Ne;
          return {
            ...we,
            [Ee.denom]: {
              coin: {
                denom: Ee.denom,
                amount: (($e = le[xe].result) == null ? void 0 : $e.toString()) || "0"
              },
              amount: new BigNumber(
                ((Ne = le[xe].result) == null ? void 0 : Ne.toString()) || "0"
              ).dividedBy(getDecimalPower10(Ee.decimals)),
              denomData: {
                chain: v,
                coinDenom: Ee.denom,
                coinDecimals: Ee.decimals,
                coinMinimalDenom: Ee.symbol,
                icon: Ee.logoUri
              },
              priceInUsd: null,
              valueInUsd: null
            }
          };
        },
        {}
      );
      return {
        chainId: v,
        balances: he
      };
    },
    {
      revalidateOnFocus: !1,
      revalidateOnReconnect: !0
    }
  );
}, useSvmChainBalances = ({
  chainId: v
}) => {
  var he;
  const { wallet: y } = useWallet(), z = (he = y == null ? void 0 : y.adapter.publicKey) == null ? void 0 : he.toBase58(), ne = useAllSkipAssets(), ue = "https://mainnet.helius-rpc.com/?api-key=a03caec1-c66a-417d-98f5-639cb761e0bc", le = new Connection(ue);
  return useSWR(
    v && z && le && ne.data ? `chainBalances:${v}:${z}` : null,
    async () => {
      var st;
      const ge = (st = ne.data) == null ? void 0 : st[v], we = await le.getBalance(new PublicKey(z)), Ee = {};
      v === "solana" && (Ee["solana-native"] = we.toString()), (await Promise.all(
        ge.filter((Nr) => Nr.denom !== "solana-devnet-native").map(async (Nr) => {
          try {
            const br = await token$1.getAssociatedTokenAddress(
              new PublicKey(Nr.denom),
              new PublicKey(z)
            ), $n = await token$1.getAccount(
              le,
              br
            );
            return {
              denom: Nr.denom,
              amount: $n.amount.toString()
            };
          } catch (br) {
            return br;
          }
        })
      )).filter(
        (Nr) => !(Nr instanceof Error)
      ).forEach((Nr) => {
        Nr instanceof Error || (Ee[Nr.denom] = Nr.amount);
      });
      const Ne = ge == null ? void 0 : ge.reduce(
        (Nr, br) => ({
          ...Nr,
          [br.denom]: {
            coin: {
              denom: br.denom,
              amount: Ee[br.denom] || "0"
            },
            amount: new BigNumber(Ee[br.denom] || "0").dividedBy(
              getDecimalPower10(br.decimals)
            ),
            denomData: {
              chain: v,
              coinDenom: br.denom,
              coinDecimals: br.decimals,
              coinMinimalDenom: br.symbol,
              icon: br.logoUri
            },
            priceInUsd: null,
            valueInUsd: null
          }
        }),
        {}
      );
      return {
        chainId: v,
        balances: Ne
      };
    },
    {
      revalidateOnFocus: !1,
      revalidateOnReconnect: !0
    }
  );
}, useFalseUntilItsTrue = (v) => {
  const [y, z] = useState(v);
  return useEffect(() => {
    y === !1 && v === !1 || y === !0 && v === !1 || y === !1 && v === !0 && z(!0);
  }, [y, v]), y;
}, ModalView = ({ isOpen: v, setIsOpen: y, children: z }) => {
  const ne = Bn$1(), ue = useFalseUntilItsTrue(v);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Y0$1, { modal: !0, open: ue, onOpenChange: y, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(X0$1, { container: ne, children: [
    v ? /* @__PURE__ */ jsxRuntimeExports.jsx(Ki, { className: "z-10" }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Q$,
      {
        tabIndex: -1,
        className: Y$1(
          "fixed left-[50%] top-[50%] z-50 grid translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background w-auto shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          v ? "block" : "hidden"
        ),
        children: z
      }
    )
  ] }) });
}, SourceRestrictionsContext = createContext(void 0), SourceRestrictionsProvider = ({ children: v, chains: y, allowedCurrencies: z }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SourceRestrictionsContext.Provider,
  {
    value: {
      chains: y,
      allowedCurrencies: z
    },
    children: v
  }
), useSourceRestrictionsContext = () => {
  const v = useContext(SourceRestrictionsContext);
  return useEffect(() => {
    v || console.warn(
      "Trying to access SourceRestrictionsContext, but it's not mounted on a parent"
    );
  }, [v]), v;
}, DestinationRestrictionsContext = createContext(void 0), DestinationRestrictionsProvider = ({ children: v, chains: y }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  DestinationRestrictionsContext.Provider,
  {
    value: {
      chains: y
    },
    children: v
  }
), useDestinationRestrictionsContext = () => {
  const v = useContext(DestinationRestrictionsContext);
  return useEffect(() => {
    v || console.warn(
      "Trying to access DestinationRestrictionsContext, but it's not mounted on a parent"
    );
  }, [v]), v;
}, Logo = ({ size: v = "16", className: y }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: v,
    height: (parseInt(v) * 0.75).toFixed(2),
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: y,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Logo", clipPath: "url(#clip0_2367_4215)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Layer 2", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "Layer 1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector",
            d: "M14.4137 7.99725C14.4137 10.298 11.6209 11.2334 8.15054 11.2334C4.68016 11.2334 1.84668 10.298 1.84668 7.99725C1.84668 5.69655 4.65983 3.83142 8.1302 3.83142C11.6006 3.83142 14.4137 5.69655 14.4137 7.99725Z",
            fill: "#1F7F58"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_2",
            d: "M13.7738 2.9774C13.7736 2.5252 13.6338 2.0841 13.3735 1.71433C13.1132 1.34457 12.7451 1.06416 12.3195 0.91142C11.8938 0.758676 11.4314 0.741037 10.9954 0.860913C10.5594 0.980788 10.171 1.23233 9.88331 1.5812C8.73627 1.32796 7.54778 1.32796 6.40074 1.5812C6.05122 1.15528 5.55437 0.876295 5.00877 0.799591C4.46316 0.722887 3.90865 0.854065 3.45525 1.1671C3.00184 1.48014 2.68266 1.95217 2.56103 2.48955C2.43939 3.02692 2.52419 3.59039 2.79859 4.06817C2.62222 4.43902 2.53001 4.84427 2.52854 5.25492C2.52854 7.38888 5.04154 9.11857 8.14101 9.11857C11.2405 9.11857 13.7535 7.38888 13.7535 5.25492C13.7522 4.84425 13.66 4.43896 13.4834 4.06817C13.6742 3.73635 13.7744 3.36017 13.7738 2.9774Z",
            fill: "#29A874"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_3",
            d: "M4.53156 4.19753C5.27279 4.19753 5.87368 3.59664 5.87368 2.85542C5.87368 2.11419 5.27279 1.51331 4.53156 1.51331C3.79034 1.51331 3.18945 2.11419 3.18945 2.85542C3.18945 3.59664 3.79034 4.19753 4.53156 4.19753Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_4",
            d: "M11.6888 4.19753C12.43 4.19753 13.0309 3.59664 13.0309 2.85542C13.0309 2.11419 12.43 1.51331 11.6888 1.51331C10.9476 1.51331 10.3467 2.11419 10.3467 2.85542C10.3467 3.59664 10.9476 4.19753 11.6888 4.19753Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_5",
            d: "M3.81331 11.0707C3.88142 11.0708 3.94877 11.0565 4.01098 11.0288C4.07319 11.001 4.12885 10.9605 4.17433 10.9098C4.21981 10.8591 4.25408 10.7994 4.27492 10.7345C4.29575 10.6697 4.30268 10.6012 4.29525 10.5335C4.18218 9.52528 3.68072 7.3413 1.48088 6.02765C-1.44736 4.27884 0.87083 10.298 0.87083 10.298L0.265253 10.647C0.221866 10.6718 0.187918 10.7104 0.168688 10.7566C0.149458 10.8027 0.146023 10.854 0.158918 10.9023C0.171812 10.9506 0.200313 10.9933 0.239989 11.0238C0.279666 11.0543 0.328295 11.0708 0.378316 11.0707H3.81331Z",
            fill: "#29A874"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_6",
            d: "M12.554 11.0707C12.2929 11.0707 12.0888 10.8202 12.118 10.5335C12.2205 9.52528 12.6736 7.3413 14.6619 6.02765C17.3088 4.27884 15.2134 10.298 15.2134 10.298L15.7608 10.647C15.9431 10.7629 15.8686 11.0707 15.6584 11.0707H12.554Z",
            fill: "#29A874"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_7",
            d: "M4.53113 3.09937C4.6659 3.09937 4.77515 2.99012 4.77515 2.85535C4.77515 2.72058 4.6659 2.61133 4.53113 2.61133C4.39636 2.61133 4.28711 2.72058 4.28711 2.85535C4.28711 2.99012 4.39636 3.09937 4.53113 3.09937Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            id: "Vector_8",
            d: "M11.6893 3.09937C11.8241 3.09937 11.9334 2.99012 11.9334 2.85535C11.9334 2.72058 11.8241 2.61133 11.6893 2.61133C11.5546 2.61133 11.4453 2.72058 11.4453 2.85535C11.4453 2.99012 11.5546 3.09937 11.6893 3.09937Z",
            fill: "black"
          }
        )
      ] }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_2367_4215", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "rect",
        {
          width: "16",
          height: "10.4522",
          fill: "white",
          transform: "translate(0 0.78125)"
        }
      ) }) })
    ]
  }
), GenericFallbackIcon = ({ size: v = "40" }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: v,
    height: v,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
          fill: "hsl(var(--secondary))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M10 14C10.55 14 11 13.55 11 13V12C11 11.45 11.45 11 12 11H13C13.55 11 14 10.55 14 10C14 9.45 13.55 9 13 9H12C10.34 9 9 10.34 9 12V13C9 13.55 9.45 14 10 14Z",
          fill: "hsl(var(--muted-foreground))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M13 29H12C11.45 29 11 28.55 11 28V27C11 26.45 10.55 26 10 26C9.45 26 9 26.45 9 27V28C9 29.66 10.34 31 12 31H13C13.55 31 14 30.55 14 30C14 29.45 13.55 29 13 29Z",
          fill: "hsl(var(--muted-foreground))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M28 9H27C26.45 9 26 9.45 26 10C26 10.55 26.45 11 27 11H28C28.55 11 29 11.45 29 12V13C29 13.55 29.45 14 30 14C30.55 14 31 13.55 31 13V12C31 10.34 29.66 9 28 9Z",
          fill: "hsl(var(--muted-foreground))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M30 26C29.45 26 29 26.45 29 27V28C29 28.55 28.55 29 28 29H27C26.45 29 26 29.45 26 30C26 30.55 26.45 31 27 31H28C29.66 31 31 29.66 31 28V27C31 26.45 30.55 26 30 26Z",
          fill: "hsl(var(--muted-foreground))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M27 22.87V17.13C27 16.41 26.62 15.75 26 15.4L21 12.52C20.69 12.34 20.35 12.25 20 12.25C19.65 12.25 19.31 12.34 19 12.52L14 15.39C13.38 15.75 13 16.41 13 17.13V22.87C13 23.59 13.38 24.25 14 24.6L19 27.48C19.31 27.66 19.65 27.75 20 27.75C20.35 27.75 20.69 27.66 21 27.48L26 24.6C26.62 24.25 27 23.59 27 22.87ZM19 25.17L15 22.87V18.24L19 20.57V25.17ZM20 18.84L16.04 16.53L20 14.25L23.96 16.53L20 18.84ZM25 22.87L21 25.17V20.57L25 18.24V22.87Z",
          fill: "hsl(var(--muted-foreground))"
        }
      )
    ]
  }
), Spinner = ({ size: v = "36", className: y }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    width: v,
    height: v,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: y,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M35.3 18C35.3 21.4216 34.2854 24.7664 32.3844 27.6114C30.4835 30.4563 27.7816 32.6737 24.6204 33.9831C21.4593 35.2925 17.9808 35.6351 14.6249 34.9676C11.2691 34.3001 8.1865 32.6524 5.76705 30.2329C3.3476 27.8135 1.69994 24.7309 1.03241 21.3751C0.36489 18.0192 0.707488 14.5407 2.01688 11.3796C3.32628 8.21841 5.54366 5.51652 8.38864 3.61558C11.2336 1.71463 14.5784 0.7 18 0.7",
          stroke: "url(#angular-spinner-paint)",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("linearGradient", { id: "angular-spinner-paint", cx: "0", cy: "0", r: "1", children: /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0", stopColor: "hsl(var(--foreground))" }) }) })
    ]
  }
), SwapFailureIcon = ({
  className: v,
  size: y = "128"
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  motion.svg,
  {
    width: y,
    height: y,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: Y$1("relative", v),
    initial: { scale: 0 },
    animate: { scale: 1 },
    transition: {
      duration: 0.25
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M59.2937 21.0585C61.8362 18.3257 66.1638 18.3257 68.7063 21.0585C70.5928 23.0862 73.5661 23.6776 76.085 22.5262C79.4797 20.9744 83.4779 22.6305 84.781 26.1282C85.748 28.7236 88.2686 30.4078 91.0364 30.3079C94.7665 30.1734 97.8266 33.2335 97.6921 36.9636C97.5922 39.7314 99.2764 42.252 101.872 43.219C105.369 44.5221 107.026 48.5203 105.474 51.915C104.322 54.4339 104.914 57.4072 106.942 59.2937C109.674 61.8362 109.674 66.1638 106.942 68.7063C104.914 70.5928 104.322 73.5661 105.474 76.085C107.026 79.4797 105.369 83.4779 101.872 84.781C99.2764 85.748 97.5922 88.2686 97.6921 91.0364C97.8266 94.7665 94.7665 97.8266 91.0364 97.6921C88.2686 97.5922 85.748 99.2764 84.781 101.872C83.4779 105.369 79.4797 107.026 76.085 105.474C73.5661 104.322 70.5928 104.914 68.7063 106.942C66.1638 109.674 61.8362 109.674 59.2937 106.942C57.4072 104.914 54.4339 104.322 51.915 105.474C48.5203 107.026 44.5221 105.369 43.219 101.872C42.252 99.2764 39.7314 97.5922 36.9636 97.6921C33.2335 97.8266 30.1734 94.7665 30.3079 91.0364C30.4078 88.2686 28.7236 85.748 26.1282 84.781C22.6305 83.4779 20.9744 79.4797 22.5262 76.085C23.6776 73.5661 23.0862 70.5928 21.0585 68.7063C18.3257 66.1638 18.3257 61.8362 21.0585 59.2937C23.0862 57.4072 23.6776 54.4339 22.5262 51.915C20.9744 48.5203 22.6305 44.5221 26.1282 43.219C28.7236 42.252 30.4078 39.7314 30.3079 36.9636C30.1734 33.2335 33.2335 30.1734 36.9636 30.3079C39.7314 30.4078 42.252 28.7236 43.219 26.1282C44.5221 22.6305 48.5203 20.9744 51.915 22.5262C54.4339 23.6776 57.4072 23.0862 59.2937 21.0585Z",
          fill: "hsl(var(--destructive))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          initial: { scale: 0 },
          animate: { scale: 1 },
          transition: {
            duration: 0.25,
            delay: 0.1
          },
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M64 37C66.2091 37 68 38.7909 68 41L68 71C68 73.2091 66.2091 75 64 75C61.7909 75 60 73.2091 60 71L60 41C60 38.7909 61.7909 37 64 37Z",
          fill: "hsl(var(--primary-foreground))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.circle,
        {
          initial: { scale: 0 },
          animate: { scale: 1 },
          transition: {
            duration: 0.25,
            delay: 0.1
          },
          cx: "64",
          cy: "87",
          r: "4",
          fill: "hsl(var(--primary-foreground))"
        }
      )
    ]
  }
), SwapSuccessfulIcon = ({
  className: v,
  size: y = "128"
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  motion.svg,
  {
    width: y,
    height: y,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: Y$1("relative", v),
    initial: { scale: 0 },
    animate: { scale: 1 },
    transition: {
      duration: 0.25
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "animate-[spin_9s_linear_infinite] origin-center",
          d: "M59.2937 21.0585C61.8362 18.3257 66.1638 18.3257 68.7063 21.0585C70.5928 23.0862 73.5661 23.6776 76.085 22.5262C79.4797 20.9744 83.4779 22.6305 84.781 26.1282C85.748 28.7236 88.2686 30.4078 91.0364 30.3079C94.7665 30.1734 97.8266 33.2335 97.6921 36.9636C97.5922 39.7314 99.2764 42.252 101.872 43.219C105.369 44.5221 107.026 48.5203 105.474 51.915C104.322 54.4339 104.914 57.4072 106.942 59.2937C109.674 61.8362 109.674 66.1638 106.942 68.7063C104.914 70.5928 104.322 73.5661 105.474 76.085C107.026 79.4797 105.369 83.4779 101.872 84.781C99.2764 85.748 97.5922 88.2686 97.6921 91.0364C97.8266 94.7665 94.7665 97.8266 91.0364 97.6921C88.2686 97.5922 85.748 99.2764 84.781 101.872C83.4779 105.369 79.4797 107.026 76.085 105.474C73.5661 104.322 70.5928 104.914 68.7063 106.942C66.1638 109.674 61.8362 109.674 59.2937 106.942C57.4072 104.914 54.4339 104.322 51.915 105.474C48.5203 107.026 44.5221 105.369 43.219 101.872C42.252 99.2764 39.7314 97.5922 36.9636 97.6921C33.2335 97.8266 30.1734 94.7665 30.3079 91.0364C30.4078 88.2686 28.7236 85.748 26.1282 84.781C22.6305 83.4779 20.9744 79.4797 22.5262 76.085C23.6776 73.5661 23.0862 70.5928 21.0585 68.7063C18.3257 66.1638 18.3257 61.8362 21.0585 59.2937C23.0862 57.4072 23.6776 54.4339 22.5262 51.915C20.9744 48.5203 22.6305 44.5221 26.1282 43.219C28.7236 42.252 30.4078 39.7314 30.3079 36.9636C30.1734 33.2335 33.2335 30.1734 36.9636 30.3079C39.7314 30.4078 42.252 28.7236 43.219 26.1282C44.5221 22.6305 48.5203 20.9744 51.915 22.5262C54.4339 23.6776 57.4072 23.0862 59.2937 21.0585Z",
          fill: "hsl(var(--success))"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          initial: { scale: 0 },
          animate: { scale: 1 },
          transition: {
            duration: 0.25,
            delay: 0.1
          },
          d: "M47.6938 62.518L57.5694 72.6689L80.3062 49.2984C81.1483 48.4328 82.2201 48 83.5215 48C84.823 48 85.8947 48.4328 86.7368 49.2984C87.5789 50.1639 88 51.2656 88 52.6033C88 53.941 87.5789 55.0426 86.7368 55.9082L60.7847 82.5836C59.866 83.5279 58.7943 84 57.5694 84C56.3445 84 55.2727 83.5279 54.3541 82.5836L41.2632 69.1279C40.4211 68.2623 40 67.1607 40 65.823C40 64.4852 40.4211 63.3836 41.2632 62.518C42.1053 61.6525 43.177 61.2197 44.4785 61.2197C45.7799 61.2197 46.8517 61.6525 47.6938 62.518Z",
          fill: "hsl(var(--primary-foreground))"
        }
      )
    ]
  }
), UserFallbackIcon = ({ size: v = "40" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: v,
    height: v,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M18 0.5C8.064 0.5 0 8.564 0 18.5C0 28.436 8.064 36.5 18 36.5C27.936 36.5 36 28.436 36 18.5C36 8.564 27.936 0.5 18 0.5ZM18 5.9C20.988 5.9 23.4 8.312 23.4 11.3C23.4 14.288 20.988 16.7 18 16.7C15.012 16.7 12.6 14.288 12.6 11.3C12.6 8.312 15.012 5.9 18 5.9ZM18 31.46C13.5 31.46 9.522 29.156 7.2 25.664C7.254 22.082 14.4 20.12 18 20.12C21.582 20.12 28.746 22.082 28.8 25.664C26.478 29.156 22.5 31.46 18 31.46Z",
        fill: "#141414"
      }
    )
  }
), IBCIcon = ({ size: v = "40" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    width: v,
    height: v,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3.90524 2.66317L1.92047 6.06019C1.81926 6.0361 1.71324 6.02164 1.60722 6.02164C0.831312 6.02164 0.199987 6.65296 0.199987 7.42887C0.199987 7.46509 0.201362 7.50099 0.204065 7.53654C0.20903 7.77213 0.271885 8.01002 0.398308 8.22899C0.798308 8.92181 1.68046 9.15818 2.37328 8.75818C2.703 8.56782 2.92463 8.26736 3.02952 7.92855L7.00355 7.94912C7.03328 8.04881 7.07377 8.14786 7.12678 8.23968C7.51474 8.91163 8.37714 9.14271 9.04909 8.75476C9.3132 8.60228 9.5092 8.3765 9.62628 8.1178C9.7371 7.91313 9.79999 7.67851 9.79999 7.42887C9.79999 6.62887 9.1542 5.98308 8.3542 5.98308C8.23854 5.98308 8.1277 6.00236 8.01686 6.02646L6.0517 2.65558C6.24225 2.44238 6.36267 2.17944 6.40329 1.90289C6.41852 1.81959 6.42649 1.73369 6.42649 1.64573C6.42649 0.845734 5.78071 0.199951 4.98071 0.199951C4.26679 0.199951 3.67568 0.714243 3.55674 1.39347C3.48544 1.73018 3.53378 2.09353 3.7199 2.41589C3.77242 2.50686 3.83673 2.58644 3.90524 2.66317ZM5.34244 3.08997L7.29878 6.44573C7.12716 6.63109 7.00199 6.858 6.94416 7.1108L3.03359 7.09705C2.99904 6.989 2.96031 6.88337 2.90248 6.78321C2.84465 6.68304 2.77253 6.59668 2.69624 6.51274L4.64828 3.09859C4.87509 3.15011 5.11273 3.14991 5.34244 3.08997ZM8.83026 7.50386C8.79397 7.73364 8.59377 7.9108 8.3542 7.9108C8.10394 7.9108 7.89663 7.71746 7.87427 7.47276C7.89558 7.33267 7.97781 7.20299 8.10934 7.12705C8.33888 6.99452 8.63513 7.0739 8.76766 7.30345C8.80423 7.36679 8.82467 7.43521 8.83026 7.50386ZM4.50227 1.58782C4.49997 1.60681 4.49878 1.62614 4.49878 1.64573C4.49878 1.91079 4.71565 2.12766 4.98071 2.12766C5.20586 2.12766 5.39624 1.97119 5.44846 1.76161C5.46354 1.65811 5.44539 1.54911 5.38935 1.45204C5.25682 1.22249 4.96057 1.14311 4.73102 1.27564C4.61006 1.34548 4.5308 1.46077 4.50227 1.58782ZM1.22669 7.73572C1.10314 7.50785 1.18364 7.21909 1.40943 7.08874C1.6139 6.97069 1.87128 7.02077 2.01875 7.19535C2.05743 7.26463 2.07951 7.3443 2.07951 7.42887C2.07951 7.69393 1.86264 7.91079 1.59758 7.91079C1.44884 7.91079 1.31527 7.8425 1.22669 7.73572Z",
        fill: "#141414"
      }
    )
  }
), LeapAndSkip = "data:image/svg+xml,%3csvg%20width='412'%20height='216'%20viewBox='0%200%20412%20216'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='216'%20height='216'%20rx='108'%20fill='%23BDEFCE'/%3e%3ccircle%20cx='108'%20cy='108'%20r='89'%20fill='%23CDF9DC'/%3e%3cpath%20d='M157.622%20123.981C157.622%20142.482%20135.793%20150%20108.689%20150C81.5849%20150%2059.4378%20142.482%2059.4378%20123.981C59.4378%20105.479%2081.426%2090.5082%20108.53%2090.5082C135.634%2090.5082%20157.622%20105.512%20157.622%20123.981Z'%20fill='%2324A95A'/%3e%3cpath%20d='M152.539%2083.6514C152.539%2073.9104%20144.849%2066%20135.38%2066C130.042%2066%20125.276%2068.517%20122.13%2072.4395C117.84%2071.4589%20113.265%2070.9032%20108.53%2070.9032C103.796%2070.9032%2099.2203%2071.4262%2094.9307%2072.4395C91.7532%2068.517%2086.987%2066%2081.6806%2066C72.2117%2066%2064.5222%2073.9104%2064.5222%2083.6514C64.5222%2086.8548%2065.3483%2089.8294%2066.7782%2092.4117C65.4119%2095.419%2064.6811%2098.6224%2064.6811%20101.957C64.6811%20119.118%2084.3179%20133.01%20108.53%20133.01C132.743%20133.01%20152.38%20119.118%20152.38%20101.957C152.38%2098.6224%20151.649%2095.419%20150.283%2092.4117C151.712%2089.8294%20152.539%2086.8548%20152.539%2083.6514Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M74.8086%20148.726C77.0647%20148.726%2078.8441%20146.699%2078.5899%20144.411C77.6684%20136.304%2073.7601%20118.751%2056.5699%20108.193C33.692%2094.1371%2051.8037%20142.515%2051.8037%20142.515L47.0692%20145.326C45.4805%20146.274%2046.1477%20148.726%2047.9589%20148.726H74.8086Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M74.8086%20148.726C77.0647%20148.726%2078.8441%20146.699%2078.5899%20144.411C77.6684%20136.304%2073.7601%20118.751%2056.5699%20108.193C33.692%2094.1371%2051.8037%20142.515%2051.8037%20142.515L47.0692%20145.326C45.4805%20146.274%2046.1477%20148.726%2047.9589%20148.726H74.8086Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M143.076%20148.726C141.042%20148.726%20139.453%20146.699%20139.676%20144.411C140.47%20136.337%20144.029%20118.751%20159.535%20108.193C180.22%2094.1371%20163.856%20142.515%20163.856%20142.515L168.146%20145.326C169.576%20146.274%20168.972%20148.726%20167.352%20148.726H143.076Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M143.076%20148.726C141.042%20148.726%20139.453%20146.699%20139.676%20144.411C140.47%20136.337%20144.029%20118.751%20159.535%20108.193C180.22%2094.1371%20163.856%20142.515%20163.856%20142.515L168.146%20145.326C169.576%20146.274%20168.972%20148.726%20167.352%20148.726H143.076Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M80.4061%2093.5159C86.1972%2093.5159%2090.8918%2088.6864%2090.8918%2082.729C90.8918%2076.7715%2086.1972%2071.942%2080.4061%2071.942C74.6151%2071.942%2069.9204%2076.7715%2069.9204%2082.729C69.9204%2088.6864%2074.6151%2093.5159%2080.4061%2093.5159Z'%20fill='url(%23paint0_linear_4549_4678)'/%3e%3cpath%20d='M80.4257%2088.5595C83.5845%2088.5595%2086.1452%2085.9253%2086.1452%2082.6758C86.1452%2079.4263%2083.5845%2076.7921%2080.4257%2076.7921C77.2669%2076.7921%2074.7062%2079.4263%2074.7062%2082.6758C74.7062%2085.9253%2077.2669%2088.5595%2080.4257%2088.5595Z'%20fill='black'/%3e%3cpath%20d='M136.367%2093.5159C142.158%2093.5159%20146.852%2088.6864%20146.852%2082.729C146.852%2076.7715%20142.158%2071.942%20136.367%2071.942C130.576%2071.942%20125.881%2076.7715%20125.881%2082.729C125.881%2088.6864%20130.576%2093.5159%20136.367%2093.5159Z'%20fill='url(%23paint1_linear_4549_4678)'/%3e%3cpath%20d='M136.323%2088.5595C139.481%2088.5595%20142.042%2085.9253%20142.042%2082.6758C142.042%2079.4263%20139.481%2076.7921%20136.323%2076.7921C133.164%2076.7921%20130.603%2079.4263%20130.603%2082.6758C130.603%2085.9253%20133.164%2088.5595%20136.323%2088.5595Z'%20fill='black'/%3e%3cpath%20d='M95.9199%20110.709C95.7252%20112.25%2095.8335%20113.815%2096.2386%20115.314C96.6437%20116.813%2097.3378%20118.217%2098.2811%20119.445C99.2245%20120.674%20100.399%20121.703%20101.737%20122.475C103.075%20123.246%20104.55%20123.744%20106.079%20123.94C107.608%20124.136%20109.16%20124.027%20110.647%20123.619C112.134%20123.21%20113.527%20122.511%20114.745%20121.56C115.964%20120.609%20116.985%20119.425%20117.75%20118.076C118.515%20116.728%20119.009%20115.24%20119.204%20113.699L95.9199%20110.709Z'%20fill='%23092511'/%3e%3crect%20x='196'%20width='216'%20height='216'%20rx='108'%20fill='%233D3D3D'/%3e%3ccircle%20cx='304'%20cy='108'%20r='89'%20fill='black'/%3e%3cg%20clip-path='url(%23clip0_4549_4678)'%3e%3cpath%20d='M366.744%20111.334C364.63%20108.959%20362.124%20106.532%20359.253%20104.13L358.314%2098.7798C356.069%2086.1212%20349.413%2074.5327%20339.521%2066.1545C329.525%2057.6719%20316.814%2053%20303.712%2053C289.017%2053%20274.688%2059.0031%20264.301%2069.4693C261.325%2069.0256%20256.575%2068.4775%20254.043%2068.4775C239.505%2068.4775%20234.572%2075.655%20232.928%2079.9355C229.979%2087.6089%20232.667%2096.4569%20240.706%20105.566C242.82%20107.941%20245.326%20110.368%20248.197%20112.77L249.136%20118.12C251.381%20130.779%20258.036%20142.367%20267.928%20150.745C277.925%20159.228%20290.636%20163.9%20303.738%20163.9C318.302%20163.9%20332.005%20158.315%20342.445%20148.135C345.316%20148.396%20349.387%20148.449%20352.728%20148.449H353.433C367.971%20148.449%20372.904%20141.271%20374.548%20136.991C377.471%20129.291%20374.783%20120.417%20366.744%20111.334Z'%20fill='black'/%3e%3cpath%20d='M303.716%2062.2932C324.544%2062.2932%20342.188%2076.1524%20347.93%2095.1534C350.174%2096.5367%20352.341%2097.9984%20354.403%2099.4861C350.148%2075.3694%20329.033%2056.9688%20303.716%2056.9688C279.886%2056.9688%20259.789%2073.2553%20253.969%2095.2839C255.378%2096.5106%20256.918%2097.7113%20258.562%2098.9119C262.947%2078.0317%20281.531%2062.2932%20303.716%2062.2932Z'%20fill='white'/%3e%3cpath%20d='M348.89%20117.988C344.479%20138.895%20325.895%20154.607%20303.71%20154.607C282.882%20154.607%20265.238%20140.748%20259.496%20121.747C257.252%20120.363%20255.085%20118.902%20253.023%20117.414C257.278%20141.531%20278.393%20159.905%20303.71%20159.905C327.54%20159.905%20347.637%20143.619%20353.457%20121.59C352.074%20120.389%20350.534%20119.163%20348.89%20117.988Z'%20fill='white'/%3e%3cpath%20d='M353.403%20144.454C362.408%20144.454%20368.593%20141.296%20370.812%20135.528C373.84%20127.698%20368.646%20119.477%20363.765%20113.943C357.527%20106.896%20347.844%2099.8492%20337.169%2094.603C319.186%2085.755%20301.933%2083.3277%20293.216%2088.3911C292.198%2088.9915%20291.415%2090.0094%20291.076%2091.2361C290.71%2092.4889%20290.815%2093.7939%20291.337%2094.9684C291.859%2096.1168%20292.772%2096.9781%20293.868%2097.3957C294.965%2097.7872%20296.139%2097.6828%20297.183%2097.0825C302.508%2094.0027%20316.758%2095.2294%20333.724%20103.581C335.029%20104.234%20336.334%20104.913%20337.639%20105.617C345.965%20109.898%20353.429%20115.013%20358.649%20120.077C367.315%20128.455%20367.523%20134.406%20366.166%20137.903C364.626%20141.923%20359.38%20143.959%20350.584%20143.959C348.914%20143.959%20347.113%20143.88%20345.208%20143.724C348.105%20144.193%20350.845%20144.454%20353.403%20144.454C353.377%20144.454%20353.377%20144.454%20353.403%20144.454Z'%20fill='white'/%3e%3cpath%20d='M254.042%2072.4453C245.038%2072.4453%20238.852%2075.6034%20236.633%2081.3716C233.606%2089.2017%20238.8%2097.4233%20243.68%20102.957C249.918%20110.004%20259.602%20117.051%20270.277%20122.297C288.26%20131.145%20305.512%20133.572%20314.229%20128.509C315.247%20127.908%20316.03%20126.89%20316.37%20125.664C316.735%20124.411%20316.631%20123.106%20316.109%20121.931C315.587%20120.783%20314.673%20119.922%20313.577%20119.504C312.481%20119.113%20311.306%20119.217%20310.262%20119.817C304.938%20122.897%20290.687%20121.67%20273.722%20113.318C272.417%20112.666%20271.112%20111.987%20269.807%20111.282C261.481%20107.002%20254.016%20101.886%20248.796%2096.823C240.131%2088.4448%20239.922%2082.4939%20241.279%2078.9965C242.819%2074.977%20248.065%2072.9412%20256.861%2072.9412C258.532%2072.9412%20260.332%2073.0195%20262.238%2073.1761C259.341%2072.7063%20256.6%2072.4453%20254.042%2072.4453Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_4549_4678'%20x1='107.5'%20y1='66'%20x2='107.5'%20y2='150'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%23C4C4C4'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_4549_4678'%20x1='107.5'%20y1='66'%20x2='107.5'%20y2='150'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%23C4C4C4'/%3e%3c/linearGradient%3e%3cclipPath%20id='clip0_4549_4678'%3e%3crect%20width='143.917'%20height='110.9'%20fill='white'%20transform='translate(231.742%2053)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", LeapAndKado = "data:image/svg+xml,%3csvg%20width='412'%20height='216'%20viewBox='0%200%20412%20216'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='216'%20height='216'%20rx='108'%20fill='%23BDEFCE'/%3e%3ccircle%20cx='108'%20cy='108'%20r='89'%20fill='%23CDF9DC'/%3e%3cpath%20d='M157.622%20123.981C157.622%20142.482%20135.793%20150%20108.689%20150C81.5849%20150%2059.4378%20142.482%2059.4378%20123.981C59.4378%20105.479%2081.426%2090.5082%20108.53%2090.5082C135.634%2090.5082%20157.622%20105.512%20157.622%20123.981Z'%20fill='%2324A95A'/%3e%3cpath%20d='M152.539%2083.6514C152.539%2073.9104%20144.849%2066%20135.38%2066C130.042%2066%20125.276%2068.517%20122.13%2072.4395C117.84%2071.4589%20113.265%2070.9032%20108.53%2070.9032C103.796%2070.9032%2099.2203%2071.4262%2094.9307%2072.4395C91.7532%2068.517%2086.987%2066%2081.6806%2066C72.2117%2066%2064.5222%2073.9104%2064.5222%2083.6514C64.5222%2086.8548%2065.3483%2089.8294%2066.7782%2092.4117C65.4119%2095.419%2064.6811%2098.6224%2064.6811%20101.957C64.6811%20119.118%2084.3179%20133.01%20108.53%20133.01C132.743%20133.01%20152.38%20119.118%20152.38%20101.957C152.38%2098.6224%20151.649%2095.419%20150.283%2092.4117C151.712%2089.8294%20152.539%2086.8548%20152.539%2083.6514Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M74.8086%20148.726C77.0647%20148.726%2078.8441%20146.699%2078.5899%20144.411C77.6684%20136.304%2073.7601%20118.751%2056.5699%20108.193C33.692%2094.1371%2051.8037%20142.515%2051.8037%20142.515L47.0692%20145.326C45.4805%20146.274%2046.1477%20148.726%2047.9589%20148.726H74.8086Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M74.8086%20148.726C77.0647%20148.726%2078.8441%20146.699%2078.5899%20144.411C77.6684%20136.304%2073.7601%20118.751%2056.5699%20108.193C33.692%2094.1371%2051.8037%20142.515%2051.8037%20142.515L47.0692%20145.326C45.4805%20146.274%2046.1477%20148.726%2047.9589%20148.726H74.8086Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M143.076%20148.726C141.042%20148.726%20139.453%20146.699%20139.676%20144.411C140.47%20136.337%20144.029%20118.751%20159.535%20108.193C180.22%2094.1371%20163.856%20142.515%20163.856%20142.515L168.146%20145.326C169.576%20146.274%20168.972%20148.726%20167.352%20148.726H143.076Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M143.076%20148.726C141.042%20148.726%20139.453%20146.699%20139.676%20144.411C140.47%20136.337%20144.029%20118.751%20159.535%20108.193C180.22%2094.1371%20163.856%20142.515%20163.856%20142.515L168.146%20145.326C169.576%20146.274%20168.972%20148.726%20167.352%20148.726H143.076Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M80.4061%2093.5159C86.1972%2093.5159%2090.8918%2088.6864%2090.8918%2082.729C90.8918%2076.7715%2086.1972%2071.942%2080.4061%2071.942C74.6151%2071.942%2069.9204%2076.7715%2069.9204%2082.729C69.9204%2088.6864%2074.6151%2093.5159%2080.4061%2093.5159Z'%20fill='url(%23paint0_linear_4552_4731)'/%3e%3cpath%20d='M80.4257%2088.5595C83.5845%2088.5595%2086.1452%2085.9253%2086.1452%2082.6758C86.1452%2079.4263%2083.5845%2076.7921%2080.4257%2076.7921C77.2669%2076.7921%2074.7062%2079.4263%2074.7062%2082.6758C74.7062%2085.9253%2077.2669%2088.5595%2080.4257%2088.5595Z'%20fill='black'/%3e%3cpath%20d='M136.367%2093.5159C142.158%2093.5159%20146.852%2088.6864%20146.852%2082.729C146.852%2076.7715%20142.158%2071.942%20136.367%2071.942C130.576%2071.942%20125.881%2076.7715%20125.881%2082.729C125.881%2088.6864%20130.576%2093.5159%20136.367%2093.5159Z'%20fill='url(%23paint1_linear_4552_4731)'/%3e%3cpath%20d='M136.323%2088.5595C139.481%2088.5595%20142.042%2085.9253%20142.042%2082.6758C142.042%2079.4263%20139.481%2076.7921%20136.323%2076.7921C133.164%2076.7921%20130.603%2079.4263%20130.603%2082.6758C130.603%2085.9253%20133.164%2088.5595%20136.323%2088.5595Z'%20fill='black'/%3e%3cpath%20d='M95.9199%20110.709C95.7252%20112.25%2095.8335%20113.815%2096.2386%20115.314C96.6437%20116.813%2097.3378%20118.217%2098.2811%20119.445C99.2245%20120.674%20100.399%20121.703%20101.737%20122.475C103.075%20123.246%20104.55%20123.744%20106.079%20123.94C107.608%20124.136%20109.16%20124.027%20110.647%20123.619C112.134%20123.21%20113.527%20122.511%20114.745%20121.56C115.964%20120.609%20116.985%20119.425%20117.75%20118.076C118.515%20116.728%20119.009%20115.24%20119.204%20113.699L95.9199%20110.709Z'%20fill='%23092511'/%3e%3crect%20x='196'%20width='216'%20height='216'%20rx='108'%20fill='%23AEC5EB'/%3e%3ccircle%20cx='304'%20cy='108'%20r='89'%20fill='%23C4DAFE'/%3e%3cpath%20opacity='0.75'%20d='M344.601%20123.615C347.882%20114.607%20349.169%20104.892%20347.818%2095.3697C345.502%2079.0271%20336.816%2066.4165%20320.473%2057.5376C299.692%2046.0851%20271.511%2050.1385%20254.654%2066.9313C245.324%2076.2607%20239.662%2091.7021%20247.19%20102.576C252.659%20110.425%20263.147%20113.32%20269.323%20120.591C277.044%20129.727%20276.465%20143.817%20284.122%20152.954C290.941%20161.061%20303.166%20163.313%20313.203%20159.967C321.631%20157.2%20336.816%20144.912%20344.601%20123.615Z'%20fill='%235493F7'/%3e%3cpath%20opacity='0.8'%20d='M313.203%20160.03C321.631%20157.263%20336.815%20144.975%20344.6%20123.678C347.882%20114.671%20349.683%20105.985%20347.817%2095.4328C341.576%2060.6248%20298.919%20105.405%20291.52%20109.973C276.979%20118.917%20272.99%20138.605%20283.349%20152.181C283.606%20152.502%20283.799%20152.824%20284.056%20153.081C290.877%20161.124%20303.165%20163.312%20313.203%20160.03Z'%20fill='%232043B5'/%3e%3cpath%20opacity='0.7'%20d='M326.459%2062.9427C317.451%2059.6614%20307.736%2058.3746%20298.213%2059.7257C281.871%2062.0419%20269.26%2070.7279%20260.381%2087.0702C248.929%20107.852%20252.982%20136.033%20269.775%20152.89C279.104%20162.219%20294.546%20167.881%20305.419%20160.353C313.269%20154.885%20316.164%20144.397%20323.435%20138.221C332.571%20130.5%20346.662%20131.079%20355.797%20123.422C363.905%20116.602%20366.156%20104.378%20362.811%2094.3404C360.044%2085.9121%20347.755%2070.7278%20326.459%2062.9427Z'%20fill='%233573EC'/%3e%3cpath%20d='M307.792%20131.726L299.492%20114.997L293.959%20120.08L291.45%20131.726H281.992L291.064%2088.875H300.586L297.047%20105.539L315.32%2088.875H328.51L306.956%20108.305L319.181%20131.726H307.792Z'%20fill='white'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_4552_4731'%20x1='107.5'%20y1='66'%20x2='107.5'%20y2='150'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%23C4C4C4'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_4552_4731'%20x1='107.5'%20y1='66'%20x2='107.5'%20y2='150'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%23C4C4C4'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", PoweredByLeap = forwardRef(
  ({ className: v, style: y }, z) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: Y$1(
        "text-sm flex justify-center items-center gap-2 p-4",
        v
      ),
      style: y,
      ref: z,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            className: "no-underline outline-none focus-visible:ring text-secondary-foreground py-0.5",
            href: "https://leapwallet.io",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Powered by Leap"
          }
        )
      ]
    }
  )
), PoweredByLeapAndSkip = forwardRef(
  ({ className: v, style: y }, z) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: Y$1(
        "text-sm flex justify-center items-center gap-2 p-4",
        v
      ),
      style: y,
      ref: z,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "h-5", src: LeapAndSkip, alt: "Leap and Skip" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "no-underline text-secondary-foreground py-0.5", children: [
          "Powered by",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: "https://leapwallet.io",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-primary focus-visible:text-primary outline-none rounded ring-ring focus-visible:ring-2",
              children: "Leap"
            }
          ),
          " ",
          "&",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: "https://skip.money/",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-primary focus-visible:text-primary outline-none rounded ring-ring focus-visible:ring-2",
              children: "Skip"
            }
          )
        ] })
      ]
    }
  )
), PoweredByLeapAndKado = forwardRef(
  ({ className: v, style: y }, z) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: Y$1(
        "text-sm flex justify-center items-center gap-2 p-4",
        v
      ),
      style: y,
      ref: z,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "h-5", src: LeapAndKado, alt: "Leap and Kado" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "no-underline text-secondary-foreground py-0.5", children: [
          "Powered by",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: "https://leapwallet.io",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-primary focus-visible:text-primary outline-none rounded ring-ring focus-visible:ring-2",
              children: "Leap"
            }
          ),
          " ",
          "&",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "a",
            {
              href: "https://www.kado.money/",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "transition-colors hover:text-primary focus-visible:text-primary outline-none rounded ring-ring focus-visible:ring-2",
              children: "Kado"
            }
          )
        ] })
      ]
    }
  )
), formatAmount = (v, y = 0, z = 2, ne = "standard") => {
  const ue = new BigNumber(v), le = new BigNumber(10).pow(-z);
  if (ue.isNaN())
    return "";
  if (ue.isZero())
    return "0";
  if (ue.isLessThan(le))
    return `< ${le}`;
  const he = ue.isGreaterThanOrEqualTo(100) ? 2 : y;
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: ne,
    maximumFractionDigits: ue.isGreaterThanOrEqualTo(100) ? he : z,
    minimumFractionDigits: he
  }).format(ue.toNumber()).slice(1);
}, formatAmountWithPrefix = (v, y, z = 0, ne = 2, ue = "standard") => {
  const le = formatAmount(
    v,
    z,
    ne,
    ue
  );
  return le.startsWith("<") ? `< ${y}${le.slice(2)}` : `${y}${le}`;
};
function showTrimmedTxnHash(v, y = 6, z = 4) {
  return !v || typeof v != "string" ? "Invalid Transaction Hash" : `${v.slice(0, y)}...${v.slice(
    -z
  )}`;
}
const leapCosmosLogo = "https://assets.leapwallet.io/logos/leap-cosmos-logo.svg", sliceAddress = (v, y = 5) => v ? v.slice(0, y) + "..." + v.slice(v.length - y, v.length) : "", convertAddress = (v, y) => {
  const z = bech32$6.decode(v);
  return bech32$6.encode(y, z.words);
}, getCosmosTokenSorter = (v) => {
  const y = (z) => {
    var ne, ue;
    return Array.isArray(v) ? (ne = v.find((le) => le.coin.denom === z)) == null ? void 0 : ne.amount : (ue = v == null ? void 0 : v[z]) == null ? void 0 : ue.amount;
  };
  return (z, ne) => {
    var we;
    const ue = y(z.denom), le = y(ne.denom);
    if (!ue && !le)
      return (we = z.symbol) == null ? void 0 : we.localeCompare(ne.symbol);
    const he = new BigNumber(ue ?? "0"), ge = new BigNumber(le ?? "0");
    return he.isGreaterThan(ge) ? -1 : he.isLessThan(ge) ? 1 : 0;
  };
}, iosRegex = /iPad|iPhone|iPod/i, isIOSDevice = (v) => iosRegex.test(v), windowsPhoneRegex = /Windows Phone/i, isWindowsPhoneDevice = (v) => windowsPhoneRegex.test(v), androidRegex = /Android/i, isAndroidDevice = (v) => androidRegex.test(v), blackberryRegex = /BlackBerry/i, isBlackberryDevice = (v) => blackberryRegex.test(v), isMobileDevice = (v) => isIOSDevice(v) || isWindowsPhoneDevice(v) || isAndroidDevice(v) || isBlackberryDevice(v), sdkErrors = {
  2: "due to transaction parsing failure.",
  3: "due to incorrect sequence number (nonce) for the signature.",
  4: "due to invalid transaction signature.",
  5: "due to insufficient account funds.",
  6: "due to unrecognized request.",
  7: "due to invalid address.",
  8: "due to invalid public key.",
  9: "due to unknown address.",
  10: "due to invalid coins.",
  11: "as the operation ran out of gas.",
  12: "as the memo was too long.",
  13: "due to insufficient fee.",
  14: "as maximum number of signatures was exceeded.",
  15: "as no signatures were supplied.",
  16: "as conversion to JSON format failed.",
  17: "as conversion from JSON format failed.",
  18: "due to invalid request data.",
  19: "as transaction already exists in the mempool.",
  20: "as the mempool is full.",
  21: "as the transaction is too large.",
  22: "due to key not found.",
  23: "due to invalid account password.",
  24: "as intended signer of the transaction does not match the given signer.",
  25: "due to invalid gas adjustment.",
  26: "due to invalid height.",
  27: "due to invalid version.",
  28: "due to invalid chain-id.",
  29: "due to invalid type.",
  30: "as transaction was rejected due to timeout height.",
  31: "due to unknown extension options.",
  32: "as account sequence in signer info does not match actual account sequence.",
  33: "as packing of protobuf message to Any failed.",
  34: "as unpacking of protobuf message from Any failed.",
  35: "due to internal logic error.",
  36: "due to conflict while accessing a shared resource.",
  37: "as the requested feature is not supported.",
  38: "as the requested entity doesn't exist in the state.",
  39: "due to internal Input/Output error.",
  40: "due to error in application configuration (app.toml).",
  41: "due to invalid gas limit."
}, getErrorMessageFromCode = (v, y = "sdk") => y === "sdk" ? sdkErrors[v] ?? "due to an unknown error." : "due to an unknown error.", sleep = async (v = 1e3) => {
  await new Promise((y) => setTimeout(y, v));
}, convertDenomDataToAsset = (v) => ({
  denom: v.coinMinimalDenom,
  decimals: v.coinDecimals,
  logoUri: v.icon,
  icon: v.icon,
  originDenom: v.coinMinimalDenom,
  symbol: v.coinDenom
}), convertIntoMessage = (v) => {
  const y = v.multi_chain_msg;
  switch (y.msg_type_url) {
    case "/cosmos.bank.v1beta1.MsgSend":
      return {
        chainId: y.chain_id,
        typeUrl: y.msg_type_url,
        value: snakeCaseToCamelCaseObject(JSON.parse(y.msg))
      };
    case "/ibc.applications.transfer.v1.MsgTransfer":
      return {
        chainId: y.chain_id,
        typeUrl: y.msg_type_url,
        value: snakeCaseToCamelCaseObject(
          JSON.parse(y.msg)
        )
      };
    case "/cosmwasm.wasm.v1.MsgExecuteContract":
      return {
        chainId: y.chain_id,
        typeUrl: y.msg_type_url,
        value: snakeCaseToCamelCaseObject(
          JSON.parse(y.msg)
        )
      };
    case "/circle.cctp.v1.MsgDepositForBurn":
      return {
        chainId: y.chain_id,
        typeUrl: y.msg_type_url,
        value: snakeCaseToCamelCaseObject(
          JSON.parse(y.msg)
        )
      };
    case "/circle.cctp.v1.MsgDepositForBurnWithCaller":
      return {
        chainId: y.chain_id,
        typeUrl: y.msg_type_url,
        value: snakeCaseToCamelCaseObject(
          JSON.parse(y.msg)
        )
      };
  }
}, getSwapAmountsFromMessages = async (v, y, z) => {
  const ne = v.messages.filter(
    (le) => "multi_chain_msg" in le
  ), ue = ne.length;
  if (ue === 1)
    return [
      {
        fromAmount: v.amountIn,
        toAmount: v.amountOut
      }
    ];
  if (ue === 2) {
    const le = {
      fromAmount: v.amountIn,
      toAmount: ""
    }, he = {
      fromAmount: "",
      toAmount: v.amountOut
    }, ge = convertIntoMessage(ne[0]), we = convertIntoMessage(ne[1]);
    switch (ge.typeUrl) {
      case "/cosmos.bank.v1beta1.MsgSend": {
        const Ee = y.find(
          ($e) => $e.chainId === ge.chainId
        ), xe = await getCosmosSendMessageWithInfo(
          Ee,
          ge.value,
          y,
          z
        );
        le.toAmount = xe.info.amount;
        break;
      }
      case "/ibc.applications.transfer.v1.MsgTransfer": {
        const Ee = y.find(
          ($e) => $e.chainId === ge.chainId
        ), xe = await getIbcTransferMessageWithInfo(
          Ee,
          ge.value,
          ge.value.receiver,
          y,
          z
        );
        le.toAmount = xe.info.amount;
        break;
      }
      case "/cosmwasm.wasm.v1.MsgExecuteContract": {
        const xe = JSON.parse(
          Buffer.from(ge.value.msg).toString("utf-8")
        ).swap_and_action.min_asset.native, $e = await getDenomData(
          xe.denom,
          ge.chainId,
          y,
          z
        ), Ne = ($e == null ? void 0 : $e.coinDecimals) ?? 6, st = new BigNumber(xe.amount).dividedBy(
          getDecimalPower10(Ne)
        );
        le.toAmount = st.toFixed();
        break;
      }
    }
    switch (we.typeUrl) {
      case "/cosmos.bank.v1beta1.MsgSend": {
        const Ee = y.find(
          ($e) => $e.chainId === we.chainId
        ), xe = await getCosmosSendMessageWithInfo(
          Ee,
          we.value,
          y,
          z
        );
        he.fromAmount = xe.info.amount;
        break;
      }
      case "/ibc.applications.transfer.v1.MsgTransfer": {
        const Ee = y.find(
          ($e) => $e.chainId === we.chainId
        ), xe = await getIbcTransferMessageWithInfo(
          Ee,
          we.value,
          we.value.receiver,
          y,
          z
        );
        he.fromAmount = xe.info.amount;
        break;
      }
      case "/cosmwasm.wasm.v1.MsgExecuteContract": {
        const [Ee] = Array.isArray(we.value.funds) ? we.value.funds : [];
        if (Ee) {
          const xe = await getDenomData(
            Ee.denom,
            we.chainId,
            y,
            z
          ), $e = (xe == null ? void 0 : xe.coinDecimals) ?? 6, Ne = new BigNumber(Ee.amount).dividedBy(
            getDecimalPower10($e)
          );
          he.fromAmount = Ne.toFixed();
        }
        break;
      }
    }
    return [le, he];
  }
  return [];
}, getSwapData = async (v, y, z) => {
  let ne, ue, le, he, ge = 0;
  for (let $n = 0; $n < v.length; $n++) {
    const En = v[$n];
    En.type === "SWAP" ? $n === 0 ? (ne = En.chain, le = [En.chain, En.sourceAsset], ue = En.chain, he = [En.chain, En.destinationAsset]) : he = [En.chain, En.destinationAsset] : (En.sourceChain !== En.destinationChain && (ge += 1), $n === 0 ? (ne = En.sourceChain, le = [En.sourceChain, En.asset], ue = En.destinationChain, he = [En.sourceChain, En.asset]) : (ue = En.destinationChain, he = [En.sourceChain, En.asset]));
  }
  const we = y.find(($n) => $n.chainId === ne), Ee = y.find(($n) => $n.chainId === ue);
  if (!we || !Ee || !le || !he)
    throw new Error("Insufficient data to create swap data");
  const [xe, $e] = le, Ne = await getDenomData(
    $e,
    xe,
    y,
    z
  );
  if (!Ne)
    throw new Error("Insufficient data to create swap data");
  const [st, Nr] = he, br = await getDenomData(
    Nr,
    st,
    y,
    z
  );
  if (!br)
    throw new Error("Insufficient data to create swap data");
  return {
    type: "ibc-swap-data",
    provider: "skip",
    fromChain: we,
    toChain: Ee,
    fromToken: convertDenomDataToAsset(Ne),
    toToken: convertDenomDataToAsset(br),
    hops: ge
  };
}, getCosmosSendMessageWithInfo = async (v, y, z, ne) => {
  const ue = y.amount[0].denom, le = await getDenomData(
    ue,
    v.chainId,
    z,
    ne
  ), he = (le == null ? void 0 : le.coinDecimals) ?? 6, ge = new BigNumber(y.amount[0].amount).dividedBy(
    getDecimalPower10(he)
  );
  return {
    typeUrl: "/cosmos.bank.v1beta1.MsgSend",
    value: y,
    info: {
      chain: v,
      asset: le ? {
        denom: ue,
        decimals: le.coinDecimals,
        logoUri: le.icon,
        icon: le.icon,
        originDenom: le.coinMinimalDenom,
        symbol: le.coinDenom
      } : ue,
      amount: ge.toFixed(),
      sender: y.fromAddress,
      receiver: y.toAddress
    }
  };
}, getIbcTransferMessageWithInfo = async (v, y, z, ne, ue) => {
  var $e, Ne;
  const le = await getDestinationChainIdFromSourceChannelId(
    v,
    y.sourceChannel
  ), he = le ? ne.find((st) => st.chainId === le) : void 0, ge = ($e = y.token) == null ? void 0 : $e.denom, we = await getDenomData(
    ge ?? "",
    v.chainId,
    ne,
    ue
  ), Ee = (we == null ? void 0 : we.coinDecimals) ?? 6, xe = new BigNumber(((Ne = y.token) == null ? void 0 : Ne.amount) ?? 0).dividedBy(
    getDecimalPower10(Ee)
  );
  return {
    typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
    value: y,
    info: {
      fromChain: v,
      toChain: he,
      sourceChannel: y.sourceChannel,
      sourcePort: y.sourcePort,
      amount: xe.toFixed(),
      asset: we && ge ? {
        denom: ge,
        decimals: we.coinDecimals,
        logoUri: we.icon,
        icon: we.icon,
        originDenom: we.coinMinimalDenom,
        symbol: we.coinDenom
      } : "",
      sender: y.sender,
      receiver: z
    }
  };
}, withRetry = async (v, y, z = 3, ne = 0) => {
  try {
    return await v();
  } catch (ue) {
    if (z <= 0)
      throw ue;
    return await sleep(ne), withRetry(v, y, z - 1, ne);
  }
};
async function sendTrackingRequest(v, y, z = 3, ne = 3e3) {
  let ue;
  for (let le = 0; le < z; le++) {
    const he = ne * 2;
    try {
      const ge = await SkipAPI.trackTransaction({
        chain_id: v,
        tx_hash: y
      });
      if (ue = ge, ge.success)
        break;
      const we = z - 1;
      if (le === we)
        return {
          success: !1,
          error: "Unable to track transaction"
        };
      await sleep(he);
    } catch {
      const we = z - 1;
      if (le === we)
        return {
          success: !1,
          error: "Unable to track transaction"
        };
      await sleep(he);
    }
  }
  return ue;
}
const handlePromise = async (v) => {
  try {
    return {
      data: await (typeof v == "function" ? v() : v),
      error: void 0
    };
  } catch (y) {
    return {
      data: void 0,
      error: y
    };
  }
}, useIsMobileDevice = () => useMemo(() => window ? isMobileDevice(window.navigator.userAgent) : !1, []), ListMessage = ({ message: v, subtext: y, icon: z = null, className: ne }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-[40svh] max-h-[25rem] w-full flex-col items-center pt-20", children: [
  z,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "h2",
    {
      className: Y$1(
        "text-foreground break-all text-center text-lg font-bold",
        {
          "mt-2": !!z
        },
        ne
      ),
      children: v
    }
  ),
  y ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-muted-foreground mt-1 break-all text-center text-sm", children: y }) : null
] }), isAmountValid = (v) => {
  const y = v.trim();
  return y ? !isNaN(parseFloat(y)) : !0;
}, oneBillion = 1e9, FiatValueDisplay = ({ coingeckoId: v, amount: y, conversionRate: z, fiatData: ne }) => {
  var le;
  const ue = useUSDPrice(v);
  if (!v)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground text-sm", children: "–" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { className: "text-left", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-left", children: "Price data not available" }) })
    ] });
  if (!isAmountValid(y))
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground text-sm", children: "–" });
  if (ue.isLoading || z != null && z.isLoading)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-12 rounded-3xl" });
  if (ue.data) {
    const he = ue.data * parseFloat(y);
    if ((le = z == null ? void 0 : z.data) != null && le.success && ne && (z == null ? void 0 : z.data.conversionRate) !== 0) {
      const ge = he / (z == null ? void 0 : z.data.conversionRate);
      return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground text-sm", children: formatAmountWithPrefix(
        ge,
        ne.symbol,
        void 0,
        void 0,
        ge > oneBillion ? "compact" : "standard"
      ) });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground text-sm", children: formatAmountWithPrefix(
      he,
      "$",
      void 0,
      void 0,
      he > oneBillion ? "compact" : "standard"
    ) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground text-sm", children: " " });
}, SearchInput = ({ searchQuery: v, setSearchQuery: y, disabled: z, placeholder: ne }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative mb-4 w-full", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    w$2,
    {
      weight: "bold",
      className: "text-muted-foreground absolute left-3 top-3"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Cb,
    {
      autoFocus: useIsMobileDevice(),
      disabled: z,
      className: "text-foreground w-full !pl-8",
      placeholder: ne,
      value: v,
      onChange: (ue) => y(ue.target.value)
    }
  )
] }), HelpPopover = ({ children: v }) => v ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: v }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
  np,
  {
    size: "sm",
    variant: "secondary",
    className: "h-auto rounded-3xl px-2 py-1 text-sm font-medium",
    onClick: () => {
      window.open(
        "https://leapwallet.io/support",
        "_blank",
        "noopener,noreferrer"
      );
    },
    children: "Get Help"
  }
), NewFrogeSad = "data:image/svg+xml,%3csvg%20width='190'%20height='124'%20viewBox='0%200%20190%20124'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M170.744%2085.3528C170.744%20112.392%20137.744%20123.38%2096.7711%20123.38C55.7978%20123.38%2022.3179%20112.392%2022.3179%2085.3528C22.3179%2058.3135%2055.5576%2036.4336%2096.531%2036.4336C137.504%2036.4336%20170.744%2058.3613%20170.744%2085.3528Z'%20fill='%2324A95A'/%3e%3cpath%20d='M163.208%2026.4144C163.208%2012.1782%20151.583%200.617188%20137.269%200.617188C129.843%200.617188%20123.15%203.73178%20118.424%208.6955C117.668%209.48871%20116.567%209.8761%20115.493%209.65991C109.518%208.45683%20103.199%207.78309%2096.6799%207.78309C90.1618%207.78309%2083.8429%208.41706%2077.8683%209.64891C76.7935%209.87053%2075.6875%209.48948%2074.9277%208.69757C70.164%203.73265%2063.4732%200.617188%2056.0909%200.617188C41.7767%200.617188%2030.1523%2012.1782%2030.1523%2026.4144C30.1523%2030.5512%2031.1274%2034.4269%2032.8456%2037.8767C33.2706%2038.73%2033.3135%2039.7281%2032.9457%2040.6075C31.2781%2044.5952%2030.3925%2048.8046%2030.3925%2053.1672C30.3925%2078.2478%2060.0778%2098.5512%2096.6799%2098.5512C133.282%2098.5512%20162.967%2078.2478%20162.967%2053.1672C162.967%2048.8046%20162.082%2044.5952%20160.414%2040.6075C160.046%2039.7281%20160.089%2038.73%20160.514%2037.8767C162.232%2034.4269%20163.208%2030.5512%20163.208%2026.4144Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M163.208%2026.4144C163.208%2012.1782%20151.583%200.617188%20137.269%200.617188C129.843%200.617188%20123.15%203.73178%20118.424%208.6955C117.668%209.48871%20116.567%209.8761%20115.493%209.65991C109.518%208.45683%20103.199%207.78309%2096.6799%207.78309C90.1618%207.78309%2083.8429%208.41706%2077.8683%209.64891C76.7935%209.87053%2075.6875%209.48948%2074.9277%208.69757C70.164%203.73265%2063.4732%200.617188%2056.0909%200.617188C41.7767%200.617188%2030.1523%2012.1782%2030.1523%2026.4144C30.1523%2030.5512%2031.1274%2034.4269%2032.8456%2037.8767C33.2706%2038.73%2033.3135%2039.7281%2032.9457%2040.6075C31.2781%2044.5952%2030.3925%2048.8046%2030.3925%2053.1672C30.3925%2078.2478%2060.0778%2098.5512%2096.6799%2098.5512C133.282%2098.5512%20162.967%2078.2478%20162.967%2053.1672C162.967%2048.8046%20162.082%2044.5952%20160.414%2040.6075C160.046%2039.7281%20160.089%2038.73%20160.514%2037.8767C162.232%2034.4269%20163.208%2030.5512%20163.208%2026.4144Z'%20fill='url(%23paint0_radial_2544_13391)'/%3e%3cpath%20d='M53.9744%2040.7253C62.7288%2040.7253%2069.8257%2033.6671%2069.8257%2024.9603C69.8257%2016.2535%2062.7288%209.19531%2053.9744%209.19531C45.2199%209.19531%2038.123%2016.2535%2038.123%2024.9603C38.123%2033.6671%2045.2199%2040.7253%2053.9744%2040.7253Z'%20fill='white'/%3e%3cpath%20d='M138.539%2040.7253C147.293%2040.7253%20154.39%2033.6671%20154.39%2024.9603C154.39%2016.2535%20147.293%209.19531%20138.539%209.19531C129.784%209.19531%20122.688%2016.2535%20122.688%2024.9603C122.688%2033.6671%20129.784%2040.7253%20138.539%2040.7253Z'%20fill='white'/%3e%3cpath%20d='M45.5625%20121.434C48.973%20121.434%2051.6629%20118.473%2051.2786%20115.128C49.8856%20103.281%2043.9774%2077.6269%2017.9908%2062.1964C-10.3968%2045.335%202.96305%2089.9491%208.66235%20106.479C9.83895%20109.892%208.47337%20113.685%205.34282%20115.482L3.62852%20116.466C1.2268%20117.852%202.23552%20121.434%204.97348%20121.434H45.5625Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M148.798%20121.434C145.723%20121.434%20143.322%20118.473%20143.658%20115.128C144.859%20103.329%20150.239%2077.6269%20173.679%2062.1964C199.552%2045.1998%20187.083%2090.6687%20182.008%20106.871C180.992%20110.115%20182.245%20113.645%20185.116%20115.465L186.697%20116.466C188.858%20117.852%20187.946%20121.434%20185.496%20121.434H148.798Z'%20fill='%2332DA6D'/%3e%3cpath%20d='M56.2292%2038.3226C61.4517%2038.3226%2065.6854%2034.0889%2065.6854%2028.8664C65.6854%2023.6439%2061.4517%2019.4102%2056.2292%2019.4102C51.0066%2019.4102%2046.7729%2023.6439%2046.7729%2028.8664C46.7729%2034.0889%2051.0066%2038.3226%2056.2292%2038.3226Z'%20fill='%23092511'/%3e%3cpath%20d='M140.795%2038.3226C146.018%2038.3226%20150.251%2034.0889%20150.251%2028.8664C150.251%2023.6439%20146.018%2019.4102%20140.795%2019.4102C135.573%2019.4102%20131.339%2023.6439%20131.339%2028.8664C131.339%2034.0889%20135.573%2038.3226%20140.795%2038.3226Z'%20fill='%23092511'/%3e%3cpath%20d='M74.1619%2080.5171C72.5714%2080.0532%2071.643%2078.3792%2072.2763%2076.8482C73.9039%2072.9137%2076.4234%2069.3946%2079.6518%2066.5774C83.6363%2063.1004%2088.5337%2060.8381%2093.7642%2060.0583C98.9946%2059.2786%20104.339%2060.0141%20109.164%2062.1777C113.074%2063.9308%20116.51%2066.5619%20119.215%2069.8506C120.267%2071.1304%20119.867%2073.0023%20118.481%2073.91L112.156%2078.0525C110.77%2078.9602%20108.929%2078.5425%20107.749%2077.3792C106.556%2076.2035%20105.158%2075.2437%20103.616%2074.552C101.156%2073.4489%2098.4306%2073.0739%2095.7638%2073.4714C93.0969%2073.869%2090.5999%2075.0225%2088.5683%2076.7953C87.2945%2077.9068%2086.2372%2079.2326%2085.4396%2080.7051C84.6504%2082.1619%2083.0113%2083.0983%2081.4208%2082.6344L74.1619%2080.5171Z'%20fill='%23092511'/%3e%3cdefs%3e%3cradialGradient%20id='paint0_radial_2544_13391'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(87.5298%2012.7733)%20rotate(84.0479)%20scale(86.2427%20116.007)'%3e%3cstop%20stop-color='%2332DA6D'/%3e%3cstop%20offset='0.557236'%20stop-color='%2356E488'/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e";
class ErrorBoundary extends a__default.Component {
  constructor(y) {
    super(y), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(y, z) {
    console.log("Elements UI Crashed", y, z);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: Y$1(
          "bg-background h-[34rem] w-[26rem] rounded-2xl",
          this.props.className
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between px-4 my-4", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-bold", children: this.props.title }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(HelpPopover, {})
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 pb-4 h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-lg h-full flex flex-col px-8 items-center justify-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                className: "block w-40 h-auto -mt-8",
                src: NewFrogeSad,
                alt: "Sad Frog"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-center font-bold text-2xl mt-6", children: "Woops!" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-center text-muted-foreground mt-4", children: "Something went wrong. Please reload the page or contact support if the issue persists." })
          ] }) })
        ] })
      }
    ) : this.props.children;
  }
}
const useOverflowFade = (v) => {
  useEffect(() => {
    if (!v.current)
      return;
    const y = v.current;
    function z(ne) {
      if (!ne.currentTarget)
        return;
      const ue = ne.currentTarget;
      if (!(ue.scrollHeight > ue.clientHeight)) {
        ue.classList.remove("is-bottom-overflowing", "is-top-overflowing");
        return;
      }
      const he = Math.floor(ue.scrollHeight) === Math.floor(ue.clientHeight + ue.scrollTop), ge = Math.floor(ue.scrollTop) === 0;
      ue.classList.toggle(
        "is-bottom-overflowing",
        ge || !he
      );
    }
    return y.classList.add("overflow-fade-hint"), y.addEventListener("scroll", z), z({
      currentTarget: y
    }), () => {
      y.classList.remove("overflow-fade-hint"), y.removeEventListener("scroll", z);
    };
  }, [v]);
}, useCosmosAddresses = (v = [], y, z, ne) => {
  const { userAddress: ue, walletClient: le } = useWalletClientContext(), [he, ge] = useState(null), { data: we } = useChains(), [Ee, xe] = useState(null), $e = useAddressCoinType(ue), Ne = ne || we;
  return useEffect(() => {
    async function st() {
      if (!ue || !Ne)
        return;
      const Nr = [], br = {};
      for (const $n of v)
        if ($n === y)
          br[$n] = z;
        else {
          const En = Ne == null ? void 0 : Ne.find(
            (wa) => wa.chainId === $n
          );
          if (!En)
            throw new Error(`Chain ${$n} not found`);
          const Rn = En;
          if (Rn.coinType === ($e == null ? void 0 : $e.coinType)) {
            const wa = convertAddress(
              ue,
              Rn.addressPrefix
            );
            br[$n] = wa;
          } else
            Nr.push($n);
        }
      if (Nr.length) {
        try {
          await le.enable(Nr);
        } catch {
          xe(
            "Transaction through chain mentioned in the route is not supported"
          );
        }
        for (const $n of Nr)
          try {
            const { bech32Address: En } = await le.getAccount($n);
            br[$n] = En;
          } catch {
            throw new Error(`Failed to get address for chain ${$n}`);
          }
      }
      ge(br);
    }
    xe(null), v && v.length > 0 && ue && Ne && Ne.length > 0 && z && y && st();
  }, [
    v,
    y,
    z,
    ue,
    $e == null ? void 0 : $e.coinType,
    le,
    Ne
  ]), {
    userAddresses: he,
    isError: Ee
  };
}, useAddresses = (v = [], y, z) => {
  const { userAddress: ne, walletClient: ue } = useWalletClientContext(), [le, he] = useState(null), { data: ge } = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), [we, Ee] = useState(null), xe = useAddressCoinType(ne), { address: $e } = useAccount(), { wallet: Ne } = useWallet();
  return useEffect(() => {
    async function st() {
      var $n;
      if (!ne && !$e && !Ne)
        return;
      const Nr = [], br = {};
      for (const En of v)
        if (En === y)
          br[En] = z;
        else {
          const Rn = ge == null ? void 0 : ge.find((wa) => wa.chainId === En);
          if (!Rn)
            throw new Error(`Chain ${En} not found`);
          if (Rn.chainType === "cosmos") {
            const wa = Rn;
            if (wa.coinType === (xe == null ? void 0 : xe.coinType)) {
              const Aa = convertAddress(
                ne,
                wa.addressPrefix
              );
              br[En] = Aa;
            } else
              Nr.push(En);
          } else
            Rn.chainType === "evm" ? br[En] = $e : Rn.chainType === "svm" && (br[En] = ($n = Ne == null ? void 0 : Ne.adapter.publicKey) == null ? void 0 : $n.toBase58());
        }
      if (Nr.length) {
        try {
          await ue.enable(Nr);
        } catch {
          Ee("Failed to get address for one or more chains");
        }
        for (const En of Nr)
          try {
            const { bech32Address: Rn } = await ue.getAccount(En);
            br[En] = Rn;
          } catch {
            throw new Error(`Failed to get address for chain ${En}`);
          }
      }
      he(br);
    }
    Ee(null), v != null && v.length && (ne || $e || Ne) && ue && (ge != null && ge.length) && z && y && st();
  }, [
    v,
    ge,
    y,
    z,
    ne,
    xe == null ? void 0 : xe.coinType,
    ue,
    $e,
    Ne
  ]), {
    userAddresses: le,
    isError: we
  };
}, usePreviousState = (v) => {
  const y = useRef(void 0);
  return useEffect(() => {
    y.current = v;
  }, [v]), y.current;
}, useGetTimeSpent = () => {
  const v = useRef(0), y = useCallback(() => v.current, []), z = useCallback(() => {
    v.current = 0;
  }, []);
  return useEffect(() => {
    const ne = setInterval(() => {
      v.current += 1;
    }, 1e3);
    return () => {
      clearInterval(ne);
    };
  }, []), [y, z];
}, useCosmosTokenBalance = ({
  chainId: v,
  denom: y
}) => {
  var le;
  const z = useWalletClientContext(), ne = useCosmosChainBalances({
    chainId: v
  }), ue = useMemo(() => {
    var he;
    if (y)
      return (he = ne.data) == null ? void 0 : he.balances[y];
  }, [(le = ne.data) == null ? void 0 : le.balances, y]);
  return useMemo(
    () => ({
      data: ue,
      isLoading: ne.isLoading,
      error: ne.error,
      isWalletConnected: !!z.userAddress
    }),
    [ne.error, ne.isLoading, ue, z.userAddress]
  );
}, useTokenBalance = ({
  chainId: v,
  denom: y,
  chainType: z
}) => {
  var we;
  const ne = useWalletClientContext(), { isConnected: ue } = useAccount(), { wallet: le } = useWallet(), he = useChainBalances({
    chainId: v
  }), ge = useMemo(() => {
    var Ee, xe;
    if (y)
      return (xe = (Ee = he.data) == null ? void 0 : Ee.balances) == null ? void 0 : xe[y];
  }, [(we = he.data) == null ? void 0 : we.balances, y]);
  return useMemo(
    () => ({
      data: ge,
      isLoading: he.isLoading,
      error: he.error,
      isWalletConnected: z === "cosmos" ? !!ne.userAddress : z === "evm" ? !!ue : !!(le != null && le.adapter.connected)
    }),
    [
      he.error,
      he.isLoading,
      ge,
      ne.userAddress,
      ue,
      z,
      le == null ? void 0 : le.adapter.connected
    ]
  );
}, RouteSettingsContext = createContext(void 0), RouteSettingsProvider = ({ children: v, bridges: y, swapVenues: z }) => {
  const ne = useMemo(
    () => ({
      bridges: y,
      swapVenues: z
    }),
    [y, z]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RouteSettingsContext.Provider, { value: ne, children: v });
}, useRouteSettings = () => useContext(RouteSettingsContext), SELECT_NONE = "SELECT_NONE", getDefaultValueGivenFallback = (v, y, z) => {
  if (v === SELECT_NONE)
    return v;
  const ne = v ?? y;
  return z && !z.includes(ne) ? z[0] : ne;
}, getDefaultValue = (v, y) => v === SELECT_NONE ? v : y && (v === void 0 || !y.includes(v)) ? y[0] : v, getDefaultValueByOriginObject = (v, y) => y && (v === void 0 || !y.find(
  (z) => z.originChainId === v.originChainId && z.originDenom === v.originDenom
)) ? y[0] : v, getSlippageRemark = (v) => {
  const y = v.trim();
  if (!y)
    return;
  const z = parseFloat(y);
  if (isNaN(z))
    return {
      type: "error",
      message: "Please enter a valid number."
    };
  if (z <= 0 || z > 99)
    return {
      type: "error",
      message: "Slippage must be between 0 and 99."
    };
  if (z < 0.1)
    return {
      type: "warning",
      message: "Slippage is too low, your transaction may fail."
    };
  if (z > 3 && z <= 10)
    return {
      type: "warning",
      message: "High slippage can result in an unfavourable trade if the price shifts significantly when the transaction is executed."
    };
  if (z > 10)
    return {
      type: "warning-alert",
      message: "Extremely high slippage: The recommended slippage is between 0.1% to 3%."
    };
}, getInputAmountRemark = (v) => {
  const y = v.trim();
  if (!y)
    return;
  const z = parseFloat(y);
  if (isNaN(z))
    return {
      type: "error",
      message: "Amount must be a number."
    };
  if (z < 0)
    return {
      type: "error",
      message: "Amount must be greater than 0."
    };
}, getPriceImpactVars = (v) => {
  const y = !!(v != null && v.response.does_swap), z = y ? new BigNumber((v == null ? void 0 : v.response.swap_price_impact_percent) ?? NaN) : void 0, ne = new BigNumber(
    (v == null ? void 0 : v.response.usd_amount_in) ?? NaN
  ), ue = new BigNumber(
    (v == null ? void 0 : v.response.usd_amount_out) ?? NaN
  ), le = (ne.isNaN() ? ue.gte(0.01) : ne.gte(0.01)) ? new BigNumber(ne).minus(ue).dividedBy(ne).multipliedBy(100) : new BigNumber(0);
  return {
    shouldCheckPriceImpact: y,
    priceImpactPercent: z,
    usdValueDecreasePercent: le,
    sourceAssetUSDValue: ne,
    destinationAssetUSDValue: ue
  };
}, getConversionRateRemark = (v) => {
  if (!v)
    return "ok";
  const {
    shouldCheckPriceImpact: y,
    priceImpactPercent: z,
    usdValueDecreasePercent: ne
  } = getPriceImpactVars(v);
  return y ? z.isNaN() ? ne.isNaN() ? "request-confirmation" : ne.lt(5) ? "ok" : "request-confirmation" : z.lt(5) ? ne.isNaN() ? "warn" : ne.lt(5) ? "ok" : "request-confirmation" : "request-confirmation" : ne.isNaN() ? "warn" : ne.lt(5) ? "ok" : ne.gte(5) ? "request-confirmation" : "ok";
}, IBCSwapsFlowContext = createContext(void 0), IBCSwapsFlowProvider = ({
  children: v
}) => {
  const [y, z] = useState(0), ne = usePreviousState(y), [ue, le] = useGetTimeSpent();
  useEffect(() => {
    le();
  }, [le, y]);
  const he = useMemo(
    () => ({
      step: y,
      setStep: z,
      previousStep: ne,
      goBack: () => {
        switch (y) {
          case 1:
            z(0);
            break;
          case 2:
            z(0);
            break;
        }
      },
      goForward: () => {
        switch (y) {
          case 0:
            z(1);
            break;
        }
      },
      getTimeSpentOnCurrentStep: ue
    }),
    [ue, ne, y]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsFlowContext.Provider, { value: he, children: v });
}, useIBCSwapsFlowContext = () => {
  const v = useContext(IBCSwapsFlowContext);
  return invariant$1(
    v,
    `Please use ${useIBCSwapsFlowContext.name} within IBCSwapsFlowProvider`
  ), v;
}, IBCSwapsContext = createContext(
  void 0
), IBCSwapsProvider = ({
  children: v,
  defaultValues: y,
  defaultSettings: z,
  onValuesChange: ne,
  onSettingsChange: ue,
  txnLifecycleHooks: le
}) => {
  var U1;
  const [he, ge] = useState(
    y.sourceChainId
  ), [we, Ee] = useState(
    typeof y.sourceAsset == "string" ? y.sourceAsset : void 0
  ), [xe, $e] = useState(y.destinationChainId), [Ne, st] = useState(
    typeof y.destinationAsset == "string" ? y.destinationAsset : void 0
  ), [Nr, br] = useState(z.slippage), [$n, En] = useState(!1), [Rn, wa] = useState(
    y.inputAmount ?? ""
  ), [Aa, _a] = useState({}), [Ta, Zn] = useState(), Ra = useMemo(() => getSlippageRemark(Nr), [Nr]), Yn = useMemo(
    () => getInputAmountRemark(Rn),
    [Rn]
  ), $o = useSkipSupportedChains(), ct = useAllSkipAssets(), fe = useCallback(
    (g2) => {
      var X1, $2;
      ge(g2);
      const Ic = ($2 = (X1 = $o.data) == null ? void 0 : X1.find(
        (ah) => ah.chainId === g2
      )) == null ? void 0 : $2.baseDenom;
      Ee(Ic || void 0);
    },
    [$o.data]
  ), be = useCallback(
    (g2) => {
      var X1, $2;
      $e(g2);
      const Ic = ($2 = (X1 = $o.data) == null ? void 0 : X1.find(
        (ah) => ah.chainId === g2
      )) == null ? void 0 : $2.baseDenom;
      st(Ic || void 0);
    },
    [$o.data]
  ), ye = useMemo(() => {
    var Ic;
    return he ? (Ic = $o.data) == null ? void 0 : Ic.find(
      (X1) => X1.chainId === he
    ) : void 0;
  }, [$o.data, he]), Se = useMemo(() => {
    var g2;
    if (xe)
      return (g2 = $o.data) == null ? void 0 : g2.find(
        (Ic) => Ic.chainId === xe
      );
  }, [$o.data, xe]), Oe = useMemo(() => {
    if (!ct.data || !he || !we)
      return;
    const g2 = ct.data[he];
    return g2 == null ? void 0 : g2.find((Ic) => Ic.denom === we);
  }, [ct.data, we, he]), Fr = useMemo(() => {
    if (!ct.data || !xe || !Ne)
      return;
    const g2 = ct.data[xe];
    return g2 == null ? void 0 : g2.find((Ic) => Ic.denom === Ne);
  }, [ct.data, xe, Ne]), zn = useMemo(() => {
    var X1;
    const g2 = y.sourceAsset;
    if (g2 === void 0 || typeof g2 == "string")
      return g2;
    if (!ct.data || !he)
      return;
    const Ic = (X1 = ct.data) == null ? void 0 : X1[he].find(
      ($2) => $2.originDenom === g2.originDenom && $2.originChainId === g2.originChainId
    );
    return Ic == null ? void 0 : Ic.denom;
  }, [he, ct.data, y.sourceAsset]), Fe = useMemo(() => {
    var X1;
    const g2 = y.destinationAsset;
    if (g2 === void 0 || typeof g2 == "string")
      return g2;
    if (!ct.data || !xe)
      return;
    const Ic = (X1 = ct.data) == null ? void 0 : X1[xe].find(
      ($2) => $2.originDenom === g2.originDenom && $2.originChainId === g2.originChainId
    );
    return Ic == null ? void 0 : Ic.denom;
  }, [xe, ct.data, y.destinationAsset]), pe = useRef(
    y.sourceAsset === SELECT_NONE
  );
  useEffect(() => {
    zn && !pe.current && (Ee(zn), pe.current = !0);
  }, [zn]);
  const it = useRef(
    y.destinationAsset === SELECT_NONE
  );
  useEffect(() => {
    Fe && !it.current && (st(Fe), it.current = !0);
  }, [Fe]);
  const xa = useCosmosTokenBalance({
    chainId: he,
    denom: Oe == null ? void 0 : Oe.denom
  }), wo = useCosmosTokenBalance({
    chainId: xe,
    denom: Fr == null ? void 0 : Fr.denom
  }), { step: _u } = useIBCSwapsFlowContext(), Oa = useDebouncedValue(Rn, 500), Os = useMemo(() => !!Oa && !Yn && Number(Oa) !== 0 && !!Oe && !!ye && !!Fr && !!Se && (ye.chainId === Se.chainId ? Oe.denom !== Fr.denom : !0), [
    Oa,
    Fr,
    Se,
    Yn,
    Oe,
    ye
  ]), Pa = useRouteSettings(), {
    routeResponse: Ml,
    amountOut: Su,
    isLoadingRoute: Tu,
    isValidatingRoute: Au,
    routeError: Zl,
    refresh: Iu,
    routeKey: Uc
  } = useRoute(
    Oa,
    Oe,
    ye,
    Fr,
    Se,
    Os,
    Pa == null ? void 0 : Pa.bridges,
    Pa == null ? void 0 : Pa.swapVenues,
    !1,
    {
      revalidateOnFocus: _u === 0,
      revalidateIfStale: _u === 0,
      revalidateOnReconnect: _u === 0
    }
  );
  useEffect(() => {
    En(!1);
  }, [Uc]), useEffect(() => {
    if (Os && _u === 0 && !Tu && !Au) {
      const g2 = setInterval(() => {
        Iu();
      }, 3e4);
      return () => clearInterval(g2);
    }
  }, [Tu, Os, Au, Iu, _u]), useEffect(() => {
    we === void 0 && (ye == null ? void 0 : ye.baseDenom) !== void 0 && Ee(ye.baseDenom);
  }, [ye == null ? void 0 : ye.baseDenom]), useEffect(() => {
    Ne === void 0 && (Se == null ? void 0 : Se.baseDenom) !== void 0 && st(Se.baseDenom);
  }, [Se == null ? void 0 : Se.baseDenom]);
  const Pu = useMemo(() => ye && ye.chainType === "cosmos" ? ye : void 0, [ye]), Lu = useSourceAddress(Pu), th = useMemo(() => Se && Se.chainType === "cosmos" ? Se : void 0, [Se]), Zc = useSourceAddress(
    th
  ), { userAddresses: N1, isError: Gh } = useCosmosAddresses(
    Ml == null ? void 0 : Ml.response.chain_ids,
    xe,
    Zc.address
  ), Mc = !!Gh, h1 = useMemo(() => ({
    slippageTolerancePercent: Number(Nr).toFixed(2)
  }), [Nr]), { data: l2, isLoading: Gc } = useMessagesSWR(
    N1,
    Ml == null ? void 0 : Ml.response,
    h1,
    !Mc,
    {
      revalidateOnFocus: _u === 0,
      revalidateIfStale: _u === 0,
      revalidateOnReconnect: _u === 0
    }
  ), Kc = (U1 = xa == null ? void 0 : xa.data) == null ? void 0 : U1.amount.isLessThan(Rn), M2 = useMemo(() => !Kc && Os && !!Ml && !Tu && !Au && !Zl && !!l2 && (ye == null ? void 0 : ye.chainType) === "cosmos", [
    Kc,
    Tu,
    Os,
    Au,
    l2,
    Zl,
    Ml,
    ye == null ? void 0 : ye.chainType
  ]), { isMainnet: d1 } = useWalletClientContext(), {
    data: K1,
    isLoading: k2,
    isValidating: Eu
  } = useSkipGasFeeSWR(
    l2,
    N1,
    d1,
    {
      revalidateOnFocus: _u === 0,
      revalidateIfStale: _u === 0,
      revalidateOnReconnect: _u === 0
    },
    M2
  ), Zo = useBridgeFee(Ml), Fl = useRelayerFee(Ml), Ru = useMemo(() => !!$o.data && !!ct.data && !!he && !!we && !!xe && !!Ne, [
    $o.data,
    ct.data,
    he,
    we,
    xe,
    Ne
  ]), ku = useCallback(() => {
    if (!Ru)
      return;
    const g2 = $o.data.find(
      (ah) => ah.chainId === xe
    ), Ic = $o.data.find(
      (ah) => ah.chainId === he
    ), X1 = ct.data[g2.chainId].find(
      (ah) => ah.originDenom === Fr.originDenom
    ), $2 = ct.data[Ic.chainId].find((ah) => ah.originDenom === Oe.originDenom);
    ge(g2.chainId), Ee(X1 == null ? void 0 : X1.denom), $e(Ic.chainId), st($2 == null ? void 0 : $2.denom);
  }, [
    ct.data,
    Fr,
    xe,
    Ru,
    $o.data,
    Oe,
    he
  ]);
  useEffect(() => {
    ne == null || ne({
      sourceChainId: he,
      sourceAsset: we,
      destinationChainId: xe,
      destinationAsset: Ne,
      inputAmount: Rn,
      data: {
        sourceChain: ye,
        sourceAsset: Oe,
        destinationChain: Se,
        destinationAsset: Fr
      }
    });
  }, [
    Ne,
    xe,
    Rn,
    ne,
    we,
    he,
    ye,
    Oe,
    Se,
    Fr
  ]), useEffect(() => {
    ue == null || ue({ slippage: Nr });
  }, [ue, Nr]);
  const kc = useCallback(
    (g2 = !0) => {
      g2 && (ge(y.sourceChainId), Ee(zn), $e(y.destinationChainId), st(Fe)), wa(y.inputAmount ?? ""), Zn(void 0);
    },
    [y, zn, Fe]
  );
  useEffect(() => {
    if (Object.values(Aa).some(
      (Ic) => !Ic.isComplete
    ) && window) {
      const Ic = (X1) => {
        X1.preventDefault(), X1.returnValue = "";
      };
      return window.addEventListener("beforeunload", Ic), () => {
        window.removeEventListener("beforeunload", Ic);
      };
    }
  }, [Aa]);
  const Ou = useMemo(
    () => {
      var g2, Ic, X1, $2, ah, O1, T2;
      return {
        sourceChainId: he,
        setSourceChainId: fe,
        sourceAsset: we,
        setSourceAsset: Ee,
        destinationChainId: xe,
        setDestinationChainId: be,
        destinationAsset: Ne,
        setDestinationAsset: st,
        slippage: Nr,
        setSlippage: br,
        slippageRemark: Ra,
        inputAmount: Rn,
        setInputAmount: wa,
        inputAmountRemark: Yn,
        sourceTokenBalance: xa,
        destinationTokenBalance: wo,
        routeResponse: Ta ? (g2 = Aa[Ta]) == null ? void 0 : g2.routeResponse : Ml,
        amountOut: Su,
        isLoadingRoute: Tu,
        routeError: Zl,
        isValidatingRoute: Au,
        refresh: Iu,
        isRouteQueryEnabled: Os,
        messages: Ta ? (Ic = Aa[Ta]) == null ? void 0 : Ic.messages : l2,
        isLoadingMessages: Gc,
        isUserAddressesError: Mc,
        gasFeesData: Ta ? (X1 = Aa[Ta]) == null ? void 0 : X1.gasFeesData : K1,
        relayerFee: Fl,
        isLoadingGasFee: k2,
        isValidatingGasFee: Eu,
        interchange: ku,
        isInterchangeEnabled: Ru,
        isConversionRateChecked: $n,
        setIsConversionRateChecked: En,
        sourceAssetData: Ta ? ($2 = Aa[Ta]) == null ? void 0 : $2.sourceAssetData : Oe,
        destinationAssetData: Ta ? (ah = Aa[Ta]) == null ? void 0 : ah.destinationAssetData : Fr,
        sourceAddress: Lu,
        destinationAddress: Zc,
        txnLifecycleHooks: le,
        resetInputsToDefaults: kc,
        sourceChainData: Ta ? (O1 = Aa[Ta]) == null ? void 0 : O1.sourceChainData : ye,
        destinationChainData: Ta ? (T2 = Aa[Ta]) == null ? void 0 : T2.destinationChainData : Se,
        ongoingTransactions: Aa,
        setOngoingTransactions: _a,
        currentSwapId: Ta,
        setCurrentSwapId: Zn,
        routeKey: Uc,
        bridgeFeesData: Zo
      };
    },
    [
      he,
      fe,
      we,
      xe,
      be,
      Ne,
      Nr,
      Ra,
      Rn,
      Yn,
      xa,
      wo,
      Ta,
      Aa,
      Ml,
      Su,
      Tu,
      Zl,
      Au,
      Iu,
      Os,
      l2,
      Gc,
      Mc,
      K1,
      Fl,
      k2,
      Eu,
      ku,
      Ru,
      $n,
      Oe,
      Fr,
      Lu,
      Zc,
      le,
      kc,
      ye,
      Se,
      Uc,
      Zo
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsContext.Provider, { value: Ou, children: v });
}, useIBCSwapsContext = () => {
  const v = useContext(IBCSwapsContext);
  return invariant$1(
    v,
    `Please use ${useIBCSwapsContext.name} within IBCSwapsProvider`
  ), v;
}, SwapsFlowContext = createContext(void 0), SwapsFlowProvider = ({
  children: v
}) => {
  const [y, z] = useState(0), ne = usePreviousState(y), [ue, le] = useGetTimeSpent();
  useEffect(() => {
    le();
  }, [le, y]);
  const he = useMemo(
    () => ({
      step: y,
      setStep: z,
      previousStep: ne,
      goBack: () => {
        switch (y) {
          case 1:
            z(0);
            break;
          case 2:
            z(0);
            break;
        }
      },
      goForward: () => {
        switch (y) {
          case 0:
            z(1);
            break;
        }
      },
      getTimeSpentOnCurrentStep: ue
    }),
    [ue, ne, y]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsFlowContext.Provider, { value: he, children: v });
}, useSwapsFlowContext = () => {
  const v = useContext(SwapsFlowContext);
  return invariant$1(
    v,
    `Please use ${useSwapsFlowContext.name} within SwapsFlowProvider`
  ), v;
}, SwapsContext = createContext(
  void 0
), SwapsProvider = ({
  children: v,
  defaultValues: y,
  defaultSettings: z,
  onValuesChange: ne,
  onSettingsChange: ue,
  txnLifecycleHooks: le
}) => {
  var ah;
  const [he, ge] = useState(
    y.sourceChainId
  ), [we, Ee] = useState(
    typeof y.sourceAsset == "string" ? y.sourceAsset : void 0
  ), [xe, $e] = useState(y.destinationChainId), [Ne, st] = useState(
    typeof y.destinationAsset == "string" ? y.destinationAsset : void 0
  ), [Nr, br] = useState(z == null ? void 0 : z.slippage), [$n, En] = useState(
    z == null ? void 0 : z.provider
  ), [Rn, wa] = useState(!1), [Aa, _a] = useState(
    y.inputAmount ?? ""
  ), Ta = useMemo(() => getSlippageRemark(Nr), [Nr]), Zn = useMemo(
    () => getInputAmountRemark(Aa),
    [Aa]
  ), Ra = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), Yn = useAllSkipAssets(), $o = useCallback(
    (O1) => {
      var ih, oh;
      ge(O1);
      const T2 = (oh = (ih = Ra.data) == null ? void 0 : ih.find(
        (j2) => j2.chainId === O1
      )) == null ? void 0 : oh.baseDenom;
      Ee(T2 || void 0);
    },
    [Ra.data]
  ), ct = useCallback(
    (O1) => {
      var ih, oh;
      $e(O1);
      const T2 = (oh = (ih = Ra.data) == null ? void 0 : ih.find(
        (j2) => j2.chainId === O1
      )) == null ? void 0 : oh.baseDenom;
      st(T2 || void 0);
    },
    [Ra.data]
  ), fe = useMemo(() => {
    var T2;
    if (!he)
      return;
    const O1 = (T2 = Ra.data) == null ? void 0 : T2.find(
      (ih) => ih.chainId === he
    );
    if (((O1 == null ? void 0 : O1.chainType) === "evm" || (O1 == null ? void 0 : O1.chainType) === "svm") && Yn.data) {
      const oh = Yn.data[O1.chainId].find((j2) => j2.denom.endsWith("-native"));
      return {
        ...O1,
        baseDenom: oh == null ? void 0 : oh.denom
      };
    }
    return O1;
  }, [Ra.data, he, Yn.data]), be = useMemo(() => {
    var T2;
    if (!xe)
      return;
    const O1 = (T2 = Ra.data) == null ? void 0 : T2.find(
      (ih) => ih.chainId === xe
    );
    if (((O1 == null ? void 0 : O1.chainType) === "evm" || (O1 == null ? void 0 : O1.chainType) === "svm") && Yn.data) {
      const oh = Yn.data[O1.chainId].find((j2) => j2.denom.endsWith("-native"));
      return {
        ...O1,
        baseDenom: oh == null ? void 0 : oh.denom
      };
    }
    return O1;
  }, [Ra.data, xe, Yn.data]), ye = useTokenBalance({
    chainId: he,
    denom: we,
    chainType: fe == null ? void 0 : fe.chainType
  }), Se = useTokenBalance({
    chainId: xe,
    denom: Ne,
    chainType: be == null ? void 0 : be.chainType
  }), Oe = useMemo(() => {
    if (!Yn.data || !he)
      return;
    const O1 = Yn.data[he];
    return O1 == null ? void 0 : O1.find((T2) => T2.denom === we);
  }, [Yn.data, we, he]), Fr = useMemo(() => {
    if (!Yn.data || !xe)
      return;
    const O1 = Yn.data[xe];
    return O1 == null ? void 0 : O1.find((T2) => T2.denom === Ne);
  }, [Yn.data, xe, Ne]), zn = useMemo(() => {
    var ih;
    const O1 = y.sourceAsset;
    if (O1 === void 0 || typeof O1 == "string")
      return O1;
    if (!Yn.data || !he)
      return;
    const T2 = (ih = Yn.data) == null ? void 0 : ih[he].find(
      (oh) => oh.originDenom === O1.originDenom && oh.originChainId === O1.originChainId
    );
    return T2 == null ? void 0 : T2.denom;
  }, [he, Yn.data, y.sourceAsset]), Fe = useMemo(() => {
    var ih;
    const O1 = y.destinationAsset;
    if (O1 === void 0 || typeof O1 == "string")
      return O1;
    if (!Yn.data || !xe)
      return;
    const T2 = (ih = Yn.data) == null ? void 0 : ih[xe].find(
      (oh) => oh.originDenom === O1.originDenom && oh.originChainId === O1.originChainId
    );
    return T2 == null ? void 0 : T2.denom;
  }, [xe, Yn.data, y.destinationAsset]), pe = useRef(
    y.sourceAsset === SELECT_NONE
  );
  useEffect(() => {
    zn && !pe.current && (Ee(zn), pe.current = !0);
  }, [zn]);
  const it = useRef(
    y.destinationAsset === SELECT_NONE
  );
  useEffect(() => {
    Fe && !it.current && (st(Fe), it.current = !0);
  }, [Fe]);
  const { step: xa } = useSwapsFlowContext(), wo = useDebouncedValue(Aa, 500), _u = useMemo(() => !!wo && !Zn && Number(wo) !== 0 && !!Oe && !!fe && !!Fr && !!be && (Oe.denom !== Fr.denom || fe.chainId !== be.chainId), [
    wo,
    Fr,
    be,
    Zn,
    Oe,
    fe
  ]), Oa = useRouteSettings(), {
    routeResponse: Os,
    amountOut: Pa,
    isLoadingRoute: Ml,
    isValidatingRoute: Su,
    routeError: Tu,
    refresh: Au,
    routeKey: Zl
  } = useRoute(
    wo,
    Oe,
    fe,
    Fr,
    be,
    _u,
    Oa == null ? void 0 : Oa.bridges,
    Oa == null ? void 0 : Oa.swapVenues,
    !0,
    // enabled smart relay
    {
      revalidateOnFocus: xa === 0,
      revalidateIfStale: xa === 0,
      revalidateOnReconnect: xa === 0
    }
  );
  useEffect(() => {
    wa(!1);
  }, [Zl]), useEffect(() => {
    if (_u && xa === 0 && !Ml && !Su) {
      const O1 = setInterval(() => {
        Au();
      }, 3e4);
      return () => clearInterval(O1);
    }
  }, [Ml, _u, Su, Au, xa]), useEffect(() => {
    we === void 0 && (fe == null ? void 0 : fe.baseDenom) !== void 0 && Ee(fe.baseDenom);
  }, [fe == null ? void 0 : fe.baseDenom]), useEffect(() => {
    Ne === void 0 && (be == null ? void 0 : be.baseDenom) !== void 0 && st(be.baseDenom);
  }, [be == null ? void 0 : be.baseDenom]);
  const Iu = useSourceAddress(
    fe
  ), Uc = useSourceAddress(
    be
  ), { address: Pu, isConnected: Lu } = useAccount(), { wallet: th } = useWallet(), Zc = useMemo(() => {
    var O1;
    return (fe == null ? void 0 : fe.chainType) === "cosmos" ? Iu : (fe == null ? void 0 : fe.chainType) === "evm" ? {
      address: Pu,
      error: null,
      refetch: () => Pu
    } : {
      address: ((O1 = th == null ? void 0 : th.adapter.publicKey) == null ? void 0 : O1.toBase58()) ?? "",
      error: null,
      refetch: () => {
        var T2;
        return ((T2 = th == null ? void 0 : th.adapter.publicKey) == null ? void 0 : T2.toBase58()) ?? "";
      }
    };
  }, [
    fe,
    Iu,
    Pu,
    th == null ? void 0 : th.adapter
  ]), N1 = useMemo(() => {
    var O1;
    return (be == null ? void 0 : be.chainType) === "cosmos" ? Uc : (be == null ? void 0 : be.chainType) === "evm" ? {
      address: Pu,
      error: null,
      refetch: () => Pu
    } : {
      address: ((O1 = th == null ? void 0 : th.adapter.publicKey) == null ? void 0 : O1.toBase58()) ?? "",
      error: null,
      refetch: () => {
        var T2;
        return ((T2 = th == null ? void 0 : th.adapter.publicKey) == null ? void 0 : T2.toBase58()) ?? "";
      }
    };
  }, [
    be,
    Uc,
    Pu,
    th == null ? void 0 : th.adapter
  ]), { userAddresses: Gh, isError: Mc } = useAddresses(
    Os == null ? void 0 : Os.response.chain_ids,
    xe,
    N1.address
  ), h1 = !!Mc, l2 = useMemo(() => ({
    slippageTolerancePercent: Number(Nr).toFixed(2),
    isSmartRelayEnabled: !0
  }), [Nr]), { data: Gc, isLoading: Kc } = useMessagesSWR(
    Gh,
    Os == null ? void 0 : Os.response,
    l2,
    !h1,
    {
      revalidateOnFocus: xa === 0,
      revalidateIfStale: xa === 0
    }
  ), M2 = (ah = ye == null ? void 0 : ye.data) == null ? void 0 : ah.amount.isLessThan(Aa), d1 = useMemo(() => !M2 && _u && !!Os && !Ml && !Su && !Tu && !!Gc, [
    M2,
    Ml,
    _u,
    Su,
    Tu,
    Os,
    Gc
  ]), { isMainnet: K1 } = useWalletClientContext(), {
    data: k2,
    isLoading: Eu,
    isValidating: Zo
  } = useSkipGasFeeSWR(
    Gc,
    Gh,
    K1,
    {
      revalidateOnFocus: xa === 0,
      revalidateIfStale: xa === 0
    },
    d1
  ), Fl = useBridgeFee(Os), Ru = useRelayerFee(Os), ku = useMemo(() => !!Ra.data && !!Yn.data && !!he && !!we && !!xe && !!Ne, [
    Ra.data,
    Yn.data,
    he,
    we,
    xe,
    Ne
  ]), kc = useCallback(() => {
    if (!ku)
      return;
    const O1 = Ra.data.find(
      (j2) => j2.chainId === xe
    ), T2 = Ra.data.find(
      (j2) => j2.chainId === he
    ), ih = Yn.data[O1.chainId].find(
      (j2) => j2.originDenom === Fr.originDenom
    ), oh = Yn.data[T2.chainId].find((j2) => j2.originDenom === Oe.originDenom);
    ge(O1.chainId), Ee(ih == null ? void 0 : ih.denom), $e(T2.chainId), st(oh == null ? void 0 : oh.denom);
  }, [
    Yn.data,
    Fr,
    xe,
    ku,
    Ra.data,
    Oe,
    he
  ]);
  useEffect(() => {
    ne == null || ne({
      sourceChainId: he,
      sourceAsset: we,
      destinationChainId: xe,
      destinationAsset: Ne,
      inputAmount: Aa,
      data: {
        sourceChain: fe,
        sourceAsset: Oe,
        destinationChain: be,
        destinationAsset: Fr
      }
    });
  }, [
    Ne,
    xe,
    Aa,
    ne,
    we,
    he,
    fe,
    Oe,
    be,
    Fr
  ]), useEffect(() => {
    ue == null || ue({ slippage: Nr, provider: $n });
  }, [ue, Nr, $n]);
  const Ou = useCallback(
    (O1 = !0) => {
      O1 && (ge(y.sourceChainId), Ee(zn), $e(y.destinationChainId), st(Fe)), _a(y.inputAmount ?? ""), X1(void 0);
    },
    [y, zn, Fe]
  ), [U1, g2] = useState({}), [Ic, X1] = useState();
  useEffect(() => {
    if (Object.values(U1).some(
      (T2) => !T2.isComplete
    ) && window) {
      const T2 = (ih) => {
        ih.preventDefault(), ih.returnValue = "";
      };
      return window.addEventListener("beforeunload", T2), () => {
        window.removeEventListener("beforeunload", T2);
      };
    }
  }, [U1]);
  const $2 = useMemo(
    () => {
      var O1, T2, ih, oh, j2, lh, kh;
      return {
        sourceChainId: he,
        setSourceChainId: $o,
        sourceAsset: we,
        setSourceAsset: Ee,
        destinationChainId: xe,
        setDestinationChainId: ct,
        destinationAsset: Ne,
        setDestinationAsset: st,
        slippage: Nr,
        setSlippage: br,
        slippageRemark: Ta,
        inputAmount: Aa,
        setInputAmount: _a,
        inputAmountRemark: Zn,
        sourceTokenBalance: ye,
        destinationTokenBalance: Se,
        routeResponse: Ic ? (O1 = U1[Ic]) == null ? void 0 : O1.routeResponse : Os,
        amountOut: Pa,
        isLoadingRoute: Ml,
        routeError: Tu,
        isValidatingRoute: Su,
        userEVMAddress: Pu,
        isEVMWalletConnected: Lu,
        isSVMWalletConnected: !!(th != null && th.adapter.connected),
        refresh: Au,
        isRouteQueryEnabled: _u,
        messages: Ic ? (T2 = U1[Ic]) == null ? void 0 : T2.messages : Gc,
        isLoadingMessages: Kc,
        isUserAddressesError: h1,
        gasFeesData: Ic ? (ih = U1[Ic]) == null ? void 0 : ih.gasFeesData : k2,
        isLoadingGasFee: Eu,
        isValidatingGasFee: Zo,
        interchange: kc,
        isInterchangeEnabled: ku,
        isConversionRateChecked: Rn,
        setIsConversionRateChecked: wa,
        sourceAssetData: Ic ? (oh = U1[Ic]) == null ? void 0 : oh.sourceAssetData : Oe,
        destinationAssetData: Ic ? (j2 = U1[Ic]) == null ? void 0 : j2.destinationAssetData : Fr,
        sourceAddress: Zc,
        destinationAddress: N1,
        txnLifecycleHooks: le,
        resetInputsToDefaults: Ou,
        sourceChainData: Ic ? (lh = U1[Ic]) == null ? void 0 : lh.sourceChainData : fe,
        destinationChainData: Ic ? (kh = U1[Ic]) == null ? void 0 : kh.destinationChainData : be,
        swapProvider: $n,
        setSwapProvider: En,
        userAddresses: Gh,
        ongoingTransactions: U1,
        setOngoingTransactions: g2,
        currentSwapId: Ic,
        setCurrentSwapId: X1,
        relayerFee: Ru,
        routeKey: Zl,
        bridgeFeesData: Fl
      };
    },
    [
      he,
      $o,
      we,
      xe,
      ct,
      Ne,
      Nr,
      Ta,
      Aa,
      Zn,
      ye,
      Se,
      Ic,
      U1,
      Os,
      Pa,
      Ml,
      Tu,
      Su,
      Pu,
      Lu,
      th == null ? void 0 : th.adapter.connected,
      Au,
      _u,
      Gc,
      Kc,
      h1,
      k2,
      Eu,
      Zo,
      kc,
      ku,
      Rn,
      Oe,
      Fr,
      Zc,
      N1,
      le,
      Ou,
      fe,
      be,
      $n,
      Gh,
      Ru,
      Zl,
      Fl
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsContext.Provider, { value: $2, children: v });
}, useSwapsContext = () => {
  const v = useContext(SwapsContext);
  return invariant$1(v, `Please use ${useSwapsContext.name} within SwapsProvider`), v;
};
function defineChain(v, y = {}) {
  const { fees: z = v.fees, formatters: ne = v.formatters, serializers: ue = v.serializers } = y;
  return {
    ...v,
    fees: z,
    formatters: ne,
    serializers: ue
  };
}
const arbitrum = /* @__PURE__ */ defineChain({
  id: 42161,
  name: "Arbitrum One",
  network: "arbitrum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://arb-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://arb-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://arbitrum-mainnet.infura.io/v3"],
      webSocket: ["wss://arbitrum-mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    },
    public: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    etherscan: { name: "Arbiscan", url: "https://arbiscan.io" },
    default: { name: "Arbiscan", url: "https://arbiscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
}), arbitrumGoerli = /* @__PURE__ */ defineChain({
  id: 421613,
  name: "Arbitrum Goerli",
  network: "arbitrum-goerli",
  nativeCurrency: {
    name: "Arbitrum Goerli Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    alchemy: {
      http: ["https://arb-goerli.g.alchemy.com/v2"],
      webSocket: ["wss://arb-goerli.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://arbitrum-goerli.infura.io/v3"],
      webSocket: ["wss://arbitrum-goerli.infura.io/ws/v3"]
    },
    default: {
      http: ["https://goerli-rollup.arbitrum.io/rpc"]
    },
    public: {
      http: ["https://goerli-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    etherscan: { name: "Arbiscan", url: "https://goerli.arbiscan.io" },
    default: { name: "Arbiscan", url: "https://goerli.arbiscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 88114
    }
  },
  testnet: !0
}), arbitrumNova = /* @__PURE__ */ defineChain({
  id: 42170,
  name: "Arbitrum Nova",
  network: "arbitrum-nova",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    blast: {
      http: ["https://arbitrum-nova.public.blastapi.io"],
      webSocket: ["wss://arbitrum-nova.public.blastapi.io"]
    },
    default: {
      http: ["https://nova.arbitrum.io/rpc"]
    },
    public: {
      http: ["https://nova.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    etherscan: { name: "Arbiscan", url: "https://nova.arbiscan.io" },
    blockScout: {
      name: "BlockScout",
      url: "https://nova-explorer.arbitrum.io/"
    },
    default: { name: "Arbiscan", url: "https://nova.arbiscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1746963
    }
  }
}), astar = /* @__PURE__ */ defineChain({
  id: 592,
  name: "Astar",
  network: "astar-mainnet",
  nativeCurrency: {
    name: "Astar",
    symbol: "ASTR",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://astar.api.onfinality.io/public"] },
    default: { http: ["https://astar.api.onfinality.io/public"] }
  },
  blockExplorers: {
    default: { name: "Astar Subscan", url: "https://astar.subscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 761794
    }
  },
  testnet: !1
}), arbitrumSepolia = /* @__PURE__ */ defineChain({
  id: 421614,
  name: "Arbitrum Sepolia",
  network: "arbitrum-sepolia",
  nativeCurrency: {
    name: "Arbitrum Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    alchemy: {
      http: ["https://arb-sepolia.g.alchemy.com/v2"],
      webSocket: ["wss://arb-sepolia.g.alchemy.com/v2"]
    },
    default: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    },
    public: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    etherscan: { name: "Arbiscan", url: "https://sepolia.arbiscan.io" },
    default: { name: "Arbiscan", url: "https://sepolia.arbiscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 81930
    }
  },
  testnet: !0
}), astarZkatana = /* @__PURE__ */ defineChain({
  id: 1261120,
  name: "Astar zkEVM Testnet zKatana",
  network: "zKatana",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://rpc.zkatana.gelato.digital",
        "https://rpc.startale.com/zkatana"
      ]
    },
    public: {
      http: [
        "https://rpc.zkatana.gelato.digital",
        "https://rpc.startale.com/zkatana"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Blockscout zKatana chain explorer",
      url: "https://zkatana.blockscout.com"
    },
    default: {
      name: "zKatana Explorer",
      url: "https://zkatana.explorer.startale.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 31317
    }
  },
  testnet: !0
}), aurora = /* @__PURE__ */ defineChain({
  id: 1313161554,
  name: "Aurora",
  network: "aurora",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    infura: { http: ["https://aurora-mainnet.infura.io/v3"] },
    default: { http: ["https://mainnet.aurora.dev"] },
    public: { http: ["https://mainnet.aurora.dev"] }
  },
  blockExplorers: {
    etherscan: { name: "Aurorascan", url: "https://aurorascan.dev" },
    default: { name: "Aurorascan", url: "https://aurorascan.dev" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 62907816
    }
  }
}), auroraTestnet = /* @__PURE__ */ defineChain({
  id: 1313161555,
  name: "Aurora Testnet",
  network: "aurora-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    infura: { http: ["https://aurora-testnet.infura.io/v3"] },
    default: { http: ["https://testnet.aurora.dev"] },
    public: { http: ["https://testnet.aurora.dev"] }
  },
  blockExplorers: {
    etherscan: { name: "Aurorascan", url: "https://testnet.aurorascan.dev" },
    default: { name: "Aurorascan", url: "https://testnet.aurorascan.dev" }
  },
  testnet: !0
}), avalanche = /* @__PURE__ */ defineChain({
  id: 43114,
  name: "Avalanche",
  network: "avalanche",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax.network/ext/bc/C/rpc"] },
    public: { http: ["https://api.avax.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    etherscan: { name: "SnowTrace", url: "https://snowtrace.io" },
    default: { name: "SnowTrace", url: "https://snowtrace.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11907934
    }
  }
}), avalancheFuji = /* @__PURE__ */ defineChain({
  id: 43113,
  name: "Avalanche Fuji",
  network: "avalanche-fuji",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche Fuji",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] },
    public: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    etherscan: { name: "SnowTrace", url: "https://testnet.snowtrace.io" },
    default: { name: "SnowTrace", url: "https://testnet.snowtrace.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7096959
    }
  },
  testnet: !0
}), version = "1.21.0", getVersion = () => `viem@${version}`;
class BaseError extends Error {
  constructor(y, z = {}) {
    var le;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: getVersion()
    });
    const ne = z.cause instanceof BaseError ? z.cause.details : (le = z.cause) != null && le.message ? z.cause.message : z.details, ue = z.cause instanceof BaseError && z.cause.docsPath || z.docsPath;
    this.message = [
      y || "An error occurred.",
      "",
      ...z.metaMessages ? [...z.metaMessages, ""] : [],
      ...ue ? [
        `Docs: https://viem.sh${ue}.html${z.docsSlug ? `#${z.docsSlug}` : ""}`
      ] : [],
      ...ne ? [`Details: ${ne}`] : [],
      `Version: ${this.version}`
    ].join(`
`), z.cause && (this.cause = z.cause), this.details = ne, this.docsPath = ue, this.metaMessages = z.metaMessages, this.shortMessage = y;
  }
  walk(y) {
    return walk$1(this, y);
  }
}
function walk$1(v, y) {
  return y != null && y(v) ? v : v && typeof v == "object" && "cause" in v ? walk$1(v.cause, y) : y ? null : v;
}
class IntegerOutOfRangeError extends BaseError {
  constructor({ max: y, min: z, signed: ne, size: ue, value: le }) {
    super(`Number "${le}" is not in safe ${ue ? `${ue * 8}-bit ${ne ? "signed" : "unsigned"} ` : ""}integer range ${y ? `(${z} to ${y})` : `(above ${z})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class SizeOverflowError extends BaseError {
  constructor({ givenSize: y, maxSize: z }) {
    super(`Size cannot exceed ${z} bytes. Given size: ${y} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
function isHex(v, { strict: y = !0 } = {}) {
  return !v || typeof v != "string" ? !1 : y ? /^0x[0-9a-fA-F]*$/.test(v) : v.startsWith("0x");
}
function size(v) {
  return isHex(v, { strict: !1 }) ? Math.ceil((v.length - 2) / 2) : v.length;
}
function trim(v, { dir: y = "left" } = {}) {
  let z = typeof v == "string" ? v.replace("0x", "") : v, ne = 0;
  for (let ue = 0; ue < z.length - 1 && z[y === "left" ? ue : z.length - ue - 1].toString() === "0"; ue++)
    ne++;
  return z = y === "left" ? z.slice(ne) : z.slice(0, z.length - ne), typeof v == "string" ? (z.length === 1 && y === "right" && (z = `${z}0`), `0x${z.length % 2 === 1 ? `0${z}` : z}`) : z;
}
class SizeExceedsPaddingSizeError extends BaseError {
  constructor({ size: y, targetSize: z, type: ne }) {
    super(`${ne.charAt(0).toUpperCase()}${ne.slice(1).toLowerCase()} size (${y}) exceeds padding size (${z}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
function pad(v, { dir: y, size: z = 32 } = {}) {
  return typeof v == "string" ? padHex(v, { dir: y, size: z }) : padBytes(v, { dir: y, size: z });
}
function padHex(v, { dir: y, size: z = 32 } = {}) {
  if (z === null)
    return v;
  const ne = v.replace("0x", "");
  if (ne.length > z * 2)
    throw new SizeExceedsPaddingSizeError({
      size: Math.ceil(ne.length / 2),
      targetSize: z,
      type: "hex"
    });
  return `0x${ne[y === "right" ? "padEnd" : "padStart"](z * 2, "0")}`;
}
function padBytes(v, { dir: y, size: z = 32 } = {}) {
  if (z === null)
    return v;
  if (v.length > z)
    throw new SizeExceedsPaddingSizeError({
      size: v.length,
      targetSize: z,
      type: "bytes"
    });
  const ne = new Uint8Array(z);
  for (let ue = 0; ue < z; ue++) {
    const le = y === "right";
    ne[le ? ue : z - ue - 1] = v[le ? ue : v.length - ue - 1];
  }
  return ne;
}
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (v, y) => y.toString(16).padStart(2, "0"));
function toHex(v, y = {}) {
  return typeof v == "number" || typeof v == "bigint" ? numberToHex(v, y) : typeof v == "string" ? stringToHex(v, y) : typeof v == "boolean" ? boolToHex(v, y) : bytesToHex(v, y);
}
function boolToHex(v, y = {}) {
  const z = `0x${Number(v)}`;
  return typeof y.size == "number" ? (assertSize(z, { size: y.size }), pad(z, { size: y.size })) : z;
}
function bytesToHex(v, y = {}) {
  let z = "";
  for (let ue = 0; ue < v.length; ue++)
    z += hexes[v[ue]];
  const ne = `0x${z}`;
  return typeof y.size == "number" ? (assertSize(ne, { size: y.size }), pad(ne, { dir: "right", size: y.size })) : ne;
}
function numberToHex(v, y = {}) {
  const { signed: z, size: ne } = y, ue = BigInt(v);
  let le;
  ne ? z ? le = (1n << BigInt(ne) * 8n - 1n) - 1n : le = 2n ** (BigInt(ne) * 8n) - 1n : typeof v == "number" && (le = BigInt(Number.MAX_SAFE_INTEGER));
  const he = typeof le == "bigint" && z ? -le - 1n : 0;
  if (le && ue > le || ue < he) {
    const we = typeof v == "bigint" ? "n" : "";
    throw new IntegerOutOfRangeError({
      max: le ? `${le}${we}` : void 0,
      min: `${he}${we}`,
      signed: z,
      size: ne,
      value: `${v}${we}`
    });
  }
  const ge = `0x${(z && ue < 0 ? (1n << BigInt(ne * 8)) + BigInt(ue) : ue).toString(16)}`;
  return ne ? pad(ge, { size: ne }) : ge;
}
const encoder = /* @__PURE__ */ new TextEncoder();
function stringToHex(v, y = {}) {
  const z = encoder.encode(v);
  return bytesToHex(z, y);
}
const charCodeMap = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function charCodeToBase16(v) {
  if (v >= charCodeMap.zero && v <= charCodeMap.nine)
    return v - charCodeMap.zero;
  if (v >= charCodeMap.A && v <= charCodeMap.F)
    return v - (charCodeMap.A - 10);
  if (v >= charCodeMap.a && v <= charCodeMap.f)
    return v - (charCodeMap.a - 10);
}
function hexToBytes(v, y = {}) {
  let z = v;
  y.size && (assertSize(z, { size: y.size }), z = pad(z, { dir: "right", size: y.size }));
  let ne = z.slice(2);
  ne.length % 2 && (ne = `0${ne}`);
  const ue = ne.length / 2, le = new Uint8Array(ue);
  for (let he = 0, ge = 0; he < ue; he++) {
    const we = charCodeToBase16(ne.charCodeAt(ge++)), Ee = charCodeToBase16(ne.charCodeAt(ge++));
    if (we === void 0 || Ee === void 0)
      throw new BaseError(`Invalid byte sequence ("${ne[ge - 2]}${ne[ge - 1]}" in "${ne}").`);
    le[he] = we * 16 + Ee;
  }
  return le;
}
function assertSize(v, { size: y }) {
  if (size(v) > y)
    throw new SizeOverflowError({
      givenSize: size(v),
      maxSize: y
    });
}
function hexToBigInt(v, y = {}) {
  const { signed: z } = y;
  y.size && assertSize(v, { size: y.size });
  const ne = BigInt(v);
  if (!z)
    return ne;
  const ue = (v.length - 2) / 2, le = (1n << BigInt(ue) * 8n - 1n) - 1n;
  return ne <= le ? ne : ne - BigInt(`0x${"f".padStart(ue * 2, "f")}`) - 1n;
}
function hexToNumber(v, y = {}) {
  return Number(hexToBigInt(v, y));
}
function defineFormatter(v, y) {
  return ({ exclude: z, format: ne }) => ({
    exclude: z,
    format: (ue) => {
      const le = y(ue);
      if (z)
        for (const he of z)
          delete le[he];
      return {
        ...le,
        ...ne(ue)
      };
    },
    type: v
  });
}
const transactionType = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559"
};
function formatTransaction(v) {
  const y = {
    ...v,
    blockHash: v.blockHash ? v.blockHash : null,
    blockNumber: v.blockNumber ? BigInt(v.blockNumber) : null,
    chainId: v.chainId ? hexToNumber(v.chainId) : void 0,
    gas: v.gas ? BigInt(v.gas) : void 0,
    gasPrice: v.gasPrice ? BigInt(v.gasPrice) : void 0,
    maxFeePerGas: v.maxFeePerGas ? BigInt(v.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: v.maxPriorityFeePerGas ? BigInt(v.maxPriorityFeePerGas) : void 0,
    nonce: v.nonce ? hexToNumber(v.nonce) : void 0,
    to: v.to ? v.to : null,
    transactionIndex: v.transactionIndex ? Number(v.transactionIndex) : null,
    type: v.type ? transactionType[v.type] : void 0,
    typeHex: v.type ? v.type : void 0,
    value: v.value ? BigInt(v.value) : void 0,
    v: v.v ? BigInt(v.v) : void 0
  };
  return y.yParity = (() => {
    if (v.yParity)
      return Number(v.yParity);
    if (typeof y.v == "bigint") {
      if (y.v === 0n || y.v === 27n)
        return 0;
      if (y.v === 1n || y.v === 28n)
        return 1;
      if (y.v >= 35n)
        return y.v % 2n === 0n ? 1 : 0;
    }
  })(), y.type === "legacy" && (delete y.accessList, delete y.maxFeePerGas, delete y.maxPriorityFeePerGas, delete y.yParity), y.type === "eip2930" && (delete y.maxFeePerGas, delete y.maxPriorityFeePerGas), y;
}
const defineTransaction = /* @__PURE__ */ defineFormatter("transaction", formatTransaction);
function formatBlock(v) {
  var z;
  const y = (z = v.transactions) == null ? void 0 : z.map((ne) => typeof ne == "string" ? ne : formatTransaction(ne));
  return {
    ...v,
    baseFeePerGas: v.baseFeePerGas ? BigInt(v.baseFeePerGas) : null,
    difficulty: v.difficulty ? BigInt(v.difficulty) : void 0,
    gasLimit: v.gasLimit ? BigInt(v.gasLimit) : void 0,
    gasUsed: v.gasUsed ? BigInt(v.gasUsed) : void 0,
    hash: v.hash ? v.hash : null,
    logsBloom: v.logsBloom ? v.logsBloom : null,
    nonce: v.nonce ? v.nonce : null,
    number: v.number ? BigInt(v.number) : null,
    size: v.size ? BigInt(v.size) : void 0,
    timestamp: v.timestamp ? BigInt(v.timestamp) : void 0,
    transactions: y,
    totalDifficulty: v.totalDifficulty ? BigInt(v.totalDifficulty) : null
  };
}
const defineBlock = /* @__PURE__ */ defineFormatter("block", formatBlock);
function formatLog(v, { args: y, eventName: z } = {}) {
  return {
    ...v,
    blockHash: v.blockHash ? v.blockHash : null,
    blockNumber: v.blockNumber ? BigInt(v.blockNumber) : null,
    logIndex: v.logIndex ? Number(v.logIndex) : null,
    transactionHash: v.transactionHash ? v.transactionHash : null,
    transactionIndex: v.transactionIndex ? Number(v.transactionIndex) : null,
    ...z ? { args: y, eventName: z } : {}
  };
}
const statuses = {
  "0x0": "reverted",
  "0x1": "success"
};
function formatTransactionReceipt(v) {
  return {
    ...v,
    blockNumber: v.blockNumber ? BigInt(v.blockNumber) : null,
    contractAddress: v.contractAddress ? v.contractAddress : null,
    cumulativeGasUsed: v.cumulativeGasUsed ? BigInt(v.cumulativeGasUsed) : null,
    effectiveGasPrice: v.effectiveGasPrice ? BigInt(v.effectiveGasPrice) : null,
    gasUsed: v.gasUsed ? BigInt(v.gasUsed) : null,
    logs: v.logs ? v.logs.map((y) => formatLog(y)) : null,
    to: v.to ? v.to : null,
    transactionIndex: v.transactionIndex ? hexToNumber(v.transactionIndex) : null,
    status: v.status ? statuses[v.status] : null,
    type: v.type ? transactionType[v.type] || v.type : null
  };
}
const defineTransactionReceipt = /* @__PURE__ */ defineFormatter("transactionReceipt", formatTransactionReceipt), formattersOptimism = {
  block: /* @__PURE__ */ defineBlock({
    format(v) {
      var z;
      return {
        transactions: (z = v.transactions) == null ? void 0 : z.map((ne) => {
          if (typeof ne == "string")
            return ne;
          const ue = formatTransaction(ne);
          return ue.typeHex === "0x7e" && (ue.isSystemTx = ne.isSystemTx, ue.mint = ne.mint ? hexToBigInt(ne.mint) : void 0, ue.sourceHash = ne.sourceHash, ue.type = "deposit"), ue;
        }),
        stateRoot: v.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ defineTransaction({
    format(v) {
      const y = {};
      return v.type === "0x7e" && (y.isSystemTx = v.isSystemTx, y.mint = v.mint ? hexToBigInt(v.mint) : void 0, y.sourceHash = v.sourceHash, y.type = "deposit"), y;
    }
  }),
  transactionReceipt: /* @__PURE__ */ defineTransactionReceipt({
    format(v) {
      return {
        l1GasPrice: v.l1GasPrice ? hexToBigInt(v.l1GasPrice) : null,
        l1GasUsed: v.l1GasUsed ? hexToBigInt(v.l1GasUsed) : null,
        l1Fee: v.l1Fee ? hexToBigInt(v.l1Fee) : null,
        l1FeeScalar: v.l1FeeScalar ? Number(v.l1FeeScalar) : null
      };
    }
  })
}, base$1 = /* @__PURE__ */ defineChain({
  id: 8453,
  network: "base",
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://base-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://base-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://base-mainnet.infura.io/v3"],
      webSocket: ["wss://base-mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://mainnet.base.org"]
    },
    public: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Basescout",
      url: "https://base.blockscout.com"
    },
    default: {
      name: "Basescan",
      url: "https://basescan.org"
    },
    etherscan: {
      name: "Basescan",
      url: "https://basescan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    }
  }
}, {
  formatters: formattersOptimism
}), baseGoerli = /* @__PURE__ */ defineChain({
  id: 84531,
  network: "base-goerli",
  name: "Base Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://base-goerli.g.alchemy.com/v2"],
      webSocket: ["wss://base-goerli.g.alchemy.com/v2"]
    },
    default: {
      http: ["https://goerli.base.org"]
    },
    public: {
      http: ["https://goerli.base.org"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Basescan",
      url: "https://goerli.basescan.org"
    },
    default: {
      name: "Basescan",
      url: "https://goerli.basescan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1376988
    }
  },
  testnet: !0,
  sourceId: 5
  // goerli
}, {
  formatters: formattersOptimism
}), baseSepolia = /* @__PURE__ */ defineChain({
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    },
    public: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Blockscout",
      url: "https://base-sepolia.blockscout.com"
    },
    default: {
      name: "Blockscout",
      url: "https://base-sepolia.blockscout.com"
    }
  },
  testnet: !0,
  sourceId: 11155111
  // sepolia
}, {
  formatters: formattersOptimism
}), bearNetworkChainMainnet = /* @__PURE__ */ defineChain({
  id: 641230,
  name: "Bear Network Chain Mainnet",
  network: "BearNetworkChainMainnet",
  nativeCurrency: {
    decimals: 18,
    name: "BearNetworkChain",
    symbol: "BRNKC"
  },
  rpcUrls: {
    public: { http: ["https://brnkc-mainnet.bearnetwork.net"] },
    default: { http: ["https://brnkc-mainnet.bearnetwork.net"] }
  },
  blockExplorers: {
    default: { name: "BrnkScan", url: "https://brnkscan.bearnetwork.net" }
  }
}), bearNetworkChainTestnet = /* @__PURE__ */ defineChain({
  id: 751230,
  name: "Bear Network Chain Testnet",
  network: "BearNetworkChainTestnet",
  nativeCurrency: {
    decimals: 18,
    name: "tBRNKC",
    symbol: "tBRNKC"
  },
  rpcUrls: {
    public: { http: ["https://brnkc-test.bearnetwork.net"] },
    default: { http: ["https://brnkc-test.bearnetwork.net"] }
  },
  blockExplorers: {
    default: {
      name: "BrnkTestScan",
      url: "https://brnktest-scan.bearnetwork.net"
    }
  },
  testnet: !0
}), bitTorrent = /* @__PURE__ */ defineChain({
  id: 199,
  name: "BitTorrent",
  network: "bittorrent-chain-mainnet",
  nativeCurrency: { name: "BitTorrent", symbol: "BTT", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.bittorrentchain.io"] },
    public: { http: ["https://rpc.bittorrentchain.io"] }
  },
  blockExplorers: {
    etherscan: { name: "Bttcscan", url: "https://bttcscan.com" },
    default: { name: "Bttcscan", url: "https://bttcscan.com" }
  }
}), bitTorrentTestnet = /* @__PURE__ */ defineChain({
  id: 1028,
  name: "BitTorrent Chain Testnet",
  network: "bittorrent-chain-testnet",
  nativeCurrency: { name: "BitTorrent", symbol: "BTT", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://testrpc.bittorrentchain.io"] },
    public: { http: ["https://testrpc.bittorrentchain.io"] }
  },
  blockExplorers: {
    etherscan: { name: "Bttcscan", url: "https://testnet.bttcscan.com" },
    default: { name: "Bttcscan", url: "https://testnet.bttcscan.com" }
  },
  testnet: !0
}), boba = /* @__PURE__ */ defineChain({
  id: 288,
  name: "Boba Network",
  network: "boba",
  nativeCurrency: {
    decimals: 18,
    name: "Boba",
    symbol: "BOBA"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.boba.network"] },
    public: { http: ["https://mainnet.boba.network"] }
  },
  blockExplorers: {
    etherscan: { name: "BOBAScan", url: "https://bobascan.com" },
    default: { name: "BOBAScan", url: "https://bobascan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 446859
    }
  }
}), bronos = /* @__PURE__ */ defineChain({
  id: 1039,
  name: "Bronos",
  network: "bronos",
  nativeCurrency: {
    decimals: 18,
    name: "BRO",
    symbol: "BRO"
  },
  rpcUrls: {
    default: { http: ["https://evm.bronos.org"] },
    public: { http: ["https://evm.bronos.org"] }
  },
  blockExplorers: {
    default: { name: "BronoScan", url: "https://broscan.bronos.org" }
  }
}), bronosTestnet = /* @__PURE__ */ defineChain({
  id: 1038,
  name: "Bronos Testnet",
  network: "bronos-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Bronos Coin",
    symbol: "tBRO"
  },
  rpcUrls: {
    default: { http: ["https://evm-testnet.bronos.org"] },
    public: { http: ["https://evm-testnet.bronos.org"] }
  },
  blockExplorers: {
    default: { name: "BronoScan", url: "https://tbroscan.bronos.org" }
  },
  testnet: !0
}), bsc = /* @__PURE__ */ defineChain({
  id: 56,
  name: "BNB Smart Chain",
  network: "bsc",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/bsc"] },
    public: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    etherscan: { name: "BscScan", url: "https://bscscan.com" },
    default: { name: "BscScan", url: "https://bscscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), bscTestnet = /* @__PURE__ */ defineChain({
  id: 97,
  name: "Binance Smart Chain Testnet",
  network: "bsc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    default: { http: ["https://data-seed-prebsc-1-s1.bnbchain.org:8545"] },
    public: { http: ["https://data-seed-prebsc-1-s1.bnbchain.org:8545"] }
  },
  blockExplorers: {
    etherscan: { name: "BscScan", url: "https://testnet.bscscan.com" },
    default: { name: "BscScan", url: "https://testnet.bscscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 17422483
    }
  },
  testnet: !0
}), bxn = /* @__PURE__ */ defineChain({
  id: 4999,
  name: "BlackFort Exchange Network",
  network: "bxn",
  nativeCurrency: { name: "BlackFort Token", symbol: "BXN", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.blackfort.network/rpc"]
    },
    public: {
      http: ["https://mainnet.blackfort.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.blackfort.network"
    }
  }
}), bxnTestnet = /* @__PURE__ */ defineChain({
  id: 4777,
  name: "BlackFort Exchange Network Testnet",
  network: "bxnTestnet",
  nativeCurrency: {
    name: "BlackFort Testnet Token",
    symbol: "TBXN",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.blackfort.network/rpc"]
    },
    public: {
      http: ["https://testnet.blackfort.network/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer.blackfort.network"
    }
  }
}), canto = /* @__PURE__ */ defineChain({
  id: 7700,
  name: "Canto",
  network: "canto",
  nativeCurrency: {
    decimals: 18,
    name: "Canto",
    symbol: "CANTO"
  },
  rpcUrls: {
    default: { http: ["https://canto.gravitychain.io"] },
    public: { http: ["https://canto.gravitychain.io"] }
  },
  blockExplorers: {
    default: {
      name: "Tuber.Build (Blockscout)",
      url: "https://tuber.build"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2905789
    }
  }
}), rpcTransactionType = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2"
};
function formatTransactionRequest(v) {
  return {
    ...v,
    gas: typeof v.gas < "u" ? numberToHex(v.gas) : void 0,
    gasPrice: typeof v.gasPrice < "u" ? numberToHex(v.gasPrice) : void 0,
    maxFeePerGas: typeof v.maxFeePerGas < "u" ? numberToHex(v.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: typeof v.maxPriorityFeePerGas < "u" ? numberToHex(v.maxPriorityFeePerGas) : void 0,
    nonce: typeof v.nonce < "u" ? numberToHex(v.nonce) : void 0,
    type: typeof v.type < "u" ? rpcTransactionType[v.type] : void 0,
    value: typeof v.value < "u" ? numberToHex(v.value) : void 0
  };
}
const defineTransactionRequest = /* @__PURE__ */ defineFormatter("transactionRequest", formatTransactionRequest);
function isEmpty(v) {
  return v === 0 || v === 0n || v === void 0 || v === null || v === "0" || v === "" || typeof v == "string" && (trim(v).toLowerCase() === "0x" || trim(v).toLowerCase() === "0x00");
}
function isPresent(v) {
  return !isEmpty(v);
}
function isEIP1559(v) {
  return isPresent(v.maxFeePerGas) && isPresent(v.maxPriorityFeePerGas);
}
function isCIP42(v) {
  return v.type === "cip42" ? !0 : isEIP1559(v) && (isPresent(v.feeCurrency) || isPresent(v.gatewayFeeRecipient) || isPresent(v.gatewayFee));
}
function isCIP64(v) {
  return v.type === "cip64" ? !0 : isEIP1559(v) && isPresent(v.feeCurrency) && isEmpty(v.gatewayFee) && isEmpty(v.gatewayFeeRecipient);
}
const formattersCelo = {
  block: /* @__PURE__ */ defineBlock({
    exclude: ["difficulty", "gasLimit", "mixHash", "nonce", "uncles"],
    format(v) {
      var z;
      const y = (z = v.transactions) == null ? void 0 : z.map((ne) => typeof ne == "string" ? ne : {
        ...formatTransaction(ne),
        feeCurrency: ne.feeCurrency,
        ...ne.type !== "0x7b" ? {
          gatewayFee: ne.gatewayFee ? hexToBigInt(ne.gatewayFee) : null,
          gatewayFeeRecipient: ne.gatewayFeeRecipient || null
        } : {}
      });
      return {
        randomness: v.randomness,
        transactions: y
      };
    }
  }),
  transaction: /* @__PURE__ */ defineTransaction({
    format(v) {
      const y = { feeCurrency: v.feeCurrency };
      return v.type === "0x7b" ? y.type = "cip64" : (v.type === "0x7c" && (y.type = "cip42"), y.gatewayFee = v.gatewayFee ? hexToBigInt(v.gatewayFee) : null, y.gatewayFeeRecipient = v.gatewayFeeRecipient), y;
    }
  }),
  transactionRequest: /* @__PURE__ */ defineTransactionRequest({
    format(v) {
      const y = {
        feeCurrency: v.feeCurrency
      };
      return isCIP64(v) ? y.type = "0x7b" : (isCIP42(v) && (y.type = "0x7c"), y.gatewayFee = typeof v.gatewayFee < "u" ? numberToHex(v.gatewayFee) : void 0, y.gatewayFeeRecipient = v.gatewayFeeRecipient), y;
    }
  })
};
class InvalidAddressError extends BaseError {
  constructor({ address: y }) {
    super(`Address "${y}" is invalid.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class InvalidChainIdError extends BaseError {
  constructor({ chainId: y }) {
    super(`Chain ID "${y}" is invalid.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidChainIdError"
    });
  }
}
const gweiUnits = {
  ether: -9,
  wei: 9
};
function formatUnits(v, y) {
  let z = v.toString();
  const ne = z.startsWith("-");
  ne && (z = z.slice(1)), z = z.padStart(y, "0");
  let [ue, le] = [
    z.slice(0, z.length - y),
    z.slice(z.length - y)
  ];
  return le = le.replace(/(0+)$/, ""), `${ne ? "-" : ""}${ue || "0"}${le ? `.${le}` : ""}`;
}
function formatGwei(v, y = "wei") {
  return formatUnits(v, gweiUnits[y]);
}
class FeeCapTooHighError extends BaseError {
  constructor({ cause: y, maxFeePerGas: z } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${z ? ` = ${formatGwei(z)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: y
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(FeeCapTooHighError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class TipAboveFeeCapError extends BaseError {
  constructor({ cause: y, maxPriorityFeePerGas: z, maxFeePerGas: ne } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${z ? ` = ${formatGwei(z)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${ne ? ` = ${formatGwei(ne)} gwei` : ""}).`
    ].join(`
`), {
      cause: y
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(TipAboveFeeCapError, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
const addressRegex = /^0x[a-fA-F0-9]{40}$/;
function isAddress(v) {
  return addressRegex.test(v);
}
function concatHex(v) {
  return `0x${v.reduce((y, z) => y + z.replace("0x", ""), "")}`;
}
function prettyPrint(v) {
  const y = Object.entries(v).map(([ne, ue]) => ue === void 0 || ue === !1 ? null : [ne, ue]).filter(Boolean), z = y.reduce((ne, [ue]) => Math.max(ne, ue.length), 0);
  return y.map(([ne, ue]) => `  ${`${ne}:`.padEnd(z + 1)}  ${ue}`).join(`
`);
}
class InvalidLegacyVError extends BaseError {
  constructor({ v: y }) {
    super(`Invalid \`v\` value "${y}". Expected 27 or 28.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidLegacyVError"
    });
  }
}
class InvalidSerializableTransactionError extends BaseError {
  constructor({ transaction: y }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        prettyPrint(y),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class InvalidStorageKeySizeError extends BaseError {
  constructor({ storageKey: y }) {
    super(`Size for storage key "${y}" is invalid. Expected 32 bytes. Got ${Math.floor((y.length - 2) / 2)} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStorageKeySizeError"
    });
  }
}
function getTransactionType(v) {
  if (v.type)
    return v.type;
  if (typeof v.maxFeePerGas < "u" || typeof v.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof v.gasPrice < "u")
    return typeof v.accessList < "u" ? "eip2930" : "legacy";
  throw new InvalidSerializableTransactionError({ transaction: v });
}
class NegativeOffsetError extends BaseError {
  constructor({ offset: y }) {
    super(`Offset \`${y}\` cannot be negative.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NegativeOffsetError"
    });
  }
}
class PositionOutOfBoundsError extends BaseError {
  constructor({ length: y, position: z }) {
    super(`Position \`${z}\` is out of bounds (\`0 < position < ${y}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PositionOutOfBoundsError"
    });
  }
}
const staticCursor = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  assertPosition(v) {
    if (v < 0 || v > this.bytes.length - 1)
      throw new PositionOutOfBoundsError({
        length: this.bytes.length,
        position: v
      });
  },
  decrementPosition(v) {
    if (v < 0)
      throw new NegativeOffsetError({ offset: v });
    const y = this.position - v;
    this.assertPosition(y), this.position = y;
  },
  incrementPosition(v) {
    if (v < 0)
      throw new NegativeOffsetError({ offset: v });
    const y = this.position + v;
    this.assertPosition(y), this.position = y;
  },
  inspectByte(v) {
    const y = v ?? this.position;
    return this.assertPosition(y), this.bytes[y];
  },
  inspectBytes(v, y) {
    const z = y ?? this.position;
    return this.assertPosition(z + v - 1), this.bytes.subarray(z, z + v);
  },
  inspectUint8(v) {
    const y = v ?? this.position;
    return this.assertPosition(y), this.bytes[y];
  },
  inspectUint16(v) {
    const y = v ?? this.position;
    return this.assertPosition(y + 1), this.dataView.getUint16(y);
  },
  inspectUint24(v) {
    const y = v ?? this.position;
    return this.assertPosition(y + 2), (this.dataView.getUint16(y) << 8) + this.dataView.getUint8(y + 2);
  },
  inspectUint32(v) {
    const y = v ?? this.position;
    return this.assertPosition(y + 3), this.dataView.getUint32(y);
  },
  pushByte(v) {
    this.assertPosition(this.position), this.bytes[this.position] = v, this.position++;
  },
  pushBytes(v) {
    this.assertPosition(this.position + v.length - 1), this.bytes.set(v, this.position), this.position += v.length;
  },
  pushUint8(v) {
    this.assertPosition(this.position), this.bytes[this.position] = v, this.position++;
  },
  pushUint16(v) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, v), this.position += 2;
  },
  pushUint24(v) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, v >> 8), this.dataView.setUint8(this.position + 2, v & 255), this.position += 3;
  },
  pushUint32(v) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, v), this.position += 4;
  },
  readByte() {
    const v = this.inspectByte();
    return this.position++, v;
  },
  readBytes(v) {
    const y = this.inspectBytes(v);
    return this.position += v, y;
  },
  readUint8() {
    const v = this.inspectUint8();
    return this.position += 1, v;
  },
  readUint16() {
    const v = this.inspectUint16();
    return this.position += 2, v;
  },
  readUint24() {
    const v = this.inspectUint24();
    return this.position += 3, v;
  },
  readUint32() {
    const v = this.inspectUint32();
    return this.position += 4, v;
  },
  setPosition(v) {
    this.assertPosition(v), this.position = v;
  }
};
function createCursor(v) {
  const y = Object.create(staticCursor);
  return y.bytes = v, y.dataView = new DataView(v.buffer, v.byteOffset, v.byteLength), y;
}
function assertTransactionEIP1559(v) {
  const { chainId: y, maxPriorityFeePerGas: z, gasPrice: ne, maxFeePerGas: ue, to: le } = v;
  if (y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (le && !isAddress(le))
    throw new InvalidAddressError({ address: le });
  if (ne)
    throw new BaseError("`gasPrice` is not a valid EIP-1559 Transaction attribute.");
  if (ue && ue > 2n ** 256n - 1n)
    throw new FeeCapTooHighError({ maxFeePerGas: ue });
  if (z && ue && z > ue)
    throw new TipAboveFeeCapError({ maxFeePerGas: ue, maxPriorityFeePerGas: z });
}
function assertTransactionEIP2930(v) {
  const { chainId: y, maxPriorityFeePerGas: z, gasPrice: ne, maxFeePerGas: ue, to: le } = v;
  if (y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (le && !isAddress(le))
    throw new InvalidAddressError({ address: le });
  if (z || ue)
    throw new BaseError("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (ne && ne > 2n ** 256n - 1n)
    throw new FeeCapTooHighError({ maxFeePerGas: ne });
}
function assertTransactionLegacy(v) {
  const { chainId: y, maxPriorityFeePerGas: z, gasPrice: ne, maxFeePerGas: ue, to: le, accessList: he } = v;
  if (le && !isAddress(le))
    throw new InvalidAddressError({ address: le });
  if (typeof y < "u" && y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (z || ue)
    throw new BaseError("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (ne && ne > 2n ** 256n - 1n)
    throw new FeeCapTooHighError({ maxFeePerGas: ne });
  if (he)
    throw new BaseError("`accessList` is not a valid Legacy Transaction attribute.");
}
function serializeAccessList(v) {
  if (!v || v.length === 0)
    return [];
  const y = [];
  for (let z = 0; z < v.length; z++) {
    const { address: ne, storageKeys: ue } = v[z];
    for (let le = 0; le < ue.length; le++)
      if (ue[le].length - 2 !== 64)
        throw new InvalidStorageKeySizeError({ storageKey: ue[le] });
    if (!isAddress(ne))
      throw new InvalidAddressError({ address: ne });
    y.push([ne, ue]);
  }
  return y;
}
function serializeTransaction(v, y) {
  const z = getTransactionType(v);
  return z === "eip1559" ? serializeTransactionEIP1559(v, y) : z === "eip2930" ? serializeTransactionEIP2930(v, y) : serializeTransactionLegacy(v, y);
}
function serializeTransactionEIP1559(v, y) {
  const { chainId: z, gas: ne, nonce: ue, to: le, value: he, maxFeePerGas: ge, maxPriorityFeePerGas: we, accessList: Ee, data: xe } = v;
  assertTransactionEIP1559(v);
  const $e = serializeAccessList(Ee), Ne = [
    toHex(z),
    ue ? toHex(ue) : "0x",
    we ? toHex(we) : "0x",
    ge ? toHex(ge) : "0x",
    ne ? toHex(ne) : "0x",
    le ?? "0x",
    he ? toHex(he) : "0x",
    xe ?? "0x",
    $e
  ];
  if (y) {
    const st = y.v === 0n ? "0x" : y.v === 1n ? toHex(1) : y.v === 27n ? "0x" : toHex(1);
    Ne.push(st, trim(y.r), trim(y.s));
  }
  return concatHex([
    "0x02",
    toRlp(Ne)
  ]);
}
function serializeTransactionEIP2930(v, y) {
  const { chainId: z, gas: ne, data: ue, nonce: le, to: he, value: ge, accessList: we, gasPrice: Ee } = v;
  assertTransactionEIP2930(v);
  const xe = serializeAccessList(we), $e = [
    toHex(z),
    le ? toHex(le) : "0x",
    Ee ? toHex(Ee) : "0x",
    ne ? toHex(ne) : "0x",
    he ?? "0x",
    ge ? toHex(ge) : "0x",
    ue ?? "0x",
    xe
  ];
  if (y) {
    const Ne = y.v === 0n ? "0x" : y.v === 1n ? toHex(1) : y.v === 27n ? "0x" : toHex(1);
    $e.push(Ne, trim(y.r), trim(y.s));
  }
  return concatHex([
    "0x01",
    toRlp($e)
  ]);
}
function serializeTransactionLegacy(v, y) {
  const { chainId: z = 0, gas: ne, data: ue, nonce: le, to: he, value: ge, gasPrice: we } = v;
  assertTransactionLegacy(v);
  let Ee = [
    le ? toHex(le) : "0x",
    we ? toHex(we) : "0x",
    ne ? toHex(ne) : "0x",
    he ?? "0x",
    ge ? toHex(ge) : "0x",
    ue ?? "0x"
  ];
  if (y) {
    const xe = (() => {
      if (z > 0)
        return BigInt(z * 2) + BigInt(35n + y.v - 27n);
      if (y.v >= 35n)
        return (y.v - 35n) / 2n > 0 ? y.v : 27n + (y.v === 35n ? 0n : 1n);
      const $e = 27n + (y.v === 27n ? 0n : 1n);
      if (y.v !== $e)
        throw new InvalidLegacyVError({ v: y.v });
      return $e;
    })();
    Ee = [
      ...Ee,
      toHex(xe),
      y.r,
      y.s
    ];
  } else
    z > 0 && (Ee = [
      ...Ee,
      toHex(z),
      "0x",
      "0x"
    ]);
  return toRlp(Ee);
}
function toRlp(v, y = "hex") {
  const z = getEncodable(v), ne = createCursor(new Uint8Array(z.length));
  return z.encode(ne), y === "hex" ? bytesToHex(ne.bytes) : ne.bytes;
}
function getEncodable(v) {
  return Array.isArray(v) ? getEncodableList(v.map((y) => getEncodable(y))) : getEncodableBytes(v);
}
function getEncodableList(v) {
  const y = v.reduce((ue, le) => ue + le.length, 0), z = getSizeOfLength(y);
  return {
    length: y <= 55 ? 1 + y : 1 + z + y,
    encode(ue) {
      y <= 55 ? ue.pushByte(192 + y) : (ue.pushByte(247 + z), z === 1 ? ue.pushUint8(y) : z === 2 ? ue.pushUint16(y) : z === 3 ? ue.pushUint24(y) : ue.pushUint32(y));
      for (const { encode: le } of v)
        le(ue);
    }
  };
}
function getEncodableBytes(v) {
  const y = typeof v == "string" ? hexToBytes(v) : v, z = getSizeOfLength(y.length);
  return {
    length: y.length === 1 && y[0] < 128 ? 1 : y.length <= 55 ? 1 + y.length : 1 + z + y.length,
    encode(ue) {
      y.length === 1 && y[0] < 128 ? ue.pushBytes(y) : y.length <= 55 ? (ue.pushByte(128 + y.length), ue.pushBytes(y)) : (ue.pushByte(183 + z), z === 1 ? ue.pushUint8(y.length) : z === 2 ? ue.pushUint16(y.length) : z === 3 ? ue.pushUint24(y.length) : ue.pushUint32(y.length), ue.pushBytes(y));
    }
  };
}
function getSizeOfLength(v) {
  if (v < 2 ** 8)
    return 1;
  if (v < 2 ** 16)
    return 2;
  if (v < 2 ** 24)
    return 3;
  if (v < 2 ** 32)
    return 4;
  throw new BaseError("Length is too large.");
}
const serializeTransactionCelo = (v, y) => isCIP64(v) ? serializeTransactionCIP64(v, y) : isCIP42(v) ? serializeTransactionCIP42(v, y) : serializeTransaction(v, y), serializersCelo = {
  transaction: serializeTransactionCelo
};
function serializeTransactionCIP42(v, y) {
  assertTransactionCIP42(v);
  const { chainId: z, gas: ne, nonce: ue, to: le, value: he, maxFeePerGas: ge, maxPriorityFeePerGas: we, accessList: Ee, feeCurrency: xe, gatewayFeeRecipient: $e, gatewayFee: Ne, data: st } = v, Nr = [
    toHex(z),
    ue ? toHex(ue) : "0x",
    we ? toHex(we) : "0x",
    ge ? toHex(ge) : "0x",
    ne ? toHex(ne) : "0x",
    xe ?? "0x",
    $e ?? "0x",
    Ne ? toHex(Ne) : "0x",
    le ?? "0x",
    he ? toHex(he) : "0x",
    st ?? "0x",
    serializeAccessList(Ee)
  ];
  return y && Nr.push(
    y.v === 27n ? "0x" : toHex(1),
    // yParity
    trim(y.r),
    trim(y.s)
  ), concatHex([
    "0x7c",
    toRlp(Nr)
  ]);
}
function serializeTransactionCIP64(v, y) {
  assertTransactionCIP64(v);
  const { chainId: z, gas: ne, nonce: ue, to: le, value: he, maxFeePerGas: ge, maxPriorityFeePerGas: we, accessList: Ee, feeCurrency: xe, data: $e } = v, Ne = [
    toHex(z),
    ue ? toHex(ue) : "0x",
    we ? toHex(we) : "0x",
    ge ? toHex(ge) : "0x",
    ne ? toHex(ne) : "0x",
    le ?? "0x",
    he ? toHex(he) : "0x",
    $e ?? "0x",
    serializeAccessList(Ee),
    xe
  ];
  return y && Ne.push(
    y.v === 27n ? "0x" : toHex(1),
    // yParity
    trim(y.r),
    trim(y.s)
  ), concatHex([
    "0x7b",
    toRlp(Ne)
  ]);
}
const MAX_MAX_FEE_PER_GAS = 2n ** 256n - 1n;
function assertTransactionCIP42(v) {
  const { chainId: y, maxPriorityFeePerGas: z, gasPrice: ne, maxFeePerGas: ue, to: le, feeCurrency: he, gatewayFee: ge, gatewayFeeRecipient: we } = v;
  if (y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (le && !isAddress(le))
    throw new InvalidAddressError({ address: le });
  if (ne)
    throw new BaseError("`gasPrice` is not a valid CIP-42 Transaction attribute.");
  if (isPresent(ue) && ue > MAX_MAX_FEE_PER_GAS)
    throw new FeeCapTooHighError({ maxFeePerGas: ue });
  if (isPresent(z) && isPresent(ue) && z > ue)
    throw new TipAboveFeeCapError({ maxFeePerGas: ue, maxPriorityFeePerGas: z });
  if (isPresent(ge) && isEmpty(we) || isPresent(we) && isEmpty(ge))
    throw new BaseError("`gatewayFee` and `gatewayFeeRecipient` must be provided together.");
  if (isPresent(he) && !isAddress(he))
    throw new BaseError("`feeCurrency` MUST be a token address for CIP-42 transactions.");
  if (isPresent(we) && !isAddress(we))
    throw new InvalidAddressError(we);
  if (isEmpty(he) && isEmpty(we))
    throw new BaseError("Either `feeCurrency` or `gatewayFeeRecipient` must be provided for CIP-42 transactions.");
}
function assertTransactionCIP64(v) {
  const { chainId: y, maxPriorityFeePerGas: z, gasPrice: ne, maxFeePerGas: ue, to: le, feeCurrency: he } = v;
  if (y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (le && !isAddress(le))
    throw new InvalidAddressError({ address: le });
  if (ne)
    throw new BaseError("`gasPrice` is not a valid CIP-64 Transaction attribute.");
  if (isPresent(ue) && ue > MAX_MAX_FEE_PER_GAS)
    throw new FeeCapTooHighError({ maxFeePerGas: ue });
  if (isPresent(z) && isPresent(ue) && z > ue)
    throw new TipAboveFeeCapError({ maxFeePerGas: ue, maxPriorityFeePerGas: z });
  if (isPresent(he) && !isAddress(he))
    throw new BaseError("`feeCurrency` MUST be a token address for CIP-64 transactions.");
  if (isEmpty(he))
    throw new BaseError("`feeCurrency` must be provided for CIP-64 transactions.");
}
const celo = /* @__PURE__ */ defineChain({
  id: 42220,
  name: "Celo",
  network: "celo",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "CELO"
  },
  rpcUrls: {
    default: { http: ["https://forno.celo.org"] },
    infura: {
      http: ["https://celo-mainnet.infura.io/v3"]
    },
    public: {
      http: ["https://forno.celo.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://explorer.celo.org/mainnet"
    },
    etherscan: { name: "CeloScan", url: "https://celoscan.io" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 13112599
    }
  },
  testnet: !1
}, {
  formatters: formattersCelo,
  serializers: serializersCelo
}), celoAlfajores = /* @__PURE__ */ defineChain({
  id: 44787,
  name: "Alfajores",
  network: "celo-alfajores",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "A-CELO"
  },
  rpcUrls: {
    default: {
      http: ["https://alfajores-forno.celo-testnet.org"]
    },
    infura: {
      http: ["https://celo-alfajores.infura.io/v3"]
    },
    public: {
      http: ["https://alfajores-forno.celo-testnet.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://explorer.celo.org/alfajores"
    },
    etherscan: { name: "CeloScan", url: "https://alfajores.celoscan.io/" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 14569001
    }
  },
  testnet: !0
}, {
  formatters: formattersCelo,
  serializers: serializersCelo
}), chiliz = /* @__PURE__ */ defineChain({
  id: 88888,
  name: "Chiliz Chain",
  network: "chiliz-chain",
  nativeCurrency: {
    decimals: 18,
    name: "CHZ",
    symbol: "CHZ"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/chiliz", "https://chiliz.publicnode.com"]
    },
    public: {
      http: ["https://rpc.ankr.com/chiliz", "https://chiliz.publicnode.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Chiliz Explorer",
      url: "https://scan.chiliz.com"
    }
  }
}), celoCannoli = /* @__PURE__ */ defineChain({
  id: 17323,
  name: "Cannoli",
  network: "celo-cannoli",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "C-CELO"
  },
  rpcUrls: {
    default: {
      http: ["https://forno.cannoli.celo-testnet.org"]
    },
    public: {
      http: ["https://forno.cannoli.celo-testnet.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://explorer.celo.org/cannoli"
    }
  },
  contracts: {
    multicall3: {
      address: "0x5Acb0aa8BF4E8Ff0d882Ee187140713C12BF9718",
      blockCreated: 87429
    }
  },
  testnet: !0
}, {
  formatters: formattersCelo,
  serializers: serializersCelo
}), classic = /* @__PURE__ */ defineChain({
  id: 61,
  name: "Ethereum Classic",
  network: "classic",
  nativeCurrency: {
    decimals: 18,
    name: "ETC",
    symbol: "ETC"
  },
  rpcUrls: {
    default: { http: ["https://etc.rivet.link"] },
    public: { http: ["https://etc.rivet.link"] }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.com/etc/mainnet"
    }
  }
}), confluxESpace = /* @__PURE__ */ defineChain({
  id: 1030,
  name: "Conflux eSpace",
  network: "cfx-espace",
  nativeCurrency: { name: "Conflux", symbol: "CFX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm.confluxrpc.org"],
      webSocket: ["wss://evm.confluxrpc.org/ws"]
    },
    public: {
      http: ["https://evm.confluxrpc.org"],
      webSocket: ["wss://evm.confluxrpc.org/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "ConfluxScan",
      url: "https://evm.confluxscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xEFf0078910f638cd81996cc117bccD3eDf2B072F",
      blockCreated: 68602935
    }
  }
}), confluxESpaceTestnet = /* @__PURE__ */ defineChain({
  id: 71,
  name: "Conflux eSpace Testnet",
  network: "cfx-espace-testnet",
  testnet: !0,
  nativeCurrency: { name: "Conflux", symbol: "CFX", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evmtestnet.confluxrpc.org"],
      webSocket: ["wss://evmtestnet.confluxrpc.org/ws"]
    },
    public: {
      http: ["https://evmtestnet.confluxrpc.org"],
      webSocket: ["wss://evmtestnet.confluxrpc.org/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "ConfluxScan",
      url: "https://evmtestnet.confluxscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xEFf0078910f638cd81996cc117bccD3eDf2B072F",
      blockCreated: 117499050
    }
  }
}), coreDao = /* @__PURE__ */ defineChain({
  id: 1116,
  name: "Core Dao",
  network: "coreDao",
  nativeCurrency: {
    decimals: 18,
    name: "Core",
    symbol: "CORE"
  },
  rpcUrls: {
    public: { http: ["https://rpc.coredao.org"] },
    default: { http: ["https://rpc.coredao.org"] }
  },
  blockExplorers: {
    default: { name: "CoreDao", url: "https://scan.coredao.org" },
    etherscan: { name: "CoreDao", url: "https://scan.coredao.org" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 11907934
    }
  },
  testnet: !1
}), cronos = /* @__PURE__ */ defineChain({
  id: 25,
  name: "Cronos Mainnet",
  network: "cronos",
  nativeCurrency: {
    decimals: 18,
    name: "Cronos",
    symbol: "CRO"
  },
  rpcUrls: {
    default: { http: ["https://evm.cronos.org"] },
    public: { http: ["https://evm.cronos.org"] }
  },
  blockExplorers: {
    default: { name: "Cronoscan", url: "https://cronoscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1963112
    }
  }
}), cronosTestnet = /* @__PURE__ */ defineChain({
  id: 338,
  name: "Cronos Testnet",
  network: "cronos-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "CRO",
    symbol: "tCRO"
  },
  rpcUrls: {
    default: { http: ["https://evm-t3.cronos.org"] },
    public: { http: ["https://evm-t3.cronos.org"] }
  },
  blockExplorers: {
    default: {
      name: "Cronos Explorer",
      url: "https://cronos.org/explorer/testnet3"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 10191251
    }
  },
  testnet: !0
}), crossbell = /* @__PURE__ */ defineChain({
  id: 3737,
  network: "crossbell",
  name: "Crossbell",
  nativeCurrency: {
    decimals: 18,
    name: "CSB",
    symbol: "CSB"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.crossbell.io"]
    },
    public: {
      http: ["https://rpc.crossbell.io"]
    }
  },
  blockExplorers: {
    default: { name: "CrossScan", url: "https://scan.crossbell.io" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 38246031
    }
  }
}), dfk = /* @__PURE__ */ defineChain({
  id: 53935,
  name: "DFK Chain",
  network: "dfk",
  nativeCurrency: {
    decimals: 18,
    name: "Jewel",
    symbol: "JEWEL"
  },
  rpcUrls: {
    default: {
      http: ["https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"]
    },
    public: {
      http: ["https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "DFKSubnetScan",
      url: "https://subnets.avax.network/defi-kingdoms"
    },
    default: {
      name: "DFKSubnetScan",
      url: "https://subnets.avax.network/defi-kingdoms"
    }
  }
}), dogechain = /* @__PURE__ */ defineChain({
  id: 2e3,
  name: "Dogechain",
  network: "dogechain",
  nativeCurrency: {
    decimals: 18,
    name: "Dogechain",
    symbol: "DC"
  },
  rpcUrls: {
    default: { http: ["https://rpc.dogechain.dog"] },
    public: { http: ["https://rpc.dogechain.dog"] }
  },
  blockExplorers: {
    etherscan: {
      name: "DogeChainExplorer",
      url: "https://explorer.dogechain.dog"
    },
    default: {
      name: "DogeChainExplorer",
      url: "https://explorer.dogechain.dog"
    }
  }
}), edgeware = /* @__PURE__ */ defineChain({
  id: 2021,
  name: "Edgeware EdgeEVM Mainnet",
  network: "edgeware",
  nativeCurrency: {
    decimals: 18,
    name: "Edgeware",
    symbol: "EDG"
  },
  rpcUrls: {
    default: { http: ["https://edgeware-evm.jelliedowl.net"] },
    public: { http: ["https://edgeware-evm.jelliedowl.net"] }
  },
  blockExplorers: {
    etherscan: { name: "Edgscan by Bharathcoorg", url: "https://edgscan.live" },
    default: { name: "Edgscan by Bharathcoorg", url: "https://edgscan.live" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 18117872
    }
  }
}), edgewareTestnet = /* @__PURE__ */ defineChain({
  id: 2022,
  name: "Beresheet BereEVM Testnet",
  network: "edgewareTestnet",
  nativeCurrency: {
    decimals: 18,
    name: "Testnet EDG",
    symbol: "tEDG"
  },
  rpcUrls: {
    default: { http: ["https://beresheet-evm.jelliedowl.net"] },
    public: { http: ["https://beresheet-evm.jelliedowl.net"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Edgscan by Bharathcoorg",
      url: "https://testnet.edgscan.live"
    },
    default: {
      name: "Edgscan by Bharathcoorg",
      url: "https://testnet.edgscan.live"
    }
  }
}), eos = /* @__PURE__ */ defineChain({
  id: 17777,
  name: "EOS EVM",
  network: "eos",
  nativeCurrency: {
    decimals: 18,
    name: "EOS",
    symbol: "EOS"
  },
  rpcUrls: {
    default: { http: ["https://api.evm.eosnetwork.com"] },
    public: { http: ["https://api.evm.eosnetwork.com"] }
  },
  blockExplorers: {
    etherscan: {
      name: "EOS EVM Explorer",
      url: "https://explorer.evm.eosnetwork.com"
    },
    default: {
      name: "EOS EVM Explorer",
      url: "https://explorer.evm.eosnetwork.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7943933
    }
  }
}), eosTestnet = /* @__PURE__ */ defineChain({
  id: 15557,
  name: "EOS EVM Testnet",
  network: "eos",
  nativeCurrency: {
    decimals: 18,
    name: "EOS",
    symbol: "EOS"
  },
  rpcUrls: {
    default: { http: ["https://api.testnet.evm.eosnetwork.com"] },
    public: { http: ["https://api.testnet.evm.eosnetwork.com"] }
  },
  blockExplorers: {
    etherscan: {
      name: "EOS EVM Testnet Explorer",
      url: "https://explorer.testnet.evm.eosnetwork.com"
    },
    default: {
      name: "EOS EVM Testnet Explorer",
      url: "https://explorer.testnet.evm.eosnetwork.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 9067940
    }
  },
  testnet: !0
}), evmos = /* @__PURE__ */ defineChain({
  id: 9001,
  name: "Evmos",
  network: "evmos",
  nativeCurrency: {
    decimals: 18,
    name: "Evmos",
    symbol: "EVMOS"
  },
  rpcUrls: {
    default: { http: ["https://eth.bd.evmos.org:8545"] },
    public: { http: ["https://eth.bd.evmos.org:8545"] }
  },
  blockExplorers: {
    default: { name: "Evmos Block Explorer", url: "https://escan.live" }
  }
}), evmosTestnet = /* @__PURE__ */ defineChain({
  id: 9e3,
  name: "Evmos Testnet",
  network: "evmos-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Evmos",
    symbol: "EVMOS"
  },
  rpcUrls: {
    default: { http: ["https://eth.bd.evmos.dev:8545"] },
    public: { http: ["https://eth.bd.evmos.dev:8545"] }
  },
  blockExplorers: {
    default: {
      name: "Evmos Testnet Block Explorer",
      url: "https://evm.evmos.dev/"
    }
  }
}), ekta = /* @__PURE__ */ defineChain({
  id: 1994,
  name: "Ekta",
  network: "ekta",
  nativeCurrency: {
    decimals: 18,
    name: "EKTA",
    symbol: "EKTA"
  },
  rpcUrls: {
    public: { http: ["https://main.ekta.io"] },
    default: { http: ["https://main.ekta.io"] }
  },
  blockExplorers: {
    default: { name: "Ektascan", url: "https://ektascan.io" }
  }
}), ektaTestnet = /* @__PURE__ */ defineChain({
  id: 1004,
  name: "Ekta Testnet",
  network: "ekta-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "EKTA",
    symbol: "EKTA"
  },
  rpcUrls: {
    public: { http: ["https://test.ekta.io:8545"] },
    default: { http: ["https://test.ekta.io:8545"] }
  },
  blockExplorers: {
    default: { name: "Test Ektascan", url: "https://test.ektascan.io" }
  },
  testnet: !0
}), fantom = /* @__PURE__ */ defineChain({
  id: 250,
  name: "Fantom",
  network: "fantom",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/fantom"] },
    public: { http: ["https://rpc.ankr.com/fantom"] }
  },
  blockExplorers: {
    etherscan: { name: "FTMScan", url: "https://ftmscan.com" },
    default: { name: "FTMScan", url: "https://ftmscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 33001987
    }
  }
}), fantomSonicTestnet = /* @__PURE__ */ defineChain({
  id: 64240,
  name: "Fantom Sonic Open Testnet",
  network: "fantom-sonic-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpcapi.sonic.fantom.network"] },
    public: { http: ["https://rpcapi.sonic.fantom.network"] }
  },
  blockExplorers: {
    default: {
      name: "Fantom Sonic Open Testnet Explorer",
      url: "https://public-sonic.fantom.network"
    }
  },
  testnet: !0
}), fantomTestnet = /* @__PURE__ */ defineChain({
  id: 4002,
  name: "Fantom Testnet",
  network: "fantom-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.fantom.network"] },
    public: { http: ["https://rpc.testnet.fantom.network"] }
  },
  blockExplorers: {
    etherscan: { name: "FTMScan", url: "https://testnet.ftmscan.com" },
    default: { name: "FTMScan", url: "https://testnet.ftmscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 8328688
    }
  }
}), fibo = /* @__PURE__ */ defineChain({
  id: 12306,
  name: "Fibo Chain",
  network: "fibochain",
  nativeCurrency: {
    decimals: 18,
    name: "fibo",
    symbol: "FIBO"
  },
  rpcUrls: {
    default: { http: ["https://network.hzroc.art"] },
    public: { http: ["https://network.hzroc.art"] }
  },
  blockExplorers: {
    default: { name: "FiboScan", url: "https://scan.fibochain.org" }
  }
}), filecoin = /* @__PURE__ */ defineChain({
  id: 314,
  name: "Filecoin Mainnet",
  network: "filecoin-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "filecoin",
    symbol: "FIL"
  },
  rpcUrls: {
    default: { http: ["https://api.node.glif.io/rpc/v1"] },
    public: { http: ["https://api.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: { name: "Filfox", url: "https://filfox.info/en" },
    filscan: { name: "Filscan", url: "https://filscan.io" },
    filscout: { name: "Filscout", url: "https://filscout.io/en" },
    glif: { name: "Glif", url: "https://explorer.glif.io" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3328594
    }
  }
}), filecoinCalibration = /* @__PURE__ */ defineChain({
  id: 314159,
  name: "Filecoin Calibration",
  network: "filecoin-calibration",
  nativeCurrency: {
    decimals: 18,
    name: "testnet filecoin",
    symbol: "tFIL"
  },
  rpcUrls: {
    default: { http: ["https://api.calibration.node.glif.io/rpc/v1"] },
    public: { http: ["https://api.calibration.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: { name: "Filscan", url: "https://calibration.filscan.io" }
  }
}), filecoinHyperspace = /* @__PURE__ */ defineChain({
  id: 3141,
  name: "Filecoin Hyperspace",
  network: "filecoin-hyperspace",
  nativeCurrency: {
    decimals: 18,
    name: "testnet filecoin",
    symbol: "tFIL"
  },
  rpcUrls: {
    default: { http: ["https://api.hyperspace.node.glif.io/rpc/v1"] },
    public: { http: ["https://api.hyperspace.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: { name: "Filfox", url: "https://hyperspace.filfox.info/en" },
    filscan: { name: "Filscan", url: "https://hyperspace.filscan.io" }
  }
}), flare = /* @__PURE__ */ defineChain({
  id: 14,
  name: "Flare Mainnet",
  network: "flare-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "flare",
    symbol: "FLR"
  },
  rpcUrls: {
    default: { http: ["https://flare-api.flare.network/ext/C/rpc"] },
    public: { http: ["https://flare-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Flare Explorer",
      url: "https://flare-explorer.flare.network"
    }
  }
}), flareTestnet = /* @__PURE__ */ defineChain({
  id: 114,
  name: "Coston2",
  network: "coston2",
  nativeCurrency: {
    decimals: 18,
    name: "coston2flare",
    symbol: "C2FLR"
  },
  rpcUrls: {
    default: { http: ["https://coston2-api.flare.network/ext/C/rpc"] },
    public: { http: ["https://coston2-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Coston2 Explorer",
      url: "https://coston2-explorer.flare.network"
    }
  },
  testnet: !0
}), foundry = /* @__PURE__ */ defineChain({
  id: 31337,
  name: "Foundry",
  network: "foundry",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["http://127.0.0.1:8545"],
      webSocket: ["ws://127.0.0.1:8545"]
    },
    public: {
      http: ["http://127.0.0.1:8545"],
      webSocket: ["ws://127.0.0.1:8545"]
    }
  }
}), fuse = /* @__PURE__ */ defineChain({
  id: 122,
  name: "Fuse",
  network: "fuse",
  nativeCurrency: { name: "Fuse", symbol: "FUSE", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.fuse.io"] },
    public: { http: ["https://rpc.fuse.io"] }
  },
  blockExplorers: {
    default: { name: "Fuse Explorer", url: "https://explorer.fuse.io" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 16146628
    }
  }
}), fuseSparknet = /* @__PURE__ */ defineChain({
  id: 123,
  name: "Fuse Sparknet",
  network: "fuse",
  nativeCurrency: { name: "Spark", symbol: "SPARK", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://rpc.fusespark.io"] },
    public: { http: ["https://rpc.fusespark.io"] }
  },
  blockExplorers: {
    default: {
      name: "Sparkent Explorer",
      url: "https://explorer.fusespark.io"
    }
  }
}), iotex = /* @__PURE__ */ defineChain({
  id: 4689,
  name: "IoTeX",
  network: "iotex",
  nativeCurrency: {
    decimals: 18,
    name: "IoTeX",
    symbol: "IOTX"
  },
  rpcUrls: {
    default: {
      http: ["https://babel-api.mainnet.iotex.io"],
      webSocket: ["wss://babel-api.mainnet.iotex.io"]
    },
    public: {
      http: ["https://babel-api.mainnet.iotex.io"],
      webSocket: ["wss://babel-api.mainnet.iotex.io"]
    }
  },
  blockExplorers: {
    default: { name: "IoTeXScan", url: "https://iotexscan.io" }
  }
}), iotexTestnet = /* @__PURE__ */ defineChain({
  id: 4690,
  name: "IoTeX Testnet",
  network: "iotex-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "IoTeX",
    symbol: "IOTX"
  },
  rpcUrls: {
    default: {
      http: ["https://babel-api.testnet.iotex.io"],
      webSocket: ["wss://babel-api.testnet.iotex.io"]
    },
    public: {
      http: ["https://babel-api.testnet.iotex.io"],
      webSocket: ["wss://babel-api.testnet.iotex.io"]
    }
  },
  blockExplorers: {
    default: { name: "IoTeXScan", url: "https://testnet.iotexscan.io" }
  }
}), gobi = /* @__PURE__ */ defineChain({
  id: 1663,
  name: "Horizen Gobi Testnet",
  network: "gobi",
  nativeCurrency: {
    decimals: 18,
    name: "Test ZEN",
    symbol: "tZEN"
  },
  rpcUrls: {
    public: { http: ["https://gobi-testnet.horizenlabs.io/ethv1"] },
    default: { http: ["https://gobi-testnet.horizenlabs.io/ethv1"] }
  },
  blockExplorers: {
    default: { name: "Gobi Explorer", url: "https://gobi-explorer.horizen.io" }
  },
  contracts: {},
  testnet: !0
}), goerli = /* @__PURE__ */ defineChain({
  id: 5,
  network: "goerli",
  name: "Goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://eth-goerli.g.alchemy.com/v2"],
      webSocket: ["wss://eth-goerli.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://goerli.infura.io/v3"],
      webSocket: ["wss://goerli.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.ankr.com/eth_goerli"]
    },
    public: {
      http: ["https://rpc.ankr.com/eth_goerli"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://goerli.etherscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0x56522D00C410a43BFfDF00a9A569489297385790",
      blockCreated: 8765204
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 6507670
    }
  },
  testnet: !0
}), gnosis = /* @__PURE__ */ defineChain({
  id: 100,
  name: "Gnosis",
  network: "gnosis",
  nativeCurrency: {
    decimals: 18,
    name: "Gnosis",
    symbol: "xDAI"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.gnosischain.com"],
      webSocket: ["wss://rpc.gnosischain.com/wss"]
    },
    public: {
      http: ["https://rpc.gnosischain.com"],
      webSocket: ["wss://rpc.gnosischain.com/wss"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Gnosisscan",
      url: "https://gnosisscan.io"
    },
    default: {
      name: "Gnosis Chain Explorer",
      url: "https://blockscout.com/xdai/mainnet"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 21022491
    }
  }
}), gnosisChiado = /* @__PURE__ */ defineChain({
  id: 10200,
  name: "Gnosis Chiado",
  network: "chiado",
  nativeCurrency: {
    decimals: 18,
    name: "Gnosis",
    symbol: "xDAI"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.chiadochain.net"],
      webSocket: ["wss://rpc.chiadochain.net/wss"]
    },
    public: {
      http: ["https://rpc.chiadochain.net"],
      webSocket: ["wss://rpc.chiadochain.net/wss"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.chiadochain.net"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4967313
    }
  },
  testnet: !0
}), hardhat = /* @__PURE__ */ defineChain({
  id: 31337,
  name: "Hardhat",
  network: "hardhat",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] },
    public: { http: ["http://127.0.0.1:8545"] }
  }
}), harmonyOne = /* @__PURE__ */ defineChain({
  id: 16666e5,
  name: "Harmony One",
  network: "harmony",
  nativeCurrency: {
    name: "Harmony",
    symbol: "ONE",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://rpc.ankr.com/harmony"] },
    default: { http: ["https://rpc.ankr.com/harmony"] }
  },
  blockExplorers: {
    default: { name: "Harmony Explorer", url: "https://explorer.harmony.one" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 24185753
    }
  }
}), haqqMainnet = /* @__PURE__ */ defineChain({
  id: 11235,
  name: "HAQQ Mainnet",
  network: "haqq-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Islamic Coin",
    symbol: "ISLM"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.eth.haqq.network"]
    },
    public: {
      http: ["https://rpc.eth.haqq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "HAQQ Explorer",
      url: "https://explorer.haqq.network"
    }
  }
}), haqqTestedge2 = /* @__PURE__ */ defineChain({
  id: 54211,
  name: "HAQQ Testedge 2",
  network: "haqq-testedge-2",
  nativeCurrency: {
    decimals: 18,
    name: "Islamic Coin",
    symbol: "ISLMT"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.eth.testedge2.haqq.network"]
    },
    public: {
      http: ["https://rpc.eth.testedge2.haqq.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "HAQQ Explorer",
      url: "https://explorer.testedge2.haqq.network"
    }
  }
}), holesky = /* @__PURE__ */ defineChain({
  id: 17e3,
  network: "holesky",
  name: "Holesky",
  nativeCurrency: { name: "Holesky Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://ethereum-holesky.publicnode.com"]
    },
    public: {
      http: ["https://ethereum-holesky.publicnode.com"]
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 77
    }
  },
  testnet: !0
}), kava = /* @__PURE__ */ defineChain({
  id: 2222,
  name: "Kava EVM",
  network: "kava-mainnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://evm.kava.io"] },
    default: { http: ["https://evm.kava.io"] }
  },
  blockExplorers: {
    default: { name: "Kava EVM Explorer", url: "https://kavascan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3661165
    }
  },
  testnet: !1
}), kavaTestnet = /* @__PURE__ */ defineChain({
  id: 2221,
  name: "Kava EVM Testnet",
  network: "kava-testnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://evm.testnet.kava.io"] },
    default: { http: ["https://evm.testnet.kava.io"] }
  },
  blockExplorers: {
    default: {
      name: "Kava EVM Testnet Explorer",
      url: "https://testnet.kavascan.com/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6",
      blockCreated: 7242179
    }
  },
  testnet: !0
}), klaytn = /* @__PURE__ */ defineChain({
  id: 8217,
  name: "Klaytn",
  network: "klaytn",
  nativeCurrency: {
    decimals: 18,
    name: "Klaytn",
    symbol: "KLAY"
  },
  rpcUrls: {
    default: { http: ["https://klaytn.drpc.org"] },
    public: { http: ["https://klaytn.drpc.org"] }
  },
  blockExplorers: {
    etherscan: { name: "KlaytnScope", url: "https://scope.klaytn.com" },
    default: { name: "KlaytnScope", url: "https://scope.klaytn.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 96002415
    }
  }
}), klaytnBaobab = /* @__PURE__ */ defineChain({
  id: 1001,
  name: "Klaytn Baobab Testnet",
  network: "klaytn-baobab",
  nativeCurrency: {
    decimals: 18,
    name: "Baobab Klaytn",
    symbol: "KLAY"
  },
  rpcUrls: {
    default: { http: ["https://public-en-baobab.klaytn.net"] },
    public: { http: ["https://public-en-baobab.klaytn.net"] }
  },
  blockExplorers: {
    etherscan: { name: "KlaytnScope", url: "https://baobab.klaytnscope.com" },
    default: { name: "KlaytnScope", url: "https://baobab.klaytnscope.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 123390593
    }
  },
  testnet: !0
}), kroma = /* @__PURE__ */ defineChain({
  id: 255,
  network: "kroma",
  name: "Kroma",
  nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.kroma.network"]
    },
    public: {
      http: ["https://api.kroma.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kroma Explorer",
      url: "https://blockscout.kroma.network"
    }
  },
  testnet: !1
}), kromaSepolia = /* @__PURE__ */ defineChain({
  id: 2358,
  network: "kroma-sepolia",
  name: "Kroma Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.sepolia.kroma.network"]
    },
    public: {
      http: ["https://api.sepolia.kroma.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Kroma Sepolia Explorer",
      url: "https://blockscout.sepolia.kroma.network"
    }
  },
  testnet: !0
}), linea = /* @__PURE__ */ defineChain({
  id: 59144,
  name: "Linea Mainnet",
  network: "linea-mainnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    infura: {
      http: ["https://linea-mainnet.infura.io/v3"],
      webSocket: ["wss://linea-mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    },
    public: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://lineascan.build"
    },
    etherscan: {
      name: "Etherscan",
      url: "https://lineascan.build"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://explorer.linea.build"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 42
    }
  },
  testnet: !1
}), lineaTestnet = /* @__PURE__ */ defineChain({
  id: 59140,
  name: "Linea Goerli Testnet",
  network: "linea-testnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    infura: {
      http: ["https://linea-goerli.infura.io/v3"],
      webSocket: ["wss://linea-goerli.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.goerli.linea.build"],
      webSocket: ["wss://rpc.goerli.linea.build"]
    },
    public: {
      http: ["https://rpc.goerli.linea.build"],
      webSocket: ["wss://rpc.goerli.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://goerli.lineascan.build"
    },
    etherscan: {
      name: "Etherscan",
      url: "https://goerli.lineascan.build"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://explorer.goerli.linea.build"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 498623
    }
  },
  testnet: !0
}), localhost = /* @__PURE__ */ defineChain({
  id: 1337,
  name: "Localhost",
  network: "localhost",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["http://127.0.0.1:8545"] },
    public: { http: ["http://127.0.0.1:8545"] }
  }
}), lukso = /* @__PURE__ */ defineChain({
  id: 42,
  network: "lukso",
  name: "LUKSO",
  nativeCurrency: {
    name: "LUKSO",
    symbol: "LYX",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.lukso.network"],
      webSocket: ["wss://ws-rpc.mainnet.lukso.network"]
    },
    public: {
      http: ["https://rpc.mainnet.lukso.network"],
      webSocket: ["wss://ws-rpc.mainnet.lukso.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "LUKSO Mainnet Explorer",
      url: "https://explorer.execution.mainnet.lukso.network"
    }
  }
}), mainnet = /* @__PURE__ */ defineChain({
  id: 1,
  network: "homestead",
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://eth-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://eth-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://mainnet.infura.io/v3"],
      webSocket: ["wss://mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://cloudflare-eth.com"]
    },
    public: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://etherscan.io"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
      blockCreated: 16966585
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), manta = /* @__PURE__ */ defineChain({
  id: 169,
  name: "Manta Pacific Mainnet",
  network: "manta",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://pacific-rpc.manta.network/http"] },
    public: { http: ["https://pacific-rpc.manta.network/http"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Manta Explorer",
      url: "https://pacific-explorer.manta.network"
    },
    default: {
      name: "Manta Explorer",
      url: "https://pacific-explorer.manta.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 332890
    }
  }
}), mantaTestnet = /* @__PURE__ */ defineChain({
  id: 3441005,
  name: "Manta Pacific Testnet",
  network: "manta-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://manta-testnet.calderachain.xyz/http"] },
    public: { http: ["https://manta-testnet.calderachain.xyz/http"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Manta Testnet Explorer",
      url: "https://pacific-explorer.testnet.manta.network"
    },
    default: {
      name: "Manta Testnet Explorer",
      url: "https://pacific-explorer.testnet.manta.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0x211B1643b95Fe76f11eD8880EE810ABD9A4cf56C",
      blockCreated: 419915
    }
  },
  testnet: !0
}), mantle = /* @__PURE__ */ defineChain({
  id: 5e3,
  name: "Mantle",
  network: "mantle",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.mantle.xyz"] },
    public: { http: ["https://rpc.mantle.xyz"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Mantle Explorer",
      url: "https://explorer.mantle.xyz"
    },
    default: {
      name: "Mantle Explorer",
      url: "https://explorer.mantle.xyz"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 304717
    }
  }
}), mantleTestnet = /* @__PURE__ */ defineChain({
  id: 5001,
  name: "Mantle Testnet",
  network: "mantle",
  nativeCurrency: {
    decimals: 18,
    name: "MNT",
    symbol: "MNT"
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.mantle.xyz"] },
    public: { http: ["https://rpc.testnet.mantle.xyz"] }
  },
  blockExplorers: {
    etherscan: {
      name: "Mantle Testnet Explorer",
      url: "https://explorer.testnet.mantle.xyz"
    },
    default: {
      name: "Mantle Testnet Explorer",
      url: "https://explorer.testnet.mantle.xyz"
    }
  },
  testnet: !0
}), meter = /* @__PURE__ */ defineChain({
  id: 82,
  name: "Meter",
  network: "meter",
  nativeCurrency: {
    decimals: 18,
    name: "MTR",
    symbol: "MTR"
  },
  rpcUrls: {
    default: { http: ["https://rpc.meter.io"] },
    public: { http: ["https://rpc.meter.io"] }
  },
  blockExplorers: {
    default: { name: "MeterScan", url: "https://scan.meter.io" }
  }
}), meterTestnet = /* @__PURE__ */ defineChain({
  id: 83,
  name: "Meter Testnet",
  network: "meter-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MTR",
    symbol: "MTR"
  },
  rpcUrls: {
    default: { http: ["https://rpctest.meter.io"] },
    public: { http: ["https://rpctest.meter.io"] }
  },
  blockExplorers: {
    default: {
      name: "MeterTestnetScan",
      url: "https://scan-warringstakes.meter.io"
    }
  }
}), metis = /* @__PURE__ */ defineChain({
  id: 1088,
  name: "Metis",
  network: "andromeda",
  nativeCurrency: {
    decimals: 18,
    name: "Metis",
    symbol: "METIS"
  },
  rpcUrls: {
    default: { http: ["https://andromeda.metis.io/?owner=1088"] },
    public: { http: ["https://andromeda.metis.io/?owner=1088"] }
  },
  blockExplorers: {
    default: {
      name: "Andromeda Explorer",
      url: "https://andromeda-explorer.metis.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 2338552
    }
  }
}), metisGoerli = /* @__PURE__ */ defineChain({
  id: 599,
  name: "Metis Goerli",
  network: "metis-goerli",
  nativeCurrency: {
    decimals: 18,
    name: "Metis Goerli",
    symbol: "METIS"
  },
  rpcUrls: {
    default: { http: ["https://goerli.gateway.metisdevops.link"] },
    public: { http: ["https://goerli.gateway.metisdevops.link"] }
  },
  blockExplorers: {
    default: {
      name: "Metis Goerli Explorer",
      url: "https://goerli.explorer.metisdevops.link"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1006207
    }
  }
}), mev = /* @__PURE__ */ defineChain({
  id: 7518,
  network: "MEVerse",
  name: "MEVerse Chain Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "MEVerse",
    symbol: "MEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.meversemainnet.io"]
    },
    public: {
      http: ["https://rpc.meversemainnet.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://www.meversescan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 86881340
    }
  }
}), mevTestnet = /* @__PURE__ */ defineChain({
  id: 4759,
  network: "MEVerse Testnet",
  name: "MEVerse Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "MEVerse",
    symbol: "MEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.meversetestnet.io"]
    },
    public: {
      http: ["https://rpc.meversetestnet.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.meversescan.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 64371115
    }
  },
  testnet: !0
}), modeTestnet = /* @__PURE__ */ defineChain({
  id: 919,
  name: "Mode Testnet",
  network: "mode-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.mode.network"]
    },
    public: {
      http: ["https://sepolia.mode.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia.explorer.mode.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xBAba8373113Fb7a68f195deF18732e01aF8eDfCF",
      blockCreated: 3019007
    }
  },
  testnet: !0
}), moonbaseAlpha = /* @__PURE__ */ defineChain({
  id: 1287,
  name: "Moonbase Alpha",
  network: "moonbase-alpha",
  nativeCurrency: {
    decimals: 18,
    name: "DEV",
    symbol: "DEV"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.api.moonbase.moonbeam.network"],
      webSocket: ["wss://wss.api.moonbase.moonbeam.network"]
    },
    public: {
      http: ["https://rpc.api.moonbase.moonbeam.network"],
      webSocket: ["wss://wss.api.moonbase.moonbeam.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    },
    etherscan: {
      name: "Moonscan",
      url: "https://moonbase.moonscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1850686
    }
  },
  testnet: !0
}), moonbeam = /* @__PURE__ */ defineChain({
  id: 1284,
  name: "Moonbeam",
  network: "moonbeam",
  nativeCurrency: {
    decimals: 18,
    name: "GLMR",
    symbol: "GLMR"
  },
  rpcUrls: {
    public: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    },
    default: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonscan.io"
    },
    etherscan: {
      name: "Moonscan",
      url: "https://moonscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 609002
    }
  },
  testnet: !1
}), moonbeamDev = /* @__PURE__ */ defineChain({
  id: 1281,
  name: "Moonbeam Development Node",
  network: "development",
  nativeCurrency: {
    decimals: 18,
    name: "DEV",
    symbol: "DEV"
  },
  rpcUrls: {
    default: {
      http: ["http://127.0.0.1:9944"],
      webSocket: ["wss://127.0.0.1:9944"]
    },
    public: {
      http: ["http://127.0.0.1:9944"],
      webSocket: ["wss://127.0.0.1:9944"]
    }
  }
}), moonriver = /* @__PURE__ */ defineChain({
  id: 1285,
  name: "Moonriver",
  network: "moonriver",
  nativeCurrency: {
    decimals: 18,
    name: "MOVR",
    symbol: "MOVR"
  },
  rpcUrls: {
    public: {
      http: ["https://moonriver.public.blastapi.io"],
      webSocket: ["wss://moonriver.public.blastapi.io"]
    },
    default: {
      http: ["https://moonriver.public.blastapi.io"],
      webSocket: ["wss://moonriver.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonriver.moonscan.io"
    },
    etherscan: {
      name: "Moonscan",
      url: "https://moonriver.moonscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1597904
    }
  },
  testnet: !1
}), neonDevnet = /* @__PURE__ */ defineChain({
  id: 245022926,
  network: "neonDevnet",
  name: "Neon EVM DevNet",
  nativeCurrency: { name: "NEON", symbol: "NEON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://devnet.neonevm.org"]
    },
    public: {
      http: ["https://devnet.neonevm.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Neonscan",
      url: "https://devnet.neonscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 205206112
    }
  },
  testnet: !0
}), neonMainnet = /* @__PURE__ */ defineChain({
  id: 245022934,
  network: "neonMainnet",
  name: "Neon EVM MainNet",
  nativeCurrency: { name: "NEON", symbol: "NEON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://neon-proxy-mainnet.solana.p2p.org"]
    },
    public: {
      http: ["https://neon-proxy-mainnet.solana.p2p.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Neonscan",
      url: "https://neonscan.org"
    }
  },
  contracts: {},
  testnet: !1
}), nexi = /* @__PURE__ */ defineChain({
  id: 4242,
  name: "Nexi",
  network: "nexi",
  nativeCurrency: { name: "Nexi", symbol: "NEXI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.chain.nexi.technology"]
    },
    public: {
      http: ["https://rpc.chain.nexi.technology"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "NexiScan",
      url: "https://www.nexiscan.com"
    },
    default: {
      name: "NexiScan",
      url: "https://www.nexiscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0277A46Cc69A57eE3A6C8c158bA874832F718B8E",
      blockCreated: 25770160
    }
  }
}), nexilix = /* @__PURE__ */ defineChain({
  id: 240,
  name: "Nexilix Smart Chain",
  network: "nexilix",
  nativeCurrency: {
    decimals: 18,
    name: "Nexilix",
    symbol: "NEXILIX"
  },
  rpcUrls: {
    default: { http: ["https://rpcurl.pos.nexilix.com"] },
    public: { http: ["https://rpcurl.pos.nexilix.com"] }
  },
  blockExplorers: {
    etherscan: { name: "NexilixScan", url: "https://scan.nexilix.com" },
    default: { name: "NexilixScan", url: "https://scan.nexilix.com" }
  },
  contracts: {
    multicall3: {
      address: "0x58381c8e2BF9d0C2C4259cA14BdA9Afe02831244",
      blockCreated: 74448
    }
  }
}), oasys = /* @__PURE__ */ defineChain({
  id: 248,
  name: "Oasys",
  network: "oasys",
  nativeCurrency: { name: "Oasys", symbol: "OAS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.oasys.games"]
    },
    public: {
      http: ["https://rpc.mainnet.oasys.games"]
    }
  },
  blockExplorers: {
    default: {
      name: "OasysScan",
      url: "https://scan.oasys.games"
    }
  }
}), okc = /* @__PURE__ */ defineChain({
  id: 66,
  name: "OKC",
  network: "okc",
  nativeCurrency: {
    decimals: 18,
    name: "OKT",
    symbol: "OKT"
  },
  rpcUrls: {
    default: { http: ["https://exchainrpc.okex.org"] },
    public: { http: ["https://exchainrpc.okex.org"] }
  },
  blockExplorers: {
    default: { name: "oklink", url: "https://www.oklink.com/okc" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 10364792
    }
  }
}), optimism = /* @__PURE__ */ defineChain({
  id: 10,
  name: "OP Mainnet",
  network: "optimism",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://opt-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://opt-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://optimism-mainnet.infura.io/v3"],
      webSocket: ["wss://optimism-mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://mainnet.optimism.io"]
    },
    public: {
      http: ["https://mainnet.optimism.io"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://optimistic.etherscan.io"
    },
    default: {
      name: "Optimism Explorer",
      url: "https://explorer.optimism.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4286263
    }
  }
}, {
  formatters: formattersOptimism
}), optimismGoerli = /* @__PURE__ */ defineChain({
  id: 420,
  name: "Optimism Goerli",
  network: "optimism-goerli",
  nativeCurrency: { name: "Goerli Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://opt-goerli.g.alchemy.com/v2"],
      webSocket: ["wss://opt-goerli.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://optimism-goerli.infura.io/v3"],
      webSocket: ["wss://optimism-goerli.infura.io/ws/v3"]
    },
    default: {
      http: ["https://goerli.optimism.io"]
    },
    public: {
      http: ["https://goerli.optimism.io"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://goerli-optimism.etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://goerli-optimism.etherscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 49461
    }
  },
  testnet: !0
}, {
  formatters: formattersOptimism
}), optimismSepolia = /* @__PURE__ */ defineChain({
  id: 11155420,
  name: "Optimism Sepolia",
  network: "optimism-sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.optimism.io"]
    },
    public: {
      http: ["https://sepolia.optimism.io"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Blockscout",
      url: "https://optimism-sepolia.blockscout.com"
    },
    default: {
      name: "Blockscout",
      url: "https://optimism-sepolia.blockscout.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1620204
    }
  },
  testnet: !0
}, {
  formatters: formattersOptimism
}), opBNB = /* @__PURE__ */ defineChain({
  id: 204,
  name: "opBNB",
  network: "opBNB Mainnet",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://opbnb-mainnet-rpc.bnbchain.org"] },
    default: { http: ["https://opbnb-mainnet-rpc.bnbchain.org"] }
  },
  blockExplorers: {
    default: { name: "opbnbscan", url: "https://mainnet.opbnbscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 512881
    }
  }
}), opBNBTestnet = /* @__PURE__ */ defineChain({
  id: 5611,
  name: "opBNB Testnet",
  network: "opBNB Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "tBNB",
    symbol: "tBNB"
  },
  rpcUrls: {
    public: { http: ["https://opbnb-testnet-rpc.bnbchain.org"] },
    default: { http: ["https://opbnb-testnet-rpc.bnbchain.org"] }
  },
  blockExplorers: {
    default: { name: "opbnbscan", url: "https://opbnbscan.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3705108
    }
  },
  testnet: !0
}), pgn = /* @__PURE__ */ defineChain({
  id: 424,
  network: "pgn",
  name: "PGN",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.publicgoods.network"]
    },
    public: {
      http: ["https://rpc.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "PGN Explorer",
      url: "https://explorer.publicgoods.network"
    },
    blocksout: {
      name: "PGN Explorer",
      url: "https://explorer.publicgoods.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3380209
    }
  }
}, {
  formatters: formattersOptimism
}), pgnTestnet = /* @__PURE__ */ defineChain({
  id: 58008,
  network: "pgn-testnet",
  name: "PGN ",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.publicgoods.network"]
    },
    public: {
      http: ["https://sepolia.publicgoods.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "PGN Testnet Explorer",
      url: "https://explorer.sepolia.publicgoods.network"
    },
    blocksout: {
      name: "PGN Testnet Explorer",
      url: "https://explorer.sepolia.publicgoods.network"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3754925
    }
  },
  testnet: !0
}, {
  formatters: formattersOptimism
}), plinga = /* @__PURE__ */ defineChain({
  id: 242,
  name: "Plinga",
  network: "plinga",
  nativeCurrency: { name: "Plinga", symbol: "PLINGA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpcurl.mainnet.plgchain.com"]
    },
    public: {
      http: ["https://rpcurl.mainnet.plgchain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Plgscan",
      url: "https://www.plgscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0x0989576160f2e7092908BB9479631b901060b6e4",
      blockCreated: 204489
    }
  }
}), polygon = /* @__PURE__ */ defineChain({
  id: 137,
  name: "Polygon",
  network: "matic",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://polygon-mainnet.g.alchemy.com/v2"],
      webSocket: ["wss://polygon-mainnet.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://polygon-mainnet.infura.io/v3"],
      webSocket: ["wss://polygon-mainnet.infura.io/ws/v3"]
    },
    default: {
      http: ["https://polygon-rpc.com"]
    },
    public: {
      http: ["https://polygon-rpc.com"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "PolygonScan",
      url: "https://polygonscan.com"
    },
    default: {
      name: "PolygonScan",
      url: "https://polygonscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  }
}), polygonMumbai = /* @__PURE__ */ defineChain({
  id: 80001,
  name: "Polygon Mumbai",
  network: "maticmum",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://polygon-mumbai.g.alchemy.com/v2"],
      webSocket: ["wss://polygon-mumbai.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://polygon-mumbai.infura.io/v3"],
      webSocket: ["wss://polygon-mumbai.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.ankr.com/polygon_mumbai"]
    },
    public: {
      http: ["https://rpc.ankr.com/polygon_mumbai"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com"
    },
    default: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}), polygonZkEvmTestnet = /* @__PURE__ */ defineChain({
  id: 1442,
  name: "Polygon zkEVM Testnet",
  network: "polygon-zkevm-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.public.zkevm-test.net"]
    },
    public: {
      http: ["https://rpc.public.zkevm-test.net"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "Blockscout",
      url: "https://explorer.public.zkevm-test.net"
    },
    default: {
      name: "PolygonScan",
      url: "https://testnet-zkevm.polygonscan.com"
    }
  },
  testnet: !0,
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 525686
    }
  }
}), polygonZkEvm = /* @__PURE__ */ defineChain({
  id: 1101,
  name: "Polygon zkEVM",
  network: "polygon-zkevm",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://zkevm-rpc.com"]
    },
    public: {
      http: ["https://zkevm-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://zkevm.polygonscan.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 57746
    }
  }
}), pulsechain = /* @__PURE__ */ defineChain({
  id: 369,
  network: "pulsechain",
  name: "PulseChain",
  nativeCurrency: { name: "Pulse", symbol: "PLS", decimals: 18 },
  testnet: !1,
  rpcUrls: {
    default: {
      http: ["https://rpc.pulsechain.com"],
      webSocket: ["wss://ws.pulsechain.com"]
    },
    public: {
      http: ["https://rpc.pulsechain.com"],
      webSocket: ["wss://ws.pulsechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PulseScan",
      url: "https://scan.pulsechain.com"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), pulsechainV4 = /* @__PURE__ */ defineChain({
  id: 943,
  network: "pulsechainV4",
  name: "PulseChain V4",
  testnet: !0,
  nativeCurrency: { name: "V4 Pulse", symbol: "v4PLS", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.v4.testnet.pulsechain.com"],
      webSocket: ["wss://ws.v4.testnet.pulsechain.com"]
    },
    public: {
      http: ["https://rpc.v4.testnet.pulsechain.com"],
      webSocket: ["wss://ws.v4.testnet.pulsechain.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PulseScan",
      url: "https://scan.v4.testnet.pulsechain.com"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), qMainnet = /* @__PURE__ */ defineChain({
  id: 35441,
  name: "Q Mainnet",
  network: "q-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Q",
    symbol: "Q"
  },
  rpcUrls: {
    default: { http: ["https://rpc.q.org"] },
    public: { http: ["https://rpc.q.org"] }
  },
  blockExplorers: {
    default: {
      name: "Q Mainnet Explorer",
      url: "https://explorer.q.org"
    }
  }
}), qTestnet = /* @__PURE__ */ defineChain({
  id: 35443,
  name: "Q Testnet",
  network: "q-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Q",
    symbol: "Q"
  },
  rpcUrls: {
    default: { http: ["https://rpc.qtestnet.org"] },
    public: { http: ["https://rpc.qtestnet.org"] }
  },
  blockExplorers: {
    default: {
      name: "Q Testnet Explorer",
      url: "https://explorer.qtestnet.org"
    }
  },
  testnet: !0
}), rollux = /* @__PURE__ */ defineChain({
  id: 570,
  name: "Rollux Mainnet",
  network: "rollux",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.rollux.com"],
      webSocket: ["wss://rpc.rollux.com/wss"]
    },
    public: { http: ["https://rollux.public-rpc.com"] }
  },
  blockExplorers: {
    default: { name: "RolluxExplorer", url: "https://explorer.rollux.com" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 119222
    }
  }
}), rolluxTestnet = /* @__PURE__ */ defineChain({
  id: 57e3,
  name: "Rollux Testnet",
  network: "rollux-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc-tanenbaum.rollux.com/"],
      webSocket: ["wss://rpc-tanenbaum.rollux.com/wss"]
    },
    public: { http: ["https://rpc-tanenbaum.rollux.com/"] }
  },
  blockExplorers: {
    default: {
      name: "RolluxTestnetExplorer",
      url: "https://rollux.tanenbaum.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1813675
    }
  }
}), ronin = /* @__PURE__ */ defineChain({
  id: 2020,
  name: "Ronin",
  network: "ronin",
  nativeCurrency: { name: "RON", symbol: "RON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.roninchain.com/rpc"]
    },
    public: {
      http: ["https://api.roninchain.com/rpc"]
    }
  },
  blockExplorers: {
    default: { name: "Ronin Explorer", url: "https://app.roninchain.com" }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 26023535
    }
  }
}), rootstock = /* @__PURE__ */ defineChain({
  id: 30,
  name: "Rootstock Mainnet",
  network: "rootstock",
  nativeCurrency: {
    decimals: 18,
    name: "Rootstock Bitcoin",
    symbol: "RBTC"
  },
  rpcUrls: {
    public: { http: ["https://public-node.rsk.co"] },
    default: { http: ["https://public-node.rsk.co"] }
  },
  blockExplorers: {
    blockscout: { name: "Blockscout", url: "https://rootstock.blockscout.com" },
    default: { name: "RSK Explorer", url: "https://explorer.rsk.co" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 4249540
    }
  }
}), saigon = /* @__PURE__ */ defineChain({
  id: 2021,
  name: "Saigon Testnet",
  network: "saigon",
  nativeCurrency: { name: "RON", symbol: "RON", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://saigon-testnet.roninchain.com/rpc"]
    },
    public: {
      http: ["https://saigon-testnet.roninchain.com/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Saigon Explorer",
      url: "https://saigon-explorer.roninchain.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 18736871
    }
  },
  testnet: !0
}), sapphire = /* @__PURE__ */ defineChain({
  id: 23294,
  name: "Oasis Sapphire",
  network: "sapphire",
  nativeCurrency: { name: "Sapphire Rose", symbol: "ROSE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sapphire.oasis.io"],
      webSocket: ["wss://sapphire.oasis.io/ws"]
    },
    public: {
      http: ["https://sapphire.oasis.io"],
      webSocket: ["wss://sapphire.oasis.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Oasis Sapphire Explorer",
      url: "https://explorer.sapphire.oasis.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 734531
    }
  }
}), sapphireTestnet = /* @__PURE__ */ defineChain({
  id: 23295,
  name: "Oasis Sapphire Testnet",
  network: "sapphire-testnet",
  nativeCurrency: { name: "Sapphire Test Rose", symbol: "TEST", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.sapphire.oasis.dev"],
      webSocket: ["wss://testnet.sapphire.oasis.dev/ws"]
    },
    public: {
      http: ["https://testnet.sapphire.oasis.dev"],
      webSocket: ["wss://testnet.sapphire.oasis.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Oasis Sapphire Testnet Explorer",
      url: "https://testnet.explorer.sapphire.oasis.dev"
    }
  },
  testnet: !0
}), scroll = /* @__PURE__ */ defineChain({
  id: 534352,
  name: "Scroll",
  network: "scroll",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.scroll.io"],
      webSocket: ["wss://wss-rpc.scroll.io/ws"]
    },
    public: {
      http: ["https://rpc.scroll.io"],
      webSocket: ["wss://wss-rpc.scroll.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Scrollscan",
      url: "https://scrollscan.com"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://blockscout.scroll.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14
    }
  },
  testnet: !1
}), scrollSepolia = /* @__PURE__ */ defineChain({
  id: 534351,
  name: "Scroll Sepolia",
  network: "scroll-sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rpc.scroll.io"]
    },
    public: {
      http: ["https://sepolia-rpc.scroll.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://sepolia-blockscout.scroll.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 9473
    }
  },
  testnet: !0
}), scrollTestnet = /* @__PURE__ */ defineChain({
  id: 534353,
  name: "Scroll Testnet",
  network: "scroll-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://alpha-rpc.scroll.io/l2"],
      webSocket: ["wss://alpha-rpc.scroll.io/l2/ws"]
    },
    public: {
      http: ["https://alpha-rpc.scroll.io/l2"],
      webSocket: ["wss://alpha-rpc.scroll.io/l2/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://blockscout.scroll.io"
    }
  },
  testnet: !0
}), sepolia = /* @__PURE__ */ defineChain({
  id: 11155111,
  network: "sepolia",
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "SEP", decimals: 18 },
  rpcUrls: {
    alchemy: {
      http: ["https://eth-sepolia.g.alchemy.com/v2"],
      webSocket: ["wss://eth-sepolia.g.alchemy.com/v2"]
    },
    infura: {
      http: ["https://sepolia.infura.io/v3"],
      webSocket: ["wss://sepolia.infura.io/ws/v3"]
    },
    default: {
      http: ["https://rpc.sepolia.org"]
    },
    public: {
      http: ["https://rpc.sepolia.org"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io"
    },
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0x21B000Fd62a880b2125A61e36a284BB757b76025",
      blockCreated: 3914906
    }
  },
  testnet: !0
}), shimmer = /* @__PURE__ */ defineChain({
  id: 148,
  name: "Shimmer",
  network: "shimmer",
  nativeCurrency: {
    decimals: 18,
    name: "Shimmer",
    symbol: "SMR"
  },
  rpcUrls: {
    public: {
      http: ["https://json-rpc.evm.shimmer.network"]
    },
    default: {
      http: ["https://json-rpc.evm.shimmer.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shimmer Network Explorer",
      url: "https://explorer.evm.shimmer.network"
    }
  }
}), shimmerTestnet = /* @__PURE__ */ defineChain({
  id: 1073,
  name: "Shimmer Testnet",
  network: "shimmer-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Shimmer",
    symbol: "SMR"
  },
  rpcUrls: {
    public: {
      http: ["https://json-rpc.evm.testnet.shimmer.network"]
    },
    default: {
      http: ["https://json-rpc.evm.testnet.shimmer.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shimmer Network Explorer",
      url: "https://explorer.evm.testnet.shimmer.network"
    }
  },
  testnet: !0
}), skaleBlockBrawlers = /* @__PURE__ */ defineChain({
  id: 391845894,
  name: "SKALE | Block Brawlers",
  network: "skale-brawl",
  nativeCurrency: { name: "BRAWL", symbol: "BRAWL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/frayed-decent-antares"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/frayed-decent-antares"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/frayed-decent-antares"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/frayed-decent-antares"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://frayed-decent-antares.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://frayed-decent-antares.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleCalypso = /* @__PURE__ */ defineChain({
  id: 1564830818,
  name: "SKALE | Calypso NFT Hub",
  network: "skale-calypso",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/honorable-steel-rasalhague"
      ]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/honorable-steel-rasalhague"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3107626
    }
  }
}), skaleCalypsoTestnet = /* @__PURE__ */ defineChain({
  id: 344106930,
  name: "SKALE | Calypso NFT Hub Testnet",
  network: "skale-calypso-testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-utter-unripe-menkar"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-utter-unripe-menkar"
      ]
    },
    public: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-utter-unripe-menkar"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-utter-unripe-menkar"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://staging-utter-unripe-menkar.explorer.staging-v3.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://staging-utter-unripe-menkar.explorer.staging-v3.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2131424
    }
  },
  testnet: !0
}), skaleChaosTestnet = /* @__PURE__ */ defineChain({
  id: 1351057110,
  name: "SKALE | Chaos Testnet",
  network: "skale-chaos-testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-fast-active-bellatrix"
      ]
    },
    public: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-fast-active-bellatrix"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://staging-fast-active-bellatrix.explorer.staging-v3.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://staging-fast-active-bellatrix.explorer.staging-v3.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 1192202
    }
  },
  testnet: !0
}), skaleCryptoBlades = /* @__PURE__ */ defineChain({
  id: 1026062157,
  name: "SKALE | CryptoBlades",
  network: "skale-cryptoblades",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/affectionate-immediate-pollux"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/affectionate-immediate-pollux"
      ]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/affectionate-immediate-pollux"],
      webSocket: [
        "wss://mainnet.skalenodes.com/v1/ws/affectionate-immediate-pollux"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://affectionate-immediate-pollux.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://affectionate-immediate-pollux.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleCryptoColosseum = /* @__PURE__ */ defineChain({
  id: 2046399126,
  name: "SKALE | Crypto Colosseum",
  network: "skale-crypto-coloseeum",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/haunting-devoted-deneb"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/haunting-devoted-deneb"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/haunting-devoted-deneb"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/haunting-devoted-deneb"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://haunting-devoted-deneb.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://haunting-devoted-deneb.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleEuropa = /* @__PURE__ */ defineChain({
  id: 2046399126,
  name: "SKALE | Europa Liquidity Hub",
  network: "skale-europa",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/elated-tan-skat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/elated-tan-skat"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/elated-tan-skat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/elated-tan-skat"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://elated-tan-skat.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://elated-tan-skat.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3113495
    }
  }
}), skaleEuropaTestnet = /* @__PURE__ */ defineChain({
  id: 476158412,
  name: "SKALE | Europa Liquidity Hub Testnet",
  network: "skale-europa-testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://staging-v3.skalenodes.com/v1/staging-legal-crazy-castor"],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-legal-crazy-castor"
      ]
    },
    public: {
      http: ["https://staging-v3.skalenodes.com/v1/staging-legal-crazy-castor"],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-legal-crazy-castor"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://staging-legal-crazy-castor.explorer.staging-v3.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://staging-legal-crazy-castor.explorer.staging-v3.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2071911
    }
  },
  testnet: !0
}), skaleExorde = /* @__PURE__ */ defineChain({
  id: 2139927552,
  name: "SKALE | Exorde",
  network: "skale-exorde",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/light-vast-diphda"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/light-vast-diphda"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/light-vast-diphda"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/light-vast-diphda"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://light-vast-diphda.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://light-vast-diphda.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleHumanProtocol = /* @__PURE__ */ defineChain({
  id: 1273227453,
  name: "SKALE | Human Protocol",
  network: "skale-human-protocol",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/wan-red-ain"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/wan-red-ain"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/wan-red-ain"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/wan-red-ain"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://wan-red-ain.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://wan-red-ain.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleNebula = /* @__PURE__ */ defineChain({
  id: 1482601649,
  name: "SKALE | Nebula Gaming Hub",
  network: "skale-nebula",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/green-giddy-denebola"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/green-giddy-denebola"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/green-giddy-denebola"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/green-giddy-denebola"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://green-giddy-denebola.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://green-giddy-denebola.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2372986
    }
  }
}), skaleNebulaTestnet = /* @__PURE__ */ defineChain({
  id: 503129905,
  name: "SKALE | Nebula Gaming Hub Testnet",
  network: "skale-nebula-testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://staging-v3.skalenodes.com/v1/staging-faint-slimy-achird"],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-faint-slimy-achird"
      ]
    },
    public: {
      http: ["https://staging-v3.skalenodes.com/v1/staging-faint-slimy-achird"],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-faint-slimy-achird"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://staging-faint-slimy-achird.explorer.staging-v3.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://staging-faint-slimy-achird.explorer.staging-v3.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2205882
    }
  },
  testnet: !0
}), skaleRazor = /* @__PURE__ */ defineChain({
  id: 278611351,
  name: "SKALE | Razor Network",
  network: "skale-razor",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/turbulent-unique-scheat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/turbulent-unique-scheat"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/turbulent-unique-scheat"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/turbulent-unique-scheat"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {}
}), skaleTitan = /* @__PURE__ */ defineChain({
  id: 1350216234,
  name: "SKALE | Titan Community Hub",
  network: "skale-titan",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.skalenodes.com/v1/parallel-stormy-spica"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica"]
    },
    public: {
      http: ["https://mainnet.skalenodes.com/v1/parallel-stormy-spica"],
      webSocket: ["wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica"]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://parallel-stormy-spica.explorer.mainnet.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://parallel-stormy-spica.explorer.mainnet.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2076458
    }
  }
}), skaleTitanTestnet = /* @__PURE__ */ defineChain({
  id: 1517929550,
  name: "SKALE | Titan Community Hub Testnet",
  network: "skale-titan-testnet",
  nativeCurrency: { name: "sFUEL", symbol: "sFUEL", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-aware-chief-gianfar"
      ]
    },
    public: {
      http: [
        "https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar"
      ],
      webSocket: [
        "wss://staging-v3.skalenodes.com/v1/ws/staging-aware-chief-gianfar"
      ]
    }
  },
  blockExplorers: {
    blockscout: {
      name: "SKALE Explorer",
      url: "https://staging-aware-chief-gianfar.explorer.staging-v3.skalenodes.com"
    },
    default: {
      name: "SKALE Explorer",
      url: "https://staging-aware-chief-gianfar.explorer.staging-v3.skalenodes.com"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2085155
    }
  },
  testnet: !0
}), songbird = /* @__PURE__ */ defineChain({
  id: 19,
  name: "Songbird Mainnet",
  network: "songbird-mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "songbird",
    symbol: "SGB"
  },
  rpcUrls: {
    default: { http: ["https://songbird-api.flare.network/ext/C/rpc"] },
    public: { http: ["https://songbird-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Songbird Explorer",
      url: "https://songbird-explorer.flare.network"
    }
  }
}), songbirdTestnet = /* @__PURE__ */ defineChain({
  id: 16,
  name: "Coston",
  network: "coston",
  nativeCurrency: {
    decimals: 18,
    name: "costonflare",
    symbol: "CFLR"
  },
  rpcUrls: {
    default: { http: ["https://coston-api.flare.network/ext/C/rpc"] },
    public: { http: ["https://coston-api.flare.network/ext/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "Coston Explorer",
      url: "https://coston-explorer.flare.network"
    }
  },
  testnet: !0
}), spicy = /* @__PURE__ */ defineChain({
  id: 88882,
  name: "Chiliz Spicy Testnet",
  network: "chiliz-spicy-Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "CHZ",
    symbol: "CHZ"
  },
  rpcUrls: {
    default: {
      http: [
        "https://spicy-rpc.chiliz.com",
        "https://chiliz-spicy.publicnode.com"
      ],
      webSocket: [
        "wss://spicy-rpc-ws.chiliz.com",
        "wss://chiliz-spicy.publicnode.com"
      ]
    },
    public: {
      http: [
        "https://spicy-rpc.chiliz.com",
        "https://chiliz-spicy.publicnode.com"
      ],
      webSocket: [
        "wss://spicy-rpc-ws.chiliz.com",
        "wss://chiliz-spicy.publicnode.com"
      ]
    }
  },
  blockExplorers: {
    default: {
      name: "Chiliz Explorer",
      url: "http://spicy-explorer.chiliz.com"
    }
  },
  testnet: !0
}), shardeumSphinx = /* @__PURE__ */ defineChain({
  id: 8082,
  name: "Shardeum Sphinx",
  network: "shmSphinx",
  nativeCurrency: { name: "SHARDEUM", symbol: "SHM", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sphinx.shardeum.org"]
    },
    public: {
      http: ["https://sphinx.shardeum.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Shardeum Explorer",
      url: "https://explorer-sphinx.shardeum.org"
    }
  },
  testnet: !0
}), shibarium = /* @__PURE__ */ defineChain({
  id: 109,
  name: "Shibarium",
  network: "shibarium",
  nativeCurrency: { name: "Bone", symbol: "BONE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.shibrpc.com"]
    },
    public: {
      http: ["https://rpc.shibrpc.com"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "Blockscout",
      url: "https://shibariumscan.io"
    },
    default: {
      name: "Blockscout",
      url: "https://shibariumscan.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0x864Bf681ADD6052395188A89101A1B37d3B4C961",
      blockCreated: 265900
    }
  }
}), syscoin = /* @__PURE__ */ defineChain({
  id: 57,
  name: "Syscoin Mainnet",
  network: "syscoin",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.syscoin.org"],
      webSocket: ["wss://rpc.syscoin.org/wss"]
    },
    public: {
      http: ["https://rpc.syscoin.org"],
      webSocket: ["wss://rpc.syscoin.org/wss"]
    }
  },
  blockExplorers: {
    default: { name: "SyscoinExplorer", url: "https://explorer.syscoin.org" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 287139
    }
  }
}), syscoinTestnet = /* @__PURE__ */ defineChain({
  id: 5700,
  name: "Syscoin Tanenbaum Testnet",
  network: "syscoin-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Syscoin",
    symbol: "SYS"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.tanenbaum.io"],
      webSocket: ["wss://rpc.tanenbaum.io/wss"]
    },
    public: {
      http: ["https://rpc.tanenbaum.io"],
      webSocket: ["wss://rpc.tanenbaum.io/wss"]
    }
  },
  blockExplorers: {
    default: { name: "SyscoinTestnetExplorer", url: "https://tanenbaum.io" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 271288
    }
  }
}), taraxa = /* @__PURE__ */ defineChain({
  id: 841,
  name: "Taraxa Mainnet",
  network: "taraxa",
  nativeCurrency: { name: "Tara", symbol: "TARA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.mainnet.taraxa.io"]
    },
    public: {
      http: ["https://rpc.mainnet.taraxa.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taraxa Explorer",
      url: "https://explorer.mainnet.taraxa.io"
    }
  }
}), taikoJolnir = /* @__PURE__ */ defineChain({
  id: 167007,
  name: "Taiko Jolnir (Alpha-5 Testnet)",
  network: "tko-jolnir",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.jolnir.taiko.xyz"]
    },
    public: {
      http: ["https://rpc.jolnir.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.jolnir.taiko.xyz"
    }
  }
}), taikoTestnetSepolia = /* @__PURE__ */ defineChain({
  id: 167005,
  name: "Taiko (Alpha-3 Testnet)",
  network: "taiko-sepolia",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.test.taiko.xyz"]
    },
    public: {
      http: ["https://rpc.test.taiko.xyz"]
    }
  },
  blockExplorers: {
    default: {
      name: "blockscout",
      url: "https://explorer.test.taiko.xyz"
    }
  }
}), taraxaTestnet = /* @__PURE__ */ defineChain({
  id: 842,
  name: "Taraxa Testnet",
  network: "taraxa-testnet",
  nativeCurrency: { name: "Tara", symbol: "TARA", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.testnet.taraxa.io"]
    },
    public: {
      http: ["https://rpc.testnet.taraxa.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Taraxa Explorer",
      url: "https://explorer.testnet.taraxa.io"
    }
  },
  testnet: !0
}), telos = /* @__PURE__ */ defineChain({
  id: 40,
  name: "Telos",
  network: "telos",
  nativeCurrency: {
    decimals: 18,
    name: "Telos",
    symbol: "TLOS"
  },
  rpcUrls: {
    default: { http: ["https://mainnet.telos.net/evm"] },
    public: { http: ["https://mainnet.telos.net/evm"] }
  },
  blockExplorers: {
    default: {
      name: "Teloscan",
      url: "https://www.teloscan.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 246530709
    }
  }
}), telosTestnet = /* @__PURE__ */ defineChain({
  id: 41,
  name: "Telos",
  network: "telosTestnet",
  nativeCurrency: {
    decimals: 18,
    name: "Telos",
    symbol: "TLOS"
  },
  rpcUrls: {
    default: { http: ["https://testnet.telos.net/evm"] },
    public: { http: ["https://testnet.telos.net/evm"] }
  },
  blockExplorers: {
    default: {
      name: "Teloscan (testnet)",
      url: "https://testnet.teloscan.io/"
    }
  },
  testnet: !0
}), tenet = /* @__PURE__ */ defineChain({
  id: 1559,
  name: "Tenet",
  network: "tenet-mainnet",
  nativeCurrency: {
    name: "TENET",
    symbol: "TENET",
    decimals: 18
  },
  rpcUrls: {
    public: { http: ["https://rpc.tenet.org"] },
    default: { http: ["https://rpc.tenet.org"] }
  },
  blockExplorers: {
    default: { name: "TenetScan Mainnet", url: "https://tenetscan.io" }
  },
  testnet: !1
}), thunderTestnet = /* @__PURE__ */ defineChain({
  id: 997,
  name: "5ireChain Thunder Testnet",
  network: "5ireChain",
  nativeCurrency: { name: "5ire Token", symbol: "5IRE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc-testnet.5ire.network"]
    },
    public: {
      http: ["https://rpc-testnet.5ire.network"]
    }
  },
  blockExplorers: {
    default: {
      name: "5ireChain Explorer",
      url: "https://explorer.5ire.network"
    }
  },
  testnet: !0
}), vechain = /* @__PURE__ */ defineChain({
  id: 100009,
  name: "Vechain",
  network: "vechain",
  nativeCurrency: { name: "VeChain", symbol: "VET", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.vechain.org"]
    },
    public: {
      http: ["https://mainnet.vechain.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Vechain Explorer",
      url: "https://explore.vechain.org"
    },
    vechainStats: {
      name: "Vechain Stats",
      url: "https://vechainstats.com"
    }
  }
}), wanchain = /* @__PURE__ */ defineChain({
  id: 888,
  name: "Wanchain",
  network: "wanchain",
  nativeCurrency: { name: "WANCHAIN", symbol: "WAN", decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        "https://gwan-ssl.wandevs.org:56891",
        "https://gwan2-ssl.wandevs.org"
      ]
    },
    public: {
      http: [
        "https://gwan-ssl.wandevs.org:56891",
        "https://gwan2-ssl.wandevs.org"
      ]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "WanScan",
      url: "https://wanscan.org"
    },
    default: {
      name: "WanScan",
      url: "https://wanscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcDF6A1566e78EB4594c86Fe73Fcdc82429e97fbB",
      blockCreated: 25312390
    }
  }
}), wanchainTestnet = /* @__PURE__ */ defineChain({
  id: 999,
  name: "Wanchain Testnet",
  network: "wanchainTestnet",
  nativeCurrency: { name: "WANCHAIN", symbol: "WANt", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://gwan-ssl.wandevs.org:46891"]
    },
    public: {
      http: ["https://gwan-ssl.wandevs.org:46891"]
    }
  },
  blockExplorers: {
    etherscan: {
      name: "WanScanTest",
      url: "https://wanscan.org"
    },
    default: {
      name: "WanScanTest",
      url: "https://wanscan.org"
    }
  },
  contracts: {
    multicall3: {
      address: "0x11c89bF4496c39FB80535Ffb4c92715839CC5324",
      blockCreated: 24743448
    }
  },
  testnet: !0
}), wemix = /* @__PURE__ */ defineChain({
  id: 1111,
  name: "WEMIX",
  network: "wemix-mainnet",
  nativeCurrency: { name: "WEMIX", symbol: "WEMIX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.wemix.com"] },
    public: { http: ["https://api.wemix.com"] }
  },
  blockExplorers: {
    etherscan: { name: "wemixExplorer", url: "https://explorer.wemix.com" },
    default: { name: "wemixExplorer", url: "https://explorer.wemix.com" }
  }
}), wemixTestnet = /* @__PURE__ */ defineChain({
  id: 1112,
  name: "WEMIX Testnet",
  network: "wemix-testnet",
  nativeCurrency: { name: "WEMIX", symbol: "tWEMIX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.test.wemix.com"] },
    public: { http: ["https://api.test.wemix.com"] }
  },
  blockExplorers: {
    etherscan: { name: "wemixExplorer", url: "https://testnet.wemixscan.com" },
    default: { name: "wemixExplorer", url: "https://testnet.wemixscan.com" }
  },
  testnet: !0
}), xdc = /* @__PURE__ */ defineChain({
  id: 50,
  name: "XinFin Network",
  network: "xdc",
  nativeCurrency: {
    decimals: 18,
    name: "XDC",
    symbol: "XDC"
  },
  rpcUrls: {
    default: { http: ["https://rpc.xinfin.network"] },
    public: { http: ["https://rpc.xinfin.network"] }
  },
  blockExplorers: {
    xinfin: { name: "XinFin", url: "https://explorer.xinfin.network" },
    default: { name: "Blocksscan", url: "https://xdc.blocksscan.io" }
  }
}), xdcTestnet = /* @__PURE__ */ defineChain({
  id: 51,
  name: "Apothem Network",
  network: "xdc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "TXDC",
    symbol: "TXDC"
  },
  rpcUrls: {
    default: { http: ["https://erpc.apothem.network"] },
    public: { http: ["https://erpc.apothem.network"] }
  },
  blockExplorers: {
    xinfin: { name: "XinFin", url: "https://explorer.apothem.network" },
    default: { name: "Blocksscan", url: "https://apothem.blocksscan.io" }
  }
}), zhejiang = /* @__PURE__ */ defineChain({
  id: 1337803,
  network: "zhejiang",
  name: "Zhejiang",
  nativeCurrency: { name: "Zhejiang Ether", symbol: "ZhejETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.zhejiang.ethpandaops.io"]
    },
    public: {
      http: ["https://rpc.zhejiang.ethpandaops.io"]
    }
  },
  blockExplorers: {
    beaconchain: {
      name: "Etherscan",
      url: "https://zhejiang.beaconcha.in"
    },
    blockscout: {
      name: "Blockscout",
      url: "https://blockscout.com/eth/zhejiang-testnet"
    },
    default: {
      name: "Beaconchain",
      url: "https://zhejiang.beaconcha.in"
    }
  },
  testnet: !0
}), formattersZkSync = {
  block: /* @__PURE__ */ defineBlock({
    format(v) {
      var z;
      const y = (z = v.transactions) == null ? void 0 : z.map((ne) => {
        if (typeof ne == "string")
          return ne;
        const ue = formattersZkSync.transaction.format(ne);
        return ue.typeHex === "0x71" ? ue.type = "eip712" : ue.typeHex === "0xff" && (ue.type = "priority"), ue;
      });
      return {
        l1BatchNumber: v.l1BatchNumber ? hexToBigInt(v.l1BatchNumber) : null,
        l1BatchTimestamp: v.l1BatchTimestamp ? hexToBigInt(v.l1BatchTimestamp) : null,
        transactions: y
      };
    }
  }),
  transaction: /* @__PURE__ */ defineTransaction({
    format(v) {
      const y = {};
      return v.type === "0x71" ? y.type = "eip712" : v.type === "0xff" && (y.type = "priority"), {
        ...y,
        l1BatchNumber: v.l1BatchNumber ? hexToBigInt(v.l1BatchNumber) : null,
        l1BatchTxIndex: v.l1BatchTxIndex ? hexToBigInt(v.l1BatchTxIndex) : null
      };
    }
  }),
  transactionReceipt: /* @__PURE__ */ defineTransactionReceipt({
    format(v) {
      return {
        l1BatchNumber: v.l1BatchNumber ? hexToBigInt(v.l1BatchNumber) : null,
        l1BatchTxIndex: v.l1BatchTxIndex ? hexToBigInt(v.l1BatchTxIndex) : null,
        logs: v.logs.map((y) => ({
          ...formatLog(y),
          l1BatchNumber: y.l1BatchNumber ? hexToBigInt(y.l1BatchNumber) : null,
          transactionLogIndex: hexToNumber(y.transactionLogIndex),
          logType: y.logType
        })),
        l2ToL1Logs: v.l2ToL1Logs.map((y) => ({
          blockNumber: hexToBigInt(y.blockHash),
          blockHash: y.blockHash,
          l1BatchNumber: hexToBigInt(y.l1BatchNumber),
          transactionIndex: hexToBigInt(y.transactionIndex),
          shardId: hexToBigInt(y.shardId),
          isService: y.isService,
          sender: y.sender,
          key: y.key,
          value: y.value,
          transactionHash: y.transactionHash,
          logIndex: hexToBigInt(y.logIndex)
        }))
      };
    }
  }),
  transactionRequest: /* @__PURE__ */ defineTransactionRequest({
    exclude: [
      "customSignature",
      "factoryDeps",
      "gasPerPubdata",
      "paymaster",
      "paymasterInput"
    ],
    format(v) {
      return v.gasPerPubdata || v.paymaster && v.paymasterInput || v.factoryDeps || v.customSignature ? {
        eip712Meta: {
          ...v.gasPerPubdata ? { gasPerPubdata: toHex(v.gasPerPubdata) } : {},
          ...v.paymaster && v.paymasterInput ? {
            paymasterParams: {
              paymaster: v.paymaster,
              paymasterInput: Array.from(hexToBytes(v.paymasterInput))
            }
          } : {},
          ...v.factoryDeps ? { factoryDeps: v.factoryDeps } : {},
          ...v.customSignature ? { customSignature: v.customSignature } : {}
        },
        type: v.type === "eip712" ? "0x71" : "0xff"
      } : {};
    }
  })
}, serializeTransactionZkSync = (v, y) => isEIP712(v) ? serializeTransactionZkSyncEIP712(v) : serializeTransaction(v, y), serializersZkSync = {
  transaction: serializeTransactionZkSync
};
function serializeTransactionZkSyncEIP712(v) {
  const { chainId: y, gas: z, nonce: ne, to: ue, from: le, value: he, maxFeePerGas: ge, maxPriorityFeePerGas: we, customSignature: Ee, factoryDeps: xe, paymaster: $e, paymasterInput: Ne, gasPerPubdata: st, data: Nr } = v;
  assertTransactionEIP712(v);
  const br = [
    ne ? toHex(ne) : "0x",
    we ? toHex(we) : "0x",
    ge ? toHex(ge) : "0x",
    z ? toHex(z) : "0x",
    ue ?? "0x",
    he ? toHex(he) : "0x",
    Nr ?? "0x",
    toHex(y),
    toHex(""),
    toHex(""),
    toHex(y),
    le ?? "0x",
    st ? toHex(st) : "0x",
    xe ?? [],
    Ee ?? "0x",
    $e && Ne ? [$e, Ne] : []
  ];
  return concatHex([
    "0x71",
    toRlp(br)
  ]);
}
function isEIP712(v) {
  return "customSignature" in v || "paymaster" in v || "paymasterInput" in v || "gasPerPubdata" in v || "factoryDeps" in v;
}
function assertTransactionEIP712(v) {
  const { chainId: y, to: z, from: ne, paymaster: ue, paymasterInput: le } = v;
  if (y <= 0)
    throw new InvalidChainIdError({ chainId: y });
  if (z && !isAddress(z))
    throw new InvalidAddressError({ address: z });
  if (ne && !isAddress(ne))
    throw new InvalidAddressError({ address: ne });
  if (ue && !isAddress(ue))
    throw new InvalidAddressError({ address: ue });
  if (ue && !le)
    throw new BaseError("`paymasterInput` must be provided when `paymaster` is defined");
  if (!ue && le)
    throw new BaseError("`paymaster` must be provided when `paymasterInput` is defined");
}
const zkSync = /* @__PURE__ */ defineChain({
  id: 324,
  name: "zkSync Era",
  network: "zksync-era",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://mainnet.era.zksync.io"],
      webSocket: ["wss://mainnet.era.zksync.io/ws"]
    },
    public: {
      http: ["https://mainnet.era.zksync.io"],
      webSocket: ["wss://mainnet.era.zksync.io/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkExplorer",
      url: "https://explorer.zksync.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    }
  }
}, {
  serializers: serializersZkSync,
  formatters: formattersZkSync
}), zkSyncTestnet = /* @__PURE__ */ defineChain({
  id: 280,
  name: "zkSync Era Testnet",
  network: "zksync-era-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://testnet.era.zksync.dev"],
      webSocket: ["wss://testnet.era.zksync.dev/ws"]
    },
    public: {
      http: ["https://testnet.era.zksync.dev"],
      webSocket: ["wss://testnet.era.zksync.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkExplorer",
      url: "https://goerli.explorer.zksync.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    }
  },
  testnet: !0
}, {
  serializers: serializersZkSync,
  formatters: formattersZkSync
}), zkSyncSepoliaTestnet = /* @__PURE__ */ defineChain({
  id: 300,
  name: "zkSync Sepolia Testnet",
  network: "zksync-sepolia-testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.era.zksync.dev"],
      webSocket: ["wss://sepolia.era.zksync.dev/ws"]
    },
    public: {
      http: ["https://sepolia.era.zksync.dev"],
      webSocket: ["wss://sepolia.era.zksync.dev/ws"]
    }
  },
  blockExplorers: {
    default: {
      name: "zkExplorer",
      url: "https://sepolia.explorer.zksync.io/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xF9cda624FBC7e059355ce98a31693d299FACd963"
    }
  },
  testnet: !0
}, {
  serializers: serializersZkSync,
  formatters: formattersZkSync
}), zetachainAthensTestnet = /* @__PURE__ */ defineChain({
  id: 7001,
  name: "ZetaChain Athens Testnet",
  network: "zetachain-athens-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Zeta",
    symbol: "aZETA"
  },
  rpcUrls: {
    public: {
      http: ["https://zetachain-athens-evm.blockpi.network/v1/rpc/public"]
    },
    default: {
      http: ["https://zetachain-athens-evm.blockpi.network/v1/rpc/public"]
    }
  },
  blockExplorers: {
    default: {
      name: "ZetaScan",
      url: "https://athens3.explorer.zetachain.com"
    }
  },
  testnet: !0
}), zilliqa = /* @__PURE__ */ defineChain({
  id: 32769,
  name: "Zilliqa",
  network: "zilliqa",
  nativeCurrency: { name: "Zilliqa", symbol: "ZIL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://api.zilliqa.com"]
    },
    public: {
      http: ["https://api.zilliqa.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ethernal",
      url: "https://evmx.zilliqa.com"
    }
  },
  testnet: !1
}), zilliqaTestnet = /* @__PURE__ */ defineChain({
  id: 33101,
  name: "Zilliqa Testnet",
  network: "zilliqa-testnet",
  nativeCurrency: { name: "Zilliqa", symbol: "ZIL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://dev-api.zilliqa.com"]
    },
    public: {
      http: ["https://dev-api.zilliqa.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Ethernal",
      url: "https://evmx.testnet.zilliqa.com"
    }
  },
  testnet: !0
}), zora = /* @__PURE__ */ defineChain({
  id: 7777777,
  name: "Zora",
  network: "zora",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.zora.energy"],
      webSocket: ["wss://rpc.zora.energy"]
    },
    public: {
      http: ["https://rpc.zora.energy"],
      webSocket: ["wss://rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: { name: "Explorer", url: "https://explorer.zora.energy" }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 5882
    }
  }
}, {
  formatters: formattersOptimism
}), zoraSepolia = /* @__PURE__ */ defineChain({
  id: 999999999,
  name: "Zora Sepolia",
  network: "zora-sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Zora Sepolia",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.rpc.zora.energy"],
      webSocket: ["wss://sepolia.rpc.zora.energy"]
    },
    public: {
      http: ["https://sepolia.rpc.zora.energy"],
      webSocket: ["wss://sepolia.rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Zora Sepolia Explorer",
      url: "https://sepolia.explorer.zora.energy/"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 83160
    }
  },
  testnet: !0
}, {
  formatters: formattersOptimism
}), zoraTestnet = /* @__PURE__ */ defineChain({
  id: 999,
  name: "Zora Goerli Testnet",
  network: "zora-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Zora Goerli",
    symbol: "ETH"
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.zora.energy"],
      webSocket: ["wss://testnet.rpc.zora.energy"]
    },
    public: {
      http: ["https://testnet.rpc.zora.energy"],
      webSocket: ["wss://testnet.rpc.zora.energy"]
    }
  },
  blockExplorers: {
    default: {
      name: "Explorer",
      url: "https://testnet.explorer.zora.energy"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 189123
    }
  },
  testnet: !0
}, {
  formatters: formattersOptimism
}), allChains = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arbitrum,
  arbitrumGoerli,
  arbitrumNova,
  arbitrumSepolia,
  astar,
  astarZkatana,
  aurora,
  auroraTestnet,
  avalanche,
  avalancheFuji,
  base: base$1,
  baseGoerli,
  baseSepolia,
  bearNetworkChainMainnet,
  bearNetworkChainTestnet,
  bitTorrent,
  bitTorrentTestnet,
  boba,
  bronos,
  bronosTestnet,
  bsc,
  bscTestnet,
  bxn,
  bxnTestnet,
  canto,
  celo,
  celoAlfajores,
  celoCannoli,
  chiliz,
  classic,
  confluxESpace,
  confluxESpaceTestnet,
  coreDao,
  cronos,
  cronosTestnet,
  crossbell,
  dfk,
  dogechain,
  edgeware,
  edgewareTestnet,
  ekta,
  ektaTestnet,
  eos,
  eosTestnet,
  evmos,
  evmosTestnet,
  fantom,
  fantomSonicTestnet,
  fantomTestnet,
  fibo,
  filecoin,
  filecoinCalibration,
  filecoinHyperspace,
  flare,
  flareTestnet,
  foundry,
  fuse,
  fuseSparknet,
  gnosis,
  gnosisChiado,
  gobi,
  goerli,
  haqqMainnet,
  haqqTestedge2,
  hardhat,
  harmonyOne,
  holesky,
  iotex,
  iotexTestnet,
  kava,
  kavaTestnet,
  klaytn,
  klaytnBaobab,
  kroma,
  kromaSepolia,
  linea,
  lineaTestnet,
  localhost,
  lukso,
  mainnet,
  manta,
  mantaTestnet,
  mantle,
  mantleTestnet,
  meter,
  meterTestnet,
  metis,
  metisGoerli,
  mev,
  mevTestnet,
  modeTestnet,
  moonbaseAlpha,
  moonbeam,
  moonbeamDev,
  moonriver,
  neonDevnet,
  neonMainnet,
  nexi,
  nexilix,
  oasys,
  okc,
  opBNB,
  opBNBTestnet,
  optimism,
  optimismGoerli,
  optimismSepolia,
  pgn,
  pgnTestnet,
  plinga,
  polygon,
  polygonMumbai,
  polygonZkEvm,
  polygonZkEvmTestnet,
  pulsechain,
  pulsechainV4,
  qMainnet,
  qTestnet,
  rollux,
  rolluxTestnet,
  ronin,
  rootstock,
  saigon,
  sapphire,
  sapphireTestnet,
  scroll,
  scrollSepolia,
  scrollTestnet,
  sepolia,
  shardeumSphinx,
  shibarium,
  shimmer,
  shimmerTestnet,
  skaleBlockBrawlers,
  skaleCalypso,
  skaleCalypsoTestnet,
  skaleChaosTestnet,
  skaleCryptoBlades,
  skaleCryptoColosseum,
  skaleEuropa,
  skaleEuropaTestnet,
  skaleExorde,
  skaleHumanProtocol,
  skaleNebula,
  skaleNebulaTestnet,
  skaleRazor,
  skaleTitan,
  skaleTitanTestnet,
  songbird,
  songbirdTestnet,
  spicy,
  syscoin,
  syscoinTestnet,
  taikoJolnir,
  taikoTestnetSepolia,
  taraxa,
  taraxaTestnet,
  telos,
  telosTestnet,
  tenet,
  thunderTestnet,
  vechain,
  wanchain,
  wanchainTestnet,
  wemix,
  wemixTestnet,
  xdc,
  xdcTestnet,
  zetachainAthensTestnet,
  zhejiang,
  zilliqa,
  zilliqaTestnet,
  zkSync,
  zkSyncSepoliaTestnet,
  zkSyncTestnet,
  zora,
  zoraSepolia,
  zoraTestnet
}, Symbol.toStringTag, { value: "Module" })), finalityTimeMap = {
  [`${mainnet.id}`]: "16 mins",
  [`${avalanche.id}`]: "3 secs",
  [`${polygon.id}`]: "~5 mins",
  [`${opBNB.id}`]: "46 secs",
  [`${fantom.id}`]: "3 secs",
  [`${kava.id}`]: "45 secs",
  [`${optimism.id}`]: "30 mins",
  [`${linea.id}`]: "81 mins",
  [`${filecoin.id}`]: "52 mins",
  [`${moonbeam.id}`]: "25 secs",
  [`${celo.id}`]: "12 secs",
  [`${arbitrum.id}`]: "~20 mins",
  [`${base$1.id}`]: "24 mins"
}, chainsWithHighFinalityTime = [
  polygon.id,
  mainnet.id,
  arbitrum.id,
  base$1.id,
  optimism.id,
  filecoin.id,
  linea.id
];
function getFinalityTime(v) {
  return finalityTimeMap[`${v}`] || "~5 minutes";
}
const USDFeeDisplay = ({
  gasFeesData: v,
  bridgeFeesData: y,
  withTooltip: z,
  relayerFee: ne,
  showOnlyGasFee: ue = !1,
  side: le = "right",
  showUnitFees: he = !1
}) => {
  const ge = useMemo(() => {
    let $e = new BigNumber(0);
    if (v != null && v.usdGasFees.length && ($e = v == null ? void 0 : v.usdGasFees.reduce(
      (Ne, st) => st ? Ne.plus(st) : Ne,
      new BigNumber(0)
    )), !ue) {
      if (y != null && y.usdBridgeFees) {
        const Ne = y.usdBridgeFees.reduce(
          (st, Nr) => Nr ? st.plus(Nr) : st,
          new BigNumber(0)
        );
        $e = $e.plus(Ne);
      }
      $e = $e.plus((ne == null ? void 0 : ne.usdGasFees) ?? 0);
    }
    return $e;
  }, [
    v == null ? void 0 : v.usdGasFees,
    ne == null ? void 0 : ne.usdGasFees,
    ue,
    y == null ? void 0 : y.usdBridgeFees
  ]);
  if (!v && !(ne != null && ne.usdGasFees) && !(y != null && y.usdBridgeFees))
    return null;
  const we = /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: ge ? formatAmountWithPrefix(ge, "$", 2, 4) : "—" }), Ee = () => {
    if (ne != null && ne.gasFees && !ue) {
      const [$e, Ne] = ne.gasFees.split(" ");
      return $e ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-medium text-left", children: "Relayer Fee" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-left", children: [
          $e,
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground", children: Ne })
        ] })
      ] }, "relayer-fee") : null;
    }
    return null;
  }, xe = () => y != null && y.bridgeFees.length && !ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: y == null ? void 0 : y.bridgeFees.map(($e, Ne) => {
    const [st, Nr] = $e.split(" ");
    return st ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-medium text-left", children: "Bridge Fee" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-left", children: [
        st,
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground", children: Nr })
      ] })
    ] }, Ne) : null;
  }) }) : null;
  if (z)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: we }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Kg,
        {
          side: le,
          className: "max-w-[15rem] text-left grid grid-cols-[auto,auto] gap-x-2 gap-y-1 font-normal",
          children: [
            v == null ? void 0 : v.gasFees.map(($e, Ne) => {
              const [st, Nr] = $e.split(" ");
              return st ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-medium text-left", children: "Gas Fee" }),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-left", children: [
                  st,
                  " ",
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground", children: Nr })
                ] })
              ] }, Ne) : null;
            }),
            xe(),
            Ee()
          ]
        }
      )
    ] });
  if (he) {
    const [$e, Ne] = (v == null ? void 0 : v.gasFees[0].split(" ")) || [];
    return $e ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      we,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-muted-foreground text-sm", children: [
        "(",
        $e,
        " ",
        Ne,
        ")"
      ] })
    ] }) : we;
  } else
    return we;
}, ConversionRateDisplay = ({ sourceAssetData: v, destinationAssetData: y, inputAmount: z, outputAmount: ne }) => {
  const { data: ue, isLoading: le } = useUSDPrice(v == null ? void 0 : v.coingeckoId), {
    data: he,
    isLoading: ge
  } = useUSDPrice(y == null ? void 0 : y.coingeckoId), we = useMemo(() => {
    if (!(le || ge))
      return !ue || !he ? new BigNumber(z).dividedBy(ne) : new BigNumber(ue).dividedBy(
        he
      );
  }, [
    he,
    z,
    ge,
    le,
    ne,
    ue
  ]);
  return !v || !y ? null : le || ge ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-32 rounded-3xl" }) : we ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-sm text-left", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        "1 ",
        v.symbol
      ] }),
      " =",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          formatAmount(
            we,
            2,
            2,
            we.gte(1e4) ? "compact" : "standard"
          ),
          " ",
          y.symbol
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "font-normal text-left", children: [
          we.toFixed(y.decimals),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground", children: y.symbol })
        ] }) })
      ] })
    ] }),
    ue ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-muted-foreground ml-1", children: [
      "(",
      formatAmountWithPrefix(ue, "$"),
      ")"
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: he ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-muted-foreground ml-1", children: [
      "(",
      formatAmountWithPrefix(he, "$"),
      ")"
    ] }) : null })
  ] }) : null;
}, PriceImpactDisplay = ({ priceImpact: v }) => {
  if (v === void 0)
    return null;
  if (isNaN(v))
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Price impact" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "focus-visible:outline-none focus-visible:ring-2", children: "–" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "right", className: "max-w-[10rem]", children: "Data not available. Price impact is the impact your trade has on the market price of this pool. The higher the size of the swap, the higher the price impact." })
      ] })
    ] });
  const y = v > 5 ? "warning-check" : v > 2.5 ? "warning" : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Price impact" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "p",
        {
          className: `focus-visible:outline-none focus-visible:ring-2 ${y === "warning-check" ? "text-destructive" : y === "warning" ? "text-warning" : "text-foreground"}`,
          children: [
            v.toFixed(2),
            "%"
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "right", className: "max-w-[10rem]", children: "The impact your trade has on the market price of this pool. The higher the size of the swap, the higher the price impact." })
    ] })
  ] });
}, SlippageDisplay = ({ slippage: v, slippageRemark: y, amountOut: z, destinationAssetData: ne }) => {
  const ue = useMemo(() => new BigNumber(z).multipliedBy(v).dividedBy(100), [z, v]), le = useMemo(() => new BigNumber(z).minus(ue), [ue, z]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Slippage" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "p",
        {
          className: `focus-visible:outline-none focus-visible:ring-2 ${(y == null ? void 0 : y.type) === "warning" ? "text-warning-foreground" : ""} ${(y == null ? void 0 : y.type) === "warning-alert" ? "text-destructive" : ""}`,
          children: [
            v,
            "%"
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "right", className: "max-w-[10rem]", children: `You will receive a minimum of ${formatAmount(
        le.toNumber(),
        2,
        6
      )} ${ne == null ? void 0 : ne.symbol} in the worst case. If the price changes unfavorably by more than ${v}%, 
          the swap will not take place and your funds will be refunded.
          ` })
    ] })
  ] });
}, OrderRoutingDisplay = ({ orderRouting: v }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center", children: v.map((y, z, ne) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-4 w-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: y.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: y.chainName }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-muted-foreground ml-1", children: [
        "(",
        y.chainId,
        ")"
      ] })
    ] }) })
  ] }),
  ne.length - 1 !== z ? /* @__PURE__ */ jsxRuntimeExports.jsx(D$2, { className: "text-muted-foreground mx-1" }) : null
] }, `${y.chainId}-${z}`)) }), EstimatedTimeInfo = () => {
  const { sourceChainData: v, destinationChainData: y } = useSwapsContext(), { showEstimatedTime: z, evmChainIndex: ne } = useMemo(() => {
    const le = {
      showEstimatedTime: !1,
      evmChainIndex: -1
    };
    if (!v || !y || !((v == null ? void 0 : v.chainType) === "evm" || (y == null ? void 0 : y.chainType) === "evm"))
      return le;
    let ge = -1, we = -1;
    chainsWithHighFinalityTime.forEach((xe, $e) => {
      xe === Number(v.chainId) ? ge = $e : xe === Number(y.chainId) && (we = $e);
    });
    const Ee = ge > we ? ge : we;
    return {
      showEstimatedTime: Ee > -1,
      evmChainIndex: Ee
    };
  }, [v, y]);
  if (!z)
    return null;
  const ue = chainsWithHighFinalityTime[ne];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between !bg-card !text-card-foreground rounded-xl px-4 py-3 mt-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "Estimated Time" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$5, { size: 18, weight: "fill" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Kg,
          {
            side: "right",
            className: "max-w-[16rem] h-full text-wrap",
            children: [
              "This swap contains at least one EVM chain, so it might take longer. Read more about",
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  className: "underline",
                  target: "_blank",
                  href: "https://docs.axelar.dev/learn/txduration#common-finality-time-for-interchain-transactions",
                  children: "common finality times"
                }
              ),
              "."
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(R$3, { size: 18, weight: "fill" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex gap-2 items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: getFinalityTime(ue) }) })
    ] })
  ] });
}, SwapInfo = ({ className: v }) => {
  var Yn;
  const y = useRef(null), z = useSkipSupportedChains(), ne = useWalletClientContext(), {
    slippage: ue,
    slippageRemark: le,
    routeResponse: he,
    inputAmount: ge,
    isLoadingRoute: we,
    isValidatingRoute: Ee,
    isRouteQueryEnabled: xe,
    gasFeesData: $e,
    relayerFee: Ne,
    isLoadingGasFee: st,
    isValidatingGasFee: Nr,
    isLoadingMessages: br,
    sourceTokenBalance: $n,
    destinationAssetData: En,
    sourceAssetData: Rn,
    amountOut: wa
  } = useIBCSwapsContext(), Aa = !!(he != null && he.response.does_swap), _a = Aa ? Number(he.response.swap_price_impact_percent) : void 0, Ta = useMemo(() => !z.data || !(he != null && he.response.chain_ids) ? null : he.response.chain_ids.map(
    ($o) => z.data.find((ct) => ct.chainId === $o)
  ), [z.data, he == null ? void 0 : he.response.chain_ids]), Zn = (Yn = $n == null ? void 0 : $n.data) == null ? void 0 : Yn.amount.isLessThan(ge), Ra = st || we || Ee || Nr || br;
  return xe && he ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    G$,
    {
      type: "single",
      collapsible: !0,
      onValueChange: ($o) => {
        $o === "item" && setTimeout(() => {
          var ct;
          (ct = y.current) == null || ct.scrollIntoView({
            behavior: "smooth"
          });
        }, 250);
      },
      className: Y$1(
        "!bg-card !text-card-foreground w-full rounded-xl",
        v
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(kf, { value: "item", className: "border-b-0", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Lf, { className: "rounded-xl px-4 py-3 hover:no-underline", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between pr-2", children: [
          we || Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-32 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            ConversionRateDisplay,
            {
              inputAmount: he.amountIn,
              outputAmount: he.amountOut,
              sourceAssetData: Rn,
              destinationAssetData: En
            }
          ),
          !Zn && ne.userAddress ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-center gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(G$3, { size: 16, weight: "bold" }),
            Ra ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
              USDFeeDisplay,
              {
                gasFeesData: $e,
                relayerFee: Ne,
                showOnlyGasFee: !0,
                withTooltip: !0,
                side: "top"
              }
            )
          ] }) : null
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Ff, { className: "px-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-0 w-full border-t" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full space-y-2 pt-3", ref: y, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(PriceImpactDisplay, { priceImpact: _a }),
            Aa ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              SlippageDisplay,
              {
                slippage: ue,
                slippageRemark: le,
                amountOut: wa,
                destinationAssetData: En
              }
            ) : null,
            !Zn && ne.userAddress ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Fee" }),
              Ra ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                USDFeeDisplay,
                {
                  gasFeesData: $e,
                  relayerFee: Ne,
                  withTooltip: !0
                }
              )
            ] }) : null,
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Order routing" }),
              Ta ? /* @__PURE__ */ jsxRuntimeExports.jsx(OrderRoutingDisplay, { orderRouting: Ta }) : /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" })
            ] })
          ] })
        ] })
      ] })
    }
  ) : null;
}, AggregatedSwapInfo = ({ className: v }) => {
  var ye;
  const y = useRef(null), z = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), ne = useWalletClientContext(), {
    slippage: ue,
    slippageRemark: le,
    routeResponse: he,
    inputAmount: ge,
    isLoadingRoute: we,
    isValidatingRoute: Ee,
    isRouteQueryEnabled: xe,
    gasFeesData: $e,
    isLoadingGasFee: Ne,
    isValidatingGasFee: st,
    isLoadingMessages: Nr,
    sourceTokenBalance: br,
    amountOut: $n,
    destinationAssetData: En,
    sourceAssetData: Rn,
    relayerFee: wa,
    isEVMWalletConnected: Aa,
    isSVMWalletConnected: _a,
    sourceChainData: Ta,
    bridgeFeesData: Zn
  } = useSwapsContext(), Ra = !!(he != null && he.response.does_swap), Yn = Ra ? Number(he.response.swap_price_impact_percent) : void 0, $o = useMemo(() => !z.data || !(he != null && he.response.chain_ids) ? null : he.response.chain_ids.map(
    (Se) => z.data.find((Oe) => Oe.chainId === Se)
  ), [z.data, he == null ? void 0 : he.response.chain_ids]), ct = (ye = br == null ? void 0 : br.data) == null ? void 0 : ye.amount.isLessThan(ge), fe = (Ta == null ? void 0 : Ta.chainType) === "cosmos" ? !!ne.userAddress : (Ta == null ? void 0 : Ta.chainType) === "evm" ? Aa : _a, be = Ne || we || Ee || st || Nr;
  return xe && he ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      G$,
      {
        type: "single",
        collapsible: !0,
        onValueChange: (Se) => {
          Se === "item" && setTimeout(() => {
            var Oe;
            (Oe = y.current) == null || Oe.scrollIntoView({
              behavior: "smooth"
            });
          }, 250);
        },
        className: Y$1(
          "!bg-card !text-card-foreground w-full rounded-xl",
          v
        ),
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(kf, { value: "item", className: "border-b-0", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Lf, { className: "rounded-xl px-4 py-3 hover:no-underline", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between pr-2", children: [
            we || Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-32 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
              ConversionRateDisplay,
              {
                inputAmount: he.amountIn,
                outputAmount: he.amountOut,
                sourceAssetData: Rn,
                destinationAssetData: En
              }
            ),
            !ct && fe ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-center gap-2", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(G$3, { size: 16, weight: "bold" }),
              be ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                USDFeeDisplay,
                {
                  gasFeesData: $e,
                  bridgeFeesData: Zn,
                  relayerFee: wa,
                  withTooltip: !0,
                  side: "top"
                }
              )
            ] }) : null
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Ff, { className: "px-4", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-0 w-full border-t" }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full space-y-2 pt-3", ref: y, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(PriceImpactDisplay, { priceImpact: Yn }),
              Ra ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                SlippageDisplay,
                {
                  slippage: ue,
                  slippageRemark: le,
                  amountOut: $n,
                  destinationAssetData: En
                }
              ) : null,
              !ct && fe && ($e != null && $e.gasFees.length) ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Gas Fee" }),
                be ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  USDFeeDisplay,
                  {
                    gasFeesData: $e,
                    showOnlyGasFee: !0,
                    withTooltip: !0
                  }
                )
              ] }) : null,
              !ct && Zn.bridgeFees.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Bridge Fee" }),
                be ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  USDFeeDisplay,
                  {
                    bridgeFeesData: Zn,
                    withTooltip: !0
                  }
                )
              ] }) : null,
              !ct && wa.gasFees.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Relayer Fee" }),
                be ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                  USDFeeDisplay,
                  {
                    relayerFee: wa,
                    withTooltip: !0
                  }
                )
              ] }) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Order routing" }),
                $o ? /* @__PURE__ */ jsxRuntimeExports.jsx(OrderRoutingDisplay, { orderRouting: $o }) : /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" })
              ] })
            ] })
          ] })
        ] })
      },
      "aggregated-swap-info-accordion"
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(EstimatedTimeInfo, {})
  ] }) : null;
}, ConnectEVMWalletButton = ({ selectedChainId: v, renderCTAPostConnect: y }) => {
  const { chain: z } = useNetwork(), [ne, ue] = useState(!1), { switchNetworkAsync: le, isLoading: he } = useSwitchNetwork(), ge = useCallback(async () => {
    if (!(!v || ne || !le))
      try {
        ue(!0), await le(v);
      } catch {
      } finally {
        ue(!1);
      }
  }, [ne, v, le]);
  return v !== void 0 && z && z.id !== v ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full mt-3",
      disabled: he,
      onClick: ge,
      children: he ? "Switching..." : "Switch Network"
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectButton.Custom, { children: ({ account: we, chain: Ee, openChainModal: xe, openConnectModal: $e, mounted: Ne }) => {
    const st = Ne && we && Ee;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        "data-rk": !0,
        ...!Ne && {
          "aria-hidden": !0,
          style: {
            opacity: 0,
            pointerEvents: "none",
            userSelect: "none"
          }
        },
        children: st ? Ee.unsupported ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          np,
          {
            variant: "action-primary",
            className: "w-full mt-3",
            onClick: xe,
            type: "button",
            children: "Wrong network"
          }
        ) : y ? y() : null : /* @__PURE__ */ jsxRuntimeExports.jsx(
          np,
          {
            variant: "action-primary",
            className: "w-full mt-3",
            onClick: $e,
            children: "Connect EVM Wallet"
          }
        )
      }
    );
  } });
}, LEDGER_NOT_SUPPORTED_CHAINS = [
  { chainId: "evmos_9001-2", chainName: "Evmos" },
  { chainId: "injective-1", chainName: "Injective" },
  { chainId: "dymension_1100-1", chainName: "Dymension" }
], useIsLedgerSupportError = (v) => {
  const { isLedgerWallet: y } = useWalletClientContext();
  return useMemo(() => y && v ? !!v.response.chain_ids.some(
    (ue) => !!LEDGER_NOT_SUPPORTED_CHAINS.find((le) => ue === le.chainId)
  ) : !1, [y, v]);
};
function ConnectWalletCard({
  logo: v,
  prettyName: y,
  onClick: z,
  readyState: ne
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    np,
    {
      variant: "ghost",
      className: "flex justify-start p-1.5 gap-2.5 h-auto group",
      onClick: z,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: v,
            onError: (ue) => {
              ue.currentTarget.onerror = null;
            },
            className: "block shrink-0 h-7 w-7 rounded"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-left text-base font-bold", children: y }),
        ne === "NotDetected" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          q$1,
          {
            size: 18,
            weight: "bold",
            className: "hidden group-hover:block text-primary ml-auto mr-2"
          }
        ) : null
      ]
    }
  );
}
const ConnectSVMWalletButton = () => {
  const { wallets: v, select: y } = useWallet(), [z, ne] = useState(!1), ue = useCallback(
    async (le) => {
      try {
        await le.adapter.connect(), y(le.adapter.name), ne(!1);
      } catch (he) {
        console.error(he);
      }
    },
    [y]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Y0$1, { open: z, onOpenChange: ne, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(J$, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(np, { variant: "action-primary", className: "w-full mt-3", children: "Connect Solana Wallet" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Gi, { className: "w-full max-w-[20rem]", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(q0$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Q0$1, { className: "text-left", children: "Connect Solana Wallet" }) }),
      v && v.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col gap-0.5 mt-2", children: v.filter((le) => le.readyState !== "Unsupported").map((le) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConnectWalletCard,
        {
          logo: le.adapter.icon,
          prettyName: le.adapter.name,
          readyState: le.readyState,
          onClick: () => {
            switch (le.readyState) {
              case "Installed":
              case "Loadable":
                ue(le);
                break;
              case "NotDetected":
                window.open(le.adapter.url, "_blank");
                break;
            }
          }
        },
        le.adapter.name
      )) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-[14.5rem] w-full flex-col justify-center items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 24, className: "text-foreground -mt-4" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-foreground break-all text-center mt-2", children: "No wallets found for Solana" })
      ] })
    ] })
  ] });
}, CTASection = () => {
  var ye;
  const v = useWalletClientContext(), {
    inputAmount: y,
    inputAmountRemark: z,
    slippageRemark: ne,
    sourceTokenBalance: ue,
    isLoadingRoute: le,
    isValidatingRoute: he,
    isLoadingMessages: ge,
    isLoadingGasFee: we,
    isValidatingGasFee: Ee,
    routeResponse: xe,
    routeError: $e,
    messages: Ne,
    gasFeesData: st,
    isRouteQueryEnabled: Nr,
    amountOut: br,
    isConversionRateChecked: $n,
    sourceAddress: En,
    destinationAddress: Rn,
    isUserAddressesError: wa
  } = useIBCSwapsContext(), [Aa, _a] = useState(!1), { setStep: Ta } = useIBCSwapsFlowContext(), Zn = xe && !le && !$e, Ra = (ye = ue == null ? void 0 : ue.data) == null ? void 0 : ye.amount.isLessThan(y), Yn = getConversionRateRemark(xe), $o = useIsLedgerSupportError(xe), ct = () => {
    const Se = parseFloat(y), Oe = parseFloat(br), Fr = !isNaN(Se) && Se > 0, zn = !isNaN(Oe) && Oe > 0, Fe = ne ? ne.type !== "error" : !0, pe = Yn === "request-confirmation" ? $n : !0;
    return Fr && zn && Nr && !!xe && Zn && !$e && !le && !he && !Ra && !z && !we && !Ee && !!st && !st.gasFeesError && !ge && !!Ne && Fe && pe && !wa && !$o;
  }, fe = Ra, be = En.error || Rn.error;
  return fe ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      className: "w-full",
      disabled: !be,
      children: (() => {
        if (Ra)
          return `Insufficient ${ue.data.denomData.coinDenom} balance`;
      })()
    }
  ) : be ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: (() => {
        var Se, Oe;
        return (((Se = En.error) == null ? void 0 : Se.code) === 3 || ((Oe = Rn.error) == null ? void 0 : Oe.code) === 3) && Aa ? "action-primary" : "action-destructive";
      })(),
      className: "w-full transition-colors",
      onMouseEnter: () => {
        setTimeout(() => {
          _a(!0);
        }, 100);
      },
      onMouseLeave: () => {
        setTimeout(() => {
          _a(!1);
        }, 100);
      },
      onClick: () => {
        var Se, Oe;
        if (((Se = En.error) == null ? void 0 : Se.code) === 3)
          return En.refetch();
        if (((Oe = Rn.error) == null ? void 0 : Oe.code) === 3)
          return Rn.refetch();
      },
      children: (() => {
        if (En.error)
          return En.error.code === 3 && Aa ? "Click to Retry" : En.error.message;
        if (Rn.error)
          return Rn.error.code === 3 && Aa ? "Click to Retry" : Rn.error.message;
      })()
    }
  ) : v.userAddress ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      disabled: !ct(),
      onClick: () => {
        Ta(1);
      },
      children: "Review Swap"
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      onClick: () => {
        v.connectWallet("cosmoshub-4");
      },
      children: "Connect Wallet"
    }
  );
}, AggregatedCTASection = () => {
  var Fe;
  const v = useWalletClientContext(), {
    inputAmount: y,
    inputAmountRemark: z,
    slippageRemark: ne,
    sourceTokenBalance: ue,
    isLoadingRoute: le,
    isValidatingRoute: he,
    isLoadingMessages: ge,
    isLoadingGasFee: we,
    isValidatingGasFee: Ee,
    routeResponse: xe,
    routeError: $e,
    sourceChainId: Ne,
    destinationChainId: st,
    messages: Nr,
    gasFeesData: br,
    isRouteQueryEnabled: $n,
    amountOut: En,
    isConversionRateChecked: Rn,
    sourceAddress: wa,
    destinationAddress: Aa,
    isUserAddressesError: _a,
    sourceChainData: Ta,
    destinationChainData: Zn
  } = useSwapsContext(), [Ra, Yn] = useState(!1), { chain: $o } = useNetwork(), { setStep: ct } = useSwapsFlowContext(), fe = xe && !le && !$e, be = (Fe = ue == null ? void 0 : ue.data) == null ? void 0 : Fe.amount.isLessThan(y), ye = getConversionRateRemark(xe), Se = useIsLedgerSupportError(xe), Oe = () => {
    const pe = parseFloat(y), it = parseFloat(En), xa = !isNaN(pe) && pe > 0, wo = !isNaN(it) && it > 0, _u = ne ? ne.type !== "error" : !0, Oa = ye === "request-confirmation" ? Rn : !0;
    return xa && wo && $n && !!xe && fe && !$e && !le && !he && !be && !z && !we && !Ee && !!br && !br.gasFeesError && !ge && !!Nr && _u && Oa && !_a && !Se;
  }, Fr = be, zn = (wa == null ? void 0 : wa.error) || (Aa == null ? void 0 : Aa.error);
  if (Fr)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "action-destructive",
        className: "w-full",
        disabled: !zn,
        children: (() => {
          if (be)
            return "Insufficient balance";
        })()
      }
    );
  if (zn)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: (() => {
          var pe, it;
          return (((pe = wa.error) == null ? void 0 : pe.code) === 3 || ((it = Aa.error) == null ? void 0 : it.code) === 3) && Ra ? "action-primary" : "action-destructive";
        })(),
        className: "w-full transition-colors",
        onMouseEnter: () => {
          setTimeout(() => {
            Yn(!0);
          }, 100);
        },
        onMouseLeave: () => {
          setTimeout(() => {
            Yn(!1);
          }, 100);
        },
        onClick: () => {
          var pe, it;
          if (((pe = wa.error) == null ? void 0 : pe.code) === 3)
            return wa.refetch();
          if (((it = Aa.error) == null ? void 0 : it.code) === 3)
            return Aa.refetch();
        },
        children: (() => {
          if (wa.error)
            return wa.error.code === 3 && Ra ? "Click to Retry" : wa.error.message;
          if (Aa.error)
            return Aa.error.code === 3 && Ra ? "Click to Retry" : Aa.error.message;
        })()
      }
    );
  if (!wa.address) {
    if ((Ta == null ? void 0 : Ta.chainType) === "cosmos")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          variant: "action-primary",
          className: "w-full",
          onClick: () => v.connectWallet(Ne),
          children: "Connect Wallet"
        }
      );
    if ((Ta == null ? void 0 : Ta.chainType) === "svm")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectSVMWalletButton, {});
    if ((Ta == null ? void 0 : Ta.chainType) === "evm")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConnectEVMWalletButton,
        {
          selectedChainId: Number(Ne),
          renderCTAPostConnect: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
            np,
            {
              variant: "action-primary",
              className: "w-full",
              disabled: !Oe(),
              onClick: () => ct(1),
              children: "Review Swap"
            }
          )
        }
      );
  }
  if ((Ta == null ? void 0 : Ta.chainType) === "evm" && ($o == null ? void 0 : $o.id) !== Number(Ne))
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ConnectEVMWalletButton,
      {
        selectedChainId: Number(Ne),
        renderCTAPostConnect: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
          np,
          {
            variant: "action-primary",
            className: "w-full",
            disabled: !Oe(),
            onClick: () => ct(1),
            children: "Review Swap"
          }
        )
      }
    );
  if (!Aa.address) {
    if ((Zn == null ? void 0 : Zn.chainType) === "cosmos")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          variant: "action-primary",
          className: "w-full",
          onClick: () => v.connectWallet(st),
          children: "Connect Wallet"
        }
      );
    if ((Zn == null ? void 0 : Zn.chainType) === "svm")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectSVMWalletButton, {});
    if ((Zn == null ? void 0 : Zn.chainType) === "evm")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConnectEVMWalletButton,
        {
          selectedChainId: Number(st),
          renderCTAPostConnect: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
            np,
            {
              variant: "action-primary",
              className: "w-full",
              disabled: !Oe(),
              onClick: () => {
                ct(1);
              },
              children: "Review Swap"
            }
          )
        }
      );
  }
  return (Zn == null ? void 0 : Zn.chainType) === "evm" && ($o == null ? void 0 : $o.id) !== Number(st) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConnectEVMWalletButton,
    {
      selectedChainId: Number(st),
      renderCTAPostConnect: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          variant: "action-primary",
          className: "w-full",
          disabled: !Oe(),
          onClick: () => ct(1),
          children: "Review Swap"
        }
      )
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      disabled: !Oe(),
      onClick: () => ct(1),
      children: "Review Swap"
    }
  );
}, presetSlippageOptions = [0.5, 1, 3], SwapSettings = ({ slippage: v, setSlippage: y, slippageRemark: z }) => {
  const [ne, ue] = useState(!1), le = useRef(null), [he, ge] = useState(() => {
    switch (parseFloat(v)) {
      case 0.5:
        return "0.5";
      case 1:
        return "1";
      case 3:
        return "3";
      default:
        return "custom";
    }
  }), [we, Ee] = useState(
    () => he === "custom" ? parseFloat(v).toString() : ""
  ), xe = useCallback(
    ($e) => {
      if ($e === !1 && he === "custom") {
        const Ne = parseFloat(we);
        (isNaN(Ne) || Ne <= 0 || Ne > 99) && (ge("1"), Ee(""));
      }
      ue($e);
    },
    [we, he]
  );
  return useEffect(() => {
    var $e;
    he === "custom" && (($e = le == null ? void 0 : le.current) == null || $e.focus());
  }, [he]), useEffect(() => {
    y(he === "custom" ? we : he);
  }, [he, we, y]), /* @__PURE__ */ jsxRuntimeExports.jsxs(pw, { modal: !0, open: ne, onOpenChange: xe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-popover relative rounded-3xl flex items-center justify-center", children: [
      ne ? null : z ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "p",
        {
          className: `flex -mr-8 h-8 items-center justify-start rounded-3xl pl-3 pr-10 text-sm ${z.type === "warning" ? "bg-warning/10 text-warning" : "bg-destructive/5 text-destructive"}`,
          children: z.type === "error" ? "Invalid Slippage" : `${v}% slippage`
        }
      ) : he === "custom" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "flex -mr-8 h-8 items-center justify-start rounded-3xl pl-3 pr-10 text-sm bg-popover text-popover-foreground", children: [
        we,
        "% slippage"
      ] }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx(mw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          variant: "secondary",
          size: "sm-icon",
          className: "rounded-3xl z-[1]",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(G$2, { weight: "bold", size: "1.125rem" })
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(jb, { className: "w-80", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Slippage" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$5, { size: "1rem", weight: "fill" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "right", className: "max-w-44", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "Your transaction will revert if the price changes unfavorably by more than this percentage." }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        og,
        {
          autoFocus: !0,
          value: he,
          onValueChange: ge,
          className: "mt-2 grid gap-2",
          style: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr)) 1fr"
          },
          children: [
            presetSlippageOptions.map(($e, Ne) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                rg,
                {
                  value: `${$e}`,
                  id: `slippage-option-${Ne + 1}`,
                  className: "peer sr-only"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Pb,
                {
                  htmlFor: `slippage-option-${Ne + 1}`,
                  className: "peer-focus-visible:ring-ring border-border bg-popover hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-popover-foreground [&:has([data-state=checked])]:border-popover-foreground peer-data-[state=checked]:text-popover-foreground [&:has([data-state=checked])]:text-popover-foreground flex flex-col items-center justify-between rounded-md border px-2 py-1 text-sm peer-focus-visible:ring-2",
                  children: [
                    $e,
                    "%"
                  ]
                }
              )
            ] }, $e.toString())),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                rg,
                {
                  value: "custom",
                  id: "slippage-option-4",
                  className: "peer sr-only"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Pb,
                {
                  htmlFor: "slippage-option-4",
                  className: "peer-focus-visible:ring-ring border-border bg-popover hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-popover-foreground [&:has([data-state=checked])]:border-popover-foreground peer-data-[state=checked]:text-popover-foreground [&:has([data-state=checked])]:text-popover-foreground flex flex-row items-center justify-between gap-1 rounded-md border px-2 py-1 text-sm peer-focus-visible:ring-2",
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Custom" }),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Cb,
                      {
                        ref: le,
                        type: "number",
                        min: 0,
                        max: 99,
                        step: 0.5,
                        disabled: he !== "custom",
                        variant: "unstyled",
                        className: "h-[0.8rem] w-[2rem] text-sm disabled:pointer-events-none disabled:cursor-default",
                        placeholder: "0.00",
                        value: we,
                        onChange: ($e) => Ee($e.target.value)
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "%" })
                  ]
                }
              )
            ] })
          ]
        }
      ),
      z ? z.type === "warning" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-warning mt-2 flex items-start gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { size: "1rem", weight: "fill", className: "mt-1 shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: z.message })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-destructive mt-2 flex items-start gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { size: "1rem", weight: "fill", className: "mt-1 shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: z.message })
      ] }) : null
    ] })
  ] });
}, useBroadcastedTxsStatus = ({
  txs: v,
  txsRequired: y,
  enabled: z
}) => {
  const [ne, ue] = useState(!1), le = unstable_serialize([
    "solve-txs-status",
    y,
    (v == null ? void 0 : v.map((we) => we.txHash).join("-")) ?? ""
  ]), ge = (!ne && v && v.length > 0 && z !== void 0 ? z : !ne) ? le : null;
  return useSWR(
    ge,
    async () => {
      if (!v)
        return;
      const we = await Promise.all(
        v.map(async (Ne) => {
          const st = await SkipAPI.getTxnStatus({
            chain_id: Ne.chainID,
            tx_hash: Ne.txHash
          });
          if (st.success === !1)
            throw new Error(st.error);
          const Nr = txStatusResponseFromJSON(
            st.response
          ), br = Nr.transferSequence.map(($n) => {
            if ("ibcTransfer" in $n)
              return {
                type: "ibcTransfer",
                srcChainID: $n.ibcTransfer.srcChainID,
                destChainID: $n.ibcTransfer.dstChainID,
                packetTxs: {
                  sendTx: $n.ibcTransfer.packetTXs.sendTx,
                  receiveTx: $n.ibcTransfer.packetTXs.receiveTx,
                  acknowledgeTx: $n.ibcTransfer.packetTXs.acknowledgeTx,
                  timeoutTx: $n.ibcTransfer.packetTXs.timeoutTx,
                  error: $n.ibcTransfer.packetTXs.error
                },
                state: $n.ibcTransfer.state,
                originalState: $n.ibcTransfer.state
              };
            if ("cctpTransfer" in $n) {
              const En = (() => {
                switch ($n.cctpTransfer.state) {
                  case "CCTP_TRANSFER_SENT":
                    return "TRANSFER_PENDING";
                  case "CCTP_TRANSFER_PENDING_CONFIRMATION":
                    return "TRANSFER_PENDING";
                  case "CCTP_TRANSFER_CONFIRMED":
                    return "TRANSFER_PENDING";
                  case "CCTP_TRANSFER_RECEIVED":
                    return "TRANSFER_SUCCESS";
                  default:
                    return "TRANSFER_FAILURE";
                }
              })();
              return {
                type: "cctpTransfer",
                srcChainID: $n.cctpTransfer.srcChainID,
                destChainID: $n.cctpTransfer.dstChainID,
                packetTxs: {
                  sendTx: $n.cctpTransfer.txs.sendTx,
                  receiveTx: $n.cctpTransfer.txs.receiveTx
                },
                state: En,
                originalState: $n.cctpTransfer.state
              };
            }
            if ("hyperlaneTransfer" in $n) {
              const En = (() => {
                switch ($n.hyperlaneTransfer.state) {
                  case "HYPERLANE_TRANSFER_SENT":
                    return "TRANSFER_PENDING";
                  case "HYPERLANE_TRANSFER_FAILED":
                    return "TRANSFER_FAILURE";
                  case "HYPERLANE_TRANSFER_RECEIVED":
                    return "TRANSFER_SUCCESS";
                  case "HYPERLANE_TRANSFER_UNKNOWN":
                    return "TRANSFER_UNKNOWN";
                  default:
                    return "TRANSFER_UNKNOWN";
                }
              })();
              return {
                type: "hyperlaneTransfer",
                srcChainID: $n.hyperlaneTransfer.fromChainID,
                destChainID: $n.hyperlaneTransfer.toChainID,
                packetTxs: {
                  sendTx: $n.hyperlaneTransfer.txs.sendTx,
                  receiveTx: $n.hyperlaneTransfer.txs.receiveTx
                },
                state: En,
                originalState: $n.hyperlaneTransfer.state
              };
            }
            if ("axelarTransfer" in $n) {
              const En = (() => {
                switch ($n.axelarTransfer.state) {
                  case "AXELAR_TRANSFER_PENDING_RECEIPT":
                    return "TRANSFER_PENDING";
                  case "AXELAR_TRANSFER_PENDING_CONFIRMATION":
                    return "TRANSFER_PENDING";
                  case "AXELAR_TRANSFER_FAILURE":
                    return "TRANSFER_FAILURE";
                  case "AXELAR_TRANSFER_SUCCESS":
                    return "TRANSFER_SUCCESS";
                  default:
                    return "TRANSFER_UNKNOWN";
                }
              })();
              return "contractCallWithTokenTxs" in $n.axelarTransfer.txs ? {
                type: "axelarTransfer",
                axelarScanLink: $n.axelarTransfer.axelarScanLink,
                srcChainID: $n.axelarTransfer.srcChainID,
                destChainID: $n.axelarTransfer.dstChainID,
                packetTxs: {
                  sendTx: $n.axelarTransfer.txs.contractCallWithTokenTxs.sendTx,
                  receiveTx: $n.axelarTransfer.txs.contractCallWithTokenTxs.executeTx,
                  error: $n.axelarTransfer.txs.contractCallWithTokenTxs.error
                },
                state: En,
                originalState: $n.axelarTransfer.state
              } : {
                type: "axelarTransfer",
                axelarScanLink: $n.axelarTransfer.axelarScanLink,
                srcChainID: $n.axelarTransfer.srcChainID,
                destChainID: $n.axelarTransfer.dstChainID,
                packetTxs: {
                  sendTx: $n.axelarTransfer.txs.sendTokenTxs.sendTx,
                  receiveTx: $n.axelarTransfer.txs.sendTokenTxs.executeTx,
                  error: $n.axelarTransfer.txs.sendTokenTxs.error
                },
                state: En,
                originalState: $n.axelarTransfer.state
              };
            }
            throw new Error("Unknown transfer type");
          });
          return {
            state: Nr.state,
            transferSequence: br,
            nextBlockingTransfer: Nr.nextBlockingTransfer,
            transferAssetRelease: Nr.transferAssetRelease,
            error: Nr.error
          };
        })
      ), Ee = we.every((Ne) => Ne.state === "STATE_COMPLETED_SUCCESS" || Ne.state === "STATE_COMPLETED_ERROR" || Ne.state === "STATE_ABANDONED"), xe = we.every((Ne) => Ne.state === "STATE_COMPLETED_SUCCESS");
      we.length > 0 && y === we.length && Ee && ue(!0);
      const $e = we.map((Ne) => Ne.transferSequence).flat();
      return {
        isSuccess: xe,
        isSettled: Ee,
        transferSequence: $e,
        states: we.map((Ne) => Ne.state),
        grouped: we
      };
    },
    {
      errorRetryCount: 3,
      errorRetryInterval: 1e3 * 3,
      // 3 seconds
      refreshInterval: 1e3 * 3,
      // 3 seconds
      revalidateOnFocus: !1,
      revalidateOnReconnect: !0,
      keepPreviousData: !0
    }
  );
}, useConsoleLog = (...v) => {
  useEffect(() => {
    console.log(...v);
  }, [v]);
};
class TxnError extends Error {
  /**
   *
   * @param code Error Code
   * @param txnIndex Error Transaction Index
   * @param message Error Message
   */
  constructor(y, z, ne) {
    super(ne), this.code = y, this.txnIndex = z, this.message = ne;
  }
}
var NewTxnStatus = /* @__PURE__ */ ((v) => (v.IDLE = "IDLE", v.NEEDS_APPROVAL = "NEEDS_APPROVAL", v.SIGNED = "SIGNED", v.BROADCASTING = "BROADCASTING", v.BROADCASTED = "BROADCASTED", v))(NewTxnStatus || {});
const getDefaultTxnStatuses = (v) => new Array(v.transactionCount).fill({
  status: "IDLE"
  /* IDLE */
}), getMessageWithInfo = async (v, y, z) => {
  switch (v.typeUrl) {
    case "/cosmos.bank.v1beta1.MsgSend":
      return getCosmosSendMessageWithInfo(
        y,
        v.value,
        z.chains,
        z.denoms
      );
    case "/ibc.applications.transfer.v1.MsgTransfer":
      return getIbcTransferMessageWithInfo(
        y,
        v.value,
        v.value.receiver,
        z.chains,
        z.denoms
      );
    case "/cosmwasm.wasm.v1.MsgExecuteContract":
      return {
        typeUrl: v.typeUrl,
        value: v.value,
        info: {
          chain: y,
          sender: v.value.sender,
          contract: v.value.contract,
          msg: Buffer.from(v.value.msg).toString("base64"),
          funds: v.value.funds
        }
      };
    case "/circle.cctp.v1.MsgDepositForBurn":
      return {
        typeUrl: v.typeUrl,
        value: v.value,
        info: {
          sender: v.value.from,
          destinationDomain: v.value.destinationDomain,
          recipient: Buffer.from(v.value.mintRecipient).toString(
            "base64"
          ),
          token: v.value.burnToken,
          amount: v.value.amount
        }
      };
    case "/circle.cctp.v1.MsgDepositForBurnWithCaller":
      return {
        typeUrl: v.typeUrl,
        value: v.value,
        info: {
          sender: v.value.from,
          destinationDomain: v.value.destinationDomain,
          recipient: Buffer.from(v.value.mintRecipient).toString(
            "base64"
          ),
          token: v.value.burnToken,
          amount: v.value.amount,
          destinationCaller: Buffer.from(
            v.value.destinationCaller
          ).toString("base64")
        }
      };
  }
}, IBCSwapsTrackingContext = createContext(void 0), IBCSwapsTrackingProvider = ({
  children: v,
  gasFees: y,
  routeResponse: z,
  messages: ne,
  txnLifecycleHooks: ue,
  tab: le,
  updateOngoingTransactions: he,
  ongoingSwap: ge
}) => {
  const { data: we } = useChains(), { data: Ee } = useDenoms(), { walletClient: xe } = useWalletClientContext(), $e = useRef(!1), [Ne, st] = useState(0), [Nr, br] = useState(!1), [$n, En] = useState(
    ge ? "IN_PROGRESS" : "UNINITIALIZED"
  ), Rn = useMemo(() => `${z.amountIn}-${z.sourceAsset.denom}:${z.amountOut}-${z.destinationAsset.denom}:${z.transactionCount}`, [z]), wa = useRef({
    routeId: Rn,
    uuid: v4()
  });
  useEffect(() => {
    wa.current.routeId !== Rn && (wa.current = {
      routeId: Rn,
      uuid: v4()
    });
  }, [Rn]);
  const Aa = useMemo(
    () => ({
      ...z,
      messages: ne
    }),
    [ne, z]
  ), { groupedTransactions: _a } = useTransactions(Aa), [Ta, Zn] = useState(), { data: Ra, isLoading: Yn } = useSWR(
    z && we && Ee ? unstable_serialize(["transaction-amounts", Aa]) : null,
    async () => (invariant$1(we, "Chains data is missing"), invariant$1(Ee, "Denoms data is missing"), await withRetry(
      () => getSwapAmountsFromMessages(Aa, we, Ee),
      []
    ))
  ), $o = z.transactionCount, [ct, fe] = useState(
    (ge == null ? void 0 : ge.txnStatuses) ?? getDefaultTxnStatuses(z)
  ), be = useCallback(
    (xa, wo) => {
      fe((_u) => {
        const Oa = [..._u];
        return Oa[xa] = wo, Oa;
      });
    },
    []
  ), { data: ye } = useGasAdjustment(), { data: Se } = useGasPriceSteps(), Oe = ct.map((xa) => {
    if (xa.status === "BROADCASTED")
      return {
        chainID: xa.chainId,
        txHash: xa.txHash
      };
  }).filter((xa) => !!xa), Fr = useBroadcastedTxsStatus({
    txs: Oe,
    txsRequired: z.transactionCount
  }), zn = useCallback(async () => {
    var M2, d1, K1, k2, Eu, Zo, Fl;
    if (Yn || !we || !Ee || $e.current)
      return;
    En("IN_PROGRESS"), $e.current = !0;
    const xa = Ne;
    Zn(void 0);
    const wo = ne[xa].multi_chain_msg, _u = ((M2 = Ra == null ? void 0 : Ra[xa]) == null ? void 0 : M2.fromAmount) ?? "", Oa = ((d1 = Ra == null ? void 0 : Ra[xa]) == null ? void 0 : d1.toAmount) ?? "", Os = we.find(
      (Ru) => Ru.chainId === wo.chain_id
    );
    if (!Os) {
      Zn(
        new TxnError(
          0,
          xa,
          `Chain ${wo.chain_id} not supported by elements`
        )
      ), $e.current = !1;
      return;
    }
    const Pa = JSON.parse(wo.msg), Ml = (/* @__PURE__ */ new Date()).getTime();
    if (Number(Pa.timeout_timestamp / 10 ** 6) < Ml) {
      Zn(
        new TxnError(
          2,
          xa,
          `Transaction ${xa + 1} has timed out`
        )
      ), $e.current = !1;
      return;
    }
    const Tu = (K1 = ue == null ? void 0 : ue.onTxnInProgress) == null ? void 0 : K1.call(ue, le), { senderAddress: Au, encodedMessage: Zl } = getMessageMetadataForSigning(
      wo.msg_type_url,
      Pa
    );
    be(xa, {
      status: "NEEDS_APPROVAL"
      /* NEEDS_APPROVAL */
    });
    const Iu = getDecodedMessageMetadataForSigning(Zl), { data: Uc } = await handlePromise(async () => {
      var g2;
      const { data: Ru, error: ku } = await handlePromise(
        simulateTx(Os.restUrl, Au, [Iu])
      );
      if (ku || Ru === void 0)
        throw new Error("Simulation failed");
      const kc = (ye == null ? void 0 : ye[Os.key]) ?? 1.5, Ou = new BigNumber(
        ((g2 = Se == null ? void 0 : Se[Os.key]) == null ? void 0 : g2.low) ?? 0.025
      );
      return calculateFee(
        Ru.gasUsed,
        Ou.toNumber(),
        Os.baseDenom,
        kc
      );
    }), Pu = Uc ?? y[xa], { data: Lu, error: th } = await handlePromise(
      xe.getAccount(Os.chainId)
    );
    if (th || !Lu) {
      Zn(
        new TxnError(
          6,
          xa,
          `Couldn't fetch account for chain ${Os.chainName} from wallet`
        )
      ), $e.current = !1;
      return;
    }
    const { data: Zc, error: N1 } = await handlePromise(
      xe.getSigner(Os.chainId)
    );
    if (N1 || !Zc) {
      Zn(
        new TxnError(
          7,
          xa,
          `Couldn't request approval for ${Os.chainName} transaction from wallet`
        )
      ), $e.current = !1;
      return;
    }
    const Gh = new TxClient(
      Os.chainId,
      Os.restUrl,
      Os.coinType,
      Zc,
      Lu
    ), Mc = await getMessageWithInfo(Zl, Os, {
      chains: we,
      denoms: Ee
    }), h1 = {
      chainType: "cosmos",
      chainId: Os.chainId,
      chainName: Os.chainName,
      signMode: Lu.isNanoLedger ? "amino" : "direct",
      transactionTypes: [Mc.typeUrl],
      messages: [Mc]
    };
    (k2 = ue == null ? void 0 : ue.onTxnSignInit) == null || k2.call(ue, h1);
    const l2 = {
      current: void 0
    };
    try {
      const Ru = await Promise.race([
        Gh.sign(Au, [Zl], Pu, ""),
        sleep(3e4)
      ]);
      if (typeof Ru == "string")
        l2.current = Ru;
      else
        throw new Error("Transaction approval timed out");
      be(xa, {
        status: "SIGNED"
        /* SIGNED */
      });
    } catch (Ru) {
      be(xa, {
        status: "IDLE"
        /* IDLE */
      }), Ru instanceof Error ? Ru.message.includes("rejected") || Ru.message.includes("declined") ? Zn(
        new TxnError(
          3,
          xa,
          "Please approve the transaction from your wallet"
        )
      ) : Ru.message.includes("timed out") ? Zn(
        new TxnError(8, xa, "Transaction approval timed out")
      ) : Zn(new TxnError(-1, xa, Ru.message)) : Zn(
        new TxnError(-1, xa, "An unknown error occurred")
      ), (Eu = ue == null ? void 0 : ue.onTxnSignFailed) == null || Eu.call(
        ue,
        h1,
        Ru instanceof Error ? Ru : new Error("An unknown error occurred")
      ), Tu == null || Tu(), $e.current = !1;
      return;
    }
    let Gc, Kc;
    try {
      const Ru = await getSwapData(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _a[`Transaction ${xa + 1}`],
        we,
        Ee
      );
      Kc = {
        swapId: wa.current.uuid,
        fromTokenAmount: _u,
        toTokenAmount: Oa,
        ...Ru
      };
    } catch {
    }
    if (!l2.current) {
      be(xa, {
        status: "IDLE"
        /* IDLE */
      }), Zn(
        new TxnError(-1, xa, "No transaction data was found")
      ), Tu == null || Tu(), $e.current = !1;
      return;
    }
    be(xa, {
      status: "BROADCASTING"
      /* BROADCASTING */
    });
    try {
      const { success: Ru, response: ku } = await Gh.submitTx(
        Os.chainId,
        l2.current
      );
      if (!Ru)
        throw new Error("Skip SubmitTx Failed");
      Gc = ku == null ? void 0 : ku.tx_hash, (Zo = ue == null ? void 0 : ue.onTxnSignApproved) == null || Zo.call(ue, {
        ...h1,
        txHash: Gc,
        fees: Pu.amount,
        data: Kc
      }), be(xa, {
        status: "BROADCASTED",
        txHash: Gc,
        chainId: Os.chainId
      }), Tu == null || Tu(), $e.current = !1;
    } catch {
      try {
        const {
          transactionHash: ku,
          code: kc,
          codespace: Ou
        } = await Gh.broadcastTx(l2.current);
        if (Gc = ku, (Fl = ue == null ? void 0 : ue.onTxnSignApproved) == null || Fl.call(ue, {
          ...h1,
          txHash: Gc,
          fees: Pu.amount,
          data: Kc
        }), kc !== 0)
          be(xa, {
            status: "IDLE"
            /* IDLE */
          }), Zn(
            new TxnError(
              4,
              xa,
              `Transaction failed ${getErrorMessageFromCode(kc, Ou)}`
            )
          );
        else {
          const U1 = await sendTrackingRequest(Os.chainId, Gc);
          U1 != null && U1.success || Zn(
            new TxnError(
              9,
              xa,
              `Unable to track transaction. Please check the status on the explorer ${Os.txExplorer.mainnet}/${Gc}`
            )
          ), be(xa, {
            status: "BROADCASTED",
            txHash: Gc,
            chainId: Os.chainId
          });
        }
        Tu == null || Tu(), $e.current = !1;
      } catch (ku) {
        be(xa, {
          status: "IDLE"
          /* IDLE */
        }), ku instanceof Error ? Zn(new TxnError(5, xa, ku.message)) : Zn(
          new TxnError(
            5,
            xa,
            "An unknown error occurred while broadcasting the transaction"
          )
        ), Tu == null || Tu(), $e.current = !1;
        return;
      }
    }
  }, [
    we,
    Ee,
    y,
    _a,
    Yn,
    ne,
    le,
    Ra,
    ue,
    Ne,
    be,
    xe,
    ye,
    Se
  ]), Fe = useMemo(() => {
    if (Ta)
      switch (Ta.code) {
        case 0:
        case 1:
          return {
            status: "FATAL_ERROR",
            title: "Chain not supported",
            message: Ta.message
          };
        case 2:
          return {
            status: "FATAL_ERROR",
            title: "Transaction timed out",
            message: Ta.message
          };
        case 3:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: Ta.message
          };
        case 4:
          return {
            status: "FATAL_ERROR",
            title: "Transaction failed",
            message: Ta.message
          };
        case 5:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Transaction broadcast failed",
            message: Ta.message
          };
        case 6:
        case 7:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: Ta.message
          };
        case 8:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval timed out",
            message: Ta.message
          };
        case 9:
          return {
            status: "CANNOT_TRACK"
          };
        default:
          return {
            status: "FATAL_ERROR",
            title: "An unknown error occurred",
            message: Ta.message
          };
      }
    if (Fr.error)
      return {
        status: "CANNOT_TRACK"
      };
    if (Fr.data) {
      const xa = ct[Ne];
      if (xa.status === "BROADCASTED")
        switch (Fr.data.states[Ne]) {
          case "STATE_SUBMITTED":
          case "STATE_PENDING":
            return {
              status: "IN_PROGRESS"
            };
          case "STATE_UNKNOWN":
          case "STATE_ABANDONED":
            return {
              status: "CANNOT_TRACK"
            };
          case "STATE_PENDING_ERROR":
          case "STATE_COMPLETED_ERROR":
            return {
              status: "FAILED"
            };
          case "STATE_RECEIVED":
          case "STATE_COMPLETED":
          case "STATE_COMPLETED_SUCCESS":
            return {
              status: "SUCCESS"
            };
        }
      else
        switch (xa.status) {
          case "IDLE":
          case "NEEDS_APPROVAL":
            return {
              status: "SIGNATURE_REQUIRED"
            };
          case "SIGNED":
            return {
              status: "SIGNATURE_RECEIVED"
            };
          case "BROADCASTING":
            return {
              status: "BROADCASTING"
            };
        }
    }
  }, [Ne, Ta, ct, Fr]);
  useConsoleLog("IBCSwaps", "swapStatus", Fe), useConsoleLog("IBCSwaps", "lastError", Ta), useConsoleLog("IBCSwaps", "txnTrackingData", Fr.data), useConsoleLog("IBCSwaps", "overallSwapStatus", $n), useEffect(() => {
    Ta && br(!0);
  }, [Ta]), useEffect(() => {
    ct[Ne].status === "BROADCASTED" && he({
      activeTxnIndex: Ne,
      txnStatuses: ct,
      lastError: Ta
    });
  }, [Ta, Ne, ct]), useEffect(() => {
    ($n === "SUCCESS" || $n === "CANNOT_TRACK") && br(!1);
  }, [$n]);
  const pe = useMemo(() => ({
    sourceChain: z.sourceAssetChain,
    sourceAsset: z.sourceAsset,
    destinationChain: z.destinationAssetChain,
    destinationAsset: z.destinationAsset,
    inputAmount: z.amountIn,
    outAmount: z.amountOut
  }), [z]);
  useEffect(() => {
    Fe && (Fe.status === "SUCCESS" ? Ne === $o - 1 ? En("SUCCESS") : st((xa) => xa + 1) : Fe.status === "FAILED" || Fe.status === "FATAL_ERROR" ? En("FAILED") : Fe.status === "CANNOT_TRACK" && En("CANNOT_TRACK"));
  }, [
    Ne,
    pe,
    Fe,
    $o,
    ue
  ]), useEffect(() => {
    Ne > 0 && (ge == null ? void 0 : ge.activeTxnIndex) !== $o - 1 && zn();
  }, [Ne, ge, $o]);
  const it = useMemo(() => ({
    swapStatus: Fe,
    ongoingSwap: ge,
    overallSwapStatus: $n,
    isTxnTrackerOpen: Nr,
    setIsTxnTrackerOpen: br,
    executeRoute: zn,
    activeTxnIndex: Ne,
    setActiveTxnIndex: st,
    txnStatuses: ct,
    setTxnStatuses: fe,
    lastError: Ta,
    routeResponse: z,
    messages: ne,
    gasFees: y,
    txnLifecycleHooks: ue,
    tab: le,
    groupedTransactions: _a,
    txnTracking: Fr,
    updateOngoingTransactions: he
  }), [
    Fe,
    ge,
    $n,
    Nr,
    zn,
    Ne,
    ct,
    Ta,
    z,
    ne,
    y,
    ue,
    le,
    _a,
    Fr,
    he
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsTrackingContext.Provider, { value: it, children: v });
}, useIBCSwapsTrackingContext = () => {
  const v = useContext(IBCSwapsTrackingContext);
  return invariant$1(
    v,
    "useIBCSwapsTracking must be used within a IBCSwapsTrackingProvider"
  ), v;
}, SwapHistoryCTA = ({ setStep: v }) => {
  const y = () => {
    v(2);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "outline",
      size: "sm-icon",
      className: "rounded-3xl",
      onClick: y,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$3, { weight: "bold", size: 20 })
    }
  );
}, SwapHistoryHeader = ({ goBack: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "secondary",
      size: "sm-icon",
      className: "mr-3 rounded-3xl",
      onClick: v,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: "Ongoing transactions" })
] }), ZeroState = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-full justify-center items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(k$1, { weight: "bold", size: 32, className: "mb-2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-md", children: "No pending transactions" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground", children: "Your ongoing transactions will appear here" })
] }) }), SwapHistoryItem = ({
  transactionData: v,
  onSelectSwap: y,
  onDeleteSwap: z,
  callbackHooks: ne,
  onSwapComplete: ue
}) => {
  const {
    txnStatuses: le,
    routeResponse: he,
    sourceAssetData: ge,
    destinationAssetData: we,
    activeTxnIndex: Ee,
    lastError: xe
  } = v, $e = le.map((En) => {
    if (En.status === NewTxnStatus.BROADCASTED)
      return {
        chainID: En.chainId,
        txHash: En.txHash
      };
  }).filter((En) => !!En), Ne = useBroadcastedTxsStatus({
    txs: $e,
    txsRequired: he == null ? void 0 : he.transactionCount
  }), st = useRevalidateBalances(), Nr = useMemo(() => {
    var En, Rn, wa, Aa, _a, Ta, Zn;
    if (xe)
      switch (xe.code) {
        case 0:
        case 1:
          return {
            status: "FATAL_ERROR",
            title: "Chain not supported",
            message: xe.message
          };
        case 2:
          return {
            status: "FATAL_ERROR",
            title: "Transaction timed out",
            message: xe.message
          };
        case 3:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval Rejected",
            message: xe.message
          };
        case 4:
          return {
            status: "FATAL_ERROR",
            title: "Transaction Failed",
            message: xe.message
          };
        case 5:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Transaction broadcast failed",
            message: xe.message
          };
        case 6:
        case 7:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: xe.message
          };
        case 8:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval timed out",
            message: xe.message
          };
        case 9:
          return {
            status: "CANNOT_TRACK"
          };
        default:
          return {
            status: "FATAL_ERROR",
            title: "An unknown error occurred",
            message: xe.message
          };
      }
    if (Ne.error)
      return {
        status: "CANNOT_TRACK"
      };
    if (Ne.data) {
      if (le[Ee].status === NewTxnStatus.BROADCASTED) {
        const Yn = Ne.data.states[Ee], $o = (wa = (Rn = (En = Ne.data) == null ? void 0 : En.grouped) == null ? void 0 : Rn[Ee]) == null ? void 0 : wa.transferAssetRelease;
        if (((Zn = (Ta = (_a = (Aa = Ne.data.grouped) == null ? void 0 : Aa[Ee]) == null ? void 0 : _a.transferSequence) == null ? void 0 : Ta[0]) == null ? void 0 : Zn.type) === "cctpTransfer" && Yn === "STATE_RECEIVED")
          return {
            status: "IN_PROGRESS"
          };
        switch (Yn) {
          case "STATE_SUBMITTED":
          case "STATE_PENDING":
            return {
              status: "IN_PROGRESS"
            };
          case "STATE_UNKNOWN":
          case "STATE_ABANDONED":
            return {
              status: "CANNOT_TRACK"
            };
          case "STATE_PENDING_ERROR":
          case "STATE_COMPLETED_ERROR":
            return {
              status: "FAILED"
            };
          case "STATE_RECEIVED":
          case "STATE_COMPLETED":
          case "STATE_COMPLETED_SUCCESS":
            return Ee + 1 < (he == null ? void 0 : he.transactionCount) ? {
              status: "ATTENTION_REQUIRED"
            } : Ee + 1 === (he == null ? void 0 : he.transactionCount) && ($o == null ? void 0 : $o.chainID) === (he == null ? void 0 : he.destinationAssetChain.chainId) ? {
              status: "SUCCESS"
            } : {
              status: "FAILED"
            };
        }
      }
      return {
        status: "CANNOT_TRACK"
      };
    }
  }, [Ee, xe, le, Ne, he]), { color: br, text: $n } = useMemo(() => {
    switch (Nr == null ? void 0 : Nr.status) {
      case "IN_PROGRESS":
        return {
          color: "text-success",
          text: "Swap in progress"
        };
      case "ATTENTION_REQUIRED":
      case "RECOVERABLE_ERROR":
        return {
          color: "text-warning",
          text: "Action required"
        };
      case "SUCCESS":
        return {
          color: "text-success",
          text: "Success"
        };
      case "FAILED":
      case "FATAL_ERROR":
        return {
          color: "text-destructive",
          text: "Transaction failed"
        };
      case "CANNOT_TRACK":
        return {
          color: "text-warning",
          text: "Unable to track transaction"
        };
      default:
        return {
          color: "text-muted-foreground",
          text: "Unknown"
        };
    }
  }, [Nr]);
  return useConsoleLog("SwapHistoryItem", "swapStatus", Nr), useConsoleLog("SwapHistoryItem", "lastError", xe), useConsoleLog("SwapHistoryItem", "txnTrackingData", Ne.data), useEffect(() => {
    var wa;
    const { routeResponse: En, id: Rn } = v;
    !Nr || !En || ((Nr == null ? void 0 : Nr.status) === "SUCCESS" || (Nr == null ? void 0 : Nr.status) === "FAILED") && !v.isComplete && (ue(v), st(), (wa = ne == null ? void 0 : ne.onTxnComplete) == null || wa.call(ne, {
      id: Rn,
      sourceChain: En.sourceAssetChain,
      sourceAsset: En.sourceAsset,
      destinationChain: En.destinationAssetChain,
      destinationAsset: En.destinationAsset,
      inputAmount: En.amountIn,
      outAmount: En.amountOut,
      status: Nr.status === "SUCCESS" ? "success" : "failed"
    }));
  }, [
    Nr,
    ne,
    ue,
    v,
    st
  ]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative mt-3", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "bg-card rounded-xl cursor-pointer text-card-foreground w-full flex justify-between items-center px-7 py-4",
        onClick: y,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-3 items-start w-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "bg-background h-6 w-6 shadow-[0_0_0_0.2rem_hsl(var(--border))]", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: we == null ? void 0 : we.logoUri }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "bg-background absolute -bottom-3 -left-2 h-6 w-6 shadow-[0_0_0_0.2rem_hsl(var(--border))]", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: ge == null ? void 0 : ge.logoUri }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-[50%] shrink-0", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-md font-bold flex gap-1 items-center truncate w-full", children: [
              ge == null ? void 0 : ge.symbol,
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(d$4, { size: 16, weight: "bold" }) }),
              we == null ? void 0 : we.symbol
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: `text-xs ${br}`, children: $n })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-[30%] flex gap-2 justify-end items-center shrink-0 ml-auto self-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-right", children: [
              he != null && he.response.usd_amount_in && (he == null ? void 0 : he.response.usd_amount_in) !== "0.00" ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold max-w-full truncate", children: formatAmountWithPrefix(
                (he == null ? void 0 : he.response.usd_amount_in) ?? "0",
                "$"
              ) }) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs text-muted-foreground max-w-full truncate", children: [
                formatAmount((he == null ? void 0 : he.amountIn) ?? "0"),
                " ",
                ge == null ? void 0 : ge.symbol
              ] })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(l$4, { size: 16, className: "text-muted-foreground" })
          ] })
        ] })
      }
    ),
    (Nr == null ? void 0 : Nr.status) === "CANNOT_TRACK" || (Nr == null ? void 0 : Nr.status) === "FAILED" || (Nr == null ? void 0 : Nr.status) === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "rounded-3xl absolute overflow-visible -top-3 -right-3 !bg-black !h-7 !w-7",
        onClick: z,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-4 w-4 bg-muted-foreground rounded-3xl flex justify-center items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$2, { weight: "bold", size: 14, className: "text-black" }) })
      }
    ) : null
  ] });
}, SwapHistoryView = () => {
  const { goBack: v, setStep: y } = useIBCSwapsFlowContext(), {
    ongoingTransactions: z,
    setCurrentSwapId: ne,
    setOngoingTransactions: ue,
    txnLifecycleHooks: le
  } = useIBCSwapsContext(), he = useMemo(() => Object.values(z).sort((Ee, xe) => xe.timestamp - Ee.timestamp), [z]), ge = useCallback(
    (Ee) => {
      const xe = Object.keys(
        z
      ).filter(($e) => Ee !== $e);
      ue(
        xe.reduce(
          ($e, Ne) => ($e[Ne] = z[Ne], $e),
          {}
        )
      );
    },
    [z, ue]
  ), we = useCallback(
    (Ee) => {
      ue({
        ...z,
        [Ee.id]: {
          ...Ee,
          isComplete: !0
        }
      });
    },
    [z, ue]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapHistoryHeader, { goBack: v }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 overflow-y-auto no-scrollbar h-full flex flex-col", children: he.length > 0 ? he.map((Ee) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      SwapHistoryItem,
      {
        transactionData: Ee,
        onSelectSwap: () => {
          ne(Ee.id), y(1);
        },
        onDeleteSwap: () => {
          ge(Ee.id);
        },
        callbackHooks: le,
        onSwapComplete: we
      },
      Ee.timestamp
    )) : /* @__PURE__ */ jsxRuntimeExports.jsx(ZeroState, {}) })
  ] });
}, AggregatedSwapHistoryView = () => {
  const { goBack: v, setStep: y } = useSwapsFlowContext(), {
    ongoingTransactions: z,
    setCurrentSwapId: ne,
    setOngoingTransactions: ue,
    txnLifecycleHooks: le
  } = useSwapsContext(), he = useMemo(() => Object.values(z).sort((Ee, xe) => xe.timestamp - Ee.timestamp), [z]), ge = useCallback(
    (Ee) => {
      const xe = Object.keys(
        z
      ).filter(($e) => Ee !== $e);
      ue(
        xe.reduce(
          ($e, Ne) => ($e[Ne] = z[Ne], $e),
          {}
        )
      );
    },
    [z, ue]
  ), we = useCallback(
    (Ee) => {
      ue({
        ...z,
        [Ee.id]: {
          ...Ee,
          isComplete: !0
        }
      });
    },
    [z, ue]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapHistoryHeader, { goBack: v }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 overflow-y-auto no-scrollbar h-full flex flex-col", children: he.length > 0 ? he.map((Ee) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      SwapHistoryItem,
      {
        transactionData: Ee,
        onSelectSwap: () => {
          ne(Ee.id), y(1);
        },
        onDeleteSwap: () => {
          ge(Ee.id);
        },
        callbackHooks: le,
        onSwapComplete: we
      },
      Ee.timestamp
    )) : /* @__PURE__ */ jsxRuntimeExports.jsx(ZeroState, {}) })
  ] });
}, SwapRefreshButton = ({ refresh: v, isValidatingRoute: y }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  np,
  {
    variant: "outline",
    size: "sm-icon",
    className: "rounded-xl",
    disabled: y,
    onClick: v,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      A$1,
      {
        weight: "bold",
        size: "1.125rem",
        className: y ? "animate-spin" : ""
      }
    )
  }
), Header$4 = ({ title: v }) => {
  const { setStep: y } = useIBCSwapsFlowContext(), { slippage: z, slippageRemark: ne, setSlippage: ue, refresh: le, isValidatingRoute: he } = useIBCSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-bold", children: v ?? "IBC Swaps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SwapHistoryCTA, { setStep: y }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwapRefreshButton,
        {
          refresh: le,
          isValidatingRoute: he
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwapSettings,
        {
          slippage: z,
          slippageRemark: ne,
          setSlippage: ue
        }
      )
    ] })
  ] });
}, AggregatedHeader = ({ title: v }) => {
  const { setStep: y } = useSwapsFlowContext(), { slippage: z, slippageRemark: ne, setSlippage: ue, refresh: le, isValidatingRoute: he } = useSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-bold", children: v ?? "Swaps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SwapHistoryCTA, { setStep: y }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwapRefreshButton,
        {
          refresh: le,
          isValidatingRoute: he
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwapSettings,
        {
          slippage: z,
          slippageRemark: ne,
          setSlippage: ue
        }
      )
    ] })
  ] });
}, TokenBalance = ({
  classNames: v,
  withMaxButton: y = !1,
  onMaxClick: z,
  compareWithAmount: ne,
  tokenBalance: { data: ue, isLoading: le, isWalletConnected: he }
}) => {
  const ge = useMemo(() => ne && ue && ue.amount.isLessThan(ne) ? "text-destructive" : "", [ne, ue]);
  return he ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("flex items-center gap-2", v), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: Y$1(
          "text-muted-foreground flex items-center gap-1 text-sm transition-colors",
          ge
        ),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Bal:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: le ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "inline-block h-4 w-8" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ue ? /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: formatAmount(ue.amount.toString() ?? 0) }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { side: "top", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              ue.amount.toFixed(
                ue.denomData.coinDecimals
              ) ?? 0,
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-muted-foreground", children: ue.denomData.coinDenom ?? "" })
            ] }) })
          ] }) : "0" }) })
        ]
      }
    ),
    y ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        disabled: ue === void 0,
        variant: "secondary",
        size: "xs",
        className: "rounded-3xl text-xs",
        onClick: () => {
          ue && z && z(ue.amount.toFixed());
        },
        children: "Max"
      }
    ) : null
  ] }) : null;
}, PUBLISH = 0, SUBSCRIBE = 1, RESET = 2, VALUE = 4;
function compose(v, y) {
  return (z) => v(y(z));
}
function thrush(v, y) {
  return y(v);
}
function curry2to1(v, y) {
  return (z) => v(y, z);
}
function curry1to0(v, y) {
  return () => v(y);
}
function tap(v, y) {
  return y(v), v;
}
function tup(...v) {
  return v;
}
function call(v) {
  v();
}
function always(v) {
  return () => v;
}
function joinProc(...v) {
  return () => {
    v.map(call);
  };
}
function isDefined(v) {
  return v !== void 0;
}
function noop() {
}
function subscribe$1(v, y) {
  return v(SUBSCRIBE, y);
}
function publish(v, y) {
  v(PUBLISH, y);
}
function reset(v) {
  v(RESET);
}
function getValue(v) {
  return v(VALUE);
}
function connect(v, y) {
  return subscribe$1(v, curry2to1(y, PUBLISH));
}
function handleNext(v, y) {
  const z = v(SUBSCRIBE, (ne) => {
    z(), y(ne);
  });
  return z;
}
function stream$1() {
  const v = [];
  return (y, z) => {
    switch (y) {
      case RESET:
        v.splice(0, v.length);
        return;
      case SUBSCRIBE:
        return v.push(z), () => {
          const ne = v.indexOf(z);
          ne > -1 && v.splice(ne, 1);
        };
      case PUBLISH:
        v.slice().forEach((ne) => {
          ne(z);
        });
        return;
      default:
        throw new Error(`unrecognized action ${y}`);
    }
  };
}
function statefulStream(v) {
  let y = v;
  const z = stream$1();
  return (ne, ue) => {
    switch (ne) {
      case SUBSCRIBE:
        ue(y);
        break;
      case PUBLISH:
        y = ue;
        break;
      case VALUE:
        return y;
    }
    return z(ne, ue);
  };
}
function eventHandler(v) {
  let y, z;
  const ne = () => y && y();
  return function(ue, le) {
    switch (ue) {
      case SUBSCRIBE:
        return le ? z === le ? void 0 : (ne(), z = le, y = subscribe$1(v, le), y) : (ne(), noop);
      case RESET:
        ne(), z = null;
        return;
      default:
        throw new Error(`unrecognized action ${ue}`);
    }
  };
}
function streamFromEmitter(v) {
  return tap(stream$1(), (y) => connect(v, y));
}
function statefulStreamFromEmitter(v, y) {
  return tap(statefulStream(y), (z) => connect(v, z));
}
function combineOperators(...v) {
  return (y) => v.reduceRight(thrush, y);
}
function pipe(v, ...y) {
  const z = combineOperators(...y);
  return (ne, ue) => {
    switch (ne) {
      case SUBSCRIBE:
        return subscribe$1(v, z(ue));
      case RESET:
        reset(v);
        return;
    }
  };
}
function defaultComparator(v, y) {
  return v === y;
}
function distinctUntilChanged(v = defaultComparator) {
  let y;
  return (z) => (ne) => {
    v(y, ne) || (y = ne, z(ne));
  };
}
function filter(v) {
  return (y) => (z) => {
    v(z) && y(z);
  };
}
function map(v) {
  return (y) => compose(y, v);
}
function mapTo(v) {
  return (y) => () => y(v);
}
function scan(v, y) {
  return (z) => (ne) => z(y = v(y, ne));
}
function skip(v) {
  return (y) => (z) => {
    v > 0 ? v-- : y(z);
  };
}
function throttleTime(v) {
  let y = null, z;
  return (ne) => (ue) => {
    y = ue, !z && (z = setTimeout(() => {
      z = void 0, ne(y);
    }, v));
  };
}
function debounceTime(v) {
  let y, z;
  return (ne) => (ue) => {
    y = ue, z && clearTimeout(z), z = setTimeout(() => {
      ne(y);
    }, v);
  };
}
function withLatestFrom(...v) {
  const y = new Array(v.length);
  let z = 0, ne = null;
  const ue = Math.pow(2, v.length) - 1;
  return v.forEach((le, he) => {
    const ge = Math.pow(2, he);
    subscribe$1(le, (we) => {
      const Ee = z;
      z = z | ge, y[he] = we, Ee !== ue && z === ue && ne && (ne(), ne = null);
    });
  }), (le) => (he) => {
    const ge = () => le([he].concat(y));
    z === ue ? ge() : ne = ge;
  };
}
function merge(...v) {
  return function(y, z) {
    switch (y) {
      case SUBSCRIBE:
        return joinProc(...v.map((ne) => subscribe$1(ne, z)));
      case RESET:
        return;
      default:
        throw new Error(`unrecognized action ${y}`);
    }
  };
}
function duc(v, y = defaultComparator) {
  return pipe(v, distinctUntilChanged(y));
}
function combineLatest(...v) {
  const y = stream$1(), z = new Array(v.length);
  let ne = 0;
  const ue = Math.pow(2, v.length) - 1;
  return v.forEach((le, he) => {
    const ge = Math.pow(2, he);
    subscribe$1(le, (we) => {
      z[he] = we, ne = ne | ge, ne === ue && publish(y, z);
    });
  }), function(le, he) {
    switch (le) {
      case SUBSCRIBE:
        return ne === ue && he(z), subscribe$1(y, he);
      case RESET:
        return reset(y);
      default:
        throw new Error(`unrecognized action ${le}`);
    }
  };
}
function system$1(v, y = [], { singleton: z } = { singleton: !0 }) {
  return {
    id: id(),
    constructor: v,
    dependencies: y,
    singleton: z
  };
}
const id = () => Symbol();
function init(v) {
  const y = /* @__PURE__ */ new Map(), z = ({ id: ne, constructor: ue, dependencies: le, singleton: he }) => {
    if (he && y.has(ne))
      return y.get(ne);
    const ge = ue(le.map((we) => z(we)));
    return he && y.set(ne, ge), ge;
  };
  return z(v);
}
function omit(v, y) {
  const z = {}, ne = {};
  let ue = 0;
  const le = v.length;
  for (; ue < le; )
    ne[v[ue]] = 1, ue += 1;
  for (const he in y)
    ne.hasOwnProperty(he) || (z[he] = y[he]);
  return z;
}
const useIsomorphicLayoutEffect$2 = typeof document < "u" ? a__default.useLayoutEffect : a__default.useEffect;
function systemToComponent(v, y, z) {
  const ne = Object.keys(y.required || {}), ue = Object.keys(y.optional || {}), le = Object.keys(y.methods || {}), he = Object.keys(y.events || {}), ge = a__default.createContext({});
  function we(En, Rn) {
    En.propsReady && publish(En.propsReady, !1);
    for (const wa of ne) {
      const Aa = En[y.required[wa]];
      publish(Aa, Rn[wa]);
    }
    for (const wa of ue)
      if (wa in Rn) {
        const Aa = En[y.optional[wa]];
        publish(Aa, Rn[wa]);
      }
    En.propsReady && publish(En.propsReady, !0);
  }
  function Ee(En) {
    return le.reduce((Rn, wa) => (Rn[wa] = (Aa) => {
      const _a = En[y.methods[wa]];
      publish(_a, Aa);
    }, Rn), {});
  }
  function xe(En) {
    return he.reduce((Rn, wa) => (Rn[wa] = eventHandler(En[y.events[wa]]), Rn), {});
  }
  const $e = a__default.forwardRef((En, Rn) => {
    const { children: wa, ...Aa } = En, [_a] = a__default.useState(() => tap(init(v), (Zn) => we(Zn, Aa))), [Ta] = a__default.useState(curry1to0(xe, _a));
    return useIsomorphicLayoutEffect$2(() => {
      for (const Zn of he)
        Zn in Aa && subscribe$1(Ta[Zn], Aa[Zn]);
      return () => {
        Object.values(Ta).map(reset);
      };
    }, [Aa, Ta, _a]), useIsomorphicLayoutEffect$2(() => {
      we(_a, Aa);
    }), a__default.useImperativeHandle(Rn, always(Ee(_a))), a__default.createElement(
      ge.Provider,
      { value: _a },
      z ? a__default.createElement(
        z,
        omit([...ne, ...ue, ...he], Aa),
        wa
      ) : wa
    );
  }), Ne = (En) => a__default.useCallback(curry2to1(publish, a__default.useContext(ge)[En]), [En]), st = (En) => {
    const wa = a__default.useContext(ge)[En], Aa = a__default.useCallback(
      (_a) => subscribe$1(wa, _a),
      [wa]
    );
    return a__default.useSyncExternalStore(
      Aa,
      () => getValue(wa),
      () => getValue(wa)
    );
  }, Nr = (En) => {
    const wa = a__default.useContext(ge)[En], [Aa, _a] = a__default.useState(curry1to0(getValue, wa));
    return useIsomorphicLayoutEffect$2(
      () => subscribe$1(wa, (Ta) => {
        Ta !== Aa && _a(always(Ta));
      }),
      [wa, Aa]
    ), Aa;
  }, br = a__default.version.startsWith("18") ? st : Nr;
  return {
    Component: $e,
    usePublisher: Ne,
    useEmitterValue: br,
    useEmitter: (En, Rn) => {
      const Aa = a__default.useContext(ge)[En];
      useIsomorphicLayoutEffect$2(() => subscribe$1(Aa, Rn), [Rn, Aa]);
    }
  };
}
const useIsomorphicLayoutEffect = typeof document < "u" ? a__default.useLayoutEffect : a__default.useEffect, useIsomorphicLayoutEffect$1 = useIsomorphicLayoutEffect;
var LogLevel = /* @__PURE__ */ ((v) => (v[v.DEBUG = 0] = "DEBUG", v[v.INFO = 1] = "INFO", v[v.WARN = 2] = "WARN", v[v.ERROR = 3] = "ERROR", v))(LogLevel || {});
const CONSOLE_METHOD_MAP = {
  0: "debug",
  1: "log",
  2: "warn",
  3: "error"
}, getGlobalThis = () => typeof globalThis > "u" ? window : globalThis, loggerSystem = system$1(
  () => {
    const v = statefulStream(
      3
      /* ERROR */
    );
    return {
      log: statefulStream((z, ne, ue = 1) => {
        var le;
        const he = (le = getGlobalThis().VIRTUOSO_LOG_LEVEL) != null ? le : getValue(v);
        ue >= he && console[CONSOLE_METHOD_MAP[ue]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          z,
          ne
        );
      }),
      logLevel: v
    };
  },
  [],
  { singleton: !0 }
);
function useSizeWithElRef(v, y = !0) {
  const z = a__default.useRef(null);
  let ne = (ue) => {
  };
  if (typeof ResizeObserver < "u") {
    const ue = a__default.useMemo(() => new ResizeObserver((le) => {
      const he = le[0].target;
      he.offsetParent !== null && requestAnimationFrame(() => {
        v(he);
      });
    }), [v]);
    ne = (le) => {
      le && y ? (ue.observe(le), z.current = le) : (z.current && ue.unobserve(z.current), z.current = null);
    };
  }
  return { ref: z, callbackRef: ne };
}
function useSize(v, y = !0) {
  return useSizeWithElRef(v, y).callbackRef;
}
function useChangedListContentsSizes(v, y, z, ne, ue, le, he) {
  const ge = a__default.useCallback(
    (we) => {
      const Ee = getChangedChildSizes(we.children, y, "offsetHeight", ue);
      let xe = we.parentElement;
      for (; !xe.dataset.virtuosoScroller; )
        xe = xe.parentElement;
      const $e = xe.lastElementChild.dataset.viewportType === "window", Ne = he ? he.scrollTop : $e ? window.pageYOffset || document.documentElement.scrollTop : xe.scrollTop, st = he ? he.scrollHeight : $e ? document.documentElement.scrollHeight : xe.scrollHeight, Nr = he ? he.offsetHeight : $e ? window.innerHeight : xe.offsetHeight;
      ne({
        scrollTop: Math.max(Ne, 0),
        scrollHeight: st,
        viewportHeight: Nr
      }), le == null || le(resolveGapValue$1("row-gap", getComputedStyle(we).rowGap, ue)), Ee !== null && v(Ee);
    },
    [v, y, ue, le, he, ne]
  );
  return useSizeWithElRef(ge, z);
}
function getChangedChildSizes(v, y, z, ne) {
  const ue = v.length;
  if (ue === 0)
    return null;
  const le = [];
  for (let he = 0; he < ue; he++) {
    const ge = v.item(he);
    if (!ge || ge.dataset.index === void 0)
      continue;
    const we = parseInt(ge.dataset.index), Ee = parseFloat(ge.dataset.knownSize), xe = y(ge, z);
    if (xe === 0 && ne("Zero-sized element, this should not happen", { child: ge }, LogLevel.ERROR), xe === Ee)
      continue;
    const $e = le[le.length - 1];
    le.length === 0 || $e.size !== xe || $e.endIndex !== we - 1 ? le.push({ startIndex: we, endIndex: we, size: xe }) : le[le.length - 1].endIndex++;
  }
  return le;
}
function resolveGapValue$1(v, y, z) {
  return y !== "normal" && !(y != null && y.endsWith("px")) && z(`${v} was not resolved to pixel value correctly`, y, LogLevel.WARN), y === "normal" ? 0 : parseInt(y ?? "0", 10);
}
function correctItemSize(v, y) {
  return Math.round(v.getBoundingClientRect()[y]);
}
function approximatelyEqual(v, y) {
  return Math.abs(v - y) < 1.01;
}
function useScrollTop(v, y, z, ne = noop, ue) {
  const le = a__default.useRef(null), he = a__default.useRef(null), ge = a__default.useRef(null), we = a__default.useCallback(
    ($e) => {
      const Ne = $e.target, st = Ne === window || Ne === document, Nr = st ? window.pageYOffset || document.documentElement.scrollTop : Ne.scrollTop, br = st ? document.documentElement.scrollHeight : Ne.scrollHeight, $n = st ? window.innerHeight : Ne.offsetHeight, En = () => {
        v({
          scrollTop: Math.max(Nr, 0),
          scrollHeight: br,
          viewportHeight: $n
        });
      };
      $e.suppressFlushSync ? En() : Nu__default.flushSync(En), he.current !== null && (Nr === he.current || Nr <= 0 || Nr === br - $n) && (he.current = null, y(!0), ge.current && (clearTimeout(ge.current), ge.current = null));
    },
    [v, y]
  );
  a__default.useEffect(() => {
    const $e = ue || le.current;
    return ne(ue || le.current), we({ target: $e, suppressFlushSync: !0 }), $e.addEventListener("scroll", we, { passive: !0 }), () => {
      ne(null), $e.removeEventListener("scroll", we);
    };
  }, [le, we, z, ne, ue]);
  function Ee($e) {
    const Ne = le.current;
    if (!Ne || "offsetHeight" in Ne && Ne.offsetHeight === 0)
      return;
    const st = $e.behavior === "smooth";
    let Nr, br, $n;
    Ne === window ? (br = Math.max(correctItemSize(document.documentElement, "height"), document.documentElement.scrollHeight), Nr = window.innerHeight, $n = document.documentElement.scrollTop) : (br = Ne.scrollHeight, Nr = correctItemSize(Ne, "height"), $n = Ne.scrollTop);
    const En = br - Nr;
    if ($e.top = Math.ceil(Math.max(Math.min(En, $e.top), 0)), approximatelyEqual(Nr, br) || $e.top === $n) {
      v({ scrollTop: $n, scrollHeight: br, viewportHeight: Nr }), st && y(!0);
      return;
    }
    st ? (he.current = $e.top, ge.current && clearTimeout(ge.current), ge.current = setTimeout(() => {
      ge.current = null, he.current = null, y(!0);
    }, 1e3)) : he.current = null, Ne.scrollTo($e);
  }
  function xe($e) {
    le.current.scrollBy($e);
  }
  return { scrollerRef: le, scrollByCallback: xe, scrollToCallback: Ee };
}
const domIOSystem = system$1(
  () => {
    const v = stream$1(), y = stream$1(), z = statefulStream(0), ne = stream$1(), ue = statefulStream(0), le = stream$1(), he = stream$1(), ge = statefulStream(0), we = statefulStream(0), Ee = statefulStream(0), xe = statefulStream(0), $e = stream$1(), Ne = stream$1(), st = statefulStream(!1);
    return connect(
      pipe(
        v,
        map(({ scrollTop: Nr }) => Nr)
      ),
      y
    ), connect(
      pipe(
        v,
        map(({ scrollHeight: Nr }) => Nr)
      ),
      he
    ), connect(y, ue), {
      // input
      scrollContainerState: v,
      scrollTop: y,
      viewportHeight: le,
      headerHeight: ge,
      fixedHeaderHeight: we,
      fixedFooterHeight: Ee,
      footerHeight: xe,
      scrollHeight: he,
      smoothScrollTargetReached: ne,
      // signals
      scrollTo: $e,
      scrollBy: Ne,
      // state
      statefulScrollTop: ue,
      deviation: z,
      scrollingInProgress: st
    };
  },
  [],
  { singleton: !0 }
), NIL_NODE = { lvl: 0 };
function newAANode(v, y, z, ne = NIL_NODE, ue = NIL_NODE) {
  return { k: v, v: y, lvl: z, l: ne, r: ue };
}
function empty(v) {
  return v === NIL_NODE;
}
function newTree() {
  return NIL_NODE;
}
function remove(v, y) {
  if (empty(v))
    return NIL_NODE;
  const { k: z, l: ne, r: ue } = v;
  if (y === z) {
    if (empty(ne))
      return ue;
    if (empty(ue))
      return ne;
    {
      const [le, he] = last(ne);
      return adjust(clone(v, { k: le, v: he, l: deleteLast(ne) }));
    }
  } else
    return y < z ? adjust(clone(v, { l: remove(ne, y) })) : adjust(clone(v, { r: remove(ue, y) }));
}
function find(v, y) {
  if (!empty(v))
    return y === v.k ? v.v : y < v.k ? find(v.l, y) : find(v.r, y);
}
function findMaxKeyValue(v, y, z = "k") {
  if (empty(v))
    return [-1 / 0, void 0];
  if (Number(v[z]) === y)
    return [v.k, v.v];
  if (Number(v[z]) < y) {
    const ne = findMaxKeyValue(v.r, y, z);
    return ne[0] === -1 / 0 ? [v.k, v.v] : ne;
  }
  return findMaxKeyValue(v.l, y, z);
}
function insert(v, y, z) {
  return empty(v) ? newAANode(y, z, 1) : y === v.k ? clone(v, { k: y, v: z }) : y < v.k ? rebalance(clone(v, { l: insert(v.l, y, z) })) : rebalance(clone(v, { r: insert(v.r, y, z) }));
}
function walkWithin(v, y, z) {
  if (empty(v))
    return [];
  const { k: ne, v: ue, l: le, r: he } = v;
  let ge = [];
  return ne > y && (ge = ge.concat(walkWithin(le, y, z))), ne >= y && ne <= z && ge.push({ k: ne, v: ue }), ne <= z && (ge = ge.concat(walkWithin(he, y, z))), ge;
}
function walk(v) {
  return empty(v) ? [] : [...walk(v.l), { k: v.k, v: v.v }, ...walk(v.r)];
}
function last(v) {
  return empty(v.r) ? [v.k, v.v] : last(v.r);
}
function deleteLast(v) {
  return empty(v.r) ? v.l : adjust(clone(v, { r: deleteLast(v.r) }));
}
function clone(v, y) {
  return newAANode(
    y.k !== void 0 ? y.k : v.k,
    y.v !== void 0 ? y.v : v.v,
    y.lvl !== void 0 ? y.lvl : v.lvl,
    y.l !== void 0 ? y.l : v.l,
    y.r !== void 0 ? y.r : v.r
  );
}
function isSingle(v) {
  return empty(v) || v.lvl > v.r.lvl;
}
function rebalance(v) {
  return split(skew(v));
}
function adjust(v) {
  const { l: y, r: z, lvl: ne } = v;
  if (z.lvl >= ne - 1 && y.lvl >= ne - 1)
    return v;
  if (ne > z.lvl + 1) {
    if (isSingle(y))
      return skew(clone(v, { lvl: ne - 1 }));
    if (!empty(y) && !empty(y.r))
      return clone(y.r, {
        l: clone(y, { r: y.r.l }),
        r: clone(v, {
          l: y.r.r,
          lvl: ne - 1
        }),
        lvl: ne
      });
    throw new Error("Unexpected empty nodes");
  } else {
    if (isSingle(v))
      return split(clone(v, { lvl: ne - 1 }));
    if (!empty(z) && !empty(z.l)) {
      const ue = z.l, le = isSingle(ue) ? z.lvl - 1 : z.lvl;
      return clone(ue, {
        l: clone(v, {
          r: ue.l,
          lvl: ne - 1
        }),
        r: split(clone(z, { l: ue.r, lvl: le })),
        lvl: ue.lvl + 1
      });
    } else
      throw new Error("Unexpected empty nodes");
  }
}
function rangesWithin(v, y, z) {
  if (empty(v))
    return [];
  const ne = findMaxKeyValue(v, y)[0];
  return toRanges(walkWithin(v, ne, z));
}
function arrayToRanges(v, y) {
  const z = v.length;
  if (z === 0)
    return [];
  let { index: ne, value: ue } = y(v[0]);
  const le = [];
  for (let he = 1; he < z; he++) {
    const { index: ge, value: we } = y(v[he]);
    le.push({ start: ne, end: ge - 1, value: ue }), ne = ge, ue = we;
  }
  return le.push({ start: ne, end: 1 / 0, value: ue }), le;
}
function toRanges(v) {
  return arrayToRanges(v, ({ k: y, v: z }) => ({ index: y, value: z }));
}
function split(v) {
  const { r: y, lvl: z } = v;
  return !empty(y) && !empty(y.r) && y.lvl === z && y.r.lvl === z ? clone(y, { l: clone(v, { r: y.l }), lvl: z + 1 }) : v;
}
function skew(v) {
  const { l: y } = v;
  return !empty(y) && y.lvl === v.lvl ? clone(y, { r: clone(v, { l: y.r }) }) : v;
}
function findIndexOfClosestSmallerOrEqual(v, y, z, ne = 0) {
  let ue = v.length - 1;
  for (; ne <= ue; ) {
    const le = Math.floor((ne + ue) / 2), he = v[le], ge = z(he, y);
    if (ge === 0)
      return le;
    if (ge === -1) {
      if (ue - ne < 2)
        return le - 1;
      ue = le - 1;
    } else {
      if (ue === ne)
        return le;
      ne = le + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${v.join(",")}, searched for ${y}`);
}
function findClosestSmallerOrEqual(v, y, z) {
  return v[findIndexOfClosestSmallerOrEqual(v, y, z)];
}
function findRange(v, y, z, ne) {
  const ue = findIndexOfClosestSmallerOrEqual(v, y, ne), le = findIndexOfClosestSmallerOrEqual(v, z, ne, ue);
  return v.slice(ue, le + 1);
}
const recalcSystem = system$1(
  () => ({ recalcInProgress: statefulStream(!1) }),
  [],
  { singleton: !0 }
);
function rangeIncludes(v) {
  const { size: y, startIndex: z, endIndex: ne } = v;
  return (ue) => ue.start === z && (ue.end === ne || ue.end === 1 / 0) && ue.value === y;
}
function affectedGroupCount(v, y) {
  let z = 0, ne = 0;
  for (; z < v; )
    z += y[ne + 1] - y[ne] - 1, ne++;
  return ne - (z === v ? 0 : 1);
}
function insertRanges(v, y) {
  let z = empty(v) ? 0 : 1 / 0;
  for (const ne of y) {
    const { size: ue, startIndex: le, endIndex: he } = ne;
    if (z = Math.min(z, le), empty(v)) {
      v = insert(v, 0, ue);
      continue;
    }
    const ge = rangesWithin(v, le - 1, he + 1);
    if (ge.some(rangeIncludes(ne)))
      continue;
    let we = !1, Ee = !1;
    for (const { start: xe, end: $e, value: Ne } of ge)
      we ? (he >= xe || ue === Ne) && (v = remove(v, xe)) : (Ee = Ne !== ue, we = !0), $e > he && he >= xe && Ne !== ue && (v = insert(v, he + 1, Ne));
    Ee && (v = insert(v, le, ue));
  }
  return [v, z];
}
function initialSizeState() {
  return {
    offsetTree: [],
    sizeTree: newTree(),
    groupOffsetTree: newTree(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function indexComparator({ index: v }, y) {
  return y === v ? 0 : y < v ? -1 : 1;
}
function offsetComparator({ offset: v }, y) {
  return y === v ? 0 : y < v ? -1 : 1;
}
function offsetPointParser(v) {
  return { index: v.index, value: v };
}
function rangesWithinOffsets(v, y, z, ne = 0) {
  return ne > 0 && (y = Math.max(y, findClosestSmallerOrEqual(v, ne, indexComparator).offset)), arrayToRanges(findRange(v, y, z, offsetComparator), offsetPointParser);
}
function createOffsetTree(v, y, z, ne) {
  let ue = v, le = 0, he = 0, ge = 0, we = 0;
  if (y !== 0) {
    we = findIndexOfClosestSmallerOrEqual(ue, y - 1, indexComparator), ge = ue[we].offset;
    const xe = findMaxKeyValue(z, y - 1);
    le = xe[0], he = xe[1], ue.length && ue[we].size === findMaxKeyValue(z, y)[1] && (we -= 1), ue = ue.slice(0, we + 1);
  } else
    ue = [];
  for (const { start: Ee, value: xe } of rangesWithin(z, y, 1 / 0)) {
    const $e = Ee - le, Ne = $e * he + ge + $e * ne;
    ue.push({
      offset: Ne,
      size: xe,
      index: Ee
    }), le = Ee, ge = Ne, he = xe;
  }
  return {
    offsetTree: ue,
    lastIndex: le,
    lastOffset: ge,
    lastSize: he
  };
}
function sizeStateReducer(v, [y, z, ne, ue]) {
  y.length > 0 && ne("received item sizes", y, LogLevel.DEBUG);
  const le = v.sizeTree;
  let he = le, ge = 0;
  if (z.length > 0 && empty(le) && y.length === 2) {
    const Ne = y[0].size, st = y[1].size;
    he = z.reduce((Nr, br) => insert(insert(Nr, br, Ne), br + 1, st), he);
  } else
    [he, ge] = insertRanges(he, y);
  if (he === le)
    return v;
  const { offsetTree: we, lastIndex: Ee, lastSize: xe, lastOffset: $e } = createOffsetTree(v.offsetTree, ge, he, ue);
  return {
    sizeTree: he,
    offsetTree: we,
    lastIndex: Ee,
    lastOffset: $e,
    lastSize: xe,
    groupOffsetTree: z.reduce((Ne, st) => insert(Ne, st, offsetOf(st, we, ue)), newTree()),
    groupIndices: z
  };
}
function offsetOf(v, y, z) {
  if (y.length === 0)
    return 0;
  const { offset: ne, index: ue, size: le } = findClosestSmallerOrEqual(y, v, indexComparator), he = v - ue, ge = le * he + (he - 1) * z + ne;
  return ge > 0 ? ge + z : ge;
}
function isGroupLocation(v) {
  return typeof v.groupIndex < "u";
}
function originalIndexFromLocation(v, y, z) {
  if (isGroupLocation(v))
    return y.groupIndices[v.groupIndex] + 1;
  {
    const ne = v.index === "LAST" ? z : v.index;
    let ue = originalIndexFromItemIndex(ne, y);
    return ue = Math.max(0, ue, Math.min(z, ue)), ue;
  }
}
function originalIndexFromItemIndex(v, y) {
  if (!hasGroups(y))
    return v;
  let z = 0;
  for (; y.groupIndices[z] <= v + z; )
    z++;
  return v + z;
}
function hasGroups(v) {
  return !empty(v.groupOffsetTree);
}
function sizeTreeToRanges(v) {
  return walk(v).map(({ k: y, v: z }, ne, ue) => {
    const le = ue[ne + 1], he = le ? le.k - 1 : 1 / 0;
    return { startIndex: y, endIndex: he, size: z };
  });
}
const SIZE_MAP = {
  offsetHeight: "height",
  offsetWidth: "width"
}, sizeSystem = system$1(
  ([{ log: v }, { recalcInProgress: y }]) => {
    const z = stream$1(), ne = stream$1(), ue = statefulStreamFromEmitter(ne, 0), le = stream$1(), he = stream$1(), ge = statefulStream(0), we = statefulStream([]), Ee = statefulStream(void 0), xe = statefulStream(void 0), $e = statefulStream((_a, Ta) => correctItemSize(_a, SIZE_MAP[Ta])), Ne = statefulStream(void 0), st = statefulStream(0), Nr = initialSizeState(), br = statefulStreamFromEmitter(
      pipe(z, withLatestFrom(we, v, st), scan(sizeStateReducer, Nr), distinctUntilChanged()),
      Nr
    ), $n = statefulStreamFromEmitter(
      pipe(
        we,
        distinctUntilChanged(),
        scan((_a, Ta) => ({ prev: _a.current, current: Ta }), {
          prev: [],
          current: []
        }),
        map(({ prev: _a }) => _a)
      ),
      []
    );
    connect(
      pipe(
        we,
        filter((_a) => _a.length > 0),
        withLatestFrom(br, st),
        map(([_a, Ta, Zn]) => {
          const Ra = _a.reduce((Yn, $o, ct) => insert(Yn, $o, offsetOf($o, Ta.offsetTree, Zn) || ct), newTree());
          return {
            ...Ta,
            groupIndices: _a,
            groupOffsetTree: Ra
          };
        })
      ),
      br
    ), connect(
      pipe(
        ne,
        withLatestFrom(br),
        filter(([_a, { lastIndex: Ta }]) => _a < Ta),
        map(([_a, { lastIndex: Ta, lastSize: Zn }]) => [
          {
            startIndex: _a,
            endIndex: Ta,
            size: Zn
          }
        ])
      ),
      z
    ), connect(Ee, xe);
    const En = statefulStreamFromEmitter(
      pipe(
        Ee,
        map((_a) => _a === void 0)
      ),
      !0
    );
    connect(
      pipe(
        xe,
        filter((_a) => _a !== void 0 && empty(getValue(br).sizeTree)),
        map((_a) => [{ startIndex: 0, endIndex: 0, size: _a }])
      ),
      z
    );
    const Rn = streamFromEmitter(
      pipe(
        z,
        withLatestFrom(br),
        scan(
          ({ sizes: _a }, [Ta, Zn]) => ({
            changed: Zn !== _a,
            sizes: Zn
          }),
          { changed: !1, sizes: Nr }
        ),
        map((_a) => _a.changed)
      )
    );
    subscribe$1(
      pipe(
        ge,
        scan(
          (_a, Ta) => ({ diff: _a.prev - Ta, prev: Ta }),
          { diff: 0, prev: 0 }
        ),
        map((_a) => _a.diff)
      ),
      (_a) => {
        const { groupIndices: Ta } = getValue(br);
        if (_a > 0)
          publish(y, !0), publish(le, _a + affectedGroupCount(_a, Ta));
        else if (_a < 0) {
          const Zn = getValue($n);
          Zn.length > 0 && (_a -= affectedGroupCount(-_a, Zn)), publish(he, _a);
        }
      }
    ), subscribe$1(pipe(ge, withLatestFrom(v)), ([_a, Ta]) => {
      _a < 0 && Ta(
        "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
        { firstItemIndex: ge },
        LogLevel.ERROR
      );
    });
    const wa = streamFromEmitter(le);
    connect(
      pipe(
        le,
        withLatestFrom(br),
        map(([_a, Ta]) => {
          const Zn = Ta.groupIndices.length > 0, Ra = [], Yn = Ta.lastSize;
          if (Zn) {
            const $o = find(Ta.sizeTree, 0);
            let ct = 0, fe = 0;
            for (; ct < _a; ) {
              const Se = Ta.groupIndices[fe], Oe = Ta.groupIndices.length === fe + 1 ? 1 / 0 : Ta.groupIndices[fe + 1] - Se - 1;
              Ra.push({
                startIndex: Se,
                endIndex: Se,
                size: $o
              }), Ra.push({
                startIndex: Se + 1,
                endIndex: Se + 1 + Oe - 1,
                size: Yn
              }), fe++, ct += Oe + 1;
            }
            const be = walk(Ta.sizeTree);
            return ct !== _a && be.shift(), be.reduce(
              (Se, { k: Oe, v: Fr }) => {
                let zn = Se.ranges;
                return Se.prevSize !== 0 && (zn = [
                  ...Se.ranges,
                  {
                    startIndex: Se.prevIndex,
                    endIndex: Oe + _a - 1,
                    size: Se.prevSize
                  }
                ]), {
                  ranges: zn,
                  prevIndex: Oe + _a,
                  prevSize: Fr
                };
              },
              {
                ranges: Ra,
                prevIndex: _a,
                prevSize: 0
              }
            ).ranges;
          }
          return walk(Ta.sizeTree).reduce(
            ($o, { k: ct, v: fe }) => ({
              ranges: [...$o.ranges, { startIndex: $o.prevIndex, endIndex: ct + _a - 1, size: $o.prevSize }],
              prevIndex: ct + _a,
              prevSize: fe
            }),
            {
              ranges: [],
              prevIndex: 0,
              prevSize: Yn
            }
          ).ranges;
        })
      ),
      z
    );
    const Aa = streamFromEmitter(
      pipe(
        he,
        withLatestFrom(br, st),
        map(([_a, { offsetTree: Ta }, Zn]) => {
          const Ra = -_a;
          return offsetOf(Ra, Ta, Zn);
        })
      )
    );
    return connect(
      pipe(
        he,
        withLatestFrom(br, st),
        map(([_a, Ta, Zn]) => {
          if (Ta.groupIndices.length > 0) {
            if (empty(Ta.sizeTree))
              return Ta;
            let Yn = newTree();
            const $o = getValue($n);
            let ct = 0, fe = 0, be = 0;
            for (; ct < -_a; ) {
              be = $o[fe];
              const Se = $o[fe + 1] - be - 1;
              fe++, ct += Se + 1;
            }
            if (Yn = walk(Ta.sizeTree).reduce((Se, { k: Oe, v: Fr }) => insert(Se, Math.max(0, Oe + _a), Fr), Yn), ct !== -_a) {
              const Se = find(Ta.sizeTree, be);
              Yn = insert(Yn, 0, Se);
              const Oe = findMaxKeyValue(Ta.sizeTree, -_a + 1)[1];
              Yn = insert(Yn, 1, Oe);
            }
            return {
              ...Ta,
              sizeTree: Yn,
              ...createOffsetTree(Ta.offsetTree, 0, Yn, Zn)
            };
          } else {
            const Yn = walk(Ta.sizeTree).reduce(($o, { k: ct, v: fe }) => insert($o, Math.max(0, ct + _a), fe), newTree());
            return {
              ...Ta,
              sizeTree: Yn,
              ...createOffsetTree(Ta.offsetTree, 0, Yn, Zn)
            };
          }
        })
      ),
      br
    ), {
      // input
      data: Ne,
      totalCount: ne,
      sizeRanges: z,
      groupIndices: we,
      defaultItemSize: xe,
      fixedItemSize: Ee,
      unshiftWith: le,
      shiftWith: he,
      shiftWithOffset: Aa,
      beforeUnshiftWith: wa,
      firstItemIndex: ge,
      gap: st,
      // output
      sizes: br,
      listRefresh: Rn,
      statefulTotalCount: ue,
      trackItemSizes: En,
      itemSize: $e
    };
  },
  tup(loggerSystem, recalcSystem),
  { singleton: !0 }
), SUPPORTS_SCROLL_TO_OPTIONS = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function normalizeIndexLocation(v) {
  const y = typeof v == "number" ? { index: v } : v;
  return y.align || (y.align = "start"), (!y.behavior || !SUPPORTS_SCROLL_TO_OPTIONS) && (y.behavior = "auto"), y.offset || (y.offset = 0), y;
}
const scrollToIndexSystem = system$1(
  ([
    { sizes: v, totalCount: y, listRefresh: z, gap: ne },
    {
      scrollingInProgress: ue,
      viewportHeight: le,
      scrollTo: he,
      smoothScrollTargetReached: ge,
      headerHeight: we,
      footerHeight: Ee,
      fixedHeaderHeight: xe,
      fixedFooterHeight: $e
    },
    { log: Ne }
  ]) => {
    const st = stream$1(), Nr = stream$1(), br = statefulStream(0);
    let $n = null, En = null, Rn = null;
    function wa() {
      $n && ($n(), $n = null), Rn && (Rn(), Rn = null), En && (clearTimeout(En), En = null), publish(ue, !1);
    }
    return connect(
      pipe(
        st,
        withLatestFrom(v, le, y, br, we, Ee, Ne),
        withLatestFrom(ne, xe, $e),
        map(
          ([
            [Aa, _a, Ta, Zn, Ra, Yn, $o, ct],
            fe,
            be,
            ye
          ]) => {
            const Se = normalizeIndexLocation(Aa), { align: Oe, behavior: Fr, offset: zn } = Se, Fe = Zn - 1, pe = originalIndexFromLocation(Se, _a, Fe);
            let it = offsetOf(pe, _a.offsetTree, fe) + Yn;
            Oe === "end" ? (it += be + findMaxKeyValue(_a.sizeTree, pe)[1] - Ta + ye, pe === Fe && (it += $o)) : Oe === "center" ? it += (be + findMaxKeyValue(_a.sizeTree, pe)[1] - Ta + ye) / 2 : it -= Ra, zn && (it += zn);
            const xa = (wo) => {
              wa(), wo ? (ct("retrying to scroll to", { location: Aa }, LogLevel.DEBUG), publish(st, Aa)) : (publish(Nr, !0), ct("list did not change, scroll successful", {}, LogLevel.DEBUG));
            };
            if (wa(), Fr === "smooth") {
              let wo = !1;
              Rn = subscribe$1(z, (_u) => {
                wo = wo || _u;
              }), $n = handleNext(ge, () => {
                xa(wo);
              });
            } else
              $n = handleNext(pipe(z, watchChangesFor(150)), xa);
            return En = setTimeout(() => {
              wa();
            }, 1200), publish(ue, !0), ct("scrolling from index to", { index: pe, top: it, behavior: Fr }, LogLevel.DEBUG), { top: it, behavior: Fr };
          }
        )
      ),
      he
    ), {
      scrollToIndex: st,
      scrollTargetReached: Nr,
      topListHeight: br
    };
  },
  tup(sizeSystem, domIOSystem, loggerSystem),
  { singleton: !0 }
);
function watchChangesFor(v) {
  return (y) => {
    const z = setTimeout(() => {
      y(!1);
    }, v);
    return (ne) => {
      ne && (y(!0), clearTimeout(z));
    };
  };
}
const UP = "up", DOWN = "down", NONE$1 = "none", INITIAL_BOTTOM_STATE = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
}, DEFAULT_AT_TOP_THRESHOLD = 0, stateFlagsSystem = system$1(([{ scrollContainerState: v, scrollTop: y, viewportHeight: z, headerHeight: ne, footerHeight: ue, scrollBy: le }]) => {
  const he = statefulStream(!1), ge = statefulStream(!0), we = stream$1(), Ee = stream$1(), xe = statefulStream(4), $e = statefulStream(DEFAULT_AT_TOP_THRESHOLD), Ne = statefulStreamFromEmitter(
    pipe(
      merge(pipe(duc(y), skip(1), mapTo(!0)), pipe(duc(y), skip(1), mapTo(!1), debounceTime(100))),
      distinctUntilChanged()
    ),
    !1
  ), st = statefulStreamFromEmitter(
    pipe(merge(pipe(le, mapTo(!0)), pipe(le, mapTo(!1), debounceTime(200))), distinctUntilChanged()),
    !1
  );
  connect(
    pipe(
      combineLatest(duc(y), duc($e)),
      map(([Rn, wa]) => Rn <= wa),
      distinctUntilChanged()
    ),
    ge
  ), connect(pipe(ge, throttleTime(50)), Ee);
  const Nr = streamFromEmitter(
    pipe(
      combineLatest(v, duc(z), duc(ne), duc(ue), duc(xe)),
      scan((Rn, [{ scrollTop: wa, scrollHeight: Aa }, _a, Ta, Zn, Ra]) => {
        const Yn = wa + _a - Aa > -Ra, $o = {
          viewportHeight: _a,
          scrollTop: wa,
          scrollHeight: Aa
        };
        if (Yn) {
          let fe, be;
          return wa > Rn.state.scrollTop ? (fe = "SCROLLED_DOWN", be = Rn.state.scrollTop - wa) : (fe = "SIZE_DECREASED", be = Rn.state.scrollTop - wa || Rn.scrollTopDelta), {
            atBottom: !0,
            state: $o,
            atBottomBecause: fe,
            scrollTopDelta: be
          };
        }
        let ct;
        return $o.scrollHeight > Rn.state.scrollHeight ? ct = "SIZE_INCREASED" : _a < Rn.state.viewportHeight ? ct = "VIEWPORT_HEIGHT_DECREASING" : wa < Rn.state.scrollTop ? ct = "SCROLLING_UPWARDS" : ct = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: ct,
          state: $o
        };
      }, INITIAL_BOTTOM_STATE),
      distinctUntilChanged((Rn, wa) => Rn && Rn.atBottom === wa.atBottom)
    )
  ), br = statefulStreamFromEmitter(
    pipe(
      v,
      scan(
        (Rn, { scrollTop: wa, scrollHeight: Aa, viewportHeight: _a }) => {
          if (approximatelyEqual(Rn.scrollHeight, Aa))
            return {
              scrollTop: wa,
              scrollHeight: Aa,
              jump: 0,
              changed: !1
            };
          {
            const Ta = Aa - (wa + _a) < 1;
            return Rn.scrollTop !== wa && Ta ? {
              scrollHeight: Aa,
              scrollTop: wa,
              jump: Rn.scrollTop - wa,
              changed: !0
            } : {
              scrollHeight: Aa,
              scrollTop: wa,
              jump: 0,
              changed: !0
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: !1 }
      ),
      filter((Rn) => Rn.changed),
      map((Rn) => Rn.jump)
    ),
    0
  );
  connect(
    pipe(
      Nr,
      map((Rn) => Rn.atBottom)
    ),
    he
  ), connect(pipe(he, throttleTime(50)), we);
  const $n = statefulStream(DOWN);
  connect(
    pipe(
      v,
      map(({ scrollTop: Rn }) => Rn),
      distinctUntilChanged(),
      scan(
        (Rn, wa) => getValue(st) ? { direction: Rn.direction, prevScrollTop: wa } : { direction: wa < Rn.prevScrollTop ? UP : DOWN, prevScrollTop: wa },
        { direction: DOWN, prevScrollTop: 0 }
      ),
      map((Rn) => Rn.direction)
    ),
    $n
  ), connect(pipe(v, throttleTime(50), mapTo(NONE$1)), $n);
  const En = statefulStream(0);
  return connect(
    pipe(
      Ne,
      filter((Rn) => !Rn),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      mapTo(0)
    ),
    En
  ), connect(
    pipe(
      y,
      throttleTime(100),
      withLatestFrom(Ne),
      filter(([Rn, wa]) => !!wa),
      scan(([Rn, wa], [Aa]) => [wa, Aa], [0, 0]),
      map(([Rn, wa]) => wa - Rn)
    ),
    En
  ), {
    isScrolling: Ne,
    isAtTop: ge,
    isAtBottom: he,
    atBottomState: Nr,
    atTopStateChange: Ee,
    atBottomStateChange: we,
    scrollDirection: $n,
    atBottomThreshold: xe,
    atTopThreshold: $e,
    scrollVelocity: En,
    lastJumpDueToItemResize: br
  };
}, tup(domIOSystem)), propsReadySystem = system$1(
  ([{ log: v }]) => {
    const y = statefulStream(!1), z = streamFromEmitter(
      pipe(
        y,
        filter((ne) => ne),
        distinctUntilChanged()
      )
    );
    return subscribe$1(y, (ne) => {
      ne && getValue(v)("props updated", {}, LogLevel.DEBUG);
    }), { propsReady: y, didMount: z };
  },
  tup(loggerSystem),
  { singleton: !0 }
);
function skipFrames(v, y) {
  v == 0 ? y() : requestAnimationFrame(() => skipFrames(v - 1, y));
}
function getInitialTopMostItemIndexNumber(v, y) {
  const z = y - 1;
  return typeof v == "number" ? v : v.index === "LAST" ? z : v.index;
}
const initialTopMostItemIndexSystem = system$1(
  ([{ sizes: v, listRefresh: y, defaultItemSize: z }, { scrollTop: ne }, { scrollToIndex: ue, scrollTargetReached: le }, { didMount: he }]) => {
    const ge = statefulStream(!0), we = statefulStream(0), Ee = statefulStream(!0);
    return connect(
      pipe(
        he,
        withLatestFrom(we),
        filter(([xe, $e]) => !!$e),
        mapTo(!1)
      ),
      ge
    ), connect(
      pipe(
        he,
        withLatestFrom(we),
        filter(([xe, $e]) => !!$e),
        mapTo(!1)
      ),
      Ee
    ), subscribe$1(
      pipe(
        combineLatest(y, he),
        withLatestFrom(ge, v, z, Ee),
        filter(([[, xe], $e, { sizeTree: Ne }, st, Nr]) => xe && (!empty(Ne) || isDefined(st)) && !$e && !Nr),
        withLatestFrom(we)
      ),
      ([, xe]) => {
        handleNext(le, () => {
          publish(Ee, !0);
        }), skipFrames(3, () => {
          handleNext(ne, () => {
            publish(ge, !0);
          }), publish(ue, xe);
        });
      }
    ), {
      scrolledToInitialItem: ge,
      initialTopMostItemIndex: we,
      initialItemFinalLocationReached: Ee
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem),
  { singleton: !0 }
);
function normalizeFollowOutput(v) {
  return v ? v === "smooth" ? "smooth" : "auto" : !1;
}
const behaviorFromFollowOutput = (v, y) => typeof v == "function" ? normalizeFollowOutput(v(y)) : y && normalizeFollowOutput(v), followOutputSystem = system$1(
  ([
    { totalCount: v, listRefresh: y },
    { isAtBottom: z, atBottomState: ne },
    { scrollToIndex: ue },
    { scrolledToInitialItem: le },
    { propsReady: he, didMount: ge },
    { log: we },
    { scrollingInProgress: Ee }
  ]) => {
    const xe = statefulStream(!1), $e = stream$1();
    let Ne = null;
    function st(br) {
      publish(ue, {
        index: "LAST",
        align: "end",
        behavior: br
      });
    }
    subscribe$1(
      pipe(
        combineLatest(pipe(duc(v), skip(1)), ge),
        withLatestFrom(duc(xe), z, le, Ee),
        map(([[br, $n], En, Rn, wa, Aa]) => {
          let _a = $n && wa, Ta = "auto";
          return _a && (Ta = behaviorFromFollowOutput(En, Rn || Aa), _a = _a && !!Ta), { totalCount: br, shouldFollow: _a, followOutputBehavior: Ta };
        }),
        filter(({ shouldFollow: br }) => br)
      ),
      ({ totalCount: br, followOutputBehavior: $n }) => {
        Ne && (Ne(), Ne = null), Ne = handleNext(y, () => {
          getValue(we)("following output to ", { totalCount: br }, LogLevel.DEBUG), st($n), Ne = null;
        });
      }
    );
    function Nr(br) {
      const $n = handleNext(ne, (En) => {
        br && !En.atBottom && En.notAtBottomBecause === "SIZE_INCREASED" && !Ne && (getValue(we)("scrolling to bottom due to increased size", {}, LogLevel.DEBUG), st("auto"));
      });
      setTimeout($n, 100);
    }
    return subscribe$1(
      pipe(
        combineLatest(duc(xe), v, he),
        filter(([br, , $n]) => br && $n),
        scan(
          ({ value: br }, [, $n]) => ({ refreshed: br === $n, value: $n }),
          { refreshed: !1, value: 0 }
        ),
        filter(({ refreshed: br }) => br),
        withLatestFrom(xe, v)
      ),
      ([, br]) => {
        getValue(le) && Nr(br !== !1);
      }
    ), subscribe$1($e, () => {
      Nr(getValue(xe) !== !1);
    }), subscribe$1(combineLatest(duc(xe), ne), ([br, $n]) => {
      br && !$n.atBottom && $n.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && st("auto");
    }), { followOutput: xe, autoscrollToBottom: $e };
  },
  tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem)
);
function groupCountsToIndicesAndCount(v) {
  return v.reduce(
    (y, z) => (y.groupIndices.push(y.totalCount), y.totalCount += z + 1, y),
    {
      totalCount: 0,
      groupIndices: []
    }
  );
}
const groupedListSystem = system$1(([{ totalCount: v, groupIndices: y, sizes: z }, { scrollTop: ne, headerHeight: ue }]) => {
  const le = stream$1(), he = stream$1(), ge = streamFromEmitter(pipe(le, map(groupCountsToIndicesAndCount)));
  return connect(
    pipe(
      ge,
      map((we) => we.totalCount)
    ),
    v
  ), connect(
    pipe(
      ge,
      map((we) => we.groupIndices)
    ),
    y
  ), connect(
    pipe(
      combineLatest(ne, z, ue),
      filter(([we, Ee]) => hasGroups(Ee)),
      map(([we, Ee, xe]) => findMaxKeyValue(Ee.groupOffsetTree, Math.max(we - xe, 0), "v")[0]),
      distinctUntilChanged(),
      map((we) => [we])
    ),
    he
  ), { groupCounts: le, topItemsIndexes: he };
}, tup(sizeSystem, domIOSystem));
function tupleComparator(v, y) {
  return !!(v && v[0] === y[0] && v[1] === y[1]);
}
function rangeComparator(v, y) {
  return !!(v && v.startIndex === y.startIndex && v.endIndex === y.endIndex);
}
const TOP = "top", BOTTOM = "bottom", NONE = "none";
function getOverscan(v, y, z) {
  return typeof v == "number" ? z === UP && y === TOP || z === DOWN && y === BOTTOM ? v : 0 : z === UP ? y === TOP ? v.main : v.reverse : y === BOTTOM ? v.main : v.reverse;
}
function getViewportIncrease(v, y) {
  return typeof v == "number" ? v : v[y] || 0;
}
const sizeRangeSystem = system$1(
  ([{ scrollTop: v, viewportHeight: y, deviation: z, headerHeight: ne, fixedHeaderHeight: ue }]) => {
    const le = stream$1(), he = statefulStream(0), ge = statefulStream(0), we = statefulStream(0), Ee = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          duc(v),
          duc(y),
          duc(ne),
          duc(le, tupleComparator),
          duc(we),
          duc(he),
          duc(ue),
          duc(z),
          duc(ge)
        ),
        map(
          ([
            xe,
            $e,
            Ne,
            [st, Nr],
            br,
            $n,
            En,
            Rn,
            wa
          ]) => {
            const Aa = xe - Rn, _a = $n + En, Ta = Math.max(Ne - Aa, 0);
            let Zn = NONE;
            const Ra = getViewportIncrease(wa, TOP), Yn = getViewportIncrease(wa, BOTTOM);
            return st -= Rn, st += Ne + En, Nr += Ne + En, Nr -= Rn, st > xe + _a - Ra && (Zn = UP), Nr < xe - Ta + $e + Yn && (Zn = DOWN), Zn !== NONE ? [
              Math.max(Aa - Ne - getOverscan(br, TOP, Zn) - Ra, 0),
              Aa - Ta - En + $e + getOverscan(br, BOTTOM, Zn) + Yn
            ] : null;
          }
        ),
        filter((xe) => xe != null),
        distinctUntilChanged(tupleComparator)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary: le,
      overscan: we,
      topListHeight: he,
      increaseViewportBy: ge,
      // output
      visibleRange: Ee
    };
  },
  tup(domIOSystem),
  { singleton: !0 }
);
function probeItemSet(v, y, z) {
  if (hasGroups(y)) {
    const ne = originalIndexFromItemIndex(v, y);
    return [
      { index: findMaxKeyValue(y.groupOffsetTree, ne)[0], size: 0, offset: 0 },
      { index: ne, size: 0, offset: 0, data: z && z[0] }
    ];
  }
  return [{ index: v, size: 0, offset: 0, data: z && z[0] }];
}
const EMPTY_LIST_STATE = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function transposeItems(v, y, z) {
  if (v.length === 0)
    return [];
  if (!hasGroups(y))
    return v.map((Ee) => ({ ...Ee, index: Ee.index + z, originalIndex: Ee.index }));
  const ne = v[0].index, ue = v[v.length - 1].index, le = [], he = rangesWithin(y.groupOffsetTree, ne, ue);
  let ge, we = 0;
  for (const Ee of v) {
    (!ge || ge.end < Ee.index) && (ge = he.shift(), we = y.groupIndices.indexOf(ge.start));
    let xe;
    Ee.index === ge.start ? xe = {
      type: "group",
      index: we
    } : xe = {
      index: Ee.index - (we + 1) + z,
      groupIndex: we
    }, le.push({
      ...xe,
      size: Ee.size,
      offset: Ee.offset,
      originalIndex: Ee.index,
      data: Ee.data
    });
  }
  return le;
}
function buildListState(v, y, z, ne, ue, le) {
  const { lastSize: he, lastOffset: ge, lastIndex: we } = ue;
  let Ee = 0, xe = 0;
  if (v.length > 0) {
    Ee = v[0].offset;
    const br = v[v.length - 1];
    xe = br.offset + br.size;
  }
  const $e = z - we, Ne = ge + $e * he + ($e - 1) * ne, st = Ee, Nr = Ne - xe;
  return {
    items: transposeItems(v, ue, le),
    topItems: transposeItems(y, ue, le),
    topListHeight: y.reduce((br, $n) => $n.size + br, 0),
    offsetTop: Ee,
    offsetBottom: Nr,
    top: st,
    bottom: xe,
    totalCount: z,
    firstItemIndex: le
  };
}
function buildListStateFromItemCount(v, y, z, ne, ue, le) {
  let he = 0;
  if (z.groupIndices.length > 0)
    for (const xe of z.groupIndices) {
      if (xe - he >= v)
        break;
      he++;
    }
  const ge = v + he, we = getInitialTopMostItemIndexNumber(y, ge), Ee = Array.from({ length: ge }).map((xe, $e) => ({
    index: $e + we,
    size: 0,
    offset: 0,
    data: le[$e + we]
  }));
  return buildListState(Ee, [], ge, ue, z, ne);
}
const listStateSystem = system$1(
  ([
    { sizes: v, totalCount: y, data: z, firstItemIndex: ne, gap: ue },
    le,
    { visibleRange: he, listBoundary: ge, topListHeight: we },
    { scrolledToInitialItem: Ee, initialTopMostItemIndex: xe },
    { topListHeight: $e },
    Ne,
    { didMount: st },
    { recalcInProgress: Nr }
  ]) => {
    const br = statefulStream([]), $n = statefulStream(0), En = stream$1();
    connect(le.topItemsIndexes, br);
    const Rn = statefulStreamFromEmitter(
      pipe(
        combineLatest(
          st,
          Nr,
          duc(he, tupleComparator),
          duc(y),
          duc(v),
          duc(xe),
          Ee,
          duc(br),
          duc(ne),
          duc(ue),
          z
        ),
        filter(([Ta, Zn, , Ra, , , , , , , Yn]) => {
          const $o = Yn && Yn.length !== Ra;
          return Ta && !Zn && !$o;
        }),
        map(
          ([
            ,
            ,
            [Ta, Zn],
            Ra,
            Yn,
            $o,
            ct,
            fe,
            be,
            ye,
            Se
          ]) => {
            const Oe = Yn, { sizeTree: Fr, offsetTree: zn } = Oe, Fe = getValue($n);
            if (Ra === 0)
              return { ...EMPTY_LIST_STATE, totalCount: Ra };
            if (Ta === 0 && Zn === 0)
              return Fe === 0 ? { ...EMPTY_LIST_STATE, totalCount: Ra } : buildListStateFromItemCount(Fe, $o, Yn, be, ye, Se || []);
            if (empty(Fr))
              return Fe > 0 ? null : buildListState(
                probeItemSet(getInitialTopMostItemIndexNumber($o, Ra), Oe, Se),
                [],
                Ra,
                ye,
                Oe,
                be
              );
            const pe = [];
            if (fe.length > 0) {
              const Oa = fe[0], Os = fe[fe.length - 1];
              let Pa = 0;
              for (const Ml of rangesWithin(Fr, Oa, Os)) {
                const Su = Ml.value, Tu = Math.max(Ml.start, Oa), Au = Math.min(Ml.end, Os);
                for (let Zl = Tu; Zl <= Au; Zl++)
                  pe.push({ index: Zl, size: Su, offset: Pa, data: Se && Se[Zl] }), Pa += Su;
              }
            }
            if (!ct)
              return buildListState([], pe, Ra, ye, Oe, be);
            const it = fe.length > 0 ? fe[fe.length - 1] + 1 : 0, xa = rangesWithinOffsets(zn, Ta, Zn, it);
            if (xa.length === 0)
              return null;
            const wo = Ra - 1, _u = tap([], (Oa) => {
              for (const Os of xa) {
                const Pa = Os.value;
                let Ml = Pa.offset, Su = Os.start;
                const Tu = Pa.size;
                if (Pa.offset < Ta) {
                  Su += Math.floor((Ta - Pa.offset + ye) / (Tu + ye));
                  const Zl = Su - Os.start;
                  Ml += Zl * Tu + Zl * ye;
                }
                Su < it && (Ml += (it - Su) * Tu, Su = it);
                const Au = Math.min(Os.end, wo);
                for (let Zl = Su; Zl <= Au && !(Ml >= Zn); Zl++)
                  Oa.push({ index: Zl, size: Tu, offset: Ml, data: Se && Se[Zl] }), Ml += Tu + ye;
              }
            });
            return buildListState(_u, pe, Ra, ye, Oe, be);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        filter((Ta) => Ta !== null),
        distinctUntilChanged()
      ),
      EMPTY_LIST_STATE
    );
    connect(
      pipe(
        z,
        filter(isDefined),
        map((Ta) => Ta == null ? void 0 : Ta.length)
      ),
      y
    ), connect(
      pipe(
        Rn,
        map((Ta) => Ta.topListHeight)
      ),
      $e
    ), connect($e, we), connect(
      pipe(
        Rn,
        map((Ta) => [Ta.top, Ta.bottom])
      ),
      ge
    ), connect(
      pipe(
        Rn,
        map((Ta) => Ta.items)
      ),
      En
    );
    const wa = streamFromEmitter(
      pipe(
        Rn,
        filter(({ items: Ta }) => Ta.length > 0),
        withLatestFrom(y, z),
        filter(([{ items: Ta }, Zn]) => Ta[Ta.length - 1].originalIndex === Zn - 1),
        map(([, Ta, Zn]) => [Ta - 1, Zn]),
        distinctUntilChanged(tupleComparator),
        map(([Ta]) => Ta)
      )
    ), Aa = streamFromEmitter(
      pipe(
        Rn,
        throttleTime(200),
        filter(({ items: Ta, topItems: Zn }) => Ta.length > 0 && Ta[0].originalIndex === Zn.length),
        map(({ items: Ta }) => Ta[0].index),
        distinctUntilChanged()
      )
    ), _a = streamFromEmitter(
      pipe(
        Rn,
        filter(({ items: Ta }) => Ta.length > 0),
        map(({ items: Ta }) => {
          let Zn = 0, Ra = Ta.length - 1;
          for (; Ta[Zn].type === "group" && Zn < Ra; )
            Zn++;
          for (; Ta[Ra].type === "group" && Ra > Zn; )
            Ra--;
          return {
            startIndex: Ta[Zn].index,
            endIndex: Ta[Ra].index
          };
        }),
        distinctUntilChanged(rangeComparator)
      )
    );
    return { listState: Rn, topItemsIndexes: br, endReached: wa, startReached: Aa, rangeChanged: _a, itemsRendered: En, initialItemCount: $n, ...Ne };
  },
  tup(
    sizeSystem,
    groupedListSystem,
    sizeRangeSystem,
    initialTopMostItemIndexSystem,
    scrollToIndexSystem,
    stateFlagsSystem,
    propsReadySystem,
    recalcSystem
  ),
  { singleton: !0 }
), initialItemCountSystem = system$1(
  ([{ sizes: v, firstItemIndex: y, data: z, gap: ne }, { initialTopMostItemIndex: ue }, { initialItemCount: le, listState: he }, { didMount: ge }]) => (connect(
    pipe(
      ge,
      withLatestFrom(le),
      filter(([, we]) => we !== 0),
      withLatestFrom(ue, v, y, ne, z),
      map(([[, we], Ee, xe, $e, Ne, st = []]) => buildListStateFromItemCount(we, Ee, xe, $e, Ne, st))
    ),
    he
  ), {}),
  tup(sizeSystem, initialTopMostItemIndexSystem, listStateSystem, propsReadySystem),
  { singleton: !0 }
), scrollSeekSystem = system$1(
  ([{ scrollVelocity: v }]) => {
    const y = statefulStream(!1), z = stream$1(), ne = statefulStream(!1);
    return connect(
      pipe(
        v,
        withLatestFrom(ne, y, z),
        filter(([ue, le]) => !!le),
        map(([ue, le, he, ge]) => {
          const { exit: we, enter: Ee } = le;
          if (he) {
            if (we(ue, ge))
              return !1;
          } else if (Ee(ue, ge))
            return !0;
          return he;
        }),
        distinctUntilChanged()
      ),
      y
    ), subscribe$1(
      pipe(combineLatest(y, v, z), withLatestFrom(ne)),
      ([[ue, le, he], ge]) => ue && ge && ge.change && ge.change(le, he)
    ), { isSeeking: y, scrollSeekConfiguration: ne, scrollVelocity: v, scrollSeekRangeChanged: z };
  },
  tup(stateFlagsSystem),
  { singleton: !0 }
), topItemCountSystem = system$1(([{ topItemsIndexes: v }]) => {
  const y = statefulStream(0);
  return connect(
    pipe(
      y,
      filter((z) => z > 0),
      map((z) => Array.from({ length: z }).map((ne, ue) => ue))
    ),
    v
  ), { topItemCount: y };
}, tup(listStateSystem)), totalListHeightSystem = system$1(
  ([{ footerHeight: v, headerHeight: y, fixedHeaderHeight: z, fixedFooterHeight: ne }, { listState: ue }]) => {
    const le = stream$1(), he = statefulStreamFromEmitter(
      pipe(
        combineLatest(v, ne, y, z, ue),
        map(([ge, we, Ee, xe, $e]) => ge + we + Ee + xe + $e.offsetBottom + $e.bottom)
      ),
      0
    );
    return connect(duc(he), le), { totalListHeight: he, totalListHeightChanged: le };
  },
  tup(domIOSystem, listStateSystem),
  { singleton: !0 }
);
function simpleMemoize(v) {
  let y = !1, z;
  return () => (y || (y = !0, z = v()), z);
}
const isMobileSafari = simpleMemoize(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)), upwardScrollFixSystem = system$1(
  ([
    { scrollBy: v, scrollTop: y, deviation: z, scrollingInProgress: ne },
    { isScrolling: ue, isAtBottom: le, scrollDirection: he, lastJumpDueToItemResize: ge },
    { listState: we },
    { beforeUnshiftWith: Ee, shiftWithOffset: xe, sizes: $e, gap: Ne },
    { log: st },
    { recalcInProgress: Nr }
  ]) => {
    const br = streamFromEmitter(
      pipe(
        we,
        withLatestFrom(ge),
        scan(
          ([, En, Rn, wa], [{ items: Aa, totalCount: _a, bottom: Ta, offsetBottom: Zn }, Ra]) => {
            const Yn = Ta + Zn;
            let $o = 0;
            return Rn === _a && En.length > 0 && Aa.length > 0 && (Aa[0].originalIndex === 0 && En[0].originalIndex === 0 || ($o = Yn - wa, $o !== 0 && ($o += Ra))), [$o, Aa, _a, Yn];
          },
          [0, [], 0, 0]
        ),
        filter(([En]) => En !== 0),
        withLatestFrom(y, he, ne, le, st, Nr),
        filter(([, En, Rn, wa, , , Aa]) => !Aa && !wa && En !== 0 && Rn === UP),
        map(([[En], , , , , Rn]) => (Rn("Upward scrolling compensation", { amount: En }, LogLevel.DEBUG), En))
      )
    );
    function $n(En) {
      En > 0 ? (publish(v, { top: -En, behavior: "auto" }), publish(z, 0)) : (publish(z, 0), publish(v, { top: -En, behavior: "auto" }));
    }
    return subscribe$1(pipe(br, withLatestFrom(z, ue)), ([En, Rn, wa]) => {
      wa && isMobileSafari() ? publish(z, Rn - En) : $n(-En);
    }), subscribe$1(
      pipe(
        combineLatest(statefulStreamFromEmitter(ue, !1), z, Nr),
        filter(([En, Rn, wa]) => !En && !wa && Rn !== 0),
        map(([En, Rn]) => Rn),
        throttleTime(1)
      ),
      $n
    ), connect(
      pipe(
        xe,
        map((En) => ({ top: -En }))
      ),
      v
    ), subscribe$1(
      pipe(
        Ee,
        withLatestFrom($e, Ne),
        map(([En, { lastSize: Rn, groupIndices: wa, sizeTree: Aa }, _a]) => {
          function Ta(Zn) {
            return Zn * (Rn + _a);
          }
          if (wa.length === 0)
            return Ta(En);
          {
            let Zn = 0;
            const Ra = find(Aa, 0);
            let Yn = 0, $o = 0;
            for (; Yn < En; ) {
              Yn++, Zn += Ra;
              let ct = wa.length === $o + 1 ? 1 / 0 : wa[$o + 1] - wa[$o] - 1;
              Yn + ct > En && (Zn -= Ra, ct = En - Yn + 1), Yn += ct, Zn += Ta(ct), $o++;
            }
            return Zn;
          }
        })
      ),
      (En) => {
        publish(z, En), requestAnimationFrame(() => {
          publish(v, { top: En }), requestAnimationFrame(() => {
            publish(z, 0), publish(Nr, !1);
          });
        });
      }
    ), { deviation: z };
  },
  tup(domIOSystem, stateFlagsSystem, listStateSystem, sizeSystem, loggerSystem, recalcSystem)
), initialScrollTopSystem = system$1(
  ([{ didMount: v }, { scrollTo: y }, { listState: z }]) => {
    const ne = statefulStream(0);
    return subscribe$1(
      pipe(
        v,
        withLatestFrom(ne),
        filter(([, ue]) => ue !== 0),
        map(([, ue]) => ({ top: ue }))
      ),
      (ue) => {
        handleNext(
          pipe(
            z,
            skip(1),
            filter((le) => le.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              publish(y, ue);
            });
          }
        );
      }
    ), {
      initialScrollTop: ne
    };
  },
  tup(propsReadySystem, domIOSystem, listStateSystem),
  { singleton: !0 }
), alignToBottomSystem = system$1(
  ([{ viewportHeight: v }, { totalListHeight: y }]) => {
    const z = statefulStream(!1), ne = statefulStreamFromEmitter(
      pipe(
        combineLatest(z, v, y),
        filter(([ue]) => ue),
        map(([, ue, le]) => Math.max(0, ue - le)),
        throttleTime(0),
        distinctUntilChanged()
      ),
      0
    );
    return { alignToBottom: z, paddingTopAddition: ne };
  },
  tup(domIOSystem, totalListHeightSystem),
  { singleton: !0 }
), windowScrollerSystem = system$1(([{ scrollTo: v, scrollContainerState: y }]) => {
  const z = stream$1(), ne = stream$1(), ue = stream$1(), le = statefulStream(!1), he = statefulStream(void 0);
  return connect(
    pipe(
      combineLatest(z, ne),
      map(([{ viewportHeight: ge, scrollTop: we, scrollHeight: Ee }, { offsetTop: xe }]) => ({
        scrollTop: Math.max(0, we - xe),
        scrollHeight: Ee,
        viewportHeight: ge
      }))
    ),
    y
  ), connect(
    pipe(
      v,
      withLatestFrom(ne),
      map(([ge, { offsetTop: we }]) => ({
        ...ge,
        top: ge.top + we
      }))
    ),
    ue
  ), {
    // config
    useWindowScroll: le,
    customScrollParent: he,
    // input
    windowScrollContainerState: z,
    windowViewportRect: ne,
    // signals
    windowScrollTo: ue
  };
}, tup(domIOSystem)), defaultCalculateViewLocation = ({
  itemTop: v,
  itemBottom: y,
  viewportTop: z,
  viewportBottom: ne,
  locationParams: { behavior: ue, align: le, ...he }
}) => v < z ? { ...he, behavior: ue, align: le ?? "start" } : y > ne ? { ...he, behavior: ue, align: le ?? "end" } : null, scrollIntoViewSystem = system$1(
  ([
    { sizes: v, totalCount: y, gap: z },
    { scrollTop: ne, viewportHeight: ue, headerHeight: le, fixedHeaderHeight: he, fixedFooterHeight: ge, scrollingInProgress: we },
    { scrollToIndex: Ee }
  ]) => {
    const xe = stream$1();
    return connect(
      pipe(
        xe,
        withLatestFrom(v, ue, y, le, he, ge, ne),
        withLatestFrom(z),
        map(([[$e, Ne, st, Nr, br, $n, En, Rn], wa]) => {
          const { done: Aa, behavior: _a, align: Ta, calculateViewLocation: Zn = defaultCalculateViewLocation, ...Ra } = $e, Yn = originalIndexFromLocation($e, Ne, Nr - 1), $o = offsetOf(Yn, Ne.offsetTree, wa) + br + $n, ct = $o + findMaxKeyValue(Ne.sizeTree, Yn)[1], fe = Rn + $n, be = Rn + st - En, ye = Zn({
            itemTop: $o,
            itemBottom: ct,
            viewportTop: fe,
            viewportBottom: be,
            locationParams: { behavior: _a, align: Ta, ...Ra }
          });
          return ye ? Aa && handleNext(
            pipe(
              we,
              filter((Se) => Se === !1),
              // skips the initial publish of false, and the cleanup call.
              // but if scrollingInProgress is true, we skip the initial publish.
              skip(getValue(we) ? 1 : 2)
            ),
            Aa
          ) : Aa && Aa(), ye;
        }),
        filter(($e) => $e !== null)
      ),
      Ee
    ), {
      scrollIntoView: xe
    };
  },
  tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem),
  { singleton: !0 }
), stateLoadSystem = system$1(
  ([
    { sizes: v, sizeRanges: y },
    { scrollTop: z },
    { initialTopMostItemIndex: ne },
    { didMount: ue },
    { useWindowScroll: le, windowScrollContainerState: he, windowViewportRect: ge }
  ]) => {
    const we = stream$1(), Ee = statefulStream(void 0), xe = statefulStream(null), $e = statefulStream(null);
    return connect(he, xe), connect(ge, $e), subscribe$1(
      pipe(we, withLatestFrom(v, z, le, xe, $e)),
      ([Ne, st, Nr, br, $n, En]) => {
        const Rn = sizeTreeToRanges(st.sizeTree);
        br && $n !== null && En !== null && (Nr = $n.scrollTop - En.offsetTop), Ne({ ranges: Rn, scrollTop: Nr });
      }
    ), connect(pipe(Ee, filter(isDefined), map(locationFromSnapshot)), ne), connect(
      pipe(
        ue,
        withLatestFrom(Ee),
        filter(([, Ne]) => Ne !== void 0),
        distinctUntilChanged(),
        map(([, Ne]) => Ne.ranges)
      ),
      y
    ), {
      getState: we,
      restoreStateFrom: Ee
    };
  },
  tup(sizeSystem, domIOSystem, initialTopMostItemIndexSystem, propsReadySystem, windowScrollerSystem)
);
function locationFromSnapshot(v) {
  return { offset: v.scrollTop, index: 0, align: "start" };
}
const featureGroup1System = system$1(
  ([
    v,
    y,
    z,
    ne,
    ue,
    le,
    he,
    ge,
    we,
    Ee
  ]) => ({
    ...v,
    ...y,
    ...z,
    ...ne,
    ...ue,
    ...le,
    ...he,
    ...ge,
    ...we,
    ...Ee
  }),
  tup(
    sizeRangeSystem,
    initialItemCountSystem,
    propsReadySystem,
    scrollSeekSystem,
    totalListHeightSystem,
    initialScrollTopSystem,
    alignToBottomSystem,
    windowScrollerSystem,
    scrollIntoViewSystem,
    loggerSystem
  )
), listSystem = system$1(
  ([
    {
      totalCount: v,
      sizeRanges: y,
      fixedItemSize: z,
      defaultItemSize: ne,
      trackItemSizes: ue,
      itemSize: le,
      data: he,
      firstItemIndex: ge,
      groupIndices: we,
      statefulTotalCount: Ee,
      gap: xe,
      sizes: $e
    },
    { initialTopMostItemIndex: Ne, scrolledToInitialItem: st, initialItemFinalLocationReached: Nr },
    br,
    $n,
    En,
    { listState: Rn, topItemsIndexes: wa, ...Aa },
    { scrollToIndex: _a },
    Ta,
    { topItemCount: Zn },
    { groupCounts: Ra },
    Yn
  ]) => (connect(Aa.rangeChanged, Yn.scrollSeekRangeChanged), connect(
    pipe(
      Yn.windowViewportRect,
      map(($o) => $o.visibleHeight)
    ),
    br.viewportHeight
  ), {
    // input
    totalCount: v,
    data: he,
    firstItemIndex: ge,
    sizeRanges: y,
    initialTopMostItemIndex: Ne,
    scrolledToInitialItem: st,
    initialItemFinalLocationReached: Nr,
    topItemsIndexes: wa,
    topItemCount: Zn,
    groupCounts: Ra,
    fixedItemHeight: z,
    defaultItemHeight: ne,
    gap: xe,
    ...En,
    // output
    statefulTotalCount: Ee,
    listState: Rn,
    scrollToIndex: _a,
    trackItemSizes: ue,
    itemSize: le,
    groupIndices: we,
    // exported from stateFlagsSystem
    ...Aa,
    // the bag of IO from featureGroup1System
    ...Yn,
    ...br,
    sizes: $e,
    ...$n
  }),
  tup(
    sizeSystem,
    initialTopMostItemIndexSystem,
    domIOSystem,
    stateLoadSystem,
    followOutputSystem,
    listStateSystem,
    scrollToIndexSystem,
    upwardScrollFixSystem,
    topItemCountSystem,
    groupedListSystem,
    featureGroup1System
  )
), WEBKIT_STICKY = "-webkit-sticky", STICKY = "sticky", positionStickyCssValue = simpleMemoize(() => {
  if (typeof document > "u")
    return STICKY;
  const v = document.createElement("div");
  return v.style.position = WEBKIT_STICKY, v.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
function useWindowViewportRectRef(v, y) {
  const z = a__default.useRef(null), ne = a__default.useCallback(
    (ge) => {
      if (ge === null || !ge.offsetParent)
        return;
      const we = ge.getBoundingClientRect(), Ee = we.width;
      let xe, $e;
      if (y) {
        const Ne = y.getBoundingClientRect(), st = we.top - Ne.top;
        xe = Ne.height - Math.max(0, st), $e = st + y.scrollTop;
      } else
        xe = window.innerHeight - Math.max(0, we.top), $e = we.top + window.pageYOffset;
      z.current = {
        offsetTop: $e,
        visibleHeight: xe,
        visibleWidth: Ee
      }, v(z.current);
    },
    [v, y]
  ), { callbackRef: ue, ref: le } = useSizeWithElRef(ne), he = a__default.useCallback(() => {
    ne(le.current);
  }, [ne, le]);
  return a__default.useEffect(() => {
    if (y) {
      y.addEventListener("scroll", he);
      const ge = new ResizeObserver(() => {
        requestAnimationFrame(he);
      });
      return ge.observe(y), () => {
        y.removeEventListener("scroll", he), ge.unobserve(y);
      };
    } else
      return window.addEventListener("scroll", he), window.addEventListener("resize", he), () => {
        window.removeEventListener("scroll", he), window.removeEventListener("resize", he);
      };
  }, [he, y]), ue;
}
const VirtuosoMockContext = a__default.createContext(void 0), VirtuosoGridMockContext = a__default.createContext(void 0);
function identity$1(v) {
  return v;
}
const listComponentPropsSystem = /* @__PURE__ */ system$1(() => {
  const v = statefulStream((we) => `Item ${we}`), y = statefulStream(null), z = statefulStream((we) => `Group ${we}`), ne = statefulStream({}), ue = statefulStream(identity$1), le = statefulStream("div"), he = statefulStream(noop), ge = (we, Ee = null) => statefulStreamFromEmitter(
    pipe(
      ne,
      map((xe) => xe[we]),
      distinctUntilChanged()
    ),
    Ee
  );
  return {
    context: y,
    itemContent: v,
    groupContent: z,
    components: ne,
    computeItemKey: ue,
    headerFooterTag: le,
    scrollerRef: he,
    FooterComponent: ge("Footer"),
    HeaderComponent: ge("Header"),
    TopItemListComponent: ge("TopItemList"),
    ListComponent: ge("List", "div"),
    ItemComponent: ge("Item", "div"),
    GroupComponent: ge("Group", "div"),
    ScrollerComponent: ge("Scroller", "div"),
    EmptyPlaceholder: ge("EmptyPlaceholder"),
    ScrollSeekPlaceholder: ge("ScrollSeekPlaceholder")
  };
}), combinedSystem$2 = /* @__PURE__ */ system$1(([v, y]) => ({ ...v, ...y }), tup(listSystem, listComponentPropsSystem)), DefaultScrollSeekPlaceholder$1 = ({ height: v }) => /* @__PURE__ */ a__default.createElement("div", { style: { height: v } }), GROUP_STYLE = { position: positionStickyCssValue(), zIndex: 1, overflowAnchor: "none" }, ITEM_STYLE$1 = { overflowAnchor: "none" }, Items$1 = /* @__PURE__ */ a__default.memo(function v({ showTopList: y = !1 }) {
  const z = useEmitterValue$2("listState"), ne = usePublisher$2("sizeRanges"), ue = useEmitterValue$2("useWindowScroll"), le = useEmitterValue$2("customScrollParent"), he = usePublisher$2("windowScrollContainerState"), ge = usePublisher$2("scrollContainerState"), we = le || ue ? he : ge, Ee = useEmitterValue$2("itemContent"), xe = useEmitterValue$2("context"), $e = useEmitterValue$2("groupContent"), Ne = useEmitterValue$2("trackItemSizes"), st = useEmitterValue$2("itemSize"), Nr = useEmitterValue$2("log"), br = usePublisher$2("gap"), { callbackRef: $n } = useChangedListContentsSizes(
    ne,
    st,
    Ne,
    y ? noop : we,
    Nr,
    br,
    le
  ), [En, Rn] = a__default.useState(0);
  useEmitter$2("deviation", (ye) => {
    En !== ye && Rn(ye);
  });
  const wa = useEmitterValue$2("EmptyPlaceholder"), Aa = useEmitterValue$2("ScrollSeekPlaceholder") || DefaultScrollSeekPlaceholder$1, _a = useEmitterValue$2("ListComponent"), Ta = useEmitterValue$2("ItemComponent"), Zn = useEmitterValue$2("GroupComponent"), Ra = useEmitterValue$2("computeItemKey"), Yn = useEmitterValue$2("isSeeking"), $o = useEmitterValue$2("groupIndices").length > 0, ct = useEmitterValue$2("alignToBottom"), fe = useEmitterValue$2("initialItemFinalLocationReached"), be = y ? {} : {
    boxSizing: "border-box",
    paddingTop: z.offsetTop,
    paddingBottom: z.offsetBottom,
    marginTop: En !== 0 ? En : ct ? "auto" : 0,
    ...fe ? {} : { visibility: "hidden" }
  };
  return !y && z.totalCount === 0 && wa ? a__default.createElement(wa, contextPropIfNotDomElement(wa, xe)) : a__default.createElement(
    _a,
    {
      ...contextPropIfNotDomElement(_a, xe),
      ref: $n,
      style: be,
      "data-test-id": y ? "virtuoso-top-item-list" : "virtuoso-item-list"
    },
    (y ? z.topItems : z.items).map((ye) => {
      const Se = ye.originalIndex, Oe = Ra(Se + z.firstItemIndex, ye.data, xe);
      return Yn ? a__default.createElement(Aa, {
        ...contextPropIfNotDomElement(Aa, xe),
        key: Oe,
        index: ye.index,
        height: ye.size,
        type: ye.type || "item",
        ...ye.type === "group" ? {} : { groupIndex: ye.groupIndex }
      }) : ye.type === "group" ? a__default.createElement(
        Zn,
        {
          ...contextPropIfNotDomElement(Zn, xe),
          key: Oe,
          "data-index": Se,
          "data-known-size": ye.size,
          "data-item-index": ye.index,
          style: GROUP_STYLE
        },
        $e(ye.index, xe)
      ) : a__default.createElement(
        Ta,
        {
          ...contextPropIfNotDomElement(Ta, xe),
          ...itemPropIfNotDomElement(Ta, ye.data),
          key: Oe,
          "data-index": Se,
          "data-known-size": ye.size,
          "data-item-index": ye.index,
          "data-item-group-index": ye.groupIndex,
          style: ITEM_STYLE$1
        },
        $o ? Ee(ye.index, ye.groupIndex, ye.data, xe) : Ee(ye.index, ye.data, xe)
      );
    })
  );
}), scrollerStyle = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, viewportStyle = (v) => ({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  ...v ? { display: "flex", flexDirection: "column" } : {}
}), topItemListStyle = {
  width: "100%",
  position: positionStickyCssValue(),
  top: 0,
  zIndex: 1
};
function contextPropIfNotDomElement(v, y) {
  if (typeof v != "string")
    return { context: y };
}
function itemPropIfNotDomElement(v, y) {
  return { item: typeof v == "string" ? void 0 : y };
}
const Header$1$1 = /* @__PURE__ */ a__default.memo(function v() {
  const y = useEmitterValue$2("HeaderComponent"), z = usePublisher$2("headerHeight"), ne = useEmitterValue$2("headerFooterTag"), ue = useSize((he) => z(correctItemSize(he, "height"))), le = useEmitterValue$2("context");
  return y ? a__default.createElement(ne, { ref: ue }, a__default.createElement(y, contextPropIfNotDomElement(y, le))) : null;
}), Footer$1 = /* @__PURE__ */ a__default.memo(function v() {
  const y = useEmitterValue$2("FooterComponent"), z = usePublisher$2("footerHeight"), ne = useEmitterValue$2("headerFooterTag"), ue = useSize((he) => z(correctItemSize(he, "height"))), le = useEmitterValue$2("context");
  return y ? a__default.createElement(ne, { ref: ue }, a__default.createElement(y, contextPropIfNotDomElement(y, le))) : null;
});
function buildScroller({ usePublisher: v, useEmitter: y, useEmitterValue: z }) {
  return a__default.memo(function({ style: le, children: he, ...ge }) {
    const we = v("scrollContainerState"), Ee = z("ScrollerComponent"), xe = v("smoothScrollTargetReached"), $e = z("scrollerRef"), Ne = z("context"), { scrollerRef: st, scrollByCallback: Nr, scrollToCallback: br } = useScrollTop(
      we,
      xe,
      Ee,
      $e
    );
    return y("scrollTo", br), y("scrollBy", Nr), a__default.createElement(
      Ee,
      {
        ref: st,
        style: { ...scrollerStyle, ...le },
        "data-test-id": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        tabIndex: 0,
        ...ge,
        ...contextPropIfNotDomElement(Ee, Ne)
      },
      he
    );
  });
}
function buildWindowScroller({ usePublisher: v, useEmitter: y, useEmitterValue: z }) {
  return a__default.memo(function({ style: le, children: he, ...ge }) {
    const we = v("windowScrollContainerState"), Ee = z("ScrollerComponent"), xe = v("smoothScrollTargetReached"), $e = z("totalListHeight"), Ne = z("deviation"), st = z("customScrollParent"), Nr = z("context"), { scrollerRef: br, scrollByCallback: $n, scrollToCallback: En } = useScrollTop(
      we,
      xe,
      Ee,
      noop,
      st
    );
    return useIsomorphicLayoutEffect$1(() => (br.current = st || window, () => {
      br.current = null;
    }), [br, st]), y("windowScrollTo", En), y("scrollBy", $n), a__default.createElement(
      Ee,
      {
        style: { position: "relative", ...le, ...$e !== 0 ? { height: $e + Ne } : {} },
        "data-virtuoso-scroller": !0,
        ...ge,
        ...contextPropIfNotDomElement(Ee, Nr)
      },
      he
    );
  });
}
const Viewport$2 = ({ children: v }) => {
  const y = a__default.useContext(VirtuosoMockContext), z = usePublisher$2("viewportHeight"), ne = usePublisher$2("fixedItemHeight"), ue = useEmitterValue$2("alignToBottom"), le = useSize(compose(z, (he) => correctItemSize(he, "height")));
  return a__default.useEffect(() => {
    y && (z(y.viewportHeight), ne(y.itemHeight));
  }, [y, z, ne]), /* @__PURE__ */ a__default.createElement("div", { style: viewportStyle(ue), ref: le, "data-viewport-type": "element" }, v);
}, WindowViewport$2 = ({ children: v }) => {
  const y = a__default.useContext(VirtuosoMockContext), z = usePublisher$2("windowViewportRect"), ne = usePublisher$2("fixedItemHeight"), ue = useEmitterValue$2("customScrollParent"), le = useWindowViewportRectRef(z, ue), he = useEmitterValue$2("alignToBottom");
  return a__default.useEffect(() => {
    y && (ne(y.itemHeight), z({ offsetTop: 0, visibleHeight: y.viewportHeight, visibleWidth: 100 }));
  }, [y, z, ne]), /* @__PURE__ */ a__default.createElement("div", { ref: le, style: viewportStyle(he), "data-viewport-type": "window" }, v);
}, TopItemListContainer = ({ children: v }) => {
  const y = useEmitterValue$2("TopItemListComponent") || "div", z = useEmitterValue$2("headerHeight"), ne = { ...topItemListStyle, marginTop: `${z}px` }, ue = useEmitterValue$2("context");
  return a__default.createElement(y, { style: ne, ...contextPropIfNotDomElement(y, ue) }, v);
}, ListRoot = /* @__PURE__ */ a__default.memo(function v(y) {
  const z = useEmitterValue$2("useWindowScroll"), ne = useEmitterValue$2("topItemsIndexes").length > 0, ue = useEmitterValue$2("customScrollParent"), le = ue || z ? WindowScroller$2 : Scroller$2, he = ue || z ? WindowViewport$2 : Viewport$2;
  return /* @__PURE__ */ a__default.createElement(le, { ...y }, ne && /* @__PURE__ */ a__default.createElement(TopItemListContainer, null, /* @__PURE__ */ a__default.createElement(Items$1, { showTopList: !0 })), /* @__PURE__ */ a__default.createElement(he, null, /* @__PURE__ */ a__default.createElement(Header$1$1, null), /* @__PURE__ */ a__default.createElement(Items$1, null), /* @__PURE__ */ a__default.createElement(Footer$1, null)));
}), {
  Component: List,
  usePublisher: usePublisher$2,
  useEmitterValue: useEmitterValue$2,
  useEmitter: useEmitter$2
} = /* @__PURE__ */ systemToComponent(
  combinedSystem$2,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      groupCounts: "groupCounts",
      topItemCount: "topItemCount",
      firstItemIndex: "firstItemIndex",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  ListRoot
), Scroller$2 = /* @__PURE__ */ buildScroller({ usePublisher: usePublisher$2, useEmitterValue: useEmitterValue$2, useEmitter: useEmitter$2 }), WindowScroller$2 = /* @__PURE__ */ buildWindowScroller({ usePublisher: usePublisher$2, useEmitterValue: useEmitterValue$2, useEmitter: useEmitter$2 }), Virtuoso = List, INITIAL_GRID_STATE = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, PROBE_GRID_STATE = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, { round, ceil, floor, min, max } = Math;
function buildProbeGridState(v) {
  return {
    ...PROBE_GRID_STATE,
    items: v
  };
}
function buildItems(v, y, z) {
  return Array.from({ length: y - v + 1 }).map((ne, ue) => {
    const le = z === null ? null : z[ue + v];
    return { index: ue + v, data: le };
  });
}
function gapComparator(v, y) {
  return v && v.column === y.column && v.row === y.row;
}
function dimensionComparator(v, y) {
  return v && v.width === y.width && v.height === y.height;
}
const gridSystem = /* @__PURE__ */ system$1(
  ([
    { overscan: v, visibleRange: y, listBoundary: z },
    { scrollTop: ne, viewportHeight: ue, scrollBy: le, scrollTo: he, smoothScrollTargetReached: ge, scrollContainerState: we, footerHeight: Ee, headerHeight: xe },
    $e,
    Ne,
    { propsReady: st, didMount: Nr },
    { windowViewportRect: br, useWindowScroll: $n, customScrollParent: En, windowScrollContainerState: Rn, windowScrollTo: wa },
    Aa
  ]) => {
    const _a = statefulStream(0), Ta = statefulStream(0), Zn = statefulStream(INITIAL_GRID_STATE), Ra = statefulStream({ height: 0, width: 0 }), Yn = statefulStream({ height: 0, width: 0 }), $o = stream$1(), ct = stream$1(), fe = statefulStream(0), be = statefulStream(null), ye = statefulStream({ row: 0, column: 0 }), Se = stream$1(), Oe = stream$1(), Fr = statefulStream(!1), zn = statefulStream(0), Fe = statefulStream(!0), pe = statefulStream(!1);
    subscribe$1(
      pipe(
        Nr,
        withLatestFrom(zn),
        filter(([Os, Pa]) => !!Pa)
      ),
      () => {
        publish(Fe, !1), publish(Ta, 0);
      }
    ), subscribe$1(
      pipe(
        combineLatest(Nr, Fe, Yn, Ra, zn, pe),
        filter(([Os, Pa, Ml, Su, , Tu]) => Os && !Pa && Ml.height !== 0 && Su.height !== 0 && !Tu)
      ),
      ([, , , , Os]) => {
        publish(pe, !0), skipFrames(1, () => {
          publish($o, Os);
        }), handleNext(pipe(ne), () => {
          publish(z, [0, 0]), publish(Fe, !0);
        });
      }
    ), connect(
      pipe(
        Oe,
        filter((Os) => Os != null && Os.scrollTop > 0),
        mapTo(0)
      ),
      Ta
    ), subscribe$1(
      pipe(
        Nr,
        withLatestFrom(Oe),
        filter(([, Os]) => Os != null)
      ),
      ([, Os]) => {
        Os && (publish(Ra, Os.viewport), publish(Yn, Os == null ? void 0 : Os.item), publish(ye, Os.gap), Os.scrollTop > 0 && (publish(Fr, !0), handleNext(pipe(ne, skip(1)), (Pa) => {
          publish(Fr, !1);
        }), publish(he, { top: Os.scrollTop })));
      }
    ), connect(
      pipe(
        Ra,
        map(({ height: Os }) => Os)
      ),
      ue
    ), connect(
      pipe(
        combineLatest(
          duc(Ra, dimensionComparator),
          duc(Yn, dimensionComparator),
          duc(ye, (Os, Pa) => Os && Os.column === Pa.column && Os.row === Pa.row),
          duc(ne)
        ),
        map(([Os, Pa, Ml, Su]) => ({
          viewport: Os,
          item: Pa,
          gap: Ml,
          scrollTop: Su
        }))
      ),
      Se
    ), connect(
      pipe(
        combineLatest(
          duc(_a),
          y,
          duc(ye, gapComparator),
          duc(Yn, dimensionComparator),
          duc(Ra, dimensionComparator),
          duc(be),
          duc(Ta),
          duc(Fr),
          duc(Fe),
          duc(zn)
        ),
        filter(([, , , , , , , Os]) => !Os),
        map(
          ([
            Os,
            [Pa, Ml],
            Su,
            Tu,
            Au,
            Zl,
            Iu,
            ,
            Uc,
            Pu
          ]) => {
            const { row: Lu, column: th } = Su, { height: Zc, width: N1 } = Tu, { width: Gh } = Au;
            if (Iu === 0 && (Os === 0 || Gh === 0))
              return INITIAL_GRID_STATE;
            if (N1 === 0) {
              const Eu = getInitialTopMostItemIndexNumber(Pu, Os), Zo = Eu === 0 ? Math.max(Iu - 1, 0) : Eu;
              return buildProbeGridState(buildItems(Eu, Zo, Zl));
            }
            const Mc = itemsPerRow(Gh, N1, th);
            let h1, l2;
            Uc ? Pa === 0 && Ml === 0 && Iu > 0 ? (h1 = 0, l2 = Iu - 1) : (h1 = Mc * floor((Pa + Lu) / (Zc + Lu)), l2 = Mc * ceil((Ml + Lu) / (Zc + Lu)) - 1, l2 = min(Os - 1, max(l2, Mc - 1)), h1 = min(l2, max(0, h1))) : (h1 = 0, l2 = -1);
            const Gc = buildItems(h1, l2, Zl), { top: Kc, bottom: M2 } = gridLayout(Au, Su, Tu, Gc), d1 = ceil(Os / Mc), k2 = d1 * Zc + (d1 - 1) * Lu - M2;
            return { items: Gc, offsetTop: Kc, offsetBottom: k2, top: Kc, bottom: M2, itemHeight: Zc, itemWidth: N1 };
          }
        )
      ),
      Zn
    ), connect(
      pipe(
        be,
        filter((Os) => Os !== null),
        map((Os) => Os.length)
      ),
      _a
    ), connect(
      pipe(
        combineLatest(Ra, Yn, Zn, ye),
        filter(([Os, Pa, { items: Ml }]) => Ml.length > 0 && Pa.height !== 0 && Os.height !== 0),
        map(([Os, Pa, { items: Ml }, Su]) => {
          const { top: Tu, bottom: Au } = gridLayout(Os, Su, Pa, Ml);
          return [Tu, Au];
        }),
        distinctUntilChanged(tupleComparator)
      ),
      z
    );
    const it = statefulStream(!1);
    connect(
      pipe(
        ne,
        withLatestFrom(it),
        map(([Os, Pa]) => Pa || Os !== 0)
      ),
      it
    );
    const xa = streamFromEmitter(
      pipe(
        duc(Zn),
        filter(({ items: Os }) => Os.length > 0),
        withLatestFrom(_a, it),
        filter(([{ items: Os }, Pa, Ml]) => Ml && Os[Os.length - 1].index === Pa - 1),
        map(([, Os]) => Os - 1),
        distinctUntilChanged()
      )
    ), wo = streamFromEmitter(
      pipe(
        duc(Zn),
        filter(({ items: Os }) => Os.length > 0 && Os[0].index === 0),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        mapTo(0),
        distinctUntilChanged()
      )
    ), _u = streamFromEmitter(
      pipe(
        duc(Zn),
        withLatestFrom(Fr),
        filter(([{ items: Os }, Pa]) => Os.length > 0 && !Pa),
        map(([{ items: Os }]) => ({
          startIndex: Os[0].index,
          endIndex: Os[Os.length - 1].index
        })),
        distinctUntilChanged(rangeComparator),
        throttleTime(0)
      )
    );
    connect(_u, Ne.scrollSeekRangeChanged), connect(
      pipe(
        $o,
        withLatestFrom(Ra, Yn, _a, ye),
        map(([Os, Pa, Ml, Su, Tu]) => {
          const Au = normalizeIndexLocation(Os), { align: Zl, behavior: Iu, offset: Uc } = Au;
          let Pu = Au.index;
          Pu === "LAST" && (Pu = Su - 1), Pu = max(0, Pu, min(Su - 1, Pu));
          let Lu = itemTop(Pa, Tu, Ml, Pu);
          return Zl === "end" ? Lu = round(Lu - Pa.height + Ml.height) : Zl === "center" && (Lu = round(Lu - Pa.height / 2 + Ml.height / 2)), Uc && (Lu += Uc), { top: Lu, behavior: Iu };
        })
      ),
      he
    );
    const Oa = statefulStreamFromEmitter(
      pipe(
        Zn,
        map((Os) => Os.offsetBottom + Os.bottom)
      ),
      0
    );
    return connect(
      pipe(
        br,
        map((Os) => ({ width: Os.visibleWidth, height: Os.visibleHeight }))
      ),
      Ra
    ), {
      // input
      data: be,
      totalCount: _a,
      viewportDimensions: Ra,
      itemDimensions: Yn,
      scrollTop: ne,
      scrollHeight: ct,
      overscan: v,
      scrollBy: le,
      scrollTo: he,
      scrollToIndex: $o,
      smoothScrollTargetReached: ge,
      windowViewportRect: br,
      windowScrollTo: wa,
      useWindowScroll: $n,
      customScrollParent: En,
      windowScrollContainerState: Rn,
      deviation: fe,
      scrollContainerState: we,
      footerHeight: Ee,
      headerHeight: xe,
      initialItemCount: Ta,
      gap: ye,
      restoreStateFrom: Oe,
      ...Ne,
      initialTopMostItemIndex: zn,
      // output
      gridState: Zn,
      totalListHeight: Oa,
      ...$e,
      startReached: wo,
      endReached: xa,
      rangeChanged: _u,
      stateChanged: Se,
      propsReady: st,
      stateRestoreInProgress: Fr,
      ...Aa
    };
  },
  tup(sizeRangeSystem, domIOSystem, stateFlagsSystem, scrollSeekSystem, propsReadySystem, windowScrollerSystem, loggerSystem)
);
function gridLayout(v, y, z, ne) {
  const { height: ue } = z;
  if (ue === void 0 || ne.length === 0)
    return { top: 0, bottom: 0 };
  const le = itemTop(v, y, z, ne[0].index), he = itemTop(v, y, z, ne[ne.length - 1].index) + ue;
  return { top: le, bottom: he };
}
function itemTop(v, y, z, ne) {
  const ue = itemsPerRow(v.width, z.width, y.column), le = floor(ne / ue), he = le * z.height + max(0, le - 1) * y.row;
  return he > 0 ? he + y.row : he;
}
function itemsPerRow(v, y, z) {
  return max(1, floor((v + z) / (floor(y) + z)));
}
const gridComponentPropsSystem = /* @__PURE__ */ system$1(() => {
  const v = statefulStream((Ee) => `Item ${Ee}`), y = statefulStream({}), z = statefulStream(null), ne = statefulStream("virtuoso-grid-item"), ue = statefulStream("virtuoso-grid-list"), le = statefulStream(identity$1), he = statefulStream("div"), ge = statefulStream(noop), we = (Ee, xe = null) => statefulStreamFromEmitter(
    pipe(
      y,
      map(($e) => $e[Ee]),
      distinctUntilChanged()
    ),
    xe
  );
  return {
    context: z,
    itemContent: v,
    components: y,
    computeItemKey: le,
    itemClassName: ne,
    listClassName: ue,
    headerFooterTag: he,
    scrollerRef: ge,
    FooterComponent: we("Footer"),
    HeaderComponent: we("Header"),
    ListComponent: we("List", "div"),
    ItemComponent: we("Item", "div"),
    ScrollerComponent: we("Scroller", "div"),
    ScrollSeekPlaceholder: we("ScrollSeekPlaceholder", "div")
  };
}), combinedSystem$1 = /* @__PURE__ */ system$1(([v, y]) => ({ ...v, ...y }), tup(gridSystem, gridComponentPropsSystem)), GridItems = /* @__PURE__ */ a__default.memo(function v() {
  const y = useEmitterValue$1("gridState"), z = useEmitterValue$1("listClassName"), ne = useEmitterValue$1("itemClassName"), ue = useEmitterValue$1("itemContent"), le = useEmitterValue$1("computeItemKey"), he = useEmitterValue$1("isSeeking"), ge = usePublisher$1("scrollHeight"), we = useEmitterValue$1("ItemComponent"), Ee = useEmitterValue$1("ListComponent"), xe = useEmitterValue$1("ScrollSeekPlaceholder"), $e = useEmitterValue$1("context"), Ne = usePublisher$1("itemDimensions"), st = usePublisher$1("gap"), Nr = useEmitterValue$1("log"), br = useEmitterValue$1("stateRestoreInProgress"), $n = useSize((En) => {
    const Rn = En.parentElement.parentElement.scrollHeight;
    ge(Rn);
    const wa = En.firstChild;
    if (wa) {
      const { width: Aa, height: _a } = wa.getBoundingClientRect();
      Ne({ width: Aa, height: _a });
    }
    st({
      row: resolveGapValue("row-gap", getComputedStyle(En).rowGap, Nr),
      column: resolveGapValue("column-gap", getComputedStyle(En).columnGap, Nr)
    });
  });
  return br ? null : a__default.createElement(
    Ee,
    {
      ref: $n,
      className: z,
      ...contextPropIfNotDomElement(Ee, $e),
      style: { paddingTop: y.offsetTop, paddingBottom: y.offsetBottom },
      "data-test-id": "virtuoso-item-list"
    },
    y.items.map((En) => {
      const Rn = le(En.index, En.data, $e);
      return he ? a__default.createElement(xe, {
        key: Rn,
        ...contextPropIfNotDomElement(xe, $e),
        index: En.index,
        height: y.itemHeight,
        width: y.itemWidth
      }) : a__default.createElement(
        we,
        { ...contextPropIfNotDomElement(we, $e), className: ne, "data-index": En.index, key: Rn },
        ue(En.index, En.data, $e)
      );
    })
  );
}), Header$3 = a__default.memo(function v() {
  const y = useEmitterValue$1("HeaderComponent"), z = usePublisher$1("headerHeight"), ne = useEmitterValue$1("headerFooterTag"), ue = useSize((he) => z(correctItemSize(he, "height"))), le = useEmitterValue$1("context");
  return y ? a__default.createElement(ne, { ref: ue }, a__default.createElement(y, contextPropIfNotDomElement(y, le))) : null;
}), Footer = a__default.memo(function v() {
  const y = useEmitterValue$1("FooterComponent"), z = usePublisher$1("footerHeight"), ne = useEmitterValue$1("headerFooterTag"), ue = useSize((he) => z(correctItemSize(he, "height"))), le = useEmitterValue$1("context");
  return y ? a__default.createElement(ne, { ref: ue }, a__default.createElement(y, contextPropIfNotDomElement(y, le))) : null;
}), Viewport$1 = ({ children: v }) => {
  const y = a__default.useContext(VirtuosoGridMockContext), z = usePublisher$1("itemDimensions"), ne = usePublisher$1("viewportDimensions"), ue = useSize((le) => {
    ne(le.getBoundingClientRect());
  });
  return a__default.useEffect(() => {
    y && (ne({ height: y.viewportHeight, width: y.viewportWidth }), z({ height: y.itemHeight, width: y.itemWidth }));
  }, [y, ne, z]), /* @__PURE__ */ a__default.createElement("div", { style: viewportStyle(!1), ref: ue }, v);
}, WindowViewport$1 = ({ children: v }) => {
  const y = a__default.useContext(VirtuosoGridMockContext), z = usePublisher$1("windowViewportRect"), ne = usePublisher$1("itemDimensions"), ue = useEmitterValue$1("customScrollParent"), le = useWindowViewportRectRef(z, ue);
  return a__default.useEffect(() => {
    y && (ne({ height: y.itemHeight, width: y.itemWidth }), z({ offsetTop: 0, visibleHeight: y.viewportHeight, visibleWidth: y.viewportWidth }));
  }, [y, z, ne]), /* @__PURE__ */ a__default.createElement("div", { ref: le, style: viewportStyle(!1) }, v);
}, GridRoot = /* @__PURE__ */ a__default.memo(function v({ ...y }) {
  const z = useEmitterValue$1("useWindowScroll"), ne = useEmitterValue$1("customScrollParent"), ue = ne || z ? WindowScroller$1 : Scroller$1, le = ne || z ? WindowViewport$1 : Viewport$1;
  return /* @__PURE__ */ a__default.createElement(ue, { ...y }, /* @__PURE__ */ a__default.createElement(le, null, /* @__PURE__ */ a__default.createElement(Header$3, null), /* @__PURE__ */ a__default.createElement(GridItems, null), /* @__PURE__ */ a__default.createElement(Footer, null)));
}), {
  Component: Grid,
  usePublisher: usePublisher$1,
  useEmitterValue: useEmitterValue$1,
  useEmitter: useEmitter$1
} = /* @__PURE__ */ systemToComponent(
  combinedSystem$1,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged"
    }
  },
  GridRoot
), Scroller$1 = /* @__PURE__ */ buildScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 }), WindowScroller$1 = /* @__PURE__ */ buildWindowScroller({ usePublisher: usePublisher$1, useEmitterValue: useEmitterValue$1, useEmitter: useEmitter$1 });
function resolveGapValue(v, y, z) {
  return y !== "normal" && !(y != null && y.endsWith("px")) && z(`${v} was not resolved to pixel value correctly`, y, LogLevel.WARN), y === "normal" ? 0 : parseInt(y ?? "0", 10);
}
const getSnapshot = () => navigator.onLine, getServerSnapshot = () => !0, subscribe = (v) => (window.addEventListener("online", v), window.addEventListener("offline", v), () => {
  window.removeEventListener("online", v), window.removeEventListener("offline", v);
}), useOnline = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot), ChainItemRaw = ({ chain: v, isSelected: y, onSelect: z }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    variant: "ghost",
    size: "sm",
    className: "text-foreground ring-inset h-auto w-full items-center justify-start gap-4 rounded-none p-3",
    onClick: z.bind(null, v.chainId),
    disabled: y,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-8 w-8", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v.logoUri }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-foreground font-bold", children: v.chainName })
    ]
  },
  v.chainId
), ChainItem = memo$1(ChainItemRaw), PopularChains = ({ chains: v, onSelect: y, selectedChainId: z }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "my-4", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-foreground text-sm font-bold", children: "Popular Chains" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-2 flex flex-wrap items-center gap-2", children: v.map((ne) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    np,
    {
      variant: "outline",
      size: "sm",
      className: "h-auto rounded-3xl p-1.5 text-sm",
      onClick: () => y(ne.chainId),
      disabled: z === ne.chainId,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-5 w-5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: ne.logoUri }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-2", children: ne.chainName })
      ]
    },
    ne.chainId
  )) })
] }), ChainSelectDialogTrigger = ({ chainData: v, error: y, onlyOneChain: z }) => /* @__PURE__ */ jsxRuntimeExports.jsx(J$, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    variant: "outline",
    size: "sm",
    disabled: v && z,
    className: Y$1("h-auto rounded-3xl py-1.5 px-2 text-sm !opacity-100", {
      "border-destructive": y
    }),
    children: [
      v != null && v.logoUri ? /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-5 w-5", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v == null ? void 0 : v.logoUri }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
      ] }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-2 font-medium", children: (v == null ? void 0 : v.chainName) ?? "Select Chain" }),
      v && z ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(D$3, { weight: "bold", size: "0.75rem" })
    ]
  }
) }), ChainSelect = ({
  chains: v,
  selectedChainId: y,
  popularChainIds: z,
  setSelectedChainId: ne,
  selectedChainError: ue,
  filterChains: le
}) => {
  const [he, ge] = useState(""), we = useDebouncedValue(he, 150), [Ee, xe] = useState(!1), $e = useOnline(), Ne = useMemo(() => {
    if (!v.data)
      return;
    const En = v.data.sort(
      (Rn, wa) => Rn.chainName.localeCompare(wa.chainName)
    );
    return le ? le(En) : En;
  }, [v.data, le]), st = useMemo(() => {
    if (!Ne)
      return;
    const En = we.trim();
    if (!En)
      return Ne;
    const Rn = new Fuse(Ne, {
      keys: ["name", "chainName"],
      threshold: 0.2
    });
    return Rn == null ? void 0 : Rn.search(En).map((wa) => wa.item);
  }, [we, Ne]), Nr = useMemo(() => {
    var En;
    if (y)
      return (En = v.data) == null ? void 0 : En.find((Rn) => Rn.chainId === y);
  }, [v.data, y]), br = useMemo(() => z ? z.map((En) => Ne == null ? void 0 : Ne.find((Rn) => Rn.chainId === En)).filter((En) => !!En) : [], [z, Ne]), $n = useCallback(
    (En) => {
      ne(En), xe(!1);
    },
    [ne]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Y0$1, { open: Ee, onOpenChange: xe, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ChainSelectDialogTrigger,
      {
        error: ue,
        chainData: Nr,
        onlyOneChain: (Ne == null ? void 0 : Ne.length) === 1
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Gi, { className: "w-full max-w-[24rem]", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(q0$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Q0$1, { className: "text-left", children: "Select Chain" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SearchInput,
          {
            searchQuery: he,
            setSearchQuery: ge,
            placeholder: "Search by name or chain id",
            disabled: st === void 0 || v.isLoading
          }
        ),
        v.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              w$3,
              {
                size: 32,
                className: "text-foreground animate-spin"
              }
            ),
            message: "Loading chains..."
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          he.length === 0 && br.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            PopularChains,
            {
              chains: br,
              onSelect: $n,
              selectedChainId: y
            }
          ) : null,
          st === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListMessage,
            {
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
              message: "Failed to load chains",
              subtext: $e ? "Oops, something went wrong. Try reloading the page." : "Please check your connection"
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (Ne == null ? void 0 : Ne.length) === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListMessage,
            {
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
              message: "No supported chains",
              subtext: "Looks like there are no supported chains"
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: st.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            ListMessage,
            {
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(I$2, { size: 32, className: "text-foreground" }),
              message: `No chains found for '${we}'`,
              subtext: "Try searching for a different term"
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "text-foreground text-sm font-bold", children: [
              we.length > 0 ? "Searched" : "All",
              " ",
              "Chains"
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Virtuoso,
              {
                className: "mt-2 w-full",
                increaseViewportBy: {
                  top: 120,
                  bottom: 120
                },
                data: st,
                style: {
                  height: "40svh",
                  maxHeight: "20rem"
                },
                itemContent: (En, Rn) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    ChainItem,
                    {
                      chain: Rn,
                      onSelect: $n,
                      isSelected: Rn.chainId === y
                    }
                  ),
                  En !== st.length - 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Sh, {}) : null
                ] }, Rn.chainId)
              }
            )
          ] }) }) })
        ] })
      ] })
    ] })
  ] });
}, AssetItemRaw = ({ asset: v, isSelected: y, onSelect: z, children: ne }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    variant: "ghost",
    size: "sm",
    className: "text-foreground ring-inset h-auto w-[20.875rem] items-stretch justify-start gap-4 rounded-none border-b p-3 last-of-type:border-none",
    onClick: () => z(v.denom),
    disabled: y,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-8 w-8 shrink-0", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v.logoUri }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full", children: ne(v) })
    ]
  },
  v.denom
), AssetItem = memo$1(AssetItemRaw), AssetSelectModalTrigger = ({ selectedAssetData: v, onlyOneAsset: y }) => /* @__PURE__ */ jsxRuntimeExports.jsx(J$, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    disabled: v && y,
    variant: "outline",
    className: "rounded-3xl py-1.5 px-3 !opacity-100",
    children: [
      v != null && v.logoUri ? /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-6 w-6 border", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v.logoUri }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
      ] }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          className: `mx-2 font-medium ${v ? "text-lg" : "text-base"}`,
          children: (v == null ? void 0 : v.symbol) ?? "Select Asset"
        }
      ),
      v && y ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(D$3, { weight: "bold", size: "0.75rem" })
    ]
  }
) }), AssetSelect = ({
  assets: v,
  selectedChainId: y,
  selectedAsset: z,
  setSelectedAsset: ne,
  children: ue,
  getIsSelected: le,
  assetFilter: he,
  defaultSorter: ge
}) => {
  const [we, Ee] = useState(""), xe = useDebouncedValue(we, 150), [$e, Ne] = useState(!1), st = useOnline(), Nr = useMemo(() => {
    var Aa;
    if (!y)
      return;
    const wa = (Aa = v.data) == null ? void 0 : Aa[y];
    return he ? wa == null ? void 0 : wa.filter(he) : wa;
  }, [v.data, he, y]), br = useMemo(() => {
    if (Nr)
      return ge ? ge(Nr) : Nr.sort((wa, Aa) => wa.symbol.localeCompare(Aa.symbol));
  }, [Nr, ge]), $n = useMemo(() => {
    if (!br)
      return;
    const wa = xe.trim();
    if (!wa)
      return br;
    const Aa = new Fuse(br, {
      keys: ["symbol", "denom"],
      threshold: 0.2
    });
    return Aa == null ? void 0 : Aa.search(wa).map((_a) => _a.item);
  }, [xe, br]), En = useMemo(() => {
    if (!(!z || !Nr))
      return Nr.find((wa) => wa.denom === z);
  }, [Nr, z]), Rn = useCallback(
    (wa) => {
      ne(wa), Ne(!1);
    },
    [ne]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Y0$1, { open: $e, onOpenChange: Ne, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AssetSelectModalTrigger,
      {
        onlyOneAsset: (br == null ? void 0 : br.length) === 1,
        selectedAssetData: En
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Gi, { className: "w-full max-w-[24rem]", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(q0$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Q0$1, { className: "text-left", children: "Select Asset" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SearchInput,
          {
            searchQuery: we,
            setSearchQuery: Ee,
            placeholder: "Search by name, symbol or denom",
            disabled: $n === void 0 || v.isLoading
          }
        ),
        v.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              w$3,
              {
                size: 32,
                className: "text-foreground animate-spin"
              }
            ),
            message: "Loading assets..."
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: $n === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: y === void 0 || y === SELECT_NONE ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "No chain selected",
            subtext: "Please select a chain to view its assets"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "Failed to load assets",
            subtext: st ? "Oops, something went wrong. Try reloading the page." : "Please check your connection"
          }
        ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (br == null ? void 0 : br.length) === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "No supported assets",
            subtext: "Looks like there are no supported assets for this chain"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: $n.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(I$2, { size: 32, className: "text-foreground" }),
            message: `No assets found for '${xe}'`,
            subtext: "Try searching for a different term"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "text-foreground text-sm font-bold", children: [
            xe.length > 0 ? "Searched" : "All",
            " ",
            "Assets"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Virtuoso,
            {
              className: "mt-2 w-full",
              increaseViewportBy: {
                top: 120,
                bottom: 120
              },
              data: $n,
              style: {
                height: "40svh",
                maxHeight: "20rem"
              },
              itemContent: (wa, Aa) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  AssetItem,
                  {
                    asset: Aa,
                    children: ue,
                    onSelect: Rn,
                    isSelected: le(
                      Aa,
                      z
                    )
                  },
                  Aa.denom
                ),
                wa !== $n.length - 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Sh, {}) : null
              ] }, Aa.denom)
            }
          )
        ] }) }) }) })
      ] })
    ] })
  ] });
};
function isNativeAsset(v, y) {
  const z = y ? (v == null ? void 0 : v.denom) === y : v == null ? void 0 : v.denom.includes("native");
  return (v == null ? void 0 : v.originDenom) === (v == null ? void 0 : v.denom) && z;
}
const useTokenSorter = ({
  chainId: v,
  baseDenom: y,
  fetchChainBalances: z
}) => {
  var le;
  const ne = z({
    chainId: v
  });
  return useMemo(() => {
    var ge;
    const he = (ge = ne.data) == null ? void 0 : ge.balances;
    return (we) => {
      const Ee = [], xe = [];
      we.forEach((Ne) => {
        y && isNativeAsset(Ne, y) ? Ee.push(Ne) : xe.push(Ne);
      });
      const $e = he ? getCosmosTokenSorter(he) : (Ne, st) => Ne.symbol.localeCompare(st.symbol);
      return [...Ee.sort($e), ...xe.sort($e)];
    };
  }, [y, (le = ne.data) == null ? void 0 : le.balances]);
}, channelRegex = /channel-(\d)+/, channelRegexGlobal = /channel-(\d)+/g, SkipAssetItemRaw = ({ asset: v, tokenBalance: y, chainId: z }) => {
  var Ee, xe, $e;
  const { data: ne } = useChains(), ue = useMemo(() => ne == null ? void 0 : ne.find((Ne) => Ne.chainId === v.originChainId), [v.originChainId, ne]), le = useMemo(() => ne == null ? void 0 : ne.find((Ne) => Ne.chainId === z), [z, ne]), he = useMemo(() => {
    var Ne, st;
    return formatAmount(((st = (Ne = y.data) == null ? void 0 : Ne.amount) == null ? void 0 : st.toString()) ?? 0);
  }, [y.data]), ge = useMemo(() => v.trace ? Array.from(v.trace.matchAll(channelRegexGlobal)).length > 1 : !1, [v.trace]), we = useSWR(
    ge ? `asset-${v.denom}-${v.trace}-source-chain` : null,
    async () => {
      if (!v.trace || !le)
        return;
      const Ne = v.trace.matchAll(
        new RegExp(channelRegexGlobal)
      );
      if (Ne) {
        const Nr = Array.from(Ne)[0][0], br = await getDestinationChainIdFromSourceChannelId(
          le,
          Nr
        );
        return ne == null ? void 0 : ne.find(($n) => $n.chainId === br);
      }
    },
    {
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1,
      refreshWhenOffline: !1,
      refreshWhenHidden: !1,
      refreshInterval: 0,
      dedupingInterval: 1 / 0
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-full w-full items-start justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "text-foreground max-w-[8rem] truncate font-bold", children: v.symbol }),
      v.trace ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "bg-muted text-card-foreground mt-1 max-w-[8rem] truncate rounded text-[0.625rem] px-1 py-0.5 leading-[150%]", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: ge ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: we.isLoading ? "Loading Chain" : (Ee = we.data) == null ? void 0 : Ee.chainName }) : ue == null ? void 0 : ue.chainName }),
        " ",
        "·",
        " ",
        ($e = (xe = v.trace.match(channelRegex)) == null ? void 0 : xe[0]) == null ? void 0 : $e.replace("channel-", "ch-")
      ] }) : null
    ] }),
    y.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: y.data ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-muted-foreground max-w-[6rem] self-center truncate text-xs", children: [
      he,
      " ",
      v.symbol
    ] }) : null })
  ] });
}, SkipAssetItem = memo$1(SkipAssetItemRaw), formatUptoSixDecimals = (v) => {
  const y = parseFloat(v);
  return isNaN(y) ? "" : Intl.NumberFormat("en", {
    maximumFractionDigits: y > 100 ? 2 : y > 1 ? 4 : 6,
    notation: "standard",
    useGrouping: !1
  }).format(y);
}, SourceSelect$1 = ({
  title: v,
  classNames: y,
  assets: z,
  chains: ne,
  inputValue: ue,
  setInputValue: le,
  selectedChainId: he,
  setSelectedChainId: ge,
  selectedAsset: we,
  setSelectedAsset: Ee,
  tokenBalance: xe,
  popularChainIds: $e,
  sourceChainData: Ne,
  selectedChainError: st,
  fetchChainBalances: Nr
}) => {
  const [br, $n] = useState(!1), [En, Rn] = useState(
    ue.toString()
  ), wa = useSourceRestrictionsContext(), Aa = useCallback(
    (ye) => {
      if (wa != null && wa.chains) {
        const Se = wa.chains;
        return Array.isArray(Se) ? ye.filter(
          (Oe) => Se.some((Fr) => Fr.chainId === Oe.chainId)
        ) : ye.filter(
          (Oe) => Se.chainTypes.includes(Oe.chainType)
        );
      }
      return ye;
    },
    [wa]
  ), _a = useMemo(() => {
    const ye = wa == null ? void 0 : wa.chains;
    if (ye)
      if (Array.isArray(ye)) {
        const Se = ye.find(
          (Fr) => Fr.chainId === he
        );
        if (!Se)
          return;
        const { assetDenoms: Oe } = Se;
        return Oe ? (Fr) => Oe.findIndex((zn) => typeof zn == "string" ? zn === Fr.denom : zn.originDenom === Fr.originDenom && zn.originChainId === Fr.originChainId) > -1 : void 0;
      } else
        return;
  }, [wa, he]), Ta = useMemo(() => {
    const ye = ue.trim(), Se = parseFloat(ye);
    return isNaN(Se) ? 0 : Se;
  }, [ue]), Zn = Nr({
    chainId: he
  }), Ra = useTokenSorter({
    chainId: he,
    baseDenom: Ne == null ? void 0 : Ne.baseDenom,
    fetchChainBalances: Nr
  }), Yn = useMemo(() => {
    var ye;
    if (he)
      return (ye = z.data) == null ? void 0 : ye[he];
  }, [z.data, he]), $o = useMemo(() => {
    if (!(!we || !Yn))
      return Yn.find((ye) => ye.denom === we);
  }, [Yn, we]), ct = $o == null ? void 0 : $o.coingeckoId, { data: fe, isLoading: be } = useUSDPrice(
    ct
  );
  return useEffect(() => {
    !fe && br && $n(!1);
  }, [fe, br]), useEffect(() => {
    if (br && fe) {
      if (!En.trim()) {
        le("");
        return;
      }
      const Se = new BigNumber$1(En).dividedBy(
        fe
      );
      le(formatUptoSixDecimals(Se.toString()));
    } else
      le(En);
  }, [En, br, fe, le]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("bg-card rounded-xl", y), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b px-4 py-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-muted-foreground text-sm", children: v ?? "You pay" }),
      ne.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-8 w-36 rounded-3xl border" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChainSelect,
        {
          chains: ne,
          filterChains: Aa,
          selectedChainId: he,
          setSelectedChainId: ge,
          popularChainIds: $e,
          selectedChainError: st
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 py-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1 max-w-[60%] overflow-x-auto no-scrollbar", children: [
          br ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-3xl font-medium", children: "$" }) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Cb,
            {
              type: "number",
              variant: "unstyled",
              step: 0.05,
              min: 0,
              className: Y$1(
                "text-card-foreground text-3xl font-medium",
                En ? {
                  "text-2xl": En.length > 10,
                  "text-xl": En.length > 14,
                  "text-lg": En.length > 18
                } : ""
              ),
              placeholder: "0",
              value: En,
              onChange: (ye) => Rn(ye.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: z.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-10 w-32 rounded-3xl border" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          AssetSelect,
          {
            assets: z,
            selectedChainId: he,
            selectedAsset: we,
            setSelectedAsset: Ee,
            assetFilter: _a,
            defaultSorter: Ra,
            getIsSelected: (ye, Se) => ye.denom === Se,
            children: (ye) => {
              var Se, Oe;
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                SkipAssetItem,
                {
                  asset: ye,
                  chainId: he,
                  tokenBalance: {
                    isWalletConnected: xe.isWalletConnected,
                    error: xe.error,
                    isLoading: xe.isLoading,
                    data: (Oe = (Se = Zn.data) == null ? void 0 : Se.balances) == null ? void 0 : Oe[ye.denom]
                  }
                },
                ye.denom
              );
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1.5", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            np,
            {
              title: br ? "Switch to crypto input" : "Switch to USD input",
              variant: "secondary",
              size: "xs-icon",
              className: "rounded-3xl",
              disabled: be || !fe || new BigNumber$1(fe ?? 0).isLessThan(10 ** -6),
              onClick: () => {
                if (invariant$1(fe, "USD price is not available"), br) {
                  $n(!1);
                  const ye = new BigNumber$1(En).dividedBy(
                    fe
                  );
                  Rn(
                    formatUptoSixDecimals(ye.toString())
                  );
                } else {
                  $n(!0);
                  const ye = new BigNumber$1(En).multipliedBy(
                    fe
                  );
                  Rn(formatUptoSixDecimals(ye.toString()));
                }
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(D$4, { weight: "bold", size: "0.625rem" })
            }
          ),
          br ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-muted-foreground text-sm", children: [
            formatAmount(Ta.toString(), 2, 6),
            " ",
            ($o == null ? void 0 : $o.symbol) ?? ""
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            FiatValueDisplay,
            {
              amount: Ta.toString(),
              coingeckoId: ct
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TokenBalance,
          {
            classNames: "mt-2",
            withMaxButton: !0,
            compareWithAmount: ue,
            onMaxClick: (ye) => {
              if (br) {
                invariant$1(fe, "USD price is not available");
                const Se = new BigNumber$1(ye).multipliedBy(
                  fe
                );
                Rn(formatUptoSixDecimals(Se.toString()));
              } else
                Rn(ye);
            },
            tokenBalance: xe
          }
        )
      ] })
    ] })
  ] });
}, DestinationSelect = ({
  classNames: v,
  chains: y,
  selectedChainId: z,
  selectedAsset: ne,
  popularChainIds: ue,
  assets: le,
  setSelectedAsset: he,
  setSelectedChainId: ge,
  tokenBalance: we,
  amountOut: Ee,
  isLoadingRoute: xe,
  isValidatingRoute: $e,
  selectedChainError: Ne,
  fetchChainBalances: st,
  conversionRate: Nr,
  fiatData: br
}) => {
  const $n = useDestinationRestrictionsContext(), En = useCallback(
    ($o) => {
      if ($n != null && $n.chains) {
        const ct = $n.chains;
        return Array.isArray(ct) ? $o.filter(
          (fe) => ct.some((be) => be.chainId === fe.chainId)
        ) : $o.filter(
          (fe) => ct.chainTypes.includes(fe.chainType)
        );
      }
      return $o;
    },
    [$n]
  ), Rn = useMemo(() => {
    const $o = $n == null ? void 0 : $n.chains;
    if ($o)
      if (Array.isArray($o)) {
        const ct = $o.find(
          (be) => be.chainId === z
        );
        if (!ct)
          return;
        const { assetDenoms: fe } = ct;
        return fe ? (be) => fe.findIndex((ye) => typeof ye == "string" ? ye === be.denom : ye.originDenom === be.originDenom && ye.originChainId === be.originChainId) > -1 : void 0;
      } else
        return;
  }, [$n, z]), wa = useMemo(() => {
    if (Ee.trim())
      return isNaN(parseFloat(Ee)) ? "0" : formatAmount(Ee, 2, 6);
  }, [Ee]), Aa = useMemo(() => {
    var $o;
    if (z)
      return ($o = y.data) == null ? void 0 : $o.find((ct) => ct.chainId === z);
  }, [y.data, z]), _a = st({
    chainId: z
  }), Ta = useTokenSorter({
    chainId: z,
    baseDenom: Aa == null ? void 0 : Aa.baseDenom,
    fetchChainBalances: st
  }), Zn = useMemo(() => {
    var $o;
    if (z)
      return ($o = le.data) == null ? void 0 : $o[z];
  }, [le.data, z]), Ra = useMemo(() => {
    if (!(!ne || !Zn))
      return Zn.find(($o) => $o.denom === ne);
  }, [Zn, ne]), Yn = useCallback(
    ($o, ct) => $o.denom === ct,
    []
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("bg-card rounded-xl", v), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between border-b px-4 py-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-muted-foreground text-sm", children: "You get" }),
      y.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-8 w-36 rounded-3xl border" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        ChainSelect,
        {
          chains: y,
          filterChains: En,
          selectedChainId: z,
          setSelectedChainId: ge,
          popularChainIds: ue,
          selectedChainError: Ne
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 py-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between gap-2", children: [
        xe || $e ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-10 w-16 rounded-md" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          "p",
          {
            className: Y$1(
              "text-card-foreground text-3xl font-medium max-w-[60%] overflow-x-auto no-scrollbar",
              wa ? {
                "text-2xl": wa.length > 10,
                "text-xl": wa.length > 14,
                "text-lg": wa.length > 18
              } : ""
            ),
            children: wa ?? "0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: le.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-10 w-32 rounded-3xl border" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          AssetSelect,
          {
            assets: le,
            selectedChainId: z,
            selectedAsset: ne,
            setSelectedAsset: he,
            getIsSelected: Yn,
            defaultSorter: Ta,
            assetFilter: Rn,
            children: ($o) => {
              var ct, fe;
              return /* @__PURE__ */ jsxRuntimeExports.jsx(
                SkipAssetItem,
                {
                  asset: $o,
                  chainId: z,
                  tokenBalance: {
                    isWalletConnected: we.isWalletConnected,
                    error: we.error,
                    isLoading: we.isLoading,
                    data: (fe = (ct = _a.data) == null ? void 0 : ct.balances) == null ? void 0 : fe[$o.denom]
                  }
                },
                $o.denom
              );
            }
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          FiatValueDisplay,
          {
            amount: Ee.toString(),
            coingeckoId: Ra == null ? void 0 : Ra.coingeckoId,
            conversionRate: Nr,
            fiatData: br
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TokenBalance, { classNames: "mt-2", tokenBalance: we })
      ] })
    ] })
  ] });
}, IBCTransferPill = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "inline-block", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center bg-background gap-2 rounded-3xl py-1 px-2 border border-[#B558E4]", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-[#C984EB] rounded-3xl p-1", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCIcon, { size: "10" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "IBC Transfer" })
] }) }), ReviewAssetInformationSkeleton = ({ type: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "text-muted-foreground text-sm", children: [
    "You ",
    v === "source" ? "pay" : "get"
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-3 flex items-center justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-9 w-40 text-3xl font-bold" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative mr-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-9 w-9 rounded-3xl shadow-[0_0_0_0.5rem_hsl(var(--border))]" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "absolute -bottom-2 -right-2 h-4 w-4 rounded-3xl shadow-[0_0_0_0.2rem_hsl(var(--border))]" })
    ] })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-4 w-36 rounded-xl" }) })
] }), ReviewAssetInformation = ({
  type: v,
  amount: y,
  assetSymbol: z,
  assetLogoUri: ne,
  assetCoingeckoId: ue,
  chainLogoUri: le,
  chainName: he,
  destinationAddress: ge,
  isIBCTransfer: we
}) => {
  const Ee = useUSDPrice(ue);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-muted-foreground text-sm", children: v === "source" || v === "destination" ? `You ${v === "source" ? "pay" : "get"}` : `${v === "send" ? "You're sending" : "To"}` }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex items-center justify-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-card-foreground text-3xl font-bold", children: v === "receive" ? sliceAddress(ge) : `${formatAmount(y, 2, 6)} ${z}` }),
        we ? /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferPill, {}) : null
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative mr-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "bg-background h-9 w-9 shadow-[0_0_0_0.5rem_hsl(var(--border))]", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: ne }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: v === "receive" ? /* @__PURE__ */ jsxRuntimeExports.jsx(UserFallbackIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "bg-background absolute -bottom-2 -right-2 h-4 w-4 shadow-[0_0_0_0.2rem_hsl(var(--border))]", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: le }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-1", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-muted-foreground text-sm", children: [
      v !== "receive" && Ee.data ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: formatAmountWithPrefix(
          Ee.data * parseFloat(y),
          "$",
          2
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mx-1.5 font-bold", children: "·" })
      ] }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        "on ",
        he
      ] })
    ] }) })
  ] });
}, SwapsTrackingContext = createContext(void 0), SwapsTrackingProvider = ({
  children: v,
  gasFees: y,
  routeResponse: z,
  messages: ne,
  txnLifecycleHooks: ue,
  tab: le,
  updateOngoingTransactions: he,
  ongoingSwap: ge
}) => {
  const { data: we } = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), { data: Ee } = useDenoms(), { data: xe } = useWalletClient(), { walletClient: $e } = useWalletClientContext(), { wallet: Ne } = useWallet(), st = useRef(!1), [Nr, br] = useState(
    (ge == null ? void 0 : ge.activeTxnIndex) ?? 0
  ), [$n, En] = useState(!1), [Rn, wa] = useState(
    ge ? "IN_PROGRESS" : "UNINITIALIZED"
  ), Aa = useMemo(() => `${z.amountIn}-${z.sourceAsset.denom}:${z.amountOut}-${z.destinationAsset.denom}:${z.transactionCount}`, [z]), _a = useRef({
    routeId: Aa,
    uuid: v4()
  });
  useEffect(() => {
    _a.current.routeId !== Aa && (_a.current = {
      routeId: Aa,
      uuid: v4()
    });
  }, [Aa]);
  const Ta = useMemo(
    () => ({
      ...z,
      messages: ne
    }),
    [ne, z]
  ), { groupedTransactions: Zn } = useTransactions(Ta), [Ra, Yn] = useState(), $o = z.transactionCount, [ct, fe] = useState(
    (ge == null ? void 0 : ge.txnStatuses) ?? getDefaultTxnStatuses(z)
  ), be = useCallback(
    (Oa, Os) => {
      fe((Pa) => {
        const Ml = [...Pa];
        return Ml[Oa] = Os, Ml;
      });
    },
    []
  ), ye = ct.map((Oa) => {
    if (Oa.status === NewTxnStatus.BROADCASTED)
      return {
        chainID: Oa.chainId,
        txHash: Oa.txHash
      };
  }).filter((Oa) => !!Oa), Se = useBroadcastedTxsStatus({
    txs: ye,
    txsRequired: z.transactionCount
  }), Oe = useCallback(
    async ({ msg: Oa }) => {
      var Lu, th, Zc, N1, Gh;
      const Os = Nr, Pa = Oa.svm_tx;
      if (!we || !Ne)
        return;
      const Ml = we.find(
        (Mc) => Mc.chainId === Pa.chain_id
      );
      if (!Ml) {
        Yn(
          new TxnError(
            0,
            Os,
            `Chain ${Pa.chain_id} not supported by elements`
          )
        ), st.current = !1;
        return;
      }
      if (!(Ne != null && Ne.adapter)) {
        Yn(
          new TxnError(0, Os, "Failed to retrieve signer")
        ), st.current = !1;
        return;
      }
      const Su = (Lu = ue == null ? void 0 : ue.onTxnInProgress) == null ? void 0 : Lu.call(ue, le);
      be(Os, {
        status: NewTxnStatus.NEEDS_APPROVAL
      });
      const Tu = {
        chainType: "svm",
        chainId: Ml.chainId,
        chainName: Ml.chainName
      };
      (th = ue == null ? void 0 : ue.onTxnSignInit) == null || th.call(ue, Tu);
      const Au = Buffer.from(Pa.tx, "base64"), Zl = Transaction.from(Au), Iu = Ne.adapter;
      let Uc, Pu;
      if ("signTransaction" in Iu)
        try {
          Pu = (await Iu.signTransaction(Zl)).serialize(), be(Os, {
            status: NewTxnStatus.SIGNED
          });
        } catch (Mc) {
          be(Os, {
            status: NewTxnStatus.IDLE
          }), Mc instanceof Error ? Yn(new TxnError(3, Os, Mc.message)) : Yn(
            new TxnError(-1, Os, "An unknown error occurred")
          ), (Zc = ue == null ? void 0 : ue.onTxnSignFailed) == null || Zc.call(
            ue,
            Tu,
            Mc instanceof Error ? Mc : new Error("An unknown error occurred")
          ), Su == null || Su(), st.current = !1;
          return;
        }
      if (!Pu) {
        Yn(
          // Basically txn was rejected from wallet, so use code 3
          new TxnError(3, Os, "Failed to sign transaction")
        ), be(Os, {
          status: NewTxnStatus.IDLE
        }), Su == null || Su(), st.current = !1;
        return;
      }
      be(Os, {
        status: NewTxnStatus.BROADCASTING
      });
      try {
        const Mc = await SkipAPI.submitTransaction({
          chain_id: Pa.chain_id,
          tx: Buffer.from(Pu).toString("base64")
        });
        if (Mc.success)
          (N1 = ue == null ? void 0 : ue.onTxnSignApproved) == null || N1.call(ue, {
            ...Tu,
            txHash: Mc.response.tx_hash
          }), Su == null || Su(), Uc = Mc.response.tx_hash, st.current = !1;
        else if (!Mc.success)
          throw new Error(Mc.error);
      } catch (Mc) {
        be(Os, {
          status: NewTxnStatus.IDLE
        }), Mc instanceof Error ? Yn(new TxnError(4, Os, Mc.message)) : Yn(
          new TxnError(
            5,
            Os,
            "An unknown error occurred while broadcasting the transaction"
          )
        ), (Gh = ue == null ? void 0 : ue.onTxnSignFailed) == null || Gh.call(
          ue,
          Tu,
          Mc instanceof Error ? Mc : new Error("An unknown error occurred")
        ), Su == null || Su(), st.current = !1;
        return;
      }
      if (!Uc) {
        Yn(
          new TxnError(5, Os, "Transaction broadcast failed")
        ), be(Os, {
          status: NewTxnStatus.IDLE
        }), Su == null || Su(), st.current = !1;
        return;
      }
      be(Os, {
        status: NewTxnStatus.BROADCASTED,
        txHash: Uc,
        chainId: Ml.chainId
      });
    },
    [
      we,
      Ne,
      Nr,
      ue,
      be,
      le
    ]
  ), Fr = useCallback(
    async ({ msg: Oa }) => {
      var Pu, Lu, th, Zc, N1;
      if (!xe || !we)
        return;
      const Os = Nr, Pa = Oa.evm_tx, Ml = we.find(
        (Gh) => Gh.chainId === Pa.chain_id
      );
      if (!Ml) {
        Yn(
          new TxnError(
            0,
            Os,
            `Chain ${Pa.chain_id} not supported by elements`
          )
        ), st.current = !1;
        return;
      }
      const Su = (Pu = ue == null ? void 0 : ue.onTxnInProgress) == null ? void 0 : Pu.call(ue, le);
      if (be(Os, {
        status: NewTxnStatus.NEEDS_APPROVAL
      }), !(xe != null && xe.account)) {
        Yn(
          new TxnError(
            0,
            Os,
            "Failed to retrieve account from signer"
          )
        ), st.current = !1;
        return;
      }
      const Tu = {
        chainType: "evm",
        chainId: Number(Ml.chainId),
        chainName: Ml.chainName
      };
      (Lu = ue == null ? void 0 : ue.onTxnSignInit) == null || Lu.call(ue, Tu);
      let Au;
      const Zl = xe.extend(publicActions);
      try {
        for (const Gh of Pa.required_erc20_approvals) {
          if (await Zl.readContract({
            address: Gh.token_contract,
            abi: erc20ABI,
            functionName: "allowance",
            args: [
              xe.account.address,
              Gh.spender
            ]
          }) > BigInt(Gh.amount))
            continue;
          const h1 = await Zl.writeContract({
            account: xe.account,
            address: Gh.token_contract,
            abi: erc20ABI,
            functionName: "approve",
            args: [Gh.spender, maxUint256],
            chain: xe.chain
          }), l2 = await Zl.waitForTransactionReceipt({
            hash: h1
          });
          if (l2.status === "reverted")
            throw new Error(
              `executeEVMTransaction error: evm tx reverted for hash ${l2.transactionHash}`
            );
        }
        Au = await Zl.sendTransaction({
          account: xe.account,
          to: Pa.to,
          data: `0x${Pa.data}`,
          chain: xe.chain,
          value: Pa.value === "" ? void 0 : BigInt(Pa.value)
        }), be(Os, {
          status: NewTxnStatus.SIGNED
        });
      } catch (Gh) {
        be(Os, {
          status: NewTxnStatus.IDLE
        }), Gh instanceof Error ? Gh.message.includes("rejected") || Gh.message.includes("declined") ? Yn(
          new TxnError(
            3,
            Os,
            "Please approve the transaction from your wallet"
          )
        ) : Yn(new TxnError(-1, Os, Gh.message)) : Yn(
          new TxnError(-1, Os, "An unknown error occurred")
        ), (th = ue == null ? void 0 : ue.onTxnSignFailed) == null || th.call(
          ue,
          Tu,
          Gh instanceof Error ? Gh : new Error("An unknown error occurred")
        ), Su == null || Su(), st.current = !1;
        return;
      }
      be(Os, {
        status: NewTxnStatus.BROADCASTING
      });
      let Iu;
      try {
        Iu = await Zl.waitForTransactionReceipt({
          hash: Au
        }), (Zc = ue == null ? void 0 : ue.onTxnSignApproved) == null || Zc.call(ue, {
          ...Tu,
          txHash: Au
        });
      } catch (Gh) {
        be(Os, {
          status: NewTxnStatus.IDLE
        }), Gh instanceof Error ? Yn(new TxnError(5, Os, Gh.message)) : Yn(
          new TxnError(
            5,
            Os,
            "An unknown error occurred while broadcasting the transaction"
          )
        ), (N1 = ue == null ? void 0 : ue.onTxnSignFailed) == null || N1.call(
          ue,
          Tu,
          Gh instanceof Error ? Gh : new Error("An unknown error occurred")
        ), Su == null || Su(), st.current = !1;
        return;
      }
      const Uc = await sendTrackingRequest(
        Ml.chainId,
        Iu.transactionHash
      );
      Uc != null && Uc.success || Yn(
        new TxnError(
          9,
          Os,
          `Unable to track transaction. Please check the status on the explorer #${Iu.transactionHash}`
        )
      ), be(Os, {
        status: NewTxnStatus.BROADCASTED,
        txHash: Iu.transactionHash,
        chainId: Ml.chainId
      }), Su == null || Su(), st.current = !1;
    },
    [
      we,
      xe,
      Nr,
      ue,
      be,
      le
    ]
  ), { data: zn } = useGasAdjustment(), { data: Fe } = useGasPriceSteps(), pe = useCallback(
    async ({ msg: Oa }) => {
      var Kc, M2, d1, K1, k2;
      if (!$e || !we || !Ee)
        return;
      const Os = Nr, Pa = Oa.cosmos_tx, Ml = we.find(
        (Eu) => Eu.chainId === Pa.chain_id
      );
      if (!Ml) {
        Yn(
          new TxnError(
            0,
            Os,
            `Chain ${Pa.chain_id} not supported by elements`
          )
        ), st.current = !1;
        return;
      }
      const Su = (Kc = ue == null ? void 0 : ue.onTxnInProgress) == null ? void 0 : Kc.call(ue, le), Tu = Pa.msgs.map((Eu) => {
        const Zo = JSON.parse(Eu.msg), { encodedMessage: Fl } = getMessageMetadataForSigning(
          Eu.msg_type_url,
          Zo
        );
        return Fl;
      });
      be(Os, {
        status: NewTxnStatus.NEEDS_APPROVAL
      });
      const { data: Au, error: Zl } = await handlePromise(
        $e.getAccount(Ml.chainId)
      );
      if (Zl || !Au) {
        Yn(
          new TxnError(
            6,
            Os,
            `Couldn't fetch account for chain ${Ml.chainName} from wallet`
          )
        ), st.current = !1;
        return;
      }
      const Iu = Tu[0], Uc = getDecodedMessageMetadataForSigning(Iu), { data: Pu } = await handlePromise(async () => {
        var kc;
        const { data: Eu, error: Zo } = await handlePromise(
          simulateTx(Ml.restUrl, Au.bech32Address, [Uc])
        );
        if (Zo || Eu === void 0)
          throw new Error("Simulation failed");
        const Fl = (zn == null ? void 0 : zn[Ml.key]) ?? 1.5, Ru = new BigNumber(
          ((kc = Fe == null ? void 0 : Fe[Ml.key]) == null ? void 0 : kc.low) ?? 0.025
        );
        return calculateFee(
          Eu.gasUsed,
          Ru.toNumber(),
          Ml.baseDenom,
          Fl
        );
      }), Lu = Pu ?? y[Os];
      if (!Lu) {
        Yn(
          new TxnError(
            1,
            Os,
            `Couldn't calculate fee for ${Ml.chainName} transaction`
          )
        ), st.current = !1;
        return;
      }
      const { data: th, error: Zc } = await handlePromise(
        $e.getSigner(Ml.chainId)
      );
      if (Zc || !th) {
        Yn(
          new TxnError(
            7,
            Os,
            `Couldn't request approval for ${Ml.chainName} transaction from wallet`
          )
        ), st.current = !1;
        return;
      }
      const N1 = new TxClient(
        Ml.chainId,
        Ml.restUrl,
        Ml.coinType,
        th,
        Au
      ), Gh = await getMessageWithInfo(
        Tu[0],
        Ml,
        {
          chains: we,
          denoms: Ee
        }
      ), Mc = {
        chainType: "cosmos",
        chainId: Ml.chainId,
        chainName: Ml.chainName,
        signMode: Au.isNanoLedger ? "amino" : "direct",
        transactionTypes: [Gh.typeUrl],
        messages: [Gh]
      };
      (M2 = ue == null ? void 0 : ue.onTxnSignInit) == null || M2.call(ue, Mc);
      const h1 = {
        current: void 0
      };
      try {
        const Eu = await Promise.race([
          N1.sign(Au.bech32Address, Tu, Lu, ""),
          sleep(3e4)
        ]);
        if (typeof Eu == "string")
          h1.current = Eu;
        else
          throw new Error("Transaction approval timed out");
        be(Os, {
          status: NewTxnStatus.SIGNED
        });
      } catch (Eu) {
        be(Os, {
          status: NewTxnStatus.IDLE
        }), Eu instanceof Error ? Eu.message.includes("rejected") || Eu.message.includes("declined") ? Yn(
          new TxnError(
            3,
            Os,
            "Please approve the transaction from your wallet"
          )
        ) : Eu.message.includes("timed out") ? Yn(
          new TxnError(
            8,
            Os,
            "Transaction approval timed out"
          )
        ) : Yn(new TxnError(-1, Os, Eu.message)) : Yn(
          new TxnError(-1, Os, "An unknown error occurred")
        ), (d1 = ue == null ? void 0 : ue.onTxnSignFailed) == null || d1.call(
          ue,
          Mc,
          Eu instanceof Error ? Eu : new Error("An unknown error occurred")
        ), Su == null || Su(), st.current = !1;
        return;
      }
      let l2, Gc;
      try {
        const Eu = await getSwapData(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          Zn[`Transaction ${Os + 1}`],
          we,
          Ee
        );
        Gc = {
          swapId: _a.current.uuid,
          fromTokenAmount: "",
          toTokenAmount: "",
          ...Eu
        };
      } catch {
      }
      if (!h1.current) {
        be(Os, {
          status: NewTxnStatus.IDLE
        }), Yn(
          new TxnError(-1, Os, "No transaction data was found")
        ), Su == null || Su(), st.current = !1;
        return;
      }
      be(Os, {
        status: NewTxnStatus.BROADCASTING
      });
      try {
        const { success: Eu, response: Zo } = await N1.submitTx(
          Ml.chainId,
          h1.current
        );
        if (!Eu)
          throw new Error("Skip SubmitTx Failed");
        l2 = Zo == null ? void 0 : Zo.tx_hash, (K1 = ue == null ? void 0 : ue.onTxnSignApproved) == null || K1.call(ue, {
          ...Mc,
          txHash: l2,
          fees: Lu.amount,
          data: Gc
        }), be(Os, {
          status: NewTxnStatus.BROADCASTED,
          txHash: l2,
          chainId: Ml.chainId
        }), Su == null || Su(), st.current = !1;
      } catch {
        try {
          const {
            transactionHash: Zo,
            code: Fl,
            codespace: Ru
          } = await N1.broadcastTx(h1.current);
          if (l2 = Zo, (k2 = ue == null ? void 0 : ue.onTxnSignApproved) == null || k2.call(ue, {
            ...Mc,
            txHash: l2,
            fees: Lu.amount,
            data: Gc
          }), Fl !== 0)
            be(Os, {
              status: NewTxnStatus.IDLE
            }), Yn(
              new TxnError(
                4,
                Os,
                `Transaction failed ${getErrorMessageFromCode(
                  Fl,
                  Ru
                )}`
              )
            );
          else {
            const ku = await sendTrackingRequest(Ml.chainId, l2);
            ku != null && ku.success || Yn(
              new TxnError(
                9,
                Os,
                `Unable to track transaction. Please check the status on the explorer ${Ml.txExplorer.mainnet}/${l2}`
              )
            ), be(Os, {
              status: NewTxnStatus.BROADCASTED,
              txHash: l2,
              chainId: Ml.chainId
            });
          }
          Su == null || Su(), st.current = !1;
        } catch (Zo) {
          be(Os, {
            status: NewTxnStatus.IDLE
          }), Zo instanceof Error ? Yn(new TxnError(5, Os, Zo.message)) : Yn(
            new TxnError(
              5,
              Os,
              "An unknown error occurred while broadcasting the transaction"
            )
          ), Su == null || Su(), st.current = !1;
          return;
        }
      }
    },
    [
      $e,
      we,
      Ee,
      Zn,
      Nr,
      ue,
      be,
      le,
      y,
      zn,
      Fe
    ]
  ), it = useCallback(async () => {
    if (st.current)
      return;
    wa("IN_PROGRESS"), st.current = !0;
    const Oa = Nr;
    Yn(void 0);
    const Os = ne[Oa];
    if ("evm_tx" in Os)
      return Fr({ msg: Os });
    if ("cosmos_tx" in Os)
      return Os.cosmos_tx.msgs.forEach((Pa) => {
        const Ml = JSON.parse(Pa.msg), Su = (/* @__PURE__ */ new Date()).getTime();
        if (Number(Ml.timeout_timestamp / 10 ** 6) < Su) {
          Yn(
            new TxnError(
              2,
              Oa,
              `Transaction ${Oa + 1} has timed out`
            )
          ), st.current = !1;
          return;
        }
      }), pe({ msg: Os });
    if ("svm_tx" in Os)
      return Oe({ msg: Os });
  }, [ne, Nr, pe, Fr, Oe]), xa = useMemo(() => {
    var Oa, Os, Pa, Ml, Su, Tu, Au;
    if (Ra)
      switch (Ra.code) {
        case 0:
        case 1:
          return {
            status: "FATAL_ERROR",
            title: "Chain not supported",
            message: Ra.message
          };
        case 2:
          return {
            status: "FATAL_ERROR",
            title: "Transaction timed out",
            message: Ra.message
          };
        case 3:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: Ra.message
          };
        case 4:
          return {
            status: "FATAL_ERROR",
            title: "Transaction failed",
            message: Ra.message
          };
        case 5:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Transaction broadcast failed",
            message: Ra.message
          };
        case 6:
        case 7:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: Ra.message
          };
        case 8:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval timed out",
            message: Ra.message
          };
        case 9:
          return {
            status: "CANNOT_TRACK"
          };
        default:
          return {
            status: "FATAL_ERROR",
            title: "An unknown error occurred",
            message: Ra.message
          };
      }
    if (Se.error)
      return {
        status: "CANNOT_TRACK"
      };
    if (Se.data) {
      const Zl = ct[Nr];
      if ((Zl == null ? void 0 : Zl.status) === NewTxnStatus.BROADCASTED) {
        const Iu = Se.data.states[Nr], Uc = (Pa = (Os = (Oa = Se.data) == null ? void 0 : Oa.grouped) == null ? void 0 : Os[Nr]) == null ? void 0 : Pa.transferAssetRelease;
        if (((Au = (Tu = (Su = (Ml = Se.data.grouped) == null ? void 0 : Ml[Nr]) == null ? void 0 : Su.transferSequence) == null ? void 0 : Tu[0]) == null ? void 0 : Au.type) === "cctpTransfer" && Iu === "STATE_RECEIVED")
          return {
            status: "IN_PROGRESS"
          };
        switch (Iu) {
          case "STATE_SUBMITTED":
          case "STATE_PENDING":
            return {
              status: "IN_PROGRESS"
            };
          case "STATE_UNKNOWN":
          case "STATE_ABANDONED":
            return {
              status: "CANNOT_TRACK"
            };
          case "STATE_PENDING_ERROR":
          case "STATE_COMPLETED_ERROR":
            return {
              status: "FAILED"
            };
          case "STATE_RECEIVED":
          case "STATE_COMPLETED":
          case "STATE_COMPLETED_SUCCESS":
            return Nr + 1 < (z == null ? void 0 : z.transactionCount) ? {
              status: "SUCCESS"
            } : Nr + 1 === (z == null ? void 0 : z.transactionCount) && (Uc == null ? void 0 : Uc.chainID) === z.destinationAssetChain.chainId ? {
              status: "SUCCESS"
            } : {
              status: "FAILED"
            };
        }
      } else
        switch (Zl == null ? void 0 : Zl.status) {
          case NewTxnStatus.IDLE:
          case NewTxnStatus.NEEDS_APPROVAL:
            return {
              status: "SIGNATURE_REQUIRED"
            };
          case NewTxnStatus.SIGNED:
            return {
              status: "SIGNATURE_RECEIVED"
            };
          case NewTxnStatus.BROADCASTING:
            return {
              status: "BROADCASTING"
            };
        }
    }
  }, [Nr, Ra, ct, Se, z]);
  useConsoleLog("AggregatedSwaps", "swapStatus", xa), useConsoleLog("AggregatedSwaps", "lastError", Ra), useConsoleLog("AggregatedSwaps", "txnTrackingData", Se.data), useConsoleLog("AggregatedSwaps", "overallSwapStatus", Rn), useEffect(() => {
    Ra && En(!0);
  }, [Ra]), useEffect(() => {
    ct[Nr].status === NewTxnStatus.BROADCASTED && he({
      activeTxnIndex: Nr,
      txnStatuses: ct,
      lastError: Ra
    });
  }, [Ra, Nr, ct]), useEffect(() => {
    Rn === "SUCCESS" && En(!1);
  }, [Rn]);
  const wo = useMemo(() => ({
    sourceChain: z.sourceAssetChain,
    sourceAsset: z.sourceAsset,
    destinationChain: z.destinationAssetChain,
    destinationAsset: z.destinationAsset,
    inputAmount: z.amountIn,
    outAmount: z.amountOut
  }), [z]);
  useEffect(() => {
    xa && (xa.status === "SUCCESS" ? Nr === $o - 1 ? wa("SUCCESS") : br(Nr + 1) : (xa.status === "FAILED" || xa.status === "FATAL_ERROR") && wa("FAILED"));
  }, [
    Nr,
    wo,
    xa,
    $o,
    ue
  ]), useEffect(() => {
    Nr > 0 && (ge == null ? void 0 : ge.activeTxnIndex) !== $o - 1 && Rn !== "SUCCESS" && it();
  }, [Nr, ge, $o]);
  const _u = useMemo(() => ({
    swapStatus: xa,
    ongoingSwap: ge,
    overallSwapStatus: Rn,
    isTxnTrackerOpen: $n,
    setIsTxnTrackerOpen: En,
    executeRoute: it,
    activeTxnIndex: Nr,
    setActiveTxnIndex: br,
    txnStatuses: ct,
    setTxnStatuses: fe,
    lastError: Ra,
    routeResponse: z,
    messages: ne,
    gasFees: y,
    txnLifecycleHooks: ue,
    tab: le,
    groupedTransactions: Zn,
    txnTracking: Se,
    updateOngoingTransactions: he
  }), [
    Nr,
    it,
    $n,
    Ra,
    Rn,
    xa,
    ct,
    z,
    ne,
    ge,
    y,
    ue,
    le,
    Zn,
    Se,
    he
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsTrackingContext.Provider, { value: _u, children: v });
}, useSwapsTrackingContext = () => {
  const v = useContext(SwapsTrackingContext);
  return invariant$1(
    v,
    "useSwapsTrackingContext must be used within a SwapsTrackingProvider"
  ), v;
}, getSwapStatusHeading$1 = (v) => {
  switch (v) {
    case "UNINITIALIZED":
      return "Review Swap";
    case "IN_PROGRESS":
      return "Transaction in progress";
    case "SUCCESS":
      return "Swap Completed";
    case "CANNOT_TRACK":
      return "Cannot track swap";
    case "FAILED":
      return "Swap Failed";
  }
}, Header$2 = () => {
  const { goBack: v, getTimeSpentOnCurrentStep: y } = useIBCSwapsFlowContext(), { refresh: z, resetInputsToDefaults: ne, currentSwapId: ue, setCurrentSwapId: le } = useIBCSwapsContext(), { overallSwapStatus: he, swapStatus: ge } = useIBCSwapsTrackingContext(), we = useCallback(() => {
    y() > 15 && he === "UNINITIALIZED" && z(), (he === "SUCCESS" || he === "FAILED") && ne(!1), ue && le(void 0), v();
  }, [
    ue,
    y,
    v,
    he,
    z,
    ne,
    le
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        disabled: ((ge == null ? void 0 : ge.status) === "SIGNATURE_RECEIVED" || (ge == null ? void 0 : ge.status) === "BROADCASTING" || (ge == null ? void 0 : ge.status) === "SIGNATURE_REQUIRED") && he === "IN_PROGRESS",
        onClick: we,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: getSwapStatusHeading$1(he) }),
    he === "IN_PROGRESS" || he === "FAILED" || he === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(HelpPopover, {}) : null
  ] });
}, AggregatedViewHeader = () => {
  const { goBack: v, getTimeSpentOnCurrentStep: y } = useSwapsFlowContext(), { refresh: z, resetInputsToDefaults: ne, currentSwapId: ue, setCurrentSwapId: le } = useSwapsContext(), { overallSwapStatus: he, swapStatus: ge } = useSwapsTrackingContext(), we = useCallback(() => {
    y() > 15 && z(), (he === "SUCCESS" || (ge == null ? void 0 : ge.status) === "IN_PROGRESS") && ne(!1), ue && le(void 0), v();
  }, [
    ue,
    y,
    v,
    he,
    z,
    ne,
    le,
    ge == null ? void 0 : ge.status
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        disabled: ((ge == null ? void 0 : ge.status) === "SIGNATURE_RECEIVED" || (ge == null ? void 0 : ge.status) === "BROADCASTING" || (ge == null ? void 0 : ge.status) === "SIGNATURE_REQUIRED") && he === "IN_PROGRESS",
        onClick: we,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: getSwapStatusHeading$1(he) }),
    he === "IN_PROGRESS" || he === "FAILED" || he === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(HelpPopover, {}) : null
  ] });
}, useScrollIntoView = (v, y = 250) => {
  useEffect(() => {
    const z = setTimeout(() => {
      var ne;
      (ne = v.current) == null || ne.scrollIntoView({
        behavior: "smooth"
      });
    }, y);
    return () => {
      clearTimeout(z);
    };
  }, [v, y]);
}, TrackViaAxelarScanLink = ({ axelarScanLink: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-[hsl(0,0,17)] rounded-xl mt-4 p-3 flex justify-between items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "Track this transaction on" }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      href: v,
      target: "_blank",
      rel: "noreferrer",
      className: "flex gap-2 items-center bg-[hsl(0,0,22)] rounded-3xl p-2",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm", children: "Axelar" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(q$1, { size: 14, weight: "bold" })
      ]
    }
  )
] }), FundsLocationPill = ({
  amount: v,
  subtext: y,
  chainId: z,
  className: ne,
  children: ue = null,
  ...le
}) => {
  const he = useDenomData(
    "denom" in le ? le.denom : void 0,
    z
  ), ge = useMemo(() => {
    var we, Ee;
    return "denom" in le ? {
      logoUri: (we = he.data) == null ? void 0 : we.icon,
      symbol: (Ee = he.data) == null ? void 0 : Ee.coinDenom
    } : le;
  }, [he.data, le]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("rounded-lg p-3 bg-secondary mt-4", ne), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "w-8 h-8", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: ge.logoUri }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "font-bold", children: [
          v ? formatAmount(v, 2, 4) : null,
          " ",
          "denom" in le && he.isLoading ? sliceAddress(le.denom) : ge.symbol
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground", children: y })
      ] })
    ] }),
    ue
  ] });
}, PreBroadcastIBCTimeoutFundsLocation = ({ routeResponse: v, activeTxnIndex: y, groupedTransactions: z }) => {
  var ge, we;
  const ne = useChains(), ue = `Transaction ${y + 1}`, le = z[ue];
  if (y === 0)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FundsLocationPill,
      {
        logoUri: v.sourceAsset.logoUri,
        amount: v.amountIn,
        symbol: v.sourceAsset.symbol,
        chainId: v.sourceAssetChain.chainId.toString(),
        subtext: `Your funds are safe on ${v.sourceAssetChain.chainName}`
      }
    );
  const he = le == null ? void 0 : le[0];
  if (he.type === "SWAP") {
    const Ee = (ge = ne.data) == null ? void 0 : ge.find((xe) => xe.chainId === he.chain);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FundsLocationPill,
      {
        denom: he.sourceAsset,
        chainId: he.chain,
        subtext: `Your funds are safe on ${(Ee == null ? void 0 : Ee.chainName) ?? he.chain}`
      }
    );
  } else if (he.type === "TRANSFER") {
    const Ee = (we = ne.data) == null ? void 0 : we.find(
      (xe) => xe.chainId === he.sourceChain
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FundsLocationPill,
      {
        denom: he.asset,
        chainId: he.sourceChain,
        subtext: `Your funds are safe on ${(Ee == null ? void 0 : Ee.chainName) ?? he.sourceChain}`
      }
    );
  }
  return null;
}, DownloadErrorData = (v) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-lg p-2 justify-between flex items-center w-full mt-2 text-card-foreground", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm", children: [
    "Please send the error log to",
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "a",
      {
        href: `mailto:support@leapwallet.io?subject=${encodeURIComponent(
          `Swap Error: ${v.routeResponse.sourceAsset.symbol} (${v.routeResponse.sourceAssetChain.chainName}) to ${v.routeResponse.destinationAsset.symbol} (${v.routeResponse.destinationAssetChain.chainName})`
        )}`,
        className: "text-primary inline hover:underline",
        children: "support@leapwallet.io"
      }
    ),
    " ",
    "to help us investigate the issue."
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "secondary",
      size: "sm-icon",
      className: "ml-4 rounded-3xl shrink-0",
      onClick: () => {
        const y = JSON.stringify(v, null, 2), z = new Blob([y], { type: "application/json" }), ne = URL.createObjectURL(z), ue = document.createElement("a");
        ue.href = ne, ue.download = `${v.routeResponse.sourceAsset.symbol} to ${v.routeResponse.destinationAsset.symbol} Swap Error.json`, ue.click(), URL.revokeObjectURL(ne);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$4, { size: 16, weight: "bold" })
    }
  )
] }), FailureView = ({
  swapStatus: v,
  lastError: y,
  activeTxnIndex: z,
  txnTracking: ne,
  routeResponse: ue,
  groupedTransactions: le
}) => {
  var $e, Ne, st, Nr, br, $n, En, Rn;
  const he = useChains(), ge = (st = (Ne = ($e = ne.data) == null ? void 0 : $e.grouped) == null ? void 0 : Ne[z]) == null ? void 0 : st.transferSequence, we = ge == null ? void 0 : ge.find(
    (wa) => wa.type === "axelarTransfer"
  );
  if (useEffect(() => {
    var wa;
    (v == null ? void 0 : v.status) === "FATAL_ERROR" && y && console.log("🚨 Swap failed with error:", `
`, {
      error: y,
      code: y.code,
      message: y.message,
      route: ue
    }), (v == null ? void 0 : v.status) === "FAILED" && console.log("🚨 Transaction failed with error:", `
`, {
      error: ne.error,
      message: (wa = ne.error) == null ? void 0 : wa.message,
      route: ue,
      txnTrackingData: ne.data
    }), (v == null ? void 0 : v.status) === "CANNOT_TRACK" && console.log("🚨 Swap cannot be tracked:", `
`, {
      route: ue,
      lastTrackingData: ne.data,
      trackingCallError: ne.error
    });
  }, [v, y, ue, ne]), (v == null ? void 0 : v.status) === "FATAL_ERROR")
    switch (y == null ? void 0 : y.code) {
      case -1:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground mt-2 text-center", children: "Due to an unknown error" });
      case 0:
      case 1:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground mt-2 text-center", children: "One of the chains is not supported" });
      case 2:
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex flex-col items-stretch self-stretch", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm text-muted-foreground text-center mb-4", children: [
            "Transaction ",
            z + 1,
            " has timed out"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            PreBroadcastIBCTimeoutFundsLocation,
            {
              routeResponse: ue,
              activeTxnIndex: z,
              groupedTransactions: le
            }
          )
        ] });
      case 4:
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex flex-col items-stretch self-stretch", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground text-center", children: "Rejected by the chain" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl flex items-start p-3 mt-4 bg-secondary gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              I$1,
              {
                size: 16,
                weight: "fill",
                className: "text-warning shrink-0 mt-1"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "p",
              {
                style: {
                  display: "-webkit-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 6,
                  lineClamp: 6,
                  WebkitBoxOrient: "vertical"
                },
                children: y.message
              }
            )
          ] })
        ] });
      default:
        return null;
    }
  const Ee = (Nr = ne.data) == null ? void 0 : Nr.grouped[z], xe = le[`Transaction ${z + 1}`];
  if (Ee != null && Ee.transferAssetRelease) {
    const wa = {
      ...Ee.transferAssetRelease
    }, Aa = (($n = (br = he.data) == null ? void 0 : br.find((Ta) => Ta.chainId === wa.chainID)) == null ? void 0 : $n.chainName) ?? wa.chainID;
    let _a = !1;
    for (let Ta = 0; Ta < Ee.transferSequence.length; Ta++)
      if (Ee.transferSequence[Ta].state === "TRANSFER_FAILURE") {
        const Ra = xe.find(
          (Yn) => Yn.type === "SWAP"
        );
        wa.denom === (Ra == null ? void 0 : Ra.sourceAsset) && (_a = !0);
      }
    return ((En = ne.data) == null ? void 0 : En.states[z]) === "STATE_COMPLETED_SUCCESS" && (_a = !0), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex flex-col items-stretch self-stretch", children: [
      _a ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground text-center mb-4", children: "Due to slippage" }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        FundsLocationPill,
        {
          denom: wa.denom,
          subtext: `${wa.released ? "Refunded" : "Will be refunded"} on ${Aa}`,
          chainId: wa.chainID,
          children: [
            _a ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-lg p-2 flex items-center w-full mt-2 text-card-foreground", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(d$1, { size: 16, weight: "fill", className: "shrink-0" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm ml-2", children: "Tip: Try the swap with a higher slippage value." })
            ] }) : null,
            we != null && we.axelarScanLink ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-card rounded-lg p-2 flex items-center w-full mt-2 text-card-foreground", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "a",
              {
                href: we.axelarScanLink,
                target: "_blank",
                rel: "noreferrer",
                className: "flex gap-2 items-center",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-sm", children: "Track this transaction on Axelar" }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(q$1, { size: 14, weight: "bold" })
                ]
              }
            ) }) : null
          ]
        }
      )
    ] });
  }
  if (Ee != null && Ee.error) {
    const wa = (Rn = ne.data) == null ? void 0 : Rn.grouped[z - 1], Aa = /* @__PURE__ */ jsxRuntimeExports.jsx(
      DownloadErrorData,
      {
        activeTxnIndex: z,
        groupedTransactions: le,
        lastError: y,
        routeResponse: ue,
        swapStatus: v,
        txnTracking: ne
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex flex-col items-stretch self-stretch", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground text-center", children: "The transaction didn't complete" }),
      wa ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (() => {
        var Zn, Ra, Yn, $o;
        const _a = le[z - 1], Ta = _a[_a.length - 1];
        return Ta.type === "SWAP" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          FundsLocationPill,
          {
            denom: Ta.sourceAsset,
            chainId: Ta.chain,
            subtext: `Your funds are safe on ${((Ra = (Zn = he.data) == null ? void 0 : Zn.find(
              (ct) => ct.chainId === Ta.chain
            )) == null ? void 0 : Ra.chainName) ?? Ta.chain}`,
            children: Aa
          }
        ) : Ta.type === "TRANSFER" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          FundsLocationPill,
          {
            denom: Ta.asset,
            chainId: Ta.destinationChain,
            subtext: `Your funds are safe on ${(($o = (Yn = he.data) == null ? void 0 : Yn.find(
              (ct) => ct.chainId === Ta.destinationChain
            )) == null ? void 0 : $o.chainName) ?? Ta.destinationChain}`,
            children: Aa
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          FundsLocationPill,
          {
            denom: Ta.asset,
            chainId: Ta.sourceChain,
            subtext: `Your funds are safe on ${Ta.sourceChain}`,
            children: Aa
          }
        );
      })() }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        FundsLocationPill,
        {
          chainId: ue.sourceAssetChain.chainId.toString(),
          denom: ue.sourceAsset.denom,
          logoUri: ue.sourceAsset.logoUri,
          symbol: ue.sourceAsset.symbol,
          amount: ue.amountIn,
          subtext: `Your funds are safe on ${ue.sourceAssetChain.chainName}`,
          children: Aa
        }
      )
    ] });
  }
  return null;
}, CannotTrackView = ({
  routeResponse: v,
  lastError: y
}) => {
  const z = useOnline(), ne = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), ue = v.response.chain_ids.slice(1, -1).map((he) => {
    var ge, we;
    return ((we = (ge = ne.data) == null ? void 0 : ge.find((Ee) => Ee.chainId === he)) == null ? void 0 : we.chainName) ?? he;
  }).filter((he) => he !== void 0), le = useRef(null);
  return useScrollIntoView(le), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "flex flex-col items-center justify-center",
        ref: le,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            motion.span,
            {
              initial: {
                opacity: 0
              },
              animate: {
                opacity: 1
              },
              transition: {
                delay: 0.2
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {})
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Tracking Unavailable" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: " flex flex-col items-stretch self-stretch", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded-xl p-3 mt-4 bg-secondary space-y-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          I$1,
          {
            size: 16,
            weight: "fill",
            className: "text-warning shrink-0 mt-1"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "p",
          {
            className: Y$1("text-sm text-center", {
              "text-warning": !z
            }),
            children: z ? "Oops, we are not able to track this swap!" : "Please check your internet connection."
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-3", children: [
        (y == null ? void 0 : y.code) === 9 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "text-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
          "Transaction ",
          y.txnIndex + 1,
          " was broadcasted, but we couldn't track it. You can check its status on",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: (() => {
            const he = y.message.split(" "), ge = he[he.length - 1];
            return ge.startsWith("https://") ? /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                "a",
                {
                  href: ge,
                  target: "_blank",
                  rel: "noreferrer",
                  className: "underline hover:text-primary px-1 outline-none focus-visible:ring-ring focus-visible:ring-2",
                  children: new URL(ge).hostname
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "View on explorer" }) })
            ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                np,
                {
                  variant: "ghost",
                  className: "h-auto p-0 px-1 font-normal rounded-none",
                  onClick: () => {
                    navigator.clipboard.writeText(
                      ge
                    );
                  },
                  children: [
                    "explorer #",
                    sliceAddress(ge)
                  ]
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Kg, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Copy hash to clipboard" }) })
            ] });
          })() }),
          "."
        ] }) }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "text-sm", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "You can check your funds in the following places" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("ol", { className: "list-decimal list-inside text-[13px] mt-2 [&>li::marker]:opacity-80 [&>li::marker]:text-[13px] [&>li::marker]:text-sm [&>li::marker]:normal-nums space-y-1", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
              v.sourceAsset.symbol,
              " on",
              " ",
              v.sourceAssetChain.chainName,
              "."
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
              v.destinationAsset.symbol,
              " on",
              " ",
              v.destinationAssetChain.chainName,
              "."
            ] }),
            ue.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
              "Your funds may be on these intermediate chains -",
              " ",
              ue.join(", "),
              "."
            ] }) : null
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-card rounded-xl p-3", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm", children: [
        "In case you aren't able to track your funds, kindly get in touch with us at",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: "https://leapwallet.io/support",
            className: "underline hover:text-primary ",
            children: "leapwallet.io"
          }
        ),
        "."
      ] }) })
    ] }) })
  ] });
}, ReconnectToContinueView = () => {
  const v = useRef(null);
  return useScrollIntoView(v), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-card rounded-xl p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "flex flex-col items-center justify-center",
      ref: v,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.span,
          {
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1
            },
            transition: {
              delay: 0.2
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {})
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Tracking Unavailable" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold text-destructive", children: "Please check your internet connection" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start w-full gap-2 rounded-xl p-3 bg-secondary mt-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            I$1,
            {
              size: 16,
              weight: "fill",
              className: "text-warning shrink-0 mt-[2px]"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "Connect to the internet to continue your swap." })
        ] })
      ]
    }
  ) });
}, SwapAssetsOverview = () => {
  const { sourceAssetData: v, destinationAssetData: y } = useIBCSwapsContext(), {
    routeResponse: z,
    overallSwapStatus: ne,
    swapStatus: ue,
    lastError: le,
    activeTxnIndex: he,
    groupedTransactions: ge,
    txnTracking: we
  } = useIBCSwapsTrackingContext(), Ee = useOnline(), xe = useRef(null);
  return useScrollIntoView(xe), ne === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(CannotTrackView, { lastError: le, routeResponse: z }) : ne === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "flex flex-col items-center justify-center",
        ref: xe,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            motion.span,
            {
              initial: {
                opacity: 0
              },
              animate: {
                opacity: 1
              },
              transition: {
                delay: 0.2
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {})
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Swap Failed" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FailureView,
      {
        swapStatus: ue,
        lastError: le,
        activeTxnIndex: he,
        txnTracking: we,
        groupedTransactions: ge,
        routeResponse: z
      }
    )
  ] }) : ne === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center justify-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SwapSuccessfulIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Swap Successful" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-4 flex items-center justify-center gap-4 bg-secondary py-3 rounded-xl", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-6 w-6 bg-background", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v == null ? void 0 : v.logoUri }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm font-bold", children: [
          formatAmount(z.amountIn, 2, 4),
          " ",
          z.sourceAsset.symbol
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(d$4, { size: "1.5rem", className: "text-muted-foreground" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-6 w-6 bg-background", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: y == null ? void 0 : y.logoUri }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm font-bold", children: [
          formatAmount(z.amountOut ?? "0", 2, 4),
          " ",
          z.destinationAsset.symbol
        ] })
      ] })
    ] })
  ] }) : ne === "IN_PROGRESS" && !Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(ReconnectToContinueView, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "source",
          amount: z.amountIn,
          assetSymbol: z.sourceAsset.symbol,
          assetLogoUri: z.sourceAsset.logoUri,
          assetCoingeckoId: v == null ? void 0 : v.coingeckoId,
          chainLogoUri: z.sourceAssetChain.icon,
          chainName: z.sourceAssetChain.chainName
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-left mb-2 mt-5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-secondary flex h-8 w-8 items-center justify-center rounded-3xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(D$5, { size: 20, weight: "bold" }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "destination",
          amount: z.amountOut ?? "",
          assetSymbol: z.destinationAsset.symbol,
          assetLogoUri: z.destinationAsset.logoUri,
          assetCoingeckoId: y == null ? void 0 : y.coingeckoId,
          chainLogoUri: z.destinationAssetChain.icon,
          chainName: z.destinationAssetChain.chainName
        }
      )
    ] }),
    ne === "UNINITIALIZED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SwapInfo, { className: "mt-3" }) : null
  ] });
}, AggregatedSwapAssetsOverview = () => {
  var st, Nr, br;
  const { sourceAssetData: v, destinationAssetData: y } = useSwapsContext(), {
    routeResponse: z,
    overallSwapStatus: ne,
    swapStatus: ue,
    lastError: le,
    activeTxnIndex: he,
    groupedTransactions: ge,
    txnTracking: we
  } = useSwapsTrackingContext(), Ee = useOnline(), xe = useRef(null);
  useScrollIntoView(xe);
  const $e = (br = (Nr = (st = we.data) == null ? void 0 : st.grouped) == null ? void 0 : Nr[he]) == null ? void 0 : br.transferSequence, Ne = $e == null ? void 0 : $e.find(
    ($n) => $n.type === "axelarTransfer"
  );
  return (ue == null ? void 0 : ue.status) === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(CannotTrackView, { lastError: le, routeResponse: z }) : ne === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: "flex flex-col items-center justify-center",
        ref: xe,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Swap Failed" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FailureView,
      {
        swapStatus: ue,
        lastError: le,
        activeTxnIndex: he,
        txnTracking: we,
        groupedTransactions: ge,
        routeResponse: z
      }
    )
  ] }) : ne === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center justify-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SwapSuccessfulIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold text-lg", children: "Swap Successful" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-4 flex items-center justify-center gap-4 bg-secondary py-3 rounded-xl", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-6 w-6 bg-background", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v == null ? void 0 : v.logoUri }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm font-bold", children: [
          formatAmount(z.amountIn, 2, 4),
          " ",
          z.sourceAsset.symbol
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(d$4, { size: "1.5rem", className: "text-muted-foreground" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "h-6 w-6 bg-background", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: y == null ? void 0 : y.logoUri }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm font-bold", children: [
          formatAmount(z.amountOut ?? "0", 2, 4),
          " ",
          z.destinationAsset.symbol
        ] })
      ] })
    ] })
  ] }) : ne === "IN_PROGRESS" && !Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(ReconnectToContinueView, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "source",
          amount: z.amountIn,
          assetSymbol: z.sourceAsset.symbol,
          assetLogoUri: z.sourceAsset.logoUri,
          assetCoingeckoId: v == null ? void 0 : v.coingeckoId,
          chainLogoUri: z.sourceAssetChain.icon,
          chainName: z.sourceAssetChain.chainName
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-left mb-2 mt-5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-secondary flex h-8 w-8 items-center justify-center rounded-3xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(D$5, { size: 20, weight: "bold" }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "destination",
          amount: z.amountOut ?? "",
          assetSymbol: z.destinationAsset.symbol,
          assetLogoUri: z.destinationAsset.logoUri,
          assetCoingeckoId: y == null ? void 0 : y.coingeckoId,
          chainLogoUri: z.destinationAssetChain.icon,
          chainName: z.destinationAssetChain.chainName
        }
      ),
      Ne != null && Ne.axelarScanLink ? /* @__PURE__ */ jsxRuntimeExports.jsx(TrackViaAxelarScanLink, { axelarScanLink: Ne.axelarScanLink }) : null
    ] }),
    ne === "UNINITIALIZED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedSwapInfo, { className: "mt-3" }) : null
  ] });
}, RenderCTAButton$1 = ({
  refresh: v,
  resetInputsToDefaults: y,
  goBack: z,
  swapStatus: ne,
  overallSwapStatus: ue,
  executeRoute: le,
  setCurrentSwapId: he
}) => {
  const ge = useOnline();
  return ge ? ue === "UNINITIALIZED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: le,
      children: "Confirm Swap"
    }
  ) : ue === "CANNOT_TRACK" ? ge ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        z(), v(), he == null || he("");
      },
      children: "Swap Again"
    }
  ) : null : (ne == null ? void 0 : ne.status) === "FATAL_ERROR" || (ne == null ? void 0 : ne.status) === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        z(), v(), he == null || he("");
      },
      children: "Retry Swap"
    }
  ) : (ne == null ? void 0 : ne.status) === "BROADCASTING" || (ne == null ? void 0 : ne.status) === "SIGNATURE_RECEIVED" || (ne == null ? void 0 : ne.status) === "IN_PROGRESS" || (ne == null ? void 0 : ne.status) === "SIGNATURE_REQUIRED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      disabled: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { className: "animate-spin", size: "1.25rem" })
    }
  ) : (ne == null ? void 0 : ne.status) === "RECOVERABLE_ERROR" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-attention",
      className: "w-full font-bold",
      onClick: le,
      children: "Retry"
    }
  ) : (ne == null ? void 0 : ne.status) === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        y(!1), z();
      },
      children: "Done"
    }
  ) : null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      disabled: !0,
      className: "w-full font-bold",
      onClick: le,
      children: "No Internet Connection"
    }
  );
}, CTAButton$2 = () => {
  const { refresh: v, resetInputsToDefaults: y, setCurrentSwapId: z } = useIBCSwapsContext(), { goBack: ne } = useIBCSwapsFlowContext(), { swapStatus: ue, overallSwapStatus: le, executeRoute: he } = useIBCSwapsTrackingContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RenderCTAButton$1,
    {
      refresh: v,
      resetInputsToDefaults: y,
      goBack: ne,
      swapStatus: ue,
      setCurrentSwapId: z,
      overallSwapStatus: le,
      executeRoute: he
    }
  );
}, AggregatedViewCTAButton = () => {
  const { refresh: v, resetInputsToDefaults: y, setCurrentSwapId: z } = useSwapsContext(), { goBack: ne } = useSwapsFlowContext(), { swapStatus: ue, overallSwapStatus: le, executeRoute: he } = useSwapsTrackingContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RenderCTAButton$1,
    {
      refresh: v,
      resetInputsToDefaults: y,
      goBack: ne,
      setCurrentSwapId: z,
      swapStatus: ue,
      overallSwapStatus: le,
      executeRoute: he
    }
  );
}, ActionInProgressIcon = (v) => v.type === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-foreground/10 text-foreground relative flex h-5 w-5 items-center justify-center rounded-full", children: [
  "imgSrc" in v ? /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "border-foreground/50 h-3 w-3 shrink-0 border", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v.imgSrc }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: v.actionType === "TRANSFER" ? /* @__PURE__ */ jsxRuntimeExports.jsx(b, { size: "0.75rem", weight: "bold" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(k$2, { size: "0.75rem", weight: "bold" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { className: "absolute inset-0 z-10 animate-spin", size: "1.25rem" })
] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-foreground/10 text-foreground relative flex h-8 w-8 items-center justify-center rounded-full", children: [
  "imgSrc" in v ? /* @__PURE__ */ jsxRuntimeExports.jsxs(qf, { className: "border-foreground/50 h-5 w-5 shrink-0 border", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Jf, { src: v.imgSrc }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Qf, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: v.actionType === "TRANSFER" ? /* @__PURE__ */ jsxRuntimeExports.jsx(b, { size: "1rem", weight: "bold" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(k$2, { size: "1rem", weight: "bold" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { className: "absolute inset-0 z-10 animate-spin", size: "2rem" })
] }), ActionIdleIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-foreground flex h-5 w-5 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 h-3 w-3 rounded-full" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-foreground flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 h-3 w-3 rounded-full" }) }), ActionSuccessIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx(k$1, { weight: "fill", className: "h-5 w-5 text-success" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-success flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(k$1, { weight: "fill", className: "h-5 w-5" }) }), ActionWarningIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { weight: "fill", className: "h-5 w-5 text-warning" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-warning flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { weight: "fill", className: "h-5 w-5" }) }), ActionFailedIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { weight: "fill", className: "h-5 w-5 text-destructive" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-destructive flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { weight: "fill", className: "h-5 w-5" }) }), SignatureRequiredIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx(F$1, { className: "h-5 w-5 text-foreground" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 text-foreground flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(F$1, { className: "h-5 w-5" }) }), SignatureReceivedIcon = ({ type: v = "default" }) => v === "slim" ? /* @__PURE__ */ jsxRuntimeExports.jsx(F$1, { className: "h-5 w-5 text-success" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-success text-foreground flex h-8 w-8 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(F$1, { className: "h-5 w-5" }) }), SignaturePendingMiniIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 flex h-5 w-5 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-success h-2 w-2 rounded-full" }) }), SignatureRejectedMiniIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 flex h-5 w-5 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-warning h-2 w-2 rounded-full" }) }), SignatureRequiredMiniIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 flex h-5 w-5 items-center justify-center rounded-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-foreground/10 h-2 w-2 rounded-full" }) }), StepExplorerView = ({ data: v }) => v ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "a",
  {
    href: v.explorerLink,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "inline-flex mt-1 font-bold items-center gap-2 shrink-0 text-xs text-muted-foreground hover:text-foreground",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-xs tabular-nums", children: [
        "#",
        v.txHash.slice(0, 5),
        "..."
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(q$1, { size: 14, weight: "bold" })
    ]
  }
) : null, TransferActionDisplay = ({ action: v, variant: y, status: z, data: ne }) => {
  const { data: ue } = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), { data: le } = useSkipAssets(v.sourceChain, {
    includeEVMAssets: !0,
    includeSVMAssets: !0
  }), { data: he } = useDenomData(v.asset, v.sourceChain), ge = ue == null ? void 0 : ue.find(
    ($e) => $e.chainId === v.sourceChain
  ), we = ue == null ? void 0 : ue.find(
    ($e) => $e.chainId === v.destinationChain
  ), Ee = useMemo(() => le == null ? void 0 : le.find(($e) => $e.denom === v.asset), [v.asset, le]), xe = he || Ee ? {
    coinDenom: (he == null ? void 0 : he.coinDenom) ?? (Ee == null ? void 0 : Ee.symbol) ?? "",
    icon: (he == null ? void 0 : he.icon) ?? (Ee == null ? void 0 : Ee.logoUri) ?? ""
  } : void 0;
  return y === "title" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3", children: [
    (() => {
      switch (z) {
        case "idle":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionIdleIcon, { type: "slim" });
        case "in-progress":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionInProgressIcon, { actionType: "TRANSFER", type: "slim" });
        case "success":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuccessIcon, { type: "slim" });
        case "failed":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionFailedIcon, { type: "slim" });
      }
    })(),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-base font-bold", children: [
      "Transfer ",
      (xe == null ? void 0 : xe.coinDenom) ?? ""
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start gap-3 w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "py-2 bg-background", children: (() => {
      switch (z) {
        case "idle":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionIdleIcon, {});
        case "in-progress":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionInProgressIcon, { imgSrc: xe == null ? void 0 : xe.icon });
        case "success":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuccessIcon, {});
        case "failed":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionFailedIcon, {});
      }
    })() }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start justify-between gap-2 w-full", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-foreground font-bold", children: [
          "Transfer ",
          (xe == null ? void 0 : xe.coinDenom) ?? ""
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-muted-foreground text-sm", children: ge && we ? `from ${ge.chainName} to ${we.chainName}` : !ge && we ? `to ${we.chainName}` : ge && !we ? `from ${ge.chainName}` : "" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StepExplorerView, { data: ne })
    ] })
  ] });
}, SwapActionDisplay = ({ action: v, variant: y, status: z, data: ne }) => {
  const { data: ue } = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), { data: le } = useSkipAssets(v.chain, {
    includeEVMAssets: !0,
    includeSVMAssets: !0
  }), { data: he } = useDenomData(
    v.sourceAsset,
    v.chain
  ), { data: ge } = useDenomData(
    v.destinationAsset,
    v.chain
  ), we = useMemo(() => le == null ? void 0 : le.find((st) => st.denom === v.sourceAsset), [v.sourceAsset, le]), Ee = useMemo(() => le == null ? void 0 : le.find((st) => st.denom === v.destinationAsset), [v.destinationAsset, le]), xe = {
    coinDenom: (he == null ? void 0 : he.coinDenom) ?? (we == null ? void 0 : we.symbol),
    icon: (he == null ? void 0 : he.icon) ?? (we == null ? void 0 : we.logoUri)
  }, $e = {
    coinDenom: (ge == null ? void 0 : ge.coinDenom) ?? (Ee == null ? void 0 : Ee.symbol),
    icon: (ge == null ? void 0 : ge.icon) ?? (Ee == null ? void 0 : Ee.logoUri)
  }, Ne = ue == null ? void 0 : ue.find((st) => st.chainId === v.chain);
  return y === "title" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-3", children: [
    (() => {
      switch (z) {
        case "idle":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionIdleIcon, { type: "slim" });
        case "in-progress":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionInProgressIcon, { type: "slim", actionType: "SWAP" });
        case "success":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuccessIcon, { type: "slim" });
        case "failed":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionFailedIcon, { type: "slim" });
      }
    })(),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-base font-bold", children: [
      "Swap ",
      xe.coinDenom,
      " to",
      " ",
      $e.coinDenom
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start gap-3 w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "py-2 bg-background", children: (() => {
      switch (z) {
        case "idle":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionIdleIcon, {});
        case "in-progress":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            ActionInProgressIcon,
            {
              imgSrc: xe.icon
            }
          );
        case "success":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionSuccessIcon, {});
        case "failed":
          return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionFailedIcon, {});
      }
    })() }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start justify-between gap-2 w-full", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-foreground font-bold", children: [
          "Swap ",
          xe.coinDenom,
          " to",
          " ",
          $e.coinDenom
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-muted-foreground text-sm", children: Ne ? `on ${Ne.chainName}` : "" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StepExplorerView, { data: ne })
    ] })
  ] });
}, CollapsibleStatus = ({ title: v, children: y, isOpen: z, setIsOpen: ne, className: ue }) => {
  var we;
  const le = useRef(null), he = useRef(null);
  useEffect(() => {
    if (z) {
      const Ee = setTimeout(() => {
        var xe;
        (xe = le.current) == null || xe.scrollIntoView({
          behavior: "smooth"
        });
      }, 250);
      return () => clearTimeout(Ee);
    }
  }, [z, ne]);
  const ge = (we = he.current) == null ? void 0 : we.getBoundingClientRect().height;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    motion.div,
    {
      className: Y$1(
        "relative min-h-[2.75rem] overflow-hidden rounded-xl",
        ue
      ),
      ref: le,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          np,
          {
            variant: "secondary",
            onClick: () => ne(!z),
            className: Y$1(
              "w-full z-10 absolute top-0 left-0 h-auto !px-4 !py-3 bg-card hover:bg-card gap-2 transition-[border-radius,padding,background-color] duration-300 items-center rounded-xl",
              {
                "rounded-b-none": z
              }
            ),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-1", children: v }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center shrink-0 gap-1", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm text-muted-foreground", children: [
                  "Show ",
                  z ? "less" : "more"
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  D$3,
                  {
                    weight: "bold",
                    size: 16,
                    className: Y$1("transition-transform", {
                      "rotate-180": z,
                      "rotate-0": !z
                    })
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            ref: he,
            initial: !1,
            animate: {
              marginTop: z ? "44px" : `${ge !== void 0 ? ge * -1 : 44}px`,
              opacity: z ? 1 : 0
            },
            transition: { duration: 0.25, ease: "easeOut" },
            className: Y$1(
              "overflow-hidden w-full rounded-b-xl bg-card p-3 pt-0 !z-[-10]"
            ),
            children: y
          }
        )
      ]
    }
  );
}, SignatureRequiredSubStep = ({
  status: v
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "my-3 flex items-center gap-3 first-of-type:mt-0 last-of-type:mb-0", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-8 h-8 flex items-center justify-center bg-background", children: [
    v === "rejected" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureRejectedMiniIcon, {}) : null,
    v === "required" || v === "approved" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SignaturePendingMiniIcon, {}) : null,
    v === "idle" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureRequiredMiniIcon, {}) : null
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-muted-foreground text-sm", children: "Transaction approval" })
] }), initial = {
  opacity: 0,
  y: 8
}, animate = {
  opacity: 1,
  y: 0
}, exit = {
  opacity: 0,
  y: -8
}, SwapLabel = ({
  swapStatus: v,
  activeTxnIndex: y,
  overallSwapStatus: z,
  routeResponse: ne,
  bridgeType: ue
}) => {
  const le = useMemo(() => ne.response.chain_ids.length * 15, [ne.response.chain_ids]), he = useMemo(() => {
    if (le < 60)
      return `${le} second${le > 1 ? "s" : ""}`;
    const ge = Math.floor(le / 60);
    return `${ge} minute${ge > 1 ? "s" : ""}`;
  }, [le]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "min-h-[1.25rem] flex relative", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AnimatePresence, { mode: "popLayout", children: [
    (v == null ? void 0 : v.status) === "SIGNATURE_REQUIRED" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        initial,
        animate,
        exit,
        className: "flex items-center gap-3",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureRequiredIcon, { type: "slim" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: "Approval Requested" })
        ]
      },
      `${y}-signature-required`
    ) : null,
    (v == null ? void 0 : v.status) === "SIGNATURE_RECEIVED" || (v == null ? void 0 : v.status) === "BROADCASTING" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        initial,
        animate,
        exit,
        className: "flex items-center gap-3",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureReceivedIcon, { type: "slim" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: "Approval Received" })
        ]
      },
      `${y}-signature-received`
    ) : null,
    (v == null ? void 0 : v.status) === "RECOVERABLE_ERROR" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        initial,
        animate,
        exit,
        className: "flex items-center gap-3",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ActionWarningIcon, { type: "slim" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: v.title })
        ]
      },
      `${y}-recoverable-error`
    ) : null,
    z === "SUCCESS" || z === "FAILED" || z === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        initial,
        animate,
        exit,
        className: "flex items-center gap-3",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(I$3, { size: 20, weight: "fill" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: "Transaction Summary" })
        ]
      },
      "swap-final-successful-message"
    ) : null,
    z !== "FAILED" && z !== "SUCCESS" && z !== "CANNOT_TRACK" && (v == null ? void 0 : v.status) === "IN_PROGRESS" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        initial,
        animate,
        exit,
        className: "flex items-center gap-3",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(R$3, { size: 20, weight: "fill" }),
          ue === "ibc" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-sm font-bold", children: [
            "~ ",
            he
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2 items-center", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm font-bold", children: getFinalityTime(ne.response.chain_ids[0]) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(yw, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Cw, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$5, { size: 20, weight: "fill" }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Kg,
                {
                  side: "bottom",
                  className: "max-w-[16rem] h-full text-wrap",
                  children: [
                    "This swap contains at least one EVM chain, so it might take longer. Read more about",
                    " ",
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      "a",
                      {
                        className: "underline",
                        target: "_blank",
                        href: "https://docs.axelar.dev/learn/txduration#common-finality-time-for-interchain-transactions",
                        children: "common finality times"
                      }
                    ),
                    "."
                  ]
                }
              )
            ] })
          ] })
        ]
      },
      "swap-ongoing-duration"
    ) : null
  ] }) });
}, TrackSkipSwap = ({
  swapStatus: v,
  activeTxnIndex: y,
  isTxnTrackerOpen: z,
  setIsTxnTrackerOpen: ne,
  groupedTransactions: ue,
  lastError: le,
  txnTracking: he,
  overallSwapStatus: ge,
  routeResponse: we,
  bridgeType: Ee
}) => ge === "UNINITIALIZED" ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
  CollapsibleStatus,
  {
    isOpen: z,
    setIsOpen: ne,
    className: "w-full mt-3",
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(
      SwapLabel,
      {
        swapStatus: v,
        activeTxnIndex: y,
        overallSwapStatus: ge,
        routeResponse: we,
        bridgeType: Ee
      }
    ),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-background p-3 rounded-lg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative z-0 after:top-0 after:absolute after:z-[-1] after:left-[calc(1rem-1px)] after:border-r-2 after:border-muted after:w-0 after:h-[calc(100%-1.75rem)]", children: Object.values(ue).map(
      (xe, $e) => /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: xe.map((Ne, st, Nr) => {
        var Se;
        const br = (le == null ? void 0 : le.code) === 3 && (le == null ? void 0 : le.txnIndex) === $e && (v == null ? void 0 : v.status) === "RECOVERABLE_ERROR", $n = $e < y, En = (Se = he.data) == null ? void 0 : Se.grouped[$e], Rn = En == null ? void 0 : En.transferSequence, wa = En == null ? void 0 : En.state, Aa = (Oe, Fr) => Fr.type === "TRANSFER" || Fr.type === "SEND" || Fr.type === "SWAP" && st === 0 ? Oe + 1 : Oe;
        let _a = Nr.slice(0, st + 1).reduce(Aa, -1);
        const Ta = Nr.slice(0, st).reduce(Aa, -1);
        Rn && _a >= (Rn == null ? void 0 : Rn.length) && (_a = Rn.length - 1);
        const Zn = Rn == null ? void 0 : Rn[_a], Ra = Rn == null ? void 0 : Rn[Ta], Yn = Zn == null ? void 0 : Zn.packetTxs;
        let $o = "idle", ct;
        const fe = st === 0 ? void 0 : Nr[st - 1], be = Nr[0];
        Yn ? "error" in Yn && Yn.error ? ($o = "failed", _a === Ta || fe !== void 0 ? Yn.receiveTx && (ct = Yn.receiveTx) : Yn.sendTx && (ct = Yn.sendTx)) : (Ne.type === "TRANSFER" && (_a === Ta ? Yn.receiveTx ? ($o = "success", ct = Yn.receiveTx) : Yn.sendTx ? st > 0 && (be == null ? void 0 : be.type) === "TRANSFER" && (Ra == null ? void 0 : Ra.state) === "TRANSFER_PENDING" ? $o = "idle" : $o = "in-progress" : $o = "idle" : fe !== void 0 ? Yn.receiveTx ? ($o = "success", ct = Yn.receiveTx) : Yn.sendTx ? st === 1 && fe.type === "TRANSFER" && (Ra == null ? void 0 : Ra.state) === "TRANSFER_PENDING" ? $o = "idle" : $o = "in-progress" : $o = "idle" : (Yn.sendTx && [
          "TRANSFER_RECEIVED",
          "TRANSFER_SUCCESS"
        ].includes(Zn == null ? void 0 : Zn.state) ? $o = "success" : $o = "in-progress", ct = Yn.sendTx || void 0)), Ne.type === "SWAP" && (_a === Ta ? Yn.receiveTx ? ($o = "success", ct = Yn.receiveTx) : Yn.sendTx ? st > 0 && (be == null ? void 0 : be.type) === "TRANSFER" && (Ra == null ? void 0 : Ra.state) === "TRANSFER_PENDING" ? $o = "idle" : $o = "in-progress" : $o = "idle" : fe !== void 0 ? Yn.receiveTx ? ($o = "success", ct = Yn.receiveTx) : Yn.sendTx ? st === 1 && fe.type === "TRANSFER" && (Ra == null ? void 0 : Ra.state) === "TRANSFER_PENDING" ? $o = "idle" : $o = "in-progress" : $o = "idle" : Yn.sendTx ? ($o = "success", ct = Yn.sendTx) : $o = "in-progress")) : wa === "STATE_SUBMITTED" || wa === "STATE_PENDING" ? st === 0 && y === $e && ($o = "in-progress") : wa === "STATE_COMPLETED_SUCCESS" && ($o = "success");
        const ye = br ? "rejected" : $e === y ? (v == null ? void 0 : v.status) === "SIGNATURE_REQUIRED" ? "required" : "approved" : $n ? "approved" : "idle";
        return Ne.type === "SEND" ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: "mt-3 first-of-type:mt-0",
            children: [
              st === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureRequiredSubStep, { status: ye }) : null,
              Ne.type === "SWAP" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                SwapActionDisplay,
                {
                  status: $o,
                  action: Ne,
                  variant: "step",
                  data: ct
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                TransferActionDisplay,
                {
                  status: $o,
                  action: Ne,
                  variant: "step",
                  data: ct
                }
              )
            ]
          },
          `${$e}-${Ne.type}-${st}`
        );
      }) }, $e)
    ) }) })
  }
), IBCSwapWrapperForTracking = () => {
  const {
    swapStatus: v,
    activeTxnIndex: y,
    isTxnTrackerOpen: z,
    setIsTxnTrackerOpen: ne,
    groupedTransactions: ue,
    lastError: le,
    txnTracking: he,
    overallSwapStatus: ge,
    routeResponse: we
  } = useIBCSwapsTrackingContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackSkipSwap,
    {
      swapStatus: v,
      activeTxnIndex: y,
      isTxnTrackerOpen: z,
      setIsTxnTrackerOpen: ne,
      groupedTransactions: ue,
      lastError: le,
      txnTracking: he,
      overallSwapStatus: ge,
      routeResponse: we,
      bridgeType: "ibc"
    }
  );
}, AggregatedViewWrapperForTracking = () => {
  const {
    swapStatus: v,
    activeTxnIndex: y,
    isTxnTrackerOpen: z,
    setIsTxnTrackerOpen: ne,
    groupedTransactions: ue,
    lastError: le,
    txnTracking: he,
    overallSwapStatus: ge,
    routeResponse: we
  } = useSwapsTrackingContext(), { sourceChainData: Ee, destinationChainData: xe } = useSwapsContext(), $e = useMemo(() => (Ee == null ? void 0 : Ee.chainType) === "evm" || (xe == null ? void 0 : xe.chainType) === "evm" ? "axelar" : "ibc", [Ee, xe]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackSkipSwap,
    {
      swapStatus: v,
      activeTxnIndex: y,
      isTxnTrackerOpen: z,
      setIsTxnTrackerOpen: ne,
      groupedTransactions: ue,
      lastError: le,
      txnTracking: he,
      overallSwapStatus: ge,
      routeResponse: we,
      bridgeType: $e
    }
  );
}, ReviewLoadingSkeleton = ({
  goBack: v,
  refresh: y
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        onClick: () => {
          v(), y();
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: "Refreshing Swap Quote" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-y-auto px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card p-4 rounded-2xl", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewAssetInformationSkeleton, { type: "source" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-2 mt-5 flex items-center justify-start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-8 w-8 rounded-3xl" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewAssetInformationSkeleton, { type: "destination" })
  ] }) })
] }), NoDataView$1 = ({ goBack: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        onClick: v,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: "IBC Swaps" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-4 h-full overflow-y-auto flex flex-col items-center justify-center p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "-mt-32" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center mt-3 text-foreground font-bold", children: "Something went wrong" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center text-sm mt-1 text-muted-foreground px-4", children: "We are unable to fetch the swap details at the moment. You can go to the previous step and try again." })
  ] })
] }), IBCSwapTrackingView = () => {
  const {
    routeResponse: v,
    messages: y,
    gasFeesData: z,
    isLoadingGasFee: ne,
    isLoadingMessages: ue,
    isLoadingRoute: le,
    isValidatingRoute: he,
    isValidatingGasFee: ge,
    refresh: we,
    txnLifecycleHooks: Ee,
    ongoingTransactions: xe,
    currentSwapId: $e,
    setOngoingTransactions: Ne,
    sourceChainData: st,
    destinationChainData: Nr,
    sourceAssetData: br,
    destinationAssetData: $n
  } = useIBCSwapsContext(), { goBack: En } = useIBCSwapsFlowContext();
  if (ne || ue || le || he || ge)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewLoadingSkeleton, { refresh: we, goBack: En });
  if (!v || !y || !z)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NoDataView$1, { goBack: En });
  const Rn = ({
    activeTxnIndex: wa,
    txnStatuses: Aa,
    lastError: _a
  }) => {
    if (!st || !Nr || !br || !$n)
      return;
    const Ta = $e || v4();
    Ne({
      ...xe,
      [Ta]: {
        id: Ta,
        timestamp: $e ? xe[$e].timestamp : (/* @__PURE__ */ new Date()).getTime(),
        activeTxnIndex: wa,
        sourceChainData: st,
        destinationChainData: Nr,
        sourceAssetData: br,
        destinationAssetData: $n,
        messages: y,
        routeResponse: v,
        gasFeesData: z,
        txnStatuses: Aa,
        lastError: _a,
        isComplete: $e ? xe[$e].isComplete : !1
      }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    IBCSwapsTrackingProvider,
    {
      tab: Tabs.SWAP,
      gasFees: z.gasFeesAmount,
      messages: y,
      routeResponse: v,
      txnLifecycleHooks: Ee,
      updateOngoingTransactions: Rn,
      ongoingSwap: $e ? xe[$e] : void 0,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Header$2, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 overflow-y-auto no-scrollbar h-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SwapAssetsOverview, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapWrapperForTracking, {})
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 mb-4 [&:has(>*)]:mt-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CTAButton$2, {}) })
      ]
    }
  );
}, ConversionRateStaticAlert = ({ message: v }) => {
  const y = useRef(null);
  return useScrollIntoView(y), /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "warning", className: "bg-card mt-3", ref: y, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-warning", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: v })
  ] });
}, ConversionRateConfirmationAlert = ({
  isConversionRateChecked: v,
  setIsConversionRateChecked: y,
  title: z,
  message: ne
}) => {
  const ue = useRef(null);
  return useScrollIntoView(ue), /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", ref: ue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-destructive", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Hf, { className: "flex w-full items-center justify-between", children: z }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Vf, { className: "mt-2 flex items-start gap-2 !pl-0 text-sm", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        dp,
        {
          id: "cta-price-impact-checkbox",
          className: "ml-[2px] mt-1",
          checked: v,
          onCheckedChange: y
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Pb,
        {
          htmlFor: "cta-price-impact-checkbox",
          className: "ml-1 leading-relaxed font-normal",
          children: ne
        }
      )
    ] })
  ] });
}, ConversionRateAlert = ({
  routeResponse: v,
  isConversionRateChecked: y,
  setIsConversionRateChecked: z
}) => {
  const {
    shouldCheckPriceImpact: ne,
    priceImpactPercent: ue,
    usdValueDecreasePercent: le,
    sourceAssetUSDValue: he,
    destinationAssetUSDValue: ge
  } = getPriceImpactVars(v);
  return ne ? ue.isNaN() ? le.isNaN() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Low information warning" }),
      message: "I understand that I might get an unfavourable exchange rate if I go ahead with this transaction.",
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : le.lt(5) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          "-",
          le.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your estimated output value",
        " ",
        formatAmountWithPrefix(ge, "$"),
        " is",
        " ",
        le.toFixed(2),
        "% lower than your estimated input value ",
        formatAmountWithPrefix(he, "$"),
        ".",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : ue.lt(5) ? le.isNaN() ? /* @__PURE__ */ jsxRuntimeExports.jsx(ConversionRateStaticAlert, { message: "Price data unavailable for selected token(s)." }) : le.lt(5) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          "-",
          le.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your estimated output value",
        " ",
        formatAmountWithPrefix(ge, "$"),
        " is",
        " ",
        le.toFixed(2),
        "% lower than your estimated input value ",
        formatAmountWithPrefix(he, "$"),
        ".",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : le.isNaN() || le.lt(5) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ue.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your swap is expected to execute at a",
        " ",
        ue.toFixed(2),
        "% worse price than the current estimated on-chain price, likely due to low on-chain liquidity for the selected token(s).",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : le.gt(ue) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          "-",
          le.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your estimated output value",
        " ",
        formatAmountWithPrefix(ge, "$"),
        " is",
        " ",
        le.toFixed(2),
        "% lower than your estimated input value ",
        formatAmountWithPrefix(he, "$"),
        ".",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          ue.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your swap is expected to execute at a",
        " ",
        ue.toFixed(2),
        "% worse price than the current estimated on-chain price, likely due to low on-chain liquidity for the selected token(s).",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : le.isNaN() ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Low information warning" }),
      message: "I understand that I might get an unfavourable exchange rate if I go ahead with this transaction.",
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : le.gte(5) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    ConversionRateConfirmationAlert,
    {
      title: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Bad trade warning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
          "-",
          le.toFixed(2),
          "%"
        ] })
      ] }),
      message: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        "Your estimated output value",
        " ",
        formatAmountWithPrefix(ge, "$"),
        " is",
        " ",
        le.toFixed(2),
        "% lower than your estimated input value ",
        formatAmountWithPrefix(he, "$"),
        ".",
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        "I understand and wish to proceed."
      ] }),
      isConversionRateChecked: y,
      setIsConversionRateChecked: z
    }
  ) : null;
}, UserAddressErrorAlert = () => {
  const v = useRef(null);
  return useScrollIntoView(v), /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", ref: v, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Hf, { children: "Swap not supported" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-2", children: "Your wallet does not support one or more chains in the swap route. Try connecting through a different wallet." })
  ] });
}, ShowLedgerSupportErrorAlert = () => {
  const v = useRef(null);
  return useScrollIntoView(v), /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", ref: v, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Hf, { children: "Swap not supported" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Vf, { className: "mt-2", children: [
      "Signing with Ledger is not supported for",
      " ",
      LEDGER_NOT_SUPPORTED_CHAINS.map((y) => y.chainName).join(", "),
      ". We are working on adding support for it soon."
    ] })
  ] });
}, InputWarnings = ({
  inputAmountRemark: v,
  sourceAndDestinationAreSame: y,
  isUserAddressesError: z,
  routeError: ne,
  isLoadingRoute: ue,
  isValidatingRoute: le,
  routeResponse: he
}) => {
  const ge = useIsLedgerSupportError(he);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !ue && !le && ne ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-destructive", weight: "fill" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: ne.message.includes("amount") && ne.message.includes("less") ? ne.message.trim().slice(0, 1).toUpperCase() + ne.message.trim().slice(1) : "No swap route available" })
    ] }) : null,
    v ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5", weight: "fill" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: v.message })
    ] }) : null,
    y ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5", weight: "fill" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: "Source and destination cannot be the same" })
    ] }) : null,
    z ? /* @__PURE__ */ jsxRuntimeExports.jsx(UserAddressErrorAlert, {}) : null,
    ge ? /* @__PURE__ */ jsxRuntimeExports.jsx(ShowLedgerSupportErrorAlert, {}) : null
  ] });
}, GasFeeError = ({ message: v }) => {
  const y = useRef(null);
  return useScrollIntoView(y), /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", ref: y, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-destructive", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { children: v })
  ] });
}, WarningsSection = () => {
  const {
    inputAmountRemark: v,
    sourceAsset: y,
    destinationAsset: z,
    sourceChainId: ne,
    destinationChainId: ue,
    isUserAddressesError: le,
    routeResponse: he,
    isConversionRateChecked: ge,
    setIsConversionRateChecked: we,
    routeError: Ee,
    gasFeesData: xe,
    isLoadingRoute: $e,
    isValidatingRoute: Ne
  } = useIBCSwapsContext(), st = useMemo(() => ne === ue ? y === z && !!y : !1, [z, ue, y, ne]), Nr = useIsLedgerSupportError(he);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputWarnings,
      {
        inputAmountRemark: v,
        sourceAndDestinationAreSame: st,
        isUserAddressesError: le,
        routeError: Ee,
        routeResponse: he,
        isLoadingRoute: $e,
        isValidatingRoute: Ne
      }
    ),
    xe != null && xe.gasFeesError ? /* @__PURE__ */ jsxRuntimeExports.jsx(GasFeeError, { message: xe.gasFeesError }) : null,
    le || st || v || Ee || Nr || !(he != null && he.response) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
      ConversionRateAlert,
      {
        routeResponse: he,
        isConversionRateChecked: ge,
        setIsConversionRateChecked: we
      }
    )
  ] });
}, AggregatedViewWarningsSection = () => {
  const {
    inputAmountRemark: v,
    sourceAsset: y,
    destinationAsset: z,
    sourceChainId: ne,
    destinationChainId: ue,
    isUserAddressesError: le,
    routeResponse: he,
    isConversionRateChecked: ge,
    setIsConversionRateChecked: we,
    routeError: Ee,
    isLoadingRoute: xe,
    isValidatingRoute: $e,
    gasFeesData: Ne
  } = useSwapsContext(), st = useMemo(() => ne === ue ? y === z && !!y : !1, [z, ue, y, ne]), Nr = useIsLedgerSupportError(he);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputWarnings,
      {
        inputAmountRemark: v,
        sourceAndDestinationAreSame: st,
        isUserAddressesError: le,
        routeError: Ee,
        routeResponse: he,
        isLoadingRoute: xe,
        isValidatingRoute: $e
      }
    ),
    Ne != null && Ne.gasFeesError ? /* @__PURE__ */ jsxRuntimeExports.jsx(GasFeeError, { message: Ne.gasFeesError }) : null,
    le || st || v || Ee || Nr || !(he != null && he.response) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
      ConversionRateAlert,
      {
        routeResponse: he,
        isConversionRateChecked: ge,
        setIsConversionRateChecked: we
      }
    )
  ] });
}, popularChains$3 = [
  "cosmoshub-4",
  "osmosis-1",
  "pacific-1",
  "injective-1",
  "neutron-1"
], IBCSwapsSourceSelect = ({ chains: v, assets: y }) => {
  const {
    sourceChainId: z,
    sourceAsset: ne,
    setSourceChainId: ue,
    setSourceAsset: le,
    inputAmount: he,
    setInputAmount: ge,
    inputAmountRemark: we,
    sourceTokenBalance: Ee,
    sourceAddress: xe,
    sourceChainData: $e
  } = useIBCSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SourceSelect$1,
    {
      chains: v,
      assets: y,
      inputValue: he,
      setInputValue: ge,
      inputAmountRemark: we,
      selectedChainId: z,
      setSelectedChainId: ue,
      selectedAsset: ne,
      setSelectedAsset: le,
      tokenBalance: Ee,
      popularChainIds: popularChains$3,
      sourceChainData: $e,
      selectedChainError: !!xe.error,
      fetchChainBalances: useCosmosChainBalances
    }
  );
}, IBCSwapsDestinationSelect = ({ chains: v, assets: y }) => {
  const {
    destinationChainId: z,
    destinationAsset: ne,
    setDestinationChainId: ue,
    setDestinationAsset: le,
    destinationTokenBalance: he,
    routeError: ge,
    isLoadingRoute: we,
    isValidatingRoute: Ee,
    amountOut: xe,
    destinationAddress: $e
  } = useIBCSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DestinationSelect,
    {
      chains: v,
      assets: y,
      selectedChainId: z,
      setSelectedChainId: ue,
      selectedAsset: ne,
      setSelectedAsset: le,
      tokenBalance: he,
      amountOut: xe,
      isLoadingRoute: we,
      isValidatingRoute: Ee,
      routeError: ge,
      popularChainIds: popularChains$3,
      selectedChainError: !!$e.error,
      fetchChainBalances: useCosmosChainBalances
    }
  );
}, InterchangeButton$1 = () => {
  const [v, y] = useState(!1), { interchange: z, isInterchangeEnabled: ne } = useIBCSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative h-2 bg-transparent", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "secondary",
      size: "sm-icon",
      className: "absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-3xl shadow-[0_0_0_0.4rem_hsl(var(--background))] disabled:cursor-not-allowed disabled:opacity-100",
      disabled: !ne,
      onClick: () => {
        z(), y(!0), setTimeout(() => {
          y(!1);
        }, 500);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        D$4,
        {
          weight: "bold",
          size: "1rem",
          className: v ? "animate-[spin_600ms_linear_0.5]" : ""
        }
      )
    }
  ) });
}, IBCSwapsInputView = ({ title: v, chains: y, assets: z }) => {
  const ne = useRef(null);
  return useOverflowFade(ne), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Header$4, { title: v }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: ne, className: "overflow-y-auto no-scrollbar px-4 h-full", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsSourceSelect, { chains: y, assets: z }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(InterchangeButton$1, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsDestinationSelect, { chains: y, assets: z })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SwapInfo, { className: "mt-3" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(WarningsSection, {})
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 my-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CTASection, {}) })
  ] });
}, IBCSwapsView = ({ className: v, showPoweredByBanner: y, title: z }) => {
  const { step: ne, previousStep: ue } = useIBCSwapsFlowContext(), le = useChains(), he = useSkipSupportedChains(), ge = useAllSkipAssets(), we = useMemo(() => le.isLoading ? {
    isLoading: !0,
    data: void 0,
    error: void 0
  } : he, [le.isLoading, he]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: Y$1("bg-background h-[34rem] w-[26rem] rounded-2xl", v),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AnimatePresence, { mode: "popLayout", children: [
        ne === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 1 ? -8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: -8 },
            transition: {
              duration: 0.2,
              stiffness: 80
            },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              IBCSwapsInputView,
              {
                title: z,
                chains: we,
                assets: ge
              }
            )
          },
          0
        ) : null,
        ne === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 0 ? 8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: 8 },
            transition: {
              duration: 0.2,
              stiffness: 80
            },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapTrackingView, {})
          },
          1
        ) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            animate: {
              opacity: ne === 2 ? 1 : 0,
              x: ne === 2 ? 0 : 8,
              display: ne === 2 ? "grid" : "none"
            },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapHistoryView, {})
          },
          2
        ),
        y ? /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByLeapAndSkip, {}, "powered-by-banner") : null
      ] })
    }
  );
}, IBCSwaps = ({
  className: v,
  title: y,
  showPoweredByBanner: z,
  defaultValues: ne,
  defaultSettings: ue,
  allowedSourceChains: le,
  allowedDestinationChains: he,
  onValuesChange: ge,
  onSettingsChange: we,
  txnLifecycleHooks: Ee
}) => {
  const xe = useMemo(() => {
    const Ne = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.sourceChainId,
      "cosmoshub-4",
      le == null ? void 0 : le.map(($n) => $n.chainId)
    ), st = Ne && (ne == null ? void 0 : ne.sourceAsset) !== SELECT_NONE ? getDefaultAsset$1(
      Ne,
      ne == null ? void 0 : ne.sourceAsset,
      le
    ) : SELECT_NONE, Nr = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.destinationChainId,
      "osmosis-1",
      he == null ? void 0 : he.map(($n) => $n.chainId)
    ), br = Nr && (ne == null ? void 0 : ne.destinationAsset) !== SELECT_NONE ? getDefaultAsset$1(
      Nr,
      ne == null ? void 0 : ne.destinationAsset,
      he
    ) : SELECT_NONE;
    return {
      sourceChainId: Ne,
      sourceAsset: st,
      destinationChainId: Nr,
      destinationAsset: br,
      inputAmount: (ne == null ? void 0 : ne.inputAmount) ?? ""
    };
  }, [he, le, ne]), $e = useMemo(() => ({
    slippage: (ue == null ? void 0 : ue.slippage) ?? "1"
  }), [ue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { title: y ?? "IBC Swaps", className: v, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwapsFlowProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SourceRestrictionsProvider, { chains: le, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DestinationRestrictionsProvider, { chains: he, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    IBCSwapsProvider,
    {
      defaultValues: xe,
      defaultSettings: $e,
      onValuesChange: ge,
      onSettingsChange: we,
      txnLifecycleHooks: Ee,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(xw, { delayDuration: 250, skipDelayDuration: 750, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IBCSwapsView,
        {
          className: v,
          title: y,
          showPoweredByBanner: z
        }
      ) })
    }
  ) }) }) }) });
}, IBCSwapsModal = ({
  isOpen: v,
  setIsOpen: y,
  ...z
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalView, { isOpen: v, setIsOpen: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCSwaps, { ...z }) });
function getDefaultAsset$1(v, y, z) {
  var ue;
  if (z === void 0)
    return y;
  const ne = (ue = z.find((le) => le.chainId === v)) == null ? void 0 : ue.assetDenoms;
  return ne === void 0 ? y : ne.length === 0 ? SELECT_NONE : typeof y == "string" ? typeof ne[0] == "string" ? getDefaultValue(y, ne) : ne[0] : typeof ne[0] == "object" ? getDefaultValueByOriginObject(
    y,
    ne
  ) : ne[0];
}
function publicProvider() {
  return function(v) {
    return v.rpcUrls.public.http[0] ? {
      chain: v,
      rpcUrls: v.rpcUrls.public
    } : null;
  };
}
var ChainNotConfiguredForConnectorError = class extends Error {
  constructor({
    chainId: v,
    connectorId: y
  }) {
    super(`Chain "${v}" not configured for connector "${y}".`), this.name = "ChainNotConfiguredForConnectorError";
  }
}, ConnectorNotFoundError = class extends Error {
  constructor() {
    super(...arguments), this.name = "ConnectorNotFoundError", this.message = "Connector not found";
  }
};
function normalizeChainId(v) {
  return typeof v == "string" ? Number.parseInt(
    v,
    v.trim().substring(0, 2) === "0x" ? 16 : 10
  ) : typeof v == "bigint" ? Number(v) : v;
}
var eventemitter3 = { exports: {} };
(function(v) {
  var y = Object.prototype.hasOwnProperty, z = "~";
  function ne() {
  }
  Object.create && (ne.prototype = /* @__PURE__ */ Object.create(null), new ne().__proto__ || (z = !1));
  function ue(we, Ee, xe) {
    this.fn = we, this.context = Ee, this.once = xe || !1;
  }
  function le(we, Ee, xe, $e, Ne) {
    if (typeof xe != "function")
      throw new TypeError("The listener must be a function");
    var st = new ue(xe, $e || we, Ne), Nr = z ? z + Ee : Ee;
    return we._events[Nr] ? we._events[Nr].fn ? we._events[Nr] = [we._events[Nr], st] : we._events[Nr].push(st) : (we._events[Nr] = st, we._eventsCount++), we;
  }
  function he(we, Ee) {
    --we._eventsCount === 0 ? we._events = new ne() : delete we._events[Ee];
  }
  function ge() {
    this._events = new ne(), this._eventsCount = 0;
  }
  ge.prototype.eventNames = function() {
    var Ee = [], xe, $e;
    if (this._eventsCount === 0)
      return Ee;
    for ($e in xe = this._events)
      y.call(xe, $e) && Ee.push(z ? $e.slice(1) : $e);
    return Object.getOwnPropertySymbols ? Ee.concat(Object.getOwnPropertySymbols(xe)) : Ee;
  }, ge.prototype.listeners = function(Ee) {
    var xe = z ? z + Ee : Ee, $e = this._events[xe];
    if (!$e)
      return [];
    if ($e.fn)
      return [$e.fn];
    for (var Ne = 0, st = $e.length, Nr = new Array(st); Ne < st; Ne++)
      Nr[Ne] = $e[Ne].fn;
    return Nr;
  }, ge.prototype.listenerCount = function(Ee) {
    var xe = z ? z + Ee : Ee, $e = this._events[xe];
    return $e ? $e.fn ? 1 : $e.length : 0;
  }, ge.prototype.emit = function(Ee, xe, $e, Ne, st, Nr) {
    var br = z ? z + Ee : Ee;
    if (!this._events[br])
      return !1;
    var $n = this._events[br], En = arguments.length, Rn, wa;
    if ($n.fn) {
      switch ($n.once && this.removeListener(Ee, $n.fn, void 0, !0), En) {
        case 1:
          return $n.fn.call($n.context), !0;
        case 2:
          return $n.fn.call($n.context, xe), !0;
        case 3:
          return $n.fn.call($n.context, xe, $e), !0;
        case 4:
          return $n.fn.call($n.context, xe, $e, Ne), !0;
        case 5:
          return $n.fn.call($n.context, xe, $e, Ne, st), !0;
        case 6:
          return $n.fn.call($n.context, xe, $e, Ne, st, Nr), !0;
      }
      for (wa = 1, Rn = new Array(En - 1); wa < En; wa++)
        Rn[wa - 1] = arguments[wa];
      $n.fn.apply($n.context, Rn);
    } else {
      var Aa = $n.length, _a;
      for (wa = 0; wa < Aa; wa++)
        switch ($n[wa].once && this.removeListener(Ee, $n[wa].fn, void 0, !0), En) {
          case 1:
            $n[wa].fn.call($n[wa].context);
            break;
          case 2:
            $n[wa].fn.call($n[wa].context, xe);
            break;
          case 3:
            $n[wa].fn.call($n[wa].context, xe, $e);
            break;
          case 4:
            $n[wa].fn.call($n[wa].context, xe, $e, Ne);
            break;
          default:
            if (!Rn)
              for (_a = 1, Rn = new Array(En - 1); _a < En; _a++)
                Rn[_a - 1] = arguments[_a];
            $n[wa].fn.apply($n[wa].context, Rn);
        }
    }
    return !0;
  }, ge.prototype.on = function(Ee, xe, $e) {
    return le(this, Ee, xe, $e, !1);
  }, ge.prototype.once = function(Ee, xe, $e) {
    return le(this, Ee, xe, $e, !0);
  }, ge.prototype.removeListener = function(Ee, xe, $e, Ne) {
    var st = z ? z + Ee : Ee;
    if (!this._events[st])
      return this;
    if (!xe)
      return he(this, st), this;
    var Nr = this._events[st];
    if (Nr.fn)
      Nr.fn === xe && (!Ne || Nr.once) && (!$e || Nr.context === $e) && he(this, st);
    else {
      for (var br = 0, $n = [], En = Nr.length; br < En; br++)
        (Nr[br].fn !== xe || Ne && !Nr[br].once || $e && Nr[br].context !== $e) && $n.push(Nr[br]);
      $n.length ? this._events[st] = $n.length === 1 ? $n[0] : $n : he(this, st);
    }
    return this;
  }, ge.prototype.removeAllListeners = function(Ee) {
    var xe;
    return Ee ? (xe = z ? z + Ee : Ee, this._events[xe] && he(this, xe)) : (this._events = new ne(), this._eventsCount = 0), this;
  }, ge.prototype.off = ge.prototype.removeListener, ge.prototype.addListener = ge.prototype.on, ge.prefixed = z, ge.EventEmitter = ge, v.exports = ge;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
var __accessCheck = (v, y, z) => {
  if (!y.has(v))
    throw TypeError("Cannot " + z);
}, __privateGet = (v, y, z) => (__accessCheck(v, y, "read from private field"), z ? z.call(v) : y.get(v)), __privateAdd = (v, y, z) => {
  if (y.has(v))
    throw TypeError("Cannot add the same private member more than once");
  y instanceof WeakSet ? y.add(v) : y.set(v, z);
}, __privateSet = (v, y, z, ne) => (__accessCheck(v, y, "write to private field"), ne ? ne.call(v, z) : y.set(v, z), z), __privateMethod = (v, y, z) => (__accessCheck(v, y, "access private method"), z), Connector = class extends EventEmitter {
  constructor({
    chains: v = [mainnet, goerli],
    options: y
  }) {
    super(), this.chains = v, this.options = y;
  }
  getBlockExplorerUrls(v) {
    const { default: y, ...z } = v.blockExplorers ?? {};
    if (y)
      return [
        y.url,
        ...Object.values(z).map((ne) => ne.url)
      ];
  }
  isChainUnsupported(v) {
    return !this.chains.some((y) => y.id === v);
  }
  setStorage(v) {
    this.storage = v;
  }
};
function getInjectedName(v) {
  var z;
  if (!v)
    return "Injected";
  const y = (ne) => {
    if (ne.isApexWallet)
      return "Apex Wallet";
    if (ne.isAvalanche)
      return "Core Wallet";
    if (ne.isBackpack)
      return "Backpack";
    if (ne.isBifrost)
      return "Bifrost Wallet";
    if (ne.isBitKeep)
      return "BitKeep";
    if (ne.isBitski)
      return "Bitski";
    if (ne.isBlockWallet)
      return "BlockWallet";
    if (ne.isBraveWallet)
      return "Brave Wallet";
    if (ne.isCoin98)
      return "Coin98 Wallet";
    if (ne.isCoinbaseWallet)
      return "Coinbase Wallet";
    if (ne.isDawn)
      return "Dawn Wallet";
    if (ne.isDefiant)
      return "Defiant";
    if (ne.isDesig)
      return "Desig Wallet";
    if (ne.isEnkrypt)
      return "Enkrypt";
    if (ne.isExodus)
      return "Exodus";
    if (ne.isFordefi)
      return "Fordefi";
    if (ne.isFrame)
      return "Frame";
    if (ne.isFrontier)
      return "Frontier Wallet";
    if (ne.isGamestop)
      return "GameStop Wallet";
    if (ne.isHaqqWallet)
      return "HAQQ Wallet";
    if (ne.isHyperPay)
      return "HyperPay Wallet";
    if (ne.isImToken)
      return "ImToken";
    if (ne.isHaloWallet)
      return "Halo Wallet";
    if (ne.isKuCoinWallet)
      return "KuCoin Wallet";
    if (ne.isMathWallet)
      return "MathWallet";
    if (ne.isNovaWallet)
      return "Nova Wallet";
    if (ne.isOkxWallet || ne.isOKExWallet)
      return "OKX Wallet";
    if (ne.isOktoWallet)
      return "Okto Wallet";
    if (ne.isOneInchIOSWallet || ne.isOneInchAndroidWallet)
      return "1inch Wallet";
    if (ne.isOneKey)
      return "OneKey Wallet";
    if (ne.isOpera)
      return "Opera";
    if (ne.isPhantom)
      return "Phantom";
    if (ne.isPortal)
      return "Ripio Portal";
    if (ne.isRabby)
      return "Rabby Wallet";
    if (ne.isRainbow)
      return "Rainbow";
    if (ne.isSafePal)
      return "SafePal Wallet";
    if (ne.isStatus)
      return "Status";
    if (ne.isSubWallet)
      return "SubWallet";
    if (ne.isTalisman)
      return "Talisman";
    if (ne.isTally)
      return "Taho";
    if (ne.isTokenPocket)
      return "TokenPocket";
    if (ne.isTokenary)
      return "Tokenary";
    if (ne.isTrust || ne.isTrustWallet)
      return "Trust Wallet";
    if (ne.isTTWallet)
      return "TTWallet";
    if (ne.isXDEFI)
      return "XDEFI Wallet";
    if (ne.isZeal)
      return "Zeal";
    if (ne.isZerion)
      return "Zerion";
    if (ne.isMetaMask)
      return "MetaMask";
  };
  if ((z = v.providers) != null && z.length) {
    const ne = /* @__PURE__ */ new Set();
    let ue = 1;
    for (const he of v.providers) {
      let ge = y(he);
      ge || (ge = `Unknown Wallet #${ue}`, ue += 1), ne.add(ge);
    }
    const le = [...ne];
    return le.length ? le : le[0] ?? "Injected";
  }
  return y(v) ?? "Injected";
}
var _provider$3, InjectedConnector = class extends Connector {
  constructor({
    chains: v,
    options: y
  } = {}) {
    const z = {
      shimDisconnect: !0,
      getProvider() {
        if (typeof window > "u")
          return;
        const ue = window.ethereum;
        return ue != null && ue.providers && ue.providers.length > 0 ? ue.providers[0] : ue;
      },
      ...y
    };
    super({ chains: v, options: z }), this.id = "injected", __privateAdd(this, _provider$3, void 0), this.shimDisconnectKey = `${this.id}.shimDisconnect`, this.onAccountsChanged = (ue) => {
      ue.length === 0 ? this.emit("disconnect") : this.emit("change", {
        account: getAddress(ue[0])
      });
    }, this.onChainChanged = (ue) => {
      const le = normalizeChainId(ue), he = this.isChainUnsupported(le);
      this.emit("change", { chain: { id: le, unsupported: he } });
    }, this.onDisconnect = async (ue) => {
      var le;
      ue.code === 1013 && await this.getProvider() && await this.getAccount() || (this.emit("disconnect"), this.options.shimDisconnect && ((le = this.storage) == null || le.removeItem(this.shimDisconnectKey)));
    };
    const ne = z.getProvider();
    if (typeof z.name == "string")
      this.name = z.name;
    else if (ne) {
      const ue = getInjectedName(ne);
      z.name ? this.name = z.name(ue) : typeof ue == "string" ? this.name = ue : this.name = ue[0];
    } else
      this.name = "Injected";
    this.ready = !!ne;
  }
  async connect({ chainId: v } = {}) {
    var y;
    try {
      const z = await this.getProvider();
      if (!z)
        throw new ConnectorNotFoundError();
      z.on && (z.on("accountsChanged", this.onAccountsChanged), z.on("chainChanged", this.onChainChanged), z.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      const ne = await z.request({
        method: "eth_requestAccounts"
      }), ue = getAddress(ne[0]);
      let le = await this.getChainId(), he = this.isChainUnsupported(le);
      return v && le !== v && (le = (await this.switchChain(v)).id, he = this.isChainUnsupported(le)), this.options.shimDisconnect && ((y = this.storage) == null || y.setItem(this.shimDisconnectKey, !0)), { account: ue, chain: { id: le, unsupported: he } };
    } catch (z) {
      throw this.isUserRejectedRequestError(z) ? new UserRejectedRequestError(z) : z.code === -32002 ? new ResourceUnavailableRpcError(z) : z;
    }
  }
  async disconnect() {
    var y;
    const v = await this.getProvider();
    v != null && v.removeListener && (v.removeListener("accountsChanged", this.onAccountsChanged), v.removeListener("chainChanged", this.onChainChanged), v.removeListener("disconnect", this.onDisconnect), this.options.shimDisconnect && ((y = this.storage) == null || y.removeItem(this.shimDisconnectKey)));
  }
  async getAccount() {
    const v = await this.getProvider();
    if (!v)
      throw new ConnectorNotFoundError();
    const y = await v.request({
      method: "eth_accounts"
    });
    return getAddress(y[0]);
  }
  async getChainId() {
    const v = await this.getProvider();
    if (!v)
      throw new ConnectorNotFoundError();
    return v.request({ method: "eth_chainId" }).then(normalizeChainId);
  }
  async getProvider() {
    const v = this.options.getProvider();
    return v && __privateSet(this, _provider$3, v), __privateGet(this, _provider$3);
  }
  async getWalletClient({
    chainId: v
  } = {}) {
    const [y, z] = await Promise.all([
      this.getProvider(),
      this.getAccount()
    ]), ne = this.chains.find((ue) => ue.id === v);
    if (!y)
      throw new Error("provider is required.");
    return createWalletClient({
      account: z,
      chain: ne,
      transport: custom(y)
    });
  }
  async isAuthorized() {
    var v;
    try {
      if (this.options.shimDisconnect && !((v = this.storage) != null && v.getItem(this.shimDisconnectKey)))
        return !1;
      if (!await this.getProvider())
        throw new ConnectorNotFoundError();
      return !!await this.getAccount();
    } catch {
      return !1;
    }
  }
  async switchChain(v) {
    var ne, ue, le;
    const y = await this.getProvider();
    if (!y)
      throw new ConnectorNotFoundError();
    const z = numberToHex$1(v);
    try {
      return await Promise.all([
        y.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: z }]
        }),
        new Promise(
          (he) => this.on("change", ({ chain: ge }) => {
            (ge == null ? void 0 : ge.id) === v && he();
          })
        )
      ]), this.chains.find((he) => he.id === v) ?? {
        id: v,
        name: `Chain ${z}`,
        network: `${z}`,
        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
      };
    } catch (he) {
      const ge = this.chains.find((we) => we.id === v);
      if (!ge)
        throw new ChainNotConfiguredForConnectorError({
          chainId: v,
          connectorId: this.id
        });
      if (he.code === 4902 || ((ue = (ne = he == null ? void 0 : he.data) == null ? void 0 : ne.originalError) == null ? void 0 : ue.code) === 4902)
        try {
          if (await y.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: z,
                chainName: ge.name,
                nativeCurrency: ge.nativeCurrency,
                rpcUrls: [((le = ge.rpcUrls.public) == null ? void 0 : le.http[0]) ?? ""],
                blockExplorerUrls: this.getBlockExplorerUrls(ge)
              }
            ]
          }), await this.getChainId() !== v)
            throw new UserRejectedRequestError(
              new Error("User rejected switch after adding network.")
            );
          return ge;
        } catch (we) {
          throw new UserRejectedRequestError(we);
        }
      throw this.isUserRejectedRequestError(he) ? new UserRejectedRequestError(he) : new SwitchChainError(he);
    }
  }
  async watchAsset({
    address: v,
    decimals: y = 18,
    image: z,
    symbol: ne
  }) {
    const ue = await this.getProvider();
    if (!ue)
      throw new ConnectorNotFoundError();
    return ue.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: v,
          decimals: y,
          image: z,
          symbol: ne
        }
      }
    });
  }
  isUserRejectedRequestError(v) {
    return v.code === 4001;
  }
};
_provider$3 = /* @__PURE__ */ new WeakMap();
function getExplicitInjectedProvider(v) {
  if (typeof window > "u" || typeof window.ethereum > "u")
    return;
  const y = window.ethereum.providers;
  return y ? y.find((z) => z[v]) : window.ethereum[v] ? window.ethereum : void 0;
}
function hasInjectedProvider(v) {
  return !!getExplicitInjectedProvider(v);
}
function getInjectedProvider(v) {
  if (typeof window > "u" || typeof window.ethereum > "u")
    return;
  const y = window.ethereum.providers, z = getExplicitInjectedProvider(v);
  return z || (typeof y < "u" && y.length > 0 ? y[0] : window.ethereum);
}
function getInjectedConnector({
  chains: v,
  flag: y,
  options: z
}) {
  return new InjectedConnector({
    chains: v,
    options: {
      getProvider: () => getInjectedProvider(y),
      ...z
    }
  });
}
var chacha20poly1305 = {}, chacha = {}, binary = {}, int = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 });
  function y(ge, we) {
    var Ee = ge >>> 16 & 65535, xe = ge & 65535, $e = we >>> 16 & 65535, Ne = we & 65535;
    return xe * Ne + (Ee * Ne + xe * $e << 16 >>> 0) | 0;
  }
  v.mul = Math.imul || y;
  function z(ge, we) {
    return ge + we | 0;
  }
  v.add = z;
  function ne(ge, we) {
    return ge - we | 0;
  }
  v.sub = ne;
  function ue(ge, we) {
    return ge << we | ge >>> 32 - we;
  }
  v.rotl = ue;
  function le(ge, we) {
    return ge << 32 - we | ge >>> we;
  }
  v.rotr = le;
  function he(ge) {
    return typeof ge == "number" && isFinite(ge) && Math.floor(ge) === ge;
  }
  v.isInteger = Number.isInteger || he, v.MAX_SAFE_INTEGER = 9007199254740991, v.isSafeInteger = function(ge) {
    return v.isInteger(ge) && ge >= -v.MAX_SAFE_INTEGER && ge <= v.MAX_SAFE_INTEGER;
  };
})(int);
Object.defineProperty(binary, "__esModule", { value: !0 });
var int_1 = int;
function readInt16BE(v, y) {
  return y === void 0 && (y = 0), (v[y + 0] << 8 | v[y + 1]) << 16 >> 16;
}
binary.readInt16BE = readInt16BE;
function readUint16BE(v, y) {
  return y === void 0 && (y = 0), (v[y + 0] << 8 | v[y + 1]) >>> 0;
}
binary.readUint16BE = readUint16BE;
function readInt16LE(v, y) {
  return y === void 0 && (y = 0), (v[y + 1] << 8 | v[y]) << 16 >> 16;
}
binary.readInt16LE = readInt16LE;
function readUint16LE(v, y) {
  return y === void 0 && (y = 0), (v[y + 1] << 8 | v[y]) >>> 0;
}
binary.readUint16LE = readUint16LE;
function writeUint16BE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(2)), z === void 0 && (z = 0), y[z + 0] = v >>> 8, y[z + 1] = v >>> 0, y;
}
binary.writeUint16BE = writeUint16BE;
binary.writeInt16BE = writeUint16BE;
function writeUint16LE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(2)), z === void 0 && (z = 0), y[z + 0] = v >>> 0, y[z + 1] = v >>> 8, y;
}
binary.writeUint16LE = writeUint16LE;
binary.writeInt16LE = writeUint16LE;
function readInt32BE(v, y) {
  return y === void 0 && (y = 0), v[y] << 24 | v[y + 1] << 16 | v[y + 2] << 8 | v[y + 3];
}
binary.readInt32BE = readInt32BE;
function readUint32BE(v, y) {
  return y === void 0 && (y = 0), (v[y] << 24 | v[y + 1] << 16 | v[y + 2] << 8 | v[y + 3]) >>> 0;
}
binary.readUint32BE = readUint32BE;
function readInt32LE(v, y) {
  return y === void 0 && (y = 0), v[y + 3] << 24 | v[y + 2] << 16 | v[y + 1] << 8 | v[y];
}
binary.readInt32LE = readInt32LE;
function readUint32LE(v, y) {
  return y === void 0 && (y = 0), (v[y + 3] << 24 | v[y + 2] << 16 | v[y + 1] << 8 | v[y]) >>> 0;
}
binary.readUint32LE = readUint32LE;
function writeUint32BE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(4)), z === void 0 && (z = 0), y[z + 0] = v >>> 24, y[z + 1] = v >>> 16, y[z + 2] = v >>> 8, y[z + 3] = v >>> 0, y;
}
binary.writeUint32BE = writeUint32BE;
binary.writeInt32BE = writeUint32BE;
function writeUint32LE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(4)), z === void 0 && (z = 0), y[z + 0] = v >>> 0, y[z + 1] = v >>> 8, y[z + 2] = v >>> 16, y[z + 3] = v >>> 24, y;
}
binary.writeUint32LE = writeUint32LE;
binary.writeInt32LE = writeUint32LE;
function readInt64BE(v, y) {
  y === void 0 && (y = 0);
  var z = readInt32BE(v, y), ne = readInt32BE(v, y + 4);
  return z * 4294967296 + ne - (ne >> 31) * 4294967296;
}
binary.readInt64BE = readInt64BE;
function readUint64BE(v, y) {
  y === void 0 && (y = 0);
  var z = readUint32BE(v, y), ne = readUint32BE(v, y + 4);
  return z * 4294967296 + ne;
}
binary.readUint64BE = readUint64BE;
function readInt64LE(v, y) {
  y === void 0 && (y = 0);
  var z = readInt32LE(v, y), ne = readInt32LE(v, y + 4);
  return ne * 4294967296 + z - (z >> 31) * 4294967296;
}
binary.readInt64LE = readInt64LE;
function readUint64LE(v, y) {
  y === void 0 && (y = 0);
  var z = readUint32LE(v, y), ne = readUint32LE(v, y + 4);
  return ne * 4294967296 + z;
}
binary.readUint64LE = readUint64LE;
function writeUint64BE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(8)), z === void 0 && (z = 0), writeUint32BE(v / 4294967296 >>> 0, y, z), writeUint32BE(v >>> 0, y, z + 4), y;
}
binary.writeUint64BE = writeUint64BE;
binary.writeInt64BE = writeUint64BE;
function writeUint64LE(v, y, z) {
  return y === void 0 && (y = new Uint8Array(8)), z === void 0 && (z = 0), writeUint32LE(v >>> 0, y, z), writeUint32LE(v / 4294967296 >>> 0, y, z + 4), y;
}
binary.writeUint64LE = writeUint64LE;
binary.writeInt64LE = writeUint64LE;
function readUintBE(v, y, z) {
  if (z === void 0 && (z = 0), v % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (v / 8 > y.length - z)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var ne = 0, ue = 1, le = v / 8 + z - 1; le >= z; le--)
    ne += y[le] * ue, ue *= 256;
  return ne;
}
binary.readUintBE = readUintBE;
function readUintLE(v, y, z) {
  if (z === void 0 && (z = 0), v % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (v / 8 > y.length - z)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var ne = 0, ue = 1, le = z; le < z + v / 8; le++)
    ne += y[le] * ue, ue *= 256;
  return ne;
}
binary.readUintLE = readUintLE;
function writeUintBE(v, y, z, ne) {
  if (z === void 0 && (z = new Uint8Array(v / 8)), ne === void 0 && (ne = 0), v % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(y))
    throw new Error("writeUintBE value must be an integer");
  for (var ue = 1, le = v / 8 + ne - 1; le >= ne; le--)
    z[le] = y / ue & 255, ue *= 256;
  return z;
}
binary.writeUintBE = writeUintBE;
function writeUintLE(v, y, z, ne) {
  if (z === void 0 && (z = new Uint8Array(v / 8)), ne === void 0 && (ne = 0), v % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!int_1.isSafeInteger(y))
    throw new Error("writeUintLE value must be an integer");
  for (var ue = 1, le = ne; le < ne + v / 8; le++)
    z[le] = y / ue & 255, ue *= 256;
  return z;
}
binary.writeUintLE = writeUintLE;
function readFloat32BE(v, y) {
  y === void 0 && (y = 0);
  var z = new DataView(v.buffer, v.byteOffset, v.byteLength);
  return z.getFloat32(y);
}
binary.readFloat32BE = readFloat32BE;
function readFloat32LE(v, y) {
  y === void 0 && (y = 0);
  var z = new DataView(v.buffer, v.byteOffset, v.byteLength);
  return z.getFloat32(y, !0);
}
binary.readFloat32LE = readFloat32LE;
function readFloat64BE(v, y) {
  y === void 0 && (y = 0);
  var z = new DataView(v.buffer, v.byteOffset, v.byteLength);
  return z.getFloat64(y);
}
binary.readFloat64BE = readFloat64BE;
function readFloat64LE(v, y) {
  y === void 0 && (y = 0);
  var z = new DataView(v.buffer, v.byteOffset, v.byteLength);
  return z.getFloat64(y, !0);
}
binary.readFloat64LE = readFloat64LE;
function writeFloat32BE(v, y, z) {
  y === void 0 && (y = new Uint8Array(4)), z === void 0 && (z = 0);
  var ne = new DataView(y.buffer, y.byteOffset, y.byteLength);
  return ne.setFloat32(z, v), y;
}
binary.writeFloat32BE = writeFloat32BE;
function writeFloat32LE(v, y, z) {
  y === void 0 && (y = new Uint8Array(4)), z === void 0 && (z = 0);
  var ne = new DataView(y.buffer, y.byteOffset, y.byteLength);
  return ne.setFloat32(z, v, !0), y;
}
binary.writeFloat32LE = writeFloat32LE;
function writeFloat64BE(v, y, z) {
  y === void 0 && (y = new Uint8Array(8)), z === void 0 && (z = 0);
  var ne = new DataView(y.buffer, y.byteOffset, y.byteLength);
  return ne.setFloat64(z, v), y;
}
binary.writeFloat64BE = writeFloat64BE;
function writeFloat64LE(v, y, z) {
  y === void 0 && (y = new Uint8Array(8)), z === void 0 && (z = 0);
  var ne = new DataView(y.buffer, y.byteOffset, y.byteLength);
  return ne.setFloat64(z, v, !0), y;
}
binary.writeFloat64LE = writeFloat64LE;
var wipe$1 = {};
Object.defineProperty(wipe$1, "__esModule", { value: !0 });
function wipe(v) {
  for (var y = 0; y < v.length; y++)
    v[y] = 0;
  return v;
}
wipe$1.wipe = wipe;
Object.defineProperty(chacha, "__esModule", { value: !0 });
var binary_1 = binary, wipe_1$3 = wipe$1, ROUNDS = 20;
function core(v, y, z) {
  for (var ne = 1634760805, ue = 857760878, le = 2036477234, he = 1797285236, ge = z[3] << 24 | z[2] << 16 | z[1] << 8 | z[0], we = z[7] << 24 | z[6] << 16 | z[5] << 8 | z[4], Ee = z[11] << 24 | z[10] << 16 | z[9] << 8 | z[8], xe = z[15] << 24 | z[14] << 16 | z[13] << 8 | z[12], $e = z[19] << 24 | z[18] << 16 | z[17] << 8 | z[16], Ne = z[23] << 24 | z[22] << 16 | z[21] << 8 | z[20], st = z[27] << 24 | z[26] << 16 | z[25] << 8 | z[24], Nr = z[31] << 24 | z[30] << 16 | z[29] << 8 | z[28], br = y[3] << 24 | y[2] << 16 | y[1] << 8 | y[0], $n = y[7] << 24 | y[6] << 16 | y[5] << 8 | y[4], En = y[11] << 24 | y[10] << 16 | y[9] << 8 | y[8], Rn = y[15] << 24 | y[14] << 16 | y[13] << 8 | y[12], wa = ne, Aa = ue, _a = le, Ta = he, Zn = ge, Ra = we, Yn = Ee, $o = xe, ct = $e, fe = Ne, be = st, ye = Nr, Se = br, Oe = $n, Fr = En, zn = Rn, Fe = 0; Fe < ROUNDS; Fe += 2)
    wa = wa + Zn | 0, Se ^= wa, Se = Se >>> 16 | Se << 16, ct = ct + Se | 0, Zn ^= ct, Zn = Zn >>> 20 | Zn << 12, Aa = Aa + Ra | 0, Oe ^= Aa, Oe = Oe >>> 16 | Oe << 16, fe = fe + Oe | 0, Ra ^= fe, Ra = Ra >>> 20 | Ra << 12, _a = _a + Yn | 0, Fr ^= _a, Fr = Fr >>> 16 | Fr << 16, be = be + Fr | 0, Yn ^= be, Yn = Yn >>> 20 | Yn << 12, Ta = Ta + $o | 0, zn ^= Ta, zn = zn >>> 16 | zn << 16, ye = ye + zn | 0, $o ^= ye, $o = $o >>> 20 | $o << 12, _a = _a + Yn | 0, Fr ^= _a, Fr = Fr >>> 24 | Fr << 8, be = be + Fr | 0, Yn ^= be, Yn = Yn >>> 25 | Yn << 7, Ta = Ta + $o | 0, zn ^= Ta, zn = zn >>> 24 | zn << 8, ye = ye + zn | 0, $o ^= ye, $o = $o >>> 25 | $o << 7, Aa = Aa + Ra | 0, Oe ^= Aa, Oe = Oe >>> 24 | Oe << 8, fe = fe + Oe | 0, Ra ^= fe, Ra = Ra >>> 25 | Ra << 7, wa = wa + Zn | 0, Se ^= wa, Se = Se >>> 24 | Se << 8, ct = ct + Se | 0, Zn ^= ct, Zn = Zn >>> 25 | Zn << 7, wa = wa + Ra | 0, zn ^= wa, zn = zn >>> 16 | zn << 16, be = be + zn | 0, Ra ^= be, Ra = Ra >>> 20 | Ra << 12, Aa = Aa + Yn | 0, Se ^= Aa, Se = Se >>> 16 | Se << 16, ye = ye + Se | 0, Yn ^= ye, Yn = Yn >>> 20 | Yn << 12, _a = _a + $o | 0, Oe ^= _a, Oe = Oe >>> 16 | Oe << 16, ct = ct + Oe | 0, $o ^= ct, $o = $o >>> 20 | $o << 12, Ta = Ta + Zn | 0, Fr ^= Ta, Fr = Fr >>> 16 | Fr << 16, fe = fe + Fr | 0, Zn ^= fe, Zn = Zn >>> 20 | Zn << 12, _a = _a + $o | 0, Oe ^= _a, Oe = Oe >>> 24 | Oe << 8, ct = ct + Oe | 0, $o ^= ct, $o = $o >>> 25 | $o << 7, Ta = Ta + Zn | 0, Fr ^= Ta, Fr = Fr >>> 24 | Fr << 8, fe = fe + Fr | 0, Zn ^= fe, Zn = Zn >>> 25 | Zn << 7, Aa = Aa + Yn | 0, Se ^= Aa, Se = Se >>> 24 | Se << 8, ye = ye + Se | 0, Yn ^= ye, Yn = Yn >>> 25 | Yn << 7, wa = wa + Ra | 0, zn ^= wa, zn = zn >>> 24 | zn << 8, be = be + zn | 0, Ra ^= be, Ra = Ra >>> 25 | Ra << 7;
  binary_1.writeUint32LE(wa + ne | 0, v, 0), binary_1.writeUint32LE(Aa + ue | 0, v, 4), binary_1.writeUint32LE(_a + le | 0, v, 8), binary_1.writeUint32LE(Ta + he | 0, v, 12), binary_1.writeUint32LE(Zn + ge | 0, v, 16), binary_1.writeUint32LE(Ra + we | 0, v, 20), binary_1.writeUint32LE(Yn + Ee | 0, v, 24), binary_1.writeUint32LE($o + xe | 0, v, 28), binary_1.writeUint32LE(ct + $e | 0, v, 32), binary_1.writeUint32LE(fe + Ne | 0, v, 36), binary_1.writeUint32LE(be + st | 0, v, 40), binary_1.writeUint32LE(ye + Nr | 0, v, 44), binary_1.writeUint32LE(Se + br | 0, v, 48), binary_1.writeUint32LE(Oe + $n | 0, v, 52), binary_1.writeUint32LE(Fr + En | 0, v, 56), binary_1.writeUint32LE(zn + Rn | 0, v, 60);
}
function streamXOR(v, y, z, ne, ue) {
  if (ue === void 0 && (ue = 0), v.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (ne.length < z.length)
    throw new Error("ChaCha: destination is shorter than source");
  var le, he;
  if (ue === 0) {
    if (y.length !== 8 && y.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    le = new Uint8Array(16), he = le.length - y.length, le.set(y, he);
  } else {
    if (y.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    le = y, he = ue;
  }
  for (var ge = new Uint8Array(64), we = 0; we < z.length; we += 64) {
    core(ge, le, v);
    for (var Ee = we; Ee < we + 64 && Ee < z.length; Ee++)
      ne[Ee] = z[Ee] ^ ge[Ee - we];
    incrementCounter(le, 0, he);
  }
  return wipe_1$3.wipe(ge), ue === 0 && wipe_1$3.wipe(le), ne;
}
chacha.streamXOR = streamXOR;
function stream(v, y, z, ne) {
  return ne === void 0 && (ne = 0), wipe_1$3.wipe(z), streamXOR(v, y, z, z, ne);
}
chacha.stream = stream;
function incrementCounter(v, y, z) {
  for (var ne = 1; z--; )
    ne = ne + (v[y] & 255) | 0, v[y] = ne & 255, ne >>>= 8, y++;
  if (ne > 0)
    throw new Error("ChaCha: counter overflow");
}
var poly1305 = {}, constantTime = {};
Object.defineProperty(constantTime, "__esModule", { value: !0 });
function select(v, y, z) {
  return ~(v - 1) & y | v - 1 & z;
}
constantTime.select = select;
function lessOrEqual(v, y) {
  return (v | 0) - (y | 0) - 1 >>> 31 & 1;
}
constantTime.lessOrEqual = lessOrEqual;
function compare(v, y) {
  if (v.length !== y.length)
    return 0;
  for (var z = 0, ne = 0; ne < v.length; ne++)
    z |= v[ne] ^ y[ne];
  return 1 & z - 1 >>> 8;
}
constantTime.compare = compare;
function equal(v, y) {
  return v.length === 0 || y.length === 0 ? !1 : compare(v, y) !== 0;
}
constantTime.equal = equal;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 });
  var y = constantTime, z = wipe$1;
  v.DIGEST_LENGTH = 16;
  var ne = (
    /** @class */
    function() {
      function he(ge) {
        this.digestLength = v.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
        var we = ge[0] | ge[1] << 8;
        this._r[0] = we & 8191;
        var Ee = ge[2] | ge[3] << 8;
        this._r[1] = (we >>> 13 | Ee << 3) & 8191;
        var xe = ge[4] | ge[5] << 8;
        this._r[2] = (Ee >>> 10 | xe << 6) & 7939;
        var $e = ge[6] | ge[7] << 8;
        this._r[3] = (xe >>> 7 | $e << 9) & 8191;
        var Ne = ge[8] | ge[9] << 8;
        this._r[4] = ($e >>> 4 | Ne << 12) & 255, this._r[5] = Ne >>> 1 & 8190;
        var st = ge[10] | ge[11] << 8;
        this._r[6] = (Ne >>> 14 | st << 2) & 8191;
        var Nr = ge[12] | ge[13] << 8;
        this._r[7] = (st >>> 11 | Nr << 5) & 8065;
        var br = ge[14] | ge[15] << 8;
        this._r[8] = (Nr >>> 8 | br << 8) & 8191, this._r[9] = br >>> 5 & 127, this._pad[0] = ge[16] | ge[17] << 8, this._pad[1] = ge[18] | ge[19] << 8, this._pad[2] = ge[20] | ge[21] << 8, this._pad[3] = ge[22] | ge[23] << 8, this._pad[4] = ge[24] | ge[25] << 8, this._pad[5] = ge[26] | ge[27] << 8, this._pad[6] = ge[28] | ge[29] << 8, this._pad[7] = ge[30] | ge[31] << 8;
      }
      return he.prototype._blocks = function(ge, we, Ee) {
        for (var xe = this._fin ? 0 : 2048, $e = this._h[0], Ne = this._h[1], st = this._h[2], Nr = this._h[3], br = this._h[4], $n = this._h[5], En = this._h[6], Rn = this._h[7], wa = this._h[8], Aa = this._h[9], _a = this._r[0], Ta = this._r[1], Zn = this._r[2], Ra = this._r[3], Yn = this._r[4], $o = this._r[5], ct = this._r[6], fe = this._r[7], be = this._r[8], ye = this._r[9]; Ee >= 16; ) {
          var Se = ge[we + 0] | ge[we + 1] << 8;
          $e += Se & 8191;
          var Oe = ge[we + 2] | ge[we + 3] << 8;
          Ne += (Se >>> 13 | Oe << 3) & 8191;
          var Fr = ge[we + 4] | ge[we + 5] << 8;
          st += (Oe >>> 10 | Fr << 6) & 8191;
          var zn = ge[we + 6] | ge[we + 7] << 8;
          Nr += (Fr >>> 7 | zn << 9) & 8191;
          var Fe = ge[we + 8] | ge[we + 9] << 8;
          br += (zn >>> 4 | Fe << 12) & 8191, $n += Fe >>> 1 & 8191;
          var pe = ge[we + 10] | ge[we + 11] << 8;
          En += (Fe >>> 14 | pe << 2) & 8191;
          var it = ge[we + 12] | ge[we + 13] << 8;
          Rn += (pe >>> 11 | it << 5) & 8191;
          var xa = ge[we + 14] | ge[we + 15] << 8;
          wa += (it >>> 8 | xa << 8) & 8191, Aa += xa >>> 5 | xe;
          var wo = 0, _u = wo;
          _u += $e * _a, _u += Ne * (5 * ye), _u += st * (5 * be), _u += Nr * (5 * fe), _u += br * (5 * ct), wo = _u >>> 13, _u &= 8191, _u += $n * (5 * $o), _u += En * (5 * Yn), _u += Rn * (5 * Ra), _u += wa * (5 * Zn), _u += Aa * (5 * Ta), wo += _u >>> 13, _u &= 8191;
          var Oa = wo;
          Oa += $e * Ta, Oa += Ne * _a, Oa += st * (5 * ye), Oa += Nr * (5 * be), Oa += br * (5 * fe), wo = Oa >>> 13, Oa &= 8191, Oa += $n * (5 * ct), Oa += En * (5 * $o), Oa += Rn * (5 * Yn), Oa += wa * (5 * Ra), Oa += Aa * (5 * Zn), wo += Oa >>> 13, Oa &= 8191;
          var Os = wo;
          Os += $e * Zn, Os += Ne * Ta, Os += st * _a, Os += Nr * (5 * ye), Os += br * (5 * be), wo = Os >>> 13, Os &= 8191, Os += $n * (5 * fe), Os += En * (5 * ct), Os += Rn * (5 * $o), Os += wa * (5 * Yn), Os += Aa * (5 * Ra), wo += Os >>> 13, Os &= 8191;
          var Pa = wo;
          Pa += $e * Ra, Pa += Ne * Zn, Pa += st * Ta, Pa += Nr * _a, Pa += br * (5 * ye), wo = Pa >>> 13, Pa &= 8191, Pa += $n * (5 * be), Pa += En * (5 * fe), Pa += Rn * (5 * ct), Pa += wa * (5 * $o), Pa += Aa * (5 * Yn), wo += Pa >>> 13, Pa &= 8191;
          var Ml = wo;
          Ml += $e * Yn, Ml += Ne * Ra, Ml += st * Zn, Ml += Nr * Ta, Ml += br * _a, wo = Ml >>> 13, Ml &= 8191, Ml += $n * (5 * ye), Ml += En * (5 * be), Ml += Rn * (5 * fe), Ml += wa * (5 * ct), Ml += Aa * (5 * $o), wo += Ml >>> 13, Ml &= 8191;
          var Su = wo;
          Su += $e * $o, Su += Ne * Yn, Su += st * Ra, Su += Nr * Zn, Su += br * Ta, wo = Su >>> 13, Su &= 8191, Su += $n * _a, Su += En * (5 * ye), Su += Rn * (5 * be), Su += wa * (5 * fe), Su += Aa * (5 * ct), wo += Su >>> 13, Su &= 8191;
          var Tu = wo;
          Tu += $e * ct, Tu += Ne * $o, Tu += st * Yn, Tu += Nr * Ra, Tu += br * Zn, wo = Tu >>> 13, Tu &= 8191, Tu += $n * Ta, Tu += En * _a, Tu += Rn * (5 * ye), Tu += wa * (5 * be), Tu += Aa * (5 * fe), wo += Tu >>> 13, Tu &= 8191;
          var Au = wo;
          Au += $e * fe, Au += Ne * ct, Au += st * $o, Au += Nr * Yn, Au += br * Ra, wo = Au >>> 13, Au &= 8191, Au += $n * Zn, Au += En * Ta, Au += Rn * _a, Au += wa * (5 * ye), Au += Aa * (5 * be), wo += Au >>> 13, Au &= 8191;
          var Zl = wo;
          Zl += $e * be, Zl += Ne * fe, Zl += st * ct, Zl += Nr * $o, Zl += br * Yn, wo = Zl >>> 13, Zl &= 8191, Zl += $n * Ra, Zl += En * Zn, Zl += Rn * Ta, Zl += wa * _a, Zl += Aa * (5 * ye), wo += Zl >>> 13, Zl &= 8191;
          var Iu = wo;
          Iu += $e * ye, Iu += Ne * be, Iu += st * fe, Iu += Nr * ct, Iu += br * $o, wo = Iu >>> 13, Iu &= 8191, Iu += $n * Yn, Iu += En * Ra, Iu += Rn * Zn, Iu += wa * Ta, Iu += Aa * _a, wo += Iu >>> 13, Iu &= 8191, wo = (wo << 2) + wo | 0, wo = wo + _u | 0, _u = wo & 8191, wo = wo >>> 13, Oa += wo, $e = _u, Ne = Oa, st = Os, Nr = Pa, br = Ml, $n = Su, En = Tu, Rn = Au, wa = Zl, Aa = Iu, we += 16, Ee -= 16;
        }
        this._h[0] = $e, this._h[1] = Ne, this._h[2] = st, this._h[3] = Nr, this._h[4] = br, this._h[5] = $n, this._h[6] = En, this._h[7] = Rn, this._h[8] = wa, this._h[9] = Aa;
      }, he.prototype.finish = function(ge, we) {
        we === void 0 && (we = 0);
        var Ee = new Uint16Array(10), xe, $e, Ne, st;
        if (this._leftover) {
          for (st = this._leftover, this._buffer[st++] = 1; st < 16; st++)
            this._buffer[st] = 0;
          this._fin = 1, this._blocks(this._buffer, 0, 16);
        }
        for (xe = this._h[1] >>> 13, this._h[1] &= 8191, st = 2; st < 10; st++)
          this._h[st] += xe, xe = this._h[st] >>> 13, this._h[st] &= 8191;
        for (this._h[0] += xe * 5, xe = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += xe, xe = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += xe, Ee[0] = this._h[0] + 5, xe = Ee[0] >>> 13, Ee[0] &= 8191, st = 1; st < 10; st++)
          Ee[st] = this._h[st] + xe, xe = Ee[st] >>> 13, Ee[st] &= 8191;
        for (Ee[9] -= 8192, $e = (xe ^ 1) - 1, st = 0; st < 10; st++)
          Ee[st] &= $e;
        for ($e = ~$e, st = 0; st < 10; st++)
          this._h[st] = this._h[st] & $e | Ee[st];
        for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, Ne = this._h[0] + this._pad[0], this._h[0] = Ne & 65535, st = 1; st < 8; st++)
          Ne = (this._h[st] + this._pad[st] | 0) + (Ne >>> 16) | 0, this._h[st] = Ne & 65535;
        return ge[we + 0] = this._h[0] >>> 0, ge[we + 1] = this._h[0] >>> 8, ge[we + 2] = this._h[1] >>> 0, ge[we + 3] = this._h[1] >>> 8, ge[we + 4] = this._h[2] >>> 0, ge[we + 5] = this._h[2] >>> 8, ge[we + 6] = this._h[3] >>> 0, ge[we + 7] = this._h[3] >>> 8, ge[we + 8] = this._h[4] >>> 0, ge[we + 9] = this._h[4] >>> 8, ge[we + 10] = this._h[5] >>> 0, ge[we + 11] = this._h[5] >>> 8, ge[we + 12] = this._h[6] >>> 0, ge[we + 13] = this._h[6] >>> 8, ge[we + 14] = this._h[7] >>> 0, ge[we + 15] = this._h[7] >>> 8, this._finished = !0, this;
      }, he.prototype.update = function(ge) {
        var we = 0, Ee = ge.length, xe;
        if (this._leftover) {
          xe = 16 - this._leftover, xe > Ee && (xe = Ee);
          for (var $e = 0; $e < xe; $e++)
            this._buffer[this._leftover + $e] = ge[we + $e];
          if (Ee -= xe, we += xe, this._leftover += xe, this._leftover < 16)
            return this;
          this._blocks(this._buffer, 0, 16), this._leftover = 0;
        }
        if (Ee >= 16 && (xe = Ee - Ee % 16, this._blocks(ge, we, xe), we += xe, Ee -= xe), Ee) {
          for (var $e = 0; $e < Ee; $e++)
            this._buffer[this._leftover + $e] = ge[we + $e];
          this._leftover += Ee;
        }
        return this;
      }, he.prototype.digest = function() {
        if (this._finished)
          throw new Error("Poly1305 was finished");
        var ge = new Uint8Array(16);
        return this.finish(ge), ge;
      }, he.prototype.clean = function() {
        return z.wipe(this._buffer), z.wipe(this._r), z.wipe(this._h), z.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
      }, he;
    }()
  );
  v.Poly1305 = ne;
  function ue(he, ge) {
    var we = new ne(he);
    we.update(ge);
    var Ee = we.digest();
    return we.clean(), Ee;
  }
  v.oneTimeAuth = ue;
  function le(he, ge) {
    return he.length !== v.DIGEST_LENGTH || ge.length !== v.DIGEST_LENGTH ? !1 : y.equal(he, ge);
  }
  v.equal = le;
})(poly1305);
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 });
  var y = chacha, z = poly1305, ne = wipe$1, ue = binary, le = constantTime;
  v.KEY_LENGTH = 32, v.NONCE_LENGTH = 12, v.TAG_LENGTH = 16;
  var he = new Uint8Array(16), ge = (
    /** @class */
    function() {
      function we(Ee) {
        if (this.nonceLength = v.NONCE_LENGTH, this.tagLength = v.TAG_LENGTH, Ee.length !== v.KEY_LENGTH)
          throw new Error("ChaCha20Poly1305 needs 32-byte key");
        this._key = new Uint8Array(Ee);
      }
      return we.prototype.seal = function(Ee, xe, $e, Ne) {
        if (Ee.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        var st = new Uint8Array(16);
        st.set(Ee, st.length - Ee.length);
        var Nr = new Uint8Array(32);
        y.stream(this._key, st, Nr, 4);
        var br = xe.length + this.tagLength, $n;
        if (Ne) {
          if (Ne.length !== br)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          $n = Ne;
        } else
          $n = new Uint8Array(br);
        return y.streamXOR(this._key, st, xe, $n, 4), this._authenticate($n.subarray($n.length - this.tagLength, $n.length), Nr, $n.subarray(0, $n.length - this.tagLength), $e), ne.wipe(st), $n;
      }, we.prototype.open = function(Ee, xe, $e, Ne) {
        if (Ee.length > 16)
          throw new Error("ChaCha20Poly1305: incorrect nonce length");
        if (xe.length < this.tagLength)
          return null;
        var st = new Uint8Array(16);
        st.set(Ee, st.length - Ee.length);
        var Nr = new Uint8Array(32);
        y.stream(this._key, st, Nr, 4);
        var br = new Uint8Array(this.tagLength);
        if (this._authenticate(br, Nr, xe.subarray(0, xe.length - this.tagLength), $e), !le.equal(br, xe.subarray(xe.length - this.tagLength, xe.length)))
          return null;
        var $n = xe.length - this.tagLength, En;
        if (Ne) {
          if (Ne.length !== $n)
            throw new Error("ChaCha20Poly1305: incorrect destination length");
          En = Ne;
        } else
          En = new Uint8Array($n);
        return y.streamXOR(this._key, st, xe.subarray(0, xe.length - this.tagLength), En, 4), ne.wipe(st), En;
      }, we.prototype.clean = function() {
        return ne.wipe(this._key), this;
      }, we.prototype._authenticate = function(Ee, xe, $e, Ne) {
        var st = new z.Poly1305(xe);
        Ne && (st.update(Ne), Ne.length % 16 > 0 && st.update(he.subarray(Ne.length % 16))), st.update($e), $e.length % 16 > 0 && st.update(he.subarray($e.length % 16));
        var Nr = new Uint8Array(8);
        Ne && ue.writeUint64LE(Ne.length, Nr), st.update(Nr), ue.writeUint64LE($e.length, Nr), st.update(Nr);
        for (var br = st.digest(), $n = 0; $n < br.length; $n++)
          Ee[$n] = br[$n];
        st.clean(), ne.wipe(br), ne.wipe(Nr);
      }, we;
    }()
  );
  v.ChaCha20Poly1305 = ge;
})(chacha20poly1305);
var hkdf = {}, hmac$1 = {}, hash = {};
Object.defineProperty(hash, "__esModule", { value: !0 });
function isSerializableHash(v) {
  return typeof v.saveState < "u" && typeof v.restoreState < "u" && typeof v.cleanSavedState < "u";
}
hash.isSerializableHash = isSerializableHash;
Object.defineProperty(hmac$1, "__esModule", { value: !0 });
var hash_1 = hash, constant_time_1 = constantTime, wipe_1$2 = wipe$1, HMAC = (
  /** @class */
  function() {
    function v(y, z) {
      this._finished = !1, this._inner = new y(), this._outer = new y(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
      var ne = new Uint8Array(this.blockSize);
      z.length > this.blockSize ? this._inner.update(z).finish(ne).clean() : ne.set(z);
      for (var ue = 0; ue < ne.length; ue++)
        ne[ue] ^= 54;
      this._inner.update(ne);
      for (var ue = 0; ue < ne.length; ue++)
        ne[ue] ^= 106;
      this._outer.update(ne), hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), wipe_1$2.wipe(ne);
    }
    return v.prototype.reset = function() {
      if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
        throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
      return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, v.prototype.clean = function() {
      hash_1.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), hash_1.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
    }, v.prototype.update = function(y) {
      return this._inner.update(y), this;
    }, v.prototype.finish = function(y) {
      return this._finished ? (this._outer.finish(y), this) : (this._inner.finish(y), this._outer.update(y.subarray(0, this.digestLength)).finish(y), this._finished = !0, this);
    }, v.prototype.digest = function() {
      var y = new Uint8Array(this.digestLength);
      return this.finish(y), y;
    }, v.prototype.saveState = function() {
      if (!hash_1.isSerializableHash(this._inner))
        throw new Error("hmac: can't saveState() because hash doesn't implement it");
      return this._inner.saveState();
    }, v.prototype.restoreState = function(y) {
      if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer))
        throw new Error("hmac: can't restoreState() because hash doesn't implement it");
      return this._inner.restoreState(y), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
    }, v.prototype.cleanSavedState = function(y) {
      if (!hash_1.isSerializableHash(this._inner))
        throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
      this._inner.cleanSavedState(y);
    }, v;
  }()
);
hmac$1.HMAC = HMAC;
function hmac(v, y, z) {
  var ne = new HMAC(v, y);
  ne.update(z);
  var ue = ne.digest();
  return ne.clean(), ue;
}
hmac$1.hmac = hmac;
hmac$1.equal = constant_time_1.equal;
Object.defineProperty(hkdf, "__esModule", { value: !0 });
var hmac_1 = hmac$1, wipe_1$1 = wipe$1, HKDF = (
  /** @class */
  function() {
    function v(y, z, ne, ue) {
      ne === void 0 && (ne = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = y, this._info = ue;
      var le = hmac_1.hmac(this._hash, ne, z);
      this._hmac = new hmac_1.HMAC(y, le), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
    }
    return v.prototype._fillBuffer = function() {
      this._counter[0]++;
      var y = this._counter[0];
      if (y === 0)
        throw new Error("hkdf: cannot expand more");
      this._hmac.reset(), y > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
    }, v.prototype.expand = function(y) {
      for (var z = new Uint8Array(y), ne = 0; ne < z.length; ne++)
        this._bufpos === this._buffer.length && this._fillBuffer(), z[ne] = this._buffer[this._bufpos++];
      return z;
    }, v.prototype.clean = function() {
      this._hmac.clean(), wipe_1$1.wipe(this._buffer), wipe_1$1.wipe(this._counter), this._bufpos = 0;
    }, v;
  }()
), HKDF_1 = hkdf.HKDF = HKDF, random = {}, system = {}, browser = {};
Object.defineProperty(browser, "__esModule", { value: !0 });
browser.BrowserRandomSource = void 0;
const QUOTA = 65536;
class BrowserRandomSource {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const y = typeof self < "u" ? self.crypto || self.msCrypto : null;
    y && y.getRandomValues !== void 0 && (this._crypto = y, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(y) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const z = new Uint8Array(y);
    for (let ne = 0; ne < z.length; ne += QUOTA)
      this._crypto.getRandomValues(z.subarray(ne, ne + Math.min(z.length - ne, QUOTA)));
    return z;
  }
}
browser.BrowserRandomSource = BrowserRandomSource;
function commonjsRequire(v) {
  throw new Error('Could not dynamically require "' + v + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var node = {};
Object.defineProperty(node, "__esModule", { value: !0 });
node.NodeRandomSource = void 0;
const wipe_1 = wipe$1;
class NodeRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof commonjsRequire < "u") {
      const y = requireCryptoBrowserify();
      y && y.randomBytes && (this._crypto = y, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(y) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let z = this._crypto.randomBytes(y);
    if (z.length !== y)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const ne = new Uint8Array(y);
    for (let ue = 0; ue < ne.length; ue++)
      ne[ue] = z[ue];
    return (0, wipe_1.wipe)(z), ne;
  }
}
node.NodeRandomSource = NodeRandomSource;
Object.defineProperty(system, "__esModule", { value: !0 });
system.SystemRandomSource = void 0;
const browser_1 = browser, node_1 = node;
class SystemRandomSource {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new browser_1.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new node_1.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(y) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(y);
  }
}
system.SystemRandomSource = SystemRandomSource;
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.randomStringForEntropy = v.randomString = v.randomUint32 = v.randomBytes = v.defaultRandomSource = void 0;
  const y = system, z = binary, ne = wipe$1;
  v.defaultRandomSource = new y.SystemRandomSource();
  function ue(Ee, xe = v.defaultRandomSource) {
    return xe.randomBytes(Ee);
  }
  v.randomBytes = ue;
  function le(Ee = v.defaultRandomSource) {
    const xe = ue(4, Ee), $e = (0, z.readUint32LE)(xe);
    return (0, ne.wipe)(xe), $e;
  }
  v.randomUint32 = le;
  const he = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function ge(Ee, xe = he, $e = v.defaultRandomSource) {
    if (xe.length < 2)
      throw new Error("randomString charset is too short");
    if (xe.length > 256)
      throw new Error("randomString charset is too long");
    let Ne = "";
    const st = xe.length, Nr = 256 - 256 % st;
    for (; Ee > 0; ) {
      const br = ue(Math.ceil(Ee * 256 / Nr), $e);
      for (let $n = 0; $n < br.length && Ee > 0; $n++) {
        const En = br[$n];
        En < Nr && (Ne += xe.charAt(En % st), Ee--);
      }
      (0, ne.wipe)(br);
    }
    return Ne;
  }
  v.randomString = ge;
  function we(Ee, xe = he, $e = v.defaultRandomSource) {
    const Ne = Math.ceil(Ee / (Math.log(xe.length) / Math.LN2));
    return ge(Ne, xe, $e);
  }
  v.randomStringForEntropy = we;
})(random);
var sha256 = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 });
  var y = binary, z = wipe$1;
  v.DIGEST_LENGTH = 32, v.BLOCK_SIZE = 64;
  var ne = (
    /** @class */
    function() {
      function ge() {
        this.digestLength = v.DIGEST_LENGTH, this.blockSize = v.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
      }
      return ge.prototype._initState = function() {
        this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
      }, ge.prototype.reset = function() {
        return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
      }, ge.prototype.clean = function() {
        z.wipe(this._buffer), z.wipe(this._temp), this.reset();
      }, ge.prototype.update = function(we, Ee) {
        if (Ee === void 0 && (Ee = we.length), this._finished)
          throw new Error("SHA256: can't update because hash was finished.");
        var xe = 0;
        if (this._bytesHashed += Ee, this._bufferLength > 0) {
          for (; this._bufferLength < this.blockSize && Ee > 0; )
            this._buffer[this._bufferLength++] = we[xe++], Ee--;
          this._bufferLength === this.blockSize && (le(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
        }
        for (Ee >= this.blockSize && (xe = le(this._temp, this._state, we, xe, Ee), Ee %= this.blockSize); Ee > 0; )
          this._buffer[this._bufferLength++] = we[xe++], Ee--;
        return this;
      }, ge.prototype.finish = function(we) {
        if (!this._finished) {
          var Ee = this._bytesHashed, xe = this._bufferLength, $e = Ee / 536870912 | 0, Ne = Ee << 3, st = Ee % 64 < 56 ? 64 : 128;
          this._buffer[xe] = 128;
          for (var Nr = xe + 1; Nr < st - 8; Nr++)
            this._buffer[Nr] = 0;
          y.writeUint32BE($e, this._buffer, st - 8), y.writeUint32BE(Ne, this._buffer, st - 4), le(this._temp, this._state, this._buffer, 0, st), this._finished = !0;
        }
        for (var Nr = 0; Nr < this.digestLength / 4; Nr++)
          y.writeUint32BE(this._state[Nr], we, Nr * 4);
        return this;
      }, ge.prototype.digest = function() {
        var we = new Uint8Array(this.digestLength);
        return this.finish(we), we;
      }, ge.prototype.saveState = function() {
        if (this._finished)
          throw new Error("SHA256: cannot save finished state");
        return {
          state: new Int32Array(this._state),
          buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
          bufferLength: this._bufferLength,
          bytesHashed: this._bytesHashed
        };
      }, ge.prototype.restoreState = function(we) {
        return this._state.set(we.state), this._bufferLength = we.bufferLength, we.buffer && this._buffer.set(we.buffer), this._bytesHashed = we.bytesHashed, this._finished = !1, this;
      }, ge.prototype.cleanSavedState = function(we) {
        z.wipe(we.state), we.buffer && z.wipe(we.buffer), we.bufferLength = 0, we.bytesHashed = 0;
      }, ge;
    }()
  );
  v.SHA256 = ne;
  var ue = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function le(ge, we, Ee, xe, $e) {
    for (; $e >= 64; ) {
      for (var Ne = we[0], st = we[1], Nr = we[2], br = we[3], $n = we[4], En = we[5], Rn = we[6], wa = we[7], Aa = 0; Aa < 16; Aa++) {
        var _a = xe + Aa * 4;
        ge[Aa] = y.readUint32BE(Ee, _a);
      }
      for (var Aa = 16; Aa < 64; Aa++) {
        var Ta = ge[Aa - 2], Zn = (Ta >>> 17 | Ta << 15) ^ (Ta >>> 19 | Ta << 13) ^ Ta >>> 10;
        Ta = ge[Aa - 15];
        var Ra = (Ta >>> 7 | Ta << 25) ^ (Ta >>> 18 | Ta << 14) ^ Ta >>> 3;
        ge[Aa] = (Zn + ge[Aa - 7] | 0) + (Ra + ge[Aa - 16] | 0);
      }
      for (var Aa = 0; Aa < 64; Aa++) {
        var Zn = ((($n >>> 6 | $n << 26) ^ ($n >>> 11 | $n << 21) ^ ($n >>> 25 | $n << 7)) + ($n & En ^ ~$n & Rn) | 0) + (wa + (ue[Aa] + ge[Aa] | 0) | 0) | 0, Ra = ((Ne >>> 2 | Ne << 30) ^ (Ne >>> 13 | Ne << 19) ^ (Ne >>> 22 | Ne << 10)) + (Ne & st ^ Ne & Nr ^ st & Nr) | 0;
        wa = Rn, Rn = En, En = $n, $n = br + Zn | 0, br = Nr, Nr = st, st = Ne, Ne = Zn + Ra | 0;
      }
      we[0] += Ne, we[1] += st, we[2] += Nr, we[3] += br, we[4] += $n, we[5] += En, we[6] += Rn, we[7] += wa, xe += 64, $e -= 64;
    }
    return xe;
  }
  function he(ge) {
    var we = new ne();
    we.update(ge);
    var Ee = we.digest();
    return we.clean(), Ee;
  }
  v.hash = he;
})(sha256);
var x25519 = {};
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 }), v.sharedKey = v.generateKeyPair = v.generateKeyPairFromSeed = v.scalarMultBase = v.scalarMult = v.SHARED_KEY_LENGTH = v.SECRET_KEY_LENGTH = v.PUBLIC_KEY_LENGTH = void 0;
  const y = random, z = wipe$1;
  v.PUBLIC_KEY_LENGTH = 32, v.SECRET_KEY_LENGTH = 32, v.SHARED_KEY_LENGTH = 32;
  function ne(Aa) {
    const _a = new Float64Array(16);
    if (Aa)
      for (let Ta = 0; Ta < Aa.length; Ta++)
        _a[Ta] = Aa[Ta];
    return _a;
  }
  const ue = new Uint8Array(32);
  ue[0] = 9;
  const le = ne([56129, 1]);
  function he(Aa) {
    let _a = 1;
    for (let Ta = 0; Ta < 16; Ta++) {
      let Zn = Aa[Ta] + _a + 65535;
      _a = Math.floor(Zn / 65536), Aa[Ta] = Zn - _a * 65536;
    }
    Aa[0] += _a - 1 + 37 * (_a - 1);
  }
  function ge(Aa, _a, Ta) {
    const Zn = ~(Ta - 1);
    for (let Ra = 0; Ra < 16; Ra++) {
      const Yn = Zn & (Aa[Ra] ^ _a[Ra]);
      Aa[Ra] ^= Yn, _a[Ra] ^= Yn;
    }
  }
  function we(Aa, _a) {
    const Ta = ne(), Zn = ne();
    for (let Ra = 0; Ra < 16; Ra++)
      Zn[Ra] = _a[Ra];
    he(Zn), he(Zn), he(Zn);
    for (let Ra = 0; Ra < 2; Ra++) {
      Ta[0] = Zn[0] - 65517;
      for (let $o = 1; $o < 15; $o++)
        Ta[$o] = Zn[$o] - 65535 - (Ta[$o - 1] >> 16 & 1), Ta[$o - 1] &= 65535;
      Ta[15] = Zn[15] - 32767 - (Ta[14] >> 16 & 1);
      const Yn = Ta[15] >> 16 & 1;
      Ta[14] &= 65535, ge(Zn, Ta, 1 - Yn);
    }
    for (let Ra = 0; Ra < 16; Ra++)
      Aa[2 * Ra] = Zn[Ra] & 255, Aa[2 * Ra + 1] = Zn[Ra] >> 8;
  }
  function Ee(Aa, _a) {
    for (let Ta = 0; Ta < 16; Ta++)
      Aa[Ta] = _a[2 * Ta] + (_a[2 * Ta + 1] << 8);
    Aa[15] &= 32767;
  }
  function xe(Aa, _a, Ta) {
    for (let Zn = 0; Zn < 16; Zn++)
      Aa[Zn] = _a[Zn] + Ta[Zn];
  }
  function $e(Aa, _a, Ta) {
    for (let Zn = 0; Zn < 16; Zn++)
      Aa[Zn] = _a[Zn] - Ta[Zn];
  }
  function Ne(Aa, _a, Ta) {
    let Zn, Ra, Yn = 0, $o = 0, ct = 0, fe = 0, be = 0, ye = 0, Se = 0, Oe = 0, Fr = 0, zn = 0, Fe = 0, pe = 0, it = 0, xa = 0, wo = 0, _u = 0, Oa = 0, Os = 0, Pa = 0, Ml = 0, Su = 0, Tu = 0, Au = 0, Zl = 0, Iu = 0, Uc = 0, Pu = 0, Lu = 0, th = 0, Zc = 0, N1 = 0, Gh = Ta[0], Mc = Ta[1], h1 = Ta[2], l2 = Ta[3], Gc = Ta[4], Kc = Ta[5], M2 = Ta[6], d1 = Ta[7], K1 = Ta[8], k2 = Ta[9], Eu = Ta[10], Zo = Ta[11], Fl = Ta[12], Ru = Ta[13], ku = Ta[14], kc = Ta[15];
    Zn = _a[0], Yn += Zn * Gh, $o += Zn * Mc, ct += Zn * h1, fe += Zn * l2, be += Zn * Gc, ye += Zn * Kc, Se += Zn * M2, Oe += Zn * d1, Fr += Zn * K1, zn += Zn * k2, Fe += Zn * Eu, pe += Zn * Zo, it += Zn * Fl, xa += Zn * Ru, wo += Zn * ku, _u += Zn * kc, Zn = _a[1], $o += Zn * Gh, ct += Zn * Mc, fe += Zn * h1, be += Zn * l2, ye += Zn * Gc, Se += Zn * Kc, Oe += Zn * M2, Fr += Zn * d1, zn += Zn * K1, Fe += Zn * k2, pe += Zn * Eu, it += Zn * Zo, xa += Zn * Fl, wo += Zn * Ru, _u += Zn * ku, Oa += Zn * kc, Zn = _a[2], ct += Zn * Gh, fe += Zn * Mc, be += Zn * h1, ye += Zn * l2, Se += Zn * Gc, Oe += Zn * Kc, Fr += Zn * M2, zn += Zn * d1, Fe += Zn * K1, pe += Zn * k2, it += Zn * Eu, xa += Zn * Zo, wo += Zn * Fl, _u += Zn * Ru, Oa += Zn * ku, Os += Zn * kc, Zn = _a[3], fe += Zn * Gh, be += Zn * Mc, ye += Zn * h1, Se += Zn * l2, Oe += Zn * Gc, Fr += Zn * Kc, zn += Zn * M2, Fe += Zn * d1, pe += Zn * K1, it += Zn * k2, xa += Zn * Eu, wo += Zn * Zo, _u += Zn * Fl, Oa += Zn * Ru, Os += Zn * ku, Pa += Zn * kc, Zn = _a[4], be += Zn * Gh, ye += Zn * Mc, Se += Zn * h1, Oe += Zn * l2, Fr += Zn * Gc, zn += Zn * Kc, Fe += Zn * M2, pe += Zn * d1, it += Zn * K1, xa += Zn * k2, wo += Zn * Eu, _u += Zn * Zo, Oa += Zn * Fl, Os += Zn * Ru, Pa += Zn * ku, Ml += Zn * kc, Zn = _a[5], ye += Zn * Gh, Se += Zn * Mc, Oe += Zn * h1, Fr += Zn * l2, zn += Zn * Gc, Fe += Zn * Kc, pe += Zn * M2, it += Zn * d1, xa += Zn * K1, wo += Zn * k2, _u += Zn * Eu, Oa += Zn * Zo, Os += Zn * Fl, Pa += Zn * Ru, Ml += Zn * ku, Su += Zn * kc, Zn = _a[6], Se += Zn * Gh, Oe += Zn * Mc, Fr += Zn * h1, zn += Zn * l2, Fe += Zn * Gc, pe += Zn * Kc, it += Zn * M2, xa += Zn * d1, wo += Zn * K1, _u += Zn * k2, Oa += Zn * Eu, Os += Zn * Zo, Pa += Zn * Fl, Ml += Zn * Ru, Su += Zn * ku, Tu += Zn * kc, Zn = _a[7], Oe += Zn * Gh, Fr += Zn * Mc, zn += Zn * h1, Fe += Zn * l2, pe += Zn * Gc, it += Zn * Kc, xa += Zn * M2, wo += Zn * d1, _u += Zn * K1, Oa += Zn * k2, Os += Zn * Eu, Pa += Zn * Zo, Ml += Zn * Fl, Su += Zn * Ru, Tu += Zn * ku, Au += Zn * kc, Zn = _a[8], Fr += Zn * Gh, zn += Zn * Mc, Fe += Zn * h1, pe += Zn * l2, it += Zn * Gc, xa += Zn * Kc, wo += Zn * M2, _u += Zn * d1, Oa += Zn * K1, Os += Zn * k2, Pa += Zn * Eu, Ml += Zn * Zo, Su += Zn * Fl, Tu += Zn * Ru, Au += Zn * ku, Zl += Zn * kc, Zn = _a[9], zn += Zn * Gh, Fe += Zn * Mc, pe += Zn * h1, it += Zn * l2, xa += Zn * Gc, wo += Zn * Kc, _u += Zn * M2, Oa += Zn * d1, Os += Zn * K1, Pa += Zn * k2, Ml += Zn * Eu, Su += Zn * Zo, Tu += Zn * Fl, Au += Zn * Ru, Zl += Zn * ku, Iu += Zn * kc, Zn = _a[10], Fe += Zn * Gh, pe += Zn * Mc, it += Zn * h1, xa += Zn * l2, wo += Zn * Gc, _u += Zn * Kc, Oa += Zn * M2, Os += Zn * d1, Pa += Zn * K1, Ml += Zn * k2, Su += Zn * Eu, Tu += Zn * Zo, Au += Zn * Fl, Zl += Zn * Ru, Iu += Zn * ku, Uc += Zn * kc, Zn = _a[11], pe += Zn * Gh, it += Zn * Mc, xa += Zn * h1, wo += Zn * l2, _u += Zn * Gc, Oa += Zn * Kc, Os += Zn * M2, Pa += Zn * d1, Ml += Zn * K1, Su += Zn * k2, Tu += Zn * Eu, Au += Zn * Zo, Zl += Zn * Fl, Iu += Zn * Ru, Uc += Zn * ku, Pu += Zn * kc, Zn = _a[12], it += Zn * Gh, xa += Zn * Mc, wo += Zn * h1, _u += Zn * l2, Oa += Zn * Gc, Os += Zn * Kc, Pa += Zn * M2, Ml += Zn * d1, Su += Zn * K1, Tu += Zn * k2, Au += Zn * Eu, Zl += Zn * Zo, Iu += Zn * Fl, Uc += Zn * Ru, Pu += Zn * ku, Lu += Zn * kc, Zn = _a[13], xa += Zn * Gh, wo += Zn * Mc, _u += Zn * h1, Oa += Zn * l2, Os += Zn * Gc, Pa += Zn * Kc, Ml += Zn * M2, Su += Zn * d1, Tu += Zn * K1, Au += Zn * k2, Zl += Zn * Eu, Iu += Zn * Zo, Uc += Zn * Fl, Pu += Zn * Ru, Lu += Zn * ku, th += Zn * kc, Zn = _a[14], wo += Zn * Gh, _u += Zn * Mc, Oa += Zn * h1, Os += Zn * l2, Pa += Zn * Gc, Ml += Zn * Kc, Su += Zn * M2, Tu += Zn * d1, Au += Zn * K1, Zl += Zn * k2, Iu += Zn * Eu, Uc += Zn * Zo, Pu += Zn * Fl, Lu += Zn * Ru, th += Zn * ku, Zc += Zn * kc, Zn = _a[15], _u += Zn * Gh, Oa += Zn * Mc, Os += Zn * h1, Pa += Zn * l2, Ml += Zn * Gc, Su += Zn * Kc, Tu += Zn * M2, Au += Zn * d1, Zl += Zn * K1, Iu += Zn * k2, Uc += Zn * Eu, Pu += Zn * Zo, Lu += Zn * Fl, th += Zn * Ru, Zc += Zn * ku, N1 += Zn * kc, Yn += 38 * Oa, $o += 38 * Os, ct += 38 * Pa, fe += 38 * Ml, be += 38 * Su, ye += 38 * Tu, Se += 38 * Au, Oe += 38 * Zl, Fr += 38 * Iu, zn += 38 * Uc, Fe += 38 * Pu, pe += 38 * Lu, it += 38 * th, xa += 38 * Zc, wo += 38 * N1, Ra = 1, Zn = Yn + Ra + 65535, Ra = Math.floor(Zn / 65536), Yn = Zn - Ra * 65536, Zn = $o + Ra + 65535, Ra = Math.floor(Zn / 65536), $o = Zn - Ra * 65536, Zn = ct + Ra + 65535, Ra = Math.floor(Zn / 65536), ct = Zn - Ra * 65536, Zn = fe + Ra + 65535, Ra = Math.floor(Zn / 65536), fe = Zn - Ra * 65536, Zn = be + Ra + 65535, Ra = Math.floor(Zn / 65536), be = Zn - Ra * 65536, Zn = ye + Ra + 65535, Ra = Math.floor(Zn / 65536), ye = Zn - Ra * 65536, Zn = Se + Ra + 65535, Ra = Math.floor(Zn / 65536), Se = Zn - Ra * 65536, Zn = Oe + Ra + 65535, Ra = Math.floor(Zn / 65536), Oe = Zn - Ra * 65536, Zn = Fr + Ra + 65535, Ra = Math.floor(Zn / 65536), Fr = Zn - Ra * 65536, Zn = zn + Ra + 65535, Ra = Math.floor(Zn / 65536), zn = Zn - Ra * 65536, Zn = Fe + Ra + 65535, Ra = Math.floor(Zn / 65536), Fe = Zn - Ra * 65536, Zn = pe + Ra + 65535, Ra = Math.floor(Zn / 65536), pe = Zn - Ra * 65536, Zn = it + Ra + 65535, Ra = Math.floor(Zn / 65536), it = Zn - Ra * 65536, Zn = xa + Ra + 65535, Ra = Math.floor(Zn / 65536), xa = Zn - Ra * 65536, Zn = wo + Ra + 65535, Ra = Math.floor(Zn / 65536), wo = Zn - Ra * 65536, Zn = _u + Ra + 65535, Ra = Math.floor(Zn / 65536), _u = Zn - Ra * 65536, Yn += Ra - 1 + 37 * (Ra - 1), Ra = 1, Zn = Yn + Ra + 65535, Ra = Math.floor(Zn / 65536), Yn = Zn - Ra * 65536, Zn = $o + Ra + 65535, Ra = Math.floor(Zn / 65536), $o = Zn - Ra * 65536, Zn = ct + Ra + 65535, Ra = Math.floor(Zn / 65536), ct = Zn - Ra * 65536, Zn = fe + Ra + 65535, Ra = Math.floor(Zn / 65536), fe = Zn - Ra * 65536, Zn = be + Ra + 65535, Ra = Math.floor(Zn / 65536), be = Zn - Ra * 65536, Zn = ye + Ra + 65535, Ra = Math.floor(Zn / 65536), ye = Zn - Ra * 65536, Zn = Se + Ra + 65535, Ra = Math.floor(Zn / 65536), Se = Zn - Ra * 65536, Zn = Oe + Ra + 65535, Ra = Math.floor(Zn / 65536), Oe = Zn - Ra * 65536, Zn = Fr + Ra + 65535, Ra = Math.floor(Zn / 65536), Fr = Zn - Ra * 65536, Zn = zn + Ra + 65535, Ra = Math.floor(Zn / 65536), zn = Zn - Ra * 65536, Zn = Fe + Ra + 65535, Ra = Math.floor(Zn / 65536), Fe = Zn - Ra * 65536, Zn = pe + Ra + 65535, Ra = Math.floor(Zn / 65536), pe = Zn - Ra * 65536, Zn = it + Ra + 65535, Ra = Math.floor(Zn / 65536), it = Zn - Ra * 65536, Zn = xa + Ra + 65535, Ra = Math.floor(Zn / 65536), xa = Zn - Ra * 65536, Zn = wo + Ra + 65535, Ra = Math.floor(Zn / 65536), wo = Zn - Ra * 65536, Zn = _u + Ra + 65535, Ra = Math.floor(Zn / 65536), _u = Zn - Ra * 65536, Yn += Ra - 1 + 37 * (Ra - 1), Aa[0] = Yn, Aa[1] = $o, Aa[2] = ct, Aa[3] = fe, Aa[4] = be, Aa[5] = ye, Aa[6] = Se, Aa[7] = Oe, Aa[8] = Fr, Aa[9] = zn, Aa[10] = Fe, Aa[11] = pe, Aa[12] = it, Aa[13] = xa, Aa[14] = wo, Aa[15] = _u;
  }
  function st(Aa, _a) {
    Ne(Aa, _a, _a);
  }
  function Nr(Aa, _a) {
    const Ta = ne();
    for (let Zn = 0; Zn < 16; Zn++)
      Ta[Zn] = _a[Zn];
    for (let Zn = 253; Zn >= 0; Zn--)
      st(Ta, Ta), Zn !== 2 && Zn !== 4 && Ne(Ta, Ta, _a);
    for (let Zn = 0; Zn < 16; Zn++)
      Aa[Zn] = Ta[Zn];
  }
  function br(Aa, _a) {
    const Ta = new Uint8Array(32), Zn = new Float64Array(80), Ra = ne(), Yn = ne(), $o = ne(), ct = ne(), fe = ne(), be = ne();
    for (let Fr = 0; Fr < 31; Fr++)
      Ta[Fr] = Aa[Fr];
    Ta[31] = Aa[31] & 127 | 64, Ta[0] &= 248, Ee(Zn, _a);
    for (let Fr = 0; Fr < 16; Fr++)
      Yn[Fr] = Zn[Fr];
    Ra[0] = ct[0] = 1;
    for (let Fr = 254; Fr >= 0; --Fr) {
      const zn = Ta[Fr >>> 3] >>> (Fr & 7) & 1;
      ge(Ra, Yn, zn), ge($o, ct, zn), xe(fe, Ra, $o), $e(Ra, Ra, $o), xe($o, Yn, ct), $e(Yn, Yn, ct), st(ct, fe), st(be, Ra), Ne(Ra, $o, Ra), Ne($o, Yn, fe), xe(fe, Ra, $o), $e(Ra, Ra, $o), st(Yn, Ra), $e($o, ct, be), Ne(Ra, $o, le), xe(Ra, Ra, ct), Ne($o, $o, Ra), Ne(Ra, ct, be), Ne(ct, Yn, Zn), st(Yn, fe), ge(Ra, Yn, zn), ge($o, ct, zn);
    }
    for (let Fr = 0; Fr < 16; Fr++)
      Zn[Fr + 16] = Ra[Fr], Zn[Fr + 32] = $o[Fr], Zn[Fr + 48] = Yn[Fr], Zn[Fr + 64] = ct[Fr];
    const ye = Zn.subarray(32), Se = Zn.subarray(16);
    Nr(ye, ye), Ne(Se, Se, ye);
    const Oe = new Uint8Array(32);
    return we(Oe, Se), Oe;
  }
  v.scalarMult = br;
  function $n(Aa) {
    return br(Aa, ue);
  }
  v.scalarMultBase = $n;
  function En(Aa) {
    if (Aa.length !== v.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${v.SECRET_KEY_LENGTH} bytes`);
    const _a = new Uint8Array(Aa);
    return {
      publicKey: $n(_a),
      secretKey: _a
    };
  }
  v.generateKeyPairFromSeed = En;
  function Rn(Aa) {
    const _a = (0, y.randomBytes)(32, Aa), Ta = En(_a);
    return (0, z.wipe)(_a), Ta;
  }
  v.generateKeyPair = Rn;
  function wa(Aa, _a, Ta = !1) {
    if (Aa.length !== v.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (_a.length !== v.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const Zn = br(Aa, _a);
    if (Ta) {
      let Ra = 0;
      for (let Yn = 0; Yn < Zn.length; Yn++)
        Ra |= Zn[Yn];
      if (Ra === 0)
        throw new Error("X25519: invalid shared key");
    }
    return Zn;
  }
  v.sharedKey = wa;
})(x25519);
function asUint8Array(v) {
  return globalThis.Buffer != null ? new Uint8Array(v.buffer, v.byteOffset, v.byteLength) : v;
}
function allocUnsafe(v = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? asUint8Array(globalThis.Buffer.allocUnsafe(v)) : new Uint8Array(v);
}
function concat(v, y) {
  y || (y = v.reduce((ue, le) => ue + le.length, 0));
  const z = allocUnsafe(y);
  let ne = 0;
  for (const ue of v)
    z.set(ue, ne), ne += ue.length;
  return asUint8Array(z);
}
function base(v, y) {
  if (v.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var z = new Uint8Array(256), ne = 0; ne < z.length; ne++)
    z[ne] = 255;
  for (var ue = 0; ue < v.length; ue++) {
    var le = v.charAt(ue), he = le.charCodeAt(0);
    if (z[he] !== 255)
      throw new TypeError(le + " is ambiguous");
    z[he] = ue;
  }
  var ge = v.length, we = v.charAt(0), Ee = Math.log(ge) / Math.log(256), xe = Math.log(256) / Math.log(ge);
  function $e(Nr) {
    if (Nr instanceof Uint8Array || (ArrayBuffer.isView(Nr) ? Nr = new Uint8Array(Nr.buffer, Nr.byteOffset, Nr.byteLength) : Array.isArray(Nr) && (Nr = Uint8Array.from(Nr))), !(Nr instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Nr.length === 0)
      return "";
    for (var br = 0, $n = 0, En = 0, Rn = Nr.length; En !== Rn && Nr[En] === 0; )
      En++, br++;
    for (var wa = (Rn - En) * xe + 1 >>> 0, Aa = new Uint8Array(wa); En !== Rn; ) {
      for (var _a = Nr[En], Ta = 0, Zn = wa - 1; (_a !== 0 || Ta < $n) && Zn !== -1; Zn--, Ta++)
        _a += 256 * Aa[Zn] >>> 0, Aa[Zn] = _a % ge >>> 0, _a = _a / ge >>> 0;
      if (_a !== 0)
        throw new Error("Non-zero carry");
      $n = Ta, En++;
    }
    for (var Ra = wa - $n; Ra !== wa && Aa[Ra] === 0; )
      Ra++;
    for (var Yn = we.repeat(br); Ra < wa; ++Ra)
      Yn += v.charAt(Aa[Ra]);
    return Yn;
  }
  function Ne(Nr) {
    if (typeof Nr != "string")
      throw new TypeError("Expected String");
    if (Nr.length === 0)
      return new Uint8Array();
    var br = 0;
    if (Nr[br] !== " ") {
      for (var $n = 0, En = 0; Nr[br] === we; )
        $n++, br++;
      for (var Rn = (Nr.length - br) * Ee + 1 >>> 0, wa = new Uint8Array(Rn); Nr[br]; ) {
        var Aa = z[Nr.charCodeAt(br)];
        if (Aa === 255)
          return;
        for (var _a = 0, Ta = Rn - 1; (Aa !== 0 || _a < En) && Ta !== -1; Ta--, _a++)
          Aa += ge * wa[Ta] >>> 0, wa[Ta] = Aa % 256 >>> 0, Aa = Aa / 256 >>> 0;
        if (Aa !== 0)
          throw new Error("Non-zero carry");
        En = _a, br++;
      }
      if (Nr[br] !== " ") {
        for (var Zn = Rn - En; Zn !== Rn && wa[Zn] === 0; )
          Zn++;
        for (var Ra = new Uint8Array($n + (Rn - Zn)), Yn = $n; Zn !== Rn; )
          Ra[Yn++] = wa[Zn++];
        return Ra;
      }
    }
  }
  function st(Nr) {
    var br = Ne(Nr);
    if (br)
      return br;
    throw new Error(`Non-${y} character`);
  }
  return {
    encode: $e,
    decodeUnsafe: Ne,
    decode: st
  };
}
var src = base, _brrp__multiformats_scope_baseX = src;
const coerce = (v) => {
  if (v instanceof Uint8Array && v.constructor.name === "Uint8Array")
    return v;
  if (v instanceof ArrayBuffer)
    return new Uint8Array(v);
  if (ArrayBuffer.isView(v))
    return new Uint8Array(v.buffer, v.byteOffset, v.byteLength);
  throw new Error("Unknown type, must be binary type");
}, fromString$1 = (v) => new TextEncoder().encode(v), toString$1 = (v) => new TextDecoder().decode(v);
class Encoder {
  constructor(y, z, ne) {
    this.name = y, this.prefix = z, this.baseEncode = ne;
  }
  encode(y) {
    if (y instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(y)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Decoder {
  constructor(y, z, ne) {
    if (this.name = y, this.prefix = z, z.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = z.codePointAt(0), this.baseDecode = ne;
  }
  decode(y) {
    if (typeof y == "string") {
      if (y.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(y)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(y.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(y) {
    return or(this, y);
  }
}
class ComposedDecoder {
  constructor(y) {
    this.decoders = y;
  }
  or(y) {
    return or(this, y);
  }
  decode(y) {
    const z = y[0], ne = this.decoders[z];
    if (ne)
      return ne.decode(y);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(y)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const or = (v, y) => new ComposedDecoder({
  ...v.decoders || { [v.prefix]: v },
  ...y.decoders || { [y.prefix]: y }
});
class Codec {
  constructor(y, z, ne, ue) {
    this.name = y, this.prefix = z, this.baseEncode = ne, this.baseDecode = ue, this.encoder = new Encoder(y, z, ne), this.decoder = new Decoder(y, z, ue);
  }
  encode(y) {
    return this.encoder.encode(y);
  }
  decode(y) {
    return this.decoder.decode(y);
  }
}
const from = ({ name: v, prefix: y, encode: z, decode: ne }) => new Codec(v, y, z, ne), baseX = ({ prefix: v, name: y, alphabet: z }) => {
  const { encode: ne, decode: ue } = _brrp__multiformats_scope_baseX(z, y);
  return from({
    prefix: v,
    name: y,
    encode: ne,
    decode: (le) => coerce(ue(le))
  });
}, decode$2 = (v, y, z, ne) => {
  const ue = {};
  for (let xe = 0; xe < y.length; ++xe)
    ue[y[xe]] = xe;
  let le = v.length;
  for (; v[le - 1] === "="; )
    --le;
  const he = new Uint8Array(le * z / 8 | 0);
  let ge = 0, we = 0, Ee = 0;
  for (let xe = 0; xe < le; ++xe) {
    const $e = ue[v[xe]];
    if ($e === void 0)
      throw new SyntaxError(`Non-${ne} character`);
    we = we << z | $e, ge += z, ge >= 8 && (ge -= 8, he[Ee++] = 255 & we >> ge);
  }
  if (ge >= z || 255 & we << 8 - ge)
    throw new SyntaxError("Unexpected end of data");
  return he;
}, encode$1 = (v, y, z) => {
  const ne = y[y.length - 1] === "=", ue = (1 << z) - 1;
  let le = "", he = 0, ge = 0;
  for (let we = 0; we < v.length; ++we)
    for (ge = ge << 8 | v[we], he += 8; he > z; )
      he -= z, le += y[ue & ge >> he];
  if (he && (le += y[ue & ge << z - he]), ne)
    for (; le.length * z & 7; )
      le += "=";
  return le;
}, rfc4648 = ({ name: v, prefix: y, bitsPerChar: z, alphabet: ne }) => from({
  prefix: y,
  name: v,
  encode(ue) {
    return encode$1(ue, ne, z);
  },
  decode(ue) {
    return decode$2(ue, ne, z, v);
  }
}), identity = from({
  prefix: "\0",
  name: "identity",
  encode: (v) => toString$1(v),
  decode: (v) => fromString$1(v)
}), identityBase = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity
}, Symbol.toStringTag, { value: "Module" })), base2 = rfc4648({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), base2$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2
}, Symbol.toStringTag, { value: "Module" })), base8 = rfc4648({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), base8$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8
}, Symbol.toStringTag, { value: "Module" })), base10 = baseX({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), base10$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10
}, Symbol.toStringTag, { value: "Module" })), base16 = rfc4648({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), base16upper = rfc4648({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), base16$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16,
  base16upper
}, Symbol.toStringTag, { value: "Module" })), base32 = rfc4648({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), base32upper = rfc4648({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), base32pad = rfc4648({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), base32padupper = rfc4648({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), base32hex = rfc4648({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), base32hexupper = rfc4648({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), base32hexpad = rfc4648({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), base32hexpadupper = rfc4648({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), base32z = rfc4648({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), base32$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32,
  base32hex,
  base32hexpad,
  base32hexpadupper,
  base32hexupper,
  base32pad,
  base32padupper,
  base32upper,
  base32z
}, Symbol.toStringTag, { value: "Module" })), base36 = baseX({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), base36upper = baseX({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), base36$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36,
  base36upper
}, Symbol.toStringTag, { value: "Module" })), base58btc = baseX({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), base58flickr = baseX({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), base58 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc,
  base58flickr
}, Symbol.toStringTag, { value: "Module" })), base64 = rfc4648({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), base64pad = rfc4648({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), base64url = rfc4648({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), base64urlpad = rfc4648({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), base64$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64,
  base64pad,
  base64url,
  base64urlpad
}, Symbol.toStringTag, { value: "Module" })), alphabet = Array.from("🚀🪐☄🛰🌌🌑🌒🌓🌔🌕🌖🌗🌘🌍🌏🌎🐉☀💻🖥💾💿😂❤😍🤣😊🙏💕😭😘👍😅👏😁🔥🥰💔💖💙😢🤔😆🙄💪😉☺👌🤗💜😔😎😇🌹🤦🎉💞✌✨🤷😱😌🌸🙌😋💗💚😏💛🙂💓🤩😄😀🖤😃💯🙈👇🎶😒🤭❣😜💋👀😪😑💥🙋😞😩😡🤪👊🥳😥🤤👉💃😳✋😚😝😴🌟😬🙃🍀🌷😻😓⭐✅🥺🌈😈🤘💦✔😣🏃💐☹🎊💘😠☝😕🌺🎂🌻😐🖕💝🙊😹🗣💫💀👑🎵🤞😛🔴😤🌼😫⚽🤙☕🏆🤫👈😮🙆🍻🍃🐶💁😲🌿🧡🎁⚡🌞🎈❌✊👋😰🤨😶🤝🚶💰🍓💢🤟🙁🚨💨🤬✈🎀🍺🤓😙💟🌱😖👶🥴▶➡❓💎💸⬇😨🌚🦋😷🕺⚠🙅😟😵👎🤲🤠🤧📌🔵💅🧐🐾🍒😗🤑🌊🤯🐷☎💧😯💆👆🎤🙇🍑❄🌴💣🐸💌📍🥀🤢👅💡💩👐📸👻🤐🤮🎼🥵🚩🍎🍊👼💍📣🥂"), alphabetBytesToChars = alphabet.reduce((v, y, z) => (v[z] = y, v), []), alphabetCharsToBytes = alphabet.reduce((v, y, z) => (v[y.codePointAt(0)] = z, v), []);
function encode(v) {
  return v.reduce((y, z) => (y += alphabetBytesToChars[z], y), "");
}
function decode$1(v) {
  const y = [];
  for (const z of v) {
    const ne = alphabetCharsToBytes[z.codePointAt(0)];
    if (ne === void 0)
      throw new Error(`Non-base256emoji character: ${z}`);
    y.push(ne);
  }
  return new Uint8Array(y);
}
const base256emoji = from({
  prefix: "🚀",
  name: "base256emoji",
  encode,
  decode: decode$1
}), base256emoji$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
const bases = {
  ...identityBase,
  ...base2$1,
  ...base8$1,
  ...base10$1,
  ...base16$1,
  ...base32$1,
  ...base36$1,
  ...base58,
  ...base64$1,
  ...base256emoji$1
};
function createCodec(v, y, z, ne) {
  return {
    name: v,
    prefix: y,
    encoder: {
      name: v,
      prefix: y,
      encode: z
    },
    decoder: { decode: ne }
  };
}
const string = createCodec("utf8", "u", (v) => "u" + new TextDecoder("utf8").decode(v), (v) => new TextEncoder().encode(v.substring(1))), ascii = createCodec("ascii", "a", (v) => {
  let y = "a";
  for (let z = 0; z < v.length; z++)
    y += String.fromCharCode(v[z]);
  return y;
}, (v) => {
  v = v.substring(1);
  const y = allocUnsafe(v.length);
  for (let z = 0; z < v.length; z++)
    y[z] = v.charCodeAt(z);
  return y;
}), BASES = {
  utf8: string,
  "utf-8": string,
  hex: bases.base16,
  latin1: ascii,
  ascii,
  binary: ascii,
  ...bases
};
function fromString(v, y = "utf8") {
  const z = BASES[y];
  if (!z)
    throw new Error(`Unsupported encoding "${y}"`);
  return (y === "utf8" || y === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? asUint8Array(globalThis.Buffer.from(v, "utf-8")) : z.decoder.decode(`${z.prefix}${v}`);
}
function toString(v, y = "utf8") {
  const z = BASES[y];
  if (!z)
    throw new Error(`Unsupported encoding "${y}"`);
  return (y === "utf8" || y === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(v.buffer, v.byteOffset, v.byteLength).toString("utf8") : z.encoder.encode(v).substring(1);
}
var __spreadArray = function(v, y, z) {
  if (z || arguments.length === 2)
    for (var ne = 0, ue = y.length, le; ne < ue; ne++)
      (le || !(ne in y)) && (le || (le = Array.prototype.slice.call(y, 0, ne)), le[ne] = y[ne]);
  return v.concat(le || Array.prototype.slice.call(y));
}, BrowserInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function v(y, z, ne) {
      this.name = y, this.version = z, this.os = ne, this.type = "browser";
    }
    return v;
  }()
), NodeInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function v(y) {
      this.version = y, this.type = "node", this.name = "node", this.os = process$1.platform;
    }
    return v;
  }()
), SearchBotDeviceInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function v(y, z, ne, ue) {
      this.name = y, this.version = z, this.os = ne, this.bot = ue, this.type = "bot-device";
    }
    return v;
  }()
), BotInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function v() {
      this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    }
    return v;
  }()
), ReactNativeInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function v() {
      this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
    }
    return v;
  }()
), SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, REQUIRED_VERSION_PARTS = 3, userAgentRules = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", SEARCHBOX_UA_REGEX]
], operatingSystemRules = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function detect(v) {
  return v ? parseUserAgent(v) : typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new ReactNativeInfo() : typeof navigator < "u" ? parseUserAgent(navigator.userAgent) : getNodeVersion();
}
function matchUserAgent(v) {
  return v !== "" && userAgentRules.reduce(function(y, z) {
    var ne = z[0], ue = z[1];
    if (y)
      return y;
    var le = ue.exec(v);
    return !!le && [ne, le];
  }, !1);
}
function parseUserAgent(v) {
  var y = matchUserAgent(v);
  if (!y)
    return null;
  var z = y[0], ne = y[1];
  if (z === "searchbot")
    return new BotInfo();
  var ue = ne[1] && ne[1].split(".").join("_").split("_").slice(0, 3);
  ue ? ue.length < REQUIRED_VERSION_PARTS && (ue = __spreadArray(__spreadArray([], ue, !0), createVersionParts(REQUIRED_VERSION_PARTS - ue.length), !0)) : ue = [];
  var le = ue.join("."), he = detectOS(v), ge = SEARCHBOT_OS_REGEX.exec(v);
  return ge && ge[1] ? new SearchBotDeviceInfo(z, le, he, ge[1]) : new BrowserInfo(z, le, he);
}
function detectOS(v) {
  for (var y = 0, z = operatingSystemRules.length; y < z; y++) {
    var ne = operatingSystemRules[y], ue = ne[0], le = ne[1], he = le.exec(v);
    if (he)
      return ue;
  }
  return null;
}
function getNodeVersion() {
  var v = typeof process$1 < "u" && process$1.version;
  return v ? new NodeInfo(process$1.version.slice(1)) : null;
}
function createVersionParts(v) {
  for (var y = [], z = 0; z < v; z++)
    y.push("0");
  return y;
}
var cjs$2 = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(v, y) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(z, ne) {
    z.__proto__ = ne;
  } || function(z, ne) {
    for (var ue in ne)
      ne.hasOwnProperty(ue) && (z[ue] = ne[ue]);
  }, extendStatics(v, y);
};
function __extends(v, y) {
  extendStatics(v, y);
  function z() {
    this.constructor = v;
  }
  v.prototype = y === null ? Object.create(y) : (z.prototype = y.prototype, new z());
}
var __assign = function() {
  return __assign = Object.assign || function(y) {
    for (var z, ne = 1, ue = arguments.length; ne < ue; ne++) {
      z = arguments[ne];
      for (var le in z)
        Object.prototype.hasOwnProperty.call(z, le) && (y[le] = z[le]);
    }
    return y;
  }, __assign.apply(this, arguments);
};
function __rest(v, y) {
  var z = {};
  for (var ne in v)
    Object.prototype.hasOwnProperty.call(v, ne) && y.indexOf(ne) < 0 && (z[ne] = v[ne]);
  if (v != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ue = 0, ne = Object.getOwnPropertySymbols(v); ue < ne.length; ue++)
      y.indexOf(ne[ue]) < 0 && Object.prototype.propertyIsEnumerable.call(v, ne[ue]) && (z[ne[ue]] = v[ne[ue]]);
  return z;
}
function __decorate(v, y, z, ne) {
  var ue = arguments.length, le = ue < 3 ? y : ne === null ? ne = Object.getOwnPropertyDescriptor(y, z) : ne, he;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    le = Reflect.decorate(v, y, z, ne);
  else
    for (var ge = v.length - 1; ge >= 0; ge--)
      (he = v[ge]) && (le = (ue < 3 ? he(le) : ue > 3 ? he(y, z, le) : he(y, z)) || le);
  return ue > 3 && le && Object.defineProperty(y, z, le), le;
}
function __param(v, y) {
  return function(z, ne) {
    y(z, ne, v);
  };
}
function __metadata(v, y) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(v, y);
}
function __awaiter(v, y, z, ne) {
  function ue(le) {
    return le instanceof z ? le : new z(function(he) {
      he(le);
    });
  }
  return new (z || (z = Promise))(function(le, he) {
    function ge(xe) {
      try {
        Ee(ne.next(xe));
      } catch ($e) {
        he($e);
      }
    }
    function we(xe) {
      try {
        Ee(ne.throw(xe));
      } catch ($e) {
        he($e);
      }
    }
    function Ee(xe) {
      xe.done ? le(xe.value) : ue(xe.value).then(ge, we);
    }
    Ee((ne = ne.apply(v, y || [])).next());
  });
}
function __generator(v, y) {
  var z = { label: 0, sent: function() {
    if (le[0] & 1)
      throw le[1];
    return le[1];
  }, trys: [], ops: [] }, ne, ue, le, he;
  return he = { next: ge(0), throw: ge(1), return: ge(2) }, typeof Symbol == "function" && (he[Symbol.iterator] = function() {
    return this;
  }), he;
  function ge(Ee) {
    return function(xe) {
      return we([Ee, xe]);
    };
  }
  function we(Ee) {
    if (ne)
      throw new TypeError("Generator is already executing.");
    for (; z; )
      try {
        if (ne = 1, ue && (le = Ee[0] & 2 ? ue.return : Ee[0] ? ue.throw || ((le = ue.return) && le.call(ue), 0) : ue.next) && !(le = le.call(ue, Ee[1])).done)
          return le;
        switch (ue = 0, le && (Ee = [Ee[0] & 2, le.value]), Ee[0]) {
          case 0:
          case 1:
            le = Ee;
            break;
          case 4:
            return z.label++, { value: Ee[1], done: !1 };
          case 5:
            z.label++, ue = Ee[1], Ee = [0];
            continue;
          case 7:
            Ee = z.ops.pop(), z.trys.pop();
            continue;
          default:
            if (le = z.trys, !(le = le.length > 0 && le[le.length - 1]) && (Ee[0] === 6 || Ee[0] === 2)) {
              z = 0;
              continue;
            }
            if (Ee[0] === 3 && (!le || Ee[1] > le[0] && Ee[1] < le[3])) {
              z.label = Ee[1];
              break;
            }
            if (Ee[0] === 6 && z.label < le[1]) {
              z.label = le[1], le = Ee;
              break;
            }
            if (le && z.label < le[2]) {
              z.label = le[2], z.ops.push(Ee);
              break;
            }
            le[2] && z.ops.pop(), z.trys.pop();
            continue;
        }
        Ee = y.call(v, z);
      } catch (xe) {
        Ee = [6, xe], ue = 0;
      } finally {
        ne = le = 0;
      }
    if (Ee[0] & 5)
      throw Ee[1];
    return { value: Ee[0] ? Ee[1] : void 0, done: !0 };
  }
}
function __createBinding(v, y, z, ne) {
  ne === void 0 && (ne = z), v[ne] = y[z];
}
function __exportStar(v, y) {
  for (var z in v)
    z !== "default" && !y.hasOwnProperty(z) && (y[z] = v[z]);
}
function __values(v) {
  var y = typeof Symbol == "function" && Symbol.iterator, z = y && v[y], ne = 0;
  if (z)
    return z.call(v);
  if (v && typeof v.length == "number")
    return {
      next: function() {
        return v && ne >= v.length && (v = void 0), { value: v && v[ne++], done: !v };
      }
    };
  throw new TypeError(y ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(v, y) {
  var z = typeof Symbol == "function" && v[Symbol.iterator];
  if (!z)
    return v;
  var ne = z.call(v), ue, le = [], he;
  try {
    for (; (y === void 0 || y-- > 0) && !(ue = ne.next()).done; )
      le.push(ue.value);
  } catch (ge) {
    he = { error: ge };
  } finally {
    try {
      ue && !ue.done && (z = ne.return) && z.call(ne);
    } finally {
      if (he)
        throw he.error;
    }
  }
  return le;
}
function __spread() {
  for (var v = [], y = 0; y < arguments.length; y++)
    v = v.concat(__read(arguments[y]));
  return v;
}
function __spreadArrays() {
  for (var v = 0, y = 0, z = arguments.length; y < z; y++)
    v += arguments[y].length;
  for (var ne = Array(v), ue = 0, y = 0; y < z; y++)
    for (var le = arguments[y], he = 0, ge = le.length; he < ge; he++, ue++)
      ne[ue] = le[he];
  return ne;
}
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(v, y, z) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var ne = z.apply(v, y || []), ue, le = [];
  return ue = {}, he("next"), he("throw"), he("return"), ue[Symbol.asyncIterator] = function() {
    return this;
  }, ue;
  function he(Ne) {
    ne[Ne] && (ue[Ne] = function(st) {
      return new Promise(function(Nr, br) {
        le.push([Ne, st, Nr, br]) > 1 || ge(Ne, st);
      });
    });
  }
  function ge(Ne, st) {
    try {
      we(ne[Ne](st));
    } catch (Nr) {
      $e(le[0][3], Nr);
    }
  }
  function we(Ne) {
    Ne.value instanceof __await ? Promise.resolve(Ne.value.v).then(Ee, xe) : $e(le[0][2], Ne);
  }
  function Ee(Ne) {
    ge("next", Ne);
  }
  function xe(Ne) {
    ge("throw", Ne);
  }
  function $e(Ne, st) {
    Ne(st), le.shift(), le.length && ge(le[0][0], le[0][1]);
  }
}
function __asyncDelegator(v) {
  var y, z;
  return y = {}, ne("next"), ne("throw", function(ue) {
    throw ue;
  }), ne("return"), y[Symbol.iterator] = function() {
    return this;
  }, y;
  function ne(ue, le) {
    y[ue] = v[ue] ? function(he) {
      return (z = !z) ? { value: __await(v[ue](he)), done: ue === "return" } : le ? le(he) : he;
    } : le;
  }
}
function __asyncValues(v) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var y = v[Symbol.asyncIterator], z;
  return y ? y.call(v) : (v = typeof __values == "function" ? __values(v) : v[Symbol.iterator](), z = {}, ne("next"), ne("throw"), ne("return"), z[Symbol.asyncIterator] = function() {
    return this;
  }, z);
  function ne(le) {
    z[le] = v[le] && function(he) {
      return new Promise(function(ge, we) {
        he = v[le](he), ue(ge, we, he.done, he.value);
      });
    };
  }
  function ue(le, he, ge, we) {
    Promise.resolve(we).then(function(Ee) {
      le({ value: Ee, done: ge });
    }, he);
  }
}
function __makeTemplateObject(v, y) {
  return Object.defineProperty ? Object.defineProperty(v, "raw", { value: y }) : v.raw = y, v;
}
function __importStar(v) {
  if (v && v.__esModule)
    return v;
  var y = {};
  if (v != null)
    for (var z in v)
      Object.hasOwnProperty.call(v, z) && (y[z] = v[z]);
  return y.default = v, y;
}
function __importDefault(v) {
  return v && v.__esModule ? v : { default: v };
}
function __classPrivateFieldGet$2(v, y) {
  if (!y.has(v))
    throw new TypeError("attempted to get private field on non-instance");
  return y.get(v);
}
function __classPrivateFieldSet$2(v, y, z) {
  if (!y.has(v))
    throw new TypeError("attempted to set private field on non-instance");
  return y.set(v, z), z;
}
const tslib_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return __assign;
  },
  __asyncDelegator,
  __asyncGenerator,
  __asyncValues,
  __await,
  __awaiter,
  __classPrivateFieldGet: __classPrivateFieldGet$2,
  __classPrivateFieldSet: __classPrivateFieldSet$2,
  __createBinding,
  __decorate,
  __exportStar,
  __extends,
  __generator,
  __importDefault,
  __importStar,
  __makeTemplateObject,
  __metadata,
  __param,
  __read,
  __rest,
  __spread,
  __spreadArrays,
  __values
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(tslib_es6);
var utils = {}, delay = {}, hasRequiredDelay;
function requireDelay() {
  if (hasRequiredDelay)
    return delay;
  hasRequiredDelay = 1, Object.defineProperty(delay, "__esModule", { value: !0 }), delay.delay = void 0;
  function v(y) {
    return new Promise((z) => {
      setTimeout(() => {
        z(!0);
      }, y);
    });
  }
  return delay.delay = v, delay;
}
var convert = {}, constants = {}, misc = {}, hasRequiredMisc;
function requireMisc() {
  return hasRequiredMisc || (hasRequiredMisc = 1, Object.defineProperty(misc, "__esModule", { value: !0 }), misc.ONE_THOUSAND = misc.ONE_HUNDRED = void 0, misc.ONE_HUNDRED = 100, misc.ONE_THOUSAND = 1e3), misc;
}
var time = {}, hasRequiredTime;
function requireTime() {
  return hasRequiredTime || (hasRequiredTime = 1, function(v) {
    Object.defineProperty(v, "__esModule", { value: !0 }), v.ONE_YEAR = v.FOUR_WEEKS = v.THREE_WEEKS = v.TWO_WEEKS = v.ONE_WEEK = v.THIRTY_DAYS = v.SEVEN_DAYS = v.FIVE_DAYS = v.THREE_DAYS = v.ONE_DAY = v.TWENTY_FOUR_HOURS = v.TWELVE_HOURS = v.SIX_HOURS = v.THREE_HOURS = v.ONE_HOUR = v.SIXTY_MINUTES = v.THIRTY_MINUTES = v.TEN_MINUTES = v.FIVE_MINUTES = v.ONE_MINUTE = v.SIXTY_SECONDS = v.THIRTY_SECONDS = v.TEN_SECONDS = v.FIVE_SECONDS = v.ONE_SECOND = void 0, v.ONE_SECOND = 1, v.FIVE_SECONDS = 5, v.TEN_SECONDS = 10, v.THIRTY_SECONDS = 30, v.SIXTY_SECONDS = 60, v.ONE_MINUTE = v.SIXTY_SECONDS, v.FIVE_MINUTES = v.ONE_MINUTE * 5, v.TEN_MINUTES = v.ONE_MINUTE * 10, v.THIRTY_MINUTES = v.ONE_MINUTE * 30, v.SIXTY_MINUTES = v.ONE_MINUTE * 60, v.ONE_HOUR = v.SIXTY_MINUTES, v.THREE_HOURS = v.ONE_HOUR * 3, v.SIX_HOURS = v.ONE_HOUR * 6, v.TWELVE_HOURS = v.ONE_HOUR * 12, v.TWENTY_FOUR_HOURS = v.ONE_HOUR * 24, v.ONE_DAY = v.TWENTY_FOUR_HOURS, v.THREE_DAYS = v.ONE_DAY * 3, v.FIVE_DAYS = v.ONE_DAY * 5, v.SEVEN_DAYS = v.ONE_DAY * 7, v.THIRTY_DAYS = v.ONE_DAY * 30, v.ONE_WEEK = v.SEVEN_DAYS, v.TWO_WEEKS = v.ONE_WEEK * 2, v.THREE_WEEKS = v.ONE_WEEK * 3, v.FOUR_WEEKS = v.ONE_WEEK * 4, v.ONE_YEAR = v.ONE_DAY * 365;
  }(time)), time;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(v) {
    Object.defineProperty(v, "__esModule", { value: !0 });
    const y = require$$0;
    y.__exportStar(requireMisc(), v), y.__exportStar(requireTime(), v);
  }(constants)), constants;
}
var hasRequiredConvert;
function requireConvert() {
  if (hasRequiredConvert)
    return convert;
  hasRequiredConvert = 1, Object.defineProperty(convert, "__esModule", { value: !0 }), convert.fromMiliseconds = convert.toMiliseconds = void 0;
  const v = requireConstants();
  function y(ne) {
    return ne * v.ONE_THOUSAND;
  }
  convert.toMiliseconds = y;
  function z(ne) {
    return Math.floor(ne / v.ONE_THOUSAND);
  }
  return convert.fromMiliseconds = z, convert;
}
var hasRequiredUtils;
function requireUtils() {
  return hasRequiredUtils || (hasRequiredUtils = 1, function(v) {
    Object.defineProperty(v, "__esModule", { value: !0 });
    const y = require$$0;
    y.__exportStar(requireDelay(), v), y.__exportStar(requireConvert(), v);
  }(utils)), utils;
}
var watch$1 = {}, hasRequiredWatch$1;
function requireWatch$1() {
  if (hasRequiredWatch$1)
    return watch$1;
  hasRequiredWatch$1 = 1, Object.defineProperty(watch$1, "__esModule", { value: !0 }), watch$1.Watch = void 0;
  class v {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(z) {
      if (this.timestamps.has(z))
        throw new Error(`Watch already started for label: ${z}`);
      this.timestamps.set(z, { started: Date.now() });
    }
    stop(z) {
      const ne = this.get(z);
      if (typeof ne.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${z}`);
      const ue = Date.now() - ne.started;
      this.timestamps.set(z, { started: ne.started, elapsed: ue });
    }
    get(z) {
      const ne = this.timestamps.get(z);
      if (typeof ne > "u")
        throw new Error(`No timestamp found for label: ${z}`);
      return ne;
    }
    elapsed(z) {
      const ne = this.get(z);
      return ne.elapsed || Date.now() - ne.started;
    }
  }
  return watch$1.Watch = v, watch$1.default = v, watch$1;
}
var types = {}, watch = {}, hasRequiredWatch;
function requireWatch() {
  if (hasRequiredWatch)
    return watch;
  hasRequiredWatch = 1, Object.defineProperty(watch, "__esModule", { value: !0 }), watch.IWatch = void 0;
  class v {
  }
  return watch.IWatch = v, watch;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(v) {
    Object.defineProperty(v, "__esModule", { value: !0 }), require$$0.__exportStar(requireWatch(), v);
  }(types)), types;
}
(function(v) {
  Object.defineProperty(v, "__esModule", { value: !0 });
  const y = require$$0;
  y.__exportStar(requireUtils(), v), y.__exportStar(requireWatch$1(), v), y.__exportStar(requireTypes(), v), y.__exportStar(requireConstants(), v);
})(cjs$2);
var cjs$1 = {};
Object.defineProperty(cjs$1, "__esModule", { value: !0 });
var getLocalStorage_1 = cjs$1.getLocalStorage = getLocalStorageOrThrow_1 = cjs$1.getLocalStorageOrThrow = getCrypto_1 = cjs$1.getCrypto = getCryptoOrThrow_1 = cjs$1.getCryptoOrThrow = getLocation_1 = cjs$1.getLocation = getLocationOrThrow_1 = cjs$1.getLocationOrThrow = getNavigator_1 = cjs$1.getNavigator = getNavigatorOrThrow_1 = cjs$1.getNavigatorOrThrow = getDocument_1 = cjs$1.getDocument = getDocumentOrThrow_1 = cjs$1.getDocumentOrThrow = getFromWindowOrThrow_1 = cjs$1.getFromWindowOrThrow = getFromWindow_1 = cjs$1.getFromWindow = void 0;
function getFromWindow(v) {
  let y;
  return typeof window < "u" && typeof window[v] < "u" && (y = window[v]), y;
}
var getFromWindow_1 = cjs$1.getFromWindow = getFromWindow;
function getFromWindowOrThrow(v) {
  const y = getFromWindow(v);
  if (!y)
    throw new Error(`${v} is not defined in Window`);
  return y;
}
var getFromWindowOrThrow_1 = cjs$1.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
  return getFromWindowOrThrow("document");
}
var getDocumentOrThrow_1 = cjs$1.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
  return getFromWindow("document");
}
var getDocument_1 = cjs$1.getDocument = getDocument;
function getNavigatorOrThrow() {
  return getFromWindowOrThrow("navigator");
}
var getNavigatorOrThrow_1 = cjs$1.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
  return getFromWindow("navigator");
}
var getNavigator_1 = cjs$1.getNavigator = getNavigator;
function getLocationOrThrow() {
  return getFromWindowOrThrow("location");
}
var getLocationOrThrow_1 = cjs$1.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
  return getFromWindow("location");
}
var getLocation_1 = cjs$1.getLocation = getLocation;
function getCryptoOrThrow() {
  return getFromWindowOrThrow("crypto");
}
var getCryptoOrThrow_1 = cjs$1.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
  return getFromWindow("crypto");
}
var getCrypto_1 = cjs$1.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
  return getFromWindowOrThrow("localStorage");
}
var getLocalStorageOrThrow_1 = cjs$1.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
  return getFromWindow("localStorage");
}
getLocalStorage_1 = cjs$1.getLocalStorage = getLocalStorage;
var cjs = {};
Object.defineProperty(cjs, "__esModule", { value: !0 });
var getWindowMetadata_1 = cjs.getWindowMetadata = void 0;
const window_getters_1 = cjs$1;
function getWindowMetadata() {
  let v, y;
  try {
    v = window_getters_1.getDocumentOrThrow(), y = window_getters_1.getLocationOrThrow();
  } catch {
    return null;
  }
  function z() {
    const $e = v.getElementsByTagName("link"), Ne = [];
    for (let st = 0; st < $e.length; st++) {
      const Nr = $e[st], br = Nr.getAttribute("rel");
      if (br && br.toLowerCase().indexOf("icon") > -1) {
        const $n = Nr.getAttribute("href");
        if ($n)
          if ($n.toLowerCase().indexOf("https:") === -1 && $n.toLowerCase().indexOf("http:") === -1 && $n.indexOf("//") !== 0) {
            let En = y.protocol + "//" + y.host;
            if ($n.indexOf("/") === 0)
              En += $n;
            else {
              const Rn = y.pathname.split("/");
              Rn.pop();
              const wa = Rn.join("/");
              En += wa + "/" + $n;
            }
            Ne.push(En);
          } else if ($n.indexOf("//") === 0) {
            const En = y.protocol + $n;
            Ne.push(En);
          } else
            Ne.push($n);
      }
    }
    return Ne;
  }
  function ne(...$e) {
    const Ne = v.getElementsByTagName("meta");
    for (let st = 0; st < Ne.length; st++) {
      const Nr = Ne[st], br = ["itemprop", "property", "name"].map(($n) => Nr.getAttribute($n)).filter(($n) => $n ? $e.includes($n) : !1);
      if (br.length && br) {
        const $n = Nr.getAttribute("content");
        if ($n)
          return $n;
      }
    }
    return "";
  }
  function ue() {
    let $e = ne("name", "og:site_name", "og:title", "twitter:title");
    return $e || ($e = v.title), $e;
  }
  function le() {
    return ne("description", "og:description", "twitter:description", "keywords");
  }
  const he = ue(), ge = le(), we = y.origin, Ee = z();
  return {
    description: ge,
    url: we,
    icons: Ee,
    name: he
  };
}
getWindowMetadata_1 = cjs.getWindowMetadata = getWindowMetadata;
var queryString = {}, strictUriEncode = (v) => encodeURIComponent(v).replace(/[!'()*]/g, (y) => `%${y.charCodeAt(0).toString(16).toUpperCase()}`), token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(v, y) {
  try {
    return [decodeURIComponent(v.join(""))];
  } catch {
  }
  if (v.length === 1)
    return v;
  y = y || 1;
  var z = v.slice(0, y), ne = v.slice(y);
  return Array.prototype.concat.call([], decodeComponents(z), decodeComponents(ne));
}
function decode(v) {
  try {
    return decodeURIComponent(v);
  } catch {
    for (var y = v.match(singleMatcher) || [], z = 1; z < y.length; z++)
      v = decodeComponents(y, z).join(""), y = v.match(singleMatcher) || [];
    return v;
  }
}
function customDecodeURIComponent(v) {
  for (var y = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, z = multiMatcher.exec(v); z; ) {
    try {
      y[z[0]] = decodeURIComponent(z[0]);
    } catch {
      var ne = decode(z[0]);
      ne !== z[0] && (y[z[0]] = ne);
    }
    z = multiMatcher.exec(v);
  }
  y["%C2"] = "�";
  for (var ue = Object.keys(y), le = 0; le < ue.length; le++) {
    var he = ue[le];
    v = v.replace(new RegExp(he, "g"), y[he]);
  }
  return v;
}
var decodeUriComponent = function(v) {
  if (typeof v != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof v + "`");
  try {
    return v = v.replace(/\+/g, " "), decodeURIComponent(v);
  } catch {
    return customDecodeURIComponent(v);
  }
}, splitOnFirst = (v, y) => {
  if (!(typeof v == "string" && typeof y == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (y === "")
    return [v];
  const z = v.indexOf(y);
  return z === -1 ? [v] : [
    v.slice(0, z),
    v.slice(z + y.length)
  ];
}, filterObj = function(v, y) {
  for (var z = {}, ne = Object.keys(v), ue = Array.isArray(y), le = 0; le < ne.length; le++) {
    var he = ne[le], ge = v[he];
    (ue ? y.indexOf(he) !== -1 : y(he, ge, v)) && (z[he] = ge);
  }
  return z;
};
(function(v) {
  const y = strictUriEncode, z = decodeUriComponent, ne = splitOnFirst, ue = filterObj, le = (Rn) => Rn == null, he = Symbol("encodeFragmentIdentifier");
  function ge(Rn) {
    switch (Rn.arrayFormat) {
      case "index":
        return (wa) => (Aa, _a) => {
          const Ta = Aa.length;
          return _a === void 0 || Rn.skipNull && _a === null || Rn.skipEmptyString && _a === "" ? Aa : _a === null ? [...Aa, [xe(wa, Rn), "[", Ta, "]"].join("")] : [
            ...Aa,
            [xe(wa, Rn), "[", xe(Ta, Rn), "]=", xe(_a, Rn)].join("")
          ];
        };
      case "bracket":
        return (wa) => (Aa, _a) => _a === void 0 || Rn.skipNull && _a === null || Rn.skipEmptyString && _a === "" ? Aa : _a === null ? [...Aa, [xe(wa, Rn), "[]"].join("")] : [...Aa, [xe(wa, Rn), "[]=", xe(_a, Rn)].join("")];
      case "colon-list-separator":
        return (wa) => (Aa, _a) => _a === void 0 || Rn.skipNull && _a === null || Rn.skipEmptyString && _a === "" ? Aa : _a === null ? [...Aa, [xe(wa, Rn), ":list="].join("")] : [...Aa, [xe(wa, Rn), ":list=", xe(_a, Rn)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const wa = Rn.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (Aa) => (_a, Ta) => Ta === void 0 || Rn.skipNull && Ta === null || Rn.skipEmptyString && Ta === "" ? _a : (Ta = Ta === null ? "" : Ta, _a.length === 0 ? [[xe(Aa, Rn), wa, xe(Ta, Rn)].join("")] : [[_a, xe(Ta, Rn)].join(Rn.arrayFormatSeparator)]);
      }
      default:
        return (wa) => (Aa, _a) => _a === void 0 || Rn.skipNull && _a === null || Rn.skipEmptyString && _a === "" ? Aa : _a === null ? [...Aa, xe(wa, Rn)] : [...Aa, [xe(wa, Rn), "=", xe(_a, Rn)].join("")];
    }
  }
  function we(Rn) {
    let wa;
    switch (Rn.arrayFormat) {
      case "index":
        return (Aa, _a, Ta) => {
          if (wa = /\[(\d*)\]$/.exec(Aa), Aa = Aa.replace(/\[\d*\]$/, ""), !wa) {
            Ta[Aa] = _a;
            return;
          }
          Ta[Aa] === void 0 && (Ta[Aa] = {}), Ta[Aa][wa[1]] = _a;
        };
      case "bracket":
        return (Aa, _a, Ta) => {
          if (wa = /(\[\])$/.exec(Aa), Aa = Aa.replace(/\[\]$/, ""), !wa) {
            Ta[Aa] = _a;
            return;
          }
          if (Ta[Aa] === void 0) {
            Ta[Aa] = [_a];
            return;
          }
          Ta[Aa] = [].concat(Ta[Aa], _a);
        };
      case "colon-list-separator":
        return (Aa, _a, Ta) => {
          if (wa = /(:list)$/.exec(Aa), Aa = Aa.replace(/:list$/, ""), !wa) {
            Ta[Aa] = _a;
            return;
          }
          if (Ta[Aa] === void 0) {
            Ta[Aa] = [_a];
            return;
          }
          Ta[Aa] = [].concat(Ta[Aa], _a);
        };
      case "comma":
      case "separator":
        return (Aa, _a, Ta) => {
          const Zn = typeof _a == "string" && _a.includes(Rn.arrayFormatSeparator), Ra = typeof _a == "string" && !Zn && $e(_a, Rn).includes(Rn.arrayFormatSeparator);
          _a = Ra ? $e(_a, Rn) : _a;
          const Yn = Zn || Ra ? _a.split(Rn.arrayFormatSeparator).map(($o) => $e($o, Rn)) : _a === null ? _a : $e(_a, Rn);
          Ta[Aa] = Yn;
        };
      case "bracket-separator":
        return (Aa, _a, Ta) => {
          const Zn = /(\[\])$/.test(Aa);
          if (Aa = Aa.replace(/\[\]$/, ""), !Zn) {
            Ta[Aa] = _a && $e(_a, Rn);
            return;
          }
          const Ra = _a === null ? [] : _a.split(Rn.arrayFormatSeparator).map((Yn) => $e(Yn, Rn));
          if (Ta[Aa] === void 0) {
            Ta[Aa] = Ra;
            return;
          }
          Ta[Aa] = [].concat(Ta[Aa], Ra);
        };
      default:
        return (Aa, _a, Ta) => {
          if (Ta[Aa] === void 0) {
            Ta[Aa] = _a;
            return;
          }
          Ta[Aa] = [].concat(Ta[Aa], _a);
        };
    }
  }
  function Ee(Rn) {
    if (typeof Rn != "string" || Rn.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function xe(Rn, wa) {
    return wa.encode ? wa.strict ? y(Rn) : encodeURIComponent(Rn) : Rn;
  }
  function $e(Rn, wa) {
    return wa.decode ? z(Rn) : Rn;
  }
  function Ne(Rn) {
    return Array.isArray(Rn) ? Rn.sort() : typeof Rn == "object" ? Ne(Object.keys(Rn)).sort((wa, Aa) => Number(wa) - Number(Aa)).map((wa) => Rn[wa]) : Rn;
  }
  function st(Rn) {
    const wa = Rn.indexOf("#");
    return wa !== -1 && (Rn = Rn.slice(0, wa)), Rn;
  }
  function Nr(Rn) {
    let wa = "";
    const Aa = Rn.indexOf("#");
    return Aa !== -1 && (wa = Rn.slice(Aa)), wa;
  }
  function br(Rn) {
    Rn = st(Rn);
    const wa = Rn.indexOf("?");
    return wa === -1 ? "" : Rn.slice(wa + 1);
  }
  function $n(Rn, wa) {
    return wa.parseNumbers && !Number.isNaN(Number(Rn)) && typeof Rn == "string" && Rn.trim() !== "" ? Rn = Number(Rn) : wa.parseBooleans && Rn !== null && (Rn.toLowerCase() === "true" || Rn.toLowerCase() === "false") && (Rn = Rn.toLowerCase() === "true"), Rn;
  }
  function En(Rn, wa) {
    wa = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, wa), Ee(wa.arrayFormatSeparator);
    const Aa = we(wa), _a = /* @__PURE__ */ Object.create(null);
    if (typeof Rn != "string" || (Rn = Rn.trim().replace(/^[?#&]/, ""), !Rn))
      return _a;
    for (const Ta of Rn.split("&")) {
      if (Ta === "")
        continue;
      let [Zn, Ra] = ne(wa.decode ? Ta.replace(/\+/g, " ") : Ta, "=");
      Ra = Ra === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(wa.arrayFormat) ? Ra : $e(Ra, wa), Aa($e(Zn, wa), Ra, _a);
    }
    for (const Ta of Object.keys(_a)) {
      const Zn = _a[Ta];
      if (typeof Zn == "object" && Zn !== null)
        for (const Ra of Object.keys(Zn))
          Zn[Ra] = $n(Zn[Ra], wa);
      else
        _a[Ta] = $n(Zn, wa);
    }
    return wa.sort === !1 ? _a : (wa.sort === !0 ? Object.keys(_a).sort() : Object.keys(_a).sort(wa.sort)).reduce((Ta, Zn) => {
      const Ra = _a[Zn];
      return Ra && typeof Ra == "object" && !Array.isArray(Ra) ? Ta[Zn] = Ne(Ra) : Ta[Zn] = Ra, Ta;
    }, /* @__PURE__ */ Object.create(null));
  }
  v.extract = br, v.parse = En, v.stringify = (Rn, wa) => {
    if (!Rn)
      return "";
    wa = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, wa), Ee(wa.arrayFormatSeparator);
    const Aa = (Ra) => wa.skipNull && le(Rn[Ra]) || wa.skipEmptyString && Rn[Ra] === "", _a = ge(wa), Ta = {};
    for (const Ra of Object.keys(Rn))
      Aa(Ra) || (Ta[Ra] = Rn[Ra]);
    const Zn = Object.keys(Ta);
    return wa.sort !== !1 && Zn.sort(wa.sort), Zn.map((Ra) => {
      const Yn = Rn[Ra];
      return Yn === void 0 ? "" : Yn === null ? xe(Ra, wa) : Array.isArray(Yn) ? Yn.length === 0 && wa.arrayFormat === "bracket-separator" ? xe(Ra, wa) + "[]" : Yn.reduce(_a(Ra), []).join("&") : xe(Ra, wa) + "=" + xe(Yn, wa);
    }).filter((Ra) => Ra.length > 0).join("&");
  }, v.parseUrl = (Rn, wa) => {
    wa = Object.assign({
      decode: !0
    }, wa);
    const [Aa, _a] = ne(Rn, "#");
    return Object.assign(
      {
        url: Aa.split("?")[0] || "",
        query: En(br(Rn), wa)
      },
      wa && wa.parseFragmentIdentifier && _a ? { fragmentIdentifier: $e(_a, wa) } : {}
    );
  }, v.stringifyUrl = (Rn, wa) => {
    wa = Object.assign({
      encode: !0,
      strict: !0,
      [he]: !0
    }, wa);
    const Aa = st(Rn.url).split("?")[0] || "", _a = v.extract(Rn.url), Ta = v.parse(_a, { sort: !1 }), Zn = Object.assign(Ta, Rn.query);
    let Ra = v.stringify(Zn, wa);
    Ra && (Ra = `?${Ra}`);
    let Yn = Nr(Rn.url);
    return Rn.fragmentIdentifier && (Yn = `#${wa[he] ? xe(Rn.fragmentIdentifier, wa) : Rn.fragmentIdentifier}`), `${Aa}${Ra}${Yn}`;
  }, v.pick = (Rn, wa, Aa) => {
    Aa = Object.assign({
      parseFragmentIdentifier: !0,
      [he]: !1
    }, Aa);
    const { url: _a, query: Ta, fragmentIdentifier: Zn } = v.parseUrl(Rn, Aa);
    return v.stringifyUrl({
      url: _a,
      query: ue(Ta, wa),
      fragmentIdentifier: Zn
    }, Aa);
  }, v.exclude = (Rn, wa, Aa) => {
    const _a = Array.isArray(wa) ? (Ta) => !wa.includes(Ta) : (Ta, Zn) => !wa(Ta, Zn);
    return v.pick(Rn, _a, Aa);
  };
})(queryString);
const C$1 = { waku: { publish: "waku_publish", batchPublish: "waku_batchPublish", subscribe: "waku_subscribe", batchSubscribe: "waku_batchSubscribe", subscription: "waku_subscription", unsubscribe: "waku_unsubscribe", batchUnsubscribe: "waku_batchUnsubscribe", batchFetchMessages: "waku_batchFetchMessages" }, irn: { publish: "irn_publish", batchPublish: "irn_batchPublish", subscribe: "irn_subscribe", batchSubscribe: "irn_batchSubscribe", subscription: "irn_subscription", unsubscribe: "irn_unsubscribe", batchUnsubscribe: "irn_batchUnsubscribe", batchFetchMessages: "irn_batchFetchMessages" }, iridium: { publish: "iridium_publish", batchPublish: "iridium_batchPublish", subscribe: "iridium_subscribe", batchSubscribe: "iridium_batchSubscribe", subscription: "iridium_subscription", unsubscribe: "iridium_unsubscribe", batchUnsubscribe: "iridium_batchUnsubscribe", batchFetchMessages: "iridium_batchFetchMessages" } }, K = ":";
function ve(v) {
  const [y, z] = v.split(K);
  return { namespace: y, reference: z };
}
function Un(v, y = []) {
  const z = [];
  return Object.keys(v).forEach((ne) => {
    if (y.length && !y.includes(ne))
      return;
    const ue = v[ne];
    z.push(...ue.accounts);
  }), z;
}
function L(v, y) {
  return v.includes(":") ? [v] : y.chains || [];
}
const J = "base10", p = "base16", F = "base64pad", H = "utf8", Q = 0, _ = 1, Dn = 0, Pe = 1, Z = 12, X = 32;
function kn() {
  const v = x25519.generateKeyPair();
  return { privateKey: toString(v.secretKey, p), publicKey: toString(v.publicKey, p) };
}
function Vn() {
  const v = random.randomBytes(X);
  return toString(v, p);
}
function Mn(v, y) {
  const z = x25519.sharedKey(fromString(v, p), fromString(y, p), !0), ne = new HKDF_1(sha256.SHA256, z).expand(X);
  return toString(ne, p);
}
function Kn(v) {
  const y = sha256.hash(fromString(v, p));
  return toString(y, p);
}
function Ln(v) {
  const y = sha256.hash(fromString(v, H));
  return toString(y, p);
}
function Re(v) {
  return fromString(`${v}`, J);
}
function $(v) {
  return Number(toString(v, J));
}
function xn(v) {
  const y = Re(typeof v.type < "u" ? v.type : Q);
  if ($(y) === _ && typeof v.senderPublicKey > "u")
    throw new Error("Missing sender public key for type 1 envelope");
  const z = typeof v.senderPublicKey < "u" ? fromString(v.senderPublicKey, p) : void 0, ne = typeof v.iv < "u" ? fromString(v.iv, p) : random.randomBytes(Z), ue = new chacha20poly1305.ChaCha20Poly1305(fromString(v.symKey, p)).seal(ne, fromString(v.message, H));
  return Te({ type: y, sealed: ue, iv: ne, senderPublicKey: z });
}
function Fn(v) {
  const y = new chacha20poly1305.ChaCha20Poly1305(fromString(v.symKey, p)), { sealed: z, iv: ne } = ee(v.encoded), ue = y.open(ne, z);
  if (ue === null)
    throw new Error("Failed to decrypt");
  return toString(ue, H);
}
function Te(v) {
  if ($(v.type) === _) {
    if (typeof v.senderPublicKey > "u")
      throw new Error("Missing sender public key for type 1 envelope");
    return toString(concat([v.type, v.senderPublicKey, v.iv, v.sealed]), F);
  }
  return toString(concat([v.type, v.iv, v.sealed]), F);
}
function ee(v) {
  const y = fromString(v, F), z = y.slice(Dn, Pe), ne = Pe;
  if ($(z) === _) {
    const ge = ne + X, we = ge + Z, Ee = y.slice(ne, ge), xe = y.slice(ge, we), $e = y.slice(we);
    return { type: z, sealed: $e, iv: xe, senderPublicKey: Ee };
  }
  const ue = ne + Z, le = y.slice(ne, ue), he = y.slice(ue);
  return { type: z, sealed: he, iv: le };
}
function Hn(v, y) {
  const z = ee(v);
  return Ae({ type: $(z.type), senderPublicKey: typeof z.senderPublicKey < "u" ? toString(z.senderPublicKey, p) : void 0, receiverPublicKey: y == null ? void 0 : y.receiverPublicKey });
}
function Ae(v) {
  const y = (v == null ? void 0 : v.type) || Q;
  if (y === _) {
    if (typeof (v == null ? void 0 : v.senderPublicKey) > "u")
      throw new Error("missing sender public key");
    if (typeof (v == null ? void 0 : v.receiverPublicKey) > "u")
      throw new Error("missing receiver public key");
  }
  return { type: y, senderPublicKey: v == null ? void 0 : v.senderPublicKey, receiverPublicKey: v == null ? void 0 : v.receiverPublicKey };
}
function qn(v) {
  return v.type === _ && typeof v.senderPublicKey == "string" && typeof v.receiverPublicKey == "string";
}
var Bn = Object.defineProperty, Ue = Object.getOwnPropertySymbols, Gn = Object.prototype.hasOwnProperty, Wn = Object.prototype.propertyIsEnumerable, _e = (v, y, z) => y in v ? Bn(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, Ce = (v, y) => {
  for (var z in y || (y = {}))
    Gn.call(y, z) && _e(v, z, y[z]);
  if (Ue)
    for (var z of Ue(y))
      Wn.call(y, z) && _e(v, z, y[z]);
  return v;
};
const je = "ReactNative", m = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, De = "js";
function te() {
  return typeof process$1 < "u" && typeof process$1.versions < "u" && typeof process$1.versions.node < "u";
}
function C() {
  return !getDocument_1() && !!getNavigator_1() && navigator.product === je;
}
function D() {
  return !te() && !!getNavigator_1() && !!getDocument_1();
}
function T() {
  return C() ? m.reactNative : te() ? m.node : D() ? m.browser : m.unknown;
}
function Jn() {
  var v;
  try {
    return C() && typeof global$1 < "u" && typeof (global$1 == null ? void 0 : global$1.Application) < "u" ? (v = global$1.Application) == null ? void 0 : v.applicationId : void 0;
  } catch {
    return;
  }
}
function ke(v, y) {
  let z = queryString.parse(v);
  return z = Ce(Ce({}, z), y), v = queryString.stringify(z), v;
}
function Qn() {
  return getWindowMetadata_1() || { name: "", description: "", url: "", icons: [""] };
}
function Ve() {
  if (T() === m.reactNative && typeof global$1 < "u" && typeof (global$1 == null ? void 0 : global$1.Platform) < "u") {
    const { OS: z, Version: ne } = global$1.Platform;
    return [z, ne].join("-");
  }
  const v = detect();
  if (v === null)
    return "unknown";
  const y = v.os ? v.os.replace(" ", "").toLowerCase() : "unknown";
  return v.type === "browser" ? [y, v.name, v.version].join("-") : [y, v.version].join("-");
}
function Me() {
  var v;
  const y = T();
  return y === m.browser ? [y, ((v = getLocation_1()) == null ? void 0 : v.host) || "unknown"].join(":") : y;
}
function Ke(v, y, z) {
  const ne = Ve(), ue = Me();
  return [[v, y].join("-"), [De, z].join("-"), ne, ue].join("/");
}
function Xn({ protocol: v, version: y, relayUrl: z, sdkVersion: ne, auth: ue, projectId: le, useOnCloseEvent: he, bundleId: ge }) {
  const we = z.split("?"), Ee = Ke(v, y, ne), xe = { auth: ue, ua: Ee, projectId: le, useOnCloseEvent: he || void 0, origin: ge || void 0 }, $e = ke(we[1] || "", xe);
  return we[0] + "?" + $e;
}
function O(v, y) {
  return v.filter((z) => y.includes(z)).length === v.length;
}
function rt(v) {
  return Object.fromEntries(v.entries());
}
function ot(v) {
  return new Map(Object.entries(v));
}
function at(v = cjs$2.FIVE_MINUTES, y) {
  const z = cjs$2.toMiliseconds(v || cjs$2.FIVE_MINUTES);
  let ne, ue, le;
  return { resolve: (he) => {
    le && ne && (clearTimeout(le), ne(he));
  }, reject: (he) => {
    le && ue && (clearTimeout(le), ue(he));
  }, done: () => new Promise((he, ge) => {
    le = setTimeout(() => {
      ge(new Error(y));
    }, z), ne = he, ue = ge;
  }) };
}
function ut(v, y, z) {
  return new Promise(async (ne, ue) => {
    const le = setTimeout(() => ue(new Error(z)), y);
    try {
      const he = await v;
      ne(he);
    } catch (he) {
      ue(he);
    }
    clearTimeout(le);
  });
}
function re(v, y) {
  if (typeof y == "string" && y.startsWith(`${v}:`))
    return y;
  if (v.toLowerCase() === "topic") {
    if (typeof y != "string")
      throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${y}`;
  } else if (v.toLowerCase() === "id") {
    if (typeof y != "number")
      throw new Error('Value must be "number" for expirer target type: id');
    return `id:${y}`;
  }
  throw new Error(`Unknown expirer target type: ${v}`);
}
function lt(v) {
  return re("topic", v);
}
function dt(v) {
  return re("id", v);
}
function ft(v) {
  const [y, z] = v.split(":"), ne = { id: void 0, topic: void 0 };
  if (y === "topic" && typeof z == "string")
    ne.topic = z;
  else if (y === "id" && Number.isInteger(Number(z)))
    ne.id = Number(z);
  else
    throw new Error(`Invalid target, expected id:number or topic:string, got ${y}:${z}`);
  return ne;
}
function pt(v, y) {
  return cjs$2.fromMiliseconds((y || Date.now()) + cjs$2.toMiliseconds(v));
}
function mt(v) {
  return Date.now() >= cjs$2.toMiliseconds(v);
}
function yt(v, y) {
  return `${v}${y ? `:${y}` : ""}`;
}
function S(v = [], y = []) {
  return [.../* @__PURE__ */ new Set([...v, ...y])];
}
async function ht({ id: v, topic: y, wcDeepLink: z }) {
  try {
    if (!z)
      return;
    const ne = typeof z == "string" ? JSON.parse(z) : z;
    let ue = ne == null ? void 0 : ne.href;
    if (typeof ue != "string")
      return;
    ue.endsWith("/") && (ue = ue.slice(0, -1));
    const le = `${ue}/wc?requestId=${v}&sessionTopic=${y}`, he = T();
    he === m.browser ? le.startsWith("https://") ? window.open(le, "_blank", "noreferrer noopener") : window.open(le, "_self", "noreferrer noopener") : he === m.reactNative && typeof (global$1 == null ? void 0 : global$1.Linking) < "u" && await global$1.Linking.openURL(le);
  } catch (ne) {
    console.error(ne);
  }
}
async function gt(v, y) {
  try {
    return await v.getItem(y) || (D() ? localStorage.getItem(y) : void 0);
  } catch (z) {
    console.error(z);
  }
}
const He = "irn";
function vt(v) {
  return (v == null ? void 0 : v.relay) || { protocol: He };
}
function Et(v) {
  const y = C$1[v];
  if (typeof y > "u")
    throw new Error(`Relay Protocol not supported: ${v}`);
  return y;
}
var bt = Object.defineProperty, qe = Object.getOwnPropertySymbols, Nt = Object.prototype.hasOwnProperty, Ot = Object.prototype.propertyIsEnumerable, Be = (v, y, z) => y in v ? bt(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, St = (v, y) => {
  for (var z in y || (y = {}))
    Nt.call(y, z) && Be(v, z, y[z]);
  if (qe)
    for (var z of qe(y))
      Ot.call(y, z) && Be(v, z, y[z]);
  return v;
};
function Ge(v, y = "-") {
  const z = {}, ne = "relay" + y;
  return Object.keys(v).forEach((ue) => {
    if (ue.startsWith(ne)) {
      const le = ue.replace(ne, ""), he = v[ue];
      z[le] = he;
    }
  }), z;
}
function wt(v) {
  v = v.includes("wc://") ? v.replace("wc://", "") : v, v = v.includes("wc:") ? v.replace("wc:", "") : v;
  const y = v.indexOf(":"), z = v.indexOf("?") !== -1 ? v.indexOf("?") : void 0, ne = v.substring(0, y), ue = v.substring(y + 1, z).split("@"), le = typeof z < "u" ? v.substring(z) : "", he = queryString.parse(le);
  return { protocol: ne, topic: We(ue[0]), version: parseInt(ue[1], 10), symKey: he.symKey, relay: Ge(he) };
}
function We(v) {
  return v.startsWith("//") ? v.substring(2) : v;
}
function ze(v, y = "-") {
  const z = "relay", ne = {};
  return Object.keys(v).forEach((ue) => {
    const le = z + y + ue;
    v[ue] && (ne[le] = v[ue]);
  }), ne;
}
function It(v) {
  return `${v.protocol}:${v.topic}@${v.version}?` + queryString.stringify(St({ symKey: v.symKey }, ze(v.relay)));
}
var Pt = Object.defineProperty, Rt = Object.defineProperties, Tt = Object.getOwnPropertyDescriptors, Ye = Object.getOwnPropertySymbols, At = Object.prototype.hasOwnProperty, Ut = Object.prototype.propertyIsEnumerable, Je = (v, y, z) => y in v ? Pt(v, y, { enumerable: !0, configurable: !0, writable: !0, value: z }) : v[y] = z, _t = (v, y) => {
  for (var z in y || (y = {}))
    At.call(y, z) && Je(v, z, y[z]);
  if (Ye)
    for (var z of Ye(y))
      Ut.call(y, z) && Je(v, z, y[z]);
  return v;
}, Ct = (v, y) => Rt(v, Tt(y));
function A(v) {
  const y = [];
  return v.forEach((z) => {
    const [ne, ue] = z.split(":");
    y.push(`${ne}:${ue}`);
  }), y;
}
function Qe(v) {
  const y = [];
  return Object.values(v).forEach((z) => {
    y.push(...A(z.accounts));
  }), y;
}
function Ze(v, y) {
  const z = [];
  return Object.values(v).forEach((ne) => {
    A(ne.accounts).includes(y) && z.push(...ne.methods);
  }), z;
}
function Xe(v, y) {
  const z = [];
  return Object.values(v).forEach((ne) => {
    A(ne.accounts).includes(y) && z.push(...ne.events);
  }), z;
}
function jt(v, y) {
  const z = ln(v, y);
  if (z)
    throw new Error(z.message);
  const ne = {};
  for (const [ue, le] of Object.entries(v))
    ne[ue] = { methods: le.methods, events: le.events, chains: le.accounts.map((he) => `${he.split(":")[0]}:${he.split(":")[1]}`) };
  return ne;
}
function oe(v) {
  return v.includes(":");
}
function en(v) {
  return oe(v) ? v.split(":")[0] : v;
}
function se(v) {
  var y, z, ne;
  const ue = {};
  if (!B(v))
    return ue;
  for (const [le, he] of Object.entries(v)) {
    const ge = oe(le) ? [le] : he.chains, we = he.methods || [], Ee = he.events || [], xe = en(le);
    ue[xe] = Ct(_t({}, ue[xe]), { chains: S(ge, (y = ue[xe]) == null ? void 0 : y.chains), methods: S(we, (z = ue[xe]) == null ? void 0 : z.methods), events: S(Ee, (ne = ue[xe]) == null ? void 0 : ne.events) });
  }
  return ue;
}
const nn = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, tn = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function N(v, y) {
  const { message: z, code: ne } = tn[v];
  return { message: y ? `${z} ${y}` : z, code: ne };
}
function U(v, y) {
  const { message: z, code: ne } = nn[v];
  return { message: y ? `${z} ${y}` : z, code: ne };
}
function k(v, y) {
  return Array.isArray(v) ? typeof y < "u" && v.length ? v.every(y) : !0 : !1;
}
function B(v) {
  return Object.getPrototypeOf(v) === Object.prototype && Object.keys(v).length;
}
function w(v) {
  return typeof v > "u";
}
function h(v, y) {
  return y && w(v) ? !0 : typeof v == "string" && !!v.trim().length;
}
function G(v, y) {
  return y && w(v) ? !0 : typeof v == "number" && !isNaN(v);
}
function Dt(v, y) {
  const { requiredNamespaces: z } = y, ne = Object.keys(v.namespaces), ue = Object.keys(z);
  let le = !0;
  return O(ue, ne) ? (ne.forEach((he) => {
    const { accounts: ge, methods: we, events: Ee } = v.namespaces[he], xe = A(ge), $e = z[he];
    (!O(L(he, $e), xe) || !O($e.methods, we) || !O($e.events, Ee)) && (le = !1);
  }), le) : !1;
}
function V(v) {
  return h(v, !1) && v.includes(":") ? v.split(":").length === 2 : !1;
}
function rn(v) {
  if (h(v, !1) && v.includes(":")) {
    const y = v.split(":");
    if (y.length === 3) {
      const z = y[0] + ":" + y[1];
      return !!y[2] && V(z);
    }
  }
  return !1;
}
function kt(v) {
  if (h(v, !1))
    try {
      return typeof new URL(v) < "u";
    } catch {
      return !1;
    }
  return !1;
}
function Vt(v) {
  var y;
  return (y = v == null ? void 0 : v.proposer) == null ? void 0 : y.publicKey;
}
function Mt(v) {
  return v == null ? void 0 : v.topic;
}
function Kt(v, y) {
  let z = null;
  return h(v == null ? void 0 : v.publicKey, !1) || (z = N("MISSING_OR_INVALID", `${y} controller public key should be a string`)), z;
}
function ie(v) {
  let y = !0;
  return k(v) ? v.length && (y = v.every((z) => h(z, !1))) : y = !1, y;
}
function on(v, y, z) {
  let ne = null;
  return k(y) && y.length ? y.forEach((ue) => {
    ne || V(ue) || (ne = U("UNSUPPORTED_CHAINS", `${z}, chain ${ue} should be a string and conform to "namespace:chainId" format`));
  }) : V(v) || (ne = U("UNSUPPORTED_CHAINS", `${z}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), ne;
}
function sn(v, y, z) {
  let ne = null;
  return Object.entries(v).forEach(([ue, le]) => {
    if (ne)
      return;
    const he = on(ue, L(ue, le), `${y} ${z}`);
    he && (ne = he);
  }), ne;
}
function cn(v, y) {
  let z = null;
  return k(v) ? v.forEach((ne) => {
    z || rn(ne) || (z = U("UNSUPPORTED_ACCOUNTS", `${y}, account ${ne} should be a string and conform to "namespace:chainId:address" format`));
  }) : z = U("UNSUPPORTED_ACCOUNTS", `${y}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), z;
}
function an(v, y) {
  let z = null;
  return Object.values(v).forEach((ne) => {
    if (z)
      return;
    const ue = cn(ne == null ? void 0 : ne.accounts, `${y} namespace`);
    ue && (z = ue);
  }), z;
}
function un(v, y) {
  let z = null;
  return ie(v == null ? void 0 : v.methods) ? ie(v == null ? void 0 : v.events) || (z = U("UNSUPPORTED_EVENTS", `${y}, events should be an array of strings or empty array for no events`)) : z = U("UNSUPPORTED_METHODS", `${y}, methods should be an array of strings or empty array for no methods`), z;
}
function ce(v, y) {
  let z = null;
  return Object.values(v).forEach((ne) => {
    if (z)
      return;
    const ue = un(ne, `${y}, namespace`);
    ue && (z = ue);
  }), z;
}
function Lt(v, y, z) {
  let ne = null;
  if (v && B(v)) {
    const ue = ce(v, y);
    ue && (ne = ue);
    const le = sn(v, y, z);
    le && (ne = le);
  } else
    ne = N("MISSING_OR_INVALID", `${y}, ${z} should be an object with data`);
  return ne;
}
function ln(v, y) {
  let z = null;
  if (v && B(v)) {
    const ne = ce(v, y);
    ne && (z = ne);
    const ue = an(v, y);
    ue && (z = ue);
  } else
    z = N("MISSING_OR_INVALID", `${y}, namespaces should be an object with data`);
  return z;
}
function dn(v) {
  return h(v.protocol, !0);
}
function xt(v, y) {
  let z = !1;
  return y && !v ? z = !0 : v && k(v) && v.length && v.forEach((ne) => {
    z = dn(ne);
  }), z;
}
function Ft(v) {
  return typeof v == "number";
}
function Ht(v) {
  return typeof v < "u" && typeof v !== null;
}
function qt(v) {
  return !(!v || typeof v != "object" || !v.code || !G(v.code, !1) || !v.message || !h(v.message, !1));
}
function Bt(v) {
  return !(w(v) || !h(v.method, !1));
}
function Gt(v) {
  return !(w(v) || w(v.result) && w(v.error) || !G(v.id, !1) || !h(v.jsonrpc, !1));
}
function Wt(v) {
  return !(w(v) || !h(v.name, !1));
}
function zt(v, y) {
  return !(!V(y) || !Qe(v).includes(y));
}
function Yt(v, y, z) {
  return h(z, !1) ? Ze(v, y).includes(z) : !1;
}
function Jt(v, y, z) {
  return h(z, !1) ? Xe(v, y).includes(z) : !1;
}
function fn(v, y, z) {
  let ne = null;
  const ue = Qt(v), le = Zt(y), he = Object.keys(ue), ge = Object.keys(le), we = pn(Object.keys(v)), Ee = pn(Object.keys(y)), xe = we.filter(($e) => !Ee.includes($e));
  return xe.length && (ne = N("NON_CONFORMING_NAMESPACES", `${z} namespaces keys don't satisfy requiredNamespaces.
      Required: ${xe.toString()}
      Received: ${Object.keys(y).toString()}`)), O(he, ge) || (ne = N("NON_CONFORMING_NAMESPACES", `${z} namespaces chains don't satisfy required namespaces.
      Required: ${he.toString()}
      Approved: ${ge.toString()}`)), Object.keys(y).forEach(($e) => {
    if (!$e.includes(":") || ne)
      return;
    const Ne = A(y[$e].accounts);
    Ne.includes($e) || (ne = N("NON_CONFORMING_NAMESPACES", `${z} namespaces accounts don't satisfy namespace accounts for ${$e}
        Required: ${$e}
        Approved: ${Ne.toString()}`));
  }), he.forEach(($e) => {
    ne || (O(ue[$e].methods, le[$e].methods) ? O(ue[$e].events, le[$e].events) || (ne = N("NON_CONFORMING_NAMESPACES", `${z} namespaces events don't satisfy namespace events for ${$e}`)) : ne = N("NON_CONFORMING_NAMESPACES", `${z} namespaces methods don't satisfy namespace methods for ${$e}`));
  }), ne;
}
function Qt(v) {
  const y = {};
  return Object.keys(v).forEach((z) => {
    var ne;
    z.includes(":") ? y[z] = v[z] : (ne = v[z].chains) == null || ne.forEach((ue) => {
      y[ue] = { methods: v[z].methods, events: v[z].events };
    });
  }), y;
}
function pn(v) {
  return [...new Set(v.map((y) => y.includes(":") ? y.split(":")[0] : y))];
}
function Zt(v) {
  const y = {};
  return Object.keys(v).forEach((z) => {
    if (z.includes(":"))
      y[z] = v[z];
    else {
      const ne = A(v[z].accounts);
      ne == null || ne.forEach((ue) => {
        y[ue] = { accounts: v[z].accounts.filter((le) => le.includes(`${ue}:`)), methods: v[z].methods, events: v[z].events };
      });
    }
  }), y;
}
function Xt(v, y) {
  return G(v, !1) && v <= y.max && v >= y.min;
}
function er() {
  const v = T();
  return new Promise((y) => {
    switch (v) {
      case m.browser:
        y(mn());
        break;
      case m.reactNative:
        y(yn());
        break;
      case m.node:
        y(hn());
        break;
      default:
        y(!0);
    }
  });
}
function mn() {
  return D() && (navigator == null ? void 0 : navigator.onLine);
}
async function yn() {
  if (C() && typeof global$1 < "u" && global$1 != null && global$1.NetInfo) {
    const v = await (global$1 == null ? void 0 : global$1.NetInfo.fetch());
    return v == null ? void 0 : v.isConnected;
  }
  return !0;
}
function hn() {
  return !0;
}
function nr(v) {
  switch (T()) {
    case m.browser:
      gn(v);
      break;
    case m.reactNative:
      vn(v);
      break;
  }
}
function gn(v) {
  !C() && D() && (window.addEventListener("online", () => v(!0)), window.addEventListener("offline", () => v(!1)));
}
function vn(v) {
  C() && typeof global$1 < "u" && global$1 != null && global$1.NetInfo && (global$1 == null || global$1.NetInfo.addEventListener((y) => v(y == null ? void 0 : y.isConnected)));
}
const ae = {};
class tr {
  static get(y) {
    return ae[y];
  }
  static set(y, z) {
    ae[y] = z;
  }
  static delete(y) {
    delete ae[y];
  }
}
var NAMESPACE = "eip155", STORE_KEY = "store", REQUESTED_CHAINS_KEY = "requestedChains", ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain", _provider$2, _initProviderPromise, _createProvider, createProvider_fn, _initProvider, initProvider_fn, _isChainsStale, isChainsStale_fn, _setupListeners, setupListeners_fn, _removeListeners, removeListeners_fn, _setRequestedChainsIds, setRequestedChainsIds_fn, _getRequestedChainsIds, getRequestedChainsIds_fn, _getNamespaceChainsIds, getNamespaceChainsIds_fn, _getNamespaceMethods, getNamespaceMethods_fn, WalletConnectConnector = class extends Connector {
  constructor(v) {
    super({
      ...v,
      options: { isNewChainsStale: !0, ...v.options }
    }), __privateAdd(this, _createProvider), __privateAdd(this, _initProvider), __privateAdd(this, _isChainsStale), __privateAdd(this, _setupListeners), __privateAdd(this, _removeListeners), __privateAdd(this, _setRequestedChainsIds), __privateAdd(this, _getRequestedChainsIds), __privateAdd(this, _getNamespaceChainsIds), __privateAdd(this, _getNamespaceMethods), this.id = "walletConnect", this.name = "WalletConnect", this.ready = !0, __privateAdd(this, _provider$2, void 0), __privateAdd(this, _initProviderPromise, void 0), this.onAccountsChanged = (y) => {
      y.length === 0 ? this.emit("disconnect") : this.emit("change", { account: getAddress(y[0]) });
    }, this.onChainChanged = (y) => {
      const z = Number(y), ne = this.isChainUnsupported(z);
      this.emit("change", { chain: { id: z, unsupported: ne } });
    }, this.onDisconnect = () => {
      __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, []), this.emit("disconnect");
    }, this.onDisplayUri = (y) => {
      this.emit("message", { type: "display_uri", data: y });
    }, this.onConnect = () => {
      this.emit("connect", {});
    }, __privateMethod(this, _createProvider, createProvider_fn).call(this);
  }
  async connect({ chainId: v, pairingTopic: y } = {}) {
    var z, ne, ue, le, he;
    try {
      let ge = v;
      if (!ge) {
        const Nr = (z = this.storage) == null ? void 0 : z.getItem(STORE_KEY), br = (le = (ue = (ne = Nr == null ? void 0 : Nr.state) == null ? void 0 : ne.data) == null ? void 0 : ue.chain) == null ? void 0 : le.id;
        br && !this.isChainUnsupported(br) ? ge = br : ge = (he = this.chains[0]) == null ? void 0 : he.id;
      }
      if (!ge)
        throw new Error("No chains found on connector.");
      const we = await this.getProvider();
      __privateMethod(this, _setupListeners, setupListeners_fn).call(this);
      const Ee = __privateMethod(this, _isChainsStale, isChainsStale_fn).call(this);
      if (we.session && Ee && await we.disconnect(), !we.session || Ee) {
        const Nr = this.chains.filter((br) => br.id !== ge).map((br) => br.id);
        this.emit("message", { type: "connecting" }), await we.connect({
          pairingTopic: y,
          optionalChains: [ge, ...Nr]
        }), __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, this.chains.map(({ id: br }) => br));
      }
      const xe = await we.enable(), $e = getAddress(xe[0]), Ne = await this.getChainId(), st = this.isChainUnsupported(Ne);
      return {
        account: $e,
        chain: { id: Ne, unsupported: st }
      };
    } catch (ge) {
      throw /user rejected/i.test(ge == null ? void 0 : ge.message) ? new UserRejectedRequestError(ge) : ge;
    }
  }
  async disconnect() {
    const v = await this.getProvider();
    try {
      await v.disconnect();
    } catch (y) {
      if (!/No matching key/i.test(y.message))
        throw y;
    } finally {
      __privateMethod(this, _removeListeners, removeListeners_fn).call(this), __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, []);
    }
  }
  async getAccount() {
    const { accounts: v } = await this.getProvider();
    return getAddress(v[0]);
  }
  async getChainId() {
    const { chainId: v } = await this.getProvider();
    return v;
  }
  async getProvider({ chainId: v } = {}) {
    return __privateGet(this, _provider$2) || await __privateMethod(this, _createProvider, createProvider_fn).call(this), v && await this.switchChain(v), __privateGet(this, _provider$2);
  }
  async getWalletClient({
    chainId: v
  } = {}) {
    const [y, z] = await Promise.all([
      this.getProvider({ chainId: v }),
      this.getAccount()
    ]), ne = this.chains.find((ue) => ue.id === v);
    if (!y)
      throw new Error("provider is required.");
    return createWalletClient({
      account: z,
      chain: ne,
      transport: custom(y)
    });
  }
  async isAuthorized() {
    try {
      const [v, y] = await Promise.all([
        this.getAccount(),
        this.getProvider()
      ]), z = __privateMethod(this, _isChainsStale, isChainsStale_fn).call(this);
      if (!v)
        return !1;
      if (z && y.session) {
        try {
          await y.disconnect();
        } catch {
        }
        return !1;
      }
      return !0;
    } catch {
      return !1;
    }
  }
  async switchChain(v) {
    var z, ne;
    const y = this.chains.find((ue) => ue.id === v);
    if (!y)
      throw new SwitchChainError(new Error("chain not found on connector."));
    try {
      const ue = await this.getProvider(), le = __privateMethod(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this), he = __privateMethod(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this);
      if (!le.includes(v) && he.includes(ADD_ETH_CHAIN_METHOD)) {
        await ue.request({
          method: ADD_ETH_CHAIN_METHOD,
          params: [
            {
              chainId: numberToHex$1(y.id),
              blockExplorerUrls: [(ne = (z = y.blockExplorers) == null ? void 0 : z.default) == null ? void 0 : ne.url],
              chainName: y.name,
              nativeCurrency: y.nativeCurrency,
              rpcUrls: [...y.rpcUrls.default.http]
            }
          ]
        });
        const we = __privateMethod(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this);
        we.push(v), __privateMethod(this, _setRequestedChainsIds, setRequestedChainsIds_fn).call(this, we);
      }
      return await ue.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: numberToHex$1(v) }]
      }), y;
    } catch (ue) {
      const le = typeof ue == "string" ? ue : ue == null ? void 0 : ue.message;
      throw /user rejected request/i.test(le) ? new UserRejectedRequestError(ue) : new SwitchChainError(ue);
    }
  }
};
_provider$2 = /* @__PURE__ */ new WeakMap();
_initProviderPromise = /* @__PURE__ */ new WeakMap();
_createProvider = /* @__PURE__ */ new WeakSet();
createProvider_fn = async function() {
  return !__privateGet(this, _initProviderPromise) && typeof window < "u" && __privateSet(this, _initProviderPromise, __privateMethod(this, _initProvider, initProvider_fn).call(this)), __privateGet(this, _initProviderPromise);
};
_initProvider = /* @__PURE__ */ new WeakSet();
initProvider_fn = async function() {
  const { EthereumProvider: v } = await import("./index.es-C-WxJWYd.js"), y = this.chains.map(({ id: z }) => z);
  if (y.length) {
    const {
      projectId: z,
      showQrModal: ne = !0,
      qrModalOptions: ue,
      metadata: le,
      relayUrl: he
    } = this.options;
    __privateSet(this, _provider$2, await v.init({
      showQrModal: ne,
      qrModalOptions: ue,
      projectId: z,
      optionalChains: y,
      rpcMap: Object.fromEntries(
        this.chains.map((ge) => [
          ge.id,
          ge.rpcUrls.default.http[0]
        ])
      ),
      metadata: le,
      relayUrl: he
    }));
  }
};
_isChainsStale = /* @__PURE__ */ new WeakSet();
isChainsStale_fn = function() {
  if (__privateMethod(this, _getNamespaceMethods, getNamespaceMethods_fn).call(this).includes(ADD_ETH_CHAIN_METHOD) || !this.options.isNewChainsStale)
    return !1;
  const y = __privateMethod(this, _getRequestedChainsIds, getRequestedChainsIds_fn).call(this), z = this.chains.map(({ id: ue }) => ue), ne = __privateMethod(this, _getNamespaceChainsIds, getNamespaceChainsIds_fn).call(this);
  return ne.length && !ne.some((ue) => z.includes(ue)) ? !1 : !z.every((ue) => y.includes(ue));
};
_setupListeners = /* @__PURE__ */ new WeakSet();
setupListeners_fn = function() {
  __privateGet(this, _provider$2) && (__privateMethod(this, _removeListeners, removeListeners_fn).call(this), __privateGet(this, _provider$2).on("accountsChanged", this.onAccountsChanged), __privateGet(this, _provider$2).on("chainChanged", this.onChainChanged), __privateGet(this, _provider$2).on("disconnect", this.onDisconnect), __privateGet(this, _provider$2).on("session_delete", this.onDisconnect), __privateGet(this, _provider$2).on("display_uri", this.onDisplayUri), __privateGet(this, _provider$2).on("connect", this.onConnect));
};
_removeListeners = /* @__PURE__ */ new WeakSet();
removeListeners_fn = function() {
  __privateGet(this, _provider$2) && (__privateGet(this, _provider$2).removeListener("accountsChanged", this.onAccountsChanged), __privateGet(this, _provider$2).removeListener("chainChanged", this.onChainChanged), __privateGet(this, _provider$2).removeListener("disconnect", this.onDisconnect), __privateGet(this, _provider$2).removeListener("session_delete", this.onDisconnect), __privateGet(this, _provider$2).removeListener("display_uri", this.onDisplayUri), __privateGet(this, _provider$2).removeListener("connect", this.onConnect));
};
_setRequestedChainsIds = /* @__PURE__ */ new WeakSet();
setRequestedChainsIds_fn = function(v) {
  var y;
  (y = this.storage) == null || y.setItem(REQUESTED_CHAINS_KEY, v);
};
_getRequestedChainsIds = /* @__PURE__ */ new WeakSet();
getRequestedChainsIds_fn = function() {
  var v;
  return ((v = this.storage) == null ? void 0 : v.getItem(REQUESTED_CHAINS_KEY)) ?? [];
};
_getNamespaceChainsIds = /* @__PURE__ */ new WeakSet();
getNamespaceChainsIds_fn = function() {
  var ne, ue, le;
  if (!__privateGet(this, _provider$2))
    return [];
  const v = (ne = __privateGet(this, _provider$2).session) == null ? void 0 : ne.namespaces;
  return v ? ((le = (ue = se(v)[NAMESPACE]) == null ? void 0 : ue.chains) == null ? void 0 : le.map(
    (he) => parseInt(he.split(":")[1] || "")
  )) ?? [] : [];
};
_getNamespaceMethods = /* @__PURE__ */ new WeakSet();
getNamespaceMethods_fn = function() {
  var ne, ue;
  if (!__privateGet(this, _provider$2))
    return [];
  const v = (ne = __privateGet(this, _provider$2).session) == null ? void 0 : ne.namespaces;
  return v ? ((ue = se(v)[NAMESPACE]) == null ? void 0 : ue.methods) ?? [] : [];
};
var switchChainAllowedRegex = /(imtoken|metamask|rainbow|trust wallet|uniswap wallet|ledger)/i, _provider$1, _switchChain, switchChain_fn, WalletConnectLegacyConnector = class extends Connector {
  constructor() {
    super(...arguments), __privateAdd(this, _switchChain), this.id = "walletConnectLegacy", this.name = "WalletConnectLegacy", this.ready = !0, __privateAdd(this, _provider$1, void 0), this.onAccountsChanged = (v) => {
      v.length === 0 ? this.emit("disconnect") : this.emit("change", { account: getAddress(v[0]) });
    }, this.onChainChanged = (v) => {
      const y = normalizeChainId(v), z = this.isChainUnsupported(y);
      this.emit("change", { chain: { id: y, unsupported: z } });
    }, this.onDisconnect = () => {
      this.emit("disconnect");
    };
  }
  async connect({ chainId: v } = {}) {
    var y, z, ne, ue, le, he;
    try {
      let ge = v;
      if (!ge) {
        const Nr = (y = this.storage) == null ? void 0 : y.getItem("store"), br = (ue = (ne = (z = Nr == null ? void 0 : Nr.state) == null ? void 0 : z.data) == null ? void 0 : ne.chain) == null ? void 0 : ue.id;
        br && !this.isChainUnsupported(br) && (ge = br);
      }
      const we = await this.getProvider({
        chainId: ge,
        create: !0
      });
      we.on("accountsChanged", this.onAccountsChanged), we.on("chainChanged", this.onChainChanged), we.on("disconnect", this.onDisconnect), setTimeout(() => this.emit("message", { type: "connecting" }), 0);
      const Ee = await we.enable(), xe = getAddress(Ee[0]), $e = await this.getChainId(), Ne = this.isChainUnsupported($e), st = ((he = (le = we.connector) == null ? void 0 : le.peerMeta) == null ? void 0 : he.name) ?? "";
      return switchChainAllowedRegex.test(st) && (this.switchChain = __privateMethod(this, _switchChain, switchChain_fn)), {
        account: xe,
        chain: { id: $e, unsupported: Ne }
      };
    } catch (ge) {
      throw /user closed modal/i.test(ge.message) ? new UserRejectedRequestError(ge) : ge;
    }
  }
  async disconnect() {
    const v = await this.getProvider();
    await v.disconnect(), v.removeListener("accountsChanged", this.onAccountsChanged), v.removeListener("chainChanged", this.onChainChanged), v.removeListener("disconnect", this.onDisconnect), typeof localStorage < "u" && localStorage.removeItem("walletconnect");
  }
  async getAccount() {
    const y = (await this.getProvider()).accounts;
    return getAddress(y[0]);
  }
  async getChainId() {
    const v = await this.getProvider();
    return normalizeChainId(v.chainId);
  }
  async getProvider({
    chainId: v,
    create: y
  } = {}) {
    var z, ne;
    if (!__privateGet(this, _provider$1) || v || y) {
      const ue = (z = this.options) != null && z.infuraId ? {} : this.chains.reduce(
        (he, ge) => ({
          ...he,
          [ge.id]: ge.rpcUrls.default.http[0]
        }),
        {}
      ), le = (await import("./index-QqbrwE9T.js")).default;
      __privateSet(this, _provider$1, new le({
        ...this.options,
        chainId: v,
        rpc: { ...ue, ...(ne = this.options) == null ? void 0 : ne.rpc }
      })), __privateGet(this, _provider$1).http = await __privateGet(this, _provider$1).setHttpProvider(v);
    }
    return __privateGet(this, _provider$1);
  }
  async getWalletClient({
    chainId: v
  } = {}) {
    const [y, z] = await Promise.all([
      this.getProvider({ chainId: v }),
      this.getAccount()
    ]), ne = this.chains.find((ue) => ue.id === v);
    if (!y)
      throw new Error("provider is required.");
    return createWalletClient({
      account: z,
      chain: ne,
      transport: custom(y)
    });
  }
  async isAuthorized() {
    try {
      return !!await this.getAccount();
    } catch {
      return !1;
    }
  }
};
_provider$1 = /* @__PURE__ */ new WeakMap();
_switchChain = /* @__PURE__ */ new WeakSet();
switchChain_fn = async function(v) {
  const y = await this.getProvider(), z = numberToHex$1(v);
  try {
    return await Promise.race([
      y.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: z }]
      }),
      new Promise(
        (ne) => this.on("change", ({ chain: ue }) => {
          (ue == null ? void 0 : ue.id) === v && ne(v);
        })
      )
    ]), this.chains.find((ne) => ne.id === v) ?? {
      id: v,
      name: `Chain ${z}`,
      network: `${z}`,
      nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
      rpcUrls: { default: { http: [""] }, public: { http: [""] } }
    };
  } catch (ne) {
    const ue = typeof ne == "string" ? ne : ne == null ? void 0 : ne.message;
    throw /user rejected request/i.test(ue) ? new UserRejectedRequestError(ne) : new SwitchChainError(ne);
  }
};
async function getWalletConnectUri(v, y) {
  const z = await v.getProvider();
  return y === "2" ? new Promise((ne) => z.once("display_uri", ne)) : z.connector.uri;
}
var sharedConnectors = /* @__PURE__ */ new Map();
function createConnector(v, y) {
  const z = v === "1" ? new WalletConnectLegacyConnector(y) : new WalletConnectConnector(y);
  return sharedConnectors.set(JSON.stringify(y), z), z;
}
function getWalletConnectConnector({
  chains: v,
  options: y = {},
  projectId: z,
  version: ne = "2"
}) {
  const ue = "21fef48091f12692cad574a6f7753643";
  if (ne === "2") {
    if (!z || z === "")
      throw new Error("No projectId found. Every dApp must now provide a WalletConnect Cloud projectId to enable WalletConnect v2 https://www.rainbowkit.com/docs/installation#configure");
    (z === "YOUR_PROJECT_ID" || z === ue) && console.warn("Invalid projectId. Please create a unique WalletConnect Cloud projectId for your dApp https://www.rainbowkit.com/docs/installation#configure");
  }
  const le = {
    chains: v,
    options: ne === "1" ? {
      qrcode: !1,
      ...y
    } : {
      projectId: z === "YOUR_PROJECT_ID" ? ue : z,
      showQrModal: !1,
      ...y
    }
  }, he = JSON.stringify(le), ge = sharedConnectors.get(he);
  return ge ?? createConnector(ne, le);
}
function isAndroid() {
  return typeof navigator < "u" && /android/i.test(navigator.userAgent);
}
function isSmallIOS() {
  return typeof navigator < "u" && /iPhone|iPod/.test(navigator.userAgent);
}
function isLargeIOS() {
  return typeof navigator < "u" && (/iPad/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
function isIOS() {
  return isSmallIOS() || isLargeIOS();
}
var walletConnectWallet = ({
  chains: v,
  options: y,
  projectId: z,
  version: ne = "2"
}) => ({
  id: "walletConnect",
  name: "WalletConnect",
  iconUrl: async () => (await import("./walletConnectWallet-D6ZADJM7-DNWHRPIx.js")).default,
  iconBackground: "#3b99fc",
  createConnector: () => {
    const ue = isIOS(), le = getWalletConnectConnector(ne === "1" ? {
      version: "1",
      chains: v,
      options: {
        qrcode: ue,
        ...y
      }
    } : {
      version: "2",
      chains: v,
      projectId: z,
      options: {
        showQrModal: ue,
        ...y
      }
    }), he = async () => getWalletConnectUri(le, ne);
    return {
      connector: le,
      ...ue ? {} : {
        mobile: { getUri: he },
        qrCode: { getUri: he }
      }
    };
  }
}), phantomWallet = ({
  chains: v,
  ...y
}) => {
  var z;
  return {
    id: "phantom",
    name: "Phantom",
    iconUrl: async () => (await import("./phantomWallet-OLG36S4X-CJCpryCl.js")).default,
    iconBackground: "#9A8AEE",
    installed: typeof window < "u" && !!((z = window.phantom) != null && z.ethereum) || void 0,
    downloadUrls: {
      android: "https://play.google.com/store/apps/details?id=app.phantom",
      ios: "https://apps.apple.com/app/phantom-solana-wallet/1598432977",
      mobile: "https://phantom.app/download",
      qrCode: "https://phantom.app/download",
      chrome: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
      firefox: "https://addons.mozilla.org/firefox/addon/phantom-app/",
      browserExtension: "https://phantom.app/download"
    },
    createConnector: () => {
      const ne = () => {
        var le;
        return typeof window < "u" ? (le = window.phantom) == null ? void 0 : le.ethereum : void 0;
      };
      return {
        connector: new InjectedConnector({
          chains: v,
          options: { getProvider: ne, ...y }
        }),
        extension: {
          instructions: {
            steps: [
              {
                description: "wallet_connectors.phantom.extension.step1.description",
                step: "install",
                title: "wallet_connectors.phantom.extension.step1.title"
              },
              {
                description: "wallet_connectors.phantom.extension.step2.description",
                step: "create",
                title: "wallet_connectors.phantom.extension.step2.title"
              },
              {
                description: "wallet_connectors.phantom.extension.step3.description",
                step: "refresh",
                title: "wallet_connectors.phantom.extension.step3.title"
              }
            ],
            learnMoreUrl: "https://help.phantom.app"
          }
        }
      };
    }
  };
}, rainbowWallet = ({
  chains: v,
  projectId: y,
  walletConnectOptions: z,
  walletConnectVersion: ne = "2",
  ...ue
}) => {
  const le = hasInjectedProvider("isRainbow"), he = !le;
  return {
    id: "rainbow",
    name: "Rainbow",
    iconUrl: async () => (await import("./rainbowWallet-GGU64QEI-BaPfWKes.js")).default,
    iconBackground: "#0c2f78",
    installed: he ? void 0 : le,
    downloadUrls: {
      android: "https://play.google.com/store/apps/details?id=me.rainbow&referrer=utm_source%3Drainbowkit&utm_source=rainbowkit",
      ios: "https://apps.apple.com/app/apple-store/id1457119021?pt=119997837&ct=rainbowkit&mt=8",
      mobile: "https://rainbow.download?utm_source=rainbowkit",
      qrCode: "https://rainbow.download?utm_source=rainbowkit&utm_medium=qrcode",
      browserExtension: "https://rainbow.me/extension?utm_source=rainbowkit"
    },
    createConnector: () => {
      const ge = he ? getWalletConnectConnector({
        projectId: y,
        chains: v,
        version: ne,
        options: z
      }) : getInjectedConnector({ flag: "isRainbow", chains: v, options: ue }), we = async () => {
        const Ee = await getWalletConnectUri(ge, ne);
        return isAndroid() ? Ee : isIOS() ? `rainbow://wc?uri=${encodeURIComponent(Ee)}&connector=rainbowkit` : `https://rnbwapp.com/wc?uri=${encodeURIComponent(Ee)}&connector=rainbowkit`;
      };
      return {
        connector: ge,
        mobile: { getUri: he ? we : void 0 },
        qrCode: he ? {
          getUri: we,
          instructions: {
            learnMoreUrl: "https://learn.rainbow.me/connect-to-a-website-or-app?utm_source=rainbowkit&utm_medium=connector&utm_campaign=learnmore",
            steps: [
              {
                description: "wallet_connectors.rainbow.qr_code.step1.description",
                step: "install",
                title: "wallet_connectors.rainbow.qr_code.step1.title"
              },
              {
                description: "wallet_connectors.rainbow.qr_code.step2.description",
                step: "create",
                title: "wallet_connectors.rainbow.qr_code.step2.title"
              },
              {
                description: "wallet_connectors.rainbow.qr_code.step3.description",
                step: "scan",
                title: "wallet_connectors.rainbow.qr_code.step3.title"
              }
            ]
          }
        } : void 0
      };
    }
  };
}, _UNSTABLE_shimOnConnectSelectAccount, MetaMaskConnector = class extends InjectedConnector {
  constructor({
    chains: v,
    options: y
  } = {}) {
    const z = {
      name: "MetaMask",
      shimDisconnect: !0,
      getProvider() {
        function ne(le) {
          if (le != null && le.isMetaMask && !(le.isBraveWallet && !le._events && !le._state) && !le.isApexWallet && !le.isAvalanche && !le.isBitKeep && !le.isBlockWallet && !le.isCoin98 && !le.isFordefi && !le.isMathWallet && !(le.isOkxWallet || le.isOKExWallet) && !(le.isOneInchIOSWallet || le.isOneInchAndroidWallet) && !le.isOpera && !le.isPortal && !le.isRabby && !le.isDefiant && !le.isTokenPocket && !le.isTokenary && !le.isZeal && !le.isZerion)
            return le;
        }
        if (typeof window > "u")
          return;
        const ue = window.ethereum;
        return ue != null && ue.providers ? ue.providers.find(ne) : ne(ue);
      },
      ...y
    };
    super({ chains: v, options: z }), this.id = "metaMask", this.shimDisconnectKey = `${this.id}.shimDisconnect`, __privateAdd(this, _UNSTABLE_shimOnConnectSelectAccount, void 0), __privateSet(this, _UNSTABLE_shimOnConnectSelectAccount, z.UNSTABLE_shimOnConnectSelectAccount);
  }
  async connect({ chainId: v } = {}) {
    var y, z, ne, ue;
    try {
      const le = await this.getProvider();
      if (!le)
        throw new ConnectorNotFoundError();
      le.on && (le.on("accountsChanged", this.onAccountsChanged), le.on("chainChanged", this.onChainChanged), le.on("disconnect", this.onDisconnect)), this.emit("message", { type: "connecting" });
      let he = null;
      if (__privateGet(this, _UNSTABLE_shimOnConnectSelectAccount) && ((y = this.options) != null && y.shimDisconnect) && !((z = this.storage) != null && z.getItem(this.shimDisconnectKey)) && (he = await this.getAccount().catch(() => null), !!he))
        try {
          await le.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }), he = await this.getAccount();
        } catch (xe) {
          if (this.isUserRejectedRequestError(xe))
            throw new UserRejectedRequestError(xe);
          if (xe.code === new ResourceUnavailableRpcError(xe).code)
            throw xe;
        }
      if (!he) {
        const Ee = await le.request({
          method: "eth_requestAccounts"
        });
        he = getAddress(Ee[0]);
      }
      let ge = await this.getChainId(), we = this.isChainUnsupported(ge);
      return v && ge !== v && (ge = (await this.switchChain(v)).id, we = this.isChainUnsupported(ge)), (ne = this.options) != null && ne.shimDisconnect && ((ue = this.storage) == null || ue.setItem(this.shimDisconnectKey, !0)), { account: he, chain: { id: ge, unsupported: we }, provider: le };
    } catch (le) {
      throw this.isUserRejectedRequestError(le) ? new UserRejectedRequestError(le) : le.code === -32002 ? new ResourceUnavailableRpcError(le) : le;
    }
  }
};
_UNSTABLE_shimOnConnectSelectAccount = /* @__PURE__ */ new WeakMap();
function isMetaMask(v) {
  return !(!(v != null && v.isMetaMask) || v.isBraveWallet && !v._events && !v._state || v.isApexWallet || v.isAvalanche || v.isBackpack || v.isBifrost || v.isBitKeep || v.isBitski || v.isBlockWallet || v.isCoinbaseWallet || v.isDawn || v.isEnkrypt || v.isExodus || v.isFrame || v.isFrontier || v.isGamestop || v.isHyperPay || v.isImToken || v.isKuCoinWallet || v.isMathWallet || v.isOkxWallet || v.isOKExWallet || v.isOneInchIOSWallet || v.isOneInchAndroidWallet || v.isOpera || v.isPhantom || v.isPortal || v.isRabby || v.isRainbow || v.isStatus || v.isTalisman || v.isTally || v.isTokenPocket || v.isTokenary || v.isTrust || v.isTrustWallet || v.isXDEFI || v.isZeal || v.isZerion);
}
var metaMaskWallet = ({
  chains: v,
  projectId: y,
  walletConnectOptions: z,
  walletConnectVersion: ne = "2",
  ...ue
}) => {
  var le, he;
  const ge = typeof window < "u" && ((le = window.ethereum) == null ? void 0 : le.providers), we = typeof window < "u" && typeof window.ethereum < "u" && (((he = window.ethereum.providers) == null ? void 0 : he.some(isMetaMask)) || window.ethereum.isMetaMask), Ee = !we;
  return {
    id: "metaMask",
    name: "MetaMask",
    iconUrl: async () => (await import("./metaMaskWallet-ORHUNQRP-U8VURrRh.js")).default,
    iconAccent: "#f6851a",
    iconBackground: "#fff",
    installed: Ee ? void 0 : we,
    downloadUrls: {
      android: "https://play.google.com/store/apps/details?id=io.metamask",
      ios: "https://apps.apple.com/us/app/metamask/id1438144202",
      mobile: "https://metamask.io/download",
      qrCode: "https://metamask.io/download",
      chrome: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",
      edge: "https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm",
      firefox: "https://addons.mozilla.org/firefox/addon/ether-metamask",
      opera: "https://addons.opera.com/extensions/details/metamask-10",
      browserExtension: "https://metamask.io/download"
    },
    createConnector: () => {
      const xe = Ee ? getWalletConnectConnector({
        projectId: y,
        chains: v,
        version: ne,
        options: z
      }) : new MetaMaskConnector({
        chains: v,
        options: {
          getProvider: () => ge ? ge.find(isMetaMask) : typeof window < "u" ? window.ethereum : void 0,
          ...ue
        }
      }), $e = async () => {
        const Ne = await getWalletConnectUri(xe, ne);
        return isAndroid() ? Ne : isIOS() ? `metamask://wc?uri=${encodeURIComponent(Ne)}` : `https://metamask.app.link/wc?uri=${encodeURIComponent(Ne)}`;
      };
      return {
        connector: xe,
        mobile: {
          getUri: Ee ? $e : void 0
        },
        qrCode: Ee ? {
          getUri: $e,
          instructions: {
            learnMoreUrl: "https://metamask.io/faqs/",
            steps: [
              {
                description: "wallet_connectors.metamask.qr_code.step1.description",
                step: "install",
                title: "wallet_connectors.metamask.qr_code.step1.title"
              },
              {
                description: "wallet_connectors.metamask.qr_code.step2.description",
                step: "create",
                title: "wallet_connectors.metamask.qr_code.step2.title"
              },
              {
                description: "wallet_connectors.metamask.qr_code.step3.description",
                step: "refresh",
                title: "wallet_connectors.metamask.qr_code.step3.title"
              }
            ]
          }
        } : void 0,
        extension: {
          instructions: {
            learnMoreUrl: "https://metamask.io/faqs/",
            steps: [
              {
                description: "wallet_connectors.metamask.extension.step1.description",
                step: "install",
                title: "wallet_connectors.metamask.extension.step1.title"
              },
              {
                description: "wallet_connectors.metamask.extension.step2.description",
                step: "create",
                title: "wallet_connectors.metamask.extension.step2.title"
              },
              {
                description: "wallet_connectors.metamask.extension.step3.description",
                step: "refresh",
                title: "wallet_connectors.metamask.extension.step3.title"
              }
            ]
          }
        }
      };
    }
  };
}, _client, _provider, CoinbaseWalletConnector = class extends Connector {
  constructor({ chains: v, options: y }) {
    super({
      chains: v,
      options: {
        reloadOnDisconnect: !1,
        ...y
      }
    }), this.id = "coinbaseWallet", this.name = "Coinbase Wallet", this.ready = !0, __privateAdd(this, _client, void 0), __privateAdd(this, _provider, void 0), this.onAccountsChanged = (z) => {
      z.length === 0 ? this.emit("disconnect") : this.emit("change", { account: getAddress(z[0]) });
    }, this.onChainChanged = (z) => {
      const ne = normalizeChainId(z), ue = this.isChainUnsupported(ne);
      this.emit("change", { chain: { id: ne, unsupported: ue } });
    }, this.onDisconnect = () => {
      this.emit("disconnect");
    };
  }
  async connect({ chainId: v } = {}) {
    try {
      const y = await this.getProvider();
      y.on("accountsChanged", this.onAccountsChanged), y.on("chainChanged", this.onChainChanged), y.on("disconnect", this.onDisconnect), this.emit("message", { type: "connecting" });
      const z = await y.enable(), ne = getAddress(z[0]);
      let ue = await this.getChainId(), le = this.isChainUnsupported(ue);
      return v && ue !== v && (ue = (await this.switchChain(v)).id, le = this.isChainUnsupported(ue)), {
        account: ne,
        chain: { id: ue, unsupported: le }
      };
    } catch (y) {
      throw /(user closed modal|accounts received is empty)/i.test(
        y.message
      ) ? new UserRejectedRequestError(y) : y;
    }
  }
  async disconnect() {
    if (!__privateGet(this, _provider))
      return;
    const v = await this.getProvider();
    v.removeListener("accountsChanged", this.onAccountsChanged), v.removeListener("chainChanged", this.onChainChanged), v.removeListener("disconnect", this.onDisconnect), v.disconnect(), v.close();
  }
  async getAccount() {
    const y = await (await this.getProvider()).request({
      method: "eth_accounts"
    });
    return getAddress(y[0]);
  }
  async getChainId() {
    const v = await this.getProvider();
    return normalizeChainId(v.chainId);
  }
  async getProvider() {
    var v;
    if (!__privateGet(this, _provider)) {
      let y = (await import("./index-BY83uN55.js").then((he) => he.i)).default;
      typeof y != "function" && typeof y.default == "function" && (y = y.default), __privateSet(this, _client, new y(this.options));
      const z = (v = __privateGet(this, _client).walletExtension) == null ? void 0 : v.getChainId(), ne = this.chains.find(
        (he) => this.options.chainId ? he.id === this.options.chainId : he.id === z
      ) || this.chains[0], ue = this.options.chainId || (ne == null ? void 0 : ne.id), le = this.options.jsonRpcUrl || (ne == null ? void 0 : ne.rpcUrls.default.http[0]);
      __privateSet(this, _provider, __privateGet(this, _client).makeWeb3Provider(le, ue));
    }
    return __privateGet(this, _provider);
  }
  async getWalletClient({
    chainId: v
  } = {}) {
    const [y, z] = await Promise.all([
      this.getProvider(),
      this.getAccount()
    ]), ne = this.chains.find((ue) => ue.id === v);
    if (!y)
      throw new Error("provider is required.");
    return createWalletClient({
      account: z,
      chain: ne,
      transport: custom(y)
    });
  }
  async isAuthorized() {
    try {
      return !!await this.getAccount();
    } catch {
      return !1;
    }
  }
  async switchChain(v) {
    var ne;
    const y = await this.getProvider(), z = numberToHex$1(v);
    try {
      return await y.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: z }]
      }), this.chains.find((ue) => ue.id === v) ?? {
        id: v,
        name: `Chain ${z}`,
        network: `${z}`,
        nativeCurrency: { name: "Ether", decimals: 18, symbol: "ETH" },
        rpcUrls: { default: { http: [""] }, public: { http: [""] } }
      };
    } catch (ue) {
      const le = this.chains.find((he) => he.id === v);
      if (!le)
        throw new ChainNotConfiguredForConnectorError({
          chainId: v,
          connectorId: this.id
        });
      if (ue.code === 4902)
        try {
          return await y.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: z,
                chainName: le.name,
                nativeCurrency: le.nativeCurrency,
                rpcUrls: [((ne = le.rpcUrls.public) == null ? void 0 : ne.http[0]) ?? ""],
                blockExplorerUrls: this.getBlockExplorerUrls(le)
              }
            ]
          }), le;
        } catch (he) {
          throw new UserRejectedRequestError(he);
        }
      throw new SwitchChainError(ue);
    }
  }
  async watchAsset({
    address: v,
    decimals: y = 18,
    image: z,
    symbol: ne
  }) {
    return (await this.getProvider()).request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: v,
          decimals: y,
          image: z,
          symbol: ne
        }
      }
    });
  }
};
_client = /* @__PURE__ */ new WeakMap();
_provider = /* @__PURE__ */ new WeakMap();
var coinbaseWallet = ({
  appName: v,
  chains: y,
  ...z
}) => {
  const ne = hasInjectedProvider("isCoinbaseWallet");
  return {
    id: "coinbase",
    name: "Coinbase Wallet",
    shortName: "Coinbase",
    iconUrl: async () => (await import("./coinbaseWallet-2OUR5TUP-By3FyIKy.js")).default,
    iconAccent: "#2c5ff6",
    iconBackground: "#2c5ff6",
    installed: ne || void 0,
    downloadUrls: {
      android: "https://play.google.com/store/apps/details?id=org.toshi",
      ios: "https://apps.apple.com/us/app/coinbase-wallet-store-crypto/id1278383455",
      mobile: "https://coinbase.com/wallet/downloads",
      qrCode: "https://coinbase-wallet.onelink.me/q5Sx/fdb9b250",
      chrome: "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad",
      browserExtension: "https://coinbase.com/wallet"
    },
    createConnector: () => {
      const ue = isIOS(), le = new CoinbaseWalletConnector({
        chains: y,
        options: {
          appName: v,
          headlessMode: !0,
          ...z
        }
      });
      return {
        connector: le,
        ...ue ? {} : {
          qrCode: {
            getUri: async () => (await le.getProvider()).qrUrl,
            instructions: {
              learnMoreUrl: "https://coinbase.com/wallet/articles/getting-started-mobile",
              steps: [
                {
                  description: "wallet_connectors.coinbase.qr_code.step1.description",
                  step: "install",
                  title: "wallet_connectors.coinbase.qr_code.step1.title"
                },
                {
                  description: "wallet_connectors.coinbase.qr_code.step2.description",
                  step: "create",
                  title: "wallet_connectors.coinbase.qr_code.step2.title"
                },
                {
                  description: "wallet_connectors.coinbase.qr_code.step3.description",
                  step: "scan",
                  title: "wallet_connectors.coinbase.qr_code.step3.title"
                }
              ]
            }
          },
          extension: {
            instructions: {
              learnMoreUrl: "https://coinbase.com/wallet/articles/getting-started-extension",
              steps: [
                {
                  description: "wallet_connectors.coinbase.extension.step1.description",
                  step: "install",
                  title: "wallet_connectors.coinbase.extension.step1.title"
                },
                {
                  description: "wallet_connectors.coinbase.extension.step2.description",
                  step: "create",
                  title: "wallet_connectors.coinbase.extension.step2.title"
                },
                {
                  description: "wallet_connectors.coinbase.extension.step3.description",
                  step: "refresh",
                  title: "wallet_connectors.coinbase.extension.step3.title"
                }
              ]
            }
          }
        }
      };
    }
  };
};
class WalletError extends Error {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(y, z) {
    super(y), this.error = z;
  }
}
class WalletNotReadyError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletNotReadyError";
  }
}
class WalletLoadError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletLoadError";
  }
}
class WalletConfigError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletConfigError";
  }
}
class WalletConnectionError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletConnectionError";
  }
}
class WalletDisconnectedError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletDisconnectedError";
  }
}
class WalletDisconnectionError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletDisconnectionError";
  }
}
class WalletAccountError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletAccountError";
  }
}
class WalletPublicKeyError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletPublicKeyError";
  }
}
class WalletNotConnectedError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletNotConnectedError";
  }
}
class WalletSendTransactionError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletSendTransactionError";
  }
}
class WalletSignTransactionError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletSignTransactionError";
  }
}
class WalletSignMessageError extends WalletError {
  constructor() {
    super(...arguments), this.name = "WalletSignMessageError";
  }
}
var WalletReadyState;
(function(v) {
  v.Installed = "Installed", v.NotDetected = "NotDetected", v.Loadable = "Loadable", v.Unsupported = "Unsupported";
})(WalletReadyState || (WalletReadyState = {}));
class BaseWalletAdapter extends EventEmitter {
  get connected() {
    return !!this.publicKey;
  }
  async autoConnect() {
    await this.connect();
  }
  async prepareTransaction(y, z, ne = {}) {
    const ue = this.publicKey;
    if (!ue)
      throw new WalletNotConnectedError();
    return y.feePayer = y.feePayer || ue, y.recentBlockhash = y.recentBlockhash || (await z.getLatestBlockhash({
      commitment: ne.preflightCommitment,
      minContextSlot: ne.minContextSlot
    })).blockhash, y;
  }
}
function scopePollingDetectionStrategy(v) {
  if (typeof window > "u" || typeof document > "u")
    return;
  const y = [];
  function z() {
    if (v())
      for (const le of y)
        le();
  }
  const ne = (
    // TODO: #334 Replace with idle callback strategy.
    setInterval(z, 1e3)
  );
  y.push(() => clearInterval(ne)), // Implies that `DOMContentLoaded` has not yet fired.
  document.readyState === "loading" && (document.addEventListener("DOMContentLoaded", z, { once: !0 }), y.push(() => document.removeEventListener("DOMContentLoaded", z))), // If the `complete` state has been reached, we're too late.
  document.readyState !== "complete" && (window.addEventListener("load", z, { once: !0 }), y.push(() => window.removeEventListener("load", z))), z();
}
function isIosAndRedirectable() {
  if (!navigator)
    return !1;
  const v = navigator.userAgent.toLowerCase(), y = v.includes("iphone") || v.includes("ipad"), z = v.includes("safari");
  return y && z;
}
function isVersionedTransaction(v) {
  return "version" in v;
}
class BaseSignerWalletAdapter extends BaseWalletAdapter {
  async sendTransaction(y, z, ne = {}) {
    let ue = !0;
    try {
      if (isVersionedTransaction(y)) {
        if (!this.supportedTransactionVersions)
          throw new WalletSendTransactionError("Sending versioned transactions isn't supported by this wallet");
        if (!this.supportedTransactionVersions.has(y.version))
          throw new WalletSendTransactionError(`Sending transaction version ${y.version} isn't supported by this wallet`);
        try {
          y = await this.signTransaction(y);
          const le = y.serialize();
          return await z.sendRawTransaction(le, ne);
        } catch (le) {
          throw le instanceof WalletSignTransactionError ? (ue = !1, le) : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
        }
      } else
        try {
          const { signers: le, ...he } = ne;
          y = await this.prepareTransaction(y, z, he), le != null && le.length && y.partialSign(...le), y = await this.signTransaction(y);
          const ge = y.serialize();
          return await z.sendRawTransaction(ge, he);
        } catch (le) {
          throw le instanceof WalletSignTransactionError ? (ue = !1, le) : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
        }
    } catch (le) {
      throw ue && this.emit("error", le), le;
    }
  }
  async signAllTransactions(y) {
    for (const ne of y)
      if (isVersionedTransaction(ne)) {
        if (!this.supportedTransactionVersions)
          throw new WalletSignTransactionError("Signing versioned transactions isn't supported by this wallet");
        if (!this.supportedTransactionVersions.has(ne.version))
          throw new WalletSignTransactionError(`Signing transaction version ${ne.version} isn't supported by this wallet`);
      }
    const z = [];
    for (const ne of y)
      z.push(await this.signTransaction(ne));
    return z;
  }
}
class BaseMessageSignerWalletAdapter extends BaseSignerWalletAdapter {
}
const SolanaSignAndSendTransaction = "solana:signAndSendTransaction", SolanaSignMessage = "solana:signMessage", SolanaSignTransaction = "solana:signTransaction", StandardConnect = "standard:connect", StandardDisconnect = "standard:disconnect", StandardEvents = "standard:events";
var WalletAdapterNetwork;
(function(v) {
  v.Mainnet = "mainnet-beta", v.Testnet = "testnet", v.Devnet = "devnet";
})(WalletAdapterNetwork || (WalletAdapterNetwork = {}));
const CoinbaseWalletName = "Coinbase Wallet";
class CoinbaseWalletAdapter extends BaseMessageSignerWalletAdapter {
  constructor(y = {}) {
    super(), this.name = CoinbaseWalletName, this.url = "https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad", this.icon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSI1MTIiIGN5PSI1MTIiIHI9IjUxMiIgZmlsbD0iIzAwNTJGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1MiA1MTJDMTUyIDcxMC44MjMgMzEzLjE3NyA4NzIgNTEyIDg3MkM3MTAuODIzIDg3MiA4NzIgNzEwLjgyMyA4NzIgNTEyQzg3MiAzMTMuMTc3IDcxMC44MjMgMTUyIDUxMiAxNTJDMzEzLjE3NyAxNTIgMTUyIDMxMy4xNzcgMTUyIDUxMlpNNDIwIDM5NkM0MDYuNzQ1IDM5NiAzOTYgNDA2Ljc0NSAzOTYgNDIwVjYwNEMzOTYgNjE3LjI1NSA0MDYuNzQ1IDYyOCA0MjAgNjI4SDYwNEM2MTcuMjU1IDYyOCA2MjggNjE3LjI1NSA2MjggNjA0VjQyMEM2MjggNDA2Ljc0NSA2MTcuMjU1IDM5NiA2MDQgMzk2SDQyMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", this.supportedTransactionVersions = /* @__PURE__ */ new Set(["legacy", 0]), this._readyState = typeof window > "u" || typeof document > "u" ? WalletReadyState.Unsupported : WalletReadyState.NotDetected, this._disconnected = () => {
      const z = this._wallet;
      z && (z.off("disconnect", this._disconnected), this._wallet = null, this._publicKey = null, this.emit("error", new WalletDisconnectedError()), this.emit("disconnect"));
    }, this._connecting = !1, this._wallet = null, this._publicKey = null, this._readyState !== WalletReadyState.Unsupported && scopePollingDetectionStrategy(() => window != null && window.coinbaseSolana ? (this._readyState = WalletReadyState.Installed, this.emit("readyStateChange", this._readyState), !0) : !1);
  }
  get publicKey() {
    return this._publicKey;
  }
  get connecting() {
    return this._connecting;
  }
  get readyState() {
    return this._readyState;
  }
  async connect() {
    try {
      if (this.connected || this.connecting)
        return;
      if (this._readyState !== WalletReadyState.Installed)
        throw new WalletNotReadyError();
      this._connecting = !0;
      const y = window.coinbaseSolana;
      try {
        await y.connect();
      } catch (ne) {
        throw new WalletConnectionError(ne == null ? void 0 : ne.message, ne);
      }
      if (!y.publicKey)
        throw new WalletAccountError();
      let z;
      try {
        z = new PublicKey(y.publicKey.toBytes());
      } catch (ne) {
        throw new WalletPublicKeyError(ne == null ? void 0 : ne.message, ne);
      }
      y.on("disconnect", this._disconnected), this._wallet = y, this._publicKey = z, this.emit("connect", z);
    } catch (y) {
      throw this.emit("error", y), y;
    } finally {
      this._connecting = !1;
    }
  }
  async disconnect() {
    const y = this._wallet;
    if (y) {
      y.off("disconnect", this._disconnected), this._wallet = null, this._publicKey = null;
      try {
        await y.disconnect();
      } catch (z) {
        this.emit("error", new WalletDisconnectionError(z == null ? void 0 : z.message, z));
      }
    }
    this.emit("disconnect");
  }
  async sendTransaction(y, z, ne = {}) {
    try {
      const ue = this._wallet;
      if (!ue)
        throw new WalletNotConnectedError();
      try {
        const { signers: le, ...he } = ne;
        isVersionedTransaction(y) ? le != null && le.length && y.sign(le) : (y = await this.prepareTransaction(y, z, he), le != null && le.length && y.partialSign(...le)), he.preflightCommitment = he.preflightCommitment || z.commitment;
        const { signature: ge } = await ue.signAndSendTransaction(y, he);
        return ge;
      } catch (le) {
        throw le instanceof WalletError ? le : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
      }
    } catch (ue) {
      throw this.emit("error", ue), ue;
    }
  }
  async signTransaction(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signTransaction(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signAllTransactions(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signAllTransactions(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signMessage(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        const { signature: ne } = await z.signMessage(y);
        return ne;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
}
const PhantomWalletName = "Phantom";
class PhantomWalletAdapter extends BaseMessageSignerWalletAdapter {
  constructor(y = {}) {
    super(), this.name = PhantomWalletName, this.url = "https://phantom.app", this.icon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiB2aWV3Qm94PSIwIDAgMTA4IDEwOCIgZmlsbD0ibm9uZSI+CjxyZWN0IHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiByeD0iMjYiIGZpbGw9IiNBQjlGRjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni41MjY3IDY5LjkyMjlDNDIuMDA1NCA3Ni44NTA5IDM0LjQyOTIgODUuNjE4MiAyNC4zNDggODUuNjE4MkMxOS41ODI0IDg1LjYxODIgMTUgODMuNjU2MyAxNSA3NS4xMzQyQzE1IDUzLjQzMDUgNDQuNjMyNiAxOS44MzI3IDcyLjEyNjggMTkuODMyN0M4Ny43NjggMTkuODMyNyA5NCAzMC42ODQ2IDk0IDQzLjAwNzlDOTQgNTguODI1OCA4My43MzU1IDc2LjkxMjIgNzMuNTMyMSA3Ni45MTIyQzcwLjI5MzkgNzYuOTEyMiA2OC43MDUzIDc1LjEzNDIgNjguNzA1MyA3Mi4zMTRDNjguNzA1MyA3MS41NzgzIDY4LjgyNzUgNzAuNzgxMiA2OS4wNzE5IDY5LjkyMjlDNjUuNTg5MyA3NS44Njk5IDU4Ljg2ODUgODEuMzg3OCA1Mi41NzU0IDgxLjM4NzhDNDcuOTkzIDgxLjM4NzggNDUuNjcxMyA3OC41MDYzIDQ1LjY3MTMgNzQuNDU5OEM0NS42NzEzIDcyLjk4ODQgNDUuOTc2OCA3MS40NTU2IDQ2LjUyNjcgNjkuOTIyOVpNODMuNjc2MSA0Mi41Nzk0QzgzLjY3NjEgNDYuMTcwNCA4MS41NTc1IDQ3Ljk2NTggNzkuMTg3NSA0Ny45NjU4Qzc2Ljc4MTYgNDcuOTY1OCA3NC42OTg5IDQ2LjE3MDQgNzQuNjk4OSA0Mi41Nzk0Qzc0LjY5ODkgMzguOTg4NSA3Ni43ODE2IDM3LjE5MzEgNzkuMTg3NSAzNy4xOTMxQzgxLjU1NzUgMzcuMTkzMSA4My42NzYxIDM4Ljk4ODUgODMuNjc2MSA0Mi41Nzk0Wk03MC4yMTAzIDQyLjU3OTVDNzAuMjEwMyA0Ni4xNzA0IDY4LjA5MTYgNDcuOTY1OCA2NS43MjE2IDQ3Ljk2NThDNjMuMzE1NyA0Ny45NjU4IDYxLjIzMyA0Ni4xNzA0IDYxLjIzMyA0Mi41Nzk1QzYxLjIzMyAzOC45ODg1IDYzLjMxNTcgMzcuMTkzMSA2NS43MjE2IDM3LjE5MzFDNjguMDkxNiAzNy4xOTMxIDcwLjIxMDMgMzguOTg4NSA3MC4yMTAzIDQyLjU3OTVaIiBmaWxsPSIjRkZGREY4Ii8+Cjwvc3ZnPg==", this.supportedTransactionVersions = /* @__PURE__ */ new Set(["legacy", 0]), this._readyState = typeof window > "u" || typeof document > "u" ? WalletReadyState.Unsupported : WalletReadyState.NotDetected, this._disconnected = () => {
      const z = this._wallet;
      z && (z.off("disconnect", this._disconnected), z.off("accountChanged", this._accountChanged), this._wallet = null, this._publicKey = null, this.emit("error", new WalletDisconnectedError()), this.emit("disconnect"));
    }, this._accountChanged = (z) => {
      const ne = this._publicKey;
      if (ne) {
        try {
          z = new PublicKey(z.toBytes());
        } catch (ue) {
          this.emit("error", new WalletPublicKeyError(ue == null ? void 0 : ue.message, ue));
          return;
        }
        ne.equals(z) || (this._publicKey = z, this.emit("connect", z));
      }
    }, this._connecting = !1, this._wallet = null, this._publicKey = null, this._readyState !== WalletReadyState.Unsupported && (isIosAndRedirectable() ? (this._readyState = WalletReadyState.Loadable, this.emit("readyStateChange", this._readyState)) : scopePollingDetectionStrategy(() => {
      var z, ne, ue;
      return (ne = (z = window.phantom) == null ? void 0 : z.solana) != null && ne.isPhantom || (ue = window.solana) != null && ue.isPhantom ? (this._readyState = WalletReadyState.Installed, this.emit("readyStateChange", this._readyState), !0) : !1;
    }));
  }
  get publicKey() {
    return this._publicKey;
  }
  get connecting() {
    return this._connecting;
  }
  get readyState() {
    return this._readyState;
  }
  async autoConnect() {
    this.readyState === WalletReadyState.Installed && await this.connect();
  }
  async connect() {
    var y;
    try {
      if (this.connected || this.connecting)
        return;
      if (this.readyState === WalletReadyState.Loadable) {
        const ue = encodeURIComponent(window.location.href), le = encodeURIComponent(window.location.origin);
        window.location.href = `https://phantom.app/ul/browse/${ue}?ref=${le}`;
        return;
      }
      if (this.readyState !== WalletReadyState.Installed)
        throw new WalletNotReadyError();
      this._connecting = !0;
      const z = ((y = window.phantom) == null ? void 0 : y.solana) || window.solana;
      if (!z.isConnected)
        try {
          await z.connect();
        } catch (ue) {
          throw new WalletConnectionError(ue == null ? void 0 : ue.message, ue);
        }
      if (!z.publicKey)
        throw new WalletAccountError();
      let ne;
      try {
        ne = new PublicKey(z.publicKey.toBytes());
      } catch (ue) {
        throw new WalletPublicKeyError(ue == null ? void 0 : ue.message, ue);
      }
      z.on("disconnect", this._disconnected), z.on("accountChanged", this._accountChanged), this._wallet = z, this._publicKey = ne, this.emit("connect", ne);
    } catch (z) {
      throw this.emit("error", z), z;
    } finally {
      this._connecting = !1;
    }
  }
  async disconnect() {
    const y = this._wallet;
    if (y) {
      y.off("disconnect", this._disconnected), y.off("accountChanged", this._accountChanged), this._wallet = null, this._publicKey = null;
      try {
        await y.disconnect();
      } catch (z) {
        this.emit("error", new WalletDisconnectionError(z == null ? void 0 : z.message, z));
      }
    }
    this.emit("disconnect");
  }
  async sendTransaction(y, z, ne = {}) {
    try {
      const ue = this._wallet;
      if (!ue)
        throw new WalletNotConnectedError();
      try {
        const { signers: le, ...he } = ne;
        isVersionedTransaction(y) ? le != null && le.length && y.sign(le) : (y = await this.prepareTransaction(y, z, he), le != null && le.length && y.partialSign(...le)), he.preflightCommitment = he.preflightCommitment || z.commitment;
        const { signature: ge } = await ue.signAndSendTransaction(y, he);
        return ge;
      } catch (le) {
        throw le instanceof WalletError ? le : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
      }
    } catch (ue) {
      throw this.emit("error", ue), ue;
    }
  }
  async signTransaction(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signTransaction(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signAllTransactions(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signAllTransactions(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signMessage(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        const { signature: ne } = await z.signMessage(y);
        return ne;
      } catch (ne) {
        throw new WalletSignMessageError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
}
var __classPrivateFieldSet$1 = function(v, y, z, ne, ue) {
  if (ne === "m")
    throw new TypeError("Private method is not writable");
  if (ne === "a" && !ue)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof y == "function" ? v !== y || !ue : !y.has(v))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return ne === "a" ? ue.call(v, z) : ue ? ue.value = z : y.set(v, z), z;
}, __classPrivateFieldGet$1 = function(v, y, z, ne) {
  if (z === "a" && !ne)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof y == "function" ? v !== y || !ne : !y.has(v))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return z === "m" ? ne : z === "a" ? ne.call(v) : ne ? ne.value : y.get(v);
}, _RegisterWalletEvent_detail;
function registerWallet(v) {
  const y = ({ register: z }) => z(v);
  try {
    window.dispatchEvent(new RegisterWalletEvent(y));
  } catch (z) {
    console.error(`wallet-standard:register-wallet event could not be dispatched
`, z);
  }
  try {
    window.addEventListener("wallet-standard:app-ready", ({ detail: z }) => y(z));
  } catch (z) {
    console.error(`wallet-standard:app-ready event listener could not be added
`, z);
  }
}
class RegisterWalletEvent extends Event {
  constructor(y) {
    super("wallet-standard:register-wallet", {
      bubbles: !1,
      cancelable: !1,
      composed: !1
    }), _RegisterWalletEvent_detail.set(this, void 0), __classPrivateFieldSet$1(this, _RegisterWalletEvent_detail, y, "f");
  }
  get detail() {
    return __classPrivateFieldGet$1(this, _RegisterWalletEvent_detail, "f");
  }
  get type() {
    return "wallet-standard:register-wallet";
  }
  /** @deprecated */
  preventDefault() {
    throw new Error("preventDefault cannot be called");
  }
  /** @deprecated */
  stopImmediatePropagation() {
    throw new Error("stopImmediatePropagation cannot be called");
  }
  /** @deprecated */
  stopPropagation() {
    throw new Error("stopPropagation cannot be called");
  }
}
_RegisterWalletEvent_detail = /* @__PURE__ */ new WeakMap();
const SOLANA_MAINNET_CHAIN = "solana:mainnet", SOLANA_DEVNET_CHAIN = "solana:devnet", SOLANA_TESTNET_CHAIN = "solana:testnet", icon = "data:image/svg+xml;base64,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";
var __classPrivateFieldGet = function(v, y, z, ne) {
  if (z === "a" && !ne)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof y == "function" ? v !== y || !ne : !y.has(v))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return z === "m" ? ne : z === "a" ? ne.call(v) : ne ? ne.value : y.get(v);
}, __classPrivateFieldSet = function(v, y, z, ne, ue) {
  if (ne === "m")
    throw new TypeError("Private method is not writable");
  if (ne === "a" && !ue)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof y == "function" ? v !== y || !ue : !y.has(v))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return ne === "a" ? ue.call(v, z) : ue ? ue.value = z : y.set(v, z), z;
}, _SolflareMetaMaskWallet_instances, _SolflareMetaMaskWallet_listeners, _SolflareMetaMaskWallet_version, _SolflareMetaMaskWallet_name, _SolflareMetaMaskWallet_icon, _SolflareMetaMaskWallet_solflareMetaMask, _SolflareMetaMaskWallet_on, _SolflareMetaMaskWallet_emit, _SolflareMetaMaskWallet_off, _SolflareMetaMaskWallet_connect, _SolflareMetaMaskWallet_disconnect, _SolflareMetaMaskWallet_signAndSendTransaction, _SolflareMetaMaskWallet_signTransaction, _SolflareMetaMaskWallet_signMessage;
class SolflareMetaMaskWallet {
  constructor() {
    _SolflareMetaMaskWallet_instances.add(this), _SolflareMetaMaskWallet_listeners.set(this, {}), _SolflareMetaMaskWallet_version.set(this, "1.0.0"), _SolflareMetaMaskWallet_name.set(this, "MetaMask"), _SolflareMetaMaskWallet_icon.set(this, icon), _SolflareMetaMaskWallet_solflareMetaMask.set(this, null), _SolflareMetaMaskWallet_on.set(this, (y, z) => {
      var ne;
      return (ne = __classPrivateFieldGet(this, _SolflareMetaMaskWallet_listeners, "f")[y]) != null && ne.push(z) || (__classPrivateFieldGet(this, _SolflareMetaMaskWallet_listeners, "f")[y] = [z]), () => __classPrivateFieldGet(this, _SolflareMetaMaskWallet_instances, "m", _SolflareMetaMaskWallet_off).call(this, y, z);
    }), _SolflareMetaMaskWallet_connect.set(this, async () => {
      if (!__classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f")) {
        let y;
        try {
          y = (await import("./index-QHGxFxxD.js")).default;
        } catch {
          throw new Error("Unable to load Solflare MetaMask SDK");
        }
        __classPrivateFieldSet(this, _SolflareMetaMaskWallet_solflareMetaMask, new y(), "f"), __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").on("standard_change", (z) => __classPrivateFieldGet(this, _SolflareMetaMaskWallet_instances, "m", _SolflareMetaMaskWallet_emit).call(this, "change", z));
      }
      return this.accounts.length || await __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").connect(), { accounts: this.accounts };
    }), _SolflareMetaMaskWallet_disconnect.set(this, async () => {
      __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f") && await __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").disconnect();
    }), _SolflareMetaMaskWallet_signAndSendTransaction.set(this, async (...y) => {
      if (!__classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f"))
        throw new WalletNotConnectedError();
      return await __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignAndSendTransaction(...y);
    }), _SolflareMetaMaskWallet_signTransaction.set(this, async (...y) => {
      if (!__classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f"))
        throw new WalletNotConnectedError();
      return await __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignTransaction(...y);
    }), _SolflareMetaMaskWallet_signMessage.set(this, async (...y) => {
      if (!__classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f"))
        throw new WalletNotConnectedError();
      return await __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignMessage(...y);
    });
  }
  get version() {
    return __classPrivateFieldGet(this, _SolflareMetaMaskWallet_version, "f");
  }
  get name() {
    return __classPrivateFieldGet(this, _SolflareMetaMaskWallet_name, "f");
  }
  get icon() {
    return __classPrivateFieldGet(this, _SolflareMetaMaskWallet_icon, "f");
  }
  get chains() {
    return [SOLANA_MAINNET_CHAIN, SOLANA_DEVNET_CHAIN, SOLANA_TESTNET_CHAIN];
  }
  get features() {
    return {
      [StandardConnect]: {
        version: "1.0.0",
        connect: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_connect, "f")
      },
      [StandardDisconnect]: {
        version: "1.0.0",
        disconnect: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_disconnect, "f")
      },
      [StandardEvents]: {
        version: "1.0.0",
        on: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_on, "f")
      },
      [SolanaSignAndSendTransaction]: {
        version: "1.0.0",
        supportedTransactionVersions: ["legacy", 0],
        signAndSendTransaction: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_signAndSendTransaction, "f")
      },
      [SolanaSignTransaction]: {
        version: "1.0.0",
        supportedTransactionVersions: ["legacy", 0],
        signTransaction: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_signTransaction, "f")
      },
      [SolanaSignMessage]: {
        version: "1.0.0",
        signMessage: __classPrivateFieldGet(this, _SolflareMetaMaskWallet_signMessage, "f")
      }
    };
  }
  get accounts() {
    return __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f") ? __classPrivateFieldGet(this, _SolflareMetaMaskWallet_solflareMetaMask, "f").standardAccounts : [];
  }
}
_SolflareMetaMaskWallet_listeners = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_version = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_name = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_icon = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_solflareMetaMask = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_on = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_connect = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_disconnect = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_signAndSendTransaction = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_signTransaction = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_signMessage = /* @__PURE__ */ new WeakMap(), _SolflareMetaMaskWallet_instances = /* @__PURE__ */ new WeakSet(), _SolflareMetaMaskWallet_emit = function v(y, ...z) {
  var ne;
  (ne = __classPrivateFieldGet(this, _SolflareMetaMaskWallet_listeners, "f")[y]) == null || ne.forEach((ue) => ue.apply(null, z));
}, _SolflareMetaMaskWallet_off = function v(y, z) {
  var ne;
  __classPrivateFieldGet(this, _SolflareMetaMaskWallet_listeners, "f")[y] = (ne = __classPrivateFieldGet(this, _SolflareMetaMaskWallet_listeners, "f")[y]) == null ? void 0 : ne.filter((ue) => z !== ue);
};
let registered = !1;
function register() {
  registered || (registerWallet(new SolflareMetaMaskWallet()), registered = !0);
}
async function detectAndRegisterSolflareMetaMaskWallet() {
  const v = "solflare-detect-metamask";
  function y() {
    window.postMessage({
      target: "metamask-contentscript",
      data: {
        name: "metamask-provider",
        data: {
          id: v,
          jsonrpc: "2.0",
          method: "wallet_getSnaps"
        }
      }
    }, window.location.origin);
  }
  function z(ne) {
    var le, he;
    const ue = ne.data;
    (ue == null ? void 0 : ue.target) === "metamask-inpage" && ((le = ue.data) == null ? void 0 : le.name) === "metamask-provider" && (((he = ue.data.data) == null ? void 0 : he.id) === v ? (window.removeEventListener("message", z), ue.data.data.error || register()) : y());
  }
  window.addEventListener("message", z), window.setTimeout(() => window.removeEventListener("message", z), 5e3), y();
}
const SolflareWalletName = "Solflare";
class SolflareWalletAdapter extends BaseMessageSignerWalletAdapter {
  constructor(y = {}) {
    super(), this.name = SolflareWalletName, this.url = "https://solflare.com", this.icon = "data:image/svg+xml;base64,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", this.supportedTransactionVersions = /* @__PURE__ */ new Set(["legacy", 0]), this._readyState = typeof window > "u" || typeof document > "u" ? WalletReadyState.Unsupported : WalletReadyState.Loadable, this._disconnected = () => {
      const z = this._wallet;
      z && (z.off("disconnect", this._disconnected), this._wallet = null, this._publicKey = null, this.emit("error", new WalletDisconnectedError()), this.emit("disconnect"));
    }, this._accountChanged = (z) => {
      if (!z)
        return;
      const ne = this._publicKey;
      if (ne) {
        try {
          z = new PublicKey(z.toBytes());
        } catch (ue) {
          this.emit("error", new WalletPublicKeyError(ue == null ? void 0 : ue.message, ue));
          return;
        }
        ne.equals(z) || (this._publicKey = z, this.emit("connect", z));
      }
    }, this._connecting = !1, this._publicKey = null, this._wallet = null, this._config = y, this._readyState !== WalletReadyState.Unsupported && (scopePollingDetectionStrategy(() => {
      var z;
      return (z = window.solflare) != null && z.isSolflare || window.SolflareApp ? (this._readyState = WalletReadyState.Installed, this.emit("readyStateChange", this._readyState), !0) : !1;
    }), detectAndRegisterSolflareMetaMaskWallet());
  }
  get publicKey() {
    return this._publicKey;
  }
  get connecting() {
    return this._connecting;
  }
  get connected() {
    var y;
    return !!((y = this._wallet) != null && y.connected);
  }
  get readyState() {
    return this._readyState;
  }
  async autoConnect() {
    this.readyState === WalletReadyState.Loadable && isIosAndRedirectable() || await this.connect();
  }
  async connect() {
    try {
      if (this.connected || this.connecting)
        return;
      if (this._readyState !== WalletReadyState.Loadable && this._readyState !== WalletReadyState.Installed)
        throw new WalletNotReadyError();
      if (this.readyState === WalletReadyState.Loadable && isIosAndRedirectable()) {
        const ue = encodeURIComponent(window.location.href), le = encodeURIComponent(window.location.origin);
        window.location.href = `https://solflare.com/ul/v1/browse/${ue}?ref=${le}`;
        return;
      }
      let y;
      try {
        y = (await import("./index-CcYdTBBT.js")).default;
      } catch (ue) {
        throw new WalletLoadError(ue == null ? void 0 : ue.message, ue);
      }
      let z;
      try {
        z = new y({ network: this._config.network });
      } catch (ue) {
        throw new WalletConfigError(ue == null ? void 0 : ue.message, ue);
      }
      if (this._connecting = !0, !z.connected)
        try {
          await z.connect();
        } catch (ue) {
          throw new WalletConnectionError(ue == null ? void 0 : ue.message, ue);
        }
      if (!z.publicKey)
        throw new WalletConnectionError();
      let ne;
      try {
        ne = new PublicKey(z.publicKey.toBytes());
      } catch (ue) {
        throw new WalletPublicKeyError(ue == null ? void 0 : ue.message, ue);
      }
      z.on("disconnect", this._disconnected), z.on("accountChanged", this._accountChanged), this._wallet = z, this._publicKey = ne, this.emit("connect", ne);
    } catch (y) {
      throw this.emit("error", y), y;
    } finally {
      this._connecting = !1;
    }
  }
  async disconnect() {
    const y = this._wallet;
    if (y) {
      y.off("disconnect", this._disconnected), y.off("accountChanged", this._accountChanged), this._wallet = null, this._publicKey = null;
      try {
        await y.disconnect();
      } catch (z) {
        this.emit("error", new WalletDisconnectionError(z == null ? void 0 : z.message, z));
      }
    }
    this.emit("disconnect");
  }
  async sendTransaction(y, z, ne = {}) {
    try {
      const ue = this._wallet;
      if (!ue)
        throw new WalletNotConnectedError();
      try {
        const { signers: le, ...he } = ne;
        return isVersionedTransaction(y) ? le != null && le.length && y.sign(le) : (y = await this.prepareTransaction(y, z, he), le != null && le.length && y.partialSign(...le)), he.preflightCommitment = he.preflightCommitment || z.commitment, await ue.signAndSendTransaction(y, he);
      } catch (le) {
        throw le instanceof WalletError ? le : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
      }
    } catch (ue) {
      throw this.emit("error", ue), ue;
    }
  }
  async signTransaction(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signTransaction(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signAllTransactions(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signAllTransactions(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signMessage(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signMessage(y, "utf8");
      } catch (ne) {
        throw new WalletSignMessageError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
}
const TrustWalletName = "Trust";
class TrustWalletAdapter extends BaseMessageSignerWalletAdapter {
  constructor(y = {}) {
    super(), this.name = TrustWalletName, this.url = "https://trustwallet.com", this.icon = "data:image/svg+xml;base64,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", this.supportedTransactionVersions = null, this._readyState = typeof window > "u" || typeof document > "u" ? WalletReadyState.Unsupported : WalletReadyState.NotDetected, this._disconnected = () => {
      const z = this._wallet;
      z && (z.off("disconnect", this._disconnected), this._wallet = null, this._publicKey = null, this.emit("error", new WalletDisconnectedError()), this.emit("disconnect"));
    }, this._connecting = !1, this._wallet = null, this._publicKey = null, this._readyState !== WalletReadyState.Unsupported && scopePollingDetectionStrategy(() => {
      var z, ne;
      return (ne = (z = window.trustwallet) == null ? void 0 : z.solana) != null && ne.isTrust ? (this._readyState = WalletReadyState.Installed, this.emit("readyStateChange", this._readyState), !0) : !1;
    });
  }
  get publicKey() {
    return this._publicKey;
  }
  get connecting() {
    return this._connecting;
  }
  get connected() {
    var y;
    return !!((y = this._wallet) != null && y.isConnected);
  }
  get readyState() {
    return this._readyState;
  }
  async connect() {
    try {
      if (this.connected || this.connecting)
        return;
      if (this._readyState !== WalletReadyState.Installed)
        throw new WalletNotReadyError();
      this._connecting = !0;
      const y = window.trustwallet.solana;
      if (!y.isConnected)
        try {
          await y.connect();
        } catch (ne) {
          throw new WalletConnectionError(ne == null ? void 0 : ne.message, ne);
        }
      if (!y.publicKey)
        throw new WalletAccountError();
      let z;
      try {
        z = new PublicKey(y.publicKey.toBytes());
      } catch (ne) {
        throw new WalletPublicKeyError(ne == null ? void 0 : ne.message, ne);
      }
      y.on("disconnect", this._disconnected), this._wallet = y, this._publicKey = z, this.emit("connect", z);
    } catch (y) {
      throw this.emit("error", y), y;
    } finally {
      this._connecting = !1;
    }
  }
  async disconnect() {
    const y = this._wallet;
    if (y) {
      y.off("disconnect", this._disconnected), this._wallet = null, this._publicKey = null;
      try {
        await y.disconnect();
      } catch (z) {
        this.emit("error", new WalletDisconnectionError(z == null ? void 0 : z.message, z));
      }
    }
    this.emit("disconnect");
  }
  async sendTransaction(y, z, ne = {}) {
    try {
      const ue = this._wallet;
      if (!ue)
        throw new WalletNotConnectedError();
      try {
        const { signers: le, ...he } = ne;
        y = await this.prepareTransaction(y, z, he), le != null && le.length && y.partialSign(...le), he.preflightCommitment = he.preflightCommitment || z.commitment;
        const { signature: ge } = await ue.signAndSendTransaction(y, he);
        return ge;
      } catch (le) {
        throw le instanceof WalletError ? le : new WalletSendTransactionError(le == null ? void 0 : le.message, le);
      }
    } catch (ue) {
      throw this.emit("error", ue), ue;
    }
  }
  async signTransaction(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signTransaction(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signAllTransactions(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        return await z.signAllTransactions(y) || y;
      } catch (ne) {
        throw new WalletSignTransactionError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
  async signMessage(y) {
    try {
      const z = this._wallet;
      if (!z)
        throw new WalletNotConnectedError();
      try {
        const { signature: ne } = await z.signMessage(y);
        return ne;
      } catch (ne) {
        throw new WalletSignMessageError(ne == null ? void 0 : ne.message, ne);
      }
    } catch (z) {
      throw this.emit("error", z), z;
    }
  }
}
const supportedEVMChains = Object.values(allChains);
supportedEVMChains.reduce((v, y) => ({ ...v, [y.id]: !0 }), {});
const wrapHSL = (v) => {
  const [y, z, ne] = v.split(" ");
  return `hsl(${y}deg, ${z}, ${ne})`;
}, mapElementsThemeToRainbowKitTheme = () => {
  if (!globalThis.document)
    return darkTheme();
  const v = globalThis.document.querySelector(".leap-ui");
  if (!v)
    return darkTheme();
  const y = getComputedStyle(v), z = {
    primary: wrapHSL(y.getPropertyValue("--primary")),
    primaryForeground: wrapHSL(y.getPropertyValue("--primary-foreground")),
    secondary: wrapHSL(y.getPropertyValue("--secondary")),
    secondaryForeground: wrapHSL(
      y.getPropertyValue("--secondary-foreground")
    ),
    destructive: wrapHSL(y.getPropertyValue("--destructive")),
    destructiveForeground: wrapHSL(
      y.getPropertyValue("--destructive-foreground")
    ),
    warning: wrapHSL(y.getPropertyValue("--warning")),
    warningForeground: wrapHSL(y.getPropertyValue("--warning-foreground")),
    success: wrapHSL(y.getPropertyValue("--success")),
    successForeground: wrapHSL(y.getPropertyValue("--success-foreground")),
    background: wrapHSL(y.getPropertyValue("--background")),
    foreground: wrapHSL(y.getPropertyValue("--foreground")),
    radius: y.getPropertyValue("--radius"),
    border: wrapHSL(y.getPropertyValue("--border")),
    accent: wrapHSL(y.getPropertyValue("--accent")),
    accentForeground: wrapHSL(y.getPropertyValue("--accent-foreground")),
    muted: wrapHSL(y.getPropertyValue("--muted")),
    mutedForeground: wrapHSL(y.getPropertyValue("--muted-foreground")),
    font: y.getPropertyValue("--font-family"),
    blurOverlay: y.getPropertyValue("--blur-overlay")
  };
  return {
    colors: {
      accentColor: z.primary,
      accentColorForeground: z.primaryForeground,
      actionButtonBorder: z.border,
      actionButtonBorderMobile: z.border,
      actionButtonSecondaryBackground: z.secondary,
      closeButton: z.secondaryForeground,
      closeButtonBackground: z.secondary,
      connectButtonBackground: z.primary,
      connectButtonBackgroundError: z.destructive,
      connectButtonInnerBackground: z.secondary,
      connectButtonText: z.primaryForeground,
      connectButtonTextError: z.destructive,
      connectionIndicator: z.success,
      downloadBottomCardBackground: z.secondary,
      downloadTopCardBackground: z.secondary,
      error: z.destructive,
      generalBorder: z.border,
      generalBorderDim: z.border,
      menuItemBackground: z.secondary,
      modalBackdrop: "#00000064",
      modalBackground: z.background,
      modalBorder: z.border,
      modalText: z.foreground,
      modalTextDim: z.secondaryForeground,
      modalTextSecondary: z.mutedForeground,
      profileAction: z.secondary,
      profileActionHover: z.secondary,
      profileForeground: z.primary,
      selectedOptionBorder: z.border,
      standby: z.success
    },
    shadows: {
      connectButton: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      dialog: "0px 8px 32px rgba(0, 0, 0, 0.32)",
      profileDetailsAction: "0px 2px 6px rgba(37, 41, 46, 0.04)",
      selectedOption: "0px 2px 6px rgba(0, 0, 0, 0.24)",
      selectedWallet: "0px 2px 6px rgba(0, 0, 0, 0.12)",
      walletLogo: "0px 2px 16px rgba(0, 0, 0, 0.16)"
    },
    blurs: {
      modalOverlay: z.blurOverlay
    },
    fonts: {
      body: z.font
    },
    radii: {
      actionButton: `calc(${z.radius} + 2px)`,
      connectButton: `calc(${z.radius} + 2px)`,
      modal: `calc(${z.radius} + 2px)`,
      modalMobile: `calc(${z.radius} + 2px)`,
      menuButton: `calc(${z.radius} + 2px)`
    }
  };
}, { chains, publicClient } = configureChains(supportedEVMChains, [
  publicProvider()
]), getConnectors = (v) => connectorsForWallets([
  {
    groupName: "Recommended",
    wallets: [
      metaMaskWallet(v),
      rainbowWallet(v),
      coinbaseWallet(v),
      phantomWallet(v),
      walletConnectWallet(v)
    ]
  }
]), connectors = getConnectors({
  // app name
  appName: "Leap Elements",
  // wallet connect project ID
  projectId: "92bce9bb83eeb7b5cd775bf179cc46fb",
  chains
}), wagmiConfig = createConfig({
  autoConnect: !0,
  connectors,
  publicClient
}), EVMWalletProvider = ({
  children: v
}) => {
  const [y, z] = useState(
    mapElementsThemeToRainbowKitTheme()
  );
  return useEffect(() => {
    if (!MutationObserver)
      return;
    const ne = new MutationObserver(function(le) {
      le.forEach(function(he) {
        he.attributeName === "class" && z(mapElementsThemeToRainbowKitTheme());
      });
    }), ue = document.querySelector(".leap-ui");
    ue && ne.observe(ue, {
      attributes: !0,
      attributeFilter: ["class"]
    });
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(WagmiConfig, { config: wagmiConfig, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    RainbowKitProvider,
    {
      chains,
      modalSize: "compact",
      theme: y,
      id: "rainbowkit",
      children: v
    }
  ) });
}, SVMWalletProvider = ({
  children: v
}) => {
  const y = WalletAdapterNetwork.Mainnet, z = useMemo(() => clusterApiUrl(y), [y]), ne = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      // new LedgerWalletAdapter(),
      new CoinbaseWalletAdapter(),
      new TrustWalletAdapter()
    ],
    []
  ), ue = useCallback((le) => {
    console.error(le);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ConnectionProvider, { endpoint: z, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    WalletProvider,
    {
      wallets: ne,
      onError: ue,
      autoConnect: !0,
      localStorageKey: "elements-solana-wallet",
      children: v
    }
  ) });
}, SwapTrackingView = () => {
  const {
    routeResponse: v,
    messages: y,
    gasFeesData: z,
    isLoadingGasFee: ne,
    isLoadingMessages: ue,
    isLoadingRoute: le,
    isValidatingRoute: he,
    isValidatingGasFee: ge,
    refresh: we,
    ongoingTransactions: Ee,
    currentSwapId: xe,
    setOngoingTransactions: $e,
    sourceChainData: Ne,
    destinationChainData: st,
    sourceAssetData: Nr,
    txnLifecycleHooks: br,
    destinationAssetData: $n,
    setCurrentSwapId: En
  } = useSwapsContext(), { goBack: Rn } = useSwapsFlowContext();
  if (ne || ue || le || he || ge)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewLoadingSkeleton, { refresh: we, goBack: Rn });
  if (!v || !y || !z)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NoDataView$1, { goBack: Rn });
  const wa = ({
    activeTxnIndex: Aa,
    txnStatuses: _a,
    lastError: Ta
  }) => {
    if (!Nr || !Ne || !$n || !st || !y)
      return;
    const Zn = xe || v4();
    $e({
      ...Ee,
      [Zn]: {
        id: Zn,
        timestamp: xe ? Ee[xe].timestamp : (/* @__PURE__ */ new Date()).getTime(),
        activeTxnIndex: Aa,
        sourceChainData: Ne,
        destinationChainData: st,
        sourceAssetData: Nr,
        destinationAssetData: $n,
        messages: y,
        routeResponse: v,
        gasFeesData: z,
        txnStatuses: _a,
        lastError: Ta,
        isComplete: xe ? Ee[xe].isComplete : !1
      }
    }), En(Zn);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    SwapsTrackingProvider,
    {
      tab: Tabs.AGGREGATED,
      gasFees: z.gasFeesAmount,
      messages: y,
      routeResponse: v,
      txnLifecycleHooks: br,
      updateOngoingTransactions: wa,
      ongoingSwap: xe ? Ee[xe] : void 0,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedViewHeader, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 overflow-y-auto no-scrollbar h-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedSwapAssetsOverview, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedViewWrapperForTracking, {})
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 my-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedViewCTAButton, {}) })
      ]
    }
  );
}, popularChains$2 = ["1", "137", "cosmoshub-4", "osmosis-1", "injective-1"], SwapsSourceSelect = ({ chains: v, assets: y }) => {
  const {
    sourceChainId: z,
    sourceAsset: ne,
    setSourceChainId: ue,
    setSourceAsset: le,
    inputAmount: he,
    setInputAmount: ge,
    inputAmountRemark: we,
    sourceTokenBalance: Ee,
    sourceAddress: xe,
    sourceChainData: $e
  } = useSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SourceSelect$1,
    {
      chains: v,
      assets: y,
      inputValue: he,
      setInputValue: ge,
      inputAmountRemark: we,
      selectedChainId: z,
      setSelectedChainId: ue,
      selectedAsset: ne,
      setSelectedAsset: le,
      tokenBalance: Ee,
      popularChainIds: popularChains$2,
      sourceChainData: $e,
      selectedChainError: !!(xe != null && xe.error),
      fetchChainBalances: useChainBalances
    }
  );
}, SwapsDestinationSelect = ({ chains: v, assets: y }) => {
  const {
    destinationChainId: z,
    destinationAsset: ne,
    setDestinationChainId: ue,
    setDestinationAsset: le,
    destinationTokenBalance: he,
    routeError: ge,
    isLoadingRoute: we,
    isValidatingRoute: Ee,
    amountOut: xe,
    destinationAddress: $e
  } = useSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DestinationSelect,
    {
      chains: v,
      assets: y,
      selectedChainId: z,
      setSelectedChainId: ue,
      selectedAsset: ne,
      setSelectedAsset: le,
      tokenBalance: he,
      amountOut: xe,
      isLoadingRoute: we,
      isValidatingRoute: Ee,
      routeError: ge,
      popularChainIds: popularChains$2,
      selectedChainError: !!$e.error,
      fetchChainBalances: useChainBalances
    }
  );
}, InterchangeButton = () => {
  const [v, y] = useState(!1), { interchange: z, isInterchangeEnabled: ne } = useSwapsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative h-2 bg-transparent", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "secondary",
      size: "sm-icon",
      className: "absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-3xl shadow-[0_0_0_0.4rem_hsl(var(--background))] disabled:cursor-not-allowed disabled:opacity-100",
      disabled: !ne,
      onClick: () => {
        z(), y(!0), setTimeout(() => {
          y(!1);
        }, 500);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        D$4,
        {
          weight: "bold",
          size: "1rem",
          className: v ? "animate-[spin_600ms_linear_0.5]" : ""
        }
      )
    }
  ) });
}, SwapsInputView = ({ title: v, chains: y, assets: z }) => {
  const ne = useRef(null);
  return useOverflowFade(ne), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedHeader, { title: v }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "overflow-y-auto no-scrollbar px-4 h-full", ref: ne, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsSourceSelect, { chains: y, assets: z }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(InterchangeButton, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsDestinationSelect, { chains: y, assets: z })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedSwapInfo, { className: "mt-3" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedViewWarningsSection, {})
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 my-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedCTASection, {}) })
  ] });
}, SwapsView = ({ classNames: v, showPoweredByBanner: y, title: z }) => {
  const { step: ne, previousStep: ue } = useSwapsFlowContext(), le = useChains(), he = useSkipSupportedChains({
    chainTypes: ["cosmos", "evm", "svm"]
  }), ge = useAllSkipAssets(), we = useMemo(() => le.isLoading ? {
    isLoading: !0,
    data: void 0,
    error: void 0
  } : he, [le.isLoading, he]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: Y$1(
        "bg-background h-[34rem] w-[26rem] rounded-2xl",
        v
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AnimatePresence, { mode: "popLayout", children: [
        ne === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 1 ? -8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: -8 },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              SwapsInputView,
              {
                title: z,
                chains: we,
                assets: ge
              }
            )
          },
          0
        ) : null,
        ne === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 0 ? 8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: 8 },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapTrackingView, {})
          },
          1
        ) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            animate: {
              opacity: ne === 2 ? 1 : 0,
              x: ne === 2 ? 0 : 8,
              display: ne === 2 ? "grid" : "none"
            },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(AggregatedSwapHistoryView, {})
          },
          2
        ),
        y ? /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByLeapAndSkip, {}, "powered-by-banner") : null
      ] })
    }
  );
}, Swaps = ({
  className: v,
  title: y,
  showPoweredByBanner: z,
  defaultValues: ne,
  defaultSettings: ue,
  allowedSourceChains: le,
  allowedDestinationChains: he,
  onValuesChange: ge,
  onSettingsChange: we,
  txnLifecycleHooks: Ee
}) => {
  const xe = useMemo(() => {
    const Ne = getDefaultChainIdFallback(
      le,
      "cosmoshub-4"
    ), st = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.sourceChainId,
      Ne,
      Array.isArray(le) ? le.map((wa) => wa.chainId) : void 0
    ), Nr = st && (ne == null ? void 0 : ne.sourceAsset) !== SELECT_NONE ? getDefaultAsset(
      st,
      ne == null ? void 0 : ne.sourceAsset,
      le
    ) : SELECT_NONE, br = Array.isArray(
      he
    ), $n = getDefaultChainIdFallback(
      he,
      "osmosis-1"
    ), En = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.destinationChainId,
      $n,
      br ? he == null ? void 0 : he.map((wa) => wa.chainId) : void 0
    ), Rn = En && (ne == null ? void 0 : ne.destinationAsset) !== SELECT_NONE ? getDefaultAsset(
      En,
      ne == null ? void 0 : ne.destinationAsset,
      he
    ) : SELECT_NONE;
    return {
      sourceChainId: st,
      sourceAsset: Nr,
      destinationChainId: En,
      destinationAsset: Rn,
      inputAmount: (ne == null ? void 0 : ne.inputAmount) ?? ""
    };
  }, [he, le, ne]), $e = useMemo(() => ({
    slippage: (ue == null ? void 0 : ue.slippage) ?? "1",
    provider: (ue == null ? void 0 : ue.provider) ?? SWAP_PROVIDER.SKIP
  }), [ue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { title: y ?? "Swaps", className: v, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsFlowProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SourceRestrictionsProvider, { chains: le, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DestinationRestrictionsProvider, { chains: he, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SVMWalletProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(EVMWalletProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    SwapsProvider,
    {
      defaultValues: xe,
      defaultSettings: $e,
      onValuesChange: ge,
      onSettingsChange: we,
      txnLifecycleHooks: Ee,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(xw, { delayDuration: 250, skipDelayDuration: 750, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        SwapsView,
        {
          classNames: v,
          title: y,
          showPoweredByBanner: z
        }
      ) })
    }
  ) }) }) }) }) }) });
}, SwapsModal = ({
  isOpen: v,
  setIsOpen: y,
  ...z
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalView, { isOpen: v, setIsOpen: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Swaps, { ...z }) });
function getDefaultChainIdFallback(v, y) {
  let z = y;
  return v && (Array.isArray(v) ? z = v[0].chainId : v.chainTypes.includes("cosmos") ? z = "cosmoshub-4" : v.chainTypes.includes("evm") ? z = "1" : v.chainTypes.includes("svm") && (z = "solana")), z;
}
function getDefaultAsset(v, y, z) {
  var le;
  if (z === void 0)
    return y;
  const ne = Array.isArray(z), ue = ne ? (le = z.find((he) => he.chainId === v)) == null ? void 0 : le.assetDenoms : void 0;
  return ue === void 0 ? y : ue.length === 0 ? SELECT_NONE : typeof y == "string" ? ne ? typeof (ue == null ? void 0 : ue[0]) == "string" ? getDefaultValue(y, ue) : ue[0] : y : ne ? typeof (ue == null ? void 0 : ue[0]) == "object" ? getDefaultValueByOriginObject(
    y,
    ue
  ) : ue[0] : y;
}
const IBCTransferContext = createContext(void 0), IBCTransferProvider = ({ children: v, defaultValues: y, onValuesChange: z, txnLifecycleHooks: ne }) => {
  var Gc;
  const { isMainnet: ue, walletClient: le } = useWalletClientContext(), [he, ge] = useState(
    y == null ? void 0 : y.sourceChainId
  ), [we, Ee] = useState(
    typeof (y == null ? void 0 : y.sourceAsset) == "string" ? y == null ? void 0 : y.sourceAsset : void 0
  ), [xe, $e] = useState(), [Ne, st] = useState(""), [Nr, br] = useState(), [$n, En] = useState(!1), [Rn, wa] = useState(
    (y == null ? void 0 : y.inputAmount) ?? ""
  ), [Aa, _a] = useState(""), Ta = useMemo(
    () => getInputAmountRemark(Rn),
    [Rn]
  ), Zn = useSkipSupportedChains(), Ra = useAllSkipAssets(), Yn = useCallback(
    (Kc) => {
      var d1, K1;
      ge(Kc);
      const M2 = (K1 = (d1 = Zn.data) == null ? void 0 : d1.find(
        (k2) => k2.chainId === Kc
      )) == null ? void 0 : K1.baseDenom;
      Ee(M2 || void 0);
    },
    [Zn.data]
  ), $o = useMemo(() => {
    var M2;
    return he ? (M2 = Zn.data) == null ? void 0 : M2.find(
      (d1) => d1.chainId === he
    ) : void 0;
  }, [Zn.data, he]), ct = useMemo(() => {
    if (!Ra.data || !he || !we)
      return;
    const Kc = Ra.data[he];
    return Kc == null ? void 0 : Kc.find((M2) => M2.denom === we);
  }, [Ra.data, we, he]), fe = useMemo(() => {
    var d1;
    const Kc = y == null ? void 0 : y.sourceAsset;
    if (Kc === void 0 || typeof Kc == "string")
      return Kc;
    if (!Ra.data || !he)
      return;
    const M2 = (d1 = Ra.data) == null ? void 0 : d1[he].find(
      (K1) => K1.originDenom === Kc.originDenom && K1.originChainId === Kc.originChainId
    );
    return M2 == null ? void 0 : M2.denom;
  }, [he, Ra.data, y == null ? void 0 : y.sourceAsset]), be = useRef(
    (y == null ? void 0 : y.sourceAsset) === SELECT_NONE
  );
  useEffect(() => {
    fe && !be.current && (Ee(fe), be.current = !0);
  }, [fe]);
  const ye = useCosmosTokenBalance({
    chainId: he,
    denom: ct == null ? void 0 : ct.denom
  }), { step: Se } = useSwapsFlowContext(), Oe = useDebouncedValue(Rn, 500), { data: Fr } = useSkipDestinationChains(
    ct,
    $o,
    ue
  ), zn = useMemo(() => {
    if (xe && Fr)
      return Fr.find(
        (Kc) => Kc.chainId === xe
      );
  }, [xe, Fr]), Fe = useMemo(() => !xe || !zn ? void 0 : zn.asset, [zn, xe]), pe = useMemo(() => !$o || !Ne || !zn ? !1 : $o.chainId !== zn.chainId, [$o, zn, Ne]), it = useMemo(() => !!Oe && !Ta && Number(Oe) !== 0 && !!ct && !!$o && !!zn && !!Fe, [
    Oe,
    zn,
    Ta,
    ct,
    $o,
    Fe
  ]), {
    routeResponse: xa,
    amountOut: wo,
    isLoadingRoute: _u,
    isValidatingRoute: Oa,
    routeError: Os,
    refresh: Pa,
    routeKey: Ml
  } = useRoute(
    Oe,
    ct,
    $o,
    Fe,
    zn,
    it,
    void 0,
    void 0,
    !1,
    {
      revalidateOnFocus: Se === 0,
      revalidateIfStale: Se === 0,
      revalidateOnReconnect: Se === 0
    },
    !pe
  );
  useEffect(() => {
    En(!1);
  }, [Ml]), useEffect(() => {
    if (it && Se === 0 && !_u && !Oa) {
      const Kc = setInterval(() => {
        Pa();
      }, 3e4);
      return () => clearInterval(Kc);
    }
  }, [_u, it, Oa, Pa, Se]), useEffect(() => {
    we === void 0 && ($o == null ? void 0 : $o.baseDenom) !== void 0 && Ee($o.baseDenom);
  }, [$o == null ? void 0 : $o.baseDenom]);
  const Su = useMemo(() => $o && $o.chainType === "cosmos" ? $o : void 0, [$o]), Tu = useSourceAddress(Su), { userAddressList: Au, error: Zl } = useAddressList({
    chainIds: xa == null ? void 0 : xa.response.chain_ids,
    destinationChainId: xe,
    destinationAddress: Ne,
    userAddress: Tu.address,
    walletClient: le,
    chains: Fr
  }), Iu = !!Zl, Uc = useMemo(() => ({
    slippageTolerancePercent: 1 .toFixed(2)
  }), []);
  useEffect(() => {
    var Kc;
    if (Ne.trim().length === 0) {
      br(void 0);
      return;
    }
    if (Ne.includes("."))
      br(void 0);
    else {
      const M2 = Ne.trim();
      if (!M2) {
        br(void 0);
        return;
      }
      try {
        const { prefix: d1 } = bech32$6.decode(M2), K1 = (Kc = Zn == null ? void 0 : Zn.data) == null ? void 0 : Kc.find(
          (k2) => k2.bech32Prefix === d1
        );
        K1 ? $e(K1.chainId) : br("IBC transfers are not supported for this chain");
      } catch {
        br("Invalid address");
      }
    }
  }, [Ne, Zn == null ? void 0 : Zn.data]);
  const { data: Pu, isLoading: Lu } = useMessagesSWR(
    Au,
    xa == null ? void 0 : xa.response,
    Uc,
    !Iu,
    {
      revalidateOnFocus: Se === 0,
      revalidateIfStale: Se === 0,
      revalidateOnReconnect: Se === 0
    }
  ), th = useMemo(
    () => {
      var Kc;
      return (Kc = ye == null ? void 0 : ye.data) == null ? void 0 : Kc.amount.isLessThan(Rn);
    },
    [Rn, (Gc = ye == null ? void 0 : ye.data) == null ? void 0 : Gc.amount]
  ), Zc = useMemo(() => !th && it && !!xa && !_u && !Oa && !Os && !!Pu && ($o == null ? void 0 : $o.chainType) === "cosmos", [
    th,
    _u,
    it,
    Oa,
    Pu,
    Os,
    xa,
    $o == null ? void 0 : $o.chainType
  ]), {
    data: N1,
    isLoading: Gh,
    isValidating: Mc
  } = useSkipGasFeeSWR(
    Pu,
    Au,
    ue,
    {
      revalidateOnFocus: Se === 0,
      revalidateIfStale: Se === 0,
      revalidateOnReconnect: Se === 0
    },
    Zc
  );
  useEffect(() => {
    z == null || z({
      sourceChainId: he,
      sourceAsset: we,
      destinationChainId: xe,
      inputAmount: Rn
    });
  }, [
    xe,
    Rn,
    z,
    we,
    he
  ]);
  const h1 = useCallback(
    (Kc = !0) => {
      Kc && (ge(y == null ? void 0 : y.sourceChainId), Ee(fe)), wa((y == null ? void 0 : y.inputAmount) ?? "");
    },
    [y, fe]
  ), l2 = useMemo(
    () => ({
      sourceChainId: he,
      setSourceChainId: Yn,
      sourceAsset: we,
      setSourceAsset: Ee,
      destinationChainId: xe,
      setDestinationChainId: $e,
      // slippage,
      // setSlippage,
      // slippageRemark,
      inputAmount: Rn,
      setInputAmount: wa,
      inputAmountRemark: Ta,
      sourceTokenBalance: ye,
      routeResponse: xa,
      amountOut: wo,
      isLoadingRoute: _u,
      routeError: Os,
      isValidatingRoute: Oa,
      refresh: Pa,
      isRouteQueryEnabled: it,
      messages: Pu,
      isLoadingMessages: Lu,
      isUserAddressesError: Iu,
      gasFeesData: N1,
      isLoadingGasFee: Gh,
      isValidatingGasFee: Mc,
      isConversionRateChecked: $n,
      setIsConversionRateChecked: En,
      sourceAssetData: ct,
      sourceAddress: Tu,
      destinationAddress: Ne,
      txnLifecycleHooks: ne,
      resetInputsToDefaults: h1,
      sourceChainData: $o,
      destinationChainData: zn,
      routeKey: Ml,
      setDestinationAddress: st,
      addressError: Nr,
      memo: Aa,
      setMemo: _a,
      isIBCTransfer: pe
    }),
    [
      he,
      Yn,
      we,
      xe,
      // slippage,
      // slippageRemark,
      Rn,
      Ta,
      ye,
      xa,
      wo,
      _u,
      Os,
      Oa,
      Pa,
      it,
      Pu,
      Lu,
      Iu,
      N1,
      Gh,
      Mc,
      $n,
      ct,
      Tu,
      Ne,
      ne,
      h1,
      $o,
      zn,
      Ml,
      st,
      Nr,
      Aa,
      _a,
      pe
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferContext.Provider, { value: l2, children: v });
}, useIBCTransferContext = () => {
  const v = useContext(IBCTransferContext);
  return invariant$1(
    v,
    `Please use ${useIBCTransferContext.name} within IBCTransferProvider`
  ), v;
}, DestinationInput = ({
  classNames: v,
  setDestinationAddress: y,
  destinationAddress: z,
  addressError: ne
}) => {
  const [ue, le] = useState(z), he = useRef(null), [ge, we] = useState(!1);
  useEffect(() => {
    const $e = (Ne) => {
      var st;
      (st = he.current) != null && st.contains(Ne.target) || we(!0);
    };
    return document.addEventListener("mousedown", $e), () => {
      document.removeEventListener("mousedown", $e);
    };
  }, []);
  const Ee = useMemo(() => {
    if (z)
      return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-card-foreground text-xl py-1 font-medium", children: sliceAddress(z) });
  }, [z]), xe = useCallback(() => {
    navigator.clipboard.readText().then(($e) => {
      le($e);
    });
  }, [le]);
  return useEffect(() => {
    y(ue);
  }, [ue, y]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("bg-card rounded-xl", v), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "border-b px-4 py-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-muted-foreground text-sm", children: "To" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 py-4", ref: he, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between gap-2", children: [
      !ne && Ee !== void 0 && ge ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: () => we(!1), children: Ee }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        Cb,
        {
          type: "string",
          variant: "unstyled",
          className: Y$1("text-card-foreground text-xl font-medium"),
          placeholder: "Enter address",
          value: ue,
          onChange: ($e) => le($e.target.value)
        }
      ),
      ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "rounded-3xl bg-muted-foreground h-5 w-5 flex justify-center items-center cursor-pointer",
          onClick: () => le(""),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$2, { weight: "bold", className: "text-muted", size: 14 })
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          onClick: xe,
          size: "xs",
          className: "rounded-3xl bg-primary/20 text-primary hover:bg-primary/30 py-1",
          children: "Paste"
        }
      )
    ] }) })
  ] });
}, TransactionFee = ({ gasFeesData: v, gasLoading: y }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center gap-3 !bg-card !text-card-foreground rounded-xl px-4 py-3 mt-2", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground", children: "Transaction Fee" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-center gap-1", children: y ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    USDFeeDisplay,
    {
      gasFeesData: v,
      showOnlyGasFee: !0,
      withTooltip: !1,
      showUnitFees: !0
    }
  ) })
] }), Memo = ({ memo: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center gap-3 !bg-card !text-card-foreground rounded-xl px-4 py-3 mt-2", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground", children: "Memo" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: v })
] }), TransferInfo = ({ className: v }) => {
  const { setMemo: y } = useIBCTransferContext(), [z, ne] = useState("");
  return useEffect(() => {
    y(z);
  }, [z, y]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    G$,
    {
      type: "single",
      collapsible: !0,
      className: Y$1(
        "!bg-card !text-card-foreground w-full rounded-xl",
        v
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(kf, { value: "item", className: "border-b-0", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Lf, { className: "rounded-xl px-4 py-3 hover:no-underline", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-sm", children: "Memo" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Ff, { className: "px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Cb,
          {
            type: "string",
            variant: "unstyled",
            className: Y$1(
              "text-card-foreground text-sm bg-secondary rounded-xl px-2",
              z ? {
                "text-md": z.length > 10
              } : ""
            ),
            placeholder: "Required for sending to centralized exchanges..",
            value: z,
            onChange: (ue) => ne(ue.target.value)
          }
        ) })
      ] })
    }
  );
}, TransferCTASection = () => {
  var Oe;
  const v = useWalletClientContext(), {
    inputAmount: y,
    inputAmountRemark: z,
    //slippageRemark,
    sourceTokenBalance: ne,
    isLoadingRoute: ue,
    isValidatingRoute: le,
    isLoadingMessages: he,
    isLoadingGasFee: ge,
    isValidatingGasFee: we,
    routeResponse: Ee,
    routeError: xe,
    messages: $e,
    isRouteQueryEnabled: Ne,
    amountOut: st,
    isConversionRateChecked: Nr,
    sourceAddress: br,
    destinationAddress: $n,
    isUserAddressesError: En,
    addressError: Rn,
    destinationChainData: wa
  } = useIBCTransferContext(), [Aa, _a] = useState(!1), { setStep: Ta } = useSwapsFlowContext(), Zn = Ee && !ue && !xe, Ra = (Oe = ne == null ? void 0 : ne.data) == null ? void 0 : Oe.amount.isLessThan(y), Yn = getConversionRateRemark(Ee), $o = useIsLedgerSupportError(Ee), ct = () => {
    const Fr = parseFloat(y), zn = parseFloat(st), Fe = !isNaN(Fr) && Fr > 0, pe = !isNaN(zn) && zn > 0;
    return Fe && pe && Ne && !!Ee && Zn && !xe && !ue && !le && !Ra && !z && !ge && !we && // !!gasFeesData &&
    // !gasFeesData.gasFeesError &&
    !he && !!$e && (Yn === "request-confirmation" ? Nr : !0) && !En && !$o;
  }, fe = useMemo(() => br.address === $n, [br, $n]), be = useMemo(() => $n ? $n && wa : !0, [wa, $n]), ye = Ra || !be, Se = br.error || Rn || fe;
  return Se ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: (() => {
        var Fr;
        return (((Fr = br.error) == null ? void 0 : Fr.code) === 3 || Rn) && Aa ? "action-primary" : "action-destructive";
      })(),
      className: "w-full transition-colors",
      onMouseEnter: () => {
        setTimeout(() => {
          _a(!0);
        }, 100);
      },
      onMouseLeave: () => {
        setTimeout(() => {
          _a(!1);
        }, 100);
      },
      onClick: () => {
        var Fr;
        if (((Fr = br.error) == null ? void 0 : Fr.code) === 3)
          return br.refetch();
      },
      children: (() => {
        if (br.error)
          return br.error.code === 3 && Aa ? "Click to Retry" : br.error.message;
        if (Rn)
          return Rn;
        if (fe)
          return "Invalid address";
      })()
    }
  ) : ye ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      className: "w-full",
      disabled: !Se,
      children: (() => {
        if (Ra)
          return `Insufficient ${ne.data.denomData.coinDenom} balance`;
        if (!be)
          return "Select different chain or address";
      })()
    }
  ) : v.userAddress ? ue || le || he || ge || we ? /* @__PURE__ */ jsxRuntimeExports.jsx(np, { variant: "action-primary", className: "w-full", disabled: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$4, { className: "animate-spin", size: "1.25rem" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      disabled: !ct(),
      onClick: () => {
        Ta(1);
      },
      children: "Review Send"
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      onClick: () => {
        v.connectWallet("cosmoshub-4");
      },
      children: "Connect Wallet"
    }
  );
}, IBCTransferTrackingContext = createContext(void 0), IBCTransferTrackingProvider = ({
  children: v,
  gasFees: y,
  routeResponse: z,
  messages: ne,
  txnLifecycleHooks: ue,
  tab: le,
  memo: he
}) => {
  const { data: ge } = useChains(), { data: we } = useDenoms(), { walletClient: Ee } = useWalletClientContext(), xe = useRef(!1), [$e, Ne] = useState(0), [st, Nr] = useState(!1), [br, $n] = useState("UNINITIALIZED"), En = useMemo(() => `${z.amountIn}-${z.sourceAsset.denom}:${z.amountOut}-${z.destinationAsset.denom}:${z.transactionCount}`, [z]), Rn = useRef({
    routeId: En,
    uuid: v4()
  });
  useEffect(() => {
    Rn.current.routeId !== En && (Rn.current = {
      routeId: En,
      uuid: v4()
    });
  }, [En]);
  const wa = useMemo(
    () => ({
      ...z,
      messages: ne
    }),
    [ne, z]
  ), { groupedTransactions: Aa } = useTransactions(wa), [_a, Ta] = useState(), { data: Zn, isLoading: Ra } = useSWR(
    z && ge && we ? unstable_serialize(["transaction-amounts", wa]) : null,
    async () => (invariant$1(ge, "Chains data is missing"), invariant$1(we, "Denoms data is missing"), await withRetry(
      () => getSwapAmountsFromMessages(wa, ge, we),
      []
    ))
  ), Yn = z.transactionCount, [$o, ct] = useState(
    getDefaultTxnStatuses(z)
  ), fe = useCallback(
    (it, xa) => {
      ct((wo) => {
        const _u = [...wo];
        return _u[it] = xa, _u;
      });
    },
    []
  ), { data: be } = useGasAdjustment(), { data: ye } = useGasPriceSteps(), Se = $o.map((it) => {
    if (it.status === NewTxnStatus.BROADCASTED)
      return {
        chainID: it.chainId,
        txHash: it.txHash
      };
  }).filter((it) => !!it), Oe = useBroadcastedTxsStatus({
    txs: Se,
    txsRequired: z.transactionCount
  }), Fr = useCallback(async () => {
    var Kc, M2, d1, K1, k2, Eu, Zo;
    if (Ra || !ge || !we || xe.current)
      return;
    $n("IN_PROGRESS"), xe.current = !0;
    const it = $e;
    Ta(void 0);
    const xa = ne[it].multi_chain_msg, wo = ((Kc = Zn == null ? void 0 : Zn[it]) == null ? void 0 : Kc.fromAmount) ?? "", _u = ((M2 = Zn == null ? void 0 : Zn[it]) == null ? void 0 : M2.toAmount) ?? "", Oa = ge.find(
      (Fl) => Fl.chainId === xa.chain_id
    );
    if (!Oa) {
      Ta(
        new TxnError(
          0,
          it,
          `Chain ${xa.chain_id} not supported by elements`
        )
      ), xe.current = !1;
      return;
    }
    const Os = JSON.parse(xa.msg), Pa = (/* @__PURE__ */ new Date()).getTime();
    if (Number(Os.timeout_timestamp / 10 ** 6) < Pa) {
      Ta(
        new TxnError(
          2,
          it,
          `Transaction ${it + 1} has timed out`
        )
      ), xe.current = !1;
      return;
    }
    const Su = (d1 = ue == null ? void 0 : ue.onTxnInProgress) == null ? void 0 : d1.call(ue, le), { senderAddress: Tu, encodedMessage: Au } = getMessageMetadataForSigning(
      xa.msg_type_url,
      Os
    );
    fe(it, {
      status: NewTxnStatus.NEEDS_APPROVAL
    });
    const Zl = getDecodedMessageMetadataForSigning(Au), { data: Iu } = await handlePromise(async () => {
      var U1;
      const { data: Fl, error: Ru } = await handlePromise(
        simulateTx(Oa.restUrl, Tu, [Zl])
      );
      if (Ru || Fl === void 0)
        throw new Error("Simulation failed");
      const ku = (be == null ? void 0 : be[Oa.key]) ?? 1.5, kc = new BigNumber(
        ((U1 = ye == null ? void 0 : ye[Oa.key]) == null ? void 0 : U1.low) ?? 0.025
      );
      return calculateFee(
        Fl.gasUsed,
        kc.toNumber(),
        Oa.baseDenom,
        ku
      );
    }), Uc = Iu ?? y[it], { data: Pu, error: Lu } = await handlePromise(
      Ee.getAccount(Oa.chainId)
    );
    if (Lu || !Pu) {
      Ta(
        new TxnError(
          6,
          it,
          `Couldn't fetch account for chain ${Oa.chainName} from wallet`
        )
      ), xe.current = !1;
      return;
    }
    const { data: th, error: Zc } = await handlePromise(
      Ee.getSigner(Oa.chainId)
    );
    if (Zc || !th) {
      Ta(
        new TxnError(
          7,
          it,
          `Couldn't request approval for ${Oa.chainName} transaction from wallet`
        )
      ), xe.current = !1;
      return;
    }
    const N1 = new TxClient(
      Oa.chainId,
      Oa.restUrl,
      Oa.coinType,
      th,
      Pu
    ), Gh = await getMessageWithInfo(Au, Oa, {
      chains: ge,
      denoms: we
    }), Mc = {
      chainType: "cosmos",
      chainId: Oa.chainId,
      chainName: Oa.chainName,
      signMode: Pu.isNanoLedger ? "amino" : "direct",
      transactionTypes: [Gh.typeUrl],
      messages: [Gh]
    };
    (K1 = ue == null ? void 0 : ue.onTxnSignInit) == null || K1.call(ue, Mc);
    const h1 = {
      current: void 0
    };
    try {
      const Fl = await Promise.race([
        N1.sign(Tu, [Au], Uc, he),
        sleep(3e4)
      ]);
      if (typeof Fl == "string")
        h1.current = Fl;
      else
        throw new Error("Transaction approval timed out");
      fe(it, {
        status: NewTxnStatus.SIGNED
      });
    } catch (Fl) {
      fe(it, {
        status: NewTxnStatus.IDLE
      }), Fl instanceof Error ? Fl.message.includes("rejected") || Fl.message.includes("declined") ? Ta(
        new TxnError(
          3,
          it,
          "Please approve the transaction from your wallet"
        )
      ) : Fl.message.includes("timed out") ? Ta(
        new TxnError(8, it, "Transaction approval timed out")
      ) : Ta(new TxnError(-1, it, Fl.message)) : Ta(
        new TxnError(-1, it, "An unknown error occurred")
      ), (k2 = ue == null ? void 0 : ue.onTxnSignFailed) == null || k2.call(
        ue,
        Mc,
        Fl instanceof Error ? Fl : new Error("An unknown error occurred")
      ), Su == null || Su(), xe.current = !1;
      return;
    }
    let l2, Gc;
    try {
      const Fl = await getSwapData(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Aa[`Transaction ${it + 1}`],
        ge,
        we
      );
      Gc = {
        swapId: Rn.current.uuid,
        fromTokenAmount: wo,
        toTokenAmount: _u,
        ...Fl
      };
    } catch {
    }
    if (!h1.current) {
      fe(it, {
        status: NewTxnStatus.IDLE
      }), Ta(
        new TxnError(-1, it, "No transaction data was found")
      ), Su == null || Su(), xe.current = !1;
      return;
    }
    fe(it, {
      status: NewTxnStatus.BROADCASTING
    });
    try {
      const { success: Fl, response: Ru } = await N1.submitTx(
        Oa.chainId,
        h1.current
      );
      if (!Fl)
        throw new Error("Skip SubmitTx Failed");
      l2 = Ru == null ? void 0 : Ru.tx_hash, (Eu = ue == null ? void 0 : ue.onTxnSignApproved) == null || Eu.call(ue, {
        ...Mc,
        txHash: l2,
        fees: Uc.amount,
        data: Gc
      }), fe(it, {
        status: NewTxnStatus.BROADCASTED,
        txHash: l2,
        chainId: Oa.chainId
      }), Su == null || Su(), xe.current = !1;
    } catch {
      try {
        const {
          transactionHash: Ru,
          code: ku,
          codespace: kc
        } = await N1.broadcastTx(h1.current);
        if (l2 = Ru, (Zo = ue == null ? void 0 : ue.onTxnSignApproved) == null || Zo.call(ue, {
          ...Mc,
          txHash: l2,
          fees: Uc.amount,
          data: Gc
        }), ku !== 0)
          fe(it, {
            status: NewTxnStatus.IDLE
          }), Ta(
            new TxnError(
              4,
              it,
              `Transaction failed ${getErrorMessageFromCode(ku, kc)}`
            )
          );
        else {
          const Ou = await sendTrackingRequest(Oa.chainId, l2);
          Ou != null && Ou.success || Ta(
            new TxnError(
              9,
              it,
              `Unable to track transaction. Please check the status on the explorer ${Oa.txExplorer.mainnet}/${l2}`
            )
          ), fe(it, {
            status: NewTxnStatus.BROADCASTED,
            txHash: l2,
            chainId: Oa.chainId
          });
        }
        Su == null || Su(), xe.current = !1;
      } catch (Ru) {
        fe(it, {
          status: NewTxnStatus.IDLE
        }), Ru instanceof Error ? Ta(new TxnError(5, it, Ru.message)) : Ta(
          new TxnError(
            5,
            it,
            "An unknown error occurred while broadcasting the transaction"
          )
        ), Su == null || Su(), xe.current = !1;
        return;
      }
    }
  }, [
    ge,
    we,
    y,
    Aa,
    Ra,
    ne,
    le,
    Zn,
    ue,
    $e,
    fe,
    Ee,
    be,
    ye,
    he
  ]), zn = useMemo(() => {
    if (_a)
      switch (_a.code) {
        case 0:
        case 1:
          return {
            status: "FATAL_ERROR",
            title: "Chain not supported",
            message: _a.message
          };
        case 2:
          return {
            status: "FATAL_ERROR",
            title: "Transaction timed out",
            message: _a.message
          };
        case 3:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: _a.message
          };
        case 4:
          return {
            status: "FATAL_ERROR",
            title: "Transaction failed",
            message: _a.message
          };
        case 5:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Transaction broadcast failed",
            message: _a.message
          };
        case 6:
        case 7:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval rejected",
            message: _a.message
          };
        case 8:
          return {
            status: "RECOVERABLE_ERROR",
            title: "Approval timed out",
            message: _a.message
          };
        case 9:
          return {
            status: "CANNOT_TRACK"
          };
        default:
          return {
            status: "FATAL_ERROR",
            title: "An unknown error occurred",
            message: _a.message
          };
      }
    if (Oe.error)
      return {
        status: "CANNOT_TRACK"
      };
    if (Oe.data) {
      const it = $o[$e];
      if (it.status === NewTxnStatus.BROADCASTED)
        switch (Oe.data.states[$e]) {
          case "STATE_SUBMITTED":
          case "STATE_PENDING":
            return {
              status: "IN_PROGRESS"
            };
          case "STATE_UNKNOWN":
          case "STATE_ABANDONED":
            return {
              status: "CANNOT_TRACK"
            };
          case "STATE_PENDING_ERROR":
          case "STATE_COMPLETED_ERROR":
            return {
              status: "FAILED"
            };
          case "STATE_RECEIVED":
          case "STATE_COMPLETED":
          case "STATE_COMPLETED_SUCCESS":
            return {
              status: "SUCCESS"
            };
        }
      else
        switch (it.status) {
          case NewTxnStatus.IDLE:
          case NewTxnStatus.NEEDS_APPROVAL:
            return {
              status: "SIGNATURE_REQUIRED"
            };
          case NewTxnStatus.SIGNED:
            return {
              status: "SIGNATURE_RECEIVED"
            };
          case NewTxnStatus.BROADCASTING:
            return {
              status: "BROADCASTING"
            };
        }
    }
  }, [$e, _a, $o, Oe]);
  useConsoleLog("IBCTransfer", "transferStatus", zn), useConsoleLog("IBCTransfer", "lastError", _a), useConsoleLog("IBCTransfer", "txnTrackingData", Oe.data), useConsoleLog("IBCTransfer", "overallTransferStatus", br), useEffect(() => {
    _a && Nr(!0);
  }, [_a]), useEffect(() => {
    (br === "SUCCESS" || br === "CANNOT_TRACK") && Nr(!1);
  }, [br]);
  const Fe = useMemo(() => ({
    sourceChain: z.sourceAssetChain,
    sourceAsset: z.sourceAsset,
    destinationChain: z.destinationAssetChain,
    destinationAsset: z.destinationAsset,
    inputAmount: z.amountIn,
    outAmount: z.amountOut
  }), [z]);
  useEffect(() => {
    zn && (zn.status === "SUCCESS" ? $e === Yn - 1 ? $n("SUCCESS") : Ne((it) => it + 1) : zn.status === "FAILED" || zn.status === "FATAL_ERROR" ? $n("FAILED") : zn.status === "CANNOT_TRACK" && $n("CANNOT_TRACK"));
  }, [
    $e,
    Fe,
    zn,
    Yn,
    ue
  ]), useEffect(() => {
    $e > 0 && Fr();
  }, [$e, Yn]);
  const pe = useMemo(() => ({
    transferStatus: zn,
    overallTransferStatus: br,
    isTxnTrackerOpen: st,
    setIsTxnTrackerOpen: Nr,
    executeRoute: Fr,
    activeTxnIndex: $e,
    setActiveTxnIndex: Ne,
    txnStatuses: $o,
    setTxnStatuses: ct,
    lastError: _a,
    routeResponse: z,
    messages: ne,
    gasFees: y,
    txnLifecycleHooks: ue,
    tab: le,
    groupedTransactions: Aa,
    txnTracking: Oe,
    memo: he
  }), [
    zn,
    br,
    st,
    Fr,
    $e,
    $o,
    _a,
    z,
    ne,
    y,
    ue,
    le,
    Aa,
    Oe,
    he
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferTrackingContext.Provider, { value: pe, children: v });
}, useIBCTransferTrackingContext = () => {
  const v = useContext(IBCTransferTrackingContext);
  return invariant$1(
    v,
    "useIBCTransferTrackingContext must be used within a IBCTransferTrackingContext"
  ), v;
}, RenderCTAButton = ({
  refresh: v,
  resetInputsToDefaults: y,
  goBack: z,
  transferStatus: ne,
  overallTransferStatus: ue,
  executeRoute: le
}) => {
  const he = useOnline();
  return he ? ue === "UNINITIALIZED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: le,
      children: "Confirm Send"
    }
  ) : ue === "CANNOT_TRACK" ? he ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        z(), v();
      },
      children: "Send Again"
    }
  ) : null : (ne == null ? void 0 : ne.status) === "FATAL_ERROR" || (ne == null ? void 0 : ne.status) === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        z(), v();
      },
      children: "Retry Send"
    }
  ) : (ne == null ? void 0 : ne.status) === "BROADCASTING" || (ne == null ? void 0 : ne.status) === "SIGNATURE_RECEIVED" || (ne == null ? void 0 : ne.status) === "IN_PROGRESS" || (ne == null ? void 0 : ne.status) === "SIGNATURE_REQUIRED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      disabled: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(R$4, { className: "animate-spin", size: "1.25rem" })
    }
  ) : (ne == null ? void 0 : ne.status) === "RECOVERABLE_ERROR" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-attention",
      className: "w-full font-bold",
      onClick: le,
      children: "Retry"
    }
  ) : (ne == null ? void 0 : ne.status) === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        y(!1), z();
      },
      children: "Send again"
    }
  ) : null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      disabled: !0,
      className: "w-full font-bold",
      onClick: le,
      children: "No Internet Connection"
    }
  );
}, CTAButton$1 = () => {
  const { refresh: v, resetInputsToDefaults: y } = useIBCTransferContext(), { goBack: z } = useSwapsFlowContext(), { transferStatus: ne, overallTransferStatus: ue, executeRoute: le } = useIBCTransferTrackingContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RenderCTAButton,
    {
      refresh: v,
      resetInputsToDefaults: y,
      goBack: z,
      transferStatus: ne,
      overallTransferStatus: ue,
      executeRoute: le
    }
  );
}, getTransferStatusHeading = (v) => {
  switch (v) {
    case "UNINITIALIZED":
      return "Review transaction";
    case "IN_PROGRESS":
      return "Transaction in progress";
    case "SUCCESS":
      return "Transaction successful";
    case "CANNOT_TRACK":
      return "Cannot track transaction";
    case "FAILED":
      return "Transaction failed";
  }
}, Header$1 = () => {
  const { goBack: v, getTimeSpentOnCurrentStep: y } = useSwapsFlowContext(), { refresh: z, resetInputsToDefaults: ne } = useIBCTransferContext(), { overallTransferStatus: ue, transferStatus: le } = useIBCTransferTrackingContext(), he = useCallback(() => {
    y() > 15 && ue === "UNINITIALIZED" && z(), (ue === "SUCCESS" || ue === "FAILED") && ne(!1), v();
  }, [
    y,
    v,
    ue,
    z,
    ne
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        disabled: ((le == null ? void 0 : le.status) === "SIGNATURE_RECEIVED" || (le == null ? void 0 : le.status) === "BROADCASTING" || (le == null ? void 0 : le.status) === "SIGNATURE_REQUIRED") && ue === "IN_PROGRESS",
        onClick: he,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: getTransferStatusHeading(ue) }),
    ue === "IN_PROGRESS" || ue === "FAILED" || ue === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(HelpPopover, {}) : null
  ] });
}, TransferAssetsOverview = () => {
  const {
    sourceAssetData: v,
    destinationAddress: y,
    gasFeesData: z,
    isLoadingGasFee: ne,
    memo: ue,
    isIBCTransfer: le
  } = useIBCTransferContext(), { routeResponse: he, overallTransferStatus: ge, lastError: we } = useIBCTransferTrackingContext(), Ee = useOnline(), xe = useRef(null);
  if (useScrollIntoView(xe), ge === "CANNOT_TRACK")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CannotTrackView, { lastError: we, routeResponse: he });
  const $e = ({
    connectorString: Ne
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-lg font-bold text-center", children: [
      formatAmount(he.amountIn, 2, 4),
      " ",
      he.sourceAsset.symbol
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-center", children: Ne }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-4 flex justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center bg-secondary justify-center gap-2 rounded-xl py-1 px-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(UserFallbackIcon, { size: "18" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: sliceAddress(y) })
    ] }) })
  ] });
  return ge === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-card rounded-xl p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      className: "flex flex-col items-center justify-center",
      ref: xe,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.span,
          {
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1
            },
            transition: {
              delay: 0.2
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {})
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx($e, { connectorString: "failed sending to " })
      ]
    }
  ) }) : ge === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col items-center justify-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapSuccessfulIcon, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx($e, { connectorString: "sent successfully to" })
  ] }) : ge === "IN_PROGRESS" && !Ee ? /* @__PURE__ */ jsxRuntimeExports.jsx(ReconnectToContinueView, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "bg-card rounded-xl p-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "send",
          amount: he.amountIn,
          assetSymbol: he.sourceAsset.symbol,
          assetLogoUri: he.sourceAsset.logoUri,
          assetCoingeckoId: v == null ? void 0 : v.coingeckoId,
          chainLogoUri: he.sourceAssetChain.icon,
          chainName: he.sourceAssetChain.chainName
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-left mb-2 mt-5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-secondary flex h-8 w-8 items-center justify-center rounded-3xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(D$5, { size: 20, weight: "bold" }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReviewAssetInformation,
        {
          type: "receive",
          amount: he.amountOut ?? "",
          assetSymbol: he.destinationAsset.symbol,
          assetLogoUri: he.destinationAsset.logoUri,
          assetCoingeckoId: v == null ? void 0 : v.coingeckoId,
          chainLogoUri: he.destinationAssetChain.icon,
          chainName: he.destinationAssetChain.chainName,
          destinationAddress: y,
          isIBCTransfer: le
        }
      )
    ] }),
    ge === "UNINITIALIZED" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(Memo, { memo: ue }) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TransactionFee,
        {
          gasFeesData: z,
          gasLoading: ne
        }
      )
    ] }) : null
  ] });
}, TransferViewWrapperForTracking = () => {
  const {
    transferStatus: v,
    activeTxnIndex: y,
    isTxnTrackerOpen: z,
    setIsTxnTrackerOpen: ne,
    groupedTransactions: ue,
    lastError: le,
    txnTracking: he,
    overallTransferStatus: ge,
    routeResponse: we
  } = useIBCTransferTrackingContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TrackSkipSwap,
    {
      swapStatus: v,
      activeTxnIndex: y,
      isTxnTrackerOpen: z,
      setIsTxnTrackerOpen: ne,
      groupedTransactions: ue,
      lastError: le,
      txnTracking: he,
      overallSwapStatus: ge,
      routeResponse: we,
      bridgeType: "ibc"
    }
  );
}, TransactionCard = () => {
  const { isIBCTransfer: v, sourceChainData: y } = useIBCTransferContext(), { txnTracking: z, activeTxnIndex: ne, txnStatuses: ue } = useIBCTransferTrackingContext(), [le, he] = useState(!0), ge = useMemo(() => {
    var Ee, xe, $e, Ne;
    if (v) {
      const st = (Ee = z.data) == null ? void 0 : Ee.grouped[ne], Nr = st == null ? void 0 : st.transferSequence[0];
      return {
        txHash: (xe = Nr == null ? void 0 : Nr.packetTxs.sendTx) == null ? void 0 : xe.txHash,
        explorerLink: ($e = Nr == null ? void 0 : Nr.packetTxs.sendTx) == null ? void 0 : $e.explorerLink
      };
    } else {
      const st = (Ne = z.data) == null ? void 0 : Ne.grouped[ne], Nr = ue[ne];
      if (Nr.status === NewTxnStatus.BROADCASTED && ((st == null ? void 0 : st.state) === "STATE_COMPLETED_SUCCESS" || (st == null ? void 0 : st.state) === "STATE_COMPLETED_ERROR"))
        return {
          txHash: Nr == null ? void 0 : Nr.txHash,
          explorerLink: `${y == null ? void 0 : y.txExplorer.mainnet.txUrl}/${Nr == null ? void 0 : Nr.txHash}`
        };
    }
  }, [z, ne, ue, v, y]), we = async () => {
    try {
      await navigator.clipboard.writeText((ge == null ? void 0 : ge.txHash) ?? ""), he(!1), setTimeout(() => {
        he(!0);
      }, 1e3);
    } catch {
      console.warn("Failed to copy text to clipboard");
    }
  };
  return ge != null && ge.txHash ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "bg-card rounded-xl p-4 mt-2", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-sm font-bold", children: "Transaction ID" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm text-muted-foreground", children: showTrimmedTxnHash((ge == null ? void 0 : ge.txHash) ?? "") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        np,
        {
          variant: "secondary",
          size: "sm-icon",
          className: "rounded-3xl",
          onClick: we,
          children: le ? /* @__PURE__ */ jsxRuntimeExports.jsx(C$4, { size: 16, weight: "bold" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(w$4, { weight: "bold", size: "1rem" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(np, { variant: "secondary", size: "sm-icon", className: "rounded-3xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "a",
        {
          href: (ge == null ? void 0 : ge.explorerLink) ?? "",
          target: "_blank",
          rel: "noopener noreferrer",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(q$1, { size: 16, weight: "bold" })
        }
      ) })
    ] })
  ] }) }) : null;
}, IBCTransferReview = () => {
  const {
    gasFeesData: v,
    isLoadingGasFee: y,
    isLoadingRoute: z,
    isLoadingMessages: ne,
    isValidatingGasFee: ue,
    isValidatingRoute: le,
    messages: he,
    routeResponse: ge,
    txnLifecycleHooks: we,
    refresh: Ee,
    memo: xe
  } = useIBCTransferContext(), { goBack: $e } = useSwapsFlowContext();
  return y || ne || z || le || ue ? /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewLoadingSkeleton, { refresh: Ee, goBack: $e }) : !ge || !he || !v ? /* @__PURE__ */ jsxRuntimeExports.jsx(NoDataView$1, { goBack: $e }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    IBCTransferTrackingProvider,
    {
      tab: Tabs.TRANSFER,
      gasFees: v == null ? void 0 : v.gasFeesAmount,
      messages: he,
      memo: xe,
      routeResponse: ge,
      txnLifecycleHooks: we,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Header$1, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 overflow-y-auto no-scrollbar h-full", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TransferAssetsOverview, {}),
          (ge == null ? void 0 : ge.transactionCount) > 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(TransferViewWrapperForTracking, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(TransactionCard, {})
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 mb-4 [&:has(>*)]:mt-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CTAButton$1, {}) })
      ]
    }
  );
}, tokenOnCEX = ["ATOM", "SEI", "INJ", "NTRN", "USDC", "TIA", "OSMO"], WarningSection = () => {
  const {
    destinationChainData: v,
    destinationAddress: y,
    sourceAssetData: z,
    addressError: ne,
    sourceAddress: ue,
    isIBCTransfer: le
  } = useIBCTransferContext(), he = useMemo(() => ue.address === y, [ue, y]), ge = useMemo(() => y ? y && v : !0, [v, y]), we = le && tokenOnCEX.includes((z == null ? void 0 : z.symbol) || "") && (v == null ? void 0 : v.baseDenom) === (z == null ? void 0 : z.originDenom);
  return he ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-destructive", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: "You cannot send tokens to the same address" })
  ] }) : !ne && !ge ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "destructive", className: "bg-card mt-3", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-destructive", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: "IBC transfers are not supported for the following chains" })
  ] }) : we ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jf, { variant: "warning", className: "bg-card mt-3", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(I$1, { className: "h-5 w-5 text-warning", weight: "fill" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Vf, { className: "mt-[3px]", children: "This IBC transfer may not be supported if the recipient is a centralized exchange" })
  ] }) : null;
}, popularChains$1 = [
  "cosmoshub-4",
  "osmosis-1",
  "pacific-1",
  "injective-1",
  "neutron-1"
], IBCTransferSourceSelect = ({ chains: v, assets: y }) => {
  const {
    sourceChainId: z,
    sourceAsset: ne,
    setSourceChainId: ue,
    setSourceAsset: le,
    inputAmount: he,
    setInputAmount: ge,
    inputAmountRemark: we,
    sourceTokenBalance: Ee,
    sourceAddress: xe,
    sourceChainData: $e
  } = useIBCTransferContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SourceSelect$1,
    {
      title: "You're sending",
      chains: v,
      assets: y,
      inputValue: he,
      setInputValue: ge,
      inputAmountRemark: we,
      selectedChainId: z,
      setSelectedChainId: ue,
      selectedAsset: ne,
      setSelectedAsset: le,
      tokenBalance: Ee,
      popularChainIds: popularChains$1,
      sourceChainData: $e,
      selectedChainError: !!xe.error,
      fetchChainBalances: useCosmosChainBalances
    }
  );
}, IBCTransferDestinationInput = () => {
  const { destinationAddress: v, setDestinationAddress: y, addressError: z } = useIBCTransferContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DestinationInput,
    {
      isLoadingRoute: !1,
      isValidatingRoute: !1,
      addressError: z,
      setDestinationAddress: y,
      destinationAddress: v
    }
  );
}, IBCTransferInputView = ({ title: v, chains: y, assets: z }) => {
  const ne = useRef(null);
  return useOverflowFade(ne), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-between px-4 my-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-bold", children: v ?? "IBC Transfer" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "overflow-y-auto no-scrollbar px-4 h-full", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferSourceSelect, { chains: y, assets: z }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-2 bg-transparent" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferDestinationInput, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TransferInfo, { className: "mt-3" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(WarningSection, {})
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 my-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransferCTASection, {}) })
  ] });
}, IBCTransferView = ({ className: v, title: y, showPoweredByBanner: z }) => {
  const { step: ne, previousStep: ue } = useSwapsFlowContext(), le = useChains(), he = useSkipSupportedChains(), ge = useAllSkipAssets(), we = useMemo(() => le.isLoading ? {
    isLoading: !0,
    data: void 0,
    error: void 0
  } : he, [le.isLoading, he]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: Y$1("bg-background h-[34rem] w-[26rem] rounded-2xl", v),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AnimatePresence, { mode: "popLayout", children: [
        ne === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 1 ? -8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: -8 },
            transition: {
              duration: 0.2,
              stiffness: 80
            },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              IBCTransferInputView,
              {
                title: y,
                chains: we,
                assets: ge
              }
            )
          },
          0
        ) : null,
        ne === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 0 ? 8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: 8 },
            transition: {
              duration: 0.2,
              stiffness: 80
            },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransferReview, {})
          },
          1
        ) : null,
        z ? /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByLeapAndSkip, {}, "powered-by-banner") : null
      ] })
    }
  );
}, IBCTransfer = ({
  className: v,
  title: y,
  showPoweredByBanner: z,
  defaultValues: ne,
  txnLifecycleHooks: ue,
  allowedSourceChains: le,
  onValuesChange: he
}) => {
  const ge = useMemo(() => {
    const we = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.sourceChainId,
      "cosmoshub-4",
      le == null ? void 0 : le.map((xe) => xe.chainId)
    ), Ee = getDefaultAsset$1(
      we,
      ne == null ? void 0 : ne.sourceAsset,
      le
    );
    return {
      sourceChainId: we,
      sourceAsset: Ee,
      inputAmount: (ne == null ? void 0 : ne.inputAmount) ?? ""
    };
  }, [le, ne]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { title: y ?? "IBC Transfer", className: v, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsFlowProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SourceRestrictionsProvider, { chains: le, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    IBCTransferProvider,
    {
      defaultValues: ge,
      txnLifecycleHooks: ue,
      onValuesChange: he,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(xw, { delayDuration: 250, skipDelayDuration: 750, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        IBCTransferView,
        {
          className: v,
          title: y,
          showPoweredByBanner: z
        }
      ) })
    }
  ) }) }) });
}, IBCTransferModal = ({
  isOpen: v,
  setIsOpen: y,
  ...z
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalView, { isOpen: v, setIsOpen: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IBCTransfer, { ...z }) }), useEffectiveAmountValue = (v) => useMemo(() => {
  if (v.trim().length === 0)
    return "";
  const z = parseFloat(v);
  return isNaN(z) ? "" : z.toString();
}, [v]), BuyTokensContext = createContext(
  void 0
), BuyTokensProvider = ({
  defaultValues: v,
  onTxnComplete: y,
  onTxnInProgress: z,
  onFiatAmountChange: ne,
  onFiatCurrencyChange: ue,
  onDestinationChainChange: le,
  onCryptoCurrencyChange: he,
  children: ge
}) => {
  const [we, Ee] = useState(
    v.sourceAmount ?? ""
  ), [xe, $e] = useState(
    void 0
  ), [Ne, st] = useState(v.destinationChainId), [Nr, br] = useState(
    typeof v.destinationAsset == "string" ? v.destinationAsset : void 0
  ), [$n, En] = useState(), Rn = useFiatConversionRateSWR(
    xe,
    "USD",
    xe !== void 0
  ), wa = useKadoSupportedChains(), Aa = useKadoAssets(), _a = useAllSkipAssets(), Ta = useMemo(() => {
    var th;
    if (!(!wa.data || !((th = wa.data) != null && th.success) || !Aa.data))
      return wa.data.chains.filter(
        (Zc) => Aa.data[Zc.chainId].length > 0
      );
  }, [wa == null ? void 0 : wa.data, Aa == null ? void 0 : Aa.data]), Zn = useKadoCurrencyListSWR(), Ra = useSourceRestrictionsContext(), Yn = useMemo(() => {
    var Zc, N1;
    if (!((Zc = Zn == null ? void 0 : Zn.data) != null && Zc.success))
      return [];
    const th = (N1 = Zn == null ? void 0 : Zn.data) == null ? void 0 : N1.currencies.map(
      (Gh) => ({
        ...Gh,
        countryCode: currencyToCountryCode[Gh.code] ?? ""
      })
    );
    return Ra && Ra.allowedCurrencies ? th.filter(
      (Gh) => {
        var Mc;
        return (Mc = Ra.allowedCurrencies) == null ? void 0 : Mc.includes(Gh.code);
      }
    ) : th;
  }, [Ra, Zn == null ? void 0 : Zn.data]), $o = useMemo(() => ({
    data: Yn,
    isLoading: Zn.isLoading,
    error: Zn.error
  }), [Yn, Zn.error, Zn.isLoading]), ct = useMemo(() => _a.isLoading || Aa.isLoading || wa.isLoading ? {
    data: void 0,
    isLoading: !0,
    error: void 0
  } : _a.error || wa.error || Aa.error ? {
    data: void 0,
    isLoading: !1,
    error: wa.error ?? Aa.error
  } : Aa.data && wa.data ? {
    data: Ta,
    isLoading: wa.isLoading,
    error: wa.error
  } : {
    data: void 0,
    isLoading: !1,
    error: new Error("Unknown error")
  }, [
    _a.isLoading,
    _a.error,
    Aa.isLoading,
    Aa.error,
    Aa.data,
    wa.isLoading,
    wa.error,
    wa.data,
    Ta
  ]), fe = useMemo(() => {
    if (!(!xe || !Yn))
      return Yn.find((th) => th.code === xe);
  }, [xe, Yn]), be = useMemo(() => {
    var Zc;
    const th = v.currency;
    if (th === void 0 || typeof th == "string")
      return th;
    if (Yn)
      return (Zc = Yn.find((N1) => N1.code === th)) == null ? void 0 : Zc.code;
  }, [Yn, v.currency]), ye = useCallback(
    (th) => {
      var N1;
      st(th);
      const Zc = (N1 = Ta == null ? void 0 : Ta.find(
        (Gh) => Gh.chainId === th
      )) == null ? void 0 : N1.baseDenom;
      br(Zc || void 0);
    },
    [Ta]
  ), Se = useMemo(() => {
    if (Ne)
      return Ta == null ? void 0 : Ta.find(
        (th) => th.chainId === Ne
      );
  }, [Ta, Ne]), Oe = useSourceAddress(
    Se
  ), Fr = useMemo(() => {
    const th = v.destinationAsset;
    if (th === void 0 || typeof th == "string")
      return th;
    if (!_a.data || !Aa.data || !(Se != null && Se.chainId))
      return;
    const Zc = Aa.data[Se == null ? void 0 : Se.chainId].find(
      (N1) => N1.originDenom === th.originDenom && N1.originChainId === th.originChainId
    );
    return (Zc == null ? void 0 : Zc.denom) ?? (Se == null ? void 0 : Se.baseDenom);
  }, [
    v.destinationAsset,
    _a.data,
    Aa.data,
    Se == null ? void 0 : Se.chainId,
    Se == null ? void 0 : Se.baseDenom
  ]), zn = useRef(!1);
  useEffect(() => {
    be && !zn.current && ($e(be), zn.current = !0);
  }, [be]);
  const Fe = useRef(
    v.destinationAsset === SELECT_NONE
  );
  useEffect(() => {
    Fr && !Fe.current && (br(Fr), Fe.current = !0);
  }, [Fr]), useEffect(() => {
    Nr === void 0 && (Se == null ? void 0 : Se.baseDenom) !== void 0 && Fe.current && br(Se.baseDenom);
  }, [Se == null ? void 0 : Se.baseDenom]);
  const pe = useMemo(() => {
    if (!Aa.data || !Ne || !Nr)
      return;
    const th = Aa.data[Ne];
    return th == null ? void 0 : th.find((Zc) => Zc.denom === Nr);
  }, [Aa.data, Ne, Nr]), it = useCosmosTokenBalance({
    chainId: Ne,
    denom: Nr
  }), xa = useEffectiveAmountValue(we), wo = useMemo(() => {
    var Zc;
    if (!xa || !((Zc = Rn.data) != null && Zc.success))
      return;
    const th = new BigNumber(xa).times(
      Rn.data.conversionRate
    );
    if (!th.isNaN())
      return th;
  }, [xa, Rn]), _u = useMemo(() => {
    var th;
    if ((th = Rn.data) != null && th.success)
      return new BigNumber(KADO_MIN_USD_AMOUNT).div(
        Rn.data.conversionRate
      );
  }, [Rn]), Oa = useMemo(() => {
    if (wo != null && wo.isLessThan(KADO_MIN_USD_AMOUNT))
      return {
        message: `Minimum amount of ${fe == null ? void 0 : fe.symbol}${_u == null ? void 0 : _u.toFixed(2)} required`,
        type: "error"
      };
  }, [wo, fe, _u]), { step: Os } = useSwapsFlowContext();
  useEffect(() => {
    xa != null && xa.trim() || En(void 0);
  }, [xa]);
  const Pa = !!Ne && !!Nr && !!wo && !Rn.isLoading && (wo == null ? void 0 : wo.isGreaterThanOrEqualTo(KADO_MIN_USD_AMOUNT)), {
    data: Ml,
    isValidating: Su,
    isLoading: Tu,
    error: Au,
    refresh: Zl
  } = useKadoQuoteSWR(
    pe == null ? void 0 : pe.symbol,
    Se == null ? void 0 : Se.origin,
    wo == null ? void 0 : wo.toNumber(),
    !!Pa,
    {
      refreshInterval: 1e4,
      revalidateOnFocus: Os === 0,
      revalidateIfStale: Os === 0,
      revalidateOnReconnect: Os === 0
    }
  ), Iu = useMemo(() => {
    if (!(!Ml || !Ml.success))
      return Ml.quote;
  }, [Ml]), Uc = useMemo(() => {
    if (!Iu || !(xa != null && xa.trim()))
      return "";
    const { receiveUnitCountAfterFees: th } = Iu;
    return new BigNumber(th.amount).toFixed(2);
  }, [Iu, xa]), Pu = useCallback(
    (th) => {
      th && Ee(v.sourceAmount ?? ""), $e(v.currency), st(v.destinationChainId), br(Fr), En(void 0);
    },
    [
      $e,
      Ee,
      v,
      Fr
    ]
  );
  useEffect(() => {
    ne == null || ne(we);
  }, [ne, we]), useEffect(() => {
    ue == null || ue(fe);
  }, [ue, fe]), useEffect(() => {
    le == null || le(Se);
  }, [le, Se]), useEffect(() => {
    he == null || he(pe);
  }, [he, pe]);
  const Lu = useMemo(
    () => ({
      inputAmount: we,
      setInputAmount: Ee,
      effectiveAmountValue: xa,
      selectedCurrency: xe,
      setSelectedCurrency: $e,
      sourceCurrencyData: fe,
      usdValue: wo,
      destinationChainId: Ne,
      destinationAsset: Nr,
      destinationChainData: Se,
      destinationAssetData: pe,
      destinationAddress: Oe,
      setDestinationChainId: ye,
      setDestinationAsset: br,
      destinationTokenBalance: it,
      onTxnComplete: y,
      onTxnInProgress: z,
      currencies: $o,
      kadoChains: ct,
      kadoQuote: Iu,
      isKadoQuoteValidating: Su,
      isKadoQuoteLoading: Tu,
      kadoQuoteError: Au,
      refresh: Zl,
      isKadoQuoteEnabled: Pa,
      amountOut: Uc,
      resetInputsToDefaults: Pu,
      inputAmountRemark: Oa,
      alternateRoute: $n,
      conversionRate: Rn
    }),
    [
      we,
      xa,
      Ee,
      xe,
      $e,
      fe,
      wo,
      Ne,
      Nr,
      Se,
      pe,
      Oe,
      ye,
      br,
      it,
      y,
      z,
      $o,
      ct,
      Iu,
      Su,
      Tu,
      Au,
      Uc,
      Zl,
      Pa,
      Pu,
      Oa,
      $n,
      Rn
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokensContext.Provider, { value: Lu, children: ge });
}, useBuyTokensContext = () => {
  const v = useContext(BuyTokensContext);
  return invariant$1(
    v,
    `Please use ${useBuyTokensContext.name} within BuyTokensProvider`
  ), v;
}, FiatItemRaw = ({ fiat: v, isSelected: y, onSelect: z }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    variant: "ghost",
    size: "sm",
    className: "text-foreground focus-visible:bg-muted h-auto w-[20.875rem] justify-start items-center gap-4 rounded-none border-b p-3 last-of-type:border-none focus-visible:ring-0",
    onClick: () => z(v.code),
    disabled: y,
    children: [
      v.countryCode ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReactCountryFlag,
        {
          countryCode: v.countryCode,
          svg: !0,
          style: {
            width: "1.5rem"
          }
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(GenericFallbackIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "text-foreground max-w-[8rem] truncate font-bold", children: v.name })
    ]
  },
  v.code
), FiatItem = memo$1(FiatItemRaw), FiatSelectModalTrigger = ({ selectedFiatData: v, onlyOneCurrency: y }) => /* @__PURE__ */ jsxRuntimeExports.jsx(J$, { asChild: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
  np,
  {
    disabled: v && y,
    variant: "outline",
    className: "rounded-3xl py-1.5 px-3 !opacity-100",
    children: [
      v != null && v.countryCode ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReactCountryFlag,
        {
          countryCode: v == null ? void 0 : v.countryCode,
          svg: !0,
          style: {
            width: "1.5rem"
          }
        }
      ) : null,
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          className: `mx-2 font-medium ${v ? "text-lg" : "text-base"}`,
          children: (v == null ? void 0 : v.code) ?? "Select Currency"
        }
      ),
      v && y ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(D$3, { weight: "bold", size: "0.75rem" })
    ]
  }
) }), FiatSelect = ({ currencies: v, selectedFiat: y, setSelectedFiat: z, getIsSelected: ne }) => {
  var st;
  const [ue, le] = useState(""), he = useDebouncedValue(ue, 150), [ge, we] = useState(!1), Ee = useOnline(), xe = useMemo(() => v != null && v.data ? ue ? new Fuse(v == null ? void 0 : v.data, {
    keys: ["symbol", "name", "code"],
    threshold: 0.1
  }).search(ue).map((br) => br.item) : v == null ? void 0 : v.data : void 0, [v, ue]), $e = useMemo(() => {
    if (!(!y || !(v != null && v.data)))
      return v == null ? void 0 : v.data.find((Nr) => Nr.code === y);
  }, [v, y]), Ne = useCallback(
    (Nr) => {
      z(Nr), we(!1);
    },
    [z]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Y0$1, { open: ge, onOpenChange: we, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FiatSelectModalTrigger,
      {
        onlyOneCurrency: ((st = v == null ? void 0 : v.data) == null ? void 0 : st.length) === 1,
        selectedFiatData: $e
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Gi, { className: "w-full max-w-[24rem]", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(q0$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Q0$1, { className: "text-left", children: "Select Currency" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SearchInput,
          {
            searchQuery: ue,
            setSearchQuery: le,
            placeholder: "Search by name, symbol or code",
            disabled: xe === void 0 || v.isLoading
          }
        ),
        v.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              w$3,
              {
                size: 32,
                className: "text-foreground animate-spin"
              }
            ),
            message: "Loading assets..."
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: xe === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: xe === void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "No chain selected",
            subtext: "Please select a chain to view its assets"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "Failed to load assets",
            subtext: Ee ? "Oops, something went wrong. Try reloading the page." : "Please check your connection"
          }
        ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (xe == null ? void 0 : xe.length) === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(C$3, { size: 32, className: "text-foreground" }),
            message: "No supported assets",
            subtext: "Looks like there are no supported assets for this chain"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: xe.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ListMessage,
          {
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(I$2, { size: 32, className: "text-foreground" }),
            message: `No assets found for '${he}'`,
            subtext: "Try searching for a different term"
          }
        ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("h3", { className: "text-foreground text-sm font-bold", children: [
            he.length > 0 ? "Searched" : "All",
            " ",
            "Currencies"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Virtuoso,
            {
              as: "div",
              className: "mt-2 w-full",
              increaseViewportBy: {
                top: 120,
                bottom: 120
              },
              data: xe,
              style: {
                height: "40svh",
                maxHeight: "20rem"
              },
              itemContent: (Nr, br) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  FiatItem,
                  {
                    fiat: br,
                    onSelect: Ne,
                    isSelected: ne(br, y)
                  },
                  br.code
                ),
                Nr !== xe.length - 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Sh, {}) : null
              ] }, br.code)
            }
          )
        ] }) }) }) })
      ] })
    ] })
  ] });
}, SourceSelect = ({
  classNames: v,
  currencies: y,
  inputValue: z,
  setInputValue: ne,
  selectedCurrency: ue,
  setSelectedCurrency: le,
  inputAmountRemark: he
}) => {
  const [ge, we] = useState(
    z.toString()
  ), Ee = useMemo(() => {
    if (!(!ue || !(y != null && y.data)))
      return y == null ? void 0 : y.data.find(
        (xe) => xe.code === ue
      );
  }, [y, ue]);
  return useEffect(() => {
    ne(ge);
  }, [ge, ne]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("bg-card rounded-xl", v), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center justify-between border-b px-4 py-3", children: /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "text-muted-foreground text-sm", children: "You pay" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 py-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-1 max-w-[60%] overflow-x-auto no-scrollbar", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-3xl font-medium", children: Ee == null ? void 0 : Ee.symbol }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Cb,
            {
              type: "number",
              variant: "unstyled",
              step: 0.05,
              min: 0,
              className: Y$1(
                "text-card-foreground text-3xl font-medium",
                ge ? {
                  "text-2xl": ge.length > 10,
                  "text-xl": ge.length > 14,
                  "text-lg": ge.length > 18
                } : ""
              ),
              placeholder: "0",
              value: ge,
              onChange: (xe) => we(xe.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: y.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-10 w-32 rounded-3xl border" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
          FiatSelect,
          {
            currencies: y,
            selectedFiat: ue,
            setSelectedFiat: le,
            getIsSelected: (xe, $e) => xe.code === $e
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: he ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        "p",
        {
          className: Y$1("text-sm", {
            "text-destructive": he.type === "error"
          }),
          children: he.message
        }
      ) : null })
    ] })
  ] });
}, QuoteRefreshButton = ({ refresh: v, isValidatingRoute: y }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  np,
  {
    variant: "outline",
    size: "sm-icon",
    className: "rounded-3xl",
    disabled: y,
    onClick: v,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      A$1,
      {
        weight: "bold",
        size: "1.125rem",
        className: y ? "animate-spin" : ""
      }
    )
  }
), BuyTokenHeader = ({ title: v }) => {
  const { refresh: y, isKadoQuoteValidating: z } = useBuyTokensContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "font-bold", children: v ?? "Buy Tokens" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      QuoteRefreshButton,
      {
        refresh: y,
        isValidatingRoute: z
      }
    ) })
  ] });
}, FeeDisplay = ({ amount: v }) => {
  const { sourceCurrencyData: y, conversionRate: z } = useBuyTokensContext(), ne = useMemo(() => {
    var ue;
    if ((ue = z.data) != null && ue.success)
      return new BigNumber(v).div(z.data.conversionRate);
  }, [z, v]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: ne ? formatAmountWithPrefix(
    ne,
    (y == null ? void 0 : y.symbol) || "",
    2,
    2
  ) : "—" });
}, BuyTokensInfo = ({ className: v }) => {
  const {
    isKadoQuoteValidating: y,
    isKadoQuoteLoading: z,
    kadoQuote: ne,
    isKadoQuoteEnabled: ue
  } = useBuyTokensContext(), le = useRef(null), he = z || y;
  return ue && ne ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    G$,
    {
      type: "single",
      collapsible: !0,
      onValueChange: (ge) => {
        ge === "item" && setTimeout(() => {
          var we;
          (we = le.current) == null || we.scrollIntoView({
            behavior: "smooth"
          });
        }, 250);
      },
      className: Y$1(
        "!bg-card !text-card-foreground w-full rounded-xl",
        v
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(kf, { value: "item", className: "border-b-0", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Lf, { className: "rounded-xl px-4 py-3 hover:no-underline", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between pr-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-sm", children: "On ramp fee" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-center gap-2", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(G$3, { size: 16, weight: "bold" }),
            he ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FeeDisplay, { amount: ne.totalFee.amount })
          ] })
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Ff, { className: "px-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-0 w-full border-t" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "w-full space-y-2 pt-3", children: [
            ne.bridgeFee.amount ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Bridge Fee" }),
              he ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FeeDisplay, { amount: ne.bridgeFee.amount })
            ] }) : null,
            ne.networkFee.amount ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Network Fee" }),
              he ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FeeDisplay, { amount: ne.networkFee.amount })
            ] }) : null,
            ne.processingFee.amount ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Processing Fee" }),
              he ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FeeDisplay, { amount: ne.processingFee.amount })
            ] }) : null,
            ne.smartContractFee.amount ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Smart Contract Fee" }),
              he ? /* @__PURE__ */ jsxRuntimeExports.jsx(gw, { className: "h-5 w-16 rounded-3xl" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FeeDisplay, { amount: ne.smartContractFee.amount })
            ] }) : null
          ] })
        ] })
      ] })
    }
  ) : null;
}, BuyTokenCTASection = () => {
  const v = useWalletClientContext(), {
    inputAmount: y,
    usdValue: z,
    kadoQuoteError: ne,
    amountOut: ue,
    destinationAddress: le,
    isKadoQuoteValidating: he,
    isKadoQuoteLoading: ge,
    kadoQuote: we,
    isKadoQuoteEnabled: Ee,
    destinationChainId: xe
  } = useBuyTokensContext(), [$e, Ne] = useState(!1), { setStep: st } = useSwapsFlowContext(), Nr = we && !ge && !ne, br = z == null ? void 0 : z.isLessThan(KADO_MIN_USD_AMOUNT), $n = () => {
    const wa = parseFloat(y), Aa = parseFloat(ue), _a = !isNaN(wa) && wa > 0, Ta = !isNaN(Aa) && Aa > 0;
    return _a && Ta && Ee && !!we && Nr && !ne && !ge && !he;
  }, En = ne || br, Rn = le.error;
  return En ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      className: "w-full",
      disabled: !Rn,
      children: ne ? "Transaction route not supported" : "Enter minimum amount"
    }
  ) : Rn ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: (() => {
        var wa;
        return ((wa = le.error) == null ? void 0 : wa.code) === 3 && $e ? "action-primary" : "action-destructive";
      })(),
      className: "w-full transition-colors",
      onMouseEnter: () => {
        setTimeout(() => {
          Ne(!0);
        }, 100);
      },
      onMouseLeave: () => {
        setTimeout(() => {
          Ne(!1);
        }, 100);
      },
      onClick: () => {
        var wa;
        if (((wa = le.error) == null ? void 0 : wa.code) === 3)
          return le.refetch();
      },
      children: (() => {
        if (le.error)
          return le.error.code === 3 && $e ? "Click to Retry" : le.error.message;
      })()
    }
  ) : v.userAddress ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      disabled: !$n(),
      onClick: () => {
        st(1);
      },
      children: "Buy Tokens"
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full",
      onClick: () => {
        v.connectWallet(xe);
      },
      children: "Connect Wallet"
    }
  );
}, BuyOrderTrackingContext = createContext(void 0), baseUrl = KADO_URLS.prod.webView, BuyOrderTrackingProvider = ({
  tab: v,
  children: y,
  amount: z,
  amountInUsd: ne,
  selectedCurrency: ue,
  destinationChainData: le,
  destinationAssetData: he,
  destinationAddress: ge,
  selectedCurrencyData: we,
  onTxnComplete: Ee,
  onTxnInProgress: xe
}) => {
  const $e = useRef(null), [Ne, st] = useState(!1), [Nr, br] = useState("UNINITIALIZED"), $n = useCallback((_a) => {
    if (_a.origin === baseUrl) {
      const Ta = _a.data.payload;
      console.log("Received orderId:", Ta.orderId), $e.current = Ta.orderId, st(!0), br("IN_PROGRESS");
    }
  }, []), En = useCallback(
    (_a) => {
      st(!1), br("FAILED"), Ee == null || Ee({
        summaryType: "kado",
        amountIn: "",
        amountInUsd: ne,
        amountOut: "",
        selectedFiat: ue,
        destinationAsset: he,
        destinationChain: le,
        status: _a
      });
    },
    [
      ne,
      he,
      le,
      Ee,
      ue
    ]
  ), Rn = useCallback(
    (_a) => {
      st(!1), br("SUCCESS"), Ee == null || Ee({
        summaryType: "kado",
        amountIn: "",
        amountInUsd: ne,
        amountOut: "",
        selectedFiat: ue,
        destinationAsset: he,
        destinationChain: le,
        status: _a
      });
    },
    [
      ne,
      he,
      le,
      Ee,
      ue
    ]
  ), wa = useMemo(() => {
    const _a = new URL(baseUrl), Ta = new URLSearchParams({
      apiKey: KADO_API_KEY,
      onPayAmount: z,
      onPayCurrency: we.code,
      onRevCurrency: he.symbol,
      onToAddress: ge,
      network: le.network,
      product: "BUY",
      productList: "BUY",
      mode: "minimal"
    });
    return `${_a}?${Ta.toString()}`;
  }, [
    z,
    ge,
    he,
    le,
    we
  ]);
  useEffect(() => {
    const _a = {
      current: !1
    };
    if (Ne && $e.current && !_a.current) {
      const Ta = async () => {
        try {
          const Zn = await KadoAPI.getOrderStatus($e.current);
          if (Zn.success) {
            const Ra = Zn.status;
            if (Ra.paymentStatus === "failed") {
              En(Ra);
              return;
            }
            if (Ra.transferStatus === TRANSFER_STATUS.SETTLED) {
              Rn(Ra);
              return;
            }
          }
        } catch (Zn) {
          console.error("Error fetching API data:", Zn);
        }
        setTimeout(Ta, 5e3);
      };
      Ta();
    }
    return () => {
      _a.current = !0;
    };
  }, [$e, Ne, Rn, En]), useEffect(() => {
    if (Ne) {
      const _a = () => !0, Ta = window.onbeforeunload;
      window.onbeforeunload = _a;
      const Zn = xe == null ? void 0 : xe(v);
      return () => {
        window.onbeforeunload = Ta, Zn == null || Zn();
      };
    }
  }, [Ne, xe, v]), useEffect(() => (window.addEventListener("message", $n), () => window.removeEventListener("message", $n)), [$n]);
  const Aa = useMemo(
    () => ({
      iframeURL: wa,
      overallOrderStatus: Nr,
      orderId: $e.current,
      isPolling: Ne
    }),
    [wa, Nr, Ne]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BuyOrderTrackingContext.Provider, { value: Aa, children: y });
}, useBuyOrderTrackingContext = () => {
  const v = useContext(BuyOrderTrackingContext);
  return invariant$1(
    v,
    `Please use ${useBuyOrderTrackingContext.name} within BuyOrderTrackingProvider`
  ), v;
}, getSwapStatusHeading = (v) => {
  switch (v) {
    case "UNINITIALIZED":
      return "Verify & Review";
    case "IN_PROGRESS":
      return "Transaction in progress";
    case "SUCCESS":
      return "Transaction Completed";
    case "CANNOT_TRACK":
      return "Cannot track";
    case "FAILED":
      return "Transaction Failed";
  }
}, Header = () => {
  const { goBack: v, getTimeSpentOnCurrentStep: y } = useSwapsFlowContext(), { refresh: z, resetInputsToDefaults: ne } = useBuyTokensContext(), { overallOrderStatus: ue } = useBuyOrderTrackingContext(), le = useCallback(() => {
    y() > 15 && ue === "UNINITIALIZED" && z(), (ue === "SUCCESS" || ue === "FAILED") && ne(!1), v();
  }, [
    y,
    v,
    ue,
    z,
    ne
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        disabled: ue === "IN_PROGRESS",
        onClick: le,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: getSwapStatusHeading(ue) }),
    ue === "IN_PROGRESS" || ue === "FAILED" || ue === "CANNOT_TRACK" ? /* @__PURE__ */ jsxRuntimeExports.jsx(HelpPopover, {}) : null
  ] });
}, CTAButton = () => {
  const v = useOnline(), { goBack: y } = useSwapsFlowContext(), { refresh: z, resetInputsToDefaults: ne } = useBuyTokensContext(), { overallOrderStatus: ue } = useBuyOrderTrackingContext();
  return v ? ue === "FAILED" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        y(), z();
      },
      children: "Retry"
    }
  ) : ue === "SUCCESS" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-primary",
      className: "w-full font-bold",
      onClick: () => {
        ne(!1), y();
      },
      children: "Done"
    }
  ) : null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    np,
    {
      variant: "action-destructive",
      disabled: !0,
      className: "w-full font-bold",
      children: "No Internet Connection"
    }
  );
}, NoDataView = ({ goBack: v }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center px-4 my-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      np,
      {
        variant: "secondary",
        size: "sm-icon",
        className: "mr-3 rounded-3xl",
        onClick: v,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I$5, { size: 16, weight: "bold" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mr-auto font-bold", children: "Buy Tokens" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-4 h-full overflow-y-auto flex flex-col items-center justify-center p-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "-mt-32" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SwapFailureIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center mt-3 text-foreground font-bold", children: "Something went wrong" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-center text-sm mt-1 text-muted-foreground px-4", children: "We are unable to fetch the details at the moment. You can go to the previous step and try again." })
  ] })
] }), KadoWebView = () => {
  const { iframeURL: v, overallOrderStatus: y } = useBuyOrderTrackingContext(), z = useOnline();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "iframe",
    {
      src: v,
      allow: "clipboard-write; payment; accelerometer; gyroscope; camera; geolocation; autoplay; fullscreen;",
      title: "Kado",
      className: Y$1("w-full border-none", {
        "h-[468px]": z || y === "UNINITIALIZED" || y === "IN_PROGRESS",
        "h-[400px]": y === "SUCCESS" || y === "FAILED" || !z
      })
    },
    v
  ) });
}, BuyTokenTrackingView = () => {
  const { goBack: v } = useSwapsFlowContext(), {
    usdValue: y,
    selectedCurrency: z,
    destinationAddress: ne,
    destinationChainData: ue,
    destinationAssetData: le,
    kadoQuote: he,
    sourceCurrencyData: ge,
    onTxnComplete: we,
    onTxnInProgress: Ee,
    effectiveAmountValue: xe
  } = useBuyTokensContext();
  return !y || !z || !ge || !ne.address || !ue || !le || !he ? /* @__PURE__ */ jsxRuntimeExports.jsx(NoDataView, { goBack: v }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    BuyOrderTrackingProvider,
    {
      tab: Tabs.FIAT_ON_RAMP,
      amount: xe,
      amountInUsd: y == null ? void 0 : y.toString(),
      selectedCurrency: z,
      destinationAddress: ne.address,
      destinationChainData: ue,
      destinationAssetData: le,
      selectedCurrencyData: ge,
      quoteResponse: he,
      onTxnComplete: we,
      onTxnInProgress: Ee,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Header, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 overflow-y-auto no-scrollbar h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(KadoWebView, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 mb-4 [&:has(>*)]:mt-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CTAButton, {}) })
      ]
    }
  );
}, popularChains = [
  "cosmoshub-4",
  "osmosis-1",
  "pacific-1",
  "injective-1",
  "neutron-1"
], BuyTokenSourceSelect = () => {
  const {
    currencies: v,
    selectedCurrency: y,
    setSelectedCurrency: z,
    inputAmount: ne,
    setInputAmount: ue,
    inputAmountRemark: le
  } = useBuyTokensContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SourceSelect,
    {
      currencies: v,
      inputValue: ne,
      setInputValue: ue,
      selectedCurrency: y,
      inputAmountRemark: le,
      setSelectedCurrency: z
    }
  );
}, BuyTokenDestinationSelect = ({ assets: v }) => {
  const {
    destinationChainId: y,
    destinationAsset: z,
    setDestinationChainId: ne,
    setDestinationAsset: ue,
    destinationTokenBalance: le,
    kadoQuoteError: he,
    isKadoQuoteLoading: ge,
    isKadoQuoteValidating: we,
    amountOut: Ee,
    kadoChains: xe,
    destinationAddress: $e,
    sourceCurrencyData: Ne,
    conversionRate: st
  } = useBuyTokensContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DestinationSelect,
    {
      chains: xe,
      assets: v,
      selectedChainId: y,
      setSelectedChainId: ne,
      selectedAsset: z,
      setSelectedAsset: ue,
      tokenBalance: le,
      amountOut: Ee,
      isLoadingRoute: ge,
      isValidatingRoute: we,
      routeError: he,
      popularChainIds: popularChains,
      selectedChainError: !!$e.error,
      fetchChainBalances: useCosmosChainBalances,
      fiatData: Ne,
      conversionRate: st
    }
  );
}, DownButton = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative h-2 bg-transparent", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  np,
  {
    variant: "secondary",
    size: "sm-icon",
    className: "absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-3xl shadow-[0_0_0_0.4rem_hsl(var(--background))] disabled:cursor-not-allowed disabled:opacity-100",
    disabled: !0,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(D$5, { weight: "bold", size: "1rem" })
  }
) }), BuyTokensInputView = ({ title: v }) => {
  const y = useRef(null), z = useAllSkipAssets(), ne = useKadoAssets(), ue = useMemo(() => z.isLoading || ne.isLoading ? {
    isLoading: !0,
    data: void 0,
    error: void 0
  } : z.error || ne.error ? {
    isLoading: !1,
    data: void 0,
    error: z.error ?? ne.error
  } : {
    isLoading: !1,
    data: ne.data,
    error: void 0
  }, [z, ne]);
  return useOverflowFade(y), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokenHeader, { title: v }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "overflow-y-auto no-scrollbar px-4 h-full", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokenSourceSelect, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DownButton, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokenDestinationSelect, { assets: ue })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokensInfo, { className: "mt-3" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-4 my-4 bg-background rounded-b-2xl", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokenCTASection, {}) })
  ] });
}, FiatOnRampView = ({ title: v, classNames: y, showPoweredByBanner: z }) => {
  const { step: ne, previousStep: ue } = useSwapsFlowContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: Y$1(
        "bg-background h-[34rem] w-[26rem] rounded-2xl",
        y
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AnimatePresence, { mode: "popLayout", children: [
        ne === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 1 ? -8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: -8 },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokensInputView, { title: v })
          },
          0
        ) : null,
        ne === 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.div,
          {
            initial: { opacity: 0, x: ue === 0 ? 8 : 0 },
            animate: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: 8 },
            transition: { duration: 0.2, stiffness: 80 },
            className: "relative grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(BuyTokenTrackingView, {})
          },
          1
        ) : null,
        z ? /* @__PURE__ */ jsxRuntimeExports.jsx(PoweredByLeapAndKado, {}, "powered-by-banner") : null
      ] })
    }
  );
}, FiatOnRamp = ({
  className: v,
  title: y,
  showPoweredByBanner: z,
  defaultValues: ne,
  onTxnComplete: ue,
  onTxnInProgress: le,
  allowedDestinationChains: he,
  allowedCurrencies: ge,
  onFiatAmountChange: we,
  onFiatCurrencyChange: Ee,
  onDestinationChainChange: xe,
  onCryptoCurrencyChange: $e
}) => {
  const Ne = useMemo(() => {
    const st = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.currency,
      "USD",
      ge == null ? void 0 : ge.map(($n) => $n)
    ), Nr = getDefaultValueGivenFallback(
      ne == null ? void 0 : ne.destinationChainId,
      "osmosis-1",
      he == null ? void 0 : he.map(($n) => $n.chainId)
    ), br = ne != null && ne.destinationChainId ? getDefaultAsset$1(
      Nr,
      ne == null ? void 0 : ne.destinationAsset,
      he
    ) : "uosmo";
    return {
      currency: st,
      destinationChainId: Nr,
      destinationAsset: br,
      sourceAmount: (ne == null ? void 0 : ne.sourceAmount) ?? ""
    };
  }, [ge, he, ne]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { title: y ?? "Buy Tokens", className: v, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SwapsFlowProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SourceRestrictionsProvider, { allowedCurrencies: ge, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DestinationRestrictionsProvider, { chains: he, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    BuyTokensProvider,
    {
      defaultValues: Ne,
      onTxnComplete: ue,
      onTxnInProgress: le,
      onFiatAmountChange: we,
      onFiatCurrencyChange: Ee,
      onDestinationChainChange: xe,
      onCryptoCurrencyChange: $e,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(xw, { delayDuration: 250, skipDelayDuration: 750, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        FiatOnRampView,
        {
          title: y,
          showPoweredByBanner: z,
          classNames: v
        }
      ) })
    }
  ) }) }) }) });
}, FiatOnRampModal = ({
  isOpen: v,
  setIsOpen: y,
  ...z
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalView, { isOpen: v, setIsOpen: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FiatOnRamp, { ...z }) }), tabTitles = {
  [Tabs.SWAP]: "Swaps",
  [Tabs.FIAT_ON_RAMP]: "Buy",
  [Tabs.AGGREGATED]: "Bridge",
  //[Tabs.CROSS_CHAIN_SWAPS]: 'Cross Chain Swaps',
  [Tabs.TRANSFER]: "Send"
  //[Tabs.BRIDGE_USDC]: 'CCTP via Skip'
}, tabButtonInfo = [
  {
    id: Tabs.SWAP,
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(d$3, {}),
    iconBgColor: "#7927CA",
    label: tabTitles[Tabs.SWAP]
  },
  {
    id: Tabs.AGGREGATED,
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(w$5, {}),
    iconBgColor: "#E6FA36",
    label: tabTitles[Tabs.AGGREGATED]
  },
  {
    id: Tabs.TRANSFER,
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(I$6, {}),
    iconBgColor: "#E6FA36",
    label: tabTitles[Tabs.TRANSFER]
  },
  {
    id: Tabs.FIAT_ON_RAMP,
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(w$1, {}),
    iconBgColor: "#278FCA",
    label: tabTitles[Tabs.FIAT_ON_RAMP]
  }
], TabButton = ({
  onClick: v,
  isActive: y,
  icon: z,
  label: ne,
  id: ue,
  disabled: le,
  ping: he
}) => {
  const ge = useCallback(() => {
    v(ue);
  }, [v, ue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    np,
    {
      variant: "outline",
      title: `${ne} Tab`,
      className: Y$1(
        "flex items-center gap-2 justify-start bg-transparent hover:bg-card text-md",
        {
          "bg-card": y,
          "border-none": !y
        }
      ),
      "aria-label": y ? `Currently selected ${ne} tab` : `Select ${ne} tab`,
      onClick: ge,
      disabled: le,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            style: {
              position: "relative"
            },
            children: [
              he ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}) : null,
              typeof z == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: z, alt: "logo" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: z })
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { children: ne }),
        y ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "256", height: "256", fill: "none" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "polyline",
            {
              points: "96 48 176 128 96 208",
              fill: "none",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "24"
            }
          )
        ] }) }) : null
      ]
    }
  );
}, tabMap = {
  [Tabs.TRANSFER]: IBCTransfer,
  [Tabs.SWAP]: IBCSwaps,
  // [Tabs.CROSS_CHAIN_SWAPS]: CrossChainSwapsTab,
  [Tabs.FIAT_ON_RAMP]: FiatOnRamp,
  // [Tabs.BRIDGE_USDC]: BridgeUSDC,
  [Tabs.AGGREGATED]: Swaps
}, TabView = ({
  isActive: v,
  children: y
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    style: {
      display: v ? "block" : "none"
    },
    children: y
  }
), LiquidityModal = ({
  isOpen: v,
  setIsOpen: y,
  ...z
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalView, { isOpen: v, setIsOpen: y, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LiquidityView, { ...z }) }), NoTabsEnabled = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Oops!" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Looks like all the tabs are disabled. Please enable at least one tab to continue." })
] }), LiquidityView = ({
  tabsConfig: v,
  className: y,
  defaultActiveTab: z
}) => {
  const [ne, ue] = useState(
    z
  ), le = useMemo(() => Object.values(Tabs).filter((xe) => {
    var $e;
    return ($e = v == null ? void 0 : v[xe]) == null ? void 0 : $e.enabled;
  }), [v]), he = useCallback(
    (Ee, xe) => {
      var Nr, br;
      const $e = (Nr = v == null ? void 0 : v[Ee]) == null ? void 0 : Nr.orderIndex, Ne = (br = v == null ? void 0 : v[xe]) == null ? void 0 : br.orderIndex;
      if ($e !== void 0 && Ne !== void 0)
        return $e - Ne;
      const st = 1e3;
      return $e === void 0 && Ne !== void 0 ? st - Ne : $e !== void 0 && Ne === void 0 ? $e - st : 0;
    },
    [v]
  ), ge = useMemo(() => le.sort(he), [le, he]), we = useMemo(() => le.length === 0, [le]);
  return useEffect(() => {
    var xe;
    const Ee = Object.values(Tabs);
    Ee.filter(($e) => {
      var Ne;
      return ((Ne = v == null ? void 0 : v[$e]) == null ? void 0 : Ne.enabled) ?? !0;
    }).length === 1 ? ue(Ee.find(($e) => {
      var Ne;
      return ((Ne = v == null ? void 0 : v[$e]) == null ? void 0 : Ne.enabled) ?? !0;
    })) : (!ne || !(((xe = v == null ? void 0 : v[ne]) == null ? void 0 : xe.enabled) ?? !0)) && ue(Ee.find(($e) => {
      var Ne;
      return ((Ne = v == null ? void 0 : v[$e]) == null ? void 0 : Ne.enabled) ?? !0;
    }));
  }, [ne, v]), we ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: Y$1(
        "flex items-center justify-center h-[30rem] text-center",
        y
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(NoTabsEnabled, {})
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: Y$1("flex border rounded-xl w-[50rem]", y), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: " w-1/3 px-3 border-r bg-popover/45", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-muted-foreground my-3 text-sm font-bold", children: "Features" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col gap-3", children: tabButtonInfo.filter(
        (Ee) => {
          var xe;
          return ge.includes(Ee.id) && (((xe = v == null ? void 0 : v[Ee.id]) == null ? void 0 : xe.enabled) ?? !0);
        }
      ).sort((Ee, xe) => he(Ee.id, xe.id)).map((Ee) => {
        var xe;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          TabButton,
          {
            id: Ee.id,
            icon: Ee.icon,
            iconBgColor: Ee.iconBgColor,
            label: ((xe = v == null ? void 0 : v[Ee.id]) == null ? void 0 : xe.title) ?? Ee.label,
            isActive: ne === Ee.id,
            onClick: ue
          },
          Ee.id
        );
      }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-2/3 flex justify-center py-14 overflow-scroll", children: ge.map((Ee) => {
      const xe = tabMap[Ee], $e = (v == null ? void 0 : v[Ee]) ?? {};
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TabView, { isActive: ne === Ee, children: /* @__PURE__ */ jsxRuntimeExports.jsx(xe, { ...$e }) }, Ee);
    }) })
  ] });
}, AsyncLocalStorage = {
  getItem: (v) => {
    const y = localStorage.getItem(v);
    return y ? Promise.resolve(y) : Promise.resolve(null);
  },
  setItem: (v, y) => (localStorage.setItem(v, y), Promise.resolve()),
  removeItem: (v) => (localStorage.removeItem(v), Promise.resolve()),
  clear: () => (localStorage.clear(), Promise.resolve())
}, AsyncIDBStorage = {
  getItem: async (v) => {
    const y = await idb.get(v);
    return y || null;
  },
  setItem: async (v, y) => {
    await idb.set(v, y);
  },
  removeItem: async (v) => {
    await idb.del(v);
  },
  clear: async () => {
    await idb.clear();
  }
};
export {
  $,
  Ae as A,
  Buffer as B,
  er as C,
  nr as D,
  EventEmitter$2 as E,
  Fn as F,
  pt as G,
  Hn as H,
  It as I,
  Jn as J,
  Kn as K,
  wt as L,
  Mt as M,
  N,
  at as O,
  yt as P,
  mt as Q,
  Ht as R,
  kt as S,
  h as T,
  U,
  Vt as V,
  ft as W,
  Xn as X,
  lt as Y,
  dt as Z,
  _,
  requireSha_js as a,
  SELECT_NONE as a$,
  C as a0,
  D as a1,
  te as a2,
  rt as a3,
  ot as a4,
  Ln as a5,
  vt as a6,
  Et as a7,
  k as a8,
  Qn as a9,
  getLocation_1 as aA,
  getLocalStorage_1 as aB,
  getNavigator_1 as aC,
  getFromWindow_1 as aD,
  getFromWindowOrThrow_1 as aE,
  getDocumentOrThrow_1 as aF,
  getDocument_1 as aG,
  getNavigatorOrThrow_1 as aH,
  getLocationOrThrow_1 as aI,
  getCryptoOrThrow_1 as aJ,
  getCrypto_1 as aK,
  getLocalStorageOrThrow_1 as aL,
  detect as aM,
  getWindowMetadata_1 as aN,
  splitOnFirst as aO,
  filterObj as aP,
  strictUriEncode as aQ,
  decodeUriComponent as aR,
  SolanaSignAndSendTransaction as aS,
  SolanaSignTransaction as aT,
  SolanaSignMessage as aU,
  Tabs as aV,
  SWAP_PROVIDER as aW,
  Network as aX,
  IBCSwaps as aY,
  IBCSwapsModal as aZ,
  ModalView as a_,
  B as aa,
  jt as ab,
  gt as ac,
  ht as ad,
  Dt as ae,
  tr as af,
  xt as ag,
  Lt as ah,
  ln as ai,
  fn as aj,
  qt as ak,
  dn as al,
  Kt as am,
  zt as an,
  Bt as ao,
  Yt as ap,
  Xt as aq,
  Gt as ar,
  Wt as as,
  Jt as at,
  Ft as au,
  en as av,
  oe as aw,
  S as ax,
  ve as ay,
  Un as az,
  bnExports$1 as b,
  Swaps as b0,
  SwapsModal as b1,
  IBCTransfer as b2,
  IBCTransferModal as b3,
  FiatOnRamp as b4,
  FiatOnRampModal as b5,
  LiquidityView as b6,
  LiquidityModal as b7,
  convertAddress as b8,
  formatAmount as b9,
  getErrorMessageFromCode as ba,
  sleep as bb,
  sliceAddress as bc,
  withRetry as bd,
  leapCosmosLogo as be,
  handlePromise as bf,
  WalletClientContextProvider as bg,
  RouteSettingsProvider as bh,
  BRIDGES as bi,
  initCachingLayer as bj,
  AsyncIDBStorage as bk,
  AsyncLocalStorage as bl,
  setSkipAPIClientID as bm,
  PoweredByLeap as bn,
  PoweredByLeapAndSkip as bo,
  PoweredByLeapAndKado as bp,
  commonjsGlobal as c,
  requireReadableBrowser$1 as d,
  eventsExports as e,
  getAugmentedNamespace as f,
  getDefaultExportFromCjs as g,
  global$1 as h,
  cjs$2 as i,
  binary as j,
  random as k,
  fromString as l,
  concat as m,
  w as n,
  kn as o,
  process$1 as p,
  Vn as q,
  require$$0$2 as r,
  Mn as s,
  toString as t,
  qn as u,
  ee as v,
  wipe$1 as w,
  xn as x,
  p as y,
  ut as z
};
//# sourceMappingURL=index-rqPiRx3W.js.map
